
export const areas: Record<string, Array<{ value: string; label: string; pincode?: string }>> = {
  //Andaman and Nicobar Islands
  'afradganj': [
    { value: 'abids', label: 'Abids', pincode: '500001' },
    { value: 'alwal', label: 'Alwal', pincode: '500010' },
    { value: 'apba', label: 'Apba', pincode: '500062' },
    { value: 'bairamalguda', label: 'Bairamalguda', pincode: '500079' },
    { value: 'boduppal', label: 'Boduppal', pincode: '500039' },
    { value: 'bholakpur', label: 'Bholakpur', pincode: '500036' },
    { value: 'chakri', label: 'Chakri', pincode: '500073' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hakimpet', label: 'Hakimpet', pincode: '500031' },
    { value: 'jambagh', label: 'Jambagh', pincode: '500024' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '500064' },
    { value: 'kelambakkam', label: 'Kelambakkam', pincode: '500031' },
    { value: 'keshavgiri', label: 'Keshavgiri', pincode: '500066' },
    { value: 'lalapet', label: 'Lalapet', pincode: '500017' },
    { value: 'lakdikapul', label: 'Lakdikapul', pincode: '500004' },
    { value: 'malakpet', label: 'Malakpet', pincode: '500036' },
    { value: 'mahankali', label: 'Mahankali', pincode: '500001' },
    { value: 'malkajgiri', label: 'Malkajgiri', pincode: '500047' },
    { value: 'oldcity', label: 'Old City', pincode: '500002' },
    { value: 'puranapul', label: 'Puranapul', pincode: '500064' },
    { value: 'secunderabad', label: 'Secunderabad', pincode: '500003' },
    { value: 'shamshabad', label: 'Shamshabad', pincode: '500409' },
    { value: 'sultanbazar', label: 'Sultan Bazaar', pincode: '500095' },
    { value: 'tarnaka', label: 'Tarnaka', pincode: '500017' },
    { value: 'vengalrao-nagar', label: 'Vengalrao Nagar', pincode: '500038' },
    { value: 'warasiguda', label: 'Warasiguda', pincode: '500061' },
    { value: 'yaswanthpura', label: 'Yaswanthpura', pincode: '500070' },
    { value: 'zameer', label: 'Zameer', pincode: '500072' }
    ],
  
    'bambooflat': [
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744202' },
    { value: 'barrackpore', label: 'Barrackpore', pincode: '744101' },
    { value: 'blessing-nagar', label: 'Blessing Nagar', pincode: '744204' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744202' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosh-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hope-town', label: 'Hope Town', pincode: '744204' },
    { value: 'junglighat', label: 'Junglighat', pincode: '744103' },
    { value: 'kanyapuram', label: 'Kanyapuram', pincode: '744209' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'mundapahar', label: 'Mundapahar', pincode: '744103' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'sawadi', label: 'Sawadi', pincode: '744209' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'bambooflat-2', label: 'Bambooflat-2', pincode: '744203' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744204' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'clarke-town', label: 'Clarke Town', pincode: '744101' },
    { value: 'delanipur', label: 'Delanipur', pincode: '744102' },
    { value: 'garacharma-2', label: 'Garacharma-2', pincode: '744204' },
    { value: 'hut-bay', label: 'Hut Bay', pincode: '744211' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'kaushal-nagar', label: 'Kaushal Nagar', pincode: '744202' },
    { value: 'lamba', label: 'Lamba', pincode: '744209' },
    { value: 'madhupur', label: 'Madhupur', pincode: '744107' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744201' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'teresa', label: 'Teresa', pincode: '744103' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744102' }
    ],
  
  
    'billiground': [
    { value: 'admiralty-bay', label: 'Admiralty Bay', pincode: '744211' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'bombooflat', label: 'Bombooflat', pincode: '744203' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744202' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hanumanpally', label: 'Hanumanpally', pincode: '500093' },
    { value: 'hope-town', label: 'Hope Town', pincode: '744204' },
    { value: 'junglighat', label: 'Junglighat', pincode: '744103' },
    { value: 'kanyapuram', label: 'Kanyapuram', pincode: '744209' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'mundapahar', label: 'Mundapahar', pincode: '744103' },
    { value: 'netaji-nagar', label: 'Netaji Nagar', pincode: '744202' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' }
    ],
  
  
    'blairmountain': [
    { value: 'admiralty-bay', label: 'Admiralty Bay', pincode: '744211' },
    { value: 'blairmountain', label: 'Blairmountain', pincode: '744204' },
    { value: 'bombooflat', label: 'Bombooflat', pincode: '744203' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744202' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hanumanpally', label: 'Hanumanpally', pincode: '500093' },
    { value: 'hope-town', label: 'Hope Town', pincode: '744204' },
    { value: 'junglighat', label: 'Junglighat', pincode: '744103' },
    { value: 'kanyapuram', label: 'Kanyapuram', pincode: '744209' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'mundapahar', label: 'Mundapahar', pincode: '744103' },
    { value: 'netaji-nagar', label: 'Netaji Nagar', pincode: '744202' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' },
    { value: 'andaman-nagar', label: 'Andaman Nagar', pincode: '744209' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744202' },
    { value: 'barrackpore', label: 'Barrackpore', pincode: '744101' },
    { value: 'blessing-nagar', label: 'Blessing Nagar', pincode: '744204' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744204' },
    { value: 'clarke-town', label: 'Clarke Town', pincode: '744101' },
    { value: 'delanipur', label: 'Delanipur', pincode: '744102' },
    { value: 'gopal-nagar', label: 'Gopal Nagar', pincode: '744201' },
    { value: 'junglighat-2', label: 'Junglighat-2', pincode: '744103' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'kaushal-nagar', label: 'Kaushal Nagar', pincode: '744202' },
    { value: 'lamba', label: 'Lamba', pincode: '744209' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744201' },
    { value: 'srinivasnagar', label: 'Srinivasnagar', pincode: '744208' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744208' },
    { value: 'vijayanagar', label: 'Vijayanagar', pincode: '744209' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'chowra', label: 'Chowra', pincode: '744203' },
    { value: 'diglipur', label: 'Diglipur', pincode: '744202' },
    { value: 'kalapathar-2', label: 'Kalapathar 2', pincode: '744206' },
    { value: 'katchal-island', label: 'Katchal Island', pincode: '744301' },
    { value: 'mithakhari', label: 'Mithakhari', pincode: '744204' },
    { value: 'rangat-bay', label: 'Rangat Bay', pincode: '744202' },
    { value: 'tarin', label: 'Tarin', pincode: '744307' },
    { value: 'tamarind-forest', label: 'Tamarind Forest', pincode: '744209' },
    { value: 'chidiya-tapu-2', label: 'Chidiya Tapu 2', pincode: '744105' },
    { value: 'andaman-forest', label: 'Andaman Forest', pincode: '744201' },
    { value: 'black-bay', label: 'Black Bay', pincode: '744206' },
    { value: 'blue-bay', label: 'Blue Bay', pincode: '744207' },
    { value: 'sunset-beach', label: 'Sunset Beach', pincode: '744204' },
    { value: 'silicon-bay', label: 'Silicon Bay', pincode: '744209' },
    { value: 'jungleview', label: 'Jungleview', pincode: '744204' },
    { value: 'silver-sands', label: 'Silver Sands', pincode: '744208' },
    { value: 'gangeshwar', label: 'Gangeshwar', pincode: '744101' },
    { value: 'tamarind-cove', label: 'Tamarind Cove', pincode: '744208' },
    { value: 'north-bay', label: 'North Bay', pincode: '744101' },
    { value: 'south-bay', label: 'South Bay', pincode: '744205' },
    { value: 'sunset-hill', label: 'Sunset Hill', pincode: '744209' },
    { value: 'coral-island', label: 'Coral Island', pincode: '744200' }
    ],
  
    'car-nicobar': [
    { value: 'andaman-nagar', label: 'Andaman Nagar', pincode: '744303' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744303' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744303' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'netaji-nagar', label: 'Netaji Nagar', pincode: '744202' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'car-nicobar-town', label: 'Car Nicobar Town', pincode: '744302' },
    { value: 'madhupur', label: 'Madhupur', pincode: '744301' },
    { value: 'nautical-bay', label: 'Nautical Bay', pincode: '744304' },
    { value: 'north-bay', label: 'North Bay', pincode: '744305' },
    { value: 'rakhi-nagar', label: 'Rakhi Nagar', pincode: '744303' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '744306' },
    { value: 'sundari', label: 'Sundari', pincode: '744307' },
    { value: 'swadeshnagar', label: 'Swadeshnagar', pincode: '744308' },
    { value: 'sunyadweep', label: 'Sunyadweep', pincode: '744309' },
    { value: 'telanapura', label: 'Telanapura', pincode: '744310' },
    { value: 'tillangcha', label: 'Tillangcha', pincode: '744311' },
    { value: 'waterfront', label: 'Waterfront', pincode: '744312' },
    { value: 'abhinav-nagar', label: 'Abhinav Nagar', pincode: '744313' },
    { value: 'bharatnagar', label: 'Bharat Nagar', pincode: '744314' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '744315' },
    { value: 'dhanvantari-nagar', label: 'Dhanvantari Nagar', pincode: '744316' },
    { value: 'eagle-bay', label: 'Eagle Bay', pincode: '744317' },
    { value: 'greenwood', label: 'Greenwood', pincode: '744318' },
    { value: 'hermitage-bay', label: 'Hermitage Bay', pincode: '744319' },
    { value: 'island-view', label: 'Island View', pincode: '744320' },
    { value: 'jungle-bay', label: 'Jungle Bay', pincode: '744321' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744322' },
    { value: 'moonstone-bay', label: 'Moonstone Bay', pincode: '744323' },
    { value: 'neel-sagar', label: 'Neel Sagar', pincode: '744324' },
    { value: 'orange-grove', label: 'Orange Grove', pincode: '744325' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744326' },
    { value: 'quaint-bay', label: 'Quaint Bay', pincode: '744327' },
    { value: 'rocky-shores', label: 'Rocky Shores', pincode: '744328' },
    { value: 'sapphire-bay', label: 'Sapphire Bay', pincode: '744329' }
    ],
  
    'cuthbert-bay': [
    { value: 'admiralty-bay', label: 'Admiralty Bay', pincode: '744211' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744202' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744204' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'cuthbert-bay', label: 'Cuthbert Bay', pincode: '744207' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'netaji-nagar', label: 'Netaji Nagar', pincode: '744202' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'dhanvantari-nagar', label: 'Dhanvantari Nagar', pincode: '744206' },
    { value: 'eagle-bay', label: 'Eagle Bay', pincode: '744207' },
    { value: 'greenwood-bay', label: 'Greenwood Bay', pincode: '744209' },
    { value: 'hermitage-bay', label: 'Hermitage Bay', pincode: '744208' },
    { value: 'jungle-bay', label: 'Jungle Bay', pincode: '744210' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744211' },
    { value: 'moonstone-bay', label: 'Moonstone Bay', pincode: '744212' },
    { value: 'north-bay', label: 'North Bay', pincode: '744213' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744214' },
    { value: 'quaint-bay', label: 'Quaint Bay', pincode: '744215' },
    { value: 'rocky-bay', label: 'Rocky Bay', pincode: '744216' },
    { value: 'sapphire-bay', label: 'Sapphire Bay', pincode: '744217' },
    { value: 'abhinav-nagar', label: 'Abhinav Nagar', pincode: '744218' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '744219' },
    { value: 'caleb-nagar', label: 'Caleb Nagar', pincode: '744220' },
    { value: 'dream-bay', label: 'Dream Bay', pincode: '744221' },
    { value: 'eagle-nest', label: 'Eagle Nest', pincode: '744222' },
    { value: 'forest-grove', label: 'Forest Grove', pincode: '744223' },
    { value: 'harbor-view', label: 'Harbor View', pincode: '744224' },
    { value: 'island-view', label: 'Island View', pincode: '744225' },
    { value: 'jewel-bay', label: 'Jewel Bay', pincode: '744226' },
    { value: 'kinara-bay', label: 'Kinara Bay', pincode: '744227' },
    { value: 'lunar-bay', label: 'Lunar Bay', pincode: '744228' },
    { value: 'moonlit-bay', label: 'Moonlit Bay', pincode: '744229' },
    { value: 'oceanic-bay', label: 'Oceanic Bay', pincode: '744230' },
    { value: 'palm-shore', label: 'Palm Shore', pincode: '744231' },
    { value: 'quartz-bay', label: 'Quartz Bay', pincode: '744232' },
    { value: 'rosegrove', label: 'Rosegrove', pincode: '744233' },
    { value: 'sunny-bay', label: 'Sunny Bay', pincode: '744234' }
    ],
  
    'diglipur': [
    { value: 'andaman-nagar', label: 'Andaman Nagar', pincode: '744202' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744202' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744204' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'diglipur', label: 'Diglipur', pincode: '744202' },
    { value: 'dollygunj', label: 'Dollygunj', pincode: '744103' },
    { value: 'dugong-bay', label: 'Dugong Bay', pincode: '744216' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'katchal-nagar', label: 'Katchal Nagar', pincode: '744302' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'mithakari', label: 'Mithakari', pincode: '744213' },
    { value: 'netaji-nagar', label: 'Netaji Nagar', pincode: '744202' },
    { value: 'nirakarpur', label: 'Nirakarpur', pincode: '744215' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'tuticorin', label: 'Tuticorin', pincode: '744207' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'dhanvantari-nagar', label: 'Dhanvantari Nagar', pincode: '744206' },
    { value: 'eagle-bay', label: 'Eagle Bay', pincode: '744207' },
    { value: 'greenwood-bay', label: 'Greenwood Bay', pincode: '744209' },
    { value: 'hermitage-bay', label: 'Hermitage Bay', pincode: '744208' },
    { value: 'jungle-bay', label: 'Jungle Bay', pincode: '744210' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744211' },
    { value: 'moonstone-bay', label: 'Moonstone Bay', pincode: '744212' },
    { value: 'north-bay', label: 'North Bay', pincode: '744213' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744214' },
    { value: 'quaint-bay', label: 'Quaint Bay', pincode: '744215' },
    { value: 'rocky-bay', label: 'Rocky Bay', pincode: '744216' },
    { value: 'sapphire-bay', label: 'Sapphire Bay', pincode: '744217' },
    { value: 'abhinav-nagar', label: 'Abhinav Nagar', pincode: '744218' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '744219' },
    { value: 'caleb-nagar', label: 'Caleb Nagar', pincode: '744220' },
    { value: 'dream-bay', label: 'Dream Bay', pincode: '744221' },
    { value: 'eagle-nest', label: 'Eagle Nest', pincode: '744222' },
    { value: 'forest-grove', label: 'Forest Grove', pincode: '744223' },
    { value: 'harbor-view', label: 'Harbor View', pincode: '744224' },
    { value: 'island-view', label: 'Island View', pincode: '744225' },
    { value: 'jewel-bay', label: 'Jewel Bay', pincode: '744226' },
    { value: 'kinara-bay', label: 'Kinara Bay', pincode: '744227' },
    { value: 'lunar-bay', label: 'Lunar Bay', pincode: '744228' },
    { value: 'moonlit-bay', label: 'Moonlit Bay', pincode: '744229' },
    { value: 'oceanic-bay', label: 'Oceanic Bay', pincode: '744230' },
    { value: 'palm-shore', label: 'Palm Shore', pincode: '744231' },
    { value: 'quartz-bay', label: 'Quartz Bay', pincode: '744232' },
    { value: 'rosegrove', label: 'Rosegrove', pincode: '744233' },
    { value: 'sunny-bay', label: 'Sunny Bay', pincode: '744234' },
    { value: 'tulip-bay', label: 'Tulip Bay', pincode: '744235' },
    { value: 'victoria-nagar', label: 'Victoria Nagar', pincode: '744236' },
    { value: 'willow-bay', label: 'Willow Bay', pincode: '744237' }
    ],
  
  
    'hut-bay': [
    { value: 'andaman-nagar', label: 'Andaman Nagar', pincode: '744202' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744202' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744204' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'hut-bay', label: 'Hut Bay', pincode: '744211' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'netaji-nagar', label: 'Netaji Nagar', pincode: '744202' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'dhanvantari-nagar', label: 'Dhanvantari Nagar', pincode: '744206' },
    { value: 'eagle-bay', label: 'Eagle Bay', pincode: '744207' },
    { value: 'greenwood-bay', label: 'Greenwood Bay', pincode: '744209' },
    { value: 'hermitage-bay', label: 'Hermitage Bay', pincode: '744208' },
    { value: 'jungle-bay', label: 'Jungle Bay', pincode: '744210' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744211' },
    { value: 'moonstone-bay', label: 'Moonstone Bay', pincode: '744212' },
    { value: 'north-bay', label: 'North Bay', pincode: '744213' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744214' },
    { value: 'quaint-bay', label: 'Quaint Bay', pincode: '744215' },
    { value: 'rocky-bay', label: 'Rocky Bay', pincode: '744216' },
    { value: 'sapphire-bay', label: 'Sapphire Bay', pincode: '744217' },
    { value: 'abhinav-nagar', label: 'Abhinav Nagar', pincode: '744218' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '744219' },
    { value: 'caleb-nagar', label: 'Caleb Nagar', pincode: '744220' },
    { value: 'dream-bay', label: 'Dream Bay', pincode: '744221' },
    { value: 'eagle-nest', label: 'Eagle Nest', pincode: '744222' },
    { value: 'forest-grove', label: 'Forest Grove', pincode: '744223' },
    { value: 'harbor-view', label: 'Harbor View', pincode: '744224' },
    { value: 'island-view', label: 'Island View', pincode: '744225' },
    { value: 'jewel-bay', label: 'Jewel Bay', pincode: '744226' },
    { value: 'kinara-bay', label: 'Kinara Bay', pincode: '744227' },
    { value: 'lunar-bay', label: 'Lunar Bay', pincode: '744228' },
    { value: 'moonlit-bay', label: 'Moonlit Bay', pincode: '744229' },
    { value: 'oceanic-bay', label: 'Oceanic Bay', pincode: '744230' },
    { value: 'palm-shore', label: 'Palm Shore', pincode: '744231' },
    { value: 'quartz-bay', label: 'Quartz Bay', pincode: '744232' },
    { value: 'rosegrove', label: 'Rosegrove', pincode: '744233' },
    { value: 'sunny-bay', label: 'Sunny Bay', pincode: '744234' }
    ],
  
  
    'inland-point': [
    { value: 'abhinav-nagar', label: 'Abhinav Nagar', pincode: '744218' },
    { value: 'andaman-nagar', label: 'Andaman Nagar', pincode: '744202' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744202' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744204' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'dhanvantari-nagar', label: 'Dhanvantari Nagar', pincode: '744206' },
    { value: 'diglipur', label: 'Diglipur', pincode: '744202' },
    { value: 'eagle-bay', label: 'Eagle Bay', pincode: '744207' },
    { value: 'eagle-nest', label: 'Eagle Nest', pincode: '744222' },
    { value: 'forest-grove', label: 'Forest Grove', pincode: '744223' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'greenwood-bay', label: 'Greenwood Bay', pincode: '744209' },
    { value: 'hermitage-bay', label: 'Hermitage Bay', pincode: '744208' },
    { value: 'hut-bay', label: 'Hut Bay', pincode: '744211' },
    { value: 'inland-point', label: 'Inland Point', pincode: '744235' },
    { value: 'island-view', label: 'Island View', pincode: '744225' },
    { value: 'jewel-bay', label: 'Jewel Bay', pincode: '744226' },
    { value: 'jungle-bay', label: 'Jungle Bay', pincode: '744210' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'kinara-bay', label: 'Kinara Bay', pincode: '744227' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744211' },
    { value: 'lunar-bay', label: 'Lunar Bay', pincode: '744228' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'mithakari', label: 'Mithakari', pincode: '744213' },
    { value: 'moonstone-bay', label: 'Moonstone Bay', pincode: '744212' },
    { value: 'moonlit-bay', label: 'Moonlit Bay', pincode: '744229' },
    { value: 'north-bay', label: 'North Bay', pincode: '744213' },
    { value: 'oceanic-bay', label: 'Oceanic Bay', pincode: '744230' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744214' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'palm-shore', label: 'Palm Shore', pincode: '744231' },
    { value: 'quartz-bay', label: 'Quartz Bay', pincode: '744232' },
    { value: 'quaint-bay', label: 'Quaint Bay', pincode: '744215' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'rocky-bay', label: 'Rocky Bay', pincode: '744216' },
    { value: 'rose-grove', label: 'Rose Grove', pincode: '744233' },
    { value: 'sapphire-bay', label: 'Sapphire Bay', pincode: '744217' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'sunny-bay', label: 'Sunny Bay', pincode: '744234' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'tulip-bay', label: 'Tulip Bay', pincode: '744235' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' },
    { value: 'anderson-bay', label: 'Anderson Bay', pincode: '744236' },
    { value: 'sunset-point', label: 'Sunset Point', pincode: '744237' },
    { value: 'paradise-point', label: 'Paradise Point', pincode: '744238' },
    { value: 'mango-bay', label: 'Mango Bay', pincode: '744239' },
    { value: 'serenity-bay', label: 'Serenity Bay', pincode: '744240' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744241' },
    { value: 'hill-top', label: 'Hill Top', pincode: '744242' },
    { value: 'white-sands', label: 'White Sands', pincode: '744243' },
    { value: 'sea-view', label: 'Sea View', pincode: '744244' },
    { value: 'pearl-bay', label: 'Pearl Bay', pincode: '744245' }
    ],
  
    'kadamtala': [
    { value: 'abhinav-nagar', label: 'Abhinav Nagar', pincode: '744218' },
    { value: 'andaman-nagar', label: 'Andaman Nagar', pincode: '744202' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744202' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744204' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'dhanvantari-nagar', label: 'Dhanvantari Nagar', pincode: '744206' },
    { value: 'diglipur', label: 'Diglipur', pincode: '744202' },
    { value: 'eagle-bay', label: 'Eagle Bay', pincode: '744207' },
    { value: 'eagle-nest', label: 'Eagle Nest', pincode: '744222' },
    { value: 'forest-grove', label: 'Forest Grove', pincode: '744223' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'greenwood-bay', label: 'Greenwood Bay', pincode: '744209' },
    { value: 'hermitage-bay', label: 'Hermitage Bay', pincode: '744208' },
    { value: 'hut-bay', label: 'Hut Bay', pincode: '744211' },
    { value: 'inland-point', label: 'Inland Point', pincode: '744235' },
    { value: 'island-view', label: 'Island View', pincode: '744225' },
    { value: 'jewel-bay', label: 'Jewel Bay', pincode: '744226' },
    { value: 'jungle-bay', label: 'Jungle Bay', pincode: '744210' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'kinara-bay', label: 'Kinara Bay', pincode: '744227' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744211' },
    { value: 'lunar-bay', label: 'Lunar Bay', pincode: '744228' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'mithakari', label: 'Mithakari', pincode: '744213' },
    { value: 'moonstone-bay', label: 'Moonstone Bay', pincode: '744212' },
    { value: 'moonlit-bay', label: 'Moonlit Bay', pincode: '744229' },
    { value: 'north-bay', label: 'North Bay', pincode: '744213' },
    { value: 'oceanic-bay', label: 'Oceanic Bay', pincode: '744230' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744214' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'palm-shore', label: 'Palm Shore', pincode: '744231' },
    { value: 'quartz-bay', label: 'Quartz Bay', pincode: '744232' },
    { value: 'quaint-bay', label: 'Quaint Bay', pincode: '744215' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'rocky-bay', label: 'Rocky Bay', pincode: '744216' },
    { value: 'rose-grove', label: 'Rose Grove', pincode: '744233' },
    { value: 'sapphire-bay', label: 'Sapphire Bay', pincode: '744217' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'sunny-bay', label: 'Sunny Bay', pincode: '744234' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'tulip-bay', label: 'Tulip Bay', pincode: '744235' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' },
    { value: 'anderson-bay', label: 'Anderson Bay', pincode: '744236' },
    { value: 'sunset-point', label: 'Sunset Point', pincode: '744237' },
    { value: 'paradise-point', label: 'Paradise Point', pincode: '744238' },
    { value: 'mango-bay', label: 'Mango Bay', pincode: '744239' },
    { value: 'serenity-bay', label: 'Serenity Bay', pincode: '744240' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744241' },
    { value: 'hill-top', label: 'Hill Top', pincode: '744242' },
    { value: 'white-sands', label: 'White Sands', pincode: '744243' },
    { value: 'sea-view', label: 'Sea View', pincode: '744244' },
    { value: 'pearl-bay', label: 'Pearl Bay', pincode: '744245' },
    { value: 'black-bay', label: 'Black Bay', pincode: '744246' },
    { value: 'beachside', label: 'Beachside', pincode: '744247' },
    { value: 'blue-lagoon', label: 'Blue Lagoon', pincode: '744248' },
    { value: 'sunset-cove', label: 'Sunset Cove', pincode: '744249' }
    ],
    'kalpong': [
    { value: 'andaman-nagar', label: 'Andaman Nagar', pincode: '744202' },
    { value: 'anderson-bay', label: 'Anderson Bay', pincode: '744236' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744202' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744204' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'dhanvantari-nagar', label: 'Dhanvantari Nagar', pincode: '744206' },
    { value: 'diglipur', label: 'Diglipur', pincode: '744202' },
    { value: 'eagle-bay', label: 'Eagle Bay', pincode: '744207' },
    { value: 'eagle-nest', label: 'Eagle Nest', pincode: '744222' },
    { value: 'forest-grove', label: 'Forest Grove', pincode: '744223' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'greenwood-bay', label: 'Greenwood Bay', pincode: '744209' },
    { value: 'hermitage-bay', label: 'Hermitage Bay', pincode: '744208' },
    { value: 'hut-bay', label: 'Hut Bay', pincode: '744211' },
    { value: 'inland-point', label: 'Inland Point', pincode: '744235' },
    { value: 'island-view', label: 'Island View', pincode: '744225' },
    { value: 'jewel-bay', label: 'Jewel Bay', pincode: '744226' },
    { value: 'jungle-bay', label: 'Jungle Bay', pincode: '744210' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'kinara-bay', label: 'Kinara Bay', pincode: '744227' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744211' },
    { value: 'lunar-bay', label: 'Lunar Bay', pincode: '744228' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'mithakari', label: 'Mithakari', pincode: '744213' },
    { value: 'moonstone-bay', label: 'Moonstone Bay', pincode: '744212' },
    { value: 'moonlit-bay', label: 'Moonlit Bay', pincode: '744229' },
    { value: 'north-bay', label: 'North Bay', pincode: '744213' },
    { value: 'oceanic-bay', label: 'Oceanic Bay', pincode: '744230' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744214' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'palm-shore', label: 'Palm Shore', pincode: '744231' },
    { value: 'quartz-bay', label: 'Quartz Bay', pincode: '744232' },
    { value: 'quaint-bay', label: 'Quaint Bay', pincode: '744215' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'rocky-bay', label: 'Rocky Bay', pincode: '744216' },
    { value: 'rose-grove', label: 'Rose Grove', pincode: '744233' },
    { value: 'sapphire-bay', label: 'Sapphire Bay', pincode: '744217' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'sunny-bay', label: 'Sunny Bay', pincode: '744234' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'tulip-bay', label: 'Tulip Bay', pincode: '744235' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' },
    { value: 'sunset-point', label: 'Sunset Point', pincode: '744237' },
    { value: 'paradise-point', label: 'Paradise Point', pincode: '744238' },
    { value: 'mango-bay', label: 'Mango Bay', pincode: '744239' },
    { value: 'serenity-bay', label: 'Serenity Bay', pincode: '744240' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744241' },
    { value: 'hill-top', label: 'Hill Top', pincode: '744242' },
    { value: 'white-sands', label: 'White Sands', pincode: '744243' },
    { value: 'sea-view', label: 'Sea View', pincode: '744244' },
    { value: 'pearl-bay', label: 'Pearl Bay', pincode: '744245' },
    { value: 'black-bay', label: 'Black Bay', pincode: '744246' },
    { value: 'beachside', label: 'Beachside', pincode: '744247' },
    { value: 'blue-lagoon', label: 'Blue Lagoon', pincode: '744248' },
    { value: 'sunset-cove', label: 'Sunset Cove', pincode: '744249' }
    ],
  
  
    'kamorta': [
    { value: 'andaman-nagar', label: 'Andaman Nagar', pincode: '744202' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744202' },
    { value: 'calicut', label: 'Calicut', pincode: '744101' },
    { value: 'cariappa-nagar', label: 'Cariappa Nagar', pincode: '744204' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744105' },
    { value: 'dhanvantari-nagar', label: 'Dhanvantari Nagar', pincode: '744206' },
    { value: 'diglipur', label: 'Diglipur', pincode: '744202' },
    { value: 'eagle-bay', label: 'Eagle Bay', pincode: '744207' },
    { value: 'eagle-nest', label: 'Eagle Nest', pincode: '744222' },
    { value: 'forest-grove', label: 'Forest Grove', pincode: '744223' },
    { value: 'greenwood-bay', label: 'Greenwood Bay', pincode: '744209' },
    { value: 'hermitage-bay', label: 'Hermitage Bay', pincode: '744208' },
    { value: 'hut-bay', label: 'Hut Bay', pincode: '744211' },
    { value: 'inland-point', label: 'Inland Point', pincode: '744235' },
    { value: 'island-view', label: 'Island View', pincode: '744225' },
    { value: 'jewel-bay', label: 'Jewel Bay', pincode: '744226' },
    { value: 'jungle-bay', label: 'Jungle Bay', pincode: '744210' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744205' },
    { value: 'katchal', label: 'Katchal', pincode: '744301' },
    { value: 'kinara-bay', label: 'Kinara Bay', pincode: '744227' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744211' },
    { value: 'lunar-bay', label: 'Lunar Bay', pincode: '744228' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744204' },
    { value: 'mithakari', label: 'Mithakari', pincode: '744213' },
    { value: 'moonstone-bay', label: 'Moonstone Bay', pincode: '744212' },
    { value: 'moonlit-bay', label: 'Moonlit Bay', pincode: '744229' },
    { value: 'north-bay', label: 'North Bay', pincode: '744213' },
    { value: 'oceanic-bay', label: 'Oceanic Bay', pincode: '744230' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744214' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'palm-shore', label: 'Palm Shore', pincode: '744231' },
    { value: 'quartz-bay', label: 'Quartz Bay', pincode: '744232' },
    { value: 'quaint-bay', label: 'Quaint Bay', pincode: '744215' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'rocky-bay', label: 'Rocky Bay', pincode: '744216' },
    { value: 'rose-grove', label: 'Rose Grove', pincode: '744233' },
    { value: 'sapphire-bay', label: 'Sapphire Bay', pincode: '744217' },
    { value: 'shadipur', label: 'Shadipur', pincode: '744105' },
    { value: 'subashgram', label: 'Subashgram', pincode: '744101' },
    { value: 'sunny-bay', label: 'Sunny Bay', pincode: '744234' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744208' },
    { value: 'tulip-bay', label: 'Tulip Bay', pincode: '744235' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744103' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'yogendra-nagar', label: 'Yogendra Nagar', pincode: '744203' },
    { value: 'sunset-point', label: 'Sunset Point', pincode: '744237' },
    { value: 'paradise-point', label: 'Paradise Point', pincode: '744238' },
    { value: 'mango-bay', label: 'Mango Bay', pincode: '744239' },
    { value: 'serenity-bay', label: 'Serenity Bay', pincode: '744240' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744241' },
    { value: 'hill-top', label: 'Hill Top', pincode: '744242' },
    { value: 'white-sands', label: 'White Sands', pincode: '744243' },
    { value: 'sea-view', label: 'Sea View', pincode: '744244' },
    { value: 'pearl-bay', label: 'Pearl Bay', pincode: '744245' },
    { value: 'black-bay', label: 'Black Bay', pincode: '744246' },
    { value: 'beachside', label: 'Beachside', pincode: '744247' },
    { value: 'blue-lagoon', label: 'Blue Lagoon', pincode: '744248' },
    { value: 'sunset-cove', label: 'Sunset Cove', pincode: '744249' },
    { value: 'turtle-bay', label: 'Turtle Bay', pincode: '744250' },
    { value: 'island-breeze', label: 'Island Breeze', pincode: '744251' },
    { value: 'lagoon-bay', label: 'Lagoon Bay', pincode: '744252' },
    { value: 'star-bay', label: 'Star Bay', pincode: '744253' },
    { value: 'moon-bay', label: 'Moon Bay', pincode: '744254' }
    ],
  
  
    'katchal': [
    { value: 'andaman-nagar', label: 'Andaman Nagar', pincode: '744301' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744301' },
    { value: 'calicut', label: 'Calicut', pincode: '744102' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744103' },
    { value: 'coconut-grove', label: 'Coconut Grove', pincode: '744305' },
    { value: 'diglipur', label: 'Diglipur', pincode: '744302' },
    { value: 'eagle-bay', label: 'Eagle Bay', pincode: '744306' },
    { value: 'forest-grove', label: 'Forest Grove', pincode: '744307' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'greenwood-bay', label: 'Greenwood Bay', pincode: '744308' },
    { value: 'hermitage-bay', label: 'Hermitage Bay', pincode: '744309' },
    { value: 'hut-bay', label: 'Hut Bay', pincode: '744310' },
    { value: 'inland-point', label: 'Inland Point', pincode: '744311' },
    { value: 'island-view', label: 'Island View', pincode: '744312' },
    { value: 'jewel-bay', label: 'Jewel Bay', pincode: '744313' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '744314' },
    { value: 'kinara-bay', label: 'Kinara Bay', pincode: '744315' },
    { value: 'katchal-town', label: 'Katchal Town', pincode: '744301' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744316' },
    { value: 'manjeri', label: 'Manjeri', pincode: '744317' },
    { value: 'mithakari', label: 'Mithakari', pincode: '744318' },
    { value: 'north-bay', label: 'North Bay', pincode: '744319' },
    { value: 'oceanic-bay', label: 'Oceanic Bay', pincode: '744320' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'sunny-bay', label: 'Sunny Bay', pincode: '744321' },
    { value: 'tamarind', label: 'Tamarind', pincode: '744322' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744323' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744324' },
    { value: 'aquamarine-bay', label: 'Aquamarine Bay', pincode: '744325' },
    { value: 'breeze-bay', label: 'Breeze Bay', pincode: '744326' },
    { value: 'cove-view', label: 'Cove View', pincode: '744327' },
    { value: 'coral-reef', label: 'Coral Reef', pincode: '744328' },
    { value: 'diamond-bay', label: 'Diamond Bay', pincode: '744329' },
    { value: 'emerald-bay', label: 'Emerald Bay', pincode: '744330' },
    { value: 'evergreen-bay', label: 'Evergreen Bay', pincode: '744331' },
    { value: 'gulf-view', label: 'Gulf View', pincode: '744332' },
    { value: 'horizon-bay', label: 'Horizon Bay', pincode: '744333' },
    { value: 'island-breeze', label: 'Island Breeze', pincode: '744334' },
    { value: 'lagoon-bay', label: 'Lagoon Bay', pincode: '744335' },
    { value: 'moonshine-bay', label: 'Moonshine Bay', pincode: '744336' },
    { value: 'northern-bay', label: 'Northern Bay', pincode: '744337' },
    { value: 'sunset-point', label: 'Sunset Point', pincode: '744338' },
    { value: 'sunshine-bay', label: 'Sunshine Bay', pincode: '744339' },
    { value: 'turtle-bay', label: 'Turtle Bay', pincode: '744340' },
    { value: 'tropical-bay', label: 'Tropical Bay', pincode: '744341' },
    { value: 'whispering-bay', label: 'Whispering Bay', pincode: '744342' }
    ],
  
  
    'little-andaman': [
    { value: 'andaman-nicobar', label: 'Andaman Nicobar', pincode: '744101' },
    { value: 'car-nicobar', label: 'Car Nicobar', pincode: '744301' },
    { value: 'dhaninallah', label: 'Dhaninallah', pincode: '744202' },
    { value: 'gun-kumari', label: 'Gun Kumari', pincode: '744204' },
    { value: 'jolly-buoy', label: 'Jolly Buoy', pincode: '744107' },
    { value: 'katchal', label: 'Katchal', pincode: '744305' },
    { value: 'kilpauk', label: 'Kilpauk', pincode: '744302' },
    { value: 'little-andaman', label: 'Little Andaman', pincode: '744202' },
    { value: 'long-island', label: 'Long Island', pincode: '744104' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'north-andaman', label: 'North Andaman', pincode: '744201' },
    { value: 'ritchies-archipelago', label: 'Ritchie\'s Archipelago', pincode: '744202' },
    { value: 'south-andaman', label: 'South Andaman', pincode: '744205' },
    { value: 'strait-island', label: 'Strait Island', pincode: '744106' },
    { value: 'tarmugli', label: 'Tarmugli', pincode: '744207' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744201' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'rangat', label: 'Rangat', pincode: '744202' },
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744201' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744112' },
    { value: 'prothrapur', label: 'Prothrapur', pincode: '744102' },
    { value: 'dweep', label: 'Dweep', pincode: '744110' },
    { value: 'munda-pahar', label: 'Munda Pahar', pincode: '744106' },
    { value: 'lalaji-bay', label: 'Lalaji Bay', pincode: '744205' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'havelock', label: 'Havelock', pincode: '744211' },
    { value: 'ritchies-archipelago', label: 'Ritchie\'s Archipelago', pincode: '744202' }
    ],
    
    'long-island': [
    { value: 'bamboo-flat', label: 'Bamboo Flat', pincode: '744101' },
    { value: 'beach-north', label: 'Beach North', pincode: '744206' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'dhanikhari', label: 'Dhanikhari', pincode: '744301' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'lamba-bay', label: 'Lamba Bay', pincode: '744212' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mount-harriet', label: 'Mount Harriet', pincode: '744104' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-park', label: 'Tunnel Park', pincode: '744101' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' }
    ],
  
    'manglutan': [
    { value: 'andaman-bharatpur', label: 'Andaman Bharatpur', pincode: '744207' },
    { value: 'andaman-cubbon', label: 'Andaman Cubbon', pincode: '744208' },
    { value: 'andaman-nicobar', label: 'Andaman Nicobar', pincode: '744106' },
    { value: 'bambooflat', label: 'Bamboo Flat', pincode: '744101' },
    { value: 'beach-north', label: 'Beach North', pincode: '744206' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'dhanikhari', label: 'Dhanikhari', pincode: '744301' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'kuchu-bay', label: 'Kuchu Bay', pincode: '744101' },
    { value: 'lamba-bay', label: 'Lamba Bay', pincode: '744212' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'madhupur', label: 'Madhupur', pincode: '744401' },
    { value: 'manglutan', label: 'Manglutan', pincode: '744206' },
    { value: 'mount-harriet', label: 'Mount Harriet', pincode: '744104' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'nicolnabad', label: 'Nicolnabad', pincode: '744102' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-park', label: 'Tunnel Park', pincode: '744101' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744204' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'honey-valley', label: 'Honey Valley', pincode: '744207' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' }
    ],

    'mayabunder': [
    { value: 'andaman-bichitrapur', label: 'Andaman Bichitrapur', pincode: '744209' },
    { value: 'andaman-cubbon', label: 'Andaman Cubbon', pincode: '744208' },
    { value: 'andaman-nicobar', label: 'Andaman Nicobar', pincode: '744106' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'kuchu-bay', label: 'Kuchu Bay', pincode: '744101' },
    { value: 'lamba-bay', label: 'Lamba Bay', pincode: '744212' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'mount-harriet', label: 'Mount Harriet', pincode: '744104' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'north-bay', label: 'North Bay', pincode: '744101' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-park', label: 'Tunnel Park', pincode: '744101' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744204' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'honey-valley', label: 'Honey Valley', pincode: '744207' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'dhanikhari', label: 'Dhanikhari', pincode: '744301' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'durgapur', label: 'Durgapur', pincode: '744210' },
    { value: 'kuchu-nallah', label: 'Kuchu Nallah', pincode: '744204' }
    ],
    
    'middle-strait': [
    { value: 'andaman-bharatpur', label: 'Andaman Bharatpur', pincode: '744207' },
    { value: 'andaman-cubbon', label: 'Andaman Cubbon', pincode: '744208' },
    { value: 'andaman-nicobar', label: 'Andaman Nicobar', pincode: '744106' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'dhanikhari', label: 'Dhanikhari', pincode: '744301' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'honey-valley', label: 'Honey Valley', pincode: '744207' },
    { value: 'kuchu-bay', label: 'Kuchu Bay', pincode: '744101' },
    { value: 'kuchu-nallah', label: 'Kuchu Nallah', pincode: '744204' },
    { value: 'lamba-bay', label: 'Lamba Bay', pincode: '744212' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'middle-strait', label: 'Middle Strait', pincode: '744103' },
    { value: 'mount-harriet', label: 'Mount Harriet', pincode: '744104' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'north-bay', label: 'North Bay', pincode: '744101' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-park', label: 'Tunnel Park', pincode: '744101' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744204' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'durgapur', label: 'Durgapur', pincode: '744210' },
    { value: 'garacharma-bay', label: 'Garacharma Bay', pincode: '744207' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' }
    ],
  
  
    'nancowry': [
    { value: 'andaman-bharatpur', label: 'Andaman Bharatpur', pincode: '744207' },
    { value: 'andaman-cubbon', label: 'Andaman Cubbon', pincode: '744208' },
    { value: 'andaman-nicobar', label: 'Andaman Nicobar', pincode: '744106' },
    { value: 'andaman-panchayat', label: 'Andaman Panchayat', pincode: '744301' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'dhanikhari', label: 'Dhanikhari', pincode: '744301' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'kuchu-bay', label: 'Kuchu Bay', pincode: '744101' },
    { value: 'kuchu-nallah', label: 'Kuchu Nallah', pincode: '744204' },
    { value: 'lamba-bay', label: 'Lamba Bay', pincode: '744212' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'middle-strait', label: 'Middle Strait', pincode: '744103' },
    { value: 'nancowry', label: 'Nancowry', pincode: '744302' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'north-bay', label: 'North Bay', pincode: '744101' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-park', label: 'Tunnel Park', pincode: '744101' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744204' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'durgapur', label: 'Durgapur', pincode: '744210' },
    { value: 'garacharma-bay', label: 'Garacharma Bay', pincode: '744207' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'car-nicobar', label: 'Car Nicobar', pincode: '744303' },
    { value: 'kamorta', label: 'Kamorta', pincode: '744202' },
    { value: 'katchal', label: 'Katchal', pincode: '744306' },
    { value: 'great-nicobar', label: 'Great Nicobar', pincode: '744401' }
    ],
  
    'north-bay': [
    { value: 'andaman-bharatpur', label: 'Andaman Bharatpur', pincode: '744207' },
    { value: 'andaman-cubbon', label: 'Andaman Cubbon', pincode: '744208' },
    { value: 'andaman-nicobar', label: 'Andaman Nicobar', pincode: '744106' },
    { value: 'andaman-panchayat', label: 'Andaman Panchayat', pincode: '744301' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'dhanikhari', label: 'Dhanikhari', pincode: '744301' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'kuchu-bay', label: 'Kuchu Bay', pincode: '744101' },
    { value: 'kuchu-nallah', label: 'Kuchu Nallah', pincode: '744204' },
    { value: 'lamba-bay', label: 'Lamba Bay', pincode: '744212' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'middle-strait', label: 'Middle Strait', pincode: '744103' },
    { value: 'north-bay', label: 'North Bay', pincode: '744101' },
    { value: 'nancowry', label: 'Nancowry', pincode: '744302' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-park', label: 'Tunnel Park', pincode: '744101' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744204' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'durgapur', label: 'Durgapur', pincode: '744210' },
    { value: 'garacharma-bay', label: 'Garacharma Bay', pincode: '744207' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'car-nicobar', label: 'Car Nicobar', pincode: '744303' },
    { value: 'kamorta', label: 'Kamorta', pincode: '744202' },
    { value: 'katchal', label: 'Katchal', pincode: '744306' },
    { value: 'great-nicobar', label: 'Great Nicobar', pincode: '744401' },
    { value: 'rangat-bay', label: 'Rangat Bay', pincode: '744206' },
    { value: 'mithakhari', label: 'Mithakhari', pincode: '744201' }
    ],
    
    'passage-island': [
    { value: 'andaman-bharatpur', label: 'Andaman Bharatpur', pincode: '744207' },
    { value: 'andaman-cubbon', label: 'Andaman Cubbon', pincode: '744208' },
    { value: 'andaman-nicobar', label: 'Andaman Nicobar', pincode: '744106' },
    { value: 'andaman-panchayat', label: 'Andaman Panchayat', pincode: '744301' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'dhanikhari', label: 'Dhanikhari', pincode: '744301' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'kuchu-bay', label: 'Kuchu Bay', pincode: '744101' },
    { value: 'kuchu-nallah', label: 'Kuchu Nallah', pincode: '744204' },
    { value: 'lamba-bay', label: 'Lamba Bay', pincode: '744212' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'middle-strait', label: 'Middle Strait', pincode: '744103' },
    { value: 'nancowry', label: 'Nancowry', pincode: '744302' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'passage-island', label: 'Passage Island', pincode: '744101' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744204' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'durgapur', label: 'Durgapur', pincode: '744210' },
    { value: 'garacharma-bay', label: 'Garacharma Bay', pincode: '744207' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'car-nicobar', label: 'Car Nicobar', pincode: '744303' },
    { value: 'kamorta', label: 'Kamorta', pincode: '744202' },
    { value: 'katchal', label: 'Katchal', pincode: '744306' },
    { value: 'great-nicobar', label: 'Great Nicobar', pincode: '744401' },
    { value: 'rangat-bay', label: 'Rangat Bay', pincode: '744206' },
    { value: 'mithakhari', label: 'Mithakhari', pincode: '744201' },
    { value: 'carbyns-hills', label: 'Carbyns Hills', pincode: '744102' },
    { value: 'bambooflat-bay', label: 'Bambooflat Bay', pincode: '744101' },
    { value: 'tunnel-park', label: 'Tunnel Park', pincode: '744105' },
    { value: 'middle-bay', label: 'Middle Bay', pincode: '744208' }
    ],
    
    'port-blair': [
    { value: 'andaman-bharatpur', label: 'Andaman Bharatpur', pincode: '744207' },
    { value: 'andaman-cubbon', label: 'Andaman Cubbon', pincode: '744208' },
    { value: 'andaman-nicobar', label: 'Andaman Nicobar', pincode: '744106' },
    { value: 'andaman-panchayat', label: 'Andaman Panchayat', pincode: '744301' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'dhanikhari', label: 'Dhanikhari', pincode: '744301' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'kuchu-bay', label: 'Kuchu Bay', pincode: '744101' },
    { value: 'kuchu-nallah', label: 'Kuchu Nallah', pincode: '744204' },
    { value: 'lamba-bay', label: 'Lamba Bay', pincode: '744212' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'middle-strait', label: 'Middle Strait', pincode: '744103' },
    { value: 'nancowry', label: 'Nancowry', pincode: '744302' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744204' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'durgapur', label: 'Durgapur', pincode: '744210' },
    { value: 'garacharma-bay', label: 'Garacharma Bay', pincode: '744207' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'car-nicobar', label: 'Car Nicobar', pincode: '744303' },
    { value: 'kamorta', label: 'Kamorta', pincode: '744202' },
    { value: 'katchal', label: 'Katchal', pincode: '744306' },
    { value: 'great-nicobar', label: 'Great Nicobar', pincode: '744401' },
    { value: 'rangat-bay', label: 'Rangat Bay', pincode: '744206' },
    { value: 'mithakhari', label: 'Mithakhari', pincode: '744201' },
    { value: 'carbyns-hills', label: 'Carbyns Hills', pincode: '744102' },
    { value: 'bambooflat-bay', label: 'Bambooflat Bay', pincode: '744101' },
    { value: 'tunnel-park', label: 'Tunnel Park', pincode: '744105' },
    { value: 'middle-bay', label: 'Middle Bay', pincode: '744208' },
    { value: 'forest-area', label: 'Forest Area', pincode: '744207' },
    { value: 'puducherry', label: 'Puducherry', pincode: '744210' },
    { value: 'moorthy-nagar', label: 'Moorthy Nagar', pincode: '744102' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'herbert-nagar', label: 'Herbert Nagar', pincode: '744103' },
    { value: 'indira-point', label: 'Indira Point', pincode: '744302' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'carbyns-shore', label: 'Carbyns Shore', pincode: '744103' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744109' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'sagar-darshan', label: 'Sagar Darshan', pincode: '744109' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'sundarbans', label: 'Sundarbans', pincode: '744202' },
    { value: 'palmyra-beach', label: 'Palmyra Beach', pincode: '744208' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'harbour-view', label: 'Harbour View', pincode: '744101' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' }
    ],
  
    'rangat': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'arand-reef', label: 'Arand Reef', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744204' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'durgapur', label: 'Durgapur', pincode: '744210' },
    { value: 'garacharma-bay', label: 'Garacharma Bay', pincode: '744207' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'bambooflat-bay', label: 'Bambooflat Bay', pincode: '744101' },
    { value: 'durgapur', label: 'Durgapur', pincode: '744210' },
    { value: 'tunnel-park', label: 'Tunnel Park', pincode: '744105' },
    { value: 'middle-bay', label: 'Middle Bay', pincode: '744208' },
    { value: 'forest-area', label: 'Forest Area', pincode: '744207' },
    { value: 'puducherry', label: 'Puducherry', pincode: '744210' },
    { value: 'moorthy-nagar', label: 'Moorthy Nagar', pincode: '744102' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'herbert-nagar', label: 'Herbert Nagar', pincode: '744103' },
    { value: 'indira-point', label: 'Indira Point', pincode: '744302' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'carbyns-shore', label: 'Carbyns Shore', pincode: '744103' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744109' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' }
    ],
  
    'ross-island': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'arand-reef', label: 'Arand Reef', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'billiground', label: 'Billiground', pincode: '744202' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'bambooflat-bay', label: 'Bambooflat Bay', pincode: '744101' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'carbyns-shore', label: 'Carbyns Shore', pincode: '744103' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'forest-area', label: 'Forest Area', pincode: '744207' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'herbert-nagar', label: 'Herbert Nagar', pincode: '744103' },
    { value: 'indira-point', label: 'Indira Point', pincode: '744302' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'moorthy-nagar', label: 'Moorthy Nagar', pincode: '744102' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'puducherry', label: 'Puducherry', pincode: '744210' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'ross-island', label: 'Ross Island', pincode: '744101' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744109' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744204' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '744109' },
    { value: 'bamboo-bay-view', label: 'Bamboo Bay View', pincode: '744101' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'apricot-bay', label: 'Apricot Bay', pincode: '744210' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' }
    ],
  
    'rutland-island': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'forest-area', label: 'Forest Area', pincode: '744207' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'ross-island', label: 'Ross Island', pincode: '744101' },
    { value: 'rutland-island', label: 'Rutland Island', pincode: '744206' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'bamboo-bay-view', label: 'Bamboo Bay View', pincode: '744101' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'apricot-bay', label: 'Apricot Bay', pincode: '744210' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' }
    ],
  
    'shippighat': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'forest-area', label: 'Forest Area', pincode: '744207' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'ross-island', label: 'Ross Island', pincode: '744101' },
    { value: 'shippighat', label: 'Shippighat', pincode: '744105' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'bamboo-bay-view', label: 'Bamboo Bay View', pincode: '744101' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'apricot-bay', label: 'Apricot Bay', pincode: '744210' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' },
    { value: 'tamarind-beach', label: 'Tamarind Beach', pincode: '744211' },
    { value: 'bamboo-forest', label: 'Bamboo Forest', pincode: '744103' },
    { value: 'greenwich-bay', label: 'Greenwich Bay', pincode: '744105' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744204' },
    { value: 'rainforest', label: 'Rainforest', pincode: '744206' },
    { value: 'sail-rock', label: 'Sail Rock', pincode: '744110' },
    { value: 'coastal-village', label: 'Coastal Village', pincode: '744102' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744205' }
    ],
  
  
  'south-button': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744104' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'forest-area', label: 'Forest Area', pincode: '744207' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'ross-island', label: 'Ross Island', pincode: '744101' },
    { value: 'south-button', label: 'South Button', pincode: '744204' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'bamboo-bay-view', label: 'Bamboo Bay View', pincode: '744101' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'apricot-bay', label: 'Apricot Bay', pincode: '744210' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' },
    { value: 'tamarind-beach', label: 'Tamarind Beach', pincode: '744211' },
    { value: 'bamboo-forest', label: 'Bamboo Forest', pincode: '744103' },
    { value: 'greenwich-bay', label: 'Greenwich Bay', pincode: '744105' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744204' },
    { value: 'rainforest', label: 'Rainforest', pincode: '744206' },
    { value: 'sail-rock', label: 'Sail Rock', pincode: '744110' },
    { value: 'coastal-village', label: 'Coastal Village', pincode: '744102' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744205' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744106' },
    { value: 'seaview-bay', label: 'Seaview Bay', pincode: '744108' },
    { value: 'calm-bay', label: 'Calm Bay', pincode: '744110' },
    { value: 'ocean-view', label: 'Ocean View', pincode: '744209' },
    { value: 'sunset-bay', label: 'Sunset Bay', pincode: '744205' }
    ],
  
  
    'south-point': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'forest-area', label: 'Forest Area', pincode: '744207' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'ross-island', label: 'Ross Island', pincode: '744101' },
    { value: 'south-point', label: 'South Point', pincode: '744204' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'bamboo-bay-view', label: 'Bamboo Bay View', pincode: '744101' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'apricot-bay', label: 'Apricot Bay', pincode: '744210' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' },
    { value: 'tamarind-beach', label: 'Tamarind Beach', pincode: '744211' },
    { value: 'bamboo-forest', label: 'Bamboo Forest', pincode: '744103' },
    { value: 'greenwich-bay', label: 'Greenwich Bay', pincode: '744105' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744204' },
    { value: 'rainforest', label: 'Rainforest', pincode: '744206' },
    { value: 'sail-rock', label: 'Sail Rock', pincode: '744110' },
    { value: 'coastal-village', label: 'Coastal Village', pincode: '744102' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744205' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744106' },
    { value: 'seaview-bay', label: 'Seaview Bay', pincode: '744108' },
    { value: 'calm-bay', label: 'Calm Bay', pincode: '744110' },
    { value: 'ocean-view', label: 'Ocean View', pincode: '744209' },
    { value: 'sunset-bay', label: 'Sunset Bay', pincode: '744205' },
    { value: 'white-sand', label: 'White Sand', pincode: '744107' },
    { value: 'blue-water-bay', label: 'Blue Water Bay', pincode: '744204' },
    { value: 'rainbow-bay', label: 'Rainbow Bay', pincode: '744211' },
    { value: 'eagle-point', label: 'Eagle Point', pincode: '744212' },
    { value: 'ocean-breeze', label: 'Ocean Breeze', pincode: '744208' },
    { value: 'tropical-bay', label: 'Tropical Bay', pincode: '744209' },
    { value: 'sunshine-bay', label: 'Sunshine Bay', pincode: '744210' },
    { value: 'hidden-cove', label: 'Hidden Cove', pincode: '744212' },
    { value: 'cloudy-bay', label: 'Cloudy Bay', pincode: '744203' }
    ],
  
    'teressa': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'forest-area', label: 'Forest Area', pincode: '744207' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'ross-island', label: 'Ross Island', pincode: '744101' },
    { value: 'south-point', label: 'South Point', pincode: '744204' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'bamboo-bay-view', label: 'Bamboo Bay View', pincode: '744101' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'apricot-bay', label: 'Apricot Bay', pincode: '744210' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' },
    { value: 'tamarind-beach', label: 'Tamarind Beach', pincode: '744211' },
    { value: 'bamboo-forest', label: 'Bamboo Forest', pincode: '744103' },
    { value: 'greenwich-bay', label: 'Greenwich Bay', pincode: '744105' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744204' },
    { value: 'rainforest', label: 'Rainforest', pincode: '744206' },
    { value: 'sail-rock', label: 'Sail Rock', pincode: '744110' },
    { value: 'coastal-village', label: 'Coastal Village', pincode: '744102' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744205' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744106' },
    { value: 'seaview-bay', label: 'Seaview Bay', pincode: '744108' },
    { value: 'calm-bay', label: 'Calm Bay', pincode: '744110' },
    { value: 'ocean-view', label: 'Ocean View', pincode: '744209' },
    { value: 'sunset-bay', label: 'Sunset Bay', pincode: '744205' },
    { value: 'hidden-cove', label: 'Hidden Cove', pincode: '744212' },
    { value: 'cloudy-bay', label: 'Cloudy Bay', pincode: '744203' },
    { value: 'shallow-bay', label: 'Shallow Bay', pincode: '744104' },
    { value: 'misty-point', label: 'Misty Point', pincode: '744209' },
    { value: 'fishermen-village', label: 'Fishermen Village', pincode: '744103' },
    { value: 'green-bay', label: 'Green Bay', pincode: '744206' },
    { value: 'silver-bay', label: 'Silver Bay', pincode: '744210' },
    { value: 'rustic-cove', label: 'Rustic Cove', pincode: '744205' },
    { value: 'emerald-bay', label: 'Emerald Bay', pincode: '744204' },
    { value: 'teressa-1', label: 'Teressa Area 1', pincode: '744301' },
    { value: 'teressa-2', label: 'Teressa Area 2', pincode: '744303' },
    { value: 'teressa-central', label: 'Teressa Central', pincode: '744307' },
    { value: 'teressa-south', label: 'Teressa South', pincode: '744308' },
    { value: 'teressa-west', label: 'Teressa West', pincode: '744312' },
    { value: 'teressa-east', label: 'Teressa East', pincode: '744314' },
    { value: 'teressa-beach', label: 'Teressa Beach', pincode: '744305' },
    { value: 'teressa-harbour', label: 'Teressa Harbour', pincode: '744306' },
    { value: 'teressa-jungle', label: 'Teressa Jungle', pincode: '744309' }
    ],
  
    'twin-islands': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'forest-area', label: 'Forest Area', pincode: '744207' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'ross-island', label: 'Ross Island', pincode: '744101' },
    { value: 'south-point', label: 'South Point', pincode: '744204' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'tunnel-road', label: 'Tunnel Road', pincode: '744104' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '744109' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'bamboo-bay-view', label: 'Bamboo Bay View', pincode: '744101' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'apricot-bay', label: 'Apricot Bay', pincode: '744210' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' },
    { value: 'tamarind-beach', label: 'Tamarind Beach', pincode: '744211' },
    { value: 'bamboo-forest', label: 'Bamboo Forest', pincode: '744103' },
    { value: 'greenwich-bay', label: 'Greenwich Bay', pincode: '744105' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744204' },
    { value: 'rainforest', label: 'Rainforest', pincode: '744206' },
    { value: 'sail-rock', label: 'Sail Rock', pincode: '744110' },
    { value: 'coastal-village', label: 'Coastal Village', pincode: '744102' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744205' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744106' },
    { value: 'seaview-bay', label: 'Seaview Bay', pincode: '744108' },
    { value: 'calm-bay', label: 'Calm Bay', pincode: '744110' },
    { value: 'ocean-view', label: 'Ocean View', pincode: '744209' },
    { value: 'sunset-bay', label: 'Sunset Bay', pincode: '744205' },
    { value: 'hidden-cove', label: 'Hidden Cove', pincode: '744212' },
    { value: 'cloudy-bay', label: 'Cloudy Bay', pincode: '744203' },
    { value: 'shallow-bay', label: 'Shallow Bay', pincode: '744104' },
    { value: 'misty-point', label: 'Misty Point', pincode: '744209' },
    { value: 'fishermen-village', label: 'Fishermen Village', pincode: '744103' },
    { value: 'green-bay', label: 'Green Bay', pincode: '744206' },
    { value: 'silver-bay', label: 'Silver Bay', pincode: '744210' },
    { value: 'rustic-cove', label: 'Rustic Cove', pincode: '744205' },
    { value: 'emerald-bay', label: 'Emerald Bay', pincode: '744204' },
    { value: 'twin-islands-central', label: 'Twin Islands Central', pincode: '744307' },
    { value: 'twin-islands-north', label: 'Twin Islands North', pincode: '744308' },
    { value: 'twin-islands-south', label: 'Twin Islands South', pincode: '744309' },
    { value: 'twin-islands-east', label: 'Twin Islands East', pincode: '744310' },
    { value: 'twin-islands-west', label: 'Twin Islands West', pincode: '744311' },
    { value: 'twin-islands-beach', label: 'Twin Islands Beach', pincode: '744312' },
    { value: 'river-cove', label: 'River Cove', pincode: '744313' },
    { value: 'misty-lagoon', label: 'Misty Lagoon', pincode: '744314' },
    { value: 'coastal-village-bay', label: 'Coastal Village Bay', pincode: '744315' },
    { value: 'sunshine-bay', label: 'Sunshine Bay', pincode: '744316' },
    { value: 'blue-lagoon', label: 'Blue Lagoon', pincode: '744317' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744318' },
    { value: 'sand-dunes', label: 'Sand Dunes', pincode: '744319' },
    { value: 'hidden-lagoon', label: 'Hidden Lagoon', pincode: '744320' },
    { value: 'crystal-bay', label: 'Crystal Bay', pincode: '744321' },
    { value: 'twin-bay', label: 'Twin Bay', pincode: '744322' },
    { value: 'starfish-bay', label: 'Starfish Bay', pincode: '744323' },
    { value: 'jungle-cove', label: 'Jungle Cove', pincode: '744324' },
    { value: 'whale-bay', label: 'Whale Bay', pincode: '744325' },
    { value: 'echo-point', label: 'Echo Point', pincode: '744326' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744327' },
    { value: 'sunset-lagoon', label: 'Sunset Lagoon', pincode: '744328' }
    ],
  
    'viper-island': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'ross-island', label: 'Ross Island', pincode: '744101' },
    { value: 'south-point', label: 'South Point', pincode: '744204' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'viper-island', label: 'Viper Island', pincode: '744101' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'bamboo-bay-view', label: 'Bamboo Bay View', pincode: '744101' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'apricot-bay', label: 'Apricot Bay', pincode: '744210' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' },
    { value: 'tamarind-beach', label: 'Tamarind Beach', pincode: '744211' },
    { value: 'bamboo-forest', label: 'Bamboo Forest', pincode: '744103' },
    { value: 'greenwich-bay', label: 'Greenwich Bay', pincode: '744105' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744204' },
    { value: 'rainforest', label: 'Rainforest', pincode: '744206' },
    { value: 'sail-rock', label: 'Sail Rock', pincode: '744110' },
    { value: 'coastal-village', label: 'Coastal Village', pincode: '744102' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744205' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744106' },
    { value: 'seaview-bay', label: 'Seaview Bay', pincode: '744108' },
    { value: 'calm-bay', label: 'Calm Bay', pincode: '744110' },
    { value: 'ocean-view', label: 'Ocean View', pincode: '744209' },
    { value: 'sunset-bay', label: 'Sunset Bay', pincode: '744205' },
    { value: 'hidden-cove', label: 'Hidden Cove', pincode: '744212' },
    { value: 'cloudy-bay', label: 'Cloudy Bay', pincode: '744203' },
    { value: 'shallow-bay', label: 'Shallow Bay', pincode: '744104' },
    { value: 'misty-point', label: 'Misty Point', pincode: '744209' },
    { value: 'fishermen-village', label: 'Fishermen Village', pincode: '744103' },
    { value: 'green-bay', label: 'Green Bay', pincode: '744206' },
    { value: 'silver-bay', label: 'Silver Bay', pincode: '744210' },
    { value: 'rustic-cove', label: 'Rustic Cove', pincode: '744205' },
    { value: 'emerald-bay', label: 'Emerald Bay', pincode: '744204' },
    { value: 'twin-islands-central', label: 'Twin Islands Central', pincode: '744307' },
    { value: 'twin-islands-north', label: 'Twin Islands North', pincode: '744308' },
    { value: 'twin-islands-south', label: 'Twin Islands South', pincode: '744309' },
    { value: 'twin-islands-east', label: 'Twin Islands East', pincode: '744310' },
    { value: 'twin-islands-west', label: 'Twin Islands West', pincode: '744311' },
    { value: 'twin-islands-beach', label: 'Twin Islands Beach', pincode: '744312' },
    { value: 'river-cove', label: 'River Cove', pincode: '744313' },
    { value: 'misty-lagoon', label: 'Misty Lagoon', pincode: '744314' },
    { value: 'coastal-village-bay', label: 'Coastal Village Bay', pincode: '744315' },
    { value: 'sunshine-bay', label: 'Sunshine Bay', pincode: '744316' },
    { value: 'blue-lagoon', label: 'Blue Lagoon', pincode: '744317' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744318' },
    { value: 'sand-dunes', label: 'Sand Dunes', pincode: '744319' },
    { value: 'hidden-lagoon', label: 'Hidden Lagoon', pincode: '744320' },
    { value: 'crystal-bay', label: 'Crystal Bay', pincode: '744321' },
    { value: 'twin-bay', label: 'Twin Bay', pincode: '744322' },
    { value: 'starfish-bay', label: 'Starfish Bay', pincode: '744323' },
    { value: 'jungle-cove', label: 'Jungle Cove', pincode: '744324' },
    { value: 'whale-bay', label: 'Whale Bay', pincode: '744325' },
    { value: 'echo-point', label: 'Echo Point', pincode: '744326' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744327' },
    { value: 'sunset-lagoon', label: 'Sunset Lagoon', pincode: '744328' }
    ],
  
  
    'wandoor': [
    { value: 'andaman-north', label: 'Andaman North', pincode: '744205' },
    { value: 'andaman-south', label: 'Andaman South', pincode: '744206' },
    { value: 'baratang', label: 'Baratang', pincode: '744202' },
    { value: 'bambooflat', label: 'Bambooflat', pincode: '744101' },
    { value: 'carbyns-cove', label: 'Carbyns Cove', pincode: '744106' },
    { value: 'chidiya-tapu', label: 'Chidiya Tapu', pincode: '744502' },
    { value: 'garrison-village', label: 'Garrison Village', pincode: '744102' },
    { value: 'garacharma', label: 'Garacharma', pincode: '744207' },
    { value: 'kapanga', label: 'Kapanga', pincode: '744203' },
    { value: 'long-island', label: 'Long Island', pincode: '744202' },
    { value: 'mayabunder', label: 'Mayabunder', pincode: '744204' },
    { value: 'neil-island', label: 'Neil Island', pincode: '744104' },
    { value: 'port-blair', label: 'Port Blair', pincode: '744101' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '744210' },
    { value: 'rangat', label: 'Rangat', pincode: '744205' },
    { value: 'ross-island', label: 'Ross Island', pincode: '744101' },
    { value: 'south-point', label: 'South Point', pincode: '744204' },
    { value: 'sundergarh', label: 'Sundergarh', pincode: '744211' },
    { value: 'tamarind-bay', label: 'Tamarind Bay', pincode: '744205' },
    { value: 'wandoor', label: 'Wandoor', pincode: '744103' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '744103' },
    { value: 'diamond-harbour', label: 'Diamond Harbour', pincode: '744208' },
    { value: 'golden-bay', label: 'Golden Bay', pincode: '744301' },
    { value: 'sunrise-bay', label: 'Sunrise Bay', pincode: '744207' },
    { value: 'beach-view', label: 'Beach View', pincode: '744110' },
    { value: 'apricot-nagar', label: 'Apricot Nagar', pincode: '744105' },
    { value: 'south-bay', label: 'South Bay', pincode: '744207' },
    { value: 'bamboo-bay-view', label: 'Bamboo Bay View', pincode: '744101' },
    { value: 'manikpur', label: 'Manikpur', pincode: '744105' },
    { value: 'mauritius-bay', label: 'Mauritius Bay', pincode: '744301' },
    { value: 'apricot-bay', label: 'Apricot Bay', pincode: '744210' },
    { value: 'nikobar-bay', label: 'Nikobar Bay', pincode: '744309' },
    { value: 'tamarind-beach', label: 'Tamarind Beach', pincode: '744211' },
    { value: 'bamboo-forest', label: 'Bamboo Forest', pincode: '744103' },
    { value: 'greenwich-bay', label: 'Greenwich Bay', pincode: '744105' },
    { value: 'lighthouse-point', label: 'Lighthouse Point', pincode: '744204' },
    { value: 'rainforest', label: 'Rainforest', pincode: '744206' },
    { value: 'sail-rock', label: 'Sail Rock', pincode: '744110' },
    { value: 'coastal-village', label: 'Coastal Village', pincode: '744102' },
    { value: 'paradise-bay', label: 'Paradise Bay', pincode: '744205' },
    { value: 'coral-bay', label: 'Coral Bay', pincode: '744106' },
    { value: 'seaview-bay', label: 'Seaview Bay', pincode: '744108' },
    { value: 'calm-bay', label: 'Calm Bay', pincode: '744110' },
    { value: 'ocean-view', label: 'Ocean View', pincode: '744209' },
    { value: 'sunset-bay', label: 'Sunset Bay', pincode: '744205' },
    { value: 'hidden-cove', label: 'Hidden Cove', pincode: '744212' },
    { value: 'cloudy-bay', label: 'Cloudy Bay', pincode: '744203' },
    { value: 'shallow-bay', label: 'Shallow Bay', pincode: '744104' },
    { value: 'misty-point', label: 'Misty Point', pincode: '744209' },
    { value: 'fishermen-village', label: 'Fishermen Village', pincode: '744103' },
    { value: 'green-bay', label: 'Green Bay', pincode: '744206' },
    { value: 'silver-bay', label: 'Silver Bay', pincode: '744210' },
    { value: 'rustic-cove', label: 'Rustic Cove', pincode: '744205' },
    { value: 'emerald-bay', label: 'Emerald Bay', pincode: '744204' },
    { value: 'twin-islands-central', label: 'Twin Islands Central', pincode: '744307' },
    { value: 'twin-islands-north', label: 'Twin Islands North', pincode: '744308' },
    { value: 'twin-islands-south', label: 'Twin Islands South', pincode: '744309' },
    { value: 'twin-islands-east', label: 'Twin Islands East', pincode: '744310' },
    { value: 'twin-islands-west', label: 'Twin Islands West', pincode: '744311' },
    { value: 'twin-islands-beach', label: 'Twin Islands Beach', pincode: '744312' },
    { value: 'river-cove', label: 'River Cove', pincode: '744313' },
    { value: 'misty-lagoon', label: 'Misty Lagoon', pincode: '744314' },
    { value: 'coastal-village-bay', label: 'Coastal Village Bay', pincode: '744315' },
    { value: 'sunshine-bay', label: 'Sunshine Bay', pincode: '744316' },
    { value: 'blue-lagoon', label: 'Blue Lagoon', pincode: '744317' },
    { value: 'bamboo-bay', label: 'Bamboo Bay', pincode: '744318' },
    { value: 'sand-dunes', label: 'Sand Dunes', pincode: '744319' },
    { value: 'hidden-lagoon', label: 'Hidden Lagoon', pincode: '744320' },
    { value: 'crystal-bay', label: 'Crystal Bay', pincode: '744321' },
    { value: 'twin-bay', label: 'Twin Bay', pincode: '744322' },
    { value: 'starfish-bay', label: 'Starfish Bay', pincode: '744323' },
    { value: 'jungle-cove', label: 'Jungle Cove', pincode: '744324' },
    { value: 'whale-bay', label: 'Whale Bay', pincode: '744325' },
    { value: 'echo-point', label: 'Echo Point', pincode: '744326' },
    { value: 'waterfall-bay', label: 'Waterfall Bay', pincode: '744327' },
    { value: 'sunset-lagoon', label: 'Sunset Lagoon', pincode: '744328' }
    ],
  
  //Delhi areas
  'east-delhi': [
    { value: 'anand-vihar', label: 'Anand Vihar', pincode: '110092' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '110018' },
    { value: 'balbir-nagar', label: 'Balbir Nagar', pincode: '110032' },
    { value: 'chandri-bagh', label: 'Chandri Bagh', pincode: '110032' },
    { value: 'east-of-kailash', label: 'East of Kailash', pincode: '110065' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'katwaria-sarai', label: 'Katwaria Sarai', pincode: '110016' },
    { value: 'laxmi-nagar', label: 'Laxmi Nagar', pincode: '110092' },
    { value: 'mayur-vihar', label: 'Mayur Vihar', pincode: '110091' },
    { value: 'mukherjee-nagar', label: 'Mukherjee Nagar', pincode: '110009' },
    { value: 'preet-vihar', label: 'Preet Vihar', pincode: '110092' },
    { value: 'shakarpur', label: 'Shakarpur', pincode: '110092' },
    { value: 'vishwas-nagar', label: 'Vishwas Nagar', pincode: '110032' },
    { value: 'yojna-vihar', label: 'Yojna Vihar', pincode: '110092' },
    { value: 'mandawali', label: 'Mandawali', pincode: '110092' },
    { value: 'saraswati-vihar', label: 'Saraswati Vihar', pincode: '110034' },
    { value: 'vijay-chowk', label: 'Vijay Chowk', pincode: '110001' },
    { value: 'welcome', label: 'Welcome', pincode: '110053' },
    { value: 'nihal-vihar', label: 'Nihal Vihar', pincode: '110041' },
    { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '110051' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '110031' },
    { value: 'farsh-bazar', label: 'Farsh Bazar', pincode: '110053' },
    { value: 'jaffrabad', label: 'Jaffrabad', pincode: '110053' },
    { value: 'maujpur', label: 'Maujpur', pincode: '110053' },
    { value: 'kalyan-puri', label: 'Kalyan Puri', pincode: '110091' },
    { value: 'loni-road', label: 'Loni Road', pincode: '110093' },
    { value: 'krishna-basti', label: 'Krishna Basti', pincode: '110094' },
    { value: 'jankipuram', label: 'Jankipuram', pincode: '110039' }
    ],
  
  
    'west-delhi': [
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '110018' },
    { value: 'baljeet-nagar', label: 'Baljeet Nagar', pincode: '110008' },
    { value: 'janakpuri', label: 'Janakpuri', pincode: '110058' },
    { value: 'kalkaji', label: 'Kalkaji', pincode: '110019' },
    { value: 'karol-bagh', label: 'Karol Bagh', pincode: '110005' },
    { value: 'kirti-nagar', label: 'Kirti Nagar', pincode: '110015' },
    { value: 'mahipalpur', label: 'Mahipalpur', pincode: '110037' },
    { value: 'moti-nagar', label: 'Moti Nagar', pincode: '110015' },
    { value: 'mundka', label: 'Mundka', pincode: '110041' },
    { value: 'najafgarh', label: 'Najafgarh', pincode: '110043' },
    { value: 'paschim-vihar', label: 'Paschim Vihar', pincode: '110063' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '110008' },
    { value: 'punjabi-bagh', label: 'Punjabi Bagh', pincode: '110026' },
    { value: 'rajouri-garden', label: 'Rajouri Garden', pincode: '110027' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '110027' },
    { value: 'tagore-garden', label: 'Tagore Garden', pincode: '110027' },
    { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '110018' },
    { value: 'uttam-nagar', label: 'Uttam Nagar', pincode: '110059' },
    { value: 'vijay-enclave', label: 'Vijay Enclave', pincode: '110045' },
    { value: 'jwala-heritage', label: 'Jwala Heritage', pincode: '110034' },
    { value: 'mangolpuri', label: 'Mangolpuri', pincode: '110083' },
    { value: 'rohit-kunj', label: 'Rohit Kunj', pincode: '110086' },
    { value: 'west-patelnagar', label: 'West Patel Nagar', pincode: '110008' },
    { value: 'sri-agarwal', label: 'Sri Agarwal', pincode: '110062' },
    { value: 'naraina-vihar', label: 'Naraina Vihar', pincode: '110028' },
    { value: 'sant-nagar', label: 'Sant Nagar', pincode: '110065' },
    { value: 'bindapur', label: 'Bindapur', pincode: '110059' },
    { value: 'chhattarpur', label: 'Chhattarpur', pincode: '110074' },
    { value: 'dwarka', label: 'Dwarka', pincode: '110075' }
    ],
  
    'north-delhi': [
    { value: 'aditi-vihar', label: 'Aditi Vihar', pincode: '110052' },
    { value: 'azadpur', label: 'Azadpur', pincode: '110033' },
    { value: 'bhagwan-mahavir-nagar', label: 'Bhagwan Mahavir Nagar', pincode: '110018' },
    { value: 'burari', label: 'Burari', pincode: '110084' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '110054' },
    { value: 'karampura', label: 'Karampura', pincode: '110015' },
    { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '110051' },
    { value: 'kudlat-vihar', label: 'Kudlat Vihar', pincode: '110042' },
    { value: 'malka-ganj', label: 'Malka Ganj', pincode: '110007' },
    { value: 'model-town', label: 'Model Town', pincode: '110009' },
    { value: 'mori-gate', label: 'Mori Gate', pincode: '110006' },
    { value: 'narela', label: 'Narela', pincode: '110040' },
    { value: 'nehrunagar', label: 'Nehru Nagar', pincode: '110065' },
    { value: 'pratap-nagar', label: 'Pratap Nagar', pincode: '110007' },
    { value: 'roshanara', label: 'Roshanara', pincode: '110007' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '110006' },
    { value: 'shahdara', label: 'Shahdara', pincode: '110032' },
    { value: 'shalimar-bagh', label: 'Shalimar Bagh', pincode: '110088' },
    { value: 'shivaji-park', label: 'Shivaji Park', pincode: '110026' },
    { value: 'sindh-park', label: 'Sindh Park', pincode: '110042' },
    { value: 'timarpur', label: 'Timarpur', pincode: '110054' },
    { value: 'wazirabad', label: 'Wazirabad', pincode: '110084' },
    { value: 'bhalswa', label: 'Bhalswa', pincode: '110039' },
    { value: 'daryaganj', label: 'Daryaganj', pincode: '110002' },
    { value: 'kamla-nagar', label: 'Kamla Nagar', pincode: '110007' },
    { value: 'sadar-paharganj', label: 'Sadar Paharganj', pincode: '110055' },
    { value: 'pitampura', label: 'Pitampura', pincode: '110034' },
    { value: 'himalaya-mall', label: 'Himalaya Mall', pincode: '110009' },
    { value: 'kachhumber', label: 'Kachhumber', pincode: '110048' },
    { value: 'nehrugali', label: 'Nehrugali', pincode: '110016' },
    { value: 'ganga-ram-hospital', label: 'Ganga Ram Hospital', pincode: '110060' },
    { value: 'kamal-park', label: 'Kamal Park', pincode: '110014' },
    { value: 'chandni-chowk', label: 'Chandni Chowk', pincode: '110006' },
    { value: 'kashmiri-gate', label: 'Kashmiri Gate', pincode: '110006' },
    { value: 'khajoori', label: 'Khajoori', pincode: '110094' },
    { value: 'kachchi-udaan', label: 'Kachchi Udaan', pincode: '110034' },
    { value: 'north-avenue', label: 'North Avenue', pincode: '110001' }
    ],
  
  
    'south-delhi': [
    { value: 'ambi-bwala', label: 'Ambi Bwala', pincode: '110046' },
    { value: 'aschok-vihar', label: 'Ashok Vihar', pincode: '110052' },
    { value: 'bani-park', label: 'Bani Park', pincode: '110054' },
    { value: 'chauhan-bagh', label: 'Chauhan Bagh', pincode: '110043' },
    { value: 'chhattarpur', label: 'Chhattarpur', pincode: '110074' },
    { value: 'cr-puram', label: 'CR Puram', pincode: '110064' },
    { value: 'defence-colony', label: 'Defence Colony', pincode: '110024' },
    { value: 'green-park', label: 'Green Park', pincode: '110016' },
    { value: 'hauz-khas', label: 'Hauz Khas', pincode: '110016' },
    { value: 'jaitpur', label: 'Jaitpur', pincode: '110044' },
    { value: 'kalindi-colony', label: 'Kalindi Colony', pincode: '110019' },
    { value: 'kalkaji', label: 'Kalkaji', pincode: '110019' },
    { value: 'lajpat-nagar', label: 'Lajpat Nagar', pincode: '110024' },
    { value: 'madangir', label: 'Madangir', pincode: '110062' },
    { value: 'masjid-moth', label: 'Masjid Moth', pincode: '110048' },
    { value: 'mehrauli', label: 'Mehrauli', pincode: '110030' },
    { value: 'molarband', label: 'Molarband', pincode: '110044' },
    { value: 'nehru-place', label: 'Nehru Place', pincode: '110019' },
    { value: 'okhla', label: 'Okhla', pincode: '110020' },
    { value: 'panchsheel-park', label: 'Panchsheel Park', pincode: '110017' },
    { value: 'saket', label: 'Saket', pincode: '110017' },
    { value: 'sarita-vihar', label: 'Sarita Vihar', pincode: '110076' },
    { value: 'shaheen-bagh', label: 'Shaheen Bagh', pincode: '110025' },
    { value: 'sionia', label: 'Sionia', pincode: '110074' },
    { value: 'sri-aurangzeb-road', label: 'Sri Aurangzeb Road', pincode: '110020' },
    { value: 'south-extension', label: 'South Extension', pincode: '110049' },
    { value: 'tughlakabad', label: 'Tughlakabad', pincode: '110044' },
    { value: 'vasant-kunj', label: 'Vasant Kunj', pincode: '110070' },
    { value: 'vijay-bhawan', label: 'Vijay Bhawan', pincode: '110070' },
    { value: 'zakhira', label: 'Zakhira', pincode: '110014' },
    { value: 'alaknanda', label: 'Alaknanda', pincode: '110019' },
    { value: 'badarpur', label: 'Badarpur', pincode: '110044' },
    { value: 'beharaj-ka-bagh', label: 'Beharaj Ka Bagh', pincode: '110045' },
    { value: 'chhatarpur-enclave', label: 'Chhatarpur Enclave', pincode: '110074' },
    { value: 'friends-colony', label: 'Friends Colony', pincode: '110065' },
    { value: 'gulmohar-park', label: 'Gulmohar Park', pincode: '110049' },
    { value: 'janakpuri', label: 'Janakpuri', pincode: '110058' },
    { value: 'lajpat-nagar-ii', label: 'Lajpat Nagar II', pincode: '110024' },
    { value: 'moti-bagh', label: 'Moti Bagh', pincode: '110021' },
    { value: 'neeti-bagh', label: 'Neeti Bagh', pincode: '110049' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '110008' },
    { value: 'rangpuri', label: 'Rangpuri', pincode: '110037' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '110006' },
    { value: 'sarojini-nagar', label: 'Sarojini Nagar', pincode: '110023' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '110030' },
    { value: 'zafrabad', label: 'Zafrabad', pincode: '110020' }
    ],
  
    'central-delhi': [
    { value: 'ahmed-abad', label: 'Ahmedabad', pincode: '110004' },
    { value: 'ajmeri-gate', label: 'Ajmeri Gate', pincode: '110006' },
    { value: 'ajmal-khan-road', label: 'Ajmal Khan Road', pincode: '110005' },
    { value: 'bal-jeevan-park', label: 'Bal Jeevan Park', pincode: '110005' },
    { value: 'barakhamba-road', label: 'Barakhamba Road', pincode: '110001' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '110052' },
    { value: 'bangla-sahib', label: 'Bangla Sahib', pincode: '110001' },
    { value: 'chandni-chowk', label: 'Chandni Chowk', pincode: '110006' },
    { value: 'chawri-bazar', label: 'Chawri Bazar', pincode: '110006' },
    { value: 'connaught-place', label: 'Connaught Place', pincode: '110001' },
    { value: 'dav-park', label: 'DAV Park', pincode: '110009' },
    { value: 'delhi-gate', label: 'Delhi Gate', pincode: '110002' },
    { value: 'daryaganj', label: 'Daryaganj', pincode: '110002' },
    { value: 'fatehpuri', label: 'Fatehpuri', pincode: '110006' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '110031' },
    { value: 'karol-bagh', label: 'Karol Bagh', pincode: '110005' },
    { value: 'karol-bagh-market', label: 'Karol Bagh Market', pincode: '110005' },
    { value: 'kashmiri-gate', label: 'Kashmiri Gate', pincode: '110006' },
    { value: 'mandi-house', label: 'Mandi House', pincode: '110001' },
    { value: 'maharashtra-sadan', label: 'Maharashtra Sadan', pincode: '110001' },
    { value: 'moti-bagh', label: 'Moti Bagh', pincode: '110021' },
    { value: 'moti-bagh-market', label: 'Moti Bagh Market', pincode: '110021' },
    { value: 'old-patel-nagar', label: 'Old Patel Nagar', pincode: '110008' },
    { value: 'pahar-ganj', label: 'Pahar Ganj', pincode: '110055' },
    { value: 'patel-nagar-west', label: 'Patel Nagar West', pincode: '110008' },
    { value: 'rajinder-nagar', label: 'Rajinder Nagar', pincode: '110060' },
    { value: 'rani-jhansi-road', label: 'Rani Jhansi Road', pincode: '110055' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '110006' },
    { value: 'sadar-bazaar-area', label: 'Sadar Bazaar Area', pincode: '110006' },
    { value: 'shankar-road', label: 'Shankar Road', pincode: '110060' },
    { value: 'sri-aurobindo-marg', label: 'Sri Aurobindo Marg', pincode: '110016' },
    { value: 'tantia-bhagwan', label: 'Tantia Bhagwan', pincode: '110005' },
    { value: 'tata-road', label: 'Tata Road', pincode: '110005' },
    { value: 'west-patel-nagar', label: 'West Patel Nagar', pincode: '110008' },
    { value: 'william-purse', label: 'William Purse', pincode: '110001' },
    { value: 'bhishma-ali-road', label: 'Bhishma Ali Road', pincode: '110005' },
    { value: 'azad-market', label: 'Azad Market', pincode: '110006' },
    { value: 'baoli', label: 'Baoli', pincode: '110006' },
    { value: 'chandni-chowk-market', label: 'Chandni Chowk Market', pincode: '110006' },
    { value: 'connaught-place-market', label: 'Connaught Place Market', pincode: '110001' },
    { value: 'gokul-puri', label: 'Gokul Puri', pincode: '110094' },
    { value: 'pahar-ganj-market', label: 'Pahar Ganj Market', pincode: '110055' },
    { value: 'patel-nagar-east', label: 'Patel Nagar East', pincode: '110008' },
    { value: 'rickshaw-pullers-area', label: 'Rickshaw Pullers Area', pincode: '110005' },
    { value: 'teliwara', label: 'Teliwara', pincode: '110006' }
    ],

'puducherry': [
  { value: 'abhishekapakkam', label: 'Abhishekapakkam', pincode: '605010' },
  { value: 'annanagar', label: 'Anna Nagar', pincode: '605005' },
  { value: 'annamalainagar', label: 'Annamalai Nagar', pincode: '605001' },
  { value: 'aravindarnagar', label: 'Aravindar Nagar', pincode: '605004' },
  { value: 'ariyankuppam', label: 'Ariyankuppam', pincode: '605102' },
  { value: 'ariyapalayam', label: 'Ariyapalayam', pincode: '605005' },
  { value: 'ariyur', label: 'Ariyur', pincode: '605009' },
  { value: 'ashoknagar', label: 'Ashok Nagar', pincode: '605008' },
  { value: 'auroville', label: 'Auroville', pincode: '605101' },
  { value: 'bahur', label: 'Bahur', pincode: '605110' },
  { value: 'bommayapalayam', label: 'Bommayapalayam', pincode: '605009' },
  { value: 'brindavanam', label: 'Brindavanam', pincode: '605001' },
  { value: 'chettipattu', label: 'Chettipattu', pincode: '605014' },
  { value: 'colasnagar', label: 'Colas Nagar', pincode: '605008' },
  { value: 'cuddalore', label: 'Cuddalore', pincode: '607001' },
  { value: 'dharmapuri', label: 'Dharmapuri', pincode: '605105' },
  { value: 'ecrroad', label: 'ECR Road', pincode: '605007' },
  { value: 'edayanchavady', label: 'Edayanchavady', pincode: '605103' },
  { value: 'ellaiammankoil', label: 'Ellaiamman Koil', pincode: '605104' },
  { value: 'gaffournagarextension', label: 'Gaffour Nagar Extension', pincode: '605103' },
  { value: 'gorimedu', label: 'Gorimedu', pincode: '605102' },
  { value: 'hacircle', label: 'HAC Circle', pincode: '605001' },
  { value: 'heritagetown', label: 'Heritage Town', pincode: '605001' },
  { value: 'ilangonagar', label: 'Ilango Nagar', pincode: '605002' },
  { value: 'iyyankarcoilstreet', label: 'Iyyanar Koil Street', pincode: '605003' },
  { value: 'jansinagar', label: 'Jansi Nagar', pincode: '605005' },
  { value: 'jhonsinagar', label: 'Jhonsi Nagar', pincode: '605002' },
  { value: 'kalaivanarnagar', label: 'Kalaivanar Nagar', pincode: '605004' },
  { value: 'kalapet', label: 'Kalapet', pincode: '605014' },
  { value: 'kamarajnagar', label: 'Kamaraj Nagar', pincode: '605008' },
  { value: 'kanniyakoil', label: 'Kanniyakoil', pincode: '605001' },
  { value: 'karaikal', label: 'Karaikal', pincode: '609602' },
  { value: 'karikalampakkam', label: 'Karikalampakkam', pincode: '605101' },
  { value: 'karuvadikuppamecrroad', label: 'Karuvadikuppam ECR Road', pincode: '605007' },
  { value: 'kathirkamam', label: 'Kathirkamam', pincode: '605106' },
  { value: 'keezhsathamangalam', label: 'Keezh Sathamangalam', pincode: '605008' },
  { value: 'kirumampakkam', label: 'Kirumampakkam', pincode: '605101' },
  { value: 'kottakuppam', label: 'Kottakuppam', pincode: '605102' },
  { value: 'kottupalayam', label: 'Kottupalayam', pincode: '605104' },
  { value: 'krishnanagar', label: 'Krishna Nagar', pincode: '605010' },
  { value: 'kuruchikuppam', label: 'Kuruchikuppam', pincode: '605104' },
  { value: 'kurumbapet', label: 'Kurumbapet', pincode: '605009' },
  { value: 'lawspet', label: 'Lawspet', pincode: '605008' },
  { value: 'lebonheurnagar', label: 'Le Bonheur Nagar', pincode: '605103' },
  { value: 'madagadipet', label: 'Madagadipet', pincode: '605106' },
  { value: 'madukarai', label: 'Madukarai', pincode: '605107' },
  { value: 'mahaveernagar', label: 'Mahaveer Nagar', pincode: '605007' },
  { value: 'mailam', label: 'Mailam', pincode: '605205' },
  { value: 'manapet', label: 'Manapet', pincode: '605108' },
  { value: 'marapalam', label: 'Marapalam', pincode: '605007' },
  { value: 'marieoulgaret', label: 'Marie Oulgaret', pincode: '605004' },
  { value: 'mariyalnagar', label: 'Mariyal Nagar', pincode: '605005' },
  { value: 'mettuplalayam', label: 'Mettupalayam', pincode: '605102' },
  { value: 'mgrood', label: 'MG Road', pincode: '605001' },
  { value: 'montorsierstreet', label: 'Montorsier Street', pincode: '605001' },
  { value: 'moogambigainagar', label: 'Moogambigai Nagar', pincode: '605107' },
  { value: 'moolakulam', label: 'Moolakulam', pincode: '605006' },
  { value: 'mudaliyarpet', label: 'Mudaliyarpet', pincode: '605008' },
  { value: 'muratandy', label: 'Muratandy', pincode: '605102' },
  { value: 'murungapakam', label: 'Murungapakam', pincode: '605002' },
  { value: 'muthialpet', label: 'Muthialpet', pincode: '605003' },
  { value: 'navarkulam', label: 'Navarkulam', pincode: '605103' },
  { value: 'nethajinagar', label: 'Nethaji Nagar', pincode: '605008' },
  { value: 'nettapakkam', label: 'Nettapakkam', pincode: '605106' },
  { value: 'newsaram', label: 'New Saram', pincode: '605013' },
  { value: 'odiyampattu', label: 'Odiyampattu', pincode: '605108' },
  { value: 'orleanpet', label: 'Orleanpet', pincode: '605002' },
  { value: 'oulgaret', label: 'Oulgaret', pincode: '605008' },
  { value: 'pakkamudayanpet', label: 'Pakkamudayanpet', pincode: '605106' },
  { value: 'pangoor', label: 'Pangoor', pincode: '605107' },
  { value: 'pappammalkoilstreet', label: 'Pappammal Koil Street', pincode: '605103' },
  { value: 'pattanur', label: 'Pattanur', pincode: '605103' },
  { value: 'periyakattupalayam', label: 'Periyakattupalayam', pincode: '605101' },
  { value: 'pillaichavady', label: 'Pillaichavady', pincode: '605107' },
  { value: 'ponnagar', label: 'Pon Nagar', pincode: '605012' },
  { value: 'puducherry', label: 'Puducherry', pincode: '605001' },
  { value: 'pulivalam', label: 'Pulivalam', pincode: '605106' },
  { value: 'ragavendranagar', label: 'Ragavendra Nagar', pincode: '605008' },
  { value: 'rainbownagar', label: 'Rainbow Nagar', pincode: '605012' },
  { value: 'ramalinganagar', label: 'Ramalinga Nagar', pincode: '605008' },
  { value: 'reddiarpalayam', label: 'Reddiarpalayam', pincode: '605009' },
  { value: 'reddiyarpalayam', label: 'Reddiyar Palayam', pincode: '605010' },
  { value: 'saram', label: 'Saram', pincode: '605013' },
  { value: 'shanthinagar', label: 'Shanthi Nagar', pincode: '605011' },
  { value: 'sorapet', label: 'Sorapet', pincode: '605004' },
  { value: 'subbiah', label: 'Subbiah Nagar', pincode: '605004' },
  { value: 'swarnanagar', label: 'Swarna Nagar', pincode: '605104' },
  { value: 'tagorenagar', label: 'Tagore Nagar', pincode: '605004' },
  { value: 'thattanchavady', label: 'Thattanchavady', pincode: '605009' },
  { value: 'thavalakuppam', label: 'Thavalakuppam', pincode: '605007' },
  { value: 'thengaithittu', label: 'Thengaithittu', pincode: '605007' },
  { value: 'thirukkanur', label: 'Thirukkanur', pincode: '605005' },
  { value: 'thiruvandarkoil', label: 'Thiruvandarkoil', pincode: '605102' },
  { value: 'utchimedu', label: 'Utchimedu', pincode: '605111' },
  { value: 'vaithikuppam', label: 'Vaithikuppam', pincode: '605101' },
  { value: 'vasannagar', label: 'Vasan Nagar', pincode: '605008' },
  { value: 'veerapattinam', label: 'Veerampattinam', pincode: '605007' },
  { value: 'velrampet', label: 'Velrampet', pincode: '605011' },
  { value: 'venkatanagar', label: 'Venkata Nagar', pincode: '605003' },
  { value: 'villiyannur', label: 'Villiyannur', pincode: '605402' },
  { value: 'vocstreet', label: 'VOC street', pincode: '605001' },
  { value: 'whitetown', label: 'White Town', pincode: '605001' },
  { value: 'yanam', label: 'Yanam', pincode: '533464' }
  ],
'ariyankuppam': [
  { value: 'adityanagar', label: 'Adityanagar', pincode: '605007' },
  { value: 'akkarappalayam', label: 'Akkarappalayam', pincode: '605009' },
  { value: 'balaianthangal', label: 'Balaianthangal', pincode: '605008' },
  { value: 'bharthidasan', label: 'Bharthidasan', pincode: '605014' },
  { value: 'buddhavarapalayam', label: 'Buddhavarapalayam', pincode: '605014' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karikalampakkam', label: 'Karikalampakkam', pincode: '605010' },
  { value: 'kattukuppam', label: 'Kattukuppam', pincode: '605011' },
  { value: 'kottakuppam', label: 'Kottakuppam', pincode: '605016' },
  { value: 'neelangarai', label: 'Neelangarai', pincode: '605013' },
  { value: 'pettai', label: 'Pettai', pincode: '605015' },
  { value: 'sithanandha', label: 'Sithanandha', pincode: '605016' },
  { value: 'thavalakuppam', label: 'Thavalakuppam', pincode: '605017' },
  { value: 'vellakupam', label: 'Vellakupam', pincode: '605017' },
  { value: 'arjunapalayam', label: 'Arjunapalayam', pincode: '605001' },
  { value: 'chinna-mudaliar-chavadi', label: 'Chinna Mudaliar Chavadi', pincode: '605003' },
  { value: 'krishnapuram', label: 'Krishnapuram', pincode: '605005' },
  { value: 'manaveli', label: 'Manaveli', pincode: '605019' },
  { value: 'mandagapalayam', label: 'Mandagapalayam', pincode: '605020' },
  { value: 'sindhanai', label: 'Sindhanai', pincode: '605021' },
  { value: 'villianur', label: 'Villianur', pincode: '605108' },
  { value: 'varadarajapuram', label: 'Varadarajapuram', pincode: '605101' }
  ],

  'bahour': [
  { value: 'a-virapandian', label: 'A. Virapandian', pincode: '605106' },
  { value: 'balanvadi', label: 'Balanvadi', pincode: '605107' },
  { value: 'bahour', label: 'Bahour', pincode: '605101' },
  { value: 'bangaloor', label: 'Bangaloor', pincode: '605105' },
  { value: 'bhankarpalayam', label: 'Bhankarpalayam', pincode: '605102' },
  { value: 'chinna-bahour', label: 'Chinna Bahour', pincode: '605108' },
  { value: 'darga', label: 'Darga', pincode: '605103' },
  { value: 'gandhinagar', label: 'Gandhinagar', pincode: '605104' },
  { value: 'kattur', label: 'Kattur', pincode: '605109' },
  { value: 'kottakuppam', label: 'Kottakuppam', pincode: '605116' },
  { value: 'kumilagaram', label: 'Kumilagaram', pincode: '605110' },
  { value: 'manaveli', label: 'Manaveli', pincode: '605111' },
  { value: 'murungapakkam', label: 'Murungapakkam', pincode: '605112' },
  { value: 'nallampalayam', label: 'Nallampalayam', pincode: '605113' },
  { value: 'pettai', label: 'Pettai', pincode: '605114' },
  { value: 'sithanandha', label: 'Sithanandha', pincode: '605115' },
  { value: 'perungulam', label: 'Perungulam', pincode: '605119' },
  { value: 'ranganathapuram', label: 'Ranganathapuram', pincode: '605120' },
  { value: 'sundaravadi', label: 'Sundaravadi', pincode: '605121' },
  { value: 'thirubuvanam', label: 'Thirubuvanam', pincode: '605122' },
  { value: 'thiruvandarkoil', label: 'Thiruvandarkoil', pincode: '605123' },
  { value: 'valavanthankarai', label: 'Valavanthankarai', pincode: '605124' },
  { value: 'villianur', label: 'Villianur', pincode: '605108' }
  ],

  'chettipattu/chettipet': [
  { value: 'chettipattu', label: 'Chettipattu', pincode: '605104' },
  { value: 'chinthamani', label: 'Chinthamani', pincode: '605103' },
  { value: 'irumbuliyur', label: 'Irumbuliyur', pincode: '605102' },
  { value: 'kattur', label: 'Kattur', pincode: '605105' },
  { value: 'kottakuppam', label: 'Kottakuppam', pincode: '605106' },
  { value: 'muthanallur', label: 'Muthanallur', pincode: '605107' },
  { value: 'neelangarai', label: 'Neelangarai', pincode: '605108' },
  { value: 'pettai', label: 'Pettai', pincode: '605110' },
  { value: 'sithanandha', label: 'Sithanandha', pincode: '605111' },
  { value: 'thiruporur', label: 'Thiruporur', pincode: '605112' },
  { value: 'vellankuppam', label: 'Vellankuppam', pincode: '605113' },
  { value: 'villianur', label: 'Villianur', pincode: '605114' },
  { value: 'adityanagar', label: 'Adityanagar', pincode: '605105' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '605101' },
  { value: 'ananthapalayam', label: 'Ananthapalayam', pincode: '605120' },
  { value: 'balanvadi', label: 'Balanvadi', pincode: '605121' },
  { value: 'bharathidasan', label: 'Bharathidasan', pincode: '605122' },
  { value: 'buddhavarapalayam', label: 'Buddhavarapalayam', pincode: '605123' },
  { value: 'karikalampakkam', label: 'Karikalampakkam', pincode: '605124' },
  { value: 'kolathur', label: 'Kolathur', pincode: '605125' },
  { value: 'manaveli', label: 'Manaveli', pincode: '605126' },
  { value: 'murungapakkam', label: 'Murungapakkam', pincode: '605127' },
  { value: 'sundaravadi', label: 'Sundaravadi', pincode: '605128' }
  ],

  'karaikal': [
  { value: 'karaikal', label: 'Karaikal', pincode: '609602' },
  { value: 'balakumaran', label: 'Balakumaran', pincode: '609603' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '609604' },
  { value: 'kamaraj-nagar', label: 'Kamaraj Nagar', pincode: '609605' },
  { value: 'kottur', label: 'Kottur', pincode: '609606' },
  { value: 'muttam', label: 'Muttam', pincode: '609607' },
  { value: 'nagapattinam', label: 'Nagapattinam', pincode: '609608' },
  { value: 'neravy', label: 'Neravy', pincode: '609609' },
  { value: 'periyakalapet', label: 'Periyakalapet', pincode: '609610' },
  { value: 'punalur', label: 'Punalur', pincode: '609611' },
  { value: 'sankaraperi', label: 'Sankaraperi', pincode: '609612' },
  { value: 'sitharkadu', label: 'Sitharkadu', pincode: '609613' },
  { value: 'thirunallar', label: 'Thirunallar', pincode: '609614' },
  { value: 'veppalodai', label: 'Veppalodai', pincode: '609615' },
  { value: 'annai-veerakaliamman', label: 'Annai Veerakaliamman', pincode: '609616' },
  { value: 'avittam', label: 'Avittam', pincode: '609617' },
  { value: 'cheranmahadevi', label: 'Cheranmahadevi', pincode: '609618' },
  { value: 'kandarvakottai', label: 'Kandarvakottai', pincode: '609619' },
  { value: 'kizhakku-palayam', label: 'Kizhakku Palayam', pincode: '609620' },
  { value: 'koothanur', label: 'Koothanur', pincode: '609621' },
  { value: 'kudavasal', label: 'Kudavasal', pincode: '609622' },
  { value: 'tulasingapuram', label: 'Tulasingapuram', pincode: '609623' },
  { value: 'vadakkumangudi', label: 'Vadakkumangudi', pincode: '609624' },
  { value: 'varadarajapuram', label: 'Varadarajapuram', pincode: '609625' }
  ],

  'katterikuppam/katteri': [
  { value: 'katterikuppam', label: 'Katterikuppam', pincode: '605106' },
  { value: 'anandapuram', label: 'Anandapuram', pincode: '605107' },
  { value: 'aranganathapuram', label: 'Aranganathapuram', pincode: '605108' },
  { value: 'balapet', label: 'Balapet', pincode: '605109' },
  { value: 'cheruvallur', label: 'Cheruvallur', pincode: '605110' },
  { value: 'irungattukottai', label: 'Irungattukottai', pincode: '605111' },
  { value: 'karaiyur', label: 'Karaiyur', pincode: '605112' },
  { value: 'kolathur', label: 'Kolathur', pincode: '605113' },
  { value: 'manaveli', label: 'Manaveli', pincode: '605114' },
  { value: 'muthampalayam', label: 'Muthampalayam', pincode: '605115' },
  { value: 'pettai', label: 'Pettai', pincode: '605116' },
  { value: 'sithanandha', label: 'Sithanandha', pincode: '605117' },
  { value: 'thavalakuppam', label: 'Thavalakuppam', pincode: '605118' },
  { value: 'vellakupam', label: 'Vellakupam', pincode: '605119' },
  { value: 'adanur', label: 'Adanur', pincode: '605120' },
  { value: 'avadi', label: 'Avadi', pincode: '605121' },
  { value: 'kudamuripi', label: 'Kudamuripi', pincode: '605122' },
  { value: 'manakuppam', label: 'Manakuppam', pincode: '605123' },
  { value: 'muthur', label: 'Muthur', pincode: '605124' },
  { value: 'perungulam', label: 'Perungulam', pincode: '605125' },
  { value: 'tirukalampudur', label: 'Tirukalampudur', pincode: '605126' },
  { value: 'varadapalayam', label: 'Varadapalayam', pincode: '605127' },
  { value: 'vayalpad', label: 'Vayalpad', pincode: '605128' },
  { value: 'arivoli', label: 'Arivoli', pincode: '605129' },
  { value: 'ayalapalayam', label: 'Ayalapalayam', pincode: '605130' },
  { value: 'bharathipuram', label: 'Bharathipuram', pincode: '605131' },
  { value: 'devikapuram', label: 'Devikapuram', pincode: '605132' },
  { value: 'elavanayagapuram', label: 'Elavanayagapuram', pincode: '605133' },
  { value: 'kadiyapalayam', label: 'Kadiyapalayam', pincode: '605134' },
  { value: 'thudiyalur', label: 'Thudiyalur', pincode: '605135' }
  ],

  'mahe': [
  { value: 'mahe', label: 'Mahe', pincode: '673310' },
  { value: 'chelimi', label: 'Chelimi', pincode: '673311' },
  { value: 'chundal', label: 'Chundal', pincode: '673312' },
  { value: 'karikal', label: 'Karikal', pincode: '673313' },
  { value: 'keelaiyur', label: 'Keelaiyur', pincode: '673314' },
  { value: 'kizhakkambalam', label: 'Kizhakkambalam', pincode: '673315' },
  { value: 'kombanadu', label: 'Kombanadu', pincode: '673316' },
  { value: 'mankudy', label: 'Mankudy', pincode: '673317' },
  { value: 'nediayath', label: 'Nediayath', pincode: '673318' },
  { value: 'periyamathur', label: 'Periyamathur', pincode: '673319' },
  { value: 'vayalpad', label: 'Vayalpad', pincode: '673320' },
  { value: 'ponnadath', label: 'Ponnadath', pincode: '673321' },
  { value: 'vellikunnu', label: 'Vellikunnu', pincode: '673322' },
  { value: 'vittanassery', label: 'Vittanassery', pincode: '673323' },
  { value: 'alappad', label: 'Alappad', pincode: '673324' },
  { value: 'arippara', label: 'Arippara', pincode: '673325' },
  { value: 'kadachira', label: 'Kadachira', pincode: '673326' },
  { value: 'kayalpad', label: 'Kayalpad', pincode: '673327' },
  { value: 'kottappuram', label: 'Kottappuram', pincode: '673328' },
  { value: 'kurichiparamba', label: 'Kurichiparamba', pincode: '673329' },
  { value: 'naluthara', label: 'Naluthara', pincode: '673330' },
  { value: 'puducherry', label: 'Puducherry', pincode: '673331' }
  ],

  'mannadipet': [
  { value: 'mannadipet', label: 'Mannadipet', pincode: '605107' },
  { value: 'athipattu', label: 'Athipattu', pincode: '605108' },
  { value: 'chinnasalem', label: 'Chinnasalem', pincode: '605109' },
  { value: 'elavampattu', label: 'Elavampattu', pincode: '605110' },
  { value: 'karikadu', label: 'Karikadu', pincode: '605111' },
  { value: 'kottur', label: 'Kottur', pincode: '605112' },
  { value: 'kurumbapet', label: 'Kurumbapet', pincode: '605113' },
  { value: 'mannadipet-extended', label: 'Mannadipet Extended', pincode: '605114' },
  { value: 'pudupet', label: 'Pudupet', pincode: '605115' },
  { value: 'sundaravalli', label: 'Sundaravalli', pincode: '605116' },
  { value: 'thindivanam', label: 'Thindivanam', pincode: '605117' },
  { value: 'velankanni', label: 'Velankanni', pincode: '605118' },
  { value: 'thiruvannamalai', label: 'Thiruvannamalai', pincode: '605119' },
  { value: 'vengadamangalam', label: 'Vengadamangalam', pincode: '605120' },
  { value: 'veppur', label: 'Veppur', pincode: '605121' },
  { value: 'thazhuvankarai', label: 'Thazhuvankarai', pincode: '605122' },
  { value: 'pudupattu', label: 'Pudupattu', pincode: '605123' },
  { value: 'kulathupet', label: 'Kulathupet', pincode: '605124' },
  { value: 'muthupet', label: 'Muthupet', pincode: '605125' }
  ],

  'mudaliarpet': [
  { value: 'mudaliarpet', label: 'Mudaliarpet', pincode: '605008' },
  { value: 'annanagar', label: 'Annanagar', pincode: '605009' },
  { value: 'banikuppam', label: 'Banikuppam', pincode: '605010' },
  { value: 'chemmalai', label: 'Chemmalai', pincode: '605011' },
  { value: 'cherupet', label: 'Cherupet', pincode: '605012' },
  { value: 'kothapet', label: 'Kothapet', pincode: '605013' },
  { value: 'kottur', label: 'Kottur', pincode: '605014' },
  { value: 'kurumbapet', label: 'Kurumbapet', pincode: '605015' },
  { value: 'muthialpet', label: 'Muthialpet', pincode: '605016' },
  { value: 'pettai', label: 'Pettai', pincode: '605017' },
  { value: 'sundarapet', label: 'Sundarapet', pincode: '605018' },
  { value: 'thiruvikramapuram', label: 'Thiruvikramapuram', pincode: '605019' },
  { value: 'vellalapet', label: 'Vellalapet', pincode: '605020' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '605021' },
  { value: 'avadikuppam', label: 'Avadikuppam', pincode: '605022' },
  { value: 'kottur-mudaliarpet', label: 'Kottur Mudaliarpet', pincode: '605023' },
  { value: 'muthialpet-extended', label: 'Muthialpet Extended', pincode: '605024' },
  { value: 'velachery', label: 'Velachery', pincode: '605025' },
  { value: 'pudupet', label: 'Pudupet', pincode: '605026' },
  { value: 'vanniyarpet', label: 'Vanniyarpet', pincode: '605027' },
  { value: 'vishwanathapuram', label: 'Vishwanathapuram', pincode: '605028' },
  { value: 'thiruvallur', label: 'Thiruvallur', pincode: '605029' },
  { value: 'karuvadikuppam', label: 'Karuvadikuppam', pincode: '605030' },
  { value: 'kaviyur', label: 'Kaviyur', pincode: '605031' },
  { value: 'kizhakambalam', label: 'Kizhakambalam', pincode: '605032' },
  { value: 'mannadipet', label: 'Mannadipet', pincode: '605033' },
  { value: 'munnavarapet', label: 'Munnavarapet', pincode: '605034' },
  { value: 'veppur', label: 'Veppur', pincode: '605035' },
  { value: 'poovarasanpet', label: 'Poovarasanpet', pincode: '605036' }
  ],

  'muthialpet': [
  { value: 'muthialpet', label: 'Muthialpet', pincode: '605002' },
  { value: 'annanagar', label: 'Annanagar', pincode: '605003' },
  { value: 'bhoopathy', label: 'Bhoopathy', pincode: '605004' },
  { value: 'chinnasalem', label: 'Chinnasalem', pincode: '605005' },
  { value: 'elavampattu', label: 'Elavampattu', pincode: '605006' },
  { value: 'kottur', label: 'Kottur', pincode: '605007' },
  { value: 'kurumbapet', label: 'Kurumbapet', pincode: '605008' },
  { value: 'muthialpet-extended', label: 'Muthialpet Extended', pincode: '605009' },
  { value: 'pudupet', label: 'Pudupet', pincode: '605010' },
  { value: 'sundarapet', label: 'Sundarapet', pincode: '605011' },
  { value: 'vanniyarpet', label: 'Vanniyarpet', pincode: '605012' },
  { value: 'velachery', label: 'Velachery', pincode: '605013' },
  { value: 'vishwanathapuram', label: 'Vishwanathapuram', pincode: '605014' },
  { value: 'karuvadikuppam', label: 'Karuvadikuppam', pincode: '605015' },
  { value: 'pudupet-extended', label: 'Pudupet Extended', pincode: '605016' },
  { value: 'nalakuppam', label: 'Nalakuppam', pincode: '605017' },
  { value: 'poovarasanpet', label: 'Poovarasanpet', pincode: '605018' },
  { value: 'sithalapakkam', label: 'Sithalapakkam', pincode: '605019' },
  { value: 'muthialpet-north', label: 'Muthialpet North', pincode: '605020' },
  { value: 'muthialpet-south', label: 'Muthialpet South', pincode: '605021' },
  { value: 'selvapuram', label: 'Selvapuram', pincode: '605022' },
  { value: 'kavundampalayam', label: 'Kavundampalayam', pincode: '605023' },
  { value: 'kanagam', label: 'Kanagam', pincode: '605024' },
  { value: 'muthialpet-central', label: 'Muthialpet Central', pincode: '605025' },
  { value: 'salem-kottur', label: 'Salem Kottur', pincode: '605026' },
  { value: 'vannathur', label: 'Vannathur', pincode: '605027' }
  ],
  
  'nettapakkam': [
  { value: 'nettapakkam', label: 'Nettapakkam', pincode: '605106' },
  { value: 'ananthapuram', label: 'Ananthapuram', pincode: '605107' },
  { value: 'bhoopathy', label: 'Bhoopathy', pincode: '605108' },
  { value: 'kottur', label: 'Kottur', pincode: '605109' },
  { value: 'kurumbapet', label: 'Kurumbapet', pincode: '605110' },
  { value: 'mannadipet', label: 'Mannadipet', pincode: '605111' },
  { value: 'murungapakkam', label: 'Murungapakkam', pincode: '605112' },
  { value: 'poovam', label: 'Poovam', pincode: '605113' },
  { value: 'sundarapet', label: 'Sundarapet', pincode: '605114' },
  { value: 'vellakulam', label: 'Vellakulam', pincode: '605115' },
  { value: 'velachery', label: 'Velachery', pincode: '605116' },
  { value: 'avadikuppam', label: 'Avadikuppam', pincode: '605117' },
  { value: 'elavampattu', label: 'Elavampattu', pincode: '605118' },
  { value: 'muthialpet', label: 'Muthialpet', pincode: '605119' },
  { value: 'pudupet', label: 'Pudupet', pincode: '605120' },
  { value: 'thiruvikramapuram', label: 'Thiruvikramapuram', pincode: '605121' },
  { value: 'sithalapakkam', label: 'Sithalapakkam', pincode: '605122' },
  { value: 'veppur', label: 'Veppur', pincode: '605123' },
  { value: 'vanniyarpet', label: 'Vanniyarpet', pincode: '605124' },
  { value: 'vishwanathapuram', label: 'Vishwanathapuram', pincode: '605125' },
  { value: 'karuvadikuppam', label: 'Karuvadikuppam', pincode: '605126' }
  ],

  'ozhukarai': [
  { value: 'ozhukarai', label: 'Ozhukarai', pincode: '605009' },
  { value: 'annanagar', label: 'Annanagar', pincode: '605010' },
  { value: 'bhoopathy', label: 'Bhoopathy', pincode: '605011' },
  { value: 'cherupet', label: 'Cherupet', pincode: '605012' },
  { value: 'kurumbapet', label: 'Kurumbapet', pincode: '605013' },
  { value: 'mannadipet', label: 'Mannadipet', pincode: '605014' },
  { value: 'murungapakkam', label: 'Murungapakkam', pincode: '605015' },
  { value: 'nalakuppam', label: 'Nalakuppam', pincode: '605016' },
  { value: 'pudupet', label: 'Pudupet', pincode: '605017' },
  { value: 'sundarapet', label: 'Sundarapet', pincode: '605018' },
  { value: 'thiruvikramapuram', label: 'Thiruvikramapuram', pincode: '605019' },
  { value: 'vanniyarpet', label: 'Vanniyarpet', pincode: '605020' },
  { value: 'vellakulam', label: 'Vellakulam', pincode: '605021' },
  { value: 'vishwanathapuram', label: 'Vishwanathapuram', pincode: '605022' },
  { value: 'avadikuppam', label: 'Avadikuppam', pincode: '605023' },
  { value: 'elavampattu', label: 'Elavampattu', pincode: '605024' },
  { value: 'karuvadikuppam', label: 'Karuvadikuppam', pincode: '605025' },
  { value: 'muthialpet', label: 'Muthialpet', pincode: '605026' },
  { value: 'nalapattu', label: 'Nalapattu', pincode: '605027' },
  { value: 'poovarasanpet', label: 'Poovarasanpet', pincode: '605028' },
  { value: 'sithalapakkam', label: 'Sithalapakkam', pincode: '605029' },
  { value: 'thirumangalam', label: 'Thirumangalam', pincode: '605030' },
  { value: 'vannathur', label: 'Vannathur', pincode: '605031' },
  { value: 'kottur', label: 'Kottur', pincode: '605032' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '605033' },
  { value: 'thiruvakkarai', label: 'Thiruvakkarai', pincode: '605034' },
  { value: 'venkatesapuram', label: 'Venkatesapuram', pincode: '605035' },
  { value: 'sudharapet', label: 'Sudharapet', pincode: '605036' }
  ],

  'villianur': [
  { value: 'annai-indira-nagar', label: 'Annai Indira Nagar', pincode: '605110' },
  { value: 'kalapet', label: 'Kalapet', pincode: '605014' },
  { value: 'kottakuppam', label: 'Kottakuppam', pincode: '605109' },
  { value: 'manaveli', label: 'Manaveli', pincode: '605109' },
  { value: 'moolakulam', label: 'Moolakulam', pincode: '605002' },
  { value: 'nallavadu', label: 'Nallavadu', pincode: '605109' },
  { value: 'perumal-koil', label: 'Perumal Koil', pincode: '605110' },
  { value: 'pillaiyar-koil', label: 'Pillaiyar Koil', pincode: '605110' },
  { value: 'thirunallar', label: 'Thirunallar', pincode: '605109' },
  { value: 'thuthipet', label: 'Thuthipet', pincode: '605110' },
  { value: 'villianur', label: 'Villianur', pincode: '605110' },
  { value: 'veerapuram', label: 'Veerapuram', pincode: '605109' },
  { value: 'kadirgamam', label: 'Kadirgamam', pincode: '605110' },
  { value: 'sundaravadi', label: 'Sundaravadi', pincode: '605110' },
  { value: 'bahour', label: 'Bahour', pincode: '605101' },
  { value: 'bavanisundarapuram', label: 'Bavanisundarapuram', pincode: '605110' },
  { value: 'chinna-mangalam', label: 'Chinna Mangalam', pincode: '605110' },
  { value: 'kumarapuram', label: 'Kumarapuram', pincode: '605110' },
  { value: 'pudupalayam', label: 'Pudupalayam', pincode: '605110' },
  { value: 'sothikuppam', label: 'Sothikuppam', pincode: '605110' },
  { value: 'villupuram', label: 'Villupuram', pincode: '605602' }
  ],

  'yanam': [
  { value: 'ambedkar-nagar', label: 'Ambedkar Nagar', pincode: '533464' },
  { value: 'annamalaipuram', label: 'Annamalaipuram', pincode: '533464' },
  { value: 'bayyaram', label: 'Bayyaram', pincode: '533464' },
  { value: 'burugupeta', label: 'Burugupeta', pincode: '533464' },
  { value: 'chinna-mukha', label: 'Chinna Mukha', pincode: '533464' },
  { value: 'chimakurthy', label: 'Chimakurthy', pincode: '533464' },
  { value: 'ekkada', label: 'Ekkada', pincode: '533464' },
  { value: 'gollapalli', label: 'Gollapalli', pincode: '533464' },
  { value: 'karakkal', label: 'Karakkal', pincode: '533464' },
  { value: 'kondapalli', label: 'Kondapalli', pincode: '533464' },
  { value: 'kottur', label: 'Kottur', pincode: '533464' },
  { value: 'madhavaram', label: 'Madhavaram', pincode: '533464' },
  { value: 'mathur', label: 'Mathur', pincode: '533464' },
  { value: 'nallapadu', label: 'Nallapadu', pincode: '533464' },
  { value: 'peddagudem', label: 'Peddagudem', pincode: '533464' },
  { value: 'puducherry', label: 'Puducherry', pincode: '533464' },
  { value: 'rayavaram', label: 'Rayavaram', pincode: '533464' },
  { value: 'yanam', label: 'Yanam', pincode: '533464' },
  { value: 'yellapalli', label: 'Yellapalli', pincode: '533464' }
  ],
'bairabi': [
  { value: 'bairabi-town', label: 'Bairabi Town', pincode: '796161' },
  { value: 'chalchawng', label: 'Chalchawng', pincode: '796163' },
  { value: 'doltlang', label: 'Doltlang', pincode: '796161' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796081' },
  { value: 'lengteng', label: 'Lengteng', pincode: '796161' },
  { value: 'mamit', label: 'Mamit', pincode: '796441' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'tuipui', label: 'Tuipui', pincode: '796162' },
  { value: 'saplai', label: 'Saplai', pincode: '796161' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796252' },
  { value: 'venglai', label: 'Venglai', pincode: '796252' },
  { value: 'zohnuai', label: 'Zohnuai', pincode: '796181' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'tanhril', label: 'Tanhril', pincode: '796029' },
  { value: 'lungverh', label: 'Lungverh', pincode: '796152' },
  { value: 'champhai', label: 'Champhai', pincode: '796321' },
  { value: 'bualpui', label: 'Bualpui', pincode: '796081' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796122' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796321' },
  { value: 'chhipphir', label: 'Chhipphir', pincode: '796192' },
  { value: 'hawla', label: 'Hawla', pincode: '796443' },
  { value: 'thenzawl', label: 'Thenzawl', pincode: '796371' },
  { value: 'serchhip-lal', label: 'Serchhip Lal', pincode: '796182' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796442' },
  { value: 'daizawl', label: 'Daizawl', pincode: '796001' },
  { value: 'aizawl', label: 'Aizawl', pincode: '796001' },
  { value: 'tuipang', label: 'Tuipang', pincode: '796441' },
  { value: 'bualte', label: 'Bualte', pincode: '796451' },
  { value: 'bewlal', label: 'Bewlal', pincode: '796353' },
  { value: 'east-pukpui', label: 'East Pukpui', pincode: '796212' },
  { value: 'teirei', label: 'Teirei', pincode: '796042' },
  { value: 'saiphai', label: 'Saiphai', pincode: '796181' },
  { value: 'north-kolasib', label: 'North Kolasib', pincode: '796082' },
  { value: 'tualte', label: 'Tualte', pincode: '796092' },
  { value: 'ailenphai', label: 'Ailenphai', pincode: '796261' },
  { value: 'tungzawl', label: 'Tungzawl', pincode: '796351' },
  { value: 'bungtlang', label: 'Bungtlang', pincode: '796343' },
  { value: 'sarfai', label: 'Sarfai', pincode: '796032' },
  { value: 'loharding', label: 'Loharding', pincode: '796421' }
  ],

  'biate': [
  { value: 'biate-town', label: 'Biate Town', pincode: '796303' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796303' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796302' },
  { value: 'khuachung', label: 'Khuachung', pincode: '796303' },
  { value: 'lamzawl', label: 'Lamzawl', pincode: '796303' },
  { value: 'lemtur', label: 'Lemtur', pincode: '796305' },
  { value: 'lungmawi', label: 'Lungmawi', pincode: '796303' },
  { value: 'mualthuam', label: 'Mualthuam', pincode: '796304' },
  { value: 'ngur', label: 'Ngur', pincode: '796302' },
  { value: 'tlangsam', label: 'Tlangsam', pincode: '796303' },
  { value: 'venghlun', label: 'Venghlun', pincode: '796303' },
  { value: 'zelian', label: 'Zelian', pincode: '796303' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796301' },
  { value: 'buangpui', label: 'Buangpui', pincode: '796307' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796371' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796307' },
  { value: 'teirei', label: 'Teirei', pincode: '796305' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'kawnpui', label: 'Kawnpui', pincode: '796303' },
  { value: 'tualte', label: 'Tualte', pincode: '796092' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796442' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796303' },
  { value: 'lengteng', label: 'Lengteng', pincode: '796303' },
  { value: 'awmpui', label: 'Awmpui', pincode: '796304' },
  { value: 'phullen', label: 'Phullen', pincode: '796105' },
  { value: 'hnimtuipui', label: 'Hnimtuipui', pincode: '796306' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796307' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796308' },
  { value: 'thuampui', label: 'Thuampui', pincode: '796309' },
  { value: 'lawnpui', label: 'Lawnpui', pincode: '796310' },
  { value: 'lungtian', label: 'Lungtian', pincode: '796311' },
  { value: 'bualnang', label: 'Bualnang', pincode: '796312' }
  ],

  'bilkhawthlir': [
  { value: 'bilkhawthlir-town', label: 'Bilkhawthlir Town', pincode: '796341' },
  { value: 'bualpui', label: 'Bualpui', pincode: '796350' },
  { value: 'chhiahtlang', label: 'Chhiahtlang', pincode: '796340' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796371' },
  { value: 'lungpui', label: 'Lungpui', pincode: '796343' },
  { value: 'n-lung', label: 'N Lung', pincode: '796343' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796442' },
  { value: 'saiha', label: 'Saiha', pincode: '796901' },
  { value: 'tlangsam', label: 'Tlangsam', pincode: '796343' },
  { value: 'tualte', label: 'Tualte', pincode: '796092' },
  { value: 'phuaibuang', label: 'Phuaibuang', pincode: '796372' },
  { value: 'zingel', label: 'Zingel', pincode: '796340' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796301' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796343' },
  { value: 'ngurnu', label: 'Ngurnu', pincode: '796344' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796307' },
  { value: 'zokai', label: 'Zokai', pincode: '796343' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796308' },
  { value: 'chhipphir', label: 'Chhipphir', pincode: '796252' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796370' },
  { value: 'kaipui', label: 'Kaipui', pincode: '796344' },
  { value: 'ramhlun', label: 'Ramhlun', pincode: '796345' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'ruantlang', label: 'Ruantlang', pincode: '796341' },
  { value: 'nengpui', label: 'Nengpui', pincode: '796350' },
  { value: 'sualpui', label: 'Sualpui', pincode: '796340' },
  { value: 'chinmual', label: 'Chinmual', pincode: '796302' },
  { value: 'tualpui', label: 'Tualpui', pincode: '796366' },
  { value: 'tuipui', label: 'Tuipui', pincode: '796344' },
  { value: 'awmpui', label: 'Awmpui', pincode: '796343' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796342' },
  { value: 'khuachung', label: 'Khuachung', pincode: '796341' },
  { value: 'lungmawi', label: 'Lungmawi', pincode: '796344' },
  { value: 'sawpui', label: 'Sawpui', pincode: '796302' },
  { value: 'zohmun', label: 'Zohmun', pincode: '796341' },
  { value: 'huanvawm', label: 'Huanvawm', pincode: '796340' },
  { value: 'buangpui', label: 'Buangpui', pincode: '796372' },
  { value: 'thinghlun', label: 'Thinghlun', pincode: '796343' }
  ],
  
  'bungzung': [
  { value: 'bungzung-town', label: 'Bungzung Town', pincode: '796440' },
  { value: 'buangpui', label: 'Buangpui', pincode: '796443' },
  { value: 'chawngtlai', label: 'Chawngtlai', pincode: '796441' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796307' },
  { value: 'lungver', label: 'Lungver', pincode: '796440' },
  { value: 'ngalthlang', label: 'Ngalthlang', pincode: '796442' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796442' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'tualte', label: 'Tualte', pincode: '796092' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796441' },
  { value: 'saiha', label: 'Saiha', pincode: '796901' },
  { value: 'thinghlun', label: 'Thinghlun', pincode: '796443' },
  { value: 'bualpui', label: 'Bualpui', pincode: '796350' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796342' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796371' },
  { value: 'lungpui', label: 'Lungpui', pincode: '796343' },
  { value: 'ruantlang', label: 'Ruantlang', pincode: '796341' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796308' },
  { value: 'khuachung', label: 'Khuachung', pincode: '796341' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796340' },
  { value: 'chhipphir', label: 'Chhipphir', pincode: '796252' },
  { value: 'serpui', label: 'Serpui', pincode: '796350' },
  { value: 'chinmual', label: 'Chinmual', pincode: '796302' },
  { value: 'rengdil', label: 'Rengdil', pincode: '796372' },
  { value: 'theiriat', label: 'Theiriat', pincode: '796371' },
  { value: 'rawpui', label: 'Rawpui', pincode: '796341' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796343' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796340' },
  { value: 'bawngkawn', label: 'Bawngkawn', pincode: '796303' }
  ],
  
  'chalrang': [
  { value: 'chalrang-town', label: 'Chalrang Town', pincode: '796343' },
  { value: 'bungzang', label: 'Bungzang', pincode: '796340' },
  { value: 'chhawrhing', label: 'Chhawrhing', pincode: '796341' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796342' },
  { value: 'lungpui', label: 'Lungpui', pincode: '796343' },
  { value: 'ramhlun', label: 'Ramhlun', pincode: '796345' },
  { value: 'saiha', label: 'Saiha', pincode: '796901' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796308' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796341' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796371' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'bualpui', label: 'Bualpui', pincode: '796350' },
  { value: 'buangpui', label: 'Buangpui', pincode: '796443' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796442' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796343' },
  { value: 'thinghlun', label: 'Thinghlun', pincode: '796443' },
  { value: 'chhipphir', label: 'Chhipphir', pincode: '796252' },
  { value: 'serpui', label: 'Serpui', pincode: '796350' },
  { value: 'lawngtlai-west', label: 'Lawngtlai West', pincode: '796372' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796340' },
  { value: 'rawpui', label: 'Rawpui', pincode: '796341' },
  { value: 'ngalthlang', label: 'Ngalthlang', pincode: '796442' },
  { value: 'bawngkawn', label: 'Bawngkawn', pincode: '796303' },
  { value: 'lungver', label: 'Lungver', pincode: '796440' },
  { value: 'theiriat', label: 'Theiriat', pincode: '796371' },
  { value: 'chhinlung', label: 'Chhinlung', pincode: '796351' },
  { value: 'tualte', label: 'Tualte', pincode: '796092' },
  { value: 'zoveng', label: 'Zoveng', pincode: '796342' },
  { value: 'chhawrpui', label: 'Chhawrpui', pincode: '796340' },
  { value: 'lungmawi', label: 'Lungmawi', pincode: '796344' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796307' },
  { value: 'awmpui', label: 'Awmpui', pincode: '796343' },
  { value: 'laitlang', label: 'Laitlang', pincode: '796344' },
  { value: 'zothilang', label: 'Zothilang', pincode: '796351' },
  { value: 'huichhum', label: 'Huichhum', pincode: '796351' },
  { value: 'rumte', label: 'Rumte', pincode: '796342' },
  { value: 'kawlbuk', label: 'Kawlbuk', pincode: '796343' },
  { value: 'sazang', label: 'Sazang', pincode: '796351' },
  { value: 'zokhaw', label: 'Zokhaw', pincode: '796350' }
  ],
  
  'chiahpi': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796350' },
  { value: 'buangpui', label: 'Buangpui', pincode: '796443' },
  { value: 'chawngtlai', label: 'Chawngtlai', pincode: '796441' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796342' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796307' },
  { value: 'lungpui', label: 'Lungpui', pincode: '796343' },
  { value: 'ramhlun', label: 'Ramhlun', pincode: '796345' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'tualte', label: 'Tualte', pincode: '796092' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796441' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796343' },
  { value: 'thinghlun', label: 'Thinghlun', pincode: '796443' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796371' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796442' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796308' },
  { value: 'saiha', label: 'Saiha', pincode: '796901' },
  { value: 'zoveng', label: 'Zoveng', pincode: '796342' },
  { value: 'chhipphir', label: 'Chhipphir', pincode: '796252' },
  { value: 'serpui', label: 'Serpui', pincode: '796350' },
  { value: 'lawngtlai-west', label: 'Lawngtlai West', pincode: '796372' },
  { value: 'chhinlung', label: 'Chhinlung', pincode: '796351' },
  { value: 'rawpui', label: 'Rawpui', pincode: '796341' },
  { value: 'bawngkawn', label: 'Bawngkawn', pincode: '796303' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796340' },
  { value: 'lungver', label: 'Lungver', pincode: '796440' },
  { value: 'zothilang', label: 'Zothilang', pincode: '796351' },
  { value: 'tualte-village', label: 'Tualte Village', pincode: '796092' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796350' },
  { value: 'serchhip-town', label: 'Serchhip Town', pincode: '796181' },
  { value: 'chawngbawlh', label: 'Chawngbawlh', pincode: '796343' },
  { value: 'kawnpui', label: 'Kawnpui', pincode: '796360' },
  { value: 'lamchhip', label: 'Lamchhip', pincode: '796342' },
  { value: 'bungzang', label: 'Bungzang', pincode: '796340' },
  { value: 'lawngtlai-east', label: 'Lawngtlai East', pincode: '796373' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'khoirang', label: 'Khoirang', pincode: '796310' },
  { value: 'chhawrhing', label: 'Chhawrhing', pincode: '796343' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796371' }
  ],

  'dilkawn': [
  { value: 'aizawl', label: 'Aizawl', pincode: '796001' },
  { value: 'bawngkawn', label: 'Bawngkawn', pincode: '796001' },
  { value: 'bualpui', label: 'Bualpui', pincode: '796002' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796002' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796006' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796005' },
  { value: 'khatla', label: 'Khatla', pincode: '796005' },
  { value: 'kolsang', label: 'Kolsang', pincode: '796004' },
  { value: 'lammual', label: 'Lammual', pincode: '796004' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'mawkai', label: 'Mawkai', pincode: '796009' },
  { value: 'mamit', label: 'Mamit', pincode: '796440' },
  { value: 'mohammedpur', label: 'Mohammedpur', pincode: '796003' },
  { value: 'pengpui', label: 'Pengpui', pincode: '796015' },
  { value: 'reiek', label: 'Reiek', pincode: '796014' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796017' },
  { value: 'saitual', label: 'Saitual', pincode: '796009' },
  { value: 'thangtlang', label: 'Thangtlang', pincode: '796013' },
  { value: 'tuipui', label: 'Tuipui', pincode: '796030' },
  { value: 'vawmbuk', label: 'Vawmbuk', pincode: '796016' },
  { value: 'venglai', label: 'Venglai', pincode: '796010' },
  { value: 'zawlnuam', label: 'Zawlnuam', pincode: '796020' },
  { value: 'bawngkawn-2', label: 'Bawngkawn-2', pincode: '796001' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796029' },
  { value: 'lamzawl', label: 'Lamzawl', pincode: '796027' },
  { value: 'mawbai', label: 'Mawbai', pincode: '796024' },
  { value: 'serchhip-town', label: 'Serchhip Town', pincode: '796017' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796028' },
  { value: 'tualcheng', label: 'Tualcheng', pincode: '796005' },
  { value: 'saizawl', label: 'Saizawl', pincode: '796022' },
  { value: 'kawnpui', label: 'Kawnpui', pincode: '796024' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796033' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796010' },
  { value: 'venghlun', label: 'Venghlun', pincode: '796001' }
],

  'farkawn': [
  { value: 'aizawl', label: 'Aizawl', pincode: '796001' },
  { value: 'bawngkawn', label: 'Bawngkawn', pincode: '796001' },
  { value: 'bualpui', label: 'Bualpui', pincode: '796002' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796002' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796006' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796014' },
  { value: 'farkawn-2', label: 'Farkawn-2', pincode: '796014' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796028' },
  { value: 'khatla', label: 'Khatla', pincode: '796005' },
  { value: 'kolsang', label: 'Kolsang', pincode: '796004' },
  { value: 'lamzawl', label: 'Lamzawl', pincode: '796027' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'mawkai', label: 'Mawkai', pincode: '796009' },
  { value: 'mamit', label: 'Mamit', pincode: '796440' },
  { value: 'mohammedpur', label: 'Mohammedpur', pincode: '796003' },
  { value: 'pengpui', label: 'Pengpui', pincode: '796015' },
  { value: 'reiek', label: 'Reiek', pincode: '796014' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796017' },
  { value: 'saitual', label: 'Saitual', pincode: '796009' },
  { value: 'thangtlang', label: 'Thangtlang', pincode: '796013' },
  { value: 'tuipui', label: 'Tuipui', pincode: '796030' },
  { value: 'vawmbuk', label: 'Vawmbuk', pincode: '796016' },
  { value: 'venglai', label: 'Venglai', pincode: '796010' },
  { value: 'zawlnuam', label: 'Zawlnuam', pincode: '796020' },
  { value: 'bawngkawn-2', label: 'Bawngkawn-2', pincode: '796001' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796029' },
  { value: 'mawbai', label: 'Mawbai', pincode: '796024' },
  { value: 'saizawl', label: 'Saizawl', pincode: '796022' },
  { value: 'tualcheng', label: 'Tualcheng', pincode: '796005' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796010' },
  { value: 'venghlun', label: 'Venghlun', pincode: '796001' },
  { value: 'zohnuai', label: 'Zohnuai', pincode: '796031' },
  { value: 'chaihat', label: 'Chaihat', pincode: '796017' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796016' },
  { value: 'hualngohmun', label: 'Hualngohmun', pincode: '796018' },
  { value: 'khuangchera', label: 'Khuangchera', pincode: '796020' },
  { value: 'lailapur', label: 'Lailapur', pincode: '796022' },
  { value: 'lokchao', label: 'Lokchao', pincode: '796022' },
  { value: 'tuikam', label: 'Tuikam', pincode: '796029' },
  { value: 'zarum', label: 'Zarum', pincode: '796015' }
  ],

  'hnahlan': [
  { value: 'aizawl', label: 'Aizawl', pincode: '796001' },
  { value: 'bawngkawn', label: 'Bawngkawn', pincode: '796001' },
  { value: 'bualpui', label: 'Bualpui', pincode: '796002' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796002' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796006' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796014' },
  { value: 'farkawn-2', label: 'Farkawn-2', pincode: '796014' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796028' },
  { value: 'hnahlan', label: 'Hnahlan', pincode: '796021' },
  { value: 'khatla', label: 'Khatla', pincode: '796005' },
  { value: 'kolsang', label: 'Kolsang', pincode: '796004' },
  { value: 'lamzawl', label: 'Lamzawl', pincode: '796027' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'mawkai', label: 'Mawkai', pincode: '796009' },
  { value: 'mamit', label: 'Mamit', pincode: '796440' },
  { value: 'mohammedpur', label: 'Mohammedpur', pincode: '796003' },
  { value: 'pengpui', label: 'Pengpui', pincode: '796015' },
  { value: 'reiek', label: 'Reiek', pincode: '796014' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796017' },
  { value: 'saitual', label: 'Saitual', pincode: '796009' },
  { value: 'thangtlang', label: 'Thangtlang', pincode: '796013' },
  { value: 'tuipui', label: 'Tuipui', pincode: '796030' },
  { value: 'vawmbuk', label: 'Vawmbuk', pincode: '796016' },
  { value: 'venglai', label: 'Venglai', pincode: '796010' },
  { value: 'zawlnuam', label: 'Zawlnuam', pincode: '796020' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796029' },
  { value: 'mawbai', label: 'Mawbai', pincode: '796024' },
  { value: 'saizawl', label: 'Saizawl', pincode: '796022' },
  { value: 'tualcheng', label: 'Tualcheng', pincode: '796005' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796010' },
  { value: 'venghlun', label: 'Venghlun', pincode: '796001' },
  { value: 'zohnuai', label: 'Zohnuai', pincode: '796031' },
  { value: 'chaihat', label: 'Chaihat', pincode: '796017' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796016' },
  { value: 'hualngohmun', label: 'Hualngohmun', pincode: '796018' },
  { value: 'khuangchera', label: 'Khuangchera', pincode: '796020' },
  { value: 'lailapur', label: 'Lailapur', pincode: '796022' },
  { value: 'lokchao', label: 'Lokchao', pincode: '796022' },
  { value: 'tuikam', label: 'Tuikam', pincode: '796029' },
  { value: 'zarum', label: 'Zarum', pincode: '796015' },
  { value: 'sahlam', label: 'Sahlam', pincode: '796029' },
  { value: 'lengte', label: 'Lengte', pincode: '796010' },
  { value: 'vengthlang-2', label: 'Vengthlang-2', pincode: '796017' },
  { value: 'bualchhuana', label: 'Bualchhuana', pincode: '796002' }
  ],

  'hruaikawn-new': [
  { value: 'aizawl', label: 'Aizawl', pincode: '796001' },
  { value: 'bawngkawn', label: 'Bawngkawn', pincode: '796001' },
  { value: 'bualpui', label: 'Bualpui', pincode: '796002' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796002' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796006' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796014' },
  { value: 'farkawn-2', label: 'Farkawn-2', pincode: '796014' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796028' },
  { value: 'hnahlan', label: 'Hnahlan', pincode: '796021' },
  { value: 'hruaikawn-new', label: 'Hruaikawn New', pincode: '796022' },
  { value: 'khatla', label: 'Khatla', pincode: '796005' },
  { value: 'kolsang', label: 'Kolsang', pincode: '796004' },
  { value: 'lamzawl', label: 'Lamzawl', pincode: '796027' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'mawkai', label: 'Mawkai', pincode: '796009' },
  { value: 'mamit', label: 'Mamit', pincode: '796440' },
  { value: 'mohammedpur', label: 'Mohammedpur', pincode: '796003' },
  { value: 'pengpui', label: 'Pengpui', pincode: '796015' },
  { value: 'reiek', label: 'Reiek', pincode: '796014' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796017' },
  { value: 'saitual', label: 'Saitual', pincode: '796009' },
  { value: 'thangtlang', label: 'Thangtlang', pincode: '796013' },
  { value: 'tuipui', label: 'Tuipui', pincode: '796030' },
  { value: 'vawmbuk', label: 'Vawmbuk', pincode: '796016' },
  { value: 'venglai', label: 'Venglai', pincode: '796010' },
  { value: 'zawlnuam', label: 'Zawlnuam', pincode: '796020' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796029' },
  { value: 'mawbai', label: 'Mawbai', pincode: '796024' },
  { value: 'saizawl', label: 'Saizawl', pincode: '796022' },
  { value: 'tualcheng', label: 'Tualcheng', pincode: '796005' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796010' },
  { value: 'venghlun', label: 'Venghlun', pincode: '796001' },
  { value: 'zohnuai', label: 'Zohnuai', pincode: '796031' },
  { value: 'chaihat', label: 'Chaihat', pincode: '796017' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796016' },
  { value: 'hualngohmun', label: 'Hualngohmun', pincode: '796018' },
  { value: 'khuangchera', label: 'Khuangchera', pincode: '796020' },
  { value: 'lailapur', label: 'Lailapur', pincode: '796022' },
  { value: 'lokchao', label: 'Lokchao', pincode: '796022' },
  { value: 'tuikam', label: 'Tuikam', pincode: '796029' },
  { value: 'zarum', label: 'Zarum', pincode: '796015' },
  { value: 'sahlam', label: 'Sahlam', pincode: '796029' },
  { value: 'lengte', label: 'Lengte', pincode: '796010' },
  { value: 'vengthlang-2', label: 'Vengthlang-2', pincode: '796017' },
  { value: 'bualchhuana', label: 'Bualchhuana', pincode: '796002' },
  { value: 'north-lunglei', label: 'North Lunglei', pincode: '796702' },
  { value: 'south-lunglei', label: 'South Lunglei', pincode: '796703' },
  { value: 'ngurtav', label: 'Ngurtav', pincode: '796709' },
  { value: 'chhuanthar', label: 'Chhuanthar', pincode: '796705' },
  { value: 'tlanglian', label: 'Tlanglian', pincode: '796708' },
  { value: 'tengsang', label: 'Tengsang', pincode: '796706' }
  ],

  'keitum': [
  { value: 'bungtlang', label: 'Bungtlang', pincode: '796290' },
  { value: 'chentlang', label: 'Chentlang', pincode: '796290' },
  { value: 'engkim', label: 'Engkim', pincode: '796290' },
  { value: 'keim', label: 'Keim', pincode: '796290' },
  { value: 'keitum', label: 'Keitum', pincode: '796290' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796081' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'mamit', label: 'Mamit', pincode: '796440' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'thenzawl', label: 'Thenzawl', pincode: '796318' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796191' },
  { value: 'ailawng', label: 'Ailawng', pincode: '796690' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796290' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796290' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796285' },
  { value: 'lianchhiar', label: 'Lianchhiar', pincode: '796290' },
  { value: 'thingsul', label: 'Thingsul', pincode: '796261' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796271' },
  { value: 'aizawl', label: 'Aizawl', pincode: '796001' },
  { value: 'baktawng', label: 'Baktawng', pincode: '796351' },
  { value: 'chandmary', label: 'Chandmary', pincode: '796001' },
  { value: 'edvul', label: 'Edvul', pincode: '796290' },
  { value: 'hualngo', label: 'Hualngo', pincode: '796350' },
  { value: 'khawzawl', label: 'Khawzawl', pincode: '796690' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796901' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796403' },
  { value: 'luangmual', label: 'Luangmual', pincode: '796012' },
  { value: 'mualkawi', label: 'Mualkawi', pincode: '796291' },
  { value: 'ngurt', label: 'Ngurt', pincode: '796290' },
  { value: 'sialsuk', label: 'Sialsuk', pincode: '796290' },
  { value: 'thilawng', label: 'Thilawng', pincode: '796352' }
  ],

 'Kelkang': [
  { value: 'aizawl', label: 'Aizawl', pincode: '796001' },
  { value: 'ailawng', label: 'Ailawng', pincode: '796690' },
  { value: 'baktawng', label: 'Baktawng', pincode: '796351' },
  { value: 'chandmary', label: 'Chandmary', pincode: '796001' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796290' },
  { value: 'edvul', label: 'Edvul', pincode: '796290' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796290' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796285' },
  { value: 'hualngo', label: 'Hualngo', pincode: '796350' },
  { value: 'keim', label: 'Keim', pincode: '796290' },
  { value: 'keitum', label: 'Keitum', pincode: '796290' },
  { value: 'khawzawl', label: 'Khawzawl', pincode: '796690' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796081' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796901' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'luangmual', label: 'Luangmual', pincode: '796012' },
  { value: 'mamit', label: 'Mamit', pincode: '796440' },
  { value: 'mualkawi', label: 'Mualkawi', pincode: '796291' },
  { value: 'ngurt', label: 'Ngurt', pincode: '796290' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'sialsuk', label: 'Sialsuk', pincode: '796290' },
  { value: 'thingsul', label: 'Thingsul', pincode: '796261' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796191' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796271' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796352' },
  { value: 'churachandpur', label: 'Churachandpur', pincode: '796350' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796390' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796290' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796321' },
  { value: 'khawzawl', label: 'Khawzawl', pincode: '796690' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796410' },
  { value: 'langkaih', label: 'Langkaih', pincode: '796380' },
  { value: 'lungdai', label: 'Lungdai', pincode: '796351' },
  { value: 'mawmaw', label: 'Mawmaw', pincode: '796290' },
  { value: 'phainuam', label: 'Phainuam', pincode: '796404' }
  ],

'Khualen': [
  { value: 'ailawng', label: 'Ailawng', pincode: '796690' },
  { value: 'baktawng', label: 'Baktawng', pincode: '796351' },
  { value: 'chandmary', label: 'Chandmary', pincode: '796001' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796290' },
  { value: 'edvul', label: 'Edvul', pincode: '796290' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796290' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796285' },
  { value: 'hualngo', label: 'Hualngo', pincode: '796350' },
  { value: 'keim', label: 'Keim', pincode: '796290' },
  { value: 'keitum', label: 'Keitum', pincode: '796290' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796081' },
  { value: 'khawzawl', label: 'Khawzawl', pincode: '796690' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796901' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'mamit', label: 'Mamit', pincode: '796440' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'thingsul', label: 'Thingsul', pincode: '796261' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796191' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796271' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796352' },
  { value: 'churachandpur', label: 'Churachandpur', pincode: '796350' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796390' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796321' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796410' },
  { value: 'langkaih', label: 'Langkaih', pincode: '796380' },
  { value: 'lungdai', label: 'Lungdai', pincode: '796351' },
  { value: 'mawmaw', label: 'Mawmaw', pincode: '796290' },
  { value: 'phainuam', label: 'Phainuam', pincode: '796404' },
  { value: 'farkawn-ii', label: 'Farkawn-II', pincode: '796440' },
  { value: 'kawnpui', label: 'Kawnpui', pincode: '796200' },
  { value: 'khawzawl-ii', label: 'Khawzawl-II', pincode: '796691' },
  { value: 'lungpui', label: 'Lungpui', pincode: '796403' },
  { value: 'serchhip-ii', label: 'Serchhip-II', pincode: '796180' },
  { value: 'zawlnuam', label: 'Zawlnuam', pincode: '796263' },
  { value: 'thenzawl', label: 'Thenzawl', pincode: '796318' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796392' },
  { value: 'tuikhur', label: 'Tuikhur', pincode: '796420' },
  { value: 'senvawn', label: 'Senvawn', pincode: '796330' },
  { value: 'phanai', label: 'Phanai', pincode: '796301' },
  { value: 'tawipui', label: 'Tawipui', pincode: '796421' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796022' },
  { value: 'zawngin', label: 'Zawngin', pincode: '796324' },
  { value: 'khuanuam', label: 'Khuanuam', pincode: '796206' },
  { value: 'vengsang', label: 'Vengsang', pincode: '796314' }
  ],

  'khawhai': [
  { value: 'ailawng', label: 'Ailawng', pincode: '796690' },
  { value: 'baktawng', label: 'Baktawng', pincode: '796351' },
  { value: 'chandmary', label: 'Chandmary', pincode: '796001' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796290' },
  { value: 'edvul', label: 'Edvul', pincode: '796290' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796290' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796285' },
  { value: 'hualngo', label: 'Hualngo', pincode: '796350' },
  { value: 'keim', label: 'Keim', pincode: '796290' },
  { value: 'keitum', label: 'Keitum', pincode: '796290' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796081' },
  { value: 'khawzawl', label: 'Khawzawl', pincode: '796690' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796901' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796701' },
  { value: 'mamit', label: 'Mamit', pincode: '796440' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796181' },
  { value: 'thingsul', label: 'Thingsul', pincode: '796261' },
  { value: 'vengthlang', label: 'Vengthlang', pincode: '796191' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796271' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796352' },
  { value: 'churachandpur', label: 'Churachandpur', pincode: '796350' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796390' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796321' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796410' },
  { value: 'langkaih', label: 'Langkaih', pincode: '796380' },
  { value: 'lungdai', label: 'Lungdai', pincode: '796351' },
  { value: 'mawmaw', label: 'Mawmaw', pincode: '796290' },
  { value: 'phainuam', label: 'Phainuam', pincode: '796404' },
  { value: 'farkawn-ii', label: 'Farkawn-II', pincode: '796440' },
  { value: 'kawnpui', label: 'Kawnpui', pincode: '796200' },
  { value: 'khawzawl-ii', label: 'Khawzawl-II', pincode: '796691' },
  { value: 'lungpui', label: 'Lungpui', pincode: '796403' },
  { value: 'serchhip-ii', label: 'Serchhip-II', pincode: '796180' },
  { value: 'zawlnuam', label: 'Zawlnuam', pincode: '796263' },
  { value: 'thenzawl', label: 'Thenzawl', pincode: '796318' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796392' },
  { value: 'tuikhur', label: 'Tuikhur', pincode: '796420' },
  { value: 'senvawn', label: 'Senvawn', pincode: '796330' },
  { value: 'phanai', label: 'Phanai', pincode: '796301' },
  { value: 'tawipui', label: 'Tawipui', pincode: '796421' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796022' },
  { value: 'zawngin', label: 'Zawngin', pincode: '796324' },
  { value: 'khuanuam', label: 'Khuanuam', pincode: '796206' },
  { value: 'vengsang', label: 'Vengsang', pincode: '796314' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796183' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796202' },
  { value: 'ngur', label: 'Ngur', pincode: '796281' },
  { value: 'neihdawn', label: 'Neihdawn', pincode: '796251' },
  { value: 'ramhlun', label: 'Ramhlun', pincode: '796011' },
  { value: 'sakawrdai', label: 'Sakawrdai', pincode: '796413' },
  { value: 'thakthing', label: 'Thakthing', pincode: '796201' },
  { value: 'tualvung-ii', label: 'Tualvung-II', pincode: '796293' }
  ],

  'khawzawl': [
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796152' },
  { value: 'chenpui', label: 'Chenpui', pincode: '796159' },
  { value: 'khawzawl-town', label: 'Khawzawl Town', pincode: '796151' },
  { value: 'lamzawl', label: 'Lamzawl', pincode: '796153' },
  { value: 'luangpui', label: 'Luangpui', pincode: '796156' },
  { value: 'mawkang', label: 'Mawkang', pincode: '796160' },
  { value: 'saizah', label: 'Saizah', pincode: '796154' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796155' },
  { value: 'vaitin', label: 'Vaitin', pincode: '796157' },
  { value: 'thenzawl', label: 'Thenzawl', pincode: '796158' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796160' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796161' },
  { value: 'saitual', label: 'Saitual', pincode: '796162' },
  { value: 'rawpui', label: 'Rawpui', pincode: '796163' },
  { value: 'khawhming', label: 'Khawhming', pincode: '796164' },
  { value: 'suangpuilawn', label: 'Suangpuilawn', pincode: '796165' },
  { value: 'ramhlun', label: 'Ramhlun', pincode: '796166' },
  { value: 'vengsang', label: 'Vengsang', pincode: '796167' },
  { value: 'phaileng', label: 'Phaileng', pincode: '796168' },
  { value: 'ruantlang', label: 'Ruantlang', pincode: '796169' }
  ],

  'khuangleng': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796171' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796172' },
  { value: 'khuangleng-town', label: 'Khuangleng Town', pincode: '796170' },
  { value: 'khaichawng', label: 'Khaichawng', pincode: '796173' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796174' },
  { value: 'mawmtai', label: 'Mawmtai', pincode: '796175' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796176' },
  { value: 'sualpui', label: 'Sualpui', pincode: '796177' },
  { value: 'thinghlung', label: 'Thinghlung', pincode: '796178' },
  { value: 'vangkawng', label: 'Vangkawng', pincode: '796179' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796180' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796181' },
  { value: 'thakthing', label: 'Thakthing', pincode: '796182' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796183' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796184' },
  { value: 'ramhlun', label: 'Ramhlun', pincode: '796185' },
  { value: 'phalpui', label: 'Phalpui', pincode: '796186' },
  { value: 'chhawngte', label: 'Chhawngte', pincode: '796187' },
  { value: 'saichal', label: 'Saichal', pincode: '796188' },
  { value: 'tedim', label: 'Tedim', pincode: '796189' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796190' }
  ],

'kawlkulh': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796191' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796192' },
  { value: 'kawlkulh-town', label: 'Kawlkulh Town', pincode: '796190' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796193' },
  { value: 'khuongpui', label: 'Khuongpui', pincode: '796199' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796194' },
  { value: 'mawii', label: 'Mawii', pincode: '796195' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796196' },
  { value: 'saiha', label: 'Saiha', pincode: '796197' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796198' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796200' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796201' },
  { value: 'hmunpui', label: 'Hmunpui', pincode: '796202' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796203' },
  { value: 'mualkawi', label: 'Mualkawi', pincode: '796204' },
  { value: 'ngur', label: 'Ngur', pincode: '796205' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796206' },
  { value: 'zarau', label: 'Zarau', pincode: '796207' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796208' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796209' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796210' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796211' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796212' },
  { value: 'saitual', label: 'Saitual', pincode: '796213' },
  { value: 'changpui', label: 'Changpui', pincode: '796214' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796215' },
  { value: 'lailui', label: 'Lailui', pincode: '796216' }
  ],

  'madanryting.': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796217' },
  { value: 'changpui', label: 'Changpui', pincode: '796218' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796219' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796220' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796221' },
  { value: 'madanryting-town', label: 'Madanryting Town', pincode: '796220' },
  { value: 'mawii', label: 'Mawii', pincode: '796222' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796223' },
  { value: 'saiha', label: 'Saiha', pincode: '796224' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796225' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796226' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796227' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796228' },
  { value: 'zarau', label: 'Zarau', pincode: '796229' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796230' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796231' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796232' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796233' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796234' },
  { value: 'saitual', label: 'Saitual', pincode: '796235' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796236' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796237' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796238' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796239' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796240' },
  { value: 'khuangleng', label: 'Khuangleng', pincode: '796241' },
  { value: 'thakthing', label: 'Thakthing', pincode: '796242' }
  ],

  'mimbung': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796243' },
  { value: 'changpui', label: 'Changpui', pincode: '796244' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796245' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796246' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796247' },
  { value: 'mimbung-town', label: 'Mimbung Town', pincode: '796246' },
  { value: 'mawii', label: 'Mawii', pincode: '796248' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796249' },
  { value: 'saiha', label: 'Saiha', pincode: '796250' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796251' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796252' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796253' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796254' },
  { value: 'zarau', label: 'Zarau', pincode: '796255' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796256' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796257' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796258' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796259' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796260' },
  { value: 'saitual', label: 'Saitual', pincode: '796261' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796262' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796263' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796264' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796265' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796266' },
  { value: 'khuangleng', label: 'Khuangleng', pincode: '796267' },
  { value: 'thakthing', label: 'Thakthing', pincode: '796268' },
  { value: 'vanglian', label: 'Vanglian', pincode: '796269' },
  { value: 'tualvung-tlang', label: 'Tualvung Tlang', pincode: '796270' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796271' },
  { value: 'khamzang', label: 'Khamzang', pincode: '796272' },
  { value: 'hmunpui', label: 'Hmunpui', pincode: '796273' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796274' }
  ],

  'murlen': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796275' },
  { value: 'changpui', label: 'Changpui', pincode: '796276' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796277' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796278' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796279' },
  { value: 'murlen-town', label: 'Murlen Town', pincode: '796278' },
  { value: 'mawii', label: 'Mawii', pincode: '796280' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796281' },
  { value: 'saiha', label: 'Saiha', pincode: '796282' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796283' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796284' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796285' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796286' },
  { value: 'zarau', label: 'Zarau', pincode: '796287' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796288' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796289' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796290' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796291' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796292' },
  { value: 'saitual', label: 'Saitual', pincode: '796293' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796294' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796295' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796296' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796297' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796298' },
  { value: 'khuangleng', label: 'Khuangleng', pincode: '796299' },
  { value: 'thakthing', label: 'Thakthing', pincode: '796300' },
  { value: 'vanglian', label: 'Vanglian', pincode: '796301' },
  { value: 'tualvung-tlang', label: 'Tualvung Tlang', pincode: '796302' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796303' },
  { value: 'khamzang', label: 'Khamzang', pincode: '796304' },
  { value: 'hmunpui', label: 'Hmunpui', pincode: '796305' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796306' },
  { value: 'buangpui', label: 'Buangpui', pincode: '796307' },
  { value: 'ngur', label: 'Ngur', pincode: '796308' },
  { value: 'teipui', label: 'Teipui', pincode: '796309' },
  { value: 'zokhawthar-lung', label: 'Zokhawthar Lung', pincode: '796310' },
  { value: 'sihphir', label: 'Sihphir', pincode: '796311' },
  { value: 'ramri', label: 'Ramri', pincode: '796312' },
  { value: 'saihapui', label: 'Saihapui', pincode: '796313' },
  { value: 'lengteng', label: 'Lengteng', pincode: '796314' }
  ],

  'n.e.khawdungsei': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796315' },
  { value: 'changpui', label: 'Changpui', pincode: '796316' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796317' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796318' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796319' },
  { value: 'n.e.khawdungsei-town', label: 'N.E. Khawdungsei Town', pincode: '796318' },
  { value: 'mawii', label: 'Mawii', pincode: '796320' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796321' },
  { value: 'saiha', label: 'Saiha', pincode: '796322' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796323' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796324' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796325' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796326' },
  { value: 'zarau', label: 'Zarau', pincode: '796327' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796328' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796329' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796330' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796331' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796332' },
  { value: 'saitual', label: 'Saitual', pincode: '796333' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796334' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796335' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796336' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796337' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796338' },
  { value: 'khuangleng', label: 'Khuangleng', pincode: '796339' },
  { value: 'thakthing', label: 'Thakthing', pincode: '796340' },
  { value: 'vanglian', label: 'Vanglian', pincode: '796341' },
  { value: 'tualvung-tlang', label: 'Tualvung Tlang', pincode: '796342' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796343' },
  { value: 'khamzang', label: 'Khamzang', pincode: '796344' },
  { value: 'hmunpui', label: 'Hmunpui', pincode: '796345' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796346' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796347' },
  { value: 'thlahmuia', label: 'Thlahmuia', pincode: '796348' },
  { value: 'sialsuk', label: 'Sialsuk', pincode: '796349' },
  { value: 'thuampui', label: 'Thuampui', pincode: '796350' },
  { value: 'hualdapui', label: 'Hualdapui', pincode: '796351' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796352' },
  { value: 'chandmual', label: 'Chandmual', pincode: '796353' },
  { value: 'tepui', label: 'Tepui', pincode: '796354' },
  { value: 'silsury', label: 'Silsury', pincode: '796355' },
  { value: 'zuangtu', label: 'Zuangtu', pincode: '796356' }
  ],

  'n.lungpher': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796357' },
  { value: 'changpui', label: 'Changpui', pincode: '796358' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796359' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796360' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796361' },
  { value: 'n.lungpher-town', label: 'N.Lungpher Town', pincode: '796360' },
  { value: 'mawii', label: 'Mawii', pincode: '796362' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796363' },
  { value: 'saiha', label: 'Saiha', pincode: '796364' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796365' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796366' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796367' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796368' },
  { value: 'zarau', label: 'Zarau', pincode: '796369' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796370' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796371' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796372' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796373' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796374' },
  { value: 'saitual', label: 'Saitual', pincode: '796375' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796376' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796377' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796378' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796379' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796380' },
  { value: 'khuangleng', label: 'Khuangleng', pincode: '796381' },
  { value: 'thakthing', label: 'Thakthing', pincode: '796382' },
  { value: 'vanglian', label: 'Vanglian', pincode: '796383' },
  { value: 'tualvung-tlang', label: 'Tualvung Tlang', pincode: '796384' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796385' },
  { value: 'khamzang', label: 'Khamzang', pincode: '796386' },
  { value: 'hmunpui', label: 'Hmunpui', pincode: '796387' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796388' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796389' },
  { value: 'thlahmuia', label: 'Thlahmuia', pincode: '796390' },
  { value: 'sialsuk', label: 'Sialsuk', pincode: '796391' },
  { value: 'thuampui', label: 'Thuampui', pincode: '796392' },
  { value: 'hualdapui', label: 'Hualdapui', pincode: '796393' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796394' },
  { value: 'chandmual', label: 'Chandmual', pincode: '796395' },
  { value: 'tepui', label: 'Tepui', pincode: '796396' },
  { value: 'silsury', label: 'Silsury', pincode: '796397' },
  { value: 'zuangtu', label: 'Zuangtu', pincode: '796398' },
  { value: 'lungphun', label: 'Lungphun', pincode: '796399' },
  { value: 'bualnung', label: 'Bualnung', pincode: '796400' },
  { value: 'sumsuih', label: 'Sumsuih', pincode: '796401' },
  { value: 'buaisora', label: 'Buaisora', pincode: '796402' },
  { value: 'huampi', label: 'Huampi', pincode: '796403' },
  { value: 'lamteng', label: 'Lamteng', pincode: '796404' },
  { value: 'thantlang', label: 'Thantlang', pincode: '796405' },
  { value: 'tuilut', label: 'Tuilut', pincode: '796406' },
  { value: 'khawthlang', label: 'Khawthlang', pincode: '796407' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796408' }
  ],

  'neihdawn': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796409' },
  { value: 'changpui', label: 'Changpui', pincode: '796410' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796411' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796412' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796413' },
  { value: 'mawii', label: 'Mawii', pincode: '796414' },
  { value: 'neihdawn-town', label: 'Neihdawn Town', pincode: '796415' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796416' },
  { value: 'saiha', label: 'Saiha', pincode: '796417' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796418' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796419' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796420' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796421' },
  { value: 'zarau', label: 'Zarau', pincode: '796422' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796423' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796424' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796425' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796426' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796427' },
  { value: 'saitual', label: 'Saitual', pincode: '796428' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796429' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796430' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796431' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796432' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796433' },
  { value: 'khuangleng', label: 'Khuangleng', pincode: '796434' },
  { value: 'thakthing', label: 'Thakthing', pincode: '796435' },
  { value: 'vanglian', label: 'Vanglian', pincode: '796436' },
  { value: 'tualvung-tlang', label: 'Tualvung Tlang', pincode: '796437' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796438' },
  { value: 'khamzang', label: 'Khamzang', pincode: '796439' },
  { value: 'hmunpui', label: 'Hmunpui', pincode: '796440' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796441' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796442' },
  { value: 'thlahmuia', label: 'Thlahmuia', pincode: '796443' },
  { value: 'sialsuk', label: 'Sialsuk', pincode: '796444' },
  { value: 'thuampui', label: 'Thuampui', pincode: '796445' },
  { value: 'hualdapui', label: 'Hualdapui', pincode: '796446' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796447' },
  { value: 'chandmual', label: 'Chandmual', pincode: '796448' },
  { value: 'tepui', label: 'Tepui', pincode: '796449' },
  { value: 'silsury', label: 'Silsury', pincode: '796450' },
  { value: 'zuangtu', label: 'Zuangtu', pincode: '796451' },
  { value: 'lungphun', label: 'Lungphun', pincode: '796452' },
  { value: 'bualnung', label: 'Bualnung', pincode: '796453' },
  { value: 'sumsuih', label: 'Sumsuih', pincode: '796454' },
  { value: 'buaisora', label: 'Buaisora', pincode: '796455' },
  { value: 'huampi', label: 'Huampi', pincode: '796456' },
  { value: 'lamteng', label: 'Lamteng', pincode: '796457' },
  { value: 'thantlang', label: 'Thantlang', pincode: '796458' },
  { value: 'tuilut', label: 'Tuilut', pincode: '796459' },
  { value: 'khawthlang', label: 'Khawthlang', pincode: '796460' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796461' },
  { value: 'zamual', label: 'Zamual', pincode: '796462' },
  { value: 'kaibi', label: 'Kaibi', pincode: '796463' },
  { value: 'chawngtui', label: 'Chawngtui', pincode: '796464' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796465' },
  { value: 'phulzawl', label: 'Phulzawl', pincode: '796466' },
  { value: 'serkawn', label: 'Serkawn', pincode: '796467' }
  ],

  'north-vanlaiphai': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796468' },
  { value: 'changpui', label: 'Changpui', pincode: '796469' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796470' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796471' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796472' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796473' },
  { value: 'mawii', label: 'Mawii', pincode: '796474' },
  { value: 'north-vanlaiphai-town', label: 'North Vanlaiphai Town', pincode: '796475' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796476' },
  { value: 'saiha', label: 'Saiha', pincode: '796477' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796478' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796479' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796480' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796481' },
  { value: 'zarau', label: 'Zarau', pincode: '796482' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796483' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796484' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796485' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796486' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796487' },
  { value: 'saitual', label: 'Saitual', pincode: '796488' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796489' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796490' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796491' },
  { value: 'kolasib', label: 'Kolasib', pincode: '796492' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796493' },
  { value: 'khuangleng', label: 'Khuangleng', pincode: '796494' },
  { value: 'thakthing', label: 'Thakthing', pincode: '796495' },
  { value: 'vanglian', label: 'Vanglian', pincode: '796496' },
  { value: 'tualvung-tlang', label: 'Tualvung Tlang', pincode: '796497' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796498' },
  { value: 'khamzang', label: 'Khamzang', pincode: '796499' },
  { value: 'hmunpui', label: 'Hmunpui', pincode: '796500' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796501' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796502' },
  { value: 'thlahmuia', label: 'Thlahmuia', pincode: '796503' },
  { value: 'sialsuk', label: 'Sialsuk', pincode: '796504' },
  { value: 'thuampui', label: 'Thuampui', pincode: '796505' },
  { value: 'hualdapui', label: 'Hualdapui', pincode: '796506' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796507' },
  { value: 'chandmual', label: 'Chandmual', pincode: '796508' },
  { value: 'tepui', label: 'Tepui', pincode: '796509' },
  { value: 'silsury', label: 'Silsury', pincode: '796510' },
  { value: 'zuangtu', label: 'Zuangtu', pincode: '796511' },
  { value: 'lungphun', label: 'Lungphun', pincode: '796512' },
  { value: 'bualnung', label: 'Bualnung', pincode: '796513' },
  { value: 'sumsuih', label: 'Sumsuih', pincode: '796514' },
  { value: 'buaisora', label: 'Buaisora', pincode: '796515' },
  { value: 'huampi', label: 'Huampi', pincode: '796516' },
  { value: 'lamteng', label: 'Lamteng', pincode: '796517' },
  { value: 'thantlang', label: 'Thantlang', pincode: '796518' },
  { value: 'tuilut', label: 'Tuilut', pincode: '796519' },
  { value: 'khawthlang', label: 'Khawthlang', pincode: '796520' },
  { value: 'chhingchhip', label: 'Chhingchhip', pincode: '796521' },
  { value: 'zamual', label: 'Zamual', pincode: '796522' },
  { value: 'kaibi', label: 'Kaibi', pincode: '796523' },
  { value: 'chawngtui', label: 'Chawngtui', pincode: '796524' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796525' },
  { value: 'phulzawl', label: 'Phulzawl', pincode: '796526' },
  { value: 'serkawn', label: 'Serkawn', pincode: '796527' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796528' },
  { value: 'rungkua', label: 'Rungkua', pincode: '796529' },
  { value: 'ramlalai', label: 'Ramlalai', pincode: '796530' },
  { value: 'tehchung', label: 'Tehchung', pincode: '796531' },
  { value: 'thilchhuak', label: 'Thilchhuak', pincode: '796532' },
  { value: 'sumzawl', label: 'Sumzawl', pincode: '796533' }
  ],

  'phullen': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796470' },
  { value: 'chawngtui', label: 'Chawngtui', pincode: '796471' },
  { value: 'changpui', label: 'Changpui', pincode: '796472' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796473' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796474' },
  { value: 'hmunpui', label: 'Hmunpui', pincode: '796475' },
  { value: 'khawbung', label: 'Khawbung', pincode: '796476' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796477' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796478' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796479' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796480' },
  { value: 'mawii', label: 'Mawii', pincode: '796481' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796482' },
  { value: 'north-phullen', label: 'North Phullen', pincode: '796483' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796484' },
  { value: 'saiha', label: 'Saiha', pincode: '796485' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796486' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796487' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796488' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796489' },
  { value: 'zarau', label: 'Zarau', pincode: '796490' },
  { value: 'khawthlang', label: 'Khawthlang', pincode: '796491' },
  { value: 'huampi', label: 'Huampi', pincode: '796492' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796493' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796494' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796495' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796496' },
  { value: 'saitual', label: 'Saitual', pincode: '796497' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796498' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796499' },
  { value: 'bualnung', label: 'Bualnung', pincode: '796500' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796501' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796502' },
  { value: 'tualvung-tlang', label: 'Tualvung Tlang', pincode: '796503' },
  { value: 'serkawn', label: 'Serkawn', pincode: '796504' },
  { value: 'rungkua', label: 'Rungkua', pincode: '796505' }
  ],

  'saitlaw': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796470' },
  { value: 'chawngtui', label: 'Chawngtui', pincode: '796471' },
  { value: 'changpui', label: 'Changpui', pincode: '796472' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796473' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796474' },
  { value: 'huampi', label: 'Huampi', pincode: '796475' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796476' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796477' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796478' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796479' },
  { value: 'mawii', label: 'Mawii', pincode: '796480' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796481' },
  { value: 'north-saitlaw', label: 'North Saitlaw', pincode: '796482' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796483' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796484' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796485' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796486' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796487' },
  { value: 'zarau', label: 'Zarau', pincode: '796488' },
  { value: 'khawthlang', label: 'Khawthlang', pincode: '796489' },
  { value: 'saitlaw-town', label: 'Saitlaw Town', pincode: '796490' },
  { value: 'bualnung', label: 'Bualnung', pincode: '796491' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796492' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796493' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796494' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796495' },
  { value: 'saitual', label: 'Saitual', pincode: '796496' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796497' },
  { value: 'serkawn', label: 'Serkawn', pincode: '796498' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796499' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796500' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796501' },
  { value: 'ramlalai', label: 'Ramlalai', pincode: '796502' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796503' },
  { value: 'zarang', label: 'Zarang', pincode: '796504' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796505' },
  { value: 'sakawrtu', label: 'Sakawrtu', pincode: '796506' },
  { value: 'kulikawn', label: 'Kulikawn', pincode: '796507' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796508' },
  { value: 'mualdai', label: 'Mualdai', pincode: '796509' },
  { value: 'zawlpuiah', label: 'Zawlpuiah', pincode: '796510' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796511' },
  { value: 'ramdinthar', label: 'Ramdinthar', pincode: '796512' }
  ],

  'saichal': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796470' },
  { value: 'chawngtui', label: 'Chawngtui', pincode: '796471' },
  { value: 'changpui', label: 'Changpui', pincode: '796472' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796473' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796474' },
  { value: 'huampi', label: 'Huampi', pincode: '796475' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796476' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796477' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796478' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796479' },
  { value: 'mawii', label: 'Mawii', pincode: '796480' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796481' },
  { value: 'north-saichal', label: 'North Saichal', pincode: '796482' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796483' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796484' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796485' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796486' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796487' },
  { value: 'zarau', label: 'Zarau', pincode: '796488' },
  { value: 'khawthlang', label: 'Khawthlang', pincode: '796489' },
  { value: 'saichal-town', label: 'Saichal Town', pincode: '796490' },
  { value: 'bualnung', label: 'Bualnung', pincode: '796491' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796492' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796493' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796494' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796495' },
  { value: 'saitual', label: 'Saitual', pincode: '796496' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796497' },
  { value: 'serkawn', label: 'Serkawn', pincode: '796498' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796499' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796500' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796501' },
  { value: 'ramlalai', label: 'Ramlalai', pincode: '796502' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796503' },
  { value: 'zarang', label: 'Zarang', pincode: '796504' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796505' },
  { value: 'sakawrtu', label: 'Sakawrtu', pincode: '796506' },
  { value: 'kulikawn', label: 'Kulikawn', pincode: '796507' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796508' },
  { value: 'mualdai', label: 'Mualdai', pincode: '796509' },
  { value: 'zawlpuiah', label: 'Zawlpuiah', pincode: '796510' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796511' },
  { value: 'ramdinthar', label: 'Ramdinthar', pincode: '796512' },
  { value: 'phaileng', label: 'Phaileng', pincode: '796513' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796514' },
  { value: 'bualchhungi', label: 'Bualchhungi', pincode: '796515' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796516' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796517' },
  { value: 'bualveng', label: 'Bualveng', pincode: '796518' },
  { value: 'longsai', label: 'Longsai', pincode: '796519' }
  ],

  'samthang-new': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796470' },
  { value: 'chawngtui', label: 'Chawngtui', pincode: '796471' },
  { value: 'changpui', label: 'Changpui', pincode: '796472' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796473' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796474' },
  { value: 'huampi', label: 'Huampi', pincode: '796475' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796476' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796477' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796478' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796479' },
  { value: 'mawii', label: 'Mawii', pincode: '796480' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796481' },
  { value: 'north-samthang-new', label: 'North Samthang New', pincode: '796482' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796483' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796484' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796485' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796486' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796487' },
  { value: 'zarau', label: 'Zarau', pincode: '796488' },
  { value: 'khawthlang', label: 'Khawthlang', pincode: '796489' },
  { value: 'samthang-new-town', label: 'Samthang New Town', pincode: '796490' },
  { value: 'bualnung', label: 'Bualnung', pincode: '796491' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796492' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796493' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796494' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796495' },
  { value: 'saitual', label: 'Saitual', pincode: '796496' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796497' },
  { value: 'serkawn', label: 'Serkawn', pincode: '796498' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796499' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796500' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796501' },
  { value: 'ramlalai', label: 'Ramlalai', pincode: '796502' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796503' },
  { value: 'zarang', label: 'Zarang', pincode: '796504' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796505' },
  { value: 'sakawrtu', label: 'Sakawrtu', pincode: '796506' },
  { value: 'kulikawn', label: 'Kulikawn', pincode: '796507' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796508' },
  { value: 'mualdai', label: 'Mualdai', pincode: '796509' },
  { value: 'zawlpuiah', label: 'Zawlpuiah', pincode: '796510' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796511' },
  { value: 'ramdinthar', label: 'Ramdinthar', pincode: '796512' },
  { value: 'phaileng', label: 'Phaileng', pincode: '796513' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796514' },
  { value: 'bualchhungi', label: 'Bualchhungi', pincode: '796515' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796516' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796517' },
  { value: 'bualveng', label: 'Bualveng', pincode: '796518' },
  { value: 'longsai', label: 'Longsai', pincode: '796519' }
  ],
  
  'serkawn': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796470' },
  { value: 'chawngtui', label: 'Chawngtui', pincode: '796471' },
  { value: 'changpui', label: 'Changpui', pincode: '796472' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796473' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796474' },
  { value: 'huampi', label: 'Huampi', pincode: '796475' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796476' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796477' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796478' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796479' },
  { value: 'mawii', label: 'Mawii', pincode: '796480' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796481' },
  { value: 'north-serkawn', label: 'North Serkawn', pincode: '796482' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796483' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796484' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796485' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796486' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796487' },
  { value: 'zarau', label: 'Zarau', pincode: '796488' },
  { value: 'khawthlang', label: 'Khawthlang', pincode: '796489' },
  { value: 'serkawn-new-town', label: 'Serkawn New Town', pincode: '796490' },
  { value: 'bualnung', label: 'Bualnung', pincode: '796491' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796492' },
  { value: 'ramthar', label: 'Ramthar', pincode: '796493' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796494' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796495' },
  { value: 'saitual', label: 'Saitual', pincode: '796496' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796497' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796498' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796499' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796500' },
  { value: 'ramlalai', label: 'Ramlalai', pincode: '796501' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796502' },
  { value: 'zarang', label: 'Zarang', pincode: '796503' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796504' },
  { value: 'sakawrtu', label: 'Sakawrtu', pincode: '796505' },
  { value: 'kulikawn', label: 'Kulikawn', pincode: '796506' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796507' },
  { value: 'mualdai', label: 'Mualdai', pincode: '796508' },
  { value: 'zawlpuiah', label: 'Zawlpuiah', pincode: '796509' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796510' },
  { value: 'ramdinthar', label: 'Ramdinthar', pincode: '796511' },
  { value: 'phaileng', label: 'Phaileng', pincode: '796512' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796513' },
  { value: 'bualchhungi', label: 'Bualchhungi', pincode: '796514' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796515' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796516' },
  { value: 'bualveng', label: 'Bualveng', pincode: '796517' },
  { value: 'longsai', label: 'Longsai', pincode: '796518' }
  ],

  'sialsuk': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796470' },
  { value: 'bualveng', label: 'Bualveng', pincode: '796517' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796495' },
  { value: 'changpui', label: 'Changpui', pincode: '796472' },
  { value: 'chawngtui', label: 'Chawngtui', pincode: '796471' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796515' },
  { value: 'darlawn', label: 'Darlawn', pincode: '796516' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796473' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796474' },
  { value: 'huampi', label: 'Huampi', pincode: '796475' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796513' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796476' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796477' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796507' },
  { value: 'kulikawn', label: 'Kulikawn', pincode: '796506' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796478' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796479' },
  { value: 'longsai', label: 'Longsai', pincode: '796518' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796492' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796498' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796499' },
  { value: 'mawii', label: 'Mawii', pincode: '796480' },
  { value: 'mualdai', label: 'Mualdai', pincode: '796508' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796481' },
  { value: 'north-sialsuk', label: 'North Sialsuk', pincode: '796482' },
  { value: 'phaileng', label: 'Phaileng', pincode: '796512' },
  { value: 'ramdinthar', label: 'Ramdinthar', pincode: '796511' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796483' },
  { value: 'ramlalai', label: 'Ramlalai', pincode: '796501' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796484' },
  { value: 'saitual', label: 'Saitual', pincode: '796496' },
  { value: 'sakawrtu', label: 'Sakawrtu', pincode: '796505' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796510' },
  { value: 'sialsuk-new-town', label: 'Sialsuk New Town', pincode: '796490' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796486' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796494' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796485' },
  { value: 'tualvung', label: 'Tualvung', pincode: '796497' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796504' },
  { value: 'vengpui', label: 'Vengpui', pincode: '796487' },
  { value: 'zarau', label: 'Zarau', pincode: '796488' },
  { value: 'zarang', label: 'Zarang', pincode: '796503' },
  { value: 'zawlpuiah', label: 'Zawlpuiah', pincode: '796509' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796502' },
  ],

  's.khawbung': [
  { value: 'bungtlang', label: 'Bungtlang', pincode: '796570' },
  { value: 'chhawrtui', label: 'Chhawrtui', pincode: '796571' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796572' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796573' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796574' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796575' },
  { value: 'khuallian', label: 'Khuallian', pincode: '796576' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796577' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796578' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796579' },
  { value: 'north-s.khawbung', label: 'North S.Khawbung', pincode: '796580' },
  { value: 'phaileng', label: 'Phaileng', pincode: '796581' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796582' },
  { value: 'ramlalai', label: 'Ramlalai', pincode: '796583' },
  { value: 'saitual', label: 'Saitual', pincode: '796584' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796585' },
  { value: 'senglai', label: 'Senglai', pincode: '796586' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796587' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796588' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796589' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796590' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796591' },
  { value: 'dingdawn', label: 'Dingdawn', pincode: '796592' },
  { value: 'khawhai', label: 'Khawhai', pincode: '796593' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796594' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796595' },
  { value: 'mamit', label: 'Mamit', pincode: '796596' },
  { value: 'phullen', label: 'Phullen', pincode: '796597' },
  { value: 'saitual-new', label: 'Saitual New', pincode: '796598' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796599' },
  { value: 'chhipphir', label: 'Chhipphir', pincode: '796600' },
  { value: 'fangzawl', label: 'Fangzawl', pincode: '796601' },
  { value: 'huampi', label: 'Huampi', pincode: '796602' },
  { value: 'khuailian', label: 'Khuailian', pincode: '796603' },
  { value: 'khawruhlian', label: 'Khawruhlian', pincode: '796604' },
  { value: 'longsai', label: 'Longsai', pincode: '796605' },
  { value: 'lungdar-new', label: 'Lungdar New', pincode: '796606' },
  { value: 'luangpui', label: 'Luangpui', pincode: '796607' },
  { value: 'mamit-new', label: 'Mamit New', pincode: '796608' },
  { value: 'phaileng-new', label: 'Phaileng New', pincode: '796609' },
  { value: 'thinglung', label: 'Thinglung', pincode: '796610' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796611' },
  { value: 'venglai', label: 'Venglai', pincode: '796612' }
  ],

  'tlabung': [
  { value: 'buarpui', label: 'Buarpui', pincode: '796588' },
  { value: 'chandmari', label: 'Chandmari', pincode: '796570' },
  { value: 'chhimtuipui', label: 'Chhimtuipui', pincode: '796589' },
  { value: 'dingdawn', label: 'Dingdawn', pincode: '796590' },
  { value: 'duhda', label: 'Duhda', pincode: '796571' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796572' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796573' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796574' },
  { value: 'khawhai', label: 'Khawhai', pincode: '796575' },
  { value: 'khawruhlian', label: 'Khawruhlian', pincode: '796591' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796576' },
  { value: 'lianpui', label: 'Lianpui', pincode: '796592' },
  { value: 'lungdar', label: 'Lungdar', pincode: '796577' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796593' },
  { value: 'mamit', label: 'Mamit', pincode: '796594' },
  { value: 'mualpui', label: 'Mualpui', pincode: '796578' },
  { value: 'north-tlabung', label: 'North Tlabung', pincode: '796579' },
  { value: 'phaileng', label: 'Phaileng', pincode: '796580' },
  { value: 'phullen', label: 'Phullen', pincode: '796595' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796581' },
  { value: 'ramlalai', label: 'Ramlalai', pincode: '796582' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796583' },
  { value: 'senglai', label: 'Senglai', pincode: '796584' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796585' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796596' },
  { value: 'tlangpui', label: 'Tlangpui', pincode: '796586' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796597' },
  { value: 'venglai', label: 'Venglai', pincode: '796598' },
  { value: 'zokhawthar', label: 'Zokhawthar', pincode: '796587' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796600' },
  { value: 'dongzawl', label: 'Dongzawl', pincode: '796601' },
  { value: 'huampi', label: 'Huampi', pincode: '796602' },
  { value: 'lungpui', label: 'Lungpui', pincode: '796603' },
  { value: 'mizoram-bazar', label: 'Mizoram Bazar', pincode: '796604' },
  { value: 'sailulak', label: 'Sailulak', pincode: '796605' },
  { value: 'tuipuibari', label: 'Tuipuibari', pincode: '796606' }
  ],

  'tuipang': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796611' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796600' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796612' },
  { value: 'farkawn-chung', label: 'Farkawn Chung', pincode: '796613' },
  { value: 'hmuifang', label: 'Hmuifang', pincode: '796613' },
  { value: 'khawhai', label: 'Khawhai', pincode: '796614' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796615' },
  { value: 'lunglei', label: 'Lunglei', pincode: '796616' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796617' },
  { value: 'mamit', label: 'Mamit', pincode: '796618' },
  { value: 'north-tlabung', label: 'North Tlabung', pincode: '796619' },
  { value: 'phaileng', label: 'Phaileng', pincode: '796620' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796620' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796621' },
  { value: 'senglai', label: 'Senglai', pincode: '796622' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796623' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796624' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796625' },
  { value: 'venglai', label: 'Venglai', pincode: '796626' },
  { value: 'buarpui', label: 'Buarpui', pincode: '796627' },
  { value: 'dongzawl', label: 'Dongzawl', pincode: '796628' },
  { value: 'huampi', label: 'Huampi', pincode: '796629' },
  { value: 'lungpui', label: 'Lungpui', pincode: '796630' },
  { value: 'mizoram-bazar', label: 'Mizoram Bazar', pincode: '796631' },
  { value: 'sailulak', label: 'Sailulak', pincode: '796632' },
  { value: 'tuipuibari', label: 'Tuipuibari', pincode: '796633' },
  { value: 'barkhawn', label: 'Barkhawn', pincode: '796634' },
  { value: 'changchung', label: 'Changchung', pincode: '796635' },
  { value: 'dawnpui', label: 'Dawnpui', pincode: '796636' },
  { value: 'khawlailung', label: 'Khawlailung', pincode: '796637' },
  { value: 'lungmawii', label: 'Lungmawii', pincode: '796638' },
  { value: 'paletlang', label: 'Paletlang', pincode: '796639' },
  { value: 'serkawn', label: 'Serkawn', pincode: '796640' },
  { value: 'siltui', label: 'Siltui', pincode: '796641' },
  { value: 'thlanthlang', label: 'Thlanthlang', pincode: '796642' },
  { value: 'vankhawn', label: 'Vankhawn', pincode: '796643' }
  ],

  'vairengte': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796111' },
  { value: 'chhiahtlang', label: 'Chhiahtlang', pincode: '796112' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796113' },
  { value: 'khawhai', label: 'Khawhai', pincode: '796114' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796115' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796116' },
  { value: 'mamit', label: 'Mamit', pincode: '796117' },
  { value: 'north-tlabung', label: 'North Tlabung', pincode: '796118' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796119' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796120' },
  { value: 'senglai', label: 'Senglai', pincode: '796121' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796122' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796123' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796124' },
  { value: 'venglai', label: 'Venglai', pincode: '796125' },
  { value: 'khawruhlian', label: 'Khawruhlian', pincode: '796126' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796127' },
  { value: 'dungtlang', label: 'Dungtlang', pincode: '796128' },
  { value: 'hmunzawl', label: 'Hmunzawl', pincode: '796129' },
  { value: 'khuachung', label: 'Khuachung', pincode: '796130' },
  { value: 'lungmawii', label: 'Lungmawii', pincode: '796131' },
  { value: 'serkawn', label: 'Serkawn', pincode: '796132' },
  { value: 'siltui', label: 'Siltui', pincode: '796133' },
  { value: 'thlantlang', label: 'Thlantlang', pincode: '796134' },
  { value: 'thingdawl-lunglei', label: 'Thingdawl Lunglei', pincode: '796135' },
  { value: 'zote', label: 'Zote', pincode: '796136' },
  { value: 'thenzawl', label: 'Thenzawl', pincode: '796137' },
  { value: 'lunglei-town', label: 'Lunglei Town', pincode: '796138' },
  { value: 'khuangpui', label: 'Khuangpui', pincode: '796139' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796140' },
  { value: 'vanlaiphai', label: 'Vanlaiphai', pincode: '796141' },
  { value: 'ngur', label: 'Ngur', pincode: '796142' },
  { value: 'leithum', label: 'Leithum', pincode: '796143' },
  { value: 'sairang', label: 'Sairang', pincode: '796144' },
  { value: 'sehlun', label: 'Sehlun', pincode: '796145' }
  ],

  'zawlnuam': [
  { value: 'bualpui', label: 'Bualpui', pincode: '796111' },
  { value: 'chhiahtlang', label: 'Chhiahtlang', pincode: '796112' },
  { value: 'farkawn', label: 'Farkawn', pincode: '796113' },
  { value: 'khawhai', label: 'Khawhai', pincode: '796114' },
  { value: 'khamrang', label: 'Khamrang', pincode: '796115' },
  { value: 'lengpui', label: 'Lengpui', pincode: '796116' },
  { value: 'mamit', label: 'Mamit', pincode: '796117' },
  { value: 'north-tlabung', label: 'North Tlabung', pincode: '796118' },
  { value: 'ramlaitui', label: 'Ramlaitui', pincode: '796119' },
  { value: 'serchhip', label: 'Serchhip', pincode: '796120' },
  { value: 'senglai', label: 'Senglai', pincode: '796121' },
  { value: 'sengkawn', label: 'Sengkawn', pincode: '796122' },
  { value: 'thingdawl', label: 'Thingdawl', pincode: '796123' },
  { value: 'tuivawl', label: 'Tuivawl', pincode: '796124' },
  { value: 'venglai', label: 'Venglai', pincode: '796125' },
  { value: 'khawruhlian', label: 'Khawruhlian', pincode: '796126' },
  { value: 'dinthar', label: 'Dinthar', pincode: '796127' },
  { value: 'zote', label: 'Zote', pincode: '796128' },
  { value: 'thenzawl', label: 'Thenzawl', pincode: '796129' },
  { value: 'lungmawii', label: 'Lungmawii', pincode: '796130' },
  { value: 'lawngtlai', label: 'Lawngtlai', pincode: '796131' },
  { value: 'vanlaiphai', label: 'Vanlaiphai', pincode: '796132' },
  { value: 'ngur', label: 'Ngur', pincode: '796133' },
  { value: 'leithum', label: 'Leithum', pincode: '796134' },
  { value: 'sairang', label: 'Sairang', pincode: '796135' },
  { value: 'sehlun', label: 'Sehlun', pincode: '796136' },
  { value: 'tharlung', label: 'Tharlung', pincode: '796137' },
  { value: 'thingdawl-lunglei', label: 'Thingdawl Lunglei', pincode: '796138' },
  { value: 'tualchhawn', label: 'Tualchhawn', pincode: '796139' },
  { value: 'zohnuai', label: 'Zohnuai', pincode: '796140' },
  { value: 'chawngte', label: 'Chawngte', pincode: '796141' },
  { value: 'serchhip-town', label: 'Serchhip Town', pincode: '796142' }
  ],
  //Odisha

  'balangir': [
  { value: 'balangir-town', label: 'Balangir Town', pincode: '767001' },
  { value: 'barpali', label: 'Barpali', pincode: '767002' },
  { value: 'belpada', label: 'Belpada', pincode: '767028' },
  { value: 'bijepur', label: 'Bijepur', pincode: '767014' },
  { value: 'bhainsmunda', label: 'Bhainsmunda', pincode: '767015' },
  { value: 'bhilapada', label: 'Bhilapada', pincode: '767034' },
  { value: 'jharbandh', label: 'Jharbandh', pincode: '767030' },
  { value: 'kankapali', label: 'Kankapali', pincode: '767024' },
  { value: 'kesinga', label: 'Kesinga', pincode: '767037' },
  { value: 'komna', label: 'Komna', pincode: '767039' },
  { value: 'laimura', label: 'Laimura', pincode: '767021' },
  { value: 'loisingha', label: 'Loisingha', pincode: '767040' },
  { value: 'mangala', label: 'Mangala', pincode: '767027' },
  { value: 'muribahal', label: 'Muribahal', pincode: '767025' },
  { value: 'patnagarh', label: 'Patnagarh', pincode: '767025' },
  { value: 'rajauna', label: 'Rajauna', pincode: '767041' },
  { value: 'salebhata', label: 'Salebhata', pincode: '767045' },
  { value: 'turekela', label: 'Turekela', pincode: '767053' },
  { value: 'deogaon', label: 'Deogaon', pincode: '767017' },
  { value: 'puintala', label: 'Puintala', pincode: '767017' },
  { value: 'bhatapada', label: 'Bhatapada', pincode: '767031' },
  { value: 'charbhata', label: 'Charbhata', pincode: '767049' },
  { value: 'jugalpada', label: 'Jugalpada', pincode: '767038' },
  { value: 'kundurapada', label: 'Kundurapada', pincode: '767013' },
  { value: 'kuturia', label: 'Kuturia', pincode: '767052' },
  { value: 'ladapada', label: 'Ladapada', pincode: '767036' },
  { value: 'nalikadamba', label: 'Nalikadamba', pincode: '767042' },
  { value: 'panikhela', label: 'Panikhela', pincode: '767033' },
  { value: 'patrapali', label: 'Patrapali', pincode: '767043' },
  { value: 'sarar', label: 'Sarar', pincode: '767022' },
  { value: 'santipada', label: 'Santipada', pincode: '767050' },
  { value: 'sargipali', label: 'Sargipali', pincode: '767048' },
  { value: 'thirubali', label: 'Thirubali', pincode: '767051' },
  { value: 'birsamunda', label: 'Birsamunda', pincode: '767004' },
  { value: 'chhatrabali', label: 'Chhatrabali', pincode: '767018' },
  { value: 'dudhiyapada', label: 'Dudhiyapada', pincode: '767019' },
  { value: 'kacharapali', label: 'Kacharapali', pincode: '767020' },
  { value: 'kanpada', label: 'Kanpada', pincode: '767023' },
  { value: 'kharasuan', label: 'Kharasuan', pincode: '767046' },
  { value: 'mokalbahal', label: 'Mokalbahal', pincode: '767044' },
  { value: 'sarada', label: 'Sarada', pincode: '767029' },
  { value: 'tularam', label: 'Tularam', pincode: '767055' }
  ],

  'athagarh': [
  { value: 'badabhuin', label: 'Badabhuin', pincode: '754029' },
  { value: 'banpur', label: 'Banpur', pincode: '754029' },
  { value: 'baripada', label: 'Baripada', pincode: '754029' },
  { value: 'belaguntha', label: 'Belaguntha', pincode: '754029' },
  { value: 'bhurunda', label: 'Bhurunda', pincode: '754029' },
  { value: 'dhenkanal', label: 'Dhenkanal', pincode: '759001' },
  { value: 'khamar', label: 'Khamar', pincode: '759001' },
  { value: 'khajuripada', label: 'Khajuripada', pincode: '754029' },
  { value: 'malikana', label: 'Malikana', pincode: '754029' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '754029' },
  { value: 'musagadia', label: 'Musagadia', pincode: '754029' },
  { value: 'puri', label: 'Puri', pincode: '754029' },
  { value: 'rudrapur', label: 'Rudrapur', pincode: '754029' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '754029' },
  { value: 'athagarh', label: 'Athagarh', pincode: '754029' },
  { value: 'gobindapur', label: 'Gobindapur', pincode: '754029' },
  { value: 'laxmipur', label: 'Laxmipur', pincode: '754029' },
  { value: 'sankarpur', label: 'Sankarpur', pincode: '754029' },
  { value: 'sijua', label: 'Sijua', pincode: '754029' }
  ],
  
  'banki': [
  { value: 'alapur', label: 'Alapur', pincode: '754008' },
  { value: 'arunapur', label: 'Arunapur', pincode: '754008' },
  { value: 'bahugram', label: 'Bahugram', pincode: '754008' },
  { value: 'balikuda', label: 'Balikuda', pincode: '754008' },
  { value: 'banpur', label: 'Banpur', pincode: '754008' },
  { value: 'baradia', label: 'Baradia', pincode: '754008' },
  { value: 'biranarayanpur', label: 'Biranarayanpur', pincode: '754008' },
  { value: 'dampada', label: 'Dampada', pincode: '754008' },
  { value: 'banki', label: 'Banki', pincode: '754008' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '754008' },
  { value: 'kantilo', label: 'Kantilo', pincode: '754008' },
  { value: 'keshojore', label: 'Keshojore', pincode: '754008' },
  { value: 'kumarpur', label: 'Kumarpur', pincode: '754008' },
  { value: 'madhapur', label: 'Madhapur', pincode: '754008' },
  { value: 'manikpur', label: 'Manikpur', pincode: '754008' },
  { value: 'paripur', label: 'Paripur', pincode: '754008' },
  { value: 'patapur', label: 'Patapur', pincode: '754008' },
  { value: 'sankaripur', label: 'Sankaripur', pincode: '754008' },
  { value: 'sijua', label: 'Sijua', pincode: '754008' },
  { value: 'sukinda', label: 'Sukinda', pincode: '754008' },
  { value: 'tulasi', label: 'Tulasi', pincode: '754008' }
  ],
  
  'basudebpur': [
  { value: 'balabhadrapur', label: 'Balabhadrapur', pincode: '754029' },
  { value: 'balikuda', label: 'Balikuda', pincode: '754029' },
  { value: 'basudebpur', label: 'Basudebpur', pincode: '754029' },
  { value: 'bhusandpur', label: 'Bhusandpur', pincode: '754029' },
  { value: 'bijapur', label: 'Bijapur', pincode: '754029' },
  { value: 'chakadhia', label: 'Chakadhia', pincode: '754029' },
  { value: 'daspur', label: 'Daspur', pincode: '754029' },
  { value: 'khuntuni', label: 'Khuntuni', pincode: '754029' },
  { value: 'kutra', label: 'Kutra', pincode: '754029' },
  { value: 'nalabandh', label: 'Nalabandh', pincode: '754029' },
  { value: 'paradip', label: 'Paradip', pincode: '754142' },
  { value: 'patapur', label: 'Patapur', pincode: '754029' },
  { value: 'sadar', label: 'Sadar', pincode: '754029' },
  { value: 'sijua', label: 'Sijua', pincode: '754029' },
  { value: 'barikpur', label: 'Barikpur', pincode: '754029' },
  { value: 'kachhuli', label: 'Kachhuli', pincode: '754029' },
  { value: 'kantabania', label: 'Kantabania', pincode: '754029' },
  { value: 'kumarabad', label: 'Kumarabad', pincode: '754029' },
  { value: 'mathura', label: 'Mathura', pincode: '754029' },
  { value: 'naliposi', label: 'Naliposi', pincode: '754029' },
  { value: 'rajasur', label: 'Rajasur', pincode: '754029' },
  { value: 'sijua', label: 'Sijua', pincode: '754029' }
  ],
  
  'bellaguntha': [
  { value: 'badagaon', label: 'Badagaon', pincode: '768220' },
  { value: 'bellaguntha', label: 'Bellaguntha', pincode: '768220' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '768220' },
  { value: 'dandisahi', label: 'Dandisahi', pincode: '768220' },
  { value: 'ghumukhi', label: 'Ghumukhi', pincode: '768220' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '768220' },
  { value: 'kamakshyanagar', label: 'Kamakshyanagar', pincode: '768220' },
  { value: 'kanheipur', label: 'Kanheipur', pincode: '768220' },
  { value: 'kantilo', label: 'Kantilo', pincode: '768220' },
  { value: 'kumarabasta', label: 'Kumarabasta', pincode: '768220' },
  { value: 'laxmipur', label: 'Laxmipur', pincode: '768220' },
  { value: 'ludhipur', label: 'Ludhipur', pincode: '768220' },
  { value: 'madhapur', label: 'Madhapur', pincode: '768220' },
  { value: 'mangalapur', label: 'Mangalapur', pincode: '768220' },
  { value: 'palasara', label: 'Palasara', pincode: '768220' },
  { value: 'rasulpur', label: 'Rasulpur', pincode: '768220' },
  { value: 'samantarapur', label: 'Samantarapur', pincode: '768220' },
  { value: 'santipur', label: 'Santipur', pincode: '768220' },
  { value: 'sarpal', label: 'Sarpal', pincode: '768220' },
  { value: 'tandai', label: 'Tandai', pincode: '768220' },
  { value: 'kurumunda', label: 'Kurumunda', pincode: '768220' },
  { value: 'samaleipur', label: 'Samaleipur', pincode: '768220' },
  { value: 'kaliapada', label: 'Kaliapada', pincode: '768220' },
  { value: 'subarnapur', label: 'Subarnapur', pincode: '768220' },
  { value: 'patali', label: 'Patali', pincode: '768220' },
  { value: 'banasahi', label: 'Banasahi', pincode: '768220' },
  { value: 'daspur', label: 'Daspur', pincode: '768220' }
  ],
  
  'bhatli': [
  { value: 'badagaon', label: 'Badagaon', pincode: '768220' },
  { value: 'bhatli', label: 'Bhatli', pincode: '768220' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '768220' },
  { value: 'ghumukhi', label: 'Ghumukhi', pincode: '768220' },
  { value: 'kanheipur', label: 'Kanheipur', pincode: '768220' },
  { value: 'karandia', label: 'Karandia', pincode: '768220' },
  { value: 'khandiola', label: 'Khandiola', pincode: '768220' },
  { value: 'laxmipur', label: 'Laxmipur', pincode: '768220' },
  { value: 'ludhipur', label: 'Ludhipur', pincode: '768220' },
  { value: 'maipadar', label: 'Maipadar', pincode: '768220' },
  { value: 'mangalpur', label: 'Mangalpur', pincode: '768220' },
  { value: 'manjhi', label: 'Manjhi', pincode: '768220' },
  { value: 'patali', label: 'Patali', pincode: '768220' },
  { value: 'rasulpur', label: 'Rasulpur', pincode: '768220' },
  { value: 'samaleipur', label: 'Samaleipur', pincode: '768220' },
  { value: 'sarpal', label: 'Sarpal', pincode: '768220' },
  { value: 'tandai', label: 'Tandai', pincode: '768220' },
  { value: 'sundarapada', label: 'Sundarapada', pincode: '768220' },
  { value: 'talapada', label: 'Talapada', pincode: '768220' },
  { value: 'gudidihi', label: 'Gudidihi', pincode: '768220' },
  { value: 'gobindpur', label: 'Gobindpur', pincode: '768220' }
  ],
  
  'bhawanipatna': [
  { value: 'badagada', label: 'Badagada', pincode: '766001' },
  { value: 'bhawanipatna', label: 'Bhawanipatna', pincode: '766001' },
  { value: 'chichia', label: 'Chichia', pincode: '766001' },
  { value: 'durgapali', label: 'Durgapali', pincode: '766001' },
  { value: 'kanaktora', label: 'Kanaktora', pincode: '766001' },
  { value: 'kesharpur', label: 'Kesharpur', pincode: '766001' },
  { value: 'khariar', label: 'Khariar', pincode: '766001' },
  { value: 'mahamaya', label: 'Mahamaya', pincode: '766001' },
  { value: 'malpada', label: 'Malpada', pincode: '766001' },
  { value: 'mundiapada', label: 'Mundiapada', pincode: '766001' },
  { value: 'nalabandha', label: 'Nalabandha', pincode: '766001' },
  { value: 'patrapali', label: 'Patrapali', pincode: '766001' },
  { value: 'raikera', label: 'Raikera', pincode: '766001' },
  { value: 'rampur', label: 'Rampur', pincode: '766001' },
  { value: 'sardarpara', label: 'Sardarpara', pincode: '766001' },
  { value: 'tunga', label: 'Tunga', pincode: '766001' },
  { value: 'alwapatna', label: 'Alwapatna', pincode: '766001' },
  { value: 'balisarda', label: 'Balisarda', pincode: '766001' },
  { value: 'bhairabpur', label: 'Bhairabpur', pincode: '766001' },
  { value: 'chakradharpur', label: 'Chakradharpur', pincode: '766001' },
  { value: 'deogarh', label: 'Deogarh', pincode: '766001' },
  { value: 'indipur', label: 'Indipur', pincode: '766001' },
  { value: 'jaganathpur', label: 'Jaganathpur', pincode: '766001' },
  { value: 'jodapada', label: 'Jodapada', pincode: '766001' },
  { value: 'kandrasila', label: 'Kandrasila', pincode: '766001' },
  { value: 'manikpur', label: 'Manikpur', pincode: '766001' },
  { value: 'pattamundai', label: 'Pattamundai', pincode: '766001' },
  { value: 'sanjari', label: 'Sanjari', pincode: '766001' },
  { value: 'sikarpada', label: 'Sikarpada', pincode: '766001' }
  ],
  
  'bhuban': [
  { value: 'bada-khunti', label: 'Bada Khunti', pincode: '759018' },
  { value: 'balabhadrapur', label: 'Balabhadrapur', pincode: '759018' },
  { value: 'bhuban', label: 'Bhuban', pincode: '759001' },
  { value: 'dumuduma', label: 'Dumuduma', pincode: '759018' },
  { value: 'jhankarpada', label: 'Jhankarpada', pincode: '759018' },
  { value: 'jolapada', label: 'Jolapada', pincode: '759018' },
  { value: 'kandala', label: 'Kandala', pincode: '759018' },
  { value: 'khatanga', label: 'Khatanga', pincode: '759018' },
  { value: 'kushadi', label: 'Kushadi', pincode: '759018' },
  { value: 'mangalpur', label: 'Mangalpur', pincode: '759018' },
  { value: 'nagar', label: 'Nagar', pincode: '759018' },
  { value: 'narendrapur', label: 'Narendrapur', pincode: '759018' },
  { value: 'radhanagar', label: 'Radhanagar', pincode: '759018' },
  { value: 'rajnagar', label: 'Rajnagar', pincode: '759018' },
  { value: 'rangamatia', label: 'Rangamatia', pincode: '759018' },
  { value: 'sadar', label: 'Sadar', pincode: '759018' },
  { value: 'sikhapur', label: 'Sikhapur', pincode: '759018' },
  { value: 'sukinda', label: 'Sukinda', pincode: '759018' },
  { value: 'saradhapur', label: 'Saradhapur', pincode: '759018' },
  { value: 'badasahi', label: 'Badasahi', pincode: '759001' },
  { value: 'balichandrapur', label: 'Balichandrapur', pincode: '759001' },
  { value: 'birsinghpur', label: 'Birsinghpur', pincode: '759001' },
  { value: 'devpur', label: 'Devpur', pincode: '759001' },
  { value: 'haridaspur', label: 'Haridaspur', pincode: '759001' },
  { value: 'kanpur', label: 'Kanpur', pincode: '759001' },
  { value: 'kapilaprasad', label: 'Kapilaprasad', pincode: '759001' },
  { value: 'khetrajpur', label: 'Khetrajpur', pincode: '759001' },
  { value: 'kudapada', label: 'Kudapada', pincode: '759001' },
  { value: 'malasahi', label: 'Malasahi', pincode: '759001' },
  { value: 'manapur', label: 'Manapur', pincode: '759001' }
  ],
  
  'bishama-katek': [
  { value: 'badhabada', label: 'Badhabada', pincode: '759033' },
  { value: 'balikuda', label: 'Balikuda', pincode: '759033' },
  { value: 'basanti', label: 'Basanti', pincode: '759033' },
  { value: 'bhagatpur', label: 'Bhagatpur', pincode: '759033' },
  { value: 'bhagwanpur', label: 'Bhagwanpur', pincode: '759033' },
  { value: 'chandragiri', label: 'Chandragiri', pincode: '759033' },
  { value: 'dharmapur', label: 'Dharmapur', pincode: '759033' },
  { value: 'jhankarpada', label: 'Jhankarpada', pincode: '759033' },
  { value: 'katapada', label: 'Katapada', pincode: '759033' },
  { value: 'kelai', label: 'Kelai', pincode: '759033' },
  { value: 'khamar', label: 'Khamar', pincode: '759033' },
  { value: 'manpur', label: 'Manpur', pincode: '759033' },
  { value: 'maurabandh', label: 'Maurabandh', pincode: '759033' },
  { value: 'panchugani', label: 'Panchugani', pincode: '759033' },
  { value: 'rajang', label: 'Rajang', pincode: '759033' },
  { value: 'sadhua', label: 'Sadhua', pincode: '759033' },
  { value: 'sakhigopal', label: 'Sakhigopal', pincode: '759033' },
  { value: 'bhushandpur', label: 'Bhushandpur', pincode: '759033' },
  { value: 'gobindpur', label: 'Gobindpur', pincode: '759033' },
  { value: 'jharpada', label: 'Jharpada', pincode: '759033' },
  { value: 'kundhei', label: 'Kundhei', pincode: '759033' },
  { value: 'patia', label: 'Patia', pincode: '759033' },
  { value: 'ramanandpur', label: 'Ramanandpur', pincode: '759033' },
  { value: 'santipur', label: 'Santipur', pincode: '759033' },
  { value: 'saradhapur', label: 'Saradhapur', pincode: '759033' },
  { value: 'sindholi', label: 'Sindholi', pincode: '759033' },
  { value: 'talagada', label: 'Talagada', pincode: '759033' },
  { value: 'tangiri', label: 'Tangiri', pincode: '759033' }
  ],
  
  'birmitrapur': [
  { value: 'bahal', label: 'Bahal', pincode: '770033' },
  { value: 'banharpali', label: 'Banharpali', pincode: '770033' },
  { value: 'barpali', label: 'Barpali', pincode: '770033' },
  { value: 'belpada', label: 'Belpada', pincode: '770033' },
  { value: 'chirigaon', label: 'Chirigaon', pincode: '770033' },
  { value: 'gandhamunda', label: 'Gandhamunda', pincode: '770033' },
  { value: 'jharpali', label: 'Jharpali', pincode: '770033' },
  { value: 'kandha', label: 'Kandha', pincode: '770033' },
  { value: 'kapasda', label: 'Kapasda', pincode: '770033' },
  { value: 'khuntpali', label: 'Khuntpali', pincode: '770033' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '770033' },
  { value: 'kumar', label: 'Kumar', pincode: '770033' },
  { value: 'mangalpur', label: 'Mangalpur', pincode: '770033' },
  { value: 'manoharpali', label: 'Manoharpali', pincode: '770033' },
  { value: 'patanikela', label: 'Patanikela', pincode: '770033' },
  { value: 'ranibandh', label: 'Ranibandh', pincode: '770033' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '770033' },
  { value: 'tanla', label: 'Tanla', pincode: '770033' },
  { value: 'tulasi', label: 'Tulasi', pincode: '770033' },
  { value: 'ambapada', label: 'Ambapada', pincode: '770033' },
  { value: 'baliapada', label: 'Baliapada', pincode: '770033' },
  { value: 'banhatpada', label: 'Banhatpada', pincode: '770033' },
  { value: 'barlota', label: 'Barlota', pincode: '770033' },
  { value: 'deulasahi', label: 'Deulasahi', pincode: '770033' },
  { value: 'gudpada', label: 'Gudpada', pincode: '770033' },
  { value: 'kachhari', label: 'Kachhari', pincode: '770033' },
  { value: 'kalarpada', label: 'Kalarpada', pincode: '770033' },
  { value: 'laxmipur', label: 'Laxmipur', pincode: '770033' },
  { value: 'murisola', label: 'Murisola', pincode: '770033' },
  { value: 'sarsakani', label: 'Sarsakani', pincode: '770033' },
  { value: 'shyamsundarpur', label: 'Shyamsundarpur', pincode: '770033' }
  ],
  
  'dhamanagar': [
  { value: 'bhimapada', label: 'Bhimapada', pincode: '756167' },
  { value: 'dangarh', label: 'Dangarh', pincode: '756167' },
  { value: 'dhamanagar-bazar', label: 'Dhamanagar Bazar', pincode: '756167' },
  { value: 'ghumushar', label: 'Ghumushar', pincode: '756167' },
  { value: 'jhankarpada', label: 'Jhankarpada', pincode: '756167' },
  { value: 'kanpur', label: 'Kanpur', pincode: '756167' },
  { value: 'manpur', label: 'Manpur', pincode: '756167' },
  { value: 'mendhapur', label: 'Mendhapur', pincode: '756167' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '756167' },
  { value: 'sagarpada', label: 'Sagarpada', pincode: '756167' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '756167' },
  { value: 'tapanga', label: 'Tapanga', pincode: '756167' },
  { value: 'thakurpada', label: 'Thakurpada', pincode: '756167' },
  { value: 'tulasi', label: 'Tulasi', pincode: '756167' },
  { value: 'banpada', label: 'Banpada', pincode: '756167' },
  { value: 'barun', label: 'Barun', pincode: '756167' },
  { value: 'birsinghpur', label: 'Birsinghpur', pincode: '756167' },
  { value: 'ghumusharpada', label: 'Ghumusharpada', pincode: '756167' },
  { value: 'kacheri', label: 'Kacheri', pincode: '756167' },
  { value: 'madhupur', label: 'Madhupur', pincode: '756167' },
  { value: 'naranpur', label: 'Naranpur', pincode: '756167' },
  { value: 'rasulpur', label: 'Rasulpur', pincode: '756167' },
  { value: 'sahajpada', label: 'Sahajpada', pincode: '756167' },
  { value: 'sambalpur', label: 'Sambalpur', pincode: '756167' },
  { value: 'saradhapur', label: 'Saradhapur', pincode: '756167' }
   ],
  'gopalpur': [
  { value: 'badajora', label: 'Badajora', pincode: '761002' },
  { value: 'balijuri', label: 'Balijuri', pincode: '761002' },
  { value: 'bari', label: 'Bari', pincode: '761002' },
  { value: 'bentapur', label: 'Bentapur', pincode: '761002' },
  { value: 'bihar', label: 'Bihar', pincode: '761002' },
  { value: 'chandipadar', label: 'Chandipadar', pincode: '761002' },
  { value: 'dhobijhola', label: 'Dhobijhola', pincode: '761002' },
  { value: 'gajapati-nagar', label: 'Gajapati Nagar', pincode: '761002' },
  { value: 'gopalpur-bazar', label: 'Gopalpur Bazar', pincode: '761002' },
  { value: 'kanisi', label: 'Kanisi', pincode: '761002' },
  { value: 'karagola', label: 'Karagola', pincode: '761002' },
  { value: 'khandayatpada', label: 'Khandayatpada', pincode: '761002' },
  { value: 'kurumkuda', label: 'Kurumkuda', pincode: '761002' },
  { value: 'madhupur', label: 'Madhupur', pincode: '761002' },
  { value: 'mallikapur', label: 'Mallikapur', pincode: '761002' },
  { value: 'mendapur', label: 'Mendapur', pincode: '761002' },
  { value: 'nikirai', label: 'Nikirai', pincode: '761002' },
  { value: 'penthapada', label: 'Penthapada', pincode: '761002' },
  { value: 'santapada', label: 'Santapada', pincode: '761002' },
  { value: 'satyabadi', label: 'Satyabadi', pincode: '761002' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '761002' },
  { value: 'tampara', label: 'Tampara', pincode: '761002' },
  { value: 'tangibanta', label: 'Tangibanta', pincode: '761002' },
  { value: 'tangiri', label: 'Tangiri', pincode: '761002' }
],

'hirakud': [
  { value: 'adal', label: 'Adal', pincode: '768204' },
  { value: 'amplab', label: 'Amplab', pincode: '768204' },
  { value: 'banjipali', label: 'Banjipali', pincode: '768204' },
  { value: 'bargaon', label: 'Bargaon', pincode: '768204' },
  { value: 'bargarh', label: 'Bargarh', pincode: '768028' },
  { value: 'basantpur', label: 'Basantpur', pincode: '768204' },
  { value: 'belgaon', label: 'Belgaon', pincode: '768204' },
  { value: 'chandragiri', label: 'Chandragiri', pincode: '768204' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '768204' },
  { value: 'ghantapada', label: 'Ghantapada', pincode: '768204' },
  { value: 'hindol', label: 'Hindol', pincode: '768204' },
  { value: 'jharsuguda', label: 'Jharsuguda', pincode: '768201' },
  { value: 'kandhara', label: 'Kandhara', pincode: '768204' },
  { value: 'kansari', label: 'Kansari', pincode: '768204' },
  { value: 'khariar', label: 'Khariar', pincode: '768204' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '768222' },
  { value: 'maneswar', label: 'Maneswar', pincode: '768204' },
  { value: 'mandla', label: 'Mandla', pincode: '768204' },
  { value: 'mulapali', label: 'Mulapali', pincode: '768204' },
  { value: 'nawapada', label: 'Nawapada', pincode: '768204' },
  { value: 'pada', label: 'Pada', pincode: '768204' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '768204' },
  { value: 'sadeipali', label: 'Sadeipali', pincode: '768204' },
  { value: 'sarasmal', label: 'Sarasmal', pincode: '768204' },
  { value: 'sundarpada', label: 'Sundarpada', pincode: '768204' },
  { value: 'tangarpali', label: 'Tangarpali', pincode: '768204' },
  { value: 'vedanta', label: 'Vedanta', pincode: '768204' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '768204' },
  { value: 'khandagiri', label: 'Khandagiri', pincode: '768204' },
  { value: 'baniapada', label: 'Baniapada', pincode: '768204' },
  { value: 'nandangiri', label: 'Nandangiri', pincode: '768204' },
  { value: 'sarkanda', label: 'Sarkanda', pincode: '768204' },
  { value: 'balangir', label: 'Balangir', pincode: '768001' },
  { value: 'tungabhadra', label: 'Tungabhadra', pincode: '768204' },
  { value: 'mahanadi', label: 'Mahanadi', pincode: '768204' },
  { value: 'dunguripali', label: 'Dunguripali', pincode: '768204' },
  { value: 'chandramohanpur', label: 'Chandramohanpur', pincode: '768204' }
  ],
  
  'jagatsinghpur': [
  { value: 'alapada', label: 'Alapada', pincode: '754105' },
  { value: 'amdal', label: 'Amdal', pincode: '754110' },
  { value: 'anandapur', label: 'Anandapur', pincode: '754106' },
  { value: 'bhadamundai', label: 'Bhadamundai', pincode: '754103' },
  { value: 'bhubaneswar', label: 'Bhubaneswar', pincode: '754101' },
  { value: 'chandol', label: 'Chandol', pincode: '754103' },
  { value: 'dhanamanjuri', label: 'Dhanamanjuri', pincode: '754110' },
  { value: 'ghumusa', label: 'Ghumusa', pincode: '754103' },
  { value: 'gobindpur', label: 'Gobindpur', pincode: '754103' },
  { value: 'jagatpur', label: 'Jagatpur', pincode: '754105' },
  { value: 'jagatsinghpur', label: 'Jagatsinghpur', pincode: '754103' },
  { value: 'kajalapada', label: 'Kajalapada', pincode: '754106' },
  { value: 'kaipada', label: 'Kaipada', pincode: '754110' },
  { value: 'kharasuan', label: 'Kharasuan', pincode: '754103' },
  { value: 'kiripada', label: 'Kiripada', pincode: '754103' },
  { value: 'madhabnagar', label: 'Madhabnagar', pincode: '754101' },
  { value: 'nandankana', label: 'Nandankana', pincode: '754106' },
  { value: 'pattamundai', label: 'Pattamundai', pincode: '754105' },
  { value: 'sadar', label: 'Sadar', pincode: '754103' },
  { value: 'sherpura', label: 'Sherpura', pincode: '754106' },
  { value: 'sinhapada', label: 'Sinhapada', pincode: '754103' },
  { value: 'sundarapada', label: 'Sundarapada', pincode: '754106' },
  { value: 'suryanagar', label: 'Suryanagar', pincode: '754105' },
  { value: 'banar', label: 'Banar', pincode: '754110' },
  { value: 'bhatapada', label: 'Bhatapada', pincode: '754107' },
  { value: 'gopalpur', label: 'Gopalpur', pincode: '754108' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '754109' },
  { value: 'manijanga', label: 'Manijanga', pincode: '754107' },
  { value: 'mulapala', label: 'Mulapala', pincode: '754108' }
  ],
  
  'jashipur': [
  { value: 'birsadabasa', label: 'Birsadabasa', pincode: '757034' },
  { value: 'chhinda', label: 'Chhinda', pincode: '757034' },
  { value: 'gadiapada', label: 'Gadiapada', pincode: '757034' },
  { value: 'hantalpada', label: 'Hantalpada', pincode: '757034' },
  { value: 'jashipur', label: 'Jashipur', pincode: '757034' },
  { value: 'kaliapada', label: 'Kaliapada', pincode: '757034' },
  { value: 'kantapada', label: 'Kantapada', pincode: '757034' },
  { value: 'kuchila', label: 'Kuchila', pincode: '757034' },
  { value: 'matabari', label: 'Matabari', pincode: '757034' },
  { value: 'ramakrushnapur', label: 'Ramakrushnapur', pincode: '757034' },
  { value: 'sadar', label: 'Sadar', pincode: '757034' },
  { value: 'samantara', label: 'Samantara', pincode: '757034' },
  { value: 'saradhapur', label: 'Saradhapur', pincode: '757034' },
  { value: 'sundargarh', label: 'Sundargarh', pincode: '757034' },
  { value: 'dholibahal', label: 'Dholibahal', pincode: '757035' },
  { value: 'gunupur', label: 'Gunupur', pincode: '757036' },
  { value: 'gudisahi', label: 'Gudisahi', pincode: '757037' },
  { value: 'kumurabeda', label: 'Kumurabeda', pincode: '757038' },
  { value: 'karanamunda', label: 'Karanamunda', pincode: '757039' }
  ],
  
  'kamakhyanagar': [
  { value: 'alapur', label: 'Alapur', pincode: '759018' },
  { value: 'bandhagaon', label: 'Bandhagaon', pincode: '759018' },
  { value: 'bahalda', label: 'Bahalda', pincode: '759018' },
  { value: 'basundhara', label: 'Basundhara', pincode: '759018' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '759018' },
  { value: 'dahikhal', label: 'Dahikhal', pincode: '759018' },
  { value: 'kamakhyanagar', label: 'Kamakhyanagar', pincode: '759018' },
  { value: 'karadagadia', label: 'Karadagadia', pincode: '759018' },
  { value: 'kathakhurda', label: 'Kathakhurda', pincode: '759018' },
  { value: 'kuduman', label: 'Kuduman', pincode: '759018' },
  { value: 'lohartol', label: 'Lohartol', pincode: '759018' },
  { value: 'nuagaon', label: 'Nuagaon', pincode: '759018' },
  { value: 'rajnagar', label: 'Rajnagar', pincode: '759018' },
  { value: 'sadeipur', label: 'Sadeipur', pincode: '759018' },
  { value: 'suguda', label: 'Suguda', pincode: '759018' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '759018' },
  { value: 'sahaspur', label: 'Sahaspur', pincode: '759018' },
  { value: 'saradhapur', label: 'Saradhapur', pincode: '759018' },
  { value: 'sibramkhal', label: 'Sibramkhal', pincode: '759018' },
  { value: 'jharpada', label: 'Jharpada', pincode: '759018' },
  { value: 'patana', label: 'Patana', pincode: '759018' },
  { value: 'puriapada', label: 'Puriapada', pincode: '759018' }
  ],
  
  'kalahandi': [
  { value: 'alubani', label: 'Alubani', pincode: '766001' },
  { value: 'barkote', label: 'Barkote', pincode: '766023' },
  { value: 'bhawanipatna', label: 'Bhawanipatna', pincode: '766001' },
  { value: 'bhejiput', label: 'Bhejiput', pincode: '766029' },
  { value: 'bilemundi', label: 'Bilemundi', pincode: '766014' },
  { value: 'chhetikela', label: 'Chhetikela', pincode: '766018' },
  { value: 'dhanikota', label: 'Dhanikota', pincode: '766028' },
  { value: 'gariabandh', label: 'Gariabandh', pincode: '766027' },
  { value: 'kalampur', label: 'Kalampur', pincode: '766029' },
  { value: 'kalahandi', label: 'Kalahandi', pincode: '766001' },
  { value: 'kandhaka', label: 'Kandhaka', pincode: '766017' },
  { value: 'kutinibahal', label: 'Kutinibahal', pincode: '766019' },
  { value: 'madanpur', label: 'Madanpur', pincode: '766020' },
  { value: 'narla', label: 'Narla', pincode: '766001' },
  { value: 'padmapur', label: 'Padmapur', pincode: '766030' },
  { value: 'pushpal', label: 'Pushpal', pincode: '766032' },
  { value: 'rajyadharpur', label: 'Rajyadharpur', pincode: '766033' },
  { value: 'sainkela', label: 'Sainkela', pincode: '766014' },
  { value: 'samakhol', label: 'Samakhol', pincode: '766031' },
  { value: 'tendukumpa', label: 'Tendukumpa', pincode: '766019' },
  { value: 'udayagiri', label: 'Udayagiri', pincode: '766037' },
  { value: 'kumudabali', label: 'Kumudabali', pincode: '766035' },
  { value: 'banasara', label: 'Banasara', pincode: '766026' },
  { value: 'maligaon', label: 'Maligaon', pincode: '766034' }
  ],
  
  'kantabanji': [
  { value: 'ambabari', label: 'Ambabari', pincode: '766002' },
  { value: 'bahalda', label: 'Bahalda', pincode: '766027' },
  { value: 'bhura', label: 'Bhura', pincode: '766010' },
  { value: 'dharuadihi', label: 'Dharuadihi', pincode: '766030' },
  { value: 'jareda', label: 'Jareda', pincode: '766020' },
  { value: 'kantabanji', label: 'Kantabanji', pincode: '766029' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '766024' },
  { value: 'mohantapali', label: 'Mohantapali', pincode: '766012' },
  { value: 'nalimunda', label: 'Nalimunda', pincode: '766032' },
  { value: 'palahara', label: 'Palahara', pincode: '766016' },
  { value: 'samasingha', label: 'Samasingha', pincode: '766031' },
  { value: 'sarapali', label: 'Sarapali', pincode: '766013' },
  { value: 'tentulikhunti', label: 'Tentulikhunti', pincode: '766019' },
  { value: 'sundar', label: 'Sundar', pincode: '766021' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '766033' }
  ],
  
  'karanjia': [
  { value: 'baliapal', label: 'Baliapal', pincode: '756035' },
  { value: 'bahalda', label: 'Bahalda', pincode: '756023' },
  { value: 'barua', label: 'Barua', pincode: '756027' },
  { value: 'dhipasana', label: 'Dhipasana', pincode: '756025' },
  { value: 'gobindapur', label: 'Gobindapur', pincode: '756024' },
  { value: 'karanjia', label: 'Karanjia', pincode: '756001' },
  { value: 'kandia', label: 'Kandia', pincode: '756029' },
  { value: 'ketara', label: 'Ketara', pincode: '756031' },
  { value: 'madhapur', label: 'Madhapur', pincode: '756030' },
  { value: 'nuagaon', label: 'Nuagaon', pincode: '756028' },
  { value: 'rajsahi', label: 'Rajshahi', pincode: '756022' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '756032' },
  { value: 'salapada', label: 'Salapada', pincode: '756033' },
  { value: 'soroda', label: 'Soroda', pincode: '756034' },
  { value: 'kumari', label: 'Kumari', pincode: '756036' },
  { value: 'deuli', label: 'Deuli', pincode: '756037' },
  { value: 'beldihi', label: 'Beldihi', pincode: '756038' },
  { value: 'chandragiri', label: 'Chandragiri', pincode: '756039' },
  { value: 'tangiria', label: 'Tangiria', pincode: '756040' },
  { value: 'balasore', label: 'Balasore', pincode: '756041' },
  { value: 'barbil', label: 'Barbil', pincode: '756042' },
  { value: 'shyamsundarpur', label: 'Shyamsundarpur', pincode: '756043' }
  ],
  
  'keonjhar': [
  { value: 'bansapathar', label: 'Bansapathar', pincode: '758020' },
  { value: 'barbil', label: 'Barbil', pincode: '758035' },
  { value: 'bhanjpur', label: 'Bhanjpur', pincode: '758001' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '758056' },
  { value: 'duarsini', label: 'Duarsini', pincode: '758021' },
  { value: 'gandhamardan', label: 'Gandhamardan', pincode: '758045' },
  { value: 'ghatmunda', label: 'Ghatmunda', pincode: '758013' },
  { value: 'kamarda', label: 'Kamarda', pincode: '758048' },
  { value: 'kandhadhara', label: 'Kandhadhara', pincode: '758029' },
  { value: 'keonjhar', label: 'Keonjhar', pincode: '758001' },
  { value: 'kusumjodi', label: 'Kusumjodi', pincode: '758002' },
  { value: 'mandua', label: 'Mandua', pincode: '758029' },
  { value: 'mayurbhanj', label: 'Mayurbhanj', pincode: '758054' },
  { value: 'naranpur', label: 'Naranpur', pincode: '758036' },
  { value: 'patana', label: 'Patana', pincode: '758037' },
  { value: 'sarasahi', label: 'Sarasahi', pincode: '758028' },
  { value: 'saraskana', label: 'Saraskana', pincode: '758022' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '758034' },
  { value: 'tensa', label: 'Tensa', pincode: '758043' },
  { value: 'tungadhia', label: 'Tungadhia', pincode: '758051' },
  { value: 'ambagadia', label: 'Ambagadia', pincode: '758040' },
  { value: 'badagaon', label: 'Badagaon', pincode: '758059' },
  { value: 'banspani', label: 'Banspani', pincode: '758044' },
  { value: 'bhimpur', label: 'Bhimpur', pincode: '758052' },
  { value: 'dandibari', label: 'Dandibari', pincode: '758050' },
  { value: 'digapahandi', label: 'Digapahandi', pincode: '758057' },
  { value: 'ganshpur', label: 'Ganshpur', pincode: '758055' },
  { value: 'kamkhuntuni', label: 'Kamkhuntuni', pincode: '758049' },
  { value: 'kensama', label: 'Kensama', pincode: '758058' },
  { value: 'phuljharan', label: 'Phuljharan', pincode: '758030' }
  ],
  
  'khallikot': [
  { value: 'badapada', label: 'Badapada', pincode: '761021' },
  { value: 'bhargavi', label: 'Bhargavi', pincode: '761027' },
  { value: 'chandapur', label: 'Chandapur', pincode: '761028' },
  { value: 'chhatrapur', label: 'Chhatrapur', pincode: '761020' },
  { value: 'dhanola', label: 'Dhanola', pincode: '761025' },
  { value: 'fatepur', label: 'Fatepur', pincode: '761030' },
  { value: 'kanisi', label: 'Kanisi', pincode: '761029' },
  { value: 'khallikot', label: 'Khallikot', pincode: '761022' },
  { value: 'kholachua', label: 'Kholachua', pincode: '761023' },
  { value: 'kumari', label: 'Kumari', pincode: '761024' },
  { value: 'kurali', label: 'Kurali', pincode: '761031' },
  { value: 'padhia', label: 'Padhia', pincode: '761032' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '761033' },
  { value: 'tangiriapal', label: 'Tangiriapal', pincode: '761026' },
  { value: 'baliguda', label: 'Baliguda', pincode: '761034' },
  { value: 'belaguntha', label: 'Belaguntha', pincode: '761035' },
  { value: 'bhalupali', label: 'Bhalupali', pincode: '761036' },
  { value: 'dharmasala', label: 'Dharmasala', pincode: '761037' },
  { value: 'kuturipalli', label: 'Kuturipalli', pincode: '761038' },
  { value: 'mandapada', label: 'Mandapada', pincode: '761039' }
  ],
  
  'kotpad': [
  { value: 'alajkala', label: 'Alajkala', pincode: '764058' },
  { value: 'badakunduli', label: 'Badakunduli', pincode: '764060' },
  { value: 'balisira', label: 'Balisira', pincode: '764061' },
  { value: 'banagudi', label: 'Banagudi', pincode: '764062' },
  { value: 'bansapala', label: 'Bansapala', pincode: '764063' },
  { value: 'kotapad', label: 'Kotapad', pincode: '764059' },
  { value: 'kumuli', label: 'Kumuli', pincode: '764064' },
  { value: 'mahanadi', label: 'Mahanadi', pincode: '764065' },
  { value: 'malipada', label: 'Malipada', pincode: '764066' },
  { value: 'mandiput', label: 'Mandiput', pincode: '764067' },
  { value: 'nuagaon', label: 'Nuagaon', pincode: '764068' },
  { value: 'sundhipada', label: 'Sundhipada', pincode: '764069' },
  { value: 'talab', label: 'Talab', pincode: '764070' },
  { value: 'udayagiri', label: 'Udayagiri', pincode: '764071' },
  { value: 'santapada', label: 'Santapada', pincode: '764072' },
  { value: 'garambha', label: 'Garambha', pincode: '764073' },
  { value: 'kalimundia', label: 'Kalimundia', pincode: '764074' },
  { value: 'kanamana', label: 'Kanamana', pincode: '764075' },
  { value: 'kandhapada', label: 'Kandhapada', pincode: '764076' },
  { value: 'khuntapada', label: 'Khuntapada', pincode: '764077' },
  { value: 'mathagaon', label: 'Mathagaon', pincode: '764078' },
  { value: 'phulbari', label: 'Phulbari', pincode: '764079' },
  { value: 'sindheikala', label: 'Sindheikala', pincode: '764080' }
  ],
  
  'konark': [
  { value: 'balanga', label: 'Balanga', pincode: '752044' },
  { value: 'baranga', label: 'Baranga', pincode: '752030' },
  { value: 'chandpur', label: 'Chandpur', pincode: '752030' },
  { value: 'digapahandi', label: 'Digapahandi', pincode: '761018' },
  { value: 'jagatpur', label: 'Jagatpur', pincode: '752027' },
  { value: 'jogannathpur', label: 'Jogannathpur', pincode: '752046' },
  { value: 'konark', label: 'Konark', pincode: '752111' },
  { value: 'nandapur', label: 'Nandapur', pincode: '752059' },
  { value: 'neheria', label: 'Neheria', pincode: '752031' },
  { value: 'pentha', label: 'Pentha', pincode: '752048' },
  { value: 'purunagarh', label: 'Purunagarh', pincode: '752014' },
  { value: 'rajanagar', label: 'Rajanagar', pincode: '752115' },
  { value: 'sakhigopal', label: 'Sakhigopal', pincode: '752014' },
  { value: 'satyabadi', label: 'Satyabadi', pincode: '752013' },
  { value: 'sri-kalayanpur', label: 'Sri Kalyanpur', pincode: '752028' },
  { value: 'taradapada', label: 'Taradapada', pincode: '752040' },
  { value: 'chandanpur', label: 'Chandanpur', pincode: '752039' },
  { value: 'madhapur', label: 'Madhapur', pincode: '752015' },
  { value: 'puri', label: 'Puri', pincode: '752001' },
  { value: 'ramachandi', label: 'Ramachandi', pincode: '752015' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '752028' },
  { value: 'tangi', label: 'Tangi', pincode: '752014' }
  ],
  
  'koraput': [
  { value: 'andharu', label: 'Andharu', pincode: '764020' },
  { value: 'banabira', label: 'Banabira', pincode: '764016' },
  { value: 'badajore', label: 'Badajore', pincode: '764017' },
  { value: 'balimela', label: 'Balimela', pincode: '764051' },
  { value: 'bhawanipatna', label: 'Bhawanipatna', pincode: '764002' },
  { value: 'berhampur', label: 'Berhampur', pincode: '764013' },
  { value: 'chirku', label: 'Chirku', pincode: '764031' },
  { value: 'damanjodi', label: 'Damanjodi', pincode: '764021' },
  { value: 'damonjodi', label: 'Damonjodi', pincode: '764022' },
  { value: 'kachinga', label: 'Kachinga', pincode: '764030' },
  { value: 'kamang', label: 'Kamang', pincode: '764028' },
  { value: 'kanaguda', label: 'Kanaguda', pincode: '764050' },
  { value: 'koraput', label: 'Koraput', pincode: '764020' },
  { value: 'laxmipur', label: 'Laxmipur', pincode: '764053' },
  { value: 'malkangiri', label: 'Malkangiri', pincode: '764051' },
  { value: 'nuwagada', label: 'Nuwagada', pincode: '764053' },
  { value: 'padmapur', label: 'Padmapur', pincode: '764015' },
  { value: 'patangi', label: 'Patangi', pincode: '764030' },
  { value: 'pottangi', label: 'Pottangi', pincode: '764046' },
  { value: 'raighar', label: 'Raighar', pincode: '764042' },
  { value: 'sadar', label: 'Sadar', pincode: '764019' },
  { value: 'sinapalli', label: 'Sinapalli', pincode: '764045' },
  { value: 'tadma', label: 'Tadma', pincode: '764040' },
  { value: 'udayagiri', label: 'Udayagiri', pincode: '764034' },
  { value: 'ramgiri', label: 'Ramgiri', pincode: '764036' },
  { value: 'badaput', label: 'Badaput', pincode: '764032' },
  { value: 'kothaput', label: 'Kothaput', pincode: '764038' },
  { value: 'mukundapur', label: 'Mukundapur', pincode: '764022' }
  ],
  
  'kuchinda': [
  { value: 'adhang', label: 'Adhang', pincode: '768222' },
  { value: 'balikuda', label: 'Balikuda', pincode: '768223' },
  { value: 'banki', label: 'Banki', pincode: '768224' },
  { value: 'biranbandh', label: 'Biranbandh', pincode: '768225' },
  { value: 'birasal', label: 'Birasal', pincode: '768226' },
  { value: 'boinda', label: 'Boinda', pincode: '768227' },
  { value: 'chamundia', label: 'Chamundia', pincode: '768228' },
  { value: 'daringbadi', label: 'Daringbadi', pincode: '768229' },
  { value: 'jangir', label: 'Jangir', pincode: '768230' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '768221' },
  { value: 'loisingha', label: 'Loisingha', pincode: '768231' },
  { value: 'manjhgaon', label: 'Manjhgaon', pincode: '768232' },
  { value: 'nalco', label: 'Nalco', pincode: '768233' },
  { value: 'patna', label: 'Patna', pincode: '768234' },
  { value: 'phulbani', label: 'Phulbani', pincode: '768235' },
  { value: 'raikala', label: 'Raikala', pincode: '768236' },
  { value: 'sambalpur', label: 'Sambalpur', pincode: '768237' },
  { value: 'sundarpada', label: 'Sundarpada', pincode: '768238' },
  { value: 'sura', label: 'Sura', pincode: '768239' },
  { value: 'tainsi', label: 'Tainsi', pincode: '768240' },
  { value: 'tundri', label: 'Tundri', pincode: '768241' },
  { value: 'ghantapada', label: 'Ghantapada', pincode: '768242' },
  { value: 'kuchindagarh', label: 'Kuchindagarh', pincode: '768243' },
  { value: 'manikpada', label: 'Manikpada', pincode: '768244' },
  { value: 'nabadwip', label: 'Nabadwip', pincode: '768245' },
  { value: 'patmunda', label: 'Patmunda', pincode: '768246' },
  { value: 'sikalbaha', label: 'Sikalbaha', pincode: '768247' },
  { value: 'tumudibandh', label: 'Tumudibandh', pincode: '768248' }
  ],
  
  'nayagarh': [
  { value: 'badapada', label: 'Badapada', pincode: '752065' },
  { value: 'bahadurpur', label: 'Bahadurpur', pincode: '752010' },
  { value: 'balakati', label: 'Balakati', pincode: '752040' },
  { value: 'balasore', label: 'Balasore', pincode: '752019' },
  { value: 'baral', label: 'Baral', pincode: '752055' },
  { value: 'basantapur', label: 'Basantapur', pincode: '752061' },
  { value: 'bharudhi', label: 'Bharudhi', pincode: '752022' },
  { value: 'dakhinabada', label: 'Dakhinabada', pincode: '752016' },
  { value: 'ganjam', label: 'Ganjam', pincode: '752032' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '752021' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '752014' },
  { value: 'kamalapur', label: 'Kamalapur', pincode: '752020' },
  { value: 'khalamba', label: 'Khalamba', pincode: '752066' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '752043' },
  { value: 'madhuban', label: 'Madhuban', pincode: '752067' },
  { value: 'mohammadabad', label: 'Mohammadabad', pincode: '752057' },
  { value: 'rampur', label: 'Rampur', pincode: '752034' },
  { value: 'sadhanapada', label: 'Sadhanapada', pincode: '752058' },
  { value: 'sahaspur', label: 'Sahaspur', pincode: '752042' },
  { value: 'salia', label: 'Salia', pincode: '752030' },
  { value: 'tangi', label: 'Tangi', pincode: '752053' },
  { value: 'boudh', label: 'Boudh', pincode: '752070' },
  { value: 'balipadar', label: 'Balipadar', pincode: '752052' },
  { value: 'chudamani', label: 'Chudamani', pincode: '752045' },
  { value: 'dhenkanal', label: 'Dhenkanal', pincode: '752060' },
  { value: 'nuagaon', label: 'Nuagaon', pincode: '752015' },
  { value: 'singhpur', label: 'Singhpur', pincode: '752062' },
  { value: 'sapang', label: 'Sapang', pincode: '752063' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '752072' },
  { value: 'kantilo', label: 'Kantilo', pincode: '752073' },
  { value: 'radhamohanpur', label: 'Radhamohanpur', pincode: '752027' },
  { value: 'bapujinagar', label: 'Bapujinagar', pincode: '752035' },
  { value: 'kandarpur', label: 'Kandarpur', pincode: '752074' }
  ],
  
  'nuapada': [
  { value: 'adhira', label: 'Adhira', pincode: '766105' },
  { value: 'barpali', label: 'Barpali', pincode: '766109' },
  { value: 'bhutapadar', label: 'Bhutapadar', pincode: '766102' },
  { value: 'boga', label: 'Boga', pincode: '766115' },
  { value: 'chhatia', label: 'Chhatia', pincode: '766103' },
  { value: 'dhanupali', label: 'Dhanupali', pincode: '766110' },
  { value: 'dumerpali', label: 'Dumerpali', pincode: '766106' },
  { value: 'gaisama', label: 'Gaisama', pincode: '766116' },
  { value: 'govindpur', label: 'Govindpur', pincode: '766107' },
  { value: 'jharbandh', label: 'Jharbandh', pincode: '766118' },
  { value: 'karla', label: 'Karla', pincode: '766111' },
  { value: 'khuntpali', label: 'Khuntpali', pincode: '766113' },
  { value: 'kushma', label: 'Kushma', pincode: '766108' },
  { value: 'manoharpali', label: 'Manoharpali', pincode: '766112' },
  { value: 'mudulipada', label: 'Mudulipada', pincode: '766104' },
  { value: 'nakhira', label: 'Nakhira', pincode: '766114' },
  { value: 'pada', label: 'Pada', pincode: '766120' },
  { value: 'rajpur', label: 'Rajpur', pincode: '766117' },
  { value: 'rampur', label: 'Rampur', pincode: '766121' },
  { value: 'sada', label: 'Sada', pincode: '766122' },
  { value: 'sahajpali', label: 'Sahajpali', pincode: '766123' },
  { value: 'salmari', label: 'Salmari', pincode: '766125' },
  { value: 'shankarpur', label: 'Shankarpur', pincode: '766124' },
  { value: 'sidhamal', label: 'Sidhamal', pincode: '766126' },
  { value: 'tela', label: 'Tela', pincode: '766127' },
  { value: 'udaypur', label: 'Udaypur', pincode: '766128' },
  { value: 'vanjipali', label: 'Vanjipali', pincode: '766129' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '766130' },
  { value: 'balabhadrapur', label: 'Balabhadrapur', pincode: '766131' },
  { value: 'chheda', label: 'Chheda', pincode: '766132' },
  { value: 'jalam', label: 'Jalam', pincode: '766133' },
  { value: 'sarpan', label: 'Sarpan', pincode: '766134' }
  ],
  
  'nowrangpur': [
  { value: 'adari', label: 'Adari', pincode: '764056' },
  { value: 'ambabani', label: 'Ambabani', pincode: '764058' },
  { value: 'ambapada', label: 'Ambapada', pincode: '764050' },
  { value: 'badaguda', label: 'Badaguda', pincode: '764065' },
  { value: 'balagaon', label: 'Balagaon', pincode: '764061' },
  { value: 'balimela', label: 'Balimela', pincode: '764059' },
  { value: 'bankapada', label: 'Bankapada', pincode: '764051' },
  { value: 'barada', label: 'Barada', pincode: '764062' },
  { value: 'baranjala', label: 'Baranjala', pincode: '764064' },
  { value: 'belghar', label: 'Belghar', pincode: '764060' },
  { value: 'bhanjipali', label: 'Bhanjipali', pincode: '764066' },
  { value: 'bhawanipatna', label: 'Bhawanipatna', pincode: '764067' },
  { value: 'bodinga', label: 'Bodinga', pincode: '764052' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '764053' },
  { value: 'dangajhari', label: 'Dangajhari', pincode: '764068' },
  { value: 'jaganathpada', label: 'Jaganathpada', pincode: '764069' },
  { value: 'jhigidi', label: 'Jhigidi', pincode: '764070' },
  { value: 'kadalimunda', label: 'Kadalimunda', pincode: '764055' },
  { value: 'kamkaguda', label: 'Kamkaguda', pincode: '764073' },
  { value: 'kanabaguda', label: 'Kanabaguda', pincode: '764072' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '764074' },
  { value: 'kunja', label: 'Kunja', pincode: '764075' },
  { value: 'mahasundarpada', label: 'Mahasundarpada', pincode: '764076' },
  { value: 'mantriguda', label: 'Mantriguda', pincode: '764077' },
  { value: 'matakabeda', label: 'Matakabeda', pincode: '764078' },
  { value: 'nuapada', label: 'Nuapada', pincode: '764079' },
  { value: 'palsi', label: 'Palsi', pincode: '764080' },
  { value: 'rajapada', label: 'Rajapada', pincode: '764081' },
  { value: 'rambha', label: 'Rambha', pincode: '764082' },
  { value: 'salanpur', label: 'Salanpur', pincode: '764083' },
  { value: 'samantarapur', label: 'Samantarapur', pincode: '764084' },
  { value: 'sirigi', label: 'Sirigi', pincode: '764085' },
  { value: 'sikhar', label: 'Sikhar', pincode: '764086' },
  { value: 'singupada', label: 'Singupada', pincode: '764087' },
  { value: 'tapaguma', label: 'Tapaguma', pincode: '764088' },
  { value: 'unibedi', label: 'Unibedi', pincode: '764089' }
  ],
  
  'rajgangpur': [
  { value: 'balisankara', label: 'Balisankara', pincode: '770017' },
  { value: 'bhatli', label: 'Bhatli', pincode: '770019' },
  { value: 'chatapada', label: 'Chatapada', pincode: '770018' },
  { value: 'dagarpada', label: 'Dagarpada', pincode: '770019' },
  { value: 'kankadahada', label: 'Kankadahada', pincode: '770017' },
  { value: 'khamara', label: 'Khamara', pincode: '770017' },
  { value: 'kamakhyanagar', label: 'Kamakhyanagar', pincode: '770018' },
  { value: 'kansbahal', label: 'Kansbahal', pincode: '770017' },
  { value: 'khermal', label: 'Khermal', pincode: '770017' },
  { value: 'patrapali', label: 'Patrapali', pincode: '770019' },
  { value: 'rajgangpur', label: 'Rajgangpur', pincode: '770016' },
  { value: 'salchera', label: 'Salchera', pincode: '770017' },
  { value: 'sarasada', label: 'Sarasada', pincode: '770019' },
  { value: 'sundarpada', label: 'Sundarpada', pincode: '770018' },
  { value: 'tanpada', label: 'Tanpada', pincode: '770018' }
  ],
  
  'rairangpur': [
  { value: 'abhimanpur', label: 'Abhimanpur', pincode: '757043' },
  { value: 'baripada', label: 'Baripada', pincode: '757001' },
  { value: 'baskhapada', label: 'Baskhapada', pincode: '757054' },
  { value: 'bijayapada', label: 'Bijayapada', pincode: '757051' },
  { value: 'dhobasila', label: 'Dhobasila', pincode: '757042' },
  { value: 'jashipur', label: 'Jashipur', pincode: '757034' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '757036' },
  { value: 'kumirdaha', label: 'Kumirdaha', pincode: '757038' },
  { value: 'madhupur', label: 'Madhupur', pincode: '757052' },
  { value: 'mangurjan', label: 'Mangurjan', pincode: '757044' },
  { value: 'rairangpur', label: 'Rairangpur', pincode: '757043' },
  { value: 'sabira', label: 'Sabira', pincode: '757046' },
  { value: 'sarisama', label: 'Sarisama', pincode: '757045' },
  { value: 'sudua', label: 'Sudua', pincode: '757039' },
  { value: 'badapada', label: 'Badapada', pincode: '757047' },
  { value: 'chunapada', label: 'Chunapada', pincode: '757048' },
  { value: 'dharmagarh', label: 'Dharmagarh', pincode: '757049' },
  { value: 'kumbharpada', label: 'Kumbharpada', pincode: '757050' },
  { value: 'madhapur', label: 'Madhapur', pincode: '757053' },
  { value: 'mathabhanga', label: 'Mathabhanga', pincode: '757055' },
  { value: 'rambha', label: 'Rambha', pincode: '757056' },
  { value: 'talasahi', label: 'Talasahi', pincode: '757057' }
  ],
  
  'rayagada': [
  { value: 'babri', label: 'Babri', pincode: '765001' },
  { value: 'bagru', label: 'Bagru', pincode: '765002' },
  { value: 'balisankara', label: 'Balisankara', pincode: '765003' },
  { value: 'belghar', label: 'Belghar', pincode: '765004' },
  { value: 'bhubangini', label: 'Bhubangini', pincode: '765005' },
  { value: 'chhatisipur', label: 'Chhatisipur', pincode: '765006' },
  { value: 'damba', label: 'Damba', pincode: '765007' },
  { value: 'dharampur', label: 'Dharampur', pincode: '765008' },
  { value: 'gunupur', label: 'Gunupur', pincode: '765021' },
  { value: 'kantabadi', label: 'Kantabadi', pincode: '765022' },
  { value: 'kashipur', label: 'Kashipur', pincode: '765023' },
  { value: 'kolab', label: 'Kolab', pincode: '765024' },
  { value: 'mandibadi', label: 'Mandibadi', pincode: '765025' },
  { value: 'mantridi', label: 'Mantridi', pincode: '765026' },
  { value: 'muribahal', label: 'Muribahal', pincode: '765027' },
  { value: 'patrapur', label: 'Patrapur', pincode: '765028' },
  { value: 'rayagada', label: 'Rayagada', pincode: '765001' },
  { value: 'sargiguda', label: 'Sargiguda', pincode: '765029' },
  { value: 'tiriguma', label: 'Tiriguma', pincode: '765030' },
  { value: 'tungar', label: 'Tungar', pincode: '765031' },
  { value: 'vamsadhara', label: 'Vamsadhara', pincode: '765032' },
  { value: 'badabahal', label: 'Badabahal', pincode: '765033' },
  { value: 'bahinidi', label: 'Bahinidi', pincode: '765034' },
  { value: 'bankadihi', label: 'Bankadihi', pincode: '765035' },
  { value: 'barikpeta', label: 'Barikpeta', pincode: '765036' },
  { value: 'bhagabanpur', label: 'Bhagabanpur', pincode: '765037' },
  { value: 'dholabahal', label: 'Dholabahal', pincode: '765038' },
  { value: 'kanji', label: 'Kanji', pincode: '765039' },
  { value: 'kuchapada', label: 'Kuchapada', pincode: '765040' },
  { value: 'mandal', label: 'Mandal', pincode: '765041' },
  { value: 'mangalpur', label: 'Mangalpur', pincode: '765042' },
  { value: 'panchupalli', label: 'Panchupalli', pincode: '765043' }
  ],
  
  'sambalpur': [
  { value: 'amjora', label: 'Amjora', pincode: '768001' },
  { value: 'badabazar', label: 'Badabazar', pincode: '768002' },
  { value: 'balibandha', label: 'Balibandha', pincode: '768003' },
  { value: 'barapali', label: 'Barapali', pincode: '768101' },
  { value: 'belpada', label: 'Belpada', pincode: '768202' },
  { value: 'chiplima', label: 'Chiplima', pincode: '768025' },
  { value: 'dhanupali', label: 'Dhanupali', pincode: '768005' },
  { value: 'dunguri', label: 'Dunguri', pincode: '768019' },
  { value: 'gandhinagar', label: 'Gandhinagar', pincode: '768004' },
  { value: 'hantal', label: 'Hantal', pincode: '768012' },
  { value: 'jharbeda', label: 'Jharbeda', pincode: '768017' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '768222' },
  { value: 'mahamaya', label: 'Mahamaya', pincode: '768008' },
  { value: 'murmunda', label: 'Murmunda', pincode: '768016' },
  { value: 'nijigarh', label: 'Nijigarh', pincode: '768020' },
  { value: 'rajshree', label: 'Rajshree', pincode: '768007' },
  { value: 'sadar', label: 'Sadar', pincode: '768006' },
  { value: 'sambalpur', label: 'Sambalpur', pincode: '768001' },
  { value: 'sindurpank', label: 'Sindurpank', pincode: '768023' },
  { value: 'sundargarh', label: 'Sundargarh', pincode: '768110' },
  { value: 'tora', label: 'Tora', pincode: '768024' },
  { value: 'biramitrapur', label: 'Biramitrapur', pincode: '768017' },
  { value: 'rahatgaon', label: 'Rahatgaon', pincode: '768021' },
  { value: 'basantpur', label: 'Basantpur', pincode: '768035' },
  { value: 'kolabira', label: 'Kolabira', pincode: '768211' },
  { value: 'deogaon', label: 'Deogaon', pincode: '768106' },
  { value: 'lathikata', label: 'Lathikata', pincode: '768070' }
  ],
  
  'sundargarh': [
  { value: 'badmal', label: 'Badmal', pincode: '770001' },
  { value: 'banai', label: 'Banai', pincode: '770020' },
  { value: 'belpahar', label: 'Belpahar', pincode: '770041' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '770032' },
  { value: 'koira', label: 'Koira', pincode: '770048' },
  { value: 'kusumkera', label: 'Kusumkera', pincode: '770041' },
  { value: 'lathikata', label: 'Lathikata', pincode: '770024' },
  { value: 'raibhata', label: 'Raibhata', pincode: '770046' },
  { value: 'raikela', label: 'Raikela', pincode: '770032' },
  { value: 'sundargarh-town', label: 'Sundargarh Town', pincode: '770001' },
  { value: 'sundargarh-rural', label: 'Sundargarh Rural', pincode: '770033' },
  { value: 'sundra', label: 'Sundra', pincode: '770016' },
  { value: 'tensa', label: 'Tensa', pincode: '770038' },
  { value: 'vilaspur', label: 'Vilaspur', pincode: '770030' },
  { value: 'kudakela', label: 'Kudakela', pincode: '770034' },
  { value: 'jamboni', label: 'Jamboni', pincode: '770040' },
  { value: 'kandula', label: 'Kandula', pincode: '770039' }
  ],
  
  'titilagarh': [
  { value: 'bandhbahal', label: 'Bandhbahal', pincode: '767033' },
  { value: 'bargaon', label: 'Bargaon', pincode: '767021' },
  { value: 'bhainsapalli', label: 'Bhainsapalli', pincode: '767040' },
  { value: 'chikili', label: 'Chikili', pincode: '767033' },
  { value: 'darbangha', label: 'Darbangha', pincode: '767033' },
  { value: 'gandhi-palli', label: 'Gandhi Palli', pincode: '767032' },
  { value: 'kandharia', label: 'Kandharia', pincode: '767050' },
  { value: 'kotra', label: 'Kotra', pincode: '767029' },
  { value: 'lalapur', label: 'Lalapur', pincode: '767024' },
  { value: 'malpada', label: 'Malpada', pincode: '767034' },
  { value: 'padampur', label: 'Padampur', pincode: '767029' },
  { value: 'rampur', label: 'Rampur', pincode: '767022' },
  { value: 'titilagarh-town', label: 'Titilagarh Town', pincode: '767033' },
  { value: 'tiligaon', label: 'Tiligaon', pincode: '767031' },
  { value: 'tuari', label: 'Tuari', pincode: '767032' },
  { value: 'vermilion-palli', label: 'Vermilion Palli', pincode: '767050' }
  ],
  
  'umerkote': [
  { value: 'adharia', label: 'Adharia', pincode: '764070' },
  { value: 'baliapal', label: 'Baliapal', pincode: '764074' },
  { value: 'bankamal', label: 'Bankamal', pincode: '764060' },
  { value: 'barpada', label: 'Barpada', pincode: '764072' },
  { value: 'belpada', label: 'Belpada', pincode: '764060' },
  { value: 'godahula', label: 'Godahula', pincode: '764071' },
  { value: 'jamankira', label: 'Jamankira', pincode: '764075' },
  { value: 'janghira', label: 'Janghira', pincode: '764060' },
  { value: 'kalampur', label: 'Kalampur', pincode: '764076' },
  { value: 'kantiguda', label: 'Kantiguda', pincode: '764060' },
  { value: 'kasiapada', label: 'Kasiapada', pincode: '764073' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '764072' },
  { value: 'kumundi', label: 'Kumundi', pincode: '764060' },
  { value: 'nuwagada', label: 'Nuwagada', pincode: '764074' },
  { value: 'padia', label: 'Padia', pincode: '764070' },
  { value: 'pada', label: 'Pada', pincode: '764075' },
  { value: 'salepada', label: 'Salepada', pincode: '764071' },
  { value: 'tungarikhunta', label: 'Tungarikhunta', pincode: '764070' },
  { value: 'umerkote-town', label: 'Umerkote Town', pincode: '764073' },
  { value: 'hatikhunta', label: 'Hatikhunta', pincode: '764060' },
  { value: 'sundargarh', label: 'Sundargarh', pincode: '764077' }
  ],

  'angul': [
  { value: 'akhuapada', label: 'Akhuapada', pincode: '759122' },
  { value: 'alanda', label: 'Alanda', pincode: '759132' },
  { value: 'angul-town', label: 'Angul Town', pincode: '759122' },
  { value: 'baisinga', label: 'Baisinga', pincode: '759127' },
  { value: 'banarpal', label: 'Banarpal', pincode: '759128' },
  { value: 'barbahali', label: 'Barbahali', pincode: '759128' },
  { value: 'bhalupali', label: 'Bhalupali', pincode: '759145' },
  { value: 'chhendipada', label: 'Chhendipada', pincode: '759134' },
  { value: 'dhenkanal', label: 'Dhenkanal', pincode: '759001' },
  { value: 'hatadihi', label: 'Hatadihi', pincode: '759134' },
  { value: 'jindal', label: 'Jindal', pincode: '759145' },
  { value: 'kamakhyanagar', label: 'Kamakhyanagar', pincode: '759119' },
  { value: 'khamar', label: 'Khamar', pincode: '759127' },
  { value: 'kendujhar', label: 'Kendujhar', pincode: '758001' },
  { value: 'kolar', label: 'Kolar', pincode: '759128' },
  { value: 'mukundapur', label: 'Mukundapur', pincode: '759134' },
  { value: 'nuasahi', label: 'Nuasahi', pincode: '759132' },
  { value: 'panposh', label: 'Panposh', pincode: '759001' },
  { value: 'pallahara', label: 'Pallahara', pincode: '759144' },
  { value: 'rasol', label: 'Rasol', pincode: '759122' },
  { value: 'saradhapur', label: 'Saradhapur', pincode: '759128' },
  { value: 'sambalpur', label: 'Sambalpur', pincode: '768001' },
  { value: 'sunakhala', label: 'Sunakhala', pincode: '759147' },
  { value: 'talcher', label: 'Talcher', pincode: '759100' },
  { value: 'talarapada', label: 'Talarapada', pincode: '759128' },
  { value: 'tubey', label: 'Tubey', pincode: '759127' },
  { value: 'tulasi', label: 'Tulasi', pincode: '759123' },
  { value: 'ushakothi', label: 'Ushakothi', pincode: '759129' }
  ],
  
 'bhadrak': [
  { value: 'balisahi', label: 'Balisahi', pincode: '756100' },
  { value: 'bhadrak-town', label: 'Bhadrak Town', pincode: '756100' },
  { value: 'bhadrak-bazar', label: 'Bhadrak Bazar', pincode: '756100' },
  { value: 'bhadrak-corporation', label: 'Bhadrak Corporation', pincode: '756100' },
  { value: 'chandbali', label: 'Chandbali', pincode: '756133' },
  { value: 'dhamnagar', label: 'Dhamnagar', pincode: '756141' },
  { value: 'kankada', label: 'Kankada', pincode: '756101' },
  { value: 'kapali', label: 'Kapali', pincode: '756138' },
  { value: 'mangalpur', label: 'Mangalpur', pincode: '756134' },
  { value: 'manjuri', label: 'Manjuri', pincode: '756101' },
  { value: 'neuri', label: 'Neuri', pincode: '756144' },
  { value: 'nalagohira', label: 'Nalagohira', pincode: '756119' },
  { value: 'puruna-bhadrak', label: 'Puruna Bhadrak', pincode: '756100' },
  { value: 'sarbabhauma', label: 'Sarbabhauma', pincode: '756115' },
  { value: 'sarat', label: 'Sarat', pincode: '756126' },
  { value: 'shyamsundarpur', label: 'Shyamsundarpur', pincode: '756113' },
  { value: 'sudhakanta', label: 'Sudhakanta', pincode: '756101' },
  { value: 'tihidi', label: 'Tihidi', pincode: '756162' },
  { value: 'tribeni', label: 'Tribeni', pincode: '756101' },
  { value: 'basudevpur', label: 'Basudevpur', pincode: '756125' },
  { value: 'gobindapur', label: 'Gobindapur', pincode: '756113' },
  { value: 'jagatpur', label: 'Jagatpur', pincode: '756114' },
  { value: 'kaliapada', label: 'Kaliapada', pincode: '756162' },
  { value: 'kenduadiha', label: 'Kenduadiha', pincode: '756171' },
  { value: 'kanheipur', label: 'Kanheipur', pincode: '756101' },
  { value: 'kashipur', label: 'Kashipur', pincode: '756140' },
  { value: 'mulapala', label: 'Mulapala', pincode: '756102' },
  { value: 'salia', label: 'Salia', pincode: '756111' },
  { value: 'samagadia', label: 'Samagadia', pincode: '756161' },
  { value: 'saradhapur', label: 'Saradhapur', pincode: '756102' },
  { value: 'aradi', label: 'Aradi', pincode: '756122' },
  { value: 'batiali', label: 'Batiali', pincode: '756131' },
  { value: 'bhogpur', label: 'Bhogpur', pincode: '756150' },
  { value: 'chhatrabada', label: 'Chhatrabada', pincode: '756155' },
  { value: 'dangar', label: 'Dangar', pincode: '756152' },
  { value: 'damara', label: 'Damara', pincode: '756130' },
  { value: 'darua', label: 'Darua', pincode: '756129' },
  { value: 'galiabadi', label: 'Galiabadi', pincode: '756160' },
  { value: 'kasaba', label: 'Kasaba', pincode: '756158' },
  { value: 'naikanidiha', label: 'Naikanidiha', pincode: '756157' },
  { value: 'paripada', label: 'Paripada', pincode: '756156' },
  { value: 'patapur', label: 'Patapur', pincode: '756159' }
  ],
  
  'bolangir': [
  { value: 'balangir-town', label: 'Balangir Town', pincode: '767001' },
  { value: 'barpali', label: 'Barpali', pincode: '767002' },
  { value: 'belpada', label: 'Belpada', pincode: '767028' },
  { value: 'bijepur', label: 'Bijepur', pincode: '767014' },
  { value: 'bhainsmunda', label: 'Bhainsmunda', pincode: '767015' },
  { value: 'bhilapada', label: 'Bhilapada', pincode: '767034' },
  { value: 'jharbandh', label: 'Jharbandh', pincode: '767030' },
  { value: 'kankapali', label: 'Kankapali', pincode: '767024' },
  { value: 'kesinga', label: 'Kesinga', pincode: '767037' },
  { value: 'komna', label: 'Komna', pincode: '767039' },
  { value: 'laimura', label: 'Laimura', pincode: '767021' },
  { value: 'loisingha', label: 'Loisingha', pincode: '767040' },
  { value: 'mangala', label: 'Mangala', pincode: '767027' },
  { value: 'muribahal', label: 'Muribahal', pincode: '767025' },
  { value: 'patnagarh', label: 'Patnagarh', pincode: '767025' },
  { value: 'rajauna', label: 'Rajauna', pincode: '767041' },
  { value: 'salebhata', label: 'Salebhata', pincode: '767045' },
  { value: 'turekela', label: 'Turekela', pincode: '767053' },
  { value: 'deogaon', label: 'Deogaon', pincode: '767017' },
  { value: 'puintala', label: 'Puintala', pincode: '767017' },
  { value: 'bhatapada', label: 'Bhatapada', pincode: '767031' },
  { value: 'charbhata', label: 'Charbhata', pincode: '767049' },
  { value: 'jugalpada', label: 'Jugalpada', pincode: '767038' },
  { value: 'kundurapada', label: 'Kundurapada', pincode: '767013' },
  { value: 'kuturia', label: 'Kuturia', pincode: '767052' },
  { value: 'ladapada', label: 'Ladapada', pincode: '767036' },
  { value: 'nalikadamba', label: 'Nalikadamba', pincode: '767042' },
  { value: 'panikhela', label: 'Panikhela', pincode: '767033' },
  { value: 'patrapali', label: 'Patrapali', pincode: '767043' },
  { value: 'sarar', label: 'Sarar', pincode: '767022' },
  { value: 'santipada', label: 'Santipada', pincode: '767050' },
  { value: 'sargipali', label: 'Sargipali', pincode: '767048' },
  { value: 'thirubali', label: 'Thirubali', pincode: '767051' },
  { value: 'birsamunda', label: 'Birsamunda', pincode: '767004' },
  { value: 'chhatrabali', label: 'Chhatrabali', pincode: '767018' },
  { value: 'dudhiyapada', label: 'Dudhiyapada', pincode: '767019' },
  { value: 'kacharapali', label: 'Kacharapali', pincode: '767020' },
  { value: 'kanpada', label: 'Kanpada', pincode: '767023' },
  { value: 'kharasuan', label: 'Kharasuan', pincode: '767046' },
  { value: 'mokalbahal', label: 'Mokalbahal', pincode: '767044' },
  { value: 'sarada', label: 'Sarada', pincode: '767029' },
  { value: 'tularam', label: 'Tularam', pincode: '767055' }
  ],
  
  'bargarh': [
  { value: 'ambar', label: 'Ambar', pincode: '768029' },
  { value: 'bargarh-town', label: 'Bargarh Town', pincode: '768028' },
  { value: 'barpali', label: 'Barpali', pincode: '768029' },
  { value: 'battamundai', label: 'Battamundai', pincode: '768021' },
  { value: 'beldhuma', label: 'Beldhuma', pincode: '768055' },
  { value: 'bhainsmunda', label: 'Bhainsmunda', pincode: '768029' },
  { value: 'bhunri', label: 'Bhunri', pincode: '768022' },
  { value: 'chandipali', label: 'Chandipali', pincode: '768022' },
  { value: 'dunguripali', label: 'Dunguripali', pincode: '768042' },
  { value: 'gaisilat', label: 'Gaisilat', pincode: '768029' },
  { value: 'jharbandh', label: 'Jharbandh', pincode: '768021' },
  { value: 'khamar', label: 'Khamar', pincode: '768052' },
  { value: 'komna', label: 'Komna', pincode: '768024' },
  { value: 'kundheipali', label: 'Kundheipali', pincode: '768053' },
  { value: 'laimura', label: 'Laimura', pincode: '768050' },
  { value: 'loisingha', label: 'Loisingha', pincode: '768039' },
  { value: 'mangalpur', label: 'Mangalpur', pincode: '768021' },
  { value: 'muribahal', label: 'Muribahal', pincode: '768021' },
  { value: 'patnagarh', label: 'Patnagarh', pincode: '768025' },
  { value: 'rajauna', label: 'Rajauna', pincode: '768046' },
  { value: 'salepali', label: 'Salepali', pincode: '768051' },
  { value: 'turekela', label: 'Turekela', pincode: '768054' },
  { value: 'agalpur', label: 'Agalpur', pincode: '768105' },
  { value: 'balangir', label: 'Balangir', pincode: '768106' },
  { value: 'charbhata', label: 'Charbhata', pincode: '768109' },
  { value: 'gobindpur', label: 'Gobindpur', pincode: '768122' },
  { value: 'jugalpada', label: 'Jugalpada', pincode: '768108' },
  { value: 'kharsel', label: 'Kharsel', pincode: '768104' },
  { value: 'kotabeda', label: 'Kotabeda', pincode: '768123' },
  { value: 'patrapali', label: 'Patrapali', pincode: '768107' },
  { value: 'sambalpur', label: 'Sambalpur', pincode: '768101' }
  ],
  
  'balasore': [
  { value: 'ambar', label: 'Ambar', pincode: '756020' },
  { value: 'balasore-town', label: 'Balasore Town', pincode: '756001' },
  { value: 'balasore-municipal', label: 'Balasore Municipal', pincode: '756002' },
  { value: 'balasore-rural', label: 'Balasore Rural', pincode: '756003' },
  { value: 'baliapal', label: 'Baliapal', pincode: '756025' },
  { value: 'batsari', label: 'Batsari', pincode: '756029' },
  { value: 'bhogarai', label: 'Bhogarai', pincode: '756045' },
  { value: 'chandipur', label: 'Chandipur', pincode: '756025' },
  { value: 'dantan', label: 'Dantan', pincode: '756022' },
  { value: 'guansadiha', label: 'Guansadiha', pincode: '756042' },
  { value: 'jaleswar', label: 'Jaleswar', pincode: '756032' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '756028' },
  { value: 'jammu', label: 'Jammu', pincode: '756018' },
  { value: 'kashipur', label: 'Kashipur', pincode: '756010' },
  { value: 'khandual', label: 'Khandual', pincode: '756043' },
  { value: 'manjuri', label: 'Manjuri', pincode: '756026' },
  { value: 'nadia', label: 'Nadia', pincode: '756014' },
  { value: 'naupada', label: 'Naupada', pincode: '756008' },
  { value: 'olamadhab', label: 'Olamadhab', pincode: '756030' },
  { value: 'patapur', label: 'Patapur', pincode: '756020' },
  { value: 'soro', label: 'Soro', pincode: '756045' },
  { value: 'talanagar', label: 'Talanagar', pincode: '756048' },
  { value: 'adampur', label: 'Adampur', pincode: '756040' },
  { value: 'bajapada', label: 'Bajapada', pincode: '756019' },
  { value: 'balisahi', label: 'Balisahi', pincode: '756027' },
  { value: 'beherasahi', label: 'Beherasahi', pincode: '756036' },
  { value: 'bentapur', label: 'Bentapur', pincode: '756011' },
  { value: 'gadapada', label: 'Gadapada', pincode: '756017' },
  { value: 'khaira', label: 'Khaira', pincode: '756034' },
  { value: 'nuagaon', label: 'Nuagaon', pincode: '756051' },
  { value: 'palia', label: 'Palia', pincode: '756016' },
  { value: 'sujanpur', label: 'Sujanpur', pincode: '756033' },
  { value: 'sulapada', label: 'Sulapada', pincode: '756035' },
  { value: 'tulasi', label: 'Tulasi', pincode: '756044' }
  ],
  
  'bhubaneswar': [
  { value: 'acharya-vihar', label: 'Acharya Vihar', pincode: '751022' },
  { value: 'airfield', label: 'Airfield', pincode: '751001' },
  { value: 'alphapuri', label: 'Alphapuri', pincode: '751015' },
  { value: 'basanti-colony', label: 'Basanti Colony', pincode: '751006' },
  { value: 'bapuji-nagar', label: 'Bapuji Nagar', pincode: '751009' },
  { value: 'baramunda', label: 'Baramunda', pincode: '751003' },
  { value: 'baramunda-bus-stand', label: 'Baramunda Bus Stand', pincode: '751003' },
  { value: 'bharatpur', label: 'Bharatpur', pincode: '751003' },
  { value: 'bhimatangi', label: 'Bhimatangi', pincode: '751029' },
  { value: 'bhoi-nagar', label: 'Bhoi Nagar', pincode: '751022' },
  { value: 'circuit-house', label: 'Circuit House', pincode: '751005' },
  { value: 'dumduma', label: 'Dumduma', pincode: '751019' },
  { value: 'hockey-square', label: 'Hockey Square', pincode: '751001' },
  { value: 'jaya-devi', label: 'Jaya Devi', pincode: '751005' },
  { value: 'jayadev-vihar', label: 'Jayadev Vihar', pincode: '751013' },
  { value: 'kalinga-nagar', label: 'Kalinga Nagar', pincode: '751003' },
  { value: 'kesora', label: 'Kesora', pincode: '751019' },
  { value: 'kharavel-nagar', label: 'Kharavel Nagar', pincode: '751001' },
  { value: 'mahatma-gandhi-nagar', label: 'Mahatma Gandhi Nagar', pincode: '751024' },
  { value: 'nandan-kanan', label: 'Nandan Kanan', pincode: '751002' },
  { value: 'nayapalli', label: 'Nayapalli', pincode: '751013' },
  { value: 'old-town', label: 'Old Town', pincode: '751002' },
  { value: 'patrapada', label: 'Patrapada', pincode: '751019' },
  { value: 'pokhariput', label: 'Pokhariput', pincode: '751020' },
  { value: 'rajmahal-sq', label: 'Rajmahal Square', pincode: '751001' },
  { value: 'satya-nagar', label: 'Satya Nagar', pincode: '751007' },
  { value: 'sundarpada', label: 'Sundarpada', pincode: '751011' },
  { value: 'vss-nagar', label: 'VSS Nagar', pincode: '751007' },
  { value: 'agrahara', label: 'Agrahara', pincode: '751001' },
  { value: 'balakati', label: 'Balakati', pincode: '751029' },
  { value: 'banapur', label: 'Banapur', pincode: '751026' },
  { value: 'barunapada', label: 'Barunapada', pincode: '751016' },
  { value: 'berhampur', label: 'Berhampur', pincode: '751004' },
  { value: 'bhubanananda-nagar', label: 'Bhubanananda Nagar', pincode: '751003' },
  { value: 'bhubaneswar-cantt', label: 'Bhubaneswar Cantt', pincode: '751002' },
  { value: 'chisapada', label: 'Chisapada', pincode: '751014' },
  { value: 'gitanjali-nagar', label: 'Gitanjali Nagar', pincode: '751002' },
  { value: 'gopabandhu-nagar', label: 'Gopabandhu Nagar', pincode: '751016' },
  { value: 'indradhanu-market', label: 'Indradhanu Market', pincode: '751010' },
  { value: 'kahalachandi', label: 'Kahalachandi', pincode: '751019' },
  { value: 'mancheswar', label: 'Mancheswar', pincode: '751017' },
  { value: 'mangalabag', label: 'Mangalabag', pincode: '751001' },
  { value: 'mukundaprasad', label: 'Mukundaprasad', pincode: '751002' },
  { value: 'navin-nagar', label: 'Navin Nagar', pincode: '751009' },
  { value: 'rameswar-pada', label: 'Rameswar Pada', pincode: '751024' },
  { value: 'rupali-square', label: 'Rupali Square', pincode: '751025' },
  { value: 'sahid-nagar', label: 'Sahid Nagar', pincode: '751007' },
  { value: 'sai-nagar', label: 'Sai Nagar', pincode: '751010' },
  { value: 'sohara', label: 'Sohara', pincode: '751019' },
  { value: 'subash-nagar', label: 'Subash Nagar', pincode: '751008' },
  { value: 'tangarapada', label: 'Tangarapada', pincode: '751027' },
  { value: 'unit-4', label: 'Unit 4', pincode: '751001' },
  { value: 'unit-9', label: 'Unit 9', pincode: '751022' },
  { value: 'vihar', label: 'Vihar', pincode: '751004' },
  { value: 'zoopark', label: 'Zoopark', pincode: '751030' }
  ],
  
  'deogarh': [
  { value: 'balibandha', label: 'Balibandha', pincode: '768108' },
  { value: 'banakhandi', label: 'Banakhandi', pincode: '768108' },
  { value: 'barapada', label: 'Barapada', pincode: '768108' },
  { value: 'bhaliapada', label: 'Bhaliapada', pincode: '768108' },
  { value: 'deogarh-town', label: 'Deogarh Town', pincode: '768108' },
  { value: 'dhanapada', label: 'Dhanapada', pincode: '768108' },
  { value: 'gobindapur', label: 'Gobindapur', pincode: '768108' },
  { value: 'jhadeswar', label: 'Jhadeswar', pincode: '768108' },
  { value: 'karadagada', label: 'Karadagada', pincode: '768108' },
  { value: 'kenjiri', label: 'Kenjiri', pincode: '768108' },
  { value: 'khajuripada', label: 'Khajuripada', pincode: '768108' },
  { value: 'kotagada', label: 'Kotagada', pincode: '768108' },
  { value: 'kulad', label: 'Kulad', pincode: '768108' },
  { value: 'mathura', label: 'Mathura', pincode: '768108' },
  { value: 'mohantypadar', label: 'Mohantypadar', pincode: '768108' },
  { value: 'parlipadar', label: 'Parlipadar', pincode: '768108' },
  { value: 'rajtangiri', label: 'Rajtangiri', pincode: '768108' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '768108' },
  { value: 'sikarpada', label: 'Sikarpada', pincode: '768108' },
  { value: 'singhpur', label: 'Singhpur', pincode: '768108' },
  { value: 'tangiri', label: 'Tangiri', pincode: '768108' },
  { value: 'udayagiri', label: 'Udayagiri', pincode: '768108' },
  { value: 'vijayanagar', label: 'Vijayanagar', pincode: '768108' },
  { value: 'amarkot', label: 'Amarkot', pincode: '768108' },
  { value: 'baisakhia', label: 'Baisakhia', pincode: '768108' },
  { value: 'batalia', label: 'Batalia', pincode: '768108' },
  { value: 'bahira', label: 'Bahira', pincode: '768108' },
  { value: 'dhara', label: 'Dhara', pincode: '768108' },
  { value: 'gara', label: 'Gara', pincode: '768108' },
  { value: 'kherguda', label: 'Kherguda', pincode: '768108' },
  { value: 'laxmipur', label: 'Laxmipur', pincode: '768108' },
  { value: 'moharali', label: 'Moharali', pincode: '768108' },
  { value: 'purunakote', label: 'Purunakote', pincode: '768108' }
  ],
  
  'malkangiri': [
  { value: 'banguda', label: 'Banguda', pincode: '764052' },
  { value: 'barkuta', label: 'Barkuta', pincode: '764052' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '764051' },
  { value: 'dadapur', label: 'Dadapur', pincode: '764051' },
  { value: 'jagannathpalli', label: 'Jagannathpalli', pincode: '764051' },
  { value: 'kankerlanka', label: 'Kankerlanka', pincode: '764051' },
  { value: 'kudariguda', label: 'Kudariguda', pincode: '764051' },
  { value: 'malkangiri-town', label: 'Malkangiri Town', pincode: '764047' },
  { value: 'manikpalli', label: 'Manikpalli', pincode: '764051' },
  { value: 'muriguda', label: 'Muriguda', pincode: '764051' },
  { value: 'nuvagam', label: 'Nuvagam', pincode: '764052' },
  { value: 'padmapur', label: 'Padmapur', pincode: '764052' },
  { value: 'phulbani', label: 'Phulbani', pincode: '764052' },
  { value: 'rajanpalli', label: 'Rajanpalli', pincode: '764051' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '764047' },
  { value: 'sundaridi', label: 'Sundaridi', pincode: '764052' },
  { value: 'tulasi', label: 'Tulasi', pincode: '764052' },
  { value: 'adabasa', label: 'Adabasa', pincode: '764051' },
  { value: 'alapalli', label: 'Alapalli', pincode: '764052' },
  { value: 'balimela', label: 'Balimela', pincode: '764052' },
  { value: 'badigeta', label: 'Badigeta', pincode: '764052' },
  { value: 'chintalapalli', label: 'Chintalapalli', pincode: '764052' },
  { value: 'gudapalli', label: 'Gudapalli', pincode: '764052' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '764052' },
  { value: 'jogipalli', label: 'Jogipalli', pincode: '764052' },
  { value: 'kuchulapalli', label: 'Kuchulapalli', pincode: '764052' },
  { value: 'padmapur', label: 'Padmapur', pincode: '764051' }
  ],
  
  'jharsuguda': [
  { value: 'bailtupad', label: 'Bailtupad', pincode: '768202' },
  { value: 'balimela', label: 'Balimela', pincode: '768203' },
  { value: 'banakhandi', label: 'Banakhandi', pincode: '768202' },
  { value: 'baranjala', label: 'Baranjala', pincode: '768201' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '768201' },
  { value: 'chhagalbeda', label: 'Chhagalbeda', pincode: '768203' },
  { value: 'dharamshala', label: 'Dharamshala', pincode: '768201' },
  { value: 'ghoghapada', label: 'Ghoghapada', pincode: '768202' },
  { value: 'jharsuguda-town', label: 'Jharsuguda Town', pincode: '768201' },
  { value: 'kumbhari', label: 'Kumbhari', pincode: '768201' },
  { value: 'khaliapali', label: 'Khaliapali', pincode: '768203' },
  { value: 'laxmipali', label: 'Laxmipali', pincode: '768202' },
  { value: 'mahamaya', label: 'Mahamaya', pincode: '768202' },
  { value: 'manoharpali', label: 'Manoharpali', pincode: '768202' },
  { value: 'mukundapur', label: 'Mukundapur', pincode: '768202' },
  { value: 'padampur', label: 'Padampur', pincode: '768203' },
  { value: 'patmunda', label: 'Patmunda', pincode: '768203' },
  { value: 'raigarh', label: 'Raigarh', pincode: '768202' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '768201' },
  { value: 'saradhapali', label: 'Saradhapali', pincode: '768202' },
  { value: 'sukha', label: 'Sukha', pincode: '768202' },
  { value: 'talsara', label: 'Talsara', pincode: '768203' },
  { value: 'ulunda', label: 'Ulunda', pincode: '768203' },
  { value: 'bheden', label: 'Bheden', pincode: '768202' },
  { value: 'dhenkanal', label: 'Dhenkanal', pincode: '768204' },
  { value: 'kumdi', label: 'Kumdi', pincode: '768202' },
  { value: 'balipali', label: 'Balipali', pincode: '768201' },
  { value: 'kandarpali', label: 'Kandarpali', pincode: '768202' },
  { value: 'kolar', label: 'Kolar', pincode: '768202' },
  { value: 'maharajpali', label: 'Maharajpali', pincode: '768202' },
  { value: 'rengali', label: 'Rengali', pincode: '768213' },
  { value: 'radhapali', label: 'Radhapali', pincode: '768202' }
  ],
  
  'jajpur': [
  { value: 'ada-kapil', label: 'Ada Kapil', pincode: '755001' },
  { value: 'aradi', label: 'Aradi', pincode: '755008' },
  { value: 'balarampur', label: 'Balarampur', pincode: '755010' },
  { value: 'barala', label: 'Barala', pincode: '755001' },
  { value: 'birkona', label: 'Birkona', pincode: '755001' },
  { value: 'chhatabar', label: 'Chhatabar', pincode: '755009' },
  { value: 'chandipur', label: 'Chandipur', pincode: '755001' },
  { value: 'darpan', label: 'Darpan', pincode: '755008' },
  { value: 'jajpur-town', label: 'Jajpur Town', pincode: '755001' },
  { value: 'jaydevpalli', label: 'Jaydevpalli', pincode: '755005' },
  { value: 'kanheipur', label: 'Kanheipur', pincode: '755007' },
  { value: 'kalinganagar', label: 'Kalinganagar', pincode: '755026' },
  { value: 'kharakhia', label: 'Kharakhia', pincode: '755008' },
  { value: 'krushnanandapur', label: 'Krushnanandapur', pincode: '755006' },
  { value: 'manigaon', label: 'Manigaon', pincode: '755008' },
  { value: 'muladi', label: 'Muladi', pincode: '755009' },
  { value: 'nuagan', label: 'Nuagan', pincode: '755008' },
  { value: 'rajarampur', label: 'Rajarampur', pincode: '755001' },
  { value: 'sambalpur', label: 'Sambalpur', pincode: '755009' },
  { value: 'sandhapur', label: 'Sandhapur', pincode: '755008' },
  { value: 'santoshpur', label: 'Santoshpur', pincode: '755010' },
  { value: 'sundarapada', label: 'Sundarapada', pincode: '755001' },
  { value: 'tamalpur', label: 'Tamalpur', pincode: '755008' },
  { value: 'vedapur', label: 'Vedapur', pincode: '755009' },
  { value: 'jagatpur', label: 'Jagatpur', pincode: '755009' },
  { value: 'balikuda', label: 'Balikuda', pincode: '755008' },
  { value: 'bholanathpur', label: 'Bholanathpur', pincode: '755009' },
  { value: 'deulabasta', label: 'Deulabasta', pincode: '755009' },
  { value: 'gududi', label: 'Gududi', pincode: '755007' },
  { value: 'kapilash', label: 'Kapilash', pincode: '755003' },
  { value: 'keluabadi', label: 'Keluabadi', pincode: '755010' },
  { value: 'panchupalli', label: 'Panchupalli', pincode: '755009' },
  { value: 'rasulpur', label: 'Rasulpur', pincode: '755001' },
  { value: 'rengali', label: 'Rengali', pincode: '755026' }
  ],
  
  'baudhgarh': [
  { value: 'akhira', label: 'Akhira', pincode: '762001' },
  { value: 'baudhgarh-town', label: 'Baudhgarh Town', pincode: '762001' },
  { value: 'balun', label: 'Balun', pincode: '762002' },
  { value: 'barpada', label: 'Barpada', pincode: '762003' },
  { value: 'bari', label: 'Bari', pincode: '762004' },
  { value: 'belagadia', label: 'Belagadia', pincode: '762003' },
  { value: 'gokulpur', label: 'Gokulpur', pincode: '762003' },
  { value: 'jhikinda', label: 'Jhikinda', pincode: '762005' },
  { value: 'kachhar', label: 'Kachhar', pincode: '762005' },
  { value: 'kandhamal', label: 'Kandhamal', pincode: '762010' },
  { value: 'mahamaya', label: 'Mahamaya', pincode: '762006' },
  { value: 'mandal', label: 'Mandal', pincode: '762007' },
  { value: 'palaghat', label: 'Palaghat', pincode: '762008' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '762009' },
  { value: 'sarisikala', label: 'Sarisikala', pincode: '762010' },
  { value: 'sambalpur', label: 'Sambalpur', pincode: '762011' },
  { value: 'pipalpadar', label: 'Pipalpadar', pincode: '762012' },
  { value: 'dangapada', label: 'Dangapada', pincode: '762013' },
  { value: 'godianali', label: 'Godianali', pincode: '762014' },
  { value: 'barpali', label: 'Barpali', pincode: '762015' },
  { value: 'kaithapada', label: 'Kaithapada', pincode: '762016' },
  { value: 'rayadwar', label: 'Rayadwar', pincode: '762017' },
  { value: 'bhuldi', label: 'Bhuldi', pincode: '762018' }
  ],
  
  'cuttack': [
  { value: 'badambadi', label: 'Badambadi', pincode: '753001' },
  { value: 'bada-bazar', label: 'Bada Bazar', pincode: '753002' },
  { value: 'buxi-bazar', label: 'Buxi Bazar', pincode: '753001' },
  { value: 'cuttack-city', label: 'Cuttack City', pincode: '753001' },
  { value: 'chauhata', label: 'Chauhata', pincode: '753002' },
  { value: 'chauliaganj', label: 'Chauliaganj', pincode: '753004' },
  { value: 'jobra', label: 'Jobra', pincode: '753003' },
  { value: 'kanika', label: 'Kanika', pincode: '753002' },
  { value: 'mahanadi-vihar', label: 'Mahanadi Vihar', pincode: '753004' },
  { value: 'mangalabag', label: 'Mangalabag', pincode: '753001' },
  { value: 'nehrunagar', label: 'Nehrunagar', pincode: '753001' },
  { value: 'raja-bazar', label: 'Raja Bazar', pincode: '753003' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '753001' },
  { value: 'salipur', label: 'Salipur', pincode: '754202' },
  { value: 'serajuli', label: 'Serajuli', pincode: '753004' },
  { value: 'tulasipur', label: 'Tulasipur', pincode: '753003' },
  { value: 'tangi', label: 'Tangi', pincode: '754022' },
  { value: 'sector-9', label: 'Sector 9', pincode: '753015' },
  { value: 'barmunda', label: 'Barmunda', pincode: '753002' },
  { value: 'bhubaneswar-rd', label: 'Bhubaneswar Rd', pincode: '753001' },
  { value: 'kantia', label: 'Kantia', pincode: '753004' },
  { value: 'kesharpur', label: 'Kesharpur', pincode: '753003' },
  { value: 'lalbag', label: 'Lalbag', pincode: '753002' },
  { value: 'mangalpur', label: 'Mangalpur', pincode: '753014' },
  { value: 'nayasarak', label: 'Nayasarak', pincode: '753001' },
  { value: 'sijua', label: 'Sijua', pincode: '753012' },
  { value: 'sector-7', label: 'Sector 7', pincode: '753015' },
  { value: 'badapokhari', label: 'Badapokhari', pincode: '753010' }
  ],
  
  'puri': [
  { value: 'balighai', label: 'Balighai', pincode: '752002' },
  { value: 'balukhand', label: 'Balukhand', pincode: '752001' },
  { value: 'dauhudi', label: 'Dauhudi', pincode: '752002' },
  { value: 'gobindpur', label: 'Gobindpur', pincode: '752003' },
  { value: 'haripur', label: 'Haripur', pincode: '752002' },
  { value: 'jatani', label: 'Jatani', pincode: '752021' },
  { value: 'jaya-devi', label: 'Jaya Devi', pincode: '752002' },
  { value: 'konark', label: 'Konark', pincode: '752111' },
  { value: 'krushnanagar', label: 'Krushnanagar', pincode: '752001' },
  { value: 'puri-bazar', label: 'Puri Bazar', pincode: '752001' },
  { value: 'puri-town', label: 'Puri Town', pincode: '752001' },
  { value: 'ramachandi', label: 'Ramachandi', pincode: '752002' },
  { value: 'sea-beach', label: 'Sea Beach', pincode: '752001' },
  { value: 'shree-ramchandi', label: 'Shree Ramchandi', pincode: '752002' },
  { value: 'sri-krishna-nagar', label: 'Sri Krishna Nagar', pincode: '752002' },
  { value: 'swargadevi', label: 'Swargadevi', pincode: '752001' },
  { value: 'village-narendra', label: 'Village Narendra', pincode: '752004' },
  { value: 'badabhuin', label: 'Badabhuin', pincode: '752002' },
  { value: 'baliapada', label: 'Baliapada', pincode: '752002' },
  { value: 'chandanpur', label: 'Chandanpur', pincode: '752022' },
  { value: 'gandhi-market', label: 'Gandhi Market', pincode: '752001' },
  { value: 'gokarnapur', label: 'Gokarnapur', pincode: '752005' },
  { value: 'karanja', label: 'Karanja', pincode: '752012' },
  { value: 'kansar', label: 'Kansar', pincode: '752023' },
  { value: 'nalitapatna', label: 'Nalitapatna', pincode: '752021' },
  { value: 'sadar', label: 'Sadar', pincode: '752004' },
  { value: 'sankarapur', label: 'Sankarapur', pincode: '752002' },
  { value: 'sree-sabari', label: 'Sree Sabari', pincode: '752003' },
  { value: 'tulasi-khetra', label: 'Tulasi Khetra', pincode: '752013' },
  { value: 'beach-road', label: 'Beach Road', pincode: '752001' },
  { value: 'shyampur', label: 'Shyampur', pincode: '752004' },
  { value: 'purusottampur', label: 'Purusottampur', pincode: '752002' },
  { value: 'sanjay-nagar', label: 'Sanjay Nagar', pincode: '752015' },
  { value: 'gopinath-pur', label: 'Gopinath Pur', pincode: '752004' },
  { value: 'ranpur', label: 'Ranpur', pincode: '752003' }
  ],
 
  'kendrapara': [
  { value: 'badakhandi', label: 'Badakhandi', pincode: '754211' },
  { value: 'bhograi', label: 'Bhograi', pincode: '754212' },
  { value: 'bhalipur', label: 'Bhalipur', pincode: '754211' },
  { value: 'garadapur', label: 'Garadapur', pincode: '754200' },
  { value: 'kendrapara-town', label: 'Kendrapara Town', pincode: '754211' },
  { value: 'krushnanagar', label: 'Krushnanagar', pincode: '754223' },
  { value: 'manipur', label: 'Manipur', pincode: '754213' },
  { value: 'manguli', label: 'Manguli', pincode: '754211' },
  { value: 'patkura', label: 'Patkura', pincode: '754206' },
  { value: 'puri-panchayat', label: 'Puri Panchayat', pincode: '754200' },
  { value: 'rajanagar', label: 'Rajanagar', pincode: '754227' },
  { value: 'sadar', label: 'Sadar', pincode: '754211' },
  { value: 'siali', label: 'Siali', pincode: '754206' },
  { value: 'srirampur', label: 'Srirampur', pincode: '754223' },
  { value: 'talachua', label: 'Talachua', pincode: '754206' },
  { value: 'tangara', label: 'Tangara', pincode: '754227' },
  { value: 'thakura', label: 'Thakura', pincode: '754200' },
  { value: 'baladi', label: 'Baladi', pincode: '754208' },
  { value: 'balisahi', label: 'Balisahi', pincode: '754209' },
  { value: 'chalana', label: 'Chalana', pincode: '754223' },
  { value: 'goribpur', label: 'Goribpur', pincode: '754213' },
  { value: 'kandarpur', label: 'Kandarpur', pincode: '754207' },
  { value: 'kanikora', label: 'Kanikora', pincode: '754208' },
  { value: 'nandanpur', label: 'Nandanpur', pincode: '754220' },
  { value: 'rajanigandha', label: 'Rajanigandha', pincode: '754227' },
  { value: 'ratnagiri', label: 'Ratnagiri', pincode: '754204' },
  { value: 'sabira', label: 'Sabira', pincode: '754215' },
  { value: 'sandhikhai', label: 'Sandhikhai', pincode: '754212' }
  ],
  
  'khordha': [
  { value: 'adasta', label: 'Adasta', pincode: '752056' },
  { value: 'balipatna', label: 'Balipatna', pincode: '752056' },
  { value: 'bhubaneswar', label: 'Bhubaneswar', pincode: '751001' },
  { value: 'chandaka', label: 'Chandaka', pincode: '752054' },
  { value: 'gobindpur', label: 'Gobindpur', pincode: '752056' },
  { value: 'gudiali', label: 'Gudiali', pincode: '752056' },
  { value: 'jankia', label: 'Jankia', pincode: '752020' },
  { value: 'khordha-town', label: 'Khordha Town', pincode: '752055' },
  { value: 'kandarpur', label: 'Kandarpur', pincode: '752055' },
  { value: 'manpur', label: 'Manpur', pincode: '752056' },
  { value: 'pahala', label: 'Pahala', pincode: '752101' },
  { value: 'rasulpur', label: 'Rasulpur', pincode: '752056' },
  { value: 'sadar', label: 'Sadar', pincode: '752056' },
  { value: 'sankarpur', label: 'Sankarpur', pincode: '752056' },
  { value: 'srirampur', label: 'Srirampur', pincode: '752056' },
  { value: 'tangiriapal', label: 'Tangiriapal', pincode: '752056' },
  { value: 'tangiri', label: 'Tangiri', pincode: '752055' },
  { value: 'baghamari', label: 'Baghamari', pincode: '752056' },
  { value: 'balianta', label: 'Balianta', pincode: '752104' },
  { value: 'banamalipur', label: 'Banamalipur', pincode: '752056' },
  { value: 'barmunda', label: 'Barmunda', pincode: '751003' },
  { value: 'gopinathpur', label: 'Gopinathpur', pincode: '752055' },
  { value: 'kundheijhari', label: 'Kundheijhari', pincode: '752056' },
  { value: 'rajnagar', label: 'Rajnagar', pincode: '752020' },
  { value: 'ranapur', label: 'Ranapur', pincode: '752058' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '752056' },
  { value: 'tulasi', label: 'Tulasi', pincode: '752056' },
  { value: 'village-raghunathpur', label: 'Village Raghunathpur', pincode: '752056' }
  ],
  
  'sonepur': [
  { value: 'badabahal', label: 'Badabahal', pincode: '767019' },
  { value: 'barpali', label: 'Barpali', pincode: '767023' },
  { value: 'belpada', label: 'Belpada', pincode: '767019' },
  { value: 'bungamunda', label: 'Bungamunda', pincode: '767027' },
  { value: 'dunguripali', label: 'Dunguripali', pincode: '767019' },
  { value: 'kanpur', label: 'Kanpur', pincode: '767018' },
  { value: 'khaliapali', label: 'Khaliapali', pincode: '767019' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '767023' },
  { value: 'padampur', label: 'Padampur', pincode: '767018' },
  { value: 'puriapali', label: 'Puriapali', pincode: '767023' },
  { value: 'sonepur-town', label: 'Sonepur Town', pincode: '767017' },
  { value: 'sundhipali', label: 'Sundhipali', pincode: '767019' },
  { value: 'tunduru', label: 'Tunduru', pincode: '767018' },
  { value: 'vill-ranihat', label: 'Vill. Ranihat', pincode: '767023' },
  { value: 'kumuria', label: 'Kumuria', pincode: '767029' },
  { value: 'khamara', label: 'Khamara', pincode: '767029' },
  { value: 'malisahi', label: 'Malisahi', pincode: '767029' },
  { value: 'patrapali', label: 'Patrapali', pincode: '767027' },
  { value: 'purunapada', label: 'Purunapada', pincode: '767029' },
  { value: 'raijharan', label: 'Raijharan', pincode: '767019' },
  { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '767019' },
  { value: 'sahajbahal', label: 'Sahajbahal', pincode: '767029' },
  { value: 'santhapada', label: 'Santhapada', pincode: '767017' },
  { value: 'sikarpali', label: 'Sikarpali', pincode: '767017' },
  { value: 'bhalupali', label: 'Bhalupali', pincode: '767018' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '767027' },
  { value: 'gandhamardhan', label: 'Gandhamardhan', pincode: '767029' },
  { value: 'jangra', label: 'Jangra', pincode: '767017' },
  { value: 'jharbandh', label: 'Jharbandh', pincode: '767017' },
  { value: 'kandheikela', label: 'Kandheikela', pincode: '767017' },
  { value: 'mendhapali', label: 'Mendhapali', pincode: '767017' },
  { value: 'mojhapada', label: 'Mojhapada', pincode: '767029' },
  { value: 'naranpur', label: 'Naranpur', pincode: '767019' },
  { value: 'sialbahal', label: 'Sialbahal', pincode: '767018' }
  ],
  
  'patnagarh': [
  { value: 'banspal', label: 'Banspal', pincode: '767043' },
  { value: 'barpali', label: 'Barpali', pincode: '767043' },
  { value: 'belpada', label: 'Belpada', pincode: '767043' },
  { value: 'bungamunda', label: 'Bungamunda', pincode: '767042' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '767042' },
  { value: 'gundur', label: 'Gundur', pincode: '767042' },
  { value: 'jatrapali', label: 'Jatrapali', pincode: '767042' },
  { value: 'kanpur', label: 'Kanpur', pincode: '767043' },
  { value: 'kelendapali', label: 'Kelendapali', pincode: '767042' },
  { value: 'kuchinda', label: 'Kuchinda', pincode: '767043' },
  { value: 'padampur', label: 'Padampur', pincode: '767043' },
  { value: 'patnagarh-town', label: 'Patnagarh Town', pincode: '767023' },
  { value: 'purunapada', label: 'Purunapada', pincode: '767042' },
  { value: 'raijharan', label: 'Raijharan', pincode: '767042' },
  { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '767043' },
  { value: 'sikarpali', label: 'Sikarpali', pincode: '767043' },
  { value: 'sundhipali', label: 'Sundhipali', pincode: '767042' },
  { value: 'tunduru', label: 'Tunduru', pincode: '767042' },
  { value: 'adhopur', label: 'Adhopur', pincode: '767023' },
  { value: 'dharmasala', label: 'Dharmasala', pincode: '767042' },
  { value: 'kandhula', label: 'Kandhula', pincode: '767042' },
  { value: 'mendhapali', label: 'Mendhapali', pincode: '767023' },
  { value: 'nagapali', label: 'Nagapali', pincode: '767042' },
  { value: 'raikela', label: 'Raikela', pincode: '767043' },
  { value: 'santoshpur', label: 'Santoshpur', pincode: '767043' },
  { value: 'telpali', label: 'Telpali', pincode: '767042' },
  { value: 'basantpur', label: 'Basantpur', pincode: '767042' },
  { value: 'dalimbha', label: 'Dalimbha', pincode: '767042' },
  { value: 'kapari', label: 'Kapari', pincode: '767043' },
  { value: 'khaliapali', label: 'Khaliapali', pincode: '767043' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '767042' },
  { value: 'paliamba', label: 'Paliamba', pincode: '767043' },
  { value: 'radhanagar', label: 'Radhanagar', pincode: '767042' },
  { value: 'sadar', label: 'Sadar', pincode: '767043' },
  { value: 'sankrampali', label: 'Sankrampali', pincode: '767042' },
  { value: 'sapasi', label: 'Sapasi', pincode: '767042' }
  ],

//mizoram areas
'aizawl': [
  { value: 'aibawk', label: 'Aibawk', pincode: '796190' },
  { value: 'armed-veng', label: 'Armed Veng', pincode: '796007' },
  { value: 'bawngkawn', label: 'Bawngkawn', pincode: '796014' },
  { value: 'bethlehem', label: 'Bethlehem', pincode: '796007' },
  { value: 'bungkawn', label: 'Bungkawn', pincode: '796005' },
  { value: 'chaltlang', label: 'Chaltlang', pincode: '796012' },
  { value: 'dawrpui', label: 'Dawrpui', pincode: '796001' },
  { value: 'durtlang', label: 'Durtlang', pincode: '796025' },
  { value: 'electric-veng', label: 'Electric Veng', pincode: '796007' },
  { value: 'hualngohmun', label: 'Hualngohmun', pincode: '796005' },
  { value: 'kulikawn', label: 'Kulikawn', pincode: '796005' },
  { value: 'lengpui-airport', label: 'Lengpui Airport', pincode: '796410' },
  { value: 'maubawk', label: 'Maubawk', pincode: '796005' },
  { value: 'mizoram-university', label: 'Mizoram University', pincode: '796004' },
  { value: 'mission-vengthlang', label: 'Mission Vengthlang', pincode: '796005' },
  { value: 'muallungthu', label: 'Muallungthu', pincode: '796005' },
  { value: 'ramhlun', label: 'Ramhlun', pincode: '796012' },
  { value: 'saitual', label: 'Saitual', pincode: '796261' },
  { value: 'sihphir', label: 'Sihphir', pincode: '796036' },
  { value: 'tanhril', label: 'Tanhril', pincode: '796009' },
  { value: 'zarkawt', label: 'Zarkawt', pincode: '796007' },
  { value: 'zemabawk', label: 'Zemabawk', pincode: '796017' },
  { value: 'zuangtui', label: 'Zuangtui', pincode: '796017' }
  ],

  'champhai': [
  { "value": "bungzung", "label": "Bungzung", "pincode": "796320" },
  { "value": "champhai", "label": "Champhai", "pincode": "796321" },
  { "value": "dungtlang", "label": "Dungtlang", "pincode": "796320" },
  { "value": "farkawn", "label": "Farkawn", "pincode": "796320" },
  { "value": "hnahlan", "label": "Hnahlan", "pincode": "796321" },
  { "value": "hmunhmeltha", "label": "Hmunhmeltha", "pincode": "796321" },
  { "value": "hruaikawn", "label": "Hruaikawn", "pincode": "796321" },
  { "value": "kelkang", "label": "Kelkang", "pincode": "796321" },
  { "value": "khuangleng", "label": "Khuangleng", "pincode": "796321" },
  { "value": "khuangphah", "label": "Khuangphah", "pincode": "796321" },
  { "value": "khuangthing", "label": "Khuangthing", "pincode": "796320" },
  { "value": "lamzawl", "label": "Lamzawl", "pincode": "796290" },
  { "value": "leisenzo", "label": "Leisenzo", "pincode": "796321" },
  { "value": "leithum", "label": "Leithum", "pincode": "796320" },
  { "value": "lungphunlian", "label": "Lungphunlian", "pincode": "796321" },
  { "value": "mualkawi", "label": "Mualkawi", "pincode": "796321" },
  { "value": "murlen", "label": "Murlen", "pincode": "796321" },
  { "value": "n-khawbung", "label": "N. Khawbung", "pincode": "796321" },
  { "value": "ngur", "label": "Ngur", "pincode": "796321" },
  { "value": "ruantlang", "label": "Ruantlang", "pincode": "796321" },
  { "value": "s-khawbung", "label": "S. Khawbung", "pincode": "796320" },
  { "value": "samthang", "label": "Samthang", "pincode": "796320" },
  { "value": "sazep", "label": "Sazep", "pincode": "796320" },
  { "value": "selam", "label": "Selam", "pincode": "796290" },
  { "value": "sesih", "label": "Sesih", "pincode": "796321" },
  { "value": "tlangsam", "label": "Tlangsam", "pincode": "796321" },
  { "value": "tualcheng", "label": "Tualcheng", "pincode": "796321" },
  { "value": "vaikhawtlang", "label": "Vaikhawtlang", "pincode": "796290" },
  { "value": "vangchhia", "label": "Vangchhia", "pincode": "796320" },
  { "value": "vanzau", "label": "Vanzau", "pincode": "796320" },
  { "value": "vaphai", "label": "Vaphai", "pincode": "796320" },
  { "value": "vapar", "label": "Vapar", "pincode": "796321" },
  { "value": "zote", "label": "Zote", "pincode": "796321" }
  ],

  'lunglei': [
  { "value": "aithur", "label": "Aithur", "pincode": "796571" },
  { "value": "ajasora", "label": "Ajasora", "pincode": "796770" },
  { "value": "belthei", "label": "Belthei", "pincode": "796730" },
  { "value": "borapansury", "label": "Borapansury", "pincode": "796770" },
  { "value": "bualte", "label": "Bualte", "pincode": "796701" },
  { "value": "buarpui", "label": "Buarpui", "pincode": "796701" },
  { "value": "bunghmun", "label": "Bunghmun", "pincode": "796710" },
  { "value": "chandmary", "label": "Chandmary", "pincode": "796701" },
  { "value": "changpui", "label": "Changpui", "pincode": "796701" },
  { "value": "chawngte", "label": "Chawngte", "pincode": "796770" },
  { "value": "chawngtui", "label": "Chawngtui", "pincode": "796571" },
  { "value": "cherhlun", "label": "Cherhlun", "pincode": "796571" },
  { "value": "darngawn-w", "label": "Darngawn 'W'", "pincode": "796710" },
  { "value": "darzo", "label": "Darzo", "pincode": "796571" },
  { "value": "demagiri", "label": "Demagiri", "pincode": "796751" },
  { "value": "diblibagh", "label": "Diblibagh", "pincode": "796751" },
  { "value": "haulawng", "label": "Haulawng", "pincode": "796691" },
  { "value": "hauruang", "label": "Hauruang", "pincode": "796701" },
  { "value": "hnahchang", "label": "Hnahchang", "pincode": "796691" },
  { "value": "hnahthial", "label": "Hnahthial", "pincode": "796571" },
  { "value": "hrangchalkawn", "label": "Hrangchalkawn", "pincode": "796701" },
  { "value": "jarulsury", "label": "Jarulsury", "pincode": "796770" },
  { "value": "kajoisury", "label": "Kajoisury", "pincode": "796751" },
  { "value": "kamalanagar", "label": "Kamalanagar", "pincode": "796772" },
  { "value": "kawnpui-w", "label": "Kawnpui 'W'", "pincode": "796710" },
  { "value": "kikawn", "label": "Kikawn", "pincode": "796701" },
  { "value": "laisawral", "label": "Laisawral", "pincode": "796710" },
  { "value": "leite", "label": "Leite", "pincode": "796571" },
  { "value": "lungchem", "label": "Lungchem", "pincode": "796701" },
  { "value": "lunglawn", "label": "Lunglawn", "pincode": "796701" },
  { "value": "lunglei", "label": "Lunglei", "pincode": "796701" },
  { "value": "lungleng-s", "label": "Lungleng 'S'", "pincode": "796571" },
  { "value": "lungrang-s", "label": "Lungrang 'S'", "pincode": "796730" },
  { "value": "lungsen", "label": "Lungsen", "pincode": "796730" },
  { "value": "mualcheng-s", "label": "Mualcheng 'S'", "pincode": "796701" },
  { "value": "muallianpui", "label": "Muallianpui", "pincode": "796571" },
  { "value": "mualthuam-n", "label": "Mualthuam 'N'", "pincode": "796691" },
  { "value": "nunsury", "label": "Nunsury", "pincode": "796751" },
  { "value": "pangzawl", "label": "Pangzawl", "pincode": "796571" },
  { "value": "phairuangkai", "label": "Phairuangkai", "pincode": "796730" },
  { "value": "puankhai", "label": "Puankhai", "pincode": "796751" },
  { "value": "pukpui", "label": "Pukpui", "pincode": "796691" },
  { "value": "putlungasih", "label": "Putlungasih", "pincode": "796730" },
  { "value": "ralvawng", "label": "Ralvawng", "pincode": "796701" },
  { "value": "ramlaitui", "label": "Ramlaitui", "pincode": "796691" },
  { "value": "rangte", "label": "Rangte", "pincode": "796730" },
  { "value": "rawpui", "label": "Rawpui", "pincode": "796571" },
  { "value": "rualalung", "label": "Rualalung", "pincode": "796730" },
  { "value": "s-chawilung", "label": "S. Chawilung", "pincode": "796751" },
  { "value": "s-vanlaiphai", "label": "S. Vanlaiphai", "pincode": "796571" },
  { "value": "sachan", "label": "Sachan", "pincode": "796710" },
  { "value": "saizawh", "label": "Saizawh", "pincode": "796770" }
  ],
 

  'siaha': [
  { "value": "ahmypi", "label": "Ahmypi", "pincode": "796901" },
  { "value": "bualpui-ng", "label": "Bualpui NG", "pincode": "796901" },
  { "value": "chakhang", "label": "Chakhang", "pincode": "796901" },
  { "value": "chapi", "label": "Chapi", "pincode": "796901" },
  { "value": "chhaolo", "label": "Chhaolo", "pincode": "796901" },
  { "value": "chhuarlung", "label": "Chhuarlung", "pincode": "796901" },
  { "value": "fungkah", "label": "Fungkah", "pincode": "796901" },
  { "value": "khopai", "label": "Khopai", "pincode": "796901" },
  { "value": "kiang", "label": "Kiang", "pincode": "796911" },
  { "value": "laki", "label": "Laki", "pincode": "796901" },
  { "value": "latawh", "label": "Latawh", "pincode": "796901" },
  { "value": "lawngban", "label": "Lawngban", "pincode": "796901" },
  { "value": "leite", "label": "Leite", "pincode": "796911" },
  { "value": "lobo", "label": "Lobo", "pincode": "796901" },
  { "value": "lungbun", "label": "Lungbun", "pincode": "796901" },
  { "value": "lungpher-s", "label": "Lungpher S", "pincode": "796901" },
  { "value": "maubawk", "label": "Maubawk", "pincode": "796901" },
  { "value": "mivawk", "label": "Mivawk", "pincode": "796901" },
  { "value": "new-maubawk", "label": "New Maubawk", "pincode": "796901" },
  { "value": "niawhtlang", "label": "Niawhtlang", "pincode": "796901" },
  { "value": "no-aotla", "label": "No-aotla", "pincode": "796901" },
  { "value": "phura", "label": "Phura", "pincode": "796911" },
  { "value": "saikao", "label": "Saikao", "pincode": "796911" },
  { "value": "siaha", "label": "Siaha", "pincode": "796901" },
  { "value": "siata", "label": "Siata", "pincode": "796901" },
  { "value": "sihtlang", "label": "Sihtlang", "pincode": "796901" },
  { "value": "silsury", "label": "Silsury", "pincode": "796911" },
  { "value": "sumsilui", "label": "Sumsilui", "pincode": "796901" },
  { "value": "tipa", "label": "Tipa", "pincode": "796911" },
  { "value": "tokalo", "label": "Tokalo", "pincode": "796911" },
  { "value": "tuipang", "label": "Tuipang", "pincode": "796901" },
  { "value": "tuipuibari", "label": "Tuipuibari", "pincode": "796911" },
  { "value": "zawngling", "label": "Zawngling", "pincode": "796911" },
  { "value": "zyhno", "label": "Zyhno", "pincode": "796911" },
  { "value": "bualpui-ng", "label": "Bualpui NG", "pincode": "796901" },
  { "value": "chakhang", "label": "Chakhang", "pincode": "796901" },
  { "value": "chapi", "label": "Chapi", "pincode": "796901" },
  { "value": "chhaolo", "label": "Chhaolo", "pincode": "796901" },
  { "value": "chhuarlung", "label": "Chhuarlung", "pincode": "796901" },
  { "value": "fungkah", "label": "Fungkah", "pincode": "796901" },
  { "value": "khopai", "label": "Khopai", "pincode": "796901" },
  { "value": "laki", "label": "Laki", "pincode": "796901" },
  { "value": "latawh", "label": "Latawh", "pincode": "796901" },
  { "value": "lawngban", "label": "Lawngban", "pincode": "796901" },
  { "value": "lobo", "label": "Lobo", "pincode": "796901" },
  { "value": "lungbun", "label": "Lungbun", "pincode": "796901" },
  { "value": "lungpher-s", "label": "Lungpher S", "pincode": "796901" },
  { "value": "new-maubawk", "label": "New Maubawk", "pincode": "796901" },
  { "value": "niawhtlang", "label": "Niawhtlang", "pincode": "796901" },
  { "value": "no-aotla", "label": "No-aotla", "pincode": "796901" },
  { "value": "phura", "label": "Phura", "pincode": "796911" },
  { "value": "saikao", "label": "Saikao", "pincode": "796911" },
  { "value": "siaha", "label": "Siaha", "pincode": "796901" },
  { "value": "siata", "label": "Siata", "pincode": "796901" },
  { "value": "tipa", "label": "Tipa", "pincode": "796911" },
  { "value": "zyhno", "label": "Zyhno", "pincode": "796911" }
  ],

  'mamit': [
  { "value": "ailawng", "label": "Ailawng", "pincode": "796501" },
  { "value": "dampui", "label": "Dampui", "pincode": "796441" },
  { "value": "darlung", "label": "Darlung", "pincode": "796501" },
  { "value": "kawrtethawveng", "label": "Kawrtethawveng", "pincode": "796441" },
  { "value": "kawrthah", "label": "Kawrthah", "pincode": "796441" },
  { "value": "khawrihnim", "label": "Khawrihnim", "pincode": "796501" },
  { "value": "lallen", "label": "Lallen", "pincode": "796431" },
  { "value": "lungdar-w", "label": "Lungdar W", "pincode": "796501" },
  { "value": "marpara", "label": "Marpara", "pincode": "796431" },
  { "value": "mamit", "label": "Mamit", "pincode": "796441" },
  { "value": "n-chhippui", "label": "N. Chhippui", "pincode": "796431" },
  { "value": "n-sabual", "label": "N. Sabual", "pincode": "796441" },
  { "value": "parvatui", "label": "Parvatui", "pincode": "796431" },
  { "value": "phaileng", "label": "Phaileng", "pincode": "796431" },
  { "value": "serhmun", "label": "Serhmun", "pincode": "796441" },
  { "value": "tuidam", "label": "Tuidam", "pincode": "796441" }
  ],

  'serchhip': [
  { "value": "ailawn", "label": "Ailawn", "pincode": "796181" },
  { "value": "baktawng", "label": "Baktawng", "pincode": "796161" },
  { "value": "bawktlang", "label": "Bawktlang", "pincode": "796181" },
  { "value": "buangpui", "label": "Buangpui", "pincode": "796186" },
  { "value": "buhkangkawn", "label": "Buhkangkawn", "pincode": "796161" },
  { "value": "bungtlang", "label": "Bungtlang", "pincode": "796181" },
  { "value": "chekawn", "label": "Chekawn", "pincode": "796181" },
  { "value": "chhiahtlang", "label": "Chhiahtlang", "pincode": "796181" },
  { "value": "chhingchhip", "label": "Chhingchhip", "pincode": "796181" },
  { "value": "chhuanthar-tlangnuam", "label": "Chhuanthar Tlangnuam", "pincode": "796161" },
  { "value": "dinthar", "label": "Dinthar", "pincode": "796181" },
  { "value": "east-lungdar", "label": "East Lungdar", "pincode": "796181" },
  { "value": "hmawngkawn", "label": "Hmawngkawn", "pincode": "796161" },
  { "value": "hmuntha", "label": "Hmuntha", "pincode": "796181" },
  { "value": "hmunzawl", "label": "Hmunzawl", "pincode": "796181" },
  { "value": "hriangtlang", "label": "Hriangtlang", "pincode": "796181" },
  { "value": "hualtu", "label": "Hualtu", "pincode": "796161" },
  { "value": "keitum", "label": "Keitum", "pincode": "796181" },
  { "value": "khawbel", "label": "Khawbel", "pincode": "796181" },
  { "value": "khawlailung", "label": "Khawlailung", "pincode": "796181" },
  { "value": "khumtung", "label": "Khumtung", "pincode": "796161" },
  { "value": "leng", "label": "Leng", "pincode": "796370" },
  { "value": "lungchhuan", "label": "Lungchhuan", "pincode": "796181" },
  { "value": "lungkawlh", "label": "Lungkawlh", "pincode": "796181" },
  { "value": "lungpho", "label": "Lungpho", "pincode": "796181" },
  { "value": "north-mualcheng", "label": "North Mualcheng", "pincode": "796370" },
  { "value": "north-vanlaiphai", "label": "North Vanlaiphai", "pincode": "796181" },
  { "value": "neihloh", "label": "Neihloh", "pincode": "796186" },
  { "value": "ngentiang", "label": "Ngentiang", "pincode": "796181" },
  { "value": "piler", "label": "Piler", "pincode": "796181" },
  { "value": "rullam", "label": "Rullam", "pincode": "796310" },
  { "value": "sailulak", "label": "Sailulak", "pincode": "796370" },
  { "value": "serchhip", "label": "Serchhip", "pincode": "796181" },
  { "value": "sialhau", "label": "Sialhau", "pincode": "796181" },
  { "value": "sialsir", "label": "Sialsir", "pincode": "796181" },
  { "value": "thentlang", "label": "Thentlang", "pincode": "796181" },
  { "value": "thenzawl", "label": "Thenzawl", "pincode": "796186" },
  { "value": "thinglian", "label": "Thinglian", "pincode": "796181" },
  { "value": "vancheng", "label": "Vancheng", "pincode": "796181" },
  { "value": "zungleng", "label": "Zungleng", "pincode": "796181" }
  ],

  'hnahthial': [
  { "value": "aithur", "label": "Aithur", "pincode": "796571" },
  { "value": "bualpui-ng", "label": "Bualpui NG", "pincode": "796571" },
  { "value": "chawngtui", "label": "Chawngtui", "pincode": "796571" },
  { "value": "cherhlun", "label": "Cherhlun", "pincode": "796571" },
  { "value": "darzo", "label": "Darzo", "pincode": "796571" },
  { "value": "diltlang", "label": "Diltlang", "pincode": "796571" },
  { "value": "hnahthial", "label": "Hnahthial", "pincode": "796571" },
  { "value": "lungzarhtum", "label": "Lungzarhtum", "pincode": "796571" },
  { "value": "leite", "label": "Leite", "pincode": "796571" },
  { "value": "lungleng-south", "label": "Lungleng South", "pincode": "796571" },
  { "value": "muallianpui", "label": "Muallianpui", "pincode": "796571" },
  { "value": "pangzawl", "label": "Pangzawl", "pincode": "796571" },
  { "value": "rawpui", "label": "Rawpui", "pincode": "796571" },
  { "value": "s-vanlaiphai", "label": "S. Vanlaiphai", "pincode": "796571" },
  { "value": "tarpho", "label": "Tarpho", "pincode": "796571" },
  { "value": "thiltlang", "label": "Thiltlang", "pincode": "796571" },
  { "value": "tuipui-d", "label": "Tuipui D", "pincode": "796571" },
  { "value": "vangte", "label": "Vangte", "pincode": "796571" },
  { "value": "zamual", "label": "Zamual", "pincode": "796571" },
  { "value": "zungtui", "label": "Zungtui", "pincode": "796571" }
],

  'lawngtlai': [
  { "value": "balhlakawn", "label": "Balhlakawn", "pincode": "796891" },
  { "value": "bualpui-n", "label": "Bualpui N", "pincode": "796891" },
  { "value": "bungtlang-s", "label": "Bungtlang S", "pincode": "796891" },
  { "value": "chamdur", "label": "Chamdur", "pincode": "796891" },
  { "value": "cheural", "label": "Cheural", "pincode": "796810" },
  { "value": "diltlang", "label": "Diltlang", "pincode": "796891" },
  { "value": "kamalanagar", "label": "Kamalanagar", "pincode": "796772" },
  { "value": "karlui", "label": "Karlui", "pincode": "796891" },
  { "value": "kawrthah", "label": "Kawrthah", "pincode": "796891" },
  { "value": "kawlchaw-w", "label": "Kawlchaw W", "pincode": "796891" },
  { "value": "lawngtlai", "label": "Lawngtlai", "pincode": "796891" },
  { "value": "lungtian", "label": "Lungtian", "pincode": "796810" },
  { "value": "mampui", "label": "Mampui", "pincode": "796891" },
  { "value": "mualbukawn", "label": "Mualbukawn", "pincode": "796891" },
  { "value": "new-jagnasury", "label": "New Jagnasury", "pincode": "796891" },
  { "value": "ngengpuikai", "label": "Ngengpuikai", "pincode": "796891" },
  { "value": "paithar", "label": "Paithar", "pincode": "796891" },
  { "value": "pangkhua", "label": "Pangkhua", "pincode": "796810" },
  { "value": "parva", "label": "Parva", "pincode": "796891" },
  { "value": "puankhai", "label": "Puankhai", "pincode": "796891" },
  { "value": "rulkual", "label": "Rulkual", "pincode": "796891" },
  { "value": "sabualtlang", "label": "Sabualtlang", "pincode": "796891" },
  { "value": "sangau", "label": "Sangau", "pincode": "796810" },
  { "value": "serhuan", "label": "Serhuan", "pincode": "796891" },
  { "value": "thingkah", "label": "Thingkah", "pincode": "796891" },
  { "value": "tlabung", "label": "Tlabung", "pincode": "796891" },
  { "value": "tuisentlang", "label": "Tuisentlang", "pincode": "796891" },
  { "value": "tuithumhnar", "label": "Tuithumhnar", "pincode": "796891" },
  { "value": "vathuampui", "label": "Vathuampui", "pincode": "796891" },
  { "value": "vengpui", "label": "Vengpui", "pincode": "796891" }
  ],

  'darlawn': [
  { "value": "aizawl-veng", "label": "Aizawl Veng", "pincode": "796111" },
  { "value": "darlawn", "label": "Darlawn", "pincode": "796111" },
  { "value": "khawpuar", "label": "Khawpuar", "pincode": "796111" },
  { "value": "lungzarhtum", "label": "Lungzarhtum", "pincode": "796111" },
  { "value": "lungsum", "label": "Lungsum", "pincode": "796111" },
  { "value": "mauchar", "label": "Mauchar", "pincode": "796111" },
  { "value": "n-serzawl", "label": "N. Serzawl", "pincode": "796111" },
  { "value": "n-tinghmun", "label": "N. Tinghmun", "pincode": "796111" },
  { "value": "new-kawnpui", "label": "New Kawnpui", "pincode": "796111" },
  { "value": "new-vervek", "label": "New Vervek", "pincode": "796111" },
  { "value": "palsang", "label": "Palsang", "pincode": "796111" },
  { "value": "ratu", "label": "Ratu", "pincode": "796111" },
  { "value": "sakawrdai", "label": "Sakawrdai", "pincode": "796111" },
  { "value": "sailutar", "label": "Sailutar", "pincode": "796111" },
  { "value": "thingsat", "label": "Thingsat", "pincode": "796111" },
  { "value": "tualbung", "label": "Tualbung", "pincode": "796111" },
  { "value": "vaitin", "label": "Vaitin", "pincode": "796111" },
  { "value": "vervek", "label": "Vervek", "pincode": "796111" },
  { "value": "zohmun", "label": "Zohmun", "pincode": "796111" }
  ],

  'lengpui': [
  { "value": "bawngkawn-s", "label": "Bawngkawn S", "pincode": "796410" },
  { "value": "dapchhuah", "label": "Dapchhuah", "pincode": "796410" },
  { "value": "hmunpui", "label": "Hmunpui", "pincode": "796421" },
  { "value": "lengpui", "label": "Lengpui", "pincode": "796410" },
  { "value": "lengpui-airport", "label": "Lengpui Airport", "pincode": "796421" },
  { "value": "lungverh", "label": "Lungverh", "pincode": "796410" },
  { "value": "mualkhang", "label": "Mualkhang", "pincode": "796410" },
  { "value": "neihbawih", "label": "Neihbawih", "pincode": "796410" },
  { "value": "puilo", "label": "Puilo", "pincode": "796410" },
  { "value": "ptc-lungverh", "label": "PTC Lungverh", "pincode": "796410" },
  { "value": "rawpuichhip", "label": "Rawpuichhip", "pincode": "796410" },
  { "value": "rulpuihlim", "label": "Rulpuihlim", "pincode": "796410" },
  { "value": "sairang", "label": "Sairang", "pincode": "796410" },
  { "value": "sihphir", "label": "Sihphir", "pincode": "796421" },
  { "value": "thiltlang", "label": "Thiltlang", "pincode": "796410" },
  { "value": "tuidam", "label": "Tuidam", "pincode": "796410" },
  { "value": "vamawih", "label": "Vamawih", "pincode": "796410" },
  { "value": "ziamingthang", "label": "Ziamingthang", "pincode": "796421" }
  ],

  'thenzawl': [
  { "value": "bungtlang-n", "label": "Bungtlang N", "pincode": "796181" },
  { "value": "chekawn", "label": "Chekawn", "pincode": "796181" },
  { "value": "chhiahtlang", "label": "Chhiahtlang", "pincode": "796181" },
  { "value": "chhipphir", "label": "Chhipphir", "pincode": "796181" },
  { "value": "kanghmun-s", "label": "Kanghmun S", "pincode": "796181" },
  { "value": "keitum", "label": "Keitum", "pincode": "796181" },
  { "value": "khawlailung", "label": "Khawlailung", "pincode": "796181" },
  { "value": "lungchhuan", "label": "Lungchhuan", "pincode": "796181" },
  { "value": "lungkawlh", "label": "Lungkawlh", "pincode": "796181" },
  { "value": "lungpho", "label": "Lungpho", "pincode": "796181" },
  { "value": "n-vanlaiphai", "label": "N. Vanlaiphai", "pincode": "796181" },
  { "value": "new-serchhip", "label": "New Serchhip", "pincode": "796181" },
  { "value": "serchhip", "label": "Serchhip", "pincode": "796181" },
  { "value": "thenzawl", "label": "Thenzawl", "pincode": "796186" },
  { "value": "tlangpui", "label": "Tlangpui", "pincode": "796181" },
  { "value": "venghlun", "label": "Venghlun", "pincode": "796181" },
  { "value": "zokhawthar", "label": "Zokhawthar", "pincode": "796181" }
],
 //Meghalaya
 'ampati': [
  { value: 'ampati', label: 'Ampati', pincode: '794115' },
  { value: 'babadam', label: 'Babadam', pincode: '794115' },
  { value: 'balat', label: 'Balat', pincode: '793131' },
  { value: 'dalu', label: 'Dalu', pincode: '794160' },
  { value: 'garo-hills', label: 'Garo Hills', pincode: '794101' },
  { value: 'jongkap', label: 'Jongkap', pincode: '794115' },
  { value: 'kirang', label: 'Kirang', pincode: '794115' },
  { value: 'kolonggre', label: 'Kolonggre', pincode: '794115' },
  { value: 'mara', label: 'Mara', pincode: '794115' },
  { value: 'nangpala', label: 'Nangpala', pincode: '794115' },
  { value: 'nongalbibra', label: 'Nongalbibra', pincode: '794104' },
  { value: 'nongstoin', label: 'Nongstoin', pincode: '793119' },
  { value: 'siju', label: 'Siju', pincode: '794112' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'udalguri', label: 'Udalguri', pincode: '794125' },
  { value: 'williams-nagar', label: 'Williams Nagar', pincode: '794115' },
  ],
  
  'baghmara': [
  { value: 'baghmara', label: 'Baghmara', pincode: '794105' },
  { value: 'balat', label: 'Balat', pincode: '793131' },
  { value: 'dalu', label: 'Dalu', pincode: '794160' },
  { value: 'garo-hills', label: 'Garo Hills', pincode: '794101' },
  { value: 'jengjal', label: 'Jengjal', pincode: '794105' },
  { value: 'jongkap', label: 'Jongkap', pincode: '794115' },
  { value: 'kirang', label: 'Kirang', pincode: '794115' },
  { value: 'mara', label: 'Mara', pincode: '794115' },
  { value: 'nangpala', label: 'Nangpala', pincode: '794115' },
  { value: 'nongalbibra', label: 'Nongalbibra', pincode: '794104' },
  { value: 'nongstoin', label: 'Nongstoin', pincode: '793119' },
  { value: 'siju', label: 'Siju', pincode: '794112' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'udalguri', label: 'Udalguri', pincode: '794125' },
  { value: 'simsanggre', label: 'Simsanggre', pincode: '794105' },
  { value: 'bolegre', label: 'Bolegre', pincode: '794105' },
  { value: 'billang', label: 'Billang', pincode: '794105' },
  { value: 'rongara', label: 'Rongara', pincode: '794105' },
  { value: 'nangalbibra', label: 'Nangalbibra', pincode: '794104' },
  ],
  
  'balat': [
  { value: 'balat', label: 'Balat', pincode: '793131' },
  { value: 'babadam', label: 'Babadam', pincode: '793131' },
  { value: 'dalu', label: 'Dalu', pincode: '794160' },
  { value: 'garo-hills', label: 'Garo Hills', pincode: '794101' },
  { value: 'jongkap', label: 'Jongkap', pincode: '794115' },
  { value: 'kirang', label: 'Kirang', pincode: '794115' },
  { value: 'kherapara', label: 'Kherapara', pincode: '793131' },
  { value: 'mahdal', label: 'Mahdal', pincode: '793131' },
  { value: 'mara', label: 'Mara', pincode: '794115' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '794113' },
  { value: 'nongalbibra', label: 'Nongalbibra', pincode: '794104' },
  { value: 'nongstoin', label: 'Nongstoin', pincode: '793119' },
  { value: 'nangpala', label: 'Nangpala', pincode: '794115' },
  { value: 'phulbari', label: 'Phulbari', pincode: '794106' },
  { value: 'rongara', label: 'Rongara', pincode: '794105' },
  { value: 'siju', label: 'Siju', pincode: '794112' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'williams-nagar', label: 'Williams Nagar', pincode: '794115' },
  { value: 'zomdilla', label: 'Zomdilla', pincode: '793131' },
  ],
  
  'cherrapunji': [
  { value: 'cherrapunji', label: 'Cherrapunji', pincode: '793111' },
  { value: 'diengiei', label: 'Diengiei', pincode: '793111' },
  { value: 'ladmawphlang', label: 'Ladmawphlang', pincode: '793111' },
  { value: 'mawmluh', label: 'Mawmluh', pincode: '793111' },
  { value: 'mawsmai', label: 'Mawsmai', pincode: '793111' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793111' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793110' },
  { value: 'saimsari', label: 'Saimsari', pincode: '793111' },
  { value: 'thangkharang', label: 'Thangkharang', pincode: '793111' },
  { value: 'mawbri', label: 'Mawbri', pincode: '793111' },
  { value: 'madanrting', label: 'Madanrting', pincode: '793111' },
  { value: 'mawsawa', label: 'Mawsawa', pincode: '793111' },
  { value: 'sohra', label: 'Sohra', pincode: '793111' },
  { value: 'shillong', label: 'Shillong', pincode: '793001' },
  { value: 'mynriang', label: 'Mynriang', pincode: '793111' },
  { value: 'nongkrem', label: 'Nongkrem', pincode: '793108' },
  ],
  
  'dalu': [
  { value: 'dalu', label: 'Dalu', pincode: '794160' },
  { value: 'balat', label: 'Balat', pincode: '793131' },
  { value: 'baghmara', label: 'Baghmara', pincode: '794105' },
  { value: 'babadam', label: 'Babadam', pincode: '794115' },
  { value: 'garo-hills', label: 'Garo Hills', pincode: '794101' },
  { value: 'jongkap', label: 'Jongkap', pincode: '794115' },
  { value: 'kirang', label: 'Kirang', pincode: '794115' },
  { value: 'kherapara', label: 'Kherapara', pincode: '794105' },
  { value: 'mara', label: 'Mara', pincode: '794115' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '794113' },
  { value: 'nongalbibra', label: 'Nongalbibra', pincode: '794104' },
  { value: 'nongstoin', label: 'Nongstoin', pincode: '793119' },
  { value: 'siju', label: 'Siju', pincode: '794112' },
  { value: 'rongara', label: 'Rongara', pincode: '794105' },
  { value: 'samsing', label: 'Samsing', pincode: '794110' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'udalguri', label: 'Udalguri', pincode: '794125' },
  { value: 'williams-nagar', label: 'Williams Nagar', pincode: '794115' },
  ],
  
  'east-garo-hills': [
  { value: 'adur', label: 'Adur', pincode: '794105' },
  { value: 'baghmara', label: 'Baghmara', pincode: '794105' },
  { value: 'babadam', label: 'Babadam', pincode: '794115' },
  { value: 'bajengdoba', label: 'Bajengdoba', pincode: '794114' },
  { value: 'dalu', label: 'Dalu', pincode: '794160' },
  { value: 'damalgre', label: 'Damalgre', pincode: '794105' },
  { value: 'daramgre', label: 'Daramgre', pincode: '794110' },
  { value: 'garo-hills', label: 'Garo Hills', pincode: '794101' },
  { value: 'jongkap', label: 'Jongkap', pincode: '794115' },
  { value: 'kirang', label: 'Kirang', pincode: '794115' },
  { value: 'kherapara', label: 'Kherapara', pincode: '794105' },
  { value: 'mara', label: 'Mara', pincode: '794115' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '794113' },
  { value: 'nongalbibra', label: 'Nongalbibra', pincode: '794104' },
  { value: 'nongstoin', label: 'Nongstoin', pincode: '793119' },
  { value: 'rongara', label: 'Rongara', pincode: '794105' },
  { value: 'samsing', label: 'Samsing', pincode: '794110' },
  { value: 'siju', label: 'Siju', pincode: '794112' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'williams-nagar', label: 'Williams Nagar', pincode: '794115' },
  { value: 'chokpot', label: 'Chokpot', pincode: '794108' },
  { value: 'manglad', label: 'Manglad', pincode: '794115' },
  ],
  
  'east-jaintia-hills': [
  { value: 'dawn', label: 'Dawn', pincode: '793210' },
  { value: 'khliehriat', label: 'Khliehriat', pincode: '793210' },
  { value: 'ladrymbai', label: 'Ladrymbai', pincode: '793211' },
  { value: 'sijubari', label: 'Sijubari', pincode: '793210' },
  { value: 'tangmari', label: 'Tangmari', pincode: '793210' },
  { value: 'nirman', label: 'Nirman', pincode: '793211' },
  { value: 'mawsmai', label: 'Mawsmai', pincode: '793210' },
  { value: 'shangpung', label: 'Shangpung', pincode: '793210' },
  { value: 'mynriang', label: 'Mynriang', pincode: '793211' },
  { value: 'umtyneng', label: 'Umtyneng', pincode: '793210' },
  { value: 'khleithiam', label: 'Khleithiam', pincode: '793211' },
  { value: 'shillong', label: 'Shillong', pincode: '793001' },
  { value: 'lumshnong', label: 'Lumshnong', pincode: '793210' },
  { value: 'Nongjri', label: 'Nongjri', pincode: '793210' },
  { value: 'Rymbai', label: 'Rymbai', pincode: '793210' },
  { value: 'Rangthong', label: 'Rangthong', pincode: '793210' },
  { value: 'Jowai', label: 'Jowai', pincode: '793150' },
  { value: 'Laitkseh', label: 'Laitkseh', pincode: '793210' },
  { value: 'Rymbai', label: 'Rymbai', pincode: '793210' },
  { value: 'Tyrshi', label: 'Tyrshi', pincode: '793210' },
  ],
  
  'east-khasi-hills': [
  { value: 'barapathar', label: 'Barapathar', pincode: '793101' },
  { value: 'demthring', label: 'Demthring', pincode: '793001' },
  { value: 'diengpasoh', label: 'Diengpasoh', pincode: '793001' },
  { value: 'ighseng', label: 'Ighseng', pincode: '793001' },
  { value: 'jowai', label: 'Jowai', pincode: '793150' },
  { value: 'ka-mawphlang', label: 'Ka Mawphlang', pincode: '793115' },
  { value: 'mawphlang', label: 'Mawphlang', pincode: '793115' },
  { value: 'mao-pura', label: 'Mao Pura', pincode: '793101' },
  { value: 'mihmyntdu', label: 'Mihmyntdu', pincode: '793110' },
  { value: 'mylliem', label: 'Mylliem', pincode: '793002' },
  { value: 'nongkseh', label: 'Nongkseh', pincode: '793001' },
  { value: 'nongsder', label: 'Nongsder', pincode: '793001' },
  { value: 'nongstoin', label: 'Nongstoin', pincode: '793119' },
  { value: 'plengkha', label: 'Plengkha', pincode: '793001' },
  { value: 'shillong', label: 'Shillong', pincode: '793001' },
  { value: 'umpling', label: 'Umpling', pincode: '793002' },
  { value: 'mawiong', label: 'Mawiong', pincode: '793014' },
  { value: 'umroi', label: 'Umroi', pincode: '793103' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793014' },
  { value: 'lawbah', label: 'Lawbah', pincode: '793110' },
  { value: 'lambrang', label: 'Lambrang', pincode: '793001' },
  { value: 'mawdoh', label: 'Mawdoh', pincode: '793002' },
  ],
  
  'jowai': [
  { value: 'adokgre', label: 'Adokgre', pincode: '793150' },
  { value: 'jongksha', label: 'Jongksha', pincode: '793150' },
  { value: 'khaddum', label: 'Khaddum', pincode: '793150' },
  { value: 'laskor', label: 'Laskor', pincode: '793150' },
  { value: 'mohar', label: 'Mohar', pincode: '793150' },
  { value: 'mynriang', label: 'Mynriang', pincode: '793150' },
  { value: 'nongsari', label: 'Nongsari', pincode: '793150' },
  { value: 'raliang', label: 'Raliang', pincode: '793150' },
  { value: 'shangpung', label: 'Shangpung', pincode: '793150' },
  { value: 'tupbra', label: 'Tupbra', pincode: '793150' },
  { value: 'wintiem', label: 'Wintiem', pincode: '793150' },
  { value: 'barato', label: 'Barato', pincode: '793150' },
  { value: 'dawki', label: 'Dawki', pincode: '793110' },
  { value: 'krang-shnong', label: 'Krang Shnong', pincode: '793150' },
  { value: 'lumshnong', label: 'Lumshnong', pincode: '793210' },
  { value: 'nongbah', label: 'Nongbah', pincode: '793150' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793150' },
  { value: 'tangpud', label: 'Tangpud', pincode: '793150' },
  { value: 'umla', label: 'Umla', pincode: '793150' },
  ],
  
  'jorabat': [
  { value: 'barapathar', label: 'Barapathar', pincode: '793101' },
  { value: 'bataw', label: 'Bataw', pincode: '793102' },
  { value: 'jharnapani', label: 'Jharnapani', pincode: '793101' },
  { value: 'laitlyngkot', label: 'Laitlyngkot', pincode: '793110' },
  { value: 'lawmuthi', label: 'Lawmuthi', pincode: '793110' },
  { value: 'luminous', label: 'Luminous', pincode: '793101' },
  { value: 'mawblang', label: 'Mawblang', pincode: '793101' },
  { value: 'nongpoh', label: 'Nongpoh', pincode: '793102' },
  { value: 'nongsder', label: 'Nongsder', pincode: '793101' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '793102' },
  { value: 'sadar', label: 'Sadar', pincode: '793101' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'dewan', label: 'Dewan', pincode: '793110' },
  { value: 'gaon', label: 'Gaon', pincode: '793101' },
  { value: 'laitkroh', label: 'Laitkroh', pincode: '793102' },
  { value: 'mowtyrshi', label: 'Mowtyrshi', pincode: '793101' },
  { value: 'nongkseh', label: 'Nongkseh', pincode: '793101' },
  { value: 'omshik', label: 'Omshik', pincode: '793102' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793110' }
  ],
  
  'lad-rymbai': [
  { value: 'bholar', label: 'Bholar', pincode: '793210' },
  { value: 'jeldwar', label: 'Jeldwar', pincode: '793210' },
  { value: 'ka-khasi', label: 'Ka Khasi', pincode: '793210' },
  { value: 'lad-rymbai', label: 'Lad Rymbai', pincode: '793210' },
  { value: 'malang', label: 'Malang', pincode: '793210' },
  { value: 'manabari', label: 'Manabari', pincode: '793210' },
  { value: 'maram', label: 'Maram', pincode: '793210' },
  { value: 'nongkhrah', label: 'Nongkhrah', pincode: '793210' },
  { value: 'paham', label: 'Paham', pincode: '793210' },
  { value: 'pynthor', label: 'Pynthor', pincode: '793210' },
  { value: 'shongpung', label: 'Shongpung', pincode: '793210' },
  { value: 'tangmari', label: 'Tangmari', pincode: '793210' },
  { value: 'chambor', label: 'Chambor', pincode: '793210' },
  { value: 'dimalang', label: 'Dimalang', pincode: '793210' },
  { value: 'kharkhana', label: 'Kharkhana', pincode: '793210' },
  { value: 'khamtang', label: 'Khamtang', pincode: '793210' },
  { value: 'labrang', label: 'Labrang', pincode: '793210' },
  { value: 'tangalang', label: 'Tangalang', pincode: '793210' }
  ],
  
  'laitumkhrah': [
  { value: 'bakhra', label: 'Bakhra', pincode: '793003' },
  { value: 'cherry-bagan', label: 'Cherry Bagan', pincode: '793003' },
  { value: 'dornogre', label: 'Dornogre', pincode: '793003' },
  { value: 'laitumkhrah', label: 'Laitumkhrah', pincode: '793003' },
  { value: 'lajong', label: 'Lajong', pincode: '793003' },
  { value: 'mawblei', label: 'Mawblei', pincode: '793003' },
  { value: 'mawpun', label: 'Mawpun', pincode: '793003' },
  { value: 'nongkynrih', label: 'Nongkynrih', pincode: '793003' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793014' },
  { value: 'shillong', label: 'Shillong', pincode: '793003' },
  { value: 'umsohlang', label: 'Umsohlang', pincode: '793003' },
  { value: 'wahadom', label: 'Wahadom', pincode: '793003' },
  { value: 'barapathar', label: 'Barapathar', pincode: '793003' },
  { value: 'khyndailad', label: 'Khyndailad', pincode: '793003' },
  { value: 'lakadong', label: 'Lakadong', pincode: '793003' },
  { value: 'mynriang', label: 'Mynriang', pincode: '793003' },
  { value: 'nongsder', label: 'Nongsder', pincode: '793003' },
  { value: 'sadar', label: 'Sadar', pincode: '793003' },
  { value: 'tura', label: 'Tura', pincode: '794001' }
  ],
  
  'laitkynsew': [
  { value: 'bhalukdubi', label: 'Bhalukdubi', pincode: '793114' },
  { value: 'laitkynsew', label: 'Laitkynsew', pincode: '793114' },
  { value: 'lajong', label: 'Lajong', pincode: '793114' },
  { value: 'mawblang', label: 'Mawblang', pincode: '793114' },
  { value: 'mawsmai', label: 'Mawsmai', pincode: '793114' },
  { value: 'nongpoh', label: 'Nongpoh', pincode: '793114' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793014' },
  { value: 'shangpung', label: 'Shangpung', pincode: '793114' },
  { value: 'umsohlang', label: 'Umsohlang', pincode: '793114' },
  { value: 'wahadom', label: 'Wahadom', pincode: '793114' },
  { value: 'bansiar', label: 'Bansiar', pincode: '793114' },
  { value: 'kyllon', label: 'Kyllon', pincode: '793114' },
  { value: 'lawmusi', label: 'Lawmusi', pincode: '793114' },
  { value: 'mawsynthiang', label: 'Mawsynthiang', pincode: '793114' },
  { value: 'nongdhar', label: 'Nongdhar', pincode: '793114' },
  { value: 'pathaw', label: 'Pathaw', pincode: '793114' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793110' }
  ],
  
  'madanryting': [
  { value: 'diengkain', label: 'Diengkain', pincode: '793103' },
  { value: 'laitlyngkot', label: 'Laitlyngkot', pincode: '793103' },
  { value: 'madanryting', label: 'Madanryting', pincode: '793103' },
  { value: 'mawdiang', label: 'Mawdiang', pincode: '793103' },
  { value: 'mawphlang', label: 'Mawphlang', pincode: '793103' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793014' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793110' },
  { value: 'shangpung', label: 'Shangpung', pincode: '793103' },
  { value: 'umsohlang', label: 'Umsohlang', pincode: '793103' },
  { value: 'wahadom', label: 'Wahadom', pincode: '793103' },
  { value: 'barapathar', label: 'Barapathar', pincode: '793103' },
  { value: 'kharkhana', label: 'Kharkhana', pincode: '793103' },
  { value: 'mawsynthiang', label: 'Mawsynthiang', pincode: '793103' },
  { value: 'nongsder', label: 'Nongsder', pincode: '793103' },
  { value: 'nongdhar', label: 'Nongdhar', pincode: '793103' },
  { value: 'tura', label: 'Tura', pincode: '794001' }
  ],
  
  'mairang': [
  { value: 'adong', label: 'Adong', pincode: '793122' },
  { value: 'bari', label: 'Bari', pincode: '793122' },
  { value: 'bari-khwan', label: 'Bari Khwan', pincode: '793122' },
  { value: 'laitkseh', label: 'Laitkseh', pincode: '793122' },
  { value: 'mairang', label: 'Mairang', pincode: '793122' },
  { value: 'mawbathaw', label: 'Mawbathaw', pincode: '793122' },
  { value: 'mawsmai', label: 'Mawsmai', pincode: '793122' },
  { value: 'mawthurot', label: 'Mawthurot', pincode: '793122' },
  { value: 'nongmynsong', label: 'Nongmynsong', pincode: '793122' },
  { value: 'nonglyngdoh', label: 'Nonglyngdoh', pincode: '793122' },
  { value: 'pathaw', label: 'Pathaw', pincode: '793122' },
  { value: 'shangpung', label: 'Shangpung', pincode: '793122' },
  { value: 'umsohlang', label: 'Umsohlang', pincode: '793122' },
  { value: 'wanshniang', label: 'Wanshniang', pincode: '793122' },
  { value: 'sangsang', label: 'Sangsang', pincode: '793122' },
  { value: 'nongpoh', label: 'Nongpoh', pincode: '793122' },
  { value: 'nonglum', label: 'Nonglum', pincode: '793122' }
  ],
  
  'mawlynnong': [
  { value: 'bomgud', label: 'Bomgud', pincode: '793115' },
  { value: 'laitkynsew', label: 'Laitkynsew', pincode: '793115' },
  { value: 'mawlynnong', label: 'Mawlynnong', pincode: '793115' },
  { value: 'mawbiri', label: 'Mawbiri', pincode: '793115' },
  { value: 'mawsynram', label: 'Mawsynram', pincode: '793112' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793014' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793110' },
  { value: 'shnongpdeng', label: 'Shnongpdeng', pincode: '793115' },
  { value: 'tillipara', label: 'Tillipara', pincode: '793115' },
  { value: 'rongsai', label: 'Rongsai', pincode: '793115' },
  { value: 'mawsamin', label: 'Mawsamin', pincode: '793115' },
  { value: 'phlangdiloin', label: 'Phlangdiloin', pincode: '793115' },
  { value: 'nongbah', label: 'Nongbah', pincode: '793115' },
  { value: 'umden', label: 'Umden', pincode: '793115' },
  { value: 'umsohlang', label: 'Umsohlang', pincode: '793115' }
  ],
  
  'mawphlang': [
  { value: 'dongbah', label: 'Dongbah', pincode: '793115' },
  { value: 'laitlyngkot', label: 'Laitlyngkot', pincode: '793115' },
  { value: 'mawphlang', label: 'Mawphlang', pincode: '793115' },
  { value: 'mawbri', label: 'Mawbri', pincode: '793115' },
  { value: 'mawsmai', label: 'Mawsmai', pincode: '793115' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793014' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793110' },
  { value: 'shnongpdeng', label: 'Shnongpdeng', pincode: '793115' },
  { value: 'tillipara', label: 'Tillipara', pincode: '793115' },
  { value: 'umden', label: 'Umden', pincode: '793115' },
  { value: 'adokgre', label: 'Adokgre', pincode: '793115' },
  { value: 'kiangnong', label: 'Kiangnong', pincode: '793115' },
  { value: 'lumdeng', label: 'Lumdeng', pincode: '793115' },
  { value: 'mawbding', label: 'Mawbding', pincode: '793115' },
  { value: 'nongbah', label: 'Nongbah', pincode: '793115' }
  ],
  
  'mawsynram': [
  { value: 'adokgre', label: 'Adokgre', pincode: '793112' },
  { value: 'dongbah', label: 'Dongbah', pincode: '793112' },
  { value: 'kiangnong', label: 'Kiangnong', pincode: '793112' },
  { value: 'laitlyngkot', label: 'Laitlyngkot', pincode: '793112' },
  { value: 'mawsynram', label: 'Mawsynram', pincode: '793112' },
  { value: 'mawbri', label: 'Mawbri', pincode: '793112' },
  { value: 'mawsmai', label: 'Mawsmai', pincode: '793112' },
  { value: 'nongbah', label: 'Nongbah', pincode: '793112' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793014' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793110' },
  { value: 'shnongpdeng', label: 'Shnongpdeng', pincode: '793112' },
  { value: 'tillipara', label: 'Tillipara', pincode: '793112' },
  { value: 'umden', label: 'Umden', pincode: '793112' },
  { value: 'wanshniang', label: 'Wanshniang', pincode: '793112' },
  { value: 'phlangdiloin', label: 'Phlangdiloin', pincode: '793112' }
  ],
  
  'nongalbibra': [
  { value: 'baghmara', label: 'Baghmara', pincode: '794102' },
  { value: 'balsora', label: 'Balsora', pincode: '794103' },
  { value: 'gittim', label: 'Gittim', pincode: '794103' },
  { value: 'jakhong', label: 'Jakhong', pincode: '794102' },
  { value: 'kormang', label: 'Kormang', pincode: '794102' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '794105' },
  { value: 'nongalbibra', label: 'Nongalbibra', pincode: '794103' },
  { value: 'nongchram', label: 'Nongchram', pincode: '794103' },
  { value: 'shyamnagar', label: 'Shyamnagar', pincode: '794103' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'adokgre', label: 'Adokgre', pincode: '794101' },
  { value: 'dangadiri', label: 'Dangadiri', pincode: '794102' },
  { value: 'dawagre', label: 'Dawagre', pincode: '794101' },
  { value: 'dalu', label: 'Dalu', pincode: '794101' },
  { value: 'sengrim', label: 'Sengrim', pincode: '794103' },
  { value: 'shillang', label: 'Shillang', pincode: '794104' }
  ],
  
  'nongmynsong': [
  { value: 'batsora', label: 'Batsora', pincode: '793105' },
  { value: 'dongkam', label: 'Dongkam', pincode: '793105' },
  { value: 'laitduh', label: 'Laitduh', pincode: '793105' },
  { value: 'mawngap', label: 'Mawngap', pincode: '793105' },
  { value: 'nongmynsong', label: 'Nongmynsong', pincode: '793105' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793105' },
  { value: 'shnongpdeng', label: 'Shnongpdeng', pincode: '793105' },
  { value: 'tillipara', label: 'Tillipara', pincode: '793105' },
  { value: 'adokgre', label: 'Adokgre', pincode: '793105' },
  { value: 'balad', label: 'Balad', pincode: '793105' },
  { value: 'diengpasoh', label: 'Diengpasoh', pincode: '793105' },
  { value: 'lyngngam', label: 'Lyngngam', pincode: '793105' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793110' }
  ],
  
  'nongpoh': [
  { value: 'adokgre', label: 'Adokgre', pincode: '793101' },
  { value: 'balat', label: 'Balat', pincode: '793101' },
  { value: 'barengapara', label: 'Barengapara', pincode: '793102' },
  { value: 'boklapara', label: 'Boklapara', pincode: '793102' },
  { value: 'dhaune', label: 'Dhaune', pincode: '793102' },
  { value: 'dawki', label: 'Dawki', pincode: '793111' },
  { value: 'kharmut', label: 'Kharmut', pincode: '793102' },
  { value: 'mawphlang', label: 'Mawphlang', pincode: '793102' },
  { value: 'nongpoh', label: 'Nongpoh', pincode: '793102' },
  { value: 'nongthymmai', label: 'Nongthymmai', pincode: '793101' },
  { value: 'patharkhmah', label: 'Patharkhmah', pincode: '793102' },
  { value: 'phlangwan', label: 'Phlangwan', pincode: '793102' },
  { value: 'shanbeng', label: 'Shanbeng', pincode: '793102' },
  { value: 'shillong', label: 'Shillong', pincode: '793001' },
  { value: 'syllai', label: 'Syallai', pincode: '793102' },
  { value: 'umlyngka', label: 'Umlyngka', pincode: '793102' },
  { value: 'umkhen', label: 'Umkhen', pincode: '793102' },
  { value: 'wanshniang', label: 'Wanshniang', pincode: '793102' }
  ],
  
  'nongriat': [
  { value: 'baba-ramdev', label: 'Baba Ramdev', pincode: '793109' },
  { value: 'bahal-umran', label: 'Bahal Umran', pincode: '793109' },
  { value: 'diengpasoh', label: 'Diengpasoh', pincode: '793109' },
  { value: 'khongthong', label: 'Khongthong', pincode: '793109' },
  { value: 'mawsmai', label: 'Mawsmai', pincode: '793109' },
  { value: 'nongriat', label: 'Nongriat', pincode: '793109' },
  { value: 'shnongpdeng', label: 'Shnongpdeng', pincode: '793109' },
  { value: 'tad-umran', label: 'Tad Umran', pincode: '793109' },
  { value: 'umkrem', label: 'Umkrem', pincode: '793109' },
  { value: 'lapalang', label: 'Lapalang', pincode: '793109' },
  { value: 'laitkynsew', label: 'Laitkynsew', pincode: '793109' },
  { value: 'lyngdoh', label: 'Lyngdoh', pincode: '793109' },
  { value: 'mawlong', label: 'Mawlong', pincode: '793109' },
  { value: 'nongsder', label: 'Nongsder', pincode: '793109' }
  ],
  
  'nongstoin': [
  { value: 'bajengdoba', label: 'Bajengdoba', pincode: '793119' },
  { value: 'baltimari', label: 'Baltimari', pincode: '793119' },
  { value: 'bongkhalang', label: 'Bongkhalang', pincode: '793119' },
  { value: 'jengjal', label: 'Jengjal', pincode: '793119' },
  { value: 'kangthilangso', label: 'Kangthilangso', pincode: '793119' },
  { value: 'khliehriat', label: 'Khliehriat', pincode: '793119' },
  { value: 'lawbyrtun', label: 'Lawbyrtun', pincode: '793119' },
  { value: 'nongstoin', label: 'Nongstoin', pincode: '793119' },
  { value: 'nyongri', label: 'Nyongri', pincode: '793119' },
  { value: 'phamoi', label: 'Phamoi', pincode: '793119' },
  { value: 'tungbung', label: 'Tungbung', pincode: '793119' },
  { value: 'umthlong', label: 'Umthlong', pincode: '793119' },
  { value: 'wekasik', label: 'Wekasik', pincode: '793119' },
  { value: 'weshara', label: 'Weshara', pincode: '793119' }
  ],
  
  'north-garo-hills': [
  { value: 'adokgre', label: 'Adokgre', pincode: '794102' },
  { value: 'aldor', label: 'Aldor', pincode: '794102' },
  { value: 'ampati', label: 'Ampati', pincode: '794110' },
  { value: 'babadam', label: 'Babadam', pincode: '794111' },
  { value: 'bajengdoba', label: 'Bajengdoba', pincode: '794114' },
  { value: 'dainadubi', label: 'Dainadubi', pincode: '794101' },
  { value: 'dadenggre', label: 'Dadenggre', pincode: '794104' },
  { value: 'dawagre', label: 'Dawagre', pincode: '794101' },
  { value: 'darengre', label: 'Darengre', pincode: '794110' },
  { value: 'kherapara', label: 'Kherapara', pincode: '794113' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '794122' },
  { value: 'nongalbibra', label: 'Nongalbibra', pincode: '794105' },
  { value: 'nongrimbah', label: 'Nongrimbah', pincode: '794110' },
  { value: 'rongara', label: 'Rongara', pincode: '794101' },
  { value: 'sakor', label: 'Sakor', pincode: '794103' },
  { value: 'samanda', label: 'Samanda', pincode: '794105' },
  { value: 'siju', label: 'Siju', pincode: '794102' },
  { value: 'west-agar', label: 'West Agar', pincode: '794102' },
  { value: 'wiliasgre', label: 'Wiliasgre', pincode: '794104' }
  ],
  
  'resubelpara': [
  { value: 'adokgre', label: 'Adokgre', pincode: '794110' },
  { value: 'basupara', label: 'Basupara', pincode: '794110' },
  { value: 'dumdumgre', label: 'Dumdumgre', pincode: '794109' },
  { value: 'katari', label: 'Katari', pincode: '794110' },
  { value: 'khareng', label: 'Khareng', pincode: '794110' },
  { value: 'kusimkol', label: 'Kusimkol', pincode: '794110' },
  { value: 'mawdok', label: 'Mawdok', pincode: '794110' },
  { value: 'ngemwamsing', label: 'Ngemwamsing', pincode: '794110' },
  { value: 'resubelpara', label: 'Resubelpara', pincode: '794110' },
  { value: 'rongjeng', label: 'Rongjeng', pincode: '794110' },
  { value: 'sakho', label: 'Sakho', pincode: '794110' },
  { value: 'baladmara', label: 'Baladmara', pincode: '794110' },
  { value: 'chibinang', label: 'Chibinang', pincode: '794110' },
  { value: 'koinadubi', label: 'Koinadubi', pincode: '794110' },
  { value: 'krangmari', label: 'Krangmari', pincode: '794110' },
  { value: 'nongpoh', label: 'Nongpoh', pincode: '794110' },
  { value: 'nongkrem', label: 'Nongkrem', pincode: '794110' }
  ],
  
  'ri-bhoi': [
  { value: 'barato', label: 'Barato', pincode: '793103' },
  { value: 'diengngan', label: 'Diengngan', pincode: '793102' },
  { value: 'jagiroad', label: 'Jagiroad', pincode: '782410' },
  { value: 'krangshuri', label: 'Krangshuri', pincode: '793103' },
  { value: 'lumbaji', label: 'Lumbaji', pincode: '793102' },
  { value: 'madanreng', label: 'Madanreng', pincode: '793103' },
  { value: 'mawdiangdiang', label: 'Mawdiangdiang', pincode: '793102' },
  { value: 'nongpoh', label: 'Nongpoh', pincode: '793102' },
  { value: 'nongkya', label: 'Nongkya', pincode: '793103' },
  { value: 'phamoi', label: 'Phamoi', pincode: '793102' },
  { value: 'sawkdong', label: 'Sawkdong', pincode: '793103' },
  { value: 'thadlaskein', label: 'Thadlaskein', pincode: '793103' },
  { value: 'birsingh', label: 'Birsingh', pincode: '793104' },
  { value: 'donkamukam', label: 'Donkamukam', pincode: '793101' },
  { value: 'kurung', label: 'Kurung', pincode: '793104' },
  { value: 'laitlyngkot', label: 'Laitlyngkot', pincode: '793101' },
  { value: 'laitkroh', label: 'Laitkroh', pincode: '793101' },
  { value: 'mawblang', label: 'Mawblang', pincode: '793103' },
  { value: 'mokepur', label: 'Mokepur', pincode: '793102' }
  ],
  
  'shillong': [
  { value: 'alderete', label: 'Alderete', pincode: '793001' },
  { value: 'laban', label: 'Laban', pincode: '793004' },
  { value: 'lawmali', label: 'Lawmali', pincode: '793007' },
  { value: 'mahadevpara', label: 'Mahadevpara', pincode: '793002' },
  { value: 'markethotel', label: 'Markethotel', pincode: '793005' },
  { value: 'mohendranagar', label: 'Mohendranagar', pincode: '793009' },
  { value: 'mukherjee', label: 'Mukherjee', pincode: '793003' },
  { value: 'pynthorbah', label: 'Pynthorbah', pincode: '793008' },
  { value: 'rongkhon', label: 'Rongkhon', pincode: '793010' },
  { value: 'sadar', label: 'Sadar', pincode: '793003' },
  { value: 'sewah', label: 'Sewah', pincode: '793011' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'umshing', label: 'Umshing', pincode: '793006' },
  { value: 'wahiajer', label: 'Wahiajer', pincode: '793007' },
  { value: 'westkasi', label: 'West Kasi', pincode: '793012' },
  { value: 'westsillong', label: 'West Shillong', pincode: '793013' }
  ],
  
  'south-garo-hills': [
  { value: 'bonggre', label: 'Bonggre', pincode: '794102' },
  { value: 'chandmary', label: 'Chandmary', pincode: '794104' },
  { value: 'dalu', label: 'Dalu', pincode: '794103' },
  { value: 'diring', label: 'Diring', pincode: '794104' },
  { value: 'dobu', label: 'Dobu', pincode: '794105' },
  { value: 'gara', label: 'Gara', pincode: '794106' },
  { value: 'gamasuli', label: 'Gamasuli', pincode: '794107' },
  { value: 'kasiabari', label: 'Kasiabari', pincode: '794108' },
  { value: 'kherapara', label: 'Kherapara', pincode: '794109' },
  { value: 'nengsang', label: 'Nengsang', pincode: '794109' },
  { value: 'pynursla', label: 'Pynursla', pincode: '794110' },
  { value: 'rongram', label: 'Rongram', pincode: '794111' },
  { value: 'siju', label: 'Siju', pincode: '794112' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'williamsnagar', label: 'Williamsnagar', pincode: '794113' },
  { value: 'dining', label: 'Dining', pincode: '794115' },
  { value: 'babadam', label: 'Babadam', pincode: '794116' },
  { value: 'chibragre', label: 'Chibragre', pincode: '794117' },
  { value: 'garobadha', label: 'Garobadha', pincode: '794118' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '794119' }
  ],
  
  'south-west-garo-hills': [
  { value: 'adokgre', label: 'Adokgre', pincode: '794102' },
  { value: 'amalapara', label: 'Amalapara', pincode: '794101' },
  { value: 'babadam', label: 'Babadam', pincode: '794103' },
  { value: 'bongalgre', label: 'Bongalgre', pincode: '794104' },
  { value: 'dalu', label: 'Dalu', pincode: '794105' },
  { value: 'dobu', label: 'Dobu', pincode: '794106' },
  { value: 'garobadha', label: 'Garobadha', pincode: '794107' },
  { value: 'gamasuli', label: 'Gamasuli', pincode: '794108' },
  { value: 'kasiabari', label: 'Kasiabari', pincode: '794109' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '794110' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '794111' },
  { value: 'nengsang', label: 'Nengsang', pincode: '794112' },
  { value: 'pangma', label: 'Pangma', pincode: '794113' },
  { value: 'rongram', label: 'Rongram', pincode: '794114' },
  { value: 'siju', label: 'Siju', pincode: '794115' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'williamsnagar', label: 'Williamsnagar', pincode: '794116' },
  { value: 'kherapara', label: 'Kherapara', pincode: '794117' },
  { value: 'chongkha', label: 'Chongkha', pincode: '794118' },
  { value: 'dining', label: 'Dining', pincode: '794119' },
  { value: 'rongchugre', label: 'Rongchugre', pincode: '794120' }
  ],
  
  'south-west-khasi-hills': [
  { value: 'bambara', label: 'Bambara', pincode: '793122' },
  { value: 'bholar', label: 'Bholar', pincode: '793121' },
  { value: 'diengngan', label: 'Diengngan', pincode: '793120' },
  { value: 'jowai', label: 'Jowai', pincode: '793150' },
  { value: 'mawiong', label: 'Mawiong', pincode: '793153' },
  { value: 'nongtraw', label: 'Nongtraw', pincode: '793155' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793131' },
  { value: 'rangkynsai', label: 'Rangkynsai', pincode: '793157' },
  { value: 'shillong', label: 'Shillong', pincode: '793001' },
  { value: 'sotngat', label: 'Sotngat', pincode: '793160' },
  { value: 'tuberkmar', label: 'Tuberkmar', pincode: '793156' },
  { value: 'umkhen', label: 'Umkhen', pincode: '793158' },
  { value: 'mawphlang', label: 'Mawphlang', pincode: '793122' },
  { value: 'wymman', label: 'Wymman', pincode: '793161' },
  { value: 'syllang', label: 'Syllang', pincode: '793159' },
  { value: 'ladmawphlang', label: 'Ladmawphlang', pincode: '793123' },
  { value: 'mawsynram', label: 'Mawsynram', pincode: '793151' },
  { value: 'mangra', label: 'Mangra', pincode: '793152' }
  ],
  
  'tura': [
  { value: 'adarpara', label: 'Adarpara', pincode: '794001' },
  { value: 'babadam', label: 'Babadam', pincode: '794002' },
  { value: 'bongalgre', label: 'Bongalgre', pincode: '794003' },
  { value: 'chibinang', label: 'Chibinang', pincode: '794004' },
  { value: 'chokpot', label: 'Chokpot', pincode: '794016' },
  { value: 'dalu', label: 'Dalu', pincode: '794005' },
  { value: 'dobu', label: 'Dobu', pincode: '794006' },
  { value: 'garobadha', label: 'Garobadha', pincode: '794007' },
  { value: 'gamasuli', label: 'Gamasuli', pincode: '794008' },
  { value: 'jengjal', label: 'Jengjal', pincode: '794017' },
  { value: 'kasiabari', label: 'Kasiabari', pincode: '794009' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '794010' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '794011' },
  { value: 'nengsang', label: 'Nengsang', pincode: '794012' },
  { value: 'rongram', label: 'Rongram', pincode: '794013' },
  { value: 'siju', label: 'Siju', pincode: '794014' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'williamsnagar', label: 'Williamsnagar', pincode: '794015' },
  { value: 'dining', label: 'Dining', pincode: '794018' },
  { value: 'chokchokia', label: 'Chokchokia', pincode: '794019' },
  { value: 'rongsak', label: 'Rongsak', pincode: '794020' },
  { value: 'balwakgre', label: 'Balwakgre', pincode: '794021' },
  { value: 'tura-rangblang', label: 'Tura Rangblang', pincode: '794022' }
  ],
  
  'west-garo-hills': [
  { value: 'adarpara', label: 'Adarpara', pincode: '794001' },
  { value: 'babadam', label: 'Babadam', pincode: '794002' },
  { value: 'bongalgre', label: 'Bongalgre', pincode: '794003' },
  { value: 'chibinang', label: 'Chibinang', pincode: '794004' },
  { value: 'chokpot', label: 'Chokpot', pincode: '794017' },
  { value: 'dalu', label: 'Dalu', pincode: '794005' },
  { value: 'dobu', label: 'Dobu', pincode: '794006' },
  { value: 'garobadha', label: 'Garobadha', pincode: '794007' },
  { value: 'gamasuli', label: 'Gamasuli', pincode: '794008' },
  { value: 'jengjal', label: 'Jengjal', pincode: '794009' },
  { value: 'kasiabari', label: 'Kasiabari', pincode: '794018' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '794010' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '794011' },
  { value: 'nengsang', label: 'Nengsang', pincode: '794012' },
  { value: 'pangneng', label: 'Pangneng', pincode: '794019' },
  { value: 'pongtung', label: 'Pongtung', pincode: '794013' },
  { value: 'rongram', label: 'Rongram', pincode: '794014' },
  { value: 'siju', label: 'Siju', pincode: '794015' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'williamsnagar', label: 'Williamsnagar', pincode: '794016' },
  { value: 'tura-rangblang', label: 'Tura Rangblang', pincode: '794020' },
  { value: 'balwakgre', label: 'Balwakgre', pincode: '794021' },
  { value: 'rongchugre', label: 'Rongchugre', pincode: '794022' }
  ],
  
  'west-jaintia-hills': [
  { value: 'adokgre', label: 'Adokgre', pincode: '793110' },
  { value: 'bynther', label: 'Bynther', pincode: '793120' },
  { value: 'dienglieng', label: 'Dienglieng', pincode: '793121' },
  { value: 'jatilla', label: 'Jatilla', pincode: '793122' },
  { value: 'lasken', label: 'Lasken', pincode: '793123' },
  { value: 'lyngkhat', label: 'Lyngkhat', pincode: '793124' },
  { value: 'muktapur', label: 'Muktapur', pincode: '793125' },
  { value: 'nartiang', label: 'Nartiang', pincode: '793126' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793127' },
  { value: 'raliang', label: 'Raliang', pincode: '793128' },
  { value: 'tangmang', label: 'Tangmang', pincode: '793129' },
  { value: 'thadlaskein', label: 'Thadlaskein', pincode: '793130' },
  { value: 'thlaper', label: 'Thlaper', pincode: '793131' },
  { value: 'wekas', label: 'Wekas', pincode: '793132' },
  { value: 'shangpung', label: 'Shangpung', pincode: '793133' },
  { value: 'mukhla', label: 'Mukhla', pincode: '793134' },
  { value: 'cherapunjee', label: 'Cherapunjee', pincode: '793135' },
  { value: 'mawdlang', label: 'Mawdlang', pincode: '793136' },
  { value: 'sumer', label: 'Sumer', pincode: '793137' },
  { value: 'laitlyngkot', label: 'Laitlyngkot', pincode: '793138' },
  { value: 'tahkhul', label: 'Tahkhul', pincode: '793139' }
  ],
  
  'west-khasi-hills': [
  { value: 'adokgre', label: 'Adokgre', pincode: '793110' },
  { value: 'bapung', label: 'Bapung', pincode: '793111' },
  { value: 'dalu', label: 'Dalu', pincode: '793112' },
  { value: 'diengngan', label: 'Diengngan', pincode: '793113' },
  { value: 'jowai', label: 'Jowai', pincode: '793150' },
  { value: 'khliehriat', label: 'Khliehriat', pincode: '793151' },
  { value: 'laitnongrim', label: 'Laitnongrim', pincode: '793152' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '793114' },
  { value: 'nongstoin', label: 'Nongstoin', pincode: '793119' },
  { value: 'pynursla', label: 'Pynursla', pincode: '793131' },
  { value: 'rambrai', label: 'Rambrai', pincode: '793115' },
  { value: 'rongra', label: 'Rongra', pincode: '793116' },
  { value: 'saflong', label: 'Saflong', pincode: '793117' },
  { value: 'sumer', label: 'Sumer', pincode: '793118' },
  { value: 'tura', label: 'Tura', pincode: '794001' },
  { value: 'west-khasi-hills', label: 'West Khasi Hills', pincode: '793120' },
  { value: 'mawsynram', label: 'Mawsynram', pincode: '793153' },
  { value: 'pahamsyiem', label: 'Pahamsyiem', pincode: '793154' },
  { value: 'tahkhiew', label: 'Tahkhiew', pincode: '793155' },
  { value: 'laimukhian', label: 'Laimukhian', pincode: '793156' },
  { value: 'shangpung', label: 'Shangpung', pincode: '793157' }
  ],
  
  'williamnagar': [
  { value: 'adarpara', label: 'Adarpara', pincode: '794001' },
  { value: 'balwakgre', label: 'Balwakgre', pincode: '794002' },
  { value: 'bongalgre', label: 'Bongalgre', pincode: '794003' },
  { value: 'chereng', label: 'Chereng', pincode: '794004' },
  { value: 'dobu', label: 'Dobu', pincode: '794005' },
  { value: 'garobadha', label: 'Garobadha', pincode: '794006' },
  { value: 'jengjal', label: 'Jengjal', pincode: '794007' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '794008' },
  { value: 'mendipathar', label: 'Mendipathar', pincode: '794009' },
  { value: 'pangneng', label: 'Pangneng', pincode: '794010' },
  { value: 'pongtung', label: 'Pongtung', pincode: '794011' },
  { value: 'rongram', label: 'Rongram', pincode: '794012' },
  { value: 'siju', label: 'Siju', pincode: '794013' },
  { value: 'tura', label: 'Tura', pincode: '794014' },
  { value: 'williamnagar', label: 'Williamnagar', pincode: '794001' },
  { value: 'chokpot', label: 'Chokpot', pincode: '794015' },
  { value: 'dalu', label: 'Dalu', pincode: '794016' },
  { value: 'nengsang', label: 'Nengsang', pincode: '794017' },
  { value: 'pangbat', label: 'Pangbat', pincode: '794018' },
  { value: 'rongchugre', label: 'Rongchugre', pincode: '794019' },
  { value: 'balwakgre-b', label: 'Balwakgre B', pincode: '794020' }
  ],
  
  //Jharkhand areas
  'jamshedpur': [
    { value: 'adityapur', label: 'Adityapur', pincode: '831013' },
    { value: 'baridih', label: 'Baridih', pincode: '831017' },
    { value: 'birsanagar', label: 'Birsanagar', pincode: '831019' },
    { value: 'bistupur', label: 'Bistupur', pincode: '831001' },
    { value: 'chakulia', label: 'Chakulia', pincode: '832301' },
    { value: 'dimna', label: 'Dimna', pincode: '831018' },
    { value: 'golmuri', label: 'Golmuri', pincode: '831003' },
    { value: 'govindpur', label: 'Govindpur', pincode: '831015' },
    { value: 'jadugora', label: 'Jadugora', pincode: '832102' },
    { value: 'kadma', label: 'Kadma', pincode: '831005' },
    { value: 'kitadih', label: 'Kitadih', pincode: '831002' },
    { value: 'mango', label: 'Mango', pincode: '831012' },
    { value: 'parsudih', label: 'Parsudih', pincode: '831002' },
    { value: 'rahargora', label: 'Rahargora', pincode: '831016' },
    { value: 'sakchi', label: 'Sakchi', pincode: '831001' },
    { value: 'sidhgora', label: 'Sidhgora', pincode: '831009' },
    { value: 'sonari', label: 'Sonari', pincode: '831011' },
    { value: 'sundernagar', label: 'Sundernagar', pincode: '832107' },
    { value: 'telco', label: 'Telco', pincode: '831004' }
    ],
  
  
    'palamu': [
    { value: 'aurangabad', label: 'Aurangabad', pincode: '822101' },
    { value: 'bishrampur', label: 'Bishrampur', pincode: '822124' },
    { value: 'chainpur', label: 'Chainpur', pincode: '822110' },
    { value: 'chhatarpur', label: 'Chhatarpur', pincode: '822113' },
    { value: 'daltonganj', label: 'Daltonganj', pincode: '822101' },
    { value: 'garhwa', label: 'Garhwa', pincode: '822114' },
    { value: 'haidernagar', label: 'Haidernagar', pincode: '822131' },
    { value: 'hussainabad', label: 'Hussainabad', pincode: '822116' },
    { value: 'kabri', label: 'Kabri', pincode: '822102' },
    { value: 'kalapahar', label: 'Kalapahar', pincode: '822122' },
    { value: 'kesura', label: 'Kesura', pincode: '822123' },
    { value: 'lesliganj', label: 'Lesliganj', pincode: '822118' },
    { value: 'manatu', label: 'Manatu', pincode: '822120' },
    { value: 'naudeeha', label: 'Naudeeha', pincode: '822115' },
    { value: 'nilamber-pitamberpur', label: 'Nilamber Pitamberpur', pincode: '822128' },
    { value: 'panki', label: 'Panki', pincode: '822122' },
    { value: 'pipra', label: 'Pipra', pincode: '822121' },
    { value: 'rehla', label: 'Rehla', pincode: '822124' },
    { value: 'satbarwa', label: 'Satbarwa', pincode: '822126' },
    { value: 'tarhasi', label: 'Tarhasi', pincode: '822112' }
    ],
  
'kathara': [
  { value: 'bariwas', label: 'Bariwas', pincode: '825327' },
  { value: 'chandpur', label: 'Chandpur', pincode: '825328' },
  { value: 'dhelwa', label: 'Dhelwa', pincode: '825329' },
  { value: 'kathara-town', label: 'Kathara Town', pincode: '825326' },
  { value: 'kherwar', label: 'Kherwar', pincode: '825325' },
  { value: 'khewar', label: 'Khewar', pincode: '825324' },
  { value: 'kudhani', label: 'Kudhani', pincode: '825323' },
  { value: 'lohara', label: 'Lohara', pincode: '825322' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '825323' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '825320' },
  { value: 'nangal', label: 'Nangal', pincode: '825324' },
  { value: 'rauri', label: 'Rauri', pincode: '825321' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '825330' },
  { value: 'sahuwas', label: 'Sahuwas', pincode: '825331' },
  { value: 'sulaipur', label: 'Sulaipur', pincode: '825332' },
  { value: 'taura', label: 'Taura', pincode: '825333' },
  { value: 'tulsi', label: 'Tulsi', pincode: '825334' },
  { value: 'vishwas', label: 'Vishwas', pincode: '825335' }
  ],

  'khalari': [
  { value: 'adampur', label: 'Adampur', pincode: '825402' },
  { value: 'bariwas', label: 'Bariwas', pincode: '825403' },
  { value: 'chakri', label: 'Chakri', pincode: '825404' },
  { value: 'dhelwa', label: 'Dhelwa', pincode: '825405' },
  { value: 'khalari-town', label: 'Khalari Town', pincode: '825406' },
  { value: 'kherwar', label: 'Kherwar', pincode: '825407' },
  { value: 'kori', label: 'Kori', pincode: '825408' },
  { value: 'lohara', label: 'Lohara', pincode: '825409' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '825410' },
  { value: 'manpur', label: 'Manpur', pincode: '825417' },
  { value: 'nangal', label: 'Nangal', pincode: '825411' },
  { value: 'rauri', label: 'Rauri', pincode: '825412' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '825413' },
  { value: 'siwani', label: 'Siwani', pincode: '825414' },
  { value: 'taura', label: 'Taura', pincode: '825415' },
  { value: 'tulsi', label: 'Tulsi', pincode: '825418' },
  { value: 'vishwas', label: 'Vishwas', pincode: '825416' },
  { value: 'wanwari', label: 'Wanwari', pincode: '825419' },
  { value: 'zainpur', label: 'Zainpur', pincode: '825420' }
  ],

'giridih': [
  { value: 'bengabad', label: 'Bengabad', pincode: '815312' },
  { value: 'chirudih', label: 'Chirudih', pincode: '815313' },
  { value: 'dhaiya', label: 'Dhaiya', pincode: '815304' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'giridih-town', label: 'Giridih Town', pincode: '815301' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jasaudih', label: 'Jasaudih', pincode: '815315' },
  { value: 'kharagdiha', label: 'Kharagdiha', pincode: '815311' },
  { value: 'mohammadganj', label: 'Mohammadganj', pincode: '815320' },
  { value: 'pirtand', label: 'Pirtand', pincode: '815324' },
  { value: 'rajdhanwar', label: 'Rajdhanwar', pincode: '815332' },
  { value: 'salkhan', label: 'Salkhan', pincode: '815325' },
  { value: 'tundi', label: 'Tundi', pincode: '815318' },
  { value: 'tilaiya', label: 'Tilaiya', pincode: '825323' }
  ],

  'ramgarh-cantonment': [
  { value: 'asnad', label: 'Asnad', pincode: '829122' },
  { value: 'bangalore', label: 'Bangalore', pincode: '829127' },
  { value: 'bariatu', label: 'Bariatu', pincode: '829117' },
  { value: 'chhota', label: 'Chhota', pincode: '829121' },
  { value: 'dumri', label: 'Dumri', pincode: '829134' },
  { value: 'ghaghra', label: 'Ghaghra', pincode: '829120' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'kesar', label: 'Kesar', pincode: '829115' },
  { value: 'khunti', label: 'Khunti', pincode: '829132' },
  { value: 'ramgarh-cantonment', label: 'Ramgarh Cantonment', pincode: '829122' },
  { value: 'ramgarh-town', label: 'Ramgarh Town', pincode: '829119' },
  { value: 'sindri', label: 'Sindri', pincode: '829126' },
  { value: 'tilaiya', label: 'Tilaiya', pincode: '829125' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kandra', label: 'Kandra', pincode: '829125' },
  { value: 'belatand', label: 'Belatand', pincode: '829133' }
  ],

  'chirkunda': [
  { value: 'banskera', label: 'Banskera', pincode: '828202' },
  { value: 'barora', label: 'Barora', pincode: '828301' },
  { value: 'chirkunda-cantonment', label: 'Chirkunda Cantonment', pincode: '828202' },
  { value: 'chirkunda-town', label: 'Chirkunda Town', pincode: '828202' },
  { value: 'jharia', label: 'Jharia', pincode: '828205' },
  { value: 'katras', label: 'Katras', pincode: '828114' },
  { value: 'kusumgram', label: 'Kusumgram', pincode: '828205' },
  { value: 'madhuban', label: 'Madhuban', pincode: '828201' },
  { value: 'sarubera', label: 'Sarubera', pincode: '828107' },
  { value: 'shyamdih', label: 'Shyamdih', pincode: '828205' },
  { value: 'tundi', label: 'Tundi', pincode: '828213' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '828401' },
  { value: 'bhelatand', label: 'Bhelatand', pincode: '828216' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '828205' },
  { value: 'kenduadih', label: 'Kenduadih', pincode: '828205' },
  { value: 'barkakana', label: 'Barkakana', pincode: '828101' }
  ],

  'phusro': [
  { value: 'baghmara', label: 'Baghmara', pincode: '829118' },
  { value: 'barakar', label: 'Barakar', pincode: '828114' },
  { value: 'bhaga', label: 'Bhaga', pincode: '828112' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '828401' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'kusumgram', label: 'Kusumgram', pincode: '828201' },
  { value: 'madhuban', label: 'Madhuban', pincode: '828201' },
  { value: 'phusro-cantonment', label: 'Phusro Cantonment', pincode: '829144' },
  { value: 'phusro-town', label: 'Phusro Town', pincode: '829144' },
  { value: 'patherdih', label: 'Patherdih', pincode: '828116' },
  { value: 'sarubera', label: 'Sarubera', pincode: '828107' },
  { value: 'tundi', label: 'Tundi', pincode: '828213' },
  { value: 'bhelatand', label: 'Bhelatand', pincode: '828216' },
  { value: 'bhuli', label: 'Bhuli', pincode: '828104' },
  { value: 'kasmar', label: 'Kasmar', pincode: '828116' },
  { value: 'kendudih', label: 'Kendudih', pincode: '828113' },
  { value: 'rajganj', label: 'Rajganj', pincode: '829101' },
  { value: 'sindri', label: 'Sindri', pincode: '828126' }
  ],

  'jhumri-telaiya': [
    { value: 'barhi', label: 'Barhi', pincode: '825405' },
  { value: 'bariyatu', label: 'Bariyatu', pincode: '825409' },
  { value: 'dadi', label: 'Dadi', pincode: '825409' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'jhumri-telaiya', label: 'Jhumri Telaiya', pincode: '825409' },
  { value: 'kenduadih', label: 'Kenduadih', pincode: '825409' },
  { value: 'kumhartoli', label: 'Kumhartoli', pincode: '825406' },
  { value: 'maharajganj', label: 'Maharajganj', pincode: '825412' },
  { value: 'panchra', label: 'Panchra', pincode: '825401' },
  { value: 'pirtand', label: 'Pirtand', pincode: '825413' },
  { value: 'sama', label: 'Sama', pincode: '825408' },
  { value: 'tundi', label: 'Tundi', pincode: '825412' },
  { value: 'udhwa', label: 'Udhwa', pincode: '825405' },
  { value: 'chandwara', label: 'Chandwara', pincode: '825409' },
  { value: 'khukhra', label: 'Khukhra', pincode: '825411' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '825409' }
  ],

  'godda': [
  { value: 'bariyatu', label: 'Bariyatu', pincode: '814133' },
  { value: 'chandana', label: 'Chandana', pincode: '814148' },
  { value: 'godda-town', label: 'Godda Town', pincode: '814133' },
  { value: 'ghoghri', label: 'Ghoghri', pincode: '814137' },
  { value: 'khirja', label: 'Khirja', pincode: '814136' },
  { value: 'kundhit', label: 'Kundhit', pincode: '814133' },
  { value: 'kustore', label: 'Kustore', pincode: '814160' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '814146' },
  { value: 'nepalganj', label: 'Nepalganj', pincode: '814147' },
  { value: 'pachamba', label: 'Pachamba', pincode: '814147' },
  { value: 'rajganj', label: 'Rajganj', pincode: '814128' },
  { value: 'sinduriya', label: 'Sinduriya', pincode: '814139' },
  { value: 'udayan', label: 'Udayan', pincode: '814140' },
  { value: 'rajbaria', label: 'Rajbaria', pincode: '814142' },
  { value: 'bakhri', label: 'Bakhri', pincode: '814155' },
  { value: 'jhitki', label: 'Jhitki', pincode: '814149' },
  { value: 'palamu', label: 'Palamu', pincode: '814150' }
  ],

  'lohardaga': [
  { value: 'bagdu', label: 'Bagdu', pincode: '835302' },
  { value: 'bano', label: 'Bano', pincode: '835201' },
  { value: 'bishunpur', label: 'Bishunpur', pincode: '835206' },
  { value: 'chainpur', label: 'Chainpur', pincode: '835212' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'ghusri', label: 'Ghusri', pincode: '835302' },
  { value: 'lohardaga-town', label: 'Lohardaga Town', pincode: '835302' },
  { value: 'manika', label: 'Manika', pincode: '835213' },
  { value: 'naudiha', label: 'Naudiha', pincode: '835206' },
  { value: 'salaiya', label: 'Salaiya', pincode: '835202' },
  { value: 'serengda', label: 'Serengda', pincode: '835203' },
  { value: 'taherpur', label: 'Taherpur', pincode: '835213' },
  { value: 'barwadih', label: 'Barwadih', pincode: '835219' },
  { value: 'kesharwan', label: 'Kesharwan', pincode: '835204' },
  { value: 'sindri', label: 'Sindri', pincode: '835207' },
  { value: 'chandwa', label: 'Chandwa', pincode: '835213' }
  ],

  'adityapur': [
  { value: 'adityapur-i', label: 'Adityapur I', pincode: '832109' },
  { value: 'adityapur-ii', label: 'Adityapur II', pincode: '832110' },
  { value: 'ghatakesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'kadma', label: 'Kadma', pincode: '832113' },
  { value: 'kandra', label: 'Kandra', pincode: '832107' },
  { value: 'kashidih', label: 'Kashidih', pincode: '832107' },
  { value: 'kumardih', label: 'Kumardih', pincode: '832109' },
  { value: 'mango', label: 'Mango', pincode: '832110' },
  { value: 'sagunia', label: 'Sagunia', pincode: '832104' },
  { value: 'sonari', label: 'Sonari', pincode: '832107' },
  { value: 'tata-steel-township', label: 'Tata Steel Township', pincode: '832107' },
  { value: 'bistupur', label: 'Bistupur', pincode: '832113' },
  { value: 'dhalbhumgarh', label: 'Dhalbhumgarh', pincode: '832302' },
  { value: 'jugsalai', label: 'Jugsalai', pincode: '832102' },
  { value: 'gamharia', label: 'Gamharia', pincode: '832108' },
  { value: 'sitaramdera', label: 'Sitaramdera', pincode: '832107' },
  { value: 'kuchai', label: 'Kuchai', pincode: '832305' }
  ],

  'khunti': [
  { value: 'adki', label: 'Adki', pincode: '835210' },
  { value: 'bunda', label: 'Bunda', pincode: '835211' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'khunti-town', label: 'Khunti Town', pincode: '835210' },
  { value: 'kutul', label: 'Kutul', pincode: '835211' },
  { value: 'murhu', label: 'Murhu', pincode: '835216' },
  { value: 'namkum', label: 'Namkum', pincode: '834010' },
  { value: 'rajarappa', label: 'Rajarappa', pincode: '835210' },
  { value: 'sarwan', label: 'Sarwan', pincode: '835216' },
  { value: 'torpa', label: 'Torpa', pincode: '835204' },
  { value: 'tamar', label: 'Tamar', pincode: '835225' },
  { value: 'bahubazar', label: 'Bahubazar', pincode: '835216' },
  { value: 'besra', label: 'Besra', pincode: '835211' },
  { value: 'fadi', label: 'Fadi', pincode: '835210' },
  { value: 'garu', label: 'Garu', pincode: '835211' },
  { value: 'kudil', label: 'Kudil', pincode: '835217' },
  { value: 'latratu', label: 'Latratu', pincode: '835204' }
  ],

  'latehar': [
  { value: 'barwadih', label: 'Barwadih', pincode: '835219' },
  { value: 'chakla', label: 'Chakla', pincode: '835221' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'kathalia', label: 'Kathalia', pincode: '835220' },
  { value: 'khunti', label: 'Khunti', pincode: '835210' },
  { value: 'latehar-town', label: 'Latehar Town', pincode: '835302' },
  { value: 'manika', label: 'Manika', pincode: '835220' },
  { value: 'norway', label: 'Norway', pincode: '835212' },
  { value: 'pindrajora', label: 'Pindrajora', pincode: '835212' },
  { value: 'tamar', label: 'Tamar', pincode: '835225' },
  { value: 'tariyatu', label: 'Tariyatu', pincode: '835219' },
  { value: 'banka', label: 'Banka', pincode: '835215' },
  { value: 'kisko', label: 'Kisko', pincode: '835219' },
  { value: 'laria', label: 'Laria', pincode: '835211' },
  { value: 'topa', label: 'Topa', pincode: '835222' },
  { value: 'khajuri', label: 'Khajuri', pincode: '835223' }
  ],

  'mango': [
  { value: 'birsanagar', label: 'Birsanagar', pincode: '832108' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'golmuri', label: 'Golmuri', pincode: '832103' },
  { value: 'jhunjhunu', label: 'Jhunjhunu', pincode: '832110' },
  { value: 'kadma', label: 'Kadma', pincode: '832113' },
  { value: 'kashidih', label: 'Kashidih', pincode: '832107' },
  { value: 'mango-town', label: 'Mango Town', pincode: '832110' },
  { value: 'sonari', label: 'Sonari', pincode: '832107' },
  { value: 'tata-steel-township', label: 'Tata Steel Township', pincode: '832107' },
  { value: 'voltas-nagar', label: 'Voltas Nagar', pincode: '832113' },
  { value: 'dhatkidih', label: 'Dhatkidih', pincode: '832109' },
  { value: 'new-plot', label: 'New Plot', pincode: '832110' },
  { value: 'old-plot', label: 'Old Plot', pincode: '832111' },
  { value: 'shankarpur', label: 'Shankarpur', pincode: '832108' },
  { value: 'ulidih', label: 'Ulidih', pincode: '832103' },
  { value: 'karmalichak', label: 'Karmalichak', pincode: '832107' }
  ],

  'garhwa': [
  { value: 'adki', label: 'Adki', pincode: '822116' },
  { value: 'chhipadohar', label: 'Chhipadohar', pincode: '822118' },
  { value: 'garhwa-town', label: 'Garhwa Town', pincode: '822114' },
  { value: 'gharwa-rural', label: 'Garhwa Rural', pincode: '822116' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'kandra', label: 'Kandra', pincode: '822109' },
  { value: 'kuchai', label: 'Kuchai', pincode: '822115' },
  { value: 'manika', label: 'Manika', pincode: '822117' },
  { value: 'nagar-union', label: 'Nagar Union', pincode: '822118' },
  { value: 'rangamati', label: 'Rangamati', pincode: '822115' },
  { value: 'tariyatu', label: 'Tariyatu', pincode: '822110' },
  { value: 'banka', label: 'Banka', pincode: '822109' },
  { value: 'bhandariya', label: 'Bhandariya', pincode: '822118' },
  { value: 'kharkhari', label: 'Kharkhari', pincode: '822111' },
  { value: 'sindri', label: 'Sindri', pincode: '822113' },
  { value: 'dumar', label: 'Dumar', pincode: '822112' }
  ],

  'pakur': [
  { value: 'balia', label: 'Balia', pincode: '816104' },
  { value: 'barkatpur', label: 'Barkatpur', pincode: '816103' },
  { value: 'baranjora', label: 'Baranjora', pincode: '816102' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'jitpur', label: 'Jitpur', pincode: '816107' },
  { value: 'kashipur', label: 'Kashipur', pincode: '816107' },
  { value: 'latabari', label: 'Latabari', pincode: '816104' },
  { value: 'murarai', label: 'Murarai', pincode: '816106' },
  { value: 'pakur-town', label: 'Pakur Town', pincode: '816107' },
  { value: 'samsabad', label: 'Samsabad', pincode: '816106' },
  { value: 'sandeshwari', label: 'Sandeshwari', pincode: '816108' },
  { value: 'tata-nagar', label: 'Tata Nagar', pincode: '816108' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '816106' },
  { value: 'ramganj', label: 'Ramganj', pincode: '816105' },
  { value: 'kunditola', label: 'Kunditola', pincode: '816109' },
  { value: 'dhanara', label: 'Dhanara', pincode: '816102' }
],
  
  'sirka': [
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'govindpur', label: 'Govindpur', pincode: '828109' },
  { value: 'jamua', label: 'Jamua', pincode: '828204' },
  { value: 'khukhundu', label: 'Khukhundu', pincode: '828204' },
  { value: 'kumardaha', label: 'Kumardaha', pincode: '828202' },
  { value: 'madhupur', label: 'Madhupur', pincode: '828130' },
  { value: 'malka', label: 'Malka', pincode: '828204' },
  { value: 'panditpur', label: 'Panditpur', pincode: '828202' },
  { value: 'sirka-town', label: 'Sirka Town', pincode: '828204' },
  { value: 'tara-mohalla', label: 'Tara Mohalla', pincode: '828204' },
  { value: 'bazar-kendua', label: 'Bazar Kendua', pincode: '828205' },
  { value: 'birni', label: 'Birni', pincode: '828205' },
  { value: 'dhelai', label: 'Dhelai', pincode: '828130' },
  { value: 'dhura', label: 'Dhura', pincode: '828210' },
  { value: 'rajauli', label: 'Rajauli', pincode: '828210' },
  { value: 'singheshwar', label: 'Singheshwar', pincode: '828201' }
  ],

  'siuliban': [
  { value: 'banra', label: 'Banra', pincode: '832103' },
  { value: 'barahara', label: 'Barahara', pincode: '832104' },
  { value: 'dharmapuri', label: 'Dharmapuri', pincode: '832105' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'jaidih', label: 'Jaidih', pincode: '832106' },
  { value: 'kormadih', label: 'Kormadih', pincode: '832107' },
  { value: 'kumardaha', label: 'Kumardaha', pincode: '832108' },
  { value: 'sikidih', label: 'Sikidih', pincode: '832109' },
  { value: 'siuliban-town', label: 'Siuliban Town', pincode: '832110' },
  { value: 'tulsiabad', label: 'Tulsiabad', pincode: '832111' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '832112' },
  { value: 'nawadih', label: 'Nawadih', pincode: '832113' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '832114' },
  { value: 'belatand', label: 'Belatand', pincode: '832115' },
  { value: 'bansdih', label: 'Bansdih', pincode: '832116' },
  { value: 'pahar-tola', label: 'Pahar Tola', pincode: '832117' }
  ],
  
  'bermo': [
  { value: 'badam', label: 'Badam', pincode: '829104' },
  { value: 'bermo-town', label: 'Bermo Town', pincode: '829104' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'kandra', label: 'Kandra', pincode: '829206' },
  { value: 'kudgaon', label: 'Kudgaon', pincode: '829301' },
  { value: 'mahuda', label: 'Mahuda', pincode: '829107' },
  { value: 'madhuban', label: 'Madhuban', pincode: '829105' },
  { value: 'mohulpahari', label: 'Mohulpahari', pincode: '829201' },
  { value: 'tupkadih', label: 'Tupkadih', pincode: '829105' },
  { value: 'damodarpur', label: 'Damodarpur', pincode: '829206' },
  { value: 'jhilari', label: 'Jhilari', pincode: '829109' },
  { value: 'kustaur', label: 'Kustaur', pincode: '829107' },
  { value: 'nehrubagan', label: 'Nehru Bagan', pincode: '829201' },
  { value: 'rahampur', label: 'Rahampur', pincode: '829202' },
  { value: 'samdi', label: 'Samdi', pincode: '829107' },
  { value: 'sarpan', label: 'Sarpan', pincode: '829208' }
  ],

  'saraikela': [
  { value: 'badkela', label: 'Badkela', pincode: '832108' },
  { value: 'chhota-dumri', label: 'Chhota Dumri', pincode: '832107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'jamda', label: 'Jamda', pincode: '832103' },
  { value: 'kandra', label: 'Kandra', pincode: '832107' },
  { value: 'mohuli', label: 'Mohuli', pincode: '832104' },
  { value: 'patkita', label: 'Patkita', pincode: '832108' },
  { value: 'rasumath', label: 'Rasumath', pincode: '832106' },
  { value: 'saraikela-town', label: 'Saraikela Town', pincode: '832101' },
  { value: 'tuiladungri', label: 'Tuiladungri', pincode: '832109' },
  { value: 'bano', label: 'Bano', pincode: '832114' },
  { value: 'jaganathpur', label: 'Jaganathpur', pincode: '832102' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832113' },
  { value: 'kumardaha', label: 'Kumardaha', pincode: '832103' },
  { value: 'paharitoli', label: 'Paharitoli', pincode: '832107' },
  { value: 'sidhgora', label: 'Sidhgora', pincode: '832106' }
  ],

  'gadhra': [
  { value: 'bhelwa', label: 'Bhelwa', pincode: '832101' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kaithu', label: 'Kaithu', pincode: '832102' },
  { value: 'kandripathar', label: 'Kandripathar', pincode: '832105' },
  { value: 'madhukam', label: 'Madhukam', pincode: '832106' },
  { value: 'patratu', label: 'Patratu', pincode: '829115' },
  { value: 'purulia', label: 'Purulia', pincode: '829101' },
  { value: 'sarai', label: 'Sarai', pincode: '832103' },
  { value: 'teliapathar', label: 'Teliapathar', pincode: '832104' },
  { value: 'banka', label: 'Banka', pincode: '832110' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '832107' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '832108' },
  { value: 'katia', label: 'Katia', pincode: '832109' },
  { value: 'raju-gram', label: 'Raju Gram', pincode: '832112' },
  { value: 'vishnu-pur', label: 'Vishnu Pur', pincode: '832105' }
  ],

  'chaibasa': [
  { value: 'barajamda', label: 'Barajamda', pincode: '833201' },
  { value: 'chaibasa-town', label: 'Chaibasa Town', pincode: '833201' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '833204' },
  { value: 'jorasanko', label: 'Jorasanko', pincode: '833202' },
  { value: 'kolhan', label: 'Kolhan', pincode: '833203' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '833221' },
  { value: 'rangamati', label: 'Rangamati', pincode: '833205' },
  { value: 'tata-kandri', label: 'Tata Kandri', pincode: '833101' },
  { value: 'bano', label: 'Bano', pincode: '833226' },
  { value: 'chhota-murmu', label: 'Chhota Murmu', pincode: '833227' },
  { value: 'ghumra', label: 'Ghumra', pincode: '833220' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '833228' },
  { value: 'kolia', label: 'Kolia', pincode: '833229' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '833210' }
  ],

  'gumla': [
  { value: 'bano', label: 'Bano', pincode: '835201' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'gumla-town', label: 'Gumla Town', pincode: '835207' },
  { value: 'khunti', label: 'Khunti', pincode: '835210' },
  { value: 'kuchai', label: 'Kuchai', pincode: '835211' },
  { value: 'manjhil', label: 'Manjhil', pincode: '835212' },
  { value: 'palkot', label: 'Palkot', pincode: '835213' },
  { value: 'ranchi-bazar', label: 'Ranchi Bazar', pincode: '835101' },
  { value: 'sarai', label: 'Sarai', pincode: '835206' },
  { value: 'birsanagar', label: 'Birsanagar', pincode: '835214' },
  { value: 'borio', label: 'Borio', pincode: '835215' },
  { value: 'chapri', label: 'Chapri', pincode: '835216' },
  { value: 'jashidih', label: 'Jashidih', pincode: '835217' },
  { value: 'keradari', label: 'Keradari', pincode: '835218' },
  { value: 'latar', label: 'Latar', pincode: '835219' }
  ],

  'paratdih': [
  { value: 'bhalukmunda', label: 'Bhalukmunda', pincode: '832107' },
  { value: 'chakradharpur', label: 'Chakradharpur', pincode: '833102' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kandri', label: 'Kandri', pincode: '832113' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '833206' },
  { value: 'paratdih-town', label: 'Paratdih Town', pincode: '832114' },
  { value: 'rajabera', label: 'Rajabera', pincode: '832115' },
  { value: 'sonahatu', label: 'Sonahatu', pincode: '832116' },
  { value: 'tata-nagar', label: 'Tata Nagar', pincode: '832117' },
  { value: 'aswathia', label: 'Aswathia', pincode: '832118' },
  { value: 'barkatoli', label: 'Barkatoli', pincode: '832119' },
  { value: 'deodih', label: 'Deodih', pincode: '832120' },
  { value: 'ghratoli', label: 'Ghratoli', pincode: '832121' },
  { value: 'hatgamharia', label: 'Hatgamharia', pincode: '832122' },
  { value: 'kumardih', label: 'Kumardih', pincode: '832123' },
  { value: 'pankebeda', label: 'Pankebeda', pincode: '832124' },
  { value: 'rajabagan', label: 'Rajabagan', pincode: '832125' }
  ],

  'mera': [
  { value: 'bada-mora', label: 'Bada Mora', pincode: '832301' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khadgarha', label: 'Khadgarha', pincode: '832302' },
  { value: 'mera-town', label: 'Mera Town', pincode: '832303' },
  { value: 'parbhat', label: 'Parbhat', pincode: '832304' },
  { value: 'rajdih', label: 'Rajdih', pincode: '832305' },
  { value: 'sarsabad', label: 'Sarsabad', pincode: '832306' },
  { value: 'tulungia', label: 'Tulungia', pincode: '832307' },
  { value: 'adityapur', label: 'Adityapur', pincode: '832308' },
  { value: 'chandil', label: 'Chandil', pincode: '832309' },
  { value: 'deodih', label: 'Deodih', pincode: '832310' },
  { value: 'jhinkpani', label: 'Jhinkpani', pincode: '832311' },
  { value: 'kuchai', label: 'Kuchai', pincode: '832312' },
  { value: 'madhuban', label: 'Madhuban', pincode: '832313' },
  { value: 'sindri', label: 'Sindri', pincode: '832314' }
  ],

  'simdega': [
  { value: 'bano', label: 'Bano', pincode: '835201' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kashinagar', label: 'Kashinagar', pincode: '835202' },
  { value: 'kumardih', label: 'Kumardih', pincode: '835207' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '835204' },
  { value: 'pario', label: 'Pario', pincode: '835205' },
  { value: 'rajdhanwar', label: 'Rajdhanwar', pincode: '835206' },
  { value: 'simdega-town', label: 'Simdega Town', pincode: '835223' },
  { value: 'thakurgaon', label: 'Thakurgaon', pincode: '835224' },
  { value: 'barahkudar', label: 'Barahkudar', pincode: '835208' },
  { value: 'gamaradih', label: 'Gamaradih', pincode: '835209' },
  { value: 'jari', label: 'Jari', pincode: '835210' },
  { value: 'khunti', label: 'Khunti', pincode: '835211' },
  { value: 'palkot', label: 'Palkot', pincode: '835212' },
  { value: 'sarai', label: 'Sarai', pincode: '835213' }
  ],

  'madhupur': [
  { value: 'alampur', label: 'Alampur', pincode: '500040' },
  { value: 'bandlaguda', label: 'Bandlaguda', pincode: '500005' },
  { value: 'chaitanyapuri', label: 'Chaitanyapuri', pincode: '500060' },
  { value: 'gachibowli', label: 'Gachibowli', pincode: '500032' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kothapet', label: 'Kothapet', pincode: '500035' },
  { value: 'malkajgiri', label: 'Malkajgiri', pincode: '500047' },
  { value: 'mallapur', label: 'Mallapur', pincode: '500076' },
  { value: 'nampally', label: 'Nampally', pincode: '500001' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '500020' },
  { value: 'sainikpuri', label: 'Sainikpuri', pincode: '500062' },
  { value: 'tankbund', label: 'Tankbund', pincode: '500029' },
  { value: 'vani-vihar', label: 'Vani Vihar', pincode: '500012' },
  { value: 'amberpet', label: 'Amberpet', pincode: '500013' },
  { value: 'barkatpura', label: 'Barkatpura', pincode: '500027' },
  { value: 'chikkadpally', label: 'Chikkadpally', pincode: '500020' },
  { value: 'dilsukhnagar', label: 'Dilsukhnagar', pincode: '500060' },
  { value: 'jubilee-hills', label: 'Jubilee Hills', pincode: '500033' },
  { value: 'kukatpally', label: 'Kukatpally', pincode: '500072' },
  { value: 'malakpet', label: 'Malakpet', pincode: '500036' },
  { value: 'nallakunta', label: 'Nallakunta', pincode: '500044' },
  { value: 'paradise', label: 'Paradise', pincode: '500003' },
  { value: 'secunderabad', label: 'Secunderabad', pincode: '500003' },
  { value: 'shivajinagar', label: 'Shivajinagar', pincode: '500011' },
  { value: 'yousufguda', label: 'Yousufguda', pincode: '500045' }
  ],

  'chakradharpur': [
  { value: 'adityapur', label: 'Adityapur', pincode: '832109' },
  { value: 'barajamda', label: 'Barajamda', pincode: '832401' },
  { value: 'chakradharpur', label: 'Chakradharpur', pincode: '833102' },
  { value: 'ganjam', label: 'Ganjam', pincode: '833201' },
  { value: 'jamda', label: 'Jamda', pincode: '832403' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832401' },
  { value: 'lotapahar', label: 'Lotapahar', pincode: '832107' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '833104' },
  { value: 'nijbadi', label: 'Nijbadi', pincode: '832402' },
  { value: 'paharbera', label: 'Paharbera', pincode: '832104' },
  { value: 'rajabera', label: 'Rajabera', pincode: '832105' },
  { value: 'sarjamda', label: 'Sarjamda', pincode: '832110' },
  { value: 'sundarnagar', label: 'Sundarnagar', pincode: '832106' },
  { value: 'tata-steel-township', label: 'Tata Steel Township', pincode: '832107' },
  { value: 'banaikela', label: 'Banaikela', pincode: '832110' },
  { value: 'chhotabera', label: 'Chhotabera', pincode: '832108' },
  { value: 'dudharia', label: 'Dudharia', pincode: '832103' },
  { value: 'jaringa', label: 'Jaringa', pincode: '832105' },
  { value: 'kachchh', label: 'Kachchh', pincode: '832111' },
  { value: 'kandri', label: 'Kandri', pincode: '832112' },
  { value: 'kachari', label: 'Kachari', pincode: '832114' },
  { value: 'manoharpur-m', label: 'Manoharpur M', pincode: '833103' },
  { value: 'purul', label: 'Purul', pincode: '832104' },
  { value: 'ratda', label: 'Ratda', pincode: '832101' }
  ],

  'patratu': [
  { value: 'barka-khera', label: 'Barka Khera', pincode: '829114' },
  { value: 'chandwa', label: 'Chandwa', pincode: '829203' },
  { value: 'chirkunda', label: 'Chirkunda', pincode: '828202' },
  { value: 'gola', label: 'Gola', pincode: '829110' },
  { value: 'haludbani', label: 'Haludbani', pincode: '829220' },
  { value: 'juri', label: 'Juri', pincode: '829124' },
  { value: 'kapali', label: 'Kapali', pincode: '829117' },
  { value: 'kandra', label: 'Kandra', pincode: '829205' },
  { value: 'karmatanr', label: 'Karmatanr', pincode: '829103' },
  { value: 'patratu', label: 'Patratu', pincode: '829125' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '829122' },
  { value: 'ranchi', label: 'Ranchi', pincode: '834001' },
  { value: 'satpura', label: 'Satpura', pincode: '829125' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'tori', label: 'Tori', pincode: '829202' },
  { value: 'andharatoli', label: 'Andharatoli', pincode: '829137' },
  { value: 'bagri', label: 'Bagri', pincode: '829108' },
  { value: 'dhurwa', label: 'Dhurwa', pincode: '834004' },
  { value: 'jaridih', label: 'Jaridih', pincode: '829101' },
  { value: 'kandu', label: 'Kandu', pincode: '829111' },
  { value: 'khunti', label: 'Khunti', pincode: '835210' },
  { value: 'kotri', label: 'Kotri', pincode: '829131' },
  { value: 'madanpur', label: 'Madanpur', pincode: '829102' },
  { value: 'mahipur', label: 'Mahipur', pincode: '829123' },
  { value: 'mohulpahari', label: 'Mohulpahari', pincode: '829130' },
  { value: 'ramu', label: 'Ramu', pincode: '829120' }
  ],

  'musabani': [
  { value: 'badajamda', label: 'Badajamda', pincode: '832104' },
  { value: 'baranjora', label: 'Baranjora', pincode: '832104' },
  { value: 'belabera', label: 'Belabera', pincode: '832105' },
  { value: 'chandil', label: 'Chandil', pincode: '832401' },
  { value: 'chhota-jamda', label: 'Chhota Jamda', pincode: '832103' },
  { value: 'gamaritola', label: 'Gamaritola', pincode: '832106' },
  { value: 'ghutarua', label: 'Ghutarua', pincode: '832107' },
  { value: 'jhinkpani', label: 'Jhinkpani', pincode: '832104' },
  { value: 'kalimati', label: 'Kalimati', pincode: '832101' },
  { value: 'karandih', label: 'Karandih', pincode: '832101' },
  { value: 'katka', label: 'Katka', pincode: '832103' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'musabani', label: 'Musabani', pincode: '832104' },
  { value: 'patabari', label: 'Patabari', pincode: '832106' },
  { value: 'rajarampur', label: 'Rajarampur', pincode: '832104' },
  { value: 'sadhukhor', label: 'Sadhukhor', pincode: '832104' },
  { value: 'sagadia', label: 'Sagadia', pincode: '832103' },
  { value: 'sardih', label: 'Sardih', pincode: '832107' },
  { value: 'barkakana', label: 'Barkakana', pincode: '832113' },
  { value: 'baruadih', label: 'Baruadih', pincode: '832115' },
  { value: 'chhota-rampur', label: 'Chhota Rampur', pincode: '832110' },
  { value: 'doriya', label: 'Doriya', pincode: '832120' },
  { value: 'gadra', label: 'Gadra', pincode: '832111' },
  { value: 'hatiyadih', label: 'Hatiyadih', pincode: '832122' },
  { value: 'kudra', label: 'Kudra', pincode: '832119' },
  { value: 'pura-besan', label: 'Pura Besan', pincode: '832118' },
  { value: 'sindri', label: 'Sindri', pincode: '828122' },
  { value: 'teliagarhi', label: 'Teliagarhi', pincode: '832116' }
  ],

  'gumia': [
  { value: 'bagdaha', label: 'Bagdaha', pincode: '829107' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '829118' },
  { value: 'gumia', label: 'Gumia', pincode: '829121' },
  { value: 'hatiyadih', label: 'Hatiyadih', pincode: '829103' },
  { value: 'jagganathpuri', label: 'Jagganathpuri', pincode: '829101' },
  { value: 'kapali', label: 'Kapali', pincode: '829117' },
  { value: 'karandih', label: 'Karandih', pincode: '832101' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'mahipur', label: 'Mahipur', pincode: '829119' },
  { value: 'musabani', label: 'Musabani', pincode: '832104' },
  { value: 'patabari', label: 'Patabari', pincode: '832106' },
  { value: 'ranchi', label: 'Ranchi', pincode: '834001' },
  { value: 'sardih', label: 'Sardih', pincode: '832107' },
  { value: 'sagadia', label: 'Sagadia', pincode: '832103' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'bagri', label: 'Bagri', pincode: '829105' },
  { value: 'basanti', label: 'Basanti', pincode: '829122' },
  { value: 'besan', label: 'Besan', pincode: '829120' },
  { value: 'dhanwar', label: 'Dhanwar', pincode: '829115' },
  { value: 'garia', label: 'Garia', pincode: '829108' },
  { value: 'kapali-ii', label: 'Kapali II', pincode: '829113' },
  { value: 'ramsagar', label: 'Ramsagar', pincode: '829109' },
  { value: 'tola', label: 'Tola', pincode: '829116' }
  ],

  'kanke': [
  { value: 'bahuara', label: 'Bahuara', pincode: '834006' },
  { value: 'barughutu', label: 'Barughutu', pincode: '834010' },
  { value: 'chakla', label: 'Chakla', pincode: '834005' },
  { value: 'kanke', label: 'Kanke', pincode: '834006' },
  { value: 'karra', label: 'Karra', pincode: '834001' },
  { value: 'kumardih', label: 'Kumardih', pincode: '834014' },
  { value: 'muri', label: 'Muri', pincode: '835101' },
  { value: 'nacho', label: 'Nacho', pincode: '835109' },
  { value: 'patratu', label: 'Patratu', pincode: '829125' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '829122' },
  { value: 'sadarbazar', label: 'Sadar Bazar', pincode: '834002' },
  { value: 'sankra', label: 'Sankra', pincode: '834014' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'vishnupuri', label: 'Vishnupuri', pincode: '834014' },
  { value: 'bandgaon', label: 'Bandgaon', pincode: '835208' },
  { value: 'dariyadih', label: 'Dariyadih', pincode: '834009' },
  { value: 'garhwa', label: 'Garhwa', pincode: '835205' },
  { value: 'ghorabandha', label: 'Ghorabandha', pincode: '834007' },
  { value: 'khijri', label: 'Khijri', pincode: '834005' },
  { value: 'meral', label: 'Meral', pincode: '835102' },
  { value: 'ranchi', label: 'Ranchi', pincode: '834001' }
  ],

  'dugda': [
  { value: 'barkakana', label: 'Barkakana', pincode: '832113' },
  { value: 'dugda', label: 'Dugda', pincode: '828205' },
  { value: 'garhwa', label: 'Garhwa', pincode: '835205' },
  { value: 'jharkhandi', label: 'Jharkhandi', pincode: '828207' },
  { value: 'kaliapathar', label: 'Kaliapathar', pincode: '828206' },
  { value: 'kandri', label: 'Kandri', pincode: '828208' },
  { value: 'kathadih', label: 'Kathadih', pincode: '828204' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'mali', label: 'Mali', pincode: '828210' },
  { value: 'patratu', label: 'Patratu', pincode: '829125' },
  { value: 'sankra', label: 'Sankra', pincode: '834014' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'amarvira', label: 'Amarvira', pincode: '828212' },
  { value: 'barajora', label: 'Barajora', pincode: '828211' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '835214' },
  { value: 'chirudih', label: 'Chirudih', pincode: '828213' },
  { value: 'gamaritola', label: 'Gamaritola', pincode: '828214' },
  { value: 'guarabara', label: 'Guarabara', pincode: '828215' },
  { value: 'kuda', label: 'Kuda', pincode: '828216' },
  { value: 'latadih', label: 'Latadih', pincode: '828217' },
  { value: 'mohammadganj', label: 'Mohammadganj', pincode: '828218' }
  ],

  'kuju': [
  { value: 'barkakana', label: 'Barkakana', pincode: '832113' },
  { value: 'chaibasa', label: 'Chaibasa', pincode: '833201' },
  { value: 'gamaritola', label: 'Gamaritola', pincode: '832114' },
  { value: 'jhinkpani', label: 'Jhinkpani', pincode: '833222' },
  { value: 'kairo', label: 'Kairo', pincode: '832104' },
  { value: 'kandri', label: 'Kandri', pincode: '828208' },
  { value: 'kathadih', label: 'Kathadih', pincode: '828204' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'kuju', label: 'Kuju', pincode: '829124' },
  { value: 'larang', label: 'Larang', pincode: '832115' },
  { value: 'patratu', label: 'Patratu', pincode: '829125' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '829122' },
  { value: 'sankra', label: 'Sankra', pincode: '834014' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'amjora', label: 'Amjora', pincode: '829126' },
  { value: 'bandgaon', label: 'Bandgaon', pincode: '835208' },
  { value: 'bundu', label: 'Bundu', pincode: '834033' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '829129' },
  { value: 'dariyadih', label: 'Dariyadih', pincode: '834034' },
  { value: 'mali', label: 'Mali', pincode: '828210' },
  { value: 'sadarbazar', label: 'Sadar Bazar', pincode: '834002' }
  ],

  'saunda-basti': [
  { value: 'amjora', label: 'Amjora', pincode: '829126' },
  { value: 'barkakana', label: 'Barkakana', pincode: '832113' },
  { value: 'bandgaon', label: 'Bandgaon', pincode: '835208' },
  { value: 'bundu', label: 'Bundu', pincode: '834033' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '829129' },
  { value: 'dugda', label: 'Dugda', pincode: '828205' },
  { value: 'dariyadih', label: 'Dariyadih', pincode: '834034' },
  { value: 'gamaritola', label: 'Gamaritola', pincode: '832114' },
  { value: 'garhwa', label: 'Garhwa', pincode: '835205' },
  { value: 'jharkhandi', label: 'Jharkhandi', pincode: '828207' },
  { value: 'kandri', label: 'Kandri', pincode: '828208' },
  { value: 'kathadih', label: 'Kathadih', pincode: '828204' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'kuju', label: 'Kuju', pincode: '829124' },
  { value: 'larang', label: 'Larang', pincode: '832115' },
  { value: 'mali', label: 'Mali', pincode: '828210' },
  { value: 'patratu', label: 'Patratu', pincode: '829125' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '829122' },
  { value: 'sadarbazar', label: 'Sadar Bazar', pincode: '834002' },
  { value: 'sankra', label: 'Sankra', pincode: '834014' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' }
  ],

  'bundu': [
  { value: 'amarvira', label: 'Amarvira', pincode: '834001' },
  { value: 'barkakana', label: 'Barkakana', pincode: '832113' },
  { value: 'bandgaon', label: 'Bandgaon', pincode: '835208' },
  { value: 'bundu', label: 'Bundu', pincode: '834033' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '829129' },
  { value: 'dugda', label: 'Dugda', pincode: '828205' },
  { value: 'garhwa', label: 'Garhwa', pincode: '835205' },
  { value: 'jharkhandi', label: 'Jharkhandi', pincode: '828207' },
  { value: 'kandri', label: 'Kandri', pincode: '828208' },
  { value: 'kathadih', label: 'Kathadih', pincode: '828204' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'kuju', label: 'Kuju', pincode: '829124' },
  { value: 'mali', label: 'Mali', pincode: '828210' },
  { value: 'patratu', label: 'Patratu', pincode: '829125' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '829122' },
  { value: 'sadarbazar', label: 'Sadar Bazar', pincode: '834002' },
  { value: 'sankra', label: 'Sankra', pincode: '834014' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'belhari', label: 'Belhari', pincode: '834042' },
  { value: 'dumri', label: 'Dumri', pincode: '834033' },
  { value: 'khunti', label: 'Khunti', pincode: '834001' },
  { value: 'murhu', label: 'Murhu', pincode: '834213' },
  { value: 'tamar', label: 'Tamar', pincode: '834204' }
  ],

  'hussainabad': [
  { value: 'barkakana', label: 'Barkakana', pincode: '832113' },
  { value: 'dugda', label: 'Dugda', pincode: '828205' },
  { value: 'garhwa', label: 'Garhwa', pincode: '835205' },
  { value: 'hussainabad', label: 'Hussainabad', pincode: '829116' },
  { value: 'jharkhandi', label: 'Jharkhandi', pincode: '828207' },
  { value: 'kandri', label: 'Kandri', pincode: '828208' },
  { value: 'kathadih', label: 'Kathadih', pincode: '828204' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'kuju', label: 'Kuju', pincode: '829124' },
  { value: 'mali', label: 'Mali', pincode: '828210' },
  { value: 'patratu', label: 'Patratu', pincode: '829125' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '829122' },
  { value: 'sadarbazar', label: 'Sadar Bazar', pincode: '834002' },
  { value: 'sankra', label: 'Sankra', pincode: '834014' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'tori', label: 'Tori', pincode: '829111' },
  { value: 'barwadih', label: 'Barwadih', pincode: '835222' },
  { value: 'belhari', label: 'Belhari', pincode: '834042' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '829129' },
  { value: 'dumri', label: 'Dumri', pincode: '834033' },
  { value: 'khunti', label: 'Khunti', pincode: '834001' },
  { value: 'muru', label: 'Muru', pincode: '829117' }
  ],

  'chas': [
  { value: 'anandpuri', label: 'Anandpuri', pincode: '828202' },
  { value: 'barmasia', label: 'Barmasia', pincode: '828401' },
  { value: 'charwa', label: 'Charwa', pincode: '828301' },
  { value: 'chakmashra', label: 'Chakmashra', pincode: '828201' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '828405' },
  { value: 'chhattidih', label: 'Chhattidih', pincode: '828403' },
  { value: 'chalni', label: 'Chalni', pincode: '828302' },
  { value: 'dharmshala', label: 'Dharmshala', pincode: '828402' },
  { value: 'jhajha', label: 'Jhajha', pincode: '828304' },
  { value: 'kamalganj', label: 'Kamalganj', pincode: '828305' },
  { value: 'madhupur', label: 'Madhupur', pincode: '828306' },
  { value: 'rajarpura', label: 'Rajar Pura', pincode: '828403' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '829122' },
  { value: 'sadarbazar', label: 'Sadar Bazar', pincode: '834002' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '828307' },
  { value: 'balumath', label: 'Balumath', pincode: '829105' },
  { value: 'chandani', label: 'Chandani', pincode: '828308' },
  { value: 'govindpur', label: 'Govindpur', pincode: '828309' },
  { value: 'hazaribagh', label: 'Hazaribagh', pincode: '825301' },
  { value: 'kathalda', label: 'Kathalda', pincode: '828310' },
  { value: 'kachari', label: 'Kachari', pincode: '828311' },
  { value: 'manatu', label: 'Manatu', pincode: '828312' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '828313' },
  { value: 'patratu', label: 'Patratu', pincode: '829125' },
  { value: 'ramgarh-urban', label: 'Ramgarh Urban', pincode: '829126' }
  ],

  'mihijam': [
  { value: 'adityapur', label: 'Adityapur', pincode: '832109' },
  { value: 'barajore', label: 'Barajore', pincode: '828202' },
  { value: 'chauparia', label: 'Chauparia', pincode: '828303' },
  { value: 'gamharia', label: 'Gamharia', pincode: '832108' },
  { value: 'ghagri', label: 'Ghagri', pincode: '828305' },
  { value: 'jamshedpur', label: 'Jamshedpur', pincode: '831001' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'mihijam', label: 'Mihijam', pincode: '828213' },
  { value: 'murkunda', label: 'Murkunda', pincode: '828209' },
  { value: 'patamda', label: 'Patamda', pincode: '832105' },
  { value: 'rahargora', label: 'Rahargora', pincode: '832108' },
  { value: 'ranchi', label: 'Ranchi', pincode: '834001' },
  { value: 'sagarnadi', label: 'Sagarnadi', pincode: '828211' },
  { value: 'sonari', label: 'Sonari', pincode: '831011' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'birsanagar', label: 'Birsanagar', pincode: '831017' },
  { value: 'dimna', label: 'Dimna', pincode: '832107' },
  { value: 'gadra', label: 'Gadra', pincode: '828212' },
  { value: 'gola', label: 'Gola', pincode: '832104' },
  { value: 'hathidah', label: 'Hathidah', pincode: '828206' },
  { value: 'kalimati', label: 'Kalimati', pincode: '832104' },
  { value: 'mohulpahari', label: 'Mohulpahari', pincode: '832110' },
  { value: 'raigarh', label: 'Raigarh', pincode: '832102' },
  { value: 'sitaramdera', label: 'Sitaramdera', pincode: '831013' },
  { value: 'tatibandh', label: 'Tatibandh', pincode: '832106' }
  ],

  'ghatshila': [
  { value: 'anandpur', label: 'Anandpur', pincode: '832106' },
  { value: 'balarampur', label: 'Balarampur', pincode: '832107' },
  { value: 'barajore', label: 'Barajore', pincode: '828202' },
  { value: 'gamharia', label: 'Gamharia', pincode: '832108' },
  { value: 'ghatshila', label: 'Ghatshila', pincode: '832103' },
  { value: 'ghagri', label: 'Ghagri', pincode: '828305' },
  { value: 'jharkhandi', label: 'Jharkhandi', pincode: '832201' },
  { value: 'kandra', label: 'Kandra', pincode: '832106' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'maitri', label: 'Maitri', pincode: '832106' },
  { value: 'mihijam', label: 'Mihijam', pincode: '828213' },
  { value: 'murkunda', label: 'Murkunda', pincode: '828209' },
  { value: 'patamda', label: 'Patamda', pincode: '832105' },
  { value: 'rajarpura', label: 'Rajar Pura', pincode: '832104' },
  { value: 'sagarnadi', label: 'Sagarnadi', pincode: '828211' },
  { value: 'sonari', label: 'Sonari', pincode: '831011' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '828307' },
  { value: 'balitora', label: 'Balitora', pincode: '832112' },
  { value: 'birsanagar', label: 'Birsanagar', pincode: '831017' },
  { value: 'dimna', label: 'Dimna', pincode: '832107' },
  { value: 'gola', label: 'Gola', pincode: '832104' },
  { value: 'hathidah', label: 'Hathidah', pincode: '828206' },
  { value: 'kalimati', label: 'Kalimati', pincode: '832104' },
  { value: 'mohulpahari', label: 'Mohulpahari', pincode: '832110' },
  { value: 'raigarh', label: 'Raigarh', pincode: '832102' },
  { value: 'sitaramdera', label: 'Sitaramdera', pincode: '831013' },
  { value: 'tatibandh', label: 'Tatibandh', pincode: '832106' }
  ],

  'barughutu': [
  { value: 'barughutu', label: 'Barughutu', pincode: '829126' },
  { value: 'birsanagar', label: 'Birsanagar', pincode: '831017' },
  { value: 'chakradharpur', label: 'Chakradharpur', pincode: '833102' },
  { value: 'gamharia', label: 'Gamharia', pincode: '832108' },
  { value: 'ghaghri', label: 'Ghaghri', pincode: '828305' },
  { value: 'jharkhandi', label: 'Jharkhandi', pincode: '832201' },
  { value: 'kandra', label: 'Kandra', pincode: '832106' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'mihijam', label: 'Mihijam', pincode: '828213' },
  { value: 'murkunda', label: 'Murkunda', pincode: '828209' },
  { value: 'patamda', label: 'Patamda', pincode: '832105' },
  { value: 'rajarpura', label: 'Rajar Pura', pincode: '832104' },
  { value: 'sagarnadi', label: 'Sagarnadi', pincode: '828211' },
  { value: 'sonari', label: 'Sonari', pincode: '831011' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '828307' },
  { value: 'balitora', label: 'Balitora', pincode: '832112' },
  { value: 'dimna', label: 'Dimna', pincode: '832107' },
  { value: 'gola', label: 'Gola', pincode: '832104' },
  { value: 'hathidah', label: 'Hathidah', pincode: '828206' },
  { value: 'kalimati', label: 'Kalimati', pincode: '832104' },
  { value: 'mohulpahari', label: 'Mohulpahari', pincode: '832110' },
  { value: 'raigarh', label: 'Raigarh', pincode: '832102' },
  { value: 'sitaramdera', label: 'Sitaramdera', pincode: '831013' },
  { value: 'tatibandh', label: 'Tatibandh', pincode: '832106' },
  { value: 'rajabasa', label: 'Rajabasa', pincode: '832110' },
  { value: 'tilaiya', label: 'Tilaiya', pincode: '829121' },
  { value: 'raihatu', label: 'Raihatu', pincode: '832103' }
  ],

  'churi': [
  { value: 'churi', label: 'Churi', pincode: '829116' },
  { value: 'ghaghri', label: 'Ghaghri', pincode: '828305' },
  { value: 'gamharia', label: 'Gamharia', pincode: '832108' },
  { value: 'jharkhandi', label: 'Jharkhandi', pincode: '832201' },
  { value: 'kandra', label: 'Kandra', pincode: '832106' },
  { value: 'kharsawan', label: 'Kharsawan', pincode: '832202' },
  { value: 'mohulpahari', label: 'Mohulpahari', pincode: '832110' },
  { value: 'mihijam', label: 'Mihijam', pincode: '828213' },
  { value: 'murkunda', label: 'Murkunda', pincode: '828209' },
  { value: 'patamda', label: 'Patamda', pincode: '832105' },
  { value: 'rajarpura', label: 'Rajar Pura', pincode: '832104' },
  { value: 'sonari', label: 'Sonari', pincode: '831011' },
  { value: 'tetari', label: 'Tetari', pincode: '829102' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '828307' },
  { value: 'balitora', label: 'Balitora', pincode: '832112' },
  { value: 'birsanagar', label: 'Birsanagar', pincode: '831017' },
  { value: 'dimna', label: 'Dimna', pincode: '832107' },
  { value: 'gola', label: 'Gola', pincode: '832104' },
  { value: 'hathidah', label: 'Hathidah', pincode: '828206' },
  { value: 'kalimati', label: 'Kalimati', pincode: '832104' },
  { value: 'mohulpahari', label: 'Mohulpahari', pincode: '832110' },
  { value: 'raigarh', label: 'Raigarh', pincode: '832102' },
  { value: 'sitaramdera', label: 'Sitaramdera', pincode: '831013' },
  { value: 'tatibandh', label: 'Tatibandh', pincode: '832106' },
  { value: 'rajabasa', label: 'Rajabasa', pincode: '832110' },
  { value: 'tilaiya', label: 'Tilaiya', pincode: '829121' },
  { value: 'raihatu', label: 'Raihatu', pincode: '832103' },
  { value: 'tata-nagar', label: 'Tata Nagar', pincode: '832110' },
  { value: 'barajore', label: 'Barajore', pincode: '828202' }
  ],

'ranchi': [
  { value: 'adarshnagar', label: 'Adarsh Nagar', pincode: '834002' },
  { value: 'ahirtoli', label: 'Ahirtoli', pincode: '834001' },
  { value: 'amithanagar', label: 'Amitha Nagar', pincode: '834001' },
  { value: 'angara', label: 'Angara', pincode: '835213' },
  { value: 'argora', label: 'Argora', pincode: '834002' },
  { value: 'arsande', label: 'Arsande', pincode: '835221' },
  { value: 'ashoknagar', label: 'Ashok Nagar', pincode: '834002' },
  { value: 'baraghaghra', label: 'Bara Ghaghra', pincode: '834010' },
  { value: 'bargain', label: 'Bargain', pincode: '834001' },
  { value: 'barganwa', label: 'Barganwa', pincode: '835213' },
  { value: 'bariatu', label: 'Bariatu', pincode: '834009' },
  { value: 'bariaturroad', label: 'Bariatu Road', pincode: '834009' },
  { value: 'bijupada', label: 'Bijupada', pincode: '834001' },
  { value: 'circularroad', label: 'Circular Road', pincode: '834001' },
  { value: 'delatoli', label: 'Delatoli', pincode: '834003' },
  { value: 'dhurwa', label: 'Dhurwa', pincode: '834004' },
  { value: 'doranda', label: 'Doranda', pincode: '834002' },
  { value: 'dwarikapuri', label: 'Dwarika Puri', pincode: '834002' },
  { value: 'firayalal', label: 'Firayalal', pincode: '834001' },
  { value: 'gandhinagar', label: 'Gandhi Nagar', pincode: '834002' },
  { value: 'getlatu', label: 'Getlatu', pincode: '834008' },
  { value: 'gosaintola', label: 'Gosaintola', pincode: '834002' },
  { value: 'hardag', label: 'Hardag', pincode: '835202' },
  { value: 'hariharsinghroad', label: 'Harihar Singh Road', pincode: '834001' },
  { value: 'harmuhousingcolony', label: 'Harmu Housing Colony', pincode: '834002' },
  { value: 'hatia', label: 'Hatia', pincode: '834003' },
  { value: 'hazaribagroad', label: 'Hazaribag Road', pincode: '834003' },
  { value: 'hesag', label: 'Hesag', pincode: '835204' },
  { value: 'hindpiri', label: 'Hindpiri', pincode: '834001' },
  { value: 'hinoo', label: 'Hinoo', pincode: '834002' },
  { value: 'hochar', label: 'Hochar', pincode: '834009' },
  { value: 'indrapuricolony', label: 'Indrapuri Colony', pincode: '834002' },
  { value: 'irba', label: 'Irba', pincode: '835217' },
  { value: 'itkithakurgoan', label: 'Itki Thakurgoan', pincode: '835202' },
  { value: 'jagarnathpur', label: 'Jagarnathpur', pincode: '834004' },
  { value: 'jamuari', label: 'Jamuari', pincode: '835204' },
  { value: 'jhiri', label: 'Jhiri', pincode: '835211' },
  { value: 'kadru', label: 'Kadru', pincode: '834005' },
  { value: 'kanka', label: 'Kanka', pincode: '834006' },
  { value: 'kanke', label: 'Kanke', pincode: '834006' },
  { value: 'kankeroad', label: 'Kanke Road', pincode: '834006' },
  { value: 'kantatoli', label: 'Kantatoli', pincode: '834001' },
  { value: 'karamtolichowk', label: 'Karamtoli Chowk', pincode: '834001' },
  { value: 'kathalkocha', label: 'Kathalkocha', pincode: '834001' },
  { value: 'khatanga', label: 'Khatanga', pincode: '834010' },
  { value: 'khelgaon', label: 'Khelgaon', pincode: '834010' },
  { value: 'kokar', label: 'Kokar', pincode: '834001' },
  { value: 'kumhartoli', label: 'Kumhar Toli', pincode: '834002' },
  { value: 'kusai', label: 'Kusai Colony', pincode: '834003' },
  { value: 'lalpur', label: 'Lalpur', pincode: '834003' },
  { value: 'lalpurchowk', label: 'Lalpur Chowk', pincode: '834003' },
  { value: 'lowadih', label: 'Lowadih', pincode: '834002' },
  { value: 'mainroad', label: 'Main Road', pincode: '834001' },
  { value: 'mandar', label: 'Mandar', pincode: '835215' },
  { value: 'masibari', label: 'Masibari', pincode: '835205' },
  { value: 'mesra', label: 'Mesra', pincode: '835215' },
  { value: 'morabadi', label: 'Morabadi', pincode: '834008' },
  { value: 'murangtoli', label: 'Murangtoli', pincode: '834001' },
  { value: 'muri', label: 'Muri', pincode: '835101' },
  { value: 'nagratoli', label: 'Nagratoli', pincode: '834003' },
  { value: 'nagri', label: 'Nagri', pincode: '835205' },
  { value: 'namkum', label: 'Namkum', pincode: '835210' },
  { value: 'nayatoli', label: 'Nayatoli', pincode: '834001' },
  { value: 'nh33', label: 'NH-33', pincode: '834010' },
  { value: 'nh33', label: 'NH:33', pincode: '834010' },
  { value: 'ohdarvillage', label: 'Ohdar Village', pincode: '835221' },
  { value: 'ormanji', label: 'Ormanjhi', pincode: '835219' },
  { value: 'oyna', label: 'Oyna', pincode: '835202' },
  { value: 'pahartoli', label: 'Pahartoli', pincode: '834002' },
  { value: 'pandra', label: 'Pandra', pincode: '834005' },
  { value: 'patelnagar', label: 'Patel Nagar', pincode: '834001' },
  { value: 'patratoli', label: 'Patratoli', pincode: '834001' },
  { value: 'pithiyatil', label: 'Pithiyatil', pincode: '835215' },
  { value: 'premnagar', label: 'Prem Nagar', pincode: '834003' },
  { value: 'pundag', label: 'Pundag', pincode: '835204' },
  { value: 'radiumroad', label: 'Radium Road', pincode: '834001' },
  { value: 'rajadera', label: 'Rajadera', pincode: '835213' },
  { value: 'ranibagan', label: 'Ranibagan', pincode: '834010' },
  { value: 'raturroad', label: 'Ratu Road', pincode: '834009' },
  { value: 'ringroad', label: 'Ring Road', pincode: '834010' },
  { value: 'samlong', label: 'Samlong', pincode: '834001' },
  { value: 'sarhulnagar', label: 'Sarhul Nagar', pincode: '834010' },
  { value: 'sector2', label: 'Sector-2', pincode: '834001' },
  { value: 'sector3', label: 'Sector-3', pincode: '834001' },
  { value: 'shuklacolony', label: 'Shukla Colony', pincode: '834010' },
  { value: 'sosovillage', label: 'SOSO Village', pincode: '834010' },
  { value: 'tatisilway', label: 'Tatisilway', pincode: '834004' },
  { value: 'tikratoli', label: 'Tikratoli', pincode: '834002' },
  { value: 'tupudana', label: 'Tupudana', pincode: '835207' },
  { value: 'upperbazar', label: 'Upper Bazar', pincode: '834001' },
  { value: 'upperchutia', label: 'Upper Chutia', pincode: '834001' },
  { value: 'vikashnagar', label: 'Vikash Nagar', pincode: '834003' }
  ],
  
'bokaro-steel-city': [
  { value: 'adityapur', label: 'Adityapur', pincode: '827014' },
  { value: 'argora', label: 'Argora', pincode: '827001' },
  { value: 'bhaga', label: 'Bhaga', pincode: '827013' },
  { value: 'bokaro-town', label: 'Bokaro Town', pincode: '827001' },
  { value: 'chandankyari', label: 'Chandankyari', pincode: '827013' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '829135' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '827014' },
  { value: 'kandrah', label: 'Kandrah', pincode: '827013' },
  { value: 'petarwar', label: 'Petarwar', pincode: '829115' },
  { value: 'rangamati', label: 'Rangamati', pincode: '827001' },
  { value: 'sector-1', label: 'Sector 1', pincode: '827001' },
  { value: 'sector-2', label: 'Sector 2', pincode: '827002' },
  { value: 'sector-3', label: 'Sector 3', pincode: '827003' },
  { value: 'sector-4', label: 'Sector 4', pincode: '827004' },
  { value: 'sector-5', label: 'Sector 5', pincode: '827005' },
  { value: 'sector-6', label: 'Sector 6', pincode: '827006' },
  { value: 'sector-7', label: 'Sector 7', pincode: '827007' },
  { value: 'sector-8', label: 'Sector 8', pincode: '827008' },
  { value: 'sector-9', label: 'Sector 9', pincode: '827009' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '827005' },
  { value: 'sindri', label: 'Sindri', pincode: '828122' },
  { value: 'steel-nagar', label: 'Steel Nagar', pincode: '827001' },
  { value: 'tata-nagar', label: 'Tata Nagar', pincode: '827005' },
  { value: 'topchanchi', label: 'Topchanchi', pincode: '829126' },
  { value: 'aluwadih', label: 'Aluwadih', pincode: '827014' },
  { value: 'bihari-basti', label: 'Bihari Basti', pincode: '827014' },
  { value: 'bhairabnath', label: 'Bhairabnath', pincode: '827002' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '829135' },
  { value: 'chandrashekharpur', label: 'Chandrashekharpur', pincode: '829301' },
  { value: 'city-center', label: 'City Center', pincode: '827012' },
  { value: 'gomia', label: 'Gomia', pincode: '829110' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '827013' },
  { value: 'jagannathnagar', label: 'Jagannath Nagar', pincode: '827014' },
  { value: 'jharna', label: 'Jharna', pincode: '827014' },
  { value: 'kali-mandir', label: 'Kali Mandir', pincode: '827014' },
  { value: 'keshrichak', label: 'Keshrichak', pincode: '827015' },
  { value: 'lohardaga', label: 'Lohardaga', pincode: '829202' },
  { value: 'mahudi', label: 'Mahudi', pincode: '829103' },
  { value: 'mohammadganj', label: 'Mohammadganj', pincode: '827124' },
  { value: 'nirmal-basti', label: 'Nirmal Basti', pincode: '827011' },
  { value: 'patratu', label: 'Patratu', pincode: '829119' }
  ],

  'dhanbad': [
  { value: 'andhra-nagar', label: 'Andhra Nagar', pincode: '828113' },
  { value: 'bhuli', label: 'Bhuli', pincode: '828105' },
  { value: 'chatra', label: 'Chatra', pincode: '828121' },
  { value: 'dhanbad', label: 'Dhanbad', pincode: '826001' },
  { value: 'ghorabandha', label: 'Ghorabandha', pincode: '828405' },
  { value: 'ghughi', label: 'Ghughi', pincode: '828118' },
  { value: 'jharia', label: 'Jharia', pincode: '828111' },
  { value: 'katras', label: 'Katras', pincode: '828113' },
  { value: 'kendua', label: 'Kendua', pincode: '828205' },
  { value: 'madhuban', label: 'Madhuban', pincode: '828305' },
  { value: 'mohanpur', label: 'Mohanpur', pincode: '828202' },
  { value: 'patherdih', label: 'Patherdih', pincode: '828125' },
  { value: 'pichhli', label: 'Pichhli', pincode: '828102' },
  { value: 'sasaram', label: 'Sasaram', pincode: '828127' },
  { value: 'sonardih', label: 'Sonardih', pincode: '828131' },
  { value: 'topchanchi', label: 'Topchanchi', pincode: '828403' },
  { value: 'vishnupur', label: 'Vishnupur', pincode: '828206' }
  ],
  'hazaribagh': [ 
  { value: 'annanda-chowk', label: 'Annanda Chowk', pincode: '825301' },
  { value: 'babhanbai', label: 'Babhanbai', pincode: '825303' },
  { value: 'badkagaon', label: 'Badkagaon', pincode: '825302' },
  { value: 'barhi', label: 'Barhi', pincode: '825405' },
  { value: 'barkatha', label: 'Barkatha', pincode: '825323' },
  { value: 'bonga', label: 'Bonga', pincode: '825302' },
  { value: 'charhi', label: 'Charhi', pincode: '825336' },
  { value: 'chiraundi', label: 'Chiraundi', pincode: '825303' },
  { value: 'daru', label: 'Daru', pincode: '825313' },
  { value: 'demotand', label: 'Demotand', pincode: '825301' },
  { value: 'gandhi-maidan', label: 'Gandhi Maidan', pincode: '825301' },
  { value: 'hazari-bazar', label: 'Hazari Bazar', pincode: '825301' },
  { value: 'jori', label: 'Jori', pincode: '825311' },
  { value: 'katkamsandi', label: 'Katkamsandi', pincode: '825319' },
  { value: 'keshwari', label: 'Keshwari', pincode: '825318' },
  { value: 'koderma-road', label: 'Koderma Road', pincode: '825303' },
  { value: 'kumhar-toli', label: 'Kumhar Toli', pincode: '825301' },
  { value: 'madhura', label: 'Madhura', pincode: '825406' },
  { value: 'oriyapath', label: 'Oriyapath', pincode: '825301' },
  { value: 'pugmil', label: 'Pugmil', pincode: '825301' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '825101' },
  { value: 'rukka', label: 'Rukka', pincode: '825312' },
  { value: 'sarley', label: 'Sarley', pincode: '825302' },
  { value: 'sitagarha', label: 'Sitagarha', pincode: '825313' },
  { value: 'urimari', label: 'Urimari', pincode: '825330' }
],

  'deoghar': [
  { value: 'a-k-bad', label: 'A.K. Bad', pincode: '814143' },
  { value: 'asna', label: 'Asna', pincode: '814146' },
  { value: 'baghmari', label: 'Baghmari', pincode: '814152' },
  { value: 'bagjora', label: 'Bagjora', pincode: '815353' },
  { value: 'baijukura', label: 'Baijukura', pincode: '814143' },
  { value: 'bamandiha', label: 'Bamandiha', pincode: '814149' },
  { value: 'bansbutia', label: 'Bansbutia', pincode: '814146' },
  { value: 'baramsoli', label: 'Baramsoli', pincode: '815357' },
  { value: 'baratanr', label: 'Baratanr', pincode: '815357' },
  { value: 'bichgarha', label: 'Bichgarha Kusumdih', pincode: '814113' },
  { value: 'chanddih', label: 'Chanddih', pincode: '814143' },
  { value: 'charak-mara', label: 'Charak Mara', pincode: '814149' },
  { value: 'deoghar-college', label: 'Deoghar College', pincode: '814113' },
  { value: 'deoghar-court', label: 'Deoghar Court', pincode: '814112' },
  { value: 'dumaria', label: 'Dumaria', pincode: '814149' },
  { value: 'jasidih', label: 'Jasidih', pincode: '814142' },
  { value: 'kunda', label: 'Kunda', pincode: '814143' },
  { value: 'madhopur', label: 'Madhopur', pincode: '814142' },
  { value: 'madhupur', label: 'Madhupur', pincode: '815353' },
  { value: 'mohansarai', label: 'Mohansarai', pincode: '814152' },
  { value: 'punasi', label: 'Punasi', pincode: '814152' },
  { value: 'sarwan', label: 'Sarwan', pincode: '814150' },
  { value: 'satsang', label: 'Satsang', pincode: '814116' },
  { value: 'simarjore', label: 'Simarjore', pincode: '814120' }
  ],

  'medininagar': [
  { value: 'baralota', label: 'Baralota', pincode: '822101' },
  { value: 'belwatikar', label: 'Belwatikar', pincode: '822101' },
  { value: 'bishrampur', label: 'Bishrampur', pincode: '822124' },
  { value: 'chainpur', label: 'Chainpur', pincode: '822110' },
  { value: 'chhatarpur', label: 'Chhatarpur', pincode: '822113' },
  { value: 'daltonganj', label: 'Daltonganj', pincode: '822101' },
  { value: 'daltonganj-bazar', label: 'Daltonganj Bazar', pincode: '822101' },
  { value: 'hamidganj', label: 'Hamidganj', pincode: '822101' },
  { value: 'hariharganj', label: 'Hariharganj', pincode: '822131' },
  { value: 'haider-nagar', label: 'Haider Nagar', pincode: '822115' },
  { value: 'hussainabad', label: 'Hussainabad', pincode: '822116' },
  { value: 'lesliganj', label: 'Lesliganj', pincode: '822118' },
  { value: 'manatu', label: 'Manatu', pincode: '822123' },
  { value: 'mohammadganj', label: 'Mohammadganj', pincode: '822115' },
  { value: 'nawa-bazar', label: 'Nawa Bazar', pincode: '822113' },
  { value: 'panki', label: 'Panki', pincode: '822122' },
  { value: 'patan', label: 'Patan', pincode: '822123' },
  { value: 'pipra', label: 'Pipra', pincode: '822131' },
  { value: 'ramgadh', label: 'Ramgadh', pincode: '822132' },
  { value: 'satbarwa', label: 'Satbarwa', pincode: '822126' },
  { value: 'sudna-industrial-area', label: 'Sudna Industrial Area', pincode: '822102' },
  { value: 'tarhasi', label: 'Tarhasi', pincode: '822118' },
  { value: 'untari-road', label: 'Untari Road', pincode: '822120' }
  ],

  'koderma': [
  { value: 'arkhango', label: 'Arkhango', pincode: '825418' },
  { value: 'bagro', label: 'Bagro', pincode: '825418' },
  { value: 'baheradih', label: 'Baheradih', pincode: '825407' },
  { value: 'bansudih', label: 'Bansudih', pincode: '805132' },
  { value: 'barkangango', label: 'Barkangango', pincode: '825323' },
  { value: 'bekobar', label: 'Bekobar', pincode: '825409' },
  { value: 'chandwara', label: 'Chandwara', pincode: '825409' },
  { value: 'chechkapi', label: 'Chechkapi', pincode: '825323' },
  { value: 'domchanch', label: 'Domchanch', pincode: '825407' },
  { value: 'gajhandi', label: 'Gajhandi', pincode: '825409' },
  { value: 'gurio', label: 'Gurio', pincode: '825413' },
  { value: 'jainagar', label: 'Jainagar', pincode: '825109' },
  { value: 'jhumri-telaiya', label: 'Jhumri Telaiya', pincode: '825409' },
  { value: 'khalakthambi', label: 'Khalakthambi', pincode: '825410' },
  { value: 'koderma', label: 'Koderma', pincode: '825410' },
  { value: 'koderma-thermal-power-station', label: 'Koderma Thermal Power Station', pincode: '825421' },
  { value: 'markacho', label: 'Markacho', pincode: '825318' },
  { value: 'masnodih', label: 'Masnodih', pincode: '825407' },
  { value: 'nawalshahi', label: 'Nawalshahi', pincode: '825418' },
  { value: 'parsabad', label: 'Parsabad', pincode: '825318' },
  { value: 'satgawan', label: 'Satgawan', pincode: '805132' },
  { value: 'telaiya-dam', label: 'Telaiya Dam', pincode: '825413' }
  ],


  'jamtara': [
  { value: 'amdiha', label: 'Amdiha', pincode: '815352' },
  { value: 'asanchua', label: 'Asanchua', pincode: '815351' },
  { value: 'bagdaha', label: 'Bagdaha', pincode: '815351' },
  { value: 'bena', label: 'Bena', pincode: '815351' },
  { value: 'bindapathar', label: 'Bindapathar', pincode: '815351' },
  { value: 'chandra-dhipa', label: 'Chandra Dhipa', pincode: '815354' },
  { value: 'charakmara', label: 'Charakmara', pincode: '815359' },
  { value: 'chitra', label: 'Chitra', pincode: '815351' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '814166' },
  { value: 'geria', label: 'Geria', pincode: '815351' },
  { value: 'gokula', label: 'Gokula', pincode: '815352' },
  { value: 'jamtara', label: 'Jamtara', pincode: '815351' },
  { value: 'jamtara-court', label: 'Jamtara Court', pincode: '815351' },
  { value: 'karmatar', label: 'Karmatar', pincode: '815352' },
  { value: 'kundahit', label: 'Kundahit', pincode: '815359' },
  { value: 'mihijam', label: 'Mihijam', pincode: '815354' },
  { value: 'nala', label: 'Nala', pincode: '815355' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '815352' },
  { value: 'pabia', label: 'Pabia', pincode: '815351' },
  { value: 'palajuri', label: 'Palajuri', pincode: '815359' },
  { value: 'panjania', label: 'Panjania', pincode: '815351' },
  { value: 'ranitanr', label: 'Ranitanr', pincode: '815352' },
  { value: 'sabanpur', label: 'Sabanpur', pincode: '815352' },
  { value: 'satki', label: 'Satki', pincode: '815359' },
  { value: 'sinduri', label: 'Sinduri', pincode: '815352' },
  { value: 'sonbad', label: 'Sonbad', pincode: '815351' }
  ],

  'dumka': [
  { value: 'ajnari-dudhani', label: 'Ajnari Dudhani', pincode: '814146' },
  { value: 'amarapahari', label: 'Amarapahari', pincode: '814102' },
  { value: 'amjora', label: 'Amjora', pincode: '814148' },
  { value: 'amlachatar', label: 'Amlachatar', pincode: '814110' },
  { value: 'asanbani', label: 'Asanbani', pincode: '816116' },
  { value: 'bandarjora', label: 'Bandarjora', pincode: '814102' },
  { value: 'baratanr', label: 'Baratanr', pincode: '814118' },
  { value: 'bhalsumar', label: 'Bhalsumar', pincode: '814102' },
  { value: 'chhoti-ranbahiyar', label: 'Chhoti Ranbahiyar', pincode: '814102' },
  { value: 'daldali', label: 'Daldali', pincode: '816103' },
  { value: 'danro', label: 'Danro', pincode: '814102' },
  { value: 'dumka', label: 'Dumka', pincode: '814101' },
  { value: 'gadibahirkunda', label: 'Gadibahirkunda', pincode: '814120' },
  { value: 'gamharia', label: 'Gamharia', pincode: '814102' },
  { value: 'ghaghri', label: 'Ghaghri', pincode: '814102' },
  { value: 'jama', label: 'Jama', pincode: '814110' },
  { value: 'jarmundi', label: 'Jarmundi', pincode: '814141' },
  { value: 'kalajhar', label: 'Kalajhar', pincode: '814103' },
  { value: 'kathikund', label: 'Kathikund', pincode: '814103' },
  { value: 'massanjore', label: 'Massanjore', pincode: '814144' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '814102' },
  { value: 'shikaripara', label: 'Shikaripara', pincode: '816103' },
  { value: 'sinduria', label: 'Sinduria', pincode: '814103' },
  { value: 'teliachak', label: 'Teliachak', pincode: '814110' },
  { value: 'haripur', label: 'Haripur', pincode: '814118' },
  { value: 'gugisimal', label: 'Gugisimal', pincode: '814119' }
  ],

  'sahibganj': [
  { value: 'balapokhar', label: 'Balapokhar', pincode: '816109' },
  { value: 'baluagairah', label: 'Baluagairah', pincode: '816109' },
  { value: 'barhait', label: 'Barhait', pincode: '816102' },
  { value: 'barharwa', label: 'Barharwa', pincode: '816101' },
  { value: 'borio', label: 'Borio', pincode: '816120' },
  { value: 'brindaban', label: 'Brindaban', pincode: '816116' },
  { value: 'chandsaher', label: 'Chandsaher', pincode: '816101' },
  { value: 'chotabangama', label: 'Chotabangama', pincode: '816120' },
  { value: 'gaganpahari', label: 'Gaganpahari', pincode: '816105' },
  { value: 'ganga-prasad-diara', label: 'Ganga Prasad Diara', pincode: '816109' },
  { value: 'hariprasad-diara', label: 'Hariprasad Diara', pincode: '816109' },
  { value: 'hatigarah', label: 'Hatigarah', pincode: '816120' },
  { value: 'kassim-bazar', label: 'Kassim Bazar', pincode: '816108' },
  { value: 'kotalpokhar', label: 'Kotalpokhar', pincode: '816105' },
  { value: 'lakhipur', label: 'Lakhipur', pincode: '816110' },
  { value: 'maharajpur', label: 'Maharajpur', pincode: '816109' },
  { value: 'mirzachowki', label: 'Mirzachowki', pincode: '813208' },
  { value: 'motipahari', label: 'Motipahari', pincode: '816120' },
  { value: 'pathna', label: 'Pathna', pincode: '816110' },
  { value: 'rajmahal', label: 'Rajmahal', pincode: '816108' },
  { value: 'sakrigali-ghat', label: 'Sakrigali Ghat', pincode: '816115' },
  { value: 'sahibganj', label: 'Sahibganj', pincode: '816109' },
  { value: 'sahibganj-college', label: 'Sahibganj College', pincode: '816109' },
  { value: 'sahibganj-court', label: 'Sahibganj Court', pincode: '816109' },
  { value: 'taljhari', label: 'Taljhari', pincode: '816129' },
  { value: 'udhwa', label: 'Udhwa', pincode: '816108' }
  ],

  // Mumbai Areas
  'nashik': [
    { value: 'abhiyanta-nagar', label: 'Abhiyanta Nagar', pincode: '422008' },
    { value: 'adgaon', label: 'Adgaon', pincode: '422101' },
    { value: 'ambad', label: 'Ambad', pincode: '422010' },
    { value: 'ambad-link-road', label: 'Ambad Link Road', pincode: '422010' },
    { value: 'ambedkar-nagar', label: 'Ambedkar Nagar', pincode: '422008' },
    { value: 'amrutdham', label: 'Amrutdham', pincode: '422010' },
    { value: 'anand-nagar', label: 'Anand Nagar', pincode: '422009' },
    { value: 'anandvalli', label: 'Anandvalli', pincode: '422003' },
    { value: 'ashwin-nagar', label: 'Ashwin Nagar', pincode: '422009' },
    { value: 'aurangabad-road', label: 'Aurangabad Road', pincode: '422001' },
    { value: 'ayodhya-nagari', label: 'Ayodhya Nagari', pincode: '422003' },
    { value: 'belgaon-dhaga', label: 'Belgaon Dhaga', pincode: '422305' },
    { value: 'bhabha-nagar', label: 'Bhabha Nagar', pincode: '422006' },
    { value: 'bhagur', label: 'Bhagur', pincode: '422502' },
    { value: 'bhausahebnagar', label: 'Bhausahebnagar', pincode: '422013' },
    { value: 'buddha-vihar', label: 'Buddha Vihar', pincode: '422005' },
    { value: 'canada-corner', label: 'Canada Corner', pincode: '422002' },
    { value: 'chandshi', label: 'Chandshi', pincode: '422215' },
    { value: 'chandwad', label: 'Chandwad', pincode: '423101' },
    { value: 'chetana-nagar', label: 'Chetana Nagar', pincode: '422008' },
    { value: 'chinchkhed', label: 'Chinchkhed', pincode: '422207' },
    { value: 'chincholi', label: 'Chincholi', pincode: '422204' },
    { value: 'chunchale', label: 'Chunchale', pincode: '422213' },
    { value: 'cidco', label: 'CIDCO', pincode: '422009' },
    { value: 'college-road', label: 'College Road', pincode: '422005' },
    { value: 'd.k-nagar', label: 'D. K. Nagar', pincode: '422007' },
    { value: 'dasak', label: 'Dasak', pincode: '422213' },
    { value: 'deepali-nagar', label: 'Deepali Nagar', pincode: '422009' },
    { value: 'deolali-gaon', label: 'Deolali Gaon', pincode: '422401' },
    { value: 'devgaon', label: 'Devgaon', pincode: '422214' },
    { value: 'devlali', label: 'Devlali', pincode: '422401' },
    { value: 'dgp-nagar', label: 'DGP Nagar', pincode: '422002' },
    { value: 'dindori', label: 'Dindori', pincode: '422202' },
    { value: 'dindori-road', label: 'Dindori Road', pincode: '422202' },
    { value: 'dsouza-colony', label: 'DSouza Colony', pincode: '422005' },
    { value: 'dwarka', label: 'Dwarka', pincode: '422011' },
    { value: 'ekdant-nagar', label: 'Ekdant Nagar', pincode: '422010' },
    { value: 'eklahare', label: 'Eklahare', pincode: '422105' },
    { value: 'gandhi-nagar-airport-area', label: 'Gandhi Nagar Airport Area', pincode: '422003' },
    { value: 'ganesh-baba-nagar', label: 'Ganesh Baba Nagar', pincode: '422010' },
    { value: 'gangapur-road', label: 'Gangapur Road', pincode: '422013' },
    { value: 'ganjmal', label: 'Ganjmal', pincode: '422001' },
    { value: 'gayakhe-colony', label: 'Gayakhe Colony', pincode: '422004' },
    { value: 'general-vaidya-nagar', label: 'General Vaidya Nagar', pincode: '422005' },
    { value: 'ghoti-budrak', label: 'Ghoti Budrak', pincode: '422402' },
    { value: 'girnare', label: 'Girnare', pincode: '422302' },
    { value: 'gondedumala', label: 'Gondedumala', pincode: '422213' },
    { value: 'gotane-wada', label: 'Gotane Wada', pincode: '422213' },
    { value: 'government-colony', label: 'Government Colony', pincode: '422009' },
    { value: 'govind-nagar', label: 'Govind Nagar', pincode: '422002' },
    { value: 'hanuman-nagar', label: 'Hanuman Nagar', pincode: '422002' },
    { value: 'hirawadi', label: 'Hirawadi', pincode: '422009' },
    { value: 'homi-bhabha-nagar', label: 'Homi Bhabha Nagar', pincode: '422006' },
    { value: 'igatpuri', label: 'Igatpuri', pincode: '422403' },
    { value: 'indira-nagar', label: 'Indira Nagar', pincode: '422009' },
    { value: 'jagtap-nagar', label: 'Jagtap Nagar', pincode: '422010' },
    { value: 'jai-bhavani-road', label: 'Jai Bhavani Road', pincode: '422213' },
    { value: 'jail-road', label: 'Jail Road', pincode: '422002' },
    { value: 'kalpataru-nagar', label: 'Kalpataru Nagar', pincode: '422008' },
    { value: 'kamatwade', label: 'Kamatwade', pincode: '422008' },
    { value: 'kamod-nagar', label: 'Kamod Nagar', pincode: '422008' },
    { value: 'karmayogi-nagar', label: 'Karmayogi Nagar', pincode: '422009' },
    { value: 'khode-nagar', label: 'Khode Nagar', pincode: '422005' },
    { value: 'khutwad-nagar', label: 'Khutwad Nagar', pincode: '422002' },
    { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '422008' },
    { value: 'lam-road', label: 'Lam Road', pincode: '422007' },
    { value: 'lekha-nagar', label: 'Lekha Nagar', pincode: '422009' },
    { value: 'madsangavi', label: 'Madsangavi', pincode: '422202' },
    { value: 'mahatma-nagar', label: 'Mahatma Nagar', pincode: '422002' },
    { value: 'makhmalabad-road', label: 'Makhmalabad Road', pincode: '422003' },
    { value: 'malegaon', label: 'Malegaon', pincode: '423203' },
    { value: 'manegaon', label: 'Manegaon', pincode: '422101' },
    { value: 'manmad', label: 'Manmad', pincode: '423104' },
    { value: 'medage-nagar', label: 'Medage Nagar', pincode: '422101' },
    { value: 'meri', label: 'MERI', pincode: '422010' },
    { value: 'meri-rasbihari-link-road', label: 'MERI Rasbihari Link Road', pincode: '422010' },
    { value: 'mhasrul-gaon', label: 'Mhasrul Gaon', pincode: '422004' },
    { value: 'midc-ambad', label: 'MIDC Ambad', pincode: '422010' },
    { value: 'mohadi', label: 'Mohadi', pincode: '422102' },
    { value: 'mohan-nagar', label: 'Mohan Nagar', pincode: '422009' },
    { value: 'mumbai-agra-road', label: 'Mumbai Agra Road', pincode: '422001' },
    { value: 'mumbai-nashik-highway', label: 'Mumbai Nashik Highway', pincode: '422010' },
    { value: 'mundhegaon', label: 'Mundhegaon', pincode: '422210' },
    { value: 'nagalwadi', label: 'Nagalwadi', pincode: '422106' },
    { value: 'nagarsul', label: 'Nagarsul', pincode: '423204' },
    { value: 'nashik-road', label: 'Nashik Road', pincode: '422101' },
    { value: 'nashik-pune-road', label: 'Nashik-Pune Road', pincode: '422006' },
    { value: 'new-pandit-colony', label: 'New Pandit Colony', pincode: '422009' },
    { value: 'nilwandi', label: 'Nilwandi', pincode: '422204' },
    { value: 'niphad', label: 'Niphad', pincode: '422303' },
    { value: 'ojhar', label: 'Ojhar', pincode: '422206' },
    { value: 'old-agra-road', label: 'Old Agra Road', pincode: '422009' },
    { value: 'om-nagar', label: 'Om Nagar', pincode: '422009' },
    { value: 'p-and-t-colony', label: 'P and T Colony', pincode: '422002' },
    { value: 'panchavati', label: 'Panchavati', pincode: '422003' },
    { value: 'pandit-colony', label: 'Pandit Colony', pincode: '422003' },
    { value: 'parijat-nagar', label: 'Parijat Nagar', pincode: '422009' },
    { value: 'patharadi-road', label: 'Patharadi Road', pincode: '422306' },
    { value: 'pathardi', label: 'Pathardi', pincode: '422307' },
    { value: 'pathardi-phata', label: 'Pathardi Phata', pincode: '422306' },
    { value: 'patil-nagar', label: 'Patil Nagar', pincode: '422008' },
    { value: 'pawan-nagar', label: 'Pawan Nagar', pincode: '422009' },
    { value: 'peth-road', label: 'Peth Road', pincode: '422003' },
    { value: 'pimpalgaon-baswant', label: 'Pimpalgaon Baswant', pincode: '422209' },
    { value: 'pimplad', label: 'Pimplad', pincode: '422101' },
    { value: 'prabhat-colony', label: 'Prabhat Colony', pincode: '422009' },
    { value: 'rajiv-nagar', label: 'Rajiv Nagar', pincode: '422002' },
    { value: 'rajur-bahula', label: 'Rajur Bahula', pincode: '422206' },
    { value: 'ram-wadi', label: 'Ram Wadi', pincode: '422002' },
    { value: 'rane-nagar', label: 'Rane Nagar', pincode: '422002' },
    { value: 'rasegaon', label: 'Rasegaon', pincode: '422207' },
    { value: 'renuka-nagar', label: 'Renuka Nagar', pincode: '422009' },
    { value: 'sadguru-nagar', label: 'Sadguru Nagar', pincode: '422008' },
    { value: 'samarth-nagar', label: 'Samarth Nagar', pincode: '422013' },
    { value: 'sane-guruji-nagar', label: 'Sane Guruji Nagar', pincode: '422013' },
    { value: 'satpur', label: 'Satpur', pincode: '422007' },
    { value: 'savata-nagar', label: 'Savata Nagar', pincode: '422003' },
    { value: 'sawarkar-nagar', label: 'Sawarkar Nagar', pincode: '422011' },
    { value: 'shalimar', label: 'Shalimar', pincode: '422001' },
    { value: 'sharanpur', label: 'Sharanpur', pincode: '422002' },
    { value: 'shinde', label: 'Shinde', pincode: '422001' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '422009' },
    { value: 'shivshakti-nagar', label: 'Shivshakti Nagar', pincode: '422009' },
    { value: 'shramik-nagar', label: 'Shramik Nagar', pincode: '422009' },
    { value: 'shreerang-nagar', label: 'Shreerang Nagar', pincode: '422008' },
    { value: 'shri-ram-colony', label: 'Shri Ram Colony', pincode: '422003' },
    { value: 'sinnar', label: 'Sinnar', pincode: '422103' },
    { value: 'sneha-nagar', label: 'Sneha Nagar', pincode: '422009' },
    { value: 'sobhag-nagar', label: 'Sobhag Nagar', pincode: '422003' },
    { value: 'someshwar-colony', label: 'Someshwar Colony', pincode: '422010' },
    { value: 'swaminarayan-nagar', label: 'Swaminarayan Nagar', pincode: '422007' },
    { value: 'tagore-nagar', label: 'Tagore Nagar', pincode: '422005' },
    { value: 'tapovan-road', label: 'Tapovan Road', pincode: '422007' },
    { value: 'thatte-nagar', label: 'Thatte Nagar', pincode: '422008' },
    { value: 'tidke-colony', label: 'Tidke Colony', pincode: '422009' },
    { value: 'tidke-nagar', label: 'Tidke Nagar', pincode: '422009' },
    { value: 'trimbak', label: 'Trimbak', pincode: '422212' },
    { value: 'trimbak-road', label: 'Trimbak Road', pincode: '422212' },
    { value: 'untwadi', label: 'Untwadi', pincode: '422202' },
    { value: 'upendra-nagar-colony', label: 'Upendra Nagar Colony', pincode: '422009' },
    { value: 'upnagar', label: 'Upnagar', pincode: '422008' },
    { value: 'uttara-nagar', label: 'Uttara Nagar', pincode: '422009' },
    { value: 'vaiduwadi', label: 'Vaiduwadi', pincode: '422003' },
    { value: 'vaitarna-nagar', label: 'Vaitarna Nagar', pincode: '422401' },
    { value: 'vani', label: 'Vani', pincode: '422214' },
    { value: 'vihitgaon', label: 'Vihitgaon', pincode: '422208' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '422005' },
    { value: 'vinay-nagar', label: 'Vinay Nagar', pincode: '422008' },
    { value: 'wadala-gaon', label: 'Wadala Gaon', pincode: '422101' },
    { value: 'wadner-road', label: 'Wadner Road', pincode: '422206' },
    { value: 'wavi', label: 'Wavi', pincode: '422306' },
    { value: 'yeola', label: 'Yeola', pincode: '423401' },
    { value: 'yeolekar-mala', label: 'Yeolekar Mala', pincode: '423106' }
  ],

  'gondiya': [
    { value: 'adgaon', label: 'Adgaon', pincode: '441601' },
    { value: 'adivasi-colony', label: 'Adivasi Colony', pincode: '441623' },
    { value: 'baranjala', label: 'Baranjala', pincode: '441602' },
    { value: 'bavkheda', label: 'Bavkheda', pincode: '441603' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '441604' },
    { value: 'bhivpur-bk', label: 'Bhivpur BK', pincode: '441622' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '441605' },
    { value: 'chaprala', label: 'Chaprala', pincode: '441626' },
    { value: 'chinchbhuwan', label: 'Chinchbhuwan', pincode: '441629' },
    { value: 'dabhadi', label: 'Dabhadi', pincode: '441606' },
    { value: 'dongergaon', label: 'Dongergaon', pincode: '441624' },
    { value: 'garampada', label: 'Garampada', pincode: '441630' },
    { value: 'gokulwadi', label: 'Gokulwadi', pincode: '441607' },
    { value: 'gondiya', label: 'Gondiya', pincode: '441601' },
    { value: 'jalgaon', label: 'Jalgaon', pincode: '441608' },
    { value: 'kachner', label: 'Kachner', pincode: '441625' },
    { value: 'kamla-nagar', label: 'Kamla Nagar', pincode: '441609' },
    { value: 'khadki', label: 'Khadki', pincode: '441610' },
    { value: 'kurkheda', label: 'Kurkheda', pincode: '441611' },
    { value: 'malkapur', label: 'Malkapur', pincode: '441612' },
    { value: 'manegaon', label: 'Manegaon', pincode: '441613' },
    { value: 'mohadi', label: 'Mohadi', pincode: '441631' },
    { value: 'pathri', label: 'Pathri', pincode: '441627' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '441614' },
    { value: 'pimpalgaon-bk', label: 'Pimpalgaon BK', pincode: '441632' },
    { value: 'rahanpur', label: 'Rahanpur', pincode: '441615' },
    { value: 'rajanpur', label: 'Rajanpur', pincode: '441616' },
    { value: 'shiraswadi', label: 'Shiraswadi', pincode: '441617' },
    { value: 'tadavi', label: 'Tadavi', pincode: '441628' },
    { value: 'tahsil', label: 'Tahsil', pincode: '441618' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '441621' },
    { value: 'warikheda', label: 'Warikheda', pincode: '441633' },
    { value: 'warora', label: 'Warora', pincode: '441619' },
    { value: 'warud', label: 'Warud', pincode: '441620' }
  ],

  'thane': [
    { value: 'abhay-nagar', label: 'Abhay Nagar', pincode: '400601' },
    { value: 'agashi', label: 'Agashi', pincode: '401301' },
    { value: 'dombivli', label: 'Dombivli', pincode: '421201' },
    { value: 'dombivli-east', label: 'Dombivli East', pincode: '421201' },
    { value: 'dombivli-west', label: 'Dombivli West', pincode: '421202' },
    { value: 'gaon-bhiwandi', label: 'Gaon Bhiwandi', pincode: '421302' },
    { value: 'ghatkopar', label: 'Ghatkopar', pincode: '400077' },
    { value: 'kalwa', label: 'Kalwa', pincode: '400605' },
    { value: 'kalyan', label: 'Kalyan', pincode: '421301' },
    { value: 'khadakpada', label: 'Khadakpada', pincode: '421301' },
    { value: 'kharbao', label: 'Kharbao', pincode: '421302' },
    { value: 'kolsewadi', label: 'Kolsewadi', pincode: '421205' },
    { value: 'kopar-khairane', label: 'Kopar Khairane', pincode: '400709' },
    { value: 'lokpur', label: 'Lokpur', pincode: '421301' },
    { value: 'mankhurd', label: 'Mankhurd', pincode: '400088' },
    { value: 'manpada', label: 'Manpada', pincode: '421204' },
    { value: 'mira-bhayandar', label: 'Mira Bhayandar', pincode: '401107' },
    { value: 'mumbra', label: 'Mumbra', pincode: '400612' },
    { value: 'nashik-pada', label: 'Nashik Pada', pincode: '401208' },
    { value: 'naupada', label: 'Naupada', pincode: '400602' },
    { value: 'padmawati', label: 'Padmawati', pincode: '421205' },
    { value: 'pimparkheda', label: 'Pimparkheda', pincode: '401501' },
    { value: 'purna', label: 'Purna', pincode: '421202' },
    { value: 'shahad', label: 'Shahad', pincode: '421103' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '421204' },
    { value: 'thane-east', label: 'Thane East', pincode: '400603' },
    { value: 'thane-west', label: 'Thane West', pincode: '400607' },
    { value: 'taloja', label: 'Taloja', pincode: '410208' },
    { value: 'ulhasnagar', label: 'Ulhasnagar', pincode: '421004' },
    { value: 'vithalwadi', label: 'Vithalwadi', pincode: '421306' },
    { value: 'wagle-estate', label: 'Wagle Estate', pincode: '400604' }
  ],

  'solapur': [
    { value: 'adgaon', label: 'Adgaon', pincode: '413001' },
    { value: 'bangarwadi', label: 'Bangarwadi', pincode: '413022' },
    { value: 'babhulgaon', label: 'Babhulgaon', pincode: '413002' },
    { value: 'baranjala', label: 'Baranjala', pincode: '413003' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '413004' },
    { value: 'bhivpur-kh', label: 'Bhivpur Kh', pincode: '413023' },
    { value: 'dhotre', label: 'Dhotre', pincode: '413005' },
    { value: 'indapur', label: 'Indapur', pincode: '413006' },
    { value: 'karad', label: 'Karad', pincode: '413007' },
    { value: 'karmala', label: 'Karmala', pincode: '413008' },
    { value: 'khandavi', label: 'Khandavi', pincode: '413024' },
    { value: 'kotwade', label: 'Kotwade', pincode: '413009' },
    { value: 'mangalwar', label: 'Mangalwar', pincode: '413010' },
    { value: 'manegaon', label: 'Manegaon', pincode: '413025' },
    { value: 'murum', label: 'Murum', pincode: '413011' },
    { value: 'nagaon', label: 'Nagaon', pincode: '413012' },
    { value: 'nimbala', label: 'Nimbala', pincode: '413026' },
    { value: 'pachora', label: 'Pachora', pincode: '413027' },
    { value: 'padmawati', label: 'Padmawati', pincode: '413013' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '413014' },
    { value: 'rahata', label: 'Rahata', pincode: '413015' },
    { value: 'rupalwadi', label: 'Rupalwadi', pincode: '413028' },
    { value: 'shivapur', label: 'Shivapur', pincode: '413029' },
    { value: 'solapur-cantonment', label: 'Solapur Cantonment', pincode: '413016' },
    { value: 'solapur-urban', label: 'Solapur Urban', pincode: '413017' },
    { value: 'turkapada', label: 'Turkapada', pincode: '413018' },
    { value: 'vadgaon', label: 'Vadgaon', pincode: '413019' },
    { value: 'wathar', label: 'Wathar', pincode: '413020' },
    { value: 'yeola', label: 'Yeola', pincode: '413021' }
  ],

  'satara': [
    { value: 'adgaon', label: 'Adgaon', pincode: '415001' },
    { value: 'alapur', label: 'Alapur', pincode: '415002' },
    { value: 'banegaon', label: 'Banegaon', pincode: '415003' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '415004' },
    { value: 'borgaon', label: 'Borgaon', pincode: '415005' },
    { value: 'chaudhariwadi', label: 'Chaudhariwadi', pincode: '415006' },
    { value: 'dahiwadi', label: 'Dahiwadi', pincode: '415007' },
    { value: 'jambhali', label: 'Jambhali', pincode: '415008' },
    { value: 'karde', label: 'Karde', pincode: '415009' },
    { value: 'karad', label: 'Karad', pincode: '415010' },
    { value: 'khandala', label: 'Khandala', pincode: '415011' },
    { value: 'kharsundi', label: 'Kharsundi', pincode: '415012' },
    { value: 'kotwali', label: 'Kotwali', pincode: '415013' },
    { value: 'mahasadi', label: 'Mahasadi', pincode: '415014' },
    { value: 'mapgaon', label: 'Mapgaon', pincode: '415015' },
    { value: 'maswad', label: 'Maswad', pincode: '415016' },
    { value: 'pusegaon', label: 'Pusegaon', pincode: '415017' },
    { value: 'satara-cantonment', label: 'Satara Cantonment', pincode: '415018' },
    { value: 'satara-urban', label: 'Satara Urban', pincode: '415019' },
    { value: 'shindewadi', label: 'Shindewadi', pincode: '415020' },
    { value: 'yavapur', label: 'Yavapur', pincode: '415021' },
    { value: 'bhivpur-kh', label: 'Bhivpur Kh', pincode: '415022' },
    { value: 'gavhan', label: 'Gavhan', pincode: '415023' },
    { value: 'garadwadi', label: 'Garadwadi', pincode: '415024' },
    { value: 'kekavati', label: 'Kekavati', pincode: '415025' },
    { value: 'rahata', label: 'Rahata', pincode: '415026' },
    { value: 'savangi', label: 'Savangi', pincode: '415027' },
    { value: 'tirani', label: 'Tirani', pincode: '415028' },
    { value: 'vadgaon', label: 'Vadgaon', pincode: '415029' },
    { value: 'wathar', label: 'Wathar', pincode: '415030' },
    { value: 'kudwa', label: 'Kudwa', pincode: '415031' },
    { value: 'pachwad', label: 'Pachwad', pincode: '415032' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '415033' },
    { value: 'rajapur', label: 'Rajapur', pincode: '415034' }
  ],

  'osmanabad': [
    { value: 'adgaon', label: 'Adgaon', pincode: '413503' },
    { value: 'alapur', label: 'Alapur', pincode: '413501' },
    { value: 'banegaon', label: 'Banegaon', pincode: '413502' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '413505' },
    { value: 'bhorkheda', label: 'Bhorkheda', pincode: '413525' },
    { value: 'dhamangaon', label: 'Dhamangaon', pincode: '413504' },
    { value: 'gajanan-nagar', label: 'Gajanan Nagar', pincode: '413520' },
    { value: 'goregaon', label: 'Goregaon', pincode: '413524' },
    { value: 'gurpur', label: 'Gurpur', pincode: '413506' },
    { value: 'jalgaon', label: 'Jalgaon', pincode: '413521' },
    { value: 'kallapur', label: 'Kallapur', pincode: '413507' },
    { value: 'kamthi', label: 'Kamthi', pincode: '413508' },
    { value: 'karkheda', label: 'Karkheda', pincode: '413509' },
    { value: 'khamgaon', label: 'Khamgaon', pincode: '413528' },
    { value: 'malkapur', label: 'Malkapur', pincode: '413510' },
    { value: 'manegaon', label: 'Manegaon', pincode: '413511' },
    { value: 'nanded', label: 'Nanded', pincode: '413512' },
    { value: 'parli', label: 'Parli', pincode: '413513' },
    { value: 'rahimabad', label: 'Rahimabad', pincode: '413514' },
    { value: 'rukhadi', label: 'Rukhadi', pincode: '413515' },
    { value: 'sherpur', label: 'Sherpur', pincode: '413516' },
    { value: 'varkheda', label: 'Varkheda', pincode: '413527' },
    { value: 'vijaynagar', label: 'Vijaynagar', pincode: '413522' },
    { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '413526' },
    { value: 'wadhona', label: 'Wadhona', pincode: '413517' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '413518' },
    { value: 'wanjari', label: 'Wanjari', pincode: '413529' },
    { value: 'yewalawadi', label: 'Yewalawadi', pincode: '413519' },
    { value: 'zari', label: 'Zari', pincode: '413523' }
  ],

  'nanded': [
    { value: 'adhapur', label: 'Adhapur', pincode: '431605' },
    { value: 'baranjala', label: 'Baranjala', pincode: '431628' },
    { value: 'belura', label: 'Belura', pincode: '431629' },
    { value: 'bhorkheda', label: 'Bhorkheda', pincode: '431607' },
    { value: 'bhorkheda-kh', label: 'Bhorkheda Kh', pincode: '431630' },
    { value: 'boradi', label: 'Boradi', pincode: '431608' },
    { value: 'chandpur', label: 'Chandpur', pincode: '431610' },
    { value: 'gajanan-nagar', label: 'Gajanan Nagar', pincode: '431611' },
    { value: 'godamba', label: 'Godamba', pincode: '431631' },
    { value: 'gokul-nagar', label: 'Gokul Nagar', pincode: '431612' },
    { value: 'jambhli', label: 'Jambhli', pincode: '431613' },
    { value: 'karmad', label: 'Karmad', pincode: '431614' },
    { value: 'khandala', label: 'Khandala', pincode: '431632' },
    { value: 'kolapur', label: 'Kolapur', pincode: '431615' },
    { value: 'latur', label: 'Latur', pincode: '431616' },
    { value: 'malkapur', label: 'Malkapur', pincode: '431618' },
    { value: 'manegaon', label: 'Manegaon', pincode: '431617' },
    { value: 'mirzapada', label: 'Mirzapada', pincode: '431633' },
    { value: 'mubarakpur', label: 'Mubarakpur', pincode: '431634' },
    { value: 'nagaon', label: 'Nagaon', pincode: '431619' },
    { value: 'pangri', label: 'Pangri', pincode: '431635' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '431620' },
    { value: 'pimpalgaon-rs', label: 'Pimpalgaon RS', pincode: '431636' },
    { value: 'rahata', label: 'Rahata', pincode: '431621' },
    { value: 'satara', label: 'Satara', pincode: '431622' },
    { value: 'shiraswadi', label: 'Shiraswadi', pincode: '431637' },
    { value: 'sonala', label: 'Sonala', pincode: '431623' },
    { value: 'vijaypur', label: 'Vijaypur', pincode: '431638' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '431625' },
    { value: 'wadgaon-bk', label: 'Wadgaon BK', pincode: '431626' },
    { value: 'warora', label: 'Warora', pincode: '431624' },
    { value: 'yewala', label: 'Yewala', pincode: '431627' }
  ],

  'latur': [
    { value: 'adgaon', label: 'Adgaon', pincode: '413512' },
    { value: 'alapur', label: 'Alapur', pincode: '413501' },
    { value: 'ankapur', label: 'Ankapur', pincode: '413543' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '413544' },
    { value: 'bhorkheda', label: 'Bhorkheda', pincode: '413503' },
    { value: 'borgaon', label: 'Borgaon', pincode: '413504' },
    { value: 'chandapur', label: 'Chandapur', pincode: '413505' },
    { value: 'gajanan-nagar', label: 'Gajanan Nagar', pincode: '413506' },
    { value: 'gokul-nagar', label: 'Gokul Nagar', pincode: '413545' },
    { value: 'jambhli', label: 'Jambhli', pincode: '413507' },
    { value: 'karmad', label: 'Karmad', pincode: '413508' },
    { value: 'kolapur', label: 'Kolapur', pincode: '413509' },
    { value: 'latur', label: 'Latur', pincode: '413531' },
    { value: 'madhapur', label: 'Madhapur', pincode: '413546' },
    { value: 'malkapur', label: 'Malkapur', pincode: '413533' },
    { value: 'manegaon', label: 'Manegaon', pincode: '413532' },
    { value: 'mirajpur', label: 'Mirajpur', pincode: '413547' },
    { value: 'nagaon', label: 'Nagaon', pincode: '413534' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '413535' },
    { value: 'pimpalwadi', label: 'Pimpalwadi', pincode: '413548' },
    { value: 'rahata', label: 'Rahata', pincode: '413536' },
    { value: 'satara', label: 'Satara', pincode: '413537' },
    { value: 'sonala', label: 'Sonala', pincode: '413538' },
    { value: 'sugli', label: 'Sugli', pincode: '413549' },
    { value: 'tarsai', label: 'Tarsai', pincode: '413550' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '413540' },
    { value: 'wadgaon-bk', label: 'Wadgaon BK', pincode: '413541' },
    { value: 'wadgaon-tq', label: 'Wadgaon TQ', pincode: '413551' },
    { value: 'wangi', label: 'Wangi', pincode: '413552' },
    { value: 'warora', label: 'Warora', pincode: '413539' },
    { value: 'yewala', label: 'Yewala', pincode: '413542' }
  ],

  'kolhapur': [
    { value: 'adgaon', label: 'Adgaon', pincode: '416001' },
    { value: 'alapur', label: 'Alapur', pincode: '416002' },
    { value: 'babhulgaon', label: 'Babhulgaon', pincode: '416003' },
    { value: 'bhorkheda', label: 'Bhorkheda', pincode: '416004' },
    { value: 'borkarwadi', label: 'Borkarwadi', pincode: '416024' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '416005' },
    { value: 'devpur', label: 'Devpur', pincode: '416006' },
    { value: 'gajanan-nagar', label: 'Gajanan Nagar', pincode: '416007' },
    { value: 'ghatkopar', label: 'Ghatkopar', pincode: '416008' },
    { value: 'gokul-shirgaon', label: 'Gokul Shirgaon', pincode: '416051' },
    { value: 'hadakhed', label: 'Hadakhed', pincode: '416055' },
    { value: 'kamathi', label: 'Kamathi', pincode: '416011' },
    { value: 'khandala', label: 'Khandala', pincode: '416012' },
    { value: 'kolhapur', label: 'Kolhapur', pincode: '416010' },
    { value: 'kothali', label: 'Kothali', pincode: '416013' },
    { value: 'malkapur', label: 'Malkapur', pincode: '416014' },
    { value: 'manegaon', label: 'Manegaon', pincode: '416015' },
    { value: 'nawali', label: 'Nawali', pincode: '416056' },
    { value: 'pachwad', label: 'Pachwad', pincode: '416054' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '416016' },
    { value: 'rajamala', label: 'Rajamala', pincode: '416053' },
    { value: 'rahata', label: 'Rahata', pincode: '416017' },
    { value: 'sakharpa', label: 'Sakharpa', pincode: '416057' },
    { value: 'satara', label: 'Satara', pincode: '416018' },
    { value: 'sawantwadi', label: 'Sawantwadi', pincode: '416019' },
    { value: 'shirgaon', label: 'Shirgaon', pincode: '416052' },
    { value: 'tarsai', label: 'Tarsai', pincode: '416058' },
    { value: 'tq-kolhapur', label: 'TQ Kolhapur', pincode: '416020' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '416022' },
    { value: 'wadgaon-bk', label: 'Wadgaon BK', pincode: '416023' },
    { value: 'warora', label: 'Warora', pincode: '416021' },
    { value: 'yewala', label: 'Yewala', pincode: '416025' }
  ],

  'jalna': [
    { value: 'adgaon', label: 'Adgaon', pincode: '431201' },
    { value: 'alapur', label: 'Alapur', pincode: '431202' },
    { value: 'babhulgaon', label: 'Babhulgaon', pincode: '431203' },
    { value: 'bandhanwadi', label: 'Bandhanwadi', pincode: '431225' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '431227' },
    { value: 'bhorkheda', label: 'Bhorkheda', pincode: '431204' },
    { value: 'chandpur', label: 'Chandpur', pincode: '431205' },
    { value: 'dhamangaon', label: 'Dhamangaon', pincode: '431206' },
    { value: 'gajanan-nagar', label: 'Gajanan Nagar', pincode: '431222' },
    { value: 'ghansawangi', label: 'Ghansawangi', pincode: '431207' },
    { value: 'jalna', label: 'Jalna', pincode: '431001' },
    { value: 'kalamb', label: 'Kalamb', pincode: '431226' },
    { value: 'kamthi', label: 'Kamthi', pincode: '431208' },
    { value: 'khamgaon', label: 'Khamgaon', pincode: '431223' },
    { value: 'khandvi', label: 'Khandvi', pincode: '431209' },
    { value: 'malkapur', label: 'Malkapur', pincode: '431210' },
    { value: 'manegaon', label: 'Manegaon', pincode: '431211' },
    { value: 'manikpur', label: 'Manikpur', pincode: '431221' },
    { value: 'nepaliwadi', label: 'Nepaliwadi', pincode: '431228' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '431212' },
    { value: 'pimpalgaon-bk', label: 'Pimpalgaon BK', pincode: '431224' },
    { value: 'pimpalwadi', label: 'Pimpalwadi', pincode: '431230' },
    { value: 'rahata', label: 'Rahata', pincode: '431213' },
    { value: 'sant-nagar', label: 'Sant Nagar', pincode: '431214' },
    { value: 'shahabad', label: 'Shahabad', pincode: '431215' },
    { value: 'sonala', label: 'Sonala', pincode: '431216' },
    { value: 'tq-jalna', label: 'TQ Jalna', pincode: '431220' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '431218' },
    { value: 'wadgaon-bk', label: 'Wadgaon BK', pincode: '431219' },
    { value: 'warora', label: 'Warora', pincode: '431217' },
    { value: 'yewala', label: 'Yewala', pincode: '431229' }
  ],

  'dhule': [
    { value: 'adhvay', label: 'Adhvay', pincode: '424001' },
    { value: 'alapur', label: 'Alapur', pincode: '424002' },
    { value: 'amkheda', label: 'Amkheda', pincode: '424003' },
    { value: 'babhulgaon', label: 'Babhulgaon', pincode: '424004' },
    { value: 'babhulgaon-bk', label: 'Babhulgaon BK', pincode: '424022' },
    { value: 'babhulgaon-tq', label: 'Babhulgaon TQ', pincode: '424029' },
    { value: 'bhorkheda', label: 'Bhorkheda', pincode: '424005' },
    { value: 'borvihir', label: 'Borvihir', pincode: '424023' },
    { value: 'chinchpada', label: 'Chinchpada', pincode: '424006' },
    { value: 'dandegaon', label: 'Dandegaon', pincode: '424028' },
    { value: 'dhamangaon', label: 'Dhamangaon', pincode: '424007' },
    { value: 'dhule', label: 'Dhule', pincode: '424001' },
    { value: 'gokulwadi', label: 'Gokulwadi', pincode: '424008' },
    { value: 'jalgaon', label: 'Jalgaon', pincode: '424009' },
    { value: 'khamgaon', label: 'Khamgaon', pincode: '424010' },
    { value: 'khadki', label: 'Khadki', pincode: '424030' },
    { value: 'khubgaon', label: 'Khubgaon', pincode: '424011' },
    { value: 'kurla', label: 'Kurla', pincode: '424031' },
    { value: 'malkapur', label: 'Malkapur', pincode: '424012' },
    { value: 'manegaon', label: 'Manegaon', pincode: '424013' },
    { value: 'mohadi', label: 'Mohadi', pincode: '424026' },
    { value: 'nehrunagar', label: 'Nehrunagar', pincode: '424024' },
    { value: 'niphad', label: 'Niphad', pincode: '424033' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '424014' },
    { value: 'rahata', label: 'Rahata', pincode: '424015' },
    { value: 'sardapur', label: 'Sardapur', pincode: '424021' },
    { value: 'shivpur', label: 'Shivpur', pincode: '424032' },
    { value: 'shiraswadi', label: 'Shiraswadi', pincode: '424016' },
    { value: 'sutarwadi', label: 'Sutarwadi', pincode: '424027' },
    { value: 'tahsil', label: 'Tahsil', pincode: '424025' },
    { value: 'talegaon', label: 'Talegaon', pincode: '424017' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '424018' },
    { value: 'warora', label: 'Warora', pincode: '424020' },
    { value: 'warud', label: 'Warud', pincode: '424019' }
  ],

  'chandrapur': [
    { value: 'adgaon', label: 'Adgaon', pincode: '442401' },
    { value: 'anvapada', label: 'Anvapada', pincode: '442402' },
    { value: 'babhulgaon', label: 'Babhulgaon', pincode: '442405' },
    { value: 'babhulgaon-bk', label: 'Babhulgaon BK', pincode: '442427' },
    { value: 'balapur', label: 'Balapur', pincode: '442403' },
    { value: 'belura', label: 'Belura', pincode: '442422' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '442404' },
    { value: 'borvihir', label: 'Borvihir', pincode: '442436' },
    { value: 'chatrapur', label: 'Chatrapur', pincode: '442428' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '442401' },
    { value: 'dhamangaon', label: 'Dhamangaon', pincode: '442406' },
    { value: 'dhanora', label: 'Dhanora', pincode: '442429' },
    { value: 'dongargaon', label: 'Dongargaon', pincode: '442423' },
    { value: 'gajanan-nagar', label: 'Gajanan Nagar', pincode: '442430' },
    { value: 'gokulwadi', label: 'Gokulwadi', pincode: '442407' },
    { value: 'jalgaon', label: 'Jalgaon', pincode: '442408' },
    { value: 'jambhli', label: 'Jambhli', pincode: '442431' },
    { value: 'khamgaon', label: 'Khamgaon', pincode: '442409' },
    { value: 'khadki', label: 'Khadki', pincode: '442425' },
    { value: 'khata', label: 'Khata', pincode: '442410' },
    { value: 'khodala', label: 'Khodala', pincode: '442432' },
    { value: 'kothali', label: 'Kothali', pincode: '442411' },
    { value: 'kurkheda', label: 'Kurkheda', pincode: '442433' },
    { value: 'malkapur', label: 'Malkapur', pincode: '442412' },
    { value: 'manegaon', label: 'Manegaon', pincode: '442413' },
    { value: 'nehrunagar', label: 'Nehrunagar', pincode: '442426' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '442414' },
    { value: 'pimpalgaon-bk', label: 'Pimpalgaon BK', pincode: '442435' },
    { value: 'rahata', label: 'Rahata', pincode: '442415' },
    { value: 'sardapur', label: 'Sardapur', pincode: '442424' },
    { value: 'shahapur', label: 'Shahapur', pincode: '442434' },
    { value: 'shiraswadi', label: 'Shiraswadi', pincode: '442416' },
    { value: 'tahsil', label: 'Tahsil', pincode: '442421' },
    { value: 'talegaon', label: 'Talegaon', pincode: '442417' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '442418' },
    { value: 'warora', label: 'Warora', pincode: '442420' },
    { value: 'warud', label: 'Warud', pincode: '442419' }
  ],
  'eluru': [
    { value: 'adda', label: 'Adda', pincode: '534001' },
    { value: 'bhimavaram', label: 'Bhimavaram', pincode: '534202' },
    { value: 'budampudi', label: 'Budampudi', pincode: '534001' },
    { value: 'chintalapudi', label: 'Chintalapudi', pincode: '534002' },
    { value: 'eluru-city', label: 'Eluru City', pincode: '534001' },
    { value: 'gavarapalli', label: 'Gavarapalli', pincode: '534001' },
    { value: 'jampet', label: 'Jampet', pincode: '534001' },
    { value: 'jeedimellanka', label: 'Jeedimellanka', pincode: '534001' },
    { value: 'kankatapalem', label: 'Kankatapalem', pincode: '534001' },
    { value: 'kothapet', label: 'Kothapet', pincode: '534002' },
    { value: 'krishnalanka', label: 'Krishnalanka', pincode: '534001' },
    { value: 'malkapuram', label: 'Malkapuram', pincode: '534002' },
    { value: 'marripalem', label: 'Marripalem', pincode: '534001' },
    { value: 'nagaram', label: 'Nagaram', pincode: '534001' },
    { value: 'palakollu', label: 'Palakollu', pincode: '534260' },
    { value: 'pandurangapuram', label: 'Pandurangapuram', pincode: '534001' },
    { value: 'peddagudem', label: 'Peddagudem', pincode: '534001' },
    { value: 'sadar', label: 'Sadar', pincode: '534001' },
    { value: 'sri-ramachandrapuram', label: 'Sri Ramachandrapuram', pincode: '534001' },
    { value: 'sri-kantipudi', label: 'Sri Kantipudi', pincode: '534001' },
    { value: 'tadikalapudi', label: 'Tadikalapudi', pincode: '534001' },
    { value: 'vempadu', label: 'Vempadu', pincode: '534003' },
    { value: 'vijayanagaram', label: 'Vijayanagaram', pincode: '534003' },
    { value: 'chodavaram', label: 'Chodavaram', pincode: '534214' },
    { value: 'ganeshpuram', label: 'Ganeshpuram', pincode: '534007' },
    { value: 'kambham', label: 'Kambham', pincode: '534008' },
    { value: 'kaniparru', label: 'Kaniparru', pincode: '534113' },
    { value: 'komatipalli', label: 'Komatipalli', pincode: '534141' },
    { value: 'peddapalem', label: 'Peddapalem', pincode: '534001' },
    { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '534105' },
    { value: 'reddivaripalem', label: 'Reddivaripalem', pincode: '534201' },
    { value: 'settipudi', label: 'Settipudi', pincode: '534114' },
    { value: 'thogarrajupeta', label: 'Thogarrajupeta', pincode: '534106' }
  ],

  'kadapa': [
    { value: 'anjaneya', label: 'Anjaneya', pincode: '516001' },
    { value: 'bairagipalle', label: 'Bairagipalle', pincode: '516216' },
    { value: 'bhairavakona', label: 'Bhairavakona', pincode: '516218' },
    { value: 'chinnakodur', label: 'Chinnakodur', pincode: '516001' },
    { value: 'chintakunta', label: 'Chintakunta', pincode: '516005' },
    { value: 'chowdaripalle', label: 'Chowdaripalle', pincode: '516009' },
    { value: 'kadapa-town', label: 'Kadapa Town', pincode: '516001' },
    { value: 'kondapur', label: 'Kondapur', pincode: '516150' },
    { value: 'kurichedu', label: 'Kurichedu', pincode: '516003' },
    { value: 'kurnool', label: 'Kurnool', pincode: '516001' },
    { value: 'nagalapuram', label: 'Nagalapuram', pincode: '516110' },
    { value: 'old-city', label: 'Old City', pincode: '516002' },
    { value: 'pulivendula', label: 'Pulivendula', pincode: '516390' },
    { value: 'ragimadugu', label: 'Ragimadugu', pincode: '516098' },
    { value: 'tadipatri', label: 'Tadipatri', pincode: '516325' },
    { value: 'vallur', label: 'Vallur', pincode: '516343' },
    { value: 'vempalle', label: 'Vempalle', pincode: '516126' },
    { value: 'yasvantapuram', label: 'Yasvantapuram', pincode: '516145' },
    { value: 'rajampet', label: 'Rajampet', pincode: '516115' },
    { value: 'jammalamadugu', label: 'Jammalamadugu', pincode: '516434' },
    { value: 'buddavarapeta', label: 'Buddavarapeta', pincode: '516001' },
    { value: 'nandaluru', label: 'Nandaluru', pincode: '516202' },
    { value: 'sriramnagar', label: 'Sriramnagar', pincode: '516017' },
    { value: 'mydukur', label: 'Mydukur', pincode: '516172' },
    { value: 'puttaparthi', label: 'Puttaparthi', pincode: '516124' },
    { value: 'penukonda', label: 'Penukonda', pincode: '516110' },
    { value: 'chandragiri', label: 'Chandragiri', pincode: '516213' },
    { value: 'mamillapalli', label: 'Mamillapalli', pincode: '516113' },
    { value: 'bogulakunta', label: 'Bogulakunta', pincode: '516161' }
  ],

  'kakinada': [
    { value: 'bhavanapadu', label: 'Bhavanapadu', pincode: '533003' },
    { value: 'gollalagunta', label: 'Gollalagunta', pincode: '533001' },
    { value: 'kakinada-town', label: 'Kakinada Town', pincode: '533001' },
    { value: 'kakinada-port', label: 'Kakinada Port', pincode: '533005' },
    { value: 'konthamuru', label: 'Konthamuru', pincode: '533001' },
    { value: 'malkapuram', label: 'Malkapuram', pincode: '533004' },
    { value: 'mummidivaram', label: 'Mummidivaram', pincode: '533216' },
    { value: 'neelampuram', label: 'Neelampuram', pincode: '533005' },
    { value: 'peddapuram', label: 'Peddapuram', pincode: '533437' },
    { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '533255' },
    { value: 'rajahmundry', label: 'Rajahmundry', pincode: '533101' },
    { value: 'sarpavaram', label: 'Sarpavaram', pincode: '533437' },
    { value: 'tuni', label: 'Tuni', pincode: '533401' },
    { value: 'veeravaram', label: 'Veeravaram', pincode: '533254' },
    { value: 'yellapudi', label: 'Yellapudi', pincode: '533223' },
    { value: 'agrapada', label: 'Agrapada', pincode: '533450' },
    { value: 'anandapuram', label: 'Anandapuram', pincode: '533106' },
    { value: 'gokavaram', label: 'Gokavaram', pincode: '533001' },
    { value: 'jaggampeta', label: 'Jaggampeta', pincode: '533233' },
    { value: 'kakinada-rural', label: 'Kakinada Rural', pincode: '533126' },
    { value: 'kotturu', label: 'Kotturu', pincode: '533005' },
    { value: 'pedaganjam', label: 'Pedaganjam', pincode: '533292' },
    { value: 'prakashapuram', label: 'Prakashapuram', pincode: '533233' },
    { value: 'sriharipuram', label: 'Sriharipuram', pincode: '533221' },
    { value: 'vakalapudi', label: 'Vakalapudi', pincode: '533007' },
    { value: 'veravasaram', label: 'Veravasaram', pincode: '533001' }
  ],
'gudivada': [
  { value: 'addepalli', label: 'Addepalli', pincode: '521301' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '521301' },
  { value: 'gandhi-gramam', label: 'Gandhi Gramam', pincode: '521301' },
  { value: 'gudivada', label: 'Gudivada', pincode: '521301' },
  { value: 'godavari', label: 'Godavari', pincode: '521332' },
  { value: 'guntupalli', label: 'Guntupalli', pincode: '521311' },
  { value: 'kesavan', label: 'Kesavan', pincode: '521332' },
  { value: 'muppalla', label: 'Muppalla', pincode: '521332' },
  { value: 'nakka', label: 'Nakka', pincode: '521301' },
  { value: 'penumudi', label: 'Penumudi', pincode: '521332' },
  { value: 'prakasam', label: 'Prakasam', pincode: '521301' },
  { value: 'rayanapadu', label: 'Rayanapadu', pincode: '521301' },
  { value: 'seethanagaram', label: 'Seethanagaram', pincode: '521313' },
  { value: 'suryarao-pet', label: 'Suryarao Pet', pincode: '521301' },
  { value: 'tharigoppula', label: 'Tharigoppula', pincode: '521332' },
  { value: 'tulasi-ganesh', label: 'Tulasi Ganesh', pincode: '521301' },
  { value: 'vallemugulapalli', label: 'Vallemugulapalli', pincode: '521332' },
  { value: 'venkatagiri', label: 'Venkatagiri', pincode: '521301' },
  { value: 'vijayanagaram', label: 'Vijayanagaram', pincode: '521332' },
  { value: 'vysya-bazar', label: 'Vysya Bazar', pincode: '521301' },
  { value: 'golla-pet', label: 'Golla Pet', pincode: '521301' },
  { value: 'balusumudi', label: 'Balusumudi', pincode: '521303' },
  { value: 'banagudi', label: 'Banagudi', pincode: '521312' },
  { value: 'vengamukkapadu', label: 'Vengamukkapadu', pincode: '521331' },
  { value: 'kesavanpeta', label: 'Kesavanpeta', pincode: '521332' },
  { value: 'kothapet', label: 'Kothapet', pincode: '521301' },
  { value: 'kappaladoddi', label: 'Kappaladoddi', pincode: '521331' },
  { value: 'korukollu', label: 'Korukollu', pincode: '521303' },
  ],

  'guntakal': [
  { value: 'achampet', label: 'Achampet', pincode: '515001' },
  { value: 'aluru', label: 'Aluru', pincode: '515001' },
  { value: 'angallu', label: 'Angallu', pincode: '515801' },
  { value: 'bangarupalem', label: 'Bangarupalem', pincode: '515001' },
  { value: 'bommidi', label: 'Bommidi', pincode: '515001' },
  { value: 'gundla', label: 'Gundla', pincode: '515001' },
  { value: 'guntakal', label: 'Guntakal', pincode: '515801' },
  { value: 'jangama', label: 'Jangama', pincode: '515801' },
  { value: 'kallur', label: 'Kallur', pincode: '515001' },
  { value: 'kothapeta', label: 'Kothapeta', pincode: '515001' },
  { value: 'ramagiri', label: 'Ramagiri', pincode: '515001' },
  { value: 'sarvamangala', label: 'Sarvamangala', pincode: '515001' },
  { value: 'sompeta', label: 'Sompeta', pincode: '515001' },
  { value: 'vellalapalli', label: 'Vellalapalli', pincode: '515801' },
  { value: 'yerraguntla', label: 'Yerraguntla', pincode: '515001' }
  ],
  
  'hindupuram': [
  { value: 'adoni', label: 'Adoni', pincode: '518301' },
  { value: 'bhogapuram', label: 'Bhogapuram', pincode: '531163' },
  { value: 'chinthakunta', label: 'Chinthakunta', pincode: '518384' },
  { value: 'gampa', label: 'Gampa', pincode: '518390' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'hindupuram-town', label: 'Hindupuram Town', pincode: '518101' },
  { value: 'kalyanadurg', label: 'Kalyanadurg', pincode: '515761' },
  { value: 'kothacheruvu', label: 'Kothacheruvu', pincode: '518123' },
  { value: 'nallacheruvu', label: 'Nallacheruvu', pincode: '518301' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '505172' },
  { value: 'rayadurg', label: 'Rayadurg', pincode: '515865' },
  { value: 'siddhartha-colony', label: 'Siddhartha Colony', pincode: '518102' },
  { value: 'sri-sai-nagar', label: 'Sri Sai Nagar', pincode: '518101' },
  { value: 'tadipatri', label: 'Tadipatri', pincode: '515411' },
  { value: 'yerraguntla', label: 'Yerraguntla', pincode: '518332' },
  { value: 'bangalore', label: 'Bangalore', pincode: '560001' }, // 
  { value: 'pillalamarri', label: 'Pillalamarri', pincode: '518299' },
  { value: 'peddagattu', label: 'Peddagattu', pincode: '518387' },
  { value: 'banganapalli', label: 'Banganapalli', pincode: '518124' },
  { value: 'addanki', label: 'Addanki', pincode: '523201' },
  { value: 'anantapur', label: 'Anantapur', pincode: '515001' }
  ],

  'madanapalle': [
  { value: 'adoni', label: 'Adoni', pincode: '518301' },
  { value: 'anantapur', label: 'Anantapur', pincode: '515001' },
  { value: 'banchayapeta', label: 'Banchayapeta', pincode: '515571' },
  { value: 'bommanahal', label: 'Bommanahal', pincode: '515111' },
  { value: 'chakrayapeta', label: 'Chakrayapeta', pincode: '515571' },
  { value: 'chinnakampalle', label: 'Chinnakampalle', pincode: '515631' },
  { value: 'chintakunta', label: 'Chintakunta', pincode: '515416' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kalyandurg', label: 'Kalyandurg', pincode: '515761' },
  { value: 'kothacheruvu', label: 'Kothacheruvu', pincode: '518101' },
  { value: 'mandapalle-town', label: 'Madanapalle Town', pincode: '517325' },
  { value: 'mohammed-pet', label: 'Mohammed Pet', pincode: '515151' },
  { value: 'narayanavanam', label: 'Narayanavanam', pincode: '517581' },
  { value: 'peddamudiam', label: 'Peddamudiam', pincode: '515004' },
  { value: 'puttaparthi', label: 'Puttaparthi', pincode: '515134' },
  { value: 'ramanadapuram', label: 'Ramanadapuram', pincode: '515865' },
  { value: 'sri-sai-nagar', label: 'Sri Sai Nagar', pincode: '517325' },
  { value: 'tadipatri', label: 'Tadipatri', pincode: '515411' },
  { value: 'tirupati', label: 'Tirupati', pincode: '517501' },
  { value: 'vadamalapeta', label: 'Vadamalapeta', pincode: '517551' },
  { value: 'vempalle', label: 'Vempalle', pincode: '518124' },
  { value: 'yerraguntla', label: 'Yerraguntla', pincode: '518332' },
  { value: 'bangarapet', label: 'Bangarapet', pincode: '563114' },
  { value: 'chinthakunta', label: 'Chinthakunta', pincode: '518384' },
  { value: 'kothakota', label: 'Kothakota', pincode: '518223' },
  { value: 'mallapuram', label: 'Mallapuram', pincode: '515561' },
  { value: 'nandalur', label: 'Nandalur', pincode: '518560' }
  ],

  'machilipatnam': [
  { value: 'achutapuram', label: 'Achutapuram', pincode: '521001' },
  { value: 'bapulapadu', label: 'Bapulapadu', pincode: '521221' },
  { value: 'chinnapuram', label: 'Chinnapuram', pincode: '521215' },
  { value: 'chintalapudi', label: 'Chintalapudi', pincode: '521158' },
  { value: 'chakaligunta', label: 'Chakaligunta', pincode: '521120' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jupudi', label: 'Jupudi', pincode: '521212' },
  { value: 'kankipadu', label: 'Kankipadu', pincode: '521151' },
  { value: 'kothuru', label: 'Kothuru', pincode: '521242' },
  { value: 'machilipatnam-town', label: 'Machilipatnam Town', pincode: '521001' },
  { value: 'marripalem', label: 'Marripalem', pincode: '521211' },
  { value: 'muthyalapadu', label: 'Muthyalapadu', pincode: '521002' },
  { value: 'nimmakayala', label: 'Nimmakayala', pincode: '521212' },
  { value: 'naguluppalapadu', label: 'Naguluppalapadu', pincode: '521243' },
  { value: 'pedana', label: 'Pedana', pincode: '521366' },
  { value: 'penuganchiprolu', label: 'Penuganchiprolu', pincode: '521186' },
  { value: 'phoolbaugh', label: 'Phoolbaugh', pincode: '521101' },
  { value: 'rayanapadu', label: 'Rayanapadu', pincode: '521214' },
  { value: 'sathenapalle', label: 'Sathenapalle', pincode: '521132' },
  { value: 'sitanagaram', label: 'Sitanagaram', pincode: '521252' },
  { value: 'vadlamannadu', label: 'Vadlamannadu', pincode: '521243' },
  { value: 'vissannapeta', label: 'Vissannapeta', pincode: '521235' },
  { value: 'tallapalem', label: 'Tallapalem', pincode: '521230' },
  { value: 'boyapalli', label: 'Boyapalli', pincode: '521161' },
  { value: 'perur', label: 'Perur', pincode: '521230' },
  { value: 'raghunathapalem', label: 'Raghunathapalem', pincode: '521226' },
  { value: 'surampalem', label: 'Surampalem', pincode: '521234' },
  { value: 'pedagantyada', label: 'Pedagantyada', pincode: '521206' },
  { value: 'rajupeta', label: 'Rajupeta', pincode: '521223' },
  { value: 'yanamadala', label: 'Yanamadala', pincode: '521246' },
  { value: 'kottapeta', label: 'Kottapeta', pincode: '521219' },
  { value: 'mohammadapuram', label: 'Mohammadapuram', pincode: '521101' },
  { value: 'suryapet', label: 'Suryapet', pincode: '521132' },
  { value: 'chandarlapadu', label: 'Chandarlapadu', pincode: '521231' },
  { value: 'prathipadu', label: 'Prathipadu', pincode: '521132' }
],

'nandyal': [
  { value: 'adoni', label: 'Adoni', pincode: '518301' },
  { value: 'bhairavapatnam', label: 'Bhairavapatnam', pincode: '518533' },
  { value: 'bapanapalle', label: 'Bapanapalle', pincode: '518216' },
  { value: 'dornipadu', label: 'Dornipadu', pincode: '518591' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kallur', label: 'Kallur', pincode: '518224' },
  { value: 'kottala', label: 'Kottala', pincode: '518149' },
  { value: 'maddikera', label: 'Maddikera', pincode: '518622' },
  { value: 'nandyal-town', label: 'Nandyal Town', pincode: '518501' },
  { value: 'nayanipalli', label: 'Nayanipalli', pincode: '518211' },
  { value: 'peddakottala', label: 'Peddakottala', pincode: '518591' },
  { value: 'pedda-kurapadu', label: 'Pedda Kurapadu', pincode: '518631' },
  { value: 'potharajupalem', label: 'Potharajupalem', pincode: '518532' },
  { value: 'rayalpad', label: 'Rayalpad', pincode: '518441' },
  { value: 'sambavaram', label: 'Sambavaram', pincode: '518512' },
  { value: 'siripuram', label: 'Siripuram', pincode: '518441' },
  { value: 'tadipatri', label: 'Tadipatri', pincode: '515411' },
  { value: 'yerraguntla', label: 'Yerraguntla', pincode: '518332' },
  { value: 'venkatareddypalle', label: 'Venkatareddypalle', pincode: '518271' },
  { value: 'vempalle', label: 'Vempalle', pincode: '518124' },
  { value: 'sirivella', label: 'Sirivella', pincode: '518423' },
  { value: 'kachhupalle', label: 'Kachhupalle', pincode: '518241' },
  { value: 'kanchikacherla', label: 'Kanchikacherla', pincode: '518106' },
  { value: 'kothapalle', label: 'Kothapalle', pincode: '518521' },
  { value: 'parlapanur', label: 'Parlapanur', pincode: '518311' },
  { value: 'banavasi', label: 'Banavasi', pincode: '518402' },
  { value: 'ballepalle', label: 'Ballepalle', pincode: '518124' },
  { value: 'kodur', label: 'Kodur', pincode: '518380' },
  { value: 'ramanapalle', label: 'Ramanapalle', pincode: '518441' },
  { value: 'tummalapalle', label: 'Tummalapalle', pincode: '518104' },
  { value: 'gundlapalle', label: 'Gundlapalle', pincode: '518422' },
  { value: 'yellapur', label: 'Yellapur', pincode: '518435' },
  { value: 'madanapalle', label: 'Madanapalle', pincode: '518121' },
  { value: 'kothakota', label: 'Kothakota', pincode: '518223' }
  ],

  'narasaraopet': [
  { value: 'addanki', label: 'Addanki', pincode: '523201' },
  { value: 'bapatla', label: 'Bapatla', pincode: '522101' },
  { value: 'chakrayapeta', label: 'Chakrayapeta', pincode: '523261' },
  { value: 'chinnaganjam', label: 'Chinnaganjam', pincode: '523167' },
  { value: 'jonnalagadda', label: 'Jonnalagadda', pincode: '523273' },
  { value: 'kondapi', label: 'Kondapi', pincode: '523257' },
  { value: 'kothapeta', label: 'Kothapeta', pincode: '523105' },
  { value: 'narpala', label: 'Narpala', pincode: '523105' },
  { value: 'narsaraopet', label: 'Narasaraopet', pincode: '522601' },
  { value: 'peddaganjam', label: 'Peddaganjam', pincode: '523211' },
  { value: 'pudur', label: 'Pudur', pincode: '523169' },
  { value: 'rajanagaram', label: 'Rajanagaram', pincode: '523263' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '523246' },
  { value: 'santanutalapadu', label: 'Santanutalapadu', pincode: '523281' },
  { value: 'siddharthanagar', label: 'Siddharthanagar', pincode: '522601' },
  { value: 'sirivella', label: 'Sirivella', pincode: '523201' },
  { value: 'tadikonda', label: 'Tadikonda', pincode: '522503' },
  { value: 'tenali', label: 'Tenali', pincode: '522201' },
  { value: 'vetapalem', label: 'Vetapalem', pincode: '523187' }
  ],

  'proddatur': [
  { value: 'alaru', label: 'Alaru', pincode: '516366' },
  { value: 'bopparam', label: 'Bopparam', pincode: '516309' },
  { value: 'chandagiri', label: 'Chandagiri', pincode: '516101' },
  { value: 'chakrayapeta', label: 'Chakrayapeta', pincode: '516360' },
  { value: 'koduru', label: 'Koduru', pincode: '516101' },
  { value: 'kosuvaripalli', label: 'Kosuvaripalli', pincode: '516405' },
  { value: 'maddanapalle', label: 'Maddanapalle', pincode: '516318' },
  { value: 'proddatur', label: 'Proddatur', pincode: '516360' },
  { value: 'rajaram', label: 'Rajarampeta', pincode: '516103' },
  { value: 'ramapuram', label: 'Ramapuram', pincode: '516107' },
  { value: 'vempalle', label: 'Vempalle', pincode: '516328' },
  { value: 'yerraguntla', label: 'Yerraguntla', pincode: '516310' },
  { value: 'bhaskarapalli', label: 'Bhaskarapalli', pincode: '516201' },
  { value: 'chinnampalli', label: 'Chinnampalli', pincode: '516423' },
  { value: 'duddukuru', label: 'Duddukuru', pincode: '516321' },
  { value: 'ghantasala', label: 'Ghantasala', pincode: '516341' },
  { value: 'kambhampadu', label: 'Kambhampadu', pincode: '516212' },
  { value: 'konakanchi', label: 'Konakanchi', pincode: '516369' },
  { value: 'mullapadu', label: 'Mullapadu', pincode: '516213' },
  { value: 'nallacheruvu', label: 'Nallacheruvu', pincode: '516107' },
  { value: 'peddagudi', label: 'Peddagudi', pincode: '516316' }
  ],

  'tadepalligudem': [
  { value: 'aelur', label: 'Aelur', pincode: '534149' },
  { value: 'bhatkal', label: 'Bhatkal', pincode: '534101' },
  { value: 'chinna-ponnuru', label: 'Chinna Ponnuru', pincode: '534103' },
  { value: 'gampalagudem', label: 'Gampalagudem', pincode: '534308' },
  { value: 'jaggampeta', label: 'Jaggampeta', pincode: '534451' },
  { value: 'kavuru', label: 'Kavuru', pincode: '534150' },
  { value: 'lankapalli', label: 'Lankapalli', pincode: '534205' },
  { value: 'mangavaram', label: 'Mangavaram', pincode: '534204' },
  { value: 'pedapudi', label: 'Pedapudi', pincode: '534227' },
  { value: 'tadepalligudem', label: 'Tadepalligudem', pincode: '534101' },
  { value: 'thadepalli', label: 'Thadepalli', pincode: '534204' },
  { value: 'veeravasaram', label: 'Veeravasaram', pincode: '534222' },
  { value: 'yasvapuram', label: 'Yasvapuram', pincode: '534207' },
  { value: 'avilala', label: 'Avilala', pincode: '534124' },
  { value: 'bopparajukunta', label: 'Bopparajukunta', pincode: '534213' },
  { value: 'dharmajigudem', label: 'Dharmajigudem', pincode: '534242' },
  { value: 'gandhipuram', label: 'Gandhipuram', pincode: '534205' },
  { value: 'kondapalli', label: 'Kondapalli', pincode: '534314' },
  { value: 'madhavaram', label: 'Madhavaram', pincode: '534303' },
  { value: 'nallapadu', label: 'Nallapadu', pincode: '534401' },
  { value: 'patrunivalasa', label: 'Patrunivalasa', pincode: '534307' }
  ],

  'tadipatri': [
  { value: 'adivaripalli', label: 'Adivaripalli', pincode: '515411' },
  { value: 'alampur', label: 'Alampur', pincode: '515581' },
  { value: 'bommanapalli', label: 'Bommanapalli', pincode: '515411' },
  { value: 'chandragiri', label: 'Chandragiri', pincode: '515411' },
  { value: 'chinnapalli', label: 'Chinnapalli', pincode: '515408' },
  { value: 'guntakal', label: 'Guntakal', pincode: '515801' },
  { value: 'kalyandurg', label: 'Kalyandurg', pincode: '515761' },
  { value: 'kurukonda', label: 'Kurukonda', pincode: '515411' },
  { value: 'tadipatri', label: 'Tadipatri', pincode: '515411' },
  { value: 'venkatapuram', label: 'Venkatapuram', pincode: '515411' },
  { value: 'yerraguntla', label: 'Yerraguntla', pincode: '515304' },
  { value: 'bhogapuram', label: 'Bhogapuram', pincode: '515423' },
  { value: 'chimakurthi', label: 'Chimakurthi', pincode: '515521' },
  { value: 'dharmajigudem', label: 'Dharmajigudem', pincode: '515414' },
  { value: 'kallur', label: 'Kallur', pincode: '515461' },
  { value: 'mallapuram', label: 'Mallapuram', pincode: '515451' },
  { value: 'nagarampalle', label: 'Nagarampalle', pincode: '515301' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '515424' },
  { value: 'ravirala', label: 'Ravirala', pincode: '515307' },
  { value: 'yerraguntlapadu', label: 'Yerraguntlapadu', pincode: '515305' },
  { value: 'anantapuram', label: 'Anantapuram', pincode: '515715' },
  { value: 'banavasi', label: 'Banavasi', pincode: '515438' },
  { value: 'chandramouli', label: 'Chandramouli', pincode: '515422' },
  { value: 'gandlapalli', label: 'Gandlapalli', pincode: '515112' },
  { value: 'hemapur', label: 'Hemapur', pincode: '515101' },
  { value: 'koppur', label: 'Koppur', pincode: '515207' },
  { value: 'neelakantapuram', label: 'Neelakantapuram', pincode: '515451' },
  { value: 'peddaravula', label: 'Peddaravula', pincode: '515410' },
  { value: 'siddampalli', label: 'Siddampalli', pincode: '515405' },
  { value: 'yerramanchili', label: 'Yerramanchili', pincode: '515205' }
  ],

  'tenali': [
  { value: 'annapurna-pet', label: 'Annapurna Pet', pincode: '522201' },
  { value: 'bommuru', label: 'Bommuru', pincode: '522201' },
  { value: 'chebrolu', label: 'Chebrolu', pincode: '522212' },
  { value: 'chimakurthi', label: 'Chimakurthi', pincode: '522202' },
  { value: 'chowdaripeta', label: 'Chowdaripeta', pincode: '522202' },
  { value: 'gundam', label: 'Gundam', pincode: '522201' },
  { value: 'kakumanu', label: 'Kakumanu', pincode: '522223' },
  { value: 'kotha-pet', label: 'Kotha Pet', pincode: '522201' },
  { value: 'makavarapalem', label: 'Makavarapalem', pincode: '522222' },
  { value: 'mandapeta', label: 'Mandapeta', pincode: '522201' },
  { value: 'tenali', label: 'Tenali', pincode: '522201' },
  { value: 'vempadu', label: 'Vempadu', pincode: '522211' },
  { value: 'vijayapuri', label: 'Vijayapuri', pincode: '522202' },
  { value: 'achanta', label: 'Achanta', pincode: '522204' },
  { value: 'gollaprolu', label: 'Gollaprolu', pincode: '522234' },
  { value: 'lankapalli', label: 'Lankapalli', pincode: '522233' },
  { value: 'malapaka', label: 'Malapaka', pincode: '522221' },
  { value: 'nallur', label: 'Nallur', pincode: '522207' },
  { value: 'penumudi', label: 'Penumudi', pincode: '522213' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '522214' },
  { value: 'sompeta', label: 'Sompeta', pincode: '522210' },
  { value: 'thiruvur', label: 'Thiruvur', pincode: '522208' },
  { value: 'veerapuram', label: 'Veerapuram', pincode: '522206' },
  { value: 'chandranagaram', label: 'Chandranagaram', pincode: '522215' },
  { value: 'chintalapudi', label: 'Chintalapudi', pincode: '522216' },
  { value: 'madhurapuri', label: 'Madhurapuri', pincode: '522217' },
  { value: 'peddagudem', label: 'Peddagudem', pincode: '522218' },
  { value: 'penugonda', label: 'Penugonda', pincode: '522220' },
  { value: 'pudur', label: 'Pudur', pincode: '522205' }
  ],

  'parvathipuram': [
  { value: 'bommidi', label: 'Bommidi', pincode: '535527' },
  { value: 'boddapadu', label: 'Boddapadu', pincode: '535503' },
  { value: 'gajalampeta', label: 'Gajalampeta', pincode: '535523' },
  { value: 'godduguda', label: 'Godduguda', pincode: '535531' },
  { value: 'gothavada', label: 'Gothavada', pincode: '535525' },
  { value: 'kakarapalli', label: 'Kakarapalli', pincode: '535532' },
  { value: 'kotturu', label: 'Kotturu', pincode: '535530' },
  { value: 'lingapuram', label: 'Lingapuram', pincode: '535518' },
  { value: 'parvathipuram', label: 'Parvathipuram', pincode: '535501' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '535534' },
  { value: 'rampachodavaram', label: 'Rampachodavaram', pincode: '535521' },
  { value: 'sagaram', label: 'Sagaram', pincode: '535522' },
  { value: 'santanu', label: 'Santanu', pincode: '535513' },
  { value: 'valasapeta', label: 'Valasapeta', pincode: '535524' },
  { value: 'vempalle', label: 'Vempalle', pincode: '535533' },
  { value: 'vijayapuri', label: 'Vijayapuri', pincode: '535505' },
  { value: 'yendapalli', label: 'Yendapalli', pincode: '535504' }
  ],

  'ichchapuram': [
  { value: 'appannapalem', label: 'Appannapalem', pincode: '532212' },
  { value: 'chinnagudipadu', label: 'Chinnagudipadu', pincode: '532222' },
  { value: 'ichchapuram', label: 'Ichchapuram', pincode: '532102' },
  { value: 'kolligundla', label: 'Kolligundla', pincode: '532212' },
  { value: 'kotturu', label: 'Kotturu', pincode: '532126' },
  { value: 'mallavari', label: 'Mallavari', pincode: '532122' },
  { value: 'palakonda', label: 'Palakonda', pincode: '532209' },
  { value: 'srikakulam', label: 'Srikakulam', pincode: '532001' },
  { value: 'suryalanka', label: 'Suryalanka', pincode: '532133' },
  { value: 'thotapalem', label: 'Thotapalem', pincode: '532132' },
  { value: 'valmikipuram', label: 'Valmikipuram', pincode: '532105' },
  { value: 'peddagudipadu', label: 'Peddagudipadu', pincode: '532220' },
  { value: 'laxmipuram', label: 'Laxmipuram', pincode: '532118' },
  { value: 'kumaragiri', label: 'Kumaragiri', pincode: '532128' },
  { value: 'maddinapeta', label: 'Maddinapeta', pincode: '532136' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '532115' },
  { value: 'pendurthi', label: 'Pendurthi', pincode: '532119' },
  { value: 'lankapalli', label: 'Lankapalli', pincode: '532119' },
  { value: 'somagiri', label: 'Somagiri', pincode: '532220' },
  { value: 'amadalavalasa', label: 'Amadalavalasa', pincode: '532185' },
  { value: 'nagarampalem', label: 'Nagarampalem', pincode: '532211' },
  { value: 'garividi', label: 'Garividi', pincode: '532215' },
  { value: 'chintalavalasa', label: 'Chintalavalasa', pincode: '532201' }
  ],

  'yemmiganur': [
  { value: 'adoni', label: 'Adoni', pincode: '518301' },
  { value: 'baddirajupalem', label: 'Baddirajupalem', pincode: '518360' },
  { value: 'brindavan', label: 'Brindavan', pincode: '518360' },
  { value: 'chintakunta', label: 'Chintakunta', pincode: '518360' },
  { value: 'doddanapalli', label: 'Doddanapalli', pincode: '518360' },
  { value: 'gaddamvaripalli', label: 'Gaddamvaripalli', pincode: '518360' },
  { value: 'gajulapalli', label: 'Gajulapalli', pincode: '518360' },
  { value: 'gokavaram', label: 'Gokavaram', pincode: '518360' },
  { value: 'hatnur', label: 'Hatnur', pincode: '518360' },
  { value: 'kanakagiri', label: 'Kanakagiri', pincode: '518360' },
  { value: 'kesavanapalli', label: 'Kesavanapalli', pincode: '518360' },
  { value: 'kesarapalli', label: 'Kesarapalli', pincode: '518360' },
  { value: 'kondapur', label: 'Kondapur', pincode: '518360' },
  { value: 'malkapur', label: 'Malkapur', pincode: '518360' },
  { value: 'nagireddypalli', label: 'Nagireddypalli', pincode: '518360' },
  { value: 'nallacheruvu', label: 'Nallacheruvu', pincode: '518360' },
  { value: 'rajamudigapalli', label: 'Rajamudigapalli', pincode: '518360' },
  { value: 'ramapuram', label: 'Ramapuram', pincode: '518360' },
  { value: 'siddipet', label: 'Siddipet', pincode: '518360' },
  { value: 'srinivaspur', label: 'Srinivaspur', pincode: '518360' },
  { value: 'tadipatri', label: 'Tadipatri', pincode: '518360' },
  { value: 'vepada', label: 'Vepada', pincode: '518360' },
  { value: 'yemmiganur', label: 'Yemmiganur', pincode: '518360' }
  ],

  'bapatla': [
  { value: 'ammavaripalem', label: 'Ammavaripalem', pincode: '522101' },
  { value: 'bapatla', label: 'Bapatla', pincode: '522101' },
  { value: 'chandrapalem', label: 'Chandrapalem', pincode: '522101' },
  { value: 'chinnayapalem', label: 'Chinnayapalem', pincode: '522101' },
  { value: 'gopavaram', label: 'Gopavaram', pincode: '522101' },
  { value: 'gollapudi', label: 'Gollapudi', pincode: '522101' },
  { value: 'kollur', label: 'Kollur', pincode: '522101' },
  { value: 'kothapet', label: 'Kothapet', pincode: '522101' },
  { value: 'pedagarlapadu', label: 'Pedagarlapadu', pincode: '522101' },
  { value: 'pedapudi', label: 'Pedapudi', pincode: '522101' },
  { value: 'penuganchiprolu', label: 'Penuganchiprolu', pincode: '522101' },
  { value: 'peddagudem', label: 'Peddagudem', pincode: '522101' },
  { value: 'tadepalligudem', label: 'Tadepalligudem', pincode: '522101' },
  { value: 'vempadu', label: 'Vempadu', pincode: '522101' },
  { value: 'vijayapuri', label: 'Vijayapuri', pincode: '522101' },
  { value: 'vujjampalem', label: 'Vujjampalem', pincode: '522101' },
  { value: 'yerragunta', label: 'Yerragunta', pincode: '522101' },
  { value: 'balayapalle', label: 'Balayapalle', pincode: '522101' },
  { value: 'chintalapudi', label: 'Chintalapudi', pincode: '522101' },
  { value: 'chinagundam', label: 'Chinagundam', pincode: '522101' },
  { value: 'korisapadu', label: 'Korisapadu', pincode: '522101' },
  { value: 'muthyampalle', label: 'Muthyampalle', pincode: '522101' },
  { value: 'nallapadu', label: 'Nallapadu', pincode: '522101' },
  { value: 'peddapulipaka', label: 'Peddapulipaka', pincode: '522101' },
  { value: 'sitaramapuram', label: 'Sitaramapuram', pincode: '522101' },
  { value: 'sompeta', label: 'Sompeta', pincode: '522101' }
  ],

  'cumbum': [
  { value: 'adavi', label: 'Adavi', pincode: '523333' },
  { value: 'bhimavaram', label: 'Bhimavaram', pincode: '523333' },
  { value: 'cumbum', label: 'Cumbum', pincode: '523333' },
  { value: 'govindapuram', label: 'Govindapuram', pincode: '523333' },
  { value: 'kondapuram', label: 'Kondapuram', pincode: '523333' },
  { value: 'kumool', label: 'Kumool', pincode: '523333' },
  { value: 'madhavaram', label: 'Madhavaram', pincode: '523333' },
  { value: 'mukkampadu', label: 'Mukkampadu', pincode: '523333' },
  { value: 'nallapadu', label: 'Nallapadu', pincode: '523333' },
  { value: 'palakole', label: 'Palakole', pincode: '523333' },
  { value: 'peddakallepalli', label: 'Peddakallepalli', pincode: '523333' },
  { value: 'rajampet', label: 'Rajampet', pincode: '523333' },
  { value: 'siddapur', label: 'Siddapur', pincode: '523333' },
  { value: 'tadiparthi', label: 'Tadiparthi', pincode: '523333' },
  { value: 'chandravaram', label: 'Chandravaram', pincode: '523333' },
  { value: 'chinnayapalem', label: 'Chinnayapalem', pincode: '523333' },
  { value: 'govindarajupalem', label: 'Govindarajupalem', pincode: '523333' },
  { value: 'kondur', label: 'Kondur', pincode: '523333' },
  { value: 'madhavapalle', label: 'Madhavapalle', pincode: '523333' },
  { value: 'neelampadu', label: 'Neelampadu', pincode: '523333' },
  { value: 'pallapatla', label: 'Pallapatla', pincode: '523333' },
  { value: 'ramapuram', label: 'Ramapuram', pincode: '523333' },
  { value: 'santipuram', label: 'Santipuram', pincode: '523333' },
  { value: 'siddhartha', label: 'Siddhartha', pincode: '523333' },
  { value: 'tummalapalle', label: 'Tummalapalle', pincode: '523333' }
  ],

 'yerraguntla': [
  { value: 'adoni', label: 'Adoni', pincode: '518301' },
  { value: 'anantapur', label: 'Anantapur', pincode: '515001' },
  { value: 'bukkapatnam', label: 'Bukkapatnam', pincode: '515741' },
  { value: 'chakrayapet', label: 'Chakrayapet', pincode: '515571' },
  { value: 'garladinne', label: 'Garladinne', pincode: '515731' },
  { value: 'gundla-palli', label: 'Gundla Palli', pincode: '518123' },
  { value: 'kadiri', label: 'Kadiri', pincode: '515591' },
  { value: 'kothacheruvu', label: 'Kothacheruvu', pincode: '515765' },
  { value: 'madhavaram', label: 'Madhavaram', pincode: '515681' },
  { value: 'nallamada', label: 'Nallamada', pincode: '515481' },
  { value: 'obuladevarapalli', label: 'Obuladevarapalli', pincode: '515681' },
  { value: 'peddapappur', label: 'Peddapappur', pincode: '515481' },
  { value: 'raganapalli', label: 'Raganapalli', pincode: '515865' },
  { value: 'sri-satyasai', label: 'Sri Satyasai', pincode: '515001' },
  { value: 'tirupathi', label: 'Tirupathi', pincode: '517501' },
  { value: 'yerraguntla', label: 'Yerraguntla', pincode: '516310' },
  ],
  'kurnool': [
    { value: 'adoni', label: 'Adoni', pincode: '518301' },
    { value: 'alur', label: 'Alur', pincode: '518395' },
    { value: 'bantumilli', label: 'Bantumilli', pincode: '518324' },
    { value: 'borepalli', label: 'Borepalli', pincode: '518228' },
    { value: 'buddhapuram', label: 'Buddhapuram', pincode: '518002' },
    { value: 'chagalamarri', label: 'Chagalamarri', pincode: '518533' },
    { value: 'chakrayapeta', label: 'Chakrayapeta', pincode: '518351' },
    { value: 'dhanwada', label: 'Dhanwada', pincode: '518222' },
    { value: 'kadapa', label: 'Kadapa', pincode: '518001' },
    { value: 'kallur', label: 'Kallur', pincode: '518123' },
    { value: 'kurnool-town', label: 'Kurnool Town', pincode: '518001' },
    { value: 'kurnool-rural', label: 'Kurnool Rural', pincode: '518218' },
    { value: 'mahaboobnagar', label: 'Mahaboobnagar', pincode: '518002' },
    { value: 'midthur', label: 'Midthur', pincode: '518221' },
    { value: 'nandyal', label: 'Nandyal', pincode: '518501' },
    { value: 'pamulapadu', label: 'Pamulapadu', pincode: '518122' },
    { value: 'penukonda', label: 'Penukonda', pincode: '518110' },
    { value: 'peddapadu', label: 'Peddapadu', pincode: '518313' },
    { value: 'rapur', label: 'Rapur', pincode: '518125' },
    { value: 'srp-konda', label: 'SRP Konda', pincode: '518145' },
    { value: 'tadipatri', label: 'Tadipatri', pincode: '518501' },
    { value: 'tadipatri-rural', label: 'Tadipatri Rural', pincode: '518501' },
    { value: 'bellary', label: 'Bellary', pincode: '518501' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '518002' },
    { value: 'jupadu', label: 'Jupadu', pincode: '518112' },
    { value: 'kothapet', label: 'Kothapet', pincode: '518113' },
    { value: 'nagari', label: 'Nagari', pincode: '518151' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '518002' },
    { value: 'pothuluru', label: 'Pothuluru', pincode: '518234' },
    { value: 'pullaguntapalle', label: 'Pullaguntapalle', pincode: '518222' },
    { value: 'rajupalem', label: 'Rajupalem', pincode: '518334' },
    { value: 'ragampeta', label: 'Ragampeta', pincode: '518123' },
    { value: 'siddavatam', label: 'Siddavatam', pincode: '518106' },
    { value: 'thimmapur', label: 'Thimmapur', pincode: '518327' },
    { value: 'wazirabad', label: 'Wazirabad', pincode: '518355' }
  ],

  'tirupati': [
    { value: 'alipiri', label: 'Alipiri', pincode: '517507' },
    { value: 'balaji-colony', label: 'Balaji Colony', pincode: '517501' },
    { value: 'chandragiri', label: 'Chandragiri', pincode: '517101' },
    { value: 'chinnakandriga', label: 'Chinnakandriga', pincode: '517102' },
    { value: 'devappa', label: 'Devappa', pincode: '517402' },
    { value: 'gangappa', label: 'Gangappa', pincode: '517416' },
    { value: 'jammichettu', label: 'Jammichettu', pincode: '517502' },
    { value: 'kacharlapalli', label: 'Kacharlapalli', pincode: '517521' },
    { value: 'kotha-pudupet', label: 'Kotha Pudupet', pincode: '517520' },
    { value: 'krishnapuram', label: 'Krishnapuram', pincode: '517416' },
    { value: 'lakshmi-nagar', label: 'Lakshmi Nagar', pincode: '517507' },
    { value: 'maruthi-nagar', label: 'Maruthi Nagar', pincode: '517501' },
    { value: 'mattipalli', label: 'Mattipalli', pincode: '517564' },
    { value: 'nagapattinam', label: 'Nagapattinam', pincode: '517501' },
    { value: 'nawabpet', label: 'Nawabpet', pincode: '517001' },
    { value: 'padmavathi-nagar', label: 'Padmavathi Nagar', pincode: '517501' },
    { value: 'raju-kandigai', label: 'Raju Kandigai', pincode: '517508' },
    { value: 'siddavaram', label: 'Siddavaram', pincode: '517211' },
    { value: 'tirumala', label: 'Tirumala', pincode: '517504' },
    { value: 'tirupati-town', label: 'Tirupati Town', pincode: '517501' },
    { value: 'tirupati-rural', label: 'Tirupati Rural', pincode: '517502' },
    { value: 'velampet', label: 'Velampet', pincode: '517503' },
    { value: 'venkateshwara', label: 'Venkateshwara', pincode: '517502' },
    { value: 'vijayawada', label: 'Vijayawada', pincode: '517501' },
    { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '517501' },
    { value: 'bairagipatteda', label: 'Bairagipatteda', pincode: '517503' },
    { value: 'chandragiri-town', label: 'Chandragiri Town', pincode: '517101' },
    { value: 'chupakulur', label: 'Chupakulur', pincode: '517523' },
    { value: 'kalyanapuram', label: 'Kalyanapuram', pincode: '517416' },
    { value: 'kandukur', label: 'Kandukur', pincode: '517202' },
    { value: 'kothur', label: 'Kothur', pincode: '517514' },
    { value: 'kurabalakota', label: 'Kurabalakota', pincode: '517416' },
    { value: 'mallavolu', label: 'Mallavolu', pincode: '517540' },
    { value: 'nagulapalli', label: 'Nagulapalli', pincode: '517512' },
    { value: 'peddagavandlapalli', label: 'Peddagavandlapalli', pincode: '517564' },
    { value: 'pedda-kandriga', label: 'Pedda Kandriga', pincode: '517105' },
    { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '517562' },
    { value: 'raju-kandigai', label: 'Raju Kandigai', pincode: '517508' },
    { value: 'santapet', label: 'Santapet', pincode: '517513' },
    { value: 'srimukhi', label: 'Srimukhi', pincode: '517512' },
    { value: 'subbarayanipalem', label: 'Subbarayanipalem', pincode: '517411' },
    { value: 'tiruchanur', label: 'Tiruchanur', pincode: '517503' }
  ],

  'vizianagaram': [
    { value: 'achutapuram', label: 'Achutapuram', pincode: '535216' },
    { value: 'alambaguda', label: 'Alambaguda', pincode: '535267' },
    { value: 'boddapadu', label: 'Boddapadu', pincode: '535215' },
    { value: 'burja', label: 'Burja', pincode: '535121' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '535247' },
    { value: 'chinamiryalapalem', label: 'Chinamiryalapalem', pincode: '535145' },
    { value: 'chipurupalle', label: 'Chipurupalle', pincode: '535272' },
    { value: 'donkinavalasa', label: 'Donkinavalasa', pincode: '535291' },
    { value: 'gundambilli', label: 'Gundambilli', pincode: '535234' },
    { value: 'jonnada', label: 'Jonnada', pincode: '535101' },
    { value: 'karakavalasa', label: 'Karakavalasa', pincode: '535134' },
    { value: 'kasibugga', label: 'Kasibugga', pincode: '535126' },
    { value: 'kothapeta', label: 'Kothapeta', pincode: '535267' },
    { value: 'malkapuram', label: 'Malkapuram', pincode: '535234' },
    { value: 'nandamuru', label: 'Nandamuru', pincode: '535272' },
    { value: 'peddagummadidoddi', label: 'Peddagummadidoddi', pincode: '535243' },
    { value: 'prakasaraopeta', label: 'Prakasaraopeta', pincode: '535207' },
    { value: 'pydibhimavaram', label: 'Pydibhimavaram', pincode: '535167' },
    { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '535133' },
    { value: 'reddipalli', label: 'Reddipalli', pincode: '535134' },
    { value: 'sithanagaram', label: 'Sithanagaram', pincode: '535234' },
    { value: 'tummalapalem', label: 'Tummalapalem', pincode: '535233' },
    { value: 'vizianagaram-town', label: 'Vizianagaram Town', pincode: '535001' },
    { value: 'vizianagaram-rural', label: 'Vizianagaram Rural', pincode: '535002' },
    { value: 'vizianagaram-urban', label: 'Vizianagaram Urban', pincode: '535003' },
    { value: 'vijayapuri', label: 'Vijayapuri', pincode: '535248' },
    { value: 'yerraballi', label: 'Yerraballi', pincode: '535205' },
    { value: 'borepalli', label: 'Borepalli', pincode: '535228' },
    { value: 'chikupalle', label: 'Chikupalle', pincode: '535246' },
    { value: 'garividi', label: 'Garividi', pincode: '535270' },
    { value: 'jogulamba', label: 'Jogulamba', pincode: '535220' },
    { value: 'kasipeta', label: 'Kasipeta', pincode: '535118' },
    { value: 'kondapeta', label: 'Kondapeta', pincode: '535236' },
    { value: 'kurupam', label: 'Kurupam', pincode: '535587' },
    { value: 'peddagummadidoddi', label: 'Peddagummadidoddi', pincode: '535243' },
    { value: 'ralapadu', label: 'Ralapadu', pincode: '535275' },
    { value: 'sitarampuram', label: 'Sitarampuram', pincode: '535256' },
    { value: 'tarlupadu', label: 'Tarlupadu', pincode: '535264' },
    { value: 'yellapadu', label: 'Yellapadu', pincode: '535237' }
  ],

  'amravati': [
    { value: 'adgaon', label: 'Adgaon', pincode: '444601' },
    { value: 'alapur', label: 'Alapur', pincode: '444602' },
    { value: 'amravati', label: 'Amravati', pincode: '444601' },
    { value: 'anvapada', label: 'Anvapada', pincode: '444603' },
    { value: 'babhulgaon', label: 'Babhulgaon', pincode: '444604' },
    { value: 'belura', label: 'Belura', pincode: '444625' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '444605' },
    { value: 'bhivpur-bk', label: 'Bhivpur BK', pincode: '444630' },
    { value: 'bhorkheda', label: 'Bhorkheda', pincode: '444606' },
    { value: 'chandpur', label: 'Chandpur', pincode: '444607' },
    { value: 'dhamangaon', label: 'Dhamangaon', pincode: '444608' },
    { value: 'dongargaon', label: 'Dongargaon', pincode: '444631' },
    { value: 'gokulwadi', label: 'Gokulwadi', pincode: '444609' },
    { value: 'gorakshnagar', label: 'Gorakshnagar', pincode: '444632' },
    { value: 'heerapur', label: 'Heerapur', pincode: '444633' },
    { value: 'jalgaon', label: 'Jalgaon', pincode: '444610' },
    { value: 'khamgaon', label: 'Khamgaon', pincode: '444611' },
    { value: 'khamgaon-bk', label: 'Khamgaon BK', pincode: '444634' },
    { value: 'khadki', label: 'Khadki', pincode: '444635' },
    { value: 'khata', label: 'Khata', pincode: '444612' },
    { value: 'khandvi', label: 'Khandvi', pincode: '444620' },
    { value: 'kothali', label: 'Kothali', pincode: '444626' },
    { value: 'malkapur', label: 'Malkapur', pincode: '444613' },
    { value: 'manegaon', label: 'Manegaon', pincode: '444624' },
    { value: 'mohadi', label: 'Mohadi', pincode: '444628' },
    { value: 'mohadi-bk', label: 'Mohadi BK', pincode: '444636' },
    { value: 'nalpur', label: 'Nalpur', pincode: '444627' },
    { value: 'nehrunagar', label: 'Nehrunagar', pincode: '444629' },
    { value: 'nimbhora', label: 'Nimbhora', pincode: '444614' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '444621' },
    { value: 'rahata', label: 'Rahata', pincode: '444615' },
    { value: 'rajur', label: 'Rajur', pincode: '444622' },
    { value: 'sardapur', label: 'Sardapur', pincode: '444637' },
    { value: 'shiraswadi', label: 'Shiraswadi', pincode: '444616' },
    { value: 'sundarpur', label: 'Sundarpur', pincode: '444623' },
    { value: 'tahsil', label: 'Tahsil', pincode: '444602' },
    { value: 'talegaon', label: 'Talegaon', pincode: '444617' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '444618' },
    { value: 'warud', label: 'Warud', pincode: '444619' },
    { value: 'warudi', label: 'Warudi', pincode: '444638' }
  ],

  'akola': [
    { value: 'adgaon', label: 'Adgaon', pincode: '444103' },
    { value: 'akola', label: 'Akola', pincode: '444001' },
    { value: 'anvapada', label: 'Anvapada', pincode: '444104' },
    { value: 'ashti', label: 'Ashti', pincode: '444144' },
    { value: 'balapur', label: 'Balapur', pincode: '444302' },
    { value: 'baranjala', label: 'Baranjala', pincode: '444105' },
    { value: 'barshitakli', label: 'Barshitakli', pincode: '444401' },
    { value: 'babhulgaon', label: 'Babhulgaon', pincode: '444106' },
    { value: 'belura', label: 'Belura', pincode: '444129' },
    { value: 'bhadgaon', label: 'Bhadgaon', pincode: '444101' },
    { value: 'bhimnath', label: 'Bhimnath', pincode: '444110' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '444107' },
    { value: 'bordi', label: 'Bordi', pincode: '444108' },
    { value: 'borgaon', label: 'Borgaon', pincode: '444108' },
    { value: 'chalbardi', label: 'Chalbardi', pincode: '444110' },
    { value: 'chandpur', label: 'Chandpur', pincode: '444111' },
    { value: 'chandur', label: 'Chandur', pincode: '444904' },
    { value: 'dapura', label: 'Dapura', pincode: '444118' },
    { value: 'dhamangaon', label: 'Dhamangaon', pincode: '444711' },
    { value: 'dharni', label: 'Dharni', pincode: '444702' },
    { value: 'eklari', label: 'Eklari', pincode: '444506' },
    { value: 'gokulwadi', label: 'Gokulwadi', pincode: '444112' },
    { value: 'jalgaon', label: 'Jalgaon', pincode: '444113' },
    { value: 'jalka', label: 'Jalka', pincode: '444302' },
    { value: 'khamgaon', label: 'Khamgaon', pincode: '444114' },
    { value: 'khamgaon-road', label: 'Khamgaon Road', pincode: '444110' },
    { value: 'khata', label: 'Khata', pincode: '444115' },
    { value: 'khandvi', label: 'Khandvi', pincode: '444123' },
    { value: 'kothali', label: 'Kothali', pincode: '444130' },
    { value: 'manegaon', label: 'Manegaon', pincode: '444128' },
    { value: 'malkapur', label: 'Malkapur', pincode: '444116' },
    { value: 'mohadi', label: 'Mohadi', pincode: '444132' },
    { value: 'murtizapur', label: 'Murtizapur', pincode: '444107' },
    { value: 'nalpur', label: 'Nalpur', pincode: '444131' },
    { value: 'nashikwadi', label: 'Nashikwadi', pincode: '444124' },
    { value: 'naya-akola', label: 'Naya Akola', pincode: '444004' },
    { value: 'nehrunagar', label: 'Nehrunagar', pincode: '444133' },
    { value: 'nimbhora', label: 'Nimbhora', pincode: '444117' },
    { value: 'patur', label: 'Patur', pincode: '444501' },
    { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '444125' },
    { value: 'poharadevi', label: 'Poharadevi', pincode: '444201' },
    { value: 'rahata', label: 'Rahata', pincode: '444118' },
    { value: 'rajur', label: 'Rajur', pincode: '444126' },
    { value: 'ramtek', label: 'Ramtek', pincode: '444204' },
    { value: 'ranjangaon', label: 'Ranjangaon', pincode: '444110' },
    { value: 'sundarpur', label: 'Sundarpur', pincode: '444127' },
    { value: 'shegaon', label: 'Shegaon', pincode: '444203' },
    { value: 'shivapur', label: 'Shivapur', pincode: '444203' },
    { value: 'shiraswadi', label: 'Shiraswadi', pincode: '444119' },
    { value: 'sindkhed', label: 'Sindkhed', pincode: '444004' },
    { value: 'tahsil', label: 'Tahsil', pincode: '444002' },
    { value: 'talegaon', label: 'Talegaon', pincode: '444120' },
    { value: 'tapovan', label: 'Tapovan', pincode: '444117' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '444121' },
    { value: 'warud', label: 'Warud', pincode: '444122' },
    { value: 'wadi', label: 'Wadi', pincode: '444101' }
  ],

  'ahmadnagar': [
    { value: 'adgaon', label: 'Adgaon', pincode: '414104' },
    { value: 'ahmadnagar', label: 'Ahmadnagar', pincode: '414001' },
    { value: 'alapur', label: 'Alapur', pincode: '414003' },
    { value: 'anjangaon', label: 'Anjangaon', pincode: '414107' },
    { value: 'babhulgaon', label: 'Babhulgaon', pincode: '414104' },
    { value: 'babhulgaon-bk', label: 'Babhulgaon BK', pincode: '414001' },
    { value: 'babhulgaon-kd', label: 'Babhulgaon KD', pincode: '414003' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '414109' },
    { value: 'bhivpur-bk', label: 'Bhivpur BK', pincode: '414109' },
    { value: 'bhorkheda', label: 'Bhorkheda', pincode: '414109' },
    { value: 'chandpur', label: 'Chandpur', pincode: '414103' },
    { value: 'chinchkheda', label: 'Chinchkheda', pincode: '414110' },
    { value: 'chinchkheda-bk', label: 'Chinchkheda BK', pincode: '414110' },
    { value: 'dnyaneshwarwadi', label: 'Dnyaneshwarwadi', pincode: '414003' },
    { value: 'gadadgaon', label: 'Gadadgaon', pincode: '414103' },
    { value: 'ghodegaon', label: 'Ghodegaon', pincode: '414105' },
    { value: 'jalgaon', label: 'Jalgaon', pincode: '414103' },
    { value: 'jamkhed', label: 'Jamkhed', pincode: '413201' },
    { value: 'khamgaon', label: 'Khamgaon', pincode: '414004' },
    { value: 'khamgaon-bk', label: 'Khamgaon BK', pincode: '414004' },
    { value: 'khandvi', label: 'Khandvi', pincode: '414001' },
    { value: 'khandvi-bk', label: 'Khandvi BK', pincode: '414001' },
    { value: 'kharvi', label: 'Kharvi', pincode: '414107' },
    { value: 'khedgaon', label: 'Khedgaon', pincode: '414104' },
    { value: 'kothur', label: 'Kothur', pincode: '414001' },
    { value: 'malikpura', label: 'Malikpura', pincode: '414105' },
    { value: 'malkapur', label: 'Malkapur', pincode: '414001' },
    { value: 'nandur', label: 'Nandur', pincode: '414109' },
    { value: 'nehrunagar', label: 'Nehrunagar', pincode: '414001' },
    { value: 'padmavati', label: 'Padmavati', pincode: '414003' },
    { value: 'pandharpur', label: 'Pandharpur', pincode: '413704' },
    { value: 'pangri', label: 'Pangri', pincode: '414108' },
    { value: 'parner', label: 'Parner', pincode: '414302' },
    { value: 'pathardi', label: 'Pathardi', pincode: '414102' },
    { value: 'rahatgaon', label: 'Rahatgaon', pincode: '414110' },
    { value: 'rahuri', label: 'Rahuri', pincode: '413705' },
    { value: 'rashin', label: 'Rashin', pincode: '414403' },
    { value: 'sangamner', label: 'Sangamner', pincode: '422605' },
    { value: 'shahapur', label: 'Shahapur', pincode: '414107' },
    { value: 'shiraswadi', label: 'Shiraswadi', pincode: '414110' },
    { value: 'shrirampur', label: 'Shrirampur', pincode: '413709' },
    { value: 'sonai', label: 'Sonai', pincode: '414105' },
    { value: 'sudkoli', label: 'Sudkoli', pincode: '414106' },
    { value: 'sundapur', label: 'Sundapur', pincode: '414101' },
    { value: 'talegaon', label: 'Talegaon', pincode: '414106' },
    { value: 'tapkala', label: 'Tapkala', pincode: '414108' },
    { value: 'vadgaon', label: 'Vadgaon', pincode: '414001' },
    { value: 'wadgaon', label: 'Wadgaon', pincode: '414002' },
    { value: 'wakadi', label: 'Wakadi', pincode: '414104' },
    { value: 'warud', label: 'Warud', pincode: '414101' }
  ],

  'mumbai': [
    { value: 'agripada', label: 'Agripada', pincode: '400011' },
    { value: 'air-india-staff-colony', label: 'Air India Staff Colony', pincode: '400099' },
    { value: 'airoli', label: 'Airoli', pincode: '400708' },
    { value: 'airoli-sector-4', label: 'Airoli Sector 4', pincode: '400708' },
    { value: 'airoli-sector-8', label: 'Airoli Sector 8', pincode: '400708' },
    { value: 'ambarnath', label: 'Ambarnath', pincode: '421501' },
    { value: 'ambarnath-east', label: 'Ambarnath East', pincode: '421501' },
    { value: 'ambarnath-west', label: 'Ambarnath West', pincode: '421501' },
    { value: 'ambewadi', label: 'Ambewadi', pincode: '400004' },
    { value: 'amboli', label: 'Amboli', pincode: '400058' },
    { value: 'andheri', label: 'Andheri', pincode: '400053' },
    { value: 'andheri-east', label: 'Andheri East', pincode: '400069' },
    { value: 'andheri-west', label: 'Andheri West', pincode: '400058' },
    { value: 'antop-hill', label: 'Antop Hill', pincode: '400037' },
    { value: 'apollo-bunder', label: 'Apollo Bunder', pincode: '400001' },
    { value: 'august-kranti-maidan', label: 'August Kranti Maidan', pincode: '400036' },
    { value: 'azad-nagar', label: 'Azad Nagar', pincode: '400053' },
    { value: 'badlapur', label: 'Badlapur', pincode: '421503' },
    { value: 'ballard-estate', label: 'Ballard Estate', pincode: '400038' },
    { value: 'bandra', label: 'Bandra', pincode: '400050' },
    { value: 'bandra-east', label: 'Bandra East', pincode: '400051' },
    { value: 'bandra-west', label: 'Bandra West', pincode: '400050' },
    { value: 'belapur', label: 'Belapur', pincode: '400614' },
    { value: 'bhandup', label: 'Bhandup', pincode: '400078' },
    { value: 'bhandup-east', label: 'Bhandup East', pincode: '400078' },
    { value: 'bhandup-west', label: 'Bhandup West', pincode: '400078' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '400086' },
    { value: 'bhayandar', label: 'Bhayandar', pincode: '401105' },
    { value: 'bhayandar-east', label: 'Bhayandar East', pincode: '401105' },
    { value: 'bhayandar-west', label: 'Bhayandar West', pincode: '401101' },
    { value: 'bhiwandi', label: 'Bhiwandi', pincode: '421302' },
    { value: 'bhoiwada', label: 'Bhoiwada', pincode: '400003' },
    { value: 'boisar', label: 'Boisar', pincode: '401501' },
    { value: 'boisar-west', label: 'Boisar West', pincode: '401501' },
    { value: 'borivali', label: 'Borivali', pincode: '400066' },
    { value: 'borivali-east', label: 'Borivali East', pincode: '400066' },
    { value: 'borivali-west', label: 'Borivali West', pincode: '400092' },
    { value: 'breach-candy', label: 'Breach Candy', pincode: '400026' },
    { value: 'byculla', label: 'Byculla', pincode: '400027' },
    { value: 'byculla-east', label: 'Byculla East', pincode: '400027' },
    { value: 'byculla-west', label: 'Byculla West', pincode: '400027' },
    { value: 'cbd-belapur-sector-11', label: 'CBD Belapur Sector 11', pincode: '400614' },
    { value: 'chandivali', label: 'Chandivali', pincode: '400072' },
    { value: 'chembur', label: 'Chembur', pincode: '400071' },
    { value: 'chembur-east', label: 'Chembur East', pincode: '400071' },
    { value: 'chembur-west', label: 'Chembur West', pincode: '400089' },
    { value: 'chinchpokli', label: 'Chinchpokli', pincode: '400033' },
    { value: 'chinchpokli-east', label: 'Chinchpokli East', pincode: '400033' },
    { value: 'chinchpokli-west', label: 'Chinchpokli West', pincode: '400033' },
    { value: 'chira-bazaar', label: 'Chira Bazaar', pincode: '400002' },
    { value: 'chowpatti', label: 'Chowpatti', pincode: '400007' },
    { value: 'churchgate', label: 'Churchgate', pincode: '400020' },
    { value: 'colaba', label: 'Colaba', pincode: '400005' },
    { value: 'cuffe-parade', label: 'Cuffe Parade', pincode: '400005' },
    { value: 'cumbala-hill', label: 'Cumbala Hill', pincode: '400026' },
    { value: 'dadar', label: 'Dadar', pincode: '400014' },
    { value: 'dadar-east', label: 'Dadar East', pincode: '400014' },
    { value: 'dadar-t.t', label: 'Dadar T.T', pincode: '400033' },
    { value: 'dadar-west', label: 'Dadar West', pincode: '400028' },
    { value: 'dahisar-east', label: 'Dahisar East', pincode: '400068' },
    { value: 'dahisar-west', label: 'Dahisar West', pincode: '400068' },
    { value: 'danda', label: 'Danda', pincode: '400049' },
    { value: 'deonar', label: 'Deonar', pincode: '400088' },
    { value: 'deonar-east', label: 'Deonar East', pincode: '400088' },
    { value: 'dharavi', label: 'Dharavi', pincode: '400017' },
    { value: 'dhobi-talao', label: 'Dhobi Talao', pincode: '400002' },
    { value: 'dombivli', label: 'Dombivli', pincode: '421201' },
    { value: 'dombivli-east', label: 'Dombivli East', pincode: '421201' },
    { value: 'dombivli-west', label: 'Dombivli West', pincode: '421202' },
    { value: 'fort', label: 'Fort', pincode: '400001' },
    { value: 'gamdevi', label: 'Gamdevi', pincode: '400007' },
    { value: 'ghansoli', label: 'Ghansoli', pincode: '400701' },
    { value: 'ghatkopar', label: 'Ghatkopar', pincode: '400077' },
    { value: 'ghatkopar-east', label: 'Ghatkopar East', pincode: '400077' },
    { value: 'ghatkopar-west', label: 'Ghatkopar West', pincode: '400086' },
    { value: 'girgaon', label: 'Girgaon', pincode: '400004' },
    { value: 'goregaon', label: 'Goregaon', pincode: '400063' },
    { value: 'goregaon-east', label: 'Goregaon East', pincode: '400063' },
    { value: 'goregaon-west', label: 'Goregaon West', pincode: '400104' },
    { value: 'govandi', label: 'Govandi', pincode: '400043' },
    { value: 'govandi-east', label: 'Govandi East', pincode: '400043' },
    { value: 'govandi-west', label: 'Govandi West', pincode: '400043' },
    { value: 'government-colony', label: 'Government Colony', pincode: '400086' },
    { value: 'gowalia-tank', label: 'Gowalia Tank', pincode: '400026' },
    { value: 'grant-road', label: 'Grant Road', pincode: '400007' },
    { value: 'grant-road-east', label: 'Grant Road East', pincode: '400007' },
    { value: 'grant-road-west', label: 'Grant Road West', pincode: '400007' },
    { value: 'green-park-extension', label: 'Green Park Extension', pincode: '400034' },
    { value: 'irla', label: 'Irla', pincode: '400056' },
    { value: 'j-b-nagar', label: 'J B Nagar', pincode: '400059' },
    { value: 'jacob-circle', label: 'Jacob Circle', pincode: '400011' },
    { value: 'jogeshwari', label: 'Jogeshwari', pincode: '400102' },
    { value: 'jogeshwari-east', label: 'Jogeshwari East', pincode: '400060' },
    { value: 'jogeshwari-west', label: 'Jogeshwari West', pincode: '400102' },
    { value: 'juhu', label: 'Juhu', pincode: '400049' },
    { value: 'juhu-scheme', label: 'Juhu Scheme', pincode: '400049' },
    { value: 'kala-ghoda', label: 'Kala Ghoda', pincode: '400023' },
    { value: 'kalamboli', label: 'Kalamboli', pincode: '410218' },
    { value: 'kalbadevi', label: 'Kalbadevi', pincode: '400002' },
    { value: 'kalwa', label: 'Kalwa', pincode: '400605' },
    { value: 'kalwa-west', label: 'Kalwa West', pincode: '400605' },
    { value: 'kalyan', label: 'Kalyan', pincode: '421301' },
    { value: 'kalyan-east', label: 'Kalyan East', pincode: '421306' },
    { value: 'kalyan-west', label: 'Kalyan West', pincode: '421301' },
    { value: 'kamothe', label: 'Kamothe', pincode: '410209' },
    { value: 'kandivali', label: 'Kandivali', pincode: '400067' },
    { value: 'kandivali-east', label: 'Kandivali East', pincode: '400101' },
    { value: 'kandivali-west', label: 'Kandivali West', pincode: '400067' },
    { value: 'kanjur-marg', label: 'Kanjur Marg', pincode: '400042' },
    { value: 'kanjur-marg-east', label: 'Kanjur Marg East', pincode: '400042' },
    { value: 'kanjur-marg-west', label: 'Kanjur Marg West', pincode: '400078' },
    { value: 'kemps-corner', label: 'Kemps Corner', pincode: '400036' },
    { value: 'ketkipada', label: 'Ketkipada', pincode: '400101' },
    { value: 'khar', label: 'Khar', pincode: '400052' },
    { value: 'khar-danda', label: 'Khar Danda', pincode: '400052' },
    { value: 'khar-east', label: 'Khar East', pincode: '400052' },
    { value: 'khar-west', label: 'Khar West', pincode: '400052' },
    { value: 'kharghar', label: 'Kharghar', pincode: '410210' },
    { value: 'kharghar-sector-12', label: 'Kharghar Sector 12', pincode: '410210' },
    { value: 'kharghar-sector-2', label: 'Kharghar Sector 2', pincode: '410210' },
    { value: 'kharghar-sector-7', label: 'Kharghar Sector 7', pincode: '410210' },
    { value: 'khetwadi', label: 'Khetwadi', pincode: '400004' },
    { value: 'khopoli', label: 'Khopoli', pincode: '410203' },
    { value: 'kidwai-nagar', label: 'Kidwai Nagar', pincode: '400031' },
    { value: 'kopar-khairane', label: 'Kopar Khairane', pincode: '400709' },
    { value: 'kurla-east', label: 'Kurla East', pincode: '400024' },
    { value: 'kurla-west', label: 'Kurla West', pincode: '400070' },
    { value: 'lal-baug', label: 'Lal Baug', pincode: '400012' },
    { value: 'lohar-chawl', label: 'Lohar Chawl', pincode: '400002' },
    { value: 'lokhandwala', label: 'Lokhandwala', pincode: '400053' },
    { value: 'lower-parel-east', label: 'Lower Parel East', pincode: '400013' },
    { value: 'lower-parel-west', label: 'Lower Parel West', pincode: '400013' },
    { value: 'mahalaxmi', label: 'Mahalaxmi', pincode: '400034' },
    { value: 'mahape', label: 'Mahape', pincode: '400710' },
    { value: 'mahim', label: 'Mahim', pincode: '400016' },
    { value: 'mahim-east', label: 'Mahim East', pincode: '400016' },
    { value: 'mahim-west', label: 'Mahim West', pincode: '400016' },
    { value: 'malabar-hill', label: 'Malabar Hill', pincode: '400006' },
    { value: 'malad', label: 'Malad', pincode: '400064' },
    { value: 'malad-west', label: 'Malad West', pincode: '400064' },
    { value: 'marine-lines', label: 'Marine Lines', pincode: '400020' },
    { value: 'mazagaon', label: 'Mazagaon', pincode: '400010' },
    { value: 'naigaon', label: 'Naigaon', pincode: '400014' },
    { value: 'navi-mumbai', label: 'Navi Mumbai', pincode: '400614' },
    { value: 'oshiwara', label: 'Oshiwara', pincode: '400102' },
    { value: 'panvel', label: 'Panvel', pincode: '410206' },
    { value: 'parel', label: 'Parel', pincode: '400012' },
    { value: 'prabhadevi', label: 'Prabhadevi', pincode: '400025' },
    { value: 'santacruz', label: 'Santacruz', pincode: '400054' },
    { value: 'seepz', label: 'Seepz', pincode: '400093' },
    { value: 'tardeo', label: 'Tardeo', pincode: '400034' },
    { value: 'thakurdwar', label: 'Thakurdwar', pincode: '400002' },
    { value: 'vakola', label: 'Vakola', pincode: '400055' },
    { value: 'versova', label: 'Versova', pincode: '400061' },
    { value: 'vile-parle', label: 'Vile Parle', pincode: '400057' },
    { value: 'wadala', label: 'Wadala', pincode: '400031' },
    { value: 'worli', label: 'Worli', pincode: '400018' }
  ],

  // Karnatak Areas
  'bagalkote': [
  { value: 'bagalkot', label: 'Bagalkot', pincode: '587101' },
  { value: 'badami', label: 'Badami', pincode: '587201' },
  { value: 'bailhongal', label: 'Bailhongal', pincode: '591102' },
  { value: 'banahatti', label: 'Banahatti', pincode: '587312' },
  { value: 'bannihatti', label: 'Bannihatti', pincode: '587315' },
  { value: 'bilgi', label: 'Bilgi', pincode: '587114' },
  { value: 'hubli', label: 'Hubli', pincode: '580024' },
  { value: 'kudachi', label: 'Kudachi', pincode: '591312' },
  { value: 'kudalsangama', label: 'Kudalsangama', pincode: '587202' },
  { value: 'nalwar', label: 'Nalwar', pincode: '587203' },
  { value: 'ranebennur', label: 'Ranebennur', pincode: '581115' },
  { value: 'sankeshwar', label: 'Sankeshwar', pincode: '591313' },
  { value: 'tolaki', label: 'Tolaki', pincode: '587315' },
  { value: 'turvihal', label: 'Turvihal', pincode: '587308' },
  { value: 'alapur', label: 'Alapur', pincode: '587103' },
  { value: 'jamboti', label: 'Jamboti', pincode: '591305' },
  { value: 'kalahalli', label: 'Kalahalli', pincode: '587301' },
  { value: 'kanbargi', label: 'Kanbargi', pincode: '587107' },
  { value: 'karatagi', label: 'Karatagi', pincode: '587307' },
  { value: 'kudlagi', label: 'Kudlagi', pincode: '583205' },
  { value: 'mudalgi', label: 'Mudalgi', pincode: '591313' },
  { value: 'savadatti', label: 'Savadatti', pincode: '591137' },
  { value: 'balebagewadi', label: 'Balebagewadi', pincode: '587316' },
  { value: 'hanumapur', label: 'Hanumapur', pincode: '587116' },
  { value: 'jattikoppal', label: 'Jattikoppal', pincode: '587314' },
  { value: 'kendagi', label: 'Kendagi', pincode: '587118' },
  { value: 'laxmeshwar', label: 'Laxmeshwar', pincode: '591124' },
  { value: 'malakheda', label: 'Malakheda', pincode: '587319' },
  { value: 'narlapur', label: 'Narlapur', pincode: '587311' },
  { value: 'sindgi', label: 'Sindgi', pincode: '586128' }
  ],

'bengaluru': [
  { value: 'agraharam', label: 'Agraharam', pincode: '560001' },
  { value: 'airport-road', label: 'Airport Road', pincode: '560017' },
  { value: 'arakere-gate', label: 'Arakere Gate', pincode: '560076' },
  { value: 'adu-godi', label: 'Adugodi', pincode: '560030' },
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '560025' },
  { value: 'austin-town', label: 'Austin Town', pincode: '560047' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '560037' },
  { value: 'banashankari', label: 'Banashankari', pincode: '560070' },
  { value: 'banaswadi', label: 'Banaswadi', pincode: '560043' },
  { value: 'benson-town', label: 'Benson Town', pincode: '560046' },
  { value: 'bilekahalli', label: 'Bilekahalli', pincode: '560076' },
  { value: 'bellandur', label: 'Bellandur', pincode: '560103' },
  { value: 'bidadi', label: 'Bidadi', pincode: '562109' },
  { value: 'blvd-road', label: 'Brigade Road', pincode: '560001' },
  { value: 'byatarayanapura', label: 'Byatarayanapura', pincode: '560092' },
  { value: 'bommanahalli', label: 'Bommanahalli', pincode: '560068' },
  { value: 'basavanagudi', label: 'Basavanagudi', pincode: '560004' },
  { value: 'basaveshwaranagar', label: 'Basaveshwaranagar', pincode: '560079' },
  { value: 'bannerghatta-road', label: 'Bannerghatta Road', pincode: '560029' },
  { value: 'btm-layout', label: 'BTM Layout', pincode: '560029' },
  { value: 'cbd', label: 'CBD', pincode: '560001' },
  { value: 'cunningham-road', label: 'Cunningham Road', pincode: '560052' },
  { value: 'chamarajpet', label: 'Chamarajpet', pincode: '560018' },
  { value: 'chandra-layout', label: 'Chandra Layout', pincode: '560040' },
  { value: 'chickpet', label: 'Chickpet', pincode: '560053' },
  { value: 'cubbon-park', label: 'Cubbon Park', pincode: '560001' },
  { value: 'cooke-town', label: 'Cooke Town', pincode: '560084' },
  { value: 'domlur', label: 'Domlur', pincode: '560071' },
  { value: 'double-road', label: 'Double Road', pincode: '560027' },
  { value: 'electronic-city', label: 'Electronic City', pincode: '560100' },
  { value: 'ejipura', label: 'Ejipura', pincode: '560047' },
  { value: 'frazer-town', label: 'Frazer Town', pincode: '560005' },
  { value: 'gandhinagar', label: 'Gandhinagar', pincode: '560009' },
  { value: 'hal-airport-road', label: 'HAL Airport Road', pincode: '560017' },
  { value: 'hoskote', label: 'Hoskote', pincode: '562114' },
  { value: 'hsr-layout', label: 'HSR Layout', pincode: '560102' },
  { value: 'indiranagar', label: 'Indiranagar', pincode: '560038' },
  { value: 'jayanagar', label: 'Jayanagar', pincode: '560011' },
  { value: 'jp-nagar', label: 'JP Nagar', pincode: '560078' },
  { value: 'kalyan-nagar', label: 'Kalyan Nagar', pincode: '560043' },
  { value: 'koramangala', label: 'Koramangala', pincode: '560034' },
  { value: 'malleswaram', label: 'Malleswaram', pincode: '560003' },
  { value: 'marathahalli', label: 'Marathahalli', pincode: '560037' },
  { value: 'mathikere', label: 'Mathikere', pincode: '560054' },
  { value: 'magrath-road', label: 'Magrath Road', pincode: '560025' },
  { value: 'malleshwaram', label: 'Malleshwaram', pincode: '560003' },
  { value: 'mgh-road', label: 'M.G Road', pincode: '560001' },
  { value: 'mahalakshmi-layout', label: 'Mahalakshmi Layout', pincode: '560086' },
  { value: 'marathahalli', label: 'Marathahalli', pincode: '560037' },
  { value: 'nagarbhavi', label: 'Nagarbhavi', pincode: '560072' },
  { value: 'new-bel-road', label: 'New BEL Road', pincode: '560094' },
  { value: 'peenya-industrial-area', label: 'Peenya Industrial Area', pincode: '560058' },
  { value: 'rajajinagar', label: 'Rajajinagar', pincode: '560010' },
  { value: 'rajkunte', label: 'Rajkunte', pincode: '560076' },
  { value: 'ramanagaram', label: 'Ramanagaram', pincode: '562159' },
  { value: 'rmg-road', label: 'RMV 2nd Stage', pincode: '560094' },
  { value: 'sarjapur', label: 'Sarjapur', pincode: '560035' },
  { value: 'seshadripuram', label: 'Seshadripuram', pincode: '560020' },
  { value: 'shivajinagar', label: 'Shivajinagar', pincode: '560051' },
  { value: 'sultanpalya', label: 'Sultanpalya', pincode: '560032' },
  { value: 'tumkur-road', label: 'Tumkur Road', pincode: '560022' },
  { value: 'vittal-mallya-road', label: 'Vittal Mallya Road', pincode: '560001' },
  { value: 'whitefield', label: 'Whitefield', pincode: '560066' },
  { value: 'wilson-garden', label: 'Wilson Garden', pincode: '560027' },
  { value: 'yelahanka', label: 'Yelahanka', pincode: '560064' },
  { value: 'yeshwanthpur', label: 'Yeshwanthpur', pincode: '560022' }
  ],

  'kalaburagi': [
  { value: 'alapur', label: 'Alapur', pincode: '585102' },
  { value: 'ambedkar-nagar', label: 'Ambedkar Nagar', pincode: '585102' },
  { value: 'bagalkot-road', label: 'Bagalkot Road', pincode: '585101' },
  { value: 'biloli', label: 'Biloli', pincode: '585103' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '585102' },
  { value: 'bhavani-nagar', label: 'Bhavani Nagar', pincode: '585101' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '585105' },
  { value: 'halki', label: 'Halki', pincode: '585101' },
  { value: 'hazrat-nagar', label: 'Hazrat Nagar', pincode: '585101' },
  { value: 'jambhali', label: 'Jambhali', pincode: '585105' },
  { value: 'kamgar-nagar', label: 'Kamgar Nagar', pincode: '585103' },
  { value: 'karur', label: 'Karur', pincode: '585103' },
  { value: 'keshawpura', label: 'Keshawpura', pincode: '585104' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '585101' },
  { value: 'maharaj-nagar', label: 'Maharaj Nagar', pincode: '585101' },
  { value: 'maniknagar', label: 'Maniknagar', pincode: '585101' },
  { value: 'mohammad-nagar', label: 'Mohammad Nagar', pincode: '585101' },
  { value: 'nirmal', label: 'Nirmal', pincode: '585104' },
  { value: 'onkareshwar', label: 'Onkareshwar', pincode: '585101' },
  { value: 'santosh-nagar', label: 'Santosh Nagar', pincode: '585101' },
  { value: 'shankar-nagar', label: 'Shankar Nagar', pincode: '585101' },
  { value: 'vishwanathpura', label: 'Vishwanathpura', pincode: '585104' },
  { value: 'zindari', label: 'Zindari', pincode: '585101' },
  { value: 'anwar-nagar', label: 'Anwar Nagar', pincode: '585104' },
  { value: 'bhalki', label: 'Bhalki', pincode: '585328' },
  { value: 'gaddanakonda', label: 'Gaddanakonda', pincode: '585104' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '585102' },
  { value: 'gaon', label: 'Gaon', pincode: '585104' },
  { value: 'kallur', label: 'Kallur', pincode: '585106' },
  { value: 'karur-village', label: 'Karur Village', pincode: '585103' },
  { value: 'konnur', label: 'Konnur', pincode: '585102' },
  { value: 'siddheshwar', label: 'Siddheshwar', pincode: '585101' },
  { value: 'talikoti', label: 'Talikoti', pincode: '585115' },
  { value: 'wadi', label: 'Wadi', pincode: '585225' },
  { value: 'bahadurpura', label: 'Bahadurpura', pincode: '585104' },
  { value: 'bhavani-vihar', label: 'Bhavani Vihar', pincode: '585104' },
  { value: 'dharwad', label: 'Dharwad', pincode: '585106' },
  { value: 'gogal', label: 'Gogal', pincode: '585104' },
  { value: 'halapur', label: 'Halapur', pincode: '585104' },
  { value: 'kammapur', label: 'Kammapur', pincode: '585106' },
  { value: 'khanapur', label: 'Khanapur', pincode: '585102' },
  { value: 'koppal', label: 'Koppal', pincode: '585103' },
  { value: 'koravi', label: 'Koravi', pincode: '585101' },
  { value: 'malkapur', label: 'Malkapur', pincode: '585104' },
  { value: 'manjra', label: 'Manjra', pincode: '585104' },
  { value: 'muradpura', label: 'Muradpura', pincode: '585104' },
  { value: 'nagina', label: 'Nagina', pincode: '585105' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '585102' },
  { value: 'rampur', label: 'Rampur', pincode: '585106' },
  { value: 'safipur', label: 'Safipur', pincode: '585104' },
  { value: 'shahapur', label: 'Shahapur', pincode: '585115' },
  { value: 'shahabad', label: 'Shahabad', pincode: '585228' },
  { value: 'shevgaon', label: 'Shevgaon', pincode: '585115' },
  { value: 'village-babanpur', label: 'Babanpur Village', pincode: '585106' }
  ],

  'hosapete': [
  { value: 'adapada', label: 'Adapada', pincode: '583201' },
  { value: 'bagalkot-road', label: 'Bagalkot Road', pincode: '583201' },
  { value: 'bhimapura', label: 'Bhimapura', pincode: '583221' },
  { value: 'bhoodan', label: 'Bhoodan', pincode: '583212' },
  { value: 'channarayapatna', label: 'Channarayapatna', pincode: '583213' },
  { value: 'coconut-grove', label: 'Coconut Grove', pincode: '583206' },
  { value: 'gadag-road', label: 'Gadag Road', pincode: '583227' },
  { value: 'hampi', label: 'Hampi', pincode: '583239' },
  { value: 'hosapete-main-road', label: 'Hosapete Main Road', pincode: '583201' },
  { value: 'hospet-city', label: 'Hospet City', pincode: '583201' },
  { value: 'karanjal', label: 'Karanjal', pincode: '583203' },
  { value: 'kampapura', label: 'Kampapura', pincode: '583206' },
  { value: 'koppal', label: 'Koppal', pincode: '583222' },
  { value: 'krishnanagara', label: 'Krishnanagara', pincode: '583201' },
  { value: 'muruguraja', label: 'Muruguraja', pincode: '583204' },
  { value: 'nuggehalli', label: 'Nuggehalli', pincode: '583203' },
  { value: 'raichur-road', label: 'Raichur Road', pincode: '583221' },
  { value: 'shivanapura', label: 'Shivanapura', pincode: '583226' },
  { value: 'siddapura', label: 'Siddapura', pincode: '583205' },
  { value: 'sri-ramapura', label: 'Sri Ramapura', pincode: '583206' },
  { value: 'srinivasanagar', label: 'Srinivasanagar', pincode: '583201' },
  { value: 'vasanthapura', label: 'Vasanthapura', pincode: '583212' },
  { value: 'vishwanathapura', label: 'Vishwanathapura', pincode: '583227' },
  { value: 'yellapur', label: 'Yellapur', pincode: '583224' },
  { value: 'balehonnur', label: 'Balehonnur', pincode: '583222' },
  { value: 'bemmankere', label: 'Bemmankere', pincode: '583229' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '583227' },
  { value: 'devapura', label: 'Devapura', pincode: '583209' },
  { value: 'hospet-rural', label: 'Hospet Rural', pincode: '583209' },
  { value: 'jyothinagar', label: 'Jyothinagar', pincode: '583203' },
  { value: 'kotturu', label: 'Kotturu', pincode: '583223' },
  { value: 'kunigal', label: 'Kunigal', pincode: '583205' },
  { value: 'mahalaxmi', label: 'Mahalaxmi', pincode: '583201' },
  { value: 'mangalaram', label: 'Mangalaram', pincode: '583204' },
  { value: 'mardahalli', label: 'Mardahalli', pincode: '583228' },
  { value: 'martapura', label: 'Martapura', pincode: '583222' },
  { value: 'nagur', label: 'Nagur', pincode: '583210' },
  { value: 'pattana', label: 'Pattana', pincode: '583221' },
  { value: 'pillappa', label: 'Pillappa', pincode: '583207' },
  { value: 'shivapura', label: 'Shivapura', pincode: '583208' },
  { value: 'tuppanhalli', label: 'Tuppanhalli', pincode: '583224' },
  { value: 'veerabhadra', label: 'Veerabhadra', pincode: '583202' }
  ],
  
  'vijayapura': [
  { value: 'abad', label: 'Abad', pincode: '586101' },
  { value: 'balekundri', label: 'Balekundri', pincode: '586103' },
  { value: 'banahatti', label: 'Banahatti', pincode: '586107' },
  { value: 'basavan-bagewadi', label: 'Basavan Bagewadi', pincode: '586203' },
  { value: 'bustikoti', label: 'Bustikoti', pincode: '586102' },
  { value: 'chandapura', label: 'Chandapura', pincode: '586111' },
  { value: 'chinchali', label: 'Chinchali', pincode: '586101' },
  { value: 'chinchanal', label: 'Chinchanal', pincode: '586103' },
  { value: 'dambal', label: 'Dambal', pincode: '586110' },
  { value: 'godachinmalkapur', label: 'Godachinmalkapur', pincode: '586105' },
  { value: 'hattargi', label: 'Hattargi', pincode: '586102' },
  { value: 'hospet', label: 'Hospet', pincode: '586101' },
  { value: 'hurali', label: 'Hurali', pincode: '586104' },
  { value: 'iragur', label: 'Iragur', pincode: '586103' },
  { value: 'jambagi', label: 'Jambagi', pincode: '586105' },
  { value: 'karapur', label: 'Karapur', pincode: '586103' },
  { value: 'kesarkoppa', label: 'Kesarkoppa', pincode: '586109' },
  { value: 'mallapur', label: 'Mallapur', pincode: '586107' },
  { value: 'nallur', label: 'Nallur', pincode: '586103' },
  { value: 'pattadakal', label: 'Pattadakal', pincode: '586101' },
  { value: 'payanapur', label: 'Payanapur', pincode: '586108' },
  { value: 'rajanpura', label: 'Rajanpura', pincode: '586104' },
  { value: 'ramapura', label: 'Ramapura', pincode: '586109' },
  { value: 'sindagi', label: 'Sindagi', pincode: '586128' },
  { value: 'talikota', label: 'Talikota', pincode: '586224' },
  { value: 'tungabhadra', label: 'Tungabhadra', pincode: '586202' },
  { value: 'vadrahatti', label: 'Vadrahatti', pincode: '586104' },
  { value: 'vijayapura-town', label: 'Vijayapura Town', pincode: '586101' },
  { value: 'yadapura', label: 'Yadapura', pincode: '586103' },
  { value: 'adampur', label: 'Adampur', pincode: '586116' },
  { value: 'alapur', label: 'Alapur', pincode: '586124' },
  { value: 'babanapur', label: 'Babanapur', pincode: '586125' },
  { value: 'bhalanapur', label: 'Bhalanapur', pincode: '586127' },
  { value: 'banakatti', label: 'Banakatti', pincode: '586202' },
  { value: 'baranjala', label: 'Baranjala', pincode: '586118' },
  { value: 'basapur', label: 'Basapur', pincode: '586122' },
  { value: 'bavapur', label: 'Bavapur', pincode: '586130' },
  { value: 'bilagi', label: 'Bilagi', pincode: '586102' },
  { value: 'chandapur-village', label: 'Chandapur Village', pincode: '586105' },
  { value: 'chinchali-2', label: 'Chinchali 2', pincode: '586105' },
  { value: 'gajendrapur', label: 'Gajendrapur', pincode: '586108' },
  { value: 'halaga', label: 'Halaga', pincode: '586103' },
  { value: 'holakatti', label: 'Holakatti', pincode: '586114' },
  { value: 'jaggahalli', label: 'Jaggahalli', pincode: '586101' },
  { value: 'kamatgi', label: 'Kamatgi', pincode: '586105' },
  { value: 'kankumbi', label: 'Kankumbi', pincode: '586121' },
  { value: 'khajuri', label: 'Khajuri', pincode: '586124' },
  { value: 'kulgod', label: 'Kulgod', pincode: '586116' },
  { value: 'limbali', label: 'Limbali', pincode: '586120' },
  { value: 'malkapur', label: 'Malkapur', pincode: '586122' },
  { value: 'mallapur-village', label: 'Mallapur Village', pincode: '586109' },
  { value: 'mangatti', label: 'Mangatti', pincode: '586124' },
  { value: 'nandanpur', label: 'Nandanpur', pincode: '586120' },
  { value: 'nithyapur', label: 'Nithyapur', pincode: '586108' },
  { value: 'ragunathpura', label: 'Ragunathpura', pincode: '586119' },
  { value: 'sakarahalli', label: 'Sakarahalli', pincode: '586125' },
  { value: 'siddapur-village', label: 'Siddapur Village', pincode: '586126' },
  { value: 'turvihal', label: 'Turvihal', pincode: '586110' },
  { value: 'yarral', label: 'Yarral', pincode: '586103' }
  ],
  
  'arsikere': [
  { value: 'angadi', label: 'Angadi', pincode: '573103' },
  { value: 'arehalli', label: 'Arehalli', pincode: '573120' },
  { value: 'bhogapura', label: 'Bhogapura', pincode: '573103' },
  { value: 'chandravalli', label: 'Chandravalli', pincode: '573101' },
  { value: 'chikkajogihalli', label: 'Chikkajogihalli', pincode: '573105' },
  { value: 'gundlahalli', label: 'Gundlahalli', pincode: '573114' },
  { value: 'hebbalu', label: 'Hebbalu', pincode: '573111' },
  { value: 'hosahalli', label: 'Hosahalli', pincode: '573103' },
  { value: 'kallambella', label: 'Kallambella', pincode: '573125' },
  { value: 'karnataka', label: 'Karnataka', pincode: '573105' },
  { value: 'kammarahalli', label: 'Kammarahalli', pincode: '573124' },
  { value: 'koratagere', label: 'Koratagere', pincode: '573123' },
  { value: 'kudige', label: 'Kudige', pincode: '573130' },
  { value: 'kunigal', label: 'Kunigal', pincode: '573114' },
  { value: 'mandipura', label: 'Mandipura', pincode: '573104' },
  { value: 'mudigere', label: 'Mudigere', pincode: '573115' },
  { value: 'pillaghatta', label: 'Pillaghatta', pincode: '573115' },
  { value: 'sagarpura', label: 'Sagarpura', pincode: '573103' },
  { value: 'shivapura', label: 'Shivapura', pincode: '573127' },
  { value: 'siddapura', label: 'Siddapura', pincode: '573106' },
  { value: 'surahonne', label: 'Surahonne', pincode: '573102' },
  { value: 'tumbasogur', label: 'Tumbasogur', pincode: '573106' },
  { value: 'uthur', label: 'Uthur', pincode: '573120' },
  { value: 'yadgir', label: 'Yadgir', pincode: '573107' },
  { value: 'yellambagilu', label: 'Yellambagilu', pincode: '573103' },
  { value: 'biligirirangan', label: 'Biligirirangan', pincode: '573142' },
  { value: 'doddaghatta', label: 'Doddaghatta', pincode: '573128' },
  { value: 'madenur', label: 'Madenur', pincode: '573122' },
  { value: 'mullur', label: 'Mullur', pincode: '573116' },
  { value: 'santhebachahalli', label: 'Santhebachahalli', pincode: '573121' },
  { value: 'tiptur', label: 'Tiptur', pincode: '573202' },
  { value: 'belavadi', label: 'Belavadi', pincode: '573136' }
  ],
  
  'chamarajanagar': [
  { value: 'achchamagere', label: 'Achchamagere', pincode: '571411' },
  { value: 'alamba', label: 'Alamba', pincode: '571307' },
  { value: 'anandapura', label: 'Anandapura', pincode: '571429' },
  { value: 'bandipura', label: 'Bandipura', pincode: '571116' },
  { value: 'balehonnur', label: 'Balehonnur', pincode: '571315' },
  { value: 'bembala', label: 'Bembala', pincode: '571104' },
  { value: 'bidanur', label: 'Bidanur', pincode: '571150' },
  { value: 'bikkavolu', label: 'Bikkavolu', pincode: '571146' },
  { value: 'chamarajanagar-town', label: 'Chamarajanagar Town', pincode: '571313' },
  { value: 'channarayapatna', label: 'Channarayapatna', pincode: '571149' },
  { value: 'chikkabagalur', label: 'Chikkabagalur', pincode: '571314' },
  { value: 'chinnadahalli', label: 'Chinnadahalli', pincode: '571128' },
  { value: 'chamundipura', label: 'Chamundipura', pincode: '571333' },
  { value: 'devanur', label: 'Devanur', pincode: '571112' },
  { value: 'gowdagere', label: 'Gowdagere', pincode: '571324' },
  { value: 'hanur', label: 'Hanur', pincode: '571439' },
  { value: 'hebbur', label: 'Hebbur', pincode: '571313' },
  { value: 'hindapura', label: 'Hindapura', pincode: '571322' },
  { value: 'javaladinne', label: 'Javaladinne', pincode: '571315' },
  { value: 'jogihalli', label: 'Jogihalli', pincode: '571307' },
  { value: 'kollegal', label: 'Kollegal', pincode: '571440' },
  { value: 'malavalli', label: 'Malavalli', pincode: '571425' },
  { value: 'mallanayakanahalli', label: 'Mallanayakanahalli', pincode: '571329' },
  { value: 'mallikarjuna', label: 'Mallikarjuna', pincode: '571432' },
  { value: 'mukundapura', label: 'Mukundapura', pincode: '571121' },
  { value: 'nanjanagudu', label: 'Nanjanagudu', pincode: '571301' },
  { value: 'periyapatna', label: 'Periyapatna', pincode: '571107' },
  { value: 'ramanaghatta', label: 'Ramanaghatta', pincode: '571328' },
  { value: 'ramapura', label: 'Ramapura', pincode: '571120' },
  { value: 'saligrama', label: 'Saligrama', pincode: '571124' },
  { value: 'somanahalli', label: 'Somanahalli', pincode: '571116' },
  { value: 'varuna', label: 'Varuna', pincode: '571140' },
  { value: 'yelandur', label: 'Yelandur', pincode: '571441' },
  { value: 'acharya-cheruvalli', label: 'Acharya Cheruvalli', pincode: '571149' },
  { value: 'adichunchanagiri', label: 'Adichunchanagiri', pincode: '571132' },
  { value: 'balaganur', label: 'Balaganur', pincode: '571406' },
  { value: 'bhairapura', label: 'Bhairapura', pincode: '571315' },
  { value: 'hampapura', label: 'Hampapura', pincode: '571311' },
  { value: 'hangal', label: 'Hangal', pincode: '571324' },
  { value: 'kunigal', label: 'Kunigal', pincode: '571421' }
  ],
  
  'yadgir': [
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '585207' },
  { value: 'banegaon', label: 'Banegaon', pincode: '585209' },
  { value: 'barkhera', label: 'Barkhera', pincode: '585213' },
  { value: 'borkheda', label: 'Borkheda', pincode: '585207' },
  { value: 'chandapur', label: 'Chandapur', pincode: '585201' },
  { value: 'chincholi', label: 'Chincholi', pincode: '585305' },
  { value: 'devaraj', label: 'Devaraj', pincode: '585211' },
  { value: 'gabbur', label: 'Gabbur', pincode: '585220' },
  { value: 'gundapur', label: 'Gundapur', pincode: '585229' },
  { value: 'halki', label: 'Halki', pincode: '585212' },
  { value: 'kampli', label: 'Kampli', pincode: '585313' },
  { value: 'kamthana', label: 'Kamthana', pincode: '585101' },
  { value: 'khadkola', label: 'Khadkola', pincode: '585208' },
  { value: 'kutbalki', label: 'Kutbalki', pincode: '585315' },
  { value: 'lingasugur', label: 'Lingasugur', pincode: '585401' },
  { value: 'mudnal', label: 'Mudnal', pincode: '585307' },
  { value: 'nidanapur', label: 'Nidanapur', pincode: '585313' },
  { value: 'raghupati', label: 'Raghupati', pincode: '585216' },
  { value: 'sadar', label: 'Sadar', pincode: '585312' },
  { value: 'shirasagi', label: 'Shirasagi', pincode: '585316' },
  { value: 'surpur', label: 'Surpur', pincode: '585202' },
  { value: 'tq-yadgir', label: 'Tq Yadgir', pincode: '585202' },
  { value: 'yadgir-town', label: 'Yadgir Town', pincode: '585202' },
  { value: 'akvalli', label: 'Akvalli', pincode: '585213' },
  { value: 'basapur', label: 'Basapur', pincode: '585216' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '585214' },
  { value: 'chhatarpur', label: 'Chhatarpur', pincode: '585222' },
  { value: 'devapur', label: 'Devapur', pincode: '585201' },
  { value: 'guvvi', label: 'Guvvi', pincode: '585310' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '585307' },
  { value: 'sambapur', label: 'Sambapur', pincode: '585206' },
  { value: 'tandur', label: 'Tandur', pincode: '585303' },
  { value: 'turvihal', label: 'Turvihal', pincode: '585312' },
  { value: 'adakpur', label: 'Adakpur', pincode: '585201' },
  { value: 'anantapur', label: 'Anantapur', pincode: '585213' },
  { value: 'arjunpur', label: 'Arjunpur', pincode: '585204' },
  { value: 'bhimapura', label: 'Bhimapura', pincode: '585216' },
  { value: 'dadapur', label: 'Dadapur', pincode: '585214' },
  { value: 'jambagi', label: 'Jambagi', pincode: '585220' },
  { value: 'kanjalkheda', label: 'Kanjalkheda', pincode: '585306' },
  { value: 'kapatgaon', label: 'Kapatgaon', pincode: '585314' },
  { value: 'karankheda', label: 'Karankheda', pincode: '585210' },
  { value: 'khodgaon', label: 'Khodgaon', pincode: '585311' }
  ],

  'afzalpur': [
  { value: 'adapur', label: 'Adapur', pincode: '585301' },
  { value: 'babbur', label: 'Babbur', pincode: '585305' },
  { value: 'banahalli', label: 'Banahalli', pincode: '585304' },
  { value: 'banshankari', label: 'Banshankari', pincode: '585303' },
  { value: 'chandapur', label: 'Chandapur', pincode: '585305' },
  { value: 'chincholi', label: 'Chincholi', pincode: '585315' },
  { value: 'gabbur', label: 'Gabbur', pincode: '585308' },
  { value: 'gandhinagar', label: 'Gandhinagar', pincode: '585303' },
  { value: 'halki', label: 'Halki', pincode: '585302' },
  { value: 'kampli', label: 'Kampli', pincode: '585306' },
  { value: 'kanakpur', label: 'Kanakpur', pincode: '585301' },
  { value: 'khadkheda', label: 'Khadkheda', pincode: '585309' },
  { value: 'kutbalki', label: 'Kutbalki', pincode: '585305' },
  { value: 'lingasugur', label: 'Lingasugur', pincode: '585313' },
  { value: 'mudnal', label: 'Mudnal', pincode: '585314' },
  { value: 'nidanapur', label: 'Nidanapur', pincode: '585312' },
  { value: 'sadar', label: 'Sadar', pincode: '585307' },
  { value: 'siddapur', label: 'Siddapur', pincode: '585303' },
  { value: 'surpur', label: 'Surpur', pincode: '585301' },
  { value: 'tq-afzalpur', label: 'Tq Afzalpur', pincode: '585301' },
  { value: 'yadgir-town', label: 'Yadgir Town', pincode: '585301' },
  { value: 'alapur', label: 'Alapur', pincode: '585307' },
  { value: 'bichkunda', label: 'Bichkunda', pincode: '585310' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '585309' },
  { value: 'byrapur', label: 'Byrapur', pincode: '585303' },
  { value: 'chandranagar', label: 'Chandranagar', pincode: '585304' },
  { value: 'devapur', label: 'Devapur', pincode: '585301' },
  { value: 'gojalli', label: 'Gojalli', pincode: '585308' },
  { value: 'kanakmardi', label: 'Kanakmardi', pincode: '585306' },
  { value: 'kamathal', label: 'Kamathal', pincode: '585311' },
  { value: 'masali', label: 'Masali', pincode: '585309' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '585312' },
  { value: 'rampur', label: 'Rampur', pincode: '585304' },
  { value: 'somanahalli', label: 'Somanahalli', pincode: '585308' },
  { value: 'turvihal', label: 'Turvihal', pincode: '585307' },
  { value: 'bajjal', label: 'Bajjal', pincode: '585308' },
  { value: 'barmani', label: 'Barmani', pincode: '585314' },
  { value: 'belura', label: 'Belura', pincode: '585305' },
  { value: 'bhivpur-kh', label: 'Bhivpur Kh', pincode: '585311' },
  { value: 'chandrangiri', label: 'Chandrangiri', pincode: '585309' },
  { value: 'doddapur', label: 'Doddapur', pincode: '585312' },
  { value: 'gajjal', label: 'Gajjal', pincode: '585305' },
  { value: 'golgi', label: 'Golgi', pincode: '585306' },
  { value: 'jambagi', label: 'Jambagi', pincode: '585307' },
  { value: 'kamankheda', label: 'Kamankheda', pincode: '585310' },
  { value: 'kudalgi', label: 'Kudalgi', pincode: '585309' }
  ],

  'gokak': [
  { value: 'adapur', label: 'Adapur', pincode: '591303' },
  { value: 'alapur', label: 'Alapur', pincode: '591302' },
  { value: 'babasai', label: 'Babasai', pincode: '591307' },
  { value: 'banahatti', label: 'Banahatti', pincode: '591308' },
  { value: 'bannihatti', label: 'Bannihatti', pincode: '591311' },
  { value: 'belur', label: 'Belur', pincode: '591311' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '591302' },
  { value: 'bovinkoppa', label: 'Bovinkoppa', pincode: '591301' },
  { value: 'chandapur', label: 'Chandapur', pincode: '591303' },
  { value: 'chincholi', label: 'Chincholi', pincode: '591305' },
  { value: 'gajjan', label: 'Gajjan', pincode: '591306' },
  { value: 'gokak-town', label: 'Gokak Town', pincode: '591307' },
  { value: 'golgumbaz', label: 'Golgumbaz', pincode: '591309' },
  { value: 'gudihal', label: 'Gudihal', pincode: '591303' },
  { value: 'hanchinal', label: 'Hanchinal', pincode: '591306' },
  { value: 'harugeri', label: 'Harugeri', pincode: '591312' },
  { value: 'honnur', label: 'Honnur', pincode: '591308' },
  { value: 'kamthi', label: 'Kamthi', pincode: '591309' },
  { value: 'kavali', label: 'Kavali', pincode: '591303' },
  { value: 'kudal', label: 'Kudal', pincode: '591312' },
  { value: 'linginabavi', label: 'Linginabavi', pincode: '591310' },
  { value: 'mudhol', label: 'Mudhol', pincode: '591315' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '591311' },
  { value: 'ranebennur', label: 'Ranebennur', pincode: '591314' },
  { value: 'sannati', label: 'Sannati', pincode: '591313' },
  { value: 'siddapur', label: 'Siddapur', pincode: '591305' },
  { value: 'surapur', label: 'Surapur', pincode: '591310' },
  { value: 'tq-gokak', label: 'Tq Gokak', pincode: '591307' },
  { value: 'wadagaon', label: 'Wadagaon', pincode: '591308' },
  { value: 'bajirao', label: 'Bajirao', pincode: '591307' },
  { value: 'bhivpur-2', label: 'Bhivpur 2', pincode: '591305' },
  { value: 'borlikatti', label: 'Borlikatti', pincode: '591306' },
  { value: 'chandranagar', label: 'Chandranagar', pincode: '591310' },
  { value: 'devapur', label: 'Devapur', pincode: '591314' },
  { value: 'gojalli', label: 'Gojalli', pincode: '591307' },
  { value: 'honnatti', label: 'Honnatti', pincode: '591312' },
  { value: 'kanakmardi', label: 'Kanakmardi', pincode: '591309' },
  { value: 'kamathal', label: 'Kamathal', pincode: '591313' },
  { value: 'kharvi', label: 'Kharvi', pincode: '591305' },
  { value: 'madapur', label: 'Madapur', pincode: '591310' },
  { value: 'malavan', label: 'Malavan', pincode: '591315' },
  { value: 'siddhapur', label: 'Siddhapur', pincode: '591301' },
  { value: 'turvihal', label: 'Turvihal', pincode: '591314' },
  { value: 'uppal', label: 'Uppal', pincode: '591302' },
  { value: 'wadar', label: 'Wadar', pincode: '591301' },
  { value: 'akapur', label: 'Akapur', pincode: '591319' },
  { value: 'bellary', label: 'Bellary', pincode: '591320' },
  { value: 'jambagi', label: 'Jambagi', pincode: '591316' },
  { value: 'karadgi', label: 'Karadgi', pincode: '591318' },
  { value: 'kotur', label: 'Kotur', pincode: '591321' },
  { value: 'malakheda', label: 'Malakheda', pincode: '591322' },
  { value: 'manur', label: 'Manur', pincode: '591323' },
  { value: 'masali', label: 'Masali', pincode: '591324' },
  { value: 'panchgani', label: 'Panchgani', pincode: '591325' },
  { value: 'rampur', label: 'Rampur', pincode: '591326' },
  { value: 'shivapur', label: 'Shivapur', pincode: '591327' },
  { value: 'tirumalapur', label: 'Tirumalapur', pincode: '591328' }
  ],

  'devanahalli': [
  { value: 'anekal', label: 'Anekal', pincode: '562106' },
  { value: 'bannur', label: 'Bannur', pincode: '562110' },
  { value: 'bikkanahalli', label: 'Bikkanahalli', pincode: '562115' },
  { value: 'chandapura', label: 'Chandapura', pincode: '562106' },
  { value: 'chikkaballapur', label: 'Chikkaballapur', pincode: '562101' },
  { value: 'devanahalli-town', label: 'Devanahalli Town', pincode: '562110' },
  { value: 'hebbala', label: 'Hebbala', pincode: '562157' },
  { value: 'hosakote', label: 'Hosakote', pincode: '562114' },
  { value: 'jalahalli', label: 'Jalahalli', pincode: '562102' },
  { value: 'kammasandra', label: 'Kammasandra', pincode: '562114' },
  { value: 'kolar', label: 'Kolar', pincode: '563101' },
  { value: 'krishnapuram', label: 'Krishnapuram', pincode: '562105' },
  { value: 'lakshmipura', label: 'Lakshmipura', pincode: '562109' },
  { value: 'majestic', label: 'Majestic', pincode: '562104' },
  { value: 'nandi-hills', label: 'Nandi Hills', pincode: '562103' },
  { value: 'shanthinagar', label: 'Shanthinagar', pincode: '562111' },
  { value: 'shivagange', label: 'Shivagange', pincode: '562104' },
  { value: 'tq-devanahalli', label: 'Tq Devanahalli', pincode: '562110' },
  { value: 'vijayapura', label: 'Vijayapura', pincode: '562107' },
  { value: 'yelahanka', label: 'Yelahanka', pincode: '562130' },
  { value: 'aluru', label: 'Aluru', pincode: '562106' },
  { value: 'bagaluru', label: 'Bagaluru', pincode: '562157' },
  { value: 'bangarpet', label: 'Bangarpet', pincode: '563114' },
  { value: 'bhogapura', label: 'Bhogapura', pincode: '562106' },
  { value: 'chikkasandra', label: 'Chikkasandra', pincode: '562111' },
  { value: 'doddaballapur', label: 'Doddaballapur', pincode: '561203' },
  { value: 'gokare', label: 'Gokare', pincode: '562105' },
  { value: 'hennur', label: 'Hennur', pincode: '562104' },
  { value: 'kamarajapura', label: 'Kamarajapura', pincode: '562106' },
  { value: 'kavakumarahalli', label: 'Kavakumarahalli', pincode: '562101' },
  { value: 'kolaras', label: 'Kolaras', pincode: '563114' },
  { value: 'madhur', label: 'Madhur', pincode: '562106' },
  { value: 'madahalli', label: 'Madahalli', pincode: '562103' },
  { value: 'malur', label: 'Malur', pincode: '563130' },
  { value: 'manchihalli', label: 'Manchihalli', pincode: '562105' },
  { value: 'marthahalli', label: 'Marthahalli', pincode: '562130' },
  { value: 'nandi-granite', label: 'Nandi Granite', pincode: '562101' },
  { value: 'shivapura', label: 'Shivapura', pincode: '562103' },
  { value: 'thimmapura', label: 'Thimmapura', pincode: '562101' }
  ],

  'ramanagara': [
  { value: 'amangala', label: 'Amangala', pincode: '562127' },
  { value: 'banavara', label: 'Banavara', pincode: '562114' },
  { value: 'bangarpet', label: 'Bangarpet', pincode: '563114' },
  { value: 'bangarapet', label: 'Bangarapet', pincode: '563114' },
  { value: 'bidadi', label: 'Bidadi', pincode: '562109' },
  { value: 'channarayapatna', label: 'Channarayapatna', pincode: '562127' },
  { value: 'channarayapura', label: 'Channarayapura', pincode: '562128' },
  { value: 'garudacharapalya', label: 'Garudacharapalya', pincode: '562115' },
  { value: 'goddapura', label: 'Goddapura', pincode: '562122' },
  { value: 'heggenahalli', label: 'Heggenahalli', pincode: '562126' },
  { value: 'holenarasipura', label: 'Holenarasipura', pincode: '572129' },
  { value: 'kodihalli', label: 'Kodihalli', pincode: '562123' },
  { value: 'kumaraswamy-layout', label: 'Kumaraswamy Layout', pincode: '562139' },
  { value: 'makali', label: 'Makali', pincode: '562104' },
  { value: 'ramanagaram-town', label: 'Ramanagaram Town', pincode: '562159' },
  { value: 'shahabad', label: 'Shahabad', pincode: '563129' },
  { value: 'shivanahalli', label: 'Shivanahalli', pincode: '562122' },
  { value: 'tavarekere', label: 'Tavarekere', pincode: '562123' },
  { value: 'tq-ramanagara', label: 'Tq Ramanagara', pincode: '562159' },
  { value: 'thummanamale', label: 'Thummanamale', pincode: '562115' },
  { value: 'yadavagiri', label: 'Yadavagiri', pincode: '562121' },
  { value: 'banashankari', label: 'Banashankari', pincode: '562139' },
  { value: 'bilikere', label: 'Bilikere', pincode: '562108' },
  { value: 'channarayapura-2', label: 'Channarayapura 2', pincode: '562127' },
  { value: 'chandapura', label: 'Chandapura', pincode: '562106' },
  { value: 'channaraypatna', label: 'Channaraypatna', pincode: '562127' },
  { value: 'doddakallasandra', label: 'Doddakallasandra', pincode: '562116' },
  { value: 'ganapathipura', label: 'Ganapathipura', pincode: '562112' },
  { value: 'hebbal', label: 'Hebbal', pincode: '562110' },
  { value: 'hudukki', label: 'Hudukki', pincode: '562110' },
  { value: 'kambipura', label: 'Kambipura', pincode: '562118' },
  { value: 'kanakapura', label: 'Kanakapura', pincode: '562117' },
  { value: 'kavallam', label: 'Kavallam', pincode: '562114' },
  { value: 'mallappanahalli', label: 'Mallappanahalli', pincode: '562106' },
  { value: 'masagalli', label: 'Masagalli', pincode: '562108' },
  { value: 'muthurayana', label: 'Muthurayana', pincode: '562110' },
  { value: 'nagara', label: 'Nagara', pincode: '562106' },
  { value: 'pattandur', label: 'Pattandur', pincode: '562103' },
  { value: 'ramanagaram-village', label: 'Ramanagaram Village', pincode: '562101' },
  { value: 'somalapura', label: 'Somalapura', pincode: '562113' }
  ],

  'mangaluru': [
  { value: 'abbagal', label: 'Abbagal', pincode: '575001' },
  { value: 'ballalbagh', label: 'Ballalbagh', pincode: '575002' },
  { value: 'bajpe', label: 'Bajpe', pincode: '574142' },
  { value: 'bendoor', label: 'Bendoor', pincode: '575002' },
  { value: 'bondel', label: 'Bondel', pincode: '575008' },
  { value: 'bunts', label: 'Bunts', pincode: '575001' },
  { value: 'catholicate', label: 'Catholicate', pincode: '575007' },
  { value: 'changavara', label: 'Changavara', pincode: '574153' },
  { value: 'gorigudda', label: 'Gorigudda', pincode: '575001' },
  { value: 'karangalpady', label: 'Karangalpady', pincode: '575003' },
  { value: 'katipalla', label: 'Katipalla', pincode: '575021' },
  { value: 'katipalla-udupi', label: 'Katipalla Udupi', pincode: '575021' },
  { value: 'kuntikana', label: 'Kuntikana', pincode: '575004' },
  { value: 'madhava-nagar', label: 'Madhava Nagar', pincode: '575003' },
  { value: 'mangala-devi', label: 'Mangala Devi', pincode: '575003' },
  { value: 'mangalore-central', label: 'Mangalore Central', pincode: '575001' },
  { value: 'mangalore-east', label: 'Mangalore East', pincode: '575001' },
  { value: 'mangalore-north', label: 'Mangalore North', pincode: '575001' },
  { value: 'mangalore-south', label: 'Mangalore South', pincode: '575001' },
  { value: 'padil', label: 'Padil', pincode: '575007' },
  { value: 'pachhanady', label: 'Pachhanady', pincode: '575019' },
  { value: 'puttur', label: 'Puttur', pincode: '574201' },
  { value: 'sultan-battery', label: 'Sultan Battery', pincode: '575002' },
  { value: 'thokkottu', label: 'Thokkottu', pincode: '575005' },
  { value: 'yaswanth-nagar', label: 'Yaswanth Nagar', pincode: '575019' },
  { value: 'alape', label: 'Alape', pincode: '574142' },
  { value: 'attavar', label: 'Attavar', pincode: '575001' },
  { value: 'bajpe-udupi', label: 'Bajpe Udupi', pincode: '574142' },
  { value: 'banjargate', label: 'Banjargate', pincode: '575001' },
  { value: 'bejai', label: 'Bejai', pincode: '575004' },
  { value: 'bikkarnakatte', label: 'Bikkarnakatte', pincode: '575005' },
  { value: 'capitanio', label: 'Capitanio', pincode: '575002' },
  { value: 'kemmannu', label: 'Kemmannu', pincode: '574118' },
  { value: 'kondodi', label: 'Kondodi', pincode: '575022' },
  { value: 'kumara-pura', label: 'Kumara Pura', pincode: '574145' },
  { value: 'kuthar', label: 'Kuthar', pincode: '574105' },
  { value: 'kuntalnagar', label: 'Kuntalnagar', pincode: '574114' },
  { value: 'malali', label: 'Malali', pincode: '574121' },
  { value: 'manjotti', label: 'Manjotti', pincode: '574114' },
  { value: 'mundkur', label: 'Mundkur', pincode: '574118' },
  { value: 'nalapu', label: 'Nalapu', pincode: '574141' },
  { value: 'neerude', label: 'Neerude', pincode: '574112' },
  { value: 'paivalike', label: 'Paivalike', pincode: '574102' },
  { value: 'pilikula', label: 'Pilikula', pincode: '574153' },
  { value: 'sajipanadu', label: 'Sajipanadu', pincode: '574115' },
  { value: 'moodabidri', label: 'Moodabidri', pincode: '574227' },
  { value: 'kinnigoli', label: 'Kinnigoli', pincode: '574150' },
  { value: 'kotekar', label: 'Kotekar', pincode: '575002' },
  { value: 'pallathadka', label: 'Pallathadka', pincode: '574159' },
  { value: 'neermarga', label: 'Neermarga', pincode: '574101' },
  { value: 'panja', label: 'Panja', pincode: '574163' },
  { value: 'shirthady', label: 'Shirthady', pincode: '574115' }
  ],

  'gadag-betageri': [
  { value: 'betageri', label: 'Betageri', pincode: '582101' },
  { value: 'channapur', label: 'Channapur', pincode: '582102' },
  { value: 'gajendragad', label: 'Gajendragad', pincode: '582114' },
  { value: 'gadag', label: 'Gadag', pincode: '582103' },
  { value: 'gavadangundi', label: 'Gavadangundi', pincode: '582114' },
  { value: 'hidkal', label: 'Hidkal', pincode: '582210' },
  { value: 'karjol', label: 'Karjol', pincode: '582101' },
  { value: 'laxmeshwar', label: 'Laxmeshwar', pincode: '582116' },
  { value: 'malkhed', label: 'Malkhed', pincode: '582103' },
  { value: 'mundaragi', label: 'Mundaragi', pincode: '582118' },
  { value: 'nirahalli', label: 'Nirahalli', pincode: '582118' },
  { value: 'rasulabad', label: 'Rasulabad', pincode: '582102' },
  { value: 'sadalaga', label: 'Sadalaga', pincode: '582105' },
  { value: 'sindhnoor', label: 'Sindhnoor', pincode: '582111' },
  { value: 'ankol', label: 'Ankol', pincode: '582101' },
  { value: 'balagavi', label: 'Balagavi', pincode: '582103' },
  { value: 'banahatti', label: 'Banahatti', pincode: '582115' },
  { value: 'belur', label: 'Belur', pincode: '582103' },
  { value: 'bagalkot', label: 'Bagalkot', pincode: '582101' },
  { value: 'yadgir', label: 'Yadgir', pincode: '582109' },
  { value: 'bilagi', label: 'Bilagi', pincode: '582117' },
  { value: 'kanavi', label: 'Kanavi', pincode: '582112' },
  { value: 'pattankodla', label: 'Pattankodla', pincode: '582114' },
  { value: 'neelawadi', label: 'Neelawadi', pincode: '582120' },
  { value: 'sarpanahalli', label: 'Sarpanahalli', pincode: '582115' },
  { value: 'bajragoli', label: 'Bajragoli', pincode: '582118' },
  { value: 'bilgi', label: 'Bilgi', pincode: '582116' },
  { value: 'gajendragad-urban', label: 'Gajendragad Urban', pincode: '582114' },
  { value: 'hadadimatti', label: 'Hadadimatti', pincode: '582105' },
  { value: 'halaga', label: 'Halaga', pincode: '582102' },
  { value: 'hanchinal', label: 'Hanchinal', pincode: '582118' },
  { value: 'madhugiri', label: 'Madhugiri', pincode: '582114' },
  { value: 'rajur', label: 'Rajur', pincode: '582111' },
  { value: 'rayanal', label: 'Rayanal', pincode: '582105' },
  { value: 'sarwad', label: 'Sarwad', pincode: '582110' },
  { value: 'talikota', label: 'Talikota', pincode: '582115' },
  { value: 'vijayanagar', label: 'Vijayanagar', pincode: '582116' }
  ],

  'ranebennur': [
  { value: 'adabala', label: 'Adabala', pincode: '581115' },
  { value: 'bagalkot', label: 'Bagalkot', pincode: '581125' },
  { value: 'bailhongal', label: 'Bailhongal', pincode: '581125' },
  { value: 'belur', label: 'Belur', pincode: '581115' },
  { value: 'dudda', label: 'Dudda', pincode: '581119' },
  { value: 'gangavathi', label: 'Gangavathi', pincode: '581116' },
  { value: 'hatti', label: 'Hatti', pincode: '581120' },
  { value: 'honnali', label: 'Honnali', pincode: '581129' },
  { value: 'karanji', label: 'Karanji', pincode: '581122' },
  { value: 'koodal', label: 'Koodal', pincode: '581114' },
  { value: 'mallapura', label: 'Mallapura', pincode: '581128' },
  { value: 'ranebennur', label: 'Ranebennur', pincode: '581115' },
  { value: 'shiralakoppa', label: 'Shiralakoppa', pincode: '581134' },
  { value: 'sundipura', label: 'Sundipura', pincode: '581122' },
  { value: 'tumbha', label: 'Tumbha', pincode: '581115' },
  { value: 'bannihatti', label: 'Bannihatti', pincode: '581124' },
  { value: 'chikkabidarakere', label: 'Chikkabidarakere', pincode: '581118' },
  { value: 'gundli', label: 'Gundli', pincode: '581113' },
  { value: 'hebbalu', label: 'Hebbalu', pincode: '581116' },
  { value: 'kalasapura', label: 'Kalasapura', pincode: '581125' },
  { value: 'kanaka', label: 'Kanaka', pincode: '581122' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '581115' },
  { value: 'naregal', label: 'Naregal', pincode: '581131' },
  { value: 'pattigod', label: 'Pattigod', pincode: '581115' },
  { value: 'pura', label: 'Pura', pincode: '581128' },
  { value: 'ranebennur-town', label: 'Ranebennur Town', pincode: '581115' },
  { value: 'shankarnahalli', label: 'Shankarnahalli', pincode: '581113' },
  { value: 'siddapura', label: 'Siddapura', pincode: '581119' },
  { value: 'shivapura', label: 'Shivapura', pincode: '581112' },
  { value: 'somanahalli', label: 'Somanahalli', pincode: '581125' },
  { value: 'sugur', label: 'Sugur', pincode: '581133' },
  { value: 'gubbiga', label: 'Gubbiga', pincode: '581129' },
  { value: 'kanakapur', label: 'Kanakapur', pincode: '581116' },
  { value: 'mallur', label: 'Mallur', pincode: '581128' },
  { value: 'manvi', label: 'Manvi', pincode: '581128' },
  { value: 'naregal-koppa', label: 'Naregal Koppa', pincode: '581132' },
  { value: 'siddhanahalli', label: 'Siddhanahalli', pincode: '581125' },
  { value: 'villupuram', label: 'Villupuram', pincode: '581134' },
  { value: 'yadahalli', label: 'Yadahalli', pincode: '581133' }
  ],

  'koppal': [
  { value: 'adavi', label: 'Adavi', pincode: '583237' },
  { value: 'banahatti', label: 'Banahatti', pincode: '583232' },
  { value: 'banapura', label: 'Banapura', pincode: '583223' },
  { value: 'chandapur', label: 'Chandapur', pincode: '583232' },
  { value: 'chitradurga', label: 'Chitradurga', pincode: '583222' },
  { value: 'gowdara', label: 'Gowdara', pincode: '583234' },
  { value: 'hanchinal', label: 'Hanchinal', pincode: '583235' },
  { value: 'honnur', label: 'Honnur', pincode: '583239' },
  { value: 'karatagi', label: 'Karatagi', pincode: '583229' },
  { value: 'koppal', label: 'Koppal', pincode: '583231' },
  { value: 'karehalli', label: 'Karehalli', pincode: '583238' },
  { value: 'kudligi', label: 'Kudligi', pincode: '583235' },
  { value: 'muddapur', label: 'Muddapur', pincode: '583222' },
  { value: 'nadagudi', label: 'Nadagudi', pincode: '583231' },
  { value: 'padmavathi', label: 'Padmavathi', pincode: '583233' },
  { value: 'pattihal', label: 'Pattihal', pincode: '583226' },
  { value: 'ranebennur', label: 'Ranebennur', pincode: '583215' },
  { value: 'somasagara', label: 'Somasagara', pincode: '583230' },
  { value: 'siddapura', label: 'Siddapura', pincode: '583232' },
  { value: 'tadikonda', label: 'Tadikonda', pincode: '583240' },
  { value: 'temple-road', label: 'Temple Road', pincode: '583233' },
  { value: 'veerapura', label: 'Veerapura', pincode: '583241' },
  { value: 'vittalapura', label: 'Vittalapura', pincode: '583242' },
  { value: 'yadgir', label: 'Yadgir', pincode: '583220' },
  { value: 'alapur', label: 'Alapur', pincode: '583237' },
  { value: 'anegundi', label: 'Anegundi', pincode: '583227' },
  { value: 'balabatti', label: 'Balabatti', pincode: '583224' },
  { value: 'banavara', label: 'Banavara', pincode: '583223' },
  { value: 'bichali', label: 'Bichali', pincode: '583235' },
  { value: 'budihal', label: 'Budihal', pincode: '583238' },
  { value: 'gundlapur', label: 'Gundlapur', pincode: '583239' },
  { value: 'hagalavadi', label: 'Hagalavadi', pincode: '583241' },
  { value: 'harihara', label: 'Harihara', pincode: '583234' },
  { value: 'honavar', label: 'Honavar', pincode: '583236' },
  { value: 'kanakapur', label: 'Kanakapur', pincode: '583232' },
  { value: 'kuduvalli', label: 'Kuduvalli', pincode: '583240' },
  { value: 'malkapur', label: 'Malkapur', pincode: '583245' },
  { value: 'shahapur', label: 'Shahapur', pincode: '583246' },
  { value: 'bannur', label: 'Bannur', pincode: '583248' },
  { value: 'bellary', label: 'Bellary', pincode: '583249' },
  { value: 'kanakapura', label: 'Kanakapura', pincode: '583247' },
  { value: 'gundar', label: 'Gundar', pincode: '583250' },
  { value: 'kamalapur', label: 'Kamalapur', pincode: '583251' },
  { value: 'manvalli', label: 'Manvalli', pincode: '583252' },
  { value: 'panchalinga', label: 'Panchalinga', pincode: '583253' }
  ],
  
  'malur': [
  { value: 'adakamaranahalli', label: 'Adakamaranahalli', pincode: '563130' },
  { value: 'alappanahalli', label: 'Alappanahalli', pincode: '563131' },
  { value: 'bannikuppe', label: 'Bannikuppe', pincode: '563132' },
  { value: 'bommadahalli', label: 'Bommadahalli', pincode: '563133' },
  { value: 'chikkarayapur', label: 'Chikkarayapur', pincode: '563134' },
  { value: 'chikkasandra', label: 'Chikkasandra', pincode: '563135' },
  { value: 'chinnappanahalli', label: 'Chinnappanahalli', pincode: '563136' },
  { value: 'malur', label: 'Malur', pincode: '563160' },
  { value: 'manivattana', label: 'Manivattana', pincode: '563161' },
  { value: 'moodaganahalli', label: 'Moodaganahalli', pincode: '563162' },
  { value: 'nagavara', label: 'Nagavara', pincode: '563163' },
  { value: 'somanaikanahalli', label: 'Somanaikanahalli', pincode: '563164' },
  { value: 'tavarekere', label: 'Tavarekere', pincode: '563165' },
  { value: 'vaddarahalli', label: 'Vaddarahalli', pincode: '563166' },
  { value: 'yellahalli', label: 'Yellahalli', pincode: '563167' },
  { value: 'bengaluru', label: 'Bengaluru', pincode: '560001' },
  { value: 'bangarpet', label: 'Bangarpet', pincode: '563114' },
  { value: 'basavanahalli', label: 'Basavanahalli', pincode: '563125' },
  { value: 'beddarahalli', label: 'Beddarahalli', pincode: '563127' },
  { value: 'belur', label: 'Belur', pincode: '563121' },
  { value: 'chintamani', label: 'Chintamani', pincode: '563125' },
  { value: 'dodda-hosahalli', label: 'Dodda Hosahalli', pincode: '563138' },
  { value: 'gollahalli', label: 'Gollahalli', pincode: '563139' },
  { value: 'hosur', label: 'Hosur', pincode: '635109' },
  { value: 'kolar', label: 'Kolar', pincode: '563101' },
  { value: 'kudur', label: 'Kudur', pincode: '563140' },
  { value: 'kurubarapalli', label: 'Kurubarapalli', pincode: '563141' },
  { value: 'marandahalli', label: 'Marandahalli', pincode: '563142' },
  { value: 'mulbagal', label: 'Mulbagal', pincode: '563131' }
  ],
  
  'holenarasipur': [
  { value: 'alathur', label: 'Alathur', pincode: '573211' },
  { value: 'balehonnur', label: 'Balehonnur', pincode: '573212' },
  { value: 'banavara', label: 'Banavara', pincode: '573213' },
  { value: 'bidanur', label: 'Bidanur', pincode: '573214' },
  { value: 'boranahalli', label: 'Boranahalli', pincode: '573215' },
  { value: 'chikkanahalli', label: 'Chikkanahalli', pincode: '573216' },
  { value: 'holenarasipur', label: 'Holenarasipur', pincode: '573220' },
  { value: 'krishnapura', label: 'Krishnapura', pincode: '573221' },
  { value: 'mallenahalli', label: 'Mallenahalli', pincode: '573222' },
  { value: 'muthur', label: 'Muthur', pincode: '573223' },
  { value: 'nallur', label: 'Nallur', pincode: '573224' },
  { value: 'pulikallu', label: 'Pulikallu', pincode: '573225' },
  { value: 'siddapura', label: 'Siddapura', pincode: '573226' },
  { value: 'venkatapura', label: 'Venkatapura', pincode: '573227' },
  { value: 'yellur', label: 'Yellur', pincode: '573228' },
  { value: 'banapura', label: 'Banapura', pincode: '573229' },
  { value: 'chandrashekhara-pura', label: 'Chandrashekhara Pura', pincode: '573230' },
  { value: 'devanahalli', label: 'Devanahalli', pincode: '573231' },
  { value: 'doddamalai', label: 'Doddamalai', pincode: '573232' },
  { value: 'gundlahalli', label: 'Gundlahalli', pincode: '573233' },
  { value: 'hadonahalli', label: 'Hadonahalli', pincode: '573234' },
  { value: 'jaladahalli', label: 'Jaladahalli', pincode: '573235' },
  { value: 'kudur', label: 'Kudur', pincode: '573236' },
  { value: 'mandyahalli', label: 'Mandyahalli', pincode: '573237' },
  { value: 'nagavalli', label: 'Nagavalli', pincode: '573238' },
  { value: 'sankepalya', label: 'Sankepalya', pincode: '573239' },
  { value: 'thimmasandra', label: 'Thimmasandra', pincode: '573240' },
  { value: 'uradihalli', label: 'Uradihalli', pincode: '573241' },
  { value: 'gokul', label: 'Gokul', pincode: '573242' },
  { value: 'hadali', label: 'Hadali', pincode: '573243' },
  { value: 'ilamballi', label: 'Ilamballi', pincode: '573244' },
  { value: 'kappathi', label: 'Kappathi', pincode: '573245' },
  { value: 'maligehalli', label: 'Maligehalli', pincode: '573246' },
  { value: 'muddanahalli', label: 'Muddanahalli', pincode: '573247' },
  { value: 'narlahalli', label: 'Narlahalli', pincode: '573248' },
  { value: 'rajalakshmipuram', label: 'Rajalakshmipuram', pincode: '573249' },
  { value: 'sampigehalli', label: 'Sampigehalli', pincode: '573250' },
  { value: 'tharavanahalli', label: 'Tharavanahalli', pincode: '573251' },
  { value: 'vallabha', label: 'Vallabha', pincode: '573252' },
  { value: 'yadamaru', label: 'Yadamaru', pincode: '573253' },
  { value: 'bhavanahalli', label: 'Bhavanahalli', pincode: '573254' },
  { value: 'yallappanahalli', label: 'Yallappanahalli', pincode: '573255' },
  { value: 'kallapalli', label: 'Kallapalli', pincode: '573256' },
  { value: 'naganahalli', label: 'Naganahalli', pincode: '573257' },
  { value: 'gowdahalli', label: 'Gowdahalli', pincode: '573258' },
  { value: 'rayapur', label: 'Rayapur', pincode: '573259' },
  { value: 'bennehalli', label: 'Bennehalli', pincode: '573260' }
  ],
  
  'laxmeshwar': [
  { value: 'adihalli', label: 'Adihalli', pincode: '581101' },
  { value: 'balepura', label: 'Balepura', pincode: '581102' },
  { value: 'belur', label: 'Belur', pincode: '581103' },
  { value: 'bidi', label: 'Bidi', pincode: '581104' },
  { value: 'chandranahalli', label: 'Chandranahalli', pincode: '581105' },
  { value: 'halebidu', label: 'Halebidu', pincode: '581106' },
  { value: 'kanakachowki', label: 'Kanakachowki', pincode: '581107' },
  { value: 'kanakagiri', label: 'Kanakagiri', pincode: '581108' },
  { value: 'kavithahalli', label: 'Kavithahalli', pincode: '581109' },
  { value: 'kemmanahalli', label: 'Kemmanahalli', pincode: '581110' },
  { value: 'laxmeshwar', label: 'Laxmeshwar', pincode: '581111' },
  { value: 'maranahalli', label: 'Maranahalli', pincode: '581112' },
  { value: 'neelavara', label: 'Neelavara', pincode: '581113' },
  { value: 'rangapura', label: 'Rangapura', pincode: '581114' },
  { value: 'shivapura', label: 'Shivapura', pincode: '581115' },
  { value: 'siddapura', label: 'Siddapura', pincode: '581116' },
  { value: 'somanahalli', label: 'Somanahalli', pincode: '581117' },
  { value: 'somapura', label: 'Somapura', pincode: '581118' },
  { value: 'thimmanahalli', label: 'Thimmanahalli', pincode: '581119' },
  { value: 'vaddarahalli', label: 'Vaddarahalli', pincode: '581120' },
  { value: 'yanapura', label: 'Yanapura', pincode: '581121' },
  { value: 'allapur', label: 'Allapur', pincode: '581122' },
  { value: 'anegundi', label: 'Anegundi', pincode: '581123' },
  { value: 'bandal', label: 'Bandal', pincode: '581124' },
  { value: 'bannikoppa', label: 'Bannikoppa', pincode: '581125' },
  { value: 'kadur', label: 'Kadur', pincode: '581126' },
  { value: 'gokak', label: 'Gokak', pincode: '581127' },
  { value: 'halasuru', label: 'Halasuru', pincode: '581128' },
  { value: 'harihalli', label: 'Harihalli', pincode: '581129' },
  { value: 'huskatti', label: 'Huskatti', pincode: '581130' },
  { value: 'jokatte', label: 'Jokatte', pincode: '581131' },
  { value: 'khanapur', label: 'Khanapur', pincode: '581132' },
  { value: 'krishnapura', label: 'Krishnapura', pincode: '581133' },
  { value: 'manoor', label: 'Manoor', pincode: '581134' },
  { value: 'mudakavi', label: 'Mudakavi', pincode: '581135' },
  { value: 'pethale', label: 'Pethale', pincode: '581136' },
  { value: 'shivajinagar', label: 'Shivajinagar', pincode: '581137' },
  { value: 'sunka', label: 'Sunka', pincode: '581138' },
  { value: 'gogalakere', label: 'Gogalakere', pincode: '581139' },
  { value: 'honnalagere', label: 'Honnalagere', pincode: '581140' },
  { value: 'kabbinahalli', label: 'Kabbinahalli', pincode: '581141' },
  { value: 'kalasa', label: 'Kalasa', pincode: '581142' },
  { value: 'maddanakoppa', label: 'Maddanakoppa', pincode: '581143' },
  { value: 'mallenahalli', label: 'Mallenahalli', pincode: '581144' },
  { value: 'nandanahalli', label: 'Nandanahalli', pincode: '581145' },
  { value: 'rayapura', label: 'Rayapura', pincode: '581146' },
  { value: 'tholpete', label: 'Tholpete', pincode: '581147' }
  ],

  'anekal': [
  { value: 'anjanapura', label: 'Anjanapura', pincode: '562106' },
  { value: 'banaswadi', label: 'Banaswadi', pincode: '562106' },
  { value: 'billekahalli', label: 'Billekahalli', pincode: '562106' },
  { value: 'chakrathahalli', label: 'Chakrathahalli', pincode: '562106' },
  { value: 'channarayana', label: 'Channarayana', pincode: '562106' },
  { value: 'chikkathogur', label: 'Chikkathogur', pincode: '562106' },
  { value: 'deverachikkanahalli', label: 'Deverachikkanahalli', pincode: '562106' },
  { value: 'gollahalli', label: 'Gollahalli', pincode: '562106' },
  { value: 'hagalur', label: 'Hagalur', pincode: '562106' },
  { value: 'harohalli', label: 'Harohalli', pincode: '562106' },
  { value: 'hossahalli', label: 'Hossahalli', pincode: '562106' },
  { value: 'kenkere', label: 'Kenkere', pincode: '562106' },
  { value: 'koramangala', label: 'Koramangala', pincode: '560034' },
  { value: 'kothanur', label: 'Kothanur', pincode: '562106' },
  { value: 'madiwala', label: 'Madiwala', pincode: '560068' },
  { value: 'mulundhalli', label: 'Mulundhalli', pincode: '562106' },
  { value: 'nandagudi', label: 'Nandagudi', pincode: '562106' },
  { value: 'parappana', label: 'Parappana', pincode: '560100' },
  { value: 'sarjapura', label: 'Sarjapura', pincode: '562125' },
  { value: 'siddapura', label: 'Siddapura', pincode: '562106' },
  { value: 'singasandra', label: 'Singasandra', pincode: '562106' },
  { value: 'tharabanahalli', label: 'Tharabanahalli', pincode: '562106' },
  { value: 'vittasandra', label: 'Vittasandra', pincode: '562106' },
  { value: 'banasavadi', label: 'Banasavadi', pincode: '562106' },
  { value: 'bomanhalli', label: 'Bomanhalli', pincode: '560068' },
  { value: 'carmelaram', label: 'Carmelaram', pincode: '562106' },
  { value: 'doddathogur', label: 'Doddathogur', pincode: '562106' },
  { value: 'hiranandani', label: 'Hiranandani', pincode: '562106' },
  { value: 'hebbal', label: 'Hebbal', pincode: '560024' },
  { value: 'jigani', label: 'Jigani', pincode: '562106' },
  { value: 'kanakapura', label: 'Kanakapura', pincode: '562117' },
  { value: 'kudlu', label: 'Kudlu', pincode: '562106' },
  { value: 'mallasandra', label: 'Mallasandra', pincode: '562106' },
  { value: 'mavallipura', label: 'Mavallipura', pincode: '562106' },
  { value: 'neelamangala', label: 'Neelamangala', pincode: '562123' },
  { value: 'singena Agrahara', label: 'Singena Agrahara', pincode: '562106' }
  ],

  'chikkaballapur': [
  { value: 'adigondanahalli', label: 'Adigondanahalli', pincode: '562101' },
  { value: 'ankireddypalya', label: 'Ankireddypalya', pincode: '562103' },
  { value: 'banaswadi', label: 'Banaswadi', pincode: '562101' },
  { value: 'belur', label: 'Belur', pincode: '562102' },
  { value: 'bengaluru', label: 'Bengaluru', pincode: '560002' },
  { value: 'chandapura', label: 'Chandapura', pincode: '562101' },
  { value: 'chikkajala', label: 'Chikkajala', pincode: '562101' },
  { value: 'chintamani', label: 'Chintamani', pincode: '562102' },
  { value: 'gundlapalli', label: 'Gundlapalli', pincode: '562101' },
  { value: 'hesaraghatta', label: 'Hesaraghatta', pincode: '562101' },
  { value: 'hennur', label: 'Hennur', pincode: '562101' },
  { value: 'kavitha', label: 'Kavitha', pincode: '562102' },
  { value: 'kolar', label: 'Kolar', pincode: '563101' },
  { value: 'lakshmipura', label: 'Lakshmipura', pincode: '562101' },
  { value: 'malur', label: 'Malur', pincode: '563160' },
  { value: 'nandi', label: 'Nandi', pincode: '562101' },
  { value: 'penukonda', label: 'Penukonda', pincode: '562101' },
  { value: 'salarpur', label: 'Salarpur', pincode: '562102' },
  { value: 'siddhapura', label: 'Siddhapura', pincode: '562103' },
  { value: 'thimmarayasandra', label: 'Thimmarayasandra', pincode: '562101' },
  { value: 'vijanapura', label: 'Vijanapura', pincode: '562101' },
  { value: 'bidadi', label: 'Bidadi', pincode: '562109' },
  { value: 'bangarpet', label: 'Bangarpet', pincode: '563114' },
  { value: 'chikkaballapur town', label: 'Chikkaballapur Town', pincode: '562101' },
  { value: 'gowribidanur', label: 'Gowribidanur', pincode: '562103' },
  { value: 'kodihalli', label: 'Kodihalli', pincode: '562101' },
  { value: 'yelahanka', label: 'Yelahanka', pincode: '560064' },
  { value: 'ramanagaram', label: 'Ramanagaram', pincode: '562159' },
  { value: 'chowdenahalli', label: 'Chowdenahalli', pincode: '562101' },
  { value: 'singasandra', label: 'Singasandra', pincode: '562106' },
  { value: 'madahalli', label: 'Madahalli', pincode: '562101' },
  { value: 'doddaballapur', label: 'Doddaballapur', pincode: '561203' },
  { value: 'hosakote', label: 'Hosakote', pincode: '562114' },
  { value: 'kyadigowdanahalli', label: 'Kyadigowdanahalli', pincode: '562105' },
  { value: 'mathsande', label: 'Mathsande', pincode: '562102' },
  { value: 'nadigeri', label: 'Nadigeri', pincode: '562103' },
  { value: 'peddanahalli', label: 'Peddanahalli', pincode: '562102' },
  { value: 'ramapura', label: 'Ramapura', pincode: '562102' },
  { value: 'siddharthanagar', label: 'Siddharthanagar', pincode: '562101' },
  { value: 'yellapura', label: 'Yellapura', pincode: '562105' },
  { value: 'udayanagar', label: 'Udayanagar', pincode: '562101' },
  { value: 'vaddarahalli', label: 'Vaddarahalli', pincode: '562101' }
  ],

  'chikkamagaluru': [
  { value: 'adihalli', label: 'Adihalli', pincode: '577101' },
  { value: 'aladahalli', label: 'Aladahalli', pincode: '577102' },
  { value: 'babbukuppe', label: 'Babbukuppe', pincode: '577101' },
  { value: 'ballekere', label: 'Ballekere', pincode: '577101' },
  { value: 'banakal', label: 'Banakal', pincode: '577134' },
  { value: 'chikkamagaluru town', label: 'Chikkamagaluru Town', pincode: '577101' },
  { value: 'chikkahejjuru', label: 'Chikkahejjuru', pincode: '577130' },
  { value: 'chikmagalur', label: 'Chikmagalur', pincode: '577101' },
  { value: 'doddagowdanahalli', label: 'Doddagowdanahalli', pincode: '577101' },
  { value: 'galikere', label: 'Galikere', pincode: '577103' },
  { value: 'jannapura', label: 'Jannapura', pincode: '577126' },
  { value: 'kadur', label: 'Kadur', pincode: '577548' },
  { value: 'kottigehara', label: 'Kottigehara', pincode: '577120' },
  { value: 'kudremukh', label: 'Kudremukh', pincode: '577140' },
  { value: 'mavinahalli', label: 'Mavinahalli', pincode: '577107' },
  { value: 'mudigere', label: 'Mudigere', pincode: '577132' },
  { value: 'nagashettihalli', label: 'Nagashettihalli', pincode: '577101' },
  { value: 'srirampura', label: 'Srirampura', pincode: '577101' },
  { value: 'tavarekere', label: 'Tavarekere', pincode: '577126' },
  { value: 'uppinangadi', label: 'Uppinangadi', pincode: '577107' },
  { value: 'yellapura', label: 'Yellapura', pincode: '577135' },
  { value: 'hebbale', label: 'Hebbale', pincode: '577108' },
  { value: 'nallur', label: 'Nallur', pincode: '577129' },
  { value: 'rajendranahalli', label: 'Rajendranahalli', pincode: '577130' },
  { value: 'sankeshwar', label: 'Sankeshwar', pincode: '577101' },
  { value: 'hulikere', label: 'Hulikere', pincode: '577103' },
  { value: 'alur', label: 'Alur', pincode: '577122' },
  { value: 'arasinakere', label: 'Arasinakere', pincode: '577111' },
  { value: 'buddigere', label: 'Buddigere', pincode: '577135' },
  { value: 'chikkagondanahalli', label: 'Chikkagondanahalli', pincode: '577101' },
  { value: 'hanchinal', label: 'Hanchinal', pincode: '577108' },
  { value: 'manjanahalli', label: 'Manjanahalli', pincode: '577122' },
  { value: 'marekoppa', label: 'Marekoppa', pincode: '577111' },
  { value: 'muppinaghatta', label: 'Muppinaghatta', pincode: '577116' },
  { value: 'pejavara', label: 'Pejavara', pincode: '577127' },
  { value: 'sanivarsante', label: 'Sanivarsante', pincode: '577135' },
  { value: 'thagodu', label: 'Thagodu', pincode: '577111' },
  { value: 'varadapura', label: 'Varadapura', pincode: '577126' },
  { value: 'yerehalli', label: 'Yerehalli', pincode: '577101' }
  ],

  'srirangapatna': [
  { value: 'balepura', label: 'Balepura', pincode: '571438' },
  { value: 'belagola', label: 'Belagola', pincode: '571441' },
  { value: 'bhorkere', label: 'Bhorkere', pincode: '571439' },
  { value: 'doddanahalli', label: 'Doddanahalli', pincode: '571438' },
  { value: 'huthur', label: 'Huthur', pincode: '571421' },
  { value: 'kanakagiri', label: 'Kanakagiri', pincode: '571430' },
  { value: 'malavalli', label: 'Malavalli', pincode: '571430' },
  { value: 'masthikoppalu', label: 'Masthikoppalu', pincode: '571439' },
  { value: 'mugur', label: 'Mugur', pincode: '571439' },
  { value: 'niranahalli', label: 'Niranahalli', pincode: '571436' },
  { value: 'paduvagalu', label: 'Paduvagalu', pincode: '571431' },
  { value: 'pura', label: 'Pura', pincode: '571438' },
  { value: 'srirangapatna town', label: 'Srirangapatna Town', pincode: '571438' },
  { value: 'timmarajapura', label: 'Timmarajapura', pincode: '571440' },
  { value: 'udayapura', label: 'Udayapura', pincode: '571437' },
  { value: 'vaddarahalli', label: 'Vaddarahalli', pincode: '571439' },
  { value: 'aralikatte', label: 'Aralikatte', pincode: '571421' },
  { value: 'bengaluru village', label: 'Bengaluru Village', pincode: '571428' },
  { value: 'kallur', label: 'Kallur', pincode: '571440' },
  { value: 'kudlur', label: 'Kudlur', pincode: '571428' },
  { value: 'malaiyur', label: 'Malaiyur', pincode: '571438' },
  { value: 'salem', label: 'Salem', pincode: '571429' },
  { value: 'palahalli', label: 'Palahalli', pincode: '571435' },
  { value: 'sadarahalli', label: 'Sadarahalli', pincode: '571441' },
  { value: 'vanahalli', label: 'Vanahalli', pincode: '571435' },
  { value: 'chandapura', label: 'Chandapura', pincode: '571439' },
  { value: 'guddahalli', label: 'Guddahalli', pincode: '571437' },
  { value: 'haranahalli', label: 'Haranahalli', pincode: '571431' },
  { value: 'tavarekere', label: 'Tavarekere', pincode: '571426' }
  ],

  'uttara-kannada': [
  { value: 'achhavi', label: 'Achhavi', pincode: '581350' },
  { value: 'ankola', label: 'Ankola', pincode: '581314' },
  { value: 'arga', label: 'Arga', pincode: '581326' },
  { value: 'banavasi', label: 'Banavasi', pincode: '581318' },
  { value: 'bhatkal', label: 'Bhatkal', pincode: '581320' },
  { value: 'bhairumbe', label: 'Bhairumbe', pincode: '581323' },
  { value: 'bidi', label: 'Bidi', pincode: '581351' },
  { value: 'dandeli', label: 'Dandeli', pincode: '581325' },
  { value: 'gokarna', label: 'Gokarna', pincode: '581326' },
  { value: 'hubli', label: 'Hubli', pincode: '581301' },
  { value: 'karwar', label: 'Karwar', pincode: '581301' },
  { value: 'kavle', label: 'Kavle', pincode: '581316' },
  { value: 'kumta', label: 'Kumta', pincode: '581343' },
  { value: 'manjewadi', label: 'Manjewadi', pincode: '581311' },
  { value: 'molahalli', label: 'Molahalli', pincode: '581334' },
  { value: 'naganathapura', label: 'Naganathapura', pincode: '581307' },
  { value: 'patal', label: 'Patal', pincode: '581355' },
  { value: 'siddapura', label: 'Siddapura', pincode: '581355' },
  { value: 'supa', label: 'Supa', pincode: '581357' },
  { value: 'talewadi', label: 'Talewadi', pincode: '581354' },
  { value: 'vibhaga', label: 'Vibhaga', pincode: '581329' },
  { value: 'alnavar', label: 'Alnavar', pincode: '581103' },
  { value: 'bhujunagar', label: 'Bhujunagar', pincode: '581103' },
  { value: 'hulekal', label: 'Hulekal', pincode: '581319' },
  { value: 'kachur', label: 'Kachur', pincode: '581309' },
  { value: 'karajgi', label: 'Karajgi', pincode: '581308' },
  { value: 'kothambagilu', label: 'Kothambagilu', pincode: '581351' },
  { value: 'mavina-halli', label: 'Mavina Halli', pincode: '581351' },
  { value: 'murdeshwar', label: 'Murdeshwar', pincode: '581353' },
  { value: 'naregal', label: 'Naregal', pincode: '581305' },
  { value: 'panji', label: 'Panji', pincode: '581312' },
  { value: 'bekare', label: 'Bekare', pincode: '581338' },
  { value: 'chandavalli', label: 'Chandavalli', pincode: '581319' },
  { value: 'ghatmath', label: 'Ghatmath', pincode: '581310' },
  { value: 'gulvadi', label: 'Gulvadi', pincode: '581316' },
  { value: 'kanangihalli', label: 'Kanangihalli', pincode: '581353' },
  { value: 'kudle', label: 'Kudle', pincode: '581326' },
  { value: 'mathighatta', label: 'Mathighatta', pincode: '581356' },
  { value: 'padubidri', label: 'Padubidri', pincode: '581314' },
  { value: 'shishila', label: 'Shishila', pincode: '581356' },
  { value: 'sonti', label: 'Sonti', pincode: '581312' },
  { value: 'adgaon', label: 'Adgaon', pincode: '581303' },
  { value: 'bevinahalli', label: 'Bevinahalli', pincode: '581352' },
  { value: 'chandraguti', label: 'Chandraguti', pincode: '581355' },
  { value: 'gundiyal', label: 'Gundiyal', pincode: '581340' },
  { value: 'halkar', label: 'Halkar', pincode: '581333' },
  { value: 'karvi', label: 'Karvi', pincode: '581304' },
  { value: 'kunda', label: 'Kunda', pincode: '581336' },
  { value: 'mulur', label: 'Mulur', pincode: '581332' },
  { value: 'paniyar', label: 'Paniyar', pincode: '581344' },
  { value: 'salai', label: 'Salai', pincode: '581341' }
  ],

  'manvi': [
  { value: 'balapur', label: 'Balapur', pincode: '583202' },
  { value: 'bidanur', label: 'Bidanur', pincode: '583205' },
  { value: 'chandapur', label: 'Chandapur', pincode: '583204' },
  { value: 'halaga', label: 'Halaga', pincode: '583206' },
  { value: 'jambal', label: 'Jambal', pincode: '583207' },
  { value: 'kambargi', label: 'Kambargi', pincode: '583209' },
  { value: 'manvi', label: 'Manvi', pincode: '583203' },
  { value: 'muthalapalli', label: 'Muthalapalli', pincode: '583208' },
  { value: 'nagasampalli', label: 'Nagasampalli', pincode: '583205' },
  { value: 'pilluguddi', label: 'Pilluguddi', pincode: '583209' },
  { value: 'savanur', label: 'Savanur', pincode: '583201' },
  { value: 'shiras', label: 'Shiras', pincode: '583210' },
  { value: 'sindhanoor', label: 'Sindhanoor', pincode: '583234' },
  { value: 'varalapur', label: 'Varalapur', pincode: '583211' },
  { value: 'yellapur', label: 'Yellapur', pincode: '583212' },
  { value: 'achhampalli', label: 'Achhampalli', pincode: '583213' },
  { value: 'avalahalli', label: 'Avalahalli', pincode: '583214' },
  { value: 'banavasi', label: 'Banavasi', pincode: '583215' },
  { value: 'chandralapalli', label: 'Chandralapalli', pincode: '583216' },
  { value: 'gundlapalli', label: 'Gundlapalli', pincode: '583217' },
  { value: 'kottur', label: 'Kottur', pincode: '583218' },
  { value: 'lokapur', label: 'Lokapur', pincode: '583219' },
  { value: 'malkapur', label: 'Malkapur', pincode: '583220' },
  { value: 'manakpur', label: 'Manakpur', pincode: '583221' },
  { value: 'srinivaspur', label: 'Srinivaspur', pincode: '583222' },
  { value: 'talikoppa', label: 'Talikoppa', pincode: '583223' },
  { value: 'wardi', label: 'Wardi', pincode: '583224' },
  { value: 'yallapur', label: 'Yallapur', pincode: '583225' },
  { value: 'bangi', label: 'Bangi', pincode: '583226' },
  { value: 'bhagewadi', label: 'Bhagewadi', pincode: '583227' },
  { value: 'bharathi', label: 'Bharathi', pincode: '583228' },
  { value: 'belur', label: 'Belur', pincode: '583229' },
  { value: 'beru', label: 'Beru', pincode: '583230' },
  { value: 'chandranath', label: 'Chandranath', pincode: '583231' },
  { value: 'gokavari', label: 'Gokavari', pincode: '583232' },
  { value: 'kavadi', label: 'Kavadi', pincode: '583233' },
  { value: 'linganapura', label: 'Linganapura', pincode: '583235' },
  { value: 'murugodu', label: 'Murugodu', pincode: '583236' },
  { value: 'narasapura', label: 'Narasapura', pincode: '583237' },
  { value: 'siddapura', label: 'Siddapura', pincode: '583238' },
  { value: 'vidyanagar', label: 'Vidyanagar', pincode: '583239' }
],

  'bagepalli': [
  { value: 'bagepalli-town', label: 'Bagepalli Town', pincode: '561207' },
  { value: 'banavara', label: 'Banavara', pincode: '561208' },
  { value: 'bhogapura', label: 'Bhogapura', pincode: '561209' },
  { value: 'bukkasagara', label: 'Bukkasagara', pincode: '561210' },
  { value: 'devarapalli', label: 'Devarapalli', pincode: '561211' },
  { value: 'gollahalli', label: 'Gollahalli', pincode: '561212' },
  { value: 'hallapur', label: 'Hallapur', pincode: '561213' },
  { value: 'kanakapalli', label: 'Kanakapalli', pincode: '561214' },
  { value: 'kempaiahnapalli', label: 'Kempaiahnapalli', pincode: '561215' },
  { value: 'kolar', label: 'Kolar', pincode: '563101' },
  { value: 'sagarpura', label: 'Sagarpura', pincode: '561216' },
  { value: 'sathyarajapura', label: 'Sathyarajapura', pincode: '561217' },
  { value: 'thumkur', label: 'Thumkur', pincode: '561218' },
  { value: 'adampalli', label: 'Adampalli', pincode: '561219' },
  { value: 'ajjanahalli', label: 'Ajjanahalli', pincode: '561220' },
  { value: 'amaravathi', label: 'Amaravathi', pincode: '561221' },
  { value: 'annanagar', label: 'Annanagar', pincode: '561222' },
  { value: 'babusapalya', label: 'Babusapalya', pincode: '561223' },
  { value: 'bemmangala', label: 'Bemmangala', pincode: '561224' },
  { value: 'chandapura', label: 'Chandapura', pincode: '561225' },
  { value: 'chikkaballapura', label: 'Chikkaballapura', pincode: '561226' },
  { value: 'ganganapalli', label: 'Ganganapalli', pincode: '561227' },
  { value: 'govindapura', label: 'Govindapura', pincode: '561228' },
  { value: 'hayathnagar', label: 'Hayathnagar', pincode: '561229' }
  ],

  'maddur': [
  { value: 'avathi', label: 'Avathi', pincode: '571428' },
  { value: 'banavara', label: 'Banavara', pincode: '571425' },
  { value: 'belligere', label: 'Belligere', pincode: '571426' },
  { value: 'bhairanayakanahalli', label: 'Bhairanayakanahalli', pincode: '571427' },
  { value: 'channarayana', label: 'Channarayana', pincode: '571429' },
  { value: 'chikkabanavara', label: 'Chikkabanavara', pincode: '571430' },
  { value: 'chikkanayakanahalli', label: 'Chikkanayakanahalli', pincode: '571431' },
  { value: 'gopasamudra', label: 'Gopasamudra', pincode: '571432' },
  { value: 'halenahalli', label: 'Halenahalli', pincode: '571433' },
  { value: 'kadol', label: 'Kadol', pincode: '571434' },
  { value: 'krishnapura', label: 'Krishnapura', pincode: '571435' },
  { value: 'maddur-town', label: 'Maddur Town', pincode: '571421' },
  { value: 'malavalli', label: 'Malavalli', pincode: '571423' },
  { value: 'muthur', label: 'Muthur', pincode: '571436' },
  { value: 'pattanahalli', label: 'Pattanahalli', pincode: '571437' },
  { value: 'sangapura', label: 'Sangapura', pincode: '571438' },
  { value: 'sidiganahalli', label: 'Sidiganahalli', pincode: '571439' },
  { value: 'tiptur', label: 'Tiptur', pincode: '571440' },
  { value: 'aralaguppe', label: 'Aralaguppe', pincode: '571441' },
  { value: 'bikkanahalli', label: 'Bikkanahalli', pincode: '571442' },
  { value: 'chennaiahnapalya', label: 'Chennaiahnapalya', pincode: '571443' },
  { value: 'churdagatta', label: 'Churdagatta', pincode: '571444' },
  { value: 'halebid', label: 'Halebid', pincode: '571445' },
  { value: 'hottigere', label: 'Hottigere', pincode: '571446' },
  { value: 'krishnagiri', label: 'Krishnagiri', pincode: '571447' },
  { value: 'maddur-village', label: 'Maddur Village', pincode: '571448' },
  { value: 'manchanahalli', label: 'Manchanahalli', pincode: '571449' },
  { value: 'nandihalli', label: 'Nandihalli', pincode: '571450' },
  { value: 'peddahalli', label: 'Peddahalli', pincode: '571451' },
  { value: 'ramanahalli', label: 'Ramanahalli', pincode: '571452' },
  { value: 'siddapura', label: 'Siddapura', pincode: '571453' },
  { value: 'singanahalli', label: 'Singanahalli', pincode: '571454' },
  { value: 'tavarekere', label: 'Tavarekere', pincode: '571455' },
  { value: 'tippanahalli', label: 'Tippanahalli', pincode: '571456' },
  { value: 'yelenahalli', label: 'Yelenahalli', pincode: '571457' }
  ],

  'bhadravathi': [
  { value: 'banavara', label: 'Banavara', pincode: '577301' },
  { value: 'bhadravathi-town', label: 'Bhadravathi Town', pincode: '577301' },
  { value: 'binnimallige', label: 'Binnimallige', pincode: '577302' },
  { value: 'chandapura', label: 'Chandapura', pincode: '577303' },
  { value: 'chikkahalli', label: 'Chikkahalli', pincode: '577304' },
  { value: 'chitravathi', label: 'Chitravathi', pincode: '577305' },
  { value: 'huliyar', label: 'Huliyar', pincode: '577306' },
  { value: 'jagaluru', label: 'Jagaluru', pincode: '577307' },
  { value: 'kadur', label: 'Kadur', pincode: '577308' },
  { value: 'kanagal', label: 'Kanagal', pincode: '577309' },
  { value: 'kappagallu', label: 'Kappagallu', pincode: '577310' },
  { value: 'kuruvalli', label: 'Kuruvalli', pincode: '577311' },
  { value: 'madduru', label: 'Madduru', pincode: '577312' },
  { value: 'nallur', label: 'Nallur', pincode: '577313' },
  { value: 'pandaravalli', label: 'Pandaravalli', pincode: '577314' },
  { value: 'singanayakanahalli', label: 'Singanayakanahalli', pincode: '577315' },
  { value: 'somanahalli', label: 'Somanahalli', pincode: '577316' },
  { value: 'tavarekere', label: 'Tavarekere', pincode: '577317' },
  { value: 'thimmanahalli', label: 'Thimmanahalli', pincode: '577318' },
  { value: 'virajpet', label: 'Virajpet', pincode: '577319' },
  { value: 'adhiraj', label: 'Adhiraj', pincode: '577320' },
  { value: 'banashankari', label: 'Banashankari', pincode: '577321' },
  { value: 'bavadoddi', label: 'Bavadoddi', pincode: '577322' },
  { value: 'bhatkuppe', label: 'Bhatkuppe', pincode: '577323' },
  { value: 'japthapur', label: 'Japthapur', pincode: '577324' },
  { value: 'kebbadikatte', label: 'Kebbadikatte', pincode: '577325' },
  { value: 'mallapura', label: 'Mallapura', pincode: '577326' },
  { value: 'srirampura', label: 'Srirampura', pincode: '577327' },
  { value: 'muttinakoppa', label: 'Muttinakoppa', pincode: '577328' },
  { value: 'siddapura', label: 'Siddapura', pincode: '577329' },
  { value: 'gangavathi', label: 'Gangavathi', pincode: '577330' },
  { value: 'ankolalu', label: 'Ankolalu', pincode: '577331' },
  { value: 'kallur', label: 'Kallur', pincode: '577332' },
  { value: 'honnagiri', label: 'Honnagiri', pincode: '577333' },
  { value: 'bevinahalli', label: 'Bevinahalli', pincode: '577334' }
  ],

  'chintamani': [
  { value: 'abhayapura', label: 'Abhayapura', pincode: '563125' },
  { value: 'adigondanahalli', label: 'Adigondanahalli', pincode: '563126' },
  { value: 'balgal', label: 'Balgal', pincode: '563127' },
  { value: 'banganahalli', label: 'Banganahalli', pincode: '563128' },
  { value: 'banaswadi', label: 'Banaswadi', pincode: '563129' },
  { value: 'basavanahalli', label: 'Basavanahalli', pincode: '563130' },
  { value: 'bhattarahalli', label: 'Bhattarahalli', pincode: '563131' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '563132' },
  { value: 'chintamani-town', label: 'Chintamani Town', pincode: '563133' },
  { value: 'chokkahalli', label: 'Chokkahalli', pincode: '563134' },
  { value: 'donkondahalli', label: 'Donkondahalli', pincode: '563135' },
  { value: 'gaddanahalli', label: 'Gaddanahalli', pincode: '563136' },
  { value: 'giri', label: 'Giri', pincode: '563137' },
  { value: 'hallikheda', label: 'Hallikheda', pincode: '563138' },
  { value: 'hebbalahalli', label: 'Hebbalahalli', pincode: '563139' },
  { value: 'jenukal', label: 'Jenukal', pincode: '563140' },
  { value: 'kenchanahalli', label: 'Kenchanahalli', pincode: '563141' },
  { value: 'kothenahalli', label: 'Kothenahalli', pincode: '563142' },
  { value: 'malur', label: 'Malur', pincode: '563143' },
  { value: 'nalvadi', label: 'Nalvadi', pincode: '563144' },
  { value: 'neelakantapura', label: 'Neelakantapura', pincode: '563145' },
  { value: 'pranahalli', label: 'Pranahalli', pincode: '563146' },
  { value: 'rajapura', label: 'Rajapura', pincode: '563147' },
  { value: 'ramagondanahalli', label: 'Ramagondanahalli', pincode: '563148' },
  { value: 'siddapura', label: 'Siddapura', pincode: '563149' },
  { value: 'singapura', label: 'Singapura', pincode: '563150' },
  { value: 'vallur', label: 'Vallur', pincode: '563151' },
  { value: 'yadupura', label: 'Yadupura', pincode: '563152' },
  { value: 'allaka', label: 'Allaka', pincode: '563153' },
  { value: 'bennur', label: 'Bennur', pincode: '563154' },
  { value: 'bramhapuri', label: 'Bramhapuri', pincode: '563155' },
  { value: 'chickarayapur', label: 'Chickarayapur', pincode: '563156' },
  { value: 'dakshinaswara', label: 'Dakshinaswara', pincode: '563157' },
  { value: 'gangavathi', label: 'Gangavathi', pincode: '563158' },
  { value: 'haragadde', label: 'Haragadde', pincode: '563159' },
  { value: 'jogihalli', label: 'Jogihalli', pincode: '563160' },
  { value: 'kaginahalli', label: 'Kaginahalli', pincode: '563161' },
  { value: 'kallur', label: 'Kallur', pincode: '563162' },
  { value: 'malapuri', label: 'Malapuri', pincode: '563163' },
  { value: 'muthur', label: 'Muthur', pincode: '563164' },
  { value: 'naganahalli', label: 'Naganahalli', pincode: '563165' },
  { value: 'ranganahalli', label: 'Ranganahalli', pincode: '563166' },
  { value: 'siddharthapura', label: 'Siddharthapura', pincode: '563167' }
  ],

  'gangavathi': [
  { value: 'adampur', label: 'Adampur', pincode: '583227' },
  { value: 'annigiri', label: 'Annigiri', pincode: '583229' },
  { value: 'bagdoddi', label: 'Bagdoddi', pincode: '583227' },
  { value: 'bangarpet', label: 'Bangarpet', pincode: '583228' },
  { value: 'binkadakatti', label: 'Binkadakatti', pincode: '583227' },
  { value: 'chikkabettahalli', label: 'Chikkabettahalli', pincode: '583229' },
  { value: 'gangavathi', label: 'Gangavathi', pincode: '583227' },
  { value: 'gantur', label: 'Gantur', pincode: '583227' },
  { value: 'gulur', label: 'Gulur', pincode: '583227' },
  { value: 'halasuru', label: 'Halasuru', pincode: '583229' },
  { value: 'hampa', label: 'Hampa', pincode: '583227' },
  { value: 'karur', label: 'Karur', pincode: '583229' },
  { value: 'kurugodu', label: 'Kurugodu', pincode: '583229' },
  { value: 'mallasamudra', label: 'Mallasamudra', pincode: '583227' },
  { value: 'manchukonda', label: 'Manchukonda', pincode: '583229' },
  { value: 'nandi', label: 'Nandi', pincode: '583229' },
  { value: 'puducheri', label: 'Puducheri', pincode: '583227' },
  { value: 'rajapete', label: 'Rajapete', pincode: '583228' },
  { value: 'sampigehalli', label: 'Sampigehalli', pincode: '583229' },
  { value: 'thimmapur', label: 'Thimmapur', pincode: '583229' },
  { value: 'tondanur', label: 'Tondanur', pincode: '583227' },
  { value: 'veerapur', label: 'Veerapur', pincode: '583229' },
  { value: 'yermal', label: 'Yermal', pincode: '583229' }
  ],

  'harapanahalli': [
  { value: 'adavi', label: 'Adavi', pincode: '583131' },
  { value: 'arasinakere', label: 'Arasinakere', pincode: '583131' },
  { value: 'badanahalli', label: 'Badanahalli', pincode: '583131' },
  { value: 'basavanahalli', label: 'Basavanahalli', pincode: '583131' },
  { value: 'bhivapur', label: 'Bhivapur', pincode: '583131' },
  { value: 'channagiri', label: 'Channagiri', pincode: '583131' },
  { value: 'harapanahalli', label: 'Harapanahalli', pincode: '583131' },
  { value: 'honnali', label: 'Honnali', pincode: '583131' },
  { value: 'kallahalli', label: 'Kallahalli', pincode: '583131' },
  { value: 'kanakagiri', label: 'Kanakagiri', pincode: '583131' },
  { value: 'kottur', label: 'Kottur', pincode: '583131' },
  { value: 'maddur', label: 'Maddur', pincode: '583131' },
  { value: 'nagenahalli', label: 'Nagenahalli', pincode: '583131' },
  { value: 'pavadavalli', label: 'Pavadavalli', pincode: '583131' },
  { value: 'somapur', label: 'Somapur', pincode: '583131' },
  { value: 'thimmanahalli', label: 'Thimmanahalli', pincode: '583131' },
  { value: 'venkatapura', label: 'Venkatapura', pincode: '583131' },
  { value: 'yadavanahalli', label: 'Yadavanahalli', pincode: '583131' },
  { value: 'agasanahalli', label: 'Agasanahalli', pincode: '583131' },
  { value: 'bommanahalli', label: 'Bommanahalli', pincode: '583131' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '583131' },
  { value: 'doddahalli', label: 'Doddahalli', pincode: '583131' },
  { value: 'mallasamudra', label: 'Mallasamudra', pincode: '583131' },
  { value: 'nayakanahalli', label: 'Nayakanahalli', pincode: '583131' },
  { value: 'somanahalli', label: 'Somanahalli', pincode: '583131' }
  ],

  'ilkal': [
  { value: 'adihalli', label: 'Adihalli', pincode: '583134' },
  { value: 'bababail', label: 'Bababail', pincode: '583134' },
  { value: 'balaganur', label: 'Balaganur', pincode: '583134' },
  { value: 'bangarhatti', label: 'Bangarhatti', pincode: '583134' },
  { value: 'bhanapur', label: 'Bhanapur', pincode: '583134' },
  { value: 'chandapur', label: 'Chandapur', pincode: '583134' },
  { value: 'ilkal', label: 'Ilkal', pincode: '583134' },
  { value: 'jamkhandi', label: 'Jamkhandi', pincode: '587301' },
  { value: 'karadikoppa', label: 'Karadikoppa', pincode: '583134' },
  { value: 'kembhavi', label: 'Kembhavi', pincode: '583134' },
  { value: 'kosigi', label: 'Kosigi', pincode: '583134' },
  { value: 'mathod', label: 'Mathod', pincode: '583134' },
  { value: 'naganur', label: 'Naganur', pincode: '583134' },
  { value: 'pavadahalli', label: 'Pavadahalli', pincode: '583134' },
  { value: 'sangapura', label: 'Sangapura', pincode: '583134' },
  { value: 'siddapur', label: 'Siddapur', pincode: '583134' },
  { value: 'surapur', label: 'Surapur', pincode: '583134' },
  { value: 'bandihalli', label: 'Bandihalli', pincode: '583134' },
  { value: 'bailur', label: 'Bailur', pincode: '583134' },
  { value: 'hatti', label: 'Hatti', pincode: '583134' },
  { value: 'koppal', label: 'Koppal', pincode: '583231' },
  { value: 'madapur', label: 'Madapur', pincode: '583134' },
  { value: 'peddapur', label: 'Peddapur', pincode: '583134' },
  { value: 'sannapur', label: 'Sannapur', pincode: '583134' },
  { value: 'shiralakoppa', label: 'Shiralakoppa', pincode: '583134' },
  { value: 'basavanahalli', label: 'Basavanahalli', pincode: '583134' },
  { value: 'baskeri', label: 'Baskeri', pincode: '583134' },
  { value: 'devarahipparagi', label: 'Devarahipparagi', pincode: '583134' },
  { value: 'ghattihalli', label: 'Ghattihalli', pincode: '583134' },
  { value: 'hallur', label: 'Hallur', pincode: '583134' },
  { value: 'jagalur', label: 'Jagalur', pincode: '583134' },
  { value: 'kerur', label: 'Kerur', pincode: '583134' },
  { value: 'shivapur', label: 'Shivapur', pincode: '583134' },
  { value: 'tedanahalli', label: 'Tedanahalli', pincode: '583134' },
  { value: 'chinchali', label: 'Chinchali', pincode: '583134' },
  { value: 'banahatti', label: 'Banahatti', pincode: '583134' },
  { value: 'halwad', label: 'Halwad', pincode: '583134' },
  { value: 'kampi', label: 'Kampi', pincode: '583134' },
  { value: 'mugad', label: 'Mugad', pincode: '583134' },
  { value: 'papanahalli', label: 'Papanahalli', pincode: '583134' },
  { value: 'ravoor', label: 'Ravoor', pincode: '583134' },
  { value: 'siddeshwar', label: 'Siddeshwar', pincode: '583134' },
  { value: 'sindhanur', label: 'Sindhanur', pincode: '583134' }
  ],

  'madikeri': [
  { value: 'alale', label: 'Alale', pincode: '571201' },
  { value: 'baghamandala', label: 'Baghamandala', pincode: '571201' },
  { value: 'balele', label: 'Balele', pincode: '571201' },
  { value: 'balugodu', label: 'Balugodu', pincode: '571201' },
  { value: 'besagarahalli', label: 'Besagarahalli', pincode: '571201' },
  { value: 'devapura', label: 'Devapura', pincode: '571201' },
  { value: 'gaddige', label: 'Gaddige', pincode: '571201' },
  { value: 'kakkabe', label: 'Kakkabe', pincode: '571232' },
  { value: 'kalakeri', label: 'Kalakeri', pincode: '571201' },
  { value: 'koodige', label: 'Koodige', pincode: '571214' },
  { value: 'madikeri', label: 'Madikeri', pincode: '571201' },
  { value: 'madhapur', label: 'Madhapur', pincode: '571201' },
  { value: 'makuta', label: 'Makuta', pincode: '571201' },
  { value: 'manchalli', label: 'Manchalli', pincode: '571214' },
  { value: 'menyeri', label: 'Menyeri', pincode: '571201' },
  { value: 'naadapara', label: 'Naadapara', pincode: '571201' },
  { value: 'nishala', label: 'Nishala', pincode: '571201' },
  { value: 'padiyapele', label: 'Padiyapele', pincode: '571201' },
  { value: 'suntikoppa', label: 'Suntikoppa', pincode: '571237' },
  { value: 'thuruballi', label: 'Thuruballi', pincode: '571201' },
  { value: 'vontiangadi', label: 'Vontiangadi', pincode: '571201' },
  { value: 'agooru', label: 'Agooru', pincode: '571201' },
  { value: 'antharala', label: 'Antharala', pincode: '571237' },
  { value: 'bittangala', label: 'Bittangala', pincode: '571201' },
  { value: 'gundya', label: 'Gundya', pincode: '571232' },
  { value: 'hunsur', label: 'Hunsur', pincode: '571105' },
  { value: 'jaynagar', label: 'Jaynagar', pincode: '571237' },
  { value: 'kajjuru', label: 'Kajjuru', pincode: '571201' },
  { value: 'kudige', label: 'Kudige', pincode: '571237' },
  { value: 'madapura', label: 'Madapura', pincode: '571237' },
  { value: 'malleswar', label: 'Malleswar', pincode: '571237' },
  { value: 'marandahalli', label: 'Marandahalli', pincode: '571232' },
  { value: 'minchukallu', label: 'Minchukallu', pincode: '571237' },
  { value: 'nalkur', label: 'Nalkur', pincode: '571201' },
  { value: 'nechunala', label: 'Nechunala', pincode: '571232' },
  { value: 'pangala', label: 'Pangala', pincode: '571201' },
  { value: 'sampaje', label: 'Sampaje', pincode: '571232' },
  { value: 'shantalli', label: 'Shantalli', pincode: '571232' },
  { value: 'somwarpet', label: 'Somwarpet', pincode: '571236' },
  { value: 'teligaru', label: 'Teligaru', pincode: '571237' },
  { value: 'amathi', label: 'Amathi', pincode: '571201' },
  { value: 'attur', label: 'Attur', pincode: '571237' },
  { value: 'biddatala', label: 'Biddatala', pincode: '571237' },
  { value: 'chavadi', label: 'Chavadi', pincode: '571232' },
  { value: 'chikkanayakanahalli', label: 'Chikkanayakanahalli', pincode: '571237' },
  { value: 'halkar', label: 'Halkar', pincode: '571237' },
  { value: 'hampapura', label: 'Hampapura', pincode: '571232' },
  { value: 'kadrimala', label: 'Kadrimala', pincode: '571237' },
  { value: 'kallur', label: 'Kallur', pincode: '571237' },
  { value: 'kudumallur', label: 'Kudumallur', pincode: '571232' },
  { value: 'madihalli', label: 'Madihalli', pincode: '571237' },
  { value: 'nalpad', label: 'Nalpad', pincode: '571237' },
  { value: 'siddapura', label: 'Siddapura', pincode: '571202' },
  { value: 'vaddanige', label: 'Vaddanige', pincode: '571237' }
  ],

  'magadi': [
  { value: 'amruthahalli', label: 'Amruthahalli', pincode: '562120' },
  { value: 'balepet', label: 'Balepet', pincode: '562120' },
  { value: 'bengaluru', label: 'Bengaluru', pincode: '560001' },
  { value: 'channarayapatna', label: 'Channarayapatna', pincode: '562120' },
  { value: 'chikkajala', label: 'Chikkajala', pincode: '562157' },
  { value: 'honnasandra', label: 'Honnasandra', pincode: '562120' },
  { value: 'hosahalli', label: 'Hosahalli', pincode: '562120' },
  { value: 'hosur', label: 'Hosur', pincode: '562120' },
  { value: 'hebbal', label: 'Hebbal', pincode: '562120' },
  { value: 'jayanagar', label: 'Jayanagar', pincode: '562120' },
  { value: 'kammanahalli', label: 'Kammanahalli', pincode: '562120' },
  { value: 'kengeri', label: 'Kengeri', pincode: '560060' },
  { value: 'kudlu', label: 'Kudlu', pincode: '562120' },
  { value: 'magadi', label: 'Magadi', pincode: '562120' },
  { value: 'mangala', label: 'Mangala', pincode: '562120' },
  { value: 'santhebenne', label: 'Santhebenne', pincode: '562120' },
  { value: 'sathnur', label: 'Sathnur', pincode: '562120' },
  { value: 'yadavanahalli', label: 'Yadavanahalli', pincode: '562120' },
  { value: 'karlapalli', label: 'Karlapalli', pincode: '562120' },
  { value: 'kottigehara', label: 'Kottigehara', pincode: '562120' },
  { value: 'mallanayakanahalli', label: 'Mallanayakanahalli', pincode: '562120' },
  { value: 'moodahadu', label: 'Moodahadu', pincode: '562120' },
  { value: 'panathur', label: 'Panathur', pincode: '562120' },
  { value: 'sathnuru', label: 'Sathnuru', pincode: '562120' },
  { value: 'vittalapura', label: 'Vittalapura', pincode: '562120' },
  { value: 'rajanahalli', label: 'Rajanahalli', pincode: '562120' },
  { value: 'shanthapur', label: 'Shanthapur', pincode: '562120' },
  { value: 'thogur', label: 'Thogur', pincode: '562120' },
  { value: 'veeranakere', label: 'Veeranakere', pincode: '562120' },
  { value: 'yelenahalli', label: 'Yelenahalli', pincode: '562120' }
  ],
  
  'molakalmuru': [
  { value: 'banavara', label: 'Banavara', pincode: '577535' },
  { value: 'bharathinagar', label: 'Bharathinagar', pincode: '577535' },
  { value: 'bentur', label: 'Bentur', pincode: '577535' },
  { value: 'biddahalli', label: 'Biddahalli', pincode: '577535' },
  { value: 'doddaghattihalli', label: 'Doddaghattihalli', pincode: '577535' },
  { value: 'gopahalli', label: 'Gopahalli', pincode: '577535' },
  { value: 'kalasa', label: 'Kalasa', pincode: '577535' },
  { value: 'kalluru', label: 'Kalluru', pincode: '577535' },
  { value: 'kemmannu', label: 'Kemmannu', pincode: '577535' },
  { value: 'molakalmuru', label: 'Molakalmuru', pincode: '577535' },
  { value: 'mulbagal', label: 'Mulbagal', pincode: '577535' },
  { value: 'nallur', label: 'Nallur', pincode: '577535' },
  { value: 'sakarayapattana', label: 'Sakarayapattana', pincode: '577535' },
  { value: 'srirampura', label: 'Srirampura', pincode: '577535' },
  { value: 'thalakere', label: 'Thalakere', pincode: '577535' },
  { value: 'vadagere', label: 'Vadagere', pincode: '577535' },
  { value: 'chandravalli', label: 'Chandravalli', pincode: '577535' },
  { value: 'doddakallahalli', label: 'Doddakallahalli', pincode: '577535' },
  { value: 'haralahalli', label: 'Haralahalli', pincode: '577535' },
  { value: 'hebbal', label: 'Hebbal', pincode: '577535' },
  { value: 'kelavalli', label: 'Kelavalli', pincode: '577535' },
  { value: 'kottur', label: 'Kottur', pincode: '577535' },
  { value: 'mallikere', label: 'Mallikere', pincode: '577535' },
  { value: 'padmavathi', label: 'Padmavathi', pincode: '577535' },
  { value: 'ranganahalli', label: 'Ranganahalli', pincode: '577535' },
  { value: 'siddapura', label: 'Siddapura', pincode: '577535' },
  { value: 'thandavapura', label: 'Thandavapura', pincode: '577535' },
  { value: 'vaddarahalli', label: 'Vaddarahalli', pincode: '577535' },
  { value: 'yaswanthapura', label: 'Yaswanthapura', pincode: '577535' },
  { value: 'aralikatti', label: 'Aralikatti', pincode: '577535' },
  { value: 'belur', label: 'Belur', pincode: '577535' },
  { value: 'chickmangala', label: 'Chickmangala', pincode: '577535' },
  { value: 'doddanayakanahalli', label: 'Doddanayakanahalli', pincode: '577535' },
  { value: 'gangavathi', label: 'Gangavathi', pincode: '577535' },
  { value: 'harohalli', label: 'Harohalli', pincode: '577535' },
  { value: 'kundur', label: 'Kundur', pincode: '577535' },
  { value: 'madarahalli', label: 'Madarahalli', pincode: '577535' },
  { value: 'mallapalli', label: 'Mallapalli', pincode: '577535' },
  { value: 'tavarekere', label: 'Tavarekere', pincode: '577535' },
  { value: 'vaderahalli', label: 'Vaderahalli', pincode: '577535' },
  { value: 'yadavgowda', label: 'Yadavgowda', pincode: '577535' }
  ],

  'robertsonpet': [
  { value: 'balehonnur', label: 'Balehonnur', pincode: '577548' },
  { value: 'banavara', label: 'Banavara', pincode: '577548' },
  { value: 'belur', label: 'Belur', pincode: '577548' },
  { value: 'bhadravathi', label: 'Bhadravathi', pincode: '577301' },
  { value: 'channarayapatna', label: 'Channarayapatna', pincode: '577539' },
  { value: 'harohalli', label: 'Harohalli', pincode: '577548' },
  { value: 'hosahalli', label: 'Hosahalli', pincode: '577548' },
  { value: 'jogihalli', label: 'Jogihalli', pincode: '577548' },
  { value: 'karanji', label: 'Karanji', pincode: '577548' },
  { value: 'kavadi', label: 'Kavadi', pincode: '577548' },
  { value: 'koodlahalli', label: 'Koodlahalli', pincode: '577548' },
  { value: 'kudur', label: 'Kudur', pincode: '577548' },
  { value: 'robertsonpet', label: 'Robertsonpet', pincode: '577549' },
  { value: 'siddapura', label: 'Siddapura', pincode: '577548' },
  { value: 'thallavara', label: 'Thallavara', pincode: '577548' },
  { value: 'vaderahalli', label: 'Vaderahalli', pincode: '577548' },
  { value: 'vijayanagar', label: 'Vijayanagar', pincode: '577548' },
  { value: 'halli', label: 'Halli', pincode: '577548' },
  { value: 'ranjanahalli', label: 'Ranjanahalli', pincode: '577548' },
  { value: 'karigara', label: 'Karigara', pincode: '577548' },
  { value: 'chikkavara', label: 'Chikkavara', pincode: '577548' },
  { value: 'malur', label: 'Malur', pincode: '577548' },
  { value: 'srinivasanahalli', label: 'Srinivasanahalli', pincode: '577548' },
  { value: 'yelenahalli', label: 'Yelenahalli', pincode: '577548' },
  { value: 'belenahalli', label: 'Belenahalli', pincode: '577548' },
  { value: 'doddahatti', label: 'Doddahatti', pincode: '577548' },
  { value: 'hebbalagere', label: 'Hebbalagere', pincode: '577548' },
  { value: 'kanakapura', label: 'Kanakapura', pincode: '577548' },
  { value: 'nagavara', label: 'Nagavara', pincode: '577548' },
  { value: 'nandi', label: 'Nandi', pincode: '577548' },
  { value: 'sampige', label: 'Sampige', pincode: '577548' },
  { value: 'turahalli', label: 'Turahalli', pincode: '577548' },
  { value: 'uruvinagada', label: 'Uruvinagada', pincode: '577548' }
  ],

  'sakleshpura': [
  { value: 'alur', label: 'Alur', pincode: '573124' },
  { value: 'aluru', label: 'Aluru', pincode: '573124' },
  { value: 'balehonnur', label: 'Balehonnur', pincode: '573127' },
  { value: 'balanayanahalli', label: 'Balanayanahalli', pincode: '573127' },
  { value: 'bandekallu', label: 'Bandekallu', pincode: '573127' },
  { value: 'banavara', label: 'Banavara', pincode: '573127' },
  { value: 'bavikere', label: 'Bavikere', pincode: '573127' },
  { value: 'bennekuppe', label: 'Bennekuppe', pincode: '573127' },
  { value: 'bilekallu', label: 'Bilekallu', pincode: '573127' },
  { value: 'chandragiri', label: 'Chandragiri', pincode: '573127' },
  { value: 'chikkur', label: 'Chikkur', pincode: '573127' },
  { value: 'gulur', label: 'Gulur', pincode: '573127' },
  { value: 'harohalli', label: 'Harohalli', pincode: '573127' },
  { value: 'hegdehalli', label: 'Hegdehalli', pincode: '573127' },
  { value: 'hebbal', label: 'Hebbal', pincode: '573127' },
  { value: 'heggadde', label: 'Heggadde', pincode: '573127' },
  { value: 'jambur', label: 'Jambur', pincode: '573127' },
  { value: 'karadikallu', label: 'Karadikallu', pincode: '573127' },
  { value: 'karkachikatte', label: 'Karkachikatte', pincode: '573127' },
  { value: 'kudige', label: 'Kudige', pincode: '573127' },
  { value: 'kudremukh', label: 'Kudremukh', pincode: '573127' },
  { value: 'manjarabad', label: 'Manjarabad', pincode: '573127' },
  { value: 'mandi', label: 'Mandi', pincode: '573127' },
  { value: 'muthumala', label: 'Muthumala', pincode: '573127' },
  { value: 'nagenahalli', label: 'Nagenahalli', pincode: '573127' },
  { value: 'padehalli', label: 'Padehalli', pincode: '573127' },
  { value: 'ranganathapura', label: 'Ranganathapura', pincode: '573127' },
  { value: 'sakleshpura', label: 'Sakleshpura', pincode: '573134' },
  { value: 'sangama', label: 'Sangama', pincode: '573127' },
  { value: 'siddapura', label: 'Siddapura', pincode: '573127' },
  { value: 'shishila', label: 'Shishila', pincode: '573127' },
  { value: 'tavarekere', label: 'Tavarekere', pincode: '573127' },
  { value: 'vaddarahalli', label: 'Vaddarahalli', pincode: '573127' },
  { value: 'vaddarhalli', label: 'Vaddarhalli', pincode: '573127' },
  { value: 'vittalapura', label: 'Vittalapura', pincode: '573127' },
  { value: 'yellapura', label: 'Yellapura', pincode: '573127' },
  { value: 'yeralakuppe', label: 'Yeralakuppe', pincode: '573127' },
  { value: 'zarsalapura', label: 'Zarsalapura', pincode: '573127' },
  { value: 'balehalli', label: 'Balehalli', pincode: '573127' },
  { value: 'bidadi', label: 'Bidadi', pincode: '573127' },
  { value: 'devalkunda', label: 'Devalkunda', pincode: '573127' },
  { value: 'garve', label: 'Garve', pincode: '573127' },
  { value: 'hunasur', label: 'Hunasur', pincode: '573127' },
  { value: 'kallur', label: 'Kallur', pincode: '573127' },
  { value: 'kandukere', label: 'Kandukere', pincode: '573127' },
  { value: 'kyathur', label: 'Kyathur', pincode: '573127' },
  { value: 'marthahalli', label: 'Marthahalli', pincode: '573127' },
  { value: 'menasinahalli', label: 'Menasinahalli', pincode: '573127' },
  { value: 'muloor', label: 'Muloor', pincode: '573127' },
  { value: 'siddalingapura', label: 'Siddalingapura', pincode: '573127' },
  { value: 'tadiyandamol', label: 'Tadiyandamol', pincode: '573127' },
  { value: 'vaddarhalli', label: 'Vaddarhalli', pincode: '573127' }
  ],

  'sindhanur': [
  { value: 'babbur', label: 'Babbur', pincode: '583126' },
  { value: 'banahatti', label: 'Banahatti', pincode: '583126' },
  { value: 'banswada', label: 'Banswada', pincode: '583126' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '583126' },
  { value: 'gundur', label: 'Gundur', pincode: '583128' },
  { value: 'halapuru', label: 'Halapuru', pincode: '583128' },
  { value: 'jokkal', label: 'Jokkal', pincode: '583126' },
  { value: 'kallapur', label: 'Kallapur', pincode: '583128' },
  { value: 'kappur', label: 'Kappur', pincode: '583126' },
  { value: 'kudligi', label: 'Kudligi', pincode: '583128' },
  { value: 'kumbapur', label: 'Kumbapur', pincode: '583126' },
  { value: 'machapur', label: 'Machapur', pincode: '583126' },
  { value: 'mugalkhod', label: 'Mugalkhod', pincode: '583126' },
  { value: 'panchalingapura', label: 'Panchalingapura', pincode: '583128' },
  { value: 'pattanayakanahalli', label: 'Pattanayakanahalli', pincode: '583126' },
  { value: 'sandur', label: 'Sandur', pincode: '583130' },
  { value: 'sindhanur', label: 'Sindhanur', pincode: '583128' },
  { value: 'somapur', label: 'Somapur', pincode: '583126' },
  { value: 'tavargera', label: 'Tavargera', pincode: '583126' },
  { value: 'tattihalli', label: 'Tattihalli', pincode: '583126' },
  { value: 'yadahalli', label: 'Yadahalli', pincode: '583126' },
  { value: 'alapur', label: 'Alapur', pincode: '583128' },
  { value: 'bailur', label: 'Bailur', pincode: '583126' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '583126' },
  { value: 'chandpur', label: 'Chandpur', pincode: '583126' },
  { value: 'channagiri', label: 'Channagiri', pincode: '583126' },
  { value: 'gokul', label: 'Gokul', pincode: '583126' },
  { value: 'karajagi', label: 'Karajagi', pincode: '583128' },
  { value: 'kothur', label: 'Kothur', pincode: '583126' },
  { value: 'manehalli', label: 'Manehalli', pincode: '583126' },
  { value: 'narehalli', label: 'Narehalli', pincode: '583126' },
  { value: 'peddapur', label: 'Peddapur', pincode: '583126' },
  { value: 'rahimabad', label: 'Rahimabad', pincode: '583126' },
  { value: 'sanjaynagar', label: 'Sanjaynagar', pincode: '583126' },
  { value: 'sriharipura', label: 'Sriharipura', pincode: '583126' },
  { value: 'tadiparthi', label: 'Tadiparthi', pincode: '583128' },
  { value: 'umrani', label: 'Umrani', pincode: '583126' },
  { value: 'ammapur', label: 'Ammapur', pincode: '583128' },
  { value: 'bannihatti', label: 'Bannihatti', pincode: '583128' },
  { value: 'chikkanayakanahalli', label: 'Chikkanayakanahalli', pincode: '583128' },
  { value: 'chincholi', label: 'Chincholi', pincode: '583128' },
  { value: 'guddadahalli', label: 'Guddadahalli', pincode: '583126' },
  { value: 'jambihalli', label: 'Jambihalli', pincode: '583128' },
  { value: 'kanakapur', label: 'Kanakapur', pincode: '583128' },
  { value: 'keregudda', label: 'Keregudda', pincode: '583128' },
  { value: 'maddikera', label: 'Maddikera', pincode: '583126' },
  { value: 'madlapur', label: 'Madlapur', pincode: '583126' },
  { value: 'malapur', label: 'Malapur', pincode: '583128' },
  { value: 'manikpur', label: 'Manikpur', pincode: '583128' },
  { value: 'nayanahalli', label: 'Nayanahalli', pincode: '583128' },
  { value: 'neelagunda', label: 'Neelagunda', pincode: '583128' },
  { value: 'pavagi', label: 'Pavagi', pincode: '583128' },
  { value: 'peddahalli', label: 'Peddahalli', pincode: '583128' },
  { value: 'rajarampura', label: 'Rajarampura', pincode: '583128' },
  { value: 'salempur', label: 'Salempur', pincode: '583128' },
  { value: 'shivanahalli', label: 'Shivanahalli', pincode: '583128' },
  { value: 'tungabhadra', label: 'Tungabhadra', pincode: '583128' },
  { value: 'bellur', label: 'Bellur', pincode: '583128' },
  { value: 'hebbal', label: 'Hebbal', pincode: '583126' },
  { value: 'kaveripura', label: 'Kaveripura', pincode: '583128' },
  { value: 'haleshwar', label: 'Haleshwar', pincode: '583126' },
  { value: 'kanchinayanapalli', label: 'Kanchinayanapalli', pincode: '583128' },
  { value: 'krishnapur', label: 'Krishnapur', pincode: '583126' },
  { value: 'rudrampur', label: 'Rudrampur', pincode: '583128' },
  { value: 'siddapur', label: 'Siddapur', pincode: '583126' },
  { value: 'veerapur', label: 'Veerapur', pincode: '583126' }
  ],

  'Chikkamagaluru': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '577101' },
    { value: 'alur', label: 'Alur', pincode: '577102' },
    { value: 'babasab-pura', label: 'Babasab Pura', pincode: '577101' },
    { value: 'baloor', label: 'Baloor', pincode: '577101' },
    { value: 'bayanahalli', label: 'Bayanahalli', pincode: '577101' },
    { value: 'bhadravati', label: 'Bhadravati', pincode: '577301' },
    { value: 'bukkambudi', label: 'Bukkambudi', pincode: '577101' },
    { value: 'bymavara', label: 'Bymavara', pincode: '577102' },
    { value: 'chikkamagaluru-town', label: 'Chikkamagaluru Town', pincode: '577101' },
    { value: 'chikkamangaluru', label: 'Chikkamangaluru', pincode: '577102' },
    { value: 'dalavapura', label: 'Dalavapura', pincode: '577101' },
    { value: 'giriyapura', label: 'Giriyapura', pincode: '577101' },
    { value: 'hebbale', label: 'Hebbale', pincode: '577101' },
    { value: 'kalasapura', label: 'Kalasapura', pincode: '577101' },
    { value: 'kempapura', label: 'Kempapura', pincode: '577101' },
    { value: 'kudige', label: 'Kudige', pincode: '577101' },
    { value: 'kuruvalli', label: 'Kuruvalli', pincode: '577101' },
    { value: 'lakshmi-pura', label: 'Lakshmi Pura', pincode: '577102' },
    { value: 'madhugiri', label: 'Madhugiri', pincode: '577101' },
    { value: 'mallandur', label: 'Mallandur', pincode: '577102' },
    { value: 'mane-mangala', label: 'Mane Mangala', pincode: '577101' },
    { value: 'mudigere', label: 'Mudigere', pincode: '577132' },
    { value: 'nagendramalai', label: 'Nagendramalai', pincode: '577101' },
    { value: 'nallur', label: 'Nallur', pincode: '577101' },
    { value: 'nandi-kyet', label: 'Nandi Kyet', pincode: '577101' },
    { value: 'siddapura', label: 'Siddapura', pincode: '577101' },
    { value: 'srinivaspura', label: 'Srinivaspura', pincode: '577102' },
    { value: 'tekal', label: 'Tekal', pincode: '577101' },
    { value: 'yellapura', label: 'Yellapura', pincode: '577102' },
    { value: 'hadavalli', label: 'Hadavalli', pincode: '577101' },
    { value: 'channarayapatna', label: 'Channarayapatna', pincode: '577113' },
    { value: 'hosanagara', label: 'Hosanagara', pincode: '577422' },
    { value: 'shivani', label: 'Shivani', pincode: '577101' },
    { value: 'thirumale', label: 'Thirumale', pincode: '577101' },
    { value: 'chandravalli', label: 'Chandravalli', pincode: '577101' },
    { value: 'kudige-mudigere', label: 'Kudige Mudigere', pincode: '577132' }
  ],

  'davanagere': [
    { value: 'adampura', label: 'Adampura', pincode: '577002' },
    { value: 'banavara', label: 'Banavara', pincode: '577004' },
    { value: 'bhavikere', label: 'Bhavikere', pincode: '577222' },
    { value: 'bobbari', label: 'Bobbari', pincode: '577213' },
    { value: 'channarayapatna', label: 'Channarayapatna', pincode: '577003' },
    { value: 'chandavara', label: 'Chandavara', pincode: '577002' },
    { value: 'davanagere-town', label: 'Davanagere Town', pincode: '577001' },
    { value: 'gopalaswamy', label: 'Gopalaswamy', pincode: '577003' },
    { value: 'harappanahalli', label: 'Harappanahalli', pincode: '577528' },
    { value: 'huliyur', label: 'Huliyur', pincode: '577213' },
    { value: 'kadakola', label: 'Kadakola', pincode: '577206' },
    { value: 'kalenahalli', label: 'Kalenahalli', pincode: '577005' },
    { value: 'kamalapura', label: 'Kamalapura', pincode: '577201' },
    { value: 'kotturu', label: 'Kotturu', pincode: '577535' },
    { value: 'mandi', label: 'Mandi', pincode: '577213' },
    { value: 'mayakonda', label: 'Mayakonda', pincode: '577220' },
    { value: 'moodalapalya', label: 'Moodalapalya', pincode: '577207' },
    { value: 'nalvadi', label: 'Nalvadi', pincode: '577211' },
    { value: 'rajapura', label: 'Rajapura', pincode: '577505' },
    { value: 'rayapura', label: 'Rayapura', pincode: '577003' },
    { value: 'shivapura', label: 'Shivapura', pincode: '577209' },
    { value: 'vijayanagar', label: 'Vijayanagar', pincode: '577003' },
    { value: 'yadlapura', label: 'Yadlapura', pincode: '577234' },
    { value: 'kalleshwar', label: 'Kalleshwar', pincode: '577512' },
    { value: 'mallasandra', label: 'Mallasandra', pincode: '577216' },
    { value: 'sundarakere', label: 'Sundarakere', pincode: '577401' },
    { value: 'haralahalli', label: 'Haralahalli', pincode: '577205' },
    { value: 'sampige', label: 'Sampige', pincode: '577102' },
    { value: 'teeknapura', label: 'Teeknapura', pincode: '577410' },
    { value: 'tirumalashettyhalli', label: 'Tirumalashettyhalli', pincode: '577001' },
    { value: 'koppalu', label: 'Koppalu', pincode: '577208' },
    { value: 'battalapur', label: 'Battalapur', pincode: '577301' },
    { value: 'kumbalgodu', label: 'Kumbalgodu', pincode: '577411' }
  ],

  'udupi': [
    { value: 'alappady', label: 'Alappady', pincode: '576101' },
    { value: 'ballalbagh', label: 'Ballalbagh', pincode: '576103' },
    { value: 'bada', label: 'Bada', pincode: '576102' },
    { value: 'balehonnur', label: 'Balehonnur', pincode: '576102' },
    { value: 'basrur', label: 'Basrur', pincode: '576232' },
    { value: 'benne-doddi', label: 'Benne Doddi', pincode: '576229' },
    { value: 'brahmavara', label: 'Brahmavara', pincode: '576213' },
    { value: 'cardinal-patel', label: 'Cardinal Patel', pincode: '576101' },
    { value: 'hejamadi', label: 'Hejamadi', pincode: '576101' },
    { value: 'kundapura', label: 'Kundapura', pincode: '576201' },
    { value: 'manchakal', label: 'Manchakal', pincode: '576103' },
    { value: 'moodabidri', label: 'Moodabidri', pincode: '576213' },
    { value: 'mulki', label: 'Mulki', pincode: '576125' },
    { value: 'padubidri', label: 'Padubidri', pincode: '576222' },
    { value: 'pilikula', label: 'Pilikula', pincode: '576106' },
    { value: 'sarapady', label: 'Sarapady', pincode: '576213' },
    { value: 'shiroor', label: 'Shiroor', pincode: '576231' },
    { value: 'suddi', label: 'Suddi', pincode: '576233' },
    { value: 'udupi-town', label: 'Udupi Town', pincode: '576101' },
    { value: 'zavoor', label: 'Zavoor', pincode: '576211' },
    { value: 'amarapadna', label: 'Amarapadna', pincode: '576235' },
    { value: 'bajpe', label: 'Bajpe', pincode: '576102' },
    { value: 'bangady', label: 'Bangady', pincode: '576221' },
    { value: 'bayyur', label: 'Bayyur', pincode: '576227' },
    { value: 'belmannu', label: 'Belmannu', pincode: '576222' },
    { value: 'carstreet', label: 'Carstreet', pincode: '576101' },
    { value: 'chandramouleeshwara', label: 'Chandramouleeshwara', pincode: '576101' },
    { value: 'godde', label: 'Godde', pincode: '576101' },
    { value: 'karkala', label: 'Karkala', pincode: '576101' },
    { value: 'koila', label: 'Koila', pincode: '576222' },
    { value: 'kottara', label: 'Kottara', pincode: '576105' },
    { value: 'kudlu', label: 'Kudlu', pincode: '576101' },
    { value: 'mathsangara', label: 'Mathsangara', pincode: '576221' },
    { value: 'mirjan', label: 'Mirjan', pincode: '576222' },
    { value: 'mudarangadi', label: 'Mudarangadi', pincode: '576222' },
    { value: 'santhekatte', label: 'Santhekatte', pincode: '576105' },
    { value: 'yellur', label: 'Yellur', pincode: '576101' }
  ],


  'mandya': [
    { value: 'adigondanahalli', label: 'Adigondanahalli', pincode: '571401' },
    { value: 'baragur', label: 'Baragur', pincode: '571414' },
    { value: 'bellur', label: 'Bellur', pincode: '571408' },
    { value: 'bidadi', label: 'Bidadi', pincode: '571401' },
    { value: 'channarayapatna', label: 'Channarayapatna', pincode: '571401' },
    { value: 'chikkanayakanahalli', label: 'Chikkanayakanahalli', pincode: '571401' },
    { value: 'chunchanakatte', label: 'Chunchanakatte', pincode: '571401' },
    { value: 'doddamachihalli', label: 'Doddamachihalli', pincode: '571402' },
    { value: 'ganiga', label: 'Ganiga', pincode: '571411' },
    { value: 'halagur', label: 'Halagur', pincode: '571416' },
    { value: 'hampapura', label: 'Hampapura', pincode: '571402' },
    { value: 'hegde', label: 'Hegde', pincode: '571416' },
    { value: 'kodihalli', label: 'Kodihalli', pincode: '571415' },
    { value: 'krishnarajapura', label: 'Krishnarajapura', pincode: '571411' },
    { value: 'mandya-town', label: 'Mandya Town', pincode: '571401' },
    { value: 'mathenahalli', label: 'Mathenahalli', pincode: '571411' },
    { value: 'melukote', label: 'Melukote', pincode: '571423' },
    { value: 'muthughatta', label: 'Muthughatta', pincode: '571413' },
    { value: 'nanjarayanapattana', label: 'Nanjarayanapattana', pincode: '571402' },
    { value: 'narasipura', label: 'Narasipura', pincode: '571402' },
    { value: 'srirangapatna', label: 'Srirangapatna', pincode: '571438' },
    { value: 'tavarekere', label: 'Tavarekere', pincode: '571411' },
    { value: 'thimmapura', label: 'Thimmapura', pincode: '571401' },
    { value: 'turuvekere', label: 'Turuvekere', pincode: '571409' },
    { value: 'vidyanagar', label: 'Vidyanagar', pincode: '571401' },
    { value: 'yemmekere', label: 'Yemmekere', pincode: '571417' },
    { value: 'bastipura', label: 'Bastipura', pincode: '571415' },
    { value: 'bhavani', label: 'Bhavani', pincode: '571416' },
    { value: 'channarayana', label: 'Channarayana', pincode: '571416' },
    { value: 'kollegal', label: 'Kollegal', pincode: '571440' },
    { value: 'mandya-village', label: 'Mandya Village', pincode: '571402' },
    { value: 'maralur', label: 'Maralur', pincode: '571401' },
    { value: 'somanahalli', label: 'Somanahalli', pincode: '571413' },
    { value: 'kenchanahalli', label: 'Kenchanahalli', pincode: '571420' },
    { value: 'suddahalli', label: 'Suddahalli', pincode: '571402' },
    { value: 'ravichettyhalli', label: 'Ravichettyhalli', pincode: '571405' },
    { value: 'udayanahalli', label: 'Udayanahalli', pincode: '571414' },
    { value: 'chitramani', label: 'Chitramani', pincode: '571424' },
    { value: 'gundlupet', label: 'Gundlupet', pincode: '571430' },
    { value: 'kanakapura', label: 'Kanakapura', pincode: '571426' },
    { value: 'kudur', label: 'Kudur', pincode: '571419' },
    { value: 'madapura', label: 'Madapura', pincode: '571418' },
    { value: 'mahadevapura', label: 'Mahadevapura', pincode: '571421' },
    { value: 'manchanahalli', label: 'Manchanahalli', pincode: '571427' },
    { value: 'melkote-1', label: 'Melkote 1', pincode: '571423' },
    { value: 'muthur', label: 'Muthur', pincode: '571422' },
    { value: 'aluru', label: 'Aluru', pincode: '571422' },
    { value: 'bilikere', label: 'Bilikere', pincode: '571402' },
    { value: 'chandapura', label: 'Chandapura', pincode: '571412' },
    { value: 'chikkamallapura', label: 'Chikkamallapura', pincode: '571414' },
    { value: 'gundlahalli', label: 'Gundlahalli', pincode: '571413' },
    { value: 'honnasandra', label: 'Honnasandra', pincode: '571422' },
    { value: 'hokkali', label: 'Hokkali', pincode: '571420' },
    { value: 'krishnasagara', label: 'Krishnasagara', pincode: '571408' },
    { value: 'madikeri', label: 'Madikeri', pincode: '571407' }
  ],


  'belagavi': [
    { value: 'admapur', label: 'Admapur', pincode: '590014' },
    { value: 'althur', label: 'Althur', pincode: '590003' },
    { value: 'bailhongal', label: 'Bailhongal', pincode: '591102' },
    { value: 'balekundri', label: 'Balekundri', pincode: '590014' },
    { value: 'belagavi-cantonment', label: 'Belagavi Cantonment', pincode: '590001' },
    { value: 'belagavi-city', label: 'Belagavi City', pincode: '590002' },
    { value: 'bhutaramanahatti', label: 'Bhutaramanahatti', pincode: '590013' },
    { value: 'bidi', label: 'Bidi', pincode: '590014' },
    { value: 'chandapur', label: 'Chandapur', pincode: '591127' },
    { value: 'dambal', label: 'Dambal', pincode: '591302' },
    { value: 'gokak', label: 'Gokak', pincode: '591307' },
    { value: 'gokak-falls', label: 'Gokak Falls', pincode: '591312' },
    { value: 'godachinmalkapur', label: 'Godachinmalkapur', pincode: '590014' },
    { value: 'halbhavi', label: 'Halbhavi', pincode: '590015' },
    { value: 'harugeri', label: 'Harugeri', pincode: '591225' },
    { value: 'hidkal', label: 'Hidkal', pincode: '590014' },
    { value: 'hubli-road', label: 'Hubli Road', pincode: '590020' },
    { value: 'kakati', label: 'Kakati', pincode: '591203' },
    { value: 'khanapur', label: 'Khanapur', pincode: '591302' },
    { value: 'kittur', label: 'Kittur', pincode: '591115' },
    { value: 'madavpur', label: 'Madavpur', pincode: '591103' },
    { value: 'malaprabha-nagar', label: 'Malaprabha Nagar', pincode: '590015' },
    { value: 'mardol', label: 'Mardol', pincode: '590014' },
    { value: 'matha', label: 'Matha', pincode: '591213' },
    { value: 'miraj', label: 'Miraj', pincode: '591124' },
    { value: 'nehrunagar', label: 'Nehrunagar', pincode: '590014' },
    { value: 'raybag', label: 'Raybag', pincode: '591317' },
    { value: 'savadatti', label: 'Savadatti', pincode: '591126' },
    { value: 'sindhanoor', label: 'Sindhanoor', pincode: '590014' },
    { value: 'somanthpur', label: 'Somanthpur', pincode: '590014' },
    { value: 'tali', label: 'Tali', pincode: '590014' },
    { value: 'tharalabalu', label: 'Tharalabalu', pincode: '591307' },
    { value: 'uttar-karnataka', label: 'Uttar Karnataka', pincode: '590014' },
    { value: 'vaddatti', label: 'Vaddatti', pincode: '591124' },
    { value: 'bagalkot-road', label: 'Bagalkot Road', pincode: '590023' },
    { value: 'bobbili', label: 'Bobbili', pincode: '591301' },
    { value: 'baghmapur', label: 'Baghmapur', pincode: '590002' },
    { value: 'bhagewadi', label: 'Bhagewadi', pincode: '591222' },
    { value: 'hindalga', label: 'Hindalga', pincode: '590014' },
    { value: 'hooli', label: 'Hooli', pincode: '591114' },
    { value: 'jamboti', label: 'Jamboti', pincode: '591112' },
    { value: 'khanapur-town', label: 'Khanapur Town', pincode: '591303' },
    { value: 'kittur-town', label: 'Kittur Town', pincode: '591120' },
    { value: 'malaprabha', label: 'Malaprabha', pincode: '590017' },
    { value: 'nandiwada', label: 'Nandiwada', pincode: '590002' },
    { value: 'pachhapur', label: 'Pachhapur', pincode: '591105' },
    { value: 'shahapur', label: 'Shahapur', pincode: '591304' },
    { value: 'vijayanagar', label: 'Vijayanagar', pincode: '590018' },
    { value: 'yellapur', label: 'Yellapur', pincode: '591315' }
  ],

  'hubballi': [
    { value: 'adhapura', label: 'Adhapura', pincode: '580028' },
    { value: 'bagalkot-road', label: 'Bagalkot Road', pincode: '580022' },
    { value: 'balraj-pet', label: 'Balraj Pet', pincode: '580020' },
    { value: 'banjara-hills', label: 'Banjara Hills', pincode: '580031' },
    { value: 'benniganahalli', label: 'Benniganahalli', pincode: '580029' },
    { value: 'bhavaninagar', label: 'Bhavaninagar', pincode: '580023' },
    { value: 'bidi', label: 'Bidi', pincode: '580021' },
    { value: 'borewell', label: 'Borewell', pincode: '580022' },
    { value: 'chandramoulinagar', label: 'Chandramoulinagar', pincode: '580031' },
    { value: 'dharwad', label: 'Dharwad', pincode: '580001' },
    { value: 'gokul-road', label: 'Gokul Road', pincode: '580030' },
    { value: 'gokul-nagar', label: 'Gokul Nagar', pincode: '580030' },
    { value: 'gokul-scheme', label: 'Gokul Scheme', pincode: '580030' },
    { value: 'halbhavi', label: 'Halbhavi', pincode: '580014' },
    { value: 'harihar', label: 'Harihar', pincode: '580012' },
    { value: 'hindalga', label: 'Hindalga', pincode: '580015' },
    { value: 'hubli-cantonment', label: 'Hubli Cantonment', pincode: '580001' },
    { value: 'hubli-city', label: 'Hubli City', pincode: '580020' },
    { value: 'hubli-market', label: 'Hubli Market', pincode: '580023' },
    { value: 'hubli-road', label: 'Hubli Road', pincode: '580024' },
    { value: 'keshwapur', label: 'Keshwapur', pincode: '580023' },
    { value: 'kudalasangama', label: 'Kudalasangama', pincode: '580021' },
    { value: 'kumarapark', label: 'Kumarapark', pincode: '580021' },
    { value: 'mangala-nagar', label: 'Mangala Nagar', pincode: '580030' },
    { value: 'nava-nagar', label: 'Nava Nagar', pincode: '580029' },
    { value: 'rayapur', label: 'Rayapur', pincode: '580023' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '580020' },
    { value: 'siddheshwar-nagar', label: 'Siddheshwar Nagar', pincode: '580029' },
    { value: 'somalwada', label: 'Somalwada', pincode: '580020' },
    { value: 'tilakwadi', label: 'Tilakwadi', pincode: '580001' },
    { value: 'uppar-bail', label: 'Uppar Bail', pincode: '580028' },
    { value: 'vishweshwar-nagar', label: 'Vishweshwar Nagar', pincode: '580029' },
    { value: 'wadar-halli', label: 'Wadar Halli', pincode: '580026' },
    { value: 'chandapur', label: 'Chandapur', pincode: '580026' },
    { value: 'gandhinagar', label: 'Gandhinagar', pincode: '580023' },
    { value: 'jayanagar', label: 'Jayanagar', pincode: '580030' },
    { value: 'kamadhenu', label: 'Kamadhenu', pincode: '580020' },
    { value: 'kittur', label: 'Kittur', pincode: '580028' },
    { value: 'mukherjee-nagar', label: 'Mukherjee Nagar', pincode: '580024' },
    { value: 'mylari', label: 'Mylari', pincode: '580031' },
    { value: 'navanagar', label: 'Navanagar', pincode: '580022' },
    { value: 'nehrunagar', label: 'Nehrunagar', pincode: '580024' },
    { value: 'shivnagar', label: 'Shivnagar', pincode: '580026' },
    { value: 'siddhivinayak', label: 'Siddhivinayak', pincode: '580021' },
    { value: 'vishwanathpura', label: 'Vishwanathpura', pincode: '580027' }
  ],

  'haveri': [
    { value: 'achave', label: 'Achave', pincode: '581110' },
    { value: 'adihalli', label: 'Adihalli', pincode: '581103' },
    { value: 'alnavar', label: 'Alnavar', pincode: '581103' },
    { value: 'bankapur', label: 'Bankapur', pincode: '581204' },
    { value: 'bhairampur', label: 'Bhairampur', pincode: '581106' },
    { value: 'bhalavi', label: 'Bhalavi', pincode: '581205' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '581110' },
    { value: 'bhogapur', label: 'Bhogapur', pincode: '581110' },
    { value: 'bida', label: 'Bida', pincode: '581113' },
    { value: 'bommanahalli', label: 'Bommanahalli', pincode: '581102' },
    { value: 'bramhapura', label: 'Bramhapura', pincode: '581101' },
    { value: 'chandana', label: 'Chandana', pincode: '581106' },
    { value: 'chinchani', label: 'Chinchani', pincode: '581206' },
    { value: 'halasi', label: 'Halasi', pincode: '581110' },
    { value: 'haveri-cantonment', label: 'Haveri Cantonment', pincode: '581110' },
    { value: 'hosahalli', label: 'Hosahalli', pincode: '581114' },
    { value: 'honnali', label: 'Honnali', pincode: '581204' },
    { value: 'hulekal', label: 'Hulekal', pincode: '581203' },
    { value: 'kanavi', label: 'Kanavi', pincode: '581102' },
    { value: 'kelageri', label: 'Kelageri', pincode: '581110' },
    { value: 'kudari', label: 'Kudari', pincode: '581115' },
    { value: 'kumbapur', label: 'Kumbapur', pincode: '581110' },
    { value: 'magadi', label: 'Magadi', pincode: '581106' },
    { value: 'manakachalla', label: 'Manakachalla', pincode: '581102' },
    { value: 'narenahalli', label: 'Narenahalli', pincode: '581111' },
    { value: 'navanagar', label: 'Navanagar', pincode: '581110' },
    { value: 'nikkampur', label: 'Nikkampur', pincode: '581115' },
    { value: 'pattur', label: 'Pattur', pincode: '581111' },
    { value: 'shivapura', label: 'Shivapura', pincode: '581112' },
    { value: 'shivpura', label: 'Shivpura', pincode: '581103' },
    { value: 'siddapur', label: 'Siddapur', pincode: '581105' },
    { value: 'siddheshwar', label: 'Siddheshwar', pincode: '581101' },
    { value: 'sindhagi', label: 'Sindhagi', pincode: '581112' },
    { value: 'tadgeri', label: 'Tadgeri', pincode: '581102' },
    { value: 'kottur', label: 'Kottur', pincode: '581114' },
    { value: 'kumsi', label: 'Kumsi', pincode: '581106' },
    { value: 'lingapura', label: 'Lingapura', pincode: '581115' },
    { value: 'malebennur', label: 'Malebennur', pincode: '581204' },
    { value: 'shiralakoppa', label: 'Shiralakoppa', pincode: '581110' },
    { value: 'siddheshwarpura', label: 'Siddheshwarpura', pincode: '581101' },
    { value: 'varur', label: 'Varur', pincode: '581111' }
  ],

  'dharwad': [
    { value: 'ankalgi', label: 'Ankalgi', pincode: '580011' },
    { value: 'bangarpet', label: 'Bangarpet', pincode: '580010' },
    { value: 'basavanabagewadi', label: 'Basavanabagewadi', pincode: '580020' },
    { value: 'dandeli', label: 'Dandeli', pincode: '581325' },
    { value: 'dharwad-cantonment', label: 'Dharwad Cantonment', pincode: '580001' },
    { value: 'dharwad-urban', label: 'Dharwad Urban', pincode: '580004' },
    { value: 'gokul', label: 'Gokul', pincode: '580030' },
    { value: 'hubballi', label: 'Hubballi', pincode: '580023' },
    { value: 'karwar', label: 'Karwar', pincode: '581301' },
    { value: 'keshwapur', label: 'Keshwapur', pincode: '580024' },
    { value: 'mallapur', label: 'Mallapur', pincode: '580011' },
    { value: 'neelavathi', label: 'Neelavathi', pincode: '580028' },
    { value: 'sadashivnagar', label: 'Sadashivnagar', pincode: '580029' },
    { value: 'sattur', label: 'Sattur', pincode: '580004' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '580002' },
    { value: 'somashekharpur', label: 'Somashekharpur', pincode: '580017' },
    { value: 'university-campus', label: 'University Campus', pincode: '580003' },
    { value: 'vidyanagar', label: 'Vidyanagar', pincode: '580031' },
    { value: 'vishweshwaranagar', label: 'Vishweshwaranagar', pincode: '580024' },
    { value: 'yellapur', label: 'Yellapur', pincode: '581359' },
    { value: 'shivapur', label: 'Shivapur', pincode: '580002' },
    { value: 'mangala', label: 'Mangala', pincode: '580009' },
    { value: 'shantinagar', label: 'Shantinagar', pincode: '580008' },
    { value: 'bhujanga-nagar', label: 'Bhujanga Nagar', pincode: '580005' },
    { value: 'kesavanahalli', label: 'Kesavanahalli', pincode: '580017' },
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '580007' },
    { value: 'railway-station', label: 'Railway Station', pincode: '580021' },
    { value: 'shree-nagar', label: 'Shree Nagar', pincode: '580016' }
  ],

  'uttara kannada': [
    { value: 'alnavar', label: 'Alnavar', pincode: '581103' },
    { value: 'ankola', label: 'Ankola', pincode: '581314' },
    { value: 'araga', label: 'Araga', pincode: '581365' },
    { value: 'bhadravati', label: 'Bhadravati', pincode: '581320' },
    { value: 'bhatkal', label: 'Bhatkal', pincode: '581320' },
    { value: 'bikkanagudde', label: 'Bikkanagudde', pincode: '581326' },
    { value: 'devadiga', label: 'Devadiga', pincode: '581315' },
    { value: 'dandeli', label: 'Dandeli', pincode: '581325' },
    { value: 'goa', label: 'Goa', pincode: '581318' },
    { value: 'gokarna', label: 'Gokarna', pincode: '581326' },
    { value: 'haliyala', label: 'Haliyala', pincode: '581329' },
    { value: 'haladi', label: 'Haladi', pincode: '581321' },
    { value: 'hubli', label: 'Hubli', pincode: '581305' },
    { value: 'karwar', label: 'Karwar', pincode: '581301' },
    { value: 'koliwad', label: 'Koliwad', pincode: '581314' },
    { value: 'kumta', label: 'Kumta', pincode: '581343' },
    { value: 'manohar', label: 'Manohar', pincode: '581302' },
    { value: 'mundgod', label: 'Mundgod', pincode: '581413' },
    { value: 'nadikeri', label: 'Nadikeri', pincode: '581323' },
    { value: 'nagar', label: 'Nagar', pincode: '581315' },
    { value: 'pattadakal', label: 'Pattadakal', pincode: '581302' },
    { value: 'sankeshwar', label: 'Sankeshwar', pincode: '581316' },
    { value: 'siddapura', label: 'Siddapura', pincode: '581317' },
    { value: 'sugarcane', label: 'Sugarcane', pincode: '581328' },
    { value: 'tattihalli', label: 'Tattihalli', pincode: '581325' },
    { value: 'uttara', label: 'Uttara', pincode: '581319' },
    { value: 'vibhooti', label: 'Vibhooti', pincode: '581322' },
    { value: 'balehonnur', label: 'Balehonnur', pincode: '581331' },
    { value: 'bhimavaram', label: 'Bhimavaram', pincode: '581336' },
    { value: 'bhatkal-town', label: 'Bhatkal Town', pincode: '581320' },
    { value: 'keremane', label: 'Keremane', pincode: '581338' },
    { value: 'manja', label: 'Manja', pincode: '581331' },
    { value: 'raibag', label: 'Raibag', pincode: '581340' },
    { value: 'sandur', label: 'Sandur', pincode: '581333' },
    { value: 'savanur', label: 'Savanur', pincode: '581309' },
    { value: 'sirsi', label: 'Sirsi', pincode: '581401' },
    { value: 'talaguppa', label: 'Talaguppa', pincode: '581318' },
    { value: 'tavarekere', label: 'Tavarekere', pincode: '581334' },
    { value: 'vaddarhalli', label: 'Vaddarhalli', pincode: '581330' }
  ],

  'belur': [
    { value: 'ajjanahalli', label: 'Ajjanahalli', pincode: '573115' },
    { value: 'belur-town', label: 'Belur Town', pincode: '573115' },
    { value: 'bhavani', label: 'Bhavani', pincode: '573115' },
    { value: 'binnamangala', label: 'Binnamangala', pincode: '573115' },
    { value: 'chandramala', label: 'Chandramala', pincode: '573115' },
    { value: 'chikkakere', label: 'Chikkakere', pincode: '573115' },
    { value: 'gollahalli', label: 'Gollahalli', pincode: '573115' },
    { value: 'kanasavadi', label: 'Kanasavadi', pincode: '573115' },
    { value: 'kudlapur', label: 'Kudlapur', pincode: '573115' },
    { value: 'mangala', label: 'Mangala', pincode: '573115' },
    { value: 'nandi', label: 'Nandi', pincode: '573115' },
    { value: 'periyapatna', label: 'Periyapatna', pincode: '573115' },
    { value: 'shanthinagar', label: 'Shanthinagar', pincode: '573115' },
    { value: 'teverahalli', label: 'Teverahalli', pincode: '573115' },
    { value: 'yadupura', label: 'Yadupura', pincode: '573115' },
    { value: 'adyanathapura', label: 'Adyanathapura', pincode: '573115' },
    { value: 'alike', label: 'Alike', pincode: '573116' },
    { value: 'belur-gaddige', label: 'Belur Gaddige', pincode: '573116' },
    { value: 'betageri', label: 'Betageri', pincode: '573115' },
    { value: 'chiradigundi', label: 'Chiradigundi', pincode: '573115' },
    { value: 'doddakere', label: 'Doddakere', pincode: '573115' },
    { value: 'gowdagere', label: 'Gowdagere', pincode: '573115' },
    { value: 'kudur', label: 'Kudur', pincode: '573115' },
    { value: 'mattur', label: 'Mattur', pincode: '573115' },
    { value: 'munnuru', label: 'Munnuru', pincode: '573115' },
    { value: 'nanjundapura', label: 'Nanjundapura', pincode: '573115' },
    { value: 'pancharanahalli', label: 'Pancharanahalli', pincode: '573115' },
    { value: 'srinivaspura', label: 'Srinivaspura', pincode: '573115' },
    { value: 'thekkatte', label: 'Thekkatte', pincode: '573115' },
    { value: 'ajjampura', label: 'Ajjampura', pincode: '573116' },
    { value: 'andur', label: 'Andur', pincode: '573115' },
    { value: 'balehonnur', label: 'Balehonnur', pincode: '573115' },
    { value: 'channarayapatna', label: 'Channarayapatna', pincode: '573117' },
    { value: 'jayanthi', label: 'Jayanthi', pincode: '573118' },
    { value: 'kanasuru', label: 'Kanasuru', pincode: '573119' },
    { value: 'patragundi', label: 'Patragundi', pincode: '573116' },
    { value: 'ragihalli', label: 'Ragihalli', pincode: '573115' }
  ],

  'tumakuru': [
    { value: 'arehalli', label: 'Arehalli', pincode: '572107' },
    { value: 'babara-halli', label: 'Babara Halli', pincode: '572104' },
    { value: 'basavanahalli', label: 'Basavanahalli', pincode: '572101' },
    { value: 'chikkanayakanahalli', label: 'Chikkanayakanahalli', pincode: '572218' },
    { value: 'doddaghatta', label: 'Doddaghatta', pincode: '572101' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'huliyur', label: 'Huliyur', pincode: '572118' },
    { value: 'jayanthi', label: 'Jayanthi', pincode: '572104' },
    { value: 'kerehalli', label: 'Kerehalli', pincode: '572101' },
    { value: 'lakshmidevipalya', label: 'Lakshmidevipalya', pincode: '572105' },
    { value: 'manjunathapura', label: 'Manjunathapura', pincode: '572111' },
    { value: 'patanayakanahalli', label: 'Patanayakanahalli', pincode: '572125' },
    { value: 'somanahalli', label: 'Somanahalli', pincode: '572113' },
    { value: 'tiptur', label: 'Tiptur', pincode: '572201' },
    { value: 'banavara', label: 'Banavara', pincode: '572126' },
    { value: 'bhairanayakanahalli', label: 'Bhairanayakanahalli', pincode: '572121' },
    { value: 'belur', label: 'Belur', pincode: '572115' },
    { value: 'chandrapura', label: 'Chandrapura', pincode: '572123' },
    { value: 'hirehalli', label: 'Hirehalli', pincode: '572145' },
    { value: 'honnalagere', label: 'Honnalagere', pincode: '572124' },
    { value: 'kadur', label: 'Kadur', pincode: '572143' },
    { value: 'karle', label: 'Karle', pincode: '572121' },
    { value: 'kengeri', label: 'Kengeri', pincode: '572136' },
    { value: 'kundana', label: 'Kundana', pincode: '572137' },
    { value: 'madhugiri', label: 'Madhugiri', pincode: '572132' },
    { value: 'nallur', label: 'Nallur', pincode: '572122' },
    { value: 'pavagada', label: 'Pavagada', pincode: '572142' },
    { value: 'shirahatti', label: 'Shirahatti', pincode: '572140' },
    { value: 'agrahara', label: 'Agrahara', pincode: '572143' },
    { value: 'aralaguppe', label: 'Aralaguppe', pincode: '572148' },
    { value: 'badasalu', label: 'Badasalu', pincode: '572105' },
    { value: 'balagere', label: 'Balagere', pincode: '572106' },
    { value: 'bannikuppe', label: 'Bannikuppe', pincode: '572131' },
    { value: 'banthimallapura', label: 'Banthimallapura', pincode: '572120' },
    { value: 'bhadravati', label: 'Bhadravati', pincode: '572109' },
    { value: 'bhogapura', label: 'Bhogapura', pincode: '572127' },
    { value: 'channarayapatna', label: 'Channarayapatna', pincode: '572122' },
    { value: 'chikkaballapur', label: 'Chikkaballapur', pincode: '572218' },
    { value: 'choudadenahalli', label: 'Choudadenahalli', pincode: '572149' },
    { value: 'doddaballapur', label: 'Doddaballapur', pincode: '572107' },
    { value: 'halahalli', label: 'Halahalli', pincode: '572134' },
    { value: 'kallambella', label: 'Kallambella', pincode: '572150' },
    { value: 'kavaldoddi', label: 'Kavaldoddi', pincode: '572107' },
    { value: 'kuppepalya', label: 'Kuppepalya', pincode: '572139' },
    { value: 'mallapura', label: 'Mallapura', pincode: '572116' },
    { value: 'masti', label: 'Masti', pincode: '572123' },
    { value: 'nandi', label: 'Nandi', pincode: '572122' },
    { value: 'ragihalli', label: 'Ragihalli', pincode: '572110' },
    { value: 'sampigehalli', label: 'Sampigehalli', pincode: '572118' },
    { value: 'shivapura', label: 'Shivapura', pincode: '572134' },
    { value: 'somanathapura', label: 'Somanathapura', pincode: '572119' },
    { value: 'toddahalli', label: 'Toddahalli', pincode: '572128' }
  ],

  'ballari': [
    { value: 'adoni', label: 'Adoni', pincode: '518301' },
    { value: 'balaganur', label: 'Balaganur', pincode: '518123' },
    { value: 'ballari', label: 'Ballari', pincode: '583101' },
    { value: 'bichal', label: 'Bichal', pincode: '583116' },
    { value: 'bukkapatna', label: 'Bukkapatna', pincode: '583105' },
    { value: 'buregowda', label: 'Buregowda', pincode: '583125' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '583118' },
    { value: 'chinchodi', label: 'Chinchodi', pincode: '583106' },
    { value: 'hosapete', label: 'Hosapete', pincode: '583201' },
    { value: 'jogipet', label: 'Jogipet', pincode: '518114' },
    { value: 'kampli', label: 'Kampli', pincode: '583132' },
    { value: 'kottur', label: 'Kottur', pincode: '583130' },
    { value: 'krishnapura', label: 'Krishnapura', pincode: '583128' },
    { value: 'madhugiri', label: 'Madhugiri', pincode: '583129' },
    { value: 'mallapura', label: 'Mallapura', pincode: '583102' },
    { value: 'mugtalli', label: 'Mugtalli', pincode: '583103' },
    { value: 'onlapur', label: 'Onlapur', pincode: '583124' },
    { value: 'pavagal', label: 'Pavagal', pincode: '583115' },
    { value: 'sagara', label: 'Sagara', pincode: '518126' },
    { value: 'siddapur', label: 'Siddapur', pincode: '583106' },
    { value: 'tiptur', label: 'Tiptur', pincode: '583108' },
    { value: 'vaddar', label: 'Vaddar', pincode: '583120' },
    { value: 'anathapur', label: 'Anathapur', pincode: '518211' },
    { value: 'banshidhar', label: 'Banshidhar', pincode: '518103' },
    { value: 'bhairapur', label: 'Bhairapur', pincode: '583117' },
    { value: 'bichal-guttahalli', label: 'Bichal Guttahalli', pincode: '583112' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '518115' },
    { value: 'bheemarayapura', label: 'Bheemarayapura', pincode: '518118' },
    { value: 'byadgi', label: 'Byadgi', pincode: '518103' },
    { value: 'chandur', label: 'Chandur', pincode: '518124' },
    { value: 'chigpalli', label: 'Chigpalli', pincode: '583115' },
    { value: 'edur', label: 'Edur', pincode: '518118' },
    { value: 'gundlapur', label: 'Gundlapur', pincode: '518113' },
    { value: 'housur', label: 'Housur', pincode: '518101' },
    { value: 'kallur', label: 'Kallur', pincode: '518121' },
    { value: 'kanamadi', label: 'Kanamadi', pincode: '518101' },
    { value: 'koppal', label: 'Koppal', pincode: '518101' },
    { value: 'mandakini', label: 'Mandakini', pincode: '518102' },
    { value: 'nallur', label: 'Nallur', pincode: '518127' },
    { value: 'sanjaynagar', label: 'Sanjaynagar', pincode: '518108' },
    { value: 'tangadigi', label: 'Tangadigi', pincode: '518119' },
    { value: 'kappatagudda', label: 'Kappatagudda', pincode: '518102' },
    { value: 'khanapur', label: 'Khanapur', pincode: '518120' },
    { value: 'kothapet', label: 'Kothapet', pincode: '518125' },
    { value: 'kugur', label: 'Kugur', pincode: '518130' },
    { value: 'laxminarayana', label: 'Laxminarayana', pincode: '518135' },
    { value: 'malpan', label: 'Malpan', pincode: '518140' },
    { value: 'maruthi', label: 'Maruthi', pincode: '518141' },
    { value: 'matmari', label: 'Matmari', pincode: '518110' },
    { value: 'migapalle', label: 'Migapalle', pincode: '518107' },
    { value: 'nalwadi', label: 'Nalwadi', pincode: '518102' },
    { value: 'pachapur', label: 'Pachapur', pincode: '518116' },
    { value: 'padnur', label: 'Padnur', pincode: '518109' },
    { value: 'perlapur', label: 'Perlapur', pincode: '518112' }
  ],


  'bidar': [
    { value: 'alampur', label: 'Alampur', pincode: '585401' },
    { value: 'banegaon', label: 'Banegaon', pincode: '585406' },
    { value: 'bidar', label: 'Bidar', pincode: '585401' },
    { value: 'bhalki', label: 'Bhalki', pincode: '585328' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '585301' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '585325' },
    { value: 'chincholi', label: 'Chincholi', pincode: '585302' },
    { value: 'dandu', label: 'Dandu', pincode: '585403' },
    { value: 'farhatnagar', label: 'Farhatnagar', pincode: '585411' },
    { value: 'gajendragad', label: 'Gajendragad', pincode: '585405' },
    { value: 'hakimpur', label: 'Hakimpur', pincode: '585419' },
    { value: 'humnabad', label: 'Humnabad', pincode: '585301' },
    { value: 'jalgaon', label: 'Jalgaon', pincode: '585319' },
    { value: 'kamalapur', label: 'Kamalapur', pincode: '585309' },
    { value: 'khanapur', label: 'Khanapur', pincode: '585410' },
    { value: 'khodlapur', label: 'Khodlapur', pincode: '585419' },
    { value: 'maniknagar', label: 'Maniknagar', pincode: '585305' },
    { value: 'mandal', label: 'Mandal', pincode: '585409' },
    { value: 'narayanpur', label: 'Narayanpur', pincode: '585409' },
    { value: 'panchalinga', label: 'Panchalinga', pincode: '585312' },
    { value: 'rajamangala', label: 'Rajamangala', pincode: '585417' },
    { value: 'ranakol', label: 'Ranakol', pincode: '585316' },
    { value: 'sadashivnagar', label: 'Sadashivnagar', pincode: '585406' },
    { value: 'shegaon', label: 'Shegaon', pincode: '585407' },
    { value: 'sindagi', label: 'Sindagi', pincode: '585302' },
    { value: 'siranagi', label: 'Siranagi', pincode: '585303' },
    { value: 'tqbidar', label: 'Tqbidar', pincode: '585409' },
    { value: 'yadagirigutta', label: 'Yadagirigutta', pincode: '585402' },
    { value: 'adgaon', label: 'Adgaon', pincode: '585426' },
    { value: 'badami', label: 'Badami', pincode: '585321' },
    { value: 'basavakalyan', label: 'Basavakalyan', pincode: '585327' },
    { value: 'bhivpur-khanapur', label: 'Bhivpur Khanapur', pincode: '585428' },
    { value: 'chandur', label: 'Chandur', pincode: '585418' },
    { value: 'gokak', label: 'Gokak', pincode: '585309' },
    { value: 'gundri', label: 'Gundri', pincode: '585414' },
    { value: 'hubli', label: 'Hubli', pincode: '585330' },
    { value: 'karegaon', label: 'Karegaon', pincode: '585320' },
    { value: 'mahamadpur', label: 'Mahamadpur', pincode: '585313' },
    { value: 'malkapur', label: 'Malkapur', pincode: '585316' },
    { value: 'manjari', label: 'Manjari', pincode: '585317' },
    { value: 'murkhed', label: 'Murkhed', pincode: '585322' },
    { value: 'nalagonda', label: 'Nalagonda', pincode: '585424' },
    { value: 'nampur', label: 'Nampur', pincode: '585325' },
    { value: 'rangepur', label: 'Rangepur', pincode: '585411' },
    { value: 'sankhapur', label: 'Sankhapur', pincode: '585308' },
    { value: 'shirasgi', label: 'Shirasgi', pincode: '585309' },
    { value: 'siral', label: 'Siral', pincode: '585318' }
  ],

  'hassan': [
    { value: 'alur', label: 'Alur', pincode: '573102' },
    { value: 'bantwal', label: 'Bantwal', pincode: '574211' },
    { value: 'belur', label: 'Belur', pincode: '573115' },
    { value: 'bhadravathi', label: 'Bhadravathi', pincode: '577301' },
    { value: 'channarayapatna', label: 'Channarayapatna', pincode: '573116' },
    { value: 'chikmagalur', label: 'Chikmagalur', pincode: '577101' },
    { value: 'davanagere', label: 'Davanagere', pincode: '577001' },
    { value: 'donigal', label: 'Donigal', pincode: '577102' },
    { value: 'hassan', label: 'Hassan', pincode: '573201' },
    { value: 'holenarasipura', label: 'Holenarasipura', pincode: '573211' },
    { value: 'hunsur', label: 'Hunsur', pincode: '571105' },
    { value: 'jagalur', label: 'Jagalur', pincode: '577528' },
    { value: 'kaggalipura', label: 'Kaggalipura', pincode: '573230' },
    { value: 'kadur', label: 'Kadur', pincode: '577548' },
    { value: 'kishanur', label: 'Kishanur', pincode: '573129' },
    { value: 'krishnarajpet', label: 'Krishnarajpet', pincode: '573162' },
    { value: 'kudige', label: 'Kudige', pincode: '573222' },
    { value: 'malnad', label: 'Malnad', pincode: '573231' },
    { value: 'mandya', label: 'Mandya', pincode: '571401' },
    { value: 'marenahalli', label: 'Marenahalli', pincode: '573225' },
    { value: 'nagamangala', label: 'Nagamangala', pincode: '573212' },
    { value: 'nelamangala', label: 'Nelamangala', pincode: '573121' },
    { value: 'sakaleshpur', label: 'Sakaleshpur', pincode: '573134' },
    { value: 'shravanabelagola', label: 'Shravanabelagola', pincode: '573135' },
    { value: 'tiptur', label: 'Tiptur', pincode: '572202' },
    { value: 'yedehalli', label: 'Yedehalli', pincode: '573222' },
    { value: 'arakalagudda', label: 'Arakalagudda', pincode: '573121' },
    { value: 'bannur', label: 'Bannur', pincode: '573210' },
    { value: 'bellur', label: 'Bellur', pincode: '573121' },
    { value: 'chikkamagalur', label: 'Chikkamagalur', pincode: '577101' },
    { value: 'gommatagiri', label: 'Gommatagiri', pincode: '573112' },
    { value: 'hosahalli', label: 'Hosahalli', pincode: '573124' },
    { value: 'kadur-karnataka', label: 'Kadur Karnataka', pincode: '577548' },
    { value: 'koppal', label: 'Koppal', pincode: '573250' },
    { value: 'kurubarahalli', label: 'Kurubarahalli', pincode: '573227' },
    { value: 'madapura', label: 'Madapura', pincode: '573130' },
    { value: 'malavalli', label: 'Malavalli', pincode: '571425' },
    { value: 'puddenahalli', label: 'Puddenahalli', pincode: '573126' },
    { value: 'siddapura', label: 'Siddapura', pincode: '573116' },
    { value: 'srinivaspura', label: 'Srinivaspura', pincode: '573105' },
    { value: 'yellapura', label: 'Yellapura', pincode: '573113' }
  ],

  'chitradurga': [
    { value: 'adihalli', label: 'Adihalli', pincode: '577501' },
    { value: 'bhadravati', label: 'Bhadravati', pincode: '577301' },
    { value: 'channarayapatna', label: 'Channarayapatna', pincode: '577502' },
    { value: 'chitradurga-town', label: 'Chitradurga Town', pincode: '577501' },
    { value: 'hosur', label: 'Hosur', pincode: '577511' },
    { value: 'karnatak', label: 'Karnatak', pincode: '577516' },
    { value: 'kottur', label: 'Kottur', pincode: '577516' },
    { value: 'nandihalli', label: 'Nandihalli', pincode: '577525' },
    { value: 'santebennur', label: 'Santebennur', pincode: '577531' },
    { value: 'tanakal', label: 'Tanakal', pincode: '577532' },
    { value: 'tavarekere', label: 'Tavarekere', pincode: '577503' },
    { value: 'sindhanur', label: 'Sindhanur', pincode: '577518' },
    { value: 'yallambagilu', label: 'Yallambagilu', pincode: '577523' },
    { value: 'moodigere', label: 'Moodigere', pincode: '577516' },
    { value: 'bellary', label: 'Bellary', pincode: '577130' },
    { value: 'jagalur', label: 'Jagalur', pincode: '577528' },
    { value: 'hallur', label: 'Hallur', pincode: '577514' },
    { value: 'peresandra', label: 'Peresandra', pincode: '577508' },
    { value: 'doddamaravadi', label: 'Doddamaravadi', pincode: '577511' },
    { value: 'kudapura', label: 'Kudapura', pincode: '577513' },
    { value: 'magadi', label: 'Magadi', pincode: '577525' },
    { value: 'nallur', label: 'Nallur', pincode: '577507' },
    { value: 'pothnal', label: 'Pothnal', pincode: '577509' },
    { value: 'ajjampura', label: 'Ajjampura', pincode: '577524' },
    { value: 'banavara', label: 'Banavara', pincode: '577512' },
    { value: 'bommappanahalli', label: 'Bommappanahalli', pincode: '577502' },
    { value: 'chikkanayakanahalli', label: 'Chikkanayakanahalli', pincode: '577530' },
    { value: 'doddalahalli', label: 'Doddalahalli', pincode: '577506' },
    { value: 'henjaragatta', label: 'Henjaragatta', pincode: '577510' },
    { value: 'kadur', label: 'Kadur', pincode: '577531' },
    { value: 'kesavanahalli', label: 'Kesavanahalli', pincode: '577504' },
    { value: 'lakshmipura', label: 'Lakshmipura', pincode: '577507' },
    { value: 'palasapura', label: 'Palasapura', pincode: '577515' },
    { value: 'ranganathapura', label: 'Ranganathapura', pincode: '577517' },
    { value: 'siddapura', label: 'Siddapura', pincode: '577519' },
    { value: 'yemmanahalli', label: 'Yemmanahalli', pincode: '577520' },
    { value: 'kallambella', label: 'Kallambella', pincode: '577525' },
    { value: 'panjurli', label: 'Panjurli', pincode: '577529' },
    { value: 'birur', label: 'Birur', pincode: '577528' }
  ],


  'chincholi': [
    { value: 'adkoli', label: 'Adkoli', pincode: '585307' },
    { value: 'alapur', label: 'Alapur', pincode: '585319' },
    { value: 'bangarhalli', label: 'Bangarhalli', pincode: '585309' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '585309' },
    { value: 'chincholi-town', label: 'Chincholi Town', pincode: '585307' },
    { value: 'gangapur', label: 'Gangapur', pincode: '585312' },
    { value: 'golgumbaz', label: 'Golgumbaz', pincode: '585314' },
    { value: 'jambhali', label: 'Jambhali', pincode: '585316' },
    { value: 'kalaburagi', label: 'Kalaburagi', pincode: '585101' },
    { value: 'kammarabanda', label: 'Kammarabanda', pincode: '585317' },
    { value: 'kandi', label: 'Kandi', pincode: '585319' },
    { value: 'kattimalkapur', label: 'Kattimalkapur', pincode: '585308' },
    { value: 'kondapur', label: 'Kondapur', pincode: '585320' },
    { value: 'naregal', label: 'Naregal', pincode: '585308' },
    { value: 'pannur', label: 'Pannur', pincode: '585323' },
    { value: 'ramapura', label: 'Ramapura', pincode: '585311' },
    { value: 'sangameshwar', label: 'Sangameshwar', pincode: '585310' },
    { value: 'shahabad', label: 'Shahabad', pincode: '585228' },
    { value: 'shirasga', label: 'Shirasga', pincode: '585316' },
    { value: 'subhashnagar', label: 'Subhashnagar', pincode: '585305' },
    { value: 'takli', label: 'Takli', pincode: '585324' },
    { value: 'tupkal', label: 'Tupkal', pincode: '585315' },
    { value: 'vandagwadi', label: 'Vandagwadi', pincode: '585327' },
    { value: 'yadgir', label: 'Yadgir', pincode: '585202' }
  ],

  'shivamogga': [
    { value: 'adawara', label: 'Adawara', pincode: '577204' },
    { value: 'alevoor', label: 'Alevoor', pincode: '577222' },
    { value: 'bhadravathi', label: 'Bhadravathi', pincode: '577301' },
    { value: 'davanagere', label: 'Davanagere', pincode: '577004' },
    { value: 'halasuru', label: 'Halasuru', pincode: '577202' },
    { value: 'hosanagara', label: 'Hosanagara', pincode: '577418' },
    { value: 'jambur', label: 'Jambur', pincode: '577412' },
    { value: 'kodagu', label: 'Kodagu', pincode: '577229' },
    { value: 'kumarapura', label: 'Kumarapura', pincode: '577215' },
    { value: 'madhugiri', label: 'Madhugiri', pincode: '577209' },
    { value: 'manjapura', label: 'Manjapura', pincode: '577222' },
    { value: 'nagarahalli', label: 'Nagarahalli', pincode: '577311' },
    { value: 'nidi', label: 'Nidi', pincode: '577306' },
    { value: 'shivamogga-town', label: 'Shivamogga Town', pincode: '577201' },
    { value: 'sugganahalli', label: 'Sugganahalli', pincode: '577314' },
    { value: 'thirthahalli', label: 'Thirthahalli', pincode: '577432' },
    { value: 'ulvi', label: 'Ulvi', pincode: '577221' },
    { value: 'vedur', label: 'Vedur', pincode: '577103' },
    { value: 'yellapura', label: 'Yellapura', pincode: '577417' },
    { value: 'allaka', label: 'Allaka', pincode: '577217' },
    { value: 'badavara', label: 'Badavara', pincode: '577220' },
    { value: 'basavanagudi', label: 'Basavanagudi', pincode: '577232' },
    { value: 'chandavara', label: 'Chandavara', pincode: '577315' },
    { value: 'chikkanahalli', label: 'Chikkanahalli', pincode: '577227' },
    { value: 'gokak', label: 'Gokak', pincode: '577325' },
    { value: 'hosanur', label: 'Hosanur', pincode: '577413' },
    { value: 'kabbur', label: 'Kabbur', pincode: '577216' },
    { value: 'mallapura', label: 'Mallapura', pincode: '577303' },
    { value: 'mudugula', label: 'Mudugula', pincode: '577233' },
    { value: 'nanmangala', label: 'Nanmangala', pincode: '577218' },
    { value: 'sarvamangala', label: 'Sarvamangala', pincode: '577234' },
    { value: 'yelapura', label: 'Yelapura', pincode: '577236' }
  ],

  'raichur': [
    { value: 'adoni', label: 'Adoni', pincode: '518301' },
    { value: 'alapur', label: 'Alapur', pincode: '518307' },
    { value: 'balaganur', label: 'Balaganur', pincode: '518207' },
    { value: 'banahatti', label: 'Banahatti', pincode: '518205' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '518108' },
    { value: 'chikkabrahmanapalli', label: 'Chikkabrahmanapalli', pincode: '518134' },
    { value: 'raichur-town', label: 'Raichur Town', pincode: '584101' },
    { value: 'bagdadi', label: 'Bagdadi', pincode: '584102' },
    { value: 'bhalki', label: 'Bhalki', pincode: '584105' },
    { value: 'gadwal', label: 'Gadwal', pincode: '518119' },
    { value: 'godhan', label: 'Godhan', pincode: '518104' },
    { value: 'hatti', label: 'Hatti', pincode: '518101' },
    { value: 'jambli', label: 'Jambli', pincode: '518207' },
    { value: 'jigani', label: 'Jigani', pincode: '518209' },
    { value: 'kanakapur', label: 'Kanakapur', pincode: '518122' },
    { value: 'kavathambha', label: 'Kavathambha', pincode: '518113' },
    { value: 'korvi', label: 'Korvi', pincode: '518131' },
    { value: 'kottur', label: 'Kottur', pincode: '518108' },
    { value: 'mandal', label: 'Mandal', pincode: '518103' },
    { value: 'manvi', label: 'Manvi', pincode: '584123' },
    { value: 'mudnal', label: 'Mudnal', pincode: '518135' },
    { value: 'peddapalli', label: 'Peddapalli', pincode: '518112' },
    { value: 'peddanagudi', label: 'Peddanagudi', pincode: '518115' },
    { value: 'shivapur', label: 'Shivapur', pincode: '518141' },
    { value: 'vishwanathpura', label: 'Vishwanathpura', pincode: '518108' },
    { value: 'yadgir', label: 'Yadgir', pincode: '585202' },
    { value: 'bhanapur', label: 'Bhanapur', pincode: '518217' },
    { value: 'bavani', label: 'Bavani', pincode: '518116' },
    { value: 'byrapura', label: 'Byrapura', pincode: '518214' },
    { value: 'kattalapur', label: 'Kattalapur', pincode: '518145' },
    { value: 'naganur', label: 'Naganur', pincode: '518202' },
    { value: 'nalwar', label: 'Nalwar', pincode: '518118' },
    { value: 'nizampur', label: 'Nizampur', pincode: '518136' },
    { value: 'peddagudi', label: 'Peddagudi', pincode: '518143' },
    { value: 'rajapur', label: 'Rajapur', pincode: '518113' },
    { value: 'somanpalli', label: 'Somanpalli', pincode: '518108' },
    { value: 'yellapur', label: 'Yellapur', pincode: '518123' }
  ],

  'kolar': [
    { value: 'adigara', label: 'Adigara', pincode: '563101' },
    { value: 'avathi', label: 'Avathi', pincode: '563124' },
    { value: 'chinthamani', label: 'Chinthamani', pincode: '563125' },
    { value: 'guddadam', label: 'Guddadam', pincode: '563122' },
    { value: 'kolar-town', label: 'Kolar Town', pincode: '563101' },
    { value: 'kolar-gold-fields', label: 'Kolar Gold Fields', pincode: '563122' },
    { value: 'kothakota', label: 'Kothakota', pincode: '563121' },
    { value: 'kurubarahalli', label: 'Kurubarahalli', pincode: '563116' },
    { value: 'mulbagal', label: 'Mulbagal', pincode: '563131' },
    { value: 'nallur', label: 'Nallur', pincode: '563130' },
    { value: 'nanjundapur', label: 'Nanjundapur', pincode: '563127' },
    { value: 'neelamangala', label: 'Neelamangala', pincode: '563110' },
    { value: 'peenya', label: 'Peenya', pincode: '563103' },
    { value: 'srinivaspur', label: 'Srinivaspur', pincode: '563135' },
    { value: 'sulibele', label: 'Sulibele', pincode: '563127' },
    { value: 'tekal', label: 'Tekal', pincode: '563112' },
    { value: 'venkatagirikote', label: 'Venkatagirikote', pincode: '563136' },
    { value: 'virupakshipura', label: 'Virupakshipura', pincode: '563115' },
    { value: 'bangarpet', label: 'Bangarpet', pincode: '563114' },
    { value: 'bukkasagara', label: 'Bukkasagara', pincode: '563111' },
    { value: 'chennaiahnapalya', label: 'Chennaiahnapalya', pincode: '563117' },
    { value: 'gadigenahalli', label: 'Gadigenahalli', pincode: '563108' },
    { value: 'gonempur', label: 'Gonempur', pincode: '563137' },
    { value: 'kaggalipura', label: 'Kaggalipura', pincode: '563103' },
    { value: 'kanakapura', label: 'Kanakapura', pincode: '563128' },
    { value: 'krishnarajapura', label: 'Krishnarajapura', pincode: '563119' },
    { value: 'mundhaganahalli', label: 'Mundhaganahalli', pincode: '563120' },
    { value: 'pangra', label: 'Pangra', pincode: '563118' }
  ],

  'mysuru': [
    { value: 'abbigere', label: 'Abbigere', pincode: '570016' },
    { value: 'bogadi', label: 'Bogadi', pincode: '570026' },
    { value: 'chamundi-hills', label: 'Chamundi Hills', pincode: '570010' },
    { value: 'chinnaswamy', label: 'Chinnaswamy', pincode: '570002' },
    { value: 'gokulam', label: 'Gokulam', pincode: '570002' },
    { value: 'gunjur', label: 'Gunjur', pincode: '570022' },
    { value: 'hanumanthanagar', label: 'Hanumanthanagar', pincode: '570015' },
    { value: 'jayalakshmipuram', label: 'Jayalakshmipuram', pincode: '570012' },
    { value: 'kannur', label: 'Kannur', pincode: '570005' },
    { value: 'kavandahalli', label: 'Kavandahalli', pincode: '570025' },
    { value: 'kiru-mysuru', label: 'Kiru Mysuru', pincode: '570029' },
    { value: 'lakshmipuram', label: 'Lakshmipuram', pincode: '570004' },
    { value: 'lokayukta', label: 'Lokayukta', pincode: '570021' },
    { value: 'mandya', label: 'Mandya', pincode: '571401' },
    { value: 'mitra-nagar', label: 'Mitra Nagar', pincode: '570018' },
    { value: 'nandi-grama', label: 'Nandi Grama', pincode: '570017' },
    { value: 'new-hunsur', label: 'New Hunsur', pincode: '571105' },
    { value: 'srirampura', label: 'Srirampura', pincode: '570015' },
    { value: 'vijayanagar', label: 'Vijayanagar', pincode: '570017' },
    { value: 'yadavagiri', label: 'Yadavagiri', pincode: '570020' },
    { value: 'bannimantap', label: 'Bannimantap', pincode: '570015' },
    { value: 'chitranjan-nagar', label: 'Chitranjan Nagar', pincode: '570023' },
    { value: 'dattagalli', label: 'Dattagalli', pincode: '570022' },
    { value: 'garag', label: 'Garag', pincode: '570037' },
    { value: 'hinkal', label: 'Hinkal', pincode: '570065' },
    { value: 'kalyan-mandi', label: 'Kalyan Mandi', pincode: '570019' },
    { value: 'kanakagiri', label: 'Kanakagiri', pincode: '570014' },
    { value: 'madhava-nagar', label: 'Madhava Nagar', pincode: '570019' },
    { value: 'mavalli', label: 'Mavalli', pincode: '570001' },
    { value: 'nanjanagudu', label: 'Nanjanagudu', pincode: '571301' },
    { value: 'nandini-layout', label: 'Nandini Layout', pincode: '570024' },
    { value: 'padmanabhanagar', label: 'Padmanabhanagar', pincode: '570025' },
    { value: 'r.s.-siddhartha', label: 'R.S. Siddhartha', pincode: '570021' },
    { value: 't.n.puram', label: 'T.N. Puram', pincode: '570028' }
  ],

  'bangalore-rural': [
    { value: 'adigondanahalli', label: 'Adigondanahalli', pincode: '562115' },
    { value: 'aneka', label: 'Aneka', pincode: '562160' },
    { value: 'attibele', label: 'Attibele', pincode: '562107' },
    { value: 'bidadi', label: 'Bidadi', pincode: '562109' },
    { value: 'channarayapatna', label: 'Channarayapatna', pincode: '562163' },
    { value: 'devarahosahalli', label: 'Devarahosahalli', pincode: '562130' },
    { value: 'devanahalli', label: 'Devanahalli', pincode: '562110' },
    { value: 'dodda-ballapura', label: 'Dodda Ballapura', pincode: '561203' },
    { value: 'gollahalli', label: 'Gollahalli', pincode: '562123' },
    { value: 'kanakapura', label: 'Kanakapura', pincode: '562117' },
    { value: 'kengeri', label: 'Kengeri', pincode: '560060' },
    { value: 'kurubarahalli', label: 'Kurubarahalli', pincode: '562115' },
    { value: 'magadi', label: 'Magadi', pincode: '562120' },
    { value: 'maddur', label: 'Maddur', pincode: '571422' },
    { value: 'nandi-hills', label: 'Nandi Hills', pincode: '562101' },
    { value: 'nelamangala', label: 'Nelamangala', pincode: '562123' },
    { value: 'ramanagaram', label: 'Ramanagaram', pincode: '562159' },
    { value: 'siddhapura', label: 'Siddhapura', pincode: '562101' },
    { value: 'srirampura', label: 'Srirampura', pincode: '562114' },
    { value: 'tavarekere', label: 'Tavarekere', pincode: '562130' },
    { value: 'tiptur', label: 'Tiptur', pincode: '572202' },
    { value: 'venkatapura', label: 'Venkatapura', pincode: '562112' },
    { value: 'bagalur', label: 'Bagalur', pincode: '562149' },
    { value: 'bangarpet', label: 'Bangarpet', pincode: '563114' },
    { value: 'bangalore-urban', label: 'Bangalore Urban', pincode: '560001' },
    { value: 'bharathinagar', label: 'Bharathinagar', pincode: '562148' },
    { value: 'channapatna', label: 'Channapatna', pincode: '562160' },
    { value: 'chikkanayakanahalli', label: 'Chikkanayakanahalli', pincode: '562135' },
    { value: 'doddaballapura', label: 'Doddaballapura', pincode: '561203' },
    { value: 'gattahalli', label: 'Gattahalli', pincode: '562111' },
    { value: 'hassan', label: 'Hassan', pincode: '573201' },
    { value: 'honnavar', label: 'Honnavar', pincode: '562127' },
    { value: 'jigani', label: 'Jigani', pincode: '562106' },
    { value: 'kolar', label: 'Kolar', pincode: '563101' },
    { value: 'mavallipura', label: 'Mavallipura', pincode: '562101' },
    { value: 'nelamangala', label: 'Nelamangala', pincode: '562123' },
    { value: 'panathur', label: 'Panathur', pincode: '562122' },
    { value: 'sankeswari', label: 'Sankeswari', pincode: '562137' }
  ],

//Arunachal Pradesh
'aalo': [
  { value: 'bagra', label: 'Bagra', pincode: '791001' },
  { value: 'bali', label: 'Bali', pincode: '791112' },
  { value: 'bayor', label: 'Bayor', pincode: '791124' },
  { value: 'deed', label: 'Deed', pincode: '791101' },
  { value: 'jarsi', label: 'Jarsi', pincode: '791100' },
  { value: 'kamba', label: 'Kamba', pincode: '791105' },
  { value: 'kaying', label: 'Kaying', pincode: '791103' },
  { value: 'kombo', label: 'Kombo', pincode: '791107' },
  { value: 'lakhim', label: 'Lakhim', pincode: '791111' },
  { value: 'mendum', label: 'Mendum', pincode: '791113' },
  { value: 'palin', label: 'Palin', pincode: '791110' },
  { value: 'poli', label: 'Poli', pincode: '791104' },
  { value: 'ramle', label: 'Ramle', pincode: '791108' },
  { value: 'sime', label: 'Sime', pincode: '791106' },
  { value: 'tirbin', label: 'Tirbin', pincode: '791120' },
  { value: 'yigi', label: 'Yigi', pincode: '791122' },
  { value: 'yomcha', label: 'Yomcha', pincode: '791116' },
  { value: 'apsu', label: 'Apsu', pincode: '791109' },
  { value: 'adol', label: 'Adol', pincode: '791102' },
  { value: 'balang', label: 'Balang', pincode: '791115' },
  { value: 'dongi', label: 'Dongi', pincode: '791121' },
  { value: 'gakram', label: 'Gakram', pincode: '791117' },
  { value: 'genga', label: 'Genga', pincode: '791118' },
  { value: 'hurchi', label: 'Hurchi', pincode: '791119' },
  { value: 'liromi', label: 'Liromi', pincode: '791114' }
  ],
  
  'anjaw': [
  { value: 'chungtang', label: 'Chungtang', pincode: '792103' },
  { value: 'hawai', label: 'Hawai', pincode: '792101' },
  { value: 'jari', label: 'Jari', pincode: '792102' },
  { value: 'kamba', label: 'Kamba', pincode: '792111' },
  { value: 'manchal', label: 'Manchal', pincode: '792106' },
  { value: 'meka', label: 'Meka', pincode: '792104' },
  { value: 'mera', label: 'Mera', pincode: '792107' },
  { value: 'namti', label: 'Namti', pincode: '792105' },
  { value: 'paya', label: 'Paya', pincode: '792110' },
  { value: 'ramachina', label: 'Ramachina', pincode: '792113' },
  { value: 'sher', label: 'Sher', pincode: '792108' },
  { value: 'walong', label: 'Walong', pincode: '792109' },
  { value: 'hansora', label: 'Hansora', pincode: '792112' },
  { value: 'himalaya', label: 'Himalaya', pincode: '792114' },
  { value: 'dibang', label: 'Dibang', pincode: '792115' },
  { value: 'changlang', label: 'Changlang', pincode: '792116' },
  { value: 'longding', label: 'Longding', pincode: '792117' },
  { value: 'moing', label: 'Moing', pincode: '792118' },
  { value: 'arunachal', label: 'Arunachal', pincode: '792119' },
  { value: 'tawang', label: 'Tawang', pincode: '792120' },
  { value: 'yembung', label: 'Yembung', pincode: '792122' },
  { value: 'kandong', label: 'Kandong', pincode: '792123' },
  { value: 'debas', label: 'Debas', pincode: '792124' },
  { value: 'manbo', label: 'Manbo', pincode: '792125' },
  { value: 'panchou', label: 'Panchou', pincode: '792126' },
  { value: 'tholung', label: 'Tholung', pincode: '792127' },
  { value: 'mayum', label: 'Mayum', pincode: '792128' }
  ],

  'bameng': [
  { value: 'bumla', label: 'Bumla', pincode: '791115' },
  { value: 'changpang', label: 'Changpang', pincode: '791101' },
  { value: 'garu', label: 'Garu', pincode: '791110' },
  { value: 'hawai', label: 'Hawai', pincode: '791108' },
  { value: 'khonsa', label: 'Khonsa', pincode: '791120' },
  { value: 'luka', label: 'Luka', pincode: '791107' },
  { value: 'namti', label: 'Namti', pincode: '791109' },
  { value: 'paya', label: 'Paya', pincode: '791106' },
  { value: 'ramcham', label: 'Ramcham', pincode: '791103' },
  { value: 'tawang', label: 'Tawang', pincode: '791105' },
  { value: 'jong', label: 'Jong', pincode: '791122' },
  { value: 'malin', label: 'Malin', pincode: '791121' },
  { value: 'manpo', label: 'Manpo', pincode: '791104' },
  { value: 'parong', label: 'Parong', pincode: '791123' },
  { value: 'sunpo', label: 'Sunpo', pincode: '791124' },
  { value: 'zarang', label: 'Zarang', pincode: '791125' },
  { value: 'bomdila', label: 'Bomdila', pincode: '791126' },
  { value: 'beshar', label: 'Beshar', pincode: '791127' },
  { value: 'daikhum', label: 'Daikhum', pincode: '791128' },
  { value: 'tolung', label: 'Tolong', pincode: '791129' },
  { value: 'yakson', label: 'Yakson', pincode: '791130' },
  { value: 'khenewa', label: 'Khenewa', pincode: '791131' }
  ],

  'basar': [
  { value: 'akha', label: 'Akha', pincode: '791116' },
  { value: 'bango', label: 'Bango', pincode: '791101' },
  { value: 'basar', label: 'Basar', pincode: '791100' },
  { value: 'bega', label: 'Bega', pincode: '791103' },
  { value: 'chinmukh', label: 'Chinmukh', pincode: '791105' },
  { value: 'dumdu', label: 'Dumdu', pincode: '791104' },
  { value: 'gori', label: 'Gori', pincode: '791106' },
  { value: 'kalak', label: 'Kalak', pincode: '791119' },
  { value: 'kebang', label: 'Kebang', pincode: '791113' },
  { value: 'kosing', label: 'Kosing', pincode: '791107' },
  { value: 'lipa', label: 'Lipa', pincode: '791108' },
  { value: 'mepong', label: 'Mepong', pincode: '791109' },
  { value: 'nguri', label: 'Nguri', pincode: '791110' },
  { value: 'pabia', label: 'Pabia', pincode: '791111' },
  { value: 'pansum', label: 'Pansum', pincode: '791112' },
  { value: 'phesang', label: 'Phesang', pincode: '791120' },
  { value: 'rangam', label: 'Rangam', pincode: '791114' },
  { value: 'tapi', label: 'Tapi', pincode: '791115' },
  { value: 'wako', label: 'Wako', pincode: '791117' },
  { value: 'dambuk', label: 'Dambuk', pincode: '791118' },
  { value: 'longti', label: 'Longti', pincode: '791121' },
  { value: 'tupak', label: 'Tupak', pincode: '791122' },
  { value: 'yong', label: 'Yong', pincode: '791123' }
  ],

  'boleng': [
  { value: 'boleng', label: 'Boleng', pincode: '791122' },
  { value: 'bango', label: 'Bango', pincode: '791123' },
  { value: 'dambuk', label: 'Dambuk', pincode: '791128' },
  { value: 'kaying', label: 'Kaying', pincode: '791124' },
  { value: 'ramle', label: 'Ramle', pincode: '791125' },
  { value: 'nari', label: 'Nari', pincode: '791126' },
  { value: 'tuting', label: 'Tuting', pincode: '791127' },
  { value: 'konsa', label: 'Konsa', pincode: '791129' },
  { value: 'siyum', label: 'Siyum', pincode: '791130' },
  { value: 'tali', label: 'Tali', pincode: '791131' },
  { value: 'jirang', label: 'Jirang', pincode: '791132' },
  { value: 'kandang', label: 'Kandang', pincode: '791133' },
  { value: 'kokila', label: 'Kokila', pincode: '791134' },
  { value: 'rimo', label: 'Rimo', pincode: '791135' },
  { value: 'langpo', label: 'Langpo', pincode: '791136' },
  { value: 'yigong', label: 'Yigong', pincode: '791137' },
  { value: 'yachuli', label: 'Yachuli', pincode: '791138' },
  { value: 'sekong', label: 'Sekong', pincode: '791139' },
  { value: 'rambang', label: 'Rambang', pincode: '791140' },
  { value: 'chinmukh', label: 'Chinmukh', pincode: '791141' },
  { value: 'jain', label: 'Jain', pincode: '791142' },
  { value: 'rakung', label: 'Rakung', pincode: '791143' },
  { value: 'simen', label: 'Simen', pincode: '791144' },
  { value: 'lumpo', label: 'Lumpo', pincode: '791145' },
  { value: 'phadang', label: 'Phadang', pincode: '791146' }
  ],

  'bomdila': [
  { value: 'arunachal-vihar', label: 'Arunachal Vihar', pincode: '791121' },
  { value: 'bhalukpong', label: 'Bhalukpong', pincode: '791122' },
  { value: 'bomdila', label: 'Bomdila', pincode: '791120' },
  { value: 'balemu', label: 'Balemu', pincode: '791132' },
  { value: 'chengmari', label: 'Chengmari', pincode: '791133' },
  { value: 'chug', label: 'Chug', pincode: '791123' },
  { value: 'dirang', label: 'Dirang', pincode: '791124' },
  { value: 'dudunghar', label: 'Dudunghar', pincode: '791134' },
  { value: 'kalaktang', label: 'Kalaktang', pincode: '791125' },
  { value: 'kanubari', label: 'Kanubari', pincode: '791126' },
  { value: 'khela', label: 'Khela', pincode: '791127' },
  { value: 'khimiyang', label: 'Khimiyang', pincode: '791135' },
  { value: 'maja', label: 'Maja', pincode: '791128' },
  { value: 'manigong', label: 'Manigong', pincode: '791129' },
  { value: 'mogli', label: 'Mogli', pincode: '791130' },
  { value: 'niglok', label: 'Niglok', pincode: '791136' },
  { value: 'poba', label: 'Poba', pincode: '791137' },
  { value: 'shertukpen', label: 'Shertukpen', pincode: '791131' },
  { value: 'shergaon', label: 'Shergaon', pincode: '791138' },
  { value: 'thongri', label: 'Thongri', pincode: '791139' },
  { value: 'thupten', label: 'Thupten', pincode: '791140' },
  { value: 'chongkham', label: 'Chongkham', pincode: '791141' },
  { value: 'dong', label: 'Dong', pincode: '791142' },
  { value: 'kuri', label: 'Kuri', pincode: '791143' },
  { value: 'lingjui', label: 'Lingjui', pincode: '791144' },
  { value: 'phodong', label: 'Phodong', pincode: '791145' }
  ],

  'bordumsa': [
  { value: 'balijan', label: 'Balijan', pincode: '791123' },
  { value: 'bordumsa', label: 'Bordumsa', pincode: '791122' },
  { value: 'changlang', label: 'Changlang', pincode: '791124' },
  { value: 'deomali', label: 'Deomali', pincode: '791125' },
  { value: 'kangkong', label: 'Kangkong', pincode: '791126' },
  { value: 'kherem', label: 'Kherem', pincode: '791127' },
  { value: 'khamti', label: 'Khamti', pincode: '791128' },
  { value: 'khungru', label: 'Khungru', pincode: '791129' },
  { value: 'loilong', label: 'Loilong', pincode: '791130' },
  { value: 'namchik', label: 'Namchik', pincode: '791131' },
  { value: 'ramle', label: 'Ramle', pincode: '791132' },
  { value: 'tangsa', label: 'Tangsa', pincode: '791133' },
  { value: 'tirap', label: 'Tirap', pincode: '791134' },
  { value: 'tirap-1', label: 'Tirap-1', pincode: '791135' },
  { value: 'yol', label: 'Yol', pincode: '791136' },
  { value: 'amliang', label: 'Amliang', pincode: '791137' },
  { value: 'anglong', label: 'Anglong', pincode: '791138' },
  { value: 'changlung', label: 'Changlung', pincode: '791139' },
  { value: 'cheny', label: 'Cheny', pincode: '791140' },
  { value: 'dikrang', label: 'Dikrang', pincode: '791141' },
  { value: 'longchong', label: 'Longchong', pincode: '791142' },
  { value: 'lonji', label: 'Lonji', pincode: '791143' },
  { value: 'phungliang', label: 'Phungliang', pincode: '791144' },
  { value: 'samter', label: 'Samter', pincode: '791145' },
  { value: 'yamphu', label: 'Yamphu', pincode: '791146' },
  { value: 'namjain', label: 'Namjain', pincode: '791147' },
  { value: 'kamlung', label: 'Kamlung', pincode: '791148' },
  { value: 'hiyang', label: 'Hiyang', pincode: '791149' },
  { value: 'chongkham', label: 'Chongkham', pincode: '791150' },
  { value: 'yaying', label: 'Yaying', pincode: '791151' },
  { value: 'phooltuli', label: 'Phooltuli', pincode: '791152' }
  ],

  'borduria': [
  { value: 'amliang', label: 'Amliang', pincode: '791159' },
  { value: 'anglong', label: 'Anglong', pincode: '791161' },
  { value: 'balijan', label: 'Balijan', pincode: '791162' },
  { value: 'borduria', label: 'Borduria', pincode: '791147' },
  { value: 'changlang', label: 'Changlang', pincode: '791148' },
  { value: 'chongkham', label: 'Chongkham', pincode: '791162' },
  { value: 'deomali', label: 'Deomali', pincode: '791149' },
  { value: 'dibrugarh', label: 'Dibrugarh', pincode: '791150' },
  { value: 'dong', label: 'Dong', pincode: '791163' },
  { value: 'farku', label: 'Farku', pincode: '791164' },
  { value: 'hiyang', label: 'Hiyang', pincode: '791165' },
  { value: 'jengging', label: 'Jengging', pincode: '791166' },
  { value: 'kamphu', label: 'Kamphu', pincode: '791167' },
  { value: 'kherem', label: 'Kherem', pincode: '791151' },
  { value: 'khamti', label: 'Khamti', pincode: '791152' },
  { value: 'kharsang', label: 'Kharsang', pincode: '791168' },
  { value: 'longchong', label: 'Longchong', pincode: '791160' },
  { value: 'langkhang', label: 'Langkhang', pincode: '791169' },
  { value: 'namchik', label: 'Namchik', pincode: '791153' },
  { value: 'phungliang', label: 'Phungliang', pincode: '791154' },
  { value: 'ramle', label: 'Ramle', pincode: '791155' },
  { value: 'tangsa', label: 'Tangsa', pincode: '791156' },
  { value: 'tirap', label: 'Tirap', pincode: '791157' },
  { value: 'yamphu', label: 'Yamphu', pincode: '791158' }
  ],

  'changlang': [
  { value: 'amliang', label: 'Amliang', pincode: '791125' },
  { value: 'anglong', label: 'Anglong', pincode: '791126' },
  { value: 'balijan', label: 'Balijan', pincode: '791127' },
  { value: 'bordumsa', label: 'Bordumsa', pincode: '791128' },
  { value: 'changlang', label: 'Changlang', pincode: '791124' },
  { value: 'changlung', label: 'Changlung', pincode: '791129' },
  { value: 'deomali', label: 'Deomali', pincode: '791130' },
  { value: 'farku', label: 'Farku', pincode: '791139' },
  { value: 'kherem', label: 'Kherem', pincode: '791131' },
  { value: 'khamti', label: 'Khamti', pincode: '791132' },
  { value: 'kharsang', label: 'Kharsang', pincode: '791140' },
  { value: 'longchong', label: 'Longchong', pincode: '791133' },
  { value: 'namchik', label: 'Namchik', pincode: '791134' },
  { value: 'phungliang', label: 'Phungliang', pincode: '791141' },
  { value: 'ramle', label: 'Ramle', pincode: '791135' },
  { value: 'samter', label: 'Samter', pincode: '791142' },
  { value: 'tangsa', label: 'Tangsa', pincode: '791136' },
  { value: 'tirap', label: 'Tirap', pincode: '791137' },
  { value: 'yamphu', label: 'Yamphu', pincode: '791138' },
  { value: 'yaying', label: 'Yaying', pincode: '791143' },
  { value: 'yol', label: 'Yol', pincode: '791144' },
  { value: 'yomcha', label: 'Yomcha', pincode: '791145' },
  { value: 'zidak', label: 'Zidak', pincode: '791146' },
  { value: 'bohua', label: 'Bohua', pincode: '791150' },
  { value: 'chamkham', label: 'Chamkham', pincode: '791151' },
  { value: 'jaipur', label: 'Jaipur', pincode: '791152' },
  { value: 'jengging', label: 'Jengging', pincode: '791153' },
  { value: 'pangi', label: 'Pangi', pincode: '791154' },
  { value: 'tirap-south', label: 'Tirap South', pincode: '791155' },
  { value: 'rajasthan', label: 'Rajasthan', pincode: '791156' },
  { value: 'manthan', label: 'Manthan', pincode: '791157' },
  { value: 'namsang', label: 'Namsang', pincode: '791158' },
  { value: 'songking', label: 'Songking', pincode: '791159' },
  { value: 'shangtang', label: 'Shangtang', pincode: '791160' }
  ],

  'chowkham': [
  { value: 'changlang', label: 'Changlang', pincode: '791124' },
  { value: 'changlung', label: 'Changlung', pincode: '791129' },
  { value: 'chowkham', label: 'Chowkham', pincode: '791125' },
  { value: 'deomali', label: 'Deomali', pincode: '791130' },
  { value: 'farku', label: 'Farku', pincode: '791139' },
  { value: 'khamti', label: 'Khamti', pincode: '791132' },
  { value: 'kherem', label: 'Kherem', pincode: '791131' },
  { value: 'kharsang', label: 'Kharsang', pincode: '791140' },
  { value: 'longchong', label: 'Longchong', pincode: '791133' },
  { value: 'namchik', label: 'Namchik', pincode: '791134' },
  { value: 'phungliang', label: 'Phungliang', pincode: '791141' },
  { value: 'ramle', label: 'Ramle', pincode: '791135' },
  { value: 'samter', label: 'Samter', pincode: '791142' },
  { value: 'tangsa', label: 'Tangsa', pincode: '791136' },
  { value: 'tirap', label: 'Tirap', pincode: '791137' },
  { value: 'yamphu', label: 'Yamphu', pincode: '791138' },
  { value: 'yaying', label: 'Yaying', pincode: '791143' },
  { value: 'yol', label: 'Yol', pincode: '791144' },
  { value: 'zidak', label: 'Zidak', pincode: '791146' },
  { value: 'bohua', label: 'Bohua', pincode: '791150' },
  { value: 'chamkham', label: 'Chamkham', pincode: '791151' },
  { value: 'jaipur', label: 'Jaipur', pincode: '791152' },
  { value: 'jengging', label: 'Jengging', pincode: '791153' },
  { value: 'pangi', label: 'Pangi', pincode: '791154' },
  { value: 'tirap-south', label: 'Tirap South', pincode: '791155' },
  { value: 'namsang', label: 'Namsang', pincode: '791158' },
  { value: 'songking', label: 'Songking', pincode: '791159' },
  { value: 'shangtang', label: 'Shangtang', pincode: '791160' },
  { value: 'namphai', label: 'Namphai', pincode: '791161' },
  { value: 'nayagaon', label: 'Nayagaon', pincode: '791162' },
  { value: 'phibsoo', label: 'Phibsoo', pincode: '791163' },
  { value: 'sikong', label: 'Sikong', pincode: '791164' },
  { value: 'wangham', label: 'Wangham', pincode: '791165' },
  { value: 'yentse', label: 'Yentse', pincode: '791166' }
  ],
  
  'dambuk': [
  { value: 'amliang', label: 'Amliang', pincode: '791121' },
  { value: 'chowkham', label: 'Chowkham', pincode: '791125' },
  { value: 'deomali', label: 'Deomali', pincode: '791130' },
  { value: 'dambuk', label: 'Dambuk', pincode: '791120' },
  { value: 'farku', label: 'Farku', pincode: '791139' },
  { value: 'kherem', label: 'Kherem', pincode: '791131' },
  { value: 'khamti', label: 'Khamti', pincode: '791132' },
  { value: 'kharsang', label: 'Kharsang', pincode: '791140' },
  { value: 'longchong', label: 'Longchong', pincode: '791133' },
  { value: 'namchik', label: 'Namchik', pincode: '791134' },
  { value: 'phungliang', label: 'Phungliang', pincode: '791141' },
  { value: 'ramle', label: 'Ramle', pincode: '791135' },
  { value: 'samter', label: 'Samter', pincode: '791142' },
  { value: 'tangsa', label: 'Tangsa', pincode: '791136' },
  { value: 'tirap', label: 'Tirap', pincode: '791137' },
  { value: 'yamphu', label: 'Yamphu', pincode: '791138' },
  { value: 'yaying', label: 'Yaying', pincode: '791143' },
  { value: 'amchung', label: 'Amchung', pincode: '791122' },
  { value: 'bohua', label: 'Bohua', pincode: '791150' },
  { value: 'changlang', label: 'Changlang', pincode: '791124' },
  { value: 'khongkhar', label: 'Khongkhar', pincode: '791145' },
  { value: 'lapang', label: 'Lapang', pincode: '791151' },
  { value: 'namphai', label: 'Namphai', pincode: '791161' },
  { value: 'nyokum', label: 'Nyokum', pincode: '791160' },
  { value: 'sikong', label: 'Sikong', pincode: '791164' },
  { value: 'songking', label: 'Songking', pincode: '791159' },
  { value: 'tali', label: 'Tali', pincode: '791162' },
  { value: 'tirap-south', label: 'Tirap South', pincode: '791155' },
  { value: 'bandu', label: 'Bandu', pincode: '791166' },
  { value: 'doke', label: 'Doke', pincode: '791167' },
  { value: 'lempong', label: 'Lempong', pincode: '791168' },
  { value: 'longjo', label: 'Longjo', pincode: '791169' },
  { value: 'manmo', label: 'Manmo', pincode: '791170' },
  { value: 'mangkang', label: 'Mangkang', pincode: '791171' },
  { value: 'tiring', label: 'Tiring', pincode: '791172' },
  { value: 'yongbu', label: 'Yongbu', pincode: '791173' }
  ],

  'daporijo': [
  { value: 'ayung', label: 'Ayung', pincode: '791134' },
  { value: 'chinhan', label: 'Chinhan', pincode: '791133' },
  { value: 'daporijo', label: 'Daporijo', pincode: '791122' },
  { value: 'hari', label: 'Hari', pincode: '791130' },
  { value: 'itafort', label: 'Itafort', pincode: '791124' },
  { value: 'jigi', label: 'Jigi', pincode: '791137' },
  { value: 'kamle', label: 'Kamle', pincode: '791128' },
  { value: 'kalu', label: 'Kalu', pincode: '791135' },
  { value: 'lori', label: 'Lori', pincode: '791131' },
  { value: 'longding', label: 'Longding', pincode: '791123' },
  { value: 'palin', label: 'Palin', pincode: '791132' },
  { value: 'polom', label: 'Polom', pincode: '791136' },
  { value: 'siyum', label: 'Siyum', pincode: '791125' },
  { value: 'tali', label: 'Tali', pincode: '791126' },
  { value: 'taliha', label: 'Taliha', pincode: '791129' },
  { value: 'ziro', label: 'Ziro', pincode: '791127' },
  { value: 'bomdila', label: 'Bomdila', pincode: '791141' },
  { value: 'siro', label: 'Siro', pincode: '791142' },
  { value: 'thakpa', label: 'Thakpa', pincode: '791143' },
  { value: 'miri', label: 'Miri', pincode: '791144' },
  { value: 'kamin', label: 'Kamin', pincode: '791145' },
  { value: 'naking', label: 'Naking', pincode: '791146' },
  { value: 'zarak', label: 'Zarak', pincode: '791147' },
  { value: 'gillu', label: 'Gillu', pincode: '791148' },
  { value: 'miti', label: 'Miti', pincode: '791149' },
  { value: 'poir', label: 'Poir', pincode: '791150' },
  { value: 'sangram', label: 'Sangram', pincode: '791151' },
  { value: 'yaring', label: 'Yaring', pincode: '791152' },
  { value: 'lachung', label: 'Lachung', pincode: '791153' },
  { value: 'barapani', label: 'Barapani', pincode: '791154' },
  { value: 'khargo', label: 'Khargo', pincode: '791155' },
  { value: 'tajo', label: 'Tajo', pincode: '791156' },
  { value: 'lingti', label: 'Lingti', pincode: '791157' },
  { value: 'viring', label: 'Viring', pincode: '791158' }
  ],

  'deomali': [
  { value: 'bhalukpong', label: 'Bhalukpong', pincode: '790114' },
  { value: 'bomdila', label: 'Bomdila', pincode: '790201' },
  { value: 'deomali-town', label: 'Deomali Town', pincode: '792001' },
  { value: 'dirang', label: 'Dirang', pincode: '790101' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khonsa', label: 'Khonsa', pincode: '792140' },
  { value: 'khibo', label: 'Khibo', pincode: '792002' },
  { value: 'miao', label: 'Miao', pincode: '792113' },
  { value: 'namphai', label: 'Namphai', pincode: '792133' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'tezu', label: 'Tezu', pincode: '792001' },
  { value: 'tinsukia', label: 'Tinsukia', pincode: '786125' },
  { value: 'wakka', label: 'Wakka', pincode: '792125' }
  ],

  'dirang': [
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '790106' },
  { value: 'dirang', label: 'Dirang', pincode: '790101' },
  { value: 'gorzam', label: 'Gorzam', pincode: '790112' },
  { value: 'kalaktang', label: 'Kalaktang', pincode: '790102' },
  { value: 'khinjili', label: 'Khinjili', pincode: '790105' },
  { value: 'morshing', label: 'Morshing', pincode: '790103' },
  { value: 'sangti', label: 'Sangti', pincode: '790107' },
  { value: 'tawang', label: 'Tawang', pincode: '790104' },
  { value: 'wabang', label: 'Wabang', pincode: '790110' },
  { value: 'bomdila', label: 'Bomdila', pincode: '790201' },
  { value: 'nagalung', label: 'Nagalung', pincode: '790202' },
  { value: 'rupa', label: 'Rupa', pincode: '790203' },
  { value: 'zimithang', label: 'Zimithang', pincode: '790301' },
  { value: 'seppa', label: 'Seppa', pincode: '790101' },
  { value: 'shergaon', label: 'Shergaon', pincode: '790208' },
  { value: 'kalabari', label: 'Kalabari', pincode: '790205' },
  { value: 'sangdupota', label: 'Sangdupota', pincode: '790206' },
  { value: 'kimin', label: 'Kimin', pincode: '790204' },
  { value: 'agum', label: 'Agum', pincode: '790109' },
  { value: 'jang', label: 'Jang', pincode: '790107' },
  { value: 'memba', label: 'Memba', pincode: '790108' },
  { value: 'lipu', label: 'Lipu', pincode: '790110' },
  { value: 'yangtse', label: 'Yangtse', pincode: '790112' },
  { value: 'shergaon', label: 'Shergaon', pincode: '790208' },
  { value: 'chug', label: 'Chug', pincode: '790111' }
  ],

  'dirang-h.q': [
  { value: 'bomdila', label: 'Bomdila', pincode: '790001' },
  { value: 'chander', label: 'Chander', pincode: '790002' },
  { value: 'dirang', label: 'Dirang', pincode: '790101' },
  { value: 'ganjugong', label: 'Ganjugong', pincode: '790102' },
  { value: 'jalukbari', label: 'Jalukbari', pincode: '790103' },
  { value: 'khowang', label: 'Khowang', pincode: '790106' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '790107' },
  { value: 'lyomak', label: 'Lyomak', pincode: '790108' },
  { value: 'mahipur', label: 'Mahipur', pincode: '790111' },
  { value: 'matla', label: 'Matla', pincode: '790112' },
  { value: 'nyukmadung', label: 'Nyukmadung', pincode: '790104' },
  { value: 'serna', label: 'Serna', pincode: '790105' },
  { value: 'tenga', label: 'Tenga', pincode: '790109' },
  { value: 'thongri', label: 'Thongri', pincode: '790110' },
  { value: 'zilukphu', label: 'Zilukphu', pincode: '790113' },
  { value: 'bichom', label: 'Bichom', pincode: '790114' },
  { value: 'nikte', label: 'Nikte', pincode: '790115' },
  { value: 'mouling', label: 'Mouling', pincode: '790116' },
  { value: 'monigong', label: 'Monigong', pincode: '790117' }
  ],
  
  'east-kameng': [
  { value: 'bhalukpong', label: 'Bhalukpong', pincode: '790114' },
  { value: 'bomdila', label: 'Bomdila', pincode: '790001' },
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '790103' },
  { value: 'daporizo', label: 'Daporijo', pincode: '790101' },
  { value: 'kalaktang', label: 'Kalaktang', pincode: '790112' },
  { value: 'khamtang', label: 'Khamtang', pincode: '790115' },
  { value: 'kotlo', label: 'Kotlo', pincode: '790116' },
  { value: 'likabali', label: 'Likabali', pincode: '790109' },
  { value: 'mamle', label: 'Mamle', pincode: '790117' },
  { value: 'mera', label: 'Mera', pincode: '790118' },
  { value: 'nayin', label: 'Nayin', pincode: '790119' },
  { value: 'shergaon', label: 'Shergaon', pincode: '790118' },
  { value: 'sonitpur', label: 'Sonitpur', pincode: '790120' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '790121' },
  { value: 'thongri', label: 'Thongri', pincode: '790110' },
  { value: 'wayang', label: 'Wayang', pincode: '790113' },
  { value: 'zangge', label: 'Zangge', pincode: '790122' },
  { value: 'adirang', label: 'Adirang', pincode: '790123' },
  { value: 'dokum', label: 'Dokum', pincode: '790124' },
  { value: 'gumo', label: 'Gumo', pincode: '790125' },
  { value: 'kalung', label: 'Kalung', pincode: '790126' },
  { value: 'lepas', label: 'Lepas', pincode: '790127' },
  { value: 'mesu', label: 'Mesu', pincode: '790128' },
  { value: 'padu', label: 'Padu', pincode: '790129' },
  { value: 'siyom', label: 'Siyom', pincode: '790130' }
  ],
  
  'east-siang': [
  { value: 'abang', label: 'Abang', pincode: '791001' },
  { value: 'adum', label: 'Adum', pincode: '791002' },
  { value: 'amliang', label: 'Amliang', pincode: '791003' },
  { value: 'basar', label: 'Basar', pincode: '791004' },
  { value: 'bomdila', label: 'Bomdila', pincode: '790001' },
  { value: 'daying', label: 'Daying', pincode: '791005' },
  { value: 'dumduma', label: 'Dumduma', pincode: '791006' },
  { value: 'jarkong', label: 'Jarkong', pincode: '791007' },
  { value: 'kangkong', label: 'Kangkong', pincode: '791008' },
  { value: 'kongkul', label: 'Kongkul', pincode: '791015' },
  { value: 'lather', label: 'Lather', pincode: '791016' },
  { value: 'longding', label: 'Longding', pincode: '791017' },
  { value: 'mariyang', label: 'Mariyang', pincode: '791009' },
  { value: 'nari', label: 'Nari', pincode: '791010' },
  { value: 'pasighat', label: 'Pasighat', pincode: '791102' },
  { value: 'roing', label: 'Roing', pincode: '791101' },
  { value: 'seram', label: 'Seram', pincode: '791011' },
  { value: 'siang', label: 'Siang', pincode: '791012' },
  { value: 'sii', label: 'Sii', pincode: '791013' },
  { value: 'yagrung', label: 'Yagrung', pincode: '791014' },
  { value: 'ningging', label: 'Ningging', pincode: '791018' },
  { value: 'jimo', label: 'Jimo', pincode: '791019' },
  { value: 'tawang', label: 'Tawang', pincode: '790101' },
  { value: 'ongkher', label: 'Ongkher', pincode: '791020' },
  { value: 'sialmari', label: 'Sialmari', pincode: '791021' },
  { value: 'jongkhar', label: 'Jongkhar', pincode: '791022' },
  { value: 'taklung', label: 'Taklung', pincode: '791023' },
  { value: 'harpan', label: 'Harpan', pincode: '791024' },
  { value: 'demi', label: 'Demi', pincode: '791025' },
  { value: 'subansiri', label: 'Subansiri', pincode: '791026' },
  { value: 'ghoom', label: 'Ghoom', pincode: '791027' },
  { value: 'tuda', label: 'Tuda', pincode: '791028' }
  ],

  'gelling': [
  { value: 'adung', label: 'Adung', pincode: '791001' },
  { value: 'barcha', label: 'Barcha', pincode: '791002' },
  { value: 'budi', label: 'Budi', pincode: '791003' },
  { value: 'gelling', label: 'Gelling', pincode: '791004' },
  { value: 'guri', label: 'Guri', pincode: '791005' },
  { value: 'koyu', label: 'Koyu', pincode: '791006' },
  { value: 'longpo', label: 'Longpo', pincode: '791007' },
  { value: 'mariang', label: 'Mariang', pincode: '791008' },
  { value: 'mechuka', label: 'Mechuka', pincode: '791009' },
  { value: 'ruksin', label: 'Ruksin', pincode: '791010' },
  { value: 'siyum', label: 'Siyum', pincode: '791011' },
  { value: 'tupri', label: 'Tupri', pincode: '791012' },
  { value: 'yingkiong', label: 'Yingkiong', pincode: '791013' },
  { value: 'taksing', label: 'Taksing', pincode: '791014' },
  { value: 'tenga', label: 'Tenga', pincode: '790109' },
  { value: 'lungla', label: 'Lungla', pincode: '790106' },
  { value: 'dambuk', label: 'Dambuk', pincode: '790101' },
  { value: 'along', label: 'Along', pincode: '790101' },
  { value: 'bome', label: 'Bome', pincode: '790107' },
  { value: 'seppa', label: 'Seppa', pincode: '790102' }
  ],

  'hawai': [
  { value: 'asapani', label: 'Asapani', pincode: '791101' },
  { value: 'basar', label: 'Basar', pincode: '791102' },
  { value: 'chungkung', label: 'Chungkung', pincode: '791103' },
  { value: 'hawai', label: 'Hawai', pincode: '791104' },
  { value: 'hiyang', label: 'Hiyang', pincode: '791105' },
  { value: 'karda', label: 'Karda', pincode: '791106' },
  { value: 'keba', label: 'Keba', pincode: '791107' },
  { value: 'longding', label: 'Longding', pincode: '791108' },
  { value: 'mungka', label: 'Mungka', pincode: '791109' },
  { value: 'palin', label: 'Palin', pincode: '791110' },
  { value: 'ruksin', label: 'Ruksin', pincode: '791111' },
  { value: 'tali', label: 'Tali', pincode: '791112' },
  { value: 'tawang', label: 'Tawang', pincode: '790101' },
  { value: 'changlang', label: 'Changlang', pincode: '791113' },
  { value: 'jalukie', label: 'Jalukie', pincode: '791114' },
  { value: 'kayang', label: 'Kayang', pincode: '791115' },
  { value: 'lupung', label: 'Lupung', pincode: '791116' },
  { value: 'mechuka', label: 'Mechuka', pincode: '791117' },
  { value: 'shikha', label: 'Shikha', pincode: '791118' },
  { value: 'ziro', label: 'Ziro', pincode: '790101' },
  { value: 'yamne', label: 'Yamne', pincode: '791119' },
  { value: 'zakhang', label: 'Zakhang', pincode: '791120' }
  ],
  
  'itanagar': [
  { value: 'abhi-nagar', label: 'Abhi Nagar', pincode: '791111' },
  { value: 'bana', label: 'Bana', pincode: '791112' },
  { value: 'bazar-line', label: 'Bazar Line', pincode: '791113' },
  { value: 'betkheri', label: 'Betkheri', pincode: '791114' },
  { value: 'danikiri', label: 'Danikiri', pincode: '791115' },
  { value: 'doimukh', label: 'Doimukh', pincode: '791116' },
  { value: 'ena', label: 'Ena', pincode: '791117' },
  { value: 'ganga-nagar', label: 'Ganga Nagar', pincode: '791118' },
  { value: 'gohpur', label: 'Gohpur', pincode: '791119' },
  { value: 'itanagar', label: 'Itanagar', pincode: '791120' },
  { value: 'karsingsa', label: 'Karsingsa', pincode: '791121' },
  { value: 'kolla', label: 'Kolla', pincode: '791122' },
  { value: 'nh52', label: 'NH 52', pincode: '791123' },
  { value: 'nyokum', label: 'Nyokum', pincode: '791124' },
  { value: 'pappu', label: 'Pappu', pincode: '791125' },
  { value: 'panchali', label: 'Panchali', pincode: '791126' },
  { value: 'rabum', label: 'Rabum', pincode: '791127' },
  { value: 'rigyung', label: 'Rigyung', pincode: '791128' },
  { value: 'siri', label: 'Siri', pincode: '791129' },
  { value: 'yahank', label: 'Yahank', pincode: '791130' },
  { value: 'chupung', label: 'Chupung', pincode: '791131' },
  { value: 'derek', label: 'Derek', pincode: '791132' },
  { value: 'ganga-vihar', label: 'Ganga Vihar', pincode: '791133' },
  { value: 'jai-nagar', label: 'Jai Nagar', pincode: '791134' },
  { value: 'karsang', label: 'Karsang', pincode: '791135' },
  { value: 'khonsa', label: 'Khonsa', pincode: '791136' },
  { value: 'lower-district', label: 'Lower District', pincode: '791137' },
  { value: 'mynkhang', label: 'Mynkhang', pincode: '791138' },
  { value: 'naharlagun', label: 'Naharlagun', pincode: '791139' },
  { value: 'nechiphu', label: 'Nechiphu', pincode: '791140' },
  { value: 'old-itangar', label: 'Old Itanagar', pincode: '791141' }
  ],
  
  'jairampur': [
  { value: 'banskota', label: 'Banskota', pincode: '791001' },
  { value: 'chungwong', label: 'Chungwong', pincode: '791002' },
  { value: 'chungpong', label: 'Chungpong', pincode: '791003' },
  { value: 'jairampur', label: 'Jairampur', pincode: '791004' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '791005' },
  { value: 'kherem', label: 'Kherem', pincode: '791006' },
  { value: 'longki', label: 'Longki', pincode: '791007' },
  { value: 'pangchung', label: 'Pangchung', pincode: '791008' },
  { value: 'pokam', label: 'Pokam', pincode: '791009' },
  { value: 'sakhitla', label: 'Sakhitla', pincode: '791010' },
  { value: 'seleng', label: 'Seleng', pincode: '791011' },
  { value: 'sompura', label: 'Sompura', pincode: '791012' },
  { value: 'yengmang', label: 'Yengmang', pincode: '791013' },
  { value: 'changlang', label: 'Changlang', pincode: '791014' },
  { value: 'jartila', label: 'Jartila', pincode: '791015' },
  { value: 'jokai', label: 'Jokai', pincode: '791016' },
  { value: 'kharsang', label: 'Kharsang', pincode: '791017' },
  { value: 'kherem', label: 'Kherem', pincode: '791018' },
  { value: 'lathao', label: 'Lathao', pincode: '791019' },
  { value: 'loang', label: 'Loang', pincode: '791020' },
  { value: 'pangkam', label: 'Pangkam', pincode: '791021' },
  { value: 'pangsau', label: 'Pangsau', pincode: '791022' },
  { value: 'ranglung', label: 'Ranglung', pincode: '791023' }
  ],
  
  'khonsa': [
  { value: 'changlang', label: 'Changlang', pincode: '792120' },
  { value: 'chowkham', label: 'Chowkham', pincode: '792141' },
  { value: 'hayuliang', label: 'Hayuliang', pincode: '792071' },
  { value: 'khonsa', label: 'Khonsa', pincode: '792130' },
  { value: 'longding', label: 'Longding', pincode: '792131' },
  { value: 'lazu', label: 'Lazu', pincode: '792130' },
  { value: 'miao', label: 'Miao', pincode: '792122' },
  { value: 'namchik', label: 'Namchik', pincode: '792124' },
  { value: 'pumao', label: 'Pumao', pincode: '792135' },
  { value: 'tirap', label: 'Tirap', pincode: '792100' },
  { value: 'vijaynagar', label: 'Vijaynagar', pincode: '792133' },
  { value: 'wangcha', label: 'Wangcha', pincode: '792130' },
  { value: 'leparada', label: 'Leparada', pincode: '792160' },
  { value: 'deomali', label: 'Deomali', pincode: '792120' },
  { value: 'bungpung', label: 'Bungpung', pincode: '792139' },
  { value: 'phassang', label: 'Phassang', pincode: '792136' },
  { value: 'rumgong', label: 'Rumgong', pincode: '792145' },
  { value: 'kheti', label: 'Kheti', pincode: '792112' },
  { value: 'worling', label: 'Worling', pincode: '792121' },
  { value: 'itanagar', label: 'Itanagar', pincode: '791111' },
  { value: 'basar', label: 'Basar', pincode: '791101' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'tawang', label: 'Tawang', pincode: '790104' },
  { value: 'bomdila', label: 'Bomdila', pincode: '790201' },
  { value: 'dirang', label: 'Dirang', pincode: '790101' },
  { value: 'seppa', label: 'Seppa', pincode: '791102' },
  { value: 'namsai', label: 'Namsai', pincode: '792103' },
  { value: 'sunpura', label: 'Sunpura', pincode: '792150' },
  { value: 'maibang', label: 'Maibang', pincode: '792150' }
  ],
  
  'lathao': [
  { value: 'adang', label: 'Adang', pincode: '791002' },
  { value: 'balle', label: 'Balle', pincode: '791003' },
  { value: 'bungbang', label: 'Bungbang', pincode: '791005' },
  { value: 'lathao', label: 'Lathao', pincode: '791001' },
  { value: 'moitling', label: 'Moitling', pincode: '791004' },
  { value: 'narang', label: 'Narang', pincode: '791008' },
  { value: 'niglok', label: 'Niglok', pincode: '791007' },
  { value: 'sarli', label: 'Sarli', pincode: '791011' },
  { value: 'tirbin', label: 'Tirbin', pincode: '791010' },
  { value: 'bame', label: 'Bame', pincode: '791006' },
  { value: 'darak', label: 'Darak', pincode: '791015' },
  { value: 'kanubari', label: 'Kanubari', pincode: '791014' },
  { value: 'ruksin', label: 'Ruksin', pincode: '791013' },
  { value: 'siyum', label: 'Siyum', pincode: '791009' },
  { value: 'yinkiong', label: 'Yinkiong', pincode: '791012' },
  { value: 'ziro', label: 'Ziro', pincode: '791120' },
  { value: 'hong', label: 'Hong', pincode: '791121' },
  { value: 'palin', label: 'Palin', pincode: '791122' },
  { value: 'barchala', label: 'Barchala', pincode: '791123' },
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '791124' },
  { value: 'mariyang', label: 'Mariyang', pincode: '791125' },
  { value: 'tali', label: 'Tali', pincode: '791126' },
  { value: 'banggo', label: 'Banggo', pincode: '791127' },
  { value: 'basar', label: 'Basar', pincode: '791128' },
  { value: 'bomdila', label: 'Bomdila', pincode: '790201' }
  ],

  'lhou': [
  { value: 'biri', label: 'Biri', pincode: '791013' },
  { value: 'lhou', label: 'Lhou', pincode: '791014' },
  { value: 'lone', label: 'Lone', pincode: '791015' },
  { value: 'padi', label: 'Padi', pincode: '791016' },
  { value: 'ramle', label: 'Ramle', pincode: '791017' },
  { value: 'shiyom', label: 'Shiyom', pincode: '791018' },
  { value: 'tali', label: 'Tali', pincode: '791019' },
  { value: 'yomcha', label: 'Yomcha', pincode: '791020' },
  { value: 'bungbing', label: 'Bungbing', pincode: '791021' },
  { value: 'doke', label: 'Doke', pincode: '791022' },
  { value: 'jirikindong', label: 'Jirikindong', pincode: '791023' },
  { value: 'kangkin', label: 'Kangkin', pincode: '791024' },
  { value: 'mashik', label: 'Mashik', pincode: '791025' },
  { value: 'namsing', label: 'Namsing', pincode: '791026' },
  { value: 'roing', label: 'Roing', pincode: '791110' },
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '791127' },
  { value: 'pangin', label: 'Pangin', pincode: '791128' },
  { value: 'ruksin', label: 'Ruksin', pincode: '791129' }
  ],

  'lower-subansiri': [
  { value: 'daporizo', label: 'Daporizo', pincode: '791120' },
  { value: 'lappori', label: 'Lappori', pincode: '791121' },
  { value: 'longcha', label: 'Longcha', pincode: '791122' },
  { value: 'manmao', label: 'Manmao', pincode: '791123' },
  { value: 'padi', label: 'Padi', pincode: '791124' },
  { value: 'ruili', label: 'Ruili', pincode: '791125' },
  { value: 'sigen', label: 'Sigen', pincode: '791126' },
  { value: 'tali', label: 'Tali', pincode: '791127' },
  { value: 'yamne', label: 'Yamne', pincode: '791128' },
  { value: 'zemo', label: 'Zemo', pincode: '791129' },
  { value: 'nyapin', label: 'Nyapin', pincode: '791130' },
  { value: 'hija', label: 'Hija', pincode: '791131' },
  { value: 'yazali', label: 'Yazali', pincode: '791132' },
  { value: 'sarli', label: 'Sarli', pincode: '791133' },
  { value: 'leparada', label: 'Leparada', pincode: '791134' },
  { value: 'jari', label: 'Jari', pincode: '791135' },
  { value: 'krung', label: 'Krung', pincode: '791136' },
  { value: 'sagalee', label: 'Sagalee', pincode: '791137' },
  { value: 'supply', label: 'Supply', pincode: '791138' },
  { value: 'bailey', label: 'Bailey', pincode: '791139' },
  { value: 'khen', label: 'Khen', pincode: '791140' },
  { value: 'gussa', label: 'Gussa', pincode: '791141' },
  { value: 'bana', label: 'Bana', pincode: '791142' },
  { value: 'kayan', label: 'Kayan', pincode: '791143' },
  { value: 'kora', label: 'Kora', pincode: '791144' },
  { value: 'itafort', label: 'Itafort', pincode: '791145' },
  { value: 'pawe', label: 'Pawe', pincode: '791146' }
  ],
  
  'naharlagun': [
  { value: 'bapor', label: 'Bapor', pincode: '791110' },
  { value: 'bhalukpong', label: 'Bhalukpong', pincode: '791112' },
  { value: 'karsingsa', label: 'Karsingsa', pincode: '791113' },
  { value: 'naharlagun', label: 'Naharlagun', pincode: '791110' },
  { value: 'niti', label: 'Niti', pincode: '791111' },
  { value: 'papu', label: 'Papu', pincode: '791114' },
  { value: 'pabua', label: 'Pabua', pincode: '791115' },
  { value: 'balijan', label: 'Balijan', pincode: '791116' },
  { value: 'harinagar', label: 'Harinagar', pincode: '791117' },
  { value: 'chamukha', label: 'Chamukha', pincode: '791118' },
  { value: 'seppa', label: 'Seppa', pincode: '791119' },
  { value: 'sangdupota', label: 'Sangdupota', pincode: '791120' },
  { value: 'poma', label: 'Poma', pincode: '791121' },
  { value: 'ganapathiyar', label: 'Ganapathiyar', pincode: '791122' },
  { value: 'tahuk', label: 'Tahuk', pincode: '791123' },
  { value: 'rampur', label: 'Rampur', pincode: '791124' },
  { value: 'dollungmukh', label: 'Dollungmukh', pincode: '791125' },
  { value: 'dizang', label: 'Dizang', pincode: '791126' },
  { value: 'rumgong', label: 'Rumgong', pincode: '791127' },
  { value: 'gohpur', label: 'Gohpur', pincode: '791128' },
  { value: 'wessang', label: 'Wessang', pincode: '791129' },
  { value: 'sidi', label: 'Sidi', pincode: '791130' },
  { value: 'basar', label: 'Basar', pincode: '791131' },
  { value: 'rangang', label: 'Rangang', pincode: '791132' },
  { value: 'shergaon', label: 'Shergaon', pincode: '791133' },
  { value: 'gora', label: 'Gora', pincode: '791134' },
  { value: 'bhoga', label: 'Bhoga', pincode: '791135' },
  { value: 'vijaynagar', label: 'Vijaynagar', pincode: '791136' }
  ],
  
  'namsai': [
  { value: 'bomdila', label: 'Bomdila', pincode: '791120' },
  { value: 'chaglagam', label: 'Chaglagam', pincode: '791121' },
  { value: 'dambu', label: 'Dambu', pincode: '791122' },
  { value: 'duggum', label: 'Duggum', pincode: '791123' },
  { value: 'jengging', label: 'Jengging', pincode: '791124' },
  { value: 'khimiyang', label: 'Khimiyang', pincode: '791125' },
  { value: 'kongkul', label: 'Kongkul', pincode: '791126' },
  { value: 'loiliang', label: 'Loiliang', pincode: '791127' },
  { value: 'namsai', label: 'Namsai', pincode: '791129' },
  { value: 'ruksin', label: 'Ruksin', pincode: '791130' },
  { value: 'sapla', label: 'Sapla', pincode: '791131' },
  { value: 'seijosa', label: 'Seijosa', pincode: '791132' },
  { value: 'wakka', label: 'Wakka', pincode: '791133' },
  { value: 'yazali', label: 'Yazali', pincode: '791134' },
  { value: 'ziro', label: 'Ziro', pincode: '791135' },
  { value: 'lathao', label: 'Lathao', pincode: '791136' },
  { value: 'nakhu', label: 'Nakhu', pincode: '791137' },
  { value: 'panchali', label: 'Panchali', pincode: '791138' },
  { value: 'sadiya', label: 'Sadiya', pincode: '791139' },
  { value: 'walong', label: 'Walong', pincode: '791140' },
  { value: 'roing', label: 'Roing', pincode: '791141' },
  { value: 'kherem', label: 'Kherem', pincode: '791142' },
  { value: 'chungkhung', label: 'Chungkhung', pincode: '791143' },
  { value: 'dong', label: 'Dong', pincode: '791144' },
  { value: 'bali', label: 'Bali', pincode: '791145' },
  { value: 'deopani', label: 'Deopani', pincode: '791146' },
  { value: 'parshuram', label: 'Parshuram', pincode: '791147' },
  { value: 'silang', label: 'Silang', pincode: '791148' },
  { value: 'ngopok', label: 'Ngopok', pincode: '791149' }
  ],
  
  'nacho': [
  { value: 'bomdila', label: 'Bomdila', pincode: '791120' },
  { value: 'chaglagam', label: 'Chaglagam', pincode: '791121' },
  { value: 'duggum', label: 'Duggum', pincode: '791122' },
  { value: 'jengging', label: 'Jengging', pincode: '791123' },
  { value: 'khimiyang', label: 'Khimiyang', pincode: '791124' },
  { value: 'kongkul', label: 'Kongkul', pincode: '791125' },
  { value: 'nacho', label: 'Nacho', pincode: '791126' },
  { value: 'seijosa', label: 'Seijosa', pincode: '791127' },
  { value: 'namsai', label: 'Namsai', pincode: '791129' },
  { value: 'ruksin', label: 'Ruksin', pincode: '791130' },
  { value: 'sapla', label: 'Sapla', pincode: '791131' },
  { value: 'wakka', label: 'Wakka', pincode: '791132' },
  { value: 'yazali', label: 'Yazali', pincode: '791133' },
  { value: 'ziro', label: 'Ziro', pincode: '791134' },
  { value: 'lathao', label: 'Lathao', pincode: '791135' },
  { value: 'dong', label: 'Dong', pincode: '791136' },
  { value: 'pichola', label: 'Pichola', pincode: '791137' },
  { value: 'semla', label: 'Semla', pincode: '791138' },
  { value: 'anini', label: 'Anini', pincode: '791139' },
  { value: 'sadiya', label: 'Sadiya', pincode: '791140' },
  { value: 'tirap', label: 'Tirap', pincode: '791141' },
  { value: 'kamle', label: 'Kamle', pincode: '791142' },
  { value: 'itafort', label: 'Itafort', pincode: '791143' },
  { value: 'rumgong', label: 'Rumgong', pincode: '791144' },
  { value: 'chongkham', label: 'Chongkham', pincode: '791145' },
  { value: 'gusar', label: 'Gusar', pincode: '791146' },
  { value: 'longding', label: 'Longding', pincode: '791147' },
  { value: 'deomali', label: 'Deomali', pincode: '791148' },
  { value: 'tanam', label: 'Tanam', pincode: '791149' },
  { value: 'kunyung', label: 'Kunyung', pincode: '791150' }
  ],
  
  'pangin': [
  { value: 'bomdila', label: 'Bomdila', pincode: '791120' },
  { value: 'chaglagam', label: 'Chaglagam', pincode: '791121' },
  { value: 'duggum', label: 'Duggum', pincode: '791122' },
  { value: 'jengging', label: 'Jengging', pincode: '791123' },
  { value: 'khimiyang', label: 'Khimiyang', pincode: '791124' },
  { value: 'kongkul', label: 'Kongkul', pincode: '791125' },
  { value: 'nacho', label: 'Nacho', pincode: '791126' },
  { value: 'seijosa', label: 'Seijosa', pincode: '791127' },
  { value: 'namsai', label: 'Namsai', pincode: '791129' },
  { value: 'ruksin', label: 'Ruksin', pincode: '791130' },
  { value: 'sapla', label: 'Sapla', pincode: '791131' },
  { value: 'wakka', label: 'Wakka', pincode: '791132' },
  { value: 'yazali', label: 'Yazali', pincode: '791133' },
  { value: 'ziro', label: 'Ziro', pincode: '791134' },
  { value: 'pangin', label: 'Pangin', pincode: '791135' },
  { value: 'pichola', label: 'Pichola', pincode: '791136' },
  { value: 'semla', label: 'Semla', pincode: '791137' },
  { value: 'kamle', label: 'Kamle', pincode: '791138' },
  { value: 'itafort', label: 'Itafort', pincode: '791139' },
  { value: 'rumgong', label: 'Rumgong', pincode: '791140' },
  { value: 'longding', label: 'Longding', pincode: '791141' },
  { value: 'chongkham', label: 'Chongkham', pincode: '791142' },
  { value: 'gusar', label: 'Gusar', pincode: '791143' },
  { value: 'deomali', label: 'Deomali', pincode: '791144' },
  { value: 'apno', label: 'Apno', pincode: '791145' },
  { value: 'dambuk', label: 'Dambuk', pincode: '791146' },
  { value: 'tinali', label: 'Tinali', pincode: '791147' },
  { value: 'kemi', label: 'Kemi', pincode: '791148' },
  { value: 'parsang', label: 'Parsang', pincode: '791149' },
  { value: 'sitaram', label: 'Sitaram', pincode: '791150' },
  { value: 'tawang', label: 'Tawang', pincode: '791151' },
  { value: 'yegong', label: 'Yegong', pincode: '791152' },
  { value: 'lurang', label: 'Lurang', pincode: '791153' }
  ],
  
  'pasighat': [
  { value: 'bomdila', label: 'Bomdila', pincode: '791120' },
  { value: 'chaglagam', label: 'Chaglagam', pincode: '791121' },
  { value: 'duggum', label: 'Duggum', pincode: '791122' },
  { value: 'jengging', label: 'Jengging', pincode: '791123' },
  { value: 'khimiyang', label: 'Khimiyang', pincode: '791124' },
  { value: 'kongkul', label: 'Kongkul', pincode: '791125' },
  { value: 'nacho', label: 'Nacho', pincode: '791126' },
  { value: 'seijosa', label: 'Seijosa', pincode: '791127' },
  { value: 'namsai', label: 'Namsai', pincode: '791129' },
  { value: 'ruksin', label: 'Ruksin', pincode: '791130' },
  { value: 'sapla', label: 'Sapla', pincode: '791131' },
  { value: 'wakka', label: 'Wakka', pincode: '791132' },
  { value: 'yazali', label: 'Yazali', pincode: '791133' },
  { value: 'ziro', label: 'Ziro', pincode: '791134' },
  { value: 'pangin', label: 'Pangin', pincode: '791135' },
  { value: 'pichola', label: 'Pichola', pincode: '791136' },
  { value: 'semla', label: 'Semla', pincode: '791137' },
  { value: 'kamle', label: 'Kamle', pincode: '791138' },
  { value: 'itafort', label: 'Itafort', pincode: '791139' },
  { value: 'rumgong', label: 'Rumgong', pincode: '791140' },
  { value: 'longding', label: 'Longding', pincode: '791141' },
  { value: 'chongkham', label: 'Chongkham', pincode: '791142' },
  { value: 'gusar', label: 'Gusar', pincode: '791143' },
  { value: 'deomali', label: 'Deomali', pincode: '791144' },
  { value: 'pasighat', label: 'Pasighat', pincode: '791145' },
  { value: 'apno', label: 'Apno', pincode: '791146' },
  { value: 'dambuk', label: 'Dambuk', pincode: '791147' },
  { value: 'tinali', label: 'Tinali', pincode: '791148' },
  { value: 'kemi', label: 'Kemi', pincode: '791149' },
  { value: 'parsang', label: 'Parsang', pincode: '791150' },
  { value: 'sitaram', label: 'Sitaram', pincode: '791151' },
  { value: 'tawang', label: 'Tawang', pincode: '791152' },
  { value: 'yegong', label: 'Yegong', pincode: '791153' },
  { value: 'lurang', label: 'Lurang', pincode: '791154' },
  { value: 'mariyang', label: 'Mariyang', pincode: '791155' },
  { value: 'pange', label: 'Pange', pincode: '791156' },
  { value: 'pasighat-town', label: 'Pasighat Town', pincode: '791157' },
  { value: 'dibrugarh', label: 'Dibrugarh', pincode: '791158' },
  { value: 'borongi', label: 'Borongi', pincode: '791159' }
  ],
  
  'roing': [
  { value: 'adum', label: 'Adum', pincode: '791110' },
  { value: 'amliang', label: 'Amliang', pincode: '791111' },
  { value: 'dirang', label: 'Dirang', pincode: '791112' },
  { value: 'jiro', label: 'Jiro', pincode: '791113' },
  { value: 'kriyung', label: 'Kriyung', pincode: '791114' },
  { value: 'lambu', label: 'Lambu', pincode: '791115' },
  { value: 'mbang', label: 'Mbang', pincode: '791116' },
  { value: 'roing', label: 'Roing', pincode: '791117' },
  { value: 'ruksin', label: 'Ruksin', pincode: '791118' },
  { value: 'seppa', label: 'Seppa', pincode: '791119' },
  { value: 'tali', label: 'Tali', pincode: '791120' },
  { value: 'salang', label: 'Salang', pincode: '791121' },
  { value: 'yebam', label: 'Yebam', pincode: '791122' },
  { value: 'zaku', label: 'Zaku', pincode: '791123' },
  { value: 'bameng', label: 'Bameng', pincode: '791124' },
  { value: 'bungbang', label: 'Bungbang', pincode: '791125' },
  { value: 'chantang', label: 'Chantang', pincode: '791126' },
  { value: 'chowkham', label: 'Chowkham', pincode: '791127' },
  { value: 'goyang', label: 'Goyang', pincode: '791128' },
  { value: 'hija', label: 'Hija', pincode: '791129' },
  { value: 'kholong', label: 'Kholong', pincode: '791130' },
  { value: 'kumdi', label: 'Kumdi', pincode: '791131' },
  { value: 'melo', label: 'Melo', pincode: '791132' },
  { value: 'tiding', label: 'Tiding', pincode: '791133' },
  { value: 'yongi', label: 'Yongi', pincode: '791134' }
  ],
  
  'sagalee': [
  { value: 'adum', label: 'Adum', pincode: '791110' },
  { value: 'ambem', label: 'Ambem', pincode: '791111' },
  { value: 'bapla', label: 'Bapla', pincode: '791112' },
  { value: 'chayung', label: 'Chayung', pincode: '791113' },
  { value: 'dambuk', label: 'Dambuk', pincode: '791114' },
  { value: 'engkhim', label: 'Engkhim', pincode: '791115' },
  { value: 'foing', label: 'Foing', pincode: '791116' },
  { value: 'gundhi', label: 'Gundhi', pincode: '791117' },
  { value: 'hijah', label: 'Hijah', pincode: '791118' },
  { value: 'irang', label: 'Irang', pincode: '791119' },
  { value: 'jayin', label: 'Jayin', pincode: '791120' },
  { value: 'kehi', label: 'Kehi', pincode: '791121' },
  { value: 'lata', label: 'Lata', pincode: '791122' },
  { value: 'mising', label: 'Mising', pincode: '791123' },
  { value: 'ngoh', label: 'Ngoh', pincode: '791124' },
  { value: 'pasighat', label: 'Pasighat', pincode: '791125' },
  { value: 'sagalee', label: 'Sagalee', pincode: '791126' },
  { value: 'tariang', label: 'Tariang', pincode: '791127' },
  { value: 'unau', label: 'Unau', pincode: '791128' },
  { value: 'yupia', label: 'Yupia', pincode: '791129' },
  { value: 'bishing', label: 'Bishing', pincode: '791130' },
  { value: 'doimukh', label: 'Doimukh', pincode: '791131' },
  { value: 'gari', label: 'Gari', pincode: '791132' },
  { value: 'haptal', label: 'Haptal', pincode: '791133' },
  { value: 'karing', label: 'Karing', pincode: '791134' },
  { value: 'poma', label: 'Poma', pincode: '791135' },
  { value: 'solung', label: 'Solung', pincode: '791136' },
  { value: 'dallang', label: 'Dallang', pincode: '791137' },
  { value: 'rahung', label: 'Rahung', pincode: '791138' },
  { value: 'korbu', label: 'Korbu', pincode: '791139' },
  { value: 'mabira', label: 'Mabira', pincode: '791140' },
  { value: 'samten', label: 'Samten', pincode: '791141' }
  ],

  'seppa': [
  { value: 'adum', label: 'Adum', pincode: '791110' },
  { value: 'amliang', label: 'Amliang', pincode: '791111' },
  { value: 'bapla', label: 'Bapla', pincode: '791112' },
  { value: 'chayung', label: 'Chayung', pincode: '791113' },
  { value: 'dambuk', label: 'Dambuk', pincode: '791114' },
  { value: 'engkhim', label: 'Engkhim', pincode: '791115' },
  { value: 'foing', label: 'Foing', pincode: '791116' },
  { value: 'gundhi', label: 'Gundhi', pincode: '791117' },
  { value: 'hijah', label: 'Hijah', pincode: '791118' },
  { value: 'irang', label: 'Irang', pincode: '791119' },
  { value: 'jiro', label: 'Jiro', pincode: '791120' },
  { value: 'kehi', label: 'Kehi', pincode: '791121' },
  { value: 'lata', label: 'Lata', pincode: '791122' },
  { value: 'mising', label: 'Mising', pincode: '791123' },
  { value: 'ngoh', label: 'Ngoh', pincode: '791124' },
  { value: 'pasighat', label: 'Pasighat', pincode: '791125' },
  { value: 'seppa', label: 'Seppa', pincode: '791126' },
  { value: 'sinki', label: 'Sinki', pincode: '791127' },
  { value: 'tariang', label: 'Tariang', pincode: '791128' },
  { value: 'unau', label: 'Unau', pincode: '791129' },
  { value: 'yupia', label: 'Yupia', pincode: '791130' },
  { value: 'chongkham', label: 'Chongkham', pincode: '791131' },
  { value: 'pangkang', label: 'Pangkang', pincode: '791132' },
  { value: 'yembung', label: 'Yembung', pincode: '791133' },
  { value: 'lingti', label: 'Lingti', pincode: '791134' },
  { value: 'medo', label: 'Medo', pincode: '791135' },
  { value: 'kaying', label: 'Kaying', pincode: '791136' },
  { value: 'tawang', label: 'Tawang', pincode: '791137' },
  { value: 'chime', label: 'Chime', pincode: '791138' },
  { value: 'dasing', label: 'Dasing', pincode: '791139' },
  { value: 'pada', label: 'Pada', pincode: '791140' }
  ],

'taliha': [
  { value: 'adum', label: 'Adum', pincode: '791110' },
  { value: 'ambem', label: 'Ambem', pincode: '791111' },
  { value: 'bapla', label: 'Bapla', pincode: '791112' },
  { value: 'chayung', label: 'Chayung', pincode: '791113' },
  { value: 'dambuk', label: 'Dambuk', pincode: '791114' },
  { value: 'engkhim', label: 'Engkhim', pincode: '791115' },
  { value: 'foing', label: 'Foing', pincode: '791116' },
  { value: 'gundhi', label: 'Gundhi', pincode: '791117' },
  { value: 'hijah', label: 'Hijah', pincode: '791118' },
  { value: 'irang', label: 'Irang', pincode: '791119' },
  { value: 'jiro', label: 'Jiro', pincode: '791120' },
  { value: 'kehi', label: 'Kehi', pincode: '791121' },
  { value: 'lata', label: 'Lata', pincode: '791122' },
  { value: 'mising', label: 'Mising', pincode: '791123' },
  { value: 'ngoh', label: 'Ngoh', pincode: '791124' },
  { value: 'pasighat', label: 'Pasighat', pincode: '791125' },
  { value: 'seppa', label: 'Seppa', pincode: '791126' },
  { value: 'sinkhi', label: 'Sinkhi', pincode: '791127' },
  { value: 'tariang', label: 'Tariang', pincode: '791128' },
  { value: 'unau', label: 'Unau', pincode: '791129' },
  { value: 'yupia', label: 'Yupia', pincode: '791130' },
  { value: 'tawang', label: 'Tawang', pincode: '791131' },
  { value: 'kaying', label: 'Kaying', pincode: '791132' },
  { value: 'lingti', label: 'Lingti', pincode: '791133' },
  { value: 'chime', label: 'Chime', pincode: '791134' },
  { value: 'dasing', label: 'Dasing', pincode: '791135' },
  { value: 'khuim', label: 'Khuim', pincode: '791136' },
  { value: 'lindeng', label: 'Lindeng', pincode: '791137' },
  { value: 'medo', label: 'Medo', pincode: '791138' },
  { value: 'minto', label: 'Minto', pincode: '791139' },
  { value: 'rafi', label: 'Rafi', pincode: '791140' },
  { value: 'solung', label: 'Solung', pincode: '791141' },
  { value: 'angpung', label: 'Angpung', pincode: '791142' },
  { value: 'balipara', label: 'Balipara', pincode: '791143' },
  { value: 'changli', label: 'Changli', pincode: '791144' },
  { value: 'dopla', label: 'Dopla', pincode: '791145' },
  { value: 'erika', label: 'Erika', pincode: '791146' },
  { value: 'fukri', label: 'Fukri', pincode: '791147' },
  { value: 'golo', label: 'Golo', pincode: '791148' },
  { value: 'hermi', label: 'Hermi', pincode: '791149' },
  { value: 'imili', label: 'Imili', pincode: '791150' },
  { value: 'jimalu', label: 'Jimalu', pincode: '791151' }
  ],
  
  'tawang': [
  { value: 'bomdila', label: 'Bomdila', pincode: '790001' },
  { value: 'changbu', label: 'Changbu', pincode: '790002' },
  { value: 'darma', label: 'Darma', pincode: '790003' },
  { value: 'gongka', label: 'Gongka', pincode: '790004' },
  { value: 'jongdi', label: 'Jongdi', pincode: '790005' },
  { value: 'khangser', label: 'Khangser', pincode: '790006' },
  { value: 'lhou', label: 'Lhou', pincode: '790007' },
  { value: 'mangku', label: 'Mangku', pincode: '790008' },
  { value: 'naga', label: 'Naga', pincode: '790009' },
  { value: 'omling', label: 'Omling', pincode: '790010' },
  { value: 'pago', label: 'Pago', pincode: '790011' },
  { value: 'ringapong', label: 'Ringapong', pincode: '790012' },
  { value: 'sangdong', label: 'Sangdong', pincode: '790013' },
  { value: 'tawang', label: 'Tawang', pincode: '790014' },
  { value: 'wamdo', label: 'Wamdo', pincode: '790015' },
  { value: 'yangang', label: 'Yangang', pincode: '790016' },
  { value: 'arunachal', label: 'Arunachal', pincode: '790017' },
  { value: 'beyul', label: 'Beyul', pincode: '790018' },
  { value: 'chumik', label: 'Chumik', pincode: '790019' },
  { value: 'danyang', label: 'Danyang', pincode: '790020' },
  { value: 'erigum', label: 'Erigum', pincode: '790021' },
  { value: 'foyung', label: 'Foyung', pincode: '790022' },
  { value: 'garung', label: 'Garung', pincode: '790023' },
  { value: 'himni', label: 'Himni', pincode: '790024' },
  { value: 'jang', label: 'Jang', pincode: '790025' },
  { value: 'kambang', label: 'Kambang', pincode: '790026' },
  { value: 'lati', label: 'Lati', pincode: '790027' },
  { value: 'meko', label: 'Meko', pincode: '790028' },
  { value: 'ngoru', label: 'Ngoru', pincode: '790029' }
  ],
  
  'tezu': [
  { value: 'adipasi', label: 'Adipasi', pincode: '792124' },
  { value: 'balijan', label: 'Balijan', pincode: '791101' },
  { value: 'bihpuria', label: 'Bihpuria', pincode: '784160' },
  { value: 'banyak', label: 'Banyak', pincode: '792125' },
  { value: 'changlang', label: 'Changlang', pincode: '792120' },
  { value: 'dambuk', label: 'Dambuk', pincode: '792103' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gochi', label: 'Gochi', pincode: '791120' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'itafort', label: 'Itafot', pincode: '791002' },
  { value: 'kengkhi', label: 'Kengkhi', pincode: '791136' },
  { value: 'kharsang', label: 'Kharsang', pincode: '792121' },
  { value: 'kunu', label: 'Kunu', pincode: '791105' },
  { value: 'lekhapani', label: 'Lekhapani', pincode: '792103' },
  { value: 'lazu', label: 'Lazu', pincode: '791118' },
  { value: 'longding', label: 'Longding', pincode: '792130' },
  { value: 'manmao', label: 'Manmao', pincode: '792110' },
  { value: 'namchik', label: 'Namchik', pincode: '792126' },
  { value: 'namsai', label: 'Namsai', pincode: '792103' },
  { value: 'ngemu', label: 'Ngemu', pincode: '792119' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'sunpura', label: 'Sunpura', pincode: '792103' },
  { value: 'tezu', label: 'Tezu', pincode: '792001' },
  { value: 'tirap', label: 'Tirap', pincode: '792151' },
  { value: 'yazali', label: 'Yazali', pincode: '791146' },
  { value: 'aalo', label: 'Aalo', pincode: '791001' },
  { value: 'bomdila', label: 'Bomdila', pincode: '790001' },
  { value: 'west-siang', label: 'West Siang', pincode: '791115' },
  { value: 'pasighat', label: 'Pasighat', pincode: '791102' },
  { value: 'tawang', label: 'Tawang', pincode: '790104' },
  { value: 'banquet', label: 'Banquet', pincode: '790003' },
  { value: 'naya-bazar', label: 'Naya Bazar', pincode: '791104' },
  { value: 'pashighat', label: 'Pashighat', pincode: '791103' },
  { value: 'panisala', label: 'Panisala', pincode: '790002' }
  ],

  'thingbu': [
  { value: 'adirang', label: 'Adirang', pincode: '791111' },
  { value: 'alonk', label: 'Alonk', pincode: '790001' },
  { value: 'bakha', label: 'Bakha', pincode: '791105' },
  { value: 'bumla', label: 'Bumla', pincode: '790109' },
  { value: 'changla', label: 'Changla', pincode: '790102' },
  { value: 'garo', label: 'Garo', pincode: '791107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gochi', label: 'Gochi', pincode: '791120' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'itafort', label: 'Itafot', pincode: '791002' },
  { value: 'kunu', label: 'Kunu', pincode: '791105' },
  { value: 'longking', label: 'Longking', pincode: '791112' },
  { value: 'manmow', label: 'Manmow', pincode: '791110' },
  { value: 'namchik', label: 'Namchik', pincode: '792126' },
  { value: 'pangsau', label: 'Pangsau', pincode: '792121' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'sango', label: 'Sango', pincode: '791114' },
  { value: 'thingbu', label: 'Thingbu', pincode: '790113' },
  { value: 'tiru', label: 'Tiru', pincode: '791116' },
  { value: 'yangri', label: 'Yangri', pincode: '791103' },
  { value: 'nyapin', label: 'Nyapin', pincode: '791120' },
  { value: 'buri-dihing', label: 'Buri Dihing', pincode: '792135' },
  { value: 'da-dhing', label: 'Da Dhing', pincode: '791118' },
  { value: 'kumey', label: 'Kumey', pincode: '791103' },
  { value: 'seppa', label: 'Seppa', pincode: '790103' },
  { value: 'yembung', label: 'Yembung', pincode: '791119' }
  ],

  'vijoynagar': [
  { value: 'adharnagar', label: 'Adharnagar', pincode: '791001' },
  { value: 'alubari', label: 'Alubari', pincode: '791010' },
  { value: 'bongkham', label: 'Bongkham', pincode: '791009' },
  { value: 'changlang', label: 'Changlang', pincode: '792120' },
  { value: 'dalong', label: 'Dalong', pincode: '792125' },
  { value: 'dibrugarh', label: 'Dibrugarh', pincode: '786001' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gochi', label: 'Gochi', pincode: '791120' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'itafort', label: 'Itafot', pincode: '791002' },
  { value: 'kengkhi', label: 'Kengkhi', pincode: '791136' },
  { value: 'kunu', label: 'Kunu', pincode: '791105' },
  { value: 'longking', label: 'Longking', pincode: '791112' },
  { value: 'manmao', label: 'Manmao', pincode: '792110' },
  { value: 'namchik', label: 'Namchik', pincode: '792126' },
  { value: 'nyapin', label: 'Nyapin', pincode: '791120' },
  { value: 'pangsau', label: 'Pangsau', pincode: '792121' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'sango', label: 'Sango', pincode: '791114' },
  { value: 'thingbu', label: 'Thingbu', pincode: '790113' },
  { value: 'tiru', label: 'Tiru', pincode: '791116' },
  { value: 'vijoynagar', label: 'Vijoynagar', pincode: '792140' },
  { value: 'yangri', label: 'Yangri', pincode: '791103' },
  { value: 'kumey', label: 'Kumey', pincode: '791103' },
  { value: 'seppa', label: 'Seppa', pincode: '790103' },
  { value: 'buri-dihing', label: 'Buri Dihing', pincode: '792135' },
  { value: 'lazo', label: 'Lazo', pincode: '791118' },
  { value: 'kibithu', label: 'Kibithu', pincode: '790124' },
  { value: 'changmu', label: 'Changmu', pincode: '790106' },
  { value: 'jengging', label: 'Jengging', pincode: '790109' },
  { value: 'pingin', label: 'Pingin', pincode: '791116' },
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '790102' },
  { value: 'sime', label: 'Sime', pincode: '791137' },
  { value: 'tawang', label: 'Tawang', pincode: '790104' },
  { value: 'yazali', label: 'Yazali', pincode: '791146' }
  ],
  
  'wakro': [
  { value: 'adharnagar', label: 'Adharnagar', pincode: '791001' },
  { value: 'alubari', label: 'Alubari', pincode: '791010' },
  { value: 'bongkham', label: 'Bongkham', pincode: '791009' },
  { value: 'changlang', label: 'Changlang', pincode: '792120' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gochi', label: 'Gochi', pincode: '791120' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'itafort', label: 'Itafot', pincode: '791002' },
  { value: 'kengkhi', label: 'Kengkhi', pincode: '791136' },
  { value: 'kunu', label: 'Kunu', pincode: '791105' },
  { value: 'longking', label: 'Longking', pincode: '791112' },
  { value: 'manmao', label: 'Manmao', pincode: '792110' },
  { value: 'namchik', label: 'Namchik', pincode: '792126' },
  { value: 'nyapin', label: 'Nyapin', pincode: '791120' },
  { value: 'pangsau', label: 'Pangsau', pincode: '792121' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'sango', label: 'Sango', pincode: '791114' },
  { value: 'thingbu', label: 'Thingbu', pincode: '790113' },
  { value: 'tiru', label: 'Tiru', pincode: '791116' },
  { value: 'wakro', label: 'Wakro', pincode: '791120' },
  { value: 'yangri', label: 'Yangri', pincode: '791103' },
  { value: 'kumey', label: 'Kumey', pincode: '791103' },
  { value: 'seppa', label: 'Seppa', pincode: '790103' },
  { value: 'buri-dihing', label: 'Buri Dihing', pincode: '792135' },
  { value: 'lazo', label: 'Lazo', pincode: '791118' },
  { value: 'kibithu', label: 'Kibithu', pincode: '790124' },
  { value: 'changmu', label: 'Changmu', pincode: '790106' },
  { value: 'jengging', label: 'Jengging', pincode: '790109' },
  { value: 'pingin', label: 'Pingin', pincode: '791116' },
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '790102' },
  { value: 'sime', label: 'Sime', pincode: '791137' },
  { value: 'tawang', label: 'Tawang', pincode: '790104' },
  { value: 'yazali', label: 'Yazali', pincode: '791146' },
  { value: 'tezu', label: 'Tezu', pincode: '792001' },
  { value: 'laichang', label: 'Laichang', pincode: '791120' },
  { value: 'bihpuria', label: 'Bihpuria', pincode: '786126' },
  { value: 'makum', label: 'Makum', pincode: '786170' },
  { value: 'maibong', label: 'Maibong', pincode: '788711' },
  { value: 'tangsa', label: 'Tangsa', pincode: '792133' },
  { value: 'kherem', label: 'Kherem', pincode: '791141' },
  { value: 'miao', label: 'Miao', pincode: '792115' },
  { value: 'kangkong', label: 'Kangkong', pincode: '792115' }
  ],
  
  'yupia': [
  { value: 'adharnagar', label: 'Adharnagar', pincode: '791001' },
  { value: 'alubari', label: 'Alubari', pincode: '791010' },
  { value: 'bongkham', label: 'Bongkham', pincode: '791009' },
  { value: 'changlang', label: 'Changlang', pincode: '792120' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gochi', label: 'Gochi', pincode: '791120' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'itafort', label: 'Itafot', pincode: '791002' },
  { value: 'kengkhi', label: 'Kengkhi', pincode: '791136' },
  { value: 'kunu', label: 'Kunu', pincode: '791105' },
  { value: 'longking', label: 'Longking', pincode: '791112' },
  { value: 'manmao', label: 'Manmao', pincode: '792110' },
  { value: 'namchik', label: 'Namchik', pincode: '792126' },
  { value: 'nyapin', label: 'Nyapin', pincode: '791120' },
  { value: 'pangsau', label: 'Pangsau', pincode: '792121' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'sango', label: 'Sango', pincode: '791114' },
  { value: 'thingbu', label: 'Thingbu', pincode: '790113' },
  { value: 'tiru', label: 'Tiru', pincode: '791116' },
  { value: 'wakro', label: 'Wakro', pincode: '791120' },
  { value: 'yangri', label: 'Yangri', pincode: '791103' },
  { value: 'yupia', label: 'Yupia', pincode: '791112' },
  { value: 'kumey', label: 'Kumey', pincode: '791103' },
  { value: 'seppa', label: 'Seppa', pincode: '790103' },
  { value: 'buri-dihing', label: 'Buri Dihing', pincode: '792135' },
  { value: 'lazo', label: 'Lazo', pincode: '791118' },
  { value: 'kibithu', label: 'Kibithu', pincode: '790124' },
  { value: 'changmu', label: 'Changmu', pincode: '790106' },
  { value: 'jengging', label: 'Jengging', pincode: '790109' },
  { value: 'pingin', label: 'Pingin', pincode: '791116' },
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '790102' },
  { value: 'sime', label: 'Sime', pincode: '791137' },
  { value: 'tawang', label: 'Tawang', pincode: '790104' },
  { value: 'yazali', label: 'Yazali', pincode: '791146' },
  { value: 'balijan', label: 'Balijan', pincode: '791123' },
  { value: 'bamin-mungkum', label: 'Bamin Mungkum', pincode: '791120' },
  { value: 'deed', label: 'Deed', pincode: '791137' },
  { value: 'deomali', label: 'Deomali', pincode: '792010' },
  { value: 'jari', label: 'Jari', pincode: '790106' },
  { value: 'nirjuli', label: 'Nirjuli', pincode: '791109' },
  { value: 'silsango', label: 'Silsango', pincode: '791105' },
  { value: 'sonitpur', label: 'Sonitpur', pincode: '792140' },
  { value: 'tali', label: 'Tali', pincode: '791111' },
  { value: 'taloh', label: 'Taloh', pincode: '791101' },
  { value: 'tezu', label: 'Tezu', pincode: '792001' }
  ],
  
  'yingkiong': [
  { value: 'adharnagar', label: 'Adharnagar', pincode: '791001' },
  { value: 'alubari', label: 'Alubari', pincode: '791010' },
  { value: 'bongkham', label: 'Bongkham', pincode: '791009' },
  { value: 'changlang', label: 'Changlang', pincode: '792120' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gochi', label: 'Gochi', pincode: '791120' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'itafort', label: 'Itafot', pincode: '791002' },
  { value: 'kengkhi', label: 'Kengkhi', pincode: '791136' },
  { value: 'kunu', label: 'Kunu', pincode: '791105' },
  { value: 'longking', label: 'Longking', pincode: '791112' },
  { value: 'manmao', label: 'Manmao', pincode: '792110' },
  { value: 'namchik', label: 'Namchik', pincode: '792126' },
  { value: 'nyapin', label: 'Nyapin', pincode: '791120' },
  { value: 'pangsau', label: 'Pangsau', pincode: '792121' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'sango', label: 'Sango', pincode: '791114' },
  { value: 'thingbu', label: 'Thingbu', pincode: '790113' },
  { value: 'tiru', label: 'Tiru', pincode: '791116' },
  { value: 'wakro', label: 'Wakro', pincode: '791120' },
  { value: 'yangri', label: 'Yangri', pincode: '791103' },
  { value: 'yupia', label: 'Yupia', pincode: '791112' },
  { value: 'kumey', label: 'Kumey', pincode: '791103' },
  { value: 'seppa', label: 'Seppa', pincode: '790103' },
  { value: 'buri-dihing', label: 'Buri Dihing', pincode: '792135' },
  { value: 'lazo', label: 'Lazo', pincode: '791118' },
  { value: 'kibithu', label: 'Kibithu', pincode: '790124' },
  { value: 'changmu', label: 'Changmu', pincode: '790106' },
  { value: 'jengging', label: 'Jengging', pincode: '790109' },
  { value: 'pingin', label: 'Pingin', pincode: '791116' },
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '790102' },
  { value: 'sime', label: 'Sime', pincode: '791137' },
  { value: 'tawang', label: 'Tawang', pincode: '790104' },
  { value: 'yazali', label: 'Yazali', pincode: '791146' },
  { value: 'yingkiong', label: 'Yingkiong', pincode: '791001' },
  { value: 'jari', label: 'Jari', pincode: '790106' },
  { value: 'deomali', label: 'Deomali', pincode: '792010' },
  { value: 'sonitpur', label: 'Sonitpur', pincode: '792140' },
  { value: 'balijan', label: 'Balijan', pincode: '791123' }
  ],
  
  'ziro': [
  { value: 'adharnagar', label: 'Adharnagar', pincode: '791001' },
  { value: 'alubari', label: 'Alubari', pincode: '791010' },
  { value: 'bongkham', label: 'Bongkham', pincode: '791009' },
  { value: 'changlang', label: 'Changlang', pincode: '792120' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gochi', label: 'Gochi', pincode: '791120' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'itafort', label: 'Itafot', pincode: '791002' },
  { value: 'kengkhi', label: 'Kengkhi', pincode: '791136' },
  { value: 'kunu', label: 'Kunu', pincode: '791105' },
  { value: 'longking', label: 'Longking', pincode: '791112' },
  { value: 'manmao', label: 'Manmao', pincode: '792110' },
  { value: 'namchik', label: 'Namchik', pincode: '792126' },
  { value: 'nyapin', label: 'Nyapin', pincode: '791120' },
  { value: 'pangsau', label: 'Pangsau', pincode: '792121' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'sango', label: 'Sango', pincode: '791114' },
  { value: 'thingbu', label: 'Thingbu', pincode: '790113' },
  { value: 'tiru', label: 'Tiru', pincode: '791116' },
  { value: 'wakro', label: 'Wakro', pincode: '791120' },
  { value: 'yangri', label: 'Yangri', pincode: '791103' },
  { value: 'yupia', label: 'Yupia', pincode: '791112' },
  { value: 'ziro', label: 'Ziro', pincode: '791120' },
  { value: 'kumey', label: 'Kumey', pincode: '791103' },
  { value: 'seppa', label: 'Seppa', pincode: '790103' },
  { value: 'buri-dihing', label: 'Buri Dihing', pincode: '792135' },
  { value: 'lazo', label: 'Lazo', pincode: '791118' },
  { value: 'kibithu', label: 'Kibithu', pincode: '790124' },
  { value: 'changmu', label: 'Changmu', pincode: '790106' },
  { value: 'jengging', label: 'Jengging', pincode: '790109' },
  { value: 'pingin', label: 'Pingin', pincode: '791116' },
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '790102' },
  { value: 'sime', label: 'Sime', pincode: '791137' },
  { value: 'tawang', label: 'Tawang', pincode: '790104' },
  { value: 'yazali', label: 'Yazali', pincode: '791146' },
  { value: 'bilat', label: 'Bilat', pincode: '791122' },
  { value: 'daporijo', label: 'Daporijo', pincode: '791131' },
  { value: 'daporijo-town', label: 'Daporijo Town', pincode: '791131' },
  { value: 'mayodi', label: 'Mayodi', pincode: '790116' },
  { value: 'parang', label: 'Parang', pincode: '791120' },
  { value: 'pangin', label: 'Pangin', pincode: '791108' },
  { value: 'sunai', label: 'Sunai', pincode: '792135' },
  { value: 'zidang', label: 'Zidang', pincode: '791122' }
  ],
  
  'zemithang': [
  { value: 'adharnagar', label: 'Adharnagar', pincode: '791001' },
  { value: 'alubari', label: 'Alubari', pincode: '791010' },
  { value: 'bongkham', label: 'Bongkham', pincode: '791009' },
  { value: 'changlang', label: 'Changlang', pincode: '792120' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gochi', label: 'Gochi', pincode: '791120' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'itafort', label: 'Itafot', pincode: '791002' },
  { value: 'kengkhi', label: 'Kengkhi', pincode: '791136' },
  { value: 'kunu', label: 'Kunu', pincode: '791105' },
  { value: 'longking', label: 'Longking', pincode: '791112' },
  { value: 'manmao', label: 'Manmao', pincode: '792110' },
  { value: 'namchik', label: 'Namchik', pincode: '792126' },
  { value: 'nyapin', label: 'Nyapin', pincode: '791120' },
  { value: 'pangsau', label: 'Pangsau', pincode: '792121' },
  { value: 'roing', label: 'Roing', pincode: '792110' },
  { value: 'sango', label: 'Sango', pincode: '791114' },
  { value: 'thingbu', label: 'Thingbu', pincode: '790113' },
  { value: 'tiru', label: 'Tiru', pincode: '791116' },
  { value: 'wakro', label: 'Wakro', pincode: '791120' },
  { value: 'yangri', label: 'Yangri', pincode: '791103' },
  { value: 'yupia', label: 'Yupia', pincode: '791112' },
  { value: 'ziro', label: 'Ziro', pincode: '791120' },
  { value: 'kumey', label: 'Kumey', pincode: '791103' },
  { value: 'seppa', label: 'Seppa', pincode: '790103' },
  { value: 'buri-dihing', label: 'Buri Dihing', pincode: '792135' },
  { value: 'lazo', label: 'Lazo', pincode: '791118' },
  { value: 'kibithu', label: 'Kibithu', pincode: '790124' },
  { value: 'changmu', label: 'Changmu', pincode: '790106' },
  { value: 'jengging', label: 'Jengging', pincode: '790109' },
  { value: 'pingin', label: 'Pingin', pincode: '791116' },
  { value: 'chayangtajo', label: 'Chayangtajo', pincode: '790102' },
  { value: 'sime', label: 'Sime', pincode: '791137' },
  { value: 'tawang', label: 'Tawang', pincode: '790104' },
  { value: 'yazali', label: 'Yazali', pincode: '791146' },
  { value: 'zemithang', label: 'Zemithang', pincode: '790119' },
  { value: 'paeng', label: 'Paeng', pincode: '792127' },
  { value: 'phurpa', label: 'Phurpa', pincode: '790107' },
  { value: 'tali', label: 'Tali', pincode: '790114' },
  { value: 'arunachal-vihar', label: 'Arunachal Vihar', pincode: '790103' },
  { value: 'badan', label: 'Badan', pincode: '790122' },
  { value: 'burum', label: 'Burum', pincode: '791123' },
  { value: 'dagam', label: 'Dagam', pincode: '790110' },
  { value: 'lepsing', label: 'Lepsing', pincode: '790104' }
  ],

  //Himachal pradesh
  'indora': [
  { value: 'bhangani', label: 'Bhangani', pincode: '176125' },
  { value: 'chhatri', label: 'Chhatri', pincode: '176132' },
  { value: 'dharmshala', label: 'Dharmshala', pincode: '176215' },
  { value: 'duna', label: 'Duna', pincode: '176206' },
  { value: 'joginder-nagar', label: 'Joginder Nagar', pincode: '175015' },
  { value: 'kullu', label: 'Kullu', pincode: '175101' },
  { value: 'kumarhatti', label: 'Kumarhatti', pincode: '173207' },
  { value: 'mohal', label: 'Mohal', pincode: '176102' },
  { value: 'nadi', label: 'Nadi', pincode: '176022' },
  { value: 'padhar', label: 'Padhar', pincode: '176224' },
  { value: 'rahatgarh', label: 'Rahatgarh', pincode: '176051' },
  { value: 'sadar', label: 'Sadar', pincode: '176024' },
  { value: 'sidhbari', label: 'Sidhbari', pincode: '176057' },
  { value: 'tibba', label: 'Tibba', pincode: '176130' },
  { value: 'tolai', label: 'Tolai', pincode: '176206' },
  { value: 'warbala', label: 'Warbala', pincode: '176123' }
  ],

  'arki': [
  { "value": "arki", "label": "Arki", "pincode": "171220" },
  { "value": "bahadurpur", "label": "Bahadurpur", "pincode": "171220" },
  { "value": "barog", "label": "Barog", "pincode": "173211" },
  { "value": "banauri", "label": "Banauri", "pincode": "171220" },
  { "value": "dadu", "label": "Dadu", "pincode": "171220" },
  { "value": "jodhan", "label": "Jodhan", "pincode": "171220" },
  { "value": "kandoli", "label": "Kandoli", "pincode": "171220" },
  { "value": "kothon", "label": "Kothon", "pincode": "171220" },
  { "value": "ramshahar", "label": "Ramshahar", "pincode": "171220" },
  { "value": "sarkari", "label": "Sarkari", "pincode": "171220" },
  { "value": "sarol", "label": "Sarol", "pincode": "171220" },
  { "value": "sundernagar", "label": "Sundernagar", "pincode": "171215" },
  { "value": "bari", "label": "Bari", "pincode": "171222" },
  { "value": "basal", "label": "Basal", "pincode": "171220" },
  { "value": "chail", "label": "Chail", "pincode": "173217" },
  { "value": "dhanari", "label": "Dhanari", "pincode": "171220" },
  { "value": "kanholi", "label": "Kanholi", "pincode": "171220" },
  { "value": "manoh", "label": "Manoh", "pincode": "171220" },
  { "value": "palampur", "label": "Palampur", "pincode": "176061" },
  { "value": "rakkar", "label": "Rakkar", "pincode": "171220" },
  { "value": "solan", "label": "Solan", "pincode": "173212" },
  { "value": "theog", "label": "Theog", "pincode": "171201" },
  { "value": "shilan", "label": "Shilan", "pincode": "171220" },
  { "value": "chandi", "label": "Chandi", "pincode": "171206" },
  { "value": "nauradhar", "label": "Nauradhar", "pincode": "173226" }
  ],
  
  'baddi': [
  { "value": "baddi", "label": "Baddi", "pincode": "173205" },
  { "value": "barotiwala", "label": "Barotiwala", "pincode": "173211" },
  { "value": "bari", "label": "Bari", "pincode": "173205" },
  { "value": "bhud", "label": "Bhud", "pincode": "173205" },
  { "value": "bheronwala", "label": "Bheronwala", "pincode": "173205" },
  { "value": "chalwara", "label": "Chalwara", "pincode": "173205" },
  { "value": "dakhla", "label": "Dakhla", "pincode": "173205" },
  { "value": "garh", "label": "Garh", "pincode": "173205" },
  { "value": "kali-ka-mandir", "label": "Kali Ka Mandir", "pincode": "173205" },
  { "value": "kandrori", "label": "Kandrori", "pincode": "173205" },
  { "value": "nalagarh", "label": "Nalagarh", "pincode": "174101" },
  { "value": "new-baddi", "label": "New Baddi", "pincode": "173205" },
  { "value": "panjheri", "label": "Panjheri", "pincode": "173205" },
  { "value": "rangra", "label": "Rangra", "pincode": "173205" },
  { "value": "sabathu", "label": "Sabathu", "pincode": "173206" },
  { "value": "sindhi", "label": "Sindhi", "pincode": "173205" },
  { "value": "tirath", "label": "Tirath", "pincode": "173205" },
  { "value": "tattapani", "label": "Tattapani", "pincode": "173205" },
  { "value": "ambedkar-chowk", "label": "Ambedkar Chowk", "pincode": "173205" },
  { "value": "baddi-industrial-area", "label": "Baddi Industrial Area", "pincode": "173205" },
  { "value": "bhakra", "label": "Bhakra", "pincode": "174101" },
  { "value": "fatehpur", "label": "Fatehpur", "pincode": "173205" },
  { "value": "gagal", "label": "Gagal", "pincode": "173205" },
  { "value": "kalka", "label": "Kalka", "pincode": "134203" },
  { "value": "kharak", "label": "Kharak", "pincode": "173205" },
  { "value": "manpur", "label": "Manpur", "pincode": "173205" },
  { "value": "mehli", "label": "Mehli", "pincode": "173205" },
  { "value": "mandi", "label": "Mandi", "pincode": "174001" },
  { "value": "patta", "label": "Patta", "pincode": "173205" },
  { "value": "sarahan", "label": "Sarahan", "pincode": "173205" },
  { "value": "shahpur", "label": "Shahpur", "pincode": "173205" }
  ],
  
  'banjar': [
  { "value": "banjar", "label": "Banjar", "pincode": "175123" },
  { "value": "baghi", "label": "Baghi", "pincode": "175123" },
  { "value": "bahu", "label": "Bahu", "pincode": "175123" },
  { "value": "balh", "label": "Balh", "pincode": "175123" },
  { "value": "bhawani", "label": "Bhawani", "pincode": "175123" },
  { "value": "bhurat", "label": "Bhurat", "pincode": "175123" },
  { "value": "chouki", "label": "Chouki", "pincode": "175123" },
  { "value": "deori", "label": "Deori", "pincode": "175123" },
  { "value": "ghar", "label": "Ghar", "pincode": "175123" },
  { "value": "ghiyagi", "label": "Ghiyagi", "pincode": "175123" },
  { "value": "jhalori", "label": "Jhalori", "pincode": "175123" },
  { "value": "kadiyali", "label": "Kadiyali", "pincode": "175123" },
  { "value": "kandha", "label": "Kandha", "pincode": "175123" },
  { "value": "karsog", "label": "Karsog", "pincode": "175110" },
  { "value": "khem", "label": "Khem", "pincode": "175123" },
  { "value": "kohta", "label": "Kohta", "pincode": "175123" },
  { "value": "mashwara", "label": "Mashwara", "pincode": "175123" },
  { "value": "nagal", "label": "Nagal", "pincode": "175123" },
  { "value": "narli", "label": "Narli", "pincode": "175123" },
  { "value": "nuhal", "label": "Nuhal", "pincode": "175123" },
  { "value": "pada", "label": "Pada", "pincode": "175123" },
  { "value": "sundla", "label": "Sundla", "pincode": "175123" },
  { "value": "thadwa", "label": "Thadwa", "pincode": "175123" },
  { "value": "chhatrari", "label": "Chhatrari", "pincode": "175123" },
  { "value": "daran", "label": "Daran", "pincode": "175123" },
  { "value": "kamand", "label": "Kamand", "pincode": "175123" },
  { "value": "karanwala", "label": "Karanwala", "pincode": "175123" },
  { "value": "kothi", "label": "Kothi", "pincode": "175123" },
  { "value": "mashhri", "label": "Mashhri", "pincode": "175123" },
  { "value": "nadhar", "label": "Nadhar", "pincode": "175123" },
  { "value": "pundri", "label": "Pundri", "pincode": "175123" },
  { "value": "rato", "label": "Rato", "pincode": "175123" },
  { "value": "shilaroo", "label": "Shilaroo", "pincode": "175123" },
  { "value": "shugha", "label": "Shugha", "pincode": "175123" }
  ],
  
  'bhuntar': [
  { value: 'adithan', label: 'Adithan', pincode: '175125' },
  { value: 'bashist', label: 'Bashist', pincode: '175104' },
  { value: 'bhuntar', label: 'Bhuntar', pincode: '175125' },
  { value: 'chanderkhani', label: 'Chanderkhani', pincode: '175101' },
  { value: 'dhamoon', label: 'Dhamoon', pincode: '175106' },
  { value: 'jara', label: 'Jara', pincode: '175125' },
  { value: 'kullu', label: 'Kullu', pincode: '175101' },
  { value: 'manali', label: 'Manali', pincode: '175131' },
  { value: 'naggar', label: 'Naggar', pincode: '175130' },
  { value: 'sarchu', label: 'Sarchu', pincode: '175105' },
  { value: 'rauli', label: 'Rauli', pincode: '175110' },
  { value: 'salwar', label: 'Salwar', pincode: '175112' },
  { value: 'kalath', label: 'Kalath', pincode: '175103' },
  { value: 'balehi', label: 'Balehi', pincode: '175121' },
  { value: 'haripur', label: 'Haripur', pincode: '175121' },
  { value: 'kothi', label: 'Kothi', pincode: '175122' },
  { value: 'pardi', label: 'Pardi', pincode: '175126' },
  { value: 'seraj', label: 'Seraj', pincode: '175130' },
  { value: 'ranoh', label: 'Ranoh', pincode: '175114' },
  { value: 'thachi', label: 'Thachi', pincode: '175120' }
  ],
  
  'bilaspur.': [
  { value: 'alampur', label: 'Alampur', pincode: '174001' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '174001' },
  { value: 'bohal', label: 'Bohal', pincode: '174032' },
  { value: 'chandpur', label: 'Chandpur', pincode: '174032' },
  { value: 'dalash', label: 'Dalash', pincode: '174024' },
  { value: 'darlaghat', label: 'Darlaghat', pincode: '174101' },
  { value: 'hatwar', label: 'Hatwar', pincode: '174004' },
  { value: 'jhandutta', label: 'Jhandutta', pincode: '174201' },
  { value: 'kalwari', label: 'Kalwari', pincode: '174034' },
  { value: 'kailash', label: 'Kailash', pincode: '174101' },
  { value: 'kherdi', label: 'Kherdi', pincode: '174001' },
  { value: 'koti', label: 'Koti', pincode: '174102' },
  { value: 'mandi', label: 'Mandi', pincode: '174105' },
  { value: 'naina', label: 'Naina', pincode: '174103' },
  { value: 'raipur', label: 'Raipur', pincode: '174201' },
  { value: 'sari', label: 'Sari', pincode: '174106' },
  { value: 'sundernagar', label: 'Sundernagar', pincode: '174401' },
  { value: 'tenduwal', label: 'Tenduwal', pincode: '174203' },
  { value: 'thana', label: 'Thana', pincode: '174201' },
  { value: 'tihan', label: 'Tihan', pincode: '174202' },
  { value: 'tutti', label: 'Tutti', pincode: '174212' },
  { value: 'bassi', label: 'Bassi', pincode: '174002' },
  { value: 'bhater', label: 'Bhater', pincode: '174011' },
  { value: 'khong', label: 'Khong', pincode: '174007' }
  ],
  
  'chamba': [
  { value: 'bhalai', label: 'Bhalai', pincode: '176314' },
  { value: 'chamba', label: 'Chamba', pincode: '176310' },
  { value: 'dalhousie', label: 'Dalhousie', pincode: '176304' },
  { value: 'dunali', label: 'Dunali', pincode: '176312' },
  { value: 'khajjiar', label: 'Khajjiar', pincode: '176314' },
  { value: 'khaniyara', label: 'Khaniyara', pincode: '176315' },
  { value: 'luhri', label: 'Luhri', pincode: '176317' },
  { value: 'paroh', label: 'Paroh', pincode: '176323' },
  { value: 'rajasthan', label: 'Rajasthan', pincode: '176320' },
  { value: 'salooni', label: 'Salooni', pincode: '176314' },
  { value: 'swarghat', label: 'Swarghat', pincode: '176206' },
  { value: 'tissa', label: 'Tissa', pincode: '176322' },
  { value: 'warighat', label: 'Warighat', pincode: '176301' },
  { value: 'banikhet', label: 'Banikhet', pincode: '176303' },
  { value: 'bhuri', label: 'Bhuri', pincode: '176315' },
  { value: 'chandigarh', label: 'Chandigarh', pincode: '176315' },
  { value: 'dachhan', label: 'Dachhan', pincode: '176206' },
  { value: 'dara', label: 'Dara', pincode: '176305' },
  { value: 'jot', label: 'Jot', pincode: '176304' },
  { value: 'kharah', label: 'Kharah', pincode: '176311' },
  { value: 'lailar', label: 'Lailar', pincode: '176320' },
  { value: 'pangi', label: 'Pangi', pincode: '176323' },
  { value: 'rajal', label: 'Rajal', pincode: '176319' },
  { value: 'sanoh', label: 'Sanoh', pincode: '176311' },
  { value: 'thalka', label: 'Thalka', pincode: '176316' }
  ],
  
  'chopal': [
  { value: 'baghi', label: 'Baghi', pincode: '171212' },
  { value: 'chopal', label: 'Chopal', pincode: '171213' },
  { value: 'chouri', label: 'Chouri', pincode: '171211' },
  { value: 'dhabana', label: 'Dhabana', pincode: '171221' },
  { value: 'jatol', label: 'Jatol', pincode: '171221' },
  { value: 'kandi', label: 'Kandi', pincode: '171214' },
  { value: 'kauri', label: 'Kauri', pincode: '171216' },
  { value: 'kuthar', label: 'Kuthar', pincode: '171212' },
  { value: 'kwar', label: 'Kwar', pincode: '171221' },
  { value: 'nalta', label: 'Nalta', pincode: '171223' },
  { value: 'sindhu', label: 'Sindhu', pincode: '171212' },
  { value: 'sudhar', label: 'Sudhar', pincode: '171211' },
  { value: 'thakurwada', label: 'Thakurwada', pincode: '171213' },
  { value: 'thirot', label: 'Thirot', pincode: '171214' },
  { value: 'banoli', label: 'Banoli', pincode: '171221' },
  { value: 'bhud', label: 'Bhud', pincode: '171222' },
  { value: 'chhaila', label: 'Chhaila', pincode: '171211' },
  { value: 'dadi', label: 'Dadi', pincode: '171224' },
  { value: 'gohar', label: 'Gohar', pincode: '171221' },
  { value: 'kherchula', label: 'Kherchula', pincode: '171222' },
  { value: 'mohri', label: 'Mohri', pincode: '171212' },
  { value: 'nainadhar', label: 'Nainadhar', pincode: '171212' },
  { value: 'patta', label: 'Patta', pincode: '171211' },
  { value: 'sundli', label: 'Sundli', pincode: '171223' }
  ],
  
  'chuari-khas': [
  { value: 'bahra', label: 'Bahra', pincode: '176314' },
  { value: 'bari', label: 'Bari', pincode: '176314' },
  { value: 'chama', label: 'Chama', pincode: '176314' },
  { value: 'chuari', label: 'Chuari', pincode: '176314' },
  { value: 'gahrana', label: 'Gahrana', pincode: '176315' },
  { value: 'ghardholi', label: 'Ghardholi', pincode: '176314' },
  { value: 'katoli', label: 'Katoli', pincode: '176315' },
  { value: 'kothi', label: 'Kothi', pincode: '176314' },
  { value: 'lalwani', label: 'Lalwani', pincode: '176315' },
  { value: 'manjwar', label: 'Manjwar', pincode: '176314' },
  { value: 'nagroti', label: 'Nagroti', pincode: '176314' },
  { value: 'pali', label: 'Pali', pincode: '176315' },
  { value: 'poti', label: 'Poti', pincode: '176314' },
  { value: 'ranoli', label: 'Ranoli', pincode: '176314' },
  { value: 'sarwan', label: 'Sarwan', pincode: '176314' },
  { value: 'sundernagar', label: 'Sundernagar', pincode: '176202' },
  { value: 'wada', label: 'Wada', pincode: '176315' },
  { value: 'battal', label: 'Battal', pincode: '176315' },
  { value: 'banari', label: 'Banari', pincode: '176314' },
  { value: 'bhated', label: 'Bhated', pincode: '176314' },
  { value: 'bhuri', label: 'Bhuri', pincode: '176314' },
  { value: 'chhano', label: 'Chhano', pincode: '176315' },
  { value: 'dadupur', label: 'Dadupur', pincode: '176314' },
  { value: 'garli', label: 'Garli', pincode: '176314' },
  { value: 'jassur', label: 'Jassur', pincode: '176315' },
  { value: 'kahar', label: 'Kahar', pincode: '176314' },
  { value: 'kurari', label: 'Kurari', pincode: '176315' },
  { value: 'mohri', label: 'Mohri', pincode: '176314' },
  { value: 'nagal', label: 'Nagal', pincode: '176314' }
  ],
  
  'dagshai': [
  { value: 'baghi', label: 'Baghi', pincode: '173210' },
  { value: 'dagshai', label: 'Dagshai', pincode: '173210' },
  { value: 'dharampur', label: 'Dharampur', pincode: '173209' },
  { value: 'garkhal', label: 'Garkhal', pincode: '173210' },
  { value: 'kumarhatti', label: 'Kumarhatti', pincode: '173206' },
  { value: 'lower-kumarhatti', label: 'Lower Kumarhatti', pincode: '173206' },
  { value: 'mohri', label: 'Mohri', pincode: '173209' },
  { value: 'nahan', label: 'Nahan', pincode: '173001' },
  { value: 'raigarh', label: 'Raigarh', pincode: '173210' },
  { value: 'sainwala', label: 'Sainwala', pincode: '173208' },
  { value: 'solan', label: 'Solan', pincode: '173212' },
  { value: 'soni', label: 'Soni', pincode: '173210' },
  { value: 'tilloh', label: 'Tilloh', pincode: '173209' },
  { value: 'barog', label: 'Barog', pincode: '173211' },
  { value: 'bilkhet', label: 'Bilkhet', pincode: '173206' },
  { value: 'chakmoh', label: 'Chakmoh', pincode: '173213' },
  { value: 'gundoh', label: 'Gundoh', pincode: '173210' },
  { value: 'kushalgarh', label: 'Kushalgarh', pincode: '173212' },
  { value: 'lower-barog', label: 'Lower Barog', pincode: '173211' },
  { value: 'raipur', label: 'Raipur', pincode: '173210' },
  { value: 'salogra', label: 'Salogra', pincode: '173213' },
  { value: 'shogi', label: 'Shogi', pincode: '173217' },
  { value: 'shimla', label: 'Shimla', pincode: '171001' },
  { value: 'sundernagar', label: 'Sundernagar', pincode: '173202' }
  ],
  
  'dalhousie': [
  { value: 'balun', label: 'Balun', pincode: '176304' },
  { value: 'baroh', label: 'Baroh', pincode: '176304' },
  { value: 'chamba', label: 'Chamba', pincode: '176310' },
  { value: 'dalhousie', label: 'Dalhousie', pincode: '176304' },
  { value: 'dhoinda', label: 'Dhoinda', pincode: '176304' },
  { value: 'jandrighat', label: 'Jandrighat', pincode: '176303' },
  { value: 'kalatop', label: 'Kalatop', pincode: '176304' },
  { value: 'khajjiar', label: 'Khajjiar', pincode: '176304' },
  { value: 'koti', label: 'Koti', pincode: '176304' },
  { value: 'poli', label: 'Poli', pincode: '176304' },
  { value: 'ranghati', label: 'Ranghati', pincode: '176304' },
  { value: 'surangani', label: 'Surangani', pincode: '176310' },
  { value: 'thathri', label: 'Thathri', pincode: '176310' },
  { value: 'bhamour', label: 'Bhamour', pincode: '176305' },
  { value: 'bhuri', label: 'Bhuri', pincode: '176303' },
  { value: 'bagaspur', label: 'Bagaspur', pincode: '176305' },
  { value: 'dhermi', label: 'Dhermi', pincode: '176306' },
  { value: 'khori', label: 'Khori', pincode: '176305' },
  { value: 'mohri', label: 'Mohri', pincode: '176303' },
  { value: 'parat', label: 'Parat', pincode: '176305' },
  { value: 'rangmahal', label: 'Rangmahal', pincode: '176305' },
  { value: 'sundarbhati', label: 'Sundarbhati', pincode: '176305' },
  { value: 'thakurwada', label: 'Thakurwada', pincode: '176306' }
  ],
  
  'daulatpur': [
  { value: 'bhalon', label: 'Bhalon', pincode: '174103' },
  { value: 'daulatpur', label: 'Daulatpur', pincode: '174103' },
  { value: 'gullar', label: 'Gullar', pincode: '174103' },
  { value: 'kail', label: 'Kail', pincode: '174102' },
  { value: 'kandoli', label: 'Kandoli', pincode: '174103' },
  { value: 'karyal', label: 'Karyal', pincode: '174102' },
  { value: 'khera', label: 'Khera', pincode: '174102' },
  { value: 'koti', label: 'Koti', pincode: '174102' },
  { value: 'patta', label: 'Patta', pincode: '174103' },
  { value: 'rohran', label: 'Rohran', pincode: '174103' },
  { value: 'sidhpur', label: 'Sidhpur', pincode: '174103' },
  { value: 'suin', label: 'Suin', pincode: '174102' },
  { value: 'thakurdwara', label: 'Thakurdwara', pincode: '174103' },
  { value: 'wazirpur', label: 'Wazirpur', pincode: '174102' },
  { value: 'chakki', label: 'Chakki', pincode: '174103' },
  { value: 'dalgaon', label: 'Dalgaon', pincode: '174103' },
  { value: 'deoli', label: 'Deoli', pincode: '174103' },
  { value: 'kashmiri', label: 'Kashmiri', pincode: '174103' },
  { value: 'mangla', label: 'Mangla', pincode: '174102' },
  { value: 'manpur', label: 'Manpur', pincode: '174102' },
  { value: 'paniala', label: 'Paniala', pincode: '174103' },
  { value: 'sundar', label: 'Sundar', pincode: '174103' },
  { value: 'thakre', label: 'Thakre', pincode: '174103' }
  ],
  
  'dehra-gopipur': [
  { value: 'baghdhar', label: 'Baghdhar', pincode: '176055' },
  { value: 'balar', label: 'Balar', pincode: '176055' },
  { value: 'bhatera', label: 'Bhatera', pincode: '176056' },
  { value: 'chambial', label: 'Chambial', pincode: '176055' },
  { value: 'chandpur', label: 'Chandpur', pincode: '176056' },
  { value: 'dehra', label: 'Dehra', pincode: '176055' },
  { value: 'gopipur', label: 'Gopipur', pincode: '176055' },
  { value: 'jamhla', label: 'Jamhla', pincode: '176056' },
  { value: 'khukhrain', label: 'Khukhrain', pincode: '176055' },
  { value: 'ladhora', label: 'Ladhora', pincode: '176055' },
  { value: 'mahor', label: 'Mahor', pincode: '176056' },
  { value: 'mand', label: 'Mand', pincode: '176055' },
  { value: 'naru', label: 'Naru', pincode: '176055' },
  { value: 'pachhad', label: 'Pachhad', pincode: '176055' },
  { value: 'patta', label: 'Patta', pincode: '176056' },
  { value: 'salwan', label: 'Salwan', pincode: '176055' },
  { value: 'sundar', label: 'Sundar', pincode: '176056' },
  { value: 'aalu', label: 'Aalu', pincode: '176055' },
  { value: 'bhuri', label: 'Bhuri', pincode: '176056' },
  { value: 'dari', label: 'Dari', pincode: '176055' },
  { value: 'kheda', label: 'Kheda', pincode: '176055' },
  { value: 'mohri', label: 'Mohri', pincode: '176055' },
  { value: 'sujanpur', label: 'Sujanpur', pincode: '176056' },
  { value: 'tehran', label: 'Tehran', pincode: '176055' },
  { value: 'veran', label: 'Veran', pincode: '176055' }
  ],
  
  'dharamshala': [
  { value: 'bhagsu', label: 'Bhagsu', pincode: '176219' },
  { value: 'darshini', label: 'Darshini', pincode: '176215' },
  { value: 'dharamshala', label: 'Dharamshala', pincode: '176215' },
  { value: 'gaggal', label: 'Gaggal', pincode: '176209' },
  { value: 'kachehri', label: 'Kachehri', pincode: '176215' },
  { value: 'kangra', label: 'Kangra', pincode: '176001' },
  { value: 'kareri', label: 'Kareri', pincode: '176218' },
  { value: 'kotwali', label: 'Kotwali', pincode: '176215' },
  { value: 'mcleodganj', label: 'McLeodganj', pincode: '176219' },
  { value: 'nagrota', label: 'Nagrota', pincode: '176202' },
  { value: 'palampur', label: 'Palampur', pincode: '176061' },
  { value: 'sidhpur', label: 'Sidhpur', pincode: '176057' },
  { value: 'tanda', label: 'Tanda', pincode: '176003' },
  { value: 'thathi', label: 'Thathi', pincode: '176202' },
  { value: 'bani', label: 'Bani', pincode: '176001' },
  { value: 'baggi', label: 'Baggi', pincode: '176215' },
  { value: 'basundhara', label: 'Basundhara', pincode: '176205' },
  { value: 'chambaghat', label: 'Chambaghat', pincode: '176222' },
  { value: 'dadu', label: 'Dadu', pincode: '176210' },
  { value: 'dalhousie', label: 'Dalhousie', pincode: '176304' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '176223' }
  ],
  
  'gagret': [
  { value: 'adampur', label: 'Adampur', pincode: '174201' },
  { value: 'balh', label: 'Balh', pincode: '174202' },
  { value: 'gagret', label: 'Gagret', pincode: '174201' },
  { value: 'garli', label: 'Garli', pincode: '174202' },
  { value: 'jathian', label: 'Jathian', pincode: '174202' },
  { value: 'kachhiyari', label: 'Kachhiyari', pincode: '174202' },
  { value: 'kandowal', label: 'Kandowal', pincode: '174201' },
  { value: 'khad', label: 'Khad', pincode: '174201' },
  { value: 'khatehra', label: 'Khatehra', pincode: '174202' },
  { value: 'koari', label: 'Koari', pincode: '174202' },
  { value: 'nangal', label: 'Nangal', pincode: '174201' },
  { value: 'saloh', label: 'Saloh', pincode: '174201' },
  { value: 'thathi', label: 'Thathi', pincode: '174202' },
  { value: 'tunnu', label: 'Tunnu', pincode: '174201' },
  { value: 'bagban', label: 'Bagban', pincode: '174201' },
  { value: 'dharwala', label: 'Dharwala', pincode: '174202' },
  { value: 'jandli', label: 'Jandli', pincode: '174201' },
  { value: 'kanjoli', label: 'Kanjoli', pincode: '174202' },
  { value: 'kathar', label: 'Kathar', pincode: '174202' },
  { value: 'khera', label: 'Khera', pincode: '174202' },
  { value: 'mohal', label: 'Mohal', pincode: '174201' },
  { value: 'patta', label: 'Patta', pincode: '174202' },
  { value: 'rasoli', label: 'Rasoli', pincode: '174201' },
  { value: 'rawat', label: 'Rawat', pincode: '174202' },
  { value: 'salu', label: 'Salu', pincode: '174201' }
  ],
  
  'ghumarwin': [
  { value: 'adampur', label: 'Adampur', pincode: '174022' },
  { value: 'balleh', label: 'Balleh', pincode: '174021' },
  { value: 'bana', label: 'Bana', pincode: '174022' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '174001' },
  { value: 'bhadra', label: 'Bhadra', pincode: '174022' },
  { value: 'chamli', label: 'Chamli', pincode: '174021' },
  { value: 'dholra', label: 'Dholra', pincode: '174021' },
  { value: 'ghumarwin', label: 'Ghumarwin', pincode: '174021' },
  { value: 'jhandutta', label: 'Jhandutta', pincode: '174027' },
  { value: 'kailash', label: 'Kailash', pincode: '174027' },
  { value: 'khaliar', label: 'Khaliar', pincode: '174022' },
  { value: 'kuthar', label: 'Kuthar', pincode: '174021' },
  { value: 'lashta', label: 'Lashta', pincode: '174021' },
  { value: 'lohardi', label: 'Lohardi', pincode: '174022' },
  { value: 'narwana', label: 'Narwana', pincode: '174021' },
  { value: 'serla', label: 'Serla', pincode: '174022' },
  { value: 'thakurdwara', label: 'Thakurdwara', pincode: '174021' },
  { value: 'dhanu', label: 'Dhanu', pincode: '174021' },
  { value: 'garh', label: 'Garh', pincode: '174022' },
  { value: 'kheri', label: 'Kheri', pincode: '174021' },
  { value: 'patta', label: 'Patta', pincode: '174022' },
  { value: 'nangal', label: 'Nangal', pincode: '174021' }
  ],
  
  'hamirpur.': [
  { value: 'balh', label: 'Balh', pincode: '177001' },
  { value: 'baroti', label: 'Baroti', pincode: '177006' },
  { value: 'chandpur', label: 'Chandpur', pincode: '177207' },
  { value: 'hamirpur', label: 'Hamirpur', pincode: '177001' },
  { value: 'jahu', label: 'Jahu', pincode: '177001' },
  { value: 'kuthar', label: 'Kuthar', pincode: '177002' },
  { value: 'lohri', label: 'Lohri', pincode: '177211' },
  { value: 'sujanpur', label: 'Sujanpur', pincode: '177001' },
  { value: 'tanda', label: 'Tanda', pincode: '177021' },
  { value: 'talai', label: 'Talai', pincode: '177024' },
  { value: 'tutt', label: 'Tutt', pincode: '177025' },
  { value: 'bari', label: 'Bari', pincode: '177006' },
  { value: 'nalti', label: 'Nalti', pincode: '177207' },
  { value: 'ranjhi', label: 'Ranjhi', pincode: '177207' },
  { value: 'rakh', label: 'Rakh', pincode: '177001' },
  { value: 'bhota', label: 'Bhota', pincode: '177023' },
  { value: 'bura', label: 'Bura', pincode: '177205' },
  { value: 'bari', label: 'Bari', pincode: '177204' },
  { value: 'bagh', label: 'Bagh', pincode: '177212' },
  { value: 'dharampur', label: 'Dharampur', pincode: '177203' },
  { value: 'kangoo', label: 'Kangoo', pincode: '177213' },
  { value: 'madhopur', label: 'Madhopur', pincode: '177204' },
  { value: 'nari', label: 'Nari', pincode: '177206' }
  ],
  
  'jawalamukhi': [
  { value: 'baner', label: 'Baner', pincode: '176031' },
  { value: 'bharmour', label: 'Bharmour', pincode: '176311' },
  { value: 'chakwan', label: 'Chakwan', pincode: '176031' },
  { value: 'jawalamukhi', label: 'Jawalamukhi', pincode: '176031' },
  { value: 'kotla', label: 'Kotla', pincode: '176031' },
  { value: 'kulei', label: 'Kulei', pincode: '176031' },
  { value: 'manjhol', label: 'Manjhol', pincode: '176031' },
  { value: 'nangal', label: 'Nangal', pincode: '176031' },
  { value: 'patta', label: 'Patta', pincode: '176031' },
  { value: 'rahar', label: 'Rahar', pincode: '176031' },
  { value: 'saral', label: 'Saral', pincode: '176031' },
  { value: 'sujanpur', label: 'Sujanpur', pincode: '176031' },
  { value: 'thehli', label: 'Thehli', pincode: '176031' },
  { value: 'thakurdwara', label: 'Thakurdwara', pincode: '176031' },
  { value: 'shahpur', label: 'Shahpur', pincode: '176208' },
  { value: 'churadi', label: 'Churadi', pincode: '176031' },
  { value: 'dhogri', label: 'Dhogri', pincode: '176031' },
  { value: 'galoti', label: 'Galoti', pincode: '176031' },
  { value: 'jogi', label: 'Jogi', pincode: '176031' },
  { value: 'pattan', label: 'Pattan', pincode: '176031' }
  ],
  
  'joginder-nagar': [
  { value: 'alampur', label: 'Alampur', pincode: '175015' },
  { value: 'banuri', label: 'Banuri', pincode: '175015' },
  { value: 'bhakra', label: 'Bhakra', pincode: '175015' },
  { value: 'bassi', label: 'Bassi', pincode: '175015' },
  { value: 'joginder-nagar', label: 'Joginder Nagar', pincode: '175015' },
  { value: 'kandaghat', label: 'Kandaghat', pincode: '175016' },
  { value: 'karot', label: 'Karot', pincode: '175015' },
  { value: 'kothi', label: 'Kothi', pincode: '175016' },
  { value: 'patti', label: 'Patti', pincode: '175015' },
  { value: 'salah', label: 'Salah', pincode: '175015' },
  { value: 'shilla', label: 'Shilla', pincode: '175015' },
  { value: 'sundla', label: 'Sundla', pincode: '175015' },
  { value: 'thachi', label: 'Thachi', pincode: '175015' },
  { value: 'tanda', label: 'Tanda', pincode: '175016' },
  { value: 'bhanwar', label: 'Bhanwar', pincode: '175015' },
  { value: 'nagar', label: 'Nagar', pincode: '175015' },
  { value: 'dharampur', label: 'Dharampur', pincode: '175015' },
  { value: 'neri', label: 'Neri', pincode: '175015' },
  { value: 'channe', label: 'Channe', pincode: '175015' }
  ],
  
  'jubbal': [
  { value: 'bachhli', label: 'Bachhli', pincode: '171205' },
  { value: 'baragaon', label: 'Baragaon', pincode: '171205' },
  { value: 'chadru', label: 'Chadru', pincode: '171205' },
  { value: 'dhankot', label: 'Dhankot', pincode: '171205' },
  { value: 'jubbal', label: 'Jubbal', pincode: '171205' },
  { value: 'keshwa', label: 'Keshwa', pincode: '171205' },
  { value: 'kolin', label: 'Kolin', pincode: '171205' },
  { value: 'manala', label: 'Manala', pincode: '171205' },
  { value: 'mashobra', label: 'Mashobra', pincode: '171205' },
  { value: 'negal', label: 'Negal', pincode: '171205' },
  { value: 'patta', label: 'Patta', pincode: '171205' },
  { value: 'sarog', label: 'Sarog', pincode: '171205' },
  { value: 'thehli', label: 'Thehli', pincode: '171205' },
  { value: 'thangti', label: 'Thangti', pincode: '171205' },
  { value: 'baini', label: 'Baini', pincode: '171205' },
  { value: 'karanpur', label: 'Karanpur', pincode: '171205' },
  { value: 'kholi', label: 'Kholi', pincode: '171205' },
  { value: 'lohi', label: 'Lohi', pincode: '171205' },
  { value: 'mallu', label: 'Mallu', pincode: '171205' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '171205' },
  { value: 'thathi', label: 'Thathi', pincode: '171205' }
  ],
  
  'jutogh': [
  { value: 'banog', label: 'Banog', pincode: '171008' },
  { value: 'duttnagar', label: 'Duttnagar', pincode: '171008' },
  { value: 'jutogh', label: 'Jutogh', pincode: '171008' },
  { value: 'karyali', label: 'Karyali', pincode: '171008' },
  { value: 'kothi', label: 'Kothi', pincode: '171008' },
  { value: 'laili', label: 'Laili', pincode: '171008' },
  { value: 'manali', label: 'Manali', pincode: '171008' },
  { value: 'narain', label: 'Narain', pincode: '171008' },
  { value: 'nangal', label: 'Nangal', pincode: '171008' },
  { value: 'patti', label: 'Patti', pincode: '171008' },
  { value: 'rati', label: 'Rati', pincode: '171008' },
  { value: 'thakur', label: 'Thakur', pincode: '171008' },
  { value: 'thangti', label: 'Thangti', pincode: '171008' },
  { value: 'chhad', label: 'Chhad', pincode: '171008' },
  { value: 'kori', label: 'Kori', pincode: '171008' },
  { value: 'sarli', label: 'Sarli', pincode: '171008' },
  { value: 'sudha', label: 'Sudha', pincode: '171008' },
  { value: 'balh', label: 'Balh', pincode: '171008' },
  { value: 'bharari', label: 'Bharari', pincode: '171008' },
  { value: 'dehra', label: 'Dehra', pincode: '171008' }
  ],
  
  'kangra': [
  { value: 'dharamshala', label: 'Dharamshala', pincode: '176215' },
  { value: 'jaisinghpur', label: 'Jaisinghpur', pincode: '176203' },
  { value: 'kangra', label: 'Kangra', pincode: '176001' },
  { value: 'khiliana', label: 'Khiliana', pincode: '176220' },
  { value: 'kumarhatti', label: 'Kumarhatti', pincode: '176202' },
  { value: 'nagrota-bagwan', label: 'Nagrota Bagwan', pincode: '176047' },
  { value: 'palampur', label: 'Palampur', pincode: '176061' },
  { value: 'sullah', label: 'Sullah', pincode: '176206' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '176001' },
  { value: 'narwana', label: 'Narwana', pincode: '176203' },
  { value: 'baijnath', label: 'Baijnath', pincode: '176125' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '176121' },
  { value: 'mohal', label: 'Mohal', pincode: '176221' },
  { value: 'raipur', label: 'Raipur', pincode: '176062' }
  ],
  
  'kasauli': [
  { value: 'barog', label: 'Barog', pincode: '173211' },
  { value: 'dagshai', label: 'Dagshai', pincode: '173209' },
  { value: 'garkhal', label: 'Garkhal', pincode: '173204' },
  { value: 'kasauli', label: 'Kasauli', pincode: '173204' },
  { value: 'kumarhatti', label: 'Kumarhatti', pincode: '173204' },
  { value: 'mashobra', label: 'Mashobra', pincode: '173204' },
  { value: 'sanwara', label: 'Sanwara', pincode: '173211' },
  { value: 'solan', label: 'Solan', pincode: '173212' },
  { value: 'subathu', label: 'Subathu', pincode: '173205' },
  { value: 'ghati', label: 'Ghati', pincode: '173212' },
  { value: 'shahpur', label: 'Shahpur', pincode: '173211' },
  { value: 'chail', label: 'Chail', pincode: '173217' },
  { value: 'kandhri', label: 'Kandhri', pincode: '173215' },
  { value: 'mallah', label: 'Mallah', pincode: '173213' },
  { value: 'ramshehar', label: 'Ramshehar', pincode: '173207' },
  { value: 'paonta', label: 'Paonta', pincode: '173206' }
  ],
  
  'kotkhai': [
  { value: 'banjara', label: 'Banjara', pincode: '171202' },
  { value: 'chaila', label: 'Chaila', pincode: '171204' },
  { value: 'kotkhai', label: 'Kotkhai', pincode: '171202' },
  { value: 'mashan', label: 'Mashan', pincode: '171204' },
  { value: 'nashri', label: 'Nashri', pincode: '171204' },
  { value: 'poli', label: 'Poli', pincode: '171202' },
  { value: 'ramshahr', label: 'Ramshahr', pincode: '171202' },
  { value: 'sainj', label: 'Sainj', pincode: '171202' },
  { value: 'shilad', label: 'Shilad', pincode: '171204' },
  { value: 'thaila', label: 'Thaila', pincode: '171204' },
  { value: 'bhari', label: 'Bhari', pincode: '171205' },
  { value: 'dharwari', label: 'Dharwari', pincode: '171205' },
  { value: 'gogla', label: 'Gogla', pincode: '171205' },
  { value: 'jangla', label: 'Jangla', pincode: '171205' },
  { value: 'khilara', label: 'Khilara', pincode: '171205' },
  { value: 'rajwala', label: 'Rajwala', pincode: '171205' },
  { value: 'rohru', label: 'Rohru', pincode: '171207' }
  ],
  
  'kullu': [
  { value: 'bashing', label: 'Bashing', pincode: '175105' },
  { value: 'bhuntar', label: 'Bhuntar', pincode: '175125' },
  { value: 'gushaini', label: 'Gushaini', pincode: '175105' },
  { value: 'kullu', label: 'Kullu', pincode: '175101' },
  { value: 'manali', label: 'Manali', pincode: '175131' },
  { value: 'naggar', label: 'Naggar', pincode: '175130' },
  { value: 'pallo', label: 'Pallo', pincode: '175105' },
  { value: 'raigad', label: 'Raigad', pincode: '175125' },
  { value: 'sultanpur', label: 'Sultanpur', pincode: '175101' },
  { value: 'rambag', label: 'Rambag', pincode: '175101' },
  { value: 'tirthan', label: 'Tirthan', pincode: '175105' },
  { value: 'jari', label: 'Jari', pincode: '175105' },
  { value: 'katrain', label: 'Katrain', pincode: '175129' },
  { value: 'bahang', label: 'Bahang', pincode: '175131' },
  { value: 'banjar', label: 'Banjar', pincode: '175123' },
  { value: 'bharian', label: 'Bharian', pincode: '175130' },
  { value: 'dohri', label: 'Dohri', pincode: '175101' },
  { value: 'ghar', label: 'Ghar', pincode: '175101' },
  { value: 'jogni', label: 'Jogni', pincode: '175131' },
  { value: 'larji', label: 'Larji', pincode: '175129' }
  ],
  
  'mandi': [
  { value: 'balh', label: 'Balh', pincode: '175001' },
  { value: 'bassi', label: 'Bassi', pincode: '175001' },
  { value: 'chailchowk', label: 'Chail Chowk', pincode: '175021' },
  { value: 'darbara', label: 'Darbara', pincode: '175101' },
  { value: 'giripul', label: 'Giripul', pincode: '175121' },
  { value: 'kandhara', label: 'Kandhara', pincode: '175001' },
  { value: 'kullu', label: 'Kullu', pincode: '175101' },
  { value: 'mandi', label: 'Mandi', pincode: '175001' },
  { value: 'nayi-gaon', label: 'Nayi Gaon', pincode: '175001' },
  { value: 'patli', label: 'Patli', pincode: '175026' },
  { value: 'sarkaghat', label: 'Sarkaghat', pincode: '175024' },
  { value: 'sejla', label: 'Sejla', pincode: '175001' },
  { value: 'sundernagar', label: 'Sundernagar', pincode: '175018' },
  { value: 'banjar', label: 'Banjar', pincode: '175123' },
  { value: 'bharari', label: 'Bharari', pincode: '175023' },
  { value: 'bassi', label: 'Bassi', pincode: '175016' },
  { value: 'gohar', label: 'Gohar', pincode: '175101' },
  { value: 'kahanpur', label: 'Kahanpur', pincode: '175102' },
  { value: 'nauradhar', label: 'Nauradhar', pincode: '175015' },
  { value: 'panjpulla', label: 'Panjpulla', pincode: '175128' },
  { value: 'pandoh', label: 'Pandoh', pincode: '175124' },
  { value: 'rahla', label: 'Rahla', pincode: '175001' }
  ],
  
  'manali': [
  { value: 'bahang', label: 'Bahang', pincode: '175131' },
  { value: 'bhanara', label: 'Bhanara', pincode: '175131' },
  { value: 'guldhar', label: 'Guldhar', pincode: '175131' },
  { value: 'kalath', label: 'Kalath', pincode: '175130' },
  { value: 'kothi', label: 'Kothi', pincode: '175131' },
  { value: 'marhi', label: 'Marhi', pincode: '175130' },
  { value: 'manali', label: 'Manali', pincode: '175131' },
  { value: 'naggar', label: 'Naggar', pincode: '175130' },
  { value: 'old-manali', label: 'Old Manali', pincode: '175131' },
  { value: 'pallali', label: 'Pallali', pincode: '175131' },
  { value: 'prini', label: 'Prini', pincode: '175131' },
  { value: 'rangri', label: 'Rangri', pincode: '175131' },
  { value: 'rohtang', label: 'Rohtang', pincode: '175131' },
  { value: 'toll', label: 'Toll', pincode: '175131' },
  { value: 'vashisht', label: 'Vashisht', pincode: '175105' }
  ],
  
  'nadaun': [
  { value: 'bahpur', label: 'Bahpur', pincode: '177037' },
  { value: 'bhadrash', label: 'Bhadrash', pincode: '177037' },
  { value: 'chakla', label: 'Chakla', pincode: '177037' },
  { value: 'dhaneta', label: 'Dhaneta', pincode: '177037' },
  { value: 'gohar', label: 'Gohar', pincode: '177037' },
  { value: 'jhajra', label: 'Jhajra', pincode: '177037' },
  { value: 'kandru', label: 'Kandru', pincode: '177037' },
  { value: 'manjhol', label: 'Manjhol', pincode: '177037' },
  { value: 'nadaun', label: 'Nadaun', pincode: '177037' },
  { value: 'polian', label: 'Polian', pincode: '177037' },
  { value: 'poli', label: 'Poli', pincode: '177037' },
  { value: 'sundar', label: 'Sundar', pincode: '177037' },
  { value: 'tikkar', label: 'Tikkar', pincode: '177037' },
  { value: 'bhogpur', label: 'Bhogpur', pincode: '177037' },
  { value: 'kakroti', label: 'Kakroti', pincode: '177037' },
  { value: 'manjholi', label: 'Manjholi', pincode: '177037' },
  { value: 'narag', label: 'Narag', pincode: '177037' },
  { value: 'patta', label: 'Patta', pincode: '177037' },
  { value: 'sangla', label: 'Sangla', pincode: '177037' }
  ],
  
  'nahan': [
  { value: 'baghi', label: 'Baghi', pincode: '173001' },
  { value: 'banala', label: 'Banala', pincode: '173001' },
  { value: 'bawra', label: 'Bawra', pincode: '173001' },
  { value: 'chhota-bareta', label: 'Chhota Bareta', pincode: '173001' },
  { value: 'dhamoon', label: 'Dhamoon', pincode: '173001' },
  { value: 'ghari', label: 'Ghari', pincode: '173001' },
  { value: 'kamra', label: 'Kamra', pincode: '173001' },
  { value: 'kailash', label: 'Kailash', pincode: '173001' },
  { value: 'khaleta', label: 'Khaleta', pincode: '173001' },
  { value: 'kumarhatti', label: 'Kumarhatti', pincode: '173001' },
  { value: 'nahan', label: 'Nahan', pincode: '173001' },
  { value: 'panchmukhi', label: 'Panchmukhi', pincode: '173001' },
  { value: 'pathania', label: 'Pathania', pincode: '173001' },
  { value: 'raipur', label: 'Raipur', pincode: '173001' },
  { value: 'sadiqpur', label: 'Sadiqpur', pincode: '173001' },
  { value: 'shahpur', label: 'Shahpur', pincode: '173001' },
  { value: 'suketi', label: 'Suketi', pincode: '173001' },
  { value: 'talai', label: 'Talai', pincode: '173001' },
  { value: 'thapli', label: 'Thapli', pincode: '173001' },
  { value: 'titaru', label: 'Titaru', pincode: '173001' }
  ],
  
  'naina-devi': [
  { value: 'alampur', label: 'Alampur', pincode: '174201' },
  { value: 'bhakra', label: 'Bhakra', pincode: '174201' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '174201' },
  { value: 'chuhari', label: 'Chuhari', pincode: '174201' },
  { value: 'darbara', label: 'Darbara', pincode: '174201' },
  { value: 'gogdiyal', label: 'Gogdiyal', pincode: '174201' },
  { value: 'jathlana', label: 'Jathlana', pincode: '174201' },
  { value: 'kothi', label: 'Kothi', pincode: '174201' },
  { value: 'naina devi', label: 'Naina Devi', pincode: '174201' },
  { value: 'pipal', label: 'Pipal', pincode: '174201' },
  { value: 'rajpura', label: 'Rajpura', pincode: '174201' },
  { value: 'swarghat', label: 'Swarghat', pincode: '174201' },
  { value: 'taradevi', label: 'Taradevi', pincode: '174201' },
  { value: 'kalar', label: 'Kalar', pincode: '174201' },
  { value: 'dhangu', label: 'Dhangu', pincode: '174201' },
  { value: 'mehal', label: 'Mehal', pincode: '174201' },
  { value: 'mashka', label: 'Mashka', pincode: '174201' },
  { value: 'nadi', label: 'Nadi', pincode: '174201' }
  ],
  
  'nalagarh': [
  { value: 'adampur', label: 'Adampur', pincode: '174101' },
  { value: 'balag', label: 'Balag', pincode: '174101' },
  { value: 'bali', label: 'Bali', pincode: '174101' },
  { value: 'chandpur', label: 'Chandpur', pincode: '174101' },
  { value: 'dhanoti', label: 'Dhanoti', pincode: '174101' },
  { value: 'ghuggar', label: 'Ghuggar', pincode: '174101' },
  { value: 'kakarhati', label: 'Kakarhati', pincode: '174101' },
  { value: 'nalagarh', label: 'Nalagarh', pincode: '174101' },
  { value: 'nangla', label: 'Nangla', pincode: '174101' },
  { value: 'patta', label: 'Patta', pincode: '174101' },
  { value: 'palsora', label: 'Palsora', pincode: '174101' },
  { value: 'raipur', label: 'Raipur', pincode: '174101' },
  { value: 'shamshher', label: 'Shamshher', pincode: '174101' },
  { value: 'swarghat', label: 'Swarghat', pincode: '174101' },
  { value: 'tabri', label: 'Tabri', pincode: '174101' },
  { value: 'bakhri', label: 'Bakhri', pincode: '174101' },
  { value: 'dharampur', label: 'Dharampur', pincode: '174101' },
  { value: 'hasouli', label: 'Hasouli', pincode: '174101' },
  { value: 'khera', label: 'Khera', pincode: '174101' },
  { value: 'kothi', label: 'Kothi', pincode: '174101' },
  { value: 'sialba', label: 'Sialba', pincode: '174101' },
  { value: 'tira', label: 'Tira', pincode: '174101' }
  ],
  
  'nagrota-bagwan': [
  { value: 'bagwan', label: 'Bagwan', pincode: '176047' },
  { value: 'bhajwal', label: 'Bhajwal', pincode: '176047' },
  { value: 'chandpur', label: 'Chandpur', pincode: '176047' },
  { value: 'dadhol', label: 'Dadhol', pincode: '176047' },
  { value: 'ghati', label: 'Ghati', pincode: '176047' },
  { value: 'jandli', label: 'Jandli', pincode: '176047' },
  { value: 'kandror', label: 'Kandror', pincode: '176047' },
  { value: 'karela', label: 'Karela', pincode: '176047' },
  { value: 'kulehra', label: 'Kulehra', pincode: '176047' },
  { value: 'nagrota', label: 'Nagrota', pincode: '176047' },
  { value: 'panjhal', label: 'Panjhal', pincode: '176047' },
  { value: 'sungal', label: 'Sungal', pincode: '176047' },
  { value: 'swarn', label: 'Swarn', pincode: '176047' },
  { value: 'thural', label: 'Thural', pincode: '176047' },
  { value: 'vashu', label: 'Vashu', pincode: '176047' },
  { value: 'chhatrari', label: 'Chhatrari', pincode: '176047' },
  { value: 'gohar', label: 'Gohar', pincode: '176047' },
  { value: 'mashwar', label: 'Mashwar', pincode: '176047' },
  { value: 'toba', label: 'Toba', pincode: '176047' },
  { value: 'phulpur', label: 'Phulpur', pincode: '176047' },
  { value: 'kathian', label: 'Kathian', pincode: '176047' },
  { value: 'bhadyal', label: 'Bhadyal', pincode: '176047' }
  ],
  
  'narkanda': [
  { value: 'bahli', label: 'Bahli', pincode: '171213' },
  { value: 'chandbari', label: 'Chandbari', pincode: '171213' },
  { value: 'chaupal', label: 'Chaupal', pincode: '171211' },
  { value: 'dhamoon', label: 'Dhamoon', pincode: '171213' },
  { value: 'harkirpa', label: 'Harkirpa', pincode: '171213' },
  { value: 'hathal', label: 'Hathal', pincode: '171213' },
  { value: 'kashol', label: 'Kashol', pincode: '171213' },
  { value: 'khatri', label: 'Khatri', pincode: '171213' },
  { value: 'kothi', label: 'Kothi', pincode: '171213' },
  { value: 'narkanda', label: 'Narkanda', pincode: '171213' },
  { value: 'ramakot', label: 'Ramakot', pincode: '171213' },
  { value: 'rampur', label: 'Rampur', pincode: '171001' },
  { value: 'sanai', label: 'Sanai', pincode: '171213' },
  { value: 'saur', label: 'Saur', pincode: '171213' },
  { value: 'shakar', label: 'Shakar', pincode: '171213' },
  { value: 'sundar nagar', label: 'Sundar Nagar', pincode: '171212' },
  { value: 'tuni', label: 'Tuni', pincode: '171213' },
  { value: 'vashisht', label: 'Vashisht', pincode: '171213' },
  { value: 'bhakra', label: 'Bhakra', pincode: '171213' },
  { value: 'dahal', label: 'Dahal', pincode: '171213' },
  { value: 'jauz', label: 'Jauz', pincode: '171213' },
  { value: 'manji', label: 'Manji', pincode: '171213' }
  ],
  
  'nurpur': [
  { value: 'adwara', label: 'Adwara', pincode: '176202' },
  { value: 'bhajwan', label: 'Bhajwan', pincode: '176202' },
  { value: 'chakmoh', label: 'Chakmoh', pincode: '176202' },
  { value: 'chhatri', label: 'Chhatri', pincode: '176202' },
  { value: 'chhuri', label: 'Chhuri', pincode: '176202' },
  { value: 'dhanotu', label: 'Dhanotu', pincode: '176202' },
  { value: 'gagrial', label: 'Gagrial', pincode: '176202' },
  { value: 'gohar', label: 'Gohar', pincode: '176202' },
  { value: 'jhiri', label: 'Jhiri', pincode: '176202' },
  { value: 'kandela', label: 'Kandela', pincode: '176202' },
  { value: 'kassar', label: 'Kassar', pincode: '176202' },
  { value: 'mohindru', label: 'Mohindru', pincode: '176202' },
  { value: 'nagina', label: 'Nagina', pincode: '176202' },
  { value: 'nurpur', label: 'Nurpur', pincode: '176202' },
  { value: 'padhwal', label: 'Padhwal', pincode: '176202' },
  { value: 'patrara', label: 'Patrara', pincode: '176202' },
  { value: 'raviala', label: 'Raviala', pincode: '176202' },
  { value: 'ropar', label: 'Ropar', pincode: '176202' },
  { value: 'saha', label: 'Saha', pincode: '176202' },
  { value: 'sanwara', label: 'Sanwara', pincode: '176202' },
  { value: 'thana', label: 'Thana', pincode: '176202' },
  { value: 'vashisht', label: 'Vashisht', pincode: '176202' },
  { value: 'chohal', label: 'Chohal', pincode: '176202' },
  { value: 'patt', label: 'Patt', pincode: '176202' },
  { value: 'balh', label: 'Balh', pincode: '176202' }
  ],
  
  'palampur': [
  { value: 'adigun', label: 'Adigun', pincode: '176061' },
  { value: 'bagli', label: 'Bagli', pincode: '176061' },
  { value: 'bahadurpur', label: 'Bahadurpur', pincode: '176061' },
  { value: 'balh', label: 'Balh', pincode: '176061' },
  { value: 'bangru', label: 'Bangru', pincode: '176061' },
  { value: 'bari', label: 'Bari', pincode: '176061' },
  { value: 'banjar', label: 'Banjar', pincode: '176061' },
  { value: 'banjari', label: 'Banjari', pincode: '176061' },
  { value: 'basht', label: 'Basht', pincode: '176061' },
  { value: 'bharmaur', label: 'Bharmaur', pincode: '176061' },
  { value: 'bhuri', label: 'Bhuri', pincode: '176061' },
  { value: 'chadu', label: 'Chadu', pincode: '176061' },
  { value: 'chhatri', label: 'Chhatri', pincode: '176061' },
  { value: 'dharamshala', label: 'Dharamshala', pincode: '176061' },
  { value: 'gadhali', label: 'Gadhali', pincode: '176061' },
  { value: 'gamru', label: 'Gamru', pincode: '176061' },
  { value: 'gundari', label: 'Gundari', pincode: '176061' },
  { value: 'jhiri', label: 'Jhiri', pincode: '176061' },
  { value: 'kamand', label: 'Kamand', pincode: '176061' },
  { value: 'kangra', label: 'Kangra', pincode: '176061' },
  { value: 'kothi', label: 'Kothi', pincode: '176061' },
  { value: 'lambran', label: 'Lambran', pincode: '176061' },
  { value: 'madwan', label: 'Madwan', pincode: '176061' },
  { value: 'nalhati', label: 'Nalhati', pincode: '176061' },
  { value: 'padhiyar', label: 'Padhiyar', pincode: '176061' },
  { value: 'palampur', label: 'Palampur', pincode: '176061' },
  { value: 'patli', label: 'Patli', pincode: '176061' },
  { value: 'pihra', label: 'Pihra', pincode: '176061' },
  { value: 'raipur', label: 'Raipur', pincode: '176061' },
  { value: 'sundernagar', label: 'Sundernagar', pincode: '176061' },
  { value: 'thamsar', label: 'Thamsar', pincode: '176061' },
  { value: 'wazirpur', label: 'Wazirpur', pincode: '176061' }
  ],
  
  'paonta-sahib': [
  { value: 'adwal', label: 'Adwal', pincode: '173025' },
  { value: 'ambota', label: 'Ambota', pincode: '173025' },
  { value: 'balra', label: 'Balra', pincode: '173025' },
  { value: 'bhangani', label: 'Bhangani', pincode: '173025' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '173025' },
  { value: 'boree', label: 'Boree', pincode: '173025' },
  { value: 'chhater', label: 'Chhater', pincode: '173025' },
  { value: 'dharampur', label: 'Dharampur', pincode: '173025' },
  { value: 'dheradun', label: 'Dheradun', pincode: '173025' },
  { value: 'halwan', label: 'Halwan', pincode: '173025' },
  { value: 'kaithi', label: 'Kaithi', pincode: '173025' },
  { value: 'karnal', label: 'Karnal', pincode: '173025' },
  { value: 'khodri', label: 'Khodri', pincode: '173025' },
  { value: 'kurali', label: 'Kurali', pincode: '173025' },
  { value: 'manpur', label: 'Manpur', pincode: '173025' },
  { value: 'nahan', label: 'Nahan', pincode: '173025' },
  { value: 'paonta', label: 'Paonta', pincode: '173025' },
  { value: 'panta', label: 'Panta', pincode: '173025' },
  { value: 'pohli', label: 'Pohli', pincode: '173025' },
  { value: 'sihani', label: 'Sihani', pincode: '173025' },
  { value: 'sundernagar', label: 'Sundernagar', pincode: '173025' },
  { value: 'thakti', label: 'Thakti', pincode: '173025' },
  { value: 'tibba', label: 'Tibba', pincode: '173025' },
  { value: 'vikramshila', label: 'Vikramshila', pincode: '173025' },
  { value: 'sherra', label: 'Sherra', pincode: '173025' },
  { value: 'sura', label: 'Sura', pincode: '173025' },
  { value: 'khakra', label: 'Khakra', pincode: '173025' },
  { value: 'rampur', label: 'Rampur', pincode: '173025' },
  { value: 'raipur', label: 'Raipur', pincode: '173025' }
  ],
  
  'parwanoo': [
  { value: 'baghi', label: 'Baghi', pincode: '173220' },
  { value: 'barog', label: 'Barog', pincode: '173211' },
  { value: 'bhatoli', label: 'Bhatoli', pincode: '173221' },
  { value: 'bhunter', label: 'Bhunter', pincode: '173220' },
  { value: 'bhanuni', label: 'Bhanuni', pincode: '173225' },
  { value: 'bhanwar', label: 'Bhanwar', pincode: '173220' },
  { value: 'chikni', label: 'Chikni', pincode: '173215' },
  { value: 'chandpur', label: 'Chandpur', pincode: '173220' },
  { value: 'kandhaghat', label: 'Kandhaghat', pincode: '173215' },
  { value: 'koli', label: 'Koli', pincode: '173221' },
  { value: 'kullu', label: 'Kullu', pincode: '173212' },
  { value: 'manali', label: 'Manali', pincode: '173213' },
  { value: 'mohali', label: 'Mohali', pincode: '173220' },
  { value: 'nandpur', label: 'Nandpur', pincode: '173221' },
  { value: 'nati', label: 'Nati', pincode: '173220' },
  { value: 'patta', label: 'Patta', pincode: '173220' },
  { value: 'sarkaghat', label: 'Sarkaghat', pincode: '173222' },
  { value: 'solan', label: 'Solan', pincode: '173213' },
  { value: 'subathu', label: 'Subathu', pincode: '173206' },
  { value: 'dharampur', label: 'Dharampur', pincode: '173211' },
  { value: 'koti', label: 'Koti', pincode: '173222' },
  { value: 'kushalgarh', label: 'Kushalgarh', pincode: '173222' },
  { value: 'lalitpur', label: 'Lalitpur', pincode: '173220' },
  { value: 'manewal', label: 'Manewal', pincode: '173221' },
  { value: 'narmada', label: 'Narmada', pincode: '173222' }
  ],
  
  'rajgarh': [
  { value: 'banog', label: 'Banog', pincode: '173205' },
  { value: 'bhinna', label: 'Bhinna', pincode: '173225' },
  { value: 'chaila', label: 'Chaila', pincode: '173225' },
  { value: 'churag', label: 'Churag', pincode: '173225' },
  { value: 'dhalu', label: 'Dhalu', pincode: '173205' },
  { value: 'dumma', label: 'Dumma', pincode: '173205' },
  { value: 'kamah', label: 'Kamah', pincode: '173225' },
  { value: 'kalhoon', label: 'Kalhoon', pincode: '173205' },
  { value: 'kandoli', label: 'Kandoli', pincode: '173225' },
  { value: 'kumhari', label: 'Kumhari', pincode: '173205' },
  { value: 'manchi', label: 'Manchi', pincode: '173205' },
  { value: 'nagrota', label: 'Nagrota', pincode: '173205' },
  { value: 'raipur', label: 'Raipur', pincode: '173225' },
  { value: 'rajgarh', label: 'Rajgarh', pincode: '173225' },
  { value: 'solan', label: 'Solan', pincode: '173213' },
  { value: 'sundar', label: 'Sundar', pincode: '173225' },
  { value: 'talai', label: 'Talai', pincode: '173205' },
  { value: 'tihri', label: 'Tihri', pincode: '173225' },
  { value: 'udhan', label: 'Udan', pincode: '173225' },
  { value: 'vadhpur', label: 'Vadhpur', pincode: '173225' }
  ],
  
  'rampur-bushahr': [
  { value: 'banjar', label: 'Banjar', pincode: '172107' },
  { value: 'chhaila', label: 'Chhaila', pincode: '172113' },
  { value: 'dhar', label: 'Dhar', pincode: '172102' },
  { value: 'jhakri', label: 'Jhakri', pincode: '172201' },
  { value: 'kafnu', label: 'Kafnu', pincode: '172107' },
  { value: 'khalta', label: 'Khalta', pincode: '172104' },
  { value: 'khushhya', label: 'Khushhya', pincode: '172111' },
  { value: 'mashwa', label: 'Mashwa', pincode: '172109' },
  { value: 'nargu', label: 'Nargu', pincode: '172106' },
  { value: 'rampur', label: 'Rampur', pincode: '172001' },
  { value: 'rampur bushahr', label: 'Rampur Bushahr', pincode: '172001' },
  { value: 'sainj', label: 'Sainj', pincode: '172101' },
  { value: 'sarahan', label: 'Sarahan', pincode: '172102' },
  { value: 'shamsher', label: 'Shamsher', pincode: '172103' },
  { value: 'singhpur', label: 'Singhpur', pincode: '172108' },
  { value: 'sunthla', label: 'Sunthla', pincode: '172105' },
  { value: 'sidhpur', label: 'Sidhpur', pincode: '172105' },
  { value: 'kolar', label: 'Kolar', pincode: '172107' },
  { value: 'kailash', label: 'Kailash', pincode: '172107' },
  { value: 'sudher', label: 'Sudher', pincode: '172109' },
  { value: 'dhurli', label: 'Dhurli', pincode: '172106' }
  ],
  
  'rewalsar': [
  { value: 'banjala', label: 'Banjala', pincode: '175023' },
  { value: 'basa', label: 'Basa', pincode: '175023' },
  { value: 'chakmoh', label: 'Chakmoh', pincode: '175023' },
  { value: 'chariala', label: 'Chariala', pincode: '175023' },
  { value: 'dhundhi', label: 'Dhundhi', pincode: '175023' },
  { value: 'gadei', label: 'Gadei', pincode: '175023' },
  { value: 'ghungti', label: 'Ghungti', pincode: '175023' },
  { value: 'kharwar', label: 'Kharwar', pincode: '175023' },
  { value: 'kolar', label: 'Kolar', pincode: '175023' },
  { value: 'kotla', label: 'Kotla', pincode: '175023' },
  { value: 'madhot', label: 'Madhot', pincode: '175023' },
  { value: 'mehli', label: 'Mehli', pincode: '175023' },
  { value: 'pandoh', label: 'Pandoh', pincode: '175023' },
  { value: 'rewalsar', label: 'Rewalsar', pincode: '175023' },
  { value: 'solh', label: 'Solh', pincode: '175023' },
  { value: 'thachi', label: 'Thachi', pincode: '175023' },
  { value: 'sarari', label: 'Sarari', pincode: '175023' },
  { value: 'khodi', label: 'Khodi', pincode: '175023' },
  { value: 'kundi', label: 'Kundi', pincode: '175023' },
  { value: 'pundri', label: 'Pundri', pincode: '175023' },
  { value: 'sarang', label: 'Sarang', pincode: '175023' }
  ],
  
  'rohru': [
  { value: 'ashar', label: 'Ashar', pincode: '171207' },
  { value: 'baddi', label: 'Baddi', pincode: '171207' },
  { value: 'banog', label: 'Banog', pincode: '171207' },
  { value: 'bhatwari', label: 'Bhatwari', pincode: '171207' },
  { value: 'bichhli', label: 'Bichhli', pincode: '171207' },
  { value: 'chamla', label: 'Chamla', pincode: '171207' },
  { value: 'chandpur', label: 'Chandpur', pincode: '171207' },
  { value: 'dundad', label: 'Dundad', pincode: '171207' },
  { value: 'ghardi', label: 'Ghardi', pincode: '171207' },
  { value: 'kandakhet', label: 'Kandakhet', pincode: '171207' },
  { value: 'kathana', label: 'Kathana', pincode: '171207' },
  { value: 'kholan', label: 'Kholan', pincode: '171207' },
  { value: 'mashwa', label: 'Mashwa', pincode: '171207' },
  { value: 'nagana', label: 'Nagana', pincode: '171207' },
  { value: 'rohru', label: 'Rohru', pincode: '171207' },
  { value: 'sarol', label: 'Sarol', pincode: '171207' },
  { value: 'sarswati', label: 'Sarswati', pincode: '171207' },
  { value: 'shila', label: 'Shila', pincode: '171207' },
  { value: 'thana', label: 'Thana', pincode: '171207' },
  { value: 'chehru', label: 'Chehru', pincode: '171207' },
  { value: 'fagri', label: 'Fagri', pincode: '171207' },
  { value: 'kail', label: 'Kail', pincode: '171207' },
  { value: 'sarala', label: 'Sarala', pincode: '171207' },
  { value: 'singhana', label: 'Singhana', pincode: '171207' },
  { value: 'sundla', label: 'Sundla', pincode: '171207' }
  ],
  
  'sarkaghat': [
  { value: 'bajahi', label: 'Bajahi', pincode: '175024' },
  { value: 'bahra', label: 'Bahra', pincode: '175024' },
  { value: 'balh', label: 'Balh', pincode: '175024' },
  { value: 'baron', label: 'Baron', pincode: '175024' },
  { value: 'chambi', label: 'Chambi', pincode: '175024' },
  { value: 'chhaila', label: 'Chhaila', pincode: '175024' },
  { value: 'dhaneta', label: 'Dhaneta', pincode: '175024' },
  { value: 'gandhi', label: 'Gandhi', pincode: '175024' },
  { value: 'jakh', label: 'Jakh', pincode: '175024' },
  { value: 'kandrala', label: 'Kandrala', pincode: '175024' },
  { value: 'khaniar', label: 'Khaniar', pincode: '175024' },
  { value: 'kothi', label: 'Kothi', pincode: '175024' },
  { value: 'nari', label: 'Nari', pincode: '175024' },
  { value: 'paddi', label: 'Paddi', pincode: '175024' },
  { value: 'patta', label: 'Patta', pincode: '175024' },
  { value: 'sarkaghat', label: 'Sarkaghat', pincode: '175024' },
  { value: 'thachi', label: 'Thachi', pincode: '175024' },
  { value: 'thapli', label: 'Thapli', pincode: '175024' },
  { value: 'talyar', label: 'Talyar', pincode: '175024' },
  { value: 'gwalta', label: 'Gwalta', pincode: '175024' },
  { value: 'jogri', label: 'Jogri', pincode: '175024' },
  { value: 'kheri', label: 'Kheri', pincode: '175024' },
  { value: 'kutar', label: 'Kutar', pincode: '175024' },
  { value: 'lajwara', label: 'Lajwara', pincode: '175024' },
  { value: 'mandi', label: 'Mandi', pincode: '175024' },
  { value: 'nibbi', label: 'Nibbi', pincode: '175024' },
  { value: 'patran', label: 'Patran', pincode: '175024' },
  { value: 'solan', label: 'Solan', pincode: '175024' },
  { value: 'surar', label: 'Surar', pincode: '175024' },
  { value: 'theog', label: 'Theog', pincode: '175024' },
  { value: 'vilaspur', label: 'Vilaspur', pincode: '175024' }
  ],
  
  'shimla': [
  { value: 'chhota shimla', label: 'Chhota Shimla', pincode: '171002' },
  { value: 'churah', label: 'Churah', pincode: '171208' },
  { value: 'dagshai', label: 'Dagshai', pincode: '171212' },
  { value: 'fagu', label: 'Fagu', pincode: '171202' },
  { value: 'ghat', label: 'Ghat', pincode: '171103' },
  { value: 'ghumarwin', label: 'Ghumarwin', pincode: '171207' },
  { value: 'hadimba', label: 'Hadimba', pincode: '171006' },
  { value: 'kali bari', label: 'Kali Bari', pincode: '171001' },
  { value: 'kasauli', label: 'Kasauli', pincode: '173204' },
  { value: 'khalini', label: 'Khalini', pincode: '171002' },
  { value: 'kotkhai', label: 'Kotkhai', pincode: '171202' },
  { value: 'mashobra', label: 'Mashobra', pincode: '171007' },
  { value: 'minch', label: 'Minch', pincode: '171004' },
  { value: 'new shimla', label: 'New Shimla', pincode: '171009' },
  { value: 'nawati', label: 'Nawati', pincode: '171001' },
  { value: 'sanjauli', label: 'Sanjauli', pincode: '171006' },
  { value: 'shoghi', label: 'Shoghi', pincode: '171219' },
  { value: 'sidhi vinayak', label: 'Sidhi Vinayak', pincode: '171005' },
  { value: 'summer hill', label: 'Summer Hill', pincode: '171005' },
  { value: 'theog', label: 'Theog', pincode: '171201' },
  { value: 'viceregal lodge', label: 'Viceregal Lodge', pincode: '171005' },
  { value: 'wildflower hall', label: 'Wildflower Hall', pincode: '171004' },
  { value: 'bakra', label: 'Bakra', pincode: '171220' },
  { value: 'banjara', label: 'Banjara', pincode: '171009' },
  { value: 'bhatta', label: 'Bhatta', pincode: '171004' },
  { value: 'circular road', label: 'Circular Road', pincode: '171001' },
  { value: 'dhalli', label: 'Dhalli', pincode: '171001' },
  { value: 'jhakri', label: 'Jhakri', pincode: '171213' },
  { value: 'kuddu', label: 'Kuddu', pincode: '171214' },
  { value: 'lower bazar', label: 'Lower Bazar', pincode: '171001' },
  { value: 'manali road', label: 'Manali Road', pincode: '171006' },
  { value: 'old shimla', label: 'Old Shimla', pincode: '171004' },
  { value: 'shali', label: 'Shali', pincode: '171213' },
  { value: 'sharu', label: 'Sharu', pincode: '171004' },
  { value: 'vikas nagar', label: 'Vikas Nagar', pincode: '171009' }
  ],
  
  'sihor-pai': [
  { value: 'bani', label: 'Bani', pincode: '176024' },
  { value: 'banuri', label: 'Banuri', pincode: '176011' },
  { value: 'bhatkuli', label: 'Bhatkuli', pincode: '176022' },
  { value: 'duna', label: 'Duna', pincode: '176029' },
  { value: 'kangoo', label: 'Kangoo', pincode: '176026' },
  { value: 'kullu', label: 'Kullu', pincode: '175101' },
  { value: 'manal', label: 'Manal', pincode: '176042' },
  { value: 'mohal', label: 'Mohal', pincode: '176043' },
  { value: 'nagrah', label: 'Nagrah', pincode: '176004' },
  { value: 'pai', label: 'Pai', pincode: '176030' },
  { value: 'patiala', label: 'Patiala', pincode: '176039' },
  { value: 'ratwara', label: 'Ratwara', pincode: '176031' },
  { value: 'sihor', label: 'Sihor', pincode: '176025' },
  { value: 'suli', label: 'Suli', pincode: '176005' },
  { value: 'tattapani', label: 'Tattapani', pincode: '176010' }
  ],
  
  'solan': [
  { value: 'bagthan', label: 'Bagthan', pincode: '173205' },
  { value: 'banjar', label: 'Banjar', pincode: '173208' },
  { value: 'barmana', label: 'Barmana', pincode: '173206' },
  { value: 'darlaghat', label: 'Darlaghat', pincode: '173211' },
  { value: 'dera', label: 'Dera', pincode: '173212' },
  { value: 'kandaghat', label: 'Kandaghat', pincode: '173215' },
  { value: 'karanpur', label: 'Karanpur', pincode: '173217' },
  { value: 'kuthar', label: 'Kuthar', pincode: '173204' },
  { value: 'majra', label: 'Majra', pincode: '173211' },
  { value: 'nahan', label: 'Nahan', pincode: '173204' },
  { value: 'nauni', label: 'Nauni', pincode: '173230' },
  { value: 'parwanoo', label: 'Parwanoo', pincode: '173220' },
  { value: 'rohru', label: 'Rohru', pincode: '173229' },
  { value: 'solan-bazar', label: 'Solan Bazar', pincode: '173212' },
  { value: 'sujanpur', label: 'Sujanpur', pincode: '173215' },
  { value: 'theog', label: 'Theog', pincode: '173213' },
  { value: 'chhota solan', label: 'Chhota Solan', pincode: '173221' },
  { value: 'solan village', label: 'Solan Village', pincode: '173222' },
  { value: 'kaithlighat', label: 'Kaithlighat', pincode: '173223' },
  { value: 'chandpur', label: 'Chandpur', pincode: '173224' },
  { value: 'shillai', label: 'Shillai', pincode: '173225' },
  { value: 'jarol', label: 'Jarol', pincode: '173226' },
  { value: 'pali', label: 'Pali', pincode: '173227' },
  { value: 'sundernagar', label: 'Sundernagar', pincode: '173228' },
  ],
  
  'subathu': [
  { value: 'chail', label: 'Chail', pincode: '173217' },
  { value: 'chandi', label: 'Chandi', pincode: '173211' },
  { value: 'dharampur', label: 'Dharampur', pincode: '173209' },
  { value: 'kandaghat', label: 'Kandaghat', pincode: '173215' },
  { value: 'kaithlighat', label: 'Kaithlighat', pincode: '173213' },
  { value: 'mahanpur', label: 'Mahanpur', pincode: '173208' },
  { value: 'nalagarh', label: 'Nalagarh', pincode: '173202' },
  { value: 'parwanoo', label: 'Parwanoo', pincode: '173220' },
  { value: 'solan', label: 'Solan', pincode: '173212' },
  { value: 'subathu-bazar', label: 'Subathu Bazar', pincode: '173206' },
  { value: 'theog', label: 'Theog', pincode: '173213' },
  { value: 'tutikandi', label: 'Tutikandi', pincode: '173224' },
  { value: 'ambuja', label: 'Ambuja', pincode: '173215' },
  { value: 'barog', label: 'Barog', pincode: '173211' },
  { value: 'bhadi', label: 'Bhadi', pincode: '173222' },
  { value: 'darlaghat', label: 'Darlaghat', pincode: '173201' },
  { value: 'jhandutta', label: 'Jhandutta', pincode: '173221' },
  { value: 'mahaul', label: 'Mahaul', pincode: '173207' },
  { value: 'nainidhar', label: 'Nainidhar', pincode: '173218' },
  { value: 'nauradhar', label: 'Nauradhar', pincode: '173215' },
  { value: 'ramshahr', label: 'Ramshahr', pincode: '173216' }
  ],
  
  'sujanpur-tira': [
  { value: 'bhadi', label: 'Bhadi', pincode: '176110' },
  { value: 'bhanjal', label: 'Bhanjal', pincode: '176106' },
  { value: 'dohara', label: 'Dohara', pincode: '176105' },
  { value: 'jhumar', label: 'Jhumar', pincode: '176113' },
  { value: 'kaned', label: 'Kaned', pincode: '176112' },
  { value: 'kakrola', label: 'Kakrola', pincode: '176107' },
  { value: 'nadan', label: 'Nadan', pincode: '176104' },
  { value: 'sujanpur', label: 'Sujanpur', pincode: '176120' },
  { value: 'sujanpur-bazar', label: 'Sujanpur Bazar', pincode: '176122' },
  { value: 'tira', label: 'Tira', pincode: '176121' },
  { value: 'verinag', label: 'Verinag', pincode: '176114' },
  { value: 'village-bhatoli', label: 'Village Bhatoli', pincode: '176109' },
  { value: 'chakmoh', label: 'Chakmoh', pincode: '176101' },
  { value: 'chhoti', label: 'Chhoti', pincode: '176103' },
  { value: 'dharat', label: 'Dharat', pincode: '176108' },
  { value: 'nadi', label: 'Nadi', pincode: '176110' },
  { value: 'palth', label: 'Palth', pincode: '176115' },
  { value: 'thunag', label: 'Thunag', pincode: '176116' },
  { value: 'bhatoli', label: 'Bhatoli', pincode: '176102' },
  { value: 'bara-bhathi', label: 'Bara Bhathi', pincode: '176117' },
  { value: 'ghoril', label: 'Ghoril', pincode: '176118' },
  { value: 'khajoor', label: 'Khajoor', pincode: '176119' },
  { value: 'mehla', label: 'Mehla', pincode: '176100' },
  { value: 'pahar', label: 'Pahar', pincode: '176105' },
  { value: 'sanjour', label: 'Sanjour', pincode: '176104' },
  { value: 'sidhpur', label: 'Sidhpur', pincode: '176103' },
  { value: 'sukhdar', label: 'Sukhdar', pincode: '176110' }
  ],
  
  'sundar-nagar': [
  { value: 'baghi', label: 'Baghi', pincode: '174401' },
  { value: 'banjwar', label: 'Banjwar', pincode: '174401' },
  { value: 'baragaon', label: 'Baragaon', pincode: '174402' },
  { value: 'bara', label: 'Bara', pincode: '174403' },
  { value: 'bhadbari', label: 'Bhadbari', pincode: '174404' },
  { value: 'bhater', label: 'Bhater', pincode: '174406' },
  { value: 'burwa', label: 'Burwa', pincode: '174405' },
  { value: 'chatt', label: 'Chatt', pincode: '174407' },
  { value: 'dhamwari', label: 'Dhamwari', pincode: '174410' },
  { value: 'dhami', label: 'Dhami', pincode: '174408' },
  { value: 'ghansal', label: 'Ghansal', pincode: '174409' },
  { value: 'kanhol', label: 'Kanhol', pincode: '174401' },
  { value: 'kandaghat', label: 'Kandaghat', pincode: '174410' },
  { value: 'kothi', label: 'Kothi', pincode: '174411' },
  { value: 'sundar-nagar-bazar', label: 'Sundar Nagar Bazar', pincode: '174412' },
  { value: 'sundernagar', label: 'Sundernagar', pincode: '174413' },
  { value: 'tissa', label: 'Tissa', pincode: '174414' },
  { value: 'thana', label: 'Thana', pincode: '174415' },
  { value: 'vishnu', label: 'Vishnu', pincode: '174416' },
  { value: 'rajgarh', label: 'Rajgarh', pincode: '174417' },
  { value: 'majra', label: 'Majra', pincode: '174418' },
  { value: 'kular', label: 'Kular', pincode: '174419' },
  { value: 'bassi', label: 'Bassi', pincode: '174420' },
  { value: 'panog', label: 'Panog', pincode: '174421' },
  { value: 'nagal', label: 'Nagal', pincode: '174422' },
  { value: 'kalwari', label: 'Kalwari', pincode: '174423' }
],
  
  'talai': [
  { value: 'chhatri', label: 'Chhatri', pincode: '174026' },
  { value: 'gandhi-ka-bag', label: 'Gandhi Ka Bag', pincode: '174027' },
  { value: 'garhi', label: 'Garhi', pincode: '174028' },
  { value: 'ghat', label: 'Ghat', pincode: '174029' },
  { value: 'kathla', label: 'Kathla', pincode: '174030' },
  { value: 'khera', label: 'Khera', pincode: '174031' },
  { value: 'kullu', label: 'Kullu', pincode: '174032' },
  { value: 'langha', label: 'Langha', pincode: '174033' },
  { value: 'rahnal', label: 'Rahnal', pincode: '174034' },
  { value: 'sundhar', label: 'Sundhar', pincode: '174035' },
  { value: 'talai-bazar', label: 'Talai Bazar', pincode: '174036' },
  { value: 'vijaypura', label: 'Vijaypura', pincode: '174037' },
  { value: 'nangal', label: 'Nangal', pincode: '174038' },
  { value: 'nawanagar', label: 'Nawanagar', pincode: '174039' },
  { value: 'bassi', label: 'Bassi', pincode: '174040' },
  { value: 'shahpur', label: 'Shahpur', pincode: '174041' },
  { value: 'khad', label: 'Khad', pincode: '174042' }
  ],
  
  'theog': [
  { value: 'bagh', label: 'Bagh', pincode: '171201' },
  { value: 'bari', label: 'Bari', pincode: '171202' },
  { value: 'chaila', label: 'Chaila', pincode: '171203' },
  { value: 'dhamund', label: 'Dhamund', pincode: '171204' },
  { value: 'jakhri', label: 'Jakhri', pincode: '171205' },
  { value: 'kakrot', label: 'Kakrot', pincode: '171206' },
  { value: 'khasla', label: 'Khasla', pincode: '171207' },
  { value: 'koti', label: 'Koti', pincode: '171208' },
  { value: 'nawan', label: 'Nawan', pincode: '171209' },
  { value: 'sarang', label: 'Sarang', pincode: '171210' },
  { value: 'shahpur', label: 'Shahpur', pincode: '171211' },
  { value: 'theog-bazar', label: 'Theog Bazar', pincode: '171212' },
  { value: 'theog-ghat', label: 'Theog Ghat', pincode: '171213' },
  { value: 'theog-khaddar', label: 'Theog Khaddar', pincode: '171214' },
  { value: 'tikkar', label: 'Tikkar', pincode: '171215' },
  { value: 'village', label: 'Village', pincode: '171216' },
  { value: 'jaud', label: 'Jaud', pincode: '171217' },
  { value: 'kandog', label: 'Kandog', pincode: '171218' },
  { value: 'neeli', label: 'Neeli', pincode: '171219' },
  { value: 'sidh', label: 'Sidh', pincode: '171220' },
  { value: 'shilli', label: 'Shilli', pincode: '171221' }
  ],
  
  'una': [
  { value: 'bari', label: 'Bari', pincode: '174303' },
  { value: 'chandpur', label: 'Chandpur', pincode: '174302' },
  { value: 'dhanotu', label: 'Dhanotu', pincode: '174301' },
  { value: 'gagret', label: 'Gagret', pincode: '174201' },
  { value: 'jagatkhana', label: 'Jagatkhana', pincode: '174206' },
  { value: 'madhopur', label: 'Madhopur', pincode: '174205' },
  { value: 'nangal', label: 'Nangal', pincode: '174207' },
  { value: 'pali', label: 'Pali', pincode: '174208' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '174209' },
  { value: 'sabathu', label: 'Sabathu', pincode: '174210' },
  { value: 'sultanpur', label: 'Sultanpur', pincode: '174211' },
  { value: 'theog', label: 'Theog', pincode: '174212' },
  { value: 'una-bazar', label: 'Una Bazar', pincode: '174301' },
  { value: 'village-dhar', label: 'Village Dhar', pincode: '174214' },
  { value: 'village-mohali', label: 'Village Mohali', pincode: '174215' },
  { value: 'village-sukhpur', label: 'Village Sukhpur', pincode: '174216' },
  { value: 'bhated', label: 'Bhated', pincode: '174217' },
  { value: 'chatra', label: 'Chatra', pincode: '174218' },
  { value: 'gundholi', label: 'Gundholi', pincode: '174219' },
  { value: 'haripura', label: 'Haripura', pincode: '174220' },
  { value: 'khasra', label: 'Khasra', pincode: '174221' },
  { value: 'kotla', label: 'Kotla', pincode: '174222' },
  { value: 'mahal', label: 'Mahal', pincode: '174223' },
  { value: 'naru', label: 'Naru', pincode: '174224' },
  { value: 'palsora', label: 'Palsora', pincode: '174225' },
  { value: 'patta', label: 'Patta', pincode: '174226' },
  { value: 'ranwin', label: 'Ranwin', pincode: '174227' },
  { value: 'talyar', label: 'Talyar', pincode: '174228' }
  ],
  // Telangana Areas
  'alampur': [
  { value: 'adampur', label: 'Adampur', pincode: '500042' },
  { value: 'bariwas', label: 'Bariwas', pincode: '500043' },
  { value: 'chakri', label: 'Chakri', pincode: '500045' },
  { value: 'chandpur', label: 'Chandpur', pincode: '500044' },
  { value: 'dhelwa', label: 'Dhelwa', pincode: '500045' },
  { value: 'kali', label: 'Kali', pincode: '500046' },
  { value: 'kherdi', label: 'Kherdi', pincode: '500047' },
  { value: 'kushkhera', label: 'Kushkhera', pincode: '500048' },
  { value: 'loharu', label: 'Loharu', pincode: '500048' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '500049' },
  { value: 'manpur', label: 'Manpur', pincode: '500051' },
  { value: 'nangal', label: 'Nangal', pincode: '500050' },
  { value: 'pabuwas', label: 'Pabuwas', pincode: '500052' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '500051' },
  { value: 'siwani', label: 'Siwani', pincode: '500052' },
  { value: 'taura', label: 'Taura', pincode: '500053' },
  { value: 'tulsi', label: 'Tulsi', pincode: '500054' },
  { value: 'vishwas', label: 'Vishwas', pincode: '500054' },
  { value: 'wanwari', label: 'Wanwari', pincode: '500055' },
  { value: 'zainpur', label: 'Zainpur', pincode: '500056' }
  ],

  'serilingampalle': [
  { value: 'adampur', label: 'Adampur', pincode: '500078' },
  { value: 'bariwas', label: 'Bariwas', pincode: '500082' },
  { value: 'chakri', label: 'Chakri', pincode: '500085' },
  { value: 'chandpur', label: 'Chandpur', pincode: '500087' },
  { value: 'dhelwa', label: 'Dhelwa', pincode: '500089' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gollapally', label: 'Gollapally', pincode: '500084' },
  { value: 'kali', label: 'Kali', pincode: '500091' },
  { value: 'kherdi', label: 'Kherdi', pincode: '500093' },
  { value: 'loharu', label: 'Loharu', pincode: '500095' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '500096' },
  { value: 'manpur', label: 'Manpur', pincode: '500097' },
  { value: 'nagalapally', label: 'Nagalapally', pincode: '500100' },
  { value: 'nangal', label: 'Nangal', pincode: '500098' },
  { value: 'pabuwas', label: 'Pabuwas', pincode: '500099' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '500100' },
  { value: 'siwani', label: 'Siwani', pincode: '500101' },
  { value: 'taura', label: 'Taura', pincode: '500102' },
  { value: 'vishwas', label: 'Vishwas', pincode: '500103' },
  { value: 'wanwari', label: 'Wanwari', pincode: '500104' },
  { value: 'zainpur', label: 'Zainpur', pincode: '500105' }
  ],

  'vemulawada': [
  { value: 'adampur', label: 'Adampur', pincode: '505302' },
  { value: 'bariwas', label: 'Bariwas', pincode: '505303' },
  { value: 'chakri', label: 'Chakri', pincode: '505304' },
  { value: 'chandpur', label: 'Chandpur', pincode: '505305' },
  { value: 'dhelwa', label: 'Dhelwa', pincode: '505306' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gollapally', label: 'Gollapally', pincode: '505320' },
  { value: 'kali', label: 'Kali', pincode: '505307' },
  { value: 'kherdi', label: 'Kherdi', pincode: '505308' },
  { value: 'kushkhera', label: 'Kushkhera', pincode: '505309' },
  { value: 'loharu', label: 'Loharu', pincode: '505309' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '505310' },
  { value: 'manpur', label: 'Manpur', pincode: '505311' },
  { value: 'nangal', label: 'Nangal', pincode: '505312' },
  { value: 'pabuwas', label: 'Pabuwas', pincode: '505313' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '505314' },
  { value: 'siwani', label: 'Siwani', pincode: '505315' },
  { value: 'taura', label: 'Taura', pincode: '505316' },
  { value: 'tulsi', label: 'Tulsi', pincode: '505321' },
  { value: 'vishwas', label: 'Vishwas', pincode: '505317' },
  { value: 'wanwari', label: 'Wanwari', pincode: '505318' },
  { value: 'zainpur', label: 'Zainpur', pincode: '505319' }
  ],

  'yellandu': [
  { value: 'adampur', label: 'Adampur', pincode: '505184' },
  { value: 'bariwas', label: 'Bariwas', pincode: '505185' },
  { value: 'chakri', label: 'Chakri', pincode: '505186' },
  { value: 'chandpur', label: 'Chandpur', pincode: '505187' },
  { value: 'dhelwa', label: 'Dhelwa', pincode: '505188' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gollapally', label: 'Gollapally', pincode: '505201' },
  { value: 'kali', label: 'Kali', pincode: '505189' },
  { value: 'kherdi', label: 'Kherdi', pincode: '505190' },
  { value: 'kushkhera', label: 'Kushkhera', pincode: '505202' },
  { value: 'loharu', label: 'Loharu', pincode: '505191' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '505192' },
  { value: 'manpur', label: 'Manpur', pincode: '505193' },
  { value: 'nagalapally', label: 'Nagalapally', pincode: '505194' },
  { value: 'nangal', label: 'Nangal', pincode: '505195' },
  { value: 'pabuwas', label: 'Pabuwas', pincode: '505196' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '505197' },
  { value: 'siwani', label: 'Siwani', pincode: '505198' },
  { value: 'taura', label: 'Taura', pincode: '505199' },
  { value: 'tulsi', label: 'Tulsi', pincode: '505203' },
  { value: 'vishwas', label: 'Vishwas', pincode: '505200' },
  { value: 'wanwari', label: 'Wanwari', pincode: '505204' },
  { value: 'zainpur', label: 'Zainpur', pincode: '505205' }
  ],

  'khammam': [
    { value: 'addepally', label: 'Addepally', pincode: '507303' },
    { value: 'allapalli', label: 'Allapalli', pincode: '507131' },
    { value: 'bachupally', label: 'Bachupally', pincode: '507302' },
    { value: 'bharanikota', label: 'Bharanikota', pincode: '507306' },
    { value: 'bhupalpalli', label: 'Bhupalpalli', pincode: '507111' },
    { value: 'borkatpalli', label: 'Borkatpalli', pincode: '507114' },
    { value: 'boyapalli', label: 'Boyapalli', pincode: '507137' },
    { value: 'brindavan', label: 'Brindavan', pincode: '507001' },
    { value: 'chandrugonda', label: 'Chandrugonda', pincode: '507135' },
    { value: 'chegur', label: 'Chegur', pincode: '507214' },
    { value: 'chinthakani', label: 'Chinthakani', pincode: '507002' },
    { value: 'chintalapadu', label: 'Chintalapadu', pincode: '507125' },
    { value: 'choppadandi', label: 'Choppadandi', pincode: '507306' },
    { value: 'dondapadu', label: 'Dondapadu', pincode: '507110' },
    { value: 'dummugudem', label: 'Dummugudem', pincode: '507142' },
    { value: 'ghodapalli', label: 'Ghodapalli', pincode: '507001' },
    { value: 'godavarthi', label: 'Godavarthi', pincode: '507001' },
    { value: 'gundala', label: 'Gundala', pincode: '507204' },
    { value: 'gundrampalli', label: 'Gundrampalli', pincode: '507145' },
    { value: 'huzurabad', label: 'Huzurabad', pincode: '507103' },
    { value: 'ireddygudem', label: 'Ireddygudem', pincode: '507201' },
    { value: 'kanigiri', label: 'Kanigiri', pincode: '507168' },
    { value: 'khanapur', label: 'Khanapur', pincode: '507122' },
    { value: 'khammam-bazar', label: 'Khammam Bazar', pincode: '507001' },
    { value: 'kondalampadu', label: 'Kondalampadu', pincode: '507163' },
    { value: 'kothagudem', label: 'Kothagudem', pincode: '507101' },
    { value: 'kothapeta', label: 'Kothapeta', pincode: '507136' },
    { value: 'laxmidevipeta', label: 'Laxmidevipeta', pincode: '507170' },
    { value: 'madaram', label: 'Madaram', pincode: '507150' },
    { value: 'mallaram', label: 'Mallaram', pincode: '507217' },
    { value: 'manuguru', label: 'Manuguru', pincode: '507203' },
    { value: 'mulkalapalli', label: 'Mulkalapalli', pincode: '507101' },
    { value: 'nagarajpeta', label: 'Nagarajpeta', pincode: '507002' },
    { value: 'nallajerla', label: 'Nallajerla', pincode: '507202' },
    { value: 'neelakantapuram', label: 'Neelakantapuram', pincode: '507127' },
    { value: 'nirmal', label: 'Nirmal', pincode: '507210' },
    { value: 'palair', label: 'Palair', pincode: '507101' },
    { value: 'rajanagaram', label: 'Rajanagaram', pincode: '507109' },
    { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '507212' },
    { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '507211' },
    { value: 'ramavaram', label: 'Ramavaram', pincode: '507110' },
    { value: 'sarasala', label: 'Sarasala', pincode: '507171' },
    { value: 'sattupalli', label: 'Sattupalli', pincode: '507303' },
    { value: 'simhadripuram', label: 'Simhadripuram', pincode: '507154' },
    { value: 'sriyampet', label: 'Sriyampet', pincode: '507001' },
    { value: 'tadvai', label: 'Tadvai', pincode: '507141' },
    { value: 'thirumalayapalem', label: 'Thirumalayapalem', pincode: '507167' },
    { value: 'village-kondalampadu', label: 'Village Kondalampadu', pincode: '507164' },
    { value: 'village-madhira', label: 'Village Madhira', pincode: '507212' },
    { value: 'village-mudigonda', label: 'Village Mudigonda', pincode: '507167' },
    { value: 'village-mulkalapalli', label: 'Village Mulkalapalli', pincode: '507102' },
    { value: 'village-tangellamudi', label: 'Village Tangellamudi', pincode: '507202' },
    { value: 'waddadi', label: 'Waddadi', pincode: '507214' },
    { value: 'wannapalli', label: 'Wannapalli', pincode: '507111' },
    { value: 'yellandu', label: 'Yellandu', pincode: '507473' }
  ],

  'warangal': [
    { value: 'adapally', label: 'Adapally', pincode: '506003' },
    { value: 'bheemaram', label: 'Bheemaram', pincode: '506013' },
    { value: 'bhupalpally', label: 'Bhupalpally', pincode: '506169' },
    { value: 'bongar', label: 'Bongar', pincode: '506153' },
    { value: 'champakshapur', label: 'Champakshapur', pincode: '506366' },
    { value: 'cherlapalli', label: 'Cherlapalli', pincode: '506147' },
    { value: 'chennaipally', label: 'Chennaipally', pincode: '506002' },
    { value: 'chennaipet', label: 'Chennaipet', pincode: '506002' },
    { value: 'chintagattu', label: 'Chintagattu', pincode: '506138' },
    { value: 'gopalapatnam', label: 'Gopalapatnam', pincode: '506331' },
    { value: 'gundla', label: 'Gundla', pincode: '506115' },
    { value: 'hanamkonda', label: 'Hanamkonda', pincode: '506001' },
    { value: 'hasanparthi', label: 'Hasanparthi', pincode: '506331' },
    { value: 'jambagh', label: 'Jambagh', pincode: '506010' },
    { value: 'kachannapet', label: 'Kachannapet', pincode: '506104' },
    { value: 'kakatiya-university', label: 'Kakatiya University', pincode: '506009' },
    { value: 'kasibugga', label: 'Kasibugga', pincode: '506015' },
    { value: 'khilwat', label: 'Khilwat', pincode: '506011' },
    { value: 'kondapalli', label: 'Kondapalli', pincode: '506116' },
    { value: 'kothapet', label: 'Kothapet', pincode: '506002' },
    { value: 'kuravi', label: 'Kuravi', pincode: '506109' },
    { value: 'lakshmipuram', label: 'Lakshmipuram', pincode: '506143' },
    { value: 'malkapur', label: 'Malkapur', pincode: '506004' },
    { value: 'maripeda', label: 'Maripeda', pincode: '506335' },
    { value: 'naspur', label: 'Naspur', pincode: '506005' },
    { value: 'nirmal', label: 'Nirmal', pincode: '506101' },
    { value: 'peddagattu', label: 'Peddagattu', pincode: '506142' },
    { value: 'peddapalli', label: 'Peddapalli', pincode: '506106' },
    { value: 'ponnur', label: 'Ponnur', pincode: '506146' },
    { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '506107' },
    { value: 'ramaravipet', label: 'Ramaravipet', pincode: '506155' },
    { value: 'rathnapuri', label: 'Rathnapuri', pincode: '506004' },
    { value: 'sadashivpet', label: 'Sadashivpet', pincode: '506108' },
    { value: 'santosh-nagar', label: 'Santosh Nagar', pincode: '506018' },
    { value: 'shiva-puri', label: 'Shiva Puri', pincode: '506008' },
    { value: 'sri-ramnagar', label: 'Sri Ramnagar', pincode: '506001' },
    { value: 'srinivaspur', label: 'Srinivaspur', pincode: '506130' },
    { value: 'subedari', label: 'Subedari', pincode: '506002' },
    { value: 'suryapet', label: 'Suryapet', pincode: '506213' },
    { value: 'teegalapalli', label: 'Teegalapalli', pincode: '506127' },
    { value: 'warangal', label: 'Warangal', pincode: '506001' },
    { value: 'warangal-bazar', label: 'Warangal Bazar', pincode: '506001' },
    { value: 'wazirabad', label: 'Wazirabad', pincode: '506006' },
    { value: 'zphs', label: 'ZPHS', pincode: '506005' }
  ],

  'mahbubnagar': [
    { value: 'adloor', label: 'Adloor', pincode: '509001' },
    { value: 'alampur', label: 'Alampur', pincode: '509152' },
    { value: 'allapur', label: 'Allapur', pincode: '509113' },
    { value: 'angadi', label: 'Angadi', pincode: '509203' },
    { value: 'annasagar', label: 'Annasagar', pincode: '509001' },
    { value: 'arelly', label: 'Arelly', pincode: '509153' },
    { value: 'bandapur', label: 'Bandapur', pincode: '509318' },
    { value: 'bandlaguda', label: 'Bandlaguda', pincode: '509203' },
    { value: 'belura', label: 'Belura', pincode: '509304' },
    { value: 'bhagirathipalli', label: 'Bhagirathipalli', pincode: '509154' },
    { value: 'bhaskar-bharati', label: 'Bhaskar Bharati', pincode: '509001' },
    { value: 'bhavanipet', label: 'Bhavanipet', pincode: '509002' },
    { value: 'bhiknoor', label: 'Bhiknoor', pincode: '509312' },
    { value: 'bichkunda', label: 'Bichkunda', pincode: '509372' },
    { value: 'chakrayapet', label: 'Chakrayapet', pincode: '509358' },
    { value: 'chakrawarthy', label: 'Chakrawarthy', pincode: '509001' },
    { value: 'chandampet', label: 'Chandampet', pincode: '509410' },
    { value: 'chennaipally', label: 'Chennaipally', pincode: '509305' },
    { value: 'chintapally', label: 'Chintapally', pincode: '509152' },
    { value: 'dhanwada', label: 'Dhanwada', pincode: '509205' },
    { value: 'dindigul', label: 'Dindigul', pincode: '509126' },
    { value: 'devarkadra', label: 'Devarkadra', pincode: '509204' },
    { value: 'devunoor', label: 'Devunoor', pincode: '509235' },
    { value: 'dorasanpally', label: 'Dorasanpally', pincode: '509305' },
    { value: 'edlapur', label: 'Edlapur', pincode: '509214' },
    { value: 'gadwal', label: 'Gadwal', pincode: '509125' },
    { value: 'gandhinagar', label: 'Gandhinagar', pincode: '509001' },
    { value: 'garpally', label: 'Garpally', pincode: '509223' },
    { value: 'gattu', label: 'Gattu', pincode: '509102' },
    { value: 'hanmapur', label: 'Hanmapur', pincode: '509318' },
    { value: 'jalalpur', label: 'Jalalpur', pincode: '509315' },
    { value: 'jalpally', label: 'Jalpally', pincode: '509001' },
    { value: 'jupally', label: 'Jupally', pincode: '509328' },
    { value: 'kakarla', label: 'Kakarla', pincode: '509127' },
    { value: 'kalwakurthy', label: 'Kalwakurthy', pincode: '509324' },
    { value: 'kanchanpally', label: 'Kanchanpally', pincode: '509119' },
    { value: 'kodair', label: 'Kodair', pincode: '509307' },
    { value: 'kollapur', label: 'Kollapur', pincode: '509102' },
    { value: 'kothapet', label: 'Kothapet', pincode: '509235' },
    { value: 'lingampet', label: 'Lingampet', pincode: '509302' },
    { value: 'madapur', label: 'Madapur', pincode: '509134' },
    { value: 'mahabubnagar-town', label: 'Mahabubnagar Town', pincode: '509001' },
    { value: 'mallapur', label: 'Mallapur', pincode: '509205' },
    { value: 'mallapur', label: 'Mallapur', pincode: '509302' },
    { value: 'malkapur', label: 'Malkapur', pincode: '509301' },
    { value: 'manopad', label: 'Manopad', pincode: '509302' },
    { value: 'mangloor', label: 'Mangloor', pincode: '509004' },
    { value: 'mathampalli', label: 'Mathampalli', pincode: '509315' },
    { value: 'mothkur', label: 'Mothkur', pincode: '509381' },
    { value: 'nagalapalli', label: 'Nagalapalli', pincode: '509002' },
    { value: 'narayanpet', label: 'Narayanpet', pincode: '509210' },
    { value: 'peddapally', label: 'Peddapally', pincode: '509132' },
    { value: 'pillalamarri', label: 'Pillalamarri', pincode: '509302' },
    { value: 'rajapur', label: 'Rajapur', pincode: '509105' },
    { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '509004' },
    { value: 'ranganayakulapally', label: 'Ranganayakulapally', pincode: '509315' },
    { value: 'rangapur', label: 'Rangapur', pincode: '509306' },
    { value: 'shahpur', label: 'Shahpur', pincode: '509001' },
    { value: 'shivarampur', label: 'Shivarampur', pincode: '509001' },
    { value: 'tadwai', label: 'Tadwai', pincode: '509318' },
    { value: 'vempally', label: 'Vempally', pincode: '509001' },
    { value: 'wanaparthy', label: 'Wanaparthy', pincode: '509103' },
    { value: 'yellareddy', label: 'Yellareddy', pincode: '509118' }
  ],

  'nizamabad': [
    { value: 'adloor', label: 'Adloor', pincode: '503002' },
    { value: 'addagudur', label: 'Addagudur', pincode: '503142' },
    { value: 'alapur', label: 'Alapur', pincode: '503111' },
    { value: 'banswada', label: 'Banswada', pincode: '503187' },
    { value: 'bellampalli', label: 'Bellampalli', pincode: '503102' },
    { value: 'bhagathpura', label: 'Bhagathpura', pincode: '503222' },
    { value: 'bhainsa', label: 'Bhainsa', pincode: '503185' },
    { value: 'bichkunda', label: 'Bichkunda', pincode: '503325' },
    { value: 'birkur', label: 'Birkur', pincode: '503213' },
    { value: 'chandur', label: 'Chandur', pincode: '503204' },
    { value: 'chinnur', label: 'Chinnur', pincode: '503227' },
    { value: 'chintakunta', label: 'Chintakunta', pincode: '503227' },
    { value: 'chintapalli', label: 'Chintapalli', pincode: '503208' },
    { value: 'choutpally', label: 'Choutpally', pincode: '503229' },
    { value: 'dichpally', label: 'Dichpally', pincode: '503175' },
    { value: 'gandhinagar', label: 'Gandhinagar', pincode: '503001' },
    { value: 'gundaram', label: 'Gundaram', pincode: '503236' },
    { value: 'hamidpally', label: 'Hamidpally', pincode: '503230' },
    { value: 'jagarlamudi', label: 'Jagarlamudi', pincode: '503111' },
    { value: 'jammikunta', label: 'Jammikunta', pincode: '503001' },
    { value: 'jankapur', label: 'Jankapur', pincode: '503222' },
    { value: 'kalvapally', label: 'Kalvapally', pincode: '503222' },
    { value: 'kamareddy', label: 'Kamareddy', pincode: '503111' },
    { value: 'kamareddy-tp', label: 'Kamareddy TP', pincode: '503110' },
    { value: 'kandriga', label: 'Kandriga', pincode: '503136' },
    { value: 'kothapalli', label: 'Kothapalli', pincode: '503222' },
    { value: 'kothapet', label: 'Kothapet', pincode: '503220' },
    { value: 'kotagiri', label: 'Kotagiri', pincode: '503315' },
    { value: 'lalapet', label: 'Lalapet', pincode: '503214' },
    { value: 'madnoor', label: 'Madnoor', pincode: '503305' },
    { value: 'mangapur', label: 'Mangapur', pincode: '503225' },
    { value: 'manchippa', label: 'Manchippa', pincode: '503211' },
    { value: 'mandal', label: 'Mandal', pincode: '503214' },
    { value: 'medpally', label: 'Medpally', pincode: '503302' },
    { value: 'mominpally', label: 'Mominpally', pincode: '503217' },
    { value: 'nagapur', label: 'Nagapur', pincode: '503001' },
    { value: 'nandipet', label: 'Nandipet', pincode: '503306' },
    { value: 'nizamabad-town', label: 'Nizamabad Town', pincode: '503001' },
    { value: 'nizampet', label: 'Nizampet', pincode: '503213' },
    { value: 'peddapally', label: 'Peddapally', pincode: '503225' },
    { value: 'ponnur', label: 'Ponnur', pincode: '503313' },
    { value: 'raghopur', label: 'Raghapur', pincode: '503332' },
    { value: 'ramayampet', label: 'Ramayampet', pincode: '503206' },
    { value: 'sadasivapet', label: 'Sadasivapet', pincode: '503203' },
    { value: 'sagar', label: 'Sagar', pincode: '503305' },
    { value: 'sailapur', label: 'Sailapur', pincode: '503228' },
    { value: 'sangareddy', label: 'Sangareddy', pincode: '503302' },
    { value: 'sirkonda', label: 'Sirkonda', pincode: '503114' },
    { value: 'talmadla', label: 'Talmadla', pincode: '503221' },
    { value: 'yakutpura', label: 'Yakutpura', pincode: '503221' }
  ],

  'karimnagar': [
    { value: 'alair', label: 'Alair', pincode: '506101' },
    { value: 'ankapur', label: 'Ankapur', pincode: '505539' },
    { value: 'bogatla', label: 'Bogatla', pincode: '505001' },
    { value: 'chintakunta', label: 'Chintakunta', pincode: '505469' },
    { value: 'choppadandi', label: 'Choppadandi', pincode: '505415' },
    { value: 'congajala', label: 'Congajala', pincode: '505484' },
    { value: 'elgandal', label: 'Elgandal', pincode: '505401' },
    { value: 'ganneruvaram', label: 'Ganneruvaram', pincode: '505531' },
    { value: 'gopalpur', label: 'Gopalpur', pincode: '505528' },
    { value: 'habsiguda', label: 'Habsiguda', pincode: '500007' },
    { value: 'hanamkonda', label: 'Hanamkonda', pincode: '506001' },
    { value: 'huzurabad', label: 'Huzurabad', pincode: '505468' },
    { value: 'jammikunta', label: 'Jammikunta', pincode: '505475' },
    { value: 'karimnagar', label: 'Karimnagar', pincode: '505001' },
    { value: 'kothapalli', label: 'Kothapalli', pincode: '505106' },
    { value: 'kothirampur', label: 'Kothirampur', pincode: '505001' },
    { value: 'kumram-bheem', label: 'Kumram Bheem', pincode: '505529' },
    { value: 'manakondur', label: 'Manakondur', pincode: '505469' },
    { value: 'manthani', label: 'Manthani', pincode: '505184' },
    { value: 'malkapur', label: 'Malkapur', pincode: '505524' },
    { value: 'metpally', label: 'Metpally', pincode: '505325' },
    { value: 'mulkanur', label: 'Mulkanur', pincode: '505528' },
    { value: 'nagunur', label: 'Nagunur', pincode: '505215' },
    { value: 'naspur', label: 'Naspur', pincode: '505214' },
    { value: 'padmanagar', label: 'Padmanagar', pincode: '505209' },
    { value: 'pedda-palli', label: 'Pedda Palli', pincode: '505503' },
    { value: 'raikal', label: 'Raikal', pincode: '505460' },
    { value: 'ramagundam', label: 'Ramagundam', pincode: '505208' },
    { value: 'rampur', label: 'Rampur', pincode: '505307' },
    { value: 'sircilla', label: 'Sircilla', pincode: '505301' },
    { value: 'srikantapur', label: 'Srikantapur', pincode: '505521' },
    { value: 'thimmapur', label: 'Thimmapur', pincode: '505527' },
    { value: 'velair', label: 'Velair', pincode: '505204' },
    { value: 'vemulawada', label: 'Vemulawada', pincode: '505302' },
    { value: 'village-bore', label: 'Village Bore', pincode: '505212' },
    { value: 'vimanapuri', label: 'Vimanapuri', pincode: '505210' },
  ],

  'siddipet': [
    { value: 'alampur', label: 'Alampur', pincode: '502103' },
    { value: 'bhaskarapuram', label: 'Bhaskarapuram', pincode: '502249' },
    { value: 'bommalaramaram', label: 'Bommalaramaram', pincode: '502104' },
    { value: 'businayapally', label: 'Businayapally', pincode: '502276' },
    { value: 'chintalapally', label: 'Chintalapally', pincode: '502278' },
    { value: 'donthi', label: 'Donthi', pincode: '502275' },
    { value: 'gajwel', label: 'Gajwel', pincode: '502278' },
    { value: 'gandhinagar', label: 'Gandhinagar', pincode: '502276' },
    { value: 'gandhiwadi', label: 'Gandhiwadi', pincode: '502277' },
    { value: 'gurjapally', label: 'Gurjapally', pincode: '502107' },
    { value: 'intekala', label: 'Intekala', pincode: '502247' },
    { value: 'jagadevpally', label: 'Jagadevpally', pincode: '502105' },
    { value: 'kandlakoya', label: 'Kandlakoya', pincode: '502109' },
    { value: 'kareemabad', label: 'Kareemabad', pincode: '502278' },
    { value: 'kondapaka', label: 'Kondapaka', pincode: '502284' },
    { value: 'kothapalli', label: 'Kothapalli', pincode: '502279' },
    { value: 'malkapur', label: 'Malkapur', pincode: '502278' },
    { value: 'manoharabad', label: 'Manoharabad', pincode: '502277' },
    { value: 'mothe', label: 'Mothe', pincode: '502277' },
    { value: 'musalpur', label: 'Musalpur', pincode: '502278' },
    { value: 'nakrekal', label: 'Nakrekal', pincode: '502284' },
    { value: 'peddagandhi', label: 'Peddagandhi', pincode: '502273' },
    { value: 'siddipet', label: 'Siddipet', pincode: '502103' },
    { value: 'turkapally', label: 'Turkapally', pincode: '502273' },
    { value: 'vempally', label: 'Vempally', pincode: '502278' },
    { value: 'yellareddyguda', label: 'Yellareddyguda', pincode: '502274' }
  ],
'adilabad': [
  { value: 'adilabad-town', label: 'Adilabad Town', pincode: '504001' },
  { value: 'ankoli', label: 'Ankoli', pincode: '504308' },
  { value: 'asifabad', label: 'Asifabad', pincode: '504293' },
  { value: 'bellampalli', label: 'Bellampalli', pincode: '504251' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '504103' },
  { value: 'boath', label: 'Boath', pincode: '504304' },
  { value: 'chennur', label: 'Chennur', pincode: '504201' },
  { value: 'daboli', label: 'Daboli', pincode: '504309' },
  { value: 'gopalpur', label: 'Gopalpur', pincode: '504312' },
  { value: 'gudihatnur', label: 'Gudihatnur', pincode: '504308' },
  { value: 'ichoda', label: 'Ichoda', pincode: '504307' },
  { value: 'indervelly', label: 'Indervelly', pincode: '504346' },
  { value: 'jainad', label: 'Jainad', pincode: '504309' },
  { value: 'kasipet', label: 'Kasipet', pincode: '504231' },
  { value: 'khanapur', label: 'Khanapur', pincode: '504203' },
  { value: 'kothari', label: 'Kothari', pincode: '504310' },
  { value: 'kuntala', label: 'Kuntala', pincode: '504215' },
  { value: 'luxettipet', label: 'Luxettipet', pincode: '504231' },
  { value: 'mandamarri', label: 'Mandamarri', pincode: '504231' },
  { value: 'mancherial', label: 'Mancherial', pincode: '504208' },
  { value: 'narnoor', label: 'Narnoor', pincode: '504346' },
  { value: 'neradigonda', label: 'Neradigonda', pincode: '504323' },
  { value: 'nirmal', label: 'Nirmal', pincode: '504106' },
  { value: 'rebbena', label: 'Rebbena', pincode: '504292' },
  { value: 'sarangapur', label: 'Sarangapur', pincode: '504110' },
  { value: 'tandur', label: 'Tandur', pincode: '504272' },
  { value: 'tamsi', label: 'Tamsi', pincode: '504312' },
  { value: 'uddampur', label: 'Uddampur', pincode: '504323' },
  { value: 'uttnoor', label: 'Uttnoor', pincode: '504311' },
  { value: 'vemanpally', label: 'Vemanpally', pincode: '504214' },
  { value: 'wankidi', label: 'Wankidi', pincode: '504295' }
  ],

  'nalgonda': [
  { value: 'anakapalli', label: 'Anakapalli', pincode: '508001' },
  { value: 'arjalabavi', label: 'Arjalabavi', pincode: '508002' },
  { value: 'cherlapally', label: 'Cherlapally', pincode: '508001' },
  { value: 'chandur', label: 'Chandur', pincode: '508255' },
  { value: 'chityal', label: 'Chityal', pincode: '508114' },
  { value: 'chundur', label: 'Chundur', pincode: '508246' },
  { value: 'devarakonda', label: 'Devarakonda', pincode: '508248' },
  { value: 'dindi', label: 'Dindi', pincode: '508258' },
  { value: 'durajpally', label: 'Durajpally', pincode: '508211' },
  { value: 'gaddipally', label: 'Gaddipally', pincode: '508201' },
  { value: 'gollapalli', label: 'Gollapalli', pincode: '508254' },
  { value: 'gopalapuram', label: 'Gopalapuram', pincode: '508114' },
  { value: 'gundlapalli', label: 'Gundlapalli', pincode: '508115' },
  { value: 'halia', label: 'Halia', pincode: '508202' },
  { value: 'indrapalanagaram', label: 'Indrapalanagaram', pincode: '508201' },
  { value: 'kanagal', label: 'Kanagal', pincode: '508255' },
  { value: 'kattangur', label: 'Kattangur', pincode: '508205' },
  { value: 'kodad', label: 'Kodad', pincode: '508206' },
  { value: 'kondamallepally', label: 'Kondamallepally', pincode: '508243' },
  { value: 'madgulapally', label: 'Madgulapally', pincode: '508238' },
  { value: 'miryalguda', label: 'Miryalguda', pincode: '508207' },
  { value: 'mothkur', label: 'Mothkur', pincode: '508277' },
  { value: 'munugode', label: 'Munugode', pincode: '508244' },
  { value: 'nakrekal', label: 'Nakrekal', pincode: '508211' },
  { value: 'nalgonda-town', label: 'Nalgonda Town', pincode: '508001' },
  { value: 'narketpally', label: 'Narketpally', pincode: '508254' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '508253' },
  { value: 'nereducherla', label: 'Nereducherla', pincode: '508218' },
  { value: 'nidmanoor', label: 'Nidmanoor', pincode: '508278' },
  { value: 'pillalamarri', label: 'Pillalamarri', pincode: '508001' },
  { value: 'peddavoora', label: 'Peddavoora', pincode: '508266' },
  { value: 'ramannapeta', label: 'Ramannapeta', pincode: '508113' },
  { value: 'sagar', label: 'Sagar', pincode: '508213' },
  { value: 'sirpur', label: 'Sirpur', pincode: '508257' },
  { value: 'suryapet', label: 'Suryapet', pincode: '508213' },
  { value: 'thipparthy', label: 'Thipparthy', pincode: '508247' },
  { value: 'tirumalagiri', label: 'Tirumalagiri', pincode: '508223' },
  { value: 'tripuraram', label: 'Tripuraram', pincode: '508207' },
  { value: 'vallapuram', label: 'Vallapuram', pincode: '508218' },
  { value: 'vangoor', label: 'Vangoor', pincode: '508279' },
  { value: 'vellatur', label: 'Vellatur', pincode: '508221' }
  ],

  'suryapet': [
  { value: 'adavi-bhanagiri', label: 'Adavi Bhanagiri', pincode: '508213' },
  { value: 'anatharam', label: 'Anatharam', pincode: '508233' },
  { value: 'athmakur', label: 'Athmakur', pincode: '508111' },
  { value: 'chivvemla', label: 'Chivvemla', pincode: '508213' },
  { value: 'damarcherla', label: 'Damarcherla', pincode: '508355' },
  { value: 'dondapadu', label: 'Dondapadu', pincode: '508222' },
  { value: 'garidepally', label: 'Garidepally', pincode: '508201' },
  { value: 'gollaguda', label: 'Gollaguda', pincode: '508213' },
  { value: 'huzurnagar', label: 'Huzurnagar', pincode: '508204' },
  { value: 'ippalapalli', label: 'Ippalapalli', pincode: '508207' },
  { value: 'jajireddygudem', label: 'Jajireddygudem', pincode: '508223' },
  { value: 'kodad', label: 'Kodad', pincode: '508206' },
  { value: 'mallareddygudem', label: 'Mallareddygudem', pincode: '508245' },
  { value: 'mattampally', label: 'Mattampally', pincode: '508204' },
  { value: 'mothey', label: 'Mothey', pincode: '508212' },
  { value: 'munagala', label: 'Munagala', pincode: '508233' },
  { value: 'nagaram', label: 'Nagaram', pincode: '508234' },
  { value: 'nandipadu', label: 'Nandipadu', pincode: '508207' },
  { value: 'narayanagudem', label: 'Narayanagudem', pincode: '508223' },
  { value: 'nuthankal', label: 'Nuthankal', pincode: '508221' },
  { value: 'palakeedu', label: 'Palakeedu', pincode: '508212' },
  { value: 'penpahad', label: 'Penpahad', pincode: '508213' },
  { value: 'ponnala', label: 'Ponnala', pincode: '508213' },
  { value: 'ramaiahpalli', label: 'Ramaiahpalli', pincode: '508201' },
  { value: 'ramapuram', label: 'Ramapuram', pincode: '508233' },
  { value: 'siripuram', label: 'Siripuram', pincode: '508234' },
  { value: 'suryapet-town', label: 'Suryapet Town', pincode: '508213' },
  { value: 'thungathurthy', label: 'Thungathurthy', pincode: '508280' },
  { value: 'vellanki', label: 'Vellanki', pincode: '508233' },
  { value: 'yadagirigutta', label: 'Yadagirigutta', pincode: '508207' }
  ],

  'jagtial': [
  { value: 'adhirajupalem', label: 'Adhirajupalem', pincode: '505327' },
  { value: 'allipur', label: 'Allipur', pincode: '505329' },
  { value: 'birpur', label: 'Birpur', pincode: '505330' },
  { value: 'buggaram', label: 'Buggaram', pincode: '505455' },
  { value: 'chinthakunta', label: 'Chinthakunta', pincode: '505454' },
  { value: 'dharmapuri', label: 'Dharmapuri', pincode: '505425' },
  { value: 'elgandal', label: 'Elgandal', pincode: '505401' },
  { value: 'gollapalli', label: 'Gollapalli', pincode: '505532' },
  { value: 'ibrahimpatnam', label: 'Ibrahimpatnam', pincode: '505450' },
  { value: 'jagtial-rural', label: 'Jagtial Rural', pincode: '505327' },
  { value: 'jagtial-town', label: 'Jagtial Town', pincode: '505327' },
  { value: 'kalleda', label: 'Kalleda', pincode: '505405' },
  { value: 'kondagattu', label: 'Kondagattu', pincode: '505452' },
  { value: 'korutla', label: 'Korutla', pincode: '505326' },
  { value: 'mallial', label: 'Mallial', pincode: '505452' },
  { value: 'metpalli', label: 'Metpalli', pincode: '505325' },
  { value: 'mothadampalli', label: 'Mothadampalli', pincode: '505529' },
  { value: 'nagnur', label: 'Nagnur', pincode: '505401' },
  { value: 'pegadapalli', label: 'Pegadapalli', pincode: '505532' },
  { value: 'raikal', label: 'Raikal', pincode: '505460' },
  { value: 'sarangapur', label: 'Sarangapur', pincode: '505454' },
  { value: 'sarangpur', label: 'Sarangpur', pincode: '505329' },
  { value: 'tarakaram', label: 'Tarakaram', pincode: '505455' },
  { value: 'velgatur', label: 'Velgatur', pincode: '505526' },
  { value: 'vellulla', label: 'Vellulla', pincode: '505454' },
  { value: 'yendapalli', label: 'Yendapalli', pincode: '505405' }
  ],

  'jangaon': [
  { value: 'adavi-mallaram', label: 'Adavi Mallaram', pincode: '506167' },
  { value: 'alair', label: 'Alair', pincode: '506101' },
  { value: 'ameenabad', label: 'Ameenabad', pincode: '506310' },
  { value: 'bachannapet', label: 'Bachannapet', pincode: '506221' },
  { value: 'cherial', label: 'Cherial', pincode: '506223' },
  { value: 'chinnakodur', label: 'Chinnakodur', pincode: '506222' },
  { value: 'devaruppula', label: 'Devaruppula', pincode: '506302' },
  { value: 'dharmajipet', label: 'Dharmajipet', pincode: '506345' },
  { value: 'gundala', label: 'Gundala', pincode: '506344' },
  { value: 'ivelly', label: 'Ivelly', pincode: '506167' },
  { value: 'jangaon-rural', label: 'Jangaon Rural', pincode: '506167' },
  { value: 'jangaon-town', label: 'Jangaon Town', pincode: '506167' },
  { value: 'jeedikal', label: 'Jeedikal', pincode: '506313' },
  { value: 'kallem', label: 'Kallem', pincode: '506224' },
  { value: 'lingalaghanpur', label: 'Lingalaghanpur', pincode: '506201' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '506319' },
  { value: 'narmetta', label: 'Narmetta', pincode: '506175' },
  { value: 'pembarthy', label: 'Pembarthy', pincode: '506169' },
  { value: 'raghavapur', label: 'Raghavapur', pincode: '506223' },
  { value: 'ramannapet', label: 'Ramannapet', pincode: '506315' },
  { value: 'station-ghanpur', label: 'Station Ghanpur', pincode: '506201' },
  { value: 'tarigoppula', label: 'Tarigoppula', pincode: '506172' },
  { value: 'velair', label: 'Velair', pincode: '506135' },
  { value: 'warangal-highway', label: 'Warangal Highway', pincode: '506167' },
  { value: 'yellareddy-pet', label: 'Yellareddy Pet', pincode: '506311' },
  { value: 'zaffergadh', label: 'Zaffergadh', pincode: '506316' }
],

  'nirmal': [
  { value: 'bheemaram', label: 'Bheemaram', pincode: '504106' },
  { value: 'balkonda', label: 'Balkonda', pincode: '504203' },
  { value: 'chincholi', label: 'Chincholi', pincode: '504203' },
  { value: 'dandepalli', label: 'Dandepalli', pincode: '504203' },
  { value: 'gambhiraopet', label: 'Gambhiraopet', pincode: '504204' },
  { value: 'gundala', label: 'Gundala', pincode: '504103' },
  { value: 'kanukunta', label: 'Kanukunta', pincode: '504106' },
  { value: 'kotapalli', label: 'Kotapalli', pincode: '504205' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '504107' },
  { value: 'mallapur', label: 'Mallapur', pincode: '504107' },
  { value: 'nirmal', label: 'Nirmal', pincode: '504106' },
  { value: 'raipalli', label: 'Raipalli', pincode: '504108' },
  { value: 'shakarpally', label: 'Shakarpally', pincode: '504107' },
  { value: 'tamsi', label: 'Tamsi', pincode: '504205' },
  { value: 'yellareddy', label: 'Yellareddy', pincode: '504201' },
  { value: 'ponnaram', label: 'Ponnaram', pincode: '504106' },
  { value: 'chandapur', label: 'Chandapur', pincode: '504106' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '504204' }
  ],

  'medak': [
  { value: 'alwal', label: 'Alwal', pincode: '500010' },
  { value: 'banswada', label: 'Banswada', pincode: '503187' },
  { value: 'bhiknoor', label: 'Bhiknoor', pincode: '503308' },
  { value: 'duddeda', label: 'Duddeda', pincode: '502276' },
  { value: 'gaonpalli', label: 'Gaonpalli', pincode: '502281' },
  { value: 'jagdevpur', label: 'Jagdevpur', pincode: '502279' },
  { value: 'kamareddy', label: 'Kamareddy', pincode: '503111' },
  { value: 'medak', label: 'Medak', pincode: '502110' },
  { value: 'narsapur', label: 'Narsapur', pincode: '502313' },
  { value: 'pocharam', label: 'Pocharam', pincode: '502278' },
  { value: 'sadashivpet', label: 'Sadashivpet', pincode: '502291' },
  { value: 'singur', label: 'Singur', pincode: '502213' },
  { value: 'shankarampet', label: 'Shankarampet', pincode: '502218' },
  { value: 'tangellamudi', label: 'Tangellamudi', pincode: '502278' },
  { value: 'tupran', label: 'Tupran', pincode: '502334' },
  { value: 'zaheerabad', label: 'Zaheerabad', pincode: '502220' },
  { value: 'malkapur', label: 'Malkapur', pincode: '502273' }
  ],

  'vikarabad': [
  { value: 'alampur', label: 'Alampur', pincode: '501102' },
  { value: 'balkonda', label: 'Balkonda', pincode: '501101' },
  { value: 'bisanwadi', label: 'Bisanwadi', pincode: '501102' },
  { value: 'chapal', label: 'Chapal', pincode: '501101' },
  { value: 'chevella', label: 'Chevella', pincode: '501503' },
  { value: 'gandipet', label: 'Gandipet', pincode: '501520' },
  { value: 'kothapet', label: 'Kothapet', pincode: '501501' },
  { value: 'madgul', label: 'Madgul', pincode: '501103' },
  { value: 'narayanpet', label: 'Narayanpet', pincode: '501501' },
  { value: 'peddemul', label: 'Peddemul', pincode: '501142' },
  { value: 'vikarabad', label: 'Vikarabad', pincode: '501101' },
  { value: 'yeldurthy', label: 'Yeldurthy', pincode: '501504' },
  { value: 'zangapur', label: 'Zangapur', pincode: '501102' },
  { value: 'arambhavi', label: 'Arambhavi', pincode: '501103' },
  { value: 'bodepalli', label: 'Bodepalli', pincode: '501103' },
  { value: 'gajwel', label: 'Gajwel', pincode: '501301' },
  { value: 'manneguda', label: 'Manneguda', pincode: '501142' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '501124' },
  { value: 'sadasivpet', label: 'Sadasivpet', pincode: '501204' },
  { value: 'tandur', label: 'Tandur', pincode: '501141' }
  ],

  'bhupalpally': [
  { value: 'adloor', label: 'Adloor', pincode: '506169' },
  { value: 'bandreddypalli', label: 'Bandreddypalli', pincode: '506169' },
  { value: 'bhupalpally', label: 'Bhupalpally', pincode: '506169' },
  { value: 'chintakunta', label: 'Chintakunta', pincode: '506168' },
  { value: 'jagtial', label: 'Jagtial', pincode: '505327' },
  { value: 'kaghaznagar', label: 'Kaghaznagar', pincode: '504301' },
  { value: 'kondapur', label: 'Kondapur', pincode: '506169' },
  { value: 'mallampally', label: 'Mallampally', pincode: '506170' },
  { value: 'manthani', label: 'Manthani', pincode: '505184' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '505172' },
  { value: 'rajura', label: 'Rajura', pincode: '506371' },
  { value: 'sathupalli', label: 'Sathupalli', pincode: '506303' },
  { value: 'shivunipalli', label: 'Shivunipalli', pincode: '506169' },
  { value: 'telangana', label: 'Telangana', pincode: '506101' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '506171' }
  ],

  'bhuvanagiri': [
  { value: 'alair', label: 'Alair', pincode: '508101' },
  { value: 'bhuvanagiri', label: 'Bhuvanagiri', pincode: '508116' },
  { value: 'choutuppal', label: 'Choutuppal', pincode: '508252' },
  { value: 'epur', label: 'Epur', pincode: '508101' },
  { value: 'gudur', label: 'Gudur', pincode: '508113' },
  { value: 'kondur', label: 'Kondur', pincode: '508111' },
  { value: 'malkapur', label: 'Malkapur', pincode: '508118' },
  { value: 'narsampet', label: 'Narsampet', pincode: '508111' },
  { value: 'pocharam', label: 'Pocharam', pincode: '508117' },
  { value: 'raviryal', label: 'Raviryal', pincode: '508116' },
  { value: 'shamirpet', label: 'Shamirpet', pincode: '508112' },
  { value: 'tungaturthi', label: 'Tungaturthi', pincode: '508110' },
  { value: 'yadagirigutta', label: 'Yadagirigutta', pincode: '508115' },
  { value: 'bhaskarapalli', label: 'Bhaskarapalli', pincode: '508118' },
  { value: 'gundlapally', label: 'Gundlapally', pincode: '508113' },
  { value: 'peddapur', label: 'Peddapur', pincode: '508116' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '508114' }
  ],

  'asifabad': [
  { value: 'adilabad', label: 'Adilabad', pincode: '504001' },
  { value: 'alapur', label: 'Alapur', pincode: '504307' },
  { value: 'asifabad', label: 'Asifabad', pincode: '504293' },
  { value: 'baba-pet', label: 'Baba Pet', pincode: '504302' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '504305' },
  { value: 'dharur', label: 'Dharur', pincode: '504205' },
  { value: 'jainad', label: 'Jainad', pincode: '504309' },
  { value: 'kotapalli', label: 'Kotapalli', pincode: '504306' },
  { value: 'koutala', label: 'Koutala', pincode: '504208' },
  { value: 'luknow', label: 'Luknow', pincode: '504306' },
  { value: 'mandamarri', label: 'Mandamarri', pincode: '504302' },
  { value: 'rajura', label: 'Rajura', pincode: '504306' },
  { value: 'revoor', label: 'Revoor', pincode: '504303' },
  { value: 'sirsilla', label: 'Sirsilla', pincode: '504201' },
  { value: 'talamadugu', label: 'Talamadugu', pincode: '504308' },
  { value: 'bompalli', label: 'Bompalli', pincode: '504305' },
  { value: 'chandur', label: 'Chandur', pincode: '504209' },
  { value: 'gundala', label: 'Gundala', pincode: '504304' },
  { value: 'kandlur', label: 'Kandlur', pincode: '504205' },
  { value: 'mancherial', label: 'Mancherial', pincode: '504208' },
  { value: 'sarampalli', label: 'Sarampalli', pincode: '504302' },
  { value: 'tadkapalli', label: 'Tadkapalli', pincode: '504306' }
  ],

  'peddapalli': [
  { value: 'bhupathipalli', label: 'Bhupathipalli', pincode: '505172' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '505172' },
  { value: 'gudem', label: 'Gudem', pincode: '505171' },
  { value: 'jagityal', label: 'Jagityal', pincode: '505327' },
  { value: 'kamanpur', label: 'Kamanpur', pincode: '505212' },
  { value: 'karimnagar', label: 'Karimnagar', pincode: '505001' },
  { value: 'manthani', label: 'Manthani', pincode: '505184' },
  { value: 'mutharam', label: 'Mutharam', pincode: '505187' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '505172' },
  { value: 'ramagundam', label: 'Ramagundam', pincode: '505208' },
  { value: 'ravadipalli', label: 'Ravadipalli', pincode: '505173' },
  { value: 'srirampur', label: 'Srirampur', pincode: '505103' },
  { value: 'suryapet', label: 'Suryapet', pincode: '505404' },
  { value: 'tandoor', label: 'Tandoor', pincode: '505183' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '505113' },
  { value: 'yellareddy', label: 'Yellareddy', pincode: '505305' }
  ],

  'wanaparthy': [
  { value: 'addakal', label: 'Addakal', pincode: '509335' },
  { value: 'anantapur', label: 'Anantapur', pincode: '509003' },
  { value: 'balkonda', label: 'Balkonda', pincode: '509303' },
  { value: 'chalvadi', label: 'Chalvadi', pincode: '509303' },
  { value: 'chegunta', label: 'Chegunta', pincode: '509401' },
  { value: 'kowdipalli', label: 'Kowdipalli', pincode: '509352' },
  { value: 'nagarkurnool', label: 'Nagarkurnool', pincode: '509209' },
  { value: 'peddagattu', label: 'Peddagattu', pincode: '509131' },
  { value: 'siddapur', label: 'Siddapur', pincode: '509307' },
  { value: 'sirpur', label: 'Sirpur', pincode: '509301' },
  { value: 'wanaparthy', label: 'Wanaparthy', pincode: '509103' },
  { value: 'gurrampalle', label: 'Gurrampalle', pincode: '509331' },
  { value: 'lambapur', label: 'Lambapur', pincode: '509351' },
  { value: 'malkapur', label: 'Malkapur', pincode: '509308' },
  { value: 'naregal', label: 'Naregal', pincode: '509209' },
  { value: 'ramapuram', label: 'Ramapuram', pincode: '509314' },
  { value: 'timmareddy', label: 'Timmareddy', pincode: '509331' }
  ],

  'narayanpet': [
  { value: 'addagudur', label: 'Addagudur', pincode: '509210' },
  { value: 'bhavapur', label: 'Bhavapur', pincode: '509230' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '509214' },
  { value: 'girithal', label: 'Girithal', pincode: '509226' },
  { value: 'gurukunta', label: 'Gurukunta', pincode: '509229' },
  { value: 'jagannadhapur', label: 'Jagannadhapur', pincode: '509213' },
  { value: 'jillellapally', label: 'Jillellapally', pincode: '509230' },
  { value: 'karampalle', label: 'Karampalle', pincode: '509234' },
  { value: 'narayanpet', label: 'Narayanpet', pincode: '509210' },
  { value: 'peddanapalli', label: 'Peddanapalli', pincode: '509234' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '509232' },
  { value: 'siddipet', label: 'Siddipet', pincode: '509225' },
  { value: 'tadlapalle', label: 'Tadlapalle', pincode: '509212' },
  { value: 'vaddipalle', label: 'Vaddipalle', pincode: '509211' },
  { value: 'village-venkatapur', label: 'Village Venkatapur', pincode: '509208' },
  { value: 'yerragondapalem', label: 'Yerragondapalem', pincode: '509227' }
  ],

  'nagarkurnool': [
  { value: 'bhongir', label: 'Bhongir', pincode: '509202' },
  { value: 'bogaram', label: 'Bogaram', pincode: '509212' },
  { value: 'chintakunta', label: 'Chintakunta', pincode: '509213' },
  { value: 'gandipet', label: 'Gandipet', pincode: '509206' },
  { value: 'kothur', label: 'Kothur', pincode: '509207' },
  { value: 'nagarkurnool', label: 'Nagarkurnool', pincode: '509209' },
  { value: 'pillalamarri', label: 'Pillalamarri', pincode: '509225' },
  { value: 'raikal', label: 'Raikal', pincode: '509204' },
  { value: 'sangareddy', label: 'Sangareddy', pincode: '502001' },
  { value: 'siddipet', label: 'Siddipet', pincode: '509225' },
  { value: 'wargal', label: 'Wargal', pincode: '509202' },
  { value: 'ammarapet', label: 'Ammarapet', pincode: '509230' },
  { value: 'anjanapur', label: 'Anjanapur', pincode: '509208' },
  { value: 'bholakpur', label: 'Bholakpur', pincode: '509221' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '509206' },
  { value: 'kandlaguda', label: 'Kandlaguda', pincode: '509214' },
  { value: 'nagalapally', label: 'Nagalapally', pincode: '509220' },
  { value: 'takellapally', label: 'Takellapally', pincode: '509213' }
  ],

  'gadwal': [
  { value: 'adloor', label: 'Adloor', pincode: '509125' },
  { value: 'gadwal', label: 'Gadwal', pincode: '509125' },
  { value: 'gajjalapally', label: 'Gajjalapally', pincode: '509124' },
  { value: 'kotturu', label: 'Kotturu', pincode: '509124' },
  { value: 'nadikuda', label: 'Nadikuda', pincode: '509126' },
  { value: 'palakurthi', label: 'Palakurthi', pincode: '509124' },
  { value: 'rajpally', label: 'Rajpally', pincode: '509128' },
  { value: 'ramannapet', label: 'Ramannapet', pincode: '509127' },
  { value: 'siddapur', label: 'Siddapur', pincode: '509124' },
  { value: 'waddagudam', label: 'Waddagudam', pincode: '509125' },
  { value: 'allapur', label: 'Allapur', pincode: '509125' },
  { value: 'bhaskarapur', label: 'Bhaskarapur', pincode: '509125' },
  { value: 'dudekula', label: 'Dudekula', pincode: '509124' },
  { value: 'gokulapally', label: 'Gokulapally', pincode: '509124' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '509128' },
  { value: 'sangayapally', label: 'Sangayapally', pincode: '509125' }
  ],

   'kothagudem': [
  { value: 'adilabad', label: 'Adilabad', pincode: '507101' },
  { value: 'bapujinagar', label: 'Bapujinagar', pincode: '507101' },
  { value: 'bhadradri', label: 'Bhadradri', pincode: '507101' },
  { value: 'chunchupalle', label: 'Chunchupalle', pincode: '507101' },
  { value: 'godavari', label: 'Godavari', pincode: '507101' },
  { value: 'kothagudem', label: 'Kothagudem', pincode: '507101' },
  { value: 'madhapur', label: 'Madhapur', pincode: '507115' },
  { value: 'manuguru', label: 'Manuguru', pincode: '507132' },
  { value: 'mulkalapally', label: 'Mulkalapally', pincode: '507107' },
  { value: 'rampur', label: 'Rampur', pincode: '507104' },
  { value: 'sathupalli', label: 'Sathupalli', pincode: '507303' },
  { value: 'velugumatla', label: 'Velugumatla', pincode: '507101' },
  { value: 'bandagudem', label: 'Bandagudem', pincode: '507101' },
  { value: 'chinagudem', label: 'Chinagudem', pincode: '507103' },
  { value: 'godavari-basin', label: 'Godavari Basin', pincode: '507101' },
  { value: 'jaggayyapet', label: 'Jaggayyapet', pincode: '507111' },
  { value: 'kondai', label: 'Kondai', pincode: '507105' },
  { value: 'paloncha', label: 'Paloncha', pincode: '507115' },
  { value: 'somavaram', label: 'Somavaram', pincode: '507107' }
  ],

  'siricilla': [
  { value: 'adloor', label: 'Adloor', pincode: '505302' },
  { value: 'burugupally', label: 'Burugupally', pincode: '505303' },
  { value: 'chinnakodur', label: 'Chinnakodur', pincode: '505473' },
  { value: 'gajwel', label: 'Gajwel', pincode: '505275' },
  { value: 'kodur', label: 'Kodur', pincode: '505212' },
  { value: 'pedda kodur', label: 'Pedda Kodur', pincode: '505303' },
  { value: 'sircilla', label: 'Sircilla', pincode: '505301' },
  { value: 'thimmapur', label: 'Thimmapur', pincode: '505302' },
  { value: 'vempalli', label: 'Vempalli', pincode: '505211' },
  { value: 'baddipalle', label: 'Baddipalle', pincode: '505303' },
  { value: 'boraipalle', label: 'Boraipalle', pincode: '505303' },
  { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '505303' },
  { value: 'sathupally', label: 'Sathupally', pincode: '505301' },
  { value: 'tungaturthy', label: 'Tungaturthy', pincode: '505305' },
  { value: 'upalapally', label: 'Upalapally', pincode: '505312' }
  ],

  'shamshabad': [
  { value: 'bajwa', label: 'Bajwa', pincode: '500078' },
  { value: 'chakri', label: 'Chakri', pincode: '500078' },
  { value: 'chandrayangutta', label: 'Chandrayangutta', pincode: '500078' },
  { value: 'gachibowli', label: 'Gachibowli', pincode: '500032' },
  { value: 'gokul', label: 'Gokul', pincode: '500078' },
  { value: 'shamshabad', label: 'Shamshabad', pincode: '500078' },
  { value: 'tadepally', label: 'Tadepally', pincode: '500078' },
  { value: 'turkapally', label: 'Turkapally', pincode: '500078' },
  { value: 'peddaguda', label: 'Peddaguda', pincode: '500078' },
  { value: 'malkapur', label: 'Malkapur', pincode: '500078' },
  { value: 'manikonda', label: 'Manikonda', pincode: '500089' },
  { value: 'raju nagar', label: 'Raju Nagar', pincode: '500078' },
  { value: 'srinivasa nagar', label: 'Srinivasa Nagar', pincode: '500078' },
  { value: 'kesarapalli', label: 'Kesarapalli', pincode: '500078' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '500078' },
  { value: 'nandi nagar', label: 'Nandi Nagar', pincode: '500078' }
  ],

  'ramagundam': [
  { value: 'alampur', label: 'Alampur', pincode: '505211' },
  { value: 'chimakurthy', label: 'Chimakurthy', pincode: '505215' },
  { value: 'duvva', label: 'Duvva', pincode: '505221' },
  { value: 'gundlapally', label: 'Gundlapally', pincode: '505211' },
  { value: 'kamanpur', label: 'Kamanpur', pincode: '505215' },
  { value: 'manthani', label: 'Manthani', pincode: '505184' },
  { value: 'ramagundam', label: 'Ramagundam', pincode: '505208' },
  { value: 'singareni', label: 'Singareni', pincode: '505213' },
  { value: 'tadkal', label: 'Tadkal', pincode: '505220' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '505211' },
  { value: 'bachupally', label: 'Bachupally', pincode: '505208' },
  { value: 'chennur', label: 'Chennur', pincode: '505173' },
  { value: 'gollapally', label: 'Gollapally', pincode: '505184' },
  { value: 'kanukunta', label: 'Kanukunta', pincode: '505215' },
  { value: 'pendalapally', label: 'Pendalapally', pincode: '505220' },
  { value: 'ramanpally', label: 'Ramanpally', pincode: '505211' },
  { value: 'singareni-ocp', label: 'Singareni OCP', pincode: '505212' }
  ],

  'achampet': [
  { value: 'achampet', label: 'Achampet', pincode: '509204' },
  { value: 'balaram', label: 'Balaram', pincode: '509210' },
  { value: 'chandapur', label: 'Chandapur', pincode: '509207' },
  { value: 'duvva', label: 'Duvva', pincode: '509206' },
  { value: 'gundlapally', label: 'Gundlapally', pincode: '509209' },
  { value: 'jillellagudem', label: 'Jillellagudem', pincode: '509210' },
  { value: 'kondapalli', label: 'Kondapalli', pincode: '509208' },
  { value: 'nallakunta', label: 'Nallakunta', pincode: '509204' },
  { value: 'palvancha', label: 'Palvancha', pincode: '509205' },
  { value: 'rajalaxmi', label: 'Rajalaxmi', pincode: '509206' },
  { value: 'thimmapur', label: 'Thimmapur', pincode: '509207' },
  { value: 'alampur', label: 'Alampur', pincode: '509211' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '509212' },
  { value: 'gollapalli', label: 'Gollapalli', pincode: '509213' },
  { value: 'bikkavolu', label: 'Bikkavolu', pincode: '509214' },
  { value: 'mallapur', label: 'Mallapur', pincode: '509215' }
  ],

  'narsampet': [
  { value: 'adloor', label: 'Adloor', pincode: '506331' },
  { value: 'bichkunda', label: 'Bichkunda', pincode: '506331' },
  { value: 'gundla-pally', label: 'Gundla Pally', pincode: '506331' },
  { value: 'jangaon', label: 'Jangaon', pincode: '506167' },
  { value: 'kondapally', label: 'Kondapally', pincode: '506331' },
  { value: 'manoharabad', label: 'Manoharabad', pincode: '506331' },
  { value: 'narsampet', label: 'Narsampet', pincode: '506331' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '506331' },
  { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '506331' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '506331' },
  { value: 'bhongir', label: 'Bhongir', pincode: '506168' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '506171' },
  { value: 'gollapally', label: 'Gollapally', pincode: '506332' },
  { value: 'kondapoor', label: 'Kondapoor', pincode: '506331' },
  { value: 'peddamunigal', label: 'Peddamunigal', pincode: '506331' },
  { value: 'ramapur', label: 'Ramapur', pincode: '506331' },
  { value: 'vengalraopet', label: 'Vengalraopet', pincode: '506333' }
  ],

  'mulugu': [
  { value: 'achampet', label: 'Achampet', pincode: '509401' },
  { value: 'chandur', label: 'Chandur', pincode: '509401' },
  { value: 'gudur', label: 'Gudur', pincode: '509411' },
  { value: 'mulugu', label: 'Mulugu', pincode: '509101' },
  { value: 'narsapur', label: 'Narsapur', pincode: '509402' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '509111' },
  { value: 'suryapet', label: 'Suryapet', pincode: '509401' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '509106' },
  { value: 'zamin', label: 'Zamin', pincode: '509406' },
  { value: 'balaram', label: 'Balaram', pincode: '509411' },
  { value: 'jillellagudem', label: 'Jillellagudem', pincode: '509412' },
  { value: 'kondapally', label: 'Kondapally', pincode: '509413' },
  { value: 'malkapur', label: 'Malkapur', pincode: '509415' },
  { value: 'peddapally', label: 'Peddapally', pincode: '509416' },
  { value: 'ramanapally', label: 'Ramanapally', pincode: '509417' },
  { value: 'vengalraopet', label: 'Vengalraopet', pincode: '509418' }
  ],

  'badepalle': [
  { value: 'adloor', label: 'Adloor', pincode: '505183' },
  { value: 'badepalle', label: 'Badepalle', pincode: '505181' },
  { value: 'chandur', label: 'Chandur', pincode: '505181' },
  { value: 'gundlapally', label: 'Gundlapally', pincode: '505182' },
  { value: 'jillellagudem', label: 'Jillellagudem', pincode: '505184' },
  { value: 'kondapally', label: 'Kondapally', pincode: '505185' },
  { value: 'mulugu', label: 'Mulugu', pincode: '505186' },
  { value: 'narsapur', label: 'Narsapur', pincode: '505187' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '505188' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '505189' },
  { value: 'bhaskarreddy-palli', label: 'Bhaskarreddy Palli', pincode: '505190' },
  { value: 'jagannadhapet', label: 'Jagannadhapet', pincode: '505191' },
  { value: 'kothapally', label: 'Kothapally', pincode: '505192' },
  { value: 'mallapur', label: 'Mallapur', pincode: '505193' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '505194' },
  { value: 'thimmapur', label: 'Thimmapur', pincode: '505195' }
  ],

  'armoor': [
  { value: 'adloor', label: 'Adloor', pincode: '503224' },
  { value: 'armoor', label: 'Armoor', pincode: '503224' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '503227' },
  { value: 'dantupalli', label: 'Dantupalli', pincode: '503226' },
  { value: 'gollapalli', label: 'Gollapalli', pincode: '503222' },
  { value: 'jillellagudem', label: 'Jillellagudem', pincode: '503225' },
  { value: 'kondapalli', label: 'Kondapalli', pincode: '503223' },
  { value: 'mulugu', label: 'Mulugu', pincode: '503228' },
  { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '503229' },
  { value: 'thimmapur', label: 'Thimmapur', pincode: '503230' },
  { value: 'bhamini', label: 'Bhamini', pincode: '503221' },
  { value: 'bojjapally', label: 'Bojjapally', pincode: '503232' },
  { value: 'kothapalli', label: 'Kothapalli', pincode: '503231' },
  { value: 'peddapally', label: 'Peddapally', pincode: '503233' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '503234' },
  { value: 'yellareddypet', label: 'Yellareddypet', pincode: '503235' }
  ],

  'hanamkonda': [
  { value: 'azamabad', label: 'Azamabad', pincode: '506001' },
  { value: 'bhaskarwadi', label: 'Bhaskarwadi', pincode: '506002' },
  { value: 'bolaram', label: 'Bolaram', pincode: '506003' },
  { value: 'hanamkonda', label: 'Hanamkonda', pincode: '506001' },
  { value: 'hasanparthy', label: 'Hasanparthy', pincode: '506002' },
  { value: 'kakatiya-nagar', label: 'Kakatiya Nagar', pincode: '506003' },
  { value: 'nakkalapally', label: 'Nakkalapally', pincode: '506004' },
  { value: 'ramreddypet', label: 'Ramreddypet', pincode: '506005' },
  { value: 'subedari', label: 'Subedari', pincode: '506006' },
  { value: 'wargal', label: 'Wargal', pincode: '506007' },
  { value: 'kashibugga', label: 'Kashibugga', pincode: '506008' },
  { value: 'malkapur', label: 'Malkapur', pincode: '506009' },
  { value: 'padmavathi-colony', label: 'Padmavathi Colony', pincode: '506010' },
  { value: 'raghopur', label: 'Raghapur', pincode: '506011' },
  { value: 'shivalayam', label: 'Shivalayam', pincode: '506012' },
  { value: 'turkapally', label: 'Turkapally', pincode: '506013' }
  ],

  'tandur': [
  { value: 'bhongir', label: 'Bhongir', pincode: '508116' },
  { value: 'gangapur', label: 'Gangapur', pincode: '508115' },
  { value: 'kondapur', label: 'Kondapur', pincode: '508118' },
  { value: 'manugur', label: 'Manugur', pincode: '508125' },
  { value: 'nizampet', label: 'Nizampet', pincode: '508119' },
  { value: 'pedda-gudem', label: 'Pedda Gudem', pincode: '508120' },
  { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '508121' },
  { value: 'tandur', label: 'Tandur', pincode: '508001' },
  { value: 'thimmapur', label: 'Thimmapur', pincode: '508122' },
  { value: 'vaddempally', label: 'Vaddempally', pincode: '508123' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '508124' },
  { value: 'adloor', label: 'Adloor', pincode: '508126' },
  { value: 'gundlapally', label: 'Gundlapally', pincode: '508127' },
  { value: 'mallapalli', label: 'Mallapalli', pincode: '508128' },
  { value: 'vengalraopally', label: 'Vengalraopally', pincode: '508129' }
  ],

  'mandamarri': [
  { value: 'banswada', label: 'Banswada', pincode: '505502' },
  { value: 'bhoopalpally', label: 'Bhoopalpally', pincode: '505526' },
  { value: 'chennur', label: 'Chennur', pincode: '505103' },
  { value: 'kottapally', label: 'Kottapally', pincode: '505503' },
  { value: 'mandamarri', label: 'Mandamarri', pincode: '505204' },
  { value: 'pedda-tellapalli', label: 'Pedda Tellapalli', pincode: '505201' },
  { value: 'ramagundam', label: 'Ramagundam', pincode: '505208' },
  { value: 'raichur', label: 'Raichur', pincode: '505211' },
  { value: 'sirasanpally', label: 'Sirasanpally', pincode: '505222' },
  { value: 'sonpalli', label: 'Sonpalli', pincode: '505215' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '505223' },
  { value: 'manoharabad', label: 'Manoharabad', pincode: '505221' },
  { value: 'nagulapally', label: 'Nagulapally', pincode: '505212' },
  { value: 'perur', label: 'Perur', pincode: '505205' },
  { value: 'peddur', label: 'Peddur', pincode: '505213' },
  { value: 'ramagundampet', label: 'Ramagundampet', pincode: '505209' }
  ],

  'bellal-tarafa': [
  { value: 'adloor', label: 'Adloor', pincode: '505502' },
  { value: 'balampur', label: 'Balampur', pincode: '505510' },
  { value: 'bellal', label: 'Bellal', pincode: '505511' },
  { value: 'chinthalapally', label: 'Chinthalapally', pincode: '505513' },
  { value: 'dharmareddypally', label: 'Dharmareddypally', pincode: '505514' },
  { value: 'kanthera', label: 'Kanthera', pincode: '505515' },
  { value: 'mandipet', label: 'Mandipet', pincode: '505516' },
  { value: 'pedda-tellapally', label: 'Pedda Tellapally', pincode: '505517' },
  { value: 'pillalamarri', label: 'Pillalamarri', pincode: '505518' },
  { value: 'rajamurthy', label: 'Rajamurthy', pincode: '505519' },
  { value: 'rampur', label: 'Rampur', pincode: '505520' },
  { value: 'nagalapally', label: 'Nagalapally', pincode: '505521' },
  { value: 'pedda-kalapet', label: 'Pedda Kalapet', pincode: '505522' },
  { value: 'ramakrishnapur', label: 'Ramakrishnapur', pincode: '505523' },
  { value: 'santhosh-nagar', label: 'Santhosh Nagar', pincode: '505524' },
  { value: 'vempally', label: 'Vempally', pincode: '505525' }
  ],

  'bellampalle': [
  { value: 'adloor', label: 'Adloor', pincode: '505502' },
  { value: 'bellampalle', label: 'Bellampalle', pincode: '505503' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '505504' },
  { value: 'dharmapuri', label: 'Dharmapuri', pincode: '505505' },
  { value: 'gundlapalli', label: 'Gundlapalli', pincode: '505506' },
  { value: 'kammepalli', label: 'Kammepalli', pincode: '505507' },
  { value: 'koppampalli', label: 'Koppampalli', pincode: '505508' },
  { value: 'mandapalli', label: 'Mandapalli', pincode: '505509' },
  { value: 'pedda-madhapur', label: 'Pedda Madhapur', pincode: '505510' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '505511' },
  { value: 'sankarapalli', label: 'Sankarapalli', pincode: '505512' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '505513' },
  { value: 'raghopur', label: 'Raghapur', pincode: '505514' },
  { value: 'peddapur', label: 'Peddapur', pincode: '505515' },
  { value: 'zafrabad', label: 'Zafrabad', pincode: '505516' },
  { value: 'nayakpalli', label: 'Nayakpalli', pincode: '505517' },
  { value: 'gandhinagar', label: 'Gandhinagar', pincode: '505518' },
  { value: 'kothapet', label: 'Kothapet', pincode: '505519' },
  { value: 'kandukur', label: 'Kandukur', pincode: '505520' }
  ],

  'bhainsa': [
  { value: 'adloor', label: 'Adloor', pincode: '504204' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '504201' },
  { value: 'chandapur', label: 'Chandapur', pincode: '504202' },
  { value: 'gundlapalli', label: 'Gundlapalli', pincode: '504203' },
  { value: 'jandapur', label: 'Jandapur', pincode: '504205' },
  { value: 'kanchla', label: 'Kanchla', pincode: '504206' },
  { value: 'mannepalli', label: 'Mannepalli', pincode: '504207' },
  { value: 'ramannapet', label: 'Ramannapet', pincode: '504208' },
  { value: 'sankarapalli', label: 'Sankarapalli', pincode: '504209' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '504210' },
  { value: 'balapur', label: 'Balapur', pincode: '504211' },
  { value: 'bommalaramaram', label: 'Bommalaramaram', pincode: '504212' },
  { value: 'bopparam', label: 'Bopparam', pincode: '504213' },
  { value: 'chakravarthipet', label: 'Chakravarthipet', pincode: '504214' },
  { value: 'dharmajipet', label: 'Dharmajipet', pincode: '504215' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '504216' },
  { value: 'kottur', label: 'Kottur', pincode: '504217' },
  { value: 'lingampalli', label: 'Lingampalli', pincode: '504218' },
  { value: 'podagapalli', label: 'Podagapalli', pincode: '504219' },
  { value: 'rajupet', label: 'Rajupet', pincode: '504220' }
  ],

  'manuguru': [
  { value: 'bandapalli', label: 'Bandapalli', pincode: '507208' },
  { value: 'bhadrakali', label: 'Bhadrakali', pincode: '507209' },
  { value: 'chandapur', label: 'Chandapur', pincode: '507207' },
  { value: 'gundlapalli', label: 'Gundlapalli', pincode: '507206' },
  { value: 'karlakunta', label: 'Karlakunta', pincode: '507205' },
  { value: 'manuguru', label: 'Manuguru', pincode: '507203' },
  { value: 'ramancha', label: 'Ramancha', pincode: '507204' },
  { value: 'sannivada', label: 'Sannivada', pincode: '507202' },
  { value: 'velkicherla', label: 'Velkicherla', pincode: '507201' },
  { value: 'adloor', label: 'Adloor', pincode: '507210' },
  { value: 'chandupalli', label: 'Chandupalli', pincode: '507211' },
  { value: 'rajupet', label: 'Rajupet', pincode: '507212' },
  { value: 'gaddam', label: 'Gaddam', pincode: '507213' },
  { value: 'yerragunta', label: 'Yerragunta', pincode: '507214' }
  ],

  'kagaznagar': [
  { value: 'bhupalpalle', label: 'Bhupalpalle', pincode: '504294' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '504293' },
  { value: 'jammikunta', label: 'Jammikunta', pincode: '504301' },
  { value: 'kagaznagar', label: 'Kagaznagar', pincode: '504297' },
  { value: 'mancherial', label: 'Mancherial', pincode: '504208' },
  { value: 'malkapur', label: 'Malkapur', pincode: '504292' },
  { value: 'nagapur', label: 'Nagapur', pincode: '504296' },
  { value: 'rajura', label: 'Rajura', pincode: '504295' },
  { value: 'sirsilk', label: 'Sirsilk', pincode: '504298' },
  { value: 'velgatur', label: 'Velgatur', pincode: '504299' },
  { value: 'srirampur', label: 'Srirampur', pincode: '504300' },
  { value: 'tiryani', label: 'Tiryani', pincode: '504302' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '504303' },
  { value: 'gundlapalli', label: 'Gundlapalli', pincode: '504304' }
  ],

  'gajwel': [
  { value: 'appampally', label: 'Appampally', pincode: '502279' },
  { value: 'bachannapet', label: 'Bachannapet', pincode: '502278' },
  { value: 'chintalapalle', label: 'Chintalapalle', pincode: '502277' },
  { value: 'doulapur', label: 'Doulapur', pincode: '502280' },
  { value: 'elkapally', label: 'Elkapally', pincode: '502278' },
  { value: 'gajwel', label: 'Gajwel', pincode: '502278' },
  { value: 'gundlapally', label: 'Gundlapally', pincode: '502279' },
  { value: 'kannepally', label: 'Kannepally', pincode: '502280' },
  { value: 'malkapur', label: 'Malkapur', pincode: '502281' },
  { value: 'peddapally', label: 'Peddapally', pincode: '502282' },
  { value: 'sanjaywadi', label: 'Sanjaywadi', pincode: '502282' },
  { value: 'sarpar', label: 'Sarpar', pincode: '502283' },
  { value: 'theega', label: 'Theega', pincode: '502279' },
  { value: 'velgatur', label: 'Velgatur', pincode: '502279' }
  ],

  'banswada': [
  { value: 'banswada', label: 'Banswada', pincode: '503187' },
  { value: 'bhiknoor', label: 'Bhiknoor', pincode: '503307' },
  { value: 'devapur', label: 'Devapur', pincode: '503306' },
  { value: 'gannaram', label: 'Gannaram', pincode: '503303' },
  { value: 'jagadevpur', label: 'Jagadevpur', pincode: '503106' },
  { value: 'jambapur', label: 'Jambapur', pincode: '503177' },
  { value: 'kamareddy', label: 'Kamareddy', pincode: '503111' },
  { value: 'manakondur', label: 'Manakondur', pincode: '503175' },
  { value: 'mallapur', label: 'Mallapur', pincode: '503114' },
  { value: 'mothe', label: 'Mothe', pincode: '503214' },
  { value: 'palair', label: 'Palair', pincode: '503175' },
  { value: 'peddapur', label: 'Peddapur', pincode: '503107' },
  { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '503120' },
  { value: 'talmadla', label: 'Talmadla', pincode: '503301' },
  { value: 'warkhed', label: 'Warkhed', pincode: '503250' },
  { value: 'zahirabad', label: 'Zahirabad', pincode: '502220' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '505172' },
  { value: 'surampalli', label: 'Surampalli', pincode: '503148' },
  { value: 'kanukuntla', label: 'Kanukuntla', pincode: '503141' },
  { value: 'ramgopalpet', label: 'Ramgopalpet', pincode: '503101' },
  { value: 'nyalkal', label: 'Nyalkal', pincode: '503230' }
  ],

  'nakrekal': [
  { value: 'adloor', label: 'Adloor', pincode: '508211' },
  { value: 'balaram', label: 'Balaram', pincode: '508116' },
  { value: 'chandur', label: 'Chandur', pincode: '508110' },
  { value: 'gundlapally', label: 'Gundlapally', pincode: '508115' },
  { value: 'kothapalli', label: 'Kothapalli', pincode: '508114' },
  { value: 'malkapur', label: 'Malkapur', pincode: '508113' },
  { value: 'nakrekal', label: 'Nakrekal', pincode: '508211' },
  { value: 'palakurthy', label: 'Palakurthy', pincode: '508202' },
  { value: 'pangididri', label: 'Pangididri', pincode: '508211' },
  { value: 'peddamaddi', label: 'Peddamaddi', pincode: '508112' },
  { value: 'rajamadharam', label: 'Rajamadharam', pincode: '508211' },
  { value: 'siddapur', label: 'Siddapur', pincode: '508111' },
  { value: 'tirumalapur', label: 'Tirumalapur', pincode: '508111' },
  { value: 'gundlapur', label: 'Gundlapur', pincode: '508213' },
  { value: 'jeedimetla', label: 'Jeedimetla', pincode: '508110' },
  { value: 'kondapally', label: 'Kondapally', pincode: '508208' },
  { value: 'lakshmapur', label: 'Lakshmapur', pincode: '508214' },
  { value: 'madira', label: 'Madira', pincode: '508207' },
  { value: 'mannegudem', label: 'Mannegudem', pincode: '508209' },
  { value: 'ravulapally', label: 'Ravulapally', pincode: '508206' },
  { value: 'somaram', label: 'Somaram', pincode: '508212' }
  ],

  'madhira': [
  { value: 'bapulapadu', label: 'Bapulapadu', pincode: '507203' },
  { value: 'belligundla', label: 'Belligundla', pincode: '507116' },
  { value: 'chandur', label: 'Chandur', pincode: '507130' },
  { value: 'gollapally', label: 'Gollapally', pincode: '507115' },
  { value: 'madhira', label: 'Madhira', pincode: '507203' },
  { value: 'mallapur', label: 'Mallapur', pincode: '507115' },
  { value: 'malkapur', label: 'Malkapur', pincode: '507117' },
  { value: 'pedapally', label: 'Pedapally', pincode: '507117' },
  { value: 'reddygudem', label: 'Reddygudem', pincode: '507116' },
  { value: 'sarvapur', label: 'Sarvapur', pincode: '507122' },
  { value: 'singavaram', label: 'Singavaram', pincode: '507124' },
  { value: 'thungathurthy', label: 'Thungathurthy', pincode: '507134' },
  { value: 'vengalraopeta', label: 'Vengalraopeta', pincode: '507118' },
  { value: 'annaram', label: 'Annaram', pincode: '507212' },
  { value: 'gudur', label: 'Gudur', pincode: '507137' },
  { value: 'jammigudem', label: 'Jammigudem', pincode: '507115' },
  { value: 'kottapalli', label: 'Kottapalli', pincode: '507133' },
  { value: 'kunaram', label: 'Kunaram', pincode: '507121' },
  { value: 'madigapalli', label: 'Madigapalli', pincode: '507120' },
  { value: 'malkapuram', label: 'Malkapuram', pincode: '507118' },
  { value: 'palvai', label: 'Palvai', pincode: '507113' },
  { value: 'vijayapuri', label: 'Vijayapuri', pincode: '507111' }
  ],

  'devarakonda': [
  { value: 'addepally', label: 'Addepally', pincode: '508248' },
  { value: 'alampur', label: 'Alampur', pincode: '508207' },
  { value: 'anajipur', label: 'Anajipur', pincode: '508246' },
  { value: 'devarakonda', label: 'Devarakonda', pincode: '508248' },
  { value: 'gopalapur', label: 'Gopalapur', pincode: '508253' },
  { value: 'gollapally', label: 'Gollapally', pincode: '508248' },
  { value: 'jagannapet', label: 'Jagannapet', pincode: '508210' },
  { value: 'kondapur', label: 'Kondapur', pincode: '508252' },
  { value: 'kothapally', label: 'Kothapally', pincode: '508249' },
  { value: 'madira', label: 'Madira', pincode: '508250' },
  { value: 'madhapur', label: 'Madhapur', pincode: '508248' },
  { value: 'mandapalli', label: 'Mandapalli', pincode: '508250' },
  { value: 'pangididri', label: 'Pangididri', pincode: '508251' },
  { value: 'ravulapally', label: 'Ravulapally', pincode: '508254' },
  { value: 'siddapur', label: 'Siddapur', pincode: '508246' },
  { value: 'thimmapur', label: 'Thimmapur', pincode: '508245' },
  { value: 'venkatapur', label: 'Venkatapur', pincode: '508247' },
  { value: 'sathavaram', label: 'Sathavaram', pincode: '508247' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '508255' },
  { value: 'ravulapet', label: 'Ravulapet', pincode: '508246' },
  { value: 'bhupalapur', label: 'Bhupalapur', pincode: '508248' }
  ],

  'kyathanpally': [
  { value: 'chandur', label: 'Chandur', pincode: '508105' },
  { value: 'gollapally', label: 'Gollapally', pincode: '508107' },
  { value: 'jyothinagar', label: 'Jyothinagar', pincode: '508101' },
  { value: 'kyathanpally', label: 'Kyathanpally', pincode: '508105' },
  { value: 'malkapur', label: 'Malkapur', pincode: '508106' },
  { value: 'mannegudem', label: 'Mannegudem', pincode: '508103' },
  { value: 'nallabelli', label: 'Nallabelli', pincode: '508104' },
  { value: 'pedapally', label: 'Pedapally', pincode: '508102' },
  { value: 'ravulapally', label: 'Ravulapally', pincode: '508108' },
  { value: 'siddapur', label: 'Siddapur', pincode: '508110' },
  { value: 'thungathurthy', label: 'Thungathurthy', pincode: '508109' },
  { value: 'vengalraopet', label: 'Vengalraopet', pincode: '508106' },
  { value: 'addepally', label: 'Addepally', pincode: '508105' },
  { value: 'bapulapally', label: 'Bapulapally', pincode: '508105' },
  { value: 'dindigul', label: 'Dindigul', pincode: '508111' },
  { value: 'gundlapally', label: 'Gundlapally', pincode: '508107' },
  { value: 'kondapally', label: 'Kondapally', pincode: '508108' },
  { value: 'mallapur', label: 'Mallapur', pincode: '508106' },
  { value: 'peddapally', label: 'Peddapally', pincode: '508103' },
  { value: 'sarvapur', label: 'Sarvapur', pincode: '508104' }
  ],
  'sangareddy': [
    { value: 'adha', label: 'Adha', pincode: '502217' },
    { value: 'banswada', label: 'Banswada', pincode: '503187' },
    { value: 'bhongir', label: 'Bhongir', pincode: '508116' },
    { value: 'gandimaisamma', label: 'Gandimaisamma', pincode: '502302' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jogipet', label: 'Jogipet', pincode: '502270' },
    { value: 'kacharam', label: 'Kacharam', pincode: '502279' },
    { value: 'kandukur', label: 'Kandukur', pincode: '502274' },
    { value: 'kamareddy', label: 'Kamareddy', pincode: '503111' },
    { value: 'mahabubnagar', label: 'Mahabubnagar', pincode: '509001' },
    { value: 'malkapur', label: 'Malkapur', pincode: '502255' },
    { value: 'manuguru', label: 'Manuguru', pincode: '502350' },
    { value: 'narayanakhed', label: 'Narayanakhed', pincode: '502220' },
    { value: 'patancheru', label: 'Patancheru', pincode: '502319' },
    { value: 'penpahad', label: 'Penpahad', pincode: '502281' },
    { value: 'pocharam', label: 'Pocharam', pincode: '500088' },
    { value: 'rajamurthy', label: 'Rajamurthy', pincode: '502271' },
    { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '502300' },
    { value: 'sangareddy-town', label: 'Sangareddy Town', pincode: '502001' },
    { value: 'sedam', label: 'Sedam', pincode: '509124' },
    { value: 'shadnagar', label: 'Shadnagar', pincode: '509216' },
    { value: 'siddipet', label: 'Siddipet', pincode: '502103' },
    { value: 'singur', label: 'Singur', pincode: '502223' },
    { value: 'tandoor', label: 'Tandoor', pincode: '502267' },
    { value: 'tarnaka', label: 'Tarnaka', pincode: '500017' },
    { value: 'zaheerabad', label: 'Zaheerabad', pincode: '502220' },
    { value: 'zahirabad-mandal', label: 'Zahirabad Mandal', pincode: '502221' }
  ],

  'mancherial': [
    { value: 'adilabad', label: 'Adilabad', pincode: '504001' },
    { value: 'ankapalli', label: 'Ankapalli', pincode: '504212' },
    { value: 'babanpalli', label: 'Babanpalli', pincode: '504251' },
    { value: 'belampalli', label: 'Belampalli', pincode: '504251' },
    { value: 'bellampalli', label: 'Bellampalli', pincode: '504251' },
    { value: 'chennur', label: 'Chennur', pincode: '504201' },
    { value: 'gundala', label: 'Gundala', pincode: '504232' },
    { value: 'jagannadhapuri', label: 'Jagannadhapuri', pincode: '504295' },
    { value: 'jennaram', label: 'Jennaram', pincode: '504205' },
    { value: 'karkepalli', label: 'Karkepalli', pincode: '504295' },
    { value: 'kasipet', label: 'Kasipet', pincode: '504272' },
    { value: 'kotapalli', label: 'Kotapalli', pincode: '504290' },
    { value: 'koyagudem', label: 'Koyagudem', pincode: '504267' },
    { value: 'malkapur', label: 'Malkapur', pincode: '504204' },
    { value: 'mancherial', label: 'Mancherial', pincode: '504208' },
    { value: 'naspur', label: 'Naspur', pincode: '504214' },
    { value: 'padmajanakiram', label: 'Padmajanakiram', pincode: '504277' },
    { value: 'pegadapalli', label: 'Pegadapalli', pincode: '504216' },
    { value: 'peddapalli', label: 'Peddapalli', pincode: '505172' },
    { value: 'peddavangara', label: 'Peddavangara', pincode: '504228' },
    { value: 'rajivpalli', label: 'Rajivpalli', pincode: '504220' },
    { value: 'rajura', label: 'Rajura', pincode: '504204' },
    { value: 'ramagundam', label: 'Ramagundam', pincode: '504242' },
    { value: 'ramakrishnapur', label: 'Ramakrishnapur', pincode: '504203' },
    { value: 'rekatapalli', label: 'Rekatapalli', pincode: '504225' },
    { value: 'shivajipet', label: 'Shivajipet', pincode: '504257' },
    { value: 'sirsilk', label: 'Sirsilk', pincode: '504143' },
    { value: 'sriramnagar', label: 'Sriramnagar', pincode: '504228' },
    { value: 'suryapet', label: 'Suryapet', pincode: '504262' },
    { value: 'velgatur', label: 'Velgatur', pincode: '504269' }
  ],

  'kamareddy': [
    { value: 'adloor', label: 'Adloor', pincode: '503111' },
    { value: 'allipur', label: 'Allipur', pincode: '503130' },
    { value: 'amrad', label: 'Amrad', pincode: '503002' },
    { value: 'anakapalli', label: 'Anakapalli', pincode: '503122' },
    { value: 'banswada', label: 'Banswada', pincode: '503187' },
    { value: 'bellampalli', label: 'Bellampalli', pincode: '503212' },
    { value: 'bhainsa', label: 'Bhainsa', pincode: '503201' },
    { value: 'bhiknoor', label: 'Bhiknoor', pincode: '503305' },
    { value: 'boregaon', label: 'Boregaon', pincode: '503122' },
    { value: 'chandapur', label: 'Chandapur', pincode: '503217' },
    { value: 'chinnapur', label: 'Chinnapur', pincode: '503305' },
    { value: 'dharpalli', label: 'Dharpalli', pincode: '503160' },
    { value: 'dichpally', label: 'Dichpally', pincode: '503175' },
    { value: 'doolapally', label: 'Doolapally', pincode: '503209' },
    { value: 'gandhari', label: 'Gandhari', pincode: '503114' },
    { value: 'gundla', label: 'Gundla', pincode: '503242' },
    { value: 'housnabad', label: 'Housnabad', pincode: '503122' },
    { value: 'jagdevpur', label: 'Jagdevpur', pincode: '502278' },
    { value: 'janampet', label: 'Janampet', pincode: '503223' },
    { value: 'jukkal', label: 'Jukkal', pincode: '503306' },
    { value: 'kamareddy', label: 'Kamareddy', pincode: '503111' },
    { value: 'kamareddy-tp', label: 'Kamareddy TP', pincode: '503110' },
    { value: 'kallur', label: 'Kallur', pincode: '503206' },
    { value: 'kandakurthi', label: 'Kandakurthi', pincode: '503308' },
    { value: 'kandukur', label: 'Kandukur', pincode: '503223' },
    { value: 'kondapur', label: 'Kondapur', pincode: '503310' },
    { value: 'kotagiri', label: 'Kotagiri', pincode: '503114' },
    { value: 'kothapalli', label: 'Kothapalli', pincode: '503302' },
    { value: 'kowdipally', label: 'Kowdipally', pincode: '503208' },
    { value: 'lingampally', label: 'Lingampally', pincode: '503225' },
    { value: 'machareddy', label: 'Machareddy', pincode: '503115' },
    { value: 'madnoor', label: 'Madnoor', pincode: '503107' },
    { value: 'malkapur', label: 'Malkapur', pincode: '503305' },
    { value: 'mallareddy', label: 'Mallareddy', pincode: '503248' },
    { value: 'manchippa', label: 'Manchippa', pincode: '503221' },
    { value: 'manugur', label: 'Manugur', pincode: '503119' },
    { value: 'mirzapur', label: 'Mirzapur', pincode: '503310' },
    { value: 'musheerabad', label: 'Musheerabad', pincode: '503208' },
    { value: 'muslimwadi', label: 'Muslimwadi', pincode: '503134' },
    { value: 'nadikudi', label: 'Nadikudi', pincode: '503307' },
    { value: 'nagapur', label: 'Nagapur', pincode: '503225' },
    { value: 'nagulapally', label: 'Nagulapally', pincode: '503310' },
    { value: 'peddapur', label: 'Peddapur', pincode: '503134' },
    { value: 'ponnapur', label: 'Ponnapur', pincode: '503217' },
    { value: 'pothireddypet', label: 'Pothireddypet', pincode: '503234' },
    { value: 'ramareddy', label: 'Ramareddy', pincode: '503213' },
    { value: 'raghunathpally', label: 'Raghunathpally', pincode: '503235' },
    { value: 'ragunathpur', label: 'Ragunathpur', pincode: '503248' },
    { value: 'sadasivpet', label: 'Sadasivpet', pincode: '502291' },
    { value: 'sagarpur', label: 'Sagarpur', pincode: '503215' },
    { value: 'santhapur', label: 'Santhapur', pincode: '503218' },
    { value: 'shankarampet', label: 'Shankarampet', pincode: '503101' },
    { value: 'sirnapalli', label: 'Sirnapalli', pincode: '503112' },
    { value: 'sirpur', label: 'Sirpur', pincode: '503103' },
    { value: 'siddipet', label: 'Siddipet', pincode: '502103' },
    { value: 'tallampally', label: 'Tallampally', pincode: '503211' },
    { value: 'valigonda', label: 'Valigonda', pincode: '503222' },
    { value: 'venkatapur', label: 'Venkatapur', pincode: '503140' },
    { value: 'zahirabad', label: 'Zahirabad', pincode: '502318' }
  ],

  'mahabubabad': [
    { value: 'adilabad', label: 'Adilabad', pincode: '504001' },
    { value: 'bhadradri', label: 'Bhadradri', pincode: '507112' },
    { value: 'bhupalpally', label: 'Bhupalpally', pincode: '506169' },
    { value: 'chandrugonda', label: 'Chandrugonda', pincode: '506314' },
    { value: 'dameracherla', label: 'Dameracherla', pincode: '506122' },
    { value: 'gundala', label: 'Gundala', pincode: '506142' },
    { value: 'jainoor', label: 'Jainoor', pincode: '506109' },
    { value: 'khammam', label: 'Khammam', pincode: '507001' },
    { value: 'kothagudem', label: 'Kothagudem', pincode: '507101' },
    { value: 'kothapet', label: 'Kothapet', pincode: '506251' },
    { value: 'lakshmipuram', label: 'Lakshmipuram', pincode: '506371' },
    { value: 'mahabubabad', label: 'Mahabubabad', pincode: '506101' },
    { value: 'mahadevpur', label: 'Mahadevpur', pincode: '506175' },
    { value: 'mothkur', label: 'Mothkur', pincode: '506347' },
    { value: 'nallabelli', label: 'Nallabelli', pincode: '506204' },
    { value: 'narsampet', label: 'Narsampet', pincode: '506132' },
    { value: 'nellikudur', label: 'Nellikudur', pincode: '506172' },
    { value: 'palimela', label: 'Palimela', pincode: '506212' },
    { value: 'ramannapet', label: 'Ramannapet', pincode: '506313' },
    { value: 'sattupalli', label: 'Sattupalli', pincode: '507303' },
    { value: 'thorrur', label: 'Thorrur', pincode: '506163' },
    { value: 'velair', label: 'Velair', pincode: '506164' },
    { value: 'wajedu', label: 'Wajedu', pincode: '506319' },
    { value: 'warangal', label: 'Warangal', pincode: '506002' },
    { value: 'yellandu', label: 'Yellandu', pincode: '507123' }
  ],

  'hyderabad': [
    { value: 'abids-road', label: 'Abids Road', pincode: '500001' },
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '500063' },
    { value: 'adikmet', label: 'Adikmet', pincode: '500044' },
    { value: 'afzalgunj', label: 'Afzalgunj', pincode: '500012' },
    { value: 'agapura', label: 'Agapura', pincode: '500003' },
    { value: 'ahmed-nagar', label: 'Ahmed Nagar', pincode: '500062' },
    { value: 'akbar-road', label: 'Akbar Road', pincode: '500001' },
    { value: 'alexander-road', label: 'Alexander Road', pincode: '500003' },
    { value: 'aliabad', label: 'Aliabad', pincode: '500053' },
    { value: 'alwal', label: 'Alwal', pincode: '500010' },
    { value: 'amberpet', label: 'Amberpet', pincode: '500013' },
    { value: 'ameerpet', label: 'Ameerpet', pincode: '500016' },
    { value: 'anand-bagh', label: 'Anand Bagh', pincode: '500047' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '500020' },
    { value: 'asif-nagar', label: 'Asif Nagar', pincode: '500028' },
    { value: 'as-roa-nagar', label: 'AS Roa Nagar', pincode: '500062' },
    { value: 'attapur', label: 'Attapur', pincode: '500048' },
    { value: 'attapur-ring-road', label: 'Attapur Ring Road', pincode: '500048' },
    { value: 'auto-nagar', label: 'Auto Nagar', pincode: '500062' },
    { value: 'azamabad', label: 'Azamabad', pincode: '500020' },
    { value: 'azampura-masjid', label: 'Azampura Masjid', pincode: '500053' },
    { value: 'baber-bagh', label: 'Baber Bagh', pincode: '500062' },
    { value: 'bachpally', label: 'Bachpally', pincode: '500090' },
    { value: 'badichowdi', label: 'Badichowdi', pincode: '500062' },
    { value: 'bagh-amberpet', label: 'Bagh Amberpet', pincode: '500013' },
    { value: 'bagh-lingampally', label: 'Bagh Lingampally', pincode: '500044' },
    { value: 'bahadurpura', label: 'Bahadurpura', pincode: '500064' },
    { value: 'bahadurpurpally', label: 'Bahadurpurpally', pincode: '500062' },
    { value: 'bairamalguda', label: 'Bairamalguda', pincode: '500059' },
    { value: 'bakaram', label: 'Bakaram', pincode: '500062' },
    { value: 'bala-nagar', label: 'Bala Nagar', pincode: '500018' },
    { value: 'balapur', label: 'Balapur', pincode: '500062' },
    { value: 'balkampet', label: 'Balkampet', pincode: '500016' },
    { value: 'bandimet', label: 'Bandimet', pincode: '500079' },
    { value: 'bandlaguda', label: 'Bandlaguda', pincode: '500086' },
    { value: 'banjara-hills', label: 'Banjara Hills', pincode: '500034' },
    { value: 'bank-street', label: 'Bank Street', pincode: '500003' },
    { value: 'bansilal-pet', label: 'Bansilal Pet', pincode: '500063' },
    { value: 'bapuji-nagar', label: 'Bapuji Nagar', pincode: '500079' },
    { value: 'barkas', label: 'Barkas', pincode: '500039' },
    { value: 'barkatpura', label: 'Barkatpura', pincode: '500027' },
    { value: 'basheerbagh', label: 'Basheerbagh', pincode: '500029' },
    { value: 'bazarghat', label: 'Bazarghat', pincode: '500004' },
    { value: 'begum-bazar', label: 'Begum Bazar', pincode: '500012' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '500018' },
    { value: 'bhagya-nagar-colony', label: 'Bhagya Nagar Colony', pincode: '500062' },
    { value: 'bhel', label: 'Bhel', pincode: '500032' },
    { value: 'bholakpur', label: 'Bholakpur', pincode: '500062' },
    { value: 'bod-uppal', label: 'Bod Uppal', pincode: '500039' },
    { value: 'boggulakunta', label: 'Boggulakunta', pincode: '500015' },
    { value: 'bolaram', label: 'Bolaram', pincode: '500010' },
    { value: 'borabanda', label: 'Borabanda', pincode: '500018' },
    { value: 'boudha-nagar', label: 'Boudha Nagar', pincode: '500064' },
    { value: 'bowenpally', label: 'Bowenpally', pincode: '500011' },
    { value: 'boyiguda', label: 'Boyiguda', pincode: '500042' },
    { value: 'chaderghat', label: 'Chaderghat', pincode: '500024' },
    { value: 'chaitanyapuri', label: 'Chaitanyapuri', pincode: '500060' },
    { value: 'champapet', label: 'Champapet', pincode: '500079' },
    { value: 'chanda-nagar', label: 'Chanda Nagar', pincode: '500050' },
    { value: 'chandrayanagutta', label: 'Chandrayanagutta', pincode: '500005' },
    { value: 'chappel-road', label: 'Chappel Road', pincode: '500001' },
    { value: 'char-kaman', label: 'Char Kaman', pincode: '500002' },
    { value: 'charlapally', label: 'Charlapally', pincode: '500062' },
    { value: 'charminar', label: 'Charminar', pincode: '500002' },
    { value: 'cherlapally', label: 'Cherlapally', pincode: '500051' },
    { value: 'chikkadpally', label: 'Chikkadpally', pincode: '500020' },
    { value: 'chilkalguda', label: 'Chilkalguda', pincode: '500361' },
    { value: 'chintal', label: 'Chintal', pincode: '500054' },
    { value: 'chintal-basti', label: 'Chintal Basti', pincode: '500054' },
    { value: 'dabeerpura', label: 'Dabeerpura', pincode: '500023' },
    { value: 'domalguda', label: 'Domalguda', pincode: '500029' },
    { value: 'erramanzil-colony', label: 'Erramanzil Colony', pincode: '500082' },
    { value: 'falaknuma', label: 'Falaknuma', pincode: '500053' },
    { value: 'film-nagar', label: 'Film Nagar', pincode: '500096' },
    { value: 'gachibowli', label: 'Gachibowli', pincode: '500032' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '500080' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hi-tech-city', label: 'Hi-Tech City', pincode: '500081' },
    { value: 'habsiguda', label: 'Habsiguda', pincode: '500007' },
    { value: 'jubilee-hills', label: 'Jubilee Hills', pincode: '500033' },
    { value: 'kukatpally', label: 'Kukatpally', pincode: '500072' },
    { value: 'mallapur', label: 'Mallapur', pincode: '500076' },
    { value: 'manikonda', label: 'Manikonda', pincode: '500089' },
    { value: 'quthbullapur', label: 'Quthbullapur', pincode: '500062' },
    { value: 'sainikpuri', label: 'Sainikpuri', pincode: '500094' },
    { value: 'shamirpet', label: 'Shamirpet', pincode: '500078' },
    { value: 'shamshabad', label: 'Shamshabad', pincode: '500409' },
    { value: 'srinagar-colony', label: 'Srinagar Colony', pincode: '500073' },
    { value: 'uppal-kalan', label: 'Uppal Kalan', pincode: '500039' }
  ],

  // Chennai Areas
  'salem': [
    { value: 'agraharam', label: 'Agraharam', pincode: '636001' },
    { value: 'alagapuram', label: 'Alagapuram', pincode: '636016' },
    { value: 'erode-road', label: 'Erode Road', pincode: '636009' },
    { value: 'hasthampatti', label: 'Hasthampatti', pincode: '636007' },
    { value: 'karuppur', label: 'Karuppur', pincode: '636140' },
    { value: 'kondalampatti', label: 'Kondalampatti', pincode: '636010' },
    { value: 'kottaiyur', label: 'Kottaiyur', pincode: '636103' },
    { value: 'mecheri', label: 'Mecheri', pincode: '636451' },
    { value: 'mettur-road', label: 'Mettur Road', pincode: '636007' },
    { value: 'new-fairlands', label: 'New Fairlands', pincode: '636016' },
    { value: 'omalur', label: 'Omalur', pincode: '636455' },
    { value: 'panchayat-union', label: 'Panchayat Union', pincode: '636112' },
    { value: 'peddanaickenpatti', label: 'Peddanaickenpatti', pincode: '636301' },
    { value: 'peramanur', label: 'Peramanur', pincode: '636009' },
    { value: 'pattipalayam', label: 'Pattipalayam', pincode: '636008' },
    { value: 'pudur', label: 'Pudur', pincode: '636126' },
    { value: 'rasi-nagar', label: 'Rasi Nagar', pincode: '636004' },
    { value: 'salem-corporation', label: 'Salem Corporation', pincode: '636001' },
    { value: 'salem-junction', label: 'Salem Junction', pincode: '636004' },
    { value: 'sankari', label: 'Sankari', pincode: '637301' },
    { value: 'sankari-town', label: 'Sankari Town', pincode: '637301' },
    { value: 'seelanaickenpatti', label: 'Seelanaickenpatti', pincode: '636201' },
    { value: 'sittilingi', label: 'Sittilingi', pincode: '636901' },
    { value: 'suramangalam', label: 'Suramangalam', pincode: '636005' },
    { value: 'taramangalam', label: 'Taramangalam', pincode: '636502' },
    { value: 'tharamangalam', label: 'Tharamangalam', pincode: '636503' },
    { value: 'tharapuram', label: 'Tharapuram', pincode: '636106' },
    { value: 'tiruchengode', label: 'Tiruchengode', pincode: '637211' },
    { value: 'vannadu', label: 'Vannadu', pincode: '636116' },
    { value: 'vazhapadi', label: 'Vazhapadi', pincode: '636115' },
    { value: 'vellalapatti', label: 'Vellalapatti', pincode: '636202' },
    { value: 'vellore', label: 'Vellore', pincode: '636016' },
    { value: 'veerapandi', label: 'Veerapandi', pincode: '636202' },
    { value: 'vepperi', label: 'Vepperi', pincode: '636016' },
    { value: 'vilangudi', label: 'Vilangudi', pincode: '636016' },
    { value: 'virudhachalam', label: 'Virudhachalam', pincode: '636109' },
    { value: 'yercaud', label: 'Yercaud', pincode: '636601' }
  ],

  'madurai': [
    { value: 'aavin-Nagar', label: 'Aavin Nagar', pincode: '625010' },
    { value: 'aaviyur', label: 'Aaviyur', pincode: '625021' },
    { value: 'alagappan-Nagar', label: 'Alagappan Nagar', pincode: '625002' },
    { value: 'alagar-Kovil-Road', label: 'Alagar Kovil Road', pincode: '625003' },
    { value: 'alanganallur', label: 'Alanganallur', pincode: '625501' },
    { value: 'anaiyur', label: 'Anaiyur', pincode: '625017' },
    { value: 'anbu-Nagar', label: 'Anbu Nagar', pincode: '625014' },
    { value: 'andalpuram', label: 'Andalpuram', pincode: '625007' },
    { value: 'anna-Nagar', label: 'Anna Nagar', pincode: '625020' },
    { value: 'anuppanadi', label: 'Anuppanadi', pincode: '625009' },
    { value: 'arapalayam', label: 'Arapalayam', pincode: '625016' },
    { value: 'arumbanur', label: 'Arumbanur', pincode: '625107' },
    { value: 'athanur', label: 'Athanur', pincode: '625301' },
    { value: 'athikulam', label: 'Athikulam', pincode: '625002' },
    { value: 'avaniyapuram', label: 'Avaniyapuram', pincode: '625012' },
    { value: 'ayyanar-Puram', label: 'Ayyanar Puram', pincode: '625020' },
    { value: 'bama-Nagar', label: 'Bama Nagar', pincode: '625022' },
    { value: 'bibikulam', label: 'Bibikulam', pincode: '625019' },
    { value: 'bye-Pass-Road', label: 'Bye Pass Road', pincode: '625010' },
    { value: 'chatrapatti', label: 'Chatrapatti', pincode: '625014' },
    { value: 'chinna-Chokkikulam', label: 'Chinna Chokkikulam', pincode: '625002' },
    { value: 'chittampatti', label: 'Chittampatti', pincode: '625010' },
    { value: 'chokikulam', label: 'Chokikulam', pincode: '625002' },
    { value: 'dindigal-Highway', label: 'Dindigal Highway', pincode: '625007' },
    { value: 'doak-Nagar', label: 'Doak Nagar', pincode: '625002' },
    { value: 'durai-Samy-Nagar', label: 'Durai Samy Nagar', pincode: '625002' },
    { value: 'east-Veli-Street', label: 'East Veli Street', pincode: '625001' },
    { value: 'ellis-Nagar', label: 'Ellis Nagar', pincode: '625010' },
    { value: 'gayathri-Nagar', label: 'Gayathri Nagar', pincode: '625017' },
    { value: 'gomathipuram', label: 'Gomathipuram', pincode: '625016' },
    { value: 'goripalayam', label: 'Goripalayam', pincode: '625002' },
    { value: 'iyer-Bungalow', label: 'Iyer Bungalow', pincode: '625016' },
    { value: 'jEMI-Balaji-Nagar', label: 'JEMI Balaji Nagar', pincode: '625003' },
    { value: 'k-Pudur', label: 'K Pudur', pincode: '625007' },
    { value: 'kadachanendal', label: 'Kadachanendal', pincode: '625019' },
    { value: 'kalavasal', label: 'Kalavasal', pincode: '625016' },
    { value: 'kallandhiri', label: 'Kallandhiri', pincode: '625301' },
    { value: 'kallikudi', label: 'Kallikudi', pincode: '625302' },
    { value: 'kannanenthal', label: 'Kannanenthal', pincode: '625017' },
    { value: 'karumathur', label: 'Karumathur', pincode: '625005' },
    { value: 'karuppayurani', label: 'Karuppayurani', pincode: '625020' },
    { value: 'kidaripatti', label: 'Kidaripatti', pincode: '625105' },
    { value: 'kK-Nagar', label: 'KK Nagar', pincode: '625020' },
    { value: 'kochadai', label: 'Kochadai', pincode: '625022' },
    { value: 'kodaikanal', label: 'Kodaikanal', pincode: '625001' },
    { value: 'kodikulam', label: 'Kodikulam', pincode: '625003' },
    { value: 'koodal-Nagar', label: 'Koodal Nagar', pincode: '625003' },
    { value: 'kovilappangudi', label: 'Kovilappangudi', pincode: '625017' },
    { value: 'krishnapuram-Colony', label: 'Krishnapuram Colony', pincode: '625014' },
    { value: 'kulamangalam', label: 'Kulamangalam', pincode: '625304' },
    { value: 'kunnathur', label: 'Kunnathur', pincode: '625009' },
    { value: 'lakshmipuram', label: 'Lakshmipuram', pincode: '625014' },
    { value: 'lIC-Colony', label: 'LIC Colony', pincode: '625002' },
    { value: 'lourdhu-Nagar', label: 'Lourdhu Nagar', pincode: '625007' },
    { value: 'madakkulam', label: 'Madakkulam', pincode: '625002' },
    { value: 'mahatma-Gandhi-Nagar', label: 'Mahatma Gandhi Nagar', pincode: '625015' },
    { value: 'maistry-Street', label: 'Maistry Street', pincode: '625001' },
    { value: 'manalur', label: 'Manalur', pincode: '625308' },
    { value: 'mappalayam', label: 'Mappalayam', pincode: '625014' },
    { value: 'mattiuttavani', label: 'Mattiuttavani', pincode: '625020' },
    { value: 'melakkal-Road', label: 'Melakkal Road', pincode: '625010' },
    { value: 'melamadai', label: 'Melamadai', pincode: '625020' },
    { value: 'melur', label: 'Melur', pincode: '625106' },
    { value: 'milakaranai-Village', label: 'Milakaranai Village', pincode: '625019' },
    { value: 'minukkampatti', label: 'Minukkampatti', pincode: '625010' },
    { value: 'mukkampatti', label: 'Mukkampatti', pincode: '625022' },
    { value: 'n-M-Sivanathan-Nagar', label: 'N M Sivanathan Nagar', pincode: '625020' },
    { value: 'nagamalai', label: 'Nagamalai', pincode: '625019' },
    { value: 'nalukulam', label: 'Nalukulam', pincode: '625019' },
    { value: 'narayanapuram', label: 'Narayanapuram', pincode: '625020' },
    { value: 'narimedu', label: 'Narimedu', pincode: '625002' },
    { value: 'natham-Road', label: 'Natham Road', pincode: '625002' },
    { value: 'national-Highway-7', label: 'National Highway-7', pincode: '625002' },
    { value: 'nayakkanpatti', label: 'Nayakkanpatti', pincode: '625010' },
    { value: 'nedungulam', label: 'Nedungulam', pincode: '625019' },
    { value: 'nH-45B', label: 'NH 45B', pincode: '625010' },
    { value: 'Othakkadai', label: 'Othakkadai', pincode: '625107' },
    { value: 'P-and-T-Nagar', label: 'P and T Nagar', pincode: '625014' },
    { value: 'p.T.Rajan-Road', label: 'P.T. Rajan Road', pincode: '625014' },
    { value: 'palangantham', label: 'Palangantham', pincode: '625010' },
    { value: 'panthadi', label: 'Panthadi', pincode: '625202' },
    { value: 'paravai', label: 'Paravai', pincode: '625402' },
    { value: 'pasingapuram', label: 'Pasingapuram', pincode: '625001' },
    { value: 'pasumalai', label: 'Pasumalai', pincode: '625004' },
    { value: 'periya-Kodakovil', label: 'Periya Kodakovil', pincode: '625106' },
    { value: 'periyar', label: 'Periyar', pincode: '625009' },
    { value: 'perungudi', label: 'Perungudi', pincode: '625016' },
    { value: 'ponnmeni', label: 'Ponnmeni', pincode: '625018' },
    { value: 'poovanthi', label: 'Poovanthi', pincode: '625537' },
    { value: 'pottapalayam', label: 'Pottapalayam', pincode: '625017' },
    { value: 'pudhu-Thamaraipatti', label: 'Pudhu Thamaraipatti', pincode: '625018' },
    { value: 'puliyankulam', label: 'Puliyankulam', pincode: '625019' },
    { value: 'rajakambeeram', label: 'Rajakambeeram', pincode: '625106' },
    { value: 'rajapalayam', label: 'Rajapalayam', pincode: '625001' },
    { value: 'ramaond-Reserve-Line', label: 'Ramaond Reserve Line', pincode: '625001' },
    { value: 's-Alangulam', label: 'S Alangulam', pincode: '625304' },
    { value: 'sammattipuram', label: 'Sammattipuram', pincode: '625301' },
    { value: 'sathamangalam', label: 'Sathamangalam', pincode: '625011' },
    { value: 'sathya-Sai-Nagar', label: 'Sathya Sai Nagar', pincode: '625007' },
    { value: 'sellur-Road', label: 'Sellur Road', pincode: '625002' },
    { value: 'shakti Nagar', label: 'Shakti Nagar', pincode: '625009' },
    { value: 'shenoy Nagar', label: 'Shenoy Nagar', pincode: '625016' },
    { value: 'sholavandan', label: 'Sholavandan', pincode: '625214' },
    { value: 'sikandar Savadi', label: 'Sikandar Savadi', pincode: '625019' },
    { value: 'silaiman', label: 'Silaiman', pincode: '625007' },
    { value: 'simmakkal', label: 'Simmakkal', pincode: '625001' },
    { value: 'solaipatti', label: 'Solaipatti', pincode: '625009' },
    { value: 'south-Veli-Street', label: 'South Veli Street', pincode: '625001' },
    { value: 'sS-Colony', label: 'SS Colony', pincode: '625010' },
    { value: 'subramaniapuram', label: 'Subramaniapuram', pincode: '625003' },
    { value: 'surya Nagar', label: 'Surya Nagar', pincode: '625020' },
    { value: 't-Pudupatti', label: 'T Pudupatti', pincode: '625014' },
    { value: 't.Kallupatti', label: 'T.Kallupatti', pincode: '625702' },
    { value: 'tallakulam', label: 'Tallakulam', pincode: '625002' },
    { value: 'thai-Moogambigai-Nagar', label: 'Thai Moogambigai Nagar', pincode: '625020' },
    { value: 'thanakkankulam', label: 'Thanakkankulam', pincode: '625005' },
    { value: 'thasildar-Nagar', label: 'Thasildar Nagar', pincode: '625016' },
    { value: 'thathaneri', label: 'Thathaneri', pincode: '625301' },
    { value: 'thathankulam', label: 'Thathankulam', pincode: '625016' },
    { value: 'thenpalanji', label: 'Thenpalanji', pincode: '625204' },
    { value: 'thirumohur', label: 'Thirumohur', pincode: '625005' },
    { value: 'thirunagar', label: 'Thirunagar', pincode: '625006' },
    { value: 'thiruparankundram', label: 'Thiruparankundram', pincode: '625005' },
    { value: 'thiruppalai', label: 'Thiruppalai', pincode: '625014' },
    { value: 'thoppur', label: 'Thoppur', pincode: '625101' },
    { value: 'tirumangalam', label: 'Tirumangalam', pincode: '625706' },
    { value: 'tiruppuvanam', label: 'Tiruppuvanam', pincode: '625662' },
    { value: 'tVS-Nagar', label: 'TVS Nagar', pincode: '625016' },
    { value: 'umachikulam', label: 'Umachikulam', pincode: '625009' },
    { value: 'usilampatti', label: 'Usilampatti', pincode: '625532' },
    { value: 'uthangudi', label: 'Uthangudi', pincode: '625107' },
    { value: 'vadipatti', label: 'Vadipatti', pincode: '625218' },
    { value: 'vadivelkarai', label: 'Vadivelkarai', pincode: '625220' },
    { value: 'valayankulam', label: 'Valayankulam', pincode: '625202' },
    { value: 'vandiyur', label: 'Vandiyur', pincode: '625020' },
    { value: 'vasanth-Nagar', label: 'Vasanth Nagar', pincode: '625001' },
    { value: 'velmurugan-Nagar', label: 'Velmurugan Nagar', pincode: '625020' },
    { value: 'vilachery', label: 'Vilachery', pincode: '625008' },
    { value: 'vilangudi', label: 'Vilangudi', pincode: '625027' },
    { value: 'villapuram', label: 'Villapuram', pincode: '625402' },
    { value: 'virataipathu', label: 'Virataipathu', pincode: '625107' },
    { value: 'visalakshipuram', label: 'Visalakshipuram', pincode: '625014' },
    { value: 'vishwanathapuram', label: 'Vishwanathapuram', pincode: '625009' }
  ],

  'erode': [
    { value: 'akkaraikodiveri', label: 'Akkaraikodiveri', pincode: '638309' },
    { value: 'alathur', label: 'Alathur', pincode: '638101' },
    { value: 'alukuli', label: 'Alukuli', pincode: '638317' },
    { value: 'ammankoil', label: 'Ammankoil', pincode: '638317' },
    { value: 'anaipalayam', label: 'Anaipalayam', pincode: '638509' },
    { value: 'anjanur-vemandampalayam', label: 'Anjanur Vemandampalayam', pincode: '638401' },
    { value: 'anjur', label: 'Anjur', pincode: '638701' },
    { value: 'anthiyur', label: 'Anthiyur', pincode: '638501' },
    { value: 'arachalur', label: 'Arachalur', pincode: '638101' },
    { value: 'arakkankottai', label: 'Arakkankottai', pincode: '638109' },
    { value: 'arasur', label: 'Arasur', pincode: '638202' },
    { value: 'athiyur', label: 'Athiyur', pincode: '638502' },
    { value: 'attavanai-hanumanpalli', label: 'Attavanai Hanumanpalli', pincode: '638301' },
    { value: 'avalpundurai', label: 'Avalpundurai', pincode: '638107' },
    { value: 'avudayarparai', label: 'Avudayarparai', pincode: '638506' },
    { value: 'ayalur', label: 'Ayalur', pincode: '638702' },
    { value: 'ayyampalayam', label: 'Ayyampalayam', pincode: '638105' },
    { value: 'bargur-anthiyur', label: 'Bargur Anthiyur', pincode: '638501' },
    { value: 'basuvapatti', label: 'Basuvapatti', pincode: '638507' },
    { value: 'bhavani', label: 'Bhavani', pincode: '638301' },
    { value: 'bhavani-cutcherry', label: 'Bhavani Cutcherry', pincode: '638301' },
    { value: 'brahmadesam', label: 'Brahmadesam', pincode: '638115' },
    { value: 'budapadi', label: 'Budapadi', pincode: '641102' },
    { value: 'chennampatti', label: 'Chennampatti', pincode: '638501' },
    { value: 'chennimalai', label: 'Chennimalai', pincode: '638051' },
    { value: 'chikkaiah-naicker-college', label: 'Chikkaiah Naicker College', pincode: '638004' },
    { value: 'chittode', label: 'Chittode', pincode: '638102' },
    { value: 'edayankattuvalsu', label: 'Edayankattuvalsu', pincode: '638312' },
    { value: 'elavamalai', label: 'Elavamalai', pincode: '638701' },
    { value: 'elavanatham', label: 'Elavanatham', pincode: '638103' },
    { value: 'elumathur', label: 'Elumathur', pincode: '638501' },
    { value: 'ennamangalam', label: 'Ennamangalam', pincode: '638109' },
    { value: 'erode-collectorate', label: 'Erode Collectorate', pincode: '638011' },
    { value: 'erode-east', label: 'Erode East', pincode: '638001' },
    { value: 'erode-fort', label: 'Erode Fort', pincode: '638001' },
    { value: 'erode-market', label: 'Erode Market', pincode: '638001' },
    { value: 'erode-north', label: 'Erode North', pincode: '638001' },
    { value: 'erode-railway-colony', label: 'Erode Railway Colony', pincode: '638002' },
    { value: 'erode-south', label: 'Erode South', pincode: '638003' },
    { value: 'ganapathipalayam', label: 'Ganapathipalayam', pincode: '638106' },
    { value: 'gangapuram', label: 'Gangapuram', pincode: '638502' },
    { value: 'gettisamudram', label: 'Gettisamudram', pincode: '638108' },
    { value: 'gobichettipalayam', label: 'Gobichettipalayam', pincode: '638452' },
    { value: 'gudakkarai', label: 'Gudakkarai', pincode: '638505' },
    { value: 'guthialathur', label: 'Guthialathur', pincode: '638312' },
    { value: 'ichipalayam', label: 'Ichipalayam', pincode: '638401' },
    { value: 'ingur', label: 'Ingur', pincode: '638401' },
    { value: 'injampalli', label: 'Injampalli', pincode: '638503' },
    { value: 'irugalur', label: 'Irugalur', pincode: '638109' },
    { value: 'kadappanalur', label: 'Kadappanalur', pincode: '638402' },
    { value: 'kadathur-gobi', label: 'Kadathur Gobi', pincode: '638456' },
    { value: 'kadirampatti', label: 'Kadirampatti', pincode: '638102' },
    { value: 'kadukkampalayam', label: 'Kadukkampalayam', pincode: '638202' },
    { value: 'kagam', label: 'Kagam', pincode: '638501' },
    { value: 'kalbhavi', label: 'Kalbhavi', pincode: '638505' },
    { value: 'kalingiam', label: 'Kalingiam', pincode: '638506' },
    { value: 'kambiliyampatti', label: 'Kambiliyampatti', pincode: '638314' },
    { value: 'kanagapuram', label: 'Kanagapuram', pincode: '638313' },
    { value: 'kanakkampalayam', label: 'Kanakkampalayam', pincode: '638105' },
    { value: 'kandappagoundenvalasu', label: 'Kandappagoundenvalasu', pincode: '638504' },
    { value: 'kandasamipalayam', label: 'Kandasamipalayam', pincode: '638502' },
    { value: 'kandikattuvalasu', label: 'Kandikattuvalasu', pincode: '638401' },
    { value: 'karattupalayam', label: 'Karattupalayam', pincode: '638111' },
    { value: 'karukkampalayam', label: 'Karukkampalayam', pincode: '638110' },
    { value: 'karungalpalayam', label: 'Karungalpalayam', pincode: '638701' },
    { value: 'kasbapettai', label: 'Kasbapettai', pincode: '638101' },
    { value: 'kasipalayam', label: 'Kasipalayam', pincode: '638302' },
    { value: 'kasthurbagarm', label: 'Kasthurbagarm', pincode: '638303' },
    { value: 'kavindapadi', label: 'Kavindapadi', pincode: '638455' },
    { value: 'kavundichipalayam', label: 'Kavundichipalayam', pincode: '638105' },
    { value: 'kavuthampalayam', label: 'Kavuthampalayam', pincode: '638504' },
    { value: 'kesarimangalam', label: 'Kesarimangalam', pincode: '638503' },
    { value: 'kilwani', label: 'Kilwani', pincode: '638108' },
    { value: 'kodumudi', label: 'Kodumudi', pincode: '638151' },
    { value: 'kolanalli', label: 'Kolanalli', pincode: '638454' },
    { value: 'kolathupalayam', label: 'Kolathupalayam', pincode: '638101' },
    { value: 'kollampalayam', label: 'Kollampalayam', pincode: '638305' },
    { value: 'komarayanur', label: 'Komarayanur', pincode: '638505' },
    { value: 'komarayeevalasu', label: 'Komarayeevalasu', pincode: '638113' },
    { value: 'kondayampalayam-bhavani', label: 'Kondayampalayam Bhavani', pincode: '638301' },
    { value: 'kongarpalayam', label: 'Kongarpalayam', pincode: '638507' },
    { value: 'koothampalayam', label: 'Koothampalayam', pincode: '638105' },
    { value: 'koothampatti', label: 'Koothampatti', pincode: '638312' },
    { value: 'koothampoondi', label: 'Koothampoondi', pincode: '638113' },
    { value: 'koshanam', label: 'Koshanam', pincode: '638313' },
    { value: 'kottupullampalayam', label: 'Kottupullampalayam', pincode: '638102' },
    { value: 'kugalur', label: 'Kugalur', pincode: '638502' },
    { value: 'kullampalayam', label: 'Kullampalayam', pincode: '638105' },
    { value: 'kunnathur', label: 'Kunnathur', pincode: '638103' },
    { value: 'kuppandampalayam', label: 'Kuppandampalayam', pincode: '638506' },
    { value: 'kurichi', label: 'Kurichi', pincode: '638104' },
    { value: 'kurichi-kunnathur', label: 'Kurichi Kunnathur', pincode: '638106' },
    { value: 'kurumandur', label: 'Kurumandur', pincode: '638101' },
    { value: 'lakkapuram', label: 'Lakkapuram', pincode: '638507' },
    { value: 'malayampalayam', label: 'Malayampalayam', pincode: '638109' },
    { value: 'mannathampalayam', label: 'Mannathampalayam', pincode: '638112' },
    { value: 'maravapalayam', label: 'Maravapalayam', pincode: '638317' },
    { value: 'mathur', label: 'Mathur', pincode: '638106' },
    { value: 'melapalayam', label: 'Melapalayam', pincode: '638004' },
    { value: 'mevani', label: 'Mevani', pincode: '638502' },
    { value: 'minnapalayam', label: 'Minnapalayam', pincode: '638106' },
    { value: 'modakurichi', label: 'Modakurichi', pincode: '638104' },
    { value: 'morattupalayam', label: 'Morattupalayam', pincode: '638106' },
    { value: 'mukasi-hanumanpalli', label: 'Mukasi Hanumanpalli', pincode: '638113' },
    { value: 'mukasipidariyur', label: 'Mukasipidariyur', pincode: '638113' },
    { value: 'mukasipudur', label: 'Mukasipudur', pincode: '638503' },
    { value: 'mullampatti', label: 'Mullampatti', pincode: '638107' },
    { value: 'murungatholuvu', label: 'Murungatholuvu', pincode: '638104' },
    { value: 'muthayeepalayam', label: 'Muthayeepalayam', pincode: '638317' },
    { value: 'mylambadi', label: 'Mylambadi', pincode: '638151' },
    { value: 'nadupatti', label: 'Nadupatti', pincode: '638505' },
    { value: 'nagadevampalayam', label: 'Nagadevampalayam', pincode: '638501' },
    { value: 'nagalur', label: 'Nagalur', pincode: '638452' },
    { value: 'nanjai-puliampatti', label: 'Nanjai Puliampatti', pincode: '638455' },
    { value: 'nanjai-uttukuli', label: 'Nanjai Uttukuli', pincode: '638107' },
    { value: 'nasiyanur', label: 'Nasiyanur', pincode: '638106' },
    { value: 'nathagoundenpalayam', label: 'Nathagoundenpalayam', pincode: '638115' },
    { value: 'nichampalayam', label: 'Nichampalayam', pincode: '638101' },
    { value: 'odathurai', label: 'Odathurai', pincode: '638105' },
    { value: 'odayagoundenpalayam', label: 'Odayagoundenpalayam', pincode: '638503' },
    { value: 'olapalayam', label: 'Olapalayam', pincode: '638106' },
    { value: 'oricheri', label: 'Oricheri', pincode: '638506' },
    { value: 'pachampalayam', label: 'Pachampalayam', pincode: '638502' },
    { value: 'palakarai', label: 'Palakarai', pincode: '638505' },
    { value: 'palliyuthu', label: 'Palliyuthu', pincode: '638317' },
    { value: 'pandiampalayam', label: 'Pandiampalayam', pincode: '638506' },
    { value: 'pappampalayam', label: 'Pappampalayam', pincode: '638302' },
    { value: 'paruvachi', label: 'Paruvachi', pincode: '638506' },
    { value: 'pasur', label: 'Pasur', pincode: '638456' },
    { value: 'patlur', label: 'Patlur', pincode: '638107' },
    { value: 'pattakaranpalayam', label: 'Pattakaranpalayam', pincode: '638106' },
    { value: 'peria-agraharam', label: 'Peria Agraharam', pincode: '638106' },
    { value: 'peria-semur', label: 'Peria Semur', pincode: '638506' },
    { value: 'periapuliyur', label: 'Periapuliyur', pincode: '638101' },
    { value: 'periavattam', label: 'Periavattam', pincode: '638102' },
    { value: 'periaveerasangli', label: 'Periaveerasangli', pincode: '638506' },
    { value: 'perode', label: 'Perode', pincode: '638113' },
    { value: 'perundalaiyur', label: 'Perundalaiyur', pincode: '638314' },
    { value: 'perundurai', label: 'Perundurai', pincode: '638052' },
    { value: 'pichandampalayam', label: 'Pichandampalayam', pincode: '638105' },
    { value: 'polavakalipalayam', label: 'Polavakalipalayam', pincode: '638101' },
    { value: 'polavapalayam', label: 'Polavapalayam', pincode: '638106' },
    { value: 'pondilingapuram', label: 'Pondilingapuram', pincode: '638115' },
    { value: 'ponmudi', label: 'Ponmudi', pincode: '638106' },
    { value: 'pudur', label: 'Pudur', pincode: '638102' },
    { value: 'pullappanaickenpalayam', label: 'Pullappanaickenpalayam', pincode: '638115' },
    { value: 'pundurai-semur', label: 'Pundurai Semur', pincode: '638506' },
    { value: 'pungambadi', label: 'Pungambadi', pincode: '638506' },
    { value: 'punjaipalatholuvu', label: 'Punjaipalatholuvu', pincode: '638455' },
    { value: 'punjaithuraiyampalayam', label: 'Punjaithuraiyampalayam', pincode: '638506' },
    { value: 'punnam', label: 'Punnam', pincode: '638507' },
    { value: 'purappalikattuvalasu', label: 'Purappalikattuvalasu', pincode: '638106' },
    { value: 'ramalingapuram', label: 'Ramalingapuram', pincode: '638502' },
    { value: 'ramalingapuram-south', label: 'Ramalingapuram South', pincode: '638503' },
    { value: 'ramanathapuram-pudur', label: 'Ramanathapuram Pudur', pincode: '638112' },
    { value: 'rangampalayam', label: 'Rangampalayam', pincode: '638104' },
    { value: 'rasampalayam', label: 'Rasampalayam', pincode: '638107' },
    { value: 'reddipalayam', label: 'Reddipalayam', pincode: '638115' },
    { value: 'salaipudur', label: 'Salaipudur', pincode: '638106' },
    { value: 'sankarapalayam', label: 'Sankarapalayam', pincode: '638108' },
    { value: 'sanyasipatti', label: 'Sanyasipatti', pincode: '638506' },
    { value: 'satamugai', label: 'Satamugai', pincode: '638107' },
    { value: 'savandapur', label: 'Savandapur', pincode: '638102' },
    { value: 'seenapuram', label: 'Seenapuram', pincode: '638506' },
    { value: 'singampettai', label: 'Singampettai', pincode: '638506' },
    { value: 'singanallur-kvp', label: 'Singanallur KVP', pincode: '638116' },
    { value: 'sinniampalayam', label: 'Sinniampalayam', pincode: '638106' },
    { value: 'sircarkathankanni', label: 'Sircarkathankanni', pincode: '638106' },
    { value: 'sirukalanji', label: 'Sirukalanji', pincode: '638107' },
    { value: 'siruvalur', label: 'Siruvalur', pincode: '638506' },
    { value: 'sivagiri', label: 'Sivagiri', pincode: '638109' },
    { value: 'solipalayam', label: 'Solipalayam', pincode: '638107' },
    { value: 'sullipalayam', label: 'Sullipalayam', pincode: '638503' },
    { value: 'sundakkampalayam', label: 'Sundakkampalayam', pincode: '638502' },
    { value: 'surampatti', label: 'Surampatti', pincode: '638101' },
    { value: 'swaminathapuram', label: 'Swaminathapuram', pincode: '638102' },
    { value: 'talguni', label: 'Talguni', pincode: '638106' },
    { value: 'thamaraipalayam', label: 'Thamaraipalayam', pincode: '638106' },
    { value: 'thandampalayam', label: 'Thandampalayam', pincode: '638106' },
    { value: 'thattampalayam', label: 'Thattampalayam', pincode: '638105' },
    { value: 'thindal', label: 'Thindal', pincode: '638107' },
    { value: 'thoppupalayam', label: 'Thoppupalayam', pincode: '638104' },
    { value: 'thoranavavi', label: 'Thoranavavi', pincode: '638107' },
    { value: 'thuyyampundurai', label: 'Thuyyampundurai', pincode: '638506' },
    { value: 'tingalur', label: 'Tingalur', pincode: '638506' },
    { value: 'unjalur', label: 'Unjalur', pincode: '638506' },
    { value: 'vadakkupudupalayam', label: 'Vadakkupudupalayam', pincode: '638503' },
    { value: 'vadakuthaiyurpalayam', label: 'Vadakuthaiyurpalayam', pincode: '638502' },
    { value: 'vadamugam-vellodu', label: 'Vadamugam Vellodu', pincode: '638506' },
    { value: 'vadugapatti', label: 'Vadugapatti', pincode: '638503' },
    { value: 'vairamangalam', label: 'Vairamangalam', pincode: '638506' },
    { value: 'vairapalayam', label: 'Vairapalayam', pincode: '638106' },
    { value: 'vallipurathanpalayam', label: 'Vallipurathanpalayam', pincode: '638506' },
    { value: 'varadhanallur', label: 'Varadhanallur', pincode: '638506' },
    { value: 'varapalayam', label: 'Varapalayam', pincode: '638507' },
    { value: 'vazhaithottam', label: 'Vazhaithottam', pincode: '638507' },
    { value: 'veerappampalayam', label: 'Veerappampalayam', pincode: '638502' },
    { value: 'veerappanchatram', label: 'Veerappanchatram', pincode: '638505' },
    { value: 'velampalayam', label: 'Velampalayam', pincode: '638107' },
    { value: 'velampalayam', label: 'Velampalayam', pincode: '638503' },
    { value: 'velankattuvalasu', label: 'Velankattuvalasu', pincode: '638506' },
    { value: 'vellalapalayam', label: 'Vellalapalayam', pincode: '638107' },
    { value: 'vellankoil', label: 'Vellankoil', pincode: '638105' },
    { value: 'vellaraveli', label: 'Vellaraveli', pincode: '638507' },
    { value: 'vellitirupur', label: 'Vellitirupur', pincode: '638506' },
    { value: 'vellottamparappu', label: 'Vellottamparappu', pincode: '638503' },
    { value: 'vemandampalayam', label: 'Vemandampalayam', pincode: '638502' },
    { value: 'vengampur', label: 'Vengampur', pincode: '638502' },
    { value: 'vettayankinar', label: 'Vettayankinar', pincode: '638506' },
    { value: 'vijayamangalam', label: 'Vijayamangalam', pincode: '638105' },
    { value: 'vilakethi', label: 'Vilakethi', pincode: '638507' },
    { value: 'vilarasampatti', label: 'Vilarasampatti', pincode: '638507' }
  ],

  'coimbatore': [
    { value: 'aavarampalayam', label: 'Aavarampalayam', pincode: '641027' },
    { value: 'alanthurai', label: 'Alanthurai', pincode: '641105' },
    { value: 'alagapuram', label: 'Alagapuram', pincode: '641021' },
    { value: 'annamalai-hills', label: 'Annamalai Hills', pincode: '642101' },
    { value: 'annur', label: 'Annur', pincode: '641653' },
    { value: 'avarampalayam', label: 'Avarampalayam', pincode: '641027' },
    { value: 'cheranmanagar', label: 'Cheranmanagar', pincode: '641023' },
    { value: 'chettipalayam', label: 'Chettipalayam', pincode: '641027' },
    { value: 'chinniampalayam', label: 'Chinniampalayam', pincode: '641062' },
    { value: 'eachanari', label: 'Eachanari', pincode: '641021' },
    { value: 'ettimadai', label: 'Ettimadai', pincode: '641302' },
    { value: 'ganapathy', label: 'Ganapathy', pincode: '641006' },
    { value: 'gandhimanagar', label: 'Gandhimanagar', pincode: '641024' },
    { value: 'gandhipuram', label: 'Gandhipuram', pincode: '641012' },
    { value: 'ganesapuram', label: 'Ganesapuram', pincode: '641653' },
    { value: 'gopalapuram', label: 'Gopalapuram', pincode: '641018' },
    { value: 'g.v-residency', label: 'G.V Residency', pincode: '641039' },
    { value: 'irugur', label: 'Irugur', pincode: '641103' },
    { value: 'kalapatti', label: 'Kalapatti', pincode: '641048' },
    { value: 'kalveerampalayam', label: 'Kalveerampalayam', pincode: '641035' },
    { value: 'kariampalayam', label: 'Kariampalayam', pincode: '641663' },
    { value: 'karamada', label: 'Karamada', pincode: '641104' },
    { value: 'karumbukadai', label: 'Karumbukadai', pincode: '641034' },
    { value: 'karumathampatti', label: 'Karumathampatti', pincode: '641659' },
    { value: 'karunya-nagar', label: 'Karunya Nagar', pincode: '641114' },
    { value: 'keeranatham', label: 'Keeranatham', pincode: '641023' },
    { value: 'kinathukadavu', label: 'Kinathukadavu', pincode: '641205' },
    { value: 'k.g-chavadi', label: 'K.G Chavadi', pincode: '641024' },
    { value: 'kottaimedu', label: 'Kottaimedu', pincode: '641023' },
    { value: 'kovaipudur', label: 'Kovaipudur', pincode: '641042' },
    { value: 'kovilpalayam', label: 'Kovilpalayam', pincode: '641010' },
    { value: 'kuppanur', label: 'Kuppanur', pincode: '641050' },
    { value: 'kurichi', label: 'Kurichi', pincode: '641023' },
    { value: 'kurumbapalayam', label: 'Kurumbapalayam', pincode: '641016' },
    { value: 'madhampatti', label: 'Madhampatti', pincode: '641030' },
    { value: 'madukkarai', label: 'Madukkarai', pincode: '641023' },
    { value: 'malumichampatti', label: 'Malumichampatti', pincode: '641024' },
    { value: 'maruthamalai', label: 'Maruthamalai', pincode: '641023' },
    { value: 'meena-estate', label: 'Meena Estate', pincode: '641021' },
    { value: 'myleripalayam', label: 'Myleripalayam', pincode: '641014' },
    { value: 'nachipalayam', label: 'Nachipalayam', pincode: '641016' },
    { value: 'nallampalayam', label: 'Nallampalayam', pincode: '641031' },
    { value: 'nanjundapuram', label: 'Nanjundapuram', pincode: '641036' },
    { value: 'narasipuram', label: 'Narasipuram', pincode: '641110' },
    { value: 'neelambur', label: 'Neelambur', pincode: '641030' },
    { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '641020' },
    { value: 'odaiyakulam', label: 'Odaiyakulam', pincode: '641105' },
    { value: 'ondipudur', label: 'Ondipudur', pincode: '641016' },
    { value: 'othakalmandapam', label: 'Othakalmandapam', pincode: '641023' },
    { value: 'pachapalayam', label: 'Pachapalayam', pincode: '641101' },
    { value: 'p.n-pudur', label: 'P.N.Pudur', pincode: '641041' },
    { value: 'pannimadai', label: 'Pannimadai', pincode: '641052' },
    { value: 'peelamedu', label: 'Peelamedu', pincode: '641004' },
    { value: 'periyanaickenpalayam', label: 'Periyanaickenpalayam', pincode: '641110' },
    { value: 'perur', label: 'Perur', pincode: '641010' },
    { value: 'podanur', label: 'Podanur', pincode: '641023' },
    { value: 'poochiyur', label: 'Poochiyur', pincode: '641050' },
    { value: 'ponnairajapuram', label: 'Ponnairajapuram', pincode: '641039' },
    { value: 'pooluvapatti', label: 'Pooluvapatti', pincode: '641107' },
    { value: 'puliakulam', label: 'Puliakulam', pincode: '641045' },
    { value: 'puthur', label: 'Puthur', pincode: '641101' },
    { value: 'race-course', label: 'Race Course', pincode: '641018' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '641009' },
    { value: 'ramnathapuram', label: 'Ramnathapuram', pincode: '641036' },
    { value: 'ravatha-kollanur', label: 'Ravatha Kollanur', pincode: '641116' },
    { value: 'rathinapuri', label: 'Rathinapuri', pincode: '641027' },
    { value: 'r.s-puram', label: 'R.S Puram', pincode: '641002' },
    { value: 'saibaba-colony', label: 'Saibaba Colony', pincode: '641011' },
    { value: 'samathur', label: 'Samathur', pincode: '641102' },
    { value: 'saravanampatti', label: 'Saravanampatti', pincode: '641035' },
    { value: 'selvapuram', label: 'Selvapuram', pincode: '641026' },
    { value: 'sidhapudur', label: 'Sidhapudur', pincode: '641044' },
    { value: 'singanallur', label: 'Singanallur', pincode: '641005' },
    { value: 'sivananda-colony', label: 'Sivananda Colony', pincode: '641012' },
    { value: 'sowripalayam', label: 'Sowripalayam', pincode: '641028' },
    { value: 'sugunapuram', label: 'Sugunapuram', pincode: '641021' },
    { value: 'suleeswaranpatti', label: 'Suleeswaranpatti', pincode: '641207' },
    { value: 'sulur', label: 'Sulur', pincode: '641402' },
    { value: 'sundakkamuthur', label: 'Sundakkamuthur', pincode: '641034' },
    { value: 'sundarapuram', label: 'Sundarapuram', pincode: '641024' },
    { value: 'sukrawarpettai', label: 'Sukrawarpettai', pincode: '641007' },
    { value: 'tatabad', label: 'Tatabad', pincode: '641012' },
    { value: 'thadagam', label: 'Thadagam', pincode: '641017' },
    { value: 'thenkarai', label: 'Thenkarai', pincode: '641113' },
    { value: 'thirumalayampalayam', label: 'Thirumalayampalayam', pincode: '641034' },
    { value: 'thondamuthur', label: 'Thondamuthur', pincode: '641109' },
    { value: 'townhall', label: 'Townhall', pincode: '641001' },
    { value: 'udayampalayam', label: 'Udayampalayam', pincode: '641021' },
    { value: 'ukkadam', label: 'Ukkadam', pincode: '641021' },
    { value: 'uppilipalayam', label: 'Uppilipalayam', pincode: '641015' },
    { value: 'vadavalli', label: 'Vadavalli', pincode: '641041' },
    { value: 'varadarajapuram', label: 'Varadarajapuram', pincode: '641021' },
    { value: 'veedapaati', label: 'Veedapaati', pincode: '641035' },
    { value: 'veerakeralam', label: 'Veerakeralam', pincode: '641025' },
    { value: 'vellalore', label: 'Vellalore', pincode: '641004' },
    { value: 'venkatapuram', label: 'Venkatapuram', pincode: '641031' },
    { value: 'vilankurichi', label: 'Vilankurichi', pincode: '641035' },
    { value: 'walayar', label: 'Walayar', pincode: '641667' }
  ],

  'vellore': [
    { value: 'aavarampalayam', label: 'Aavarampalayam', pincode: '632005' },
    { value: 'abdullah-puram', label: 'Abdullah Puram', pincode: '632102' },
    { value: 'adukkamparai', label: 'Adukkamparai', pincode: '632102' },
    { value: 'alamelumangapuram', label: 'Alamelumangapuram', pincode: '632510' },
    { value: 'ambur', label: 'Ambur', pincode: '635802' },
    { value: 'ammoor', label: 'Ammoor', pincode: '632502' },
    { value: 'anaicut', label: 'Anaicut', pincode: '632101' },
    { value: 'arakkonam', label: 'Arakkonam', pincode: '631001' },
    { value: 'arappakkam', label: 'Arappakkam', pincode: '632102' },
    { value: 'arcot', label: 'Arcot', pincode: '632503' },
    { value: 'ariyur', label: 'Ariyur', pincode: '632509' },
    { value: 'avaloor', label: 'Avaloor', pincode: '632011' },
    { value: 'bagayam', label: 'Bagayam', pincode: '632002' },
    { value: 'bheemakulam', label: 'Bheemakulam', pincode: '632010' },
    { value: 'erayangadu', label: 'Erayangadu', pincode: '632512' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '632001' },
    { value: 'gudiyattam', label: 'Gudiyattam', pincode: '632602' },
    { value: 'kalavai', label: 'Kalavai', pincode: '632506' },
    { value: 'kalpudur', label: 'Kalpudur', pincode: '632507' },
    { value: 'kaniyambadi', label: 'Kaniyambadi', pincode: '632105' },
    { value: 'karnambut', label: 'Karnambut', pincode: '632103' },
    { value: 'kaspa', label: 'Kaspa', pincode: '632001' },
    { value: 'katpadi', label: 'Katpadi', pincode: '632007' },
    { value: 'kavanur', label: 'Kavanur', pincode: '636901' },
    { value: 'kaveripakkam', label: 'Kaveripakkam', pincode: '636901' },
    { value: 'konavattam', label: 'Konavattam', pincode: '632003' },
    { value: 'kosapet', label: 'Kosapet', pincode: '632003' },
    { value: 'latteri', label: 'Latteri', pincode: '632501' },
    { value: 'mangadu', label: 'Mangadu', pincode: '632105' },
    { value: 'melvisharam', label: 'Melvisharam', pincode: '632509' },
    { value: 'nandiyalam', label: 'Nandiyalam', pincode: '632511' },
    { value: 'nemili', label: 'Nemili', pincode: '632504' },
    { value: 'ocheri', label: 'Ocheri', pincode: '632513' },
    { value: 'otteri', label: 'Otteri', pincode: '632104' },
    { value: 'pallikonda', label: 'Pallikonda', pincode: '635809' },
    { value: 'perumugai', label: 'Perumugai', pincode: '632507' },
    { value: 'peruvalayam', label: 'Peruvalayam', pincode: '632505' },
    { value: 'poigai', label: 'Poigai', pincode: '632104' },
    { value: 'ranipet', label: 'Ranipet', pincode: '632401' },
    { value: 'rv-nagar', label: 'RV Nagar', pincode: '632014' },
    { value: 'saidapet', label: 'Saidapet', pincode: '632014' },
    { value: 'sankaranpalayam', label: 'Sankaranpalayam', pincode: '632510' },
    { value: 'sathuvachari', label: 'Sathuvachari', pincode: '632009' },
    { value: 'serkadu', label: 'Serkadu', pincode: '632002' },
    { value: 'sethuvalai', label: 'Sethuvalai', pincode: '632507' },
    { value: 'sevur', label: 'Sevur', pincode: '632014' },
    { value: 'shenbakkam', label: 'Shenbakkam', pincode: '632010' },
    { value: 'sholinghur', label: 'Sholinghur', pincode: '631102' },
    { value: 'thakkolam', label: 'Thakkolam', pincode: '632315' },
    { value: 'thamaraipakkam', label: 'Thamaraipakkam', pincode: '632517' },
    { value: 'thirumalaikodi', label: 'Thirumalaikodi', pincode: '632105' },
    { value: 'thirumani', label: 'Thirumani', pincode: '632514' },
    { value: 'thiruvalam', label: 'Thiruvalam', pincode: '632106' },
    { value: 'thorapadi', label: 'Thorapadi', pincode: '632001' },
    { value: 'thottapalayam', label: 'Thottapalayam', pincode: '632014' },
    { value: 'thuthipet', label: 'Thuthipet', pincode: '632512' },
    { value: 'tirupattur', label: 'Tirupattur', pincode: '635601' },
    { value: 'ussoor', label: 'Ussoor', pincode: '632507' },
    { value: 'vaniyambadi', label: 'Vaniyambadi', pincode: '635751' },
    { value: 'venkatapuram', label: 'Venkatapuram', pincode: '632014' },
    { value: 'virinjipuram', label: 'Virinjipuram', pincode: '632001' },
    { value: 'viruthampattu', label: 'Viruthampattu', pincode: '632015' },
    { value: 'wala-ranipet-1', label: 'Wala Ranipet 1', pincode: '632403' },
    { value: 'walajapet', label: 'Walajapet', pincode: '632513' },
    { value: 'yelagiri', label: 'Yelagiri', pincode: '635853' }
  ],

  'dindigul': [
    { value: 'alampatti', label: 'Alampatti', pincode: '624705' },
    { value: 'annavasal', label: 'Annavasal', pincode: '624701' },
    { value: 'appakoodal', label: 'Appakoodal', pincode: '624203' },
    { value: 'aruppukkottai', label: 'Aruppukkottai', pincode: '624101' },
    { value: 'athoor', label: 'Athoor', pincode: '624204' },
    { value: 'azhagappapuram', label: 'Azhagappapuram', pincode: '624201' },
    { value: 'batlagundu', label: 'Batlagundu', pincode: '624202' },
    { value: 'bodinaickanur', label: 'Bodinaickanur', pincode: '624202' },
    { value: 'chennai-dindigul-road', label: 'Chennai Dindigul Road', pincode: '624005' },
    { value: 'chettikulam', label: 'Chettikulam', pincode: '624222' },
    { value: 'chinnalapatti', label: 'Chinnalapatti', pincode: '624301' },
    { value: 'ilanthirayar', label: 'Ilanthirayar', pincode: '624702' },
    { value: 'kalugamalai', label: 'Kalugamalai', pincode: '624615' },
    { value: 'kandamanayakkanpatti', label: 'Kandamanayakkanpatti', pincode: '624301' },
    { value: 'karumalaikoodal', label: 'Karumalaikoodal', pincode: '624212' },
    { value: 'karumapuram', label: 'Karumapuram', pincode: '624701' },
    { value: 'kodaikanal', label: 'Kodaikanal', pincode: '624101' },
    { value: 'kodaikanal-road', label: 'Kodaikanal Road', pincode: '624202' },
    { value: 'kothaiyur', label: 'Kothaiyur', pincode: '624701' },
    { value: 'kothakottai', label: 'Kothakottai', pincode: '624206' },
    { value: 'kothampatti', label: 'Kothampatti', pincode: '624701' },
    { value: 'kothandaramanpatti', label: 'Kothandaramanpatti', pincode: '624204' },
    { value: 'kotthampatti', label: 'Kotthampatti', pincode: '624703' },
    { value: 'kumarapuram', label: 'Kumarapuram', pincode: '624701' },
    { value: 'kundah', label: 'Kundah', pincode: '624206' },
    { value: 'kundrakudi', label: 'Kundrakudi', pincode: '624302' },
    { value: 'kuruvimalai', label: 'Kuruvimalai', pincode: '624701' },
    { value: 'kusavankarai', label: 'Kusavankarai', pincode: '624206' },
    { value: 'mangalapuram', label: 'Mangalapuram', pincode: '624103' },
    { value: 'maruthupandiyar', label: 'Maruthupandiyar', pincode: '624204' },
    { value: 'mavathur', label: 'Mavathur', pincode: '624216' },
    { value: 'melur', label: 'Melur', pincode: '624505' },
    { value: 'mettupatti', label: 'Mettupatti', pincode: '624704' },
    { value: 'moolakaraipatti', label: 'Moolakaraipatti', pincode: '624703' },
    { value: 'mukkilpatti', label: 'Mukkilpatti', pincode: '624202' },
    { value: 'muthupatti', label: 'Muthupatti', pincode: '624210' },
    { value: 'muthur', label: 'Muthur', pincode: '624303' },
    { value: 'natham', label: 'Natham', pincode: '624401' },
    { value: 'nilakottai', label: 'Nilakottai', pincode: '624208' },
    { value: 'othakkalmandapam', label: 'Othakkalmandapam', pincode: '624603' },
    { value: 'pachalur', label: 'Pachalur', pincode: '624612' },
    { value: 'pacheri', label: 'Pacheri', pincode: '624707' },
    { value: 'panchalankurichi', label: 'Panchalankurichi', pincode: '624212' },
    { value: 'pattiveeranpatti', label: 'Pattiveeranpatti', pincode: '624702' },
    { value: 'pazhani', label: 'Pazhani', pincode: '624205' },
    { value: 'peraiyur', label: 'Peraiyur', pincode: '624601' },
    { value: 'perumalmalai', label: 'Perumalmalai', pincode: '624101' },
    { value: 'pillaiyarpatti', label: 'Pillaiyarpatti', pincode: '624215' },
    { value: 'poovandhi', label: 'Poovandhi', pincode: '624703' },
    { value: 'pudur', label: 'Pudur', pincode: '624705' },
    { value: 'rakkipatti', label: 'Rakkipatti', pincode: '624001' },
    { value: 'samayapuram', label: 'Samayapuram', pincode: '624612' },
    { value: 'sankarapuram', label: 'Sankarapuram', pincode: '624622' },
    { value: 'sembatti', label: 'Sembatti', pincode: '624303' },
    { value: 'sivagiri', label: 'Sivagiri', pincode: '624202' },
    { value: 'sivapuram', label: 'Sivapuram', pincode: '624302' },
    { value: 't-kallupatti', label: 'T. Kallupatti', pincode: '624601' },
    { value: 'thadiyampatti', label: 'Thadiyampatti', pincode: '624710' },
    { value: 'thoppampatti', label: 'Thoppampatti', pincode: '624703' },
    { value: 'tiruchuli', label: 'Tiruchuli', pincode: '624615' },
    { value: 'vadamadurai', label: 'Vadamadurai', pincode: '624706' },
    { value: 'valayapatti', label: 'Valayapatti', pincode: '624706' },
    { value: 'vallalapatti', label: 'Vallalapatti', pincode: '624209' },
    { value: 'vannipatti', label: 'Vannipatti', pincode: '624702' },
    { value: 'vavvathur', label: 'Vavvathur', pincode: '624705' },
    { value: 'vedasandur', label: 'Vedasandur', pincode: '624710' },
    { value: 'veerapandi', label: 'Veerapandi', pincode: '624308' },
    { value: 'vennandur', label: 'Vennandur', pincode: '624205' }
  ],

  'cuddalore': [
    { value: 'alapakkam', label: 'Alapakkam', pincode: '607102' },
    { value: 'b.Mutlur', label: 'B.Mutlur', pincode: '608501' },
    { value: 'bahour', label: 'Bahour', pincode: '607402' },
    { value: 'capper-Hills', label: 'Capper Hills', pincode: '607001' },
    { value: 'chidambaram', label: 'Chidambaram', pincode: '608001' },
    { value: 'chinnakumaramangalam', label: 'Chinnakumaramangalam', pincode: '607101' },
    { value: 'cuddalore-Old-Town', label: 'Cuddalore Old Town', pincode: '607003' },
    { value: 'devanampattinam', label: 'Devanampattinam', pincode: '607003' },
    { value: 'keelkumaramangalam', label: 'Keelkumaramangalam', pincode: '607101' },
    { value: 'koothapakkam', label: 'Koothapakkam', pincode: '607002' },
    { value: 'kumaratchi', label: 'Kumaratchi', pincode: '608301' },
    { value: 'kullanchavadi', label: 'Kullanchavadi', pincode: '607301' },
    { value: 'kurinjipadi', label: 'Kurinjipadi', pincode: '607302' },
    { value: 'manjakuppam', label: 'Manjakuppam', pincode: '607001' },
    { value: 'melpattampakkam', label: 'Melpattampakkam', pincode: '607104' },
    { value: 'melpazhangur', label: 'Melpazhangur', pincode: '607108' },
    { value: 'mudalur', label: 'Mudalur', pincode: '607401' },
    { value: 'nellikuppam', label: 'Nellikuppam', pincode: '607105' },
    { value: 'neyveli', label: 'Neyveli', pincode: '607802' },
    { value: 'pallipadai', label: 'Pallipadai', pincode: '607401' },
    { value: 'parangipettai', label: 'Parangipettai', pincode: '608502' },
    { value: 'periyakanganankuppam', label: 'Periyakanganankuppam', pincode: '607006' },
    { value: 'pudukkuppam', label: 'Pudukkuppam', pincode: '607003' },
    { value: 'puduchatram', label: 'Puduchatram', pincode: '607402' },
    { value: 'samiyarpettai', label: 'Samiyarpettai', pincode: '608304' },
    { value: 'semmandalam', label: 'Semmandalam', pincode: '607001' },
    { value: 'sIPCOT-Industrial-Estate', label: 'SIPCOT Industrial Estate', pincode: '607005' },
    { value: 'silver-Beach', label: 'Silver Beach', pincode: '607003' },
    { value: 'sothikuppam', label: 'Sothikuppam', pincode: '607003' },
    { value: 'thirupapuliyur', label: 'Thirupapuliyur', pincode: '607002' },
    { value: 'thiruvandipuram', label: 'Thiruvandipuram', pincode: '607401' },
    { value: 'thotappattu', label: 'Thotappattu', pincode: '607003' },
    { value: 'vadalur', label: 'Vadalur', pincode: '607303' },
    { value: 'varakkalpattu', label: 'Varakkalpattu', pincode: '607106' },
    { value: 'veppur', label: 'Veppur', pincode: '607204' },
    { value: 'vepur', label: 'Vepur', pincode: '607202' }
  ],

  'karur': [
    { value: 'andankoil', label: 'Andankoil', pincode: '639008' },
    { value: 'aravakurichi', label: 'Aravakurichi', pincode: '639201' },
    { value: 'athur', label: 'Athur', pincode: '639110' },
    { value: 'chalapatti', label: 'Chalapatti', pincode: '639118' },
    { value: 'chettipalayam', label: 'Chettipalayam', pincode: '639104' },
    { value: 'chinnadharapuram', label: 'Chinnadharapuram', pincode: '639202' },
    { value: 'gandhigramam', label: 'Gandhigramam', pincode: '639004' },
    { value: 'inungur', label: 'Inungur', pincode: '639110' },
    { value: 'kadaparai', label: 'Kadaparai', pincode: '639006' },
    { value: 'karudayampalayam', label: 'Karudayampalayam', pincode: '639002' },
    { value: 'karur-town', label: 'Karur Town', pincode: '639001' },
    { value: 'karur-vysial-street', label: 'Karur Vysial Street', pincode: '639002' },
    { value: 'kavalkaranpatti', label: 'Kavalkaranpatti', pincode: '639117' },
    { value: 'koyampalli', label: 'Koyampalli', pincode: '639114' },
    { value: 'kulithalai', label: 'Kulithalai', pincode: '639104' },
    { value: 'lalapet', label: 'Lalapet', pincode: '639105' },
    { value: 'mookanur', label: 'Mookanur', pincode: '639114' },
    { value: 'moorthypalayam', label: 'Moorthypalayam', pincode: '639120' },
    { value: 'nadayanur', label: 'Nadayanur', pincode: '639207' },
    { value: 'nerur', label: 'Nerur', pincode: '639007' },
    { value: 'pappankurichi', label: 'Pappankurichi', pincode: '639003' },
    { value: 'pugalur', label: 'Pugalur', pincode: '639113' },
    { value: 'puliyur', label: 'Puliyur', pincode: '639114' },
    { value: 'rayanoor', label: 'Rayanoor', pincode: '639002' },
    { value: 'somur', label: 'Somur', pincode: '639006' },
    { value: 'tharagampatti', label: 'Tharagampatti', pincode: '639003' },
    { value: 'thennilai', label: 'Thennilai', pincode: '639206' },
    { value: 'uppidamangalam', label: 'Uppidamangalam', pincode: '639114' },
    { value: 'vaangappalayam', label: 'Vaangappalayam', pincode: '639004' },
    { value: 'velliyanai', label: 'Velliyanai', pincode: '639118' },
    { value: 'vemudupatti', label: 'Vemudupatti', pincode: '639002' },
    { value: 'west-palayam', label: 'West Palayam', pincode: '639005' },
    { value: 'vyasanur', label: 'Vyasanur', pincode: '639118' },
    { value: 'muthur', label: 'Muthur', pincode: '639119' }
  ],

  'ramanathapuram': [
    { value: 'akamkudi', label: 'Akamkudi', pincode: '623521' },
    { value: 'alanthankarai', label: 'Alanthankarai', pincode: '623528' },
    { value: 'anaiyur', label: 'Anaiyur', pincode: '623602' },
    { value: 'chithirankudi', label: 'Chithirankudi', pincode: '623706' },
    { value: 'chittarkottai', label: 'Chittarkottai', pincode: '623513' },
    { value: 'erwadi', label: 'Erwadi', pincode: '623515' },
    { value: 'kalimankundu', label: 'Kalimankundu', pincode: '623701' },
    { value: 'kamuthi', label: 'Kamuthi', pincode: '623603' },
    { value: 'kenikarai', label: 'Kenikarai', pincode: '623503' },
    { value: 'mandapam', label: 'Mandapam', pincode: '623518' },
    { value: 'melapudukudi', label: 'Melapudukudi', pincode: '623520' },
    { value: 'mookkaiyur', label: 'Mookkaiyur', pincode: '623529' },
    { value: 'mudukulathur', label: 'Mudukulathur', pincode: '623704' },
    { value: 'nalangulam', label: 'Nalangulam', pincode: '623711' },
    { value: 'nainarkoil', label: 'Nainarkoil', pincode: '623705' },
    { value: 'ooranipuram', label: 'Ooranipuram', pincode: '623536' },
    { value: 'panaikulam', label: 'Panaikulam', pincode: '623522' },
    { value: 'paramakudi', label: 'Paramakudi', pincode: '623707' },
    { value: 'periapattinam', label: 'Periapattinam', pincode: '623523' },
    { value: 'perungulam', label: 'Perungulam', pincode: '623517' },
    { value: 'pirappanvalasai', label: 'Pirappanvalasai', pincode: '623529' },
    { value: 'pudukottai', label: 'Pudukottai', pincode: '623533' },
    { value: 'rameswaram', label: 'Rameswaram', pincode: '623526' },
    { value: 'ramanathapuram-town', label: 'Ramanathapuram Town', pincode: '623501' },
    { value: 'sayalkudi', label: 'Sayalkudi', pincode: '623120' },
    { value: 'thangachimadam', label: 'Thangachimadam', pincode: '623529' },
    { value: 'thondi', label: 'Thondi', pincode: '623409' },
    { value: 'uchipuli', label: 'Uchipuli', pincode: '623534' },
    { value: 'uppur', label: 'Uppur', pincode: '623525' },
    { value: 'valantharavai', label: 'Valantharavai', pincode: '623536' },
    { value: 'vedalai', label: 'Vedalai', pincode: '623519' },
    { value: 'vellariodai', label: 'Vellariodai', pincode: '623520' },
    { value: 'vilathikulam', label: 'Vilathikulam', pincode: '628901' }
  ],
  'viluppuram': [
    { value: 'alampoondi', label: 'Alampoondi', pincode: '606201' },
    { value: 'anandhapuram', label: 'Anandhapuram', pincode: '605103' },
    { value: 'arakkurichi', label: 'Arakkurichi', pincode: '606202' },
    { value: 'arumpattu', label: 'Arumpattu', pincode: '606207' },
    { value: 'chinnasalem', label: 'Chinnasalem', pincode: '606201' },
    { value: 'gingee', label: 'Gingee', pincode: '604202' },
    { value: 'kalvarayan-hills', label: 'Kalvarayan Hills', pincode: '606207' },
    { value: 'kanai', label: 'Kanai', pincode: '605301' },
    { value: 'kandamangalam', label: 'Kandamangalam', pincode: '605102' },
    { value: 'kilpennathur', label: 'Kilpennathur', pincode: '606611' },
    { value: 'kottakuppam', label: 'Kottakuppam', pincode: '605104' },
    { value: 'kural', label: 'Kural', pincode: '605758' },
    { value: 'mahalingampatti', label: 'Mahalingampatti', pincode: '606207' },
    { value: 'manalurpet', label: 'Manalurpet', pincode: '605754' },
    { value: 'marakkanam', label: 'Marakkanam', pincode: '604303' },
    { value: 'melmalayanur', label: 'Melmalayanur', pincode: '604204' },
    { value: 'mugaiyur', label: 'Mugaiyur', pincode: '605755' },
    { value: 'olakkur', label: 'Olakkur', pincode: '604305' },
    { value: 'panruti', label: 'Panruti', pincode: '607106' },
    { value: 'pattanam', label: 'Pattanam', pincode: '606207' },
    { value: 'periyathatchur', label: 'Periyathatchur', pincode: '606201' },
    { value: 'sengam', label: 'Sengam', pincode: '606601' },
    { value: 'thirukkoilur', label: 'Thirukkoilur', pincode: '605757' },
    { value: 'thiruvennainallur', label: 'Thiruvennainallur', pincode: '607203' },
    { value: 'tindivanam', label: 'Tindivanam', pincode: '604001' },
    { value: 'uthukuli', label: 'Uthukuli', pincode: '606302' },
    { value: 'valavanur', label: 'Valavanur', pincode: '605108' },
    { value: 'viluppuram-town', label: 'Viluppuram Town', pincode: '605602' },
    { value: 'villupuram-east', label: 'Villupuram East', pincode: '605602' },
    { value: 'villupuram-west', label: 'Villupuram West', pincode: '605602' },
    { value: 'vikravandi', label: 'Vikravandi', pincode: '605652' },
    { value: 'virudhachalam', label: 'Virudhachalam', pincode: '606001' }
  ],

  'kanchipuram': [
    { value: 'azhagarai', label: 'Azhagarai', pincode: '631551' },
    { value: 'azhividaithangi', label: 'Azhividaithangi', pincode: '603108' },
    { value: 'cheyyar', label: 'Cheyyar', pincode: '604407' },
    { value: 'chinna kanchipuram', label: 'Chinna Kanchipuram', pincode: '631502' },
    { value: 'elavambadi', label: 'Elavambadi', pincode: '631551' },
    { value: 'kandavarayanpettai', label: 'Kandavarayanpettai', pincode: '631506' },
    { value: 'kanchipuram', label: 'Kanchipuram', pincode: '631501' },
    { value: 'karaipettai', label: 'Karaipettai', pincode: '631552' },
    { value: 'kattankulathur', label: 'Kattankulathur', pincode: '603203' },
    { value: 'kottaiyur', label: 'Kottaiyur', pincode: '631551' },
    { value: 'maraimalai nagar', label: 'Maraimalai Nagar', pincode: '603209' },
    { value: 'murugan nagar', label: 'Murugan Nagar', pincode: '631502' },
    { value: 'narasamangalam', label: 'Narasamangalam', pincode: '631552' },
    { value: 'oragadam', label: 'Oragadam', pincode: '602105' },
    { value: 'padappai', label: 'Padappai', pincode: '602301' },
    { value: 'perambakkam', label: 'Perambakkam', pincode: '631402' },
    { value: 'poonamallee', label: 'Poonamallee', pincode: '600056' },
    { value: 'sakkottai', label: 'Sakkottai', pincode: '631501' },
    { value: 'sholavaram', label: 'Sholavaram', pincode: '600067' },
    { value: 'sivakamipuram', label: 'Sivakamipuram', pincode: '631552' },
    { value: 'sriperumbudur', label: 'Sriperumbudur', pincode: '602105' },
    { value: 'thirukazhukundram', label: 'Thirukazhukundram', pincode: '603109' },
    { value: 'thiruporur', label: 'Thiruporur', pincode: '603110' },
    { value: 'thiruvidandai', label: 'Thiruvidandai', pincode: '600041' },
    { value: 'uttiramerur', label: 'Uttiramerur', pincode: '603406' },
    { value: 'vandavasi', label: 'Vandavasi', pincode: '604408' },
    { value: 'walajabad', label: 'Walajabad', pincode: '631605' },
    { value: 'west tambaram', label: 'West Tambaram', pincode: '600045' }
  ],

  'tirunelveli': [
    { value: 'alwarkurichi', label: 'Alwarkurichi', pincode: '627412' },
    { value: 'appakudal', label: 'Appakudal', pincode: '627806' },
    { value: 'cheranmahadevi', label: 'Cheranmahadevi', pincode: '627414' },
    { value: 'dravida', label: 'Dravida', pincode: '627401' },
    { value: 'ethimozhi', label: 'Ethimozhi', pincode: '627263' },
    { value: 'kadayam', label: 'Kadayam', pincode: '627451' },
    { value: 'kunnathur', label: 'Kunnathur', pincode: '627105' },
    { value: 'manur', label: 'Manur', pincode: '627007' },
    { value: 'melanadu', label: 'Melanadu', pincode: '627252' },
    { value: 'nanguneri', label: 'Nanguneri', pincode: '627109' },
    { value: 'palayamkottai', label: 'Palayamkottai', pincode: '627002' },
    { value: 'panchalankurichi', label: 'Panchalankurichi', pincode: '627415' },
    { value: 'pettai', label: 'Pettai', pincode: '627003' },
    { value: 'rajakulam', label: 'Rajakulam', pincode: '627808' },
    { value: 'sankarankovil', label: 'Sankarankovil', pincode: '627756' },
    { value: 'tiruchendur', label: 'Tiruchendur', pincode: '628215' },
    { value: 'tirunelveli', label: 'Tirunelveli', pincode: '627001' },
    { value: 'tuticorin', label: 'Tuticorin', pincode: '628001' },
    { value: 'vellakulam', label: 'Vellakulam', pincode: '627018' },
    { value: 'vickramasingapuram', label: 'Vickramasingapuram', pincode: '627425' },
    { value: 'valliyur', label: 'Valliyur', pincode: '627117' },
    { value: 'sivagiri', label: 'Sivagiri', pincode: '627757' },
    { value: 'kavalkinaru', label: 'Kavalkinaru', pincode: '627105' }
  ],

  'thanjavur': [
    { value: 'avaduthurai', label: 'Avaduthurai', pincode: '613201' },
    { value: 'kottaiyur', label: 'Kottaiyur', pincode: '613002' },
    { value: 'kumbakonam', label: 'Kumbakonam', pincode: '612001' },
    { value: 'manamadurai', label: 'Manamadurai', pincode: '630606' },
    { value: 'muthupet', label: 'Muthupet', pincode: '614702' },
    { value: 'nanjikottai', label: 'Nanjikottai', pincode: '613004' },
    { value: 'neralikkottai', label: 'Neralikkottai', pincode: '613005' },
    { value: 'papanasam', label: 'Papanasam', pincode: '614205' },
    { value: 'pattukottai', label: 'Pattukottai', pincode: '614601' },
    { value: 'sakkottai', label: 'Sakkottai', pincode: '614101' },
    { value: 'seerkazhi', label: 'Seerkazhi', pincode: '609001' },
    { value: 'tanajvur', label: 'Thanjavur', pincode: '613001' },
    { value: 'thiruthuraipoondi', label: 'Thiruthuraipoondi', pincode: '614713' },
    { value: 'thiruvaiyaru', label: 'Thiruvaiyaru', pincode: '613201' },
    { value: 'valangaiman', label: 'Valangaiman', pincode: '613503' },
    { value: 'vazhuthur', label: 'Vazhuthur', pincode: '614212' },
    { value: 'veppathur', label: 'Veppathur', pincode: '613602' },
    { value: 'vijayapuram', label: 'Vijayapuram', pincode: '613203' },
    { value: 'villupuram', label: 'Villupuram', pincode: '605602' }
  ],

  'thoothukudi': [
    { value: 'adavathur', label: 'Adavathur', pincode: '628502' },
    { value: 'andarkulam', label: 'Andarkulam', pincode: '628002' },
    { value: 'athur', label: 'Athur', pincode: '628401' },
    { value: 'ettayapuram', label: 'Ettayapuram', pincode: '628902' },
    { value: 'kailasapuram', label: 'Kailasapuram', pincode: '628301' },
    { value: 'kappalankarai', label: 'Kappalankarai', pincode: '628102' },
    { value: 'kayalpattinam', label: 'Kayalpattinam', pincode: '628204' },
    { value: 'koluthur', label: 'Koluthur', pincode: '628211' },
    { value: 'kuthiravadi', label: 'Kuthiravadi', pincode: '628103' },
    { value: 'madathukulam', label: 'Madathukulam', pincode: '628504' },
    { value: 'mangalapuram', label: 'Mangalapuram', pincode: '628304' },
    { value: 'muthuramalingapuram', label: 'Muthuramalingapuram', pincode: '628601' },
    { value: 'palayakayal', label: 'Palayakayal', pincode: '628201' },
    { value: 'pallam', label: 'Pallam', pincode: '628102' },
    { value: 'pazhavur', label: 'Pazhavur', pincode: '628002' },
    { value: 'periyathalai', label: 'Periyathalai', pincode: '628502' },
    { value: 'sattankulam', label: 'Sattankulam', pincode: '628704' },
    { value: 'seruthur', label: 'Seruthur', pincode: '628401' },
    { value: 'sivakasi', label: 'Sivakasi', pincode: '626124' },
    { value: 'thoothukudi', label: 'Thoothukudi', pincode: '628001' },
    { value: 'tuticorin', label: 'Tuticorin', pincode: '628001' },
    { value: 'tuticorin-port', label: 'Tuticorin Port', pincode: '628004' },
    { value: 'udangudi', label: 'Udangudi', pincode: '628203' },
    { value: 'vadakkankulam', label: 'Vadakkankulam', pincode: '628004' },
    { value: 'vickramasingapuram', label: 'Vickramasingapuram', pincode: '628503' },
    { value: 'vilathikulam', label: 'Vilathikulam', pincode: '628601' },
    { value: 'villukkuri', label: 'Villukkuri', pincode: '628005' }
  ],
'tiruppur': [
  { value: 'annur', label: 'Annur', pincode: '641653' },
  { value: 'avinasipalayam', label: 'Avinasipalayam', pincode: '641037' },
  { value: 'bhavani', label: 'Bhavani', pincode: '638301' },
  { value: 'elavanpalayam', label: 'Elavanpalayam', pincode: '641301' },
  { value: 'irugur', label: 'Irugur', pincode: '641103' },
  { value: 'karuvampalayam', label: 'Karuvampalayam', pincode: '641663' },
  { value: 'kavundampalayam', label: 'Kavundampalayam', pincode: '641018' },
  { value: 'kirubathur', label: 'Kirubathur', pincode: '641603' },
  { value: 'kolakattai', label: 'Kolakattai', pincode: '641654' },
  { value: 'muthur', label: 'Muthur', pincode: '641407' },
  { value: 'nadupatti', label: 'Nadupatti', pincode: '641617' },
  { value: 'pudupalayam', label: 'Pudupalayam', pincode: '641687' },
  { value: 'sulur', label: 'Sulur', pincode: '641402' },
  { value: 'tiruppur', label: 'Tiruppur', pincode: '641601' },
  { value: 'tiruppur-east', label: 'Tiruppur East', pincode: '641602' },
  { value: 'tiruppur-west', label: 'Tiruppur West', pincode: '641603' },
  { value: 'udalipalayam', label: 'Udalipalayam', pincode: '641656' },
  { value: 'vellanaipudur', label: 'Vellanaipudur', pincode: '641635' },
  { value: 'vellakoil', label: 'Vellakoil', pincode: '638111' },
  { value: 'veerappanpalayam', label: 'Veerappanpalayam', pincode: '641662' },
  { value: 'karadiputhur', label: 'Karadiputhur', pincode: '641671' },
  { value: 'perumanallur', label: 'Perumanallur', pincode: '641666' },
  { value: 'pothanaickenpalayam', label: 'Pothanaickenpalayam', pincode: '641705' },
  { value: 'rayakottai', label: 'Rayakottai', pincode: '638001' },
  { value: 'sakthi-nagar', label: 'Sakthi Nagar', pincode: '641026' },
  { value: 'samundra', label: 'Samundra', pincode: '641210' },
  { value: 'saravanampatty', label: 'Saravanampatty', pincode: '641035' },
  { value: 'tidel-park', label: 'Tidel Park', pincode: '641023' },
  { value: 'thangamapalayam', label: 'Thangamapalayam', pincode: '641211' }
  ],

  'tiruchirappalli': [
  { value: 'azhagiapandipuram', label: 'Azhagiapandipuram', pincode: '620014' },
  { value: 'bhel-colony', label: 'BHEL Colony', pincode: '620014' },
  { value: 'chakrapani', label: 'Chakrapani', pincode: '620018' },
  { value: 'chernai', label: 'Cheranai', pincode: '620102' },
  { value: 'k-k-nagar', label: 'K.K. Nagar', pincode: '620021' },
  { value: 'kumaramangalam', label: 'Kumaramangalam', pincode: '620005' },
  { value: 'kottapatti', label: 'Kottapatti', pincode: '620015' },
  { value: 'kottur', label: 'Kottur', pincode: '620019' },
  { value: 'mandaiyur', label: 'Mandaiyur', pincode: '620020' },
  { value: 'mangalam', label: 'Mangalam', pincode: '620001' },
  { value: 'ponmalai', label: 'Ponmalai', pincode: '620003' },
  { value: 'pudukkottai', label: 'Pudukkottai', pincode: '622001' },
  { value: 'srirangam', label: 'Srirangam', pincode: '620006' },
  { value: 'tanjore', label: 'Tanjore', pincode: '613001' },
  { value: 'thiruvanaikoil', label: 'Thiruvanaikoil', pincode: '620005' },
  { value: 'tiruchirappalli', label: 'Tiruchirappalli', pincode: '620001' },
  { value: 'trichy-central', label: 'Trichy Central', pincode: '620002' },
  { value: 'thillai-nayak', label: 'Thillai Nayak', pincode: '620001' },
  { value: 'thiruverumbur', label: 'Thiruverumbur', pincode: '620013' },
  { value: 'tiruverumbur-west', label: 'Tiruverumbur West', pincode: '620014' },
  { value: 'uppilipalayam', label: 'Uppilipalayam', pincode: '620010' },
  { value: 'vallam', label: 'Vallam', pincode: '620017' },
  { value: 'vengur', label: 'Vengur', pincode: '620005' },
  { value: 'veppur', label: 'Veppur', pincode: '620101' },
  { value: 'viraliyur', label: 'Viraliyur', pincode: '620008' },
  { value: 'west-k-k-nagar', label: 'West K.K. Nagar', pincode: '620021' },
  { value: 'yadhava', label: 'Yadhava', pincode: '620007' }
  ],

  'pudukkottai': [
  { value: 'alampatti', label: 'Alampatti', pincode: '622001' },
  { value: 'andipatti', label: 'Andipatti', pincode: '622303' },
  { value: 'ilaiyankudi', label: 'Ilaiyankudi', pincode: '622303' },
  { value: 'kadukkampatti', label: 'Kadukkampatti', pincode: '622104' },
  { value: 'kalayarkoil', label: 'Kalayarkoil', pincode: '622203' },
  { value: 'kallukatti', label: 'Kallukatti', pincode: '622005' },
  { value: 'kandanur', label: 'Kandanur', pincode: '622507' },
  { value: 'karambakudi', label: 'Karambakudi', pincode: '622302' },
  { value: 'kavundampatti', label: 'Kavundampatti', pincode: '622202' },
  { value: 'manamelkudi', label: 'Manamelkudi', pincode: '622305' },
  { value: 'meignanapuram', label: 'Meignanapuram', pincode: '622005' },
  { value: 'muthupatti', label: 'Muthupatti', pincode: '622503' },
  { value: 'nangudi', label: 'Nangudi', pincode: '622203' },
  { value: 'peraiyur', label: 'Peraiyur', pincode: '622202' },
  { value: 'pudukkottai-town', label: 'Pudukkottai Town', pincode: '622001' },
  { value: 'sankarapuram', label: 'Sankarapuram', pincode: '622502' },
  { value: 'tiruvarankulam', label: 'Tiruvarankulam', pincode: '622201' },
  { value: 'vadugapatti', label: 'Vadugapatti', pincode: '622103' },
  { value: 'valivalam', label: 'Valivalam', pincode: '622201' },
  { value: 'vayalur', label: 'Vayalur', pincode: '622203' },
  { value: 'arimalam', label: 'Arimalam', pincode: '622103' },
  { value: 'bavaniyapuram', label: 'Bavaniyapuram', pincode: '622304' },
  { value: 'kurumbanadu', label: 'Kurumbanadu', pincode: '622204' },
  { value: 'meiyur', label: 'Meiyur', pincode: '622206' },
  { value: 'manikandapuram', label: 'Manikandapuram', pincode: '622103' },
  { value: 'neelayur', label: 'Neelayur', pincode: '622101' },
  { value: 'pulivalam', label: 'Pulivalam', pincode: '622207' },
  { value: 'thirumayam', label: 'Thirumayam', pincode: '622507' },
  { value: 'thiruvengadu', label: 'Thiruvengadu', pincode: '622508' },
  { value: 'veppur', label: 'Veppur', pincode: '622505' }
  ],

  'hosur': [
  { value: 'alampatti', label: 'Alampatti', pincode: '635109' },
  { value: 'bagalur', label: 'Bagalur', pincode: '635103' },
  { value: 'bangalore-road', label: 'Bangalore Road', pincode: '635109' },
  { value: 'chinnar', label: 'Chinnar', pincode: '635105' },
  { value: 'denkanikottai', label: 'Denkanikottai', pincode: '635107' },
  { value: 'kelamangalam', label: 'Kelamangalam', pincode: '635112' },
  { value: 'krishnagiri', label: 'Krishnagiri', pincode: '635001' },
  { value: 'muthur', label: 'Muthur', pincode: '635202' },
  { value: 'palacode', label: 'Palacode', pincode: '635208' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '635110' },
  { value: 'sathyamangalam', label: 'Sathyamangalam', pincode: '635301' },
  { value: 'shoolagiri', label: 'Shoolagiri', pincode: '635117' },
  { value: 'sithampundi', label: 'Sithampundi', pincode: '635109' },
  { value: 'thally', label: 'Thally', pincode: '635113' },
  { value: 'vandalur', label: 'Vandalur', pincode: '635111' },
  { value: 'vettangudi', label: 'Vettangudi', pincode: '635104' },
  { value: 'balathuru', label: 'Balathuru', pincode: '635119' },
  { value: 'chandrapadi', label: 'Chandrapadi', pincode: '635102' },
  { value: 'doddaballapur', label: 'Doddaballapur', pincode: '635120' },
  { value: 'jigani', label: 'Jigani', pincode: '635105' },
  { value: 'kannigaipudur', label: 'Kannigaipudur', pincode: '635102' },
  { value: 'kachinahalli', label: 'Kachinahalli', pincode: '635101' },
  { value: 'kaveripatti', label: 'Kaveripatti', pincode: '635109' },
  { value: 'sivagiri', label: 'Sivagiri', pincode: '635115' },
  { value: 'tindivanam', label: 'Tindivanam', pincode: '635119' },
  { value: 'uthangarai', label: 'Uthangarai', pincode: '635207' },
  { value: 'vavadi', label: 'Vavadi', pincode: '635116' }
  ],

  'rajapalayam': [
  { value: 'alampatti', label: 'Alampatti', pincode: '626117' },
  { value: 'ammapatti', label: 'Ammapatti', pincode: '626106' },
  { value: 'kaliyapuram', label: 'Kaliyapuram', pincode: '626110' },
  { value: 'kamuthi', label: 'Kamuthi', pincode: '626131' },
  { value: 'karisalkulam', label: 'Karisalkulam', pincode: '626124' },
  { value: 'keelapavoor', label: 'Keelapavoor', pincode: '626112' },
  { value: 'kothaiyur', label: 'Kothaiyur', pincode: '626138' },
  { value: 'mampatti', label: 'Mampatti', pincode: '626117' },
  { value: 'murungapakkam', label: 'Murungapakkam', pincode: '626106' },
  { value: 'nambikulam', label: 'Nambikulam', pincode: '626121' },
  { value: 'palayankottai', label: 'Palayankottai', pincode: '626122' },
  { value: 'pallapatti', label: 'Pallapatti', pincode: '626110' },
  { value: 'rajapalayam-town', label: 'Rajapalayam Town', pincode: '626117' },
  { value: 'sivagiri', label: 'Sivagiri', pincode: '626140' },
  { value: 't-palayam', label: 'T. Palayam', pincode: '626110' },
  { value: 'thiruvengadam', label: 'Thiruvengadam', pincode: '626113' },
  { value: 'valayankulam', label: 'Valayankulam', pincode: '626129' },
  { value: 'vannankulam', label: 'Vannankulam', pincode: '626129' },
  { value: 'vilakudi', label: 'Vilakudi', pincode: '626136' },
  { value: 'virudhunagar', label: 'Virudhunagar', pincode: '626001' },
  { value: 'angarai', label: 'Angarai', pincode: '626126' },
  { value: 'udayaneri', label: 'Udayaneri', pincode: '626115' },
  { value: 'sundarapandiapuram', label: 'Sundarapandiapuram', pincode: '626119' },
  { value: 'ponnapuram', label: 'Ponnapuram', pincode: '626128' },
  { value: 'kottur', label: 'Kottur', pincode: '626123' },
  { value: 'marimuthu-nagar', label: 'Marimuthu Nagar', pincode: '626127' },
  { value: 'thirumangalam', label: 'Thirumangalam', pincode: '626130' }
  ],

  'kumbakonam': [
  { value: 'aduthurai', label: 'Aduthurai', pincode: '612101' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '612204' },
  { value: 'kalimedu', label: 'Kalimedu', pincode: '612001' },
  { value: 'kambainallur', label: 'Kambainallur', pincode: '612701' },
  { value: 'kottaiyur', label: 'Kottaiyur', pincode: '612103' },
  { value: 'kumbakonam-town', label: 'Kumbakonam Town', pincode: '612001' },
  { value: 'mananallur', label: 'Mananallur', pincode: '612302' },
  { value: 'meelavittan', label: 'Meelavittan', pincode: '612501' },
  { value: 'nanjikottai', label: 'Nanjikottai', pincode: '612204' },
  { value: 'palayakudi', label: 'Palayakudi', pincode: '612603' },
  { value: 'peralam', label: 'Peralam', pincode: '612601' },
  { value: 'perumalpattu', label: 'Perumalpattu', pincode: '612303' },
  { value: 'pudupettai', label: 'Pudupettai', pincode: '612701' },
  { value: 'srimushnam', label: 'Srimushnam', pincode: '612302' },
  { value: 'thiruveezhimizhalai', label: 'Thiruveezhimizhalai', pincode: '612602' },
  { value: 'thirupunavasal', label: 'Thirupunavasal', pincode: '612103' },
  { value: 'thiruvidaimarudur', label: 'Thiruvidaimarudur', pincode: '612104' },
  { value: 'udaiyarkudi', label: 'Udaiyarkudi', pincode: '612203' },
  { value: 'varaganathi', label: 'Varaganathi', pincode: '612103' },
  { value: 'azhiyur', label: 'Azhiyur', pincode: '612301' },
  { value: 'balakrishnapuram', label: 'Balakrishnapuram', pincode: '612106' },
  { value: 'cuddalore', label: 'Cuddalore', pincode: '612201' },
  { value: 'melakottai', label: 'Melakottai', pincode: '612101' },
  { value: 'poovanthi', label: 'Poovanthi', pincode: '612102' },
  { value: 'thiruvengadu', label: 'Thiruvengadu', pincode: '612504' },
  { value: 'thiruthuraipoondi', label: 'Thiruthuraipoondi', pincode: '612801' }
  ],

  'karaikudi': [
  { value: 'alampatti', label: 'Alampatti', pincode: '630304' },
  { value: 'karaikudi-town', label: 'Karaikudi Town', pincode: '630001' },
  { value: 'kalaiyarkoil', label: 'Kalaiyarkoil', pincode: '630551' },
  { value: 'kanadukathan', label: 'Kanadukathan', pincode: '630103' },
  { value: 'kottaiyur', label: 'Kottaiyur', pincode: '630101' },
  { value: 'kottur', label: 'Kottur', pincode: '630107' },
  { value: 'madhagupatti', label: 'Madhagupatti', pincode: '630106' },
  { value: 'manamadurai', label: 'Manamadurai', pincode: '630606' },
  { value: 'melakottai', label: 'Melakottai', pincode: '630501' },
  { value: 'periya-sevalpatti', label: 'Periya Sevalpatti', pincode: '630404' },
  { value: 'sivagangai', label: 'Sivagangai', pincode: '630561' },
  { value: 'thiruppachetti', label: 'Thiruppachetti', pincode: '630505' },
  { value: 'thirupathisaram', label: 'Thirupathisaram', pincode: '630512' },
  { value: 'thiruvadanai', label: 'Thiruvadanai', pincode: '630561' },
  { value: 'valaiyapatti', label: 'Valaiyapatti', pincode: '630308' },
  { value: 'vettangudi', label: 'Vettangudi', pincode: '630301' },
  { value: 'avudaiyarkoil', label: 'Avudaiyarkoil', pincode: '630503' },
  { value: 'chatrapatti', label: 'Chatrapatti', pincode: '630106' },
  { value: 'chettinad', label: 'Chettinad', pincode: '630101' },
  { value: 'kandadevi', label: 'Kandadevi', pincode: '630103' },
  { value: 'madhurapuram', label: 'Madhurapuram', pincode: '630612' },
  { value: 'padalur', label: 'Padalur', pincode: '630504' },
  { value: 'pudupatti', label: 'Pudupatti', pincode: '630207' },
  { value: 'sengamangalam', label: 'Sengamangalam', pincode: '630501' },
  { value: 'thiruvengadam', label: 'Thiruvengadam', pincode: '630509' },
  { value: 'velangudi', label: 'Velangudi', pincode: '630505' }
  ],

  'ambur': [
  { value: 'ambur-town', label: 'Ambur Town', pincode: '635802' },
  { value: 'balevalai', label: 'Balevalai', pincode: '635812' },
  { value: 'baskarapuram', label: 'Baskarapuram', pincode: '635804' },
  { value: 'banavaram', label: 'Banavaram', pincode: '635806' },
  { value: 'karadipatti', label: 'Karadipatti', pincode: '635808' },
  { value: 'kaveripakkam', label: 'Kaveripakkam', pincode: '635806' },
  { value: 'kothakuppam', label: 'Kothakuppam', pincode: '635811' },
  { value: 'muthur', label: 'Muthur', pincode: '635811' },
  { value: 'nadupettai', label: 'Nadupettai', pincode: '635804' },
  { value: 'north-ambur', label: 'North Ambur', pincode: '635802' },
  { value: 'selavampet', label: 'Selavampet', pincode: '635810' },
  { value: 'thandalam', label: 'Thandalam', pincode: '635804' },
  { value: 'thennampatti', label: 'Thennampatti', pincode: '635806' },
  { value: 'thiruvannamalai', label: 'Thiruvannamalai', pincode: '635801' },
  { value: 'vannipakkam', label: 'Vannipakkam', pincode: '635807' },
  { value: 'villupuram', label: 'Villupuram', pincode: '635805' },
  { value: 'alathur', label: 'Alathur', pincode: '635806' },
  { value: 'kothur', label: 'Kothur', pincode: '635804' },
  { value: 'mukundarayapuram', label: 'Mukundarayapuram', pincode: '635809' },
  { value: 'nadukuppam', label: 'Nadukuppam', pincode: '635810' },
  { value: 'peddampet', label: 'Peddampet', pincode: '635808' },
  { value: 'perumalpatti', label: 'Perumalpatti', pincode: '635812' },
  { value: 'periyaputhur', label: 'Periyaputhur', pincode: '635803' },
  { value: 'south-ambur', label: 'South Ambur', pincode: '635802' },
  { value: 'thiruvengadam', label: 'Thiruvengadam', pincode: '635809' }
  ],

  'sivaganga': [
  { value: 'aravayal', label: 'Aravayal', pincode: '630501' },
  { value: 'karaikkudi', label: 'Karaikkudi', pincode: '630001' },
  { value: 'karaiyur', label: 'Karaiyur', pincode: '630702' },
  { value: 'kottaiyur', label: 'Kottaiyur', pincode: '630601' },
  { value: 'manamadurai', label: 'Manamadurai', pincode: '630606' },
  { value: 'melakottai', label: 'Melakottai', pincode: '630501' },
  { value: 'peraiyur', label: 'Peraiyur', pincode: '630402' },
  { value: 'perumalpatti', label: 'Perumalpatti', pincode: '630401' },
  { value: 'pudukkottai', label: 'Pudukkottai', pincode: '630303' },
  { value: 'sivaganga-town', label: 'Sivaganga Town', pincode: '630561' },
  { value: 'thirupuvanam', label: 'Thirupuvanam', pincode: '630611' },
  { value: 'thiruvadanai', label: 'Thiruvadanai', pincode: '630561' },
  { value: 'thiruvembal', label: 'Thiruvembal', pincode: '630302' },
  { value: 'vadalur', label: 'Vadalur', pincode: '630702' },
  { value: 'vadiyur', label: 'Vadiyur', pincode: '630561' },
  { value: 'vallam', label: 'Vallam', pincode: '630561' },
  { value: 'muthur', label: 'Muthur', pincode: '630604' },
  { value: 'periya-sevalpatti', label: 'Periya Sevalpatti', pincode: '630606' },
  { value: 'pudukottai-town', label: 'Pudukkottai Town', pincode: '630301' },
  { value: 'palayam', label: 'Palayam', pincode: '630701' },
  { value: 'thiruvidaimarudur', label: 'Thiruvidaimarudur', pincode: '630601' },
  { value: 'thiruvazhundur', label: 'Thiruvazhundur', pincode: '630302' },
  { value: 'achankulam', label: 'Achankulam', pincode: '630561' },
  { value: 'alampatti', label: 'Alampatti', pincode: '630202' },
  { value: 'kanadukathan', label: 'Kanadukathan', pincode: '630103' }
  ],

  'gudiyatham': [
  { value: 'badri-nagar', label: 'Badri Nagar', pincode: '632602' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '632602' },
  { value: 'gudiyatham-town', label: 'Gudiyatham Town', pincode: '632602' },
  { value: 'kannamangalam', label: 'Kannamangalam', pincode: '632602' },
  { value: 'kattu-kalayanur', label: 'Kattu Kalayanur', pincode: '632601' },
  { value: 'kothur', label: 'Kothur', pincode: '632601' },
  { value: 'madanur', label: 'Madanur', pincode: '632606' },
  { value: 'nagari', label: 'Nagari', pincode: '632602' },
  { value: 'periyapalayam', label: 'Periyapalayam', pincode: '632602' },
  { value: 'sathuvachari', label: 'Sathuvachari', pincode: '632009' },
  { value: 'thiruvennainallur', label: 'Thiruvennainallur', pincode: '632602' },
  { value: 'vellore', label: 'Vellore', pincode: '632001' },
  { value: 'villapuram', label: 'Villapuram', pincode: '632002' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '632602' },
  { value: 'arakkonam', label: 'Arakkonam', pincode: '632001' },
  { value: 'kallapalli', label: 'Kallapalli', pincode: '632601' },
  { value: 'kanakkampalayam', label: 'Kanakkampalayam', pincode: '632603' },
  { value: 'kottapalli', label: 'Kottapalli', pincode: '632601' },
  { value: 'mangalam', label: 'Mangalam', pincode: '632603' },
  { value: 'perumugai', label: 'Perumugai', pincode: '632601' },
  { value: 'sholingur', label: 'Sholingur', pincode: '632301' },
  { value: 'thirumalai', label: 'Thirumalai', pincode: '632603' },
  { value: 'vengal', label: 'Vengal', pincode: '632602' },
  { value: 'vettavalam', label: 'Vettavalam', pincode: '632604' },
  { value: 'periyapudhur', label: 'Periyapudhur', pincode: '632606' },
  { value: 'puduvallur', label: 'Puduvallur', pincode: '632604' },
  { value: 'vellakuttai', label: 'Vellakuttai', pincode: '632603' },
  { value: 'melpatti', label: 'Melpatti', pincode: '632601' },
  { value: 'kathirvedu', label: 'Kathirvedu', pincode: '632601' }
  ],

  'thiruvarur': [
  { value: 'adai', label: 'Adai', pincode: '610001' },
  { value: 'alivor', label: 'Alivor', pincode: '610102' },
  { value: 'chathiram', label: 'Chathiram', pincode: '610101' },
  { value: 'gangaikondan', label: 'Gangaikondan', pincode: '610003' },
  { value: 'kamaraj-nagar', label: 'Kamaraj Nagar', pincode: '610103' },
  { value: 'kottur', label: 'Kottur', pincode: '610104' },
  { value: 'karaikkadu', label: 'Karaikkadu', pincode: '610107' },
  { value: 'kumarapalayam', label: 'Kumarapalayam', pincode: '610206' },
  { value: 'manamelkudi', label: 'Manamelkudi', pincode: '610005' },
  { value: 'muthupet', label: 'Muthupet', pincode: '610803' },
  { value: 'nagapattinam', label: 'Nagapattinam', pincode: '611001' },
  { value: 'naduvacheri', label: 'Naduvacheri', pincode: '610107' },
  { value: 'perumpanaiyur', label: 'Perumpanaiyur', pincode: '610205' },
  { value: 'ponnavaram', label: 'Ponnavaram', pincode: '610205' },
  { value: 'sundarapuram', label: 'Sundarapuram', pincode: '610105' },
  { value: 'thiruvarur-town', label: 'Thiruvarur Town', pincode: '610001' },
  { value: 'thiruthuraipoondi', label: 'Thiruthuraipoondi', pincode: '610204' },
  { value: 'thirupunavasal', label: 'Thirupunavasal', pincode: '610302' },
  { value: 'thirukollikadu', label: 'Thirukollikadu', pincode: '610208' },
  { value: 'thiruvenkadu', label: 'Thiruvenkadu', pincode: '610001' },
  { value: 'vazhapudupakkam', label: 'Vazhapudupakkam', pincode: '610106' },
  { value: 'vettuvakkudi', label: 'Vettuvakkudi', pincode: '610207' },
  { value: 'villiyanallur', label: 'Villiyanallur', pincode: '610102' },
  { value: 'vijayapuram', label: 'Vijayapuram', pincode: '610102' },
  { value: 'vengal', label: 'Vengal', pincode: '610302' },
  { value: 'puduvai', label: 'Puduvai', pincode: '610304' },
  { value: 'vettuvankadu', label: 'Vettuvankadu', pincode: '610303' },
  { value: 'thiruvikramamangalam', label: 'Thiruvikramamangalam', pincode: '610105' },
  { value: 'alathur', label: 'Alathur', pincode: '610201' },
  { value: 'agaram', label: 'Agaram', pincode: '610108' }
  ],

  'arani': [
  { value: 'alapakkam', label: 'Alapakkam', pincode: '632317' },
  { value: 'aranikuppam', label: 'Aranikuppam', pincode: '632318' },
  { value: 'chinnathirupathi', label: 'Chinnathirupathi', pincode: '632317' },
  { value: 'kesavan', label: 'Kesavan', pincode: '632301' },
  { value: 'kumaranathapuram', label: 'Kumaranathapuram', pincode: '632316' },
  { value: 'manjakuppam', label: 'Manjakuppam', pincode: '632305' },
  { value: 'marungur', label: 'Marungur', pincode: '632317' },
  { value: 'nerkundram', label: 'Nerkundram', pincode: '632318' },
  { value: 'sattur', label: 'Sattur', pincode: '632311' },
  { value: 'tindivanam', label: 'Tindivanam', pincode: '632101' },
  { value: 'velanur', label: 'Velanur', pincode: '632318' },
  { value: 'vellore', label: 'Vellore', pincode: '632001' },
  { value: 'thiruvalluvar-nagar', label: 'Thiruvalluvar Nagar', pincode: '632305' },
  { value: 'kandamangalam', label: 'Kandamangalam', pincode: '632316' },
  { value: 'senthilnagar', label: 'Senthilnagar', pincode: '632317' },
  { value: 'kalapattu', label: 'Kalapattu', pincode: '632318' },
  { value: 'vijayanandapuram', label: 'Vijayanandapuram', pincode: '632305' },
  { value: 'polur', label: 'Polur', pincode: '632301' },
  { value: 'nallur', label: 'Nallur', pincode: '632317' },
  { value: 'karupur', label: 'Karupur', pincode: '632318' },
  { value: 'murugappan', label: 'Murugappan', pincode: '632301' }
  ],

  'kallakurichi': [
  { value: 'alathur', label: 'Alathur', pincode: '606206' },
  { value: 'arumugapalayam', label: 'Arumugapalayam', pincode: '606202' },
  { value: 'elavur', label: 'Elavur', pincode: '606301' },
  { value: 'karuvakurichi', label: 'Karuvakurichi', pincode: '606201' },
  { value: 'kallakurichi-town', label: 'Kallakurichi Town', pincode: '606202' },
  { value: 'kattumannarkoil', label: 'Kattumannarkoil', pincode: '606106' },
  { value: 'koliyanur', label: 'Koliyanur', pincode: '606207' },
  { value: 'kurinjipadi', label: 'Kurinjipadi', pincode: '606303' },
  { value: 'nadupatti', label: 'Nadupatti', pincode: '606205' },
  { value: 'sithalamangalam', label: 'Sithalamangalam', pincode: '606303' },
  { value: 'thennampattu', label: 'Thennampattu', pincode: '606204' },
  { value: 'vembi', label: 'Vembi', pincode: '606303' },
  { value: 'villupuram', label: 'Villupuram', pincode: '606301' },
  { value: 'vettavalam', label: 'Vettavalam', pincode: '606205' },
  { value: 'andipalayam', label: 'Andipalayam', pincode: '606105' },
  { value: 'elachipalayam', label: 'Elachipalayam', pincode: '606307' },
  { value: 'melpalaiyur', label: 'Melpalaiyur', pincode: '606209' },
  { value: 'siruvachur', label: 'Siruvachur', pincode: '606303' },
  { value: 'panruti', label: 'Panruti', pincode: '606103' },
  { value: 'ponneri', label: 'Ponneri', pincode: '606302' },
  { value: 'pudupalayam', label: 'Pudupalayam', pincode: '606308' },
  { value: 'chinnasalem', label: 'Chinnasalem', pincode: '606201' },
  { value: 'nallur', label: 'Nallur', pincode: '606307' },
  { value: 'kothapattu', label: 'Kothapattu', pincode: '606311' },
  { value: 'palayapalayam', label: 'Palayapalayam', pincode: '606303' },
  { value: 'salem', label: 'Salem', pincode: '606302' },
  { value: 'kothimangalam', label: 'Kothimangalam', pincode: '606309' },
  { value: 'vadakacheri', label: 'Vadakacheri', pincode: '606205' },
  { value: 'sankaranpuducherry', label: 'Sankaranpuducherry', pincode: '606101' }
  ],

  'paramakudi': [
  { value: 'alampatti', label: 'Alampatti', pincode: '623708' },
  { value: 'bariyarpatti', label: 'Bariyarpatti', pincode: '623706' },
  { value: 'chinnakadiyapatti', label: 'Chinnakadiyapatti', pincode: '623705' },
  { value: 'paramakudi', label: 'Paramakudi', pincode: '623707' },
  { value: 'pattamudaiyarpatti', label: 'Pattamudaiyarpatti', pincode: '623709' },
  { value: 'peraiyur', label: 'Peraiyur', pincode: '623705' },
  { value: 'poovarasankulam', label: 'Poovarasankulam', pincode: '623703' },
  { value: 'chinthamani', label: 'Chinthamani', pincode: '623701' },
  { value: 'irumbuliyur', label: 'Irumbuliyur', pincode: '623710' },
  { value: 'kalanthimadam', label: 'Kalanthimadam', pincode: '623710' },
  { value: 'kallur', label: 'Kallur', pincode: '623704' },
  { value: 'karungulam', label: 'Karungulam', pincode: '623703' },
  { value: 'kottaiyur', label: 'Kottaiyur', pincode: '623706' },
  { value: 'manalur', label: 'Manalur', pincode: '623711' },
  { value: 'muthupettai', label: 'Muthupettai', pincode: '623702' },
  { value: 'nallur', label: 'Nallur', pincode: '623711' },
  { value: 'rajendranagar', label: 'Rajendranagar', pincode: '623708' },
  { value: 'sevalpatti', label: 'Sevalpatti', pincode: '623704' },
  { value: 'sundarapandiapuram', label: 'Sundarapandiapuram', pincode: '623706' },
  { value: 'alavayal', label: 'Alavayal', pincode: '623707' },
  { value: 'velangudi', label: 'Velangudi', pincode: '623706' },
  { value: 'thirumangalam', label: 'Thirumangalam', pincode: '623706' },
  { value: 'pillaiyarpatti', label: 'Pillaiyarpatti', pincode: '623706' },
  { value: 'nanguneri', label: 'Nanguneri', pincode: '623703' },
  { value: 'pudur', label: 'Pudur', pincode: '623707' },
  { value: 'vakkampatti', label: 'Vakkampatti', pincode: '623711' },
  { value: 'sivagangai', label: 'Sivagangai', pincode: '630561' },
  { value: 'kanadukathan', label: 'Kanadukathan', pincode: '630103' },
  { value: 'kalayarkovil', label: 'Kalayarkovil', pincode: '630551' },
  { value: 'kandanur', label: 'Kandanur', pincode: '623708' }
  ],

  'kulithalai': [
  { value: 'alampatti', label: 'Alampatti', pincode: '621313' },
  { value: 'avudaiyapatti', label: 'Avudaiyapatti', pincode: '621313' },
  { value: 'kulithalai', label: 'Kulithalai', pincode: '621313' },
  { value: 'manjaputhur', label: 'Manjaputhur', pincode: '621313' },
  { value: 'melavadi', label: 'Melavadi', pincode: '621313' },
  { value: 'poovanoor', label: 'Poovanoor', pincode: '621313' },
  { value: 'sithurajapuram', label: 'Sithurajapuram', pincode: '621313' },
  { value: 'thennampatti', label: 'Thennampatti', pincode: '621313' },
  { value: 'vembur', label: 'Vembur', pincode: '621313' },
  { value: 'sakkottai', label: 'Sakkottai', pincode: '621313' },
  { value: 'pudupatti', label: 'Pudupatti', pincode: '621313' },
  { value: 'sivalapperi', label: 'Sivalapperi', pincode: '621313' },
  { value: 'kavundampatti', label: 'Kavundampatti', pincode: '621313' },
  { value: 'manapparai', label: 'Manapparai', pincode: '621307' },
  { value: 'thiruchuli', label: 'Thiruchuli', pincode: '621313' },
  { value: 'vallam', label: 'Vallam', pincode: '621313' },
  { value: 'karuppur', label: 'Karuppur', pincode: '621313' },
  { value: 'padalur', label: 'Padalur', pincode: '621313' },
  { value: 'arumbavur', label: 'Arumbavur', pincode: '621307' },
  { value: 'sevalpatti', label: 'Sevalpatti', pincode: '621313' },
  { value: 'pudukkottai', label: 'Pudukkottai', pincode: '622001' },
  { value: 'kottampatti', label: 'Kottampatti', pincode: '621313' },
  { value: 'sirugamani', label: 'Sirugamani', pincode: '621307' },
  { value: 'kothangudi', label: 'Kothangudi', pincode: '621313' },
  { value: 'sundaraperi', label: 'Sundaraperi', pincode: '621313' },
  { value: 'kamatchipuram', label: 'Kamatchipuram', pincode: '621313' },
  { value: 'kallankurichi', label: 'Kallankurichi', pincode: '621313' },
  { value: 'arjunanpatti', label: 'Arjunanpatti', pincode: '621313' },
  { value: 'thiruparakundram', label: 'Thiruparakundram', pincode: '621307' },
  { value: 'thennampatti', label: 'Thennampatti', pincode: '621313' },
  { value: 'paramakudi', label: 'Paramakudi', pincode: '623707' },
  { value: 'thayalur', label: 'Thayalur', pincode: '621313' },
  { value: 'pattampatti', label: 'Pattampatti', pincode: '621313' },
  { value: 'chinnampatti', label: 'Chinnampatti', pincode: '621313' }
  ],

  'oddanchatram': [
  { value: 'avaniyapuram', label: 'Avaniyapuram', pincode: '624615' },
  { value: 'bharathipuram', label: 'Bharathipuram', pincode: '624621' },
  { value: 'chinnamuthupatti', label: 'Chinnamuthupatti', pincode: '624619' },
  { value: 'dharmapuri', label: 'Dharmapuri', pincode: '624601' },
  { value: 'elumalai', label: 'Elumalai', pincode: '624619' },
  { value: 'kavindapadi', label: 'Kavindapadi', pincode: '624620' },
  { value: 'koodalnagar', label: 'Koodalnagar', pincode: '624001' },
  { value: 'nalattinputhur', label: 'Nalattinputhur', pincode: '624619' },
  { value: 'oddanchatram', label: 'Oddanchatram', pincode: '624619' },
  { value: 'sivagiri', label: 'Sivagiri', pincode: '624621' },
  { value: 'tharapuram', label: 'Tharapuram', pincode: '624619' },
  { value: 'tottiyapatti', label: 'Tottiyapatti', pincode: '624619' },
  { value: 'valliyur', label: 'Valliyur', pincode: '627117' },
  { value: 'vembakottai', label: 'Vembakottai', pincode: '624122' },
  { value: 'vellore', label: 'Vellore', pincode: '632001' },
  { value: 'veerapandi', label: 'Veerapandi', pincode: '624605' },
  { value: 'periyakulam', label: 'Periyakulam', pincode: '625601' },
  { value: 'palani', label: 'Palani', pincode: '624601' },
  { value: 'manjampatti', label: 'Manjampatti', pincode: '624614' },
  { value: 'pethappampatti', label: 'Pethappampatti', pincode: '624619' },
  { value: 'arupukottai', label: 'Arupukottai', pincode: '624101' },
  { value: 'padalur', label: 'Padalur', pincode: '624205' },
  ],

  'sathyamangalam': [
  { value: 'adigaratty', label: 'Adigaratty', pincode: '638402' },
  { value: 'athani', label: 'Athani', pincode: '638401' },
  { value: 'elumalai', label: 'Elumalai', pincode: '638402' },
  { value: 'gundri', label: 'Gundri', pincode: '638402' },
  { value: 'kolathur', label: 'Kolathur', pincode: '638402' },
  { value: 'mangalapatti', label: 'Mangalapatti', pincode: '638402' },
  { value: 'nadupatti', label: 'Nadupatti', pincode: '638402' },
  { value: 'sathyamangalam', label: 'Sathyamangalam', pincode: '638401' },
  { value: 'thimmanayakkanpatti', label: 'Thimmanayakkanpatti', pincode: '638402' },
  { value: 't.nallur', label: 'T. Nallur', pincode: '638401' },
  { value: 'vellalapalayam', label: 'Vellalapalayam', pincode: '638402' },
  { value: 'virupakshipuram', label: 'Virupakshipuram', pincode: '638402' },
  { value: 'kothagiri', label: 'Kothagiri', pincode: '638503' },
  { value: 'bhavani', label: 'Bhavani', pincode: '638301' },
  { value: 'kovilpalayam', label: 'Kovilpalayam', pincode: '638402' },
  { value: 'palayapalayam', label: 'Palayapalayam', pincode: '638402' },
  { value: 'murugampalayam', label: 'Murugampalayam', pincode: '638402' },
  { value: 'nallampatti', label: 'Nallampatti', pincode: '638402' },
  { value: 'periyaorapalayam', label: 'Periyaorapalayam', pincode: '638402' },
  ],
  
  'arakkonam': [
  { value: 'arakkonam', label: 'Arakkonam', pincode: '631001' },
  { value: 'athivakkam', label: 'Athivakkam', pincode: '631002' },
  { value: 'avadi', label: 'Avadi', pincode: '600071' },
  { value: 'bogalur', label: 'Bogalur', pincode: '631001' },
  { value: 'chinnakavanam', label: 'Chinnakavanam', pincode: '631001' },
  { value: 'chitlapakkam', label: 'Chitlapakkam', pincode: '600064' },
  { value: 'kottur', label: 'Kottur', pincode: '631001' },
  { value: 'manavalanallur', label: 'Manavalanallur', pincode: '631002' },
  { value: 'mangadu', label: 'Mangadu', pincode: '600122' },
  { value: 'ninthanur', label: 'Ninthanur', pincode: '631001' },
  { value: 'sampath-nagar', label: 'Sampath Nagar', pincode: '631001' },
  { value: 'sengundram', label: 'Sengundram', pincode: '631001' },
  { value: 'thiruporur', label: 'Thiruporur', pincode: '603110' },
  { value: 'vengal', label: 'Vengal', pincode: '631002' },
  { value: 'thiruvalangadu', label: 'Thiruvalangadu', pincode: '631210' },
  { value: 'tiruttani', label: 'Tiruttani', pincode: '631209' },
  { value: 'wadarapalayam', label: 'Wadarapalayam', pincode: '631203' },
  { value: 'kadambathur', label: 'Kadambathur', pincode: '631207' },
  { value: 'kulathur', label: 'Kulathur', pincode: '631206' },
  { value: 'neelamangalam', label: 'Neelamangalam', pincode: '631210' },
  { value: 'poovarasapalayam', label: 'Poovarasapalayam', pincode: '631207' },
  { value: 'pudur', label: 'Pudur', pincode: '631202' },
  { value: 'sathur', label: 'Sathur', pincode: '631205' },
  { value: 'tamilnadu', label: 'Tamilnadu', pincode: '631001' },
  { value: 'valasaravakkam', label: 'Valasaravakkam', pincode: '600087' },
  { value: 'velappanchavadi', label: 'Velappanchavadi', pincode: '600077' }
  ],

  'sankarankoil': [
  { value: 'alankulam', label: 'Alankulam', pincode: '627756' },
  { value: 'irakkakudi', label: 'Irakkakudi', pincode: '627756' },
  { value: 'kolungulam', label: 'Kolungulam', pincode: '627760' },
  { value: 'kumarapuram', label: 'Kumarapuram', pincode: '627759' },
  { value: 'manjalar', label: 'Manjalar', pincode: '627756' },
  { value: 'meenakshipuram', label: 'Meenakshipuram', pincode: '627758' },
  { value: 'murugankurichi', label: 'Murugankurichi', pincode: '627751' },
  { value: 'nallur', label: 'Nallur', pincode: '627752' },
  { value: 'ponnapuram', label: 'Ponnapuram', pincode: '627759' },
  { value: 'sankarankoil', label: 'Sankarankoil', pincode: '627756' },
  { value: 'seruvila', label: 'Seruvila', pincode: '627757' },
  { value: 'thirumalapuram', label: 'Thirumalapuram', pincode: '627756' },
  { value: 'velanankulam', label: 'Velanankulam', pincode: '627758' },
  { value: 'avadalai', label: 'Avadalai', pincode: '627760' },
  { value: 'chettikulam', label: 'Chettikulam', pincode: '627759' },
  { value: 'kumari', label: 'Kumari', pincode: '627761' },
  { value: 'pudur', label: 'Pudur', pincode: '627757' },
  { value: 'sathur', label: 'Sathur', pincode: '627750' },
  { value: 'senthamangalam', label: 'Senthamangalam', pincode: '627760' },
  { value: 'tattarmalai', label: 'Tattarmalai', pincode: '627752' },
  { value: 'veppankulam', label: 'Veppankulam', pincode: '627758' },
  { value: 'vijayapuri', label: 'Vijayapuri', pincode: '627756' }
  ],

  'aranthangi': [
  { value: 'alampatti', label: 'Alampatti', pincode: '614616' },
  { value: 'aviloor', label: 'Aviloor', pincode: '614618' },
  { value: 'koothanallur', label: 'Koothanallur', pincode: '614202' },
  { value: 'kottur', label: 'Kottur', pincode: '614803' },
  { value: 'kuthanallur', label: 'Kuthanallur', pincode: '614202' },
  { value: 'mangudi', label: 'Mangudi', pincode: '614616' },
  { value: 'maravankudiyiruppu', label: 'Maravankudiyiruppu', pincode: '614614' },
  { value: 'melapatti', label: 'Melapatti', pincode: '614612' },
  { value: 'nesal', label: 'Nesal', pincode: '614616' },
  { value: 'padukapatti', label: 'Padukapatti', pincode: '614617' },
  { value: 'santhamangalam', label: 'Santhamangalam', pincode: '614614' },
  { value: 'sivakasi', label: 'Sivakasi', pincode: '626123' },
  { value: 'tiruvarangam', label: 'Tiruvarangam', pincode: '614614' },
  { value: 'upanpatti', label: 'Upanpatti', pincode: '614615' },
  { value: 'vengaram', label: 'Vengaram', pincode: '614617' },
  { value: 'vettukadu', label: 'Vettukadu', pincode: '614201' },
  { value: 'perungudi', label: 'Perungudi', pincode: '614201' },
  { value: 'thiruthangal', label: 'Thiruthangal', pincode: '626130' },
  { value: 'kizhakkur', label: 'Kizhakkur', pincode: '614622' },
  { value: 'renganathapuram', label: 'Renganathapuram', pincode: '614612' },
  { value: 'tirumayam', label: 'Tirumayam', pincode: '614907' },
  { value: 'manamelkudi', label: 'Manamelkudi', pincode: '614904' },
  { value: 'pudukkottai', label: 'Pudukkottai', pincode: '622001' },
  { value: 'alankulam', label: 'Alankulam', pincode: '614713' },
  { value: 'pappakudi', label: 'Pappakudi', pincode: '614612' },
  { value: 'sundarapandiam', label: 'Sundarapandiam', pincode: '626204' },
  { value: 'pillaiyarpatti', label: 'Pillaiyarpatti', pincode: '626208' }
  ],

  'krishnagiri': [
  { value: 'alambadi', label: 'Alambadi', pincode: '635305' },
  { value: 'andiyur', label: 'Andiyur', pincode: '635307' },
  { value: 'chinnakkampatti', label: 'Chinnakkampatti', pincode: '635121' },
  { value: 'krishnagiri-town', label: 'Krishnagiri Town', pincode: '635001' },
  { value: 'madhur', label: 'Madhur', pincode: '635116' },
  { value: 'nallampatti', label: 'Nallampatti', pincode: '635110' },
  { value: 'pachapalayam', label: 'Pachapalayam', pincode: '635204' },
  { value: 'pudupet', label: 'Pudupet', pincode: '635207' },
  { value: 'thally', label: 'Thally', pincode: '635115' },
  { value: 'veppanapalli', label: 'Veppanapalli', pincode: '635107' },
  { value: 'vettangudi', label: 'Vettangudi', pincode: '635209' },
  { value: 'bargur', label: 'Bargur', pincode: '635104' },
  { value: 'bellipalayam', label: 'Bellipalayam', pincode: '635122' },
  { value: 'bhavani', label: 'Bhavani', pincode: '635116' },
  { value: 'gummidipoondi', label: 'Gummidipoondi', pincode: '635210' },
  { value: 'jambai', label: 'Jambai', pincode: '635107' },
  { value: 'kathampatti', label: 'Kathampatti', pincode: '635304' },
  { value: 'kaveripattinam', label: 'Kaveripattinam', pincode: '635112' },
  { value: 'kanakapura', label: 'Kanakapura', pincode: '635115' },
  { value: 'kodathur', label: 'Kodathur', pincode: '635106' },
  { value: 'kundumaran', label: 'Kundumaran', pincode: '635120' },
  { value: 'krishnagiri-rural', label: 'Krishnagiri Rural', pincode: '635001' },
  { value: 'pooventhanpalli', label: 'Pooventhanpalli', pincode: '635122' },
  { value: 'rayakottai', label: 'Rayakottai', pincode: '635119' },
  { value: 'sollur', label: 'Sollur', pincode: '635305' }
  ],

  'panruti': [
  { value: 'andimadam', label: 'Andimadam', pincode: '607107' },
  { value: 'kelampur', label: 'Kelampur', pincode: '607106' },
  { value: 'kurinjipadi', label: 'Kurinjipadi', pincode: '607302' },
  { value: 'mangalam', label: 'Mangalam', pincode: '607103' },
  { value: 'panruti', label: 'Panruti', pincode: '607106' },
  { value: 'pudupet', label: 'Pudupet', pincode: '607101' },
  { value: 'veppur', label: 'Veppur', pincode: '607103' },
  { value: 'valavanur', label: 'Valavanur', pincode: '607303' },
  { value: 'vellore', label: 'Vellore', pincode: '607201' },
  { value: 'rishivandiyam', label: 'Rishivandiyam', pincode: '607106' },
  { value: 'vikkiravandi', label: 'Vikkiravandi', pincode: '607204' },
  { value: 'kattumannarkoil', label: 'Kattumannarkoil', pincode: '608301' },
  { value: 'thirunallar', label: 'Thirunallar', pincode: '607106' },
  { value: 'tindivanam', label: 'Tindivanam', pincode: '604001' },
  { value: 'thiruvennainallur', label: 'Thiruvennainallur', pincode: '607305' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '607106' },
  { value: 'arupathi', label: 'Arupathi', pincode: '607302' },
  { value: 'muthur', label: 'Muthur', pincode: '607202' },
  { value: 'namangalam', label: 'Namangalam', pincode: '607204' },
  { value: 'sankaranpattu', label: 'Sankaranpattu', pincode: '607305' },
  { value: 'senthamangalam', label: 'Senthamangalam', pincode: '607303' },
  { value: 'thiruvandipuram', label: 'Thiruvandipuram', pincode: '607304' },
  { value: 'veerapandi', label: 'Veerapandi', pincode: '607305' },
  { value: 'venganur', label: 'Venganur', pincode: '607102' },
  { value: 'vilathikulam', label: 'Vilathikulam', pincode: '607107' },
  { value: 'arakkonam', label: 'Arakkonam', pincode: '631001' },
  { value: 'panruti-town', label: 'Panruti Town', pincode: '607106' }
  ],

  'devakottai': [
  { value: 'adavathur', label: 'Adavathur', pincode: '630302' },
  { value: 'alampatti', label: 'Alampatti', pincode: '630310' },
  { value: 'devakottai', label: 'Devakottai', pincode: '630302' },
  { value: 'elavayal', label: 'Elavayal', pincode: '630303' },
  { value: 'irangol', label: 'Irangol', pincode: '630304' },
  { value: 'karaiyur', label: 'Karaiyur', pincode: '630303' },
  { value: 'keelamathur', label: 'Keelamathur', pincode: '630308' },
  { value: 'kottur', label: 'Kottur', pincode: '630302' },
  { value: 'kulathur', label: 'Kulathur', pincode: '630301' },
  { value: 'mavur', label: 'Mavur', pincode: '630307' },
  { value: 'nambuthalai', label: 'Nambuthalai', pincode: '630305' },
  { value: 'palani', label: 'Palani', pincode: '630309' },
  { value: 'periyakottai', label: 'Periyakottai', pincode: '630303' },
  { value: 'ramaiyapuram', label: 'Ramaiyapuram', pincode: '630304' },
  { value: 'sundarapuri', label: 'Sundarapuri', pincode: '630306' },
  { value: 'thiruppathur', label: 'Thiruppathur', pincode: '630211' },
  { value: 'thiruvaiyaru', label: 'Thiruvaiyaru', pincode: '630304' },
  { value: 'vilathikulam', label: 'Vilathikulam', pincode: '630307' },
  { value: 'alampatti', label: 'Alampatti', pincode: '630310' },
  { value: 'vadugappatti', label: 'Vadugappatti', pincode: '630314' },
  { value: 'vandanam', label: 'Vandanam', pincode: '630308' },
  { value: 'vayaloor', label: 'Vayaloor', pincode: '630309' }
  ],

  'mannargudi': [
  { value: 'adambakkam', label: 'Adambakkam', pincode: '614001' },
  { value: 'alathur', label: 'Alathur', pincode: '614001' },
  { value: 'annanur', label: 'Annanur', pincode: '614301' },
  { value: 'arumathur', label: 'Arumathur', pincode: '614102' },
  { value: 'bhuvanagiri', label: 'Bhuvanagiri', pincode: '614102' },
  { value: 'elancheri', label: 'Elancheri', pincode: '614205' },
  { value: 'kallapulli', label: 'Kallapulli', pincode: '614003' },
  { value: 'karukkalacheri', label: 'Karukkalacheri', pincode: '614301' },
  { value: 'kizhakarai', label: 'Kizhakarai', pincode: '614101' },
  { value: 'mannargudi', label: 'Mannargudi', pincode: '614001' },
  { value: 'melapathi', label: 'Melapathi', pincode: '614302' },
  { value: 'peralam', label: 'Peralam', pincode: '614303' },
  { value: 'siruvachur', label: 'Siruvachur', pincode: '614303' },
  { value: 'thiruthuraipoondi', label: 'Thiruthuraipoondi', pincode: '614713' },
  { value: 'vaduvur', label: 'Vaduvur', pincode: '614801' },
  { value: 'vallam', label: 'Vallam', pincode: '614701' },
  { value: 'velangudi', label: 'Velangudi', pincode: '614104' },
  { value: 'vikkiravandi', label: 'Vikkiravandi', pincode: '614302' },
  { value: 'vettangudi', label: 'Vettangudi', pincode: '614205' },
  { value: 'thiruvarur', label: 'Thiruvarur', pincode: '610001' },
  { value: 'thiruvengadu', label: 'Thiruvengadu', pincode: '614210' }
  ],

  'sattur': [
  { value: 'alampatti', label: 'Alampatti', pincode: '626203' },
  { value: 'chokkampatti', label: 'Chokkampatti', pincode: '626203' },
  { value: 'kallikudi', label: 'Kallikudi', pincode: '626203' },
  { value: 'kamarajapuram', label: 'Kamarajapuram', pincode: '626203' },
  { value: 'muthupatti', label: 'Muthupatti', pincode: '626203' },
  { value: 'pettai', label: 'Pettai', pincode: '626203' },
  { value: 'rajapalayam', label: 'Rajapalayam', pincode: '626117' },
  { value: 'sattur', label: 'Sattur', pincode: '626203' },
  { value: 'sivagiri', label: 'Sivagiri', pincode: '626140' },
  { value: 't.kallupatti', label: 'T.Kallupatti', pincode: '626203' },
  { value: 't.pudupatti', label: 'T.Pudupatti', pincode: '626203' },
  { value: 'thiruthangal', label: 'Thiruthangal', pincode: '626130' },
  { value: 'vembakottai', label: 'Vembakottai', pincode: '626131' },
  { value: 'vettanur', label: 'Vettanur', pincode: '626203' },
  { value: 'poongulali', label: 'Poongulali', pincode: '626203' },
  { value: 'sivakasi', label: 'Sivakasi', pincode: '626123' },
  { value: 'vellur', label: 'Vellur', pincode: '626204' },
  { value: 'keela-rajapalayam', label: 'Keela Rajapalayam', pincode: '626116' },
  { value: 'melapatti', label: 'Melapatti', pincode: '626203' },
  { value: 'vembakottai', label: 'Vembakottai', pincode: '626131' }
  ],

  'tirumangalam': [
  { value: 'adavanakudi', label: 'Adavanakudi', pincode: '625706' },
  { value: 'chinnalapatti', label: 'Chinnalapatti', pincode: '625706' },
  { value: 'devathur', label: 'Devathur', pincode: '625706' },
  { value: 'kanadukathan', label: 'Kanadukathan', pincode: '625706' },
  { value: 'kottaiyur', label: 'Kottaiyur', pincode: '625706' },
  { value: 'mannadimangalam', label: 'Mannadimangalam', pincode: '625706' },
  { value: 'pudupatti', label: 'Pudupatti', pincode: '625706' },
  { value: 'sanjayapathai', label: 'Sanjayapathai', pincode: '625706' },
  { value: 'sivagangai', label: 'Sivagangai', pincode: '625706' },
  { value: 'tirumangalam', label: 'Tirumangalam', pincode: '625706' },
  { value: 't.kottampatti', label: 'T.Kottampatti', pincode: '625706' },
  { value: 'vempatti', label: 'Vempatti', pincode: '625706' },
  { value: 'villapuram', label: 'Villapuram', pincode: '625706' },
  { value: 'alampatti', label: 'Alampatti', pincode: '625706' },
  { value: 'sundarapuri', label: 'Sundarapuri', pincode: '625706' },
  { value: 'vattaparai', label: 'Vattaparai', pincode: '625706' },
  { value: 'velimalai', label: 'Velimalai', pincode: '625706' },
  { value: 'pudupattai', label: 'Pudupattai', pincode: '625706' },
  { value: 'vettuvapatti', label: 'Vettuvapatti', pincode: '625706' }
  ],

  'pattukkottai': [
  { value: 'alathur', label: 'Alathur', pincode: '614803' },
  { value: 'anandamangalam', label: 'Anandamangalam', pincode: '614704' },
  { value: 'chandrapadi', label: 'Chandrapadi', pincode: '614704' },
  { value: 'iluppaiyur', label: 'Iluppaiyur', pincode: '614801' },
  { value: 'karunkalvadi', label: 'Karunkalvadi', pincode: '614703' },
  { value: 'kottaiyur', label: 'Kottaiyur', pincode: '614803' },
  { value: 'kudimangalam', label: 'Kudimangalam', pincode: '614701' },
  { value: 'manikandapuram', label: 'Manikandapuram', pincode: '614703' },
  { value: 'pattukkottai', label: 'Pattukkottai', pincode: '614601' },
  { value: 'perumalnallur', label: 'Perumalnallur', pincode: '614702' },
  { value: 'ponnavarayankottai', label: 'Ponnavarayankottai', pincode: '614803' },
  { value: 'sirukudi', label: 'Sirukudi', pincode: '614803' },
  { value: 'thirukodikaval', label: 'Thirukodikaval', pincode: '614804' },
  { value: 'thiruppanandal', label: 'Thiruppanandal', pincode: '614706' },
  { value: 'vadanallur', label: 'Vadanallur', pincode: '614705' },
  { value: 'vadugapatti', label: 'Vadugapatti', pincode: '614706' },
  { value: 'arugampatti', label: 'Arugampatti', pincode: '614706' },
  { value: 'thoppur', label: 'Thoppur', pincode: '614706' },
  { value: 'nallur', label: 'Nallur', pincode: '614701' },
  { value: 'velayuthampatti', label: 'Velayuthampatti', pincode: '614703' }
  ],

  'manapparai': [
  { value: 'alankinar', label: 'Alankinar', pincode: '621307' },
  { value: 'broadway', label: 'Broadway', pincode: '621306' },
  { value: 'chinna-gramam', label: 'Chinna Gramam', pincode: '621306' },
  { value: 'koviladi', label: 'Koviladi', pincode: '621306' },
  { value: 'manapparai', label: 'Manapparai', pincode: '621307' },
  { value: 'muthupatti', label: 'Muthupatti', pincode: '621307' },
  { value: 'periyar', label: 'Periyar', pincode: '621307' },
  { value: 'pudukkottai', label: 'Pudukkottai', pincode: '621307' },
  { value: 'sivakasi', label: 'Sivakasi', pincode: '621307' },
  { value: 'thiruverkadu', label: 'Thiruverkadu', pincode: '621307' },
  { value: 'vaduvur', label: 'Vaduvur', pincode: '621306' },
  { value: 'velankanni', label: 'Velankanni', pincode: '621306' },
  { value: 'vembakottai', label: 'Vembakottai', pincode: '621306' },
  { value: 'kuruvai', label: 'Kuruvai', pincode: '621307' },
  { value: 'nallur', label: 'Nallur', pincode: '621306' },
  { value: 'perungudi', label: 'Perungudi', pincode: '621307' },
  { value: 'rajaram', label: 'Rajaram', pincode: '621306' },
  { value: 'vengavayal', label: 'Vengavayal', pincode: '621307' },
  { value: 'vadavalli', label: 'Vadavalli', pincode: '621306' },
  { value: 'melapatti', label: 'Melapatti', pincode: '621307' },
  { value: 'vanniyanpatti', label: 'Vanniyanpatti', pincode: '621307' },
  { value: 'sengal', label: 'Sengal', pincode: '621307' },
  { value: 'thiruvalluvarnagar', label: 'Thiruvalluvarnagar', pincode: '621307' },
  { value: 'perumalpatti', label: 'Perumalpatti', pincode: '621306' }
  ],
  
  'sirkali': [
  { value: 'alappakkam', label: 'Alappakkam', pincode: '609109' },
  { value: 'amaravathi', label: 'Amaravathi', pincode: '609105' },
  { value: 'anumanthapuram', label: 'Anumanthapuram', pincode: '609105' },
  { value: 'athipattu', label: 'Athipattu', pincode: '609101' },
  { value: 'kadambur', label: 'Kadambur', pincode: '609109' },
  { value: 'kalathur', label: 'Kalathur', pincode: '609101' },
  { value: 'karunkal', label: 'Karunkal', pincode: '609101' },
  { value: 'keezhappalur', label: 'Keezhappalur', pincode: '609109' },
  { value: 'kodiampalayam', label: 'Kodiampalayam', pincode: '609105' },
  { value: 'manalmedu', label: 'Manalmedu', pincode: '609105' },
  { value: 'sirkali', label: 'Sirkali', pincode: '609110' },
  { value: 'thiruvengadu', label: 'Thiruvengadu', pincode: '609107' },
  { value: 'veppur', label: 'Veppur', pincode: '609101' },
  { value: 'vilakoli', label: 'Vilakoli', pincode: '609107' },
  { value: 'avadhi', label: 'Avadhi', pincode: '609107' },
  { value: 'bramanapalayam', label: 'Bramanapalayam', pincode: '609105' },
  { value: 'kandamangalam', label: 'Kandamangalam', pincode: '609107' },
  { value: 'kottur', label: 'Kottur', pincode: '609109' },
  { value: 'muthumani', label: 'Muthumani', pincode: '609101' },
  { value: 'nambuthalai', label: 'Nambuthalai', pincode: '609101' },
  { value: 'thiruthuraipoondi', label: 'Thiruthuraipoondi', pincode: '609108' },
  { value: 'vanniyampalayam', label: 'Vanniyampalayam', pincode: '609107' },
  { value: 'poigai', label: 'Poigai', pincode: '609108' },
  { value: 'tittakudi', label: 'Tittakudi', pincode: '609108' },
  { value: 'ponnavarayankottai', label: 'Ponnavarayankottai', pincode: '609110' },
  { value: 'thiruvenkadu', label: 'Thiruvenkadu', pincode: '609107' }
  ],

  'alanthurai': [
  { value: 'alanthurai', label: 'Alanthurai', pincode: '641667' },
  { value: 'angarai', label: 'Angarai', pincode: '641667' },
  { value: 'arjunapalayam', label: 'Arjunapalayam', pincode: '641667' },
  { value: 'balarampalayam', label: 'Balarampalayam', pincode: '641667' },
  { value: 'karuvampalayam', label: 'Karuvampalayam', pincode: '641667' },
  { value: 'kattur', label: 'Kattur', pincode: '641667' },
  { value: 'konampalayam', label: 'Konampalayam', pincode: '641667' },
  { value: 'neelambur', label: 'Neelambur', pincode: '641031' },
  { value: 'sulur', label: 'Sulur', pincode: '641402' },
  { value: 'thennampalayam', label: 'Thennampalayam', pincode: '641667' },
  { value: 'vanniyampalayam', label: 'Vanniyampalayam', pincode: '641667' },
  { value: 'villankurichi', label: 'Villankurichi', pincode: '641035' },
  { value: 'vazhappadi', label: 'Vazhappadi', pincode: '641667' },
  { value: 'periya-palayam', label: 'Periya Palayam', pincode: '641670' },
  { value: 'arasur', label: 'Arasur', pincode: '641407' },
  { value: 'vadampalayam', label: 'Vadampalayam', pincode: '641667' },
  { value: 'karumathampatti', label: 'Karumathampatti', pincode: '641663' },
  { value: 'edayanpalayam', label: 'Edayanpalayam', pincode: '641023' },
  { value: 'vattur', label: 'Vattur', pincode: '641023' },
  { value: 'muthugoundanpudur', label: 'Muthugoundanpudur', pincode: '641671' },
  { value: 'chinnakuzhi', label: 'Chinnakuzhi', pincode: '641667' },
  { value: 'vallipalayam', label: 'Vallipalayam', pincode: '641662' },
  { value: 'pudupalayam', label: 'Pudupalayam', pincode: '641678' },
  { value: 'nallur', label: 'Nallur', pincode: '641661' },
  { value: 'kuttampalayam', label: 'Kuttampalayam', pincode: '641668' },
  { value: 'palladam', label: 'Palladam', pincode: '641664' }
  ],

  'arcot': [
  { value: 'alathur', label: 'Alathur', pincode: '632503' },
  { value: 'arcot', label: 'Arcot', pincode: '632503' },
  { value: 'chinna-madam', label: 'Chinna Madam', pincode: '632503' },
  { value: 'dhanalakshmi', label: 'Dhanalakshmi', pincode: '632503' },
  { value: 'kadayam', label: 'Kadayam', pincode: '632504' },
  { value: 'kamaraj-nagar', label: 'Kamaraj Nagar', pincode: '632503' },
  { value: 'kamuthi', label: 'Kamuthi', pincode: '632503' },
  { value: 'karungali', label: 'Karungali', pincode: '632504' },
  { value: 'kottur', label: 'Kottur', pincode: '632503' },
  { value: 'mangalam', label: 'Mangalam', pincode: '632503' },
  { value: 'manikandapuram', label: 'Manikandapuram', pincode: '632504' },
  { value: 'nattarmangalam', label: 'Nattarmangalam', pincode: '632504' },
  { value: 'pudur', label: 'Pudur', pincode: '632504' },
  { value: 'salem', label: 'Salem', pincode: '632503' },
  { value: 'sithalapakkam', label: 'Sithalapakkam', pincode: '632503' },
  { value: 'thavakupettai', label: 'Thavakupettai', pincode: '632504' },
  { value: 'valavanur', label: 'Valavanur', pincode: '632503' },
  { value: 'vellore', label: 'Vellore', pincode: '632001' },
  { value: 'vettavalam', label: 'Vettavalam', pincode: '632504' },
  { value: 'vengalathur', label: 'Vengalathur', pincode: '632503' }
  ],

  'ariyalur': [
  { value: 'ariyalur', label: 'Ariyalur', pincode: '621704' },
  { value: 'alathur', label: 'Alathur', pincode: '621704' },
  { value: 'appakudal', label: 'Appakudal', pincode: '621707' },
  { value: 'buvaneswar', label: 'Buvaneswar', pincode: '621704' },
  { value: 'colony', label: 'Colony', pincode: '621707' },
  { value: 'kamaraj-nagar', label: 'Kamaraj Nagar', pincode: '621707' },
  { value: 'kattur', label: 'Kattur', pincode: '621704' },
  { value: 'karupur', label: 'Karupur', pincode: '621707' },
  { value: 'manamadurai', label: 'Manamadurai', pincode: '621704' },
  { value: 'natrampalli', label: 'Natrampalli', pincode: '621704' },
  { value: 'palur', label: 'Palur', pincode: '621707' },
  { value: 'rathinapuri', label: 'Rathinapuri', pincode: '621707' },
  { value: 'sithambur', label: 'Sithambur', pincode: '621707' },
  { value: 'thirumananur', label: 'Thirumananur', pincode: '621704' },
  { value: 'vadakkupattu', label: 'Vadakkupattu', pincode: '621707' },
  { value: 'vengur', label: 'Vengur', pincode: '621707' },
  { value: 'elambalur', label: 'Elambalur', pincode: '621711' },
  { value: 'kizhakarai', label: 'Kizhakarai', pincode: '621704' },
  { value: 'veppur', label: 'Veppur', pincode: '621710' },
  { value: 'pillaiyarkuppam', label: 'Pillaiyarkuppam', pincode: '621706' },
  { value: 'manikandapuram', label: 'Manikandapuram', pincode: '621711' },
  { value: 'sivapuram', label: 'Sivapuram', pincode: '621711' },
  { value: 'panangudi', label: 'Panangudi', pincode: '621706' }
  ],

  'aruppukkottai': [
  { value: 'aruppukkottai', label: 'Aruppukkottai', pincode: '626101' },
  { value: 'alampatti', label: 'Alampatti', pincode: '626106' },
  { value: 'anantharampatti', label: 'Anantharampatti', pincode: '626101' },
  { value: 'kadiyapatti', label: 'Kadiyapatti', pincode: '626126' },
  { value: 'kanakkanpatti', label: 'Kanakkanpatti', pincode: '626101' },
  { value: 'karungulam', label: 'Karungulam', pincode: '626127' },
  { value: 'kottur', label: 'Kottur', pincode: '626103' },
  { value: 'manjapatti', label: 'Manjapatti', pincode: '626101' },
  { value: 'muthupatti', label: 'Muthupatti', pincode: '626103' },
  { value: 'nallur', label: 'Nallur', pincode: '626101' },
  { value: 'natham', label: 'Natham', pincode: '626103' },
  { value: 'sivagiri', label: 'Sivagiri', pincode: '626101' },
  { value: 'vadakkupatti', label: 'Vadakkupatti', pincode: '626103' },
  { value: 'venganur', label: 'Venganur', pincode: '626126' },
  { value: 'vembakottai', label: 'Vembakottai', pincode: '626127' },
  { value: 'avadhi', label: 'Avadhi', pincode: '626104' },
  { value: 'eruvanpatti', label: 'Eruvanpatti', pincode: '626106' },
  { value: 'illuppai', label: 'Illuppai', pincode: '626108' },
  { value: 'kanavapatti', label: 'Kanavapatti', pincode: '626107' },
  { value: 'mangalam', label: 'Mangalam', pincode: '626110' },
  { value: 'parivalur', label: 'Parivalur', pincode: '626108' },
  { value: 'sirupathur', label: 'Sirupathur', pincode: '626109' },
  { value: 'sundaraperi', label: 'Sundaraperi', pincode: '626110' }
  ],
  
  'chengalpattu': [ 
  { value: 'chengalpattu', label: 'Chengalpattu', pincode: '603001' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '603001' },
  { value: 'arasankalathur', label: 'Arasankalathur', pincode: '603002' },
  { value: 'banuvadi', label: 'Banuvadi', pincode: '603004' },
  { value: 'kuthambakkam', label: 'Kuthambakkam', pincode: '603002' },
  { value: 'mankarai', label: 'Mankarai', pincode: '603202' },
  { value: 'manimangalam', label: 'Manimangalam', pincode: '603104' },
  { value: 'ponneri', label: 'Ponneri', pincode: '603103' },
  { value: 'puliyur', label: 'Puliyur', pincode: '603111' },
  { value: 'sithalapakkam', label: 'Sithalapakkam', pincode: '603202' },
  { value: 'sunguvarchatram', label: 'Sunguvarchatram', pincode: '603212' },
  { value: 'thiruporur', label: 'Thiruporur', pincode: '603110' },
  { value: 'thirumalai', label: 'Thirumalai', pincode: '603202' },
  { value: 'vandalur', label: 'Vandalur', pincode: '603202' },
  { value: 'vazhapadi', label: 'Vazhapadi', pincode: '603001' },
  { value: 'thandalam', label: 'Thandalam', pincode: '603107' },
  { value: 'uthiramerur', label: 'Uthiramerur', pincode: '603406' },
  { value: 'varadarajapuram', label: 'Varadarajapuram', pincode: '603102' },
  { value: 'kavarapettai', label: 'Kavarapettai', pincode: '603404' },
  { value: 'kondur', label: 'Kondur', pincode: '603107' },
  { value: 'manapakkam', label: 'Manapakkam', pincode: '603102' },
  { value: 'pillaiyarpatti', label: 'Pillaiyarpatti', pincode: '603112' },
  { value: 'sundarampattu', label: 'Sundarampattu', pincode: '603212' },
  { value: 'velachery', label: 'Velachery', pincode: '603108' }
  ],

  'cheyyar': [
  { value: 'cheyyar', label: 'Cheyyar', pincode: '604407' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '604407' },
  { value: 'arungundram', label: 'Arungundram', pincode: '604407' },
  { value: 'cheruvai', label: 'Cheruvai', pincode: '604409' },
  { value: 'kallankurichi', label: 'Kallankurichi', pincode: '604405' },
  { value: 'kattankolathur', label: 'Kattankolathur', pincode: '604404' },
  { value: 'kaveripakkam', label: 'Kaveripakkam', pincode: '604402' },
  { value: 'kolathur', label: 'Kolathur', pincode: '604407' },
  { value: 'manakkal', label: 'Manakkal', pincode: '604402' },
  { value: 'nallur', label: 'Nallur', pincode: '604403' },
  { value: 'nadukuppam', label: 'Nadukuppam', pincode: '604407' },
  { value: 'perumpakkam', label: 'Perumpakkam', pincode: '604401' },
  { value: 'sundarampattu', label: 'Sundarampattu', pincode: '604407' },
  { value: 'thiruthani', label: 'Thiruthani', pincode: '604407' },
  { value: 'vikkiravandi', label: 'Vikkiravandi', pincode: '604409' },
  { value: 'adichipattu', label: 'Adichipattu', pincode: '604407' },
  { value: 'kanchipuram', label: 'Kanchipuram', pincode: '631502' },
  { value: 'karai', label: 'Karai', pincode: '604403' },
  { value: 'kanakapalayam', label: 'Kanakapalayam', pincode: '604406' },
  { value: 'kuruvikaranvalli', label: 'Kuruvikaranvalli', pincode: '604405' },
  { value: 'melsathambai', label: 'Melsathambai', pincode: '604406' },
  { value: 'poondi', label: 'Poondi', pincode: '604403' },
  { value: 'varadarajapuram', label: 'Varadarajapuram', pincode: '604401' }
  ],

  'chidambaram': [
  { value: 'chidambaram', label: 'Chidambaram', pincode: '608001' },
  { value: 'alanthangudi', label: 'Alanthangudi', pincode: '608302' },
  { value: 'ballem', label: 'Ballem', pincode: '608201' },
  { value: 'cheranmahadevi', label: 'Cheranmahadevi', pincode: '608501' },
  { value: 'irulneeki', label: 'Irulneeki', pincode: '608307' },
  { value: 'kattumanarkoil', label: 'Kattumanarkoil', pincode: '608102' },
  { value: 'kolakudi', label: 'Kolakudi', pincode: '608702' },
  { value: 'manalmelkudi', label: 'Manalmelkudi', pincode: '608302' },
  { value: 'nadukuppam', label: 'Nadukuppam', pincode: '608201' },
  { value: 'natchiyarpuram', label: 'Natchiyarpuram', pincode: '608701' },
  { value: 'poigai', label: 'Poigai', pincode: '608501' },
  { value: 'semmankudi', label: 'Semmankudi', pincode: '608106' },
  { value: 'thillai', label: 'Thillai', pincode: '608001' },
  { value: 'valavanthankottai', label: 'Valavanthankottai', pincode: '608501' },
  { value: 'vengamedu', label: 'Vengamedu', pincode: '608401' },
  { value: 'agaram', label: 'Agaram', pincode: '608301' },
  { value: 'akkur', label: 'Akkur', pincode: '608106' },
  { value: 'bhoolokapuram', label: 'Bhoolokapuram', pincode: '608305' },
  { value: 'chennasamudram', label: 'Chennasamudram', pincode: '608208' },
  { value: 'irulneelavan', label: 'Irulneelavan', pincode: '608308' },
  { value: 'nallur', label: 'Nallur', pincode: '608304' },
  { value: 'pattamangalam', label: 'Pattamangalam', pincode: '608305' },
  { value: 'seyyur', label: 'Seyyur', pincode: '608302' }
  ],

  'chinnamanur': [
  { value: 'alampatti', label: 'Alampatti', pincode: '625502' },
  { value: 'arampalayam', label: 'Arampalayam', pincode: '625515' },
  { value: 'chinnamanur-town', label: 'Chinnamanur Town', pincode: '625515' },
  { value: 'cheranmahadevi', label: 'Cheranmahadevi', pincode: '627414' },
  { value: 'karuthanankulam', label: 'Karuthanankulam', pincode: '625515' },
  { value: 'koduvilarpatti', label: 'Koduvilarpatti', pincode: '625520' },
  { value: 'kumarapuram', label: 'Kumarapuram', pincode: '625702' },
  { value: 'manjalampatti', label: 'Manjalampatti', pincode: '625515' },
  { value: 'muthuramalingapuram', label: 'Muthuramalingapuram', pincode: '625706' },
  { value: 'naganathi', label: 'Naganathi', pincode: '625510' },
  { value: 'ottapidaram', label: 'Ottapidaram', pincode: '625533' },
  { value: 'paramakudi', label: 'Paramakudi', pincode: '623707' },
  { value: 'srivilliputhur', label: 'Srivilliputhur', pincode: '626125' },
  { value: 'thirumangalam', label: 'Thirumangalam', pincode: '625706' },
  { value: 'tallakulam', label: 'Tallakulam', pincode: '625002' },
  { value: 'villapuram', label: 'Villapuram', pincode: '625002' },
  { value: 'virudhunagar', label: 'Virudhunagar', pincode: '626001' },
  { value: 'wariachivadi', label: 'Wariachivadi', pincode: '625704' },
  { value: 'thayalanpatti', label: 'Thayalanpatti', pincode: '625704' },
  { value: 'sundarapandiapuram', label: 'Sundarapandiapuram', pincode: '625705' },
  { value: 'velayuthapuram', label: 'Velayuthapuram', pincode: '625706' },
  { value: 'nattarasankottai', label: 'Nattarasankottai', pincode: '625601' },
  { value: 'kothaimangalam', label: 'Kothaimangalam', pincode: '625703' },
  { value: 'rajapalayam', label: 'Rajapalayam', pincode: '626117' }
  ],

  'dharapuram': [
  { value: 'adhinadu', label: 'Adhinadu', pincode: '638656' },
  { value: 'arakkankottai', label: 'Arakkankottai', pincode: '638656' },
  { value: 'dharapuram-town', label: 'Dharapuram Town', pincode: '638656' },
  { value: 'elavadi', label: 'Elavadi', pincode: '638702' },
  { value: 'kadiyampatty', label: 'Kadiyampatty', pincode: '638656' },
  { value: 'kodumudi', label: 'Kodumudi', pincode: '638151' },
  { value: 'kumaranallur', label: 'Kumaranallur', pincode: '638656' },
  { value: 'manickapuram', label: 'Manickapuram', pincode: '638658' },
  { value: 'muthur', label: 'Muthur', pincode: '638105' },
  { value: 'neruppur', label: 'Neruppur', pincode: '638056' },
  { value: 'pallapalayam', label: 'Pallapalayam', pincode: '638002' },
  { value: 'pudupalayam', label: 'Pudupalayam', pincode: '638056' },
  { value: 'sathiyamangalam', label: 'Sathiyamangalam', pincode: '638004' },
  { value: 'thoppampatti', label: 'Thoppampatti', pincode: '638701' },
  { value: 'vijayapuram', label: 'Vijayapuram', pincode: '638664' },
  { value: 'villankurichi', label: 'Villankurichi', pincode: '638703' },
  { value: 'alampalayam', label: 'Alampalayam', pincode: '638656' },
  { value: 'chinnakolumam', label: 'Chinnakolumam', pincode: '638703' },
  { value: 'kallappalayam', label: 'Kallappalayam', pincode: '638662' },
  { value: 'kalappan', label: 'Kalappan', pincode: '638657' },
  { value: 'kootampatti', label: 'Kootampatti', pincode: '638653' },
  { value: 'moongilthuraipatti', label: 'Moongilthuraipatti', pincode: '638662' },
  { value: 'puliankulam', label: 'Puliankulam', pincode: '638705' },
  { value: 'ramapuram', label: 'Ramapuram', pincode: '638661' },
  { value: 'sivampatti', label: 'Sivampatti', pincode: '638656' },
  { value: 'thennampalayam', label: 'Thennampalayam', pincode: '638655' },
  { value: 'valavandhi', label: 'Valavandhi', pincode: '638702' }
  ],

  'dharmapuri': [
  { value: 'adhivaram', label: 'Adhivaram', pincode: '636703' },
  { value: 'alamarathur', label: 'Alamarathur', pincode: '636804' },
  { value: 'dharmapuri', label: 'Dharmapuri', pincode: '636701' },
  { value: 'hebbal', label: 'Hebbal', pincode: '636701' },
  { value: 'hillur', label: 'Hillur', pincode: '636701' },
  { value: 'krishnagiri', label: 'Krishnagiri', pincode: '635001' },
  { value: 'kuppam', label: 'Kuppam', pincode: '636807' },
  { value: 'longanur', label: 'Longanur', pincode: '636808' },
  { value: 'muruganapalli', label: 'Muruganapalli', pincode: '636803' },
  { value: 'nallampalli', label: 'Nallampalli', pincode: '636807' },
  { value: 'palacode', label: 'Palacode', pincode: '636808' },
  { value: 'pennagaram', label: 'Pennagaram', pincode: '636809' },
  { value: 'pudur', label: 'Pudur', pincode: '636809' },
  { value: 'sagaya-medu', label: 'Sagaya Medu', pincode: '636701' },
  { value: 'salem', label: 'Salem', pincode: '636005' },
  { value: 'sitheri', label: 'Sitheri', pincode: '636707' },
  { value: 'thoppur', label: 'Thoppur', pincode: '636704' },
  { value: 'tamilnadu', label: 'Tamilnadu', pincode: '636708' },
  { value: 'vattanam', label: 'Vattanam', pincode: '636701' },
  { value: 'varadhan', label: 'Varadhan', pincode: '636711' },
  { value: 'sulur', label: 'Sulur', pincode: '636712' },
  { value: 'sundarampatti', label: 'Sundarampatti', pincode: '636712' }
  ],

  'edappadi': [
  { value: 'alampadi', label: 'Alampadi', pincode: '637101' },
  { value: 'alathur', label: 'Alathur', pincode: '637106' },
  { value: 'chinnathiruppur', label: 'Chinnathiruppur', pincode: '637102' },
  { value: 'erumapatti', label: 'Erumapatti', pincode: '637103' },
  { value: 'edappadi', label: 'Edappadi', pincode: '637101' },
  { value: 'kattukottai', label: 'Kattukottai', pincode: '637104' },
  { value: 'kolathur', label: 'Kolathur', pincode: '637105' },
  { value: 'mandagapatti', label: 'Mandagapatti', pincode: '637107' },
  { value: 'mecheri', label: 'Mecheri', pincode: '637414' },
  { value: 'muthur', label: 'Muthur', pincode: '637103' },
  { value: 'naranapuram', label: 'Naranapuram', pincode: '637108' },
  { value: 'sampalli', label: 'Sampalli', pincode: '637109' },
  { value: 'sarvanampatti', label: 'Sarvanampatti', pincode: '637110' },
  { value: 'thammampatti', label: 'Thammampatti', pincode: '637111' },
  { value: 'thoppur', label: 'Thoppur', pincode: '637112' },
  { value: 'vellalapatti', label: 'Vellalapatti', pincode: '637113' },
  { value: 'kudimangalam', label: 'Kudimangalam', pincode: '637114' },
  { value: 'nallur', label: 'Nallur', pincode: '637115' },
  { value: 'periyakodiveri', label: 'Periyakodiveri', pincode: '637116' },
  { value: 'pudupalayam', label: 'Pudupalayam', pincode: '637117' },
  { value: 'thirumalpadi', label: 'Thirumalpadi', pincode: '637118' },
  { value: 'valapadi', label: 'Valapadi', pincode: '637119' },
  { value: 'pallapatti', label: 'Pallapatti', pincode: '637120' },
  { value: 'sidhapudur', label: 'Sidhapudur', pincode: '637121' },
  { value: 'mangalam', label: 'Mangalam', pincode: '637122' },
  { value: 'ponnappatti', label: 'Ponnappatti', pincode: '637123' },
  { value: 'puruvampatti', label: 'Puruvampatti', pincode: '637124' },
  { value: 'kurangani', label: 'Kurangani', pincode: '637125' },
  { value: 'arasanapatti', label: 'Arasanapatti', pincode: '637126' },
  { value: 'thiruchengode', label: 'Thiruchengode', pincode: '637127' },
  { value: 'sathanur', label: 'Sathanur', pincode: '637128' },
  { value: 'melur', label: 'Melur', pincode: '637129' },
  { value: 'sithapudhur', label: 'Sithapudhur', pincode: '637130' },
  { value: 'agaram', label: 'Agaram', pincode: '637131' }
  ],

  'gudalur': [
  { value: 'alampalayam', label: 'Alampalayam', pincode: '643211' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '643212' },
  { value: 'banagiri', label: 'Banagiri', pincode: '643211' },
  { value: 'chinnakkal', label: 'Chinnakkal', pincode: '643215' },
  { value: 'gudalur', label: 'Gudalur', pincode: '643212' },
  { value: 'kappiyar', label: 'Kappiyar', pincode: '643213' },
  { value: 'kothagiri', label: 'Kothagiri', pincode: '643217' },
  { value: 'meenkarai', label: 'Meenkarai', pincode: '643216' },
  { value: 'mundakayam', label: 'Mundakayam', pincode: '643215' },
  { value: 'pandalur', label: 'Pandalur', pincode: '643221' },
  { value: 'sithar', label: 'Sithar', pincode: '643233' },
  { value: 'sholur', label: 'Sholur', pincode: '643232' },
  { value: 'sindhanoor', label: 'Sindhanoor', pincode: '643217' },
  { value: 'tamilnadu', label: 'Tamilnadu', pincode: '643228' },
  { value: 'tiger-hill', label: 'Tiger Hill', pincode: '643210' },
  { value: 'valparai', label: 'Valparai', pincode: '643232' },
  { value: 'vattavada', label: 'Vattavada', pincode: '643239' },
  { value: 'west-hills', label: 'West Hills', pincode: '643230' },
  { value: 'kalamandalam', label: 'Kalamandalam', pincode: '643219' },
  { value: 'kottathara', label: 'Kottathara', pincode: '643227' },
  { value: 'krishnan-koil', label: 'Krishnan Koil', pincode: '643222' },
  { value: 'thengumarahada', label: 'Thengumarahada', pincode: '643224' },
  { value: 'thokkampatti', label: 'Thokkampatti', pincode: '643225' },
  { value: 'perumbadi', label: 'Perumbadi', pincode: '643213' },
  { value: 'pudur', label: 'Pudur', pincode: '643220' },
  { value: 'aivathokku', label: 'Aivathokku', pincode: '643208' },
  { value: 'andipalayam', label: 'Andipalayam', pincode: '643214' },
  { value: 'avalappadi', label: 'Avalappadi', pincode: '643226' },
  { value: 'bharathiyar-nagar', label: 'Bharathiyar Nagar', pincode: '643229' },
  { value: 'chinnapallam', label: 'Chinnapallam', pincode: '643218' },
  { value: 'karimala', label: 'Karimala', pincode: '643240' }
  ],
  
  'kallidaikurchi': [
  { value: 'adampur', label: 'Adampur', pincode: '627856' },
  { value: 'alankulam', label: 'Alankulam', pincode: '627417' },
  { value: 'kallidaikurchi', label: 'Kallidaikurchi', pincode: '627416' },
  { value: 'karaikurichi', label: 'Karaikurichi', pincode: '627856' },
  { value: 'kattuvilai', label: 'Kattuvilai', pincode: '627858' },
  { value: 'kottur', label: 'Kottur', pincode: '627410' },
  { value: 'maniyakkarai', label: 'Maniyakkarai', pincode: '627413' },
  { value: 'melappalai', label: 'Melappalai', pincode: '627414' },
  { value: 'muthur', label: 'Muthur', pincode: '627419' },
  { value: 'pappakudi', label: 'Pappakudi', pincode: '627420' },
  { value: 'perumalpatti', label: 'Perumalpatti', pincode: '627420' },
  { value: 'pudur', label: 'Pudur', pincode: '627426' },
  { value: 'thandalam', label: 'Thandalam', pincode: '627415' },
  { value: 'thirupudai-madurai', label: 'Thirupudai Madurai', pincode: '627426' },
  { value: 'valaiyur', label: 'Valaiyur', pincode: '627412' },
  { value: 'veppankulam', label: 'Veppankulam', pincode: '627429' },
  { value: 'vikkiravandi', label: 'Vikkiravandi', pincode: '627428' },
  { value: 'alavayal', label: 'Alavayal', pincode: '627427' },
  { value: 'arunthathiyarpuram', label: 'Arunthathiyarpuram', pincode: '627423' },
  { value: 'avudaiyarkoil', label: 'Avudaiyarkoil', pincode: '627425' },
  { value: 'kalappan', label: 'Kalappan', pincode: '627430' },
  { value: 'kamuthi', label: 'Kamuthi', pincode: '627407' },
  { value: 'kanadi', label: 'Kanadi', pincode: '627431' },
  { value: 'kovilpatti', label: 'Kovilpatti', pincode: '627701' },
  { value: 'melagaram', label: 'Melagaram', pincode: '627703' },
  { value: 'perungulam', label: 'Perungulam', pincode: '627402' },
  { value: 'sirumalar', label: 'Sirumalar', pincode: '627424' },
  { value: 'thirumangalam', label: 'Thirumangalam', pincode: '627414' }
],

  'kanniyakumari': [
  { value: 'aralvayal', label: 'Aralvayal', pincode: '629157' },
  { value: 'colachel', label: 'Colachel', pincode: '629251' },
  { value: 'kanniyakumari', label: 'Kanyakumari', pincode: '629702' },
  { value: 'kanyakumari-town', label: 'Kanyakumari Town', pincode: '629702' },
  { value: 'kurinji', label: 'Kurinji', pincode: '629158' },
  { value: 'manakkudy', label: 'Manakkudy', pincode: '629161' },
  { value: 'nagercoil', label: 'Nagercoil', pincode: '629001' },
  { value: 'nazareth', label: 'Nazareth', pincode: '629201' },
  { value: 'palloor', label: 'Palloor', pincode: '629169' },
  { value: 'pudukkadai', label: 'Pudukkadai', pincode: '629204' },
  { value: 'ranipet', label: 'Ranipet', pincode: '629308' },
  { value: 'sathankulam', label: 'Sathankulam', pincode: '629204' },
  { value: 'sivanthipuram', label: 'Sivanthipuram', pincode: '629302' },
  { value: 'thengapattanam', label: 'Thengapattanam', pincode: '629402' },
  { value: 'thiruvithancode', label: 'Thiruvithancode', pincode: '629177' },
  { value: 'vadasery', label: 'Vadasery', pincode: '629001' },
  { value: 'vadakku-vilai', label: 'Vadakku Vilai', pincode: '629169' },
  { value: 'alankulam', label: 'Alankulam', pincode: '629162' },
  { value: 'chempakassery', label: 'Chempakassery', pincode: '629308' },
  { value: 'chothavilai', label: 'Chothavilai', pincode: '629167' },
  { value: 'kakkayur', label: 'Kakkayur', pincode: '629155' },
  { value: 'karode', label: 'Karode', pincode: '629166' },
  { value: 'kesavan', label: 'Kesavan', pincode: '629155' },
  { value: 'marthandam', label: 'Marthandam', pincode: '629165' },
  { value: 'muthuvarpatti', label: 'Muthuvarpatti', pincode: '629185' },
  { value: 'pongumoodu', label: 'Pongumoodu', pincode: '629177' },
  { value: 'pushpavanam', label: 'Pushpavanam', pincode: '629203' },
  { value: 'thenkasi', label: 'Thenpennai', pincode: '629336' },
  { value: 'villianur', label: 'Villianur', pincode: '629401' },
  { value: 'velimalai', label: 'Velimalai', pincode: '629210' },
  { value: 'vilavancode', label: 'Vilavancode', pincode: '629153' },
  { value: 'vanniyoor', label: 'Vanniyoor', pincode: '629201' },
  { value: 'vembayam', label: 'Vembayam', pincode: '629175' },
  { value: 'vettuvanam', label: 'Vettuvanam', pincode: '629208' },
  { value: 'vengalam', label: 'Vengalam', pincode: '629204' },
  { value: 'tharuvai', label: 'Tharuvai', pincode: '629202' },
  { value: 'valiyoor', label: 'Valiyoor', pincode: '629252' },
  { value: 'valliyoor', label: 'Valliyoor', pincode: '629208' }
  ],

  'koundampalayam': [
  { value: 'agaram', label: 'Agaram', pincode: '641030' },
  { value: 'alathur', label: 'Alathur', pincode: '641027' },
  { value: 'chinnavedampatti', label: 'Chinnavedampatti', pincode: '641035' },
  { value: 'irugur', label: 'Irugur', pincode: '641103' },
  { value: 'koundampalayam', label: 'Koundampalayam', pincode: '641030' },
  { value: 'kurichi', label: 'Kurichi', pincode: '641024' },
  { value: 'mullai-nagar', label: 'Mullai Nagar', pincode: '641030' },
  { value: 'neelambur', label: 'Neelambur', pincode: '641062' },
  { value: 'ponnammal', label: 'Ponnammal', pincode: '641023' },
  { value: 'pondy', label: 'Pondy', pincode: '641030' },
  { value: 'saravanampatti', label: 'Saravanampatti', pincode: '641035' },
  { value: 'sivanandapuram', label: 'Sivanandapuram', pincode: '641035' },
  { value: 'vadavalli', label: 'Vadavalli', pincode: '641041' },
  { value: 'varadarajapuram', label: 'Varadarajapuram', pincode: '641030' },
  { value: 'velandipalayam', label: 'Velandipalayam', pincode: '641025' },
  { value: 'vinayakapuram', label: 'Vinayakapuram', pincode: '641030' },
  { value: 'vijayapuram', label: 'Vijayapuram', pincode: '641027' },
  { value: 'vishalnagar', label: 'Vishal Nagar', pincode: '641024' },
  { value: 'annanagar', label: 'Anna Nagar', pincode: '641006' },
  { value: 'chikkanaickenpalayam', label: 'Chikkanaickenpalayam', pincode: '641105' },
  { value: 'ilampillai', label: 'Ilampillai', pincode: '641027' },
  { value: 'kattampatti', label: 'Kattampatti', pincode: '641024' },
  { value: 'manipalayam', label: 'Manipalayam', pincode: '641020' },
  { value: 'nallur', label: 'Nallur', pincode: '641105' },
  { value: 'saravanampatti-road', label: 'Saravanampatti Road', pincode: '641035' },
  { value: 'sathiamangalam', label: 'Sathiamangalam', pincode: '641030' },
  { value: 'singanallur', label: 'Singanallur', pincode: '641005' }
  ],

  'melur': [
  { value: 'arasaradi', label: 'Arasaradi', pincode: '625016' },
  { value: 'melur', label: 'Melur', pincode: '625106' },
  { value: 'muthupatti', label: 'Muthupatti', pincode: '625106' },
  { value: 'pudukkottai', label: 'Pudukkottai', pincode: '625105' },
  { value: 'rajapalayam', label: 'Rajapalayam', pincode: '625001' },
  { value: 'sevvapet', label: 'Sevvapet', pincode: '625019' },
  { value: 'sivaganga', label: 'Sivaganga', pincode: '630561' },
  { value: 'sundarapandiam', label: 'Sundarapandiam', pincode: '625106' },
  { value: 'thuraiyur', label: 'Thuraiyur', pincode: '625106' },
  { value: 'vadapalanji', label: 'Vadapalanji', pincode: '625106' },
  { value: 'vettuvanam', label: 'Vettuvanam', pincode: '625106' },
  { value: 'alankulam', label: 'Alankulam', pincode: '625105' },
  { value: 'perumalpuram', label: 'Perumalpuram', pincode: '625014' },
  { value: 'kathirampatti', label: 'Kathirampatti', pincode: '625106' },
  { value: 'kalayarkovil', label: 'Kalayarkovil', pincode: '630551' },
  { value: 'kalaiyarkoil', label: 'Kalaiyarkoil', pincode: '630552' },
  { value: 'mellur', label: 'Mellur', pincode: '625106' },
  { value: 'pallapatti', label: 'Pallapatti', pincode: '625106' },
  { value: 'sivagangai', label: 'Sivagangai', pincode: '630561' },
  { value: 'sundarapandian', label: 'Sundarapandian', pincode: '625106' },
  { value: 'thiruvadanai', label: 'Thiruvadanai', pincode: '630561' },
  { value: 'kumaramangalam', label: 'Kumaramangalam', pincode: '625106' },
  { value: 'alampatti', label: 'Alampatti', pincode: '625106' },
  { value: 'karisalkulam', label: 'Karisalkulam', pincode: '625106' },
  { value: 'palayapettai', label: 'Palayapettai', pincode: '625106' },
  { value: 'valanadu', label: 'Valanadu', pincode: '625106' },
  { value: 'tuticorin', label: 'Tuticorin', pincode: '628001' },
  { value: 'nattarasankottai', label: 'Nattarasankottai', pincode: '630111' },
  { value: 'chinna-pallapatti', label: 'Chinna Pallapatti', pincode: '625106' },
  { value: 'devipattinam', label: 'Devipattinam', pincode: '630501' },
  { value: 'kallukatti', label: 'Kallukatti', pincode: '625106' },
  { value: 'keelapattinam', label: 'Keelapattinam', pincode: '628206' },
  { value: 'kumil', label: 'Kumil', pincode: '630106' },
  { value: 'punnamaram', label: 'Punnamaram', pincode: '625106' },
  { value: 'sothuparai', label: 'Sothuparai', pincode: '625106' },
  { value: 'thiruchuli', label: 'Thiruchuli', pincode: '630107' },
  { value: 'vellaripatti', label: 'Vellaripatti', pincode: '625106' }
  ],

  'minjur': [
  { value: 'aduthurai', label: 'Aduthurai', pincode: '601203' },
  { value: 'anjur', label: 'Anjur', pincode: '601204' },
  { value: 'arugampuliyur', label: 'Arugampuliyur', pincode: '601203' },
  { value: 'chakrampettai', label: 'Chakrampettai', pincode: '601203' },
  { value: 'minjur', label: 'Minjur', pincode: '601203' },
  { value: 'nalur', label: 'Nalur', pincode: '601204' },
  { value: 'nathapettai', label: 'Nathapettai', pincode: '601205' },
  { value: 'padalam', label: 'Padalam', pincode: '601204' },
  { value: 'pallavaram', label: 'Pallavaram', pincode: '601204' },
  { value: 'periyapalayam', label: 'Periyapalayam', pincode: '601102' },
  { value: 'sengundram', label: 'Sengundram', pincode: '601203' },
  { value: 'thirupalaivanam', label: 'Thirupalaivanam', pincode: '601203' },
  { value: 'mangadu', label: 'Mangadu', pincode: '601302' },
  { value: 'ponneri', label: 'Ponneri', pincode: '601204' },
  { value: 'kalpakkam', label: 'Kalpakkam', pincode: '603102' },
  { value: 'vadanemmeli', label: 'Vadanemmeli', pincode: '601204' },
  { value: 'vengampakkam', label: 'Vengampakkam', pincode: '601204' },
  { value: 'vembakkam', label: 'Vembakkam', pincode: '601204' },
  { value: 'panchetti', label: 'Panchetti', pincode: '601204' },
  { value: 'tamilnadu', label: 'Tamilnadu', pincode: '601301' },
  { value: 'rajamangalam', label: 'Rajamangalam', pincode: '601204' },
  { value: 'irumbuliyur', label: 'Irumbuliyur', pincode: '601102' },
  { value: 'kattupalli', label: 'Kattupalli', pincode: '601102' },
  { value: 'sri-perumbudur', label: 'Sri Perumbudur', pincode: '602105' },
  { value: 'thirumudivakkam', label: 'Thirumudivakkam', pincode: '601204' },
  { value: 'uthandi', label: 'Uthandi', pincode: '601102' },
  { value: 'erukancheri', label: 'Erukancheri', pincode: '601207' },
  { value: 'kadaperi', label: 'Kadaperi', pincode: '601302' },
  { value: 'kottur', label: 'Kottur', pincode: '601204' },
  { value: 'selaiyur', label: 'Selaiyur', pincode: '600073' }
  ],

  'musiri': [
  { value: 'arungalur', label: 'Arungalur', pincode: '621213' },
  { value: 'avur', label: 'Avur', pincode: '621212' },
  { value: 'chandrapuram', label: 'Chandrapuram', pincode: '621212' },
  { value: 'chirakkal', label: 'Chirakkal', pincode: '621212' },
  { value: 'kallupatti', label: 'Kallupatti', pincode: '621212' },
  { value: 'kadaperi', label: 'Kadaperi', pincode: '621212' },
  { value: 'kattur', label: 'Kattur', pincode: '621213' },
  { value: 'kolakkadu', label: 'Kolakkadu', pincode: '621213' },
  { value: 'krishnavel', label: 'Krishnavel', pincode: '621212' },
  { value: 'muthupettai', label: 'Muthupettai', pincode: '621213' },
  { value: 'musiri-town', label: 'Musiri Town', pincode: '621211' },
  { value: 'pudukkottai-road', label: 'Pudukkottai Road', pincode: '621213' },
  { value: 'salemkarai', label: 'Salemkarai', pincode: '621212' },
  { value: 'sikkarayapuram', label: 'Sikkarayapuram', pincode: '621212' },
  { value: 'thiruvellore', label: 'Thiruvellore', pincode: '621213' },
  { value: 'thiruvenkadu', label: 'Thiruvenkadu', pincode: '621212' },
  { value: 'vayalur', label: 'Vayalur', pincode: '621212' },
  { value: 'vadakarai', label: 'Vadakarai', pincode: '621213' },
  { value: 'vellur', label: 'Vellur', pincode: '621213' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '621211' },
  { value: 'anandavadi', label: 'Anandavadi', pincode: '621212' },
  { value: 'chinna-uppur', label: 'Chinna Uppur', pincode: '621212' },
  { value: 'kottur', label: 'Kottur', pincode: '621212' },
  { value: 'manikandam', label: 'Manikandam', pincode: '621212' },
  { value: 'sankarankovil', label: 'Sankarankovil', pincode: '621212' },
  { value: 'siruvachur', label: 'Siruvachur', pincode: '621212' },
  { value: 'subramaniyapuram', label: 'Subramaniyapuram', pincode: '621212' },
  { value: 'tamilnadu-chennai', label: 'Tamil Nadu Chennai', pincode: '600001' },
  { value: 'kothamangalam', label: 'Kothamangalam', pincode: '621213' },
  { value: 'kottampatti', label: 'Kottampatti', pincode: '621213' },
  { value: 'padalur', label: 'Padalur', pincode: '621213' },
  { value: 'poovandanallur', label: 'Poovandanallur', pincode: '621212' },
  { value: 'sundarapuri', label: 'Sundarapuri', pincode: '621212' },
  { value: 'thayanur', label: 'Thayanur', pincode: '621212' },
  { value: 'thottiyapatti', label: 'Thottiyapatti', pincode: '621212' },
  { value: 'tiruvarankondan', label: 'Tiruvarankondan', pincode: '621212' },
  { value: 'uppiliyapuram', label: 'Uppiliyapuram', pincode: '621213' },
  { value: 'vadakkanandal', label: 'Vadakkanandal', pincode: '621213' },
  { value: 'valayapatti', label: 'Valayapatti', pincode: '621212' },
  { value: 'vettangudi', label: 'Vettangudi', pincode: '621212' }
  ],

  'nagercoil': [
  { value: 'azhicode', label: 'Azhicode', pincode: '629204' },
  { value: 'dalavapuram', label: 'Dalavapuram', pincode: '629203' },
  { value: 'kalungalam', label: 'Kalungalam', pincode: '629202' },
  { value: 'kottar', label: 'Kottar', pincode: '629001' },
  { value: 'kurusadi', label: 'Kurusadi', pincode: '629202' },
  { value: 'manjalumoodu', label: 'Manjalumoodu', pincode: '629202' },
  { value: 'nagercoil-town', label: 'Nagercoil Town', pincode: '629001' },
  { value: 'north-park', label: 'North Park', pincode: '629001' },
  { value: 'pondy', label: 'Pondy', pincode: '629003' },
  { value: 'pudukkadai', label: 'Pudukkadai', pincode: '629301' },
  { value: 'sankaranainar-kovil', label: 'Sankaranainar Kovil', pincode: '629161' },
  { value: 'sudalai', label: 'Sudalai', pincode: '629302' },
  { value: 'thanakkarai', label: 'Thanakkarai', pincode: '629001' },
  { value: 'thiruvithancode', label: 'Thiruvithancode', pincode: '629156' },
  { value: 'vadasery', label: 'Vadasery', pincode: '629001' },
  { value: 'vadiveeswaram', label: 'Vadiveeswaram', pincode: '629002' },
  { value: 'vattakottai', label: 'Vattakottai', pincode: '629402' },
  { value: 'agasteeswaram', label: 'Agasteeswaram', pincode: '629702' },
  { value: 'alankulam', label: 'Alankulam', pincode: '629201' },
  { value: 'anappara', label: 'Anappara', pincode: '629203' },
  { value: 'changanvila', label: 'Changanvila', pincode: '629169' },
  { value: 'colachel', label: 'Colachel', pincode: '629251' },
  { value: 'kadayal', label: 'Kadayal', pincode: '629161' },
  { value: 'kanjiracode', label: 'Kanjiracode', pincode: '629157' },
  { value: 'kollemcode', label: 'Kollemcode', pincode: '629404' },
  { value: 'kuttiyadi', label: 'Kuttiyadi', pincode: '629104' },
  { value: 'meesalai', label: 'Meesalai', pincode: '629701' },
  { value: 'mungilodai', label: 'Mungilodai', pincode: '629157' },
  { value: 'mukundarayapuram', label: 'Mukundarayapuram', pincode: '629163' },
  { value: 'nadanvilai', label: 'Nadanvilai', pincode: '629157' },
  { value: 'nambuthalai', label: 'Nambuthalai', pincode: '629158' },
  { value: 'ramanputhoor', label: 'Ramanputhoor', pincode: '629156' },
  { value: 'sothavilai', label: 'Sothavilai', pincode: '629302' },
  { value: 'vembi', label: 'Vembi', pincode: '629104' },
  { value: 'villukuri', label: 'Villukuri', pincode: '629301' },
  { value: 'chidambaran', label: 'Chidambaran', pincode: '629153' },
  { value: 'kalloor', label: 'Kalloor', pincode: '629204' },
  { value: 'karankadu', label: 'Karankadu', pincode: '629161' },
  { value: 'kilakari', label: 'Kilakari', pincode: '629402' },
  { value: 'kottakunnu', label: 'Kottakunnu', pincode: '629405' },
  { value: 'madhavapuram', label: 'Madhavapuram', pincode: '629157' },
  { value: 'manalodai', label: 'Manalodai', pincode: '629158' },
  { value: 'narayanapuram', label: 'Narayanapuram', pincode: '629157' },
  { value: 'pallikunnu', label: 'Pallikunnu', pincode: '629162' },
  { value: 'pooventhanthalam', label: 'Pooventhanthalam', pincode: '629161' },
  { value: 'poovulvilai', label: 'Poovulvilai', pincode: '629201' },
  { value: 'tamilnadupuram', label: 'Tamilnadupuram', pincode: '629153' }
  ],
 
  'nagapattinam': [
  { value: 'alankudi', label: 'Alankudi', pincode: '611111' },
  { value: 'ammapettai', label: 'Ammapettai', pincode: '611108' },
  { value: 'anchangudi', label: 'Anchangudi', pincode: '611104' },
  { value: 'balarajapuram', label: 'Balarajapuram', pincode: '611104' },
  { value: 'bharathiyar-nagar', label: 'Bharathiyar Nagar', pincode: '611001' },
  { value: 'dravida-nagar', label: 'Dravida Nagar', pincode: '611001' },
  { value: 'karaikal', label: 'Karaikal', pincode: '609602' },
  { value: 'kottur', label: 'Kottur', pincode: '611108' },
  { value: 'nagapattinam-town', label: 'Nagapattinam Town', pincode: '611001' },
  { value: 'nallur', label: 'Nallur', pincode: '611001' },
  { value: 'pudupattinam', label: 'Pudupattinam', pincode: '611108' },
  { value: 'sirkazhi', label: 'Sirkazhi', pincode: '609110' },
  { value: 'south-velur', label: 'South Velur', pincode: '611102' },
  { value: 'thirunallar', label: 'Thirunallar', pincode: '609607' },
  { value: 'vailankanni', label: 'Vailankanni', pincode: '611111' },
  { value: 'varakalpudhur', label: 'Varakalpudhur', pincode: '611108' },
  { value: 'vedaranyam', label: 'Vedaranyam', pincode: '614810' },
  { value: 'vengur', label: 'Vengur', pincode: '611108' },
  { value: 'villupuram', label: 'Villupuram', pincode: '611111' },
  { value: 'agaram', label: 'Agaram', pincode: '611113' },
  { value: 'akkinapet', label: 'Akkinapet', pincode: '611104' },
  { value: 'alappakkam', label: 'Alappakkam', pincode: '609305' },
  { value: 'chidambaram', label: 'Chidambaram', pincode: '611104' },
  { value: 'erukkur', label: 'Erukkur', pincode: '609110' },
  { value: 'kandarvan', label: 'Kandarvan', pincode: '609115' },
  { value: 'kaveripattinam', label: 'Kaveripattinam', pincode: '609115' },
  { value: 'kuthalam', label: 'Kuthalam', pincode: '609304' },
  { value: 'meimanthai', label: 'Meimanthai', pincode: '609307' },
  { value: 'muthupet', label: 'Muthupet', pincode: '614803' },
  { value: 'palloor', label: 'Palloor', pincode: '609304' },
  { value: 'paramakudi', label: 'Paramakudi', pincode: '609115' },
  { value: 'peralam', label: 'Peralam', pincode: '609309' },
  { value: 'siddhamalli', label: 'Siddhamalli', pincode: '611101' },
  { value: 'thiruthuraipoondi', label: 'Thiruthuraipoondi', pincode: '614713' },
  { value: 'tiruvarur', label: 'Tiruvarur', pincode: '610001' },
  { value: 'valangaiman', label: 'Valangaiman', pincode: '609302' },
  { value: 'vembur', label: 'Vembur', pincode: '609303' },
  { value: 'venkatasubramaniapuram', label: 'Venkatasubramaniapuram', pincode: '611107' }
  ],

  'namakkal': [
  { value: 'alathur', label: 'Alathur', pincode: '637020' },
  { value: 'avalur', label: 'Avalur', pincode: '637003' },
  { value: 'erode-road', label: 'Erode Road', pincode: '637001' },
  { value: 'kaduvetti', label: 'Kaduvetti', pincode: '637204' },
  { value: 'kalappanaicken-pudur', label: 'Kalappanaicken Pudur', pincode: '637002' },
  { value: 'kandasamypuram', label: 'Kandasamypuram', pincode: '637003' },
  { value: 'kanakku-pudur', label: 'Kanakku Pudur', pincode: '637001' },
  { value: 'karur-road', label: 'Karur Road', pincode: '637001' },
  { value: 'kolangudi', label: 'Kolangudi', pincode: '637020' },
  { value: 'mallasamudram', label: 'Mallasamudram', pincode: '637503' },
  { value: 'namakkal-town', label: 'Namakkal Town', pincode: '637001' },
  { value: 'nallur', label: 'Nallur', pincode: '637015' },
  { value: 'pettai', label: 'Pettai', pincode: '637018' },
  { value: 'salem-road', label: 'Salem Road', pincode: '637001' },
  { value: 'sathyamangalam', label: 'Sathyamangalam', pincode: '637303' },
  { value: 'senthamangalam', label: 'Senthamangalam', pincode: '637407' },
  { value: 'sivarakottai', label: 'Sivarakottai', pincode: '637202' },
  { value: 'thiruchengode', label: 'Thiruchengode', pincode: '637211' },
  { value: 'thottiam', label: 'Thottiam', pincode: '637215' },
  { value: 'veerapandi', label: 'Veerapandi', pincode: '637210' },
  { value: 'village-pudur', label: 'Village Pudur', pincode: '637215' },
  { value: 'kamaraj-nagar', label: 'Kamaraj Nagar', pincode: '637005' },
  { value: 'nallapalayam', label: 'Nallapalayam', pincode: '637103' },
  { value: 'rajanagaram', label: 'Rajanagaram', pincode: '637010' },
  { value: 'kothangudi', label: 'Kothangudi', pincode: '637106' },
  { value: 'kumarapalayam', label: 'Kumarapalayam', pincode: '637204' },
  { value: 'rathinapuri', label: 'Rathinapuri', pincode: '637201' },
  { value: 'renganathapuram', label: 'Renganathapuram', pincode: '637215' },
  { value: 'sungam', label: 'Sungam', pincode: '637211' },
  { value: 'palakurichi', label: 'Palakurichi', pincode: '637202' },
  { value: 'pillayarpalayam', label: 'Pillayarpalayam', pincode: '637217' },
  { value: 'thirupattur', label: 'Thirupattur', pincode: '637209' },
  { value: 'manmangalam', label: 'Manmangalam', pincode: '637306' },
  { value: 'vellanaipatti', label: 'Vellanaipatti', pincode: '637206' },
  { value: 'muthur', label: 'Muthur', pincode: '637011' },
  { value: 'bommidi', label: 'Bommidi', pincode: '637303' }
  ],
 
  'palani': [
  { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '624601' },
  { value: 'balaramapuram', label: 'Balaramapuram', pincode: '624615' },
  { value: 'elachipalayam', label: 'Elachipalayam', pincode: '624620' },
  { value: 'ilampillai', label: 'Ilampillai', pincode: '624615' },
  { value: 'kallimandayam', label: 'Kallimandayam', pincode: '624201' },
  { value: 'kothandapatti', label: 'Kothandapatti', pincode: '624617' },
  { value: 'krishnapuram', label: 'Krishnapuram', pincode: '624202' },
  { value: 'palani-town', label: 'Palani Town', pincode: '624601' },
  { value: 'paramathi', label: 'Paramathi', pincode: '624201' },
  { value: 'periyakulam', label: 'Periyakulam', pincode: '624101' },
  { value: 'pillayarpatti', label: 'Pillayarpatti', pincode: '624615' },
  { value: 'sithurajapuram', label: 'Sithurajapuram', pincode: '624202' },
  { value: 'thandalam', label: 'Thandalam', pincode: '624617' },
  { value: 'thiruparankundram', label: 'Thiruparankundram', pincode: '624204' },
  { value: 'thiruvalampoor', label: 'Thiruvalampoor', pincode: '624601' },
  { value: 'vadakkupatti', label: 'Vadakkupatti', pincode: '624101' },
  { value: 'varathur', label: 'Varathur', pincode: '624620' },
  { value: 'vattalagundu', label: 'Vattalagundu', pincode: '624601' },
  { value: 'chinnar', label: 'Chinnar', pincode: '624618' },
  { value: 'devanur', label: 'Devanur', pincode: '624206' },
  { value: 'kanavayal', label: 'Kanavayal', pincode: '624601' },
  { value: 'karadipatti', label: 'Karadipatti', pincode: '624615' },
  { value: 'kurinji-nagar', label: 'Kurinji Nagar', pincode: '624206' },
  { value: 'muthur', label: 'Muthur', pincode: '624205' },
  { value: 'nalakottai', label: 'Nalakottai', pincode: '624613' },
  { value: 'pachapalayam', label: 'Pachapalayam', pincode: '624201' },
  { value: 'pothampatti', label: 'Pothampatti', pincode: '624615' },
  { value: 'sengulam', label: 'Sengulam', pincode: '624101' },
  { value: 'somankadu', label: 'Somankadu', pincode: '624601' },
  { value: 'thiruvannamalai', label: 'Thiruvannamalai', pincode: '624616' },
  { value: 'vengalapuram', label: 'Vengalapuram', pincode: '624618' },
  { value: 'vilathikulam', label: 'Vilathikulam', pincode: '624604' },
  { value: 'alampatti', label: 'Alampatti', pincode: '624201' },
  { value: 'andipatti', label: 'Andipatti', pincode: '624303' },
  { value: 'aravakurichi', label: 'Aravakurichi', pincode: '624205' },
  { value: 'chinnappampatti', label: 'Chinnappampatti', pincode: '624614' },
  { value: 'iyer-patti', label: 'Iyer Patti', pincode: '624613' },
  { value: 'kamalapuram', label: 'Kamalapuram', pincode: '624206' },
  { value: 'kottur', label: 'Kottur', pincode: '624603' },
  { value: 'kurichipatti', label: 'Kurichipatti', pincode: '624205' },
  { value: 'maruthur', label: 'Maruthur', pincode: '624206' },
  { value: 'muthulapuram', label: 'Muthulapuram', pincode: '624202' },
  { value: 'nallur', label: 'Nallur', pincode: '624601' },
  { value: 'peranai', label: 'Peranai', pincode: '624205' },
  { value: 'sivakasi', label: 'Sivakasi', pincode: '624205' },
  { value: 'thirumoorthy', label: 'Thirumoorthy', pincode: '624615' },
  { value: 'vengadampatti', label: 'Vengadampatti', pincode: '624205' },
  { value: 'vijayapuri', label: 'Vijayapuri', pincode: '624206' }
  ],

  'ponneri': [
  { value: 'adhirampakkam', label: 'Adhirampakkam', pincode: '601204' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '601204' },
  { value: 'anjaneyar-kovil', label: 'Anjaneyar Kovil', pincode: '601204' },
  { value: 'ardhamalai', label: 'Ardhamalai', pincode: '601204' },
  { value: 'aramani', label: 'Aramani', pincode: '601204' },
  { value: 'chinnakavanam', label: 'Chinnakavanam', pincode: '601204' },
  { value: 'gummidipoondi', label: 'Gummidipoondi', pincode: '601201' },
  { value: 'kachur', label: 'Kachur', pincode: '601204' },
  { value: 'kachur-bazaar', label: 'Kachur Bazaar', pincode: '601204' },
  { value: 'kadambathur', label: 'Kadambathur', pincode: '601204' },
  { value: 'manali', label: 'Manali', pincode: '601104' },
  { value: 'mannivakkam', label: 'Mannivakkam', pincode: '601204' },
  { value: 'nandambakkam', label: 'Nandambakkam', pincode: '601204' },
  { value: 'nanganallur', label: 'Nanganallur', pincode: '601204' },
  { value: 'ponneri-bazaar', label: 'Ponneri Bazaar', pincode: '601204' },
  { value: 'perumpallam', label: 'Perumpallam', pincode: '601201' },
  { value: 'sengundram', label: 'Sengundram', pincode: '601204' },
  { value: 'thiruvadanai', label: 'Thiruvadanai', pincode: '601204' },
  { value: 'vadanemmeli', label: 'Vadanemmeli', pincode: '601204' },
  { value: 'varadarajapuram', label: 'Varadarajapuram', pincode: '601204' },
  { value: 'villivakkam', label: 'Villivakkam', pincode: '601204' },
  { value: 'vichoor', label: 'Vichoor', pincode: '601201' },
  { value: 'adityan-nagar', label: 'Adityan Nagar', pincode: '601204' },
  { value: 'athivakkam', label: 'Athivakkam', pincode: '601204' },
  { value: 'thiruvallur', label: 'Thiruvallur', pincode: '601204' },
  { value: 'kanagavalli', label: 'Kanagavalli', pincode: '601204' },
  { value: 'karaiyur', label: 'Karaiyur', pincode: '601204' },
  { value: 'kurichi', label: 'Kurichi', pincode: '601204' },
  { value: 'mangadu', label: 'Mangadu', pincode: '601204' },
  { value: 'kavaraipettai', label: 'Kavaraipettai', pincode: '601204' },
  { value: 'kottur', label: 'Kottur', pincode: '601204' },
  { value: 'madhavaram', label: 'Madhavaram', pincode: '601204' },
  { value: 'puducherry', label: 'Puducherry', pincode: '601204' },
  { value: 'veppampattu', label: 'Veppampattu', pincode: '601204' }
  ],

  'rameswaram': [
  { value: 'adarai', label: 'Adarai', pincode: '623526' },
  { value: 'dhanushkodi', label: 'Dhanushkodi', pincode: '623528' },
  { value: 'mandapam', label: 'Mandapam', pincode: '623518' },
  { value: 'muthupet', label: 'Muthupet', pincode: '623527' },
  { value: 'periyapattinam', label: 'Periyapattinam', pincode: '623529' },
  { value: 'rameswaram', label: 'Rameswaram', pincode: '623526' },
  { value: 'villoondi-theeram', label: 'Villoondi Theeram', pincode: '623527' },
  { value: 'kothandaramar-temple', label: 'Kothandaramar Temple', pincode: '623525' },
  { value: 'pamban', label: 'Pamban', pincode: '623501' },
  { value: 'pamban-bridge', label: 'Pamban Bridge', pincode: '623501' },
  { value: 'kattupuli', label: 'Kattupuli', pincode: '623533' },
  { value: 'erode', label: 'Erode', pincode: '623510' },
  { value: 'parvathamalai', label: 'Parvathamalai', pincode: '623531' },
  { value: 'nallur', label: 'Nallur', pincode: '623533' },
  { value: 'sitrampundi', label: 'Sitrampundi', pincode: '623527' },
  { value: 'ramanathapuram', label: 'Ramanathapuram', pincode: '623501' },
  { value: 'kudumiyanmalai', label: 'Kudumiyanmalai', pincode: '623520' },
  { value: 'chinnakadai', label: 'Chinnakadai', pincode: '623529' },
  { value: 'thirupullani', label: 'Thirupullani', pincode: '623701' },
  { value: 'kokkamangalam', label: 'Kokkamangalam', pincode: '623514' },
  { value: 'vembur', label: 'Vembur', pincode: '623535' },
  { value: 'thiruvadanai', label: 'Thiruvadanai', pincode: '623403' },
  { value: 'balaramapuram', label: 'Balaramapuram', pincode: '623534' },
  { value: 'vellakkal', label: 'Vellakkal', pincode: '623518' },
  { value: 'agathiyanallur', label: 'Agathiyanallur', pincode: '623515' },
  { value: 'pallivallal', label: 'Pallivallal', pincode: '623532' },
  { value: 'manamadurai', label: 'Manamadurai', pincode: '630606' },
  { value: 'sundaraperumal', label: 'Sundaraperumal', pincode: '623515' },
  { value: 'kumaralingam', label: 'Kumaralingam', pincode: '623528' },
  { value: 'avaniyapuram', label: 'Avaniyapuram', pincode: '623505' },
  { value: 'kothattai', label: 'Kothattai', pincode: '623522' },
  { value: 'vallanadu', label: 'Vallanadu', pincode: '623532' },
  { value: 'ramapuram', label: 'Ramapuram', pincode: '623528' },
  { value: 'kamuthi', label: 'Kamuthi', pincode: '623603' },
  { value: 'kilakarai', label: 'Kilakarai', pincode: '623803' },
  { value: 'muthur', label: 'Muthur', pincode: '623514' },
  { value: 'panangudi', label: 'Panangudi', pincode: '623503' },
  { value: 'adipattan', label: 'Adipattan', pincode: '623535' },
  { value: 'vadiyur', label: 'Vadiyur', pincode: '623405' }
  ],

  'tiruvottiyur': [
  { value: 'annai-theresa-nagar', label: 'Annai Theresa Nagar', pincode: '600019' },
  { value: 'ashtalakshmi-nagar', label: 'Ashtalakshmi Nagar', pincode: '600019' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '600019' },
  { value: 'chinna-thiruvottiyur', label: 'Chinna Thiruvottiyur', pincode: '600019' },
  { value: 'coral-mansion', label: 'Coral Mansion', pincode: '600019' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '600019' },
  { value: 'jesuraj-nagar', label: 'Jesuraj Nagar', pincode: '600019' },
  { value: 'kaladipet', label: 'Kaladipet', pincode: '600019' },
  { value: 'kamakshipuram', label: 'Kamakshipuram', pincode: '600019' },
  { value: 'labbipet', label: 'Labbipet', pincode: '600019' },
  { value: 'manali', label: 'Manali', pincode: '600068' },
  { value: 'manali-new-town', label: 'Manali New Town', pincode: '600103' },
  { value: 'mathur', label: 'Mathur', pincode: '600019' },
  { value: 'muthamizh-nagar', label: 'Muthamizh Nagar', pincode: '600019' },
  { value: 'new-thiruvottiyur', label: 'New Thiruvottiyur', pincode: '600019' },
  { value: 'north-madras', label: 'North Madras', pincode: '600019' },
  { value: 'pettai', label: 'Pettai', pincode: '600019' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '600019' },
  { value: 'srinivasapuram', label: 'Srinivasapuram', pincode: '600019' },
  { value: 'thuraiyur', label: 'Thuraiyur', pincode: '600019' },
  { value: 'tiruvalankeni', label: 'Tiruvalankeni', pincode: '600019' },
  { value: 'varadarajapuram', label: 'Varadarajapuram', pincode: '600019' },
  { value: 'vasanth-nagar', label: 'Vasanth Nagar', pincode: '600019' },
  { value: 'veeraperumal-nagar', label: 'Veeraperumal Nagar', pincode: '600019' },
  { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '600019' },
  { value: 'avadi', label: 'Avadi', pincode: '600071' },
  { value: 'azhagappa-nagar', label: 'Azhagappa Nagar', pincode: '600019' },
  { value: 'east-madras', label: 'East Madras', pincode: '600019' },
  { value: 'kotturpuram', label: 'Kotturpuram', pincode: '600085' },
  { value: 'padiripuliyur', label: 'Padiripuliyur', pincode: '600019' },
  { value: 'puduvayal', label: 'Puduvayal', pincode: '600019' },
  { value: 'sevvapet', label: 'Sevvapet', pincode: '600071' },
  { value: 'south-madras', label: 'South Madras', pincode: '600019' },
  { value: 'vanniyan-nagar', label: 'Vanniyan Nagar', pincode: '600019' }
  ],

  'virudhunagar': [
  { value: 'alangulam', label: 'Alangulam', pincode: '626130' },
  { value: 'aruppukottai', label: 'Aruppukottai', pincode: '626101' },
  { value: 'ethapur', label: 'Ethapur', pincode: '626112' },
  { value: 'kamadenu-nagar', label: 'Kamadenu Nagar', pincode: '626001' },
  { value: 'kondathur', label: 'Kondathur', pincode: '626104' },
  { value: 'kottaiyur', label: 'Kottaiyur', pincode: '626110' },
  { value: 'mangalam', label: 'Mangalam', pincode: '626112' },
  { value: 'muthuramalingapuram', label: 'Muthuramalingapuram', pincode: '626115' },
  { value: 'naduvattam', label: 'Naduvattam', pincode: '626125' },
  { value: 'peraiyur', label: 'Peraiyur', pincode: '626142' },
  { value: 'rajapalayam', label: 'Rajapalayam', pincode: '626117' },
  { value: 'sattur', label: 'Sattur', pincode: '626203' },
  { value: 'shanmugapuram', label: 'Shanmugapuram', pincode: '626130' },
  { value: 'thiruthangal', label: 'Thiruthangal', pincode: '626130' },
  { value: 'virudhunagar', label: 'Virudhunagar', pincode: '626001' },
  { value: 'vuthukatti', label: 'Vuthukatti', pincode: '626205' },
  { value: 'pudupatti', label: 'Pudupatti', pincode: '626208' },
  { value: 'kamaraj-nagar', label: 'Kamaraj Nagar', pincode: '626207' },
  { value: 'mangalam-puram', label: 'Mangalam Puram', pincode: '626130' },
  { value: 'thiruvengadam', label: 'Thiruvengadam', pincode: '626126' },
  { value: 'keerapatti', label: 'Keerapatti', pincode: '626134' },
  { value: 'vembakottai', label: 'Vembakottai', pincode: '626139' },
  { value: 'vettuvanam', label: 'Vettuvanam', pincode: '626209' },
  { value: 'sivakasi', label: 'Sivakasi', pincode: '626123' },
  { value: 'puliyangudi', label: 'Puliyangudi', pincode: '626115' },
  { value: 'pudur', label: 'Pudur', pincode: '626130' },
  { value: 'nallur', label: 'Nallur', pincode: '626128' },
  { value: 'thiruppacheti', label: 'Thiruppacheti', pincode: '626127' },
  { value: 'shanmuganathapuram', label: 'Shanmuganathapuram', pincode: '626136' },
  { value: 'karisalkulam', label: 'Karisalkulam', pincode: '626119' },
  { value: 'serrumbur', label: 'Serrumbur', pincode: '626121' },
  { value: 't.k.kulam', label: 'T.K. Kulam', pincode: '626141' },
  { value: 'uthangudi', label: 'Uthangudi', pincode: '626201' },
  { value: 'kaariyampatti', label: 'Kaariyampatti', pincode: '626115' },
  { value: 'melur', label: 'Melur', pincode: '626121' },
  { value: 'thiruvallur', label: 'Thiruvallur', pincode: '626130' },
  { value: 'ramanad', label: 'Ramanad', pincode: '626102' },
  { value: 'ichchakkarai', label: 'Ichchakkarai', pincode: '626121' },
  { value: 'pudur-uthangudi', label: 'Pudur Uthangudi', pincode: '626200' },
  { value: 'managapatti', label: 'Managapatti', pincode: '626203' }
  ],

  'walajapet': [
  { value: 'annanagar', label: 'Anna Nagar', pincode: '632513' },
  { value: 'aranganathapuram', label: 'Aranganathapuram', pincode: '632514' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '632514' },
  { value: 'chinna-cheri', label: 'Chinna Cheri', pincode: '632513' },
  { value: 'jambai', label: 'Jambai', pincode: '632510' },
  { value: 'karadikuppam', label: 'Karadikuppam', pincode: '632510' },
  { value: 'kandiyur', label: 'Kandiyur', pincode: '632513' },
  { value: 'kolappanallur', label: 'Kolappanallur', pincode: '632513' },
  { value: 'kumaranallur', label: 'Kumaranallur', pincode: '632514' },
  { value: 'kulathur', label: 'Kulathur', pincode: '632502' },
  { value: 'kuthiraveli', label: 'Kuthiraveli', pincode: '632515' },
  { value: 'mangalam', label: 'Mangalam', pincode: '632502' },
  { value: 'neelamangalam', label: 'Neelamangalam', pincode: '632511' },
  { value: 'nirmalapuram', label: 'Nirmalapuram', pincode: '632512' },
  { value: 'peddur', label: 'Peddur', pincode: '632503' },
  { value: 'perumalpattu', label: 'Perumalpattu', pincode: '632513' },
  { value: 'samiyarpalayam', label: 'Samiyarpalayam', pincode: '632515' },
  { value: 'sathamangalam', label: 'Sathamangalam', pincode: '632514' },
  { value: 'sirumugai', label: 'Sirumugai', pincode: '632516' },
  { value: 'tiruvarangam', label: 'Tiruvarangam', pincode: '632511' },
  { value: 'thirunagari', label: 'Thirunagari', pincode: '632515' },
  { value: 'vallimalai', label: 'Vallimalai', pincode: '632510' },
  { value: 'velampalayam', label: 'Velampalayam', pincode: '632510' },
  { value: 'walajapet', label: 'Walajapet', pincode: '632513' },
  { value: 'west-velur', label: 'West Velur', pincode: '632518' },
  { value: 'adapalayam', label: 'Adapalayam', pincode: '632516' },
  { value: 'alar', label: 'Alar', pincode: '632520' },
  { value: 'chandranallur', label: 'Chandranallur', pincode: '632514' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '632513' },
  { value: 'kanchipuram', label: 'Kanchipuram', pincode: '631501' },
  { value: 'manapakkam', label: 'Manapakkam', pincode: '632513' },
  { value: 'periyanayakkanpalayam', label: 'Periyanayakkanpalayam', pincode: '632518' },
  { value: 'ponneri', label: 'Ponneri', pincode: '632506' }
  ],
'mettur': [
  { value: 'alathur', label: 'Alathur', pincode: '636451' },
  { value: 'annanagar', label: 'Anna Nagar', pincode: '636141' },
  { value: 'avandhan', label: 'Avandhan', pincode: '636127' },
  { value: 'bagalur', label: 'Bagalur', pincode: '635105' },
  { value: 'bhavani', label: 'Bhavani', pincode: '638301' },
  { value: 'chinnagoundanpudur', label: 'Chinnagoundanpudur', pincode: '636401' },
  { value: 'elampillai', label: 'Elampillai', pincode: '636207' },
  { value: 'krishnagiri', label: 'Krishnagiri', pincode: '635001' },
  { value: 'kurumbapet', label: 'Kurumbapet', pincode: '636145' },
  { value: 'manalmedu', label: 'Manalmedu', pincode: '636136' },
  { value: 'mettur', label: 'Mettur', pincode: '636401' },
  { value: 'muthugoundanpudur', label: 'Muthugoundanpudur', pincode: '636130' },
  { value: 'pellichavadi', label: 'Pellichavadi', pincode: '636135' },
  { value: 'salem', label: 'Salem', pincode: '636001' },
  { value: 'sangagiri', label: 'Sangagiri', pincode: '637303' },
  { value: 'sulthanpettai', label: 'Sulthanpet', pincode: '636115' },
  { value: 'tharamangalam', label: 'Tharamangalam', pincode: '636502' },
  { value: 'thirumanimutharu', label: 'Thirumanimutharu', pincode: '636123' },
  { value: 'tollgate', label: 'Tollgate', pincode: '636130' },
  { value: 'vittapalayam', label: 'Vittapalayam', pincode: '636305' },
  { value: 'yanaiyur', label: 'Yanaiyur', pincode: '636301' },
  { value: 'vattamalaipatti', label: 'Vattamalaipatti', pincode: '636305' },
  { value: 'vazhavandankottai', label: 'Vazhavandankottai', pincode: '636130' }
  ],

  'chennai': [
    { value: 'abhiramapuram', label: 'Abhiramapuram', pincode: '600018' },
    { value: 'adambakkam', label: 'Adambakkam', pincode: '600020' },
    { value: 'adyar', label: 'Adyar', pincode: '600020' },
    { value: 'agaram', label: 'Agaram', pincode: '600082' },
    { value: 'alandur', label: 'Alandur', pincode: '600016' },
    { value: 'alapakkam', label: 'Alapakkam', pincode: '600100' },
    { value: 'alwarpet', label: 'Alwarpet', pincode: '600018' },
    { value: 'alwarthirunagar', label: 'Alwarthirunagar', pincode: '600087' },
    { value: 'ambattur', label: 'Ambattur', pincode: '600053' },
    { value: 'ambattur-industrial-estate', label: 'Ambattur Industrial Estate', pincode: '600058' },
    { value: 'ambattur-outer-town', label: 'Ambattur Outer Town', pincode: '600053' },
    { value: 'aminjikarai', label: 'Aminjikarai', pincode: '600029' },
    { value: 'anna-nagar', label: 'Anna Nagar', pincode: '600040' },
    { value: 'anna-nagar-east', label: 'Anna Nagar East', pincode: '600102' },
    { value: 'anna-nagar-west', label: 'Anna Nagar West', pincode: '600040' },
    { value: 'anna-nagar-western-extension', label: 'Anna Nagar Western Extension', pincode: '600101' },
    { value: 'anna-road', label: 'Anna Road', pincode: '600002' },
    { value: 'anna-salai', label: 'Anna Salai', pincode: '600002' },
    { value: 'arcot-road', label: 'Arcot Road', pincode: '600024' },
    { value: 'arumbakkam', label: 'Arumbakkam', pincode: '600106' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '600083' },
    { value: 'attipatttu', label: 'Attipatttu', pincode: '600056' },
    { value: 'avadi', label: 'Avadi', pincode: '600054' },
    { value: 'ayanavaram', label: 'Ayanavaram', pincode: '600023' },
    { value: 'ayyappanthangal', label: 'Ayyappanthangal', pincode: '600056' },
    { value: 'besant-nagar', label: 'Besant Nagar', pincode: '600090' },
    { value: 'broadway', label: 'Broadway', pincode: '600108' },
    { value: 'cathedral-road', label: 'Cathedral Road', pincode: '600086' },
    { value: 'chepauk', label: 'Chepauk', pincode: '600005' },
    { value: 'chetpet', label: 'Chetpet', pincode: '600031' },
    { value: 'chintadripet', label: 'Chintadripet', pincode: '600002' },
    { value: 'chinmaya-nagar', label: 'Chinmaya Nagar', pincode: '600092' },
    { value: 'choolai', label: 'Choolai', pincode: '600112' },
    { value: 'choolaimedu', label: 'Choolaimedu', pincode: '600094' },
    { value: 'cit-nagar', label: 'CIT Nagar', pincode: '600035' },
    { value: 'east-coast-road', label: 'East Coast Road', pincode: '600041' },
    { value: 'egmore', label: 'Egmore', pincode: '600008' },
    { value: 'ekkatuthangal', label: 'Ekkatuthangal', pincode: '600032' },
    { value: 'ennore', label: 'Ennore', pincode: '600057' },
    { value: 'ernavur', label: 'Ernavur', pincode: '600057' },
    { value: 'erukkancheri', label: 'Erukkancheri', pincode: '600118' },
    { value: 'flowers-road', label: 'Flowers Road', pincode: '600084' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '600020' },
    { value: 'george-town', label: 'George Town', pincode: '600001' },
    { value: 'gopalapuram', label: 'Gopalapuram', pincode: '600086' },
    { value: 'gowrivakkam', label: 'Gowrivakkam', pincode: '600073' },
    { value: 'greams-road', label: 'Greams Road', pincode: '600006' },
    { value: 'guindy', label: 'Guindy', pincode: '600032' },
    { value: 'guindy-industrial-estate', label: 'Guindy Industrial Estate', pincode: '600032' },
    { value: 'gurukkambakkam', label: 'Gurukkambakkam', pincode: '600100' },
    { value: 'haddows-road', label: 'Haddows Road', pincode: '600006' },
    { value: 'hastinapuram', label: 'Hastinapuram', pincode: '600100' },
    { value: 'iit-madras', label: 'IIT Madras', pincode: '600036' },
    { value: 'indira-nagar', label: 'Indira Nagar', pincode: '600020' },
    { value: 'injambakkam', label: 'Injambakkam', pincode: '600115' },
    { value: 'jafferkhanpet', label: 'Jafferkhanpet', pincode: '600083' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '600082' },
    { value: 'kaladipet', label: 'Kaladipet', pincode: '600100' },
    { value: 'kamaraj-nagar', label: 'Kamaraj Nagar', pincode: '600082' },
    { value: 'kandanchavadi', label: 'Kandanchavadi', pincode: '600100' },
    { value: 'karambakkam', label: 'Karambakkam', pincode: '600100' },
    { value: 'kattupakkam', label: 'Kattupakkam', pincode: '600100' },
    { value: 'kellys', label: 'Kellys', pincode: '600010' },
    { value: 'kilkattalai', label: 'Kilkattalai', pincode: '600100' },
    { value: 'kilpauk', label: 'Kilpauk', pincode: '600010' },
    { value: 'kilpauk-garden', label: 'Kilpauk Garden', pincode: '600010' },
    { value: 'kk-nagar', label: 'KK Nagar', pincode: '600078' },
    { value: 'kk-nagar-west', label: 'KK Nagar West', pincode: '600078' },
    { value: 'kodambakkam', label: 'Kodambakkam', pincode: '600024' },
    { value: 'kodungaiyur', label: 'Kodungaiyur', pincode: '600118' },
    { value: 'kolathur', label: 'Kolathur', pincode: '600099' },
    { value: 'kondithope', label: 'Kondithope', pincode: '600079' },
    { value: 'korattur', label: 'Korattur', pincode: '600080' },
    { value: 'korukkupet', label: 'Korukkupet', pincode: '600021' },
    { value: 'kottivakkam', label: 'Kottivakkam', pincode: '600100' },
    { value: 'kottur', label: 'Kottur', pincode: '600036' },
    { value: 'kotturpuram', label: 'Kotturpuram', pincode: '600085' },
    { value: 'kovilambakkam', label: 'Kovilambakkam', pincode: '600100' },
    { value: 'koyambedu', label: 'Koyambedu', pincode: '600107' },
    { value: 'little-mount', label: 'Little Mount', pincode: '600015' },
    { value: 'madambakkam', label: 'Madambakkam', pincode: '600100' },
    { value: 'madhavaram', label: 'Madhavaram', pincode: '600060' },
    { value: 'madipakkam', label: 'Madipakkam', pincode: '600091' },
    { value: 'maduravoyal', label: 'Maduravoyal', pincode: '600100' },
    { value: 'mahalingapuram', label: 'Mahalingapuram', pincode: '600034' },
    { value: 'mambalam', label: 'Mambalam', pincode: '600033' },
    { value: 'manali', label: 'Manali', pincode: '600068' },
    { value: 'manapakkam', label: 'Manapakkam', pincode: '600100' },
    { value: 'mandaveli', label: 'Mandaveli', pincode: '600028' },
    { value: 'mandavelipakkam', label: 'Mandavelipakkam', pincode: '600028' },
    { value: 'mannady', label: 'Mannady', pincode: '600001' },
    { value: 'mannurpet', label: 'Mannurpet', pincode: '600059' },
    { value: 'medavakkam', label: 'Medavakkam', pincode: '600100' },
    { value: 'meenambakkam', label: 'Meenambakkam', pincode: '600100' },
    { value: 'mogappair-west', label: 'Mogappair West', pincode: '600095' },
    { value: 'mount-road', label: 'Mount Road', pincode: '600002' },
    { value: 'mylapore', label: 'Mylapore', pincode: '600004' },
    { value: 'nungambakkam', label: 'Nungambakkam', pincode: '600034' },
    { value: 'nungambakkam-high-road', label: 'Nungambakkam High Road', pincode: '600034' },
    { value: 'old-washermanpet', label: 'Old Washermanpet', pincode: '600021' },
    { value: 'padi', label: 'Padi', pincode: '600050' },
    { value: 'pallavaram', label: 'Pallavaram', pincode: '600043' },
    { value: 'pallikaranai', label: 'Pallikaranai', pincode: '600100' },
    { value: 'park-town', label: 'Park Town', pincode: '600003' },
    { value: 'perambur', label: 'Perambur', pincode: '600011' },
    { value: 'poonamalle-high-road', label: 'Poonamalle High Road', pincode: '600084' },
    { value: 'porur', label: 'Porur', pincode: '600116' },
    { value: 'raja-annamalai-puram', label: 'Raja Annamalai Puram', pincode: '600028' },
    { value: 'ramapuram', label: 'Ramapuram', pincode: '600089' },
    { value: 'royapettah', label: 'Royapettah', pincode: '600014' },
    { value: 'royapettah-high-road', label: 'Royapettah High Road', pincode: '600014' },
    { value: 'saidapet', label: 'Saidapet', pincode: '600015' },
    { value: 'saligramam', label: 'Saligramam', pincode: '600093' },
    { value: 'santhome', label: 'Santhome', pincode: '600004' },
    { value: 'selaiyur', label: 'Selaiyur', pincode: '600073' },
    { value: 'shenoy-nagar', label: 'Shenoy Nagar', pincode: '600030' },
    { value: 'sholinganallur', label: 'Sholinganallur', pincode: '600100' },
    { value: 'sidco-industrial-estate', label: 'SIDCO Industrial Estate', pincode: '600100' },
    { value: 'sowcarpet', label: 'Sowcarpet', pincode: '600079' },
    { value: 'teynampet', label: 'Teynampet', pincode: '600018' },
    { value: 'tharamani', label: 'Tharamani', pincode: '600113' },
    { value: 'thirumangalam', label: 'Thirumangalam', pincode: '600040' },
    { value: 'thiruvanmiyur', label: 'Thiruvanmiyur', pincode: '600041' },
    { value: 'tiruvottiyur', label: 'Tiruvottiyur', pincode: '600019' },
    { value: 't-nagar', label: 'T Nagar', pincode: '600017' },
    { value: 'triplicane', label: 'Triplicane', pincode: '600005' },
    { value: 'ullagaram', label: 'Ullagaram', pincode: '600091' },
    { value: 'valasaravakkam', label: 'Valasaravakkam', pincode: '600087' },
    { value: 'vanagaram', label: 'Vanagaram', pincode: '600095' },
    { value: 'vadapalani', label: 'Vadapalani', pincode: '600026' },
    { value: 'velachery', label: 'Velachery', pincode: '600042' },
    { value: 'vepery', label: 'Vepery', pincode: '600007' },
    { value: 'villivakkam', label: 'Villivakkam', pincode: '600049' },
    { value: 'virugambakkam', label: 'Virugambakkam', pincode: '600092' },
    { value: 'vyasarpadi', label: 'Vyasarpadi', pincode: '600039' },
    { value: 'washermanpet', label: 'Washermanpet', pincode: '600021' },
    { value: 'west-cit-nagar', label: 'West CIT Nagar', pincode: '600035' },
    { value: 'west-k-k-nagar', label: 'West K.K. Nagar', pincode: '600078' },
    { value: 'west-mambalam', label: 'West Mambalam', pincode: '600033' }
  ],

//Kerala Areas
'nilambur': [
  { value: 'angadippuram', label: 'Angadippuram', pincode: '679321' },
  { value: 'edavanna', label: 'Edavanna', pincode: '679571' },
  { value: 'kalloor', label: 'Kalloor', pincode: '679330' },
  { value: 'kurumbalangode', label: 'Kurumbalangode', pincode: '679331' },
  { value: 'manjeri', label: 'Manjeri', pincode: '679333' },
  { value: 'mankada', label: 'Mankada', pincode: '679324' },
  { value: 'Nilambur-town', label: 'Nilambur Town', pincode: '679329' },
  { value: 'pattithara', label: 'Pattithara', pincode: '679327' },
  { value: 'pullencherry', label: 'Pullencherry', pincode: '679331' },
  { value: 'thalassery', label: 'Thalassery', pincode: '679332' },
  { value: 'pookkottur', label: 'Pookkottur', pincode: '679333' },
  { value: 'valluvanad', label: 'Valluvanad', pincode: '679331' },
  { value: 'vengara', label: 'Vengara', pincode: '679321' },
  { value: 'chungathara', label: 'Chungathara', pincode: '679334' },
  { value: 'edathara', label: 'Edathara', pincode: '679320' },
  { value: 'karuvasseri', label: 'Karuvasseri', pincode: '679325' }
  ],

  'thirurangadi': [
  { value: 'chathamangalam', label: 'Chathamangalam', pincode: '673601' },
  { value: 'edavannapra', label: 'Edavannapra', pincode: '673636' },
  { value: 'karad', label: 'Karad', pincode: '673628' },
  { value: 'kozhikkode', label: 'Kozhikkode', pincode: '673612' },
  { value: 'poyyannur', label: 'Poyyannur', pincode: '673634' },
  { value: 'thirurangadi-town', label: 'Thirurangadi Town', pincode: '673292' },
  { value: 'valanchery', label: 'Valanchery', pincode: '673313' },
  { value: 'vazhikadavu', label: 'Vazhikadavu', pincode: '673629' },
  { value: 'peruvallur', label: 'Peruvallur', pincode: '673602' },
  { value: 'pudukkad', label: 'Pudukkad', pincode: '673624' },
  { value: 'thiruthal', label: 'Thiruthal', pincode: '673635' },
  { value: 'undanchery', label: 'Undanchery', pincode: '673607' },
  { value: 'vallikkunnu', label: 'Vallikkunnu', pincode: '673624' },
  { value: 'varode', label: 'Varode', pincode: '673616' }
  ],

'anchal': [
  { value: 'abids', label: 'Abids', pincode: '500001' },
  { value: 'amberpet', label: 'Amberpet', pincode: '500013' },
  { value: 'aminpur', label: 'Aminpur', pincode: '502032' },
  { value: 'begumpet', label: 'Begumpet', pincode: '500016' },
  { value: 'bhel', label: 'BHEL', pincode: '502032' },
  { value: 'bowenpally', label: 'Bowenpally', pincode: '500011' },
  { value: 'charminar', label: 'Charminar', pincode: '500002' },
  { value: 'dilsukhnagar', label: 'Dilsukhnagar', pincode: '500060' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'habsiguda', label: 'Habsiguda', pincode: '500007' },
  { value: 'himayatnagar', label: 'Himayatnagar', pincode: '500029' },
  { value: 'jubilee-hills', label: 'Jubilee Hills', pincode: '500033' },
  { value: 'kondapur', label: 'Kondapur', pincode: '500084' },
  { value: 'kothapet', label: 'Kothapet', pincode: '500035' },
  { value: 'kukatpally', label: 'Kukatpally', pincode: '500072' },
  { value: 'madhapur', label: 'Madhapur', pincode: '500081' },
  { value: 'mehdipatnam', label: 'Mehdipatnam', pincode: '500028' },
  { value: 'miyapur', label: 'Miyapur', pincode: '500049' },
  { value: 'nallakunta', label: 'Nallakunta', pincode: '500044' },
  { value: 'nagole', label: 'Nagole', pincode: '500068' },
  { value: 'shamirpet', label: 'Shamirpet', pincode: '500078' },
  { value: 'somajiguda', label: 'Somajiguda', pincode: '500082' },
  { value: 'tarnaka', label: 'Tarnaka', pincode: '500017' },
  { value: 'uppal', label: 'Uppal', pincode: '500039' },
  { value: 'yousufguda', label: 'Yousufguda', pincode: '500045' },
  ],

  'attingal' : [
  { value: 'anchuthengu', label: 'Anchuthengu', pincode: '695309' },
  { value: 'arayoor', label: 'Arayoor', pincode: '695310' },
  { value: 'avolimoodu', label: 'Avolimoodu', pincode: '695102' },
  { value: 'ayarapuram', label: 'Ayarapuram', pincode: '695310' },
  { value: 'chirayinkeezhu', label: 'Chirayinkeezhu', pincode: '695304' },
  { value: 'edakkode', label: 'Edakkode', pincode: '695104' },
  { value: 'kadakkavoor', label: 'Kadakkavoor', pincode: '695306' },
  { value: 'kizhuvilam', label: 'Kizhuvilam', pincode: '695304' },
  { value: 'kudavoor', label: 'Kudavoor', pincode: '695305' },
  { value: 'manamboor', label: 'Manamboor', pincode: '695611' },
  { value: 'mangaram', label: 'Mangaram', pincode: '695103' },
  { value: 'muthana', label: 'Muthana', pincode: '695311' },
  { value: 'nagaroor', label: 'Nagaroor', pincode: '695618' },
  { value: 'ottur', label: 'Ottur', pincode: '695312' },
  { value: 'poovanpara', label: 'Poovanpara', pincode: '695605' },
  { value: 'pothencode', label: 'Pothencode', pincode: '695584' },
  { value: 'thalakulam', label: 'Thalakulam', pincode: '695305' },
  { value: 'vakkom', label: 'Vakkom', pincode: '695308' },
  { value: 'vakkam', label: 'Vakkam', pincode: '695308' },
  { value: 'vanchiyoor', label: 'Vanchiyoor', pincode: '695035' },
  { value: 'velavoor', label: 'Velavoor', pincode: '695102' },
  ],

  'beypore': [
  { value: 'alathiyur', label: 'Alathiyur', pincode: '673314' },
  { value: 'arakkal', label: 'Arakkal', pincode: '673614' },
  { value: 'beypore-town', label: 'Beypore Town', pincode: '673015' },
  { value: 'chemmad', label: 'Chemmad', pincode: '673620' },
  { value: 'chungam', label: 'Chungam', pincode: '673614' },
  { value: 'kakkodi', label: 'Kakkodi', pincode: '673611' },
  { value: 'kallayi', label: 'Kallayi', pincode: '673003' },
  { value: 'kottuli', label: 'Kottuli', pincode: '673016' },
  { value: 'kurikkil', label: 'Kurikkil', pincode: '673520' },
  { value: 'mavoor', label: 'Mavoor', pincode: '673661' },
  { value: 'meenchantha', label: 'Meenchantha', pincode: '673016' },
  { value: 'parappanangadi', label: 'Parappanangadi', pincode: '673625' },
  { value: 'perambra', label: 'Perambra', pincode: '673525' },
  { value: 'puduppady', label: 'Puduppady', pincode: '673524' },
  { value: 'tazhekkod', label: 'Tazhekkod', pincode: '673017' }
  ],

  'chavakkad': [
  { value: 'aloor', label: 'Aloor', pincode: '680541' },
  { value: 'chavakkad-town', label: 'Chavakkad Town', pincode: '680506' },
  { value: 'cheloor', label: 'Cheloor', pincode: '680509' },
  { value: 'edathirinji', label: 'Edathirinji', pincode: '680512' },
  { value: 'irinjalkuda', label: 'Irinjalakuda', pincode: '680125' },
  { value: 'kalady', label: 'Kalady', pincode: '680616' },
  { value: 'kottappuram', label: 'Kottappuram', pincode: '680505' },
  { value: 'manathala', label: 'Manathala', pincode: '680512' },
  { value: 'mathilakam', label: 'Mathilakam', pincode: '680685' },
  { value: 'mulamkunnu', label: 'Mulamkunnu', pincode: '680687' },
  { value: 'niranampuram', label: 'Niranampuram', pincode: '680506' },
  { value: 'pallikkunnu', label: 'Pallikkunnu', pincode: '680505' },
  { value: 'vadakkanchery', label: 'Vadakkanchery', pincode: '680582' },
  { value: 'varavoor', label: 'Varavoor', pincode: '680584' },
  { value: 'vengaloor', label: 'Vengaloor', pincode: '680507' },
  { value: 'vellikulangara', label: 'Vellikulangara', pincode: '680682' },
  { value: 'wadakanchery', label: 'Wadakanchery', pincode: '680591' }
  ],

  'kalamassery': [
  { value: 'aluva', label: 'Aluva', pincode: '683101' },
  { value: 'kadavanthra', label: 'Kadavanthra', pincode: '682020' },
  { value: 'kalamassery-town', label: 'Kalamassery Town', pincode: '683104' },
  { value: 'kaithappuzha', label: 'Kaithappuzha', pincode: '683103' },
  { value: 'karingachira', label: 'Karingachira', pincode: '683577' },
  { value: 'north-kalamassery', label: 'North Kalamassery', pincode: '683104' },
  { value: 'pukkattupady', label: 'Pukkattupady', pincode: '683561' },
  { value: 'sapthapadi', label: 'Sapthapadi', pincode: '683564' },
  { value: 'south-kalamassery', label: 'South Kalamassery', pincode: '683104' },
  { value: 'thrikkakara', label: 'Thrikkakara', pincode: '682021' },
  { value: 'vadacode', label: 'Vadacode', pincode: '683104' },
  { value: 'vazhakkala', label: 'Vazhakkala', pincode: '683572' },
  { value: 'angamaly', label: 'Angamaly', pincode: '683572' },
  { value: 'elamakkara', label: 'Elamakkara', pincode: '682026' },
  { value: 'irumpanam', label: 'Irumpanam', pincode: '682309' },
  { value: 'mariyapuram', label: 'Mariyapuram', pincode: '683563' },
  { value: 'mulavukad', label: 'Mulavukad', pincode: '682504' },
  { value: 'perumbavoor', label: 'Perumbavoor', pincode: '683542' },
  { value: 'pudukkad', label: 'Pudukkad', pincode: '683562' },
  { value: 'punnappra', label: 'Punnappra', pincode: '683576' }
  ],

  'kattappana': [
  { value: 'adimaly', label: 'Adimaly', pincode: '685561' },
  { value: 'chennimala', label: 'Chennimala', pincode: '685508' },
  { value: 'kattappana-town', label: 'Kattappana Town', pincode: '685508' },
  { value: 'kizhakkummuri', label: 'Kizhakkummuri', pincode: '685509' },
  { value: 'meenvallom', label: 'Meenvallom', pincode: '685589' },
  { value: 'murikkassery', label: 'Murikkassery', pincode: '685590' },
  { value: 'nedumkandam', label: 'Nedumkandam', pincode: '685553' },
  { value: 'peerumedu', label: 'Peerumedu', pincode: '685531' },
  { value: 'pothanikkad', label: 'Pothanikkad', pincode: '685507' },
  { value: 'ravinadu', label: 'Ravinadu', pincode: '685509' },
  { value: 'sabarimala', label: 'Sabarimala', pincode: '689713' },
  { value: 'vandanmedu', label: 'Vandanmedu', pincode: '685551' },
  { value: 'kanjirappally', label: 'Kanjirappally', pincode: '686507' },
  { value: 'kaipattoor', label: 'Kaipattoor', pincode: '685603' },
  { value: 'kudayathur', label: 'Kudayathur', pincode: '685530' },
  { value: 'muttakunnu', label: 'Muttakunnu', pincode: '685533' },
  { value: 'panchalimedu', label: 'Panchalimedu', pincode: '685553' },
  { value: 'pattikkad', label: 'Pattikkad', pincode: '685521' },
  { value: 'vattavada', label: 'Vattavada', pincode: '685611' }
  ],

  'kottakkal': [
  { value: 'cherukunnu', label: 'Cherukunnu', pincode: '676508' },
  { value: 'kalanadu', label: 'Kalanadu', pincode: '676503' },
  { value: 'kottakkal-town', label: 'Kottakkal Town', pincode: '676503' },
  { value: 'kottapadi', label: 'Kottapadi', pincode: '676506' },
  { value: 'kuttikkad', label: 'Kuttikkad', pincode: '676303' },
  { value: 'manjeri', label: 'Manjeri', pincode: '676121' },
  { value: 'muvattupuzha', label: 'Muvattupuzha', pincode: '676612' },
  { value: 'pangode', label: 'Pangode', pincode: '676307' },
  { value: 'pudukkad', label: 'Pudukkad', pincode: '676309' },
  { value: 'thirunavaya', label: 'Thirunavaya', pincode: '676301' },
  { value: 'tirur', label: 'Tirur', pincode: '676101' },
  { value: 'ala', label: 'Ala', pincode: '676311' },
  { value: 'elankur', label: 'Elankur', pincode: '676312' },
  { value: 'kalpeta', label: 'Kalpeta', pincode: '676315' },
  { value: 'kizhakkummuri', label: 'Kizhakkummuri', pincode: '676314' },
  { value: 'perintalmanna', label: 'Perintalmanna', pincode: '676122' },
  { value: 'randathani', label: 'Randathani', pincode: '676130' },
  { value: 'sreenarayana', label: 'Sreenarayana', pincode: '676323' }
  ],

  'mananthavady': [
  { value: 'andoor', label: 'Andoor', pincode: '670645' },
  { value: 'arippa', label: 'Arippa', pincode: '670649' },
  { value: 'chundale', label: 'Chundale', pincode: '673123' },
  { value: 'mananthavady-town', label: 'Mananthavady Town', pincode: '670645' },
  { value: 'muthanga', label: 'Muthanga', pincode: '670644' },
  { value: 'panamaram', label: 'Panamaram', pincode: '670651' },
  { value: 'pulpally', label: 'Pulpally', pincode: '670651' },
  { value: 'sultan-bathery', label: 'Sultan Bathery', pincode: '673592' },
  { value: 'vythiri', label: 'Vythiri', pincode: '673576' },
  { value: 'bathery', label: 'Bathery', pincode: '673592' },
  { value: 'edavaka', label: 'Edavaka', pincode: '673576' },
  { value: 'karapuzha', label: 'Karapuzha', pincode: '673121' },
  { value: 'kuttiyadi', label: 'Kuttiyadi', pincode: '673123' },
  { value: 'kunnummal', label: 'Kunnummal', pincode: '673122' },
  { value: 'tharuvana', label: 'Tharuvana', pincode: '673124' }
  ],

  'manjeshwaram': [
  { value: 'adkathbail', label: 'Adkathbail', pincode: '671323' },
  { value: 'kottancheri', label: 'Kottancheri', pincode: '671323' },
  { value: 'manjeshwar', label: 'Manjeshwar', pincode: '671323' },
  { value: 'manjeshwaram-town', label: 'Manjeshwaram Town', pincode: '671323' },
  { value: 'muttathadka', label: 'Muttathadka', pincode: '671327' },
  { value: 'palayam', label: 'Palayam', pincode: '671327' },
  { value: 'payyannur', label: 'Payyannur', pincode: '671320' },
  { value: 'poovallur', label: 'Poovallur', pincode: '671326' },
  { value: 'valiyaparamba', label: 'Valiyaparamba', pincode: '671327' },
  { value: 'edayannur', label: 'Edayannur', pincode: '671328' },
  { value: 'thrikaripur', label: 'Thrikaripur', pincode: '671310' },
  { value: 'koyyode', label: 'Koyyode', pincode: '671319' },
  { value: 'chokli', label: 'Chokli', pincode: '671313' },
  { value: 'kalambram', label: 'Kalambram', pincode: '671312' },
  { value: 'velleri', label: 'Velleri', pincode: '671324' }
  ],

  'maradu': [
  { value: 'edappally', label: 'Edappally', pincode: '682024' },
  { value: 'kakkanad', label: 'Kakkanad', pincode: '682030' },
  { value: 'maradu-town', label: 'Maradu Town', pincode: '682304' },
  { value: 'north-maradu', label: 'North Maradu', pincode: '682304' },
  { value: 'south-maradu', label: 'South Maradu', pincode: '682304' },
  { value: 'thripunithura', label: 'Thripunithura', pincode: '682301' },
  { value: 'vaduthala', label: 'Vaduthala', pincode: '682023' },
  { value: 'vypin', label: 'Vypin', pincode: '682508' },
  { value: 'pukkattupady', label: 'Pukkattupady', pincode: '682508' },
  { value: 'kumarapuram', label: 'Kumarapuram', pincode: '682506' },
  { value: 'chottanikkara', label: 'Chottanikkara', pincode: '682312' },
  { value: 'ponnurunni', label: 'Ponnurunni', pincode: '682025' },
  { value: 'perumbavoor', label: 'Perumbavoor', pincode: '683542' },
  { value: 'manjummel', label: 'Manjummel', pincode: '682305' },
  { value: 'mulavukad', label: 'Mulavukad', pincode: '682504' }
  ],

  'mattanur': [
  { value: 'kannur', label: 'Kannur', pincode: '670001' },
  { value: 'koothuparamba', label: 'Koothuparamba', pincode: '670586' },
  { value: 'mattanur-town', label: 'Mattanur Town', pincode: '670702' },
  { value: 'mattannur', label: 'Mattannur', pincode: '670702' },
  { value: 'peravoor', label: 'Peravoor', pincode: '670673' },
  { value: 'panoor', label: 'Panoor', pincode: '670692' },
  { value: 'payangadi', label: 'Payangadi', pincode: '670303' },
  { value: 'thillankeri', label: 'Thillankeri', pincode: '670621' },
  { value: 'thayyil', label: 'Thayyil', pincode: '670609' },
  { value: 'unniyur', label: 'Unniyur', pincode: '670308' },
  { value: 'alavil', label: 'Alavil', pincode: '670601' },
  { value: 'azhiyur', label: 'Azhiyur', pincode: '670601' },
  { value: 'battamattom', label: 'Battamattom', pincode: '670613' },
  { value: 'irikkur', label: 'Irikkur', pincode: '670703' },
  { value: 'kuthuparamba', label: 'Kuthuparamba', pincode: '670602' },
  { value: 'moorkhanadu', label: 'Moorkhanadu', pincode: '670625' },
  { value: 'piravom', label: 'Piravom', pincode: '670611' },
  { value: 'puduppa', label: 'Puduppa', pincode: '670644' }
  ],

  'nedumangad': [
  { value: 'nedumangad-town', label: 'Nedumangad Town', pincode: '695541' },
  { value: 'karimkulam', label: 'Karimkulam', pincode: '695566' },
  { value: 'kizhakkummuri', label: 'Kizhakkummuri', pincode: '695561' },
  { value: 'perumkulam', label: 'Perumkulam', pincode: '695563' },
  { value: 'sreekariyam', label: 'Sreekariyam', pincode: '695011' },
  { value: 'thirumala', label: 'Thirumala', pincode: '695006' },
  { value: 'pothencode', label: 'Pothencode', pincode: '695584' },
  { value: 'vallakkadavu', label: 'Vallakkadavu', pincode: '695541' },
  { value: 'vizhinjam', label: 'Vizhinjam', pincode: '695521' },
  { value: 'vembayam', label: 'Vembayam', pincode: '695615' },
  { value: 'chemmaruthy', label: 'Chemmaruthy', pincode: '695550' },
  { value: 'koliyankode', label: 'Koliyankode', pincode: '695614' },
  { value: 'kurisummoodu', label: 'Kurisummoodu', pincode: '695541' },
  { value: 'poovachal', label: 'Poovachal', pincode: '695574' },
  { value: 'puliyarakonam', label: 'Puliyarakonam', pincode: '695574' },
  { value: 'thiruvallam', label: 'Thiruvallam', pincode: '695027' },
  { value: 'vazhimukku', label: 'Vazhimukku', pincode: '695573' }
  ],

  'nileshwaram': [
  { value: 'chokkakkad', label: 'Chokkakkad', pincode: '671314' },
  { value: 'kavvayi', label: 'Kavvayi', pincode: '671314' },
  { value: 'kuttikol', label: 'Kuttikol', pincode: '671314' },
  { value: 'mannambalam', label: 'Mannambalam', pincode: '671314' },
  { value: 'nileshwar-town', label: 'Nileshwar Town', pincode: '671314' },
  { value: 'poovannam', label: 'Poovannam', pincode: '671314' },
  { value: 'punnappra', label: 'Punnappra', pincode: '671314' },
  { value: 'sreekariyam', label: 'Sreekariyam', pincode: '695011' },
  { value: 'thottathil', label: 'Thottathil', pincode: '671314' },
  { value: 'valapattanam', label: 'Valapattanam', pincode: '671312' },
  { value: 'nelluvelly', label: 'Nelluvelly', pincode: '671314' },
  { value: 'pallikere', label: 'Pallikere', pincode: '671314' },
  { value: 'parappuram', label: 'Parappuram', pincode: '671314' },
  { value: 'peruvallur', label: 'Peruvallur', pincode: '671314' },
  { value: 'sultan-bathery', label: 'Sultan Bathery', pincode: '671322' },
  { value: 'thayikunnu', label: 'Thayikunnu', pincode: '671314' }
  ],

  'pandalam': [
  { value: 'anjilimoottil', label: 'Anjilimoottil', pincode: '689501' },
  { value: 'kaipattoor', label: 'Kaipattoor', pincode: '689506' },
  { value: 'kuttanadu', label: 'Kuttanadu', pincode: '689501' },
  { value: 'muttar', label: 'Muttar', pincode: '689505' },
  { value: 'pandalam-town', label: 'Pandalam Town', pincode: '689501' },
  { value: 'ponjassery', label: 'Ponjassery', pincode: '689508' },
  { value: 'purakkad', label: 'Purakkad', pincode: '689507' },
  { value: 'thiruvalla', label: 'Thiruvalla', pincode: '689101' },
  { value: 'vettikkavala', label: 'Vettikkavala', pincode: '689501' },
  { value: 'elavumthitta', label: 'Elavumthitta', pincode: '689621' },
  { value: 'muvattupuzha', label: 'Muvattupuzha', pincode: '686661' },
  { value: 'kallettumkara', label: 'Kallettumkara', pincode: '689547' },
  { value: 'vazhoor', label: 'Vazhoor', pincode: '689504' },
  { value: 'kumaranalloor', label: 'Kumaranalloor', pincode: '689506' },
  { value: 'maramon', label: 'Maramon', pincode: '689549' },
  { value: 'punnappra', label: 'Punnappra', pincode: '689527' },
  { value: 'chakittappara', label: 'Chakittappara', pincode: '689538' }
  ],

  'paravur': [
  { value: 'alappad', label: 'Alappad', pincode: '691507' },
  { value: 'chemmaruthy', label: 'Chemmaruthy', pincode: '691301' },
  { value: 'chinnakkada', label: 'Chinnakkada', pincode: '691001' },
  { value: 'kallettumkara', label: 'Kallettumkara', pincode: '691301' },
  { value: 'karunagappally', label: 'Karunagappally', pincode: '690518' },
  { value: 'kollam', label: 'Kollam', pincode: '691001' },
  { value: 'manalur', label: 'Manalur', pincode: '691509' },
  { value: 'paravur-town', label: 'Paravur Town', pincode: '691301' },
  { value: 'perumpuzha', label: 'Perumpuzha', pincode: '691504' },
  { value: 'puliyarakonam', label: 'Puliyarakonam', pincode: '691501' },
  { value: 'sreebhadra', label: 'Sreebhadra', pincode: '691507' },
  { value: 'thiruvalla', label: 'Thiruvalla', pincode: '689101' },
  { value: 'valathode', label: 'Valathode', pincode: '691507' },
  { value: 'vellimon', label: 'Vellimon', pincode: '691302' },
  { value: 'vellikulangara', label: 'Vellikulangara', pincode: '691507' }
  ],

  'perinthalmanna': [
  { value: 'alathur', label: 'Alathur', pincode: '679531' },
  { value: 'chemmad', label: 'Chemmad', pincode: '679333' },
  { value: 'kondotty', label: 'Kondotty', pincode: '673638' },
  { value: 'kottakkal', label: 'Kottakkal', pincode: '676503' },
  { value: 'muthuvallur', label: 'Muthuvallur', pincode: '679331' },
  { value: 'parappur', label: 'Parappur', pincode: '679337' },
  { value: 'perinthalmanna-town', label: 'Perinthalmanna Town', pincode: '679322' },
  { value: 'pulikkal', label: 'Pulikkal', pincode: '679533' },
  { value: 'thottumugham', label: 'Thottumugham', pincode: '679333' },
  { value: 'valanchery', label: 'Valanchery', pincode: '679573' },
  { value: 'annanadu', label: 'Annanadu', pincode: '679326' },
  { value: 'chokkad', label: 'Chokkad', pincode: '679325' },
  { value: 'edavanna', label: 'Edavanna', pincode: '679121' },
  { value: 'kizhissery', label: 'Kizhissery', pincode: '679336' },
  { value: 'pookkottur', label: 'Pookkottur', pincode: '679321' },
  { value: 'pulpatta', label: 'Pulpatta', pincode: '679301' },
  { value: 'valiyaparamba', label: 'Valiyaparamba', pincode: '679302' },
  { value: 'vettikkal', label: 'Vettikkal', pincode: '679333' }
  ],

  'quilon': [
  { value: 'alumoodu', label: 'Alumoodu', pincode: '691501' },
  { value: 'chavara', label: 'Chavara', pincode: '691583' },
  { value: 'chinnakkada', label: 'Chinnakkada', pincode: '691001' },
  { value: 'iravipuram', label: 'Iravipuram', pincode: '691314' },
  { value: 'kollam-town', label: 'Kollam Town', pincode: '691001' },
  { value: 'kundara', label: 'Kundara', pincode: '691501' },
  { value: 'perinad', label: 'Perinad', pincode: '691511' },
  { value: 'punnappra', label: 'Punnappra', pincode: '691506' },
  { value: 'quilon-beach', label: 'Quilon Beach', pincode: '691001' },
  { value: 'sarapaka', label: 'Sarapaka', pincode: '691511' },
  { value: 'thirumullavaram', label: 'Thirumullavaram', pincode: '691012' },
  { value: 'varkala', label: 'Varkala', pincode: '695141' },
  { value: 'veliyanad', label: 'Veliyanad', pincode: '691531' },
  { value: 'zernai', label: 'Zernai', pincode: '691542' },
  { value: 'achunadu', label: 'Achunadu', pincode: '691312' },
  { value: 'chittumala', label: 'Chittumala', pincode: '691307' },
  { value: 'kayani', label: 'Kayani', pincode: '691503' },
  { value: 'kottankulangara', label: 'Kottankulangara', pincode: '691506' },
  { value: 'naranathu', label: 'Naranathu', pincode: '691303' },
  { value: 'pangode', label: 'Pangode', pincode: '691532' },
  { value: 'perumkulam', label: 'Perumkulam', pincode: '691314' },
  { value: 'punnappra-village', label: 'Punnappra Village', pincode: '691507' }
  ],

  'ramanattukara': [
  { value: 'alathiyur', label: 'Alathiyur', pincode: '673633' },
  { value: 'elathur', label: 'Elathur', pincode: '673303' },
  { value: 'kuttikkad', label: 'Kuttikkad', pincode: '673634' },
  { value: 'madavoor', label: 'Madavoor', pincode: '673603' },
  { value: 'manassery', label: 'Manassery', pincode: '673633' },
  { value: 'parappuram', label: 'Parappuram', pincode: '673634' },
  { value: 'ramanattukara-town', label: 'Ramanattukara Town', pincode: '673633' },
  { value: 'thazhekkode', label: 'Thazhekkode', pincode: '673633' },
  { value: 'thiruthiyad', label: 'Thiruthiyad', pincode: '673604' },
  { value: 'vengalam', label: 'Vengalam', pincode: '673303' },
  { value: 'chemmad', label: 'Chemmad', pincode: '673634' },
  { value: 'elamkulam', label: 'Elamkulam', pincode: '673602' },
  { value: 'kakkodi', label: 'Kakkodi', pincode: '673611' },
  { value: 'kanjirath', label: 'Kanjirath', pincode: '673602' },
  { value: 'meppayur', label: 'Meppayur', pincode: '673524' },
  { value: 'puliyoor', label: 'Puliyoor', pincode: '673633' },
  { value: 'ramanattukara-bazar', label: 'Ramanattukara Bazar', pincode: '673633' },
  { value: 'thiruvachur', label: 'Thiruvachur', pincode: '673302' }
  ],

  'uppala': [
  { value: 'cheruvathur', label: 'Cheruvathur', pincode: '671314' },
  { value: 'kodimbala', label: 'Kodimbala', pincode: '671318' },
  { value: 'kuttikol', label: 'Kuttikol', pincode: '671317' },
  { value: 'mandapatta', label: 'Mandapatta', pincode: '671319' },
  { value: 'marappalam', label: 'Marappalam', pincode: '671318' },
  { value: 'muttom', label: 'Muttom', pincode: '671316' },
  { value: 'panathur', label: 'Panathur', pincode: '671321' },
  { value: 'pallikkara', label: 'Pallikkara', pincode: '671319' },
  { value: 'uppala-town', label: 'Uppala Town', pincode: '671318' },
  { value: 'vengad', label: 'Vengad', pincode: '671317' },
  { value: 'thokkil', label: 'Thokkil', pincode: '671315' },
  { value: 'veliyamkundu', label: 'Veliyamkundu', pincode: '671314' },
  { value: 'parappuram', label: 'Parappuram', pincode: '671312' }
  ],

  'kottayam': [
    { value: 'adichira', label: 'Adichira', pincode: '686507' },
    { value: 'alapra', label: 'Alapra', pincode: '686571' },
    { value: 'ammanchery', label: 'Ammanchery', pincode: '686536' },
    { value: 'arpookkara', label: 'Arpookkara', pincode: '686008' },
    { value: 'athirampuzha', label: 'Athirampuzha', pincode: '686562' },
    { value: 'ayarkunnam', label: 'Ayarkunnam', pincode: '686564' },
    { value: 'aymanam', label: 'Aymanam', pincode: '686015' },
    { value: 'baker-hill', label: 'Baker Hill', pincode: '686001' },
    { value: 'bharananganam', label: 'Bharananganam', pincode: '686578' },
    { value: 'carithas', label: 'Carithas', pincode: '686578' },
    { value: 'chalukunnu', label: 'Chalukunnu', pincode: '686551' },
    { value: 'changanacherry', label: 'Changanacherry', pincode: '686101' },
    { value: 'cherppunkal', label: 'Cherppunkal', pincode: '686104' },
    { value: 'cheruvally', label: 'Cheruvally', pincode: '686572' },
    { value: 'chingavanam', label: 'Chingavanam', pincode: '686531' },
    { value: 'chirappalam', label: 'Chirappalam', pincode: '686612' },
    { value: 'chungam', label: 'Chungam', pincode: '686563' },
    { value: 'collectorate', label: 'Collectorate', pincode: '686002' },
    { value: 'devalokam-road', label: 'Devalokam Road', pincode: '686592' },
    { value: 'edakadathy', label: 'Edakadathy', pincode: '686543' },
    { value: 'eerayil-kadavu', label: 'Eerayil Kadavu', pincode: '686602' },
    { value: 'elampally', label: 'Elampally', pincode: '686510' },
    { value: 'eranjal-road', label: 'Eranjal Road', pincode: '686610' },
    { value: 'erattupetta', label: 'Erattupetta', pincode: '686121' },
    { value: 'eravinalloor', label: 'Eravinalloor', pincode: '686574' },
    { value: 'errumanoor', label: 'Errumanoor', pincode: '686604' },
    { value: 'erumeli', label: 'Erumeli', pincode: '686509' },
    { value: 'ettumanoor', label: 'Ettumanoor', pincode: '686631' },
    { value: 'gandhinagar', label: 'Gandhinagar', pincode: '686014' },
    { value: 'illikkal', label: 'Illikkal', pincode: '686577' },
    { value: 'indira-nagar', label: 'Indira Nagar', pincode: '686004' },
    { value: 'k-k-road', label: 'K K Road', pincode: '686001' },
    { value: 'kaduthuruthy', label: 'Kaduthuruthy', pincode: '686604' },
    { value: 'kalathipady', label: 'Kalathipady', pincode: '686010' },
    { value: 'kalathoor', label: 'Kalathoor', pincode: '686585' },
    { value: 'kangazha', label: 'Kangazha', pincode: '686555' },
    { value: 'kanjikuzhi', label: 'Kanjikuzhi', pincode: '686553' },
    { value: 'kanjirappally', label: 'Kanjirappally', pincode: '686507' },
    { value: 'karapuzha', label: 'Karapuzha', pincode: '686510' },
    { value: 'karukachal', label: 'Karukachal', pincode: '686546' },
    { value: 'kidangoor', label: 'Kidangoor', pincode: '686602' },
    { value: 'kodimatha', label: 'Kodimatha', pincode: '686016' },
    { value: 'kodungoor', label: 'Kodungoor', pincode: '686578' },
    { value: 'kollad', label: 'Kollad', pincode: '686610' },
    { value: 'kooroppada', label: 'Kooroppada', pincode: '686574' },
    { value: 'koovappally', label: 'Koovappally', pincode: '686518' },
    { value: 'kozhuvanal', label: 'Kozhuvanal', pincode: '686601' },
    { value: 'kudamaloor', label: 'Kudamaloor', pincode: '686504' },
    { value: 'kumarakom', label: 'Kumarakom', pincode: '686563' },
    { value: 'kumaranalloor', label: 'Kumaranalloor', pincode: '686015' },
    { value: 'kummanan', label: 'Kummanan', pincode: '686531' },
    { value: 'kuravilangad', label: 'Kuravilangad', pincode: '686633' },
    { value: 'kurichithanam', label: 'Kurichithanam', pincode: '686542' },
    { value: 'kurichy', label: 'Kurichy', pincode: '686533' },
    { value: 'kurishupally', label: 'Kurishupally', pincode: '686552' },
    { value: 'kurumannu', label: 'Kurumannu', pincode: '686529' },
    { value: 'lakkattoor', label: 'Lakkattoor', pincode: '686588' },
    { value: 'manarcadu', label: 'Manarcadu', pincode: '686026' },
    { value: 'manganam', label: 'Manganam', pincode: '686018' },
    { value: 'manimala', label: 'Manimala', pincode: '686586' },
    { value: 'manjoor', label: 'Manjoor', pincode: '686520' },
    { value: 'mannanam', label: 'Mannanam', pincode: '686561' },
    { value: 'market-road', label: 'Market Road', pincode: '686001' },
    { value: 'mc-road', label: 'MC Road', pincode: '686004' },
    { value: 'meenadom', label: 'Meenadom', pincode: '686609' },
    { value: 'memuri', label: 'Memuri', pincode: '686603' },
    { value: 'moolavattom', label: 'Moolavattom', pincode: '686583' },
    { value: 'mukkoottuthara', label: 'Mukkoottuthara', pincode: '686603' },
    { value: 'mundakayam', label: 'Mundakayam', pincode: '686513' },
    { value: 'muttuchira', label: 'Muttuchira', pincode: '686612' },
    { value: 'nagambadam', label: 'Nagambadam', pincode: '686006' },
    { value: 'nattakom', label: 'Nattakom', pincode: '686542' },
    { value: 'nattassery-east', label: 'Nattassery East', pincode: '686607' },
    { value: 'nedumkunnam', label: 'Nedumkunnam', pincode: '686551' },
    { value: 'olassa', label: 'Olassa', pincode: '686506' },
    { value: 'pala', label: 'Pala', pincode: '686575' },
    { value: 'pallickathodu', label: 'Pallickathodu', pincode: '686632' },
    { value: 'pallom', label: 'Pallom', pincode: '686573' },
    { value: 'pampady', label: 'Pampady', pincode: '686502' },
    { value: 'parampuzha', label: 'Parampuzha', pincode: '686555' },
    { value: 'parippu', label: 'Parippu', pincode: '686602' },
    { value: 'peroorkada', label: 'Peroorkada', pincode: '686575' },
    { value: 'peruva', label: 'Peruva', pincode: '686607' },
    { value: 'ponkunnam', label: 'Ponkunnam', pincode: '686506' },
    { value: 'poonjar', label: 'Poonjar', pincode: '686503' },
    { value: 'poovanthuruthu', label: 'Poovanthuruthu', pincode: '686621' },
    { value: 'punnathura-east', label: 'Punnathura East', pincode: '686503' },
    { value: 'puthanangady', label: 'Puthanangady', pincode: '686542' },
    { value: 'puthenangady', label: 'Puthenangady', pincode: '686521' },
    { value: 'puthuppally', label: 'Puthuppally', pincode: '686001' },
    { value: 'ramapuram', label: 'Ramapuram', pincode: '686576' },
    { value: 's-h-mount', label: 'S H Mount', pincode: '686610' },
    { value: 'sankranthi', label: 'Sankranthi', pincode: '686522' },
    { value: 'shastri-road', label: 'Shastri Road', pincode: '686001' },
    { value: 'tb-road', label: 'TB Road', pincode: '686001' },
    { value: 'teekoy', label: 'Teekoy', pincode: '686580' },
    { value: 'temple-road', label: 'Temple Road', pincode: '686607' },
    { value: 'thalayolaparambu', label: 'Thalayolaparambu', pincode: '686605' },
    { value: 'thellakom', label: 'Thellakom', pincode: '686586' },
    { value: 'thiruvalla', label: 'Thiruvalla', pincode: '689101' },
    { value: 'thiruvanchoor', label: 'Thiruvanchoor', pincode: '686609' },
    { value: 'vadavathoor', label: 'Vadavathoor', pincode: '686010' },
    { value: 'vagamon', label: 'Vagamon', pincode: '686503' },
    { value: 'vaikom', label: 'Vaikom', pincode: '686141' },
    { value: 'vakathanam', label: 'Vakathanam', pincode: '686523' },
    { value: 'varissery', label: 'Varissery', pincode: '686574' },
    { value: 'vazhoor', label: 'Vazhoor', pincode: '686532' },
    { value: 'vechoor', label: 'Vechoor', pincode: '686573' },
    { value: 'veliyannoor', label: 'Veliyannoor', pincode: '686509' },
    { value: 'velluthuruthy', label: 'Velluthuruthy', pincode: '686602' },
    { value: 'veloor', label: 'Veloor', pincode: '686601' },
    { value: 'vembanad-lake', label: 'Vembanad Lake', pincode: '686550' },
    { value: 'vennikulam', label: 'Vennikulam', pincode: '686507' }
  ],
  'palakkad': [
    { value: 'alathur', label: 'Alathur', pincode: '678541' },
    { value: 'alathur-east', label: 'Alathur East', pincode: '678531' },
    { value: 'asokapuram', label: 'Asokapuram', pincode: '678003' },
    { value: 'balussery', label: 'Balussery', pincode: '678508' },
    { value: 'chandranagar', label: 'Chandranagar', pincode: '678007' },
    { value: 'cherpulassery', label: 'Cherpulassery', pincode: '678601' },
    { value: 'cherukara', label: 'Cherukara', pincode: '678597' },
    { value: 'elavanchery', label: 'Elavanchery', pincode: '678533' },
    { value: 'irinjalkuda', label: 'Irinjalakuda', pincode: '678693' },
    { value: 'iruttukode', label: 'Iruttukode', pincode: '678731' },
    { value: 'kallekulangara', label: 'Kallekulangara', pincode: '678001' },
    { value: 'kallepully', label: 'Kallepully', pincode: '678505' },
    { value: 'kalpathy', label: 'Kalpathy', pincode: '678003' },
    { value: 'karimpuzha', label: 'Karimpuzha', pincode: '678592' },
    { value: 'koduvayur', label: 'Koduvayur', pincode: '678551' },
    { value: 'koppam', label: 'Koppam', pincode: '678001' },
    { value: 'kulappully', label: 'Kulappully', pincode: '678012' },
    { value: 'kunissery', label: 'Kunissery', pincode: '678527' },
    { value: 'mankara', label: 'Mankara', pincode: '678593' },
    { value: 'mannarkkad', label: 'Mannarkkad', pincode: '678507' },
    { value: 'mezhathur', label: 'Mezhathur', pincode: '678541' },
    { value: 'mundur', label: 'Mundur', pincode: '678592' },
    { value: 'nallepilly', label: 'Nallepilly', pincode: '678001' },
    { value: 'odayan', label: 'Odayan', pincode: '678004' },
    { value: 'palakkad', label: 'Palakkad', pincode: '678001' },
    { value: 'palakkad-1', label: 'Palakkad-1', pincode: '678020' },
    { value: 'palakkad-2', label: 'Palakkad-2', pincode: '678010' },
    { value: 'palakkad-town', label: 'Palakkad Town', pincode: '678001' },
    { value: 'parli', label: 'Parli', pincode: '678615' },
    { value: 'pattambi', label: 'Pattambi', pincode: '679303' },
    { value: 'perur', label: 'Perur', pincode: '678515' },
    { value: 'puliyampadam', label: 'Puliyampadam', pincode: '678582' },
    { value: 'sanal', label: 'Sanal', pincode: '678600' },
    { value: 'sreekrishnapuram', label: 'Sreekrishnapuram', pincode: '678633' },
    { value: 'tattamangalam', label: 'Tattamangalam', pincode: '678581' },
    { value: 'thrithala', label: 'Thrithala', pincode: '678612' },
    { value: 'vadakkenchery', label: 'Vadakkenchery', pincode: '678683' },
    { value: 'vadakkenchery-east', label: 'Vadakkenchery East', pincode: '678673' },
    { value: 'valappad', label: 'Valappad', pincode: '678623' },
    { value: 'valayar', label: 'Valayar', pincode: '678607' },
    { value: 'vazhikkadavu', label: 'Vazhikkadavu', pincode: '678553' },
    { value: 'vengallur', label: 'Vengallur', pincode: '678621' }
  ],

  'trivendrum': [
    { value: 'aakkulam', label: 'Aakkulam', pincode: '695002' },
    { value: 'alamcode', label: 'Alamcode', pincode: '695102' },
    { value: 'ambalam-jn', label: 'Ambalam Jn.', pincode: '695541' },
    { value: 'ambalamukku', label: 'Ambalamukku', pincode: '695017' },
    { value: 'ambalathara', label: 'Ambalathara', pincode: '695501' },
    { value: 'anayara', label: 'Anayara', pincode: '695029' },
    { value: 'arappuramukku', label: 'Arappuramukku', pincode: '695512' },
    { value: 'arasumoodu', label: 'Arasumoodu', pincode: '695611' },
    { value: 'attingal', label: 'Attingal', pincode: '695101' },
    { value: 'azhoor', label: 'Azhoor', pincode: '695542' },
    { value: 'balaramapuram', label: 'Balaramapuram', pincode: '695501' },
    { value: 'bhakti-vilasom-road', label: 'Bhakti Vilasom Road', pincode: '695011' },
    { value: 'bypass-road', label: 'Bypass Road', pincode: '695014' },
    { value: 'chacka', label: 'Chacka', pincode: '695024' },
    { value: 'chalakkuzhi', label: 'Chalakkuzhi', pincode: '695509' },
    { value: 'chanthavila', label: 'Chanthavila', pincode: '695019' },
    { value: 'chemboor', label: 'Chemboor', pincode: '695014' },
    { value: 'chempazhanthy', label: 'Chempazhanthy', pincode: '695587' },
    { value: 'chenkottukonam', label: 'Chenkottukonam', pincode: '695006' },
    { value: 'chirayinkeezhu', label: 'Chirayinkeezhu', pincode: '695303' },
    { value: 'chullimanoor', label: 'Chullimanoor', pincode: '695602' },
    { value: 'eanchakkal', label: 'Eanchakkal', pincode: '695019' },
    { value: 'edapazhanji', label: 'Edapazhanji', pincode: '695014' },
    { value: 'enikkara', label: 'Enikkara', pincode: '695583' },
    { value: 'gandhipuram', label: 'Gandhipuram', pincode: '695027' },
    { value: 'golf-link-road', label: 'Golf Link Road', pincode: '695014' },
    { value: 'idapazhanji', label: 'Idapazhanji', pincode: '695584' },
    { value: 'irumpa', label: 'Irumpa', pincode: '695003' },
    { value: 'jagathy', label: 'Jagathy', pincode: '695014' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '695014' },
    { value: 'kachani', label: 'Kachani', pincode: '695027' },
    { value: 'kadinamkulam', label: 'Kadinamkulam', pincode: '695301' },
    { value: 'kaimanom', label: 'Kaimanom', pincode: '695126' },
    { value: 'kaithamukku', label: 'Kaithamukku', pincode: '695010' },
    { value: 'kalady', label: 'Kalady', pincode: '695601' },
    { value: 'kalamachal', label: 'Kalamachal', pincode: '695011' },
    { value: 'kallambalam', label: 'Kallambalam', pincode: '695607' },
    { value: 'kallampally', label: 'Kallampally', pincode: '695005' },
    { value: 'kallayam', label: 'Kallayam', pincode: '695007' },
    { value: 'kallikadu', label: 'Kallikadu', pincode: '695554' },
    { value: 'kamaleswaram', label: 'Kamaleswaram', pincode: '695009' },
    { value: 'kaniyapuram', label: 'Kaniyapuram', pincode: '695301' },
    { value: 'kanjirampara-junction', label: 'Kanjirampara Junction', pincode: '695541' },
    { value: 'kannammoola', label: 'Kannammoola', pincode: '695010' },
    { value: 'kanyakulangara', label: 'Kanyakulangara', pincode: '695503' },
    { value: 'karakulam', label: 'Karakulam', pincode: '695301' },
    { value: 'karamana', label: 'Karamana', pincode: '695002' },
    { value: 'karikkakam', label: 'Karikkakam', pincode: '695016' },
    { value: 'kariyam', label: 'Kariyam', pincode: '695501' },
    { value: 'karyavattom', label: 'Karyavattom', pincode: '695581' },
    { value: 'kattakada', label: 'Kattakada', pincode: '695572' },
    { value: 'kattananm', label: 'Kattananm', pincode: '695511' },
    { value: 'kawdiar', label: 'Kawdiar', pincode: '695003' },
    { value: 'kazhakkoottam', label: 'Kazhakkoottam', pincode: '695582' },
    { value: 'keezharoor', label: 'Keezharoor', pincode: '695573' },
    { value: 'kesavadasapuram', label: 'Kesavadasapuram', pincode: '695008' },
    { value: 'kilimanoor', label: 'Kilimanoor', pincode: '695601' },
    { value: 'killipalam', label: 'Killipalam', pincode: '695022' },
    { value: 'kochulloor-junction', label: 'Kochulloor Junction', pincode: '695003' },
    { value: 'kochuveli', label: 'Kochuveli', pincode: '695021' },
    { value: 'kollam', label: 'Kollam', pincode: '691001' },
    { value: 'kollamkavu', label: 'Kollamkavu', pincode: '695014' },
    { value: 'kolvalam-nh-bypass', label: 'Kolvalam NH Bypass', pincode: '695001' },
    { value: 'koottappana', label: 'Koottappana', pincode: '695503' },
    { value: 'koravankonam', label: 'Koravankonam', pincode: '695514' },
    { value: 'kovalam', label: 'Kovalam', pincode: '695527' },
    { value: 'kowdiar', label: 'Kowdiar', pincode: '695003' },
    { value: 'kudappanakunnu', label: 'Kudappanakunnu', pincode: '695005' },
    { value: 'kulasekharam', label: 'Kulasekharam', pincode: '695541' },
    { value: 'kulathoor', label: 'Kulathoor', pincode: '695507' },
    { value: 'kumarapuram', label: 'Kumarapuram', pincode: '695011' },
    { value: 'kundamankadavu-vattiyoorkavu-road', label: 'Kundamankadavu Vattiyoorkavu Road', pincode: '695543' },
    { value: 'kunnukuzhi', label: 'Kunnukuzhi', pincode: '695583' },
    { value: 'kunnumpuram', label: 'Kunnumpuram', pincode: '695544' },
    { value: 'kuravankonam', label: 'Kuravankonam', pincode: '695005' },
    { value: 'kuthukuzhi-rd', label: 'Kuthukuzhi Rd', pincode: '695301' },
    { value: 'kuttiyani', label: 'Kuttiyani', pincode: '695115' },
    { value: 'kuzhivila', label: 'Kuzhivila', pincode: '695512' },
    { value: 'law-college-jn', label: 'Law College Jn.', pincode: '695014' },
    { value: 'magalapuram-sasthavattom-road', label: 'Magalapuram - Sasthavattom Road', pincode: '695015' },
    { value: 'malayinkeezhu', label: 'Malayinkeezhu', pincode: '695315' },
    { value: 'manacaud', label: 'Manacaud', pincode: '695009' },
    { value: 'mangalapuram', label: 'Mangalapuram', pincode: '695020' },
    { value: 'mannanthala', label: 'Mannanthala', pincode: '695037' },
    { value: 'manvila', label: 'Manvila', pincode: '695015' },
    { value: 'marappalam', label: 'Marappalam', pincode: '695007' },
    { value: 'maruthoor', label: 'Maruthoor', pincode: '695514' },
    { value: 'maruthumkuzhi', label: 'Maruthumkuzhi', pincode: '695020' },
    { value: 'mc-road', label: 'MC Road', pincode: '695115' },
    { value: 'menamkulam', label: 'Menamkulam', pincode: '695003' },
    { value: 'mudavanmugal', label: 'Mudavanmugal', pincode: '695011' },
    { value: 'mukkola', label: 'Mukkola', pincode: '695004' },
    { value: 'museaum-jn', label: 'Museaum Jn', pincode: '695003' },
    { value: 'muttada', label: 'Muttada', pincode: '695004' },
    { value: 'muttathara', label: 'Muttathara', pincode: '695036' },
    { value: 'nalanchira', label: 'Nalanchira', pincode: '695036' },
    { value: 'nandavanam', label: 'Nandavanam', pincode: '695036' },
    { value: 'nanthancode', label: 'Nanthancode', pincode: '695003' },
    { value: 'navaikulam', label: 'Navaikulam', pincode: '695016' },
    { value: 'nedumangadu', label: 'Nedumangadu', pincode: '695561' },
    { value: 'neerazhi-lane', label: 'Neerazhi Lane', pincode: '695016' },
    { value: 'nemom', label: 'Nemom', pincode: '695020' },
    { value: 'nettayam', label: 'Nettayam', pincode: '695015' },
    { value: 'neyyattinkara', label: 'Neyyattinkara', pincode: '695121' },
    { value: 'njandoorkonam', label: 'Njandoorkonam', pincode: '695035' },
    { value: 'oottukuzhy', label: 'Oottukuzhy', pincode: '695535' },
    { value: 'palayam', label: 'Palayam', pincode: '695014' },
    { value: 'palkulangara', label: 'Palkulangara', pincode: '695021' },
    { value: 'pallickal', label: 'Pallickal', pincode: '695526' },
    { value: 'pallipuram', label: 'Pallipuram', pincode: '695314' },
    { value: 'palode', label: 'Palode', pincode: '695543' },
    { value: 'pangappara', label: 'Pangappara', pincode: '695536' },
    { value: 'pangodu', label: 'Pangodu', pincode: '695565' },
    { value: 'pappanamcode', label: 'Pappanamcode', pincode: '695043' },
    { value: 'parassala', label: 'Parassala', pincode: '695502' },
    { value: 'parottukonam', label: 'Parottukonam', pincode: '695031' },
    { value: 'paruthippara', label: 'Paruthippara', pincode: '695101' },
    { value: 'pattom', label: 'Pattom', pincode: '695004' },
    { value: 'pattoor', label: 'Pattoor', pincode: '695016' },
    { value: 'pazhavangadi', label: 'Pazhavangadi', pincode: '695014' },
    { value: 'peroorkada', label: 'Peroorkada', pincode: '695005' },
    { value: 'pettah', label: 'Pettah', pincode: '695022' },
    { value: 'peyad', label: 'Peyad', pincode: '695573' },
    { value: 'pmg', label: 'PMG', pincode: '695011' },
    { value: 'pongumodu', label: 'Pongumodu', pincode: '695027' },
    { value: 'poojapura', label: 'Poojapura', pincode: '695011' },
    { value: 'poonkulam', label: 'Poonkulam', pincode: '695004' },
    { value: 'pothencode', label: 'Pothencode', pincode: '695543' },
    { value: 'pottakkuzhi', label: 'Pottakkuzhi', pincode: '695019' },
    { value: 'powdikonam', label: 'Powdikonam', pincode: '695025' },
    { value: 'ptp-nagar', label: 'PTP Nagar', pincode: '695038' },
    { value: 'pulayanarkotta', label: 'Pulayanarkotta', pincode: '695010' },
    { value: 'pulimoodu', label: 'Pulimoodu', pincode: '695027' },
    { value: 'puliyarakonam', label: 'Puliyarakonam', pincode: '695015' },
    { value: 'punnakkamukal', label: 'Punnakkamukal', pincode: '695543' },
    { value: 's-s-kovil-road', label: 'S S Kovil Road', pincode: '695014' },
    { value: 'sasthamangalam', label: 'Sasthamangalam', pincode: '695010' },
    { value: 'shangumukham', label: 'Shangumukham', pincode: '695006' },
    { value: 'sree-varaham', label: 'Sree Varaham', pincode: '695025' },
    { value: 'sreekariyam', label: 'Sreekariyam', pincode: '695017' },
    { value: 'technopark-road', label: 'Technopark Road', pincode: '695582' },
    { value: 'thampanoor', label: 'Thampanoor', pincode: '695001' },
    { value: 'thampuranmukku', label: 'Thampuranmukku', pincode: '695003' },
    { value: 'thekkumbhagom', label: 'Thekkumbhagom', pincode: '695015' },
    { value: 'thirumala', label: 'Thirumala', pincode: '695005' },
    { value: 'thiruvallam', label: 'Thiruvallam', pincode: '695027' },
    { value: 'thonnakkal', label: 'Thonnakkal', pincode: '695545' },
    { value: 'thrikkakkara', label: 'Thrikkakkara', pincode: '695014' },
    { value: 'thycaud', label: 'Thycaud', pincode: '695014' },
    { value: 'uliyazhathura', label: 'Uliyazhathura', pincode: '695010' },
    { value: 'ulloor', label: 'Ulloor', pincode: '695008' },
    { value: 'vakkom', label: 'Vakkom', pincode: '695543' },
    { value: 'valiyavila', label: 'Valiyavila', pincode: '695001' },
    { value: 'vamanapuram', label: 'Vamanapuram', pincode: '695608' },
    { value: 'vanchiyoor', label: 'Vanchiyoor', pincode: '695014' },
    { value: 'varkala', label: 'Varkala', pincode: '695141' },
    { value: 'vattapara', label: 'Vattapara', pincode: '695529' },
    { value: 'vattiyoorkavu', label: 'Vattiyoorkavu', pincode: '695532' },
    { value: 'vazhayila', label: 'Vazhayila', pincode: '695025' },
    { value: 'vazhuthacaud', label: 'Vazhuthacaud', pincode: '695010' },
    { value: 'veiloor', label: 'Veiloor', pincode: '695541' },
    { value: 'vellanad', label: 'Vellanad', pincode: '695543' },
    { value: 'vellayambalam', label: 'Vellayambalam', pincode: '695010' },
    { value: 'vellayani', label: 'Vellayani', pincode: '695544' },
    { value: 'vembayam', label: 'Vembayam', pincode: '695563' },
    { value: 'venjaramoodu', label: 'Venjaramoodu', pincode: '695554' },
    { value: 'venpalavattom', label: 'Venpalavattom', pincode: '695504' },
    { value: 'vettamukku', label: 'Vettamukku', pincode: '695606' },
    { value: 'vilappil', label: 'Vilappil', pincode: '695033' },
    { value: 'viswambaran-road', label: 'Viswambaran Road', pincode: '695502' },
    { value: 'vithura', label: 'Vithura', pincode: '695561' },
    { value: 'vizhinjam', label: 'Vizhinjam', pincode: '695521' },
    { value: 'ymca-road', label: 'YMCA Road', pincode: '695001' }
  ],

'thiruvanathapuram': [
    { value: 'aakkulam', label: 'Aakkulam', pincode: '695002' },
    { value: 'alamcode', label: 'Alamcode', pincode: '695102' },
    { value: 'ambalam-jn', label: 'Ambalam Jn.', pincode: '695541' },
    { value: 'ambalamukku', label: 'Ambalamukku', pincode: '695017' },
    { value: 'ambalathara', label: 'Ambalathara', pincode: '695501' },
    { value: 'anayara', label: 'Anayara', pincode: '695029' },
    { value: 'arappuramukku', label: 'Arappuramukku', pincode: '695512' },
    { value: 'arasumoodu', label: 'Arasumoodu', pincode: '695611' },
    { value: 'attingal', label: 'Attingal', pincode: '695101' },
    { value: 'azhoor', label: 'Azhoor', pincode: '695542' },
    { value: 'balaramapuram', label: 'Balaramapuram', pincode: '695501' },
    { value: 'bhakti-vilasom-road', label: 'Bhakti Vilasom Road', pincode: '695011' },
    { value: 'bypass-road', label: 'Bypass Road', pincode: '695014' },
    { value: 'chacka', label: 'Chacka', pincode: '695024' },
    { value: 'chalakkuzhi', label: 'Chalakkuzhi', pincode: '695509' },
    { value: 'chanthavila', label: 'Chanthavila', pincode: '695019' },
    { value: 'chemboor', label: 'Chemboor', pincode: '695014' },
    { value: 'chempazhanthy', label: 'Chempazhanthy', pincode: '695587' },
    { value: 'chenkottukonam', label: 'Chenkottukonam', pincode: '695006' },
    { value: 'chirayinkeezhu', label: 'Chirayinkeezhu', pincode: '695303' },
    { value: 'chullimanoor', label: 'Chullimanoor', pincode: '695602' },
    { value: 'eanchakkal', label: 'Eanchakkal', pincode: '695019' },
    { value: 'edapazhanji', label: 'Edapazhanji', pincode: '695014' },
    { value: 'enikkara', label: 'Enikkara', pincode: '695583' },
    { value: 'gandhipuram', label: 'Gandhipuram', pincode: '695027' },
    { value: 'golf-link-road', label: 'Golf Link Road', pincode: '695014' },
    { value: 'idapazhanji', label: 'Idapazhanji', pincode: '695584' },
    { value: 'irumpa', label: 'Irumpa', pincode: '695003' },
    { value: 'jagathy', label: 'Jagathy', pincode: '695014' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '695014' },
    { value: 'kachani', label: 'Kachani', pincode: '695027' },
    { value: 'kadinamkulam', label: 'Kadinamkulam', pincode: '695301' },
    { value: 'kaimanom', label: 'Kaimanom', pincode: '695126' },
    { value: 'kaithamukku', label: 'Kaithamukku', pincode: '695010' },
    { value: 'kalady', label: 'Kalady', pincode: '695601' },
    { value: 'kalamachal', label: 'Kalamachal', pincode: '695011' },
    { value: 'kallambalam', label: 'Kallambalam', pincode: '695607' },
    { value: 'kallampally', label: 'Kallampally', pincode: '695005' },
    { value: 'kallayam', label: 'Kallayam', pincode: '695007' },
    { value: 'kallikadu', label: 'Kallikadu', pincode: '695554' },
    { value: 'kamaleswaram', label: 'Kamaleswaram', pincode: '695009' },
    { value: 'kaniyapuram', label: 'Kaniyapuram', pincode: '695301' },
    { value: 'kanjirampara-junction', label: 'Kanjirampara Junction', pincode: '695541' },
    { value: 'kannammoola', label: 'Kannammoola', pincode: '695010' },
    { value: 'kanyakulangara', label: 'Kanyakulangara', pincode: '695503' },
    { value: 'karakulam', label: 'Karakulam', pincode: '695301' },
    { value: 'karamana', label: 'Karamana', pincode: '695002' },
    { value: 'karikkakam', label: 'Karikkakam', pincode: '695016' },
    { value: 'kariyam', label: 'Kariyam', pincode: '695501' },
    { value: 'karyavattom', label: 'Karyavattom', pincode: '695581' },
    { value: 'kattakada', label: 'Kattakada', pincode: '695572' },
    { value: 'kattananm', label: 'Kattananm', pincode: '695511' },
    { value: 'kawdiar', label: 'Kawdiar', pincode: '695003' },
    { value: 'kazhakkoottam', label: 'Kazhakkoottam', pincode: '695582' },
    { value: 'keezharoor', label: 'Keezharoor', pincode: '695573' },
    { value: 'kesavadasapuram', label: 'Kesavadasapuram', pincode: '695008' },
    { value: 'kilimanoor', label: 'Kilimanoor', pincode: '695601' },
    { value: 'killipalam', label: 'Killipalam', pincode: '695022' },
    { value: 'kochulloor-junction', label: 'Kochulloor Junction', pincode: '695003' },
    { value: 'kochuveli', label: 'Kochuveli', pincode: '695021' },
    { value: 'kollam', label: 'Kollam', pincode: '691001' },
    { value: 'kollamkavu', label: 'Kollamkavu', pincode: '695014' },
    { value: 'kolvalam-nh-bypass', label: 'Kolvalam NH Bypass', pincode: '695001' },
    { value: 'koottappana', label: 'Koottappana', pincode: '695503' },
    { value: 'koravankonam', label: 'Koravankonam', pincode: '695514' },
    { value: 'kovalam', label: 'Kovalam', pincode: '695527' },
    { value: 'kowdiar', label: 'Kowdiar', pincode: '695003' },
    { value: 'kudappanakunnu', label: 'Kudappanakunnu', pincode: '695005' },
    { value: 'kulasekharam', label: 'Kulasekharam', pincode: '695541' },
    { value: 'kulathoor', label: 'Kulathoor', pincode: '695507' },
    { value: 'kumarapuram', label: 'Kumarapuram', pincode: '695011' },
    { value: 'kundamankadavu-vattiyoorkavu-road', label: 'Kundamankadavu Vattiyoorkavu Road', pincode: '695543' },
    { value: 'kunnukuzhi', label: 'Kunnukuzhi', pincode: '695583' },
    { value: 'kunnumpuram', label: 'Kunnumpuram', pincode: '695544' },
    { value: 'kuravankonam', label: 'Kuravankonam', pincode: '695005' },
    { value: 'kuthukuzhi-rd', label: 'Kuthukuzhi Rd', pincode: '695301' },
    { value: 'kuttiyani', label: 'Kuttiyani', pincode: '695115' },
    { value: 'kuzhivila', label: 'Kuzhivila', pincode: '695512' },
    { value: 'law-college-jn', label: 'Law College Jn.', pincode: '695014' },
    { value: 'magalapuram-sasthavattom-road', label: 'Magalapuram - Sasthavattom Road', pincode: '695015' },
    { value: 'malayinkeezhu', label: 'Malayinkeezhu', pincode: '695315' },
    { value: 'manacaud', label: 'Manacaud', pincode: '695009' },
    { value: 'mangalapuram', label: 'Mangalapuram', pincode: '695020' },
    { value: 'mannanthala', label: 'Mannanthala', pincode: '695037' },
    { value: 'manvila', label: 'Manvila', pincode: '695015' },
    { value: 'marappalam', label: 'Marappalam', pincode: '695007' },
    { value: 'maruthoor', label: 'Maruthoor', pincode: '695514' },
    { value: 'maruthumkuzhi', label: 'Maruthumkuzhi', pincode: '695020' },
    { value: 'mc-road', label: 'MC Road', pincode: '695115' },
    { value: 'menamkulam', label: 'Menamkulam', pincode: '695003' },
    { value: 'mudavanmugal', label: 'Mudavanmugal', pincode: '695011' },
    { value: 'mukkola', label: 'Mukkola', pincode: '695004' },
    { value: 'museaum-jn', label: 'Museaum Jn', pincode: '695003' },
    { value: 'muttada', label: 'Muttada', pincode: '695004' },
    { value: 'muttathara', label: 'Muttathara', pincode: '695036' },
    { value: 'nalanchira', label: 'Nalanchira', pincode: '695036' },
    { value: 'nandavanam', label: 'Nandavanam', pincode: '695036' },
    { value: 'nanthancode', label: 'Nanthancode', pincode: '695003' },
    { value: 'navaikulam', label: 'Navaikulam', pincode: '695016' },
    { value: 'nedumangadu', label: 'Nedumangadu', pincode: '695561' },
    { value: 'neerazhi-lane', label: 'Neerazhi Lane', pincode: '695016' },
    { value: 'nemom', label: 'Nemom', pincode: '695020' },
    { value: 'nettayam', label: 'Nettayam', pincode: '695015' },
    { value: 'neyyattinkara', label: 'Neyyattinkara', pincode: '695121' },
    { value: 'njandoorkonam', label: 'Njandoorkonam', pincode: '695035' },
    { value: 'oottukuzhy', label: 'Oottukuzhy', pincode: '695535' },
    { value: 'palayam', label: 'Palayam', pincode: '695014' },
    { value: 'palkulangara', label: 'Palkulangara', pincode: '695021' },
    { value: 'pallickal', label: 'Pallickal', pincode: '695526' },
    { value: 'pallipuram', label: 'Pallipuram', pincode: '695314' },
    { value: 'palode', label: 'Palode', pincode: '695543' },
    { value: 'pangappara', label: 'Pangappara', pincode: '695536' },
    { value: 'pangodu', label: 'Pangodu', pincode: '695565' },
    { value: 'pappanamcode', label: 'Pappanamcode', pincode: '695043' },
    { value: 'parassala', label: 'Parassala', pincode: '695502' },
    { value: 'parottukonam', label: 'Parottukonam', pincode: '695031' },
    { value: 'paruthippara', label: 'Paruthippara', pincode: '695101' },
    { value: 'pattom', label: 'Pattom', pincode: '695004' },
    { value: 'pattoor', label: 'Pattoor', pincode: '695016' },
    { value: 'pazhavangadi', label: 'Pazhavangadi', pincode: '695014' },
    { value: 'peroorkada', label: 'Peroorkada', pincode: '695005' },
    { value: 'pettah', label: 'Pettah', pincode: '695022' },
    { value: 'peyad', label: 'Peyad', pincode: '695573' },
    { value: 'pmg', label: 'PMG', pincode: '695011' },
    { value: 'pongumodu', label: 'Pongumodu', pincode: '695027' },
    { value: 'poojapura', label: 'Poojapura', pincode: '695011' },
    { value: 'poonkulam', label: 'Poonkulam', pincode: '695004' },
    { value: 'pothencode', label: 'Pothencode', pincode: '695543' },
    { value: 'pottakkuzhi', label: 'Pottakkuzhi', pincode: '695019' },
    { value: 'powdikonam', label: 'Powdikonam', pincode: '695025' },
    { value: 'ptp-nagar', label: 'PTP Nagar', pincode: '695038' },
    { value: 'pulayanarkotta', label: 'Pulayanarkotta', pincode: '695010' },
    { value: 'pulimoodu', label: 'Pulimoodu', pincode: '695027' },
    { value: 'puliyarakonam', label: 'Puliyarakonam', pincode: '695015' },
    { value: 'punnakkamukal', label: 'Punnakkamukal', pincode: '695543' },
    { value: 's-s-kovil-road', label: 'S S Kovil Road', pincode: '695014' },
    { value: 'sasthamangalam', label: 'Sasthamangalam', pincode: '695010' },
    { value: 'shangumukham', label: 'Shangumukham', pincode: '695006' },
    { value: 'sree-varaham', label: 'Sree Varaham', pincode: '695025' },
    { value: 'sreekariyam', label: 'Sreekariyam', pincode: '695017' },
    { value: 'technopark-road', label: 'Technopark Road', pincode: '695582' },
    { value: 'thampanoor', label: 'Thampanoor', pincode: '695001' },
    { value: 'thampuranmukku', label: 'Thampuranmukku', pincode: '695003' },
    { value: 'thekkumbhagom', label: 'Thekkumbhagom', pincode: '695015' },
    { value: 'thirumala', label: 'Thirumala', pincode: '695005' },
    { value: 'thiruvallam', label: 'Thiruvallam', pincode: '695027' },
    { value: 'thonnakkal', label: 'Thonnakkal', pincode: '695545' },
    { value: 'thrikkakkara', label: 'Thrikkakkara', pincode: '695014' },
    { value: 'thycaud', label: 'Thycaud', pincode: '695014' },
    { value: 'uliyazhathura', label: 'Uliyazhathura', pincode: '695010' },
    { value: 'ulloor', label: 'Ulloor', pincode: '695008' },
    { value: 'vakkom', label: 'Vakkom', pincode: '695543' },
    { value: 'valiyavila', label: 'Valiyavila', pincode: '695001' },
    { value: 'vamanapuram', label: 'Vamanapuram', pincode: '695608' },
    { value: 'vanchiyoor', label: 'Vanchiyoor', pincode: '695014' },
    { value: 'varkala', label: 'Varkala', pincode: '695141' },
    { value: 'vattapara', label: 'Vattapara', pincode: '695529' },
    { value: 'vattiyoorkavu', label: 'Vattiyoorkavu', pincode: '695532' },
    { value: 'vazhayila', label: 'Vazhayila', pincode: '695025' },
    { value: 'vazhuthacaud', label: 'Vazhuthacaud', pincode: '695010' },
    { value: 'veiloor', label: 'Veiloor', pincode: '695541' },
    { value: 'vellanad', label: 'Vellanad', pincode: '695543' },
    { value: 'vellayambalam', label: 'Vellayambalam', pincode: '695010' },
    { value: 'vellayani', label: 'Vellayani', pincode: '695544' },
    { value: 'vembayam', label: 'Vembayam', pincode: '695563' },
    { value: 'venjaramoodu', label: 'Venjaramoodu', pincode: '695554' },
    { value: 'venpalavattom', label: 'Venpalavattom', pincode: '695504' },
    { value: 'vettamukku', label: 'Vettamukku', pincode: '695606' },
    { value: 'vilappil', label: 'Vilappil', pincode: '695033' },
    { value: 'viswambaran-road', label: 'Viswambaran Road', pincode: '695502' },
    { value: 'vithura', label: 'Vithura', pincode: '695561' },
    { value: 'vizhinjam', label: 'Vizhinjam', pincode: '695521' },
    { value: 'ymca-road', label: 'YMCA Road', pincode: '695001' }
  ],

  'kollam': [
    { value: 'aakkulam', label: 'Aakkulam', pincode: '695002' },
    { value: 'anad', label: 'Anad', pincode: '695541' },
    { value: 'chakai', label: 'Chakai', pincode: '695021' },
    { value: 'chathannoor', label: 'Chathannoor', pincode: '691572' },
    { value: 'chirakkara', label: 'Chirakkara', pincode: '691540' },
    { value: 'chittumala', label: 'Chittumala', pincode: '691512' },
    { value: 'kilimanoor', label: 'Kilimanoor', pincode: '695601' },
    { value: 'kodimatha', label: 'Kodimatha', pincode: '691001' },
    { value: 'kolathur', label: 'Kolathur', pincode: '691526' },
    { value: 'kollam', label: 'Kollam', pincode: '691001' },
    { value: 'kottarakara', label: 'Kottarakara', pincode: '691506' },
    { value: 'kunnicode', label: 'Kunnicode', pincode: '691531' },
    { value: 'manalam', label: 'Manalam', pincode: '691514' },
    { value: 'neendakara', label: 'Neendakara', pincode: '691582' },
    { value: 'nellimoottil', label: 'Nellimoottil', pincode: '691506' },
    { value: 'pallimukku', label: 'Pallimukku', pincode: '691001' },
    { value: 'paravur', label: 'Paravur', pincode: '691301' },
    { value: 'perinad', label: 'Perinad', pincode: '691529' },
    { value: 'perumon', label: 'Perumon', pincode: '691563' },
    { value: 'punnakulam', label: 'Punnakulam', pincode: '691537' },
    { value: 'punnappra', label: 'Punnappra', pincode: '691538' },
    { value: 'sultan-batheri', label: 'Sultan Batheri', pincode: '691501' },
    { value: 'thangassery', label: 'Thangassery', pincode: '691007' },
    { value: 'thevalakkara', label: 'Thevalakkara', pincode: '691506' },
    { value: 'vellimon', label: 'Vellimon', pincode: '691515' },
    { value: 'venmani', label: 'Venmani', pincode: '691532' },
    { value: 'vijayapuram', label: 'Vijayapuram', pincode: '691507' },
    { value: 'vypin', label: 'Vypin', pincode: '691506' }
  ],

  'thrissur': [
    { value: 'adatt', label: 'Adatt', pincode: '680312' },
    { value: 'akathiyoor', label: 'Akathiyoor', pincode: '680567' },
    { value: 'alapad', label: 'Alapad', pincode: '680567' },
    { value: 'amala', label: 'Amala', pincode: '680551' },
    { value: 'amala-nagar', label: 'Amala Nagar', pincode: '680555' },
    { value: 'amballur', label: 'Amballur', pincode: '680302' },
    { value: 'ambazhakad', label: 'Ambazhakad', pincode: '680303' },
    { value: 'anjur', label: 'Anjur', pincode: '680587' },
    { value: 'annamanada', label: 'Annamanada', pincode: '680741' },
    { value: 'aranttukara', label: 'Aranttukara', pincode: '680618' },
    { value: 'arimboor', label: 'Arimboor', pincode: '680602' },
    { value: 'ashtamichira', label: 'Ashtamichira', pincode: '680726' },
    { value: 'athani', label: 'Athani', pincode: '680581' },
    { value: 'avanoor', label: 'Avanoor', pincode: '680614' },
    { value: 'avenue-road', label: 'Avenue Road', pincode: '680001' },
    { value: 'avinissery', label: 'Avinissery', pincode: '680317' },
    { value: 'ayyanthole', label: 'Ayyanthole', pincode: '680003' },
    { value: 'bishop-palace-road', label: 'Bishop Palace Road', pincode: '680020' },
    { value: 'chalakudy', label: 'Chalakudy', pincode: '680307' },
    { value: 'changaramkulam', label: 'Changaramkulam', pincode: '680616' },
    { value: 'chavakkad', label: 'Chavakkad', pincode: '680506' },
    { value: 'chelakkara', label: 'Chelakkara', pincode: '680586' },
    { value: 'chelakottukara', label: 'Chelakottukara', pincode: '680584' },
    { value: 'chembukkavu', label: 'Chembukkavu', pincode: '680020' },
    { value: 'chemmannur', label: 'Chemmannur', pincode: '680501' },
    { value: 'chengaloor', label: 'Chengaloor', pincode: '680615' },
    { value: 'cherpu', label: 'Cherpu', pincode: '680561' },
    { value: 'cheruthuruthy', label: 'Cheruthuruthy', pincode: '680687' },
    { value: 'choondal', label: 'Choondal', pincode: '680502' },
    { value: 'desamangalam', label: 'Desamangalam', pincode: '680562' },
    { value: 'guruvayoor', label: 'Guruvayoor', pincode: '680101' },
    { value: 'kaduppassery', label: 'Kaduppassery', pincode: '680548' },
    { value: 'kaiparambu', label: 'Kaiparambu', pincode: '680681' },
    { value: 'kalamassery', label: 'Kalamassery', pincode: '683104' },
    { value: 'kandassankadavu', label: 'Kandassankadavu', pincode: '680523' },
    { value: 'kanimangalam', label: 'Kanimangalam', pincode: '680612' },
    { value: 'kannara', label: 'Kannara', pincode: '680612' },
    { value: 'karalam', label: 'Karalam', pincode: '680684' },
    { value: 'kunnamkulam', label: 'Kunnamkulam', pincode: '680503' },
    { value: 'mannuthy', label: 'Mannuthy', pincode: '680651' },
    { value: 'mattom', label: 'Mattom', pincode: '680005' },
    { value: 'pavaratty', label: 'Pavaratty', pincode: '680514' },
    { value: 'poothole', label: 'Poothole', pincode: '680001' },
    { value: 'ramavarmapuram', label: 'Ramavarmapuram', pincode: '680613' },
    { value: 's-t-nagar', label: 'S.T. Nagar', pincode: '680020' },
    { value: 'sakthan-thampuran-nagar', label: 'Sakthan Thampuran Nagar', pincode: '680001' },
    { value: 'thalikulam', label: 'Thalikulam', pincode: '680567' },
    { value: 'vadanappally', label: 'Vadanappally', pincode: '680614' },
    { value: 'vadakkanchery', label: 'Vadakkanchery', pincode: '680623' },
    { value: 'vallachira', label: 'Vallachira', pincode: '680568' },
    { value: 'vellangallur', label: 'Vellangallur', pincode: '680514' },
    { value: 'wadakkanchery', label: 'Wadakkanchery', pincode: '680623' },
    { value: 'west-fort', label: 'West Fort', pincode: '680005' },
    { value: 'zanana-mission-road', label: 'Zanana Mission Road', pincode: '680020' }
  ],

  'kannur': [
    { value: 'azhikode', label: 'Azhikode', pincode: '670009' },
    { value: 'bengaluru', label: 'Bengaluru', pincode: '670033' },
    { value: 'chirakkal', label: 'Chirakkal', pincode: '670011' },
    { value: 'irikkur', label: 'Irikkur', pincode: '670703' },
    { value: 'kakkayangad', label: 'Kakkayangad', pincode: '670593' },
    { value: 'kannur-town', label: 'Kannur Town', pincode: '670001' },
    { value: 'koothuparamba', label: 'Koothuparamba', pincode: '670643' },
    { value: 'kuttiady', label: 'Kuttiady', pincode: '670010' },
    { value: 'mattannur', label: 'Mattannur', pincode: '670702' },
    { value: 'muzhappilangad', label: 'Muzhappilangad', pincode: '670661' },
    { value: 'nadakkavu', label: 'Nadakkavu', pincode: '670632' },
    { value: 'narath', label: 'Narath', pincode: '670301' },
    { value: 'pappinisseri', label: 'Pappinisseri', pincode: '670561' },
    { value: 'payyanur', label: 'Payyanur', pincode: '670307' },
    { value: 'pinarayi', label: 'Pinarayi', pincode: '670304' },
    { value: 'sreekandapuram', label: 'Sreekandapuram', pincode: '670631' },
    { value: 'taliparamba', label: 'Taliparamba', pincode: '670141' },
    { value: 'thayyil', label: 'Thayyil', pincode: '670008' },
    { value: 'thavakkara', label: 'Thavakkara', pincode: '670101' },
    { value: 'thiruvangad', label: 'Thiruvangad', pincode: '670105' },
    { value: 'thottilpalam', label: 'Thottilpalam', pincode: '670142' },
    { value: 'udumbumthala', label: 'Udumbumthala', pincode: '670305' },
    { value: 'valapattanam', label: 'Valapattanam', pincode: '670010' },
    { value: 'velimanna', label: 'Velimanna', pincode: '670510' }
  ],
  'alappuzha': [
  { value: 'ambalappuzha', label: 'Ambalappuzha', pincode: '688561' },
  { value: 'arayankavu', label: 'Arayankavu', pincode: '690572' },
  { value: 'arthunkal', label: 'Arthunkal', pincode: '688530' },
  { value: 'cherthala', label: 'Cherthala', pincode: '688524' },
  { value: 'edathua', label: 'Edathua', pincode: '689573' },
  { value: 'haripad', label: 'Haripad', pincode: '690514' },
  { value: 'kayippuram', label: 'Kayippuram', pincode: '688529' },
  { value: 'kayamkulam', label: 'Kayamkulam', pincode: '690502' },
  { value: 'kainakary', label: 'Kainakary', pincode: '688501' },
  { value: 'karthikappally', label: 'Karthikappally', pincode: '690516' },
  { value: 'komalapuram', label: 'Komalapuram', pincode: '688006' },
  { value: 'kuttanad', label: 'Kuttanad', pincode: '689502' },
  { value: 'mannar', label: 'Mannar', pincode: '689622' },
  { value: 'muhamma', label: 'Muhamma', pincode: '688525' },
  { value: 'nangyarkulangara', label: 'Nangyarkulangara', pincode: '690513' },
  { value: 'pathirappally', label: 'Pathirappally', pincode: '688521' },
  { value: 'punnapra', label: 'Punnapra', pincode: '688004' },
  { value: 'r-block', label: 'R Block', pincode: '688503' },
  { value: 'thakazhi', label: 'Thakazhi', pincode: '688562' },
  { value: 'thiruvalla', label: 'Thiruvalla', pincode: '689101' },
  { value: 'vandanam', label: 'Vandanam', pincode: '688005' },
  { value: 'vellakkinar', label: 'Vellakkinar', pincode: '688001' }
  ],

  'malappuram': [
  { value: 'angadipuram', label: 'Angadipuram', pincode: '679321' },
  { value: 'areacode', label: 'Areacode', pincode: '673639' },
  { value: 'arulam', label: 'Arulam', pincode: '676523' },
  { value: 'chattiparamba', label: 'Chattiparamba', pincode: '676504' },
  { value: 'edappal', label: 'Edappal', pincode: '679576' },
  { value: 'kizhisseri', label: 'Kizhisseri', pincode: '673641' },
  { value: 'kondotty', label: 'Kondotty', pincode: '673638' },
  { value: 'koottilangadi', label: 'Koottilangadi', pincode: '676506' },
  { value: 'kottakkal', label: 'Kottakkal', pincode: '676503' },
  { value: 'malappuram', label: 'Malappuram', pincode: '676505' },
  { value: 'manjeri', label: 'Manjeri', pincode: '676121' },
  { value: 'melattur', label: 'Melattur', pincode: '679326' },
  { value: 'nilambur', label: 'Nilambur', pincode: '679329' },
  { value: 'parappanangadi', label: 'Parappanangadi', pincode: '676303' },
  { value: 'perinthalmanna', label: 'Perinthalmanna', pincode: '679322' },
  { value: 'ponnani', label: 'Ponnani', pincode: '679577' },
  { value: 'pulikkal', label: 'Pulikkal', pincode: '673637' },
  { value: 'tanur', label: 'Tanur', pincode: '676302' },
  { value: 'thalakkad', label: 'Thalakkad', pincode: '676508' },
  { value: 'thavanoor', label: 'Thavanoor', pincode: '679573' },
  { value: 'thirur', label: 'Thirur', pincode: '676101' },
  { value: 'thirurangadi', label: 'Thirurangadi', pincode: '676306' },
  { value: 'tirur', label: 'Tirur', pincode: '676104' },
  { value: 'valanchery', label: 'Valanchery', pincode: '676552' },
  { value: 'vazhakkad', label: 'Vazhakkad', pincode: '673640' },
  { value: 'vengara', label: 'Vengara', pincode: '676304' }
  ],

  'kayamkulam': [
  { value: 'azhikkal', label: 'Azhikkal', pincode: '690533' },
  { value: 'choolatheruvu', label: 'Choolatheruvu', pincode: '690506' },
  { value: 'cheppad', label: 'Cheppad', pincode: '690507' },
  { value: 'chunakkara', label: 'Chunakkara', pincode: '690534' },
  { value: 'devikulangara', label: 'Devikulangara', pincode: '690546' },
  { value: 'eravankara', label: 'Eravankara', pincode: '690509' },
  { value: 'karunagappally', label: 'Karunagappally', pincode: '690518' },
  { value: 'kandalloor', label: 'Kandalloor', pincode: '690535' },
  { value: 'karthikappally', label: 'Karthikappally', pincode: '690516' },
  { value: 'kayalpuram', label: 'Kayalpuram', pincode: '690539' },
  { value: 'kayamkulam', label: 'Kayamkulam', pincode: '690502' },
  { value: 'krishnapuram', label: 'Krishnapuram', pincode: '690533' },
  { value: 'kumarapuram', label: 'Kumarapuram', pincode: '690548' },
  { value: 'mynagappally', label: 'Mynagappally', pincode: '690519' },
  { value: 'oachira', label: 'Oachira', pincode: '690526' },
  { value: 'pathiyoor', label: 'Pathiyoor', pincode: '690508' },
  { value: 'pavukara', label: 'Pavukara', pincode: '690517' },
  { value: 'punna', label: 'Punna', pincode: '690538' },
  { value: 'puthuppally', label: 'Puthuppally', pincode: '690531' },
  { value: 'sreekandapuram', label: 'Sreekandapuram', pincode: '690540' },
  { value: 'thamarakulam', label: 'Thamarakulam', pincode: '690530' },
  { value: 'thrikkunnapuzha', label: 'Thrikkunnapuzha', pincode: '690515' },
  { value: 'vadakethil', label: 'Vadakethil', pincode: '690504' },
  { value: 'valiyakulangara', label: 'Valiyakulangara', pincode: '690533' },
  { value: 'vellimana', label: 'Vellimana', pincode: '690536' }
  ],

  'kanhangad': [
  { value: 'ajanur', label: 'Ajanur', pincode: '671531' },
  { value: 'anandashram', label: 'Anandashram', pincode: '671531' },
  { value: 'bandadukka', label: 'Bandadukka', pincode: '671541' },
  { value: 'bela', label: 'Bela', pincode: '671321' },
  { value: 'chandragiri', label: 'Chandragiri', pincode: '671317' },
  { value: 'chervathur', label: 'Chervathur', pincode: '671313' },
  { value: 'eelampara', label: 'Eelampara', pincode: '671314' },
  { value: 'hosdurg', label: 'Hosdurg', pincode: '671531' },
  { value: 'kanhangad', label: 'Kanhangad', pincode: '671315' },
  { value: 'karindalam', label: 'Karindalam', pincode: '671314' },
  { value: 'kinnanoor', label: 'Kinnanoor', pincode: '671531' },
  { value: 'konnakkad', label: 'Konnakkad', pincode: '671532' },
  { value: 'kottacherry', label: 'Kottacherry', pincode: '671532' },
  { value: 'kumbla', label: 'Kumbla', pincode: '671321' },
  { value: 'manjeshwar', label: 'Manjeshwar', pincode: '671323' },
  { value: 'mavungal', label: 'Mavungal', pincode: '671531' },
  { value: 'nandikkara', label: 'Nandikkara', pincode: '671316' },
  { value: 'nellikkunnu', label: 'Nellikkunnu', pincode: '671531' },
  { value: 'pallikkara', label: 'Pallikkara', pincode: '671319' },
  { value: 'panathady', label: 'Panathady', pincode: '671532' },
  { value: 'parappa', label: 'Parappa', pincode: '671533' },
  { value: 'periya', label: 'Periya', pincode: '671316' },
  { value: 'pilicode', label: 'Pilicode', pincode: '671310' },
  { value: 'poinachi', label: 'Poinachi', pincode: '671317' },
  { value: 'thayannur', label: 'Thayannur', pincode: '671314' },
  { value: 'trikarpur', label: 'Trikarpur', pincode: '671310' },
  { value: 'uduma', label: 'Uduma', pincode: '671319' },
  { value: 'ullal', label: 'Ullal', pincode: '671317' },
  { value: 'vellarikundu', label: 'Vellarikundu', pincode: '671533' }
  ],

  'manjeri': [
  { value: 'anakkayam', label: 'Anakkayam', pincode: '676509' },
  { value: 'angadippuram', label: 'Angadippuram', pincode: '679321' },
  { value: 'areekode', label: 'Areekode', pincode: '676525' },
  { value: 'cherani', label: 'Cherani', pincode: '676123' },
  { value: 'cherupara', label: 'Cherupara', pincode: '676507' },
  { value: 'edavanna', label: 'Edavanna', pincode: '676541' },
  { value: 'elankur', label: 'Elankur', pincode: '676122' },
  { value: 'karuvambram', label: 'Karuvambram', pincode: '676123' },
  { value: 'kodur', label: 'Kodur', pincode: '676504' },
  { value: 'kuthukal', label: 'Kuthukal', pincode: '676525' },
  { value: 'kuttippuram', label: 'Kuttippuram', pincode: '679571' },
  { value: 'manjeri', label: 'Manjeri', pincode: '676121' },
  { value: 'melattur', label: 'Melattur', pincode: '679326' },
  { value: 'moothedam', label: 'Moothedam', pincode: '676525' },
  { value: 'mukkam', label: 'Mukkam', pincode: '676123' },
  { value: 'nalambalam', label: 'Nalambalam', pincode: '676507' },
  { value: 'narukara', label: 'Narukara', pincode: '676122' },
  { value: 'panakkad', label: 'Panakkad', pincode: '676123' },
  { value: 'parappur', label: 'Parappur', pincode: '676503' },
  { value: 'pathirippala', label: 'Pathirippala', pincode: '676501' },
  { value: 'perinthalmanna', label: 'Perinthalmanna', pincode: '679322' },
  { value: 'pulpatta', label: 'Pulpatta', pincode: '676123' },
  { value: 'randathani', label: 'Randathani', pincode: '676510' },
  { value: 'tanur', label: 'Tanur', pincode: '676302' },
  { value: 'thalakkad', label: 'Thalakkad', pincode: '676508' },
  { value: 'thiruvali', label: 'Thiruvali', pincode: '676123' },
  { value: 'vellikkad', label: 'Vellikkad', pincode: '676508' },
  { value: 'vengara', label: 'Vengara', pincode: '676304' }
  ],

  'kasaragod': [
  { value: 'badiyadka', label: 'Badiyadka', pincode: '671531' },
  { value: 'cheruvathur', label: 'Cheruvathur', pincode: '671541' },
  { value: 'cherupuzha', label: 'Cherupuzha', pincode: '671313' },
  { value: 'enmakaje', label: 'Enmakaje', pincode: '671318' },
  { value: 'kadambar', label: 'Kadambar', pincode: '671315' },
  { value: 'kasaragod', label: 'Kasaragod', pincode: '671121' },
  { value: 'kumbla', label: 'Kumbla', pincode: '671321' },
  { value: 'manjeshwar', label: 'Manjeshwar', pincode: '671323' },
  { value: 'muliyar', label: 'Muliyar', pincode: '671533' },
  { value: 'panathady', label: 'Panathady', pincode: '671325' },
  { value: 'periya', label: 'Periya', pincode: '671314' },
  { value: 'pallikkara', label: 'Pallikkara', pincode: '671531' },
  { value: 'neeleshwar', label: 'Neeleshwar', pincode: '671314' },
  { value: 'kadirur', label: 'Kadirur', pincode: '671314' },
  { value: 'kooveri', label: 'Kooveri', pincode: '671325' },
  { value: 'kumminiparamba', label: 'Kumminiparamba', pincode: '671536' },
  { value: 'madiyadka', label: 'Madiyadka', pincode: '671539' },
  { value: 'manikoth', label: 'Manikoth', pincode: '671314' },
  { value: 'meenja', label: 'Meenja', pincode: '671532' },
  { value: 'nileshwaram', label: 'Nileshwaram', pincode: '671314' },
  { value: 'parappa', label: 'Parappa', pincode: '671535' },
  { value: 'perla', label: 'Perla', pincode: '671533' },
  { value: 'padanna', label: 'Padanna', pincode: '671314' },
  { value: 'pudukkad', label: 'Pudukkad', pincode: '671312' },
  { value: 'rambhavan', label: 'Rambhavan', pincode: '671314' },
  { value: 'sultan-bathery', label: 'Sultan Bathery', pincode: '671531' },
  { value: 'valiyaparamba', label: 'Valiyaparamba', pincode: '671523' },
  { value: 'vembayam', label: 'Vembayam', pincode: '671524' }
  ],

  'vatakara': [
  { value: 'arikkady', label: 'Arikkady', pincode: '673529' },
  { value: 'balussery', label: 'Balussery', pincode: '673612' },
  { value: 'elathur', label: 'Elathur', pincode: '673303' },
  { value: 'kuttiyadi', label: 'Kuttiyadi', pincode: '673508' },
  { value: 'mukkam', label: 'Mukkam', pincode: '673602' },
  { value: 'nadapuram', label: 'Nadapuram', pincode: '673504' },
  { value: 'nirakkal', label: 'Nirakkal', pincode: '673506' },
  { value: 'perambra', label: 'Perambra', pincode: '673525' },
  { value: 'vaduvanchal', label: 'Vaduvanchal', pincode: '673581' },
  { value: 'vatakara', label: 'Vatakara', pincode: '673101' },
  { value: 'valayam', label: 'Valayam', pincode: '673517' },
  { value: 'villavambom', label: 'Villavambom', pincode: '673512' },
  { value: 'meppayur', label: 'Meppayur', pincode: '673526' },
  { value: 'iringal', label: 'Iringal', pincode: '673522' },
  { value: 'kadavur', label: 'Kadavur', pincode: '673619' },
  { value: 'koottali', label: 'Koottali', pincode: '673512' },
  { value: 'manikandapuram', label: 'Manikandapuram', pincode: '673542' },
  { value: 'nadavayal', label: 'Nadavayal', pincode: '673523' },
  { value: 'odacheri', label: 'Odacheri', pincode: '673551' },
  { value: 'puduppadi', label: 'Puduppadi', pincode: '673580' }
  ],

  'thalassery': [
  { value: 'alavil', label: 'Alavil', pincode: '670007' },
  { value: 'cherukunnu', label: 'Cherukunnu', pincode: '670301' },
  { value: 'daniel-puram', label: 'Daniel Puram', pincode: '670102' },
  { value: 'ilambali', label: 'Ilambali', pincode: '670631' },
  { value: 'kozhikode', label: 'Kozhikode', pincode: '670634' },
  { value: 'kumaranellur', label: 'Kumaranellur', pincode: '670612' },
  { value: 'manal', label: 'Manal', pincode: '670104' },
  { value: 'munderi', label: 'Munderi', pincode: '670107' },
  { value: 'nachivayal', label: 'Nachivayal', pincode: '670643' },
  { value: 'pappinissery', label: 'Pappinissery', pincode: '670561' },
  { value: 'parassinikadavu', label: 'Parassinikadavu', pincode: '670563' },
  { value: 'peralassery', label: 'Peralassery', pincode: '670622' },
  { value: 'thalassery', label: 'Thalassery', pincode: '670101' },
  { value: 'thottada', label: 'Thottada', pincode: '670105' },
  { value: 'vellur', label: 'Vellur', pincode: '670108' },
  { value: 'adakkara', label: 'Adakkara', pincode: '670601' },
  { value: 'kuthuparamba', label: 'Kuthuparamba', pincode: '670643' },
  { value: 'meethal', label: 'Meethal', pincode: '670521' },
  { value: 'moorkhanadu', label: 'Moorkhanadu', pincode: '670523' },
  { value: 'ponnappra', label: 'Ponnappra', pincode: '670553' },
  { value: 'pudiyangadi', label: 'Pudiyangadi', pincode: '670551' },
  { value: 'thekkumbhagam', label: 'Thekkumbhagam', pincode: '670562' },
  { value: 'thiruvangad', label: 'Thiruvangad', pincode: '670101' }
  ],

  'tirur': [
  { value: 'adakkaputhur', label: 'Adakkaputhur', pincode: '676102' },
  { value: 'kuttippuram', label: 'Kuttippuram', pincode: '676107' },
  { value: 'manjeri', label: 'Manjeri', pincode: '676121' },
  { value: 'nalukettu', label: 'Nalukettu', pincode: '676309' },
  { value: 'parappur', label: 'Parappur', pincode: '676105' },
  { value: 'piravom', label: 'Piravom', pincode: '676106' },
  { value: 'pulikkal', label: 'Pulikkal', pincode: '676105' },
  { value: 'tirur', label: 'Tirur', pincode: '676101' },
  { value: 'valakkad', label: 'Valakkad', pincode: '676319' },
  { value: 'vallikkunnu', label: 'Vallikkunnu', pincode: '676307' },
  { value: 'vattamkulam', label: 'Vattamkulam', pincode: '676314' },
  { value: 'alathiyur', label: 'Alathiyur', pincode: '676101' },
  { value: 'cherur', label: 'Cherur', pincode: '676308' },
  { value: 'eramala', label: 'Eramala', pincode: '676315' },
  { value: 'kavassery', label: 'Kavassery', pincode: '676312' },
  { value: 'makkaraparambu', label: 'Makkaraparambu', pincode: '676310' },
  { value: 'moorkkanad', label: 'Moorkkanad', pincode: '676316' },
  { value: 'neerchal', label: 'Neerchal', pincode: '676303' },
  { value: 'payyannur', label: 'Payyannur', pincode: '676102' },
  { value: 'thiruvangad', label: 'Thiruvangad', pincode: '676302' }
  ],

  'ponnani': [
  { value: 'aliparamba', label: 'Aliparamba', pincode: '679586' },
  { value: 'cheriyapalam', label: 'Cheriyapalam', pincode: '679577' },
  { value: 'irinjalkuda', label: 'Irinjalkuda', pincode: '679561' },
  { value: 'kadambini', label: 'Kadambini', pincode: '679584' },
  { value: 'kottakkal', label: 'Kottakkal', pincode: '679101' },
  { value: 'mankada', label: 'Mankada', pincode: '679582' },
  { value: 'mavoor', label: 'Mavoor', pincode: '679573' },
  { value: 'ponnani', label: 'Ponnani', pincode: '679577' },
  { value: 'pulamanthole', label: 'Pulamanthole', pincode: '679531' },
  { value: 'tangasseri', label: 'Tangasseri', pincode: '679572' },
  { value: 'thirurangadi', label: 'Thirurangadi', pincode: '679585' },
  { value: 'valanthode', label: 'Valanthode', pincode: '679579' },
  { value: 'avalappara', label: 'Avalappara', pincode: '679581' },
  { value: 'kuttikkattur', label: 'Kuttikkattur', pincode: '679503' },
  { value: 'nadakkavu', label: 'Nadakkavu', pincode: '679531' },
  { value: 'odavoor', label: 'Odavoor', pincode: '679536' },
  { value: 'pothukad', label: 'Pothukad', pincode: '679538' },
  { value: 'pudur', label: 'Pudur', pincode: '679521' },
  { value: 'thiruvangad', label: 'Thiruvangad', pincode: '679571' }
  ],

  'neyyattinkara': [
  { value: 'adarappuram', label: 'Adarappuram', pincode: '695121' },
  { value: 'alancode', label: 'Alancode', pincode: '695122' },
  { value: 'kilimanoor', label: 'Kilimanoor', pincode: '695601' },
  { value: 'konchiravila', label: 'Konchiravila', pincode: '695123' },
  { value: 'kovilvila', label: 'Kovilvila', pincode: '695122' },
  { value: 'kunnathukal', label: 'Kunnathukal', pincode: '695582' },
  { value: 'neyyattinkara', label: 'Neyyattinkara', pincode: '695121' },
  { value: 'panathura', label: 'Panathura', pincode: '695585' },
  { value: 'parassala', label: 'Parassala', pincode: '695502' },
  { value: 'sreekariyam', label: 'Sreekariyam', pincode: '695017' },
  { value: 'thiruvallom', label: 'Thiruvallom', pincode: '695027' },
  { value: 'vellarada', label: 'Vellarada', pincode: '695505' },
  { value: 'cheruvakkal', label: 'Cheruvakkal', pincode: '695124' },
  { value: 'kilimanoor-panchayath', label: 'Kilimanoor Panchayath', pincode: '695601' },
  { value: 'kottur', label: 'Kottur', pincode: '695526' },
  { value: 'pazhayakunnummal', label: 'Pazhayakunnummal', pincode: '695122' },
  { value: 'vattapara', label: 'Vattapara', pincode: '695582' }
  ],

  'payyanur': [
  { value: 'cherukunnu', label: 'Cherukunnu', pincode: '670301' },
  { value: 'chowka', label: 'Chowka', pincode: '670307' },
  { value: 'irikkur', label: 'Irikkur', pincode: '670703' },
  { value: 'kakkur', label: 'Kakkur', pincode: '670305' },
  { value: 'karivellur', label: 'Karivellur', pincode: '670511' },
  { value: 'kottakkal', label: 'Kottakkal', pincode: '670102' },
  { value: 'kudlu', label: 'Kudlu', pincode: '670706' },
  { value: 'payyanur', label: 'Payyanur', pincode: '670307' },
  { value: 'punnappra', label: 'Punnappra', pincode: '670309' },
  { value: 'thazhechovva', label: 'Thazhechovva', pincode: '670307' },
  { value: 'thiruvangad', label: 'Thiruvangad', pincode: '670101' },
  { value: 'urikkara', label: 'Urikkara', pincode: '670306' },
  { value: 'aralam', label: 'Aralam', pincode: '670704' },
  { value: 'balal', label: 'Balal', pincode: '670507' },
  { value: 'chavara', label: 'Chavara', pincode: '670312' },
  { value: 'kolavelloor', label: 'Kolavelloor', pincode: '670703' },
  { value: 'kunhimangalam', label: 'Kunhimangalam', pincode: '670306' },
  { value: 'madhur', label: 'Madhur', pincode: '670701' },
  { value: 'maniyur', label: 'Maniyur', pincode: '670312' },
  { value: 'mavur', label: 'Mavur', pincode: '670307' }
  ],

  'taliparamba': [
  { value: 'ayakkunnu', label: 'Ayakkunnu', pincode: '670141' },
  { value: 'cherukunnu', label: 'Cherukunnu', pincode: '670306' },
  { value: 'edavakkad', label: 'Edavakkad', pincode: '670601' },
  { value: 'irikkur', label: 'Irikkur', pincode: '670703' },
  { value: 'karivellur', label: 'Karivellur', pincode: '670511' },
  { value: 'kottur', label: 'Kottur', pincode: '670512' },
  { value: 'manikkunna', label: 'Manikkunna', pincode: '670501' },
  { value: 'nalukody', label: 'Nalukody', pincode: '670604' },
  { value: 'payyavoor', label: 'Payyavoor', pincode: '670643' },
  { value: 'taliparamba', label: 'Taliparamba', pincode: '670141' },
  { value: 'thayyil', label: 'Thayyil', pincode: '670601' },
  { value: 'thiruvangad', label: 'Thiruvangad', pincode: '670101' },
  { value: 'vayalathur', label: 'Vayalathur', pincode: '670515' },
  { value: 'andoor', label: 'Andoor', pincode: '670602' },
  { value: 'chuzhali', label: 'Chuzhali', pincode: '670515' },
  { value: 'kumaramangalam', label: 'Kumaramangalam', pincode: '670603' },
  { value: 'panappuzha', label: 'Panappuzha', pincode: '670641' },
  { value: 'pattanakkad', label: 'Pattanakkad', pincode: '670602' },
  { value: 'piravam', label: 'Piravam', pincode: '670604' }
  ],

  'koyilandy': [
  { value: 'cheruvannur', label: 'Cheruvannur', pincode: '673614' },
  { value: 'kadalundi', label: 'Kadalundi', pincode: '673302' },
  { value: 'koyilandy', label: 'Koyilandy', pincode: '673305' },
  { value: 'krishnan', label: 'Krishnan', pincode: '673302' },
  { value: 'manapparamba', label: 'Manapparamba', pincode: '673603' },
  { value: 'nanminda', label: 'Nanminda', pincode: '673602' },
  { value: 'pudussery', label: 'Pudussery', pincode: '673614' },
  { value: 'thiruvangad', label: 'Thiruvangad', pincode: '673307' },
  { value: 'vattoli', label: 'Vattoli', pincode: '673314' },
  { value: 'vengal', label: 'Vengal', pincode: '673604' },
  { value: 'alathur', label: 'Alathur', pincode: '673317' },
  { value: 'elathur', label: 'Elathur', pincode: '673303' },
  { value: 'kolavattom', label: 'Kolavattom', pincode: '673314' },
  { value: 'padinjarethara', label: 'Padinjarethara', pincode: '673314' },
  { value: 'poovattuparamba', label: 'Poovattuparamba', pincode: '673314' },
  { value: 'thottumukham', label: 'Thottumukham', pincode: '673313' }
  ],

  'changanassery': [
  { value: 'athirampuzha', label: 'Athirampuzha', pincode: '686562' },
  { value: 'changanassery', label: 'Changanassery', pincode: '686101' },
  { value: 'elavumthitta', label: 'Elavumthitta', pincode: '686613' },
  { value: 'kallelibhagom', label: 'Kallelibhagom', pincode: '686102' },
  { value: 'karukachal', label: 'Karukachal', pincode: '686540' },
  { value: 'kurichy', label: 'Kurichy', pincode: '686539' },
  { value: 'paippad', label: 'Paippad', pincode: '686506' },
  { value: 'punnamada', label: 'Punnamada', pincode: '686021' },
  { value: 'pullilakunnu', label: 'Pullilakunnu', pincode: '686101' },
  { value: 'thiruvalla', label: 'Thiruvalla', pincode: '689101' },
  { value: 'vadakkekara', label: 'Vadakkekara', pincode: '686539' },
  { value: 'chempu', label: 'Chempu', pincode: '686602' },
  { value: 'chalakudy', label: 'Chalakudy', pincode: '686539' },
  { value: 'kurishumala', label: 'Kurishumala', pincode: '686102' },
  { value: 'painganadu', label: 'Painganadu', pincode: '686101' },
  { value: 'pallom', label: 'Pallom', pincode: '686575' },
  { value: 'pulinkunnu', label: 'Pulinkunnu', pincode: '686511' },
  { value: 'thirumoolapuram', label: 'Thirumoolapuram', pincode: '686651' }
  ],

  'varkala': [
  { value: 'akkulam', label: 'Akkulam', pincode: '695011' },
  { value: 'kaipra', label: 'Kaipra', pincode: '695311' },
  { value: 'kappil', label: 'Kappil', pincode: '695311' },
  { value: 'karunagappally', label: 'Karunagappally', pincode: '690518' },
  { value: 'varkala', label: 'Varkala', pincode: '695141' },
  { value: 'punnaveli', label: 'Punnaveli', pincode: '695311' },
  { value: 'pudur', label: 'Pudur', pincode: '695141' },
  { value: 'sivagiri', label: 'Sivagiri', pincode: '695141' },
  { value: 'chirakkara', label: 'Chirakkara', pincode: '695141' },
  { value: 'elavoor', label: 'Elavoor', pincode: '695141' },
  { value: 'perumkulam', label: 'Perumkulam', pincode: '695141' },
  { value: 'sreekariyam', label: 'Sreekariyam', pincode: '695017' },
  { value: 'neendakara', label: 'Neendakara', pincode: '690526' },
  { value: 'pothencode', label: 'Pothencode', pincode: '695589' },
  { value: 'avittathur', label: 'Avittathur', pincode: '695141' },
  { value: 'nanniyode', label: 'Nanniyode', pincode: '695141' },
  { value: 'kallambalam', label: 'Kallambalam', pincode: '695608' },
  { value: 'poovar', label: 'Poovar', pincode: '695525' }
  ],

  'kothamangalam': [
  { value: 'chemmankodu', label: 'Chemmankodu', pincode: '686691' },
  { value: 'kothamangalam', label: 'Kothamangalam', pincode: '686691' },
  { value: 'muthalapozhy', label: 'Muthalapozhy', pincode: '686691' },
  { value: 'kothapra', label: 'Kothapra', pincode: '686691' },
  { value: 'manickamangalam', label: 'Manickamangalam', pincode: '686691' },
  { value: 'perumbavoor', label: 'Perumbavoor', pincode: '683542' },
  { value: 'thrikkariyoor', label: 'Thrikkariyoor', pincode: '686692' },
  { value: 'vengoor', label: 'Vengoor', pincode: '686691' },
  { value: 'vazhakulam', label: 'Vazhakulam', pincode: '686670' },
  { value: 'pukkattupady', label: 'Pukkattupady', pincode: '683556' },
  { value: 'adimali', label: 'Adimali', pincode: '685561' },
  { value: 'chathamangalam', label: 'Chathamangalam', pincode: '686698' },
  { value: 'chottanikara', label: 'Chottanikara', pincode: '683115' },
  { value: 'kizhakkambalam', label: 'Kizhakkambalam', pincode: '683562' },
  { value: 'manjaly', label: 'Manjaly', pincode: '686691' },
  { value: 'odakkali', label: 'Odakkali', pincode: '683550' },
  { value: 'poothrikka', label: 'Poothrikka', pincode: '683584' },
  { value: 'thiruvaniyoor', label: 'Thiruvaniyoor', pincode: '683555' }
  ],

  'chalakudy': [
  { value: 'chalakudy', label: 'Chalakudy', pincode: '680307' },
  { value: 'kallettumkara', label: 'Kallettumkara', pincode: '680730' },
  { value: 'kizhakkummuri', label: 'Kizhakkummuri', pincode: '680506' },
  { value: 'koratti', label: 'Koratti', pincode: '680306' },
  { value: 'pudukkad', label: 'Pudukkad', pincode: '680726' },
  { value: 'poomangalam', label: 'Poomangalam', pincode: '680730' },
  { value: 'sreekariyam', label: 'Sreekariyam', pincode: '680724' },
  { value: 'thekkumbhagom', label: 'Thekkumbhagom', pincode: '680726' },
  { value: 'vazhappilly', label: 'Vazhappilly', pincode: '680722' },
  { value: 'vengassery', label: 'Vengassery', pincode: '680513' },
  { value: 'akaparambu', label: 'Akaparambu', pincode: '680601' },
  { value: 'elikkulam', label: 'Elikkulam', pincode: '680726' },
  { value: 'kallettumkara', label: 'Kallettumkara', pincode: '680726' },
  { value: 'mannath', label: 'Mannath', pincode: '680722' },
  { value: 'neelambur', label: 'Neelambur', pincode: '680721' },
  { value: 'thiruvilwamala', label: 'Thiruvilwamala', pincode: '680588' }
  ],


  'ottappalam': [
  { value: 'akkaparambu', label: 'Akaparambu', pincode: '679511' },
  { value: 'annamanada', label: 'Annamanada', pincode: '679576' },
  { value: 'chettuva', label: 'Chettuva', pincode: '679534' },
  { value: 'chirakkal', label: 'Chirakkal', pincode: '679561' },
  { value: 'irumbuzhi', label: 'Irumbuzhi', pincode: '679512' },
  { value: 'ottappalam', label: 'Ottappalam', pincode: '679101' },
  { value: 'palappuram', label: 'Palappuram', pincode: '679534' },
  { value: 'pudur', label: 'Pudur', pincode: '679513' },
  { value: 'pulikkal', label: 'Pulikkal', pincode: '679511' },
  { value: 'sreekrishnapuram', label: 'Sreekrishnapuram', pincode: '679513' },
  { value: 'thrithala', label: 'Thrithala', pincode: '679534' },
  { value: 'vengallur', label: 'Vengallur', pincode: '679533' },
  { value: 'adakkaputhur', label: 'Adakkaputhur', pincode: '679532' },
  { value: 'koduvayur', label: 'Koduvayur', pincode: '679535' },
  { value: 'melarcode', label: 'Melarcode', pincode: '679503' },
  { value: 'thiruvazhiyode', label: 'Thiruvazhiyode', pincode: '679541' },
  { value: 'valappad', label: 'Valappad', pincode: '679503' }
  ],

  'cherthala': [
  { value: 'cherthala', label: 'Cherthala', pincode: '688524' },
  { value: 'alappuzha', label: 'Alappuzha', pincode: '688001' },
  { value: 'changanassery', label: 'Changanassery', pincode: '688576' },
  { value: 'edathua', label: 'Edathua', pincode: '688527' },
  { value: 'kuttamangalam', label: 'Kuttamangalam', pincode: '688532' },
  { value: 'karuvatta', label: 'Karuvatta', pincode: '688522' },
  { value: 'kumarakom', label: 'Kumarakom', pincode: '686563' },
  { value: 'mannanchery', label: 'Mannanchery', pincode: '688542' },
  { value: 'palamel', label: 'Palamel', pincode: '688531' },
  { value: 'purakkad', label: 'Purakkad', pincode: '688546' },
  { value: 'thannermukkam', label: 'Thannermukkam', pincode: '688537' },
  { value: 'vaikom', label: 'Vaikom', pincode: '686141' },
  { value: 'alapuzha-south', label: 'Alapuzha South', pincode: '688006' },
  { value: 'arattupuzha', label: 'Arattupuzha', pincode: '688531' },
  { value: 'kalavoor', label: 'Kalavoor', pincode: '688522' },
  { value: 'punnappra', label: 'Punnappra', pincode: '688404' },
  { value: 'vayalar', label: 'Vayalar', pincode: '686606' }
  ],

  'chengannūr': [
  { value: 'chengannur', label: 'Chengannur', pincode: '689121' },
  { value: 'alappuzha', label: 'Alappuzha', pincode: '689101' },
  { value: 'chempu', label: 'Chempu', pincode: '689501' },
  { value: 'illickal', label: 'Illickal', pincode: '689517' },
  { value: 'kuttanadu', label: 'Kuttanadu', pincode: '689514' },
  { value: 'muthur', label: 'Muthur', pincode: '689123' },
  { value: 'niranam', label: 'Niranam', pincode: '689621' },
  { value: 'punnappra', label: 'Punnappra', pincode: '689582' },
  { value: 'purakkad', label: 'Purakkad', pincode: '689506' },
  { value: 'thiruvalla', label: 'Thiruvalla', pincode: '689101' },
  { value: 'vallom', label: 'Vallom', pincode: '689541' },
  { value: 'changanassery', label: 'Changanassery', pincode: '689585' },
  { value: 'kanjirappally', label: 'Kanjirappally', pincode: '689506' },
  { value: 'manorama', label: 'Manorama', pincode: '689536' },
  { value: 'pamba', label: 'Pamba', pincode: '689572' },
  { value: 'puliyur', label: 'Puliyur', pincode: '689121' },
  { value: 'sabarimala', label: 'Sabarimala', pincode: '689713' }
  ],

  'tiruvalla': [
  { value: 'cheerappanchira', label: 'Cheerappanchira', pincode: '689121' },
  { value: 'chirakkara', label: 'Chirakkara', pincode: '689533' },
  { value: 'chittar', label: 'Chittar', pincode: '689529' },
  { value: 'kallettumkara', label: 'Kallettumkara', pincode: '689586' },
  { value: 'kavumbhagom', label: 'Kavumbhagom', pincode: '689577' },
  { value: 'kodumon', label: 'Kodumon', pincode: '689501' },
  { value: 'manjadi', label: 'Manjadi', pincode: '689506' },
  { value: 'perunad', label: 'Perunad', pincode: '689673' },
  { value: 'punnappra', label: 'Punnappra', pincode: '689580' },
  { value: 'thiruvalla', label: 'Thiruvalla', pincode: '689101' },
  { value: 'vellaramkunnu', label: 'Vellaramkunnu', pincode: '689510' },
  { value: 'vayalar', label: 'Vayalar', pincode: '686606' },
  { value: 'kuttapuzha', label: 'Kuttapuzha', pincode: '689561' },
  { value: 'pallickal', label: 'Pallickal', pincode: '689521' },
  { value: 'pulimath', label: 'Pulimath', pincode: '689542' },
  { value: 'thiruvaniyoor', label: 'Thiruvaniyoor', pincode: '689557' },
  { value: 'velloor', label: 'Velloor', pincode: '689505' },
  { value: 'venmony', label: 'Venmony', pincode: '689587' }
  ],

  'punalur': [
  { value: 'kattakkada', label: 'Kattakkada', pincode: '695572' },
  { value: 'kizhakketheri', label: 'Kizhakketheri', pincode: '691506' },
  { value: 'kurampala', label: 'Kurampala', pincode: '691503' },
  { value: 'mukhathala', label: 'Mukhathala', pincode: '691506' },
  { value: 'punalur', label: 'Punalur', pincode: '691305' },
  { value: 'sengottai', label: 'Sengottai', pincode: '691701' },
  { value: 'thottakkad', label: 'Thottakkad', pincode: '691525' },
  { value: 'vevoor', label: 'Vevoor', pincode: '691509' },
  { value: 'ayadi', label: 'Ayadi', pincode: '691510' },
  { value: 'chadayamangalam', label: 'Chadayamangalam', pincode: '691534' },
  { value: 'kavumkal', label: 'Kavumkal', pincode: '691511' },
  { value: 'maruthadi', label: 'Maruthadi', pincode: '691531' },
  { value: 'perumon', label: 'Perumon', pincode: '691562' },
  { value: 'sreepadam', label: 'Sreepadam', pincode: '691502' }
  ],


  'shoranur': [
  { value: 'edappally', label: 'Edappally', pincode: '679121' },
  { value: 'karuvanchal', label: 'Karuvanchal', pincode: '679521' },
  { value: 'kechery', label: 'Kechery', pincode: '679502' },
  { value: 'kizhakkoth', label: 'Kizhakkoth', pincode: '679552' },
  { value: 'muthuthala', label: 'Muthuthala', pincode: '679521' },
  { value: 'nellipuzha', label: 'Nellipuzha', pincode: '679122' },
  { value: 'palakkad', label: 'Palakkad', pincode: '678001' },
  { value: 'shoranur', label: 'Shoranur', pincode: '679121' },
  { value: 'thiruvegapura', label: 'Thiruvegapura', pincode: '679533' },
  { value: 'thirumittacode', label: 'Thirumittacode', pincode: '679121' },
  { value: 'vadakkanchery', label: 'Vadakkanchery', pincode: '679532' },
  { value: 'vengallur', label: 'Vengallur', pincode: '679518' }
  ],

  'pathanamthitta': [
  { value: 'akomala', label: 'Akomala', pincode: '689501' },
  { value: 'elanthoor', label: 'Elanthoor', pincode: '689643' },
  { value: 'kozhukully', label: 'Kozhukully', pincode: '689643' },
  { value: 'mavelikkara', label: 'Mavelikkara', pincode: '690101' },
  { value: 'mundomuzhi', label: 'Mundomuzhi', pincode: '689602' },
  { value: 'pathanamthitta', label: 'Pathanamthitta', pincode: '689645' },
  { value: 'punnappra', label: 'Punnappra', pincode: '689502' },
  { value: 'pulimath', label: 'Pulimath', pincode: '689504' },
  { value: 'thiruvalla', label: 'Thiruvalla', pincode: '689101' },
  { value: 'vadasserikara', label: 'Vadasserikara', pincode: '689553' },
  { value: 'vandoor', label: 'Vandoor', pincode: '689523' },
  { value: 'chandanapally', label: 'Chandanapally', pincode: '689507' },
  { value: 'cheerappanchira', label: 'Cheerappanchira', pincode: '689121' },
  { value: 'kodumon', label: 'Kodumon', pincode: '689501' },
  { value: 'kollamthuruth', label: 'Kollamthuruth', pincode: '690504' },
  { value: 'pandalam', label: 'Pandalam', pincode: '689501' },
  { value: 'parakode', label: 'Parakode', pincode: '689655' },
  { value: 'vallicode', label: 'Vallicode', pincode: '689651' }
  ],

  'kunnamkulam': [
  { value: 'alathur', label: 'Alathur', pincode: '680701' },
  { value: 'chempu', label: 'Chempu', pincode: '680515' },
  { value: 'kallettumkara', label: 'Kallettumkara', pincode: '680503' },
  { value: 'kunnamkulam', label: 'Kunnamkulam', pincode: '680503' },
  { value: 'palappuram', label: 'Palappuram', pincode: '680503' },
  { value: 'pattikad', label: 'Pattikad', pincode: '680652' },
  { value: 'pudukkad', label: 'Pudukkad', pincode: '680503' },
  { value: 'pullut', label: 'Pullut', pincode: '680306' },
  { value: 'vallapuzha', label: 'Vallapuzha', pincode: '680701' },
  { value: 'cheruvally', label: 'Cheruvally', pincode: '680517' },
  { value: 'kodungallur', label: 'Kodungallur', pincode: '680664' },
  { value: 'pudukkadavu', label: 'Pudukkadavu', pincode: '680503' },
  { value: 'tithil', label: 'Tithil', pincode: '680501' },
  { value: 'vengannur', label: 'Vengannur', pincode: '680512' }
  ],

  'chittur-thathamangalam': [
  { value: 'alathur', label: 'Alathur', pincode: '678541' },
  { value: 'chavara', label: 'Chavara', pincode: '678541' },
  { value: 'kallekkad', label: 'Kallekkad', pincode: '678563' },
  { value: 'kunnathuparamba', label: 'Kunnathuparamba', pincode: '678541' },
  { value: 'manakassery', label: 'Manakassery', pincode: '678589' },
  { value: 'muthuthala', label: 'Muthuthala', pincode: '678589' },
  { value: 'thathamangalam', label: 'Thathamangalam', pincode: '678581' },
  { value: 'thrithala', label: 'Thrithala', pincode: '678571' },
  { value: 'vengoor', label: 'Vengoor', pincode: '678542' },
  { value: 'arikkode', label: 'Arikkode', pincode: '678581' },
  { value: 'chittur', label: 'Chittur', pincode: '678101' },
  { value: 'kunnamkulam', label: 'Kunnamkulam', pincode: '678601' },
  { value: 'nedumkandom', label: 'Nedumkandom', pincode: '678591' },
  { value: 'vattavada', label: 'Vattavada', pincode: '678561' }
  ],

  'mannarkkad': [
  { value: 'agali', label: 'Agali', pincode: '678581' },
  { value: 'anakkal', label: 'Anakkal', pincode: '678583' },
  { value: 'angadippuram', label: 'Angadippuram', pincode: '679321' },
  { value: 'attappadi', label: 'Attappadi', pincode: '678581' },
  { value: 'cherpulassery', label: 'Cherpulassery', pincode: '679503' },
  { value: 'chindakki', label: 'Chindakki', pincode: '678581' },
  { value: 'karimba', label: 'Karimba', pincode: '678597' },
  { value: 'kizhakkanchery', label: 'Kizhakkanchery', pincode: '678684' },
  { value: 'kodathipadi', label: 'Kodathipadi', pincode: '678582' },
  { value: 'koppam', label: 'Koppam', pincode: '679307' },
  { value: 'kottopadam', label: 'Kottopadam', pincode: '678591' },
  { value: 'mukkali', label: 'Mukkali', pincode: '678582' },
  { value: 'pathirippala', label: 'Pathirippala', pincode: '678642' },
  { value: 'shoranur', label: 'Shoranur', pincode: '679121' },
  { value: 'thachanattukara', label: 'Thachanattukara', pincode: '678582' },
  { value: 'vadakkenchery', label: 'Vadakkenchery', pincode: '678683' },
  { value: 'vazhakad', label: 'Vazhakad', pincode: '678601' }
  ],

  'nilambūr': [
  { value: 'achal', label: 'Achal', pincode: '679329' },
  { value: 'areekode', label: 'Areekode', pincode: '673639' },
  { value: 'chungathara', label: 'Chungathara', pincode: '679334' },
  { value: 'edakkara', label: 'Edakkara', pincode: '679331' },
  { value: 'edavanna', label: 'Edavanna', pincode: '676541' },
  { value: 'karulai', label: 'Karulai', pincode: '679330' },
  { value: 'kakkadampoyil', label: 'Kakkadampoyil', pincode: '673603' },
  { value: 'manjeri', label: 'Manjeri', pincode: '676121' },
  { value: 'mambad', label: 'Mambad', pincode: '676542' },
  { value: 'moorkanad', label: 'Moorkanad', pincode: '679331' },
  { value: 'munderi', label: 'Munderi', pincode: '676541' },
  { value: 'nilambur-town', label: 'Nilambur Town', pincode: '679329' },
  { value: 'pookkottumpadam', label: 'Pookkottumpadam', pincode: '679332' },
  { value: 'thalappuzha', label: 'Thalappuzha', pincode: '679333' },
  { value: 'vazhikkadavu', label: 'Vazhikkadavu', pincode: '679333' },
  { value: 'wandoor', label: 'Wandoor', pincode: '679328' }
  ],

  'adoor': [
  { value: 'adoor-town', label: 'Adoor Town', pincode: '691523' },
  { value: 'annanad', label: 'Annanad', pincode: '691524' },
  { value: 'angadickal', label: 'Angadickal', pincode: '691555' },
  { value: 'ayarpara', label: 'Ayarpara', pincode: '691554' },
  { value: 'bharanickavu', label: 'Bharanickavu', pincode: '690503' },
  { value: 'chandanapally', label: 'Chandanapally', pincode: '689648' },
  { value: 'edathitta', label: 'Edathitta', pincode: '691556' },
  { value: 'ezhamkulam', label: 'Ezhamkulam', pincode: '691549' },
  { value: 'kadampanad', label: 'Kadampanad', pincode: '691553' },
  { value: 'kaipattoor', label: 'Kaipattoor', pincode: '689648' },
  { value: 'kalanjoor', label: 'Kalanjoor', pincode: '689694' },
  { value: 'karingannoor', label: 'Karingannoor', pincode: '691520' },
  { value: 'kaviyoor', label: 'Kaviyoor', pincode: '689582' },
  { value: 'koodal', label: 'Koodal', pincode: '689693' },
  { value: 'mallassery', label: 'Mallassery', pincode: '689646' },
  { value: 'manjapra', label: 'Manjapra', pincode: '691525' },
  { value: 'meenadom', label: 'Meenadom', pincode: '686516' },
  { value: 'omalloor', label: 'Omalloor', pincode: '689647' },
  { value: 'pandalam', label: 'Pandalam', pincode: '689501' },
  { value: 'parakode', label: 'Parakode', pincode: '691554' },
  { value: 'thattayil', label: 'Thattayil', pincode: '691525' },
  { value: 'vadakkadathukavu', label: 'Vadakkadathukavu', pincode: '691526' }
  ],

  'kalpetta': [
  { value: 'bathery', label: 'Bathery', pincode: '673592' },
  { value: 'cherukara', label: 'Cherukara', pincode: '673122' },
  { value: 'karapuzha', label: 'Karapuzha', pincode: '673122' },
  { value: 'kalpetta', label: 'Kalpetta', pincode: '673121' },
  { value: 'mananthavady', label: 'Mananthavady', pincode: '670645' },
  { value: 'pallikkal', label: 'Pallikkal', pincode: '673122' },
  { value: 'sultan-bathery', label: 'Sultan Bathery', pincode: '673592' },
  { value: 'vaduvanchal', label: 'Vaduvanchal', pincode: '673581' },
  { value: 'wyanad', label: 'Wyanad', pincode: '673592' },
  { value: 'amabalavayal', label: 'Amabalavayal', pincode: '673577' },
  { value: 'edakkal', label: 'Edakkal', pincode: '673595' },
  { value: 'kalapetta', label: 'Kalapetta', pincode: '673592' },
  { value: 'kottathara', label: 'Kottathara', pincode: '673122' },
  { value: 'poopara', label: 'Poopara', pincode: '673592' },
  { value: 'pulpally', label: 'Pulpally', pincode: '673579' }
  ],

  'pala': [
  { value: 'chemmaruthy', label: 'Chemmaruthy', pincode: '686575' },
  { value: 'kumily', label: 'Kumily', pincode: '686509' },
  { value: 'pala', label: 'Pala', pincode: '686575' },
  { value: 'piravom', label: 'Piravom', pincode: '686664' },
  { value: 'pullad', label: 'Pullad', pincode: '686505' },
  { value: 'thodupuzha', label: 'Thodupuzha', pincode: '686580' },
  { value: 'vakathanam', label: 'Vakathanam', pincode: '686538' },
  { value: 'vallom', label: 'Vallom', pincode: '686504' },
  { value: 'varapuzha', label: 'Varapuzha', pincode: '686544' },
  { value: 'adimaly', label: 'Adimaly', pincode: '686561' },
  { value: 'akkarakalam', label: 'Akkarakalam', pincode: '686587' },
  { value: 'changanassery', label: 'Changanassery', pincode: '686536' },
  { value: 'kanjirath', label: 'Kanjirath', pincode: '686564' },
  { value: 'muvattupuzha', label: 'Muvattupuzha', pincode: '686661' },
  { value: 'ramamangalam', label: 'Ramamangalam', pincode: '686651' }
  ],

  'kottarakara': [
  { value: 'adichanalloor', label: 'Adichanalloor', pincode: '691574' },
  { value: 'athikkode', label: 'Athikkode', pincode: '691554' },
  { value: 'cherupulassery', label: 'Cherupulassery', pincode: '691516' },
  { value: 'kadakkal', label: 'Kadakkal', pincode: '691536' },
  { value: 'kulakkada', label: 'Kulakkada', pincode: '691533' },
  { value: 'kottarakara', label: 'Kottarakara', pincode: '691506' },
  { value: 'mukkatira', label: 'Mukkatira', pincode: '691533' },
  { value: 'pathanapuram', label: 'Pathanapuram', pincode: '689695' },
  { value: 'perinad', label: 'Perinad', pincode: '691507' },
  { value: 'punnappra', label: 'Punnappra', pincode: '691526' },
  { value: 'tamarakulam', label: 'Tamarakulam', pincode: '691510' },
  { value: 'thiruvathira', label: 'Thiruvathira', pincode: '691507' },
  { value: 'valakom', label: 'Valakom', pincode: '691530' },
  { value: 'vettikkavala', label: 'Vettikkavala', pincode: '691537' },
  { value: 'chirakkara', label: 'Chirakkara', pincode: '691531' },
  { value: 'koluthuvayal', label: 'Koluthuvayal', pincode: '691515' },
  { value: 'mangadu', label: 'Mangadu', pincode: '691517' },
  { value: 'padappakkara', label: 'Padappakkara', pincode: '691520' }
  ],

  'thodupuzha': [
  { value: 'adavikode', label: 'Adavikode', pincode: '685584' },
  { value: 'alummoottil', label: 'Alummoottil', pincode: '685556' },
  { value: 'karimban', label: 'Karimban', pincode: '685589' },
  { value: 'kothamangalam', label: 'Kothamangalam', pincode: '685529' },
  { value: 'kulamavu', label: 'Kulamavu', pincode: '685611' },
  { value: 'manjinikara', label: 'Manjinikara', pincode: '685522' },
  { value: 'muttom', label: 'Muttom', pincode: '685587' },
  { value: 'pallikkunnu', label: 'Pallikkunnu', pincode: '685505' },
  { value: 'puduppady', label: 'Puduppady', pincode: '685588' },
  { value: 'thodupuzha', label: 'Thodupuzha', pincode: '685584' },
  { value: 'valakkodu', label: 'Valakkodu', pincode: '685585' },
  { value: 'vazhakulam', label: 'Vazhakulam', pincode: '685605' },
  { value: 'vengola', label: 'Vengola', pincode: '685608' },
  { value: 'vadakkekara', label: 'Vadakkekara', pincode: '685592' },
  { value: 'vazhithala', label: 'Vazhithala', pincode: '685508' },
  { value: 'vengoor', label: 'Vengoor', pincode: '685501' }
  ],

  'vaikom': [
  { value: 'alappra', label: 'Alappra', pincode: '686608' },
  { value: 'changanassery', label: 'Changanassery', pincode: '686536' },
  { value: 'changanasery', label: 'Changanasery', pincode: '686536' },
  { value: 'kaipuzha', label: 'Kaipuzha', pincode: '686141' },
  { value: 'kottayam', label: 'Kottayam', pincode: '686001' },
  { value: 'mannar', label: 'Mannar', pincode: '686578' },
  { value: 'muvattupuzha', label: 'Muvattupuzha', pincode: '686661' },
  { value: 'punnamada', label: 'Punnamada', pincode: '686039' },
  { value: 'vaikom', label: 'Vaikom', pincode: '686141' },
  { value: 'varapuzha', label: 'Varapuzha', pincode: '686102' },
  { value: 'vengoor', label: 'Vengoor', pincode: '686102' },
  { value: 'cherpunkal', label: 'Cherpunkal', pincode: '686546' },
  { value: 'kallara', label: 'Kallara', pincode: '686632' },
  { value: 'kottarakkara', label: 'Kottarakkara', pincode: '686539' },
  { value: 'pallikkavala', label: 'Pallikkavala', pincode: '686568' },
  { value: 'thalayolaparambu', label: 'Thalayolaparambu', pincode: '686605' }
  ],

  'erattupetta': [
  { value: 'cheruvally', label: 'Cheruvally', pincode: '686121' },
  { value: 'erattupetta', label: 'Erattupetta', pincode: '686121' },
  { value: 'kattappana', label: 'Kattappana', pincode: '686508' },
  { value: 'kottathara', label: 'Kottathara', pincode: '686612' },
  { value: 'mutholy', label: 'Mutholy', pincode: '686530' },
  { value: 'murikkassery', label: 'Murikkassery', pincode: '686553' },
  { value: 'pallikkal', label: 'Pallikkal', pincode: '686125' },
  { value: 'pindimana', label: 'Pindimana', pincode: '686549' },
  { value: 'thodupuzha', label: 'Thodupuzha', pincode: '685584' },
  { value: 'vettikode', label: 'Vettikode', pincode: '686514' },
  { value: 'vagamon', label: 'Vagamon', pincode: '685503' },
  { value: 'veliyannoor', label: 'Veliyannoor', pincode: '686633' },
  { value: 'vazhoor', label: 'Vazhoor', pincode: '686542' }
  ],

  'thrippunithura': [
  { value: 'attur', label: 'Attur', pincode: '682301' },
  { value: 'chottanikkara', label: 'Chottanikkara', pincode: '682313' },
  { value: 'irumpanam', label: 'Irumpanam', pincode: '682309' },
  { value: 'kalamassery', label: 'Kalamassery', pincode: '683104' },
  { value: 'kanayannur', label: 'Kanayannur', pincode: '682011' },
  { value: 'kochi', label: 'Kochi', pincode: '682001' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '682024' },
  { value: 'mulanthuruthy', label: 'Mulanthuruthy', pincode: '682314' },
  { value: 'punnappra', label: 'Punnappra', pincode: '682308' },
  { value: 'thrippunithura', label: 'Thrippunithura', pincode: '682301' },
  { value: 'vandipetta', label: 'Vandipetta', pincode: '682314' },
  { value: 'vallarpadam', label: 'Vallarpadam', pincode: '682504' },
  { value: 'vattiyoorkavu', label: 'Vattiyoorkavu', pincode: '682021' },
  { value: 'kadavanthra', label: 'Kadavanthra', pincode: '682020' },
  { value: 'edappally', label: 'Edappally', pincode: '682024' },
  { value: 'kadavanthra', label: 'Kadavanthra', pincode: '682020' }
  ],

  'wadakkancherry': [
  { value: 'kanjirappally', label: 'Kanjirappally', pincode: '686507' },
  { value: 'kodakara', label: 'Kodakara', pincode: '680684' },
  { value: 'kuruvattoor', label: 'Kuruvattoor', pincode: '680667' },
  { value: 'mankara', label: 'Mankara', pincode: '680602' },
  { value: 'nadathara', label: 'Nadathara', pincode: '680751' },
  { value: 'piravam', label: 'Piravam', pincode: '682312' },
  { value: 'tanalur', label: 'Tanalur', pincode: '680589' },
  { value: 'vadakkancherry', label: 'Vadakkancherry', pincode: '680582' },
  { value: 'valapad', label: 'Valapad', pincode: '680567' },
  { value: 'vellikulangara', label: 'Vellikulangara', pincode: '680590' },
  { value: 'pudukkad', label: 'Pudukkad', pincode: '680711' },
  { value: 'kothamangalam', label: 'Kothamangalam', pincode: '680104' },
  { value: 'kallettummal', label: 'Kallettummal', pincode: '680582' },
  { value: 'ichalkaranji', label: 'Ichalkaranji', pincode: '680705' },
  { value: 'thuravoor', label: 'Thuravoor', pincode: '680614' }
  ],

  'tirurangadi': [
  { value: 'angadipuram', label: 'Angadipuram', pincode: '679321' },
  { value: 'edavannapra', label: 'Edavannapra', pincode: '679591' },
  { value: 'kottakkal', label: 'Kottakkal', pincode: '676503' },
  { value: 'kulathur', label: 'Kulathur', pincode: '679586' },
  { value: 'manjeri', label: 'Manjeri', pincode: '676121' },
  { value: 'melmuri', label: 'Melmuri', pincode: '679586' },
  { value: 'nadakkavu', label: 'Nadakkavu', pincode: '679334' },
  { value: 'perinthalmanna', label: 'Perinthalmanna', pincode: '679322' },
  { value: 'tirurangadi', label: 'Tirurangadi', pincode: '676306' },
  { value: 'vadakara', label: 'Vadakara', pincode: '676101' },
  { value: 'cheruvally', label: 'Cheruvally', pincode: '679323' },
  { value: 'edappal', label: 'Edappal', pincode: '679576' },
  { value: 'kuttippuram', label: 'Kuttippuram', pincode: '679571' },
  { value: 'parappanangadi', label: 'Parappanangadi', pincode: '676303' },
  { value: 'pudukkad', label: 'Pudukkad', pincode: '676313' },
  { value: 'thiruthiyad', label: 'Thiruthiyad', pincode: '676325' }
  ],

  'muvattupuzha': [
  { value: 'alumthuruth', label: 'Alumthuruth', pincode: '686661' },
  { value: 'changanassery', label: 'Changanassery', pincode: '686501' },
  { value: 'kothamangalam', label: 'Kothamangalam', pincode: '686691' },
  { value: 'kothapra', label: 'Kothapra', pincode: '686671' },
  { value: 'kuruppumpady', label: 'Kuruppumpady', pincode: '686604' },
  { value: 'muvattupuzha', label: 'Muvattupuzha', pincode: '686661' },
  { value: 'mulavoor', label: 'Mulavoor', pincode: '686673' },
  { value: 'nedumbassery', label: 'Nedumbassery', pincode: '683594' },
  { value: 'neriamangalam', label: 'Neriamangalam', pincode: '686693' },
  { value: 'paravur', label: 'Paravur', pincode: '686607' },
  { value: 'pudukkad', label: 'Pudukkad', pincode: '686677' },
  { value: 'thevakkal', label: 'Thevakkal', pincode: '686678' },
  { value: 'thottumukkam', label: 'Thottumukkam', pincode: '686601' },
  { value: 'vengola', label: 'Vengola', pincode: '686671' },
  { value: 'vettikkavala', label: 'Vettikkavala', pincode: '686680' }
  ],

  'pattambi': [
  { value: 'alathur', label: 'Alathur', pincode: '679104' },
  { value: 'chemmad', label: 'Chemmad', pincode: '679535' },
  { value: 'karikulam', label: 'Karikulam', pincode: '679315' },
  { value: 'kuttiyadi', label: 'Kuttiyadi', pincode: '679323' },
  { value: 'muthuvalloor', label: 'Muthuvalloor', pincode: '679306' },
  { value: 'nellaya', label: 'Nellaya', pincode: '679335' },
  { value: 'pattambi', label: 'Pattambi', pincode: '679303' },
  { value: 'perumanna', label: 'Perumanna', pincode: '679309' },
  { value: 'thiruvegapuram', label: 'Thiruvegapuram', pincode: '679303' },
  { value: 'vadakarapathy', label: 'Vadakarapathy', pincode: '679316' },
  { value: 'vengara', label: 'Vengara', pincode: '679584' },
  { value: 'valappad', label: 'Valappad', pincode: '679503' },
  { value: 'thayyil', label: 'Thayyil', pincode: '679310' },
  { value: 'edavoor', label: 'Edavoor', pincode: '679342' }
  ],

  'kochi': [
    { value: 'aluva', label: 'Aluva', pincode: '683101' },
    { value: 'cheranallur', label: 'Cheranallur', pincode: '682034' },
    { value: 'chilavannur', label: 'Chilavannur', pincode: '682020' },
    { value: 'edappally', label: 'Edappally', pincode: '682024' },
    { value: 'ernakulam-north', label: 'Ernakulam North', pincode: '682018' },
    { value: 'ernakulam-south', label: 'Ernakulam South', pincode: '682016' },
    { value: 'fort-kochi', label: 'Fort Kochi', pincode: '682001' },
    { value: 'kadavanthra', label: 'Kadavanthra', pincode: '682020' },
    { value: 'kakkanad', label: 'Kakkanad', pincode: '682030' },
    { value: 'kaloor', label: 'Kaloor', pincode: '682017' },
    { value: 'kanayannur', label: 'Kanayannur', pincode: '682011' },
    { value: 'kothamangalam', label: 'Kothamangalam', pincode: '686691' },
    { value: 'kumbalam', label: 'Kumbalam', pincode: '682506' },
    { value: 'kundannur', label: 'Kundannur', pincode: '682304' },
    { value: 'maradu', label: 'Maradu', pincode: '682304' },
    { value: 'mattancherry', label: 'Mattancherry', pincode: '682002' },
    { value: 'mulavukad', label: 'Mulavukad', pincode: '682504' },
    { value: 'muttar', label: 'Muttar', pincode: '682017' },
    { value: 'palarivattom', label: 'Palarivattom', pincode: '682025' },
    { value: 'panampilly-nagar', label: 'Panampilly Nagar', pincode: '682036' },
    { value: 'puthiyakavu', label: 'Puthiyakavu', pincode: '682313' },
    { value: 'ravipuram', label: 'Ravipuram', pincode: '682016' },
    { value: 'thevara', label: 'Thevara', pincode: '682013' },
    { value: 'thrikkakara', label: 'Thrikkakara', pincode: '682021' },
    { value: 'thripunithura', label: 'Thripunithura', pincode: '682301' },
    { value: 'vaduthala', label: 'Vaduthala', pincode: '682023' },
    { value: 'vallarpadam', label: 'Vallarpadam', pincode: '682029' },
    { value: 'vazhakkala', label: 'Vazhakkala', pincode: '682021' },
    { value: 'vypin', label: 'Vypin', pincode: '682508' },
    { value: 'vytilla', label: 'Vytilla', pincode: '682019' },
    { value: 'willingdon-island', label: 'Willingdon Island', pincode: '682003' },
    { value: 'thoppumpady', label: 'Thoppumpady', pincode: '682005' },
    { value: 'kalamassery', label: 'Kalamassery', pincode: '683104' }
  ],

  'cochin': [
    { value: 'aluva', label: 'Aluva', pincode: '683101' },
    { value: 'cheranallur', label: 'Cheranallur', pincode: '682034' },
    { value: 'chilavannur', label: 'Chilavannur', pincode: '682020' },
    { value: 'edappally', label: 'Edappally', pincode: '682024' },
    { value: 'ernakulam-north', label: 'Ernakulam North', pincode: '682018' },
    { value: 'ernakulam-south', label: 'Ernakulam South', pincode: '682016' },
    { value: 'fort-kochi', label: 'Fort Kochi', pincode: '682001' },
    { value: 'kadavanthra', label: 'Kadavanthra', pincode: '682020' },
    { value: 'kakkanad', label: 'Kakkanad', pincode: '682030' },
    { value: 'kaloor', label: 'Kaloor', pincode: '682017' },
    { value: 'kanayannur', label: 'Kanayannur', pincode: '682011' },
    { value: 'kothamangalam', label: 'Kothamangalam', pincode: '686691' },
    { value: 'kumbalam', label: 'Kumbalam', pincode: '682506' },
    { value: 'kundannur', label: 'Kundannur', pincode: '682304' },
    { value: 'maradu', label: 'Maradu', pincode: '682304' },
    { value: 'mattancherry', label: 'Mattancherry', pincode: '682002' },
    { value: 'mulavukad', label: 'Mulavukad', pincode: '682504' },
    { value: 'muttar', label: 'Muttar', pincode: '682017' },
    { value: 'palarivattom', label: 'Palarivattom', pincode: '682025' },
    { value: 'panampilly-nagar', label: 'Panampilly Nagar', pincode: '682036' },
    { value: 'puthiyakavu', label: 'Puthiyakavu', pincode: '682313' },
    { value: 'ravipuram', label: 'Ravipuram', pincode: '682016' },
    { value: 'thevara', label: 'Thevara', pincode: '682013' },
    { value: 'thrikkakara', label: 'Thrikkakara', pincode: '682021' },
    { value: 'thripunithura', label: 'Thripunithura', pincode: '682301' },
    { value: 'vaduthala', label: 'Vaduthala', pincode: '682023' },
    { value: 'vallarpadam', label: 'Vallarpadam', pincode: '682029' },
    { value: 'vazhakkala', label: 'Vazhakkala', pincode: '682021' },
    { value: 'vypin', label: 'Vypin', pincode: '682508' },
    { value: 'vytilla', label: 'Vytilla', pincode: '682019' },
    { value: 'willingdon-island', label: 'Willingdon Island', pincode: '682003' },
    { value: 'thoppumpady', label: 'Thoppumpady', pincode: '682005' },
    { value: 'kalamassery', label: 'Kalamassery', pincode: '683104' }
  ],
  'kozhikode': [
    { value: 'aranhikkal', label: 'Aranhikkal', pincode: '673008' },
    { value: 'beypore', label: 'Beypore', pincode: '673015' },
    { value: 'cheekkilode', label: 'Cheekkilode', pincode: '673315' },
    { value: 'cheruvannur', label: 'Cheruvannur', pincode: '673027' },
    { value: 'chevayur', label: 'Chevayur', pincode: '673017' },
    { value: 'elathur', label: 'Elathur', pincode: '673303' },
    { value: 'feroke', label: 'Feroke', pincode: '673631' },
    { value: 'iruvazhinji', label: 'Iruvazhinji', pincode: '673585' },
    { value: 'kallai', label: 'Kallai', pincode: '673003' },
    { value: 'karaparamba', label: 'Karaparamba', pincode: '673010' },
    { value: 'kinalur', label: 'Kinalur', pincode: '673612' },
    { value: 'kozhikode-beach', label: 'Kozhikode Beach', pincode: '673032' },
    { value: 'kozhikode-town', label: 'Kozhikode Town', pincode: '673001' },
    { value: 'kunduparamba', label: 'Kunduparamba', pincode: '673009' },
    { value: 'kuttichira', label: 'Kuttichira', pincode: '673001' },
    { value: 'mankavu', label: 'Mankavu', pincode: '673007' },
    { value: 'marad', label: 'Marad', pincode: '673019' },
    { value: 'meenchanda', label: 'Meenchanda', pincode: '673018' },
    { value: 'nadakkavu', label: 'Nadakkavu', pincode: '673011' },
    { value: 'nallalam', label: 'Nallalam', pincode: '673027' },
    { value: 'panniyankara', label: 'Panniyankara', pincode: '673003' },
    { value: 'parayancheri', label: 'Parayancheri', pincode: '673016' },
    { value: 'pavangad', label: 'Pavangad', pincode: '673021' },
    { value: 'poovattuparamba', label: 'Poovattuparamba', pincode: '673008' },
    { value: 'thalakulathur', label: 'Thalakulathur', pincode: '673317' },
    { value: 'thondayad', label: 'Thondayad', pincode: '673016' },
    { value: 'vadakara', label: 'Vadakara', pincode: '673101' },
    { value: 'vellayil', label: 'Vellayil', pincode: '673011' },
    { value: 'vellimadukunnu', label: 'Vellimadukunnu', pincode: '673012' },
    { value: 'west-hill', label: 'West Hill', pincode: '673005' }
  ],

  'calicut': [
    { value: 'aranhikkal', label: 'Aranhikkal', pincode: '673008' },
    { value: 'beypore', label: 'Beypore', pincode: '673015' },
    { value: 'cheekkilode', label: 'Cheekkilode', pincode: '673315' },
    { value: 'cheruvannur', label: 'Cheruvannur', pincode: '673027' },
    { value: 'chevayur', label: 'Chevayur', pincode: '673017' },
    { value: 'elathur', label: 'Elathur', pincode: '673303' },
    { value: 'feroke', label: 'Feroke', pincode: '673631' },
    { value: 'iruvazhinji', label: 'Iruvazhinji', pincode: '673585' },
    { value: 'kallai', label: 'Kallai', pincode: '673003' },
    { value: 'karaparamba', label: 'Karaparamba', pincode: '673010' },
    { value: 'kinalur', label: 'Kinalur', pincode: '673612' },
    { value: 'kozhikode-beach', label: 'Kozhikode Beach', pincode: '673032' },
    { value: 'kozhikode-town', label: 'Kozhikode Town', pincode: '673001' },
    { value: 'kunduparamba', label: 'Kunduparamba', pincode: '673009' },
    { value: 'kuttichira', label: 'Kuttichira', pincode: '673001' },
    { value: 'mankavu', label: 'Mankavu', pincode: '673007' },
    { value: 'marad', label: 'Marad', pincode: '673019' },
    { value: 'meenchanda', label: 'Meenchanda', pincode: '673018' },
    { value: 'nadakkavu', label: 'Nadakkavu', pincode: '673011' },
    { value: 'nallalam', label: 'Nallalam', pincode: '673027' },
    { value: 'panniyankara', label: 'Panniyankara', pincode: '673003' },
    { value: 'parayancheri', label: 'Parayancheri', pincode: '673016' },
    { value: 'pavangad', label: 'Pavangad', pincode: '673021' },
    { value: 'poovattuparamba', label: 'Poovattuparamba', pincode: '673008' },
    { value: 'thalakulathur', label: 'Thalakulathur', pincode: '673317' },
    { value: 'thondayad', label: 'Thondayad', pincode: '673016' },
    { value: 'vadakara', label: 'Vadakara', pincode: '673101' },
    { value: 'vellayil', label: 'Vellayil', pincode: '673011' },
    { value: 'vellimadukunnu', label: 'Vellimadukunnu', pincode: '673012' },
    { value: 'west-hill', label: 'West Hill', pincode: '673005' }
  ],

  // Uttar-Pradesh Areas
  'gorakhpur': [
    { value: 'alampur', label: 'Alampur', pincode: '273001' },
    { value: 'bansgaon', label: 'Bansgaon', pincode: '273402' },
    { value: 'bharwaliya', label: 'Bharwaliya', pincode: '273016' },
    { value: 'chiraiya', label: 'Chiraiya', pincode: '273010' },
    { value: 'gorakhpur', label: 'Gorakhpur', pincode: '273001' },
    { value: 'hajipur', label: 'Hajipur', pincode: '273152' },
    { value: 'jahanaganj', label: 'Jahanaganj', pincode: '273124' },
    { value: 'kaitholi', label: 'Kaitholi', pincode: '273001' },
    { value: 'kapurpur', label: 'Kapurpur', pincode: '273150' },
    { value: 'kushinagar', label: 'Kushinagar', pincode: '273004' },
    { value: 'mahadeva', label: 'Mahadeva', pincode: '273160' },
    { value: 'maniram', label: 'Maniram', pincode: '273006' },
    { value: 'mukundapur', label: 'Mukundapur', pincode: '273015' },
    { value: 'narkatia', label: 'Narkatia', pincode: '273005' },
    { value: 'pallia', label: 'Pallia', pincode: '273201' },
    { value: 'panchgachia', label: 'Panchgachia', pincode: '273010' },
    { value: 'sahjanwa', label: 'Sahjanwa', pincode: '273201' },
    { value: 'siddhartha-nagar', label: 'Siddhartha Nagar', pincode: '273155' },
    { value: 'taramandal', label: 'Taramandal', pincode: '273016' },
    { value: 'tikari', label: 'Tikari', pincode: '273025' },
    { value: 'buxar', label: 'Buxar', pincode: '273007' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '273014' },
    { value: 'dih', label: 'Dih', pincode: '273019' },
    { value: 'dumari', label: 'Dumari', pincode: '273005' },
    { value: 'durga-pur', label: 'Durga Pur', pincode: '273010' },
    { value: 'ganeshpur', label: 'Ganeshpur', pincode: '273004' },
    { value: 'khanpur', label: 'Khanpur', pincode: '273001' },
    { value: 'khushalganj', label: 'Khushalganj', pincode: '273208' },
    { value: 'kosi', label: 'Kosi', pincode: '273160' },
    { value: 'madhurapur', label: 'Madhurapur', pincode: '273156' },
    { value: 'mohaddipur', label: 'Mohaddipur', pincode: '273010' },
    { value: 'nagla', label: 'Nagla', pincode: '273108' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '273107' },
    { value: 'rajarampur', label: 'Rajarampur', pincode: '273006' },
    { value: 'sajhawan', label: 'Sajhawan', pincode: '273200' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '273008' },
    { value: 'tanda', label: 'Tanda', pincode: '273011' },
    { value: 'amarpur', label: 'Amarpur', pincode: '273027' },
    { value: 'bahadurpur', label: 'Bahadurpur', pincode: '273007' },
    { value: 'bahraich', label: 'Bahraich', pincode: '273033' },
    { value: 'bhidiya', label: 'Bhidiya', pincode: '273201' },
    { value: 'chakrapanpur', label: 'Chakrapanpur', pincode: '273107' },
    { value: 'gopalpur', label: 'Gopalpur', pincode: '273165' },
    { value: 'kaptanganj', label: 'Kaptanganj', pincode: '273302' },
    { value: 'manjholi', label: 'Manjholi', pincode: '273008' },
    { value: 'murli', label: 'Murli', pincode: '273202' },
    { value: 'pachrukhia', label: 'Pachrukhia', pincode: '273006' },
    { value: 'rauli', label: 'Rauli', pincode: '273110' },
    { value: 'sandra', label: 'Sandra', pincode: '273202' },
    { value: 'sardarnagar', label: 'Sardarnagar', pincode: '273001' },
    { value: 'satra', label: 'Satra', pincode: '273203' },
    { value: 'sinduria', label: 'Sinduria', pincode: '273022' },
    { value: 'tapra', label: 'Tapra', pincode: '273019' },
    { value: 'tijara', label: 'Tijara', pincode: '273005' }
    ],
    
    
    'jaunpur': [
    { value: 'abadpura', label: 'Abadpura', pincode: '222001' },
    { value: 'akbarpur', label: 'Akbarpur', pincode: '222202' },
    { value: 'bakhara', label: 'Bakhara', pincode: '222133' },
    { value: 'babatpur', label: 'Babatpur', pincode: '222145' },
    { value: 'baharipur', label: 'Baharipur', pincode: '222170' },
    { value: 'bhitri', label: 'Bhitri', pincode: '222102' },
    { value: 'chatri', label: 'Chatri', pincode: '222155' },
    { value: 'gora-bazar', label: 'Gora Bazar', pincode: '222002' },
    { value: 'hanumanganj', label: 'Hanumanganj', pincode: '222129' },
    { value: 'haraiya', label: 'Haraiya', pincode: '222157' },
    { value: 'jaunpur-city', label: 'Jaunpur City', pincode: '222001' },
    { value: 'jaunpur-railway-station', label: 'Jaunpur Railway Station', pincode: '222003' },
    { value: 'jabalpur', label: 'Jabalpur', pincode: '222124' },
    { value: 'karanpur', label: 'Karanpur', pincode: '222130' },
    { value: 'kotwali', label: 'Kotwali', pincode: '222101' },
    { value: 'mau', label: 'Mau', pincode: '222150' },
    { value: 'mohdabad', label: 'Mohdabad', pincode: '222181' },
    { value: 'nihalpur', label: 'Nihalpur', pincode: '222128' },
    { value: 'purabpur', label: 'Purabpur', pincode: '222165' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '222135' },
    { value: 'sarai-kawali', label: 'Sarai Kawali', pincode: '222180' },
    { value: 'sarpur', label: 'Sarpur', pincode: '222146' },
    { value: 'shekhpur', label: 'Shekhpur', pincode: '222160' },
    { value: 'tilapur', label: 'Tilapur', pincode: '222162' },
    { value: 'vishwanath-pur', label: 'Vishwanath Pur', pincode: '222166' },
    { value: 'ajganwan', label: 'Ajganwan', pincode: '222167' },
    { value: 'azampur', label: 'Azampur', pincode: '222168' },
    { value: 'dariyabad', label: 'Dariyabad', pincode: '222169' },
    { value: 'dhuraini', label: 'Dhuraini', pincode: '222182' },
    { value: 'dumri', label: 'Dumri', pincode: '222173' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '222171' },
    { value: 'jagdishpur', label: 'Jagdishpur', pincode: '222174' },
    { value: 'kadirpur', label: 'Kadirpur', pincode: '222175' },
    { value: 'khairabad', label: 'Khairabad', pincode: '222176' },
    { value: 'kushwahpur', label: 'Kushwahpur', pincode: '222177' },
    { value: 'lalganj', label: 'Lalganj', pincode: '222178' },
    { value: 'mahadevpur', label: 'Mahadevpur', pincode: '222179' },
    { value: 'majhgaon', label: 'Majhgaon', pincode: '222185' },
    { value: 'raipura', label: 'Raipura', pincode: '222186' },
    { value: 'ramdhanpur', label: 'Ramdhanpur', pincode: '222187' },
    { value: 'sikraura', label: 'Sikraura', pincode: '222188' },
    { value: 'tikauli', label: 'Tikauli', pincode: '222189' }
    ],
    
    'sitapur': [
    { value: 'azad-nagar', label: 'Azad Nagar', pincode: '261001' },
    { value: 'chhoti-mandi', label: 'Chhoti Mandi', pincode: '261002' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'johar-ganj', label: 'Johar Ganj', pincode: '261003' },
    { value: 'kushal-nagar', label: 'Kushal Nagar', pincode: '261004' },
    { value: 'mau', label: 'Mau', pincode: '261005' },
    { value: 'nawabganj', label: 'Nawabganj', pincode: '261006' },
    { value: 'raja-ka-talab', label: 'Raja Ka Talab', pincode: '261007' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '261008' },
    { value: 'shahabad', label: 'Shahabad', pincode: '261009' },
    { value: 'suryanagar', label: 'Suryanagar', pincode: '261010' },
    { value: 'aliganj', label: 'Aliganj', pincode: '261011' },
    { value: 'balram-pur', label: 'Balram Pur', pincode: '261012' },
    { value: 'bhagat-pur', label: 'Bhagat Pur', pincode: '261013' },
    { value: 'bhojpur', label: 'Bhojpur', pincode: '261014' },
    { value: 'chandpur', label: 'Chandpur', pincode: '261015' },
    { value: 'dhaurhara', label: 'Dhaurhara', pincode: '261016' },
    { value: 'fatehganj', label: 'Fatehganj', pincode: '261017' },
    { value: 'lalpur', label: 'Lalpur', pincode: '261018' },
    { value: 'maurawan', label: 'Maurawan', pincode: '261019' },
    { value: 'nehra', label: 'Nehra', pincode: '261020' },
    { value: 'padari', label: 'Padari', pincode: '261021' },
    { value: 'ramkot', label: 'Ramkot', pincode: '261022' },
    { value: 'rangpur', label: 'Rangpur', pincode: '261023' },
    { value: 'siddhpur', label: 'Siddhpur', pincode: '261024' },
    { value: 'tikra', label: 'Tikra', pincode: '261025' },
    { value: 'udaypur', label: 'Udaypur', pincode: '261026' },
    { value: 'banapur', label: 'Banapur', pincode: '261027' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '261028' },
    { value: 'chhapra', label: 'Chhapra', pincode: '261029' },
    { value: 'chandok', label: 'Chandok', pincode: '261030' },
    { value: 'jaitpura', label: 'Jaitpura', pincode: '261031' },
    { value: 'kakraula', label: 'Kakraula', pincode: '261032' },
    { value: 'kurmuli', label: 'Kurmuli', pincode: '261033' },
    { value: 'mahasu', label: 'Mahasu', pincode: '261034' },
    { value: 'mauganj', label: 'Mauganj', pincode: '261035' },
    { value: 'nawabganj', label: 'Nawabganj', pincode: '261036' },
    { value: 'patshah', label: 'Patshah', pincode: '261037' },
    { value: 'ramganj', label: 'Ramganj', pincode: '261038' },
    { value: 'sidhpur', label: 'Sidhpur', pincode: '261039' },
    { value: 'taharpur', label: 'Taharpur', pincode: '261040' },
    { value: 'vishwanathpur', label: 'Vishwanathpur', pincode: '261041' }
    ],
  
  'ambedkar-nagar': [
  { value: 'adarshnagar', label: 'Adarsh Nagar', pincode: '500045' },
  { value: 'aluva', label: 'Aluva', pincode: '500012' },
  { value: 'barkatpura', label: 'Barkatpura', pincode: '500027' },
  { value: 'basheerbagh', label: 'Basheerbagh', pincode: '500029' },
  { value: 'chikkadpally', label: 'Chikkadpally', pincode: '500020' },
  { value: 'dilshukhnagar', label: 'Dilshukhnagar', pincode: '500060' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kothapet', label: 'Kothapet', pincode: '500060' },
  { value: 'lalaguda', label: 'Lalaguda', pincode: '500017' },
  { value: 'mallapet', label: 'Mallapet', pincode: '500044' },
  { value: 'malkajgiri', label: 'Malkajgiri', pincode: '500047' },
  { value: 'mahabubnagar', label: 'Mahabubnagar', pincode: '500067' },
  { value: 'musheerabad', label: 'Musheerabad', pincode: '500020' },
  { value: 'nampally', label: 'Nampally', pincode: '500001' },
  { value: 'ramgopalpet', label: 'Ramgopalpet', pincode: '500009' },
  { value: 'sultan-bazar', label: 'Sultan Bazar', pincode: '500095' },
  { value: 'trimulgherry', label: 'Trimulgherry', pincode: '500015' },
  { value: 'upper-tank-bund', label: 'Upper Tank Bund', pincode: '500080' },
  { value: 'vikrampuri', label: 'Vikrampuri', pincode: '500016' },
  { value: 'yousufguda', label: 'Yousufguda', pincode: '500045' },
  { value: 'zoo-park', label: 'Zoo Park', pincode: '500020' },
  { value: 'madhapur', label: 'Madhapur', pincode: '500081' },
  { value: 'hyderabad-central', label: 'Hyderabad Central', pincode: '500002' },
  { value: 'kukatpally', label: 'Kukatpally', pincode: '500072' },
  { value: 'banjara-hills', label: 'Banjara Hills', pincode: '500034' },
  { value: 'gachibowli', label: 'Gachibowli', pincode: '500032' },
  { value: 'miyapur', label: 'Miyapur', pincode: '500049' },
  { value: 'panjagutta', label: 'Panjagutta', pincode: '500082' },
  { value: 'somajiguda', label: 'Somajiguda', pincode: '500082' },
  { value: 'jubilee-hills', label: 'Jubilee Hills', pincode: '500033' },
  { value: 'attapur', label: 'Attapur', pincode: '500048' },
  { value: 'balkampet', label: 'Balkampet', pincode: '500018' },
  { value: 'nagole', label: 'Nagole', pincode: '500068' },
  { value: 'alwal', label: 'Alwal', pincode: '500010' },
  { value: 'malkamcheruvu', label: 'Malkamcheruvu', pincode: '500075' },
  { value: 'serilingampally', label: 'Serilingampally', pincode: '500019' }
  ],

  'auraiya': [
  { value: 'ajitpur', label: 'Ajitpur', pincode: '206120' },
  { value: 'amarpur', label: 'Amarpur', pincode: '206122' },
  { value: 'auraiya-city', label: 'Auraiya City', pincode: '206122' },
  { value: 'babatpur', label: 'Babatpur', pincode: '206122' },
  { value: 'barachh', label: 'Barachh', pincode: '206121' },
  { value: 'bhatpur', label: 'Bhatpur', pincode: '206122' },
  { value: 'bhodpur', label: 'Bhodpur', pincode: '206123' },
  { value: 'bihar', label: 'Bihar', pincode: '206121' },
  { value: 'chakkan', label: 'Chakkan', pincode: '206122' },
  { value: 'chakmau', label: 'Chakmau', pincode: '206123' },
  { value: 'dariyapur', label: 'Dariyapur', pincode: '206124' },
  { value: 'dhamrauli', label: 'Dhamrauli', pincode: '206120' },
  { value: 'jagjivanpur', label: 'Jagjivanpur', pincode: '206121' },
  { value: 'jahanpur', label: 'Jahanpur', pincode: '206120' },
  { value: 'jigni', label: 'Jigni', pincode: '206122' },
  { value: 'kakrahi', label: 'Kakrahi', pincode: '206120' },
  { value: 'kheria', label: 'Kheria', pincode: '206122' },
  { value: 'khamri', label: 'Khamri', pincode: '206124' },
  { value: 'kanpur', label: 'Kanpur', pincode: '206121' },
  { value: 'kota', label: 'Kota', pincode: '206123' },
  { value: 'mau', label: 'Mau', pincode: '206122' },
  { value: 'naubasta', label: 'Naubasta', pincode: '206124' },
  { value: 'pali', label: 'Pali', pincode: '206122' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '206121' },
  { value: 'rahatpur', label: 'Rahatpur', pincode: '206123' },
  { value: 'shahpur', label: 'Shahpur', pincode: '206120' },
  { value: 'sikandra', label: 'Sikandra', pincode: '206121' },
  { value: 'sikandarabad', label: 'Sikandarabad', pincode: '206122' },
  { value: 'surajpur', label: 'Surajpur', pincode: '206124' },
  { value: 'tiwra', label: 'Tiwra', pincode: '206120' }
  ],
  
  'baghpat': [
  { value: 'akbarabad', label: 'Akbarabad', pincode: '250601' },
  { value: 'adampur', label: 'Adampur', pincode: '250631' },
  { value: 'ballabpur', label: 'Ballabpur', pincode: '250613' },
  { value: 'banapur', label: 'Banapur', pincode: '250602' },
  { value: 'bhadan', label: 'Bhadan', pincode: '250623' },
  { value: 'chandpur', label: 'Chandpur', pincode: '250628' },
  { value: 'chhapra', label: 'Chhapra', pincode: '250622' },
  { value: 'dhaurahra', label: 'Dhaurahra', pincode: '250631' },
  { value: 'dehri', label: 'Dehri', pincode: '250604' },
  { value: 'garhdi', label: 'Garhdi', pincode: '250610' },
  { value: 'jahanpur', label: 'Jahanpur', pincode: '250601' },
  { value: 'kaithal', label: 'Kaithal', pincode: '250616' },
  { value: 'kheri', label: 'Kheri', pincode: '250612' },
  { value: 'khushalpur', label: 'Khushalpur', pincode: '250615' },
  { value: 'kalwa', label: 'Kalwa', pincode: '250605' },
  { value: 'kisanpur', label: 'Kisanpur', pincode: '250625' },
  { value: 'laxmanpur', label: 'Laxmanpur', pincode: '250602' },
  { value: 'maurawan', label: 'Maurawan', pincode: '250623' },
  { value: 'mangalpur', label: 'Mangalpur', pincode: '250614' },
  { value: 'nangal', label: 'Nangal', pincode: '250629' },
  { value: 'panchpura', label: 'Panchpura', pincode: '250622' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '250607' },
  { value: 'sarsawa', label: 'Sarsawa', pincode: '250610' },
  { value: 'samaspur', label: 'Samaspur', pincode: '250628' },
  { value: 'shahpur', label: 'Shahpur', pincode: '250611' },
  { value: 'shikohabad', label: 'Shikohabad', pincode: '250629' },
  { value: 'singhpura', label: 'Singhpura', pincode: '250609' },
  { value: 'sikandarabad', label: 'Sikandarabad', pincode: '250607' },
  { value: 'taharpur', label: 'Taharpur', pincode: '250626' },
  { value: 'titanpur', label: 'Titanpur', pincode: '250608' },
  { value: 'alampur', label: 'Alampur', pincode: '250610' },
  { value: 'baliyan', label: 'Baliyan', pincode: '250626' },
  { value: 'chandkhera', label: 'Chandkhera', pincode: '250617' },
  { value: 'damdama', label: 'Damdama', pincode: '250614' },
  { value: 'gahara', label: 'Gahara', pincode: '250625' },
  { value: 'harwan', label: 'Harwan', pincode: '250613' },
  { value: 'khera', label: 'Khera', pincode: '250618' },
  { value: 'mandora', label: 'Mandora', pincode: '250616' },
  { value: 'nalhar', label: 'Nalhar', pincode: '250627' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '250609' },
  { value: 'sahdara', label: 'Sahdara', pincode: '250605' },
  { value: 'sawan', label: 'Sawan', pincode: '250623' }
  ],

  'ballia': [
  { value: 'achhura', label: 'Achhura', pincode: '277001' },
  { value: 'bandhi', label: 'Bandhi', pincode: '277001' },
  { value: 'bansdih', label: 'Bansdih', pincode: '277202' },
  { value: 'ballia', label: 'Ballia', pincode: '277001' },
  { value: 'bansar', label: 'Bansar', pincode: '277304' },
  { value: 'belthara', label: 'Belthara', pincode: '277401' },
  { value: 'belthara-road', label: 'Belthara Road', pincode: '277201' },
  { value: 'bhadaura', label: 'Bhadaura', pincode: '277205' },
  { value: 'bhimapar', label: 'Bhimapar', pincode: '277404' },
  { value: 'chhata', label: 'Chhata', pincode: '277102' },
  { value: 'chandpur', label: 'Chandpur', pincode: '277306' },
  { value: 'dobha', label: 'Dobha', pincode: '277303' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'gopiganj', label: 'Gopiganj', pincode: '277302' },
  { value: 'kailah', label: 'Kailah', pincode: '277102' },
  { value: 'manjhi', label: 'Manjhi', pincode: '277301' },
  { value: 'madhopur', label: 'Madhopur', pincode: '277303' },
  { value: 'nagra', label: 'Nagra', pincode: '277301' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '277103' },
  { value: 'rasra', label: 'Rasra', pincode: '277303' },
  { value: 'shahpur', label: 'Shahpur', pincode: '277205' },
  { value: 'sikanderpur', label: 'Sikanderpur', pincode: '277301' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '277208' },
  { value: 'swaroopganj', label: 'Swaroopganj', pincode: '277207' },
  { value: 'tarmasa', label: 'Tarmasa', pincode: '277207' },
  { value: 'udaypur', label: 'Udaypur', pincode: '277001' },
  { value: 'barauli', label: 'Barauli', pincode: '277301' },
  { value: 'deoghat', label: 'Deoghat', pincode: '277402' },
  { value: 'harpur', label: 'Harpur', pincode: '277207' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '277206' },
  { value: 'jhikathi', label: 'Jhikathi', pincode: '277208' },
  { value: 'khandwa', label: 'Khandwa', pincode: '277303' },
  { value: 'kishunpur', label: 'Kishunpur', pincode: '277208' },
  { value: 'paharpur', label: 'Paharpur', pincode: '277206' },
  { value: 'purvapar', label: 'Purvapar', pincode: '277302' },
  { value: 'sikandarpur-bhita', label: 'Sikandarpur Bhita', pincode: '277208' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '277302' }
  ],

  'balrampur': [
  { value: 'akhara', label: 'Akhara', pincode: '271201' },
  { value: 'balrampur', label: 'Balrampur', pincode: '271201' },
  { value: 'bhanpur', label: 'Bhanpur', pincode: '271202' },
  { value: 'bhita', label: 'Bhita', pincode: '271211' },
  { value: 'bikapur', label: 'Bikapur', pincode: '271301' },
  { value: 'bilhaur', label: 'Bilhaur', pincode: '271210' },
  { value: 'chhitauni', label: 'Chhitauni', pincode: '271204' },
  { value: 'chhitarpur', label: 'Chhitarpur', pincode: '271207' },
  { value: 'dankapur', label: 'Dankapur', pincode: '271215' },
  { value: 'gadhwa', label: 'Gadhwa', pincode: '271206' },
  { value: 'gharua', label: 'Gharua', pincode: '271205' },
  { value: 'ghatakesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jagsi', label: 'Jagsi', pincode: '271208' },
  { value: 'kaithwalia', label: 'Kaithwalia', pincode: '271218' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '271210' },
  { value: 'kanharpur', label: 'Kanharpur', pincode: '271203' },
  { value: 'kanspur', label: 'Kanspur', pincode: '271217' },
  { value: 'madhopur', label: 'Madhopur', pincode: '271217' },
  { value: 'mahalgaon', label: 'Mahalgaon', pincode: '271209' },
  { value: 'manjhi', label: 'Manjhi', pincode: '271212' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '271212' },
  { value: 'rampur', label: 'Rampur', pincode: '271214' },
  { value: 'sahjanwa', label: 'Sahjanwa', pincode: '271220' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '271213' },
  { value: 'sonpur', label: 'Sonpur', pincode: '271216' },
  { value: 'sudamapur', label: 'Sudamapur', pincode: '271219' },
  { value: 'taljhari', label: 'Taljhari', pincode: '271204' },
  { value: 'thakurpur', label: 'Thakurpur', pincode: '271205' },
  { value: 'tetri', label: 'Tetri', pincode: '271222' },
  { value: 'ustapur', label: 'Ustapur', pincode: '271223' },
  { value: 'barkhurdih', label: 'Barkhurdih', pincode: '271208' },
  { value: 'chandipur', label: 'Chandipur', pincode: '271221' },
  { value: 'dilwara', label: 'Dilwara', pincode: '271205' },
  { value: 'gangapur', label: 'Gangapur', pincode: '271211' },
  { value: 'gautampur', label: 'Gautampur', pincode: '271222' },
  { value: 'jagganpur', label: 'Jagganpur', pincode: '271220' },
  { value: 'kaithu', label: 'Kaithu', pincode: '271214' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '271219' },
  { value: 'purani-basti', label: 'Purani Basti', pincode: '271216' },
  { value: 'ramgadhwa', label: 'Ramgadhwa', pincode: '271207' },
  { value: 'sohanpur', label: 'Sohanpur', pincode: '271213' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '271211' }
  ],
  
  'budaun': [
  { value: 'achheja', label: 'Achheja', pincode: '243601' },
  { value: 'badaun', label: 'Badaun', pincode: '243601' },
  { value: 'barhapur', label: 'Barhapur', pincode: '243722' },
  { value: 'behat', label: 'Behat', pincode: '243636' },
  { value: 'bhaiyapur', label: 'Bhaiyapur', pincode: '243631' },
  { value: 'bhajanpur', label: 'Bhajanpur', pincode: '243640' },
  { value: 'bilsi', label: 'Bilsi', pincode: '243633' },
  { value: 'chandpur', label: 'Chandpur', pincode: '243621' },
  { value: 'gangujha', label: 'Gangujha', pincode: '243637' },
  { value: 'ganwar', label: 'Ganwar', pincode: '243726' },
  { value: 'kandhla', label: 'Kandhla', pincode: '243641' },
  { value: 'kaushalganj', label: 'Kaushalganj', pincode: '243622' },
  { value: 'kheda', label: 'Kheda', pincode: '243723' },
  { value: 'khudaganj', label: 'Khudaganj', pincode: '243629' },
  { value: 'kosi', label: 'Kosi', pincode: '243627' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '243641' },
  { value: 'mau', label: 'Mau', pincode: '243632' },
  { value: 'nanauta', label: 'Nanauta', pincode: '243635' },
  { value: 'rasoolpur', label: 'Rasoolpur', pincode: '243641' },
  { value: 'shahpur', label: 'Shahpur', pincode: '243626' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '243630' },
  { value: 'shergarh', label: 'Shergarh', pincode: '243728' },
  { value: 'sikandrabad', label: 'Sikandrabad', pincode: '243635' },
  { value: 'toda', label: 'Toda', pincode: '243629' },
  { value: 'udaiyapur', label: 'Udaiyapur', pincode: '243602' },
  { value: 'alapur', label: 'Alapur', pincode: '243620' },
  { value: 'birampur', label: 'Birampur', pincode: '243609' },
  { value: 'bichhiya', label: 'Bichhiya', pincode: '243606' },
  { value: 'chakrampur', label: 'Chakrampur', pincode: '243623' },
  { value: 'chhedi', label: 'Chhedi', pincode: '243604' },
  { value: 'dahdaha', label: 'Dahdaha', pincode: '243607' },
  { value: 'garhiya', label: 'Garhiya', pincode: '243608' },
  { value: 'gilaula', label: 'Gilaula', pincode: '243605' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '243633' },
  { value: 'kesaripur', label: 'Kesaripur', pincode: '243610' },
  { value: 'mawana', label: 'Mawana', pincode: '243611' },
  { value: 'nasirabad', label: 'Nasirabad', pincode: '243612' },
  { value: 'patiala', label: 'Patiala', pincode: '243614' },
  { value: 'pachgaon', label: 'Pachgaon', pincode: '243615' },
  { value: 'patauna', label: 'Patauna', pincode: '243616' },
  { value: 'rasoolpur', label: 'Rasoolpur', pincode: '243617' },
  { value: 'rawatpur', label: 'Rawatpur', pincode: '243618' },
  { value: 'shivgarh', label: 'Shivgarh', pincode: '243619' },
  { value: 'usmanpur', label: 'Usmanpur', pincode: '243622' },
  { value: 'adhirampur', label: 'Adhirampur', pincode: '243601' },
  { value: 'bangarmau', label: 'Bangarmau', pincode: '243622' },
  { value: 'bhakhera', label: 'Bhakhera', pincode: '243626' },
  { value: 'chhatri', label: 'Chhatri', pincode: '243628' },
  { value: 'dariyapur', label: 'Dariyapur', pincode: '243629' },
  { value: 'faridpur', label: 'Faridpur', pincode: '243630' },
  { value: 'gora', label: 'Gora', pincode: '243632' },
  { value: 'jogi purwa', label: 'Jogi Purwa', pincode: '243633' },
  { value: 'kaushampur', label: 'Kaushampur', pincode: '243635' },
  { value: 'kumher', label: 'Kumher', pincode: '243636' },
  { value: 'madnapur', label: 'Madnapur', pincode: '243637' },
  { value: 'mathura', label: 'Mathura', pincode: '243638' },
  { value: 'nalwa', label: 'Nalwa', pincode: '243639' },
  { value: 'pakki', label: 'Pakki', pincode: '243640' },
  { value: 'pachdeora', label: 'Pachdeora', pincode: '243641' },
  { value: 'saiyadpur', label: 'Saiyadpur', pincode: '243642' },
  { value: 'singrauli', label: 'Singrauli', pincode: '243643' },
  { value: 'tundla', label: 'Tundla', pincode: '243644' },
  { value: 'udupur', label: 'Udupur', pincode: '243645' }
  ],


  'chandauli': [
  { value: 'babhni', label: 'Babhni', pincode: '232105' },
  { value: 'barawan', label: 'Barawan', pincode: '232106' },
  { value: 'chakli', label: 'Chakli', pincode: '232102' },
  { value: 'chandpur', label: 'Chandpur', pincode: '232102' },
  { value: 'chanduli', label: 'Chanduli', pincode: '232121' },
  { value: 'dhabu', label: 'Dhabu', pincode: '232110' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '232119' },
  { value: 'godowli', label: 'Godowli', pincode: '232118' },
  { value: 'jaiti', label: 'Jaiti', pincode: '232115' },
  { value: 'kadur', label: 'Kadur', pincode: '232101' },
  { value: 'kaithapur', label: 'Kaithapur', pincode: '232107' },
  { value: 'khamaria', label: 'Khamaria', pincode: '232116' },
  { value: 'khewali', label: 'Khewali', pincode: '232109' },
  { value: 'laherua', label: 'Laherua', pincode: '232112' },
  { value: 'madhopur', label: 'Madhopur', pincode: '232111' },
  { value: 'malda', label: 'Malda', pincode: '232113' },
  { value: 'majhuwa', label: 'Majhuwa', pincode: '232104' },
  { value: 'manakpur', label: 'Manakpur', pincode: '232103' },
  { value: 'marufpur', label: 'Marufpur', pincode: '232108' },
  { value: 'murli', label: 'Murli', pincode: '232114' },
  { value: 'rahnama', label: 'Rahnama', pincode: '232117' },
  { value: 'saiyadpur', label: 'Saiyadpur', pincode: '232120' },
  { value: 'sarai', label: 'Sarai', pincode: '232122' },
  { value: 'shahpur', label: 'Shahpur', pincode: '232123' },
  { value: 'tarapur', label: 'Tarapur', pincode: '232124' },
  { value: 'andharua', label: 'Andharua', pincode: '232125' },
  { value: 'bansipahari', label: 'Bansipahari', pincode: '232126' },
  { value: 'barahi', label: 'Barahi', pincode: '232127' },
  { value: 'bhikhampur', label: 'Bhikhampur', pincode: '232128' },
  { value: 'chakbazar', label: 'Chakbazar', pincode: '232129' },
  { value: 'chhajhauli', label: 'Chhajhauli', pincode: '232130' },
  { value: 'dhobhi', label: 'Dhobhi', pincode: '232131' },
  { value: 'domari', label: 'Domari', pincode: '232132' },
  { value: 'gajkura', label: 'Gajkura', pincode: '232133' },
  { value: 'goshai', label: 'Goshai', pincode: '232134' },
  { value: 'jagmalpur', label: 'Jagmalpur', pincode: '232135' },
  { value: 'janjgir', label: 'Janjgir', pincode: '232136' },
  { value: 'kaithara', label: 'Kaithara', pincode: '232137' },
  { value: 'khamariya', label: 'Khamariya', pincode: '232138' },
  { value: 'khiriya', label: 'Khiriya', pincode: '232139' },
  { value: 'mahmudabad', label: 'Mahmudabad', pincode: '232140' },
  { value: 'manpur', label: 'Manpur', pincode: '232141' },
  { value: 'muradpur', label: 'Muradpur', pincode: '232142' },
  { value: 'pachana', label: 'Pachana', pincode: '232143' },
  { value: 'ramdih', label: 'Ramdih', pincode: '232144' },
  { value: 'ranipur', label: 'Ranipur', pincode: '232145' },
  { value: 'sahpur', label: 'Sahpur', pincode: '232146' },
  { value: 'samarapur', label: 'Samarapur', pincode: '232147' },
  { value: 'sukulpur', label: 'Sukulpur', pincode: '232148' },
  { value: 'tanda', label: 'Tanda', pincode: '232149' }
  ],

  'deoria': [
  { value: 'alapur', label: 'Alapur', pincode: '274204' },
  { value: 'balipur', label: 'Balipur', pincode: '274203' },
  { value: 'banwaripur', label: 'Banwaripur', pincode: '274204' },
  { value: 'bhagalpur', label: 'Bhagalpur', pincode: '274207' },
  { value: 'bhikampur', label: 'Bhikampur', pincode: '274208' },
  { value: 'bhabhanpur', label: 'Bhabhanpur', pincode: '274206' },
  { value: 'chhapra', label: 'Chhapra', pincode: '274205' },
  { value: 'deoria', label: 'Deoria', pincode: '274001' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '274202' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '274103' },
  { value: 'jalalpur', label: 'Jalalpur', pincode: '274105' },
  { value: 'kamrauli', label: 'Kamrauli', pincode: '274202' },
  { value: 'kandharpur', label: 'Kandharpur', pincode: '274301' },
  { value: 'kariya', label: 'Kariya', pincode: '274201' },
  { value: 'kushinagar', label: 'Kushinagar', pincode: '274402' },
  { value: 'madhupur', label: 'Madhupur', pincode: '274204' },
  { value: 'mahipur', label: 'Mahipur', pincode: '274203' },
  { value: 'mirzapur', label: 'Mirzapur', pincode: '274301' },
  { value: 'paraspur', label: 'Paraspur', pincode: '274402' },
  { value: 'ramdattpur', label: 'Ramdattpur', pincode: '274202' },
  { value: 'ramjipur', label: 'Ramjipur', pincode: '274106' },
  { value: 'sadar', label: 'Sadar', pincode: '274005' },
  { value: 'sahpur', label: 'Sahpur', pincode: '274104' },
  { value: 'sandila', label: 'Sandila', pincode: '274106' },
  { value: 'sonar', label: 'Sonar', pincode: '274201' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '274301' },
  { value: 'barwaria', label: 'Barwaria', pincode: '274107' },
  { value: 'belhara', label: 'Belhara', pincode: '274201' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '274204' },
  { value: 'chandpur', label: 'Chandpur', pincode: '274110' },
  { value: 'chaurah', label: 'Chaurah', pincode: '274109' },
  { value: 'domari', label: 'Domari', pincode: '274108' },
  { value: 'islampur', label: 'Islampur', pincode: '274111' },
  { value: 'jajpur', label: 'Jajpur', pincode: '274112' },
  { value: 'kaparwan', label: 'Kaparwan', pincode: '274113' },
  { value: 'khudai', label: 'Khudai', pincode: '274114' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '274115' },
  { value: 'rampur', label: 'Rampur', pincode: '274116' },
  { value: 'sahaspur', label: 'Sahaspur', pincode: '274117' },
  { value: 'saipur', label: 'Saipur', pincode: '274118' },
  { value: 'tarwa', label: 'Tarwa', pincode: '274119' },
  { value: 'tijara', label: 'Tijara', pincode: '274120' },
  { value: 'patelpur', label: 'Patelpur', pincode: '274121' },
  { value: 'purnea', label: 'Purnea', pincode: '274122' },
  { value: 'prakashpur', label: 'Prakashpur', pincode: '274123' },
  { value: 'rajeshpur', label: 'Rajeshpur', pincode: '274124' },
  { value: 'rishipur', label: 'Rishipur', pincode: '274125' },
  { value: 'sankarpur', label: 'Sankarpur', pincode: '274126' },
  { value: 'santoshpur', label: 'Santoshpur', pincode: '274127' },
  { value: 'saraiya', label: 'Saraiya', pincode: '274128' },
  { value: 'sewakpur', label: 'Sewakpur', pincode: '274129' },
  { value: 'sherpur', label: 'Sherpur', pincode: '274130' },
  { value: 'shuklapur', label: 'Shuklapur', pincode: '274131' }
  ],

  'etah': [
  { value: 'aligarh', label: 'Aligarh', pincode: '207001' },
  { value: 'alipur', label: 'Alipur', pincode: '207001' },
  { value: 'aupur', label: 'Aupur', pincode: '207003' },
  { value: 'bahadurganj', label: 'Bahadurganj', pincode: '207243' },
  { value: 'baheri', label: 'Baheri', pincode: '207245' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '207202' },
  { value: 'bhora', label: 'Bhora', pincode: '207204' },
  { value: 'chandpur', label: 'Chandpur', pincode: '207246' },
  { value: 'dehat', label: 'Dehat', pincode: '207248' },
  { value: 'etah', label: 'Etah', pincode: '207001' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '207202' },
  { value: 'hasanpur', label: 'Hasanpur', pincode: '207245' },
  { value: 'jahanpur', label: 'Jahanpur', pincode: '207249' },
  { value: 'jalalpur', label: 'Jalalpur', pincode: '207212' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '207245' },
  { value: 'kandharpur', label: 'Kandharpur', pincode: '207210' },
  { value: 'khurja', label: 'Khurja', pincode: '207202' },
  { value: 'kishanpur', label: 'Kishanpur', pincode: '207202' },
  { value: 'madhupur', label: 'Madhupur', pincode: '207214' },
  { value: 'mahipur', label: 'Mahipur', pincode: '207212' },
  { value: 'manjha', label: 'Manjha', pincode: '207204' },
  { value: 'puranpur', label: 'Puranpur', pincode: '207216' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '207209' },
  { value: 'sadar', label: 'Sadar', pincode: '207001' },
  { value: 'sahaspur', label: 'Sahaspur', pincode: '207202' },
  { value: 'sarai', label: 'Sarai', pincode: '207210' },
  { value: 'shahpur', label: 'Shahpur', pincode: '207246' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '207211' },
  { value: 'balmiki', label: 'Balmiki', pincode: '207247' },
  { value: 'baliyan', label: 'Baliyan', pincode: '207230' },
  { value: 'bastara', label: 'Bastara', pincode: '207237' },
  { value: 'biswa', label: 'Biswa', pincode: '207244' },
  { value: 'chhajlat', label: 'Chhajlat', pincode: '207238' },
  { value: 'chhata', label: 'Chhata', pincode: '207241' },
  { value: 'dhanoli', label: 'Dhanoli', pincode: '207239' },
  { value: 'ganeshpur', label: 'Ganeshpur', pincode: '207242' },
  { value: 'ghatakheda', label: 'Ghatakheda', pincode: '207233' },
  { value: 'gogavan', label: 'Gogavan', pincode: '207240' },
  { value: 'kamala', label: 'Kamala', pincode: '207231' },
  { value: 'madhavpur', label: 'Madhavpur', pincode: '207232' },
  { value: 'nagla', label: 'Nagla', pincode: '207235' },
  { value: 'narauli', label: 'Narauli', pincode: '207236' },
  { value: 'sarauli', label: 'Sarauli', pincode: '207234' },
  { value: 'singrauli', label: 'Singrauli', pincode: '207222' }
  ],

  'etawah': [
  { value: 'aligarh', label: 'Aligarh', pincode: '206001' },
  { value: 'alipur', label: 'Alipur', pincode: '206001' },
  { value: 'bajna', label: 'Bajna', pincode: '206122' },
  { value: 'bahadurpur', label: 'Bahadurpur', pincode: '206121' },
  { value: 'bhind', label: 'Bhind', pincode: '206124' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '206102' },
  { value: 'dehat', label: 'Dehat', pincode: '206126' },
  { value: 'etawah', label: 'Etawah', pincode: '206001' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '206001' },
  { value: 'gokul', label: 'Gokul', pincode: '206106' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '206127' },
  { value: 'kamla', label: 'Kamla', pincode: '206123' },
  { value: 'kandhpur', label: 'Kandhpur', pincode: '206125' },
  { value: 'kheriya', label: 'Kheriya', pincode: '206108' },
  { value: 'madhavganj', label: 'Madhavganj', pincode: '206113' },
  { value: 'mahipur', label: 'Mahipur', pincode: '206121' },
  { value: 'manjhanpur', label: 'Manjhanpur', pincode: '206105' },
  { value: 'purwa', label: 'Purwa', pincode: '206102' },
  { value: 'ramanpur', label: 'Ramanpur', pincode: '206128' },
  { value: 'rampur', label: 'Rampur', pincode: '206107' },
  { value: 'sadar', label: 'Sadar', pincode: '206001' },
  { value: 'sahson', label: 'Sahson', pincode: '206102' },
  { value: 'salempur', label: 'Salempur', pincode: '206110' },
  { value: 'sarai', label: 'Sarai', pincode: '206116' },
  { value: 'shahpur', label: 'Shahpur', pincode: '206104' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '206114' },
  { value: 'bachhpur', label: 'Bachhpur', pincode: '206129' },
  { value: 'bikapur', label: 'Bikapur', pincode: '206130' },
  { value: 'budaun', label: 'Budaun', pincode: '206131' },
  { value: 'chandpur', label: 'Chandpur', pincode: '206132' },
  { value: 'ganeshpur', label: 'Ganeshpur', pincode: '206133' },
  { value: 'jalalpur', label: 'Jalalpur', pincode: '206134' },
  { value: 'khurja', label: 'Khurja', pincode: '206135' },
  { value: 'manjhauli', label: 'Manjhauli', pincode: '206136' },
  { value: 'nagla', label: 'Nagla', pincode: '206137' },
  { value: 'patelganj', label: 'Patelganj', pincode: '206138' },
  { value: 'singhpur', label: 'Singhpur', pincode: '206139' }
  ],

  'faizabad': [
  { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '224001' },
  { value: 'ajgawan', label: 'Ajgawan', pincode: '224135' },
  { value: 'alapur', label: 'Alapur', pincode: '224137' },
  { value: 'bahuara', label: 'Bahuara', pincode: '224211' },
  { value: 'barabanki', label: 'Barabanki', pincode: '224001' },
  { value: 'belwa', label: 'Belwa', pincode: '224116' },
  { value: 'bhitaura', label: 'Bhitaura', pincode: '224126' },
  { value: 'bindwara', label: 'Bindwara', pincode: '224160' },
  { value: 'chak-puri', label: 'Chak Puri', pincode: '224201' },
  { value: 'dahiyawan', label: 'Dahiyawan', pincode: '224116' },
  { value: 'dharmshala', label: 'Dharmshala', pincode: '224211' },
  { value: 'fatehganj', label: 'Fatehganj', pincode: '224119' },
  { value: 'ghazipur', label: 'Ghazipur', pincode: '224105' },
  { value: 'harakapur', label: 'Harakapur', pincode: '224205' },
  { value: 'jagdispur', label: 'Jagdispur', pincode: '224107' },
  { value: 'kanakpur', label: 'Kanakpur', pincode: '224122' },
  { value: 'khichra', label: 'Khichra', pincode: '224135' },
  { value: 'madhopur', label: 'Madhopur', pincode: '224101' },
  { value: 'mankapur', label: 'Mankapur', pincode: '224139' },
  { value: 'manu-bara', label: 'Manu Bara', pincode: '224134' },
  { value: 'mau', label: 'Mau', pincode: '224161' },
  { value: 'nawabganj', label: 'Nawabganj', pincode: '224119' },
  { value: 'pali', label: 'Pali', pincode: '224136' },
  { value: 'rahatganj', label: 'Rahatganj', pincode: '224104' },
  { value: 'raunapur', label: 'Raunapur', pincode: '224162' },
  { value: 'sadar', label: 'Sadar', pincode: '224001' },
  { value: 'shahganj', label: 'Shahganj', pincode: '224155' },
  { value: 'sikanderpur', label: 'Sikanderpur', pincode: '224156' },
  { value: 'tindwara', label: 'Tindwara', pincode: '224104' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '224122' },
  { value: 'umarpur', label: 'Umarpur', pincode: '224120' },
  { value: 'bajhira', label: 'Bajhira', pincode: '224118' },
  { value: 'bichiya', label: 'Bichiya', pincode: '224123' },
  { value: 'chandauli', label: 'Chandauli', pincode: '224165' },
  { value: 'gothra', label: 'Gothra', pincode: '224175' },
  { value: 'kekra', label: 'Kekra', pincode: '224171' },
  { value: 'khepar', label: 'Khepar', pincode: '224170' },
  { value: 'mau-ganj', label: 'Mau Ganj', pincode: '224179' },
  { value: 'ramganj', label: 'Ramganj', pincode: '224175' },
  { value: 'sarai-babu', label: 'Sarai Babu', pincode: '224160' },
  { value: 'shahpur', label: 'Shahpur', pincode: '224169' },
  { value: 'vishwanath', label: 'Vishwanath', pincode: '224150' }
  ],

  'fatehpur': [
  { value: 'alampur', label: 'Alampur', pincode: '212601' },
  { value: 'bahadurpur', label: 'Bahadurpur', pincode: '212642' },
  { value: 'balapur', label: 'Balapur', pincode: '212601' },
  { value: 'bikapur', label: 'Bikapur', pincode: '212625' },
  { value: 'chakmohammadpur', label: 'Chak Mohammadpur', pincode: '212635' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '212601' },
  { value: 'ghataur', label: 'Ghataur', pincode: '212643' },
  { value: 'gokulpur', label: 'Gokulpur', pincode: '212601' },
  { value: 'harbanspur', label: 'Harbanspur', pincode: '212635' },
  { value: 'jajmau', label: 'Jajmau', pincode: '212602' },
  { value: 'kanshiram', label: 'Kanshiram', pincode: '212611' },
  { value: 'khera', label: 'Khera', pincode: '212631' },
  { value: 'khushalpur', label: 'Khushalpur', pincode: '212625' },
  { value: 'mau', label: 'Mau', pincode: '212617' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '212603' },
  { value: 'patelganj', label: 'Patelganj', pincode: '212635' },
  { value: 'rampur', label: 'Rampur', pincode: '212617' },
  { value: 'sadar', label: 'Sadar', pincode: '212601' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '212622' },
  { value: 'sindhunagar', label: 'Sindhunagar', pincode: '212619' },
  { value: 'surajpur', label: 'Surajpur', pincode: '212611' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '212604' },
  { value: 'umrauli', label: 'Umrauli', pincode: '212623' },
  { value: 'adampur', label: 'Adampur', pincode: '212611' },
  { value: 'bariya', label: 'Bariya', pincode: '212615' },
  { value: 'chandpur', label: 'Chandpur', pincode: '212614' },
  { value: 'chakbada', label: 'Chakbada', pincode: '212605' },
  { value: 'fatehpur-bazaar', label: 'Fatehpur Bazaar', pincode: '212617' },
  { value: 'gopalpur', label: 'Gopalpur', pincode: '212609' },
  { value: 'kakwan', label: 'Kakwan', pincode: '212618' },
  { value: 'kashimpur', label: 'Kashimpur', pincode: '212607' },
  { value: 'khajurgaon', label: 'Khajurgaon', pincode: '212620' },
  { value: 'mahirganj', label: 'Mahirganj', pincode: '212621' },
  { value: 'manjhanpur', label: 'Manjhanpur', pincode: '212605' },
  { value: 'nawada', label: 'Nawada', pincode: '212616' },
  { value: 'pachahri', label: 'Pachahri', pincode: '212608' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '212624' }
  ],

  'gautam-buddh-nagar': [
  { value: 'alpha-1', label: 'Alpha 1', pincode: '201301' },
  { value: 'alpha-2', label: 'Alpha 2', pincode: '201303' },
  { value: 'beta-1', label: 'Beta 1', pincode: '201304' },
  { value: 'beta-2', label: 'Beta 2', pincode: '201305' },
  { value: 'bisrakh', label: 'Bisrakh', pincode: '201204' },
  { value: 'chhapparia', label: 'Chhapparia', pincode: '201306' },
  { value: 'dalpatpur', label: 'Dalpatpur', pincode: '201304' },
  { value: 'greater-noida', label: 'Greater Noida', pincode: '201308' },
  { value: 'garh-jain', label: 'Garh Jain', pincode: '201305' },
  { value: 'gn-1', label: 'GN-1', pincode: '201307' },
  { value: 'gn-2', label: 'GN-2', pincode: '201308' },
  { value: 'kasna', label: 'Kasna', pincode: '201308' },
  { value: 'knowledge-park', label: 'Knowledge Park', pincode: '201310' },
  { value: 'maidangarhi', label: 'Maidangarhi', pincode: '201307' },
  { value: 'nithari', label: 'Nithari', pincode: '201304' },
  { value: 'parthala', label: 'Parthala', pincode: '201308' },
  { value: 'saini', label: 'Saini', pincode: '201307' },
  { value: 'sikandrabad', label: 'Sikandrabad', pincode: '201305' },
  { value: 'surajpur', label: 'Surajpur', pincode: '201312' },
  { value: 'taharpur', label: 'Taharpur', pincode: '201301' },
  { value: 'yonkheda', label: 'Yonkheda', pincode: '201301' },
  { value: 'badarpur', label: 'Badarpur', pincode: '201312' },
  { value: 'chhijarsi', label: 'Chhijarsi', pincode: '201301' },
  { value: 'delhi-gate', label: 'Delhi Gate', pincode: '201301' },
  { value: 'dhanori', label: 'Dhanori', pincode: '201307' },
  { value: 'jaganpur', label: 'Jaganpur', pincode: '201308' },
  { value: 'jhajhar', label: 'Jhajhar', pincode: '201306' },
  { value: 'kishanpur', label: 'Kishanpur', pincode: '201308' },
  { value: 'mandhera', label: 'Mandhera', pincode: '201307' },
  { value: 'mehndipur', label: 'Mehndipur', pincode: '201305' },
  { value: 'saini-badarpur', label: 'Saini Badarpur', pincode: '201312' },
  { value: 'shankar-pur', label: 'Shankar Pur', pincode: '201301' },
  { value: 'sudama-pur', label: 'Sudama Pur', pincode: '201305' }
  ],

  'ghazipur': [
  { value: 'alawalpur', label: 'Alawalpur', pincode: '233223' },
  { value: 'bahri', label: 'Bahri', pincode: '233307' },
  { value: 'bansdih', label: 'Bansdih', pincode: '233301' },
  { value: 'ghazipur-city', label: 'Ghazipur City', pincode: '233001' },
  { value: 'ghazipur-khurd', label: 'Ghazipur Khurd', pincode: '233304' },
  { value: 'garh-mau', label: 'Garh Mau', pincode: '233207' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '233229' },
  { value: 'karanpura', label: 'Karanpura', pincode: '233201' },
  { value: 'kuchahra', label: 'Kuchahra', pincode: '233220' },
  { value: 'lajpatnagar', label: 'Lajpatnagar', pincode: '233103' },
  { value: 'mohammadabad', label: 'Mohammadabad', pincode: '233221' },
  { value: 'muradabad', label: 'Muradabad', pincode: '233308' },
  { value: 'rajauli', label: 'Rajauli', pincode: '233224' },
  { value: 'sadar', label: 'Sadar', pincode: '233101' },
  { value: 'sikandarabad', label: 'Sikandarabad', pincode: '233228' },
  { value: 'sukhpur', label: 'Sukhpur', pincode: '233207' },
  { value: 'tarkulwa', label: 'Tarkulwa', pincode: '233213' },
  { value: 'tehri', label: 'Tehri', pincode: '233218' },
  { value: 'vishunpur', label: 'Vishunpur', pincode: '233228' },
  { value: 'zafarpur', label: 'Zafarpur', pincode: '233224' },
  { value: 'babhnauli', label: 'Babhnauli', pincode: '233223' },
  { value: 'chandpur', label: 'Chandpur', pincode: '233225' },
  { value: 'dadri', label: 'Dadri', pincode: '233220' },
  { value: 'gohri', label: 'Gohri', pincode: '233230' },
  { value: 'krishnapur', label: 'Krishnapur', pincode: '233205' },
  { value: 'ladpur', label: 'Ladpur', pincode: '233229' },
  { value: 'manjhanpur', label: 'Manjhanpur', pincode: '233206' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '233208' },
  { value: 'samsherpur', label: 'Samsherpur', pincode: '233214' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '233212' },
  { value: 'thana', label: 'Thana', pincode: '233211' },
  { value: 'tindhua', label: 'Tindhua', pincode: '233209' },
  { value: 'amjora', label: 'Amjora', pincode: '233226' },
  { value: 'belwa', label: 'Belwa', pincode: '233227' },
  { value: 'charapara', label: 'Charapara', pincode: '233210' },
  { value: 'danauli', label: 'Danauli', pincode: '233202' },
  { value: 'gopalpur', label: 'Gopalpur', pincode: '233215' },
  { value: 'itawa', label: 'Itawa', pincode: '233222' },
  { value: 'katka', label: 'Katka', pincode: '233223' },
  { value: 'murtazaabad', label: 'Murtazaabad', pincode: '233217' },
  { value: 'pratappur', label: 'Pratappur', pincode: '233216' }
  ],

  'hardoi': [
  { value: 'akbarpur', label: 'Akbarpur', pincode: '241304' },
  { value: 'gajnera', label: 'Gajnera', pincode: '241302' },
  { value: 'gajraula', label: 'Gajraula', pincode: '241305' },
  { value: 'ghatampur', label: 'Ghatampur', pincode: '241302' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'giria', label: 'Giria', pincode: '241306' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'hassanganj', label: 'Hassanganj', pincode: '241303' },
  { value: 'hardoi', label: 'Hardoi', pincode: '241001' },
  { value: 'jagdevkhera', label: 'Jagdevkhera', pincode: '241310' },
  { value: 'lakshmanpur', label: 'Lakshmanpur', pincode: '241307' },
  { value: 'mahanagar', label: 'Mahanagar', pincode: '241308' },
  { value: 'mau', label: 'Mau', pincode: '241305' },
  { value: 'salamabad', label: 'Salamabad', pincode: '241309' },
  { value: 'shahabad', label: 'Shahabad', pincode: '241302' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '241311' },
  { value: 'tikari', label: 'Tikari', pincode: '241312' },
  { value: 'umra', label: 'Umra', pincode: '241313' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '241314' },
  { value: 'bajhera', label: 'Bajhera', pincode: '241315' },
  { value: 'belamau', label: 'Belamau', pincode: '241316' },
  { value: 'bichhiya', label: 'Bichhiya', pincode: '241317' },
  { value: 'chandpur', label: 'Chandpur', pincode: '241318' },
  { value: 'chhapiya', label: 'Chhapiya', pincode: '241319' },
  { value: 'dalmau', label: 'Dalmau', pincode: '241320' },
  { value: 'dohari', label: 'Dohari', pincode: '241321' },
  { value: 'jalalabad', label: 'Jalalabad', pincode: '241322' },
  { value: 'kaushambi', label: 'Kaushambi', pincode: '241323' },
  { value: 'kila', label: 'Kila', pincode: '241324' },
  { value: 'kundi', label: 'Kundi', pincode: '241325' },
  { value: 'lalpur', label: 'Lalpur', pincode: '241326' },
  { value: 'rampur', label: 'Rampur', pincode: '241327' },
  { value: 'rasulpur', label: 'Rasulpur', pincode: '241328' },
  { value: 'safapur', label: 'Safapur', pincode: '241329' }
  ],

  'jalaun': [
  { value: 'agarwara', label: 'Agarwara', pincode: '285121' },
  { value: 'bailan', label: 'Bailan', pincode: '285123' },
  { value: 'bhognipur', label: 'Bhognipur', pincode: '285131' },
  { value: 'dabra', label: 'Dabra', pincode: '285111' },
  { value: 'ghatampur', label: 'Ghatampur', pincode: '285132' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '285114' },
  { value: 'jalaun', label: 'Jalaun', pincode: '285001' },
  { value: 'kalpi', label: 'Kalpi', pincode: '285201' },
  { value: 'khera', label: 'Khera', pincode: '285133' },
  { value: 'kotra', label: 'Kotra', pincode: '285134' },
  { value: 'mau', label: 'Mau', pincode: '285122' },
  { value: 'moth', label: 'Moth', pincode: '285104' },
  { value: 'rahar', label: 'Rahar', pincode: '285105' },
  { value: 'rath', label: 'Rath', pincode: '285102' },
  { value: 'suwarikala', label: 'Suwarikala', pincode: '285103' },
  { value: 'sumerpur', label: 'Sumerpur', pincode: '285135' },
  { value: 'uncha', label: 'Uncha', pincode: '285136' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '285137' },
  { value: 'adampur', label: 'Adampur', pincode: '285138' },
  { value: 'barachha', label: 'Barachha', pincode: '285139' },
  { value: 'bari', label: 'Bari', pincode: '285140' },
  { value: 'jainpur', label: 'Jainpur', pincode: '285141' },
  { value: 'mahiroli', label: 'Mahiroli', pincode: '285142' },
  { value: 'mandai', label: 'Mandai', pincode: '285143' },
  { value: 'nanauta', label: 'Nanauta', pincode: '285144' },
  { value: 'pachenda', label: 'Pachenda', pincode: '285145' },
  { value: 'palia', label: 'Palia', pincode: '285146' },
  { value: 'pura', label: 'Pura', pincode: '285147' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '285148' }
  ],

  'kannauj': [
  { value: 'akkampur', label: 'Akkampur', pincode: '209725' },
  { value: 'akhpur', label: 'Akhpur', pincode: '209739' },
  { value: 'alampur', label: 'Alampur', pincode: '209751' },
  { value: 'barhpur', label: 'Barhpur', pincode: '209740' },
  { value: 'bhogpur', label: 'Bhogpur', pincode: '209726' },
  { value: 'budaun', label: 'Budaun', pincode: '209741' },
  { value: 'chaurasi', label: 'Chaurasi', pincode: '209727' },
  { value: 'daudpur', label: 'Daudpur', pincode: '209742' },
  { value: 'dhamma', label: 'Dhamma', pincode: '209728' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '209743' },
  { value: 'ganeshpur', label: 'Ganeshpur', pincode: '209744' },
  { value: 'gangauli', label: 'Gangauli', pincode: '209729' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'hariyawan', label: 'Hariyawan', pincode: '209745' },
  { value: 'jauharabad', label: 'Jauharabad', pincode: '209731' },
  { value: 'kachhpur', label: 'Kachhpur', pincode: '209746' },
  { value: 'kannauj', label: 'Kannauj', pincode: '209725' },
  { value: 'karpuri', label: 'Karpuri', pincode: '209732' },
  { value: 'khaspur', label: 'Khaspur', pincode: '209733' },
  { value: 'kila', label: 'Kila', pincode: '209747' },
  { value: 'madanpur', label: 'Madanpur', pincode: '209734' },
  { value: 'malkapur', label: 'Malkapur', pincode: '209735' },
  { value: 'pachpedi', label: 'Pachpedi', pincode: '209748' },
  { value: 'pachenda', label: 'Pachenda', pincode: '209749' },
  { value: 'rahmapur', label: 'Rahmapur', pincode: '209749' },
  { value: 'rajaura', label: 'Rajaura', pincode: '209750' },
  { value: 'shahpur', label: 'Shahpur', pincode: '209736' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '209750' },
  { value: 'tindwari', label: 'Tindwari', pincode: '209737' },
  { value: 'uncha', label: 'Uncha', pincode: '209738' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '209752' },
  { value: 'nagar', label: 'Nagar', pincode: '209753' },
  { value: 'kunda', label: 'Kunda', pincode: '209754' },
  { value: 'chandpur', label: 'Chandpur', pincode: '209755' },
  { value: 'pachhota', label: 'Pachhota', pincode: '209756' }
  ],

  'kanpur-nagar': [
  { value: 'akabarpur', label: 'Akabarpur', pincode: '209304' },
  { value: 'alambagh', label: 'Alambagh', pincode: '208007' },
  { value: 'arrah', label: 'Arrah', pincode: '209206' },
  { value: 'baba-bakhat', label: 'Baba Bakhat', pincode: '209216' },
  { value: 'bithoor', label: 'Bithoor', pincode: '209201' },
  { value: 'barra', label: 'Barra', pincode: '208027' },
  { value: 'chakeri', label: 'Chakeri', pincode: '208008' },
  { value: 'chandrika', label: 'Chandrika', pincode: '208019' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'ganga-pur', label: 'Ganga Pur', pincode: '208027' },
  { value: 'gokulpur', label: 'Gokulpur', pincode: '208005' },
  { value: 'jajmau', label: 'Jajmau', pincode: '208010' },
  { value: 'kanpur', label: 'Kanpur', pincode: '208001' },
  { value: 'kanpur-cantt', label: 'Kanpur Cantt', pincode: '208004' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '208017' },
  { value: 'kachnar', label: 'Kachnar', pincode: '208001' },
  { value: 'kalpi-road', label: 'Kalpi Road', pincode: '208001' },
  { value: 'karra', label: 'Karra', pincode: '209206' },
  { value: 'krishnapuram', label: 'Krishnapuram', pincode: '208021' },
  { value: 'makanpur', label: 'Makanpur', pincode: '208007' },
  { value: 'panki', label: 'Panki', pincode: '208020' },
  { value: 'pandariba', label: 'Pandariba', pincode: '208010' },
  { value: 'phoolbagh', label: 'Phoolbagh', pincode: '208015' },
  { value: 'panki', label: 'Panki', pincode: '208020' },
  { value: 'ramganga', label: 'Ramganga', pincode: '208021' },
  { value: 'rahmapur', label: 'Rahmapur', pincode: '208014' },
  { value: 'ratanlal-nagar', label: 'Ratanlal Nagar', pincode: '208022' },
  { value: 'rawatpur', label: 'Rawatpur', pincode: '208019' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '208001' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '208005' },
  { value: 'shyam-nagar', label: 'Shyam Nagar', pincode: '208011' },
  { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '208010' },
  { value: 'wazirganj', label: 'Wazirganj', pincode: '208002' },
  { value: 'shuklaganj', label: 'Shuklaganj', pincode: '209861' },
  { value: 'mall-road', label: 'Mall Road', pincode: '208001' },
  { value: 'shivpur', label: 'Shivpur', pincode: '208014' },
  { value: 'makhanpur', label: 'Makhanpur', pincode: '208005' },
  { value: 'chakarpur', label: 'Chakarpur', pincode: '209305' },
  { value: 'jagirpur', label: 'Jagirpur', pincode: '208024' },
  { value: 'kunda', label: 'Kunda', pincode: '209204' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '209203' }
  ],

  'kasganj': [
  { value: 'alapur', label: 'Alapur', pincode: '207301' },
  { value: 'bahrauli', label: 'Bahrauli', pincode: '207302' },
  { value: 'bannipur', label: 'Bannipur', pincode: '207303' },
  { value: 'chakarpur', label: 'Chakarpur', pincode: '207314' },
  { value: 'dharampur', label: 'Dharampur', pincode: '207304' },
  { value: 'dhamora', label: 'Dhamora', pincode: '207305' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kasganj', label: 'Kasganj', pincode: '207123' },
  { value: 'khera', label: 'Khera', pincode: '207306' },
  { value: 'kosi', label: 'Kosi', pincode: '207307' },
  { value: 'madhugarh', label: 'Madhugarh', pincode: '207308' },
  { value: 'manjhera', label: 'Manjhera', pincode: '207315' },
  { value: 'nidhpur', label: 'Nidhpur', pincode: '207309' },
  { value: 'patel-nagar', label: 'Patel Nagar', pincode: '207310' },
  { value: 'purwa', label: 'Purwa', pincode: '207311' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '207312' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '207313' },
  { value: 'shahpur', label: 'Shahpur', pincode: '207316' },
  { value: 'talgram', label: 'Talgram', pincode: '207317' },
  { value: 'tughalpur', label: 'Tughalpur', pincode: '207318' },
  { value: 'vishunpur', label: 'Vishunpur', pincode: '207319' },
  { value: 'belpur', label: 'Belpur', pincode: '207320' },
  { value: 'bajhera', label: 'Bajhera', pincode: '207321' },
  { value: 'kailashpur', label: 'Kailashpur', pincode: '207322' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '207323' },
  { value: 'manikpur', label: 'Manikpur', pincode: '207324' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '207325' },
  { value: 'nawada', label: 'Nawada', pincode: '207326' },
  { value: 'ranipur', label: 'Ranipur', pincode: '207327' },
  { value: 'sewakpur', label: 'Sewakpur', pincode: '207328' },
  { value: 'sonpur', label: 'Sonpur', pincode: '207329' }
  ],

  'lakhimpur': [
  { value: 'alampur', label: 'Alampur', pincode: '262701' },
  { value: 'balrampur', label: 'Balrampur', pincode: '262702' },
  { value: 'bhawanipur', label: 'Bhawanipur', pincode: '262703' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '262704' },
  { value: 'chandpur', label: 'Chandpur', pincode: '262705' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'lakhimpur', label: 'Lakhimpur', pincode: '262701' },
  { value: 'manpur', label: 'Manpur', pincode: '262706' },
  { value: 'mithauli', label: 'Mithauli', pincode: '262707' },
  { value: 'mudia', label: 'Mudia', pincode: '262708' },
  { value: 'naugarh', label: 'Naugarh', pincode: '262709' },
  { value: 'nighasan', label: 'Nighasan', pincode: '262710' },
  { value: 'palia', label: 'Palia', pincode: '262711' },
  { value: 'puranpur', label: 'Puranpur', pincode: '262712' },
  { value: 'siswa-bazar', label: 'Siswa Bazar', pincode: '262713' },
  { value: 'taharpur', label: 'Taharpur', pincode: '262714' },
  { value: 'bisenpur', label: 'Bisenpur', pincode: '262715' },
  { value: 'chandni-chowk', label: 'Chandni Chowk', pincode: '262716' },
  { value: 'dandia', label: 'Dandia', pincode: '262717' },
  { value: 'darbara', label: 'Darbara', pincode: '262718' },
  { value: 'dehri', label: 'Dehri', pincode: '262719' },
  { value: 'gularia', label: 'Gularia', pincode: '262720' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '262721' },
  { value: 'keshampur', label: 'Keshampur', pincode: '262722' },
  { value: 'khatoli', label: 'Khatoli', pincode: '262723' },
  { value: 'kuchiyana', label: 'Kuchiyana', pincode: '262724' },
  { value: 'mahadevpur', label: 'Mahadevpur', pincode: '262725' },
  { value: 'manihar', label: 'Manihar', pincode: '262726' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '262727' },
  { value: 'rampur', label: 'Rampur', pincode: '262728' },
  { value: 'saraimeer', label: 'Saraimeer', pincode: '262729' },
  { value: 'sugra', label: 'Sugra', pincode: '262730' },
  { value: 'sultanpur', label: 'Sultanpur', pincode: '262731' },
  { value: 'antpur', label: 'Antpur', pincode: '262732' },
  { value: 'bhagwanpur', label: 'Bhagwanpur', pincode: '262733' },
  { value: 'chakda', label: 'Chakda', pincode: '262734' },
  { value: 'dhamma', label: 'Dhamma', pincode: '262735' },
  { value: 'gudri', label: 'Gudri', pincode: '262736' },
  { value: 'indrapur', label: 'Indrapur', pincode: '262737' },
  { value: 'kakrahiya', label: 'Kakrahiya', pincode: '262738' },
  { value: 'laksmanpur', label: 'Laksmanpur', pincode: '262739' },
  { value: 'mau', label: 'Mau', pincode: '262740' },
  { value: 'raun', label: 'Raun', pincode: '262741' },
  { value: 'sugra', label: 'Sugra', pincode: '262742' }
  ],

  'lalitpur': [
  { value: 'alampur', label: 'Alampur', pincode: '284403' },
  { value: 'badagaon', label: 'Badagaon', pincode: '284402' },
  { value: 'chakrapur', label: 'Chakrapur', pincode: '284404' },
  { value: 'gariyabujurg', label: 'Gariyabujurg', pincode: '284405' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'lalitpur', label: 'Lalitpur', pincode: '284001' },
  { value: 'maholi', label: 'Maholi', pincode: '284406' },
  { value: 'mandwara', label: 'Mandwara', pincode: '284407' },
  { value: 'meharpur', label: 'Meharpur', pincode: '284408' },
  { value: 'narsinghpur', label: 'Narsinghpur', pincode: '284409' },
  { value: 'raibha', label: 'Raibha', pincode: '284410' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '284001' },
  { value: 'sankri', label: 'Sankri', pincode: '284411' },
  { value: 'sehar', label: 'Sehar', pincode: '284412' },
  { value: 'tenduli', label: 'Tenduli', pincode: '284413' },
  { value: 'belabua', label: 'Belabua', pincode: '284414' },
  { value: 'chandpur', label: 'Chandpur', pincode: '284415' },
  { value: 'dehar', label: 'Dehar', pincode: '284416' },
  { value: 'gorai', label: 'Gorai', pincode: '284417' },
  { value: 'gunjain', label: 'Gunjain', pincode: '284418' },
  { value: 'kharela', label: 'Kharela', pincode: '284419' },
  { value: 'lalsarai', label: 'Lalsarai', pincode: '284420' },
  { value: 'manjhan', label: 'Manjhan', pincode: '284421' },
  { value: 'mau', label: 'Mau', pincode: '284422' },
  { value: 'rahtal', label: 'Rahtal', pincode: '284423' },
  { value: 'ramkhera', label: 'Ramkhera', pincode: '284424' },
  { value: 'rangapur', label: 'Rangapur', pincode: '284425' },
  { value: 'sirsama', label: 'Sirsama', pincode: '284426' },
  { value: 'shankarpur', label: 'Shankarpur', pincode: '284427' },
  { value: 'surajpur', label: 'Surajpur', pincode: '284428' }
  ],

  'maharajganj': [
  { value: 'amwa', label: 'Amwa', pincode: '273417' },
  { value: 'barhaj', label: 'Barhaj', pincode: '273402' },
  { value: 'barpeta', label: 'Barpeta', pincode: '273430' },
  { value: 'belbari', label: 'Belbari', pincode: '273418' },
  { value: 'bhogpur', label: 'Bhogpur', pincode: '273404' },
  { value: 'barmau', label: 'Barmau', pincode: '273419' },
  { value: 'chakrapur', label: 'Chakrapur', pincode: '273431' },
  { value: 'chhitauni', label: 'Chhitauni', pincode: '273405' },
  { value: 'deoria', label: 'Deoria', pincode: '273420' },
  { value: 'dhuriyari', label: 'Dhuriyari', pincode: '273406' },
  { value: 'garkha', label: 'Garkha', pincode: '273407' },
  { value: 'gangauli', label: 'Gangauli', pincode: '273421' },
  { value: 'gundwa', label: 'Gundwa', pincode: '273422' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '273423' },
  { value: 'kanhauli', label: 'Kanhauli', pincode: '273408' },
  { value: 'khurhuli', label: 'Khurhuli', pincode: '273424' },
  { value: 'kushhupur', label: 'Kushhupur', pincode: '273409' },
  { value: 'maharajganj', label: 'Maharajganj', pincode: '273303' },
  { value: 'manjha', label: 'Manjha', pincode: '273410' },
  { value: 'mudapur', label: 'Mudapur', pincode: '273411' },
  { value: 'madhopur', label: 'Madhopur', pincode: '273425' },
  { value: 'nagar-purani', label: 'Nagar Purani', pincode: '273412' },
  { value: 'pachperwa', label: 'Pachperwa', pincode: '273413' },
  { value: 'pachgachhia', label: 'Pachgachhia', pincode: '273426' },
  { value: 'rampur', label: 'Rampur', pincode: '273414' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '273427' },
  { value: 'siddharthpur', label: 'Siddharthpur', pincode: '273415' },
  { value: 'sirsia', label: 'Sirsia', pincode: '273428' },
  { value: 'sitapur', label: 'Sitapur', pincode: '273429' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '273416' }
  ],

  'mahoba': [
  { value: 'arjunpur', label: 'Arjunpur', pincode: '210427' },
  { value: 'bahadurpur', label: 'Bahadurpur', pincode: '210428' },
  { value: 'banshi', label: 'Banshi', pincode: '210429' },
  { value: 'baragaon', label: 'Baragaon', pincode: '210430' },
  { value: 'chandpur', label: 'Chandpur', pincode: '210431' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khadepur', label: 'Khadepur', pincode: '210432' },
  { value: 'kharkhari', label: 'Kharkhari', pincode: '210433' },
  { value: 'mahoba', label: 'Mahoba', pincode: '210427' },
  { value: 'madhavgarh', label: 'Madhavgarh', pincode: '210434' },
  { value: 'mau', label: 'Mau', pincode: '210435' },
  { value: 'naugaon', label: 'Naugaon', pincode: '210436' },
  { value: 'patara', label: 'Patara', pincode: '210437' },
  { value: 'rahmapur', label: 'Rahmapur', pincode: '210438' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '210439' },
  { value: 'sarai', label: 'Sarai', pincode: '210440' },
  { value: 'tenduli', label: 'Tenduli', pincode: '210441' },
  { value: 'babhnauli', label: 'Babhnauli', pincode: '210442' },
  { value: 'bhikampur', label: 'Bhikampur', pincode: '210443' },
  { value: 'bishunpura', label: 'Bishunpura', pincode: '210444' },
  { value: 'dehad', label: 'Dehad', pincode: '210445' },
  { value: 'dhimra', label: 'Dhimra', pincode: '210446' },
  { value: 'khirai', label: 'Khirai', pincode: '210447' },
  { value: 'manjhan', label: 'Manjhan', pincode: '210448' },
  { value: 'mau-purani', label: 'Mau Purani', pincode: '210449' },
  { value: 'raja-ka-purva', label: 'Raja Ka Purva', pincode: '210450' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '210451' },
  { value: 'sakala', label: 'Sakala', pincode: '210452' },
  { value: 'sarsai', label: 'Sarsai', pincode: '210453' }
  ],

  'mainpuri': [
  { value: 'agrahar', label: 'Agrahar', pincode: '205001' },
  { value: 'arwa', label: 'Arwa', pincode: '205002' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '205003' },
  { value: 'chakbani', label: 'Chakbani', pincode: '205004' },
  { value: 'dhamra', label: 'Dhamra', pincode: '205005' },
  { value: 'dhanupur', label: 'Dhanupur', pincode: '205006' },
  { value: 'ghatkauli', label: 'Ghatkauli', pincode: '205007' },
  { value: 'jamalpur', label: 'Jamalpur', pincode: '205008' },
  { value: 'kaithwari', label: 'Kaithwari', pincode: '205009' },
  { value: 'katora', label: 'Katora', pincode: '205010' },
  { value: 'kotra', label: 'Kotra', pincode: '205011' },
  { value: 'mainpuri', label: 'Mainpuri', pincode: '205012' },
  { value: 'mahalgaon', label: 'Mahalgaon', pincode: '205013' },
  { value: 'madhpur', label: 'Madhpur', pincode: '205014' },
  { value: 'mohammadabad', label: 'Mohammadabad', pincode: '205015' },
  { value: 'puranpur', label: 'Puranpur', pincode: '205016' },
  { value: 'sadarpur', label: 'Sadarpur', pincode: '205017' },
  { value: 'sarsi', label: 'Sarsi', pincode: '205018' },
  { value: 'sarai', label: 'Sarai', pincode: '205019' },
  { value: 'satrana', label: 'Satrana', pincode: '205020' },
  { value: 'sirsari', label: 'Sirsari', pincode: '205021' },
  { value: 'tatarpur', label: 'Tatarpur', pincode: '205022' },
  { value: 'tarwan', label: 'Tarwan', pincode: '205023' },
  { value: 'thakuran', label: 'Thakuran', pincode: '205024' },
  { value: 'unchauli', label: 'Unchauli', pincode: '205025' },
  { value: 'wazirpur', label: 'Wazirpur', pincode: '205026' }
  ],

  'mau': [
  { value: 'adampur', label: 'Adampur', pincode: '275101' },
  { value: 'akbarpur', label: 'Akbarpur', pincode: '275102' },
  { value: 'alapur', label: 'Alapur', pincode: '275103' },
  { value: 'ambedkar-nagar', label: 'Ambedkar Nagar', pincode: '275104' },
  { value: 'bhikampur', label: 'Bhikampur', pincode: '275105' },
  { value: 'bhandariya', label: 'Bhandariya', pincode: '275106' },
  { value: 'chakjadhav', label: 'Chak Jadhav', pincode: '275107' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '275108' },
  { value: 'dharmapur', label: 'Dharmapur', pincode: '275109' },
  { value: 'gangauli', label: 'Gangauli', pincode: '275110' },
  { value: 'garhi', label: 'Garhi', pincode: '275111' },
  { value: 'gothwa', label: 'Gothwa', pincode: '275112' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '275113' },
  { value: 'kasimpur', label: 'Kasimpur', pincode: '275114' },
  { value: 'katora', label: 'Katora', pincode: '275115' },
  { value: 'kota', label: 'Kota', pincode: '275116' },
  { value: 'mau', label: 'Mau', pincode: '275117' },
  { value: 'mau-azizpur', label: 'Mau Azizpur', pincode: '275118' },
  { value: 'mau-nawada', label: 'Mau Nawada', pincode: '275119' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '275120' },
  { value: 'pachdevra', label: 'Pachdevra', pincode: '275121' },
  { value: 'raipura', label: 'Raipura', pincode: '275122' },
  { value: 'rajpur', label: 'Rajpur', pincode: '275123' },
  { value: 'sidhpura', label: 'Sidhpura', pincode: '275124' },
  { value: 'sonpur', label: 'Sonpur', pincode: '275125' },
  { value: 'sudampur', label: 'Sudampur', pincode: '275126' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '275127' },
  { value: 'udaypur', label: 'Udaypur', pincode: '275128' },
  { value: 'vishunpur', label: 'Vishunpur', pincode: '275129' }
  ],


  'pilibhit': [
  { value: 'alampur', label: 'Alampur', pincode: '262001' },
  { value: 'ashoknagar', label: 'Ashoknagar', pincode: '262002' },
  { value: 'bhagatpur', label: 'Bhagatpur', pincode: '262003' },
  { value: 'bilsanda', label: 'Bilsanda', pincode: '262201' },
  { value: 'chakdah', label: 'Chakdah', pincode: '262004' },
  { value: 'chandanpur', label: 'Chandanpur', pincode: '262005' },
  { value: 'chandpur', label: 'Chandpur', pincode: '262006' },
  { value: 'chhitauni', label: 'Chhitauni', pincode: '262007' },
  { value: 'dandkhora', label: 'Dandkhora', pincode: '262008' },
  { value: 'ghatampur', label: 'Ghatampur', pincode: '262009' },
  { value: 'gularia', label: 'Gularia', pincode: '262010' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '262011' },
  { value: 'kailashpur', label: 'Kailashpur', pincode: '262012' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '262013' },
  { value: 'mahapur', label: 'Mahapur', pincode: '262014' },
  { value: 'madhupur', label: 'Madhupur', pincode: '262015' },
  { value: 'maujpur', label: 'Maujpur', pincode: '262016' },
  { value: 'pilibhit', label: 'Pilibhit', pincode: '262017' },
  { value: 'purani-bazaar', label: 'Purani Bazaar', pincode: '262018' },
  { value: 'raipur', label: 'Raipur', pincode: '262019' },
  { value: 'raitha', label: 'Raitha', pincode: '262020' },
  { value: 'rangpur', label: 'Rangpur', pincode: '262021' },
  { value: 'sahjanwan', label: 'Sahjanwan', pincode: '262022' },
  { value: 'sarsawan', label: 'Sarsawan', pincode: '262023' },
  { value: 'shekhpur', label: 'Shekhpur', pincode: '262024' },
  { value: 'shivnagar', label: 'Shivnagar', pincode: '262025' },
  { value: 'taraon', label: 'Taraon', pincode: '262026' },
  { value: 'bansgaon', label: 'Bansgaon', pincode: '262027' },
  { value: 'belaheri', label: 'Belaheri', pincode: '262028' },
  { value: 'dharmpur', label: 'Dharmpur', pincode: '262029' },
  { value: 'bihpuria', label: 'Bihpuria', pincode: '262030' },
  { value: 'gorkhi', label: 'Gorkhi', pincode: '262031' },
  { value: 'lakhimpur', label: 'Lakhimpur', pincode: '262032' },
  { value: 'motipur', label: 'Motipur', pincode: '262033' },
  { value: 'durgapur', label: 'Durgapur', pincode: '262034' },
  { value: 'baheri', label: 'Baheri', pincode: '262035' },
  { value: 'hasanpur', label: 'Hasanpur', pincode: '262036' }
  ],

  'pratapgarh.': [
  { value: 'adarshnagar', label: 'Adarsh Nagar', pincode: '230001' },
  { value: 'alapur', label: 'Alapur', pincode: '230002' },
  { value: 'barwan', label: 'Barwan', pincode: '230003' },
  { value: 'bela', label: 'Bela', pincode: '230004' },
  { value: 'chakda', label: 'Chakda', pincode: '230005' },
  { value: 'chakjagdish', label: 'Chak Jagdish', pincode: '230006' },
  { value: 'gokulpur', label: 'Gokulpur', pincode: '230007' },
  { value: 'ghai', label: 'Ghai', pincode: '230008' },
  { value: 'gharama', label: 'Gharama', pincode: '230009' },
  { value: 'kaitha', label: 'Kaitha', pincode: '230010' },
  { value: 'kandwa', label: 'Kandwa', pincode: '230011' },
  { value: 'mahadewa', label: 'Mahadewa', pincode: '230012' },
  { value: 'malikpur', label: 'Malikpur', pincode: '230013' },
  { value: 'manikpur', label: 'Manikpur', pincode: '230014' },
  { value: 'mau', label: 'Mau', pincode: '230015' },
  { value: 'pachnaur', label: 'Pachnaur', pincode: '230016' },
  { value: 'paraspur', label: 'Paraspur', pincode: '230017' },
  { value: 'pratapgarh', label: 'Pratapgarh', pincode: '230018' },
  { value: 'purwa', label: 'Purwa', pincode: '230019' },
  { value: 'rajarampur', label: 'Rajarampur', pincode: '230020' },
  { value: 'rajaram', label: 'Rajarama', pincode: '230021' },
  { value: 'rathour', label: 'Rathour', pincode: '230022' },
  { value: 'sahadatganj', label: 'Sahadatganj', pincode: '230023' },
  { value: 'sarai', label: 'Sarai', pincode: '230024' },
  { value: 'santoshpur', label: 'Santoshpur', pincode: '230025' },
  { value: 'telauli', label: 'Telauli', pincode: '230026' },
  { value: 'bansgaon', label: 'Bansgaon', pincode: '230027' },
  { value: 'biharpur', label: 'Biharpur', pincode: '230028' },
  { value: 'dhekua', label: 'Dhekua', pincode: '230029' },
  { value: 'dharmpur', label: 'Dharmpur', pincode: '230030' },
  { value: 'khetanpur', label: 'Khetanpur', pincode: '230031' },
  { value: 'kumarwa', label: 'Kumarwa', pincode: '230032' },
  { value: 'loharpur', label: 'Loharpur', pincode: '230033' },
  { value: 'maihar', label: 'Maihar', pincode: '230034' },
  { value: 'manikapur', label: 'Manikapur', pincode: '230035' },
  { value: 'rajjapur', label: 'Rajjapur', pincode: '230036' },
  { value: 'rahmapur', label: 'Rahmapur', pincode: '230037' }
  ],

  'siddharthnagar': [
  { value: 'alwal', label: 'Alwal', pincode: '500010' },
  { value: 'banjara-hills', label: 'Banjara Hills', pincode: '500034' },
  { value: 'bhayander', label: 'Bhayander', pincode: '401101' },
  { value: 'burhanpur', label: 'Burhanpur', pincode: '450331' },
  { value: 'dahisar', label: 'Dahisar', pincode: '400068' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khatali', label: 'Khatali', pincode: '500060' },
  { value: 'kothapet', label: 'Kothapet', pincode: '500035' },
  { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '500062' },
  { value: 'madhapur', label: 'Madhapur', pincode: '500081' },
  { value: 'malakpet', label: 'Malakpet', pincode: '500036' },
  { value: 'nagole', label: 'Nagole', pincode: '500035' },
  { value: 'nallakunta', label: 'Nallakunta', pincode: '500044' },
  { value: 'patancheru', label: 'Patancheru', pincode: '502319' },
  { value: 'rahat-basti', label: 'Rahat Basti', pincode: '500070' },
  { value: 'siddharthnagar', label: 'Siddharthnagar', pincode: '500090' },
  { value: 'srinivasa-nagar', label: 'Srinivasa Nagar', pincode: '500062' },
  { value: 'tarnaka', label: 'Tarnaka', pincode: '500017' },
  { value: 'uppal', label: 'Uppal', pincode: '500039' },
  { value: 'vanasthalipuram', label: 'Vanasthalipuram', pincode: '500070' },
  { value: 'yousufguda', label: 'Yousufguda', pincode: '500045' },
  { value: 'zoological-park', label: 'Zoological Park', pincode: '500032' }
  ],

  'sonbhadra': [
  { value: 'adamgarh', label: 'Adamgarh', pincode: '231218' },
  { value: 'andhra', label: 'Andhra', pincode: '231220' },
  { value: 'barhi', label: 'Barhi', pincode: '231213' },
  { value: 'chopan', label: 'Chopan', pincode: '231205' },
  { value: 'dudhi', label: 'Dudhi', pincode: '231210' },
  { value: 'gularia', label: 'Gularia', pincode: '231208' },
  { value: 'jigna', label: 'Jigna', pincode: '231211' },
  { value: 'katora', label: 'Katora', pincode: '231211' },
  { value: 'kotra', label: 'Kotra', pincode: '231221' },
  { value: 'meja', label: 'Meja', pincode: '231303' },
  { value: 'mau-aima', label: 'Mau Aima', pincode: '231211' },
  { value: 'obara', label: 'Obara', pincode: '231207' },
  { value: 'rajpur', label: 'Rajpur', pincode: '231214' },
  { value: 'rewa', label: 'Rewa', pincode: '231202' },
  { value: 'robertsganj', label: 'Robertsganj', pincode: '231216' },
  { value: 'sadar', label: 'Sadar', pincode: '231206' },
  { value: 'sonbhadra', label: 'Sonbhadra', pincode: '231001' },
  { value: 'suriawan', label: 'Suriawan', pincode: '231215' },
  { value: 'tanda', label: 'Tanda', pincode: '231222' },
  { value: 'usri', label: 'Usri', pincode: '231213' },
  { value: 'vijaygarh', label: 'Vijaygarh', pincode: '231209' },
  { value: 'chunar', label: 'Chunar', pincode: '231304' },
  { value: 'gohari', label: 'Gohari', pincode: '231302' },
  { value: 'kandwa', label: 'Kandwa', pincode: '231223' },
  { value: 'malgaon', label: 'Malgaon', pincode: '231212' },
  { value: 'patpar', label: 'Patpar', pincode: '231220' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '231207' },
  { value: 'sarnath', label: 'Sarnath', pincode: '231210' }
  ],

  'sant-kabir-nagar': [
  { value: 'abharwa', label: 'Abharwa', pincode: '272152' },
  { value: 'bharatganj', label: 'Bharatganj', pincode: '272161' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '272162' },
  { value: 'bairiya', label: 'Bairiya', pincode: '272144' },
  { value: 'chhapia', label: 'Chhapia', pincode: '272147' },
  { value: 'dhamaura', label: 'Dhamaura', pincode: '272152' },
  { value: 'jalalpur', label: 'Jalalpur', pincode: '272153' },
  { value: 'kahara', label: 'Kahara', pincode: '272151' },
  { value: 'khalilabad', label: 'Khalilabad', pincode: '272175' },
  { value: 'mahuwa', label: 'Mahuwa', pincode: '272140' },
  { value: 'mohammadabad', label: 'Mohammadabad', pincode: '272145' },
  { value: 'panwari', label: 'Panwari', pincode: '272141' },
  { value: 'pachperwa', label: 'Pachperwa', pincode: '272143' },
  { value: 'purandarpur', label: 'Purandarpur', pincode: '272148' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '272142' },
  { value: 'sant-kabir-nagar', label: 'Sant Kabir Nagar', pincode: '272175' },
  { value: 'shahpur', label: 'Shahpur', pincode: '272146' },
  { value: 'siddharthnagar', label: 'Siddharthnagar', pincode: '272149' },
  { value: 'sonwa', label: 'Sonwa', pincode: '272163' },
  { value: 'udaypur', label: 'Udaypur', pincode: '272150' }
  ],

  'bhadohi': [
  { value: 'alapur', label: 'Alapur', pincode: '221402' },
  { value: 'bhadohi', label: 'Bhadohi', pincode: '221401' },
  { value: 'baraipura', label: 'Baraipura', pincode: '221305' },
  { value: 'barwan', label: 'Barwan', pincode: '221306' },
  { value: 'chhijwar', label: 'Chhijwar', pincode: '221302' },
  { value: 'gopiganj', label: 'Gopiganj', pincode: '221303' },
  { value: 'jakhini', label: 'Jakhini', pincode: '221307' },
  { value: 'kamhariya', label: 'Kamhariya', pincode: '221307' },
  { value: 'kaithi', label: 'Kaithi', pincode: '221308' },
  { value: 'khamaria', label: 'Khamaria', pincode: '221309' },
  { value: 'khurahat', label: 'Khurahat', pincode: '221310' },
  { value: 'mandhai', label: 'Mandhai', pincode: '221310' },
  { value: 'mau', label: 'Mau', pincode: '221311' },
  { value: 'mohammadabad', label: 'Mohammadabad', pincode: '221312' },
  { value: 'suryanagar', label: 'Suryanagar', pincode: '221403' },
  { value: 'thekhra', label: 'Thekhra', pincode: '221304' },
  { value: 'purva', label: 'Purva', pincode: '221314' },
  { value: 'rasulpur', label: 'Rasulpur', pincode: '221315' },
  { value: 'salempur', label: 'Salempur', pincode: '221316' },
  { value: 'santoshpur', label: 'Santoshpur', pincode: '221317' },
  { value: 'tulsi', label: 'Tulsi', pincode: '221318' },
  { value: 'maheshpur', label: 'Maheshpur', pincode: '221319' },
  { value: 'mirzapur', label: 'Mirzapur', pincode: '221320' },
  { value: 'pachpera', label: 'Pachpera', pincode: '221321' },
  { value: 'bajardiha', label: 'Bajardiha', pincode: '221322' },
  { value: 'kakrahwa', label: 'Kakrahwa', pincode: '221323' }
  ],

  'rampur': [
  { value: 'aliganj', label: 'Aliganj', pincode: '244241' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '244921' },
  { value: 'bhojipura', label: 'Bhojipura', pincode: '244232' },
  { value: 'chalhera', label: 'Chalhera', pincode: '244924' },
  { value: 'fatehganj', label: 'Fatehganj', pincode: '244202' },
  { value: 'gajraula', label: 'Gajraula', pincode: '244223' },
  { value: 'jalalabad', label: 'Jalalabad', pincode: '244223' },
  { value: 'rampur', label: 'Rampur', pincode: '244901' },
  { value: 'rasiya', label: 'Rasiya', pincode: '244901' },
  { value: 'sidhpur', label: 'Sidhpur', pincode: '244901' },
  { value: 'tanda', label: 'Tanda', pincode: '244922' },
  { value: 'tanda-ganj', label: 'Tanda Ganj', pincode: '244903' },
  { value: 'tehri', label: 'Tehri', pincode: '244201' },
  { value: 'bajpur', label: 'Bajpur', pincode: '244206' },
  { value: 'kushmaur', label: 'Kushmaur', pincode: '244919' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '244902' },
  { value: 'naipura', label: 'Naipura', pincode: '244202' },
  { value: 'patwai', label: 'Patwai', pincode: '244920' },
  { value: 'rampur-ganj', label: 'Rampur Ganj', pincode: '244904' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '244205' },
  { value: 'tanda-sadiya', label: 'Tanda Sadiya', pincode: '244923' }
  ],

  'agra': [
    { value: 'belan-ganj', label: 'Belan Ganj', pincode: '282003' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '282002' },
    { value: 'daresi-road', label: 'Daresi Road', pincode: '282003' },
    { value: 'dayal-bagh', label: 'Dayal Bagh', pincode: '282005' },
    { value: 'delhi-gate', label: 'Delhi Gate', pincode: '282003' },
    { value: 'dwari', label: 'Dwari', pincode: '282005' },
    { value: 'fatehabad-road', label: 'Fatehabad Road', pincode: '282001' },
    { value: 'foundry-nagar', label: 'Foundry Nagar', pincode: '282006' },
    { value: 'hing-ki-mandi', label: 'Hing Ki Mandi', pincode: '282001' },
    { value: 'huzuri-bhawan', label: 'Huzuri Bhawan', pincode: '282003' },
    { value: 'jeoni-mandi', label: 'Jeoni Mandi', pincode: '282005' },
    { value: 'kamala-nagar', label: 'Kamala Nagar', pincode: '282005' },
    { value: 'khandari', label: 'Khandari', pincode: '282003' },
    { value: 'korai', label: 'Korai', pincode: '282007' },
    { value: 'lajpat-kunj', label: 'Lajpat Kunj', pincode: '282002' },
    { value: 'loha-mandi', label: 'Loha Mandi', pincode: '282007' },
    { value: 'madhu-nagar', label: 'Madhu Nagar', pincode: '282002' },
    { value: 'mahatma-gandhi-road', label: 'Mahatma Gandhi Road', pincode: '282003' },
    { value: 'mantola', label: 'Mantola', pincode: '282003' },
    { value: 'mg-road', label: 'MG Road', pincode: '282003' },
    { value: 'nai-ki-mandi', label: 'Nai Ki Mandi', pincode: '282001' },
    { value: 'namner-road', label: 'Namner Road', pincode: '282003' },
    { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '282001' },
    { value: 'peepal-mandi', label: 'Peepal Mandi', pincode: '282003' },
    { value: 'pratap-pura', label: 'Pratap Pura', pincode: '282002' },
    { value: 'raja-ki-mandi', label: 'Raja ki Mandi', pincode: '282002' },
    { value: 'rajora', label: 'Rajora', pincode: '282003' },
    { value: 'rajpur', label: 'Rajpur', pincode: '282007' },
    { value: 'rakabganj', label: 'Rakabganj', pincode: '282003' },
    { value: 'rasoolpur', label: 'Rasoolpur', pincode: '282001' },
    { value: 'ratoti', label: 'Ratoti', pincode: '282007' },
    { value: 'rawatpara', label: 'Rawatpara', pincode: '282002' },
    { value: 'reha', label: 'Reha', pincode: '282001' },
    { value: 'rehan-kalan', label: 'Rehan Kalan', pincode: '282001' },
    { value: 'regimental-centre', label: 'Regimental Centre', pincode: '282009' },
    { value: 'richhpura', label: 'Richhpura', pincode: '282002' },
    { value: 'rithori', label: 'Rithori', pincode: '282005' },
    { value: 'rohta', label: 'Rohta', pincode: '282007' },
    { value: 'rojholi', label: 'Rojholi', pincode: '282002' },
    { value: 'rudhmuli', label: 'Rudhmuli', pincode: '282003' },
    { value: 'runkata', label: 'Runkata', pincode: '400093' },
    { value: 'sabora', label: 'Sabora', pincode: '282010' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '282001' },
    { value: 'sadarbhatti', label: 'Sadarbhatti', pincode: '282010' },
    { value: 'sahara', label: 'Sahara', pincode: '282007' },
    { value: 'sahata', label: 'Sahata', pincode: '282001' },
    { value: 'saiyan', label: 'Saiyan', pincode: '282007' },
    { value: 'saket-colony', label: 'Saket Colony', pincode: '282007' },
    { value: 'salemabad', label: 'Salemabad', pincode: '282003' },
    { value: 'samara', label: 'Samara', pincode: '282002' },
    { value: 'sandhan', label: 'Sandhan', pincode: '282007' },
    { value: 'sanjay-place', label: 'Sanjay Place', pincode: '282002' },
    { value: 'sanjeti', label: 'Sanjeti', pincode: '282001' },
    { value: 'sarai-khawaja', label: 'Sarai Khawaja', pincode: '282003' },
    { value: 'sarendha', label: 'Sarendha', pincode: '282010' },
    { value: 'sarendhi', label: 'Sarendhi', pincode: '282010' },
    { value: 'sawa', label: 'Sawa', pincode: '282005' },
    { value: 'semera', label: 'Semera', pincode: '282002' },
    { value: 'seola-jat', label: 'Seola Jat', pincode: '282007' },
    { value: 'shahganj', label: 'Shahganj', pincode: '282010' },
    { value: 'shahganj-bazar', label: 'Shahganj Bazar', pincode: '282010' },
    { value: 'shahpur-brahman', label: 'Shahpur Brahman', pincode: '282010' },
    { value: 'shahpur-toola', label: 'Shahpur Toola', pincode: '282002' },
    { value: 'shaheed-nagar', label: 'Shaheed Nagar', pincode: '282006' },
    { value: 'shamsabad', label: 'Shamsabad', pincode: '282001' },
    { value: 'shahzadi-mandi', label: 'Shahzadi Mandi', pincode: '282001' },
    { value: 'shiaupura', label: 'Shiaupura', pincode: '282001' },
    { value: 'shiraz', label: 'Shiraz', pincode: '282002' },
    { value: 'shiv-nagar', label: 'Shiv Nagar', pincode: '282007' },
    { value: 'shoe-market', label: 'Shoe Market', pincode: '282003' },
    { value: 'shyamo', label: 'Shyamo', pincode: '282001' },
    { value: 'sidhaoli', label: 'Sidhaoli', pincode: '282007' },
    { value: 'sikandra', label: 'Sikandra', pincode: '282007' },
    { value: 'sikraondha', label: 'Sikraondha', pincode: '282007' },
    { value: 'siktara', label: 'Siktara', pincode: '282003' },
    { value: 'singaich', label: 'Singaich', pincode: '282001' },
    { value: 'snh-road', label: 'SNH Road', pincode: '282007' },
    { value: 'soni-khera', label: 'Soni Khera', pincode: '282007' },
    { value: 'spacer', label: 'Spacer', pincode: '282003' },
    { value: 'sultanpura', label: 'Sultanpura', pincode: '282007' },
    { value: 'sunari', label: 'Sunari', pincode: '282001' },
    { value: 'swara', label: 'Swara', pincode: '282005' },
    { value: 'taj-nagari', label: 'Taj Nagari', pincode: '282001' },
    { value: 'tajganj', label: 'Tajganj', pincode: '282001' },
    { value: 'taj-road', label: 'Taj Road', pincode: '282001' },
    { value: 'tanora-noorpur', label: 'Tanora Noorpur', pincode: '282001' },
    { value: 'tarauli-gujar', label: 'Tarauli Gujar', pincode: '282002' },
    { value: 'tantpur', label: 'Tantpur', pincode: '282003' },
    { value: 'tasond', label: 'Tasond', pincode: '282010' },
    { value: 'tehra', label: 'Tehra', pincode: '282001' },
    { value: 'tehu', label: 'Tehu', pincode: '282002' },
    { value: 'therai', label: 'Therai', pincode: '282003' },
    { value: 'thana-shankar', label: 'Thana Shankar', pincode: '282010' },
    { value: 'tiwaha', label: 'Tiwaha', pincode: '282003' },
    { value: 'trans-yamuna-colony', label: 'Trans Yamuna Colony', pincode: '282006' },
    { value: 'tundla', label: 'Tundla', pincode: '283204' },
    { value: 'turkia', label: 'Turkia', pincode: '282003' },
    { value: 'udyog-nagar', label: 'Udyog Nagar', pincode: '282007' },
    { value: 'ujarai', label: 'Ujarai', pincode: '282002' }
],
  'allahabad': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '211001' },
    { value: 'amraiwadi', label: 'Amraiwadi', pincode: '211004' },
    { value: 'bhitauli', label: 'Bhitauli', pincode: '211010' },
    { value: 'chaka', label: 'Chaka', pincode: '211008' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '211001' },
    { value: 'dariyabad', label: 'Dariyabad', pincode: '211015' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '211201' },
    { value: 'ghatkesari', label: 'Ghatkesari', pincode: '500088' },
    { value: 'gokulnagar', label: 'Gokulnagar', pincode: '211004' },
    { value: 'gokulpur', label: 'Gokulpur', pincode: '211006' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jagdishpur', label: 'Jagdishpur', pincode: '211011' },
    { value: 'jhalwa', label: 'Jhalwa', pincode: '211012' },
    { value: 'kanpur-road', label: 'Kanpur Road', pincode: '211019' },
    { value: 'kaushambi', label: 'Kaushambi', pincode: '211013' },
    { value: 'kothawan', label: 'Kothawan', pincode: '211005' },
    { value: 'mau-aima', label: 'Mau Aima', pincode: '211015' },
    { value: 'mau-narayanpur', label: 'Mau Narayanpur', pincode: '211022' },
    { value: 'mohanganj', label: 'Mohanganj', pincode: '211019' },
    { value: 'naini', label: 'Naini', pincode: '211008' },
    { value: 'new-teliarganj', label: 'New Teliarganj', pincode: '211004' },
    { value: 'phulpur', label: 'Phulpur', pincode: '211022' },
    { value: 'priyadarshini', label: 'Priyadarshini', pincode: '211009' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '211006' },
    { value: 'salori', label: 'Salori', pincode: '211011' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '211003' },
    { value: 'sewa-kendra', label: 'Sewa Kendra', pincode: '211020' },
    { value: 'shahganj', label: 'Shahganj', pincode: '211002' },
    { value: 'shahpur', label: 'Shahpur', pincode: '211014' },
    { value: 'shastrinagar', label: 'Shastri Nagar', pincode: '211002' },
    { value: 'swaraj-ganj', label: 'Swaraj Ganj', pincode: '211009' },
    { value: 'teliarganj', label: 'Teliarganj', pincode: '211004' },
    { value: 'tehsil-road', label: 'Tehsil Road', pincode: '211003' },
    { value: 'umaid-ganj', label: 'Umaid Ganj', pincode: '211010' },
    { value: 'urla', label: 'Urla', pincode: '211014' }
  ],
  'prayagraj': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '211001' },
    { value: 'amraiwadi', label: 'Amraiwadi', pincode: '211004' },
    { value: 'bhitauli', label: 'Bhitauli', pincode: '211010' },
    { value: 'chaka', label: 'Chaka', pincode: '211008' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '211001' },
    { value: 'dariyabad', label: 'Dariyabad', pincode: '211015' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '211201' },
    { value: 'ghatkesari', label: 'Ghatkesari', pincode: '500088' },
    { value: 'gokulnagar', label: 'Gokulnagar', pincode: '211004' },
    { value: 'gokulpur', label: 'Gokulpur', pincode: '211006' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jagdishpur', label: 'Jagdishpur', pincode: '211011' },
    { value: 'jhalwa', label: 'Jhalwa', pincode: '211012' },
    { value: 'kanpur-road', label: 'Kanpur Road', pincode: '211019' },
    { value: 'kaushambi', label: 'Kaushambi', pincode: '211013' },
    { value: 'kothawan', label: 'Kothawan', pincode: '211005' },
    { value: 'mau-aima', label: 'Mau Aima', pincode: '211015' },
    { value: 'mau-narayanpur', label: 'Mau Narayanpur', pincode: '211022' },
    { value: 'mohanganj', label: 'Mohanganj', pincode: '211019' },
    { value: 'naini', label: 'Naini', pincode: '211008' },
    { value: 'new-teliarganj', label: 'New Teliarganj', pincode: '211004' },
    { value: 'phulpur', label: 'Phulpur', pincode: '211022' },
    { value: 'priyadarshini', label: 'Priyadarshini', pincode: '211009' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '211006' },
    { value: 'salori', label: 'Salori', pincode: '211011' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '211003' },
    { value: 'sewa-kendra', label: 'Sewa Kendra', pincode: '211020' },
    { value: 'shahganj', label: 'Shahganj', pincode: '211002' },
    { value: 'shahpur', label: 'Shahpur', pincode: '211014' },
    { value: 'shastrinagar', label: 'Shastri Nagar', pincode: '211002' },
    { value: 'swaraj-ganj', label: 'Swaraj Ganj', pincode: '211009' },
    { value: 'teliarganj', label: 'Teliarganj', pincode: '211004' },
    { value: 'tehsil-road', label: 'Tehsil Road', pincode: '211003' },
    { value: 'umaid-ganj', label: 'Umaid Ganj', pincode: '211010' },
    { value: 'urla', label: 'Urla', pincode: '211014' }
  ],

  'aligarh': [
    { value: 'aligarh-1', label: 'Aligarh-1', pincode: '202005' },
    { value: 'aligarh-2', label: 'Aligarh-2', pincode: '202006' },
    { value: 'aligarh-3', label: 'Aligarh-3', pincode: '202007' },
    { value: 'aligarh-4', label: 'Aligarh-4', pincode: '202008' },
    { value: 'aligarh-5', label: 'Aligarh-5', pincode: '202009' },
    { value: 'aligarh-6', label: 'Aligarh-6', pincode: '202010' },
    { value: 'aligarh-cantt', label: 'Aligarh Cantt', pincode: '202002' },
    { value: 'aligarh-city', label: 'Aligarh City', pincode: '202001' },
    { value: 'aligarh-district', label: 'Aligarh District', pincode: '202004' },
    { value: 'aligarh-road', label: 'Aligarh Road', pincode: '202003' },
    { value: 'amrit-puri', label: 'Amrit Puri', pincode: '202011' },
    { value: 'angrish-nagar', label: 'Angrish Nagar', pincode: '202012' },
    { value: 'ashok-vihar', label: 'Ashok Vihar', pincode: '202013' },
    { value: 'bhagat-singh-nagar', label: 'Bhagat Singh Nagar', pincode: '202027' },
    { value: 'chandani-chowk', label: 'Chandani Chowk', pincode: '202028' },
    { value: 'chandpur', label: 'Chandpur', pincode: '202014' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hasanpur', label: 'Hasanpur', pincode: '202015' },
    { value: 'karahal', label: 'Karahal', pincode: '202029' },
    { value: 'kashmere-gate', label: 'Kashmere Gate', pincode: '110006' },
    { value: 'katheri', label: 'Katheri', pincode: '202026' },
    { value: 'kishanpur', label: 'Kishanpur', pincode: '202031' },
    { value: 'mahim', label: 'Mahim', pincode: '400016' },
    { value: 'mohalla-kashmir', label: 'Mohalla Kashmir', pincode: '202016' },
    { value: 'mohalla-sarai', label: 'Mohalla Sarai', pincode: '202017' },
    { value: 'neelpur', label: 'Neelpur', pincode: '202032' },
    { value: 'new-colony', label: 'New Colony', pincode: '202018' },
    { value: 'nurpur', label: 'Nurpur', pincode: '202033' },
    { value: 'prabhat-nagar', label: 'Prabhat Nagar', pincode: '202019' },
    { value: 'rahmapur', label: 'Rahmapur', pincode: '202020' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '202034' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '202009' },
    { value: 'shahjahanpur', label: 'Shahjahanpur', pincode: '202021' },
    { value: 'shahpur', label: 'Shahpur', pincode: '202025' },
    { value: 'shergarh', label: 'Shergarh', pincode: '202030' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '202022' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '202035' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '202023' },
    { value: 'vishnu-nagar', label: 'Vishnu Nagar', pincode: '202036' },
    { value: 'zafrabad', label: 'Zafrabad', pincode: '202024' }
  ],
  'hapur': [
    { value: 'adampur', label: 'Adampur', pincode: '245101' },
    { value: 'akbarabad', label: 'Akbarabad', pincode: '245202' },
    { value: 'alipur', label: 'Alipur', pincode: '245104' },
    { value: 'amroha', label: 'Amroha', pincode: '245301' },
    { value: 'anupshahr', label: 'Anupshahr', pincode: '245201' },
    { value: 'asotpur', label: 'Asotpur', pincode: '245101' },
    { value: 'aurangabad', label: 'Aurangabad', pincode: '245207' },
    { value: 'bailhura', label: 'Bailhura', pincode: '245105' },
    { value: 'balraajpur', label: 'Balraajpur', pincode: '245101' },
    { value: 'bapudham', label: 'Bapudham', pincode: '245104' },
    { value: 'belakhar', label: 'Belakhar', pincode: '245301' },
    { value: 'belhi', label: 'Belhi', pincode: '245102' },
    { value: 'bhagatpur', label: 'Bhagatpur', pincode: '245205' },
    { value: 'bhimnagar', label: 'Bhimnagar', pincode: '245101' },
    { value: 'bindpur', label: 'Bindpur', pincode: '245102' },
    { value: 'dhanora', label: 'Dhanora', pincode: '245105' },
    { value: 'dhaulana', label: 'Dhaulana', pincode: '245304' },
    { value: 'dilawarpur', label: 'Dilawarpur', pincode: '245301' },
    { value: 'gangnar', label: 'Gangnar', pincode: '245101' },
    { value: 'garkha', label: 'Garkha', pincode: '245301' },
    { value: 'harchandpur', label: 'Harchandpur', pincode: '245202' },
    { value: 'hapur', label: 'Hapur', pincode: '245101' },
    { value: 'hasanpur', label: 'Hasanpur', pincode: '245303' },
    { value: 'jodhpur', label: 'Jodhpur', pincode: '245201' },
    { value: 'kailashpur', label: 'Kailashpur', pincode: '245104' },
    { value: 'kathora', label: 'Kathora', pincode: '245101' },
    { value: 'khera', label: 'Khera', pincode: '245305' },
    { value: 'kushampur', label: 'Kushampur', pincode: '245103' },
    { value: 'luharli', label: 'Luharli', pincode: '245102' },
    { value: 'mahashpur', label: 'Mahashpur', pincode: '245301' },
    { value: 'mandola', label: 'Mandola', pincode: '245207' },
    { value: 'manjhola', label: 'Manjhola', pincode: '245105' },
    { value: 'maujpur', label: 'Maujpur', pincode: '245105' },
    { value: 'mohammadabad', label: 'Mohammadabad', pincode: '245305' },
    { value: 'nagla', label: 'Nagla', pincode: '245202' },
    { value: 'neelpur', label: 'Neelpur', pincode: '245203' },
    { value: 'new-dhaman', label: 'New Dhaman', pincode: '245202' },
    { value: 'new-hapur', label: 'New Hapur', pincode: '245101' },
    { value: 'palwari', label: 'Palwari', pincode: '245202' },
    { value: 'panchal', label: 'Panchal', pincode: '245301' },
    { value: 'patra', label: 'Patra', pincode: '245103' },
    { value: 'raipur', label: 'Raipur', pincode: '245102' },
    { value: 'ranipur', label: 'Ranipur', pincode: '245103' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '245101' },
    { value: 'sarai-khas', label: 'Sarai Khas', pincode: '245105' },
    { value: 'shahpur', label: 'Shahpur', pincode: '245206' },
    { value: 'shahpur-garhi', label: 'Shahpur Garhi', pincode: '245305' },
    { value: 'sidhpur', label: 'Sidhpur', pincode: '245301' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '245201' },
    { value: 'sikandarpur-kalan', label: 'Sikandarpur Kalan', pincode: '245302' },
    { value: 'surajpur', label: 'Surajpur', pincode: '245102' }
  ],
  'bijnor': [
    { value: 'adampur', label: 'Adampur', pincode: '246701' },
    { value: 'alisapur', label: 'Alisapur', pincode: '246735' },
    { value: 'bhojpur', label: 'Bhojpur', pincode: '246701' },
    { value: 'bijnor', label: 'Bijnor', pincode: '246701' },
    { value: 'chakla', label: 'Chakla', pincode: '246753' },
    { value: 'dandoli', label: 'Dandoli', pincode: '246753' },
    { value: 'dhaman', label: 'Dhaman', pincode: '246746' },
    { value: 'dhanora', label: 'Dhanora', pincode: '246739' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'ghosi', label: 'Ghosi', pincode: '246761' },
    { value: 'gokulpur', label: 'Gokulpur', pincode: '246734' },
    { value: 'jodhpur', label: 'Jodhpur', pincode: '246737' },
    { value: 'kaithal', label: 'Kaithal', pincode: '246736' },
    { value: 'kailon', label: 'Kailon', pincode: '246722' },
    { value: 'kudhla', label: 'Kudhla', pincode: '246734' },
    { value: 'mahmadpur', label: 'Mahmadpur', pincode: '246705' },
    { value: 'mashwara', label: 'Mashwara', pincode: '246722' },
    { value: 'nagal', label: 'Nagal', pincode: '246722' },
    { value: 'rahatgarh', label: 'Rahatgarh', pincode: '246739' },
    { value: 'ramganga', label: 'Ramganga', pincode: '246753' },
    { value: 'rampura', label: 'Rampura', pincode: '246741' },
    { value: 'sadapur', label: 'Sadapur', pincode: '246745' },
    { value: 'sadhupur', label: 'Sadhupur', pincode: '246747' },
    { value: 'sandila', label: 'Sandila', pincode: '246765' },
    { value: 'shahpur', label: 'Shahpur', pincode: '246759' },
    { value: 'shamli', label: 'Shamli', pincode: '246761' },
    { value: 'shikarpur', label: 'Shikarpur', pincode: '246726' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '246743' },
    { value: 'thakurdwara', label: 'Thakurdwara', pincode: '246747' },
    { value: 'ulra', label: 'Ulra', pincode: '246766' },
    { value: 'umarpur', label: 'Umarpur', pincode: '246734' },
    { value: 'vadhera', label: 'Vadhera', pincode: '246753' },
    { value: 'vaishali', label: 'Vaishali', pincode: '246740' },
    { value: 'wazirabad', label: 'Wazirabad', pincode: '246740' },
    { value: 'zafrabad', label: 'Zafrabad', pincode: '246767' },
    { value: 'baghpat', label: 'Baghpat', pincode: '246743' },
    { value: 'bhadauli', label: 'Bhadauli', pincode: '246747' },
    { value: 'bilaspur', label: 'Bilaspur', pincode: '246762' },
    { value: 'chandpur', label: 'Chandpur', pincode: '246725' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '246749' },
    { value: 'jogipur', label: 'Jogipur', pincode: '246741' },
    { value: 'kashipur', label: 'Kashipur', pincode: '246745' },
    { value: 'khera', label: 'Khera', pincode: '246733' },
    { value: 'mehmoodpur', label: 'Mehmoodpur', pincode: '246735' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '246754' },
    { value: 'narayanpur', label: 'Narayanpur', pincode: '246732' },
    { value: 'palra', label: 'Palra', pincode: '246761' },
    { value: 'punjabpur', label: 'Punjabpur', pincode: '246768' },
    { value: 'sahaspur', label: 'Sahaspur', pincode: '246730' },
    { value: 'sujapur', label: 'Sujapur', pincode: '246742' },
    { value: 'tilhar', label: 'Tilhar', pincode: '246738' },
    { value: 'zindpur', label: 'Zindpur', pincode: '246752' }
  ],
  'sultanpur': [
    { value: 'akbarpur', label: 'Akbarpur', pincode: '228001' },
    { value: 'badoi', label: 'Badoi', pincode: '228121' },
    { value: 'bandhua', label: 'Bandhua', pincode: '228001' },
    { value: 'banwan', label: 'Banwan', pincode: '228131' },
    { value: 'bariyawan', label: 'Bariyawan', pincode: '228142' },
    { value: 'belwa', label: 'Belwa', pincode: '228124' },
    { value: 'bhagwanpur', label: 'Bhagwanpur', pincode: '228147' },
    { value: 'bhiti', label: 'Bhiti', pincode: '228127' },
    { value: 'bhojpur', label: 'Bhojpur', pincode: '228121' },
    { value: 'dehuli', label: 'Dehuli', pincode: '228121' },
    { value: 'jagdispur', label: 'Jagdispur', pincode: '228141' },
    { value: 'jigani', label: 'Jigani', pincode: '228132' },
    { value: 'kaithi', label: 'Kaithi', pincode: '228144' },
    { value: 'kanakpur', label: 'Kanakpur', pincode: '228001' },
    { value: 'khajurgaon', label: 'Khajurgaon', pincode: '228141' },
    { value: 'khayrapur', label: 'Khayrapur', pincode: '228141' },
    { value: 'kohar', label: 'Kohar', pincode: '228132' },
    { value: 'madhopur', label: 'Madhopur', pincode: '228146' },
    { value: 'majhouli', label: 'Majhouli', pincode: '228142' },
    { value: 'manakpur', label: 'Manakpur', pincode: '228144' },
    { value: 'mau', label: 'Mau', pincode: '228143' },
    { value: 'mirzapur', label: 'Mirzapur', pincode: '228143' },
    { value: 'pachrukha', label: 'Pachrukha', pincode: '228123' },
    { value: 'palmoli', label: 'Palmoli', pincode: '228121' },
    { value: 'parshurampur', label: 'Parshurampur', pincode: '228127' },
    { value: 'purwa', label: 'Purwa', pincode: '228128' },
    { value: 'raipur', label: 'Raipur', pincode: '228121' },
    { value: 'ramganj', label: 'Ramganj', pincode: '228149' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '228150' },
    { value: 'rampur', label: 'Rampur', pincode: '228129' },
    { value: 'rasulpur', label: 'Rasulpur', pincode: '228144' },
    { value: 'sarwan', label: 'Sarwan', pincode: '228123' },
    { value: 'shahganj', label: 'Shahganj', pincode: '228141' },
    { value: 'shahpur', label: 'Shahpur', pincode: '228133' },
    { value: 'shuklaganj', label: 'Shuklaganj', pincode: '228132' },
    { value: 'sitaram', label: 'Sitaram', pincode: '228151' },
    { value: 'sultanpur-city', label: 'Sultanpur City', pincode: '228001' },
    { value: 'taharpur', label: 'Taharpur', pincode: '228121' },
    { value: 'tendua', label: 'Tendua', pincode: '228121' },
    { value: 'tilai', label: 'Tilai', pincode: '228145' }
  ],

  'muzaffarnagar': [
    { value: 'alipura', label: 'Alipura', pincode: '251001' },
    { value: 'baghpat', label: 'Baghpat', pincode: '251301' },
    { value: 'bamanheri', label: 'Bamanheri', pincode: '251305' },
    { value: 'bhood', label: 'Bhood', pincode: '251003' },
    { value: 'chhappar', label: 'Chhappar', pincode: '251314' },
    { value: 'deoband', label: 'Deoband', pincode: '247554' },
    { value: 'dhamta', label: 'Dhamta', pincode: '251310' },
    { value: 'ganeshpur', label: 'Ganeshpur', pincode: '251002' },
    { value: 'ghanaur', label: 'Ghanaur', pincode: '251308' },
    { value: 'harsur', label: 'Harsur', pincode: '251315' },
    { value: 'janta-colony', label: 'Janta Colony', pincode: '251001' },
    { value: 'kailali', label: 'Kailali', pincode: '251312' },
    { value: 'khatauli', label: 'Khatauli', pincode: '251201' },
    { value: 'kotwali', label: 'Kotwali', pincode: '251002' },
    { value: 'mandi', label: 'Mandi', pincode: '251002' },
    { value: 'milak', label: 'Milak', pincode: '251306' },
    { value: 'miranpur', label: 'Miranpur', pincode: '251314' },
    { value: 'muzaffarnagar-cantt', label: 'Muzaffarnagar Cantt', pincode: '251001' },
    { value: 'nizampur', label: 'Nizampur', pincode: '251311' },
    { value: 'raipur', label: 'Raipur', pincode: '251315' },
    { value: 'rahmapur', label: 'Rahmapur', pincode: '251002' },
    { value: 'rajputana', label: 'Rajputana', pincode: '251318' },
    { value: 'shahpur', label: 'Shahpur', pincode: '251002' },
    { value: 'sikanderpur', label: 'Sikanderpur', pincode: '251308' },
    { value: 'sikri', label: 'Sikri', pincode: '251307' },
    { value: 'sunil-vihar', label: 'Sunil Vihar', pincode: '251002' },
    { value: 'tanda', label: 'Tanda', pincode: '251317' },
    { value: 'tobri', label: 'Tobri', pincode: '251318' }
  ],

  'unnao': [
    { value: 'ajgain', label: 'Ajgain', pincode: '209821' },
    { value: 'bajna', label: 'Bajna', pincode: '209821' },
    { value: 'bangla-bazar', label: 'Bangla Bazar', pincode: '209821' },
    { value: 'bhadhri', label: 'Bhadhri', pincode: '209803' },
    { value: 'bhagatpur', label: 'Bhagatpur', pincode: '209803' },
    { value: 'bichhwan', label: 'Bichhwan', pincode: '209821' },
    { value: 'bichhwan-bajar', label: 'Bichhwan Bajar', pincode: '209810' },
    { value: 'bhitauli', label: 'Bhitauli', pincode: '209821' },
    { value: 'chandpur', label: 'Chandpur', pincode: '209821' },
    { value: 'chhatri', label: 'Chhatri', pincode: '209821' },
    { value: 'darauli', label: 'Darauli', pincode: '209821' },
    { value: 'dholpur', label: 'Dholpur', pincode: '209821' },
    { value: 'gachhbara', label: 'Gachhbara', pincode: '209821' },
    { value: 'gajner', label: 'Gajner', pincode: '209821' },
    { value: 'gokulganj', label: 'Gokulganj', pincode: '209821' },
    { value: 'gopalpur', label: 'Gopalpur', pincode: '209821' },
    { value: 'gram-rai', label: 'Gram Rai', pincode: '209821' },
    { value: 'jarauli', label: 'Jarauli', pincode: '209821' },
    { value: 'kamayni', label: 'Kamayni', pincode: '209821' },
    { value: 'kankaha', label: 'Kankaha', pincode: '209821' },
    { value: 'kanpur-road', label: 'Kanpur Road', pincode: '209821' },
    { value: 'khairpur', label: 'Khairpur', pincode: '209821' },
    { value: 'kotra', label: 'Kotra', pincode: '209821' },
    { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '209821' },
    { value: 'madapur', label: 'Madapur', pincode: '209806' },
    { value: 'madhuganj', label: 'Madhuganj', pincode: '209821' },
    { value: 'manikpur', label: 'Manikpur', pincode: '209821' },
    { value: 'meetha', label: 'Meetha', pincode: '209821' },
    { value: 'mishrikha', label: 'Mishrikha', pincode: '209821' },
    { value: 'nawabganj', label: 'Nawabganj', pincode: '209821' },
    { value: 'pachperwa', label: 'Pachperwa', pincode: '209821' },
    { value: 'padari', label: 'Padari', pincode: '209821' },
    { value: 'paikara', label: 'Paikara', pincode: '209809' },
    { value: 'paharpur', label: 'Paharpur', pincode: '209821' },
    { value: 'panchali', label: 'Panchali', pincode: '209821' },
    { value: 'rakabganj', label: 'Rakabganj', pincode: '209805' },
    { value: 'rampur', label: 'Rampur', pincode: '209821' },
    { value: 'salempur', label: 'Salempur', pincode: '209821' },
    { value: 'satpurwa', label: 'Satpurwa', pincode: '209808' },
    { value: 'safipur', label: 'Safipur', pincode: '209871' },
    { value: 'sherpur', label: 'Sherpur', pincode: '209821' },
    { value: 'shuklaganj', label: 'Shuklaganj', pincode: '209861' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '209821' },
    { value: 'sonar', label: 'Sonar', pincode: '209821' },
    { value: 'soraon', label: 'Soraon', pincode: '209821' },
    { value: 'sultanganj', label: 'Sultanganj', pincode: '209821' },
    { value: 'taudakpur', label: 'Taudakpur', pincode: '209821' },
    { value: 'tikauli', label: 'Tikauli', pincode: '209821' },
    { value: 'tilaiya', label: 'Tilaiya', pincode: '209807' },
    { value: 'tirath', label: 'Tirath', pincode: '209821' },
    { value: 'uncha-gaon', label: 'Uncha Gaon', pincode: '209821' },
    { value: 'unnao-city', label: 'Unnao City', pincode: '209801' },
    { value: 'visanagar', label: 'Visanagar', pincode: '209821' }
  ],

  'shahjahanpur': [
    { value: 'abidganj', label: 'Abidganj', pincode: '242001' },
    { value: 'achhnera', label: 'Achhnera', pincode: '242304' },
    { value: 'ashapur', label: 'Ashapur', pincode: '242309' },
    { value: 'bajra', label: 'Bajra', pincode: '242305' },
    { value: 'banjaran', label: 'Banjaran', pincode: '242301' },
    { value: 'baragaon', label: 'Baragaon', pincode: '242402' },
    { value: 'bhabhua', label: 'Bhabhua', pincode: '242202' },
    { value: 'bhagdawa', label: 'Bhagdawa', pincode: '242300' },
    { value: 'bhaupur', label: 'Bhaupur', pincode: '242302' },
    { value: 'bhatpur', label: 'Bhatpur', pincode: '242303' },
    { value: 'budhanpur', label: 'Budhanpur', pincode: '242309' },
    { value: 'chandpur', label: 'Chandpur', pincode: '242406' },
    { value: 'chandralok', label: 'Chandralok', pincode: '242308' },
    { value: 'chhibramau', label: 'Chhibramau', pincode: '242307' },
    { value: 'dilawarpur', label: 'Dilawarpur', pincode: '242202' },
    { value: 'fatehganj', label: 'Fatehganj', pincode: '242303' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '242303' },
    { value: 'gajraula', label: 'Gajraula', pincode: '242407' },
    { value: 'gonda', label: 'Gonda', pincode: '242206' },
    { value: 'gopamau', label: 'Gopamau', pincode: '242306' },
    { value: 'karanpur', label: 'Karanpur', pincode: '242304' },
    { value: 'kherda', label: 'Kherda', pincode: '242305' },
    { value: 'khajuria', label: 'Khajuria', pincode: '242304' },
    { value: 'khiriya', label: 'Khiriya', pincode: '242405' },
    { value: 'kuchesar', label: 'Kuchesar', pincode: '242203' },
    { value: 'lakhimpur', label: 'Lakhimpur', pincode: '242308' },
    { value: 'manjhanpur', label: 'Manjhanpur', pincode: '242404' },
    { value: 'manojpur', label: 'Manojpur', pincode: '242306' },
    { value: 'maurawan', label: 'Maurawan', pincode: '242307' },
    { value: 'nainpur', label: 'Nainpur', pincode: '242305' },
    { value: 'new-mandi', label: 'New Mandi', pincode: '242001' },
    { value: 'panthpur', label: 'Panthpur', pincode: '242303' },
    { value: 'puranpur', label: 'Puranpur', pincode: '242408' },
    { value: 'puri', label: 'Puri', pincode: '242307' },
    { value: 'raebareli', label: 'Raebareli', pincode: '242305' },
    { value: 'rajanpur', label: 'Rajanpur', pincode: '242309' },
    { value: 'ramganj', label: 'Ramganj', pincode: '242303' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '242001' },
    { value: 'saijna', label: 'Saijna', pincode: '242300' },
    { value: 'santpur', label: 'Santpur', pincode: '242301' },
    { value: 'sihori', label: 'Sihori', pincode: '242302' },
    { value: 'sikanderpur', label: 'Sikanderpur', pincode: '242305' },
    { value: 'sorai', label: 'Sorai', pincode: '242305' },
    { value: 'tahseemabad', label: 'Tahseemabad', pincode: '242307' },
    { value: 'tanda', label: 'Tanda', pincode: '242406' },
    { value: 'udipur', label: 'Udipur', pincode: '242308' },
    { value: 'vishwanathpur', label: 'Vishwanathpur', pincode: '242408' }
  ],

  'saharanpur': [
    { value: 'adampur', label: 'Adampur', pincode: '247001' },
    { value: 'akbarpur', label: 'Akbarpur', pincode: '247338' },
    { value: 'alampur', label: 'Alampur', pincode: '247122' },
    { value: 'bajheri', label: 'Bajheri', pincode: '247341' },
    { value: 'ballupur', label: 'Ballupur', pincode: '247451' },
    { value: 'basi', label: 'Basi', pincode: '247665' },
    { value: 'bhagal', label: 'Bhagal', pincode: '247232' },
    { value: 'bhivpur', label: 'Bhivpur', pincode: '247230' },
    { value: 'bilaspur', label: 'Bilaspur', pincode: '247667' },
    { value: 'chandanpuri', label: 'Chandanpuri', pincode: '247662' },
    { value: 'chandni-chowk', label: 'Chandni Chowk', pincode: '247501' },
    { value: 'chandpur', label: 'Chandpur', pincode: '247674' },
    { value: 'chaurasi', label: 'Chaurasi', pincode: '247443' },
    { value: 'deoband', label: 'Deoband', pincode: '247554' },
    { value: 'dilawarpur', label: 'Dilawarpur', pincode: '247232' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '247672' },
    { value: 'garh-mukteshwar', label: 'Garh Mukteshwar', pincode: '247671' },
    { value: 'gogwan', label: 'Gogwan', pincode: '247340' },
    { value: 'islamnagar', label: 'Islamnagar', pincode: '247656' },
    { value: 'jahanabad', label: 'Jahanabad', pincode: '247666' },
    { value: 'jagran', label: 'Jagran', pincode: '247231' },
    { value: 'jawahar-pur', label: 'Jawahar Pur', pincode: '247001' },
    { value: 'kalan', label: 'Kalan', pincode: '247652' },
    { value: 'kanth', label: 'Kanth', pincode: '247670' },
    { value: 'kanshiram', label: 'Kanshiram', pincode: '247456' },
    { value: 'khajoori', label: 'Khajoori', pincode: '247661' },
    { value: 'kherkhera', label: 'Kherkhera', pincode: '247223' },
    { value: 'kotwali', label: 'Kotwali', pincode: '247001' },
    { value: 'kuchesar', label: 'Kuchesar', pincode: '247449' },
    { value: 'kurli', label: 'Kurli', pincode: '247227' },
    { value: 'kutubpur', label: 'Kutubpur', pincode: '247452' },
    { value: 'mahadevpur', label: 'Mahadevpur', pincode: '247241' },
    { value: 'mahapur', label: 'Mahapur', pincode: '247445' },
    { value: 'mandkola', label: 'Mandkola', pincode: '247333' },
    { value: 'meerapur', label: 'Meerapur', pincode: '247123' },
    { value: 'mubarakpur', label: 'Mubarakpur', pincode: '247222' },
    { value: 'nagal', label: 'Nagal', pincode: '247342' },
    { value: 'nagla', label: 'Nagla', pincode: '247444' },
    { value: 'naya-pur', label: 'Naya Pur', pincode: '247431' },
    { value: 'panjupur', label: 'Panjupur', pincode: '247342' },
    { value: 'phugana', label: 'Phugana', pincode: '247456' },
    { value: 'purnanagar', label: 'Purnanagar', pincode: '247446' },
    { value: 'rajamau', label: 'Rajamau', pincode: '247441' },
    { value: 'rangpura', label: 'Rangpura', pincode: '247441' },
    { value: 'saharanpur-rural', label: 'Saharanpur Rural', pincode: '247232' },
    { value: 'sarai-alampur', label: 'Sarai Alampur', pincode: '247331' },
    { value: 'shahjahanpur', label: 'Shahjahanpur', pincode: '247222' },
    { value: 'shamsabad', label: 'Shamsabad', pincode: '247673' },
    { value: 'sikanderpur', label: 'Sikanderpur', pincode: '247234' },
    { value: 'sultankheda', label: 'Sultankheda', pincode: '247334' },
    { value: 'tanda', label: 'Tanda', pincode: '247552' },
    { value: 'tulsi-gaon', label: 'Tulsi Gaon', pincode: '247453' }
  ],

  'mirzapur': [
    { value: 'amkhera', label: 'Amkhera', pincode: '231206' },
    { value: 'bakhira', label: 'Bakhira', pincode: '231220' },
    { value: 'bhadan', label: 'Bhadan', pincode: '231301' },
    { value: 'bhiti', label: 'Bhiti', pincode: '231001' },
    { value: 'chunar', label: 'Chunar', pincode: '231304' },
    { value: 'dhanori', label: 'Dhanori', pincode: '231305' },
    { value: 'dhoomanganj', label: 'Dhoomanganj', pincode: '231305' },
    { value: 'gauriganj', label: 'Gauriganj', pincode: '231213' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jamalpur', label: 'Jamalpur', pincode: '231207' },
    { value: 'jogapur', label: 'Jogapur', pincode: '231303' },
    { value: 'katra', label: 'Katra', pincode: '231220' },
    { value: 'khamaria', label: 'Khamaria', pincode: '231302' },
    { value: 'koira', label: 'Koira', pincode: '231209' },
    { value: 'krishnanand', label: 'Krishnanand', pincode: '231221' },
    { value: 'kulhadi', label: 'Kulhadi', pincode: '231207' },
    { value: 'mirzapur-bazar', label: 'Mirzapur Bazar', pincode: '231002' },
    { value: 'mirzapur-cantt', label: 'Mirzapur Cantt', pincode: '231001' },
    { value: 'mohammadabad', label: 'Mohammadabad', pincode: '231211' },
    { value: 'padari', label: 'Padari', pincode: '231301' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '231001' },
    { value: 'rasulpur', label: 'Rasulpur', pincode: '231308' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '231001' },
    { value: 'sikraura', label: 'Sikraura', pincode: '231218' },
    { value: 'sindurpur', label: 'Sindurpur', pincode: '231215' },
    { value: 'suhelva', label: 'Suhelva', pincode: '231303' },
    { value: 'sunauli', label: 'Sunauli', pincode: '231308' },
    { value: 'tanda', label: 'Tanda', pincode: '231224' },
    { value: 'varanasi-road', label: 'Varanasi Road', pincode: '231002' },
    { value: 'wazirganj', label: 'Wazirganj', pincode: '231225' }
  ],

  'kushinagar': [
    { value: 'bahadurganj', label: 'Bahadurganj', pincode: '274301' },
    { value: 'barwa', label: 'Barwa', pincode: '274305' },
    { value: 'bhatauli', label: 'Bhatauli', pincode: '274324' },
    { value: 'dheena', label: 'Dheena', pincode: '274306' },
    { value: 'deokali', label: 'Deokali', pincode: '274303' },
    { value: 'gopalganj', label: 'Gopalganj', pincode: '274310' },
    { value: 'gularia', label: 'Gularia', pincode: '274307' },
    { value: 'hatwa', label: 'Hatwa', pincode: '274308' },
    { value: 'kushinagar-cantt', label: 'Kushinagar Cantt', pincode: '274202' },
    { value: 'kushinagar-city', label: 'Kushinagar City', pincode: '274201' },
    { value: 'mahaso', label: 'Mahaso', pincode: '274304' },
    { value: 'mohanganj', label: 'Mohanganj', pincode: '274302' },
    { value: 'padari', label: 'Padari', pincode: '274309' },
    { value: 'pachdeora', label: 'Pachdeora', pincode: '274311' },
    { value: 'panchbanga', label: 'Panchbanga', pincode: '274312' },
    { value: 'purabpar', label: 'Purabpar', pincode: '274313' },
    { value: 'rajauli', label: 'Rajauli', pincode: '274314' },
    { value: 'ramkola', label: 'Ramkola', pincode: '274315' },
    { value: 'sadar', label: 'Sadar', pincode: '274316' },
    { value: 'sasi', label: 'Sasi', pincode: '274317' },
    { value: 'tulsi', label: 'Tulsi', pincode: '274318' },
    { value: 'agwanpur', label: 'Agwanpur', pincode: '274319' },
    { value: 'barhaj', label: 'Barhaj', pincode: '274320' },
    { value: 'chandpur', label: 'Chandpur', pincode: '274321' },
    { value: 'khajuria', label: 'Khajuria', pincode: '274322' },
    { value: 'kotwa', label: 'Kotwa', pincode: '274323' },
    { value: 'mau-bahadur', label: 'Mau Bahadur', pincode: '274325' },
    { value: 'manjhanpur', label: 'Manjhanpur', pincode: '274326' },
    { value: 'purwaria', label: 'Purwaria', pincode: '274327' },
    { value: 'saraswati-pur', label: 'Saraswati Pur', pincode: '274328' },
    { value: 'vishwanathganj', label: 'Vishwanathganj', pincode: '274329' }
  ],
  'kaushambi': [
    { value: 'ara', label: 'Ara', pincode: '212201' },
    { value: 'babu-pur', label: 'Babu Pur', pincode: '212207' },
    { value: 'bargaon', label: 'Bargaon', pincode: '212220' },
    { value: 'chak-diwari', label: 'Chak Diwari', pincode: '212213' },
    { value: 'chak-rahmapur', label: 'Chak Rahmapur', pincode: '212214' },
    { value: 'chhajpur', label: 'Chhajpur', pincode: '212217' },
    { value: 'dharmshala', label: 'Dharmshala', pincode: '212216' },
    { value: 'dholi', label: 'Dholi', pincode: '212219' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gohari', label: 'Gohari', pincode: '212222' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kaitha', label: 'Kaitha', pincode: '212223' },
    { value: 'kaushambi-cantt', label: 'Kaushambi Cantt', pincode: '212201' },
    { value: 'kaushambi-city', label: 'Kaushambi City', pincode: '212202' },
    { value: 'khera', label: 'Khera', pincode: '212215' },
    { value: 'khirsa', label: 'Khirsa', pincode: '212218' },
    { value: 'kurai', label: 'Kurai', pincode: '212224' },
    { value: 'laxmanpur', label: 'Laxmanpur', pincode: '212225' },
    { value: 'majherwan', label: 'Majherwan', pincode: '212205' },
    { value: 'manjhanpur', label: 'Manjhanpur', pincode: '212207' },
    { value: 'mau', label: 'Mau', pincode: '212210' },
    { value: 'mau-bahadur', label: 'Mau Bahadur', pincode: '212226' },
    { value: 'pahuj', label: 'Pahuj', pincode: '212209' },
    { value: 'pratappur', label: 'Pratappur', pincode: '212211' },
    { value: 'rahmapur', label: 'Rahmapur', pincode: '212206' },
    { value: 'ramdhanpur', label: 'Ramdhanpur', pincode: '212227' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '212208' },
    { value: 'sarsai', label: 'Sarsai', pincode: '212228' },
    { value: 'shankar-pur', label: 'Shankar Pur', pincode: '212212' },
    { value: 'sundar-bag', label: 'Sundar Bag', pincode: '212203' },
    { value: 'tarsa', label: 'Tarsa', pincode: '212204' }
  ],

  'jhansi': [
    { value: 'adampur', label: 'Adampur', pincode: '284302' },
    { value: 'adityapur', label: 'Adityapur', pincode: '284104' },
    { value: 'aligarh', label: 'Aligarh', pincode: '284202' },
    { value: 'bajrangpura', label: 'Bajrangpura', pincode: '284209' },
    { value: 'baldeopur', label: 'Baldeopur', pincode: '284201' },
    { value: 'balkhadi', label: 'Balkhadi', pincode: '284202' },
    { value: 'barua', label: 'Barua', pincode: '284121' },
    { value: 'bhagirathpura', label: 'Bhagirathpura', pincode: '284104' },
    { value: 'bhikampur', label: 'Bhikampur', pincode: '284104' },
    { value: 'chandpur', label: 'Chandpur', pincode: '284103' },
    { value: 'chhapar', label: 'Chhapar', pincode: '284207' },
    { value: 'dharampur', label: 'Dharampur', pincode: '284202' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '284116' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'goverdhan', label: 'Goverdhan', pincode: '284210' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'gulariha', label: 'Gulariha', pincode: '284105' },
    { value: 'jhansi-cantt', label: 'Jhansi Cantt', pincode: '284001' },
    { value: 'jhansi-city', label: 'Jhansi City', pincode: '284003' },
    { value: 'kela', label: 'Kela', pincode: '284213' },
    { value: 'khakhra', label: 'Khakhra', pincode: '284201' },
    { value: 'khandar', label: 'Khandar', pincode: '284212' },
    { value: 'majholi', label: 'Majholi', pincode: '284110' },
    { value: 'manikpur', label: 'Manikpur', pincode: '284115' },
    { value: 'maurawan', label: 'Maurawan', pincode: '284301' },
    { value: 'mau', label: 'Mau', pincode: '284103' },
    { value: 'mohannagar', label: 'Mohannagar', pincode: '284101' },
    { value: 'nagrain', label: 'Nagrain', pincode: '284116' },
    { value: 'neemkheda', label: 'Neemkheda', pincode: '284120' },
    { value: 'pahuj', label: 'Pahuj', pincode: '284102' },
    { value: 'pali', label: 'Pali', pincode: '284106' },
    { value: 'rajputpura', label: 'Rajputpura', pincode: '284206' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '284108' },
    { value: 'rishabhdev', label: 'Rishabhdev', pincode: '284004' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '284005' },
    { value: 'sikandra', label: 'Sikandra', pincode: '284205' },
    { value: 'sudama', label: 'Sudama', pincode: '284118' },
    { value: 'sundarpur', label: 'Sundarpur', pincode: '284111' },
    { value: 'teli', label: 'Teli', pincode: '284108' },
    { value: 'tivra', label: 'Tivra', pincode: '284206' },
    { value: 'umaidganj', label: 'Umaidganj', pincode: '284103' },
    { value: 'vishnupura', label: 'Vishnupura', pincode: '284107' }
  ],

  'gonda': [
    { value: 'achhpur', label: 'Achhpur', pincode: '271309' },
    { value: 'alapur', label: 'Alapur', pincode: '271001' },
    { value: 'badahpur', label: 'Badhapur', pincode: '271310' },
    { value: 'balrampur', label: 'Balrampur', pincode: '271201' },
    { value: 'barabanki', label: 'Barabanki', pincode: '225001' },
    { value: 'basti', label: 'Basti', pincode: '272002' },
    { value: 'belrayan', label: 'Belrayan', pincode: '271312' },
    { value: 'bhora', label: 'Bhora', pincode: '271321' },
    { value: 'chhapia', label: 'Chhapia', pincode: '271305' },
    { value: 'gonda-cantt', label: 'Gonda Cantt', pincode: '271002' },
    { value: 'gonda-city', label: 'Gonda City', pincode: '271001' },
    { value: 'gonda-railway-station', label: 'Gonda Railway Station', pincode: '271003' },
    { value: 'kakraha', label: 'Kakraha', pincode: '271311' },
    { value: 'khajurgaon', label: 'Khajurgaon', pincode: '271322' },
    { value: 'kudiya', label: 'Kudiya', pincode: '271313' },
    { value: 'kudaraha', label: 'Kudaraha', pincode: '271328' },
    { value: 'lauriya', label: 'Lauriya', pincode: '271329' },
    { value: 'madhaiya', label: 'Madhaiya', pincode: '271323' },
    { value: 'manpur', label: 'Manpur', pincode: '271324' },
    { value: 'maurawan', label: 'Maurawan', pincode: '271306' },
    { value: 'mau-purab', label: 'Mau Purab', pincode: '271330' },
    { value: 'naraich', label: 'Naraich', pincode: '271301' },
    { value: 'pachpedwa', label: 'Pachpedwa', pincode: '271325' },
    { value: 'parshuram', label: 'Parshuram', pincode: '271331' },
    { value: 'patiyali', label: 'Patiyali', pincode: '271332' },
    { value: 'phulwaria', label: 'Phulwaria', pincode: '271333' },
    { value: 'purainiya', label: 'Purainiya', pincode: '271326' },
    { value: 'raipur', label: 'Raipur', pincode: '271334' },
    { value: 'sadar', label: 'Sadar', pincode: '271002' },
    { value: 'sahaipur', label: 'Sahaipur', pincode: '271335' },
    { value: 'shahpur', label: 'Shahpur', pincode: '271004' },
    { value: 'shivgarh', label: 'Shivgarh', pincode: '271307' },
    { value: 'sikri', label: 'Sikri', pincode: '271327' },
    { value: 'takia', label: 'Takia', pincode: '271336' },
    { value: 'tetri-bujurg', label: 'Tetri Bujurg', pincode: '271308' },
    { value: 'tulsi', label: 'Tulsi', pincode: '271337' }
  ],

  'hathras': [
    { value: 'asadpur', label: 'Asadpur', pincode: '204102' },
    { value: 'baba-ka-pura', label: 'Baba Ka Pura', pincode: '204101' },
    { value: 'bhandawari', label: 'Bhandawari', pincode: '204107' },
    { value: 'bhim-pur', label: 'Bhim Pur', pincode: '204214' },
    { value: 'chandpur', label: 'Chandpur', pincode: '204213' },
    { value: 'gajipur', label: 'Gajipur', pincode: '204210' },
    { value: 'garh-mau', label: 'Garh Mau', pincode: '204205' },
    { value: 'gokul-pur', label: 'Gokul Pur', pincode: '204106' },
    { value: 'hasanpur', label: 'Hasanpur', pincode: '202136' },
    { value: 'hasra', label: 'Hasra', pincode: '202125' },
    { value: 'hathras-city', label: 'Hathras City', pincode: '204101' },
    { value: 'hathras-road', label: 'Hathras Road', pincode: '204107' },
    { value: 'kailash-pur', label: 'Kailash Pur', pincode: '204215' },
    { value: 'karaunda', label: 'Karaunda', pincode: '204202' },
    { value: 'khandasa', label: 'Khandasa', pincode: '204106' },
    { value: 'khairpur', label: 'Khairpur', pincode: '204211' },
    { value: 'majjupur', label: 'Majjupur', pincode: '204109' },
    { value: 'mursan', label: 'Mursan', pincode: '204151' },
    { value: 'raja-ka-ganj', label: 'Raja Ka Ganj', pincode: '204201' },
    { value: 'rura', label: 'Rura', pincode: '204210' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '204132' },
    { value: 'sikandra', label: 'Sikandra', pincode: '204215' },
    { value: 'suranpura', label: 'Suranpura', pincode: '204204' },
    { value: 'thehtupur', label: 'Thehtupur', pincode: '204112' },
    { value: 'udhpur', label: 'Udhpur', pincode: '204104' },
    { value: 'vijay-pur', label: 'Vijay Pur', pincode: '204205' },
    { value: 'vishwakarma', label: 'Vishwakarma', pincode: '204101' }
  ],

  'hamirpur': [
    { value: 'adampur', label: 'Adampur', pincode: '210312' },
    { value: 'ailum', label: 'Ailum', pincode: '210301' },
    { value: 'babhani', label: 'Babhani', pincode: '210302' },
    { value: 'banarasi', label: 'Banarasi', pincode: '210314' },
    { value: 'bhondla', label: 'Bhondla', pincode: '210313' },
    { value: 'bhuri', label: 'Bhuri', pincode: '210301' },
    { value: 'chandpur', label: 'Chandpur', pincode: '210303' },
    { value: 'charkha', label: 'Charkha', pincode: '210307' },
    { value: 'dhatpur', label: 'Dhatpur', pincode: '210305' },
    { value: 'dhiman', label: 'Dhiman', pincode: '210305' },
    { value: 'dholpur', label: 'Dholpur', pincode: '210303' },
    { value: 'gajraula', label: 'Gajraula', pincode: '210306' },
    { value: 'gonda', label: 'Gonda', pincode: '210301' },
    { value: 'hamirpur', label: 'Hamirpur', pincode: '210301' },
    { value: 'kakrahi', label: 'Kakrahi', pincode: '210312' },
    { value: 'kaithora', label: 'Kaithora', pincode: '210312' },
    { value: 'khairabad', label: 'Khairabad', pincode: '210313' },
    { value: 'kumharan', label: 'Kumharan', pincode: '210314' },
    { value: 'mahrauli', label: 'Mahrauli', pincode: '210306' },
    { value: 'manihara', label: 'Manihara', pincode: '210310' },
    { value: 'mehtabpur', label: 'Mehtabpur', pincode: '210311' },
    { value: 'muradpur', label: 'Muradpur', pincode: '210305' },
    { value: 'naugarh', label: 'Naugarh', pincode: '210310' },
    { value: 'palia', label: 'Palia', pincode: '210307' },
    { value: 'rajarampur', label: 'Rajarampur', pincode: '210301' },
    { value: 'salempur', label: 'Salempur', pincode: '210312' },
    { value: 'shankarpur', label: 'Shankarpur', pincode: '210308' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '210311' },
    { value: 'singhpur', label: 'Singhpur', pincode: '210311' },
    { value: 'tikari', label: 'Tikari', pincode: '210309' },
    { value: 'tindwari', label: 'Tindwari', pincode: '210314' },
    { value: 'udaipur', label: 'Udaipur', pincode: '210305' }
  ],
  'mathura': [
    { value: 'aligarh', label: 'Aligarh', pincode: '281001' },
    { value: 'baldeo', label: 'Baldeo', pincode: '281301' },
    { value: 'barsana', label: 'Barsana', pincode: '281503' },
    { value: 'chhatikara', label: 'Chhatikara', pincode: '281121' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '281005' },
    { value: 'gokul', label: 'Gokul', pincode: '281003' },
    { value: 'govardhan', label: 'Govardhan', pincode: '281502' },
    { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '281001' },
    { value: 'mathura', label: 'Mathura', pincode: '281001' },
    { value: 'mohana', label: 'Mohana', pincode: '281204' },
    { value: 'nakhasa', label: 'Nakhasa', pincode: '281202' },
    { value: 'nauganwa', label: 'Nauganwa', pincode: '281301' },
    { value: 'nektar', label: 'Nektar', pincode: '281001' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '281202' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '281001' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '281203' },
    { value: 'vrindavan', label: 'Vrindavan', pincode: '281121' },
    { value: 'wazirganj', label: 'Wazirganj', pincode: '281001' },
    { value: 'ajabpur', label: 'Ajabpur', pincode: '281204' },
    { value: 'bad', label: 'Bad', pincode: '281003' },
    { value: 'bhuteshwar', label: 'Bhuteshwar', pincode: '281004' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '281302' },
    { value: 'dholpur', label: 'Dholpur', pincode: '281305' },
    { value: 'hathras', label: 'Hathras', pincode: '281301' },
    { value: 'kusumgram', label: 'Kusumgram', pincode: '281302' },
    { value: 'manoharpur', label: 'Manoharpur', pincode: '281205' },
    { value: 'masani', label: 'Masani', pincode: '281306' },
    { value: 'meena-bazaar', label: 'Meena Bazaar', pincode: '281207' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '281204' },
    { value: 'nehrunagar', label: 'Nehrunagar', pincode: '281301' },
    { value: 'rajeshwarpur', label: 'Rajeshwarpur', pincode: '281208' },
    { value: 'shergarh', label: 'Shergarh', pincode: '281301' },
    { value: 'shriji-nagar', label: 'Shriji Nagar', pincode: '281001' },
    { value: 'tinsukia', label: 'Tinsukia', pincode: '281309' },
    { value: 'andheriya', label: 'Andheriya', pincode: '281302' },
    { value: 'baba-ganj', label: 'Baba Ganj', pincode: '281101' },
    { value: 'bhagalpur', label: 'Bhagalpur', pincode: '281001' },
    { value: 'biharipur', label: 'Biharipur', pincode: '281306' },
    { value: 'chowk-bazaar', label: 'Chowk Bazaar', pincode: '281001' },
    { value: 'kailashpur', label: 'Kailashpur', pincode: '281205' },
    { value: 'madhurapuri', label: 'Madhurapuri', pincode: '281307' },
    { value: 'mau', label: 'Mau', pincode: '281002' },
    { value: 'murari', label: 'Murari', pincode: '281303' },
    { value: 'naganwa', label: 'Naganwa', pincode: '281209' },
    { value: 'padav', label: 'Padav', pincode: '281308' },
    { value: 'panchvati', label: 'Panchvati', pincode: '281104' },
    { value: 'ramganj', label: 'Ramganj', pincode: '281310' },
    { value: 'sai-nagar', label: 'Sai Nagar', pincode: '281208' },
    { value: 'shamshabad', label: 'Shamshabad', pincode: '281312' },
    { value: 'rithora', label: 'Rithora', pincode: '281311' },
    { value: 'nawada', label: 'Nawada', pincode: '281302' },
    { value: 'durga-nagar', label: 'Durga Nagar', pincode: '281313' },
    { value: 'prem-nagar', label: 'Prem Nagar', pincode: '281314' }
  ],

  'firozabad': [
    { value: 'ahmadabad', label: 'Ahmadabad', pincode: '283203' },
    { value: 'aligarh', label: 'Aligarh', pincode: '283201' },
    { value: 'ballabhnagar', label: 'Ballabhnagar', pincode: '283205' },
    { value: 'bhagwanpur', label: 'Bhagwanpur', pincode: '283201' },
    { value: 'firozabad', label: 'Firozabad', pincode: '283203' },
    { value: 'ganjdundwara', label: 'Ganjdundwara', pincode: '283204' },
    { value: 'ghosi', label: 'Ghosi', pincode: '283205' },
    { value: 'gonda', label: 'Gonda', pincode: '283203' },
    { value: 'gharaunda', label: 'Gharaunda', pincode: '283206' },
    { value: 'kasganj', label: 'Kasganj', pincode: '283204' },
    { value: 'khoya', label: 'Khoya', pincode: '283208' },
    { value: 'nara', label: 'Nara', pincode: '283205' },
    { value: 'purwa', label: 'Purwa', pincode: '283206' },
    { value: 'rampur', label: 'Rampur', pincode: '283207' },
    { value: 'sadabad', label: 'Sadabad', pincode: '283208' },
    { value: 'shikohabad', label: 'Shikohabad', pincode: '283135' },
    { value: 'sirsaganj', label: 'Sirsaganj', pincode: '283203' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '283208' },
    { value: 'tundla', label: 'Tundla', pincode: '283204' },
    { value: 'usrahar', label: 'Usrahar', pincode: '283206' },
    { value: 'chaurasia', label: 'Chaurasia', pincode: '283209' },
    { value: 'kalyanpur', label: 'Kalyanpur', pincode: '283212' },
    { value: 'kamruddinpur', label: 'Kamruddinpur', pincode: '283210' },
    { value: 'madhaupur', label: 'Madhaupur', pincode: '283211' },
    { value: 'mohanpur', label: 'Mohanpur', pincode: '283213' },
    { value: 'sakatpur', label: 'Sakatpur', pincode: '283214' },
    { value: 'sikri', label: 'Sikri', pincode: '283215' },
    { value: 'sirsa', label: 'Sirsa', pincode: '283216' },
    { value: 'tikari', label: 'Tikari', pincode: '283217' },
    { value: 'umarpur', label: 'Umarpur', pincode: '283218' },
    { value: 'basauni', label: 'Basauni', pincode: '283220' },
    { value: 'garhwa', label: 'Garhwa', pincode: '283221' },
    { value: 'jalalpur', label: 'Jalalpur', pincode: '283222' },
    { value: 'karnai', label: 'Karnai', pincode: '283223' },
    { value: 'mathura', label: 'Mathura', pincode: '283224' },
    { value: 'narora', label: 'Narora', pincode: '283225' },
    { value: 'nagla', label: 'Nagla', pincode: '283226' },
    { value: 'patha', label: 'Patha', pincode: '283227' },
    { value: 'rajpur', label: 'Rajpur', pincode: '283228' },
    { value: 'sangrampur', label: 'Sangrampur', pincode: '283229' },
    { value: 'tilakpur', label: 'Tilakpur', pincode: '283230' },
    { value: 'vishnupur', label: 'Vishnupur', pincode: '283231' },
    { value: 'zeropur', label: 'Zeropur', pincode: '283232' }
  ],

  'farrukhabad': [
    { value: 'agwanpur', label: 'Agwanpur', pincode: '209612' },
    { value: 'alapur', label: 'Alapur', pincode: '209612' },
    { value: 'babhnauli', label: 'Babhnauli', pincode: '209502' },
    { value: 'bhindran', label: 'Bhindran', pincode: '209621' },
    { value: 'chandpur', label: 'Chandpur', pincode: '209625' },
    { value: 'farrukhabad', label: 'Farrukhabad', pincode: '209625' },
    { value: 'garhi', label: 'Garhi', pincode: '209625' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gojra', label: 'Gojra', pincode: '209202' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kanpur-akhri', label: 'Kanpur Akhri', pincode: '209624' },
    { value: 'khurja', label: 'Khurja', pincode: '209202' },
    { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '209623' },
    { value: 'mahimpur', label: 'Mahimpur', pincode: '209503' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '209625' },
    { value: 'palpur', label: 'Palpur', pincode: '209627' },
    { value: 'pali', label: 'Pali', pincode: '209625' },
    { value: 'rajnagar', label: 'Rajnagar', pincode: '209202' },
    { value: 'rahatgarh', label: 'Rahatgarh', pincode: '209502' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '209625' },
    { value: 'sujatpur', label: 'Sujatpur', pincode: '209623' },
    { value: 'tharwai', label: 'Tharwai', pincode: '209624' },
    { value: 'vijaypur', label: 'Vijaypur', pincode: '209625' },
    { value: 'bhadohi', label: 'Bhadohi', pincode: '209623' },
    { value: 'dhanpur', label: 'Dhanpur', pincode: '209627' },
    { value: 'gopalpur', label: 'Gopalpur', pincode: '209621' },
    { value: 'laharpur', label: 'Laharpur', pincode: '209622' },
    { value: 'manpur', label: 'Manpur', pincode: '209624' },
    { value: 'mehmoodpur', label: 'Mehmoodpur', pincode: '209625' },
    { value: 'mohalla-bismillah', label: 'Mohalla Bismillah', pincode: '209625' },
    { value: 'muradganj', label: 'Muradganj', pincode: '209502' },
    { value: 'purwa', label: 'Purwa', pincode: '209623' }
  ],

  'basti': [
    { value: 'anwakherwa', label: 'Anwakherwa', pincode: '272123' },
    { value: 'basti', label: 'Basti', pincode: '272001' },
    { value: 'basti-bazar', label: 'Basti Bazar', pincode: '272002' },
    { value: 'basti-city', label: 'Basti City', pincode: '272001' },
    { value: 'belwagram', label: 'Belwagram', pincode: '272125' },
    { value: 'bhainsa', label: 'Bhainsa', pincode: '272124' },
    { value: 'bharauli', label: 'Bharauli', pincode: '272126' },
    { value: 'chakra', label: 'Chakra', pincode: '272001' },
    { value: 'chhapparia', label: 'Chhapparia', pincode: '272108' },
    { value: 'dainpur', label: 'Dainpur', pincode: '272160' },
    { value: 'dhansripur', label: 'Dhansripur', pincode: '272111' },
    { value: 'dudhpura', label: 'Dudhpura', pincode: '272116' },
    { value: 'ghatampur', label: 'Ghatampur', pincode: '272106' },
    { value: 'gonda', label: 'Gonda', pincode: '272121' },
    { value: 'hariharganj', label: 'Hariharganj', pincode: '272107' },
    { value: 'jagatpur', label: 'Jagatpur', pincode: '272131' },
    { value: 'kakrahi', label: 'Kakrahi', pincode: '272131' },
    { value: 'kachhawa', label: 'Kachhawa', pincode: '272005' },
    { value: 'kamgarpur', label: 'Kamgarpur', pincode: '272148' },
    { value: 'kamti', label: 'Kamti', pincode: '272127' },
    { value: 'kanpur', label: 'Kanpur', pincode: '272118' },
    { value: 'khajurgaon', label: 'Khajurgaon', pincode: '272134' },
    { value: 'kishunpur', label: 'Kishunpur', pincode: '272103' },
    { value: 'kunda', label: 'Kunda', pincode: '272114' },
    { value: 'mahisagar', label: 'Mahisagar', pincode: '272119' },
    { value: 'manpur', label: 'Manpur', pincode: '272112' },
    { value: 'mau', label: 'Mau', pincode: '272002' },
    { value: 'mohaddipur', label: 'Mohaddipur', pincode: '272113' },
    { value: 'mohiuddinpur', label: 'Mohiuddinpur', pincode: '272117' },
    { value: 'nangla', label: 'Nangla', pincode: '272101' },
    { value: 'nazarabad', label: 'Nazarabad', pincode: '272148' },
    { value: 'pachperwa', label: 'Pachperwa', pincode: '272122' },
    { value: 'pachrauta', label: 'Pachrauta', pincode: '272110' },
    { value: 'raju-pur', label: 'Raju Pur', pincode: '272115' },
    { value: 'rahmapur', label: 'Rahmapur', pincode: '272120' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '272129' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '272012' },
    { value: 'rohila', label: 'Rohila', pincode: '272126' },
    { value: 'sadar', label: 'Sadar', pincode: '272001' },
    { value: 'sathia', label: 'Sathia', pincode: '272104' },
    { value: 'sithari', label: 'Sithari', pincode: '272103' },
    { value: 'sonkhari', label: 'Sonkhari', pincode: '272109' },
    { value: 'talganj', label: 'Talganj', pincode: '272125' },
    { value: 'telra', label: 'Telra', pincode: '272107' },
    { value: 'zafarabad', label: 'Zafarabad', pincode: '272103' }
  ],
  'bareilly': [
    { value: 'akbarabad', label: 'Akbarabad', pincode: '243202' },
    { value: 'aliganj', label: 'Aliganj', pincode: '243001' },
    { value: 'bareilly', label: 'Bareilly', pincode: '243001' },
    { value: 'bhimapur', label: 'Bhimapur', pincode: '243205' },
    { value: 'bhojipura', label: 'Bhojipura', pincode: '243202' },
    { value: 'bithiri', label: 'Bithiri', pincode: '243202' },
    { value: 'chandpur', label: 'Chandpur', pincode: '243502' },
    { value: 'dilari', label: 'Dilari', pincode: '243303' },
    { value: 'fatehganj', label: 'Fatehganj', pincode: '243501' },
    { value: 'gokul-pur', label: 'Gokul Pur', pincode: '243109' },
    { value: 'gurudwara', label: 'Gurudwara', pincode: '243007' },
    { value: 'katghar', label: 'Katghar', pincode: '243001' },
    { value: 'kishanpura', label: 'Kishanpura', pincode: '243003' },
    { value: 'khurpa', label: 'Khurpa', pincode: '243003' },
    { value: 'madarsa', label: 'Madarsa', pincode: '243005' },
    { value: 'maniharan', label: 'Maniharan', pincode: '243503' },
    { value: 'miyanpura', label: 'Miyanpura', pincode: '243010' },
    { value: 'mohammad-pur', label: 'Mohammad Pur', pincode: '243107' },
    { value: 'moti-nagar', label: 'Moti Nagar', pincode: '243102' },
    { value: 'nainital', label: 'Nainital', pincode: '243001' },
    { value: 'pilibhit-bypass', label: 'Pilibhit Bypass', pincode: '243122' },
    { value: 'purani-basti', label: 'Purani Basti', pincode: '243003' },
    { value: 'rajendra-nagar', label: 'Rajendra Nagar', pincode: '243005' },
    { value: 'rajsheela', label: 'Rajsheela', pincode: '243007' },
    { value: 'rohila', label: 'Rohila', pincode: '243207' },
    { value: 'shahjahanpur-road', label: 'Shahjahanpur Road', pincode: '243006' },
    { value: 'shankar-pur', label: 'Shankar Pur', pincode: '243106' },
    { value: 'shergarh', label: 'Shergarh', pincode: '243204' },
    { value: 'siddharthnagar', label: 'Siddharthnagar', pincode: '243012' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '243009' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '243204' },
    { value: 'talanagri', label: 'Talanagri', pincode: '243101' },
    { value: 'telipura', label: 'Telipura', pincode: '243109' },
    { value: 'tilhar', label: 'Tilhar', pincode: '243307' },
    { value: 'vishal-pur', label: 'Vishal Pur', pincode: '243004' }
  ],

  'barabanki': [
    { value: 'abadpur', label: 'Abadpur', pincode: '225001' },
    { value: 'alapur', label: 'Alapur', pincode: '225121' },
    { value: 'bahraich', label: 'Bahraich', pincode: '225205' },
    { value: 'barabanki', label: 'Barabanki', pincode: '225001' },
    { value: 'bhiti', label: 'Bhiti', pincode: '225207' },
    { value: 'budaun', label: 'Budaun', pincode: '225128' },
    { value: 'chandranagar', label: 'Chandranagar', pincode: '225210' },
    { value: 'dharampur', label: 'Dharampur', pincode: '225121' },
    { value: 'dudhwakhora', label: 'Dudhwakhora', pincode: '225124' },
    { value: 'gokulpur', label: 'Gokulpur', pincode: '225123' },
    { value: 'gunnaur', label: 'Gunnaur', pincode: '225209' },
    { value: 'jankipuram', label: 'Jankipuram', pincode: '225209' },
    { value: 'kachhawa', label: 'Kachhawa', pincode: '225124' },
    { value: 'kamathwalia', label: 'Kamathwalia', pincode: '225110' },
    { value: 'kanpur', label: 'Kanpur', pincode: '225202' },
    { value: 'khudabaksh', label: 'Khudabaksh', pincode: '225125' },
    { value: 'mahamudpur', label: 'Mahamudpur', pincode: '225111' },
    { value: 'malihabad', label: 'Malihabad', pincode: '225108' },
    { value: 'mau', label: 'Mau', pincode: '225103' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '225110' },
    { value: 'nagina', label: 'Nagina', pincode: '225115' },
    { value: 'pachhiman', label: 'Pachhiman', pincode: '225122' },
    { value: 'rahmapur', label: 'Rahmapur', pincode: '225204' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '225202' },
    { value: 'ramnagar-ii', label: 'Ramnagar II', pincode: '225203' },
    { value: 'rishikul', label: 'Rishikul', pincode: '225106' },
    { value: 'sadar-bara', label: 'Sadar Bara', pincode: '225107' },
    { value: 'sarai-aurangabad', label: 'Sarai Aurangabad', pincode: '225204' },
    { value: 'sonbarsa', label: 'Sonbarsa', pincode: '225201' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '225123' },
    { value: 'teliya', label: 'Teliya', pincode: '225109' },
    { value: 'tindola', label: 'Tindola', pincode: '225120' },
    { value: 'zindapur', label: 'Zindapur', pincode: '225201' }
  ],

  'banda': [
    { value: 'agni-kund', label: 'Agni Kund', pincode: '210001' },
    { value: 'amraipur', label: 'Amraipur', pincode: '210203' },
    { value: 'bada-brahn', label: 'Bada Brahn', pincode: '210013' },
    { value: 'banda', label: 'Banda', pincode: '210001' },
    { value: 'bandhpur', label: 'Bandhpur', pincode: '210111' },
    { value: 'baraundha', label: 'Baraundha', pincode: '210101' },
    { value: 'bawan', label: 'Bawan', pincode: '210123' },
    { value: 'bhareh', label: 'Bhareh', pincode: '210202' },
    { value: 'bhikampur', label: 'Bhikampur', pincode: '210121' },
    { value: 'bhitarra', label: 'Bhitarra', pincode: '210105' },
    { value: 'bhurja', label: 'Bhurja', pincode: '210124' },
    { value: 'bichhua', label: 'Bichhua', pincode: '210205' },
    { value: 'chandpur', label: 'Chandpur', pincode: '210205' },
    { value: 'chilla', label: 'Chilla', pincode: '210101' },
    { value: 'dhain', label: 'Dhain', pincode: '210125' },
    { value: 'dhanepur', label: 'Dhanepur', pincode: '210102' },
    { value: 'ghatakesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'ganjam', label: 'Ganjam', pincode: '210130' },
    { value: 'gokulpur', label: 'Gokulpur', pincode: '210129' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'gunnaur', label: 'Gunnaur', pincode: '210204' },
    { value: 'jaitpur', label: 'Jaitpur', pincode: '210102' },
    { value: 'jalalpur', label: 'Jalalpur', pincode: '210117' },
    { value: 'kachhawa', label: 'Kachhawa', pincode: '210106' },
    { value: 'kakarhi', label: 'Kakarhi', pincode: '210123' },
    { value: 'kamleshwar', label: 'Kamleshwar', pincode: '210122' },
    { value: 'khamaria', label: 'Khamaria', pincode: '210107' },
    { value: 'kharati', label: 'Kharati', pincode: '210108' },
    { value: 'kudari', label: 'Kudari', pincode: '210129' },
    { value: 'kunwarpur', label: 'Kunwarpur', pincode: '210115' },
    { value: 'mahalgaon', label: 'Mahalgaon', pincode: '210110' },
    { value: 'maheshpur', label: 'Maheshpur', pincode: '210207' },
    { value: 'mandhata', label: 'Mandhata', pincode: '210126' },
    { value: 'manjhan', label: 'Manjhan', pincode: '210109' },
    { value: 'mujhra', label: 'Mujhra', pincode: '210119' },
    { value: 'nepanipur', label: 'Nepanipur', pincode: '210208' },
    { value: 'patna', label: 'Patna', pincode: '210210' },
    { value: 'rahatgarh', label: 'Rahatgarh', pincode: '210127' },
    { value: 'raipur', label: 'Raipur', pincode: '210128' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '210116' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '210114' },
    { value: 'sadar-banda', label: 'Sadar Banda', pincode: '210002' },
    { value: 'sonhara', label: 'Sonhara', pincode: '210118' },
    { value: 'sukha-brahn', label: 'Sukha Brahn', pincode: '210103' },
    { value: 'tenduwa', label: 'Tenduwa', pincode: '210205' },
    { value: 'thariyaon', label: 'Thariyaon', pincode: '210120' },
    { value: 'ugapur', label: 'Ugapur', pincode: '210122' }
  ],

  'bahraich': [
    { value: 'achhuti', label: 'Achhuti', pincode: '271303' },
    { value: 'akbarpur', label: 'Akbarpur', pincode: '271001' },
    { value: 'bahraich', label: 'Bahraich', pincode: '271801' },
    { value: 'barkhera', label: 'Barkhera', pincode: '271312' },
    { value: 'bishunpur', label: 'Bishunpur', pincode: '271206' },
    { value: 'chandpur', label: 'Chandpur', pincode: '271302' },
    { value: 'chhoti-tand', label: 'Chhoti Tand', pincode: '271002' },
    { value: 'dankaur', label: 'Dankaur', pincode: '271105' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gonda', label: 'Gonda', pincode: '271401' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hatwa', label: 'Hatwa', pincode: '271603' },
    { value: 'israuli', label: 'Israuli', pincode: '271312' },
    { value: 'jaitapur', label: 'Jaitapur', pincode: '271306' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '271112' },
    { value: 'mahuwa', label: 'Mahuwa', pincode: '271305' },
    { value: 'manjhanpur', label: 'Manjhanpur', pincode: '271104' },
    { value: 'mau', label: 'Mau', pincode: '271302' },
    { value: 'nauka-mahal', label: 'Nauka Mahal', pincode: '271206' },
    { value: 'raipur', label: 'Raipur', pincode: '271301' },
    { value: 'ram-nagar', label: 'Ram Nagar', pincode: '271006' },
    { value: 'rewa', label: 'Rewa', pincode: '271102' },
    { value: 'shahpur', label: 'Shahpur', pincode: '271602' },
    { value: 'sindur', label: 'Sindur', pincode: '271602' },
    { value: 'sugra', label: 'Sugra', pincode: '271311' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '271805' },
    { value: 'tariyani', label: 'Tariyani', pincode: '271401' },
    { value: 'tulsipur', label: 'Tulsipur', pincode: '271303' },
    { value: 'udharpur', label: 'Udharpur', pincode: '271202' },
    { value: 'villapur', label: 'Villapur', pincode: '271304' },
    { value: 'vishunpur', label: 'Vishunpur', pincode: '271212' }
  ],

  'azamgarh': [
    { value: 'alapur', label: 'Alapur', pincode: '276001' },
    { value: 'babhaniya', label: 'Babhaniya', pincode: '276135' },
    { value: 'bahadurpur', label: 'Bahadurpur', pincode: '276208' },
    { value: 'barai', label: 'Barai', pincode: '276141' },
    { value: 'bilari', label: 'Bilari', pincode: '276146' },
    { value: 'chatra', label: 'Chatra', pincode: '276202' },
    { value: 'gharam', label: 'Gharam', pincode: '276136' },
    { value: 'ghazipur', label: 'Ghazipur', pincode: '276138' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gokhula', label: 'Gokhula', pincode: '276121' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hirangpur', label: 'Hirangpur', pincode: '276123' },
    { value: 'jahanaganj', label: 'Jahanaganj', pincode: '276204' },
    { value: 'jigina', label: 'Jigina', pincode: '276205' },
    { value: 'kaptanganj', label: 'Kaptanganj', pincode: '276142' },
    { value: 'kamtapur', label: 'Kamtapur', pincode: '276141' },
    { value: 'keshavpur', label: 'Keshavpur', pincode: '276206' },
    { value: 'majhergaon', label: 'Majhergaon', pincode: '276141' },
    { value: 'mirzapur', label: 'Mirzapur', pincode: '276001' },
    { value: 'mubarakpur', label: 'Mubarakpur', pincode: '276403' },
    { value: 'nandganj', label: 'Nandganj', pincode: '276130' },
    { value: 'rajamau', label: 'Rajamau', pincode: '276137' },
    { value: 'sidhari', label: 'Sidhari', pincode: '276205' },
    { value: 'singhpur', label: 'Singhpur', pincode: '276145' },
    { value: 'tughlakpur', label: 'Tughlakpur', pincode: '276142' },
    { value: 'udaypur', label: 'Udaypur', pincode: '276208' },
    { value: 'zamania', label: 'Zamania', pincode: '276302' }
  ],

  'amroha': [
    { "value": "adampur", "label": "Adampur", "pincode": "244255" },
    { "value": "ahraula-mafi", "label": "Ahraula Mafi", "pincode": "244231" },
    { "value": "amroha", "label": "Amroha", "pincode": "244221" },
    { "value": "amroha-bazar", "label": "Amroha Bazar", "pincode": "244221" },
    { "value": "amroha-shahi-chabutra", "label": "Amroha Shahi Chabutra", "pincode": "244221" },
    { "value": "anchora-kamboh", "label": "Anchora Kamboh", "pincode": "244304" },
    { "value": "atrasikalan", "label": "Atrasikalan", "pincode": "244236" },
    { "value": "awalpur", "label": "Awalpur", "pincode": "244251" },
    { "value": "bachhraon", "label": "Bachhraon", "pincode": "244225" },
    { "value": "bahadur-pur-khurd", "label": "Bahadur Pur Khurd", "pincode": "244221" },
    { "value": "bartaura", "label": "Bartaura", "pincode": "244255" },
    { "value": "bhartiya-gram", "label": "Bhartiya Gram", "pincode": "244223" },
    { "value": "bibra-khurd", "label": "Bibra Khurd", "pincode": "244501" },
    { "value": "bijaura", "label": "Bijaura", "pincode": "244235" },
    { "value": "buderna", "label": "Buderna", "pincode": "244221" },
    { "value": "burawali", "label": "Burawali", "pincode": "244241" },
    { "value": "chakanwala", "label": "Chakanwala", "pincode": "244225" },
    { "value": "chakooni", "label": "Chakooni", "pincode": "244242" },
    { "value": "chand-nagar", "label": "Chand Nagar", "pincode": "244236" },
    { "value": "chhapna", "label": "Chhapna", "pincode": "244255" },
    { "value": "chuchela-kalan", "label": "Chuchela Kalan", "pincode": "244231" },
    { "value": "dahpa", "label": "Dahpa", "pincode": "244242" },
    { "value": "darhyal-khadar", "label": "Darhyal Khadar", "pincode": "244255" },
    { "value": "deorhi-urf-hadipur", "label": "Deorhi Urf Hadipur", "pincode": "244102" },
    { "value": "dhakka", "label": "Dhakka", "pincode": "244242" },
    { "value": "dhanaura", "label": "Dhanaura", "pincode": "244231" },
    { "value": "dhauti", "label": "Dhauti", "pincode": "244225" },
    { "value": "dhawarsi", "label": "Dhawarsi", "pincode": "244242" },
    { "value": "didauli", "label": "Didauli", "pincode": "244222" },
    { "value": "dingra", "label": "Dingra", "pincode": "244231" },
    { "value": "gajana", "label": "Gajana", "pincode": "244221" },
    { "value": "gajasthal", "label": "Gajasthal", "pincode": "244251" },
    { "value": "gajraula", "label": "Gajraula", "pincode": "244235" },
    { "value": "gangacholi", "label": "Gangacholi", "pincode": "244241" },
    { "value": "gangeshwari", "label": "Gangeshwari", "pincode": "244255" },
    { "value": "gangwar", "label": "Gangwar", "pincode": "244241" },
    { "value": "garhi-salempur", "label": "Garhi Salempur", "pincode": "244501" },
    { "value": "hajarpur-jamania", "label": "Hajarpur Jamania", "pincode": "244221" },
    { "value": "hasanpur", "label": "Hasanpur", "pincode": "244241" },
    { "value": "imratpur", "label": "Imratpur", "pincode": "244255" },
    { "value": "iqbalpur-urf-kamelpor", "label": "Iqbalpur Urf Kamelpor", "pincode": "244231" },
    { "value": "jahangirpur-chakpheri", "label": "Jahangirpur Chakpheri", "pincode": "244501" },
    { "value": "jahtauli", "label": "Jahtauli", "pincode": "244255" },
    { "value": "jajroo", "label": "Jajroo", "pincode": "244251" },
    { "value": "jalajpur-dhana", "label": "Jalajpur Dhana", "pincode": "244221" },
    { "value": "jamna-khas", "label": "Jamna Khas", "pincode": "244501" },
    { "value": "joya", "label": "Joya", "pincode": "244222" },
    { "value": "kadral", "label": "Kadral", "pincode": "244251" },
    { "value": "kail-bakri", "label": "Kail Bakri", "pincode": "244501" },
    { "value": "kailsa", "label": "Kailsa", "pincode": "244221" },
    { "value": "kankather", "label": "Kankather", "pincode": "244235" },
    { "value": "kapsua", "label": "Kapsua", "pincode": "244235" }
  ],

  'amethi': [
    { value: 'akbarpur', label: 'Akbarpur', pincode: '229122' },
    { value: 'amethi-town', label: 'Amethi Town', pincode: '229001' },
    { value: 'barmau', label: 'Barmau', pincode: '229106' },
    { value: 'barkandera', label: 'Barkandera', pincode: '229107' },
    { value: 'bhaisamau', label: 'Bhaisamau', pincode: '229126' },
    { value: 'bikapur', label: 'Bikapur', pincode: '229302' },
    { value: 'chandpur', label: 'Chandpur', pincode: '229201' },
    { value: 'dalmau', label: 'Dalmau', pincode: '229205' },
    { value: 'ganeshganj', label: 'Ganeshganj', pincode: '229403' },
    { value: 'gohari', label: 'Gohari', pincode: '229504' },
    { value: 'harvanshpur', label: 'Harvanshpur', pincode: '229402' },
    { value: 'jamo', label: 'Jamo', pincode: '229301' },
    { value: 'jogipur', label: 'Jogipur', pincode: '229309' },
    { value: 'kalakankar', label: 'Kalakankar', pincode: '229305' },
    { value: 'kalyanpur', label: 'Kalyanpur', pincode: '229107' },
    { value: 'khatoura', label: 'Khatoura', pincode: '229408' },
    { value: 'khurd', label: 'Khurd', pincode: '229201' },
    { value: 'koila', label: 'Koila', pincode: '229204' },
    { value: 'kurawar', label: 'Kurawar', pincode: '229403' },
    { value: 'manjhanpur', label: 'Manjhanpur', pincode: '229509' },
    { value: 'mau-aima', label: 'Mau Aima', pincode: '211015' },
    { value: 'mau-ramgarh', label: 'Mau Ramgarh', pincode: '229404' },
    { value: 'mithaura', label: 'Mithaura', pincode: '229305' },
    { value: 'naugarh', label: 'Naugarh', pincode: '229406' },
    { value: 'patra', label: 'Patra', pincode: '229208' },
    { value: 'patahi', label: 'Patahi', pincode: '229401' },
    { value: 'purwa', label: 'Purwa', pincode: '229411' },
    { value: 'raebareli-road', label: 'Raebareli Road', pincode: '229103' },
    { value: 'rahatganj', label: 'Rahatganj', pincode: '229302' },
    { value: 'raipur', label: 'Raipur', pincode: '229103' },
    { value: 'ramganj', label: 'Ramganj', pincode: '229406' },
    { value: 'salon', label: 'Salon', pincode: '229127' },
    { value: 'sadhwara', label: 'Sadhwara', pincode: '229501' },
    { value: 'sikandra', label: 'Sikandra', pincode: '229404' },
    { value: 'sultanpur-road', label: 'Sultanpur Road', pincode: '229001' },
    { value: 'tarapur', label: 'Tarapur', pincode: '229401' },
    { value: 'tiloi', label: 'Tiloi', pincode: '229309' },
    { value: 'tikari', label: 'Tikari', pincode: '229401' },
    { value: 'ugapur', label: 'Ugapur', pincode: '229504' },
    { value: 'uncha', label: 'Uncha', pincode: '229405' },
    { value: 'vishwanathganj', label: 'Vishwanathganj', pincode: '229404' }
  ],

 'meerut': [
  { value: 'aadarsh-nagar', label: 'Aadarsh Nagar', pincode: '250001' },
  { value: 'abdullapur', label: 'Abdullapur', pincode: '250103' },
  { value: 'akhbar-nagar', label: 'Akhbar Nagar', pincode: '250001' },
  { value: 'ambedkar-nagar', label: 'Ambedkar Nagar', pincode: '250002' },
  { value: 'ansari-road', label: 'Ansari Road', pincode: '250002' },
  { value: 'baghpat-road', label: 'Baghpat Road', pincode: '250002' },
  { value: 'balwant-nagar', label: 'Balwant Nagar', pincode: '250002' },
  { value: 'bani-sarai', label: 'Bani Sarai', pincode: '250002' },
  { value: 'sbegum-bagh', label: 'Begum Bagh', pincode: '250004' },
  { value: 'brahmanpuri', label: 'Brahmanpuri', pincode: '250002' },
  { value: 'chakbandi', label: 'Chakbandi', pincode: '250002' },
  { value: 'civil-lines', label: 'Civil Lines', pincode: '250001' },
  { value: 'delhi-road', label: 'Delhi Road', pincode: '250001' },
  { value: 'devi-nagar', label: 'Devi Nagar', pincode: '250004' },
  { value: 'durga-nagar', label: 'Durga Nagar', pincode: '250004' },
  { value: 'egarasi', label: 'Egarasi', pincode: '250205' },
  { value: 'ganga-nagar', label: 'Ganga Nagar', pincode: '250001' },
  { value: 'garh-road', label: 'Garh Road', pincode: '250003' },
  { value: 'govindpuri', label: 'Govindpuri', pincode: '250004' },
  { value: 'gulzar-nagar', label: 'Gulzar Nagar', pincode: '250001' },
  { value: 'happur-road', label: 'Happur Road', pincode: '250001' },
  { value: 'ishwar-nagar', label: 'Ishwar Nagar', pincode: '250002' },
  { value: 'jagrati-vihar', label: 'Jagrati Vihar', pincode: '250004' },
  { value: 'jawahar-quart', label: 'Jawahar Quart', pincode: '250004' },
  { value: 'kanker-khera', label: 'Kanker Khera', pincode: '250001' },
  { value: 'lakhipura', label: 'Lakhipura', pincode: '250002' },
  { value: 'mahendra-enclave', label: 'Mahendra Enclave', pincode: '250002' },
  { value: 'mall-road', label: 'Mall Road', pincode: '250001' },
  { value: 'meerut-cantt', label: 'Meerut Cantt', pincode: '250001' },
  { value: 'meerut-college-road', label: 'Meerut College Road', pincode: '250001' },
  { value: 'mohkam-pur', label: 'Mohkam Pur', pincode: '250001' },
  { value: 'modipuram', label: 'Modipuram', pincode: '250110' },
  { value: 'nandgram', label: 'Nandgram', pincode: '250002' },
  { value: 'narangpuri', label: 'Narangpuri', pincode: '250002' },
  { value: 'navjivan-city', label: 'Navjivan City', pincode: '250002' },
  { value: 'pallavpuram', label: 'Pallavpuram', pincode: '250110' },
  { value: 'phool-bagh-colony', label: 'Phool Bagh Colony', pincode: '250001' },
  { value: 'railway-road', label: 'Railway Road', pincode: '250002' },
  { value: 'ram-nagar', label: 'Ram Nagar', pincode: '250002' },
  { value: 'rohta-road', label: 'Rohta Road', pincode: '250001' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '250001' },
  { value: 'saket', label: 'Saket', pincode: '250002' },
  { value: 'sanjay-nagar', label: 'Sanjay Nagar', pincode: '250001' },
  { value: 'sarai-lal-das', label: 'Sarai Lal Das', pincode: '250001' },
  { value: 'sharda-road', label: 'Sharda Road', pincode: '250002' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '250004' },
  { value: 'shivaji-road', label: 'Shivaji Road', pincode: '250004' },
  { value: 'shivlok', label: 'Shivlok', pincode: '250005' },
  { value: 'shradha-puri', label: 'Shradha Puri', pincode: '250004' },
  { value: 'sri-nagar', label: 'Sri Nagar', pincode: '250004' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '250002' },
  { value: 'surajkund', label: 'Surajkund', pincode: '250002' },
  { value: 'vandan-puri', label: 'Vandan Puri', pincode: '250002' },
  { value: 'ved-vyas-puri', label: 'Ved Vyas Puri', pincode: '250004' },
  { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '250001' },
  { value: 'vishnu-vihar', label: 'Vishnu Vihar', pincode: '250004' },
  { value: 'western-kutchery-road', label: 'Western Kutchery Road', pincode: '250003' },
  { value: 'woodstock-colony', label: 'Woodstock Colony', pincode: '250005' },
  { value: 'zaidi-nagar', label: 'Zaidi Nagar', pincode: '250001' }
],

  'lucknow': [
    { value: 'aashiana', label: 'Aashiana', pincode: '226012' },
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '226005' },
    { value: 'ahmamau', label: 'Ahmamau', pincode: '226002' },
    { value: 'aishbagh', label: 'Aishbagh', pincode: '226004' },
    { value: 'alambagh', label: 'Alambagh', pincode: '226005' },
    { value: 'alamnagar', label: 'Alamnagar', pincode: '226017' },
    { value: 'aliganj', label: 'Aliganj', pincode: '226024' },
    { value: 'amar-shaheed-path', label: 'Amar Shaheed Path', pincode: '226001' },
    { value: 'amausi', label: 'Amausi', pincode: '226008' },
    { value: 'amber-ganj', label: 'Amber Ganj', pincode: '226003' },
    { value: 'anand-nagar', label: 'Anand Nagar', pincode: '226005' },
    { value: 'ap-sen-marg', label: 'AP Sen Marg', pincode: '226001' },
    { value: 'arjunganj', label: 'Arjunganj', pincode: '226002' },
    { value: 'arya-nagar', label: 'Arya Nagar', pincode: '226010' },
    { value: 'ashiyana-colony', label: 'Ashiyana Colony', pincode: '226012' },
    { value: 'ashok-marg', label: 'Ashok Marg', pincode: '226001' },
    { value: 'balaganj', label: 'Balaganj', pincode: '226004' },
    { value: 'banthra', label: 'Banthra', pincode: '226401' },
    { value: 'barha', label: 'Barha', pincode: '226023' },
    { value: 'behta-saboli', label: 'Behta Saboli', pincode: '226202' },
    { value: 'bhadrukh', label: 'Bhadrukh', pincode: '226001' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '226002' },
    { value: 'bijnaur', label: 'Bijnaur', pincode: '226001' },
    { value: 'chand-ganj', label: 'Chand Ganj', pincode: '226004' },
    { value: 'charbagh', label: 'Charbagh', pincode: '226004' },
    { value: 'chaupatiyan', label: 'Chaupatiyan', pincode: '226002' },
    { value: 'chinhat', label: 'Chinhat', pincode: '226028' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '226001' },
    { value: 'dalibagh-colony', label: 'Dalibagh Colony', pincode: '226001' },
    { value: 'daliganj', label: 'Daliganj', pincode: '226020' },
    { value: 'darulshafa', label: 'Darulshafa', pincode: '226003' },
    { value: 'deva-road', label: 'Deva Road', pincode: '226001' },
    { value: 'dilkusha-garden', label: 'Dilkusha Garden', pincode: '226002' },
    { value: 'dlf-garden-city', label: 'DLF Garden City', pincode: '226029' },
    { value: 'faizabad-road', label: 'Faizabad Road', pincode: '226016' },
    { value: 'ganesh-ganj', label: 'Ganesh Ganj', pincode: '226004' },
    { value: 'gari-chunauti', label: 'Gari Chunauti', pincode: '226002' },
    { value: 'ghaila', label: 'Ghaila', pincode: '226002' },
    { value: 'ghazipur', label: 'Ghazipur', pincode: '226016' },
    { value: 'goila', label: 'Goila', pincode: '226001' },
    { value: 'gokhale-marg', label: 'Gokhale Marg', pincode: '226001' },
    { value: 'gomti-nagar', label: 'Gomti Nagar', pincode: '226010' },
    { value: 'gudamba-thaana-road', label: 'Gudamba Thaana Road', pincode: '226020' },
    { value: 'guramba', label: 'Guramba', pincode: '226002' },
    { value: 'hal', label: 'HAL', pincode: '226009' },
    { value: 'hazratganj', label: 'Hazratganj', pincode: '226001' },
    { value: 'husainabad', label: 'Husainabad', pincode: '226003' },
    { value: 'hussainganj', label: 'Hussainganj', pincode: '226003' },
    { value: 'iim-road', label: 'IIM Road', pincode: '226020' },
    { value: 'indira-nagar', label: 'Indira Nagar', pincode: '226016' },
    { value: 'jal-vayu-vihar', label: 'Jal Vayu Vihar', pincode: '226016' },
    { value: 'jankipuram', label: 'Jankipuram', pincode: '226021' },
    { value: 'jopling-road', label: 'Jopling Road', pincode: '226003' },
    { value: 'jugor', label: 'Jugor', pincode: '226002' },
    { value: 'kalyanpur', label: 'Kalyanpur', pincode: '226022' },
    { value: 'kamalabad-barhauli', label: 'Kamalabad Barhauli', pincode: '226023' },
    { value: 'kanpur-road', label: 'Kanpur Road', pincode: '422101' },
    { value: 'kuroni', label: 'Kuroni', pincode: '226021' },
    { value: 'kursi-road', label: 'Kursi Road', pincode: '226026' },
    { value: 'lalbagh', label: 'Lalbagh', pincode: '226001' },
    { value: 'madion', label: 'Madion', pincode: '226019' },
    { value: 'mahanagar', label: 'Mahanagar', pincode: '226006' },
    { value: 'mahipatmau', label: 'Mahipatmau', pincode: '226201' },
    { value: 'malesemau', label: 'Malesemau', pincode: '226301' },
    { value: 'manak-nagar', label: 'Manak Nagar', pincode: '226011' },
    { value: 'manas-nagar', label: 'Manas Nagar', pincode: '226022' },
    { value: 'maunda', label: 'Maunda', pincode: '226002' },
    { value: 'miranpur-pinvat', label: 'Miranpur Pinvat', pincode: '226002' },
    { value: 'mohan-meking-road', label: 'Mohan Meking Road', pincode: '226001' },
    { value: 'narayan-nagar', label: 'Narayan Nagar', pincode: '226005' },
    { value: 'natkur', label: 'Natkur', pincode: '226021' },
    { value: 'naubasta', label: 'Naubasta', pincode: '226020' },
    { value: 'naveen-galla-mandi', label: 'Naveen Galla Mandi', pincode: '226002' },
    { value: 'navi-kot-nandana', label: 'Navi Kot Nandana', pincode: '226010' },
    { value: 'new-ganeshganj', label: 'New Ganeshganj', pincode: '226004' },
    { value: 'new-hyderabad', label: 'New Hyderabad', pincode: '226007' },
    { value: 'nijampur-malhor', label: 'Nijampur Malhor', pincode: '226002' },
    { value: 'nilmatha', label: 'Nilmatha', pincode: '226020' },
    { value: 'nirala-nagar', label: 'Nirala Nagar', pincode: '226020' },
    { value: 'nishatganj', label: 'Nishatganj', pincode: '226007' },
    { value: 'paikaramau', label: 'Paikaramau', pincode: '226002' },
    { value: 'pan-dariba-marg', label: 'Pan Dariba Marg', pincode: '226001' },
    { value: 'park-road', label: 'Park Road', pincode: '226001' },
    { value: 'pawanpuri', label: 'Pawanpuri', pincode: '226020' },
    { value: 'piparsand', label: 'Piparsand', pincode: '226203' },
    { value: 'prag-narain-road', label: 'Prag Narain Road', pincode: '226001' },
    { value: 'rae-bareli-road', label: 'Rae Bareli Road', pincode: '226025' },
    { value: 'rahim-nagar', label: 'Rahim Nagar', pincode: '226002' },
    { value: 'rajajipuram', label: 'Rajajipuram', pincode: '226017' },
    { value: 'rajendra-nagar', label: 'Rajendra Nagar', pincode: '226004' },
    { value: 'ram-mohan-rai-marg', label: 'Ram Mohan Rai Marg', pincode: '226001' },
    { value: 'rasoolpur-sadat', label: 'Rasoolpur Sadat', pincode: '226202' },
    { value: 'saadatganj', label: 'Saadatganj', pincode: '226003' },
    { value: 'sadrauna', label: 'Sadrauna', pincode: '226001' },
    { value: 'sapru-marg', label: 'Sapru Marg', pincode: '226001' },
    { value: 'sarai-mali-khan', label: 'Sarai Mali Khan', pincode: '226003' },
    { value: 'sarojini-nagar', label: 'Sarojini Nagar', pincode: '226008' },
    { value: 'sarosa-bharosa', label: 'Sarosa Bharosa', pincode: '226003' },
    { value: 'sarvodaya-nagar', label: 'Sarvodaya Nagar', pincode: '226016' },
    { value: 'sector-14', label: 'Sector 14', pincode: '226020' },
    { value: 'sector-18', label: 'Sector 18', pincode: '226020' },
    { value: 'sector-B', label: 'Sector B', pincode: '226022' },
    { value: 'sector-D', label: 'Sector D', pincode: '226022' },
    { value: 'shahnajaf-road', label: 'Shahnajaf Road', pincode: '226001' },
    { value: 'sharda-nagar', label: 'Sharda Nagar', pincode: '226002' },
    { value: 'shyam-vihar-colony', label: 'Shyam Vihar Colony', pincode: '226012' },
    { value: 'sikrauri', label: 'Sikrauri', pincode: '226020' },
    { value: 'singar-nagar', label: 'Singar Nagar', pincode: '226016' },
    { value: 'subhash-marg', label: 'Subhash Marg', pincode: '226001' },
    { value: 'sujanpura', label: 'Sujanpura', pincode: '226005' },
    { value: 'sunder-bagh', label: 'Sunder Bagh', pincode: '226018' },
    { value: 'sushant-golf-city', label: 'Sushant Golf City', pincode: '226030' },
    { value: 'telibagh', label: 'Telibagh', pincode: '226022' },
    { value: 'thakurganj', label: 'Thakurganj', pincode: '226003' },
    { value: 'the-mall-avenue', label: 'The Mall Avenue', pincode: '226022' },
    { value: 'tilak-marg', label: 'Tilak Marg', pincode: '226001' },
    { value: 'triveni-nagar', label: 'Triveni Nagar', pincode: '226020' },
    { value: 'uattardhona', label: 'Uattardhona', pincode: '226002' },
    { value: 'utrathia', label: 'Utrathia', pincode: '226202' },
    { value: 'vasant-kunj', label: 'Vasant Kunj', pincode: '226010' },
    { value: 'vibhuti-khand', label: 'Vibhuti Khand', pincode: '226010' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '226022' },
    { value: 'vineet-khand', label: 'Vineet Khand', pincode: '226010' },
    { value: 'vip-road', label: 'VIP Road', pincode: '226025' },
    { value: 'vishesh-khand', label: 'Vishesh Khand', pincode: '226010' },
    { value: 'vivekanand-puri', label: 'Vivekanand Puri', pincode: '226001' },
    { value: 'vrindavan-yojana', label: 'Vrindavan Yojana', pincode: '226029' },
    { value: 'wazirganj', label: 'Wazirganj', pincode: '226004' },
    { value: 'yahiaganj', label: 'Yahiaganj', pincode: '226003' }
  ],

  'ghaziabad': [
    { value: 'abhishek-vihar', label: 'Abhishek Vihar', pincode: '201003' },
    { value: 'ajanta-vihar', label: 'Ajanta Vihar', pincode: '201005' },
    { value: 'alipur', label: 'Alipur', pincode: '201001' },
    { value: 'ankur-vihar', label: 'Ankur Vihar', pincode: '201001' },
    { value: 'ankur-vihar-extension', label: 'Ankur Vihar Extension', pincode: '201003' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '201001' },
    { value: 'ashok-vihar', label: 'Ashok Vihar', pincode: '201001' },
    { value: 'awas-vikas', label: 'Awas Vikas', pincode: '201001' },
    { value: 'baba-farid-nagar', label: 'Baba Farid Nagar', pincode: '201001' },
    { value: 'bada-bazaar', label: 'Bada Bazaar', pincode: '201001' },
    { value: 'basant-kunj', label: 'Basant Kunj', pincode: '201010' },
    { value: 'bhagat-singh-nagar', label: 'Bhagat Singh Nagar', pincode: '201001' },
    { value: 'bhagwati-vihar', label: 'Bhagwati Vihar', pincode: '201003' },
    { value: 'bhola-nath-nagar', label: 'Bhola Nath Nagar', pincode: '201001' },
    { value: 'bhopura', label: 'Bhopura', pincode: '201205' },
    { value: 'block-c-indirapuram', label: 'Block C Indirapuram', pincode: '201014' },
    { value: 'brahma-enclave', label: 'Brahma Enclave', pincode: '201001' },
    { value: 'brahma-khand', label: 'Brahma Khand', pincode: '201014' },
    { value: 'brahmapuri', label: 'Brahmapuri', pincode: '201001' },
    { value: 'brij-vihar', label: 'Brij Vihar', pincode: '201001' },
    { value: 'chandan-vihar', label: 'Chandan Vihar', pincode: '201005' },
    { value: 'chandra-nagar', label: 'Chandra Nagar', pincode: '201011' },
    { value: 'chattarpur-enclave', label: 'Chattarpur Enclave', pincode: '201002' },
    { value: 'chiranjeev-vihar', label: 'Chiranjeev Vihar', pincode: '201011' },
    { value: 'crossings-republik', label: 'Crossings Republik', pincode: '201016' },
    { value: 'delhi-meerut-road', label: 'Delhi Meerut Road', pincode: '201001' },
    { value: 'dheeraj-nagar', label: 'Dheeraj Nagar', pincode: '201010' },
    { value: 'dhurwa', label: 'Dhurwa', pincode: '201010' },
    { value: 'dundahera', label: 'Dundahera', pincode: '201001' },
    { value: 'durga-enclave', label: 'Durga Enclave', pincode: '201010' },
    { value: 'durga-vihar', label: 'Durga Vihar', pincode: '201005' },
    { value: 'east-end-enclave', label: 'East End Enclave', pincode: '201002' },
    { value: 'elderly-colony', label: 'Elderly Colony', pincode: '201005' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '201011' },
    { value: 'ganga-nagar', label: 'Ganga Nagar', pincode: '201005' },
    { value: 'ganga-sadan', label: 'Ganga Sadan', pincode: '201003' },
    { value: 'ganga-vihar', label: 'Ganga Vihar', pincode: '201003' },
    { value: 'ghaziabad-industrial-area', label: 'Ghaziabad Industrial Area', pincode: '201001' },
    { value: 'gokulpur', label: 'Gokulpur', pincode: '201005' },
    { value: 'govindpuram', label: 'Govindpuram', pincode: '201013' },
    { value: 'gt-road', label: 'GT Road', pincode: '201001' },
    { value: 'gulab-vihar', label: 'Gulab Vihar', pincode: '201002' },
    { value: 'guldhar', label: 'Guldhar', pincode: '201005' },
    { value: 'gurukul-vihar', label: 'Gurukul Vihar', pincode: '201005' },
    { value: 'gurudwara-road', label: 'Gurudwara Road', pincode: '201001' },
    { value: 'gyan-khand', label: 'Gyan Khand', pincode: '201014' },
    { value: 'gyan-khand-II', label: 'Gyan Khand II', pincode: '201014' },
    { value: 'hapur-road', label: 'Hapur Road', pincode: '201001' },
    { value: 'harsh-vihar', label: 'Harsh Vihar', pincode: '201010' },
    { value: 'harsh-vihar-extension', label: 'Harsh Vihar Extension', pincode: '201010' },
    { value: 'himalaya-enclave', label: 'Himalaya Enclave', pincode: '201010' },
    { value: 'hindon-vihar', label: 'Hindon Vihar', pincode: '201014' },
    { value: 'indira-enclave', label: 'Indira Enclave', pincode: '201005' },
    { value: 'indira-nagar', label: 'Indira Nagar', pincode: '201005' },
    { value: 'indira-vihar', label: 'Indira Vihar', pincode: '201010' },
    { value: 'indirapuram', label: 'Indirapuram', pincode: '201014' },
    { value: 'jagdamba-colony', label: 'Jagdamba Colony', pincode: '201001' },
    { value: 'jagdish-enclave', label: 'Jagdish Enclave', pincode: '201005' },
    { value: 'jalvayu-vihar', label: 'Jalvayu Vihar', pincode: '201005' },
    { value: 'jasola-vihar', label: 'Jasola Vihar', pincode: '201003' },
    { value: 'jeevan-nagar', label: 'Jeevan Nagar', pincode: '201003' },
    { value: 'kailash-khand', label: 'Kailash Khand', pincode: '201010' },
    { value: 'kailash-kunj', label: 'Kailash Kunj', pincode: '201001' },
    { value: 'kailash-nagar', label: 'Kailash Nagar', pincode: '201001' },
    { value: 'kailash-park', label: 'Kailash Park', pincode: '201005' },
    { value: 'kavi-nagar', label: 'Kavi Nagar', pincode: '201002' },
    { value: 'kaushambi', label: 'Kaushambi', pincode: '201010' },
    { value: 'krishna-colony', label: 'Krishna Colony', pincode: '201005' },
    { value: 'krishna-vihar', label: 'Krishna Vihar', pincode: '201005' },
    { value: 'lal-kuan', label: 'Lal Kuan', pincode: '201005' },
    { value: 'lal-kuan-industrial-area', label: 'Lal Kuan Industrial Area', pincode: '201005' },
    { value: 'link-road', label: 'Link Road', pincode: '201005' },
    { value: 'loni', label: 'Loni', pincode: '201102' },
    { value: 'madhur-vihar', label: 'Madhur Vihar', pincode: '201005' },
    { value: 'madan-mohan-vihar', label: 'Madan Mohan Vihar', pincode: '201001' },
    { value: 'mohan-nagar', label: 'Mohan Nagar', pincode: '201007' },
    { value: 'mohan-nagar-extension', label: 'Mohan Nagar Extension', pincode: '201007' },
    { value: 'mohan-nagar-industrial-area', label: 'Mohan Nagar Industrial Area', pincode: '201007' },
    { value: 'mohan-vihar', label: 'Mohan Vihar', pincode: '201007' },
    { value: 'modinagar', label: 'Modinagar', pincode: '201204' },
    { value: 'muradnagar', label: 'Muradnagar', pincode: '201206' },
    { value: 'murlidhar-vihar', label: 'Murlidhar Vihar', pincode: '201010' },
    { value: 'nandgram', label: 'Nandgram', pincode: '201003' },
    { value: 'nayab-vihar', label: 'Nayab Vihar', pincode: '201001' },
    { value: 'navodaya-colony', label: 'Navodaya Colony', pincode: '201001' },
    { value: 'neelkanth-enclave', label: 'Neelkanth Enclave', pincode: '201001' },
    { value: 'new-raj-nagar', label: 'New Raj Nagar', pincode: '201002' },
    { value: 'nidhi-vihar', label: 'Nidhi Vihar', pincode: '201003' },
    { value: 'nirman-vihar', label: 'Nirman Vihar', pincode: '201010' },
    { value: 'om-nagar-extension', label: 'Om Nagar Extension', pincode: '201005' },
    { value: 'om-vihar', label: 'Om Vihar', pincode: '201005' },
    { value: 'pallavpuram', label: 'Pallavpuram', pincode: '201001' },
    { value: 'pankaj-nagar', label: 'Pankaj Nagar', pincode: '201003' },
    { value: 'pashupati-nagar', label: 'Pashupati Nagar', pincode: '201003' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '201001' },
    { value: 'pratap-vihar', label: 'Pratap Vihar', pincode: '201009' },
    { value: 'pratap-vihar-extension', label: 'Pratap Vihar Extension', pincode: '201009' },
    { value: 'prem-enclave', label: 'Prem Enclave', pincode: '201005' },
    { value: 'prem-nagar', label: 'Prem Nagar', pincode: '201002' },
    { value: 'prajapati-vihar', label: 'Prajapati Vihar', pincode: '201010' },
    { value: 'raj-nagar', label: 'Raj Nagar', pincode: '201002' },
    { value: 'raj-nagar-central', label: 'Raj Nagar Central', pincode: '201002' },
    { value: 'rajendra-nagar', label: 'Rajendra Nagar', pincode: '201001' },
    { value: 'rajendra-nagar-extension', label: 'Rajendra Nagar Extension', pincode: '201002' },
    { value: 'rajesh-vihar', label: 'Rajesh Vihar', pincode: '201014' },
    { value: 'rajnagar-extension', label: 'Rajnagar Extension', pincode: '201017' },
    { value: 'rajni-khand', label: 'Rajni Khand', pincode: '201005' },
    { value: 'rakesh-vihar', label: 'Rakesh Vihar', pincode: '201005' },
    { value: 'raghukul-vihar', label: 'Raghukul Vihar', pincode: '201005' },
    { value: 'raghunath-vihar', label: 'Raghunath Vihar', pincode: '201014' },
    { value: 'ram-vihar', label: 'Ram Vihar', pincode: '201005' },
    { value: 'ravindra-nagar', label: 'Ravindra Nagar', pincode: '201010' },
    { value: 'ravindra-puri', label: 'Ravindra Puri', pincode: '201001' },
    { value: 'rathi-vihar', label: 'Rathi Vihar', pincode: '201005' },
    { value: 'rudrapur', label: 'Rudrapur', pincode: '201102' },
    { value: 'sahibabad', label: 'Sahibabad', pincode: '201005' },
    { value: 'saket-nagar', label: 'Saket Nagar', pincode: '201001' },
    { value: 'sainik-enclave', label: 'Sainik Enclave', pincode: '201005' },
    { value: 'sanjay-enclave', label: 'Sanjay Enclave', pincode: '201001' },
    { value: 'sanjay-nagar-extension', label: 'Sanjay Nagar Extension', pincode: '201002' },
    { value: 'sardar-vallabhbhai-patel-marg', label: 'Sardar Vallabhbhai Patel Marg', pincode: '201001' },
    { value: 'saraswati-enclave', label: 'Saraswati Enclave', pincode: '201001' },
    { value: 'saraswati-vihar', label: 'Saraswati Vihar', pincode: '201005' },
    { value: 'saraswati-vihar-extension', label: 'Saraswati Vihar Extension', pincode: '201005' },
    { value: 'satyam-vihar', label: 'Satyam Vihar', pincode: '201010' },
    { value: 'satyam-vihar-extension', label: 'Satyam Vihar Extension', pincode: '201010' },
    { value: 'sector-10-vaishali', label: 'Sector 10 Vaishali', pincode: '201010' },
    { value: 'sector-62-indirapuram', label: 'Sector 62 Indirapuram', pincode: '201014' },
    { value: 'shalimar-garden', label: 'Shalimar Garden', pincode: '201005' },
    { value: 'shalimar-garden-extension', label: 'Shalimar Garden Extension', pincode: '201005' },
    { value: 'shakti-khand', label: 'Shakti Khand', pincode: '201014' },
    { value: 'shakti-khand-III', label: 'Shakti Khand III', pincode: '201014' },
    { value: 'shahdara', label: 'Shahdara', pincode: '201001' },
    { value: 'shahdara-road', label: 'Shahdara Road', pincode: '201001' },
    { value: 'shahibabad-industrial-area', label: 'Shahibabad Industrial Area', pincode: '201005' },
    { value: 'shanti-nagar', label: 'Shanti Nagar', pincode: '201001' },
    { value: 'shiv-mandir-road', label: 'Shiv Mandir Road', pincode: '201001' },
    { value: 'shiv-nagar-extension', label: 'Shiv Nagar Extension', pincode: '201001' },
    { value: 'shiv-puri', label: 'Shiv Puri', pincode: '201001' },
    { value: 'shiv-raj-vihar', label: 'Shiv Raj Vihar', pincode: '201005' },
    { value: 'shiv-shakti-nagar', label: 'Shiv Shakti Nagar', pincode: '201005' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '201001' },
    { value: 'shivaji-nagar-extension', label: 'Shivaji Nagar Extension', pincode: '201001' },
    { value: 'shivaji-park', label: 'Shivaji Park', pincode: '201001' },
    { value: 'shiv-vihar', label: 'Shiv Vihar', pincode: '201011' },
    { value: 'shree-ji-nagar', label: 'Shree Ji Nagar', pincode: '201005' },
    { value: 'shree-ram-vihar', label: 'Shree Ram Vihar', pincode: '201002' },
    { value: 'shipra-sun-city', label: 'Shipra Sun City', pincode: '201014' },
    { value: 'shivaji-park', label: 'Shivaji Park', pincode: '201001' },
    { value: 'shyam-park', label: 'Shyam Park', pincode: '201011' },
    { value: 'siddharth vihar', label: 'Siddharth Vihar', pincode: '201101' },
    { value: 'siddhartha-vihar-extension', label: 'Siddhartha Vihar Extension', pincode: '201101' },
    { value: 'suman-vihar', label: 'Suman Vihar', pincode: '201002' },
    { value: 'sundar-enclave', label: 'Sundar Enclave', pincode: '201010' },
    { value: 'sundar-nagar', label: 'Sundar Nagar', pincode: '201002' },
    { value: 'sunder-vihar', label: 'Sunder Vihar', pincode: '201005' },
    { value: 'surajmal-vihar', label: 'Surajmal Vihar', pincode: '201001' },
    { value: 'surya-nagar', label: 'Surya Nagar', pincode: '201011' },
    { value: 'surya-vihar', label: 'Surya Vihar', pincode: '201011' },
    { value: 'sushant-vihar', label: 'Sushant Vihar', pincode: '201005' },
    { value: 'sushila-vihar', label: 'Sushila Vihar', pincode: '201005' },
    { value: 'swarn-jayanti-vihar', label: 'Swarn Jayanti Vihar', pincode: '201002' },
    { value: 'swaraj-vihar', label: 'Swaraj Vihar', pincode: '201005' },
    { value: 'taj-enclave', label: 'Taj Enclave', pincode: '201014' },
    { value: 'tiwari-enclave', label: 'Tiwari Enclave', pincode: '201005' },
    { value: 'tronica-city', label: 'Tronica City', pincode: '201102' },
    { value: 'tronica-city-industrial-area', label: 'Tronica City Industrial Area', pincode: '201102' },
    { value: 'udyan-vihar', label: 'Udyan Vihar', pincode: '201005' },
    { value: 'udhav-vihar', label: 'Udhav Vihar', pincode: '201005' },
    { value: 'vaishali', label: 'Vaishali', pincode: '201010' },
    { value: 'vasundhara', label: 'Vasundhara', pincode: '201012' },
    { value: 'vashisht-vihar', label: 'Vashisht Vihar', pincode: '201010' },
    { value: 'vatsalya-vihar', label: 'Vatsalya Vihar', pincode: '201005' },
    { value: 'vikas-khand', label: 'Vikas Khand', pincode: '201014' },
    { value: 'vikas-vihar', label: 'Vikas Vihar', pincode: '201010' },
    { value: 'vikramshila', label: 'Vikramshila', pincode: '201001' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '201001' },
    { value: 'vishal-enclave', label: 'Vishal Enclave', pincode: '201005' },
    { value: 'vishal-khand', label: 'Vishal Khand', pincode: '201005' },
    { value: 'vishnu-garden', label: 'Vishnu Garden', pincode: '201005' },
    { value: 'vishwakarma-colony', label: 'Vishwakarma Colony', pincode: '201005' },
    { value: 'vivek-vihar', label: 'Vivek Vihar', pincode: '201005' },
    { value: 'yashoda-vihar', label: 'Yashoda Vihar', pincode: '201010' }
  ],

  'noida': [
    { value: 'greater-noida', label: 'Greater Noida', pincode: '201310' },
    { value: 'sector-1', label: 'Sector 1', pincode: '201301' },
    { value: 'sector-10', label: 'Sector 10', pincode: '201301' },
    { value: 'sector-105', label: 'Sector 105', pincode: '201304' },
    { value: 'sector-110', label: 'Sector 110', pincode: '201303' },
    { value: 'sector-111', label: 'Sector 111', pincode: '201303' },
    { value: 'sector-12', label: 'Sector 12', pincode: '201301' },
    { value: 'sector-120', label: 'Sector 120', pincode: '201301' },
    { value: 'sector-122', label: 'Sector 122', pincode: '201301' },
    { value: 'sector-123', label: 'Sector 123', pincode: '201303' },
    { value: 'sector-126', label: 'Sector 126', pincode: '201303' },
    { value: 'sector-128', label: 'Sector 128', pincode: '201301' },
    { value: 'sector-130', label: 'Sector 130', pincode: '201301' },
    { value: 'sector-132', label: 'Sector 132', pincode: '201301' },
    { value: 'sector-135', label: 'Sector 135', pincode: '201301' },
    { value: 'sector-137', label: 'Sector 137', pincode: '201305' },
    { value: 'sector-144', label: 'Sector 144', pincode: '201307' },
    { value: 'sector-145', label: 'Sector 145', pincode: '201307' },
    { value: 'sector-146', label: 'Sector 146', pincode: '201307' },
    { value: 'sector-147', label: 'Sector 147', pincode: '201307' },
    { value: 'sector-15', label: 'Sector 15', pincode: '201301' },
    { value: 'sector-150', label: 'Sector 150', pincode: '201310' },
    { value: 'sector-151', label: 'Sector 151', pincode: '201309' },
    { value: 'sector-152', label: 'Sector 152', pincode: '201309' },
    { value: 'sector-153', label: 'Sector 153', pincode: '201309' },
    { value: 'sector-154', label: 'Sector 154', pincode: '201309' },
    { value: 'sector-155', label: 'Sector 155', pincode: '201309' },
    { value: 'sector-156', label: 'Sector 156', pincode: '201309' },
    { value: 'sector-157', label: 'Sector 157', pincode: '201309' },
    { value: 'sector-158', label: 'Sector 158', pincode: '201309' },
    { value: 'sector-159', label: 'Sector 159', pincode: '201309' },
    { value: 'sector-16', label: 'Sector 16', pincode: '201301' },
    { value: 'sector-160', label: 'Sector 160', pincode: '201309' },
    { value: 'sector-161', label: 'Sector 161', pincode: '201309' },
    { value: 'sector-162', label: 'Sector 162', pincode: '201309' },
    { value: 'sector-163', label: 'Sector 163', pincode: '201309' },
    { value: 'sector-164', label: 'Sector 164', pincode: '201309' },
    { value: 'sector-165', label: 'Sector 165', pincode: '201309' },
    { value: 'sector-166', label: 'Sector 166', pincode: '201309' },
    { value: 'sector-167', label: 'Sector 167', pincode: '201309' },
    { value: 'sector-168', label: 'Sector 168', pincode: '201309' },
    { value: 'sector-169', label: 'Sector 169', pincode: '201309' },
    { value: 'sector-170', label: 'Sector 170', pincode: '201309' },
    { value: 'sector-171', label: 'Sector 171', pincode: '201309' },
    { value: 'sector-172', label: 'Sector 172', pincode: '201309' },
    { value: 'sector-173', label: 'Sector 173', pincode: '201309' },
    { value: 'sector-174', label: 'Sector 174', pincode: '201309' },
    { value: 'sector-175', label: 'Sector 175', pincode: '201309' },
    { value: 'sector-176', label: 'Sector 176', pincode: '201309' },
    { value: 'sector-177', label: 'Sector 177', pincode: '201309' },
    { value: 'sector-178', label: 'Sector 178', pincode: '201309' },
    { value: 'sector-179', label: 'Sector 179', pincode: '201309' },
    { value: 'sector-18', label: 'Sector 18', pincode: '201301' },
    { value: 'sector-180', label: 'Sector 180', pincode: '201309' },
    { value: 'sector-181', label: 'Sector 181', pincode: '201309' },
    { value: 'sector-182', label: 'Sector 182', pincode: '201309' },
    { value: 'sector-183', label: 'Sector 183', pincode: '201309' },
    { value: 'sector-184', label: 'Sector 184', pincode: '201309' },
    { value: 'sector-185', label: 'Sector 185', pincode: '201309' },
    { value: 'sector-186', label: 'Sector 186', pincode: '201309' },
    { value: 'sector-187', label: 'Sector 187', pincode: '201309' },
    { value: 'sector-188', label: 'Sector 188', pincode: '201309' },
    { value: 'sector-189', label: 'Sector 189', pincode: '201309' },
    { value: 'sector-19', label: 'Sector 19', pincode: '201301' },
    { value: 'sector-190', label: 'Sector 190', pincode: '201309' },
    { value: 'sector-191', label: 'Sector 191', pincode: '201309' },
    { value: 'sector-192', label: 'Sector 192', pincode: '201309' },
    { value: 'sector-193', label: 'Sector 193', pincode: '201309' },
    { value: 'sector-194', label: 'Sector 194', pincode: '201309' },
    { value: 'sector-195', label: 'Sector 195', pincode: '201309' },
    { value: 'sector-196', label: 'Sector 196', pincode: '201309' },
    { value: 'sector-197', label: 'Sector 197', pincode: '201309' },
    { value: 'sector-198', label: 'Sector 198', pincode: '201309' },
    { value: 'sector-199', label: 'Sector 199', pincode: '201309' },
    { value: 'sector-2', label: 'Sector 2', pincode: '201301' },
    { value: 'sector-20', label: 'Sector 20', pincode: '201301' },
    { value: 'sector-21', label: 'Sector 21', pincode: '201301' },
    { value: 'sector-22', label: 'Sector 22', pincode: '201301' },
    { value: 'sector-25', label: 'Sector 25', pincode: '201301' },
    { value: 'sector-27', label: 'Sector 27', pincode: '201301' },
    { value: 'sector-234', label: 'Sector 234', pincode: '201309' },
    { value: 'sector-235', label: 'Sector 235', pincode: '201309' },
    { value: 'sector-236', label: 'Sector 236', pincode: '201309' },
    { value: 'sector-237', label: 'Sector 237', pincode: '201309' },
    { value: 'sector-238', label: 'Sector 238', pincode: '201309' },
    { value: 'sector-239', label: 'Sector 239', pincode: '201309' },
    { value: 'sector-240', label: 'Sector 240', pincode: '201309' },
    { value: 'sector-241', label: 'Sector 241', pincode: '201309' },
    { value: 'sector-242', label: 'Sector 242', pincode: '201309' },
    { value: 'sector-243', label: 'Sector 243', pincode: '201309' },
    { value: 'sector-244', label: 'Sector 244', pincode: '201309' },
    { value: 'sector-245', label: 'Sector 245', pincode: '201309' },
    { value: 'sector-246', label: 'Sector 246', pincode: '201309' },
    { value: 'sector-247', label: 'Sector 247', pincode: '201309' },
    { value: 'sector-248', label: 'Sector 248', pincode: '201309' },
    { value: 'sector-249', label: 'Sector 249', pincode: '201309' },
    { value: 'sector-250', label: 'Sector 250', pincode: '201309' },
    { value: 'sector-251', label: 'Sector 251', pincode: '201309' },
    { value: 'sector-252', label: 'Sector 252', pincode: '201309' },
    { value: 'sector-253', label: 'Sector 253', pincode: '201309' },
    { value: 'sector-254', label: 'Sector 254', pincode: '201309' },
    { value: 'sector-255', label: 'Sector 255', pincode: '201309' },
    { value: 'sector-256', label: 'Sector 256', pincode: '201309' },
    { value: 'sector-257', label: 'Sector 257', pincode: '201309' },
    { value: 'sector-258', label: 'Sector 258', pincode: '201309' },
    { value: 'sector-260', label: 'Sector 260', pincode: '201309' },
    { value: 'sector-261', label: 'Sector 261', pincode: '201309' },
    { value: 'sector-262', label: 'Sector 262', pincode: '201309' },
    { value: 'sector-263', label: 'Sector 263', pincode: '201309' },
    { value: 'sector-264', label: 'Sector 264', pincode: '201309' },
    { value: 'sector-265', label: 'Sector 265', pincode: '201309' },
    { value: 'sector-266', label: 'Sector 266', pincode: '201309' },
    { value: 'sector-267', label: 'Sector 267', pincode: '201309' },
    { value: 'sector-268', label: 'Sector 268', pincode: '201309' },
    { value: 'sector-3', label: 'Sector 3', pincode: '201301' },
    { value: 'sector-4', label: 'Sector 4', pincode: '201301' },
    { value: 'sector-50', label: 'Sector 50', pincode: '201301' },
    { value: 'sector-51', label: 'Sector 51', pincode: '201301' },
    { value: 'sector-62', label: 'Sector 62', pincode: '201309' },
    { value: 'sector-63', label: 'Sector 63', pincode: '201307' },
    { value: 'sector-64', label: 'Sector 64', pincode: '201307' },
    { value: 'sector-76', label: 'Sector 76', pincode: '201306' },
    { value: 'sector-77', label: 'Sector 77', pincode: '201301' },
    { value: 'sector-78', label: 'Sector 78', pincode: '201301' }
  ],
  'varanasi': [
    { value: 'ajwa-road', label: 'Ajwa Road', pincode: '221007' },
    { value: 'alkapuri', label: 'Alkapuri', pincode: '221001' },
    { value: 'asoj', label: 'Asoj', pincode: '221001' },
    { value: 'assi', label: 'Assi', pincode: '221005' },
    { value: 'atladara', label: 'Atladara', pincode: '221003' },
    { value: 'babatpur', label: 'Babatpur', pincode: '221102' },
    { value: 'bajwa', label: 'Bajwa', pincode: '221006' },
    { value: 'bakrawadi', label: 'Bakrawadi', pincode: '221008' },
    { value: 'bapunagar', label: 'Bapunagar', pincode: '221001' },
    { value: 'bahuara', label: 'Bahuara', pincode: '221102' },
    { value: 'basharatganj', label: 'Basharatganj', pincode: '221002' },
    { value: 'bhayli', label: 'Bhayli', pincode: '221010' },
    { value: 'bhayli-road', label: 'Bhayli Road', pincode: '221015' },
    { value: 'bhelupur', label: 'Bhelupur', pincode: '221001' },
    { value: 'bil-chapad-road', label: 'Bil-Chapad Road', pincode: '221015' },
    { value: 'bill-road', label: 'Bill Road', pincode: '221010' },
    { value: 'chandni-mahal', label: 'Chandni Mahal', pincode: '221005' },
    { value: 'chandrapura', label: 'Chandrapura', pincode: '221007' },
    { value: 'chhani', label: 'Chhani', pincode: '221001' },
    { value: 'chhani-jakat-naka', label: 'Chhani Jakat Naka', pincode: '221005' },
    { value: 'chhapra', label: 'Chhapra', pincode: '221002' },
    { value: 'chhota-ganpati', label: 'Chhota Ganpati', pincode: '221001' },
    { value: 'chipad', label: 'Chipad', pincode: '221011' },
    { value: 'chokshi-bazar', label: 'Chokshi Bazar', pincode: '221002' },
    { value: 'dabhoi', label: 'Dabhoi', pincode: '221010' },
    { value: 'dabhoi-road', label: 'Dabhoi Road', pincode: '221006' },
    { value: 'dandia-bazar', label: 'Dandia Bazar', pincode: '221010' },
    { value: 'danteshwar', label: 'Danteshwar', pincode: '221008' },
    { value: 'darshali', label: 'Darshali', pincode: '221003' },
    { value: 'dashrath', label: 'Dashrath', pincode: '221007' },
    { value: 'diwalipura', label: 'Diwalipura', pincode: '221011' },
    { value: 'dumad', label: 'Dumad', pincode: '221015' },
    { value: 'durgakund', label: 'Durgakund', pincode: '221005' },
    { value: 'ellora-park', label: 'Ellora Park', pincode: '221001' },
    { value: 'fatehgunj', label: 'Fatehgunj', pincode: '221004' },
    { value: 'gadaipur', label: 'Gadaipur', pincode: '221001' },
    { value: 'gahmar', label: 'Gahmar', pincode: '221003' },
    { value: 'ganga-mahani', label: 'Ganga Mahani', pincode: '221005' },
    { value: 'gorakhpur', label: 'Gorakhpur', pincode: '221008' },
    { value: 'gorwa', label: 'Gorwa', pincode: '221002' },
    { value: 'gotri', label: 'Gotri', pincode: '221005' },
    { value: 'gotri-road', label: 'Gotri Road', pincode: '221008' },
    { value: 'halol', label: 'Halol', pincode: '221010' },
    { value: 'harinagar', label: 'Harinagar', pincode: '221010' },
    { value: 'haripura', label: 'Haripura', pincode: '221006' },
    { value: 'harni', label: 'Harni', pincode: '221008' },
    { value: 'harni-road', label: 'Harni Road', pincode: '221006' },
    { value: 'hathi-ghat', label: 'Hathi Ghat', pincode: '221007' },
    { value: 'jagatganj', label: 'Jagatganj', pincode: '221001' },
    { value: 'jalalpur', label: 'Jalalpur', pincode: '221006' },
    { value: 'jambubet', label: 'Jambubet', pincode: '221012' },
    { value: 'jambuva', label: 'Jambuva', pincode: '221001' },
    { value: 'jarod', label: 'Jarod', pincode: '221011' },
    { value: 'jaspur', label: 'Jaspur', pincode: '221004' },
    { value: 'jetalpur-road', label: 'Jetalpur Road', pincode: '221009' },
    { value: 'jitpur', label: 'Jitpur', pincode: '221101' },
    { value: 'kachchi-sarai', label: 'Kachchi Sarai', pincode: '221002' },
    { value: 'kailashpuri', label: 'Kailashpuri', pincode: '221005' },
    { value: 'kalali', label: 'Kalali', pincode: '221005' },
    { value: 'kalali-road', label: 'Kalali Road', pincode: '221010' },
    { value: 'kapurai-village', label: 'Kapurai Village', pincode: '221008' },
    { value: 'karadiya', label: 'Karadiya', pincode: '221004' },
    { value: 'karelibaug', label: 'Karelibaug', pincode: '221002' },
    { value: 'karjan', label: 'Karjan', pincode: '221007' },
    { value: 'kasi-kshetra', label: 'Kasi Kshetra', pincode: '221007' },
    { value: 'kedar-ghat', label: 'Kedar Ghat', pincode: '221005' },
    { value: 'kendranagar', label: 'Kendranagar', pincode: '221005' },
    { value: 'kevdabaug', label: 'Kevdabaug', pincode: '221008' },
    { value: 'khanpur', label: 'Khanpur', pincode: '221006' },
    { value: 'khidkiya-ghat', label: 'Khidkiya Ghat', pincode: '221002' },
    { value: 'kishanwadi', label: 'Kishanwadi', pincode: '221003' },
    { value: 'koyali', label: 'Koyali', pincode: '221001' },
    { value: 'lahurabir', label: 'Lahurabir', pincode: '221004' },
    { value: 'lalbaug', label: 'Lalbaug', pincode: '221009' },
    { value: 'lalpur', label: 'Lalpur', pincode: '221010' },
    { value: 'laxmipura', label: 'Laxmipura', pincode: '221006' },
    { value: 'madhuvan', label: 'Madhuvan', pincode: '221001' },
    { value: 'madhavpura', label: 'Madhavpura', pincode: '221003' },
    { value: 'mahapura', label: 'Mahapura', pincode: '221001' },
    { value: 'makarpura', label: 'Makarpura', pincode: '221004' },
    { value: 'mandvi', label: 'Mandvi', pincode: '221010' },
    { value: 'maneja', label: 'Maneja', pincode: '221007' },
    { value: 'manjalpur', label: 'Manjalpur', pincode: '221009' },
    { value: 'manjusar', label: 'Manjusar', pincode: '221011' },
    { value: 'moghul-wada', label: 'Moghul Wada', pincode: '221002' },
    { value: 'muj-mahuda', label: 'Muj Mahuda', pincode: '221015' },
    { value: 'mujar-gamdi', label: 'Mujar Gamdi', pincode: '221003' },
    { value: 'nagarwada', label: 'Nagarwada', pincode: '221008' },
    { value: 'nandesari', label: 'Nandesari', pincode: '221009' },
    { value: 'nani-bapod', label: 'Nani Bapod', pincode: '221015' },
    { value: 'navapura', label: 'Navapura', pincode: '221004' },
    { value: 'new-alkapuri', label: 'New Alkapuri', pincode: '221005' },
    { value: 'new-karelibaug', label: 'New Karelibaug', pincode: '221001' },
    { value: 'new-sama', label: 'New Sama', pincode: '221008' },
    { value: 'new-sama-bhadran-nagar', label: 'New Sama Bhadran Nagar', pincode: '221003' },
    { value: 'new-sama-road', label: 'New Sama Road', pincode: '221006' },
    { value: 'new-vip-road', label: 'New VIP Road', pincode: '221010' },
    { value: 'nizampura', label: 'Nizampura', pincode: '221001' },
    { value: 'old-padra-road', label: 'Old Padra Road', pincode: '221005' },
    { value: 'padra', label: 'Padra', pincode: '221006' },
    { value: 'padra-road', label: 'Padra Road', pincode: '221004' },
    { value: 'panchvati', label: 'Panchvati', pincode: '221008' },
    { value: 'parda-road', label: 'Parda Road', pincode: '221010' },
    { value: 'pratapgunj', label: 'Pratapgunj', pincode: '221009' },
    { value: 'pratham-upvan', label: 'Pratham Upvan', pincode: '221012' },
    { value: 'productivity-road', label: 'Productivity Road', pincode: '221005' },
    { value: 'puniyad', label: 'Puniyad', pincode: '221011' },
    { value: 'race-course', label: 'Race Course', pincode: '221007' },
    { value: 'ramwadi', label: 'Ramwadi', pincode: '221002' },
    { value: 'ranoli', label: 'Ranoli', pincode: '221008' },
    { value: 'raopura', label: 'Raopura', pincode: '221006' },
    { value: 'rasulabad', label: 'Rasulabad', pincode: '221005' },
    { value: 'ratanpur', label: 'Ratanpur', pincode: '221003' },
    { value: 'ravaliya-mahudevegon', label: 'Ravaliya Mahudevegon', pincode: '221010' },
    { value: 'saiyed-vasna', label: 'Saiyed Vasna', pincode: '221001' },
    { value: 'sama', label: 'Sama', pincode: '221010' },
    { value: 'sama-savil-road', label: 'Sama-Savil Road', pincode: '221008' },
    { value: 'samta', label: 'Samta', pincode: '221006' },
    { value: 'sangma', label: 'Sangma', pincode: '221011' },
    { value: 'sankarda', label: 'Sankarda', pincode: '221003' },
    { value: 'sankhyad', label: 'Sankhyad', pincode: '221007' },
    { value: 'sayaji-park-society', label: 'Sayaji Park Society', pincode: '221010' },
    { value: 'sayajigunj', label: 'Sayajigunj', pincode: '221005' },
    { value: 'sevasi', label: 'Sevasi', pincode: '221005' },
    { value: 'sherkhi', label: 'Sherkhi', pincode: '221009' },
    { value: 'shiyabaug', label: 'Shiyabaug', pincode: '221006' },
    { value: 'shukla-nagar', label: 'Shukla Nagar', pincode: '221005' },
    { value: 'siddharth-nagar', label: 'Siddharth Nagar', pincode: '221001' },
    { value: 'sokhda', label: 'Sokhda', pincode: '221008' },
    { value: 'soma-talav', label: 'Soma Talav', pincode: '221015' },
    { value: 'somnath-nagar', label: 'Somnath Nagar', pincode: '221003' },
    { value: 'subhanpura', label: 'Subhanpura', pincode: '221010' },
    { value: 'sultanpura', label: 'Sultanpura', pincode: '221008' },
    { value: 'sun-pharma-road', label: 'Sun Pharma Road', pincode: '221009' },
    { value: 'suryanagar', label: 'Suryanagar', pincode: '221010' },
    { value: 'talsat', label: 'Talsat', pincode: '221004' },
    { value: 'tandalja', label: 'Tandalja', pincode: '221001' },
    { value: 'tarsali', label: 'Tarsali', pincode: '221008' },
    { value: 'umeta', label: 'Umeta', pincode: '221004' },
    { value: 'undera', label: 'Undera', pincode: '221006' },
    { value: 'varanasi-rnklav-road', label: 'Varanasi-Anklav Road', pincode: '221007' },
    { value: 'varanasi-halol-highway', label: 'Varanasi-Halol Highway', pincode: '221010' },
    { value: 'vadsar', label: 'Vadsar', pincode: '221008' },
    { value: 'vasna', label: 'Vasna', pincode: '221005' },
    { value: 'vasna-road', label: 'Vasna Road', pincode: '221003' },
    { value: 'vasna-bhayli-road', label: 'Vasna-Bhayli Road', pincode: '221006' },
    { value: 'vemali', label: 'Vemali', pincode: '221008' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '221003' },
    { value: 'vip-road', label: 'VIP Road', pincode: '221009' },
    { value: 'vishwamitri', label: 'Vishwamitri', pincode: '221010' }
  ],
  //Jammu & Kashmir
  'achabal': [
    { value: 'achabal', label: 'Achabal', pincode: '192212' },
    { value: 'bagwanpora', label: 'Bagwanpora', pincode: '192231' },
    { value: 'bambad', label: 'Bambad', pincode: '192232' },
    { value: 'dachhan', label: 'Dachhan', pincode: '192233' },
    { value: 'damhal', label: 'Damhal', pincode: '192234' },
    { value: 'kakpora', label: 'Kakpora', pincode: '192201' },
    { value: 'khudwani', label: 'Khudwani', pincode: '192235' },
    { value: 'latiyan', label: 'Latiyan', pincode: '192236' },
    { value: 'panjran', label: 'Panjran', pincode: '192237' },
    { value: 'waghama', label: 'Waghama', pincode: '192238' },
    { value: 'checkpura', label: 'Checkpura', pincode: '192215' },
    { value: 'gundbal', label: 'Gundbal', pincode: '192213' },
    { value: 'kulgam', label: 'Kulgam', pincode: '192231' },
    { value: 'qumri', label: 'Qumri', pincode: '192240' },
    { value: 'smailpora', label: 'Smailpora', pincode: '192239' },
    { value: 'avlian', label: 'Avlian', pincode: '192238' },
    { value: 'barbugh', label: 'Barbugh', pincode: '192232' },
    { value: 'frashkhel', label: 'Frashkhel', pincode: '192234' },
    { value: 'lajura', label: 'Lajura', pincode: '192231' },
    { value: 'mattpora', label: 'Mattpora', pincode: '192230' },
    { value: 'rangreth', label: 'Rangreth', pincode: '192223' },
    { value: 'village-rahmoo', label: 'Village Rahmoo', pincode: '192233' },
    { value: 'yousufpora', label: 'Yousufpora', pincode: '192228' }
    ],
  
    'akhnoor': [
    { value: 'akhnoor', label: 'Akhnoor', pincode: '181201' },
    { value: 'bandral', label: 'Bandral', pincode: '181205' },
    { value: 'barrian', label: 'Barrian', pincode: '181206' },
    { value: 'basti', label: 'Basti', pincode: '181202' },
    { value: 'chandwan', label: 'Chandwan', pincode: '181207' },
    { value: 'chhani', label: 'Chhani', pincode: '181208' },
    { value: 'dharmari', label: 'Dharmari', pincode: '181203' },
    { value: 'gari', label: 'Gari', pincode: '181204' },
    { value: 'jandyal', label: 'Jandyal', pincode: '181209' },
    { value: 'kalai', label: 'Kalai', pincode: '181210' },
    { value: 'kansir', label: 'Kansir', pincode: '181211' },
    { value: 'kotli', label: 'Kotli', pincode: '181212' },
    { value: 'koulpur', label: 'Koulpur', pincode: '181213' },
    { value: 'palian', label: 'Palian', pincode: '181214' },
    { value: 'sagoon', label: 'Sagoon', pincode: '181215' },
    { value: 'sanjay', label: 'Sanjay', pincode: '181216' },
    { value: 'sukhwal', label: 'Sukhwal', pincode: '181217' },
    { value: 'tandar', label: 'Tandar', pincode: '181218' },
    { value: 'banola', label: 'Banola', pincode: '181219' },
    { value: 'chuker', label: 'Chuker', pincode: '181220' },
    { value: 'dabber', label: 'Dabber', pincode: '181221' },
    { value: 'douran', label: 'Douran', pincode: '181222' },
    { value: 'gagwal', label: 'Gagwal', pincode: '181223' },
    { value: 'jaghir', label: 'Jaghir', pincode: '181224' },
    { value: 'matrial', label: 'Matrial', pincode: '181225' },
    { value: 'rangpur', label: 'Rangpur', pincode: '181226' },
    { value: 'sahbari', label: 'Sahbari', pincode: '181227' },
    { value: 'samwan', label: 'Samwan', pincode: '181228' },
    { value: 'suwana', label: 'Suwana', pincode: '181229' }
    ],
  
    'arnia': [
    { value: 'arnia', label: 'Arnia', pincode: '181133' },
    { value: 'bhagwati', label: 'Bhagwati', pincode: '181134' },
    { value: 'bari', label: 'Bari', pincode: '181135' },
    { value: 'chhan', label: 'Chhan', pincode: '181136' },
    { value: 'chohla', label: 'Chohla', pincode: '181137' },
    { value: 'darsopur', label: 'Darsopur', pincode: '181138' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '181139' },
    { value: 'gagwal', label: 'Gagwal', pincode: '181140' },
    { value: 'jassu', label: 'Jassu', pincode: '181141' },
    { value: 'kalian', label: 'Kalian', pincode: '181142' },
    { value: 'kore', label: 'Kore', pincode: '181143' },
    { value: 'lalej', label: 'Lalej', pincode: '181144' },
    { value: 'mathwar', label: 'Mathwar', pincode: '181145' },
    { value: 'sakhapur', label: 'Sakhapur', pincode: '181146' },
    { value: 'sidhra', label: 'Sidhra', pincode: '181147' },
    { value: 'singhpur', label: 'Singhpur', pincode: '181148' },
    { value: 'vijaypur', label: 'Vijaypur', pincode: '181149' },
    { value: 'bari-brahmana', label: 'Bari Brahmana', pincode: '181133' },
    { value: 'ban', label: 'Ban', pincode: '181150' },
    { value: 'gajansoo', label: 'Gajansoo', pincode: '181151' },
    { value: 'jandial', label: 'Jandial', pincode: '181152' },
    { value: 'khour', label: 'Khour', pincode: '181153' },
    { value: 'laxmipur', label: 'Laxmipur', pincode: '181154' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '181155' },
    { value: 'raika', label: 'Raika', pincode: '181156' },
    { value: 'ranibagh', label: 'Ranibagh', pincode: '181157' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '181158' }
    ],
  
    'baramulla': [
    { value: 'baramulla', label: 'Baramulla', pincode: '193101' },
    { value: 'arpora', label: 'Arpora', pincode: '193102' },
    { value: 'baghwanpora', label: 'Baghwanpora', pincode: '193103' },
    { value: 'chandoosa', label: 'Chandoosa', pincode: '193104' },
    { value: 'delina', label: 'Delina', pincode: '193105' },
    { value: 'doabgah', label: 'Doabgah', pincode: '193106' },
    { value: 'downtown', label: 'Downtown', pincode: '193107' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '193108' },
    { value: 'ganai', label: 'Ganai', pincode: '193109' },
    { value: 'gund', label: 'Gund', pincode: '193110' },
    { value: 'kandizal', label: 'Kandizal', pincode: '193111' },
    { value: 'kitchen', label: 'Kitchen', pincode: '193112' },
    { value: 'lakroosa', label: 'Lakroosa', pincode: '193113' },
    { value: 'north-baramulla', label: 'North Baramulla', pincode: '193114' },
    { value: 'pattan', label: 'Pattan', pincode: '193115' },
    { value: 'rakh', label: 'Rakh', pincode: '193116' },
    { value: 'soibugh', label: 'Soibugh', pincode: '193117' },
    { value: 'sopore', label: 'Sopore', pincode: '193201' },
    { value: 'wanpora', label: 'Wanpora', pincode: '193118' },
    { value: 'alhama', label: 'Alhama', pincode: '193119' },
    { value: 'arampora', label: 'Arampora', pincode: '193120' },
    { value: 'balhama', label: 'Balhama', pincode: '193121' },
    { value: 'hajan', label: 'Hajan', pincode: '193122' },
    { value: 'khaipora', label: 'Khaipora', pincode: '193123' },
    { value: 'matrigam', label: 'Matrigam', pincode: '193124' },
    { value: 'nagsheeri', label: 'Nagsheeri', pincode: '193125' },
    { value: 'rahpora', label: 'Rahpora', pincode: '193126' },
    { value: 'sahipora', label: 'Sahipora', pincode: '193127' },
    { value: 'sheeri', label: 'Sheeri', pincode: '193128' },
    { value: 'watlab', label: 'Watlab', pincode: '193129' }
    ],
    
    'beerwah': [
    { value: 'beerwah', label: 'Beerwah', pincode: '193201' },
    { value: 'balhama', label: 'Balhama', pincode: '193202' },
    { value: 'bandipora', label: 'Bandipora', pincode: '193203' },
    { value: 'barzulla', label: 'Barzulla', pincode: '193204' },
    { value: 'chandpura', label: 'Chandpura', pincode: '193205' },
    { value: 'chugam', label: 'Chugam', pincode: '193206' },
    { value: 'dalwash', label: 'Dalwash', pincode: '193207' },
    { value: 'kagal', label: 'Kagal', pincode: '193208' },
    { value: 'kakpora', label: 'Kakpora', pincode: '193209' },
    { value: 'manzgam', label: 'Manzgam', pincode: '193210' },
    { value: 'sandoo', label: 'Sandoo', pincode: '193211' },
    { value: 'tangmarg', label: 'Tangmarg', pincode: '193212' },
    { value: 'wathora', label: 'Wathora', pincode: '193213' },
    { value: 'wuchhama', label: 'Wuchhama', pincode: '193214' }
    ],
    
    'bhaderwah': [
    { value: 'bhaderwah', label: 'Bhaderwah', pincode: '182222' },
    { value: 'bhalessa', label: 'Bhalessa', pincode: '182223' },
    { value: 'chatergala', label: 'Chatergala', pincode: '182224' },
    { value: 'chinta', label: 'Chinta', pincode: '182225' },
    { value: 'dandi', label: 'Dandi', pincode: '182226' },
    { value: 'doda', label: 'Doda', pincode: '182227' },
    { value: 'gandoh', label: 'Gandoh', pincode: '182228' },
    { value: 'jammu', label: 'Jammu', pincode: '182229' },
    { value: 'kalhota', label: 'Kalhota', pincode: '182230' },
    { value: 'khellani', label: 'Khellani', pincode: '182231' },
    { value: 'mashka', label: 'Mashka', pincode: '182232' },
    { value: 'nashu', label: 'Nashu', pincode: '182233' },
    { value: 'patnitop', label: 'Patnitop', pincode: '182234' },
    { value: 'thathri', label: 'Thathri', pincode: '182235' },
    { value: 'trishul', label: 'Trishul', pincode: '182236' },
    { value: 'bani', label: 'Bani', pincode: '182237' },
    { value: 'chakkar', label: 'Chakkar', pincode: '182238' },
    { value: 'dehari', label: 'Dehari', pincode: '182239' },
    { value: 'jalori', label: 'Jalori', pincode: '182240' },
    { value: 'jathana', label: 'Jathana', pincode: '182241' },
    { value: 'krimchi', label: 'Krimchi', pincode: '182242' },
    { value: 'nishat', label: 'Nishat', pincode: '182243' },
    { value: 'rohta', label: 'Rohta', pincode: '182244' },
    { value: 'sankri', label: 'Sankri', pincode: '182245' },
    { value: 'sarh', label: 'Sarh', pincode: '182246' },
    { value: 'shahpur', label: 'Shahpur', pincode: '182247' },
    { value: 'skul', label: 'Skul', pincode: '182248' }
    ],
  
    'billawar': [
    { value: 'billawar', label: 'Billawar', pincode: '181201' },
    { value: 'bali', label: 'Bali', pincode: '181202' },
    { value: 'chattergala', label: 'Chattergala', pincode: '181203' },
    { value: 'chhamb', label: 'Chhamb', pincode: '181204' },
    { value: 'diani', label: 'Diani', pincode: '181205' },
    { value: 'dina', label: 'Dina', pincode: '181206' },
    { value: 'ghoman', label: 'Ghoman', pincode: '181207' },
    { value: 'jakhbar', label: 'Jakhbar', pincode: '181208' },
    { value: 'kallah', label: 'Kallah', pincode: '181209' },
    { value: 'kandoli', label: 'Kandoli', pincode: '181210' },
    { value: 'kathua', label: 'Kathua', pincode: '181211' },
    { value: 'krimchi', label: 'Krimchi', pincode: '181212' },
    { value: 'ladhwal', label: 'Ladhwal', pincode: '181213' },
    { value: 'phaggu', label: 'Phaggu', pincode: '181214' },
    { value: 'ramkot', label: 'Ramkot', pincode: '181215' },
    { value: 'sambyal', label: 'Sambyal', pincode: '181216' },
    { value: 'sunej', label: 'Sunej', pincode: '181217' },
    { value: 'adhrash', label: 'Adhrash', pincode: '181218' },
    { value: 'bhojpur', label: 'Bhojpur', pincode: '181219' },
    { value: 'chakpur', label: 'Chakpur', pincode: '181220' },
    { value: 'dardnari', label: 'Dardnari', pincode: '181221' },
    { value: 'dhool', label: 'Dhool', pincode: '181222' },
    { value: 'jhira', label: 'Jhira', pincode: '181223' },
    { value: 'kandri', label: 'Kandri', pincode: '181224' },
    { value: 'maharajpur', label: 'Maharajpur', pincode: '181225' },
    { value: 'mangla', label: 'Mangla', pincode: '181226' },
    { value: 'phalian', label: 'Phalian', pincode: '181227' },
    { value: 'sujwan', label: 'Sujwan', pincode: '181228' }
    ],
  
    'bijbehara': [
    { value: 'adigam', label: 'Adigam', pincode: '192124' },
    { value: 'baderwah', label: 'Baderwah', pincode: '192125' },
    { value: 'balhama', label: 'Balhama', pincode: '192126' },
    { value: 'bijbehara', label: 'Bijbehara', pincode: '192127' },
    { value: 'chatrapora', label: 'Chatrapora', pincode: '192128' },
    { value: 'fatehpora', label: 'Fatehpora', pincode: '192129' },
    { value: 'gulabganj', label: 'Gulabganj', pincode: '192130' },
    { value: 'kanelwan', label: 'Kanelwan', pincode: '192131' },
    { value: 'kanjoor', label: 'Kanjoor', pincode: '192132' },
    { value: 'lehind', label: 'Lehind', pincode: '192133' },
    { value: 'mattan', label: 'Mattan', pincode: '192134' },
    { value: 'nazirpora', label: 'Nazirpora', pincode: '192135' },
    { value: 'panthachowk', label: 'Panthachowk', pincode: '192136' },
    { value: 'samthan', label: 'Samthan', pincode: '192137' },
    { value: 'seer', label: 'Seer', pincode: '192138' },
    { value: 'sugan', label: 'Sugan', pincode: '192139' },
    { value: 'ahangar', label: 'Ahangar', pincode: '192140' },
    { value: 'chuchater', label: 'Chuchater', pincode: '192141' },
    { value: 'gund', label: 'Gund', pincode: '192142' },
    { value: 'jablipora', label: 'Jablipora', pincode: '192143' },
    { value: 'kachwan', label: 'Kachwan', pincode: '192144' },
    { value: 'kranjbal', label: 'Kranjbal', pincode: '192145' },
    { value: 'manglora', label: 'Manglora', pincode: '192146' },
    { value: 'mashu', label: 'Mashu', pincode: '192147' },
    { value: 'shahabad', label: 'Shahabad', pincode: '192148' },
    { value: 'sukhdar', label: 'Sukhdar', pincode: '192149' }
    ],
  
    'bishnah': [
    { value: 'bishnah', label: 'Bishnah', pincode: '181132' },
    { value: 'chak', label: 'Chak', pincode: '181133' },
    { value: 'chamb', label: 'Chamb', pincode: '181134' },
    { value: 'dharpura', label: 'Dharpura', pincode: '181135' },
    { value: 'jakh', label: 'Jakh', pincode: '181136' },
    { value: 'kamalpur', label: 'Kamalpur', pincode: '181137' },
    { value: 'kanachak', label: 'Kanachak', pincode: '181138' },
    { value: 'kathar', label: 'Kathar', pincode: '181139' },
    { value: 'kewal', label: 'Kewal', pincode: '181140' },
    { value: 'manwal', label: 'Manwal', pincode: '181141' },
    { value: 'miran', label: 'Miran', pincode: '181142' },
    { value: 'raipur', label: 'Raipur', pincode: '181143' },
    { value: 'ranbirsinghpura', label: 'Ranbirsinghpura', pincode: '181144' },
    { value: 'sambora', label: 'Sambora', pincode: '181145' },
    { value: 'sarswati', label: 'Sarswati', pincode: '181146' },
    { value: 'sungli', label: 'Sungli', pincode: '181147' },
    { value: 'adhal', label: 'Adhal', pincode: '181148' },
    { value: 'balwal', label: 'Balwal', pincode: '181149' },
    { value: 'choudhary', label: 'Choudhary', pincode: '181150' },
    { value: 'jakhpura', label: 'Jakhpura', pincode: '181151' },
    { value: 'kalyanpur', label: 'Kalyanpur', pincode: '181152' },
    { value: 'khurd', label: 'Khurd', pincode: '181153' },
    { value: 'manakpur', label: 'Manakpur', pincode: '181154' },
    { value: 'narian', label: 'Narian', pincode: '181155' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '181156' },
    { value: 'rajasthan', label: 'Rajasthan', pincode: '181157' },
    { value: 'rehan', label: 'Rehan', pincode: '181158' },
    { value: 'sudhmahadev', label: 'Sudhmahadev', pincode: '181159' },
    { value: 'tankipur', label: 'Tankipur', pincode: '181160' },
    { value: 'gorkha', label: 'Gorkha', pincode: '181161' },
    { value: 'kaithpur', label: 'Kaithpur', pincode: '181162' },
    { value: 'karyal', label: 'Karyal', pincode: '181163' },
    { value: 'lahar', label: 'Lahar', pincode: '181164' },
    { value: 'tangyari', label: 'Tangyari', pincode: '181165' },
    { value: 'muhiyal', label: 'Muhiyal', pincode: '181166' },
    { value: 'nambla', label: 'Nambla', pincode: '181167' },
    { value: 'soham', label: 'Soham', pincode: '181168' },
    { value: 'nakul', label: 'Nakul', pincode: '181169' },
    { value: 'bhalwal', label: 'Bhalwal', pincode: '181170' },
    { value: 'chakmohalla', label: 'Chak Mohalla', pincode: '181171' },
    { value: 'kakra', label: 'Kakra', pincode: '181172' },
    { value: 'kandoli', label: 'Kandoli', pincode: '181173' },
    { value: 'khurda', label: 'Khurda', pincode: '181174' },
    { value: 'marh', label: 'Marh', pincode: '181175' },
    { value: 'mianpur', label: 'Mianpur', pincode: '181176' },
    { value: 'ranbirpura', label: 'Ranbirpura', pincode: '181177' },
    { value: 'tilakpur', label: 'Tilakpur', pincode: '181178' },
    { value: 'udaypur', label: 'Udaypur', pincode: '181179' }
    ],
    
    'charar-i-sharief': [
    { value: 'akroora', label: 'Akroora', pincode: '191112' },
    { value: 'bagh-i-sadiq', label: 'Bagh-i-Sadiq', pincode: '191113' },
    { value: 'bagh-i-urfan', label: 'Bagh-i-Urfan', pincode: '191114' },
    { value: 'chanapora', label: 'Chanapora', pincode: '191115' },
    { value: 'churpora', label: 'Churpora', pincode: '191116' },
    { value: 'damhall', label: 'Damhall', pincode: '191117' },
    { value: 'ferozpora', label: 'Ferozpora', pincode: '191118' },
    { value: 'gund', label: 'Gund', pincode: '191119' },
    { value: 'hanjiwara', label: 'Hanjiwara', pincode: '191120' },
    { value: 'harwan', label: 'Harwan', pincode: '191121' },
    { value: 'janpora', label: 'Janpora', pincode: '191122' },
    { value: 'kanyari', label: 'Kanyari', pincode: '191123' },
    { value: 'kacheri', label: 'Kacheri', pincode: '191124' },
    { value: 'khag', label: 'Khag', pincode: '191125' },
    { value: 'mohammadpora', label: 'Mohammadpora', pincode: '191126' },
    { value: 'pora', label: 'Porra', pincode: '191127' },
    { value: 'shahabad', label: 'Shahabad', pincode: '191128' },
    { value: 'sumbal', label: 'Sumbal', pincode: '191129' },
    { value: 'yakhman', label: 'Yakhman', pincode: '191130' },
    { value: 'awantipora', label: 'Awantipora', pincode: '191131' },
    { value: 'gagran', label: 'Gagran', pincode: '191132' },
    { value: 'kralpora', label: 'Kralpora', pincode: '191133' },
    { value: 'kharpora', label: 'Kharpora', pincode: '191134' },
    { value: 'mandoora', label: 'Mandoora', pincode: '191135' },
    { value: 'nagbal', label: 'Nagbal', pincode: '191136' },
    { value: 'narwara', label: 'Narwara', pincode: '191137' },
    { value: 'neel', label: 'Neel', pincode: '191138' },
    { value: 'sangam', label: 'Sangam', pincode: '191139' },
    { value: 'vishwara', label: 'Vishwara', pincode: '191140' }
    ],
    
    'doda': [
    { value: 'bhaderwah', label: 'Bhaderwah', pincode: '182222' },
    { value: 'bhalla', label: 'Bhalla', pincode: '182221' },
    { value: 'chadar', label: 'Chadar', pincode: '182223' },
    { value: 'cheerla', label: 'Cheerla', pincode: '182224' },
    { value: 'chinta', label: 'Chinta', pincode: '182225' },
    { value: 'choppy', label: 'Choppy', pincode: '182226' },
    { value: 'doda-town', label: 'Doda Town', pincode: '182201' },
    { value: 'dubgali', label: 'Dubgali', pincode: '182202' },
    { value: 'gandoh', label: 'Gandoh', pincode: '182203' },
    { value: 'harni', label: 'Harni', pincode: '182204' },
    { value: 'japow', label: 'Japow', pincode: '182205' },
    { value: 'jathi', label: 'Jathi', pincode: '182206' },
    { value: 'kishtwar', label: 'Kishtwar', pincode: '182207' },
    { value: 'machdara', label: 'Machdara', pincode: '182208' },
    { value: 'margan', label: 'Margan', pincode: '182209' },
    { value: 'mushkool', label: 'Mushkool', pincode: '182210' },
    { value: 'nalthi', label: 'Nalthi', pincode: '182211' },
    { value: 'padiyar', label: 'Padiyar', pincode: '182212' },
    { value: 'paseena', label: 'Paseena', pincode: '182213' },
    { value: 'rohani', label: 'Rohani', pincode: '182214' },
    { value: 'shahpur', label: 'Shahpur', pincode: '182215' },
    { value: 'sarthal', label: 'Sarthal', pincode: '182216' },
    { value: 'thathri', label: 'Thathri', pincode: '182217' },
    { value: 'tulsi', label: 'Tulsi', pincode: '182218' },
    { value: 'bagli', label: 'Bagli', pincode: '182219' },
    { value: 'bhatta', label: 'Bhatta', pincode: '182220' },
    { value: 'chamka', label: 'Chamka', pincode: '182227' },
    { value: 'garh', label: 'Garh', pincode: '182228' },
    { value: 'hiranagar', label: 'Hiranagar', pincode: '182229' },
    { value: 'jandrah', label: 'Jandrah', pincode: '182230' },
    { value: 'khour', label: 'Khour', pincode: '182231' },
    { value: 'kund', label: 'Kund', pincode: '182232' },
    { value: 'macha', label: 'Macha', pincode: '182233' },
    { value: 'narla', label: 'Narla', pincode: '182234' },
    { value: 'sudhmahadev', label: 'Sudhmahadev', pincode: '182235' },
    { value: 'surankote', label: 'Surankote', pincode: '182236' }
    ],
    
    'ganderbal': [
    { value: 'bagh-i-dilawar', label: 'Bagh-i-Dilawar', pincode: '191123' },
    { value: 'balhama', label: 'Balhama', pincode: '191124' },
    { value: 'bandipora', label: 'Bandipora', pincode: '191125' },
    { value: 'chanpora', label: 'Chanpora', pincode: '191126' },
    { value: 'gagarpora', label: 'Gagarpora', pincode: '191127' },
    { value: 'ganderbal-town', label: 'Ganderbal Town', pincode: '191128' },
    { value: 'gudabal', label: 'Gudabal', pincode: '191129' },
    { value: 'hajan', label: 'Hajan', pincode: '191130' },
    { value: 'kanihama', label: 'Kanihama', pincode: '191131' },
    { value: 'kangan', label: 'Kangan', pincode: '191132' },
    { value: 'kothibagh', label: 'Kothibagh', pincode: '191133' },
    { value: 'naranag', label: 'Naranag', pincode: '191134' },
    { value: 'nazimabad', label: 'Nazimabad', pincode: '191135' },
    { value: 'soibugh', label: 'Soibugh', pincode: '191136' },
    { value: 'wagar', label: 'Wagar', pincode: '191137' },
    { value: 'wusan', label: 'Wusan', pincode: '191138' }
    ],
    
    'ghou-manhasan': [
    { value: 'bagh-i-sadiq', label: 'Bagh-i-Sadiq', pincode: '181125' },
    { value: 'ban', label: 'Ban', pincode: '181126' },
    { value: 'batal', label: 'Batal', pincode: '181127' },
    { value: 'garnai', label: 'Garnai', pincode: '181128' },
    { value: 'ghou', label: 'Ghou', pincode: '181129' },
    { value: 'ghou-manhasan', label: 'Ghou Manhasan', pincode: '181130' },
    { value: 'gundla', label: 'Gundla', pincode: '181131' },
    { value: 'manhasan', label: 'Manhasan', pincode: '181132' },
    { value: 'narayana', label: 'Narayana', pincode: '181133' },
    { value: 'purna', label: 'Purna', pincode: '181134' },
    { value: 'rajam', label: 'Rajam', pincode: '181135' },
    { value: 'ranbirsingh', label: 'Ranbir Singh', pincode: '181136' },
    { value: 'saidan', label: 'Saidan', pincode: '181137' },
    { value: 'sambal', label: 'Sambal', pincode: '181138' },
    { value: 'sangrampur', label: 'Sangrampur', pincode: '181139' },
    { value: 'chandala', label: 'Chandala', pincode: '181140' },
    { value: 'chakka', label: 'Chakka', pincode: '181141' },
    { value: 'garhi', label: 'Garhi', pincode: '181142' },
    { value: 'gathoo', label: 'Gathoo', pincode: '181143' },
    { value: 'jagran', label: 'Jagran', pincode: '181144' },
    { value: 'kalwan', label: 'Kalwan', pincode: '181145' },
    { value: 'kannera', label: 'Kannera', pincode: '181146' },
    { value: 'khanyari', label: 'Khanyari', pincode: '181147' },
    { value: 'kishenpur', label: 'Kishenpur', pincode: '181148' },
    { value: 'patta', label: 'Patta', pincode: '181149' },
    { value: 'pirpanchal', label: 'Pirpanchal', pincode: '181150' }
    ],
    
    'hajan': [
    { value: 'arampora', label: 'Arampora', pincode: '191201' },
    { value: 'bagh-i-shah', label: 'Bagh-i-Shah', pincode: '191202' },
    { value: 'battabugh', label: 'Battabugh', pincode: '191203' },
    { value: 'duderhama', label: 'Duderhama', pincode: '191204' },
    { value: 'gund', label: 'Gund', pincode: '191205' },
    { value: 'gundbal', label: 'Gundbal', pincode: '191206' },
    { value: 'hajan-town', label: 'Hajan Town', pincode: '191207' },
    { value: 'kanihama', label: 'Kanihama', pincode: '191208' },
    { value: 'kulingam', label: 'Kulingam', pincode: '191209' },
    { value: 'manigam', label: 'Manigam', pincode: '191210' },
    { value: 'nawakadal', label: 'Nawakadal', pincode: '191211' },
    { value: 'panchpora', label: 'Panchpora', pincode: '191212' },
    { value: 'raithan', label: 'Raithan', pincode: '191213' },
    { value: 'shahabad', label: 'Shahabad', pincode: '191214' },
    { value: 'thathri', label: 'Thathri', pincode: '191215' },
    { value: 'gulgam', label: 'Gulgam', pincode: '191216' },
    { value: 'hasanat', label: 'Hasanat', pincode: '191217' },
    { value: 'khrew', label: 'Khrew', pincode: '191218' },
    { value: 'lehar', label: 'Lehar', pincode: '191219' },
    { value: 'manjimpora', label: 'Manjimpora', pincode: '191220' },
    { value: 'minderpora', label: 'Minderpora', pincode: '191221' },
    { value: 'mohammadpora', label: 'Mohammadpora', pincode: '191222' },
    { value: 'samwan', label: 'Samwan', pincode: '191223' },
    { value: 'sathpora', label: 'Sathpora', pincode: '191224' }
    ],
  
    'handwara': [
    { value: 'chogal', label: 'Chogal', pincode: '193222' },
    { value: 'dobhi', label: 'Dobhi', pincode: '193222' },
    { value: 'gund', label: 'Gund', pincode: '193223' },
    { value: 'habbakadal', label: 'Habbakadal', pincode: '190001' },
    { value: 'hangarapora', label: 'Hangarapora', pincode: '193221' },
    { value: 'jakhama', label: 'Jakhama', pincode: '193204' },
    { value: 'kalaroos', label: 'Kalaroos', pincode: '193225' },
    { value: 'kralpora', label: 'Kralpora', pincode: '193301' },
    { value: 'langate', label: 'Langate', pincode: '193302' },
    { value: 'lohai-malwan', label: 'Loahi Malwan', pincode: '193301' },
    { value: 'manzgam', label: 'Manzgam', pincode: '193226' },
    { value: 'pethkot', label: 'Pethkot', pincode: '193226' },
    { value: 'ranbher', label: 'Ranbher', pincode: '193222' },
    { value: 'salar', label: 'Salar', pincode: '193222' },
    { value: 'wagay', label: 'Wagay', pincode: '193221' },
    { value: 'brar', label: 'Brar', pincode: '193221' },
    { value: 'shaho', label: 'Shaho', pincode: '193224' },
    { value: 'batergam', label: 'Batergam', pincode: '193222' },
    { value: 'watwan', label: 'Watwan', pincode: '193225' },
    { value: 'sathran', label: 'Sathran', pincode: '193226' },
    { value: 'kishenpora', label: 'Kishenpora', pincode: '193222' }
    ],
  
    'hiranagar': [
    { value: 'bangar', label: 'Bangar', pincode: '181204' },
    { value: 'badyal', label: 'Badyal', pincode: '181204' },
    { value: 'chak', label: 'Chak', pincode: '181204' },
    { value: 'channa', label: 'Channa', pincode: '181204' },
    { value: 'charwah', label: 'Charwah', pincode: '181204' },
    { value: 'hiranagar', label: 'Hiranagar', pincode: '181201' },
    { value: 'jogian', label: 'Jogian', pincode: '181204' },
    { value: 'karol', label: 'Karol', pincode: '181204' },
    { value: 'khour', label: 'Khour', pincode: '181204' },
    { value: 'lachhipur', label: 'Lachhipur', pincode: '181204' },
    { value: 'metha', label: 'Metha', pincode: '181204' },
    { value: 'naryal', label: 'Naryal', pincode: '181204' },
    { value: 'rahmangate', label: 'Rahmangate', pincode: '181204' },
    { value: 'sathra', label: 'Sathra', pincode: '181204' },
    { value: 'wardi', label: 'Wardi', pincode: '181204' },
    { value: 'chak-bat', label: 'Chak Bat', pincode: '181203' },
    { value: 'balhama', label: 'Balhama', pincode: '181202' },
    { value: 'panyari', label: 'Panyari', pincode: '181204' },
    { value: 'samdwan', label: 'Samdwan', pincode: '181204' },
    { value: 'sialkot', label: 'Sialkot', pincode: '181205' },
    { value: 'tinmari', label: 'Tinmari', pincode: '181204' },
    { value: 'talab', label: 'Talab', pincode: '181204' }
    ],
  
    'jammu': [
    { value: 'akhnoor', label: 'Akhnoor', pincode: '181201' },
    { value: 'bahu-fort', label: 'Bahu Fort', pincode: '180001' },
    { value: 'bagh-e-bahu', label: 'Bagh-e-Bahu', pincode: '180001' },
    { value: 'barjala', label: 'Barjala', pincode: '180001' },
    { value: 'bari-brahmana', label: 'Bari Brahmana', pincode: '181133' },
    { value: 'chak', label: 'Chak', pincode: '180001' },
    { value: 'channi-himmat', label: 'Channi Himmat', pincode: '180015' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '180004' },
    { value: 'jammu-cantt', label: 'Jammu Cantt', pincode: '180003' },
    { value: 'jammu-city', label: 'Jammu City', pincode: '180001' },
    { value: 'kanachak', label: 'Kanachak', pincode: '181123' },
    { value: 'karan-nagar', label: 'Karan Nagar', pincode: '180001' },
    { value: 'kathua', label: 'Kathua', pincode: '184101' },
    { value: 'mahal', label: 'Mahal', pincode: '180001' },
    { value: 'mandal', label: 'Mandal', pincode: '181123' },
    { value: 'narwal', label: 'Narwal', pincode: '180006' },
    { value: 'patoli', label: 'Patoli', pincode: '180017' },
    { value: 'ranibagh', label: 'Ranibagh', pincode: '180001' },
    { value: 'raipur', label: 'Raipur', pincode: '181205' },
    { value: 'satwari', label: 'Satwari', pincode: '180003' },
    { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '180004' },
    { value: 'sidra', label: 'Sidra', pincode: '181124' },
    { value: 'sunjwan', label: 'Sunjwan', pincode: '181141' },
    { value: 'trikuta-nagar', label: 'Trikuta Nagar', pincode: '180012' }
    ],
  
    'jourian': [
    { value: 'baleer', label: 'Baleer', pincode: '181203' },
    { value: 'chak-jammu', label: 'Chak Jammu', pincode: '181201' },
    { value: 'gajansoo', label: 'Gajansoo', pincode: '181202' },
    { value: 'jourian', label: 'Jourian', pincode: '181204' },
    { value: 'kanachak', label: 'Kanachak', pincode: '181123' },
    { value: 'kandoli', label: 'Kandoli', pincode: '181203' },
    { value: 'miran-sahib', label: 'Miran Sahib', pincode: '181101' },
    { value: 'paloura', label: 'Paloura', pincode: '180001' },
    { value: 'sanjwan', label: 'Sanjwan', pincode: '181112' },
    { value: 'taraf-bahu', label: 'Taraf Bahu', pincode: '181204' },
    { value: 'baga', label: 'Baga', pincode: '181205' },
    { value: 'chak-sunjuwan', label: 'Chak Sunjuwan', pincode: '181142' },
    { value: 'dhanwal', label: 'Dhanwal', pincode: '181204' },
    { value: 'gundla', label: 'Gundla', pincode: '181205' },
    { value: 'jogi-bari', label: 'Jogi Bari', pincode: '181203' },
    { value: 'khour', label: 'Khour', pincode: '181204' },
    { value: 'lohi', label: 'Lohi', pincode: '181205' },
    { value: 'nandpur', label: 'Nandpur', pincode: '181204' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '181201' }
    ],
  
    'kathua': [
    { value: 'badhori', label: 'Badhori', pincode: '184205' },
    { value: 'bari-brahmana', label: 'Bari Brahmana', pincode: '181133' },
    { value: 'chak', label: 'Chak', pincode: '184205' },
    { value: 'daggar', label: 'Daggar', pincode: '184201' },
    { value: 'dinanagar', label: 'Dinanagar', pincode: '184205' },
    { value: 'jammu-road', label: 'Jammu Road', pincode: '184101' },
    { value: 'kathua', label: 'Kathua', pincode: '184101' },
    { value: 'kishanpur', label: 'Kishanpur', pincode: '184205' },
    { value: 'nagri', label: 'Nagri', pincode: '184142' },
    { value: 'pathankot', label: 'Pathankot', pincode: '184101' },
    { value: 'salaria', label: 'Salaria', pincode: '184205' },
    { value: 'sanam', label: 'Sanam', pincode: '184101' },
    { value: 'sarthal', label: 'Sarthal', pincode: '184206' },
    { value: 'sunderbani', label: 'Sunderbani', pincode: '184202' },
    { value: 'barnoti', label: 'Barnoti', pincode: '184205' },
    { value: 'bhojpur', label: 'Bhojpur', pincode: '184205' },
    { value: 'chandwan', label: 'Chandwan', pincode: '184206' },
    { value: 'gagore', label: 'Gagore', pincode: '184205' },
    { value: 'kharah', label: 'Kharah', pincode: '184101' },
    { value: 'madana', label: 'Madana', pincode: '184101' },
    { value: 'pahariwala', label: 'Pahariwala', pincode: '184205' },
    { value: 'tapia', label: 'Tapia', pincode: '184205' },
    { value: 'udheywala', label: 'Udheywala', pincode: '184205' }
    ],
  
    'katra': [
    { value: 'baghwan', label: 'Baghwan', pincode: '182301' },
    { value: 'bhagatpur', label: 'Bhagatpur', pincode: '182301' },
    { value: 'choudhary-bela', label: 'Choudhary Bela', pincode: '182301' },
    { value: 'chowki', label: 'Chowki', pincode: '182301' },
    { value: 'dhanwail', label: 'Dhanwail', pincode: '182301' },
    { value: 'ganji-maal', label: 'Ganji Maal', pincode: '182301' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jai', label: 'Jai', pincode: '182301' },
    { value: 'jammu', label: 'Jammu', pincode: '180001' },
    { value: 'katra-town', label: 'Katra Town', pincode: '182301' },
    { value: 'kud', label: 'Kud', pincode: '182301' },
    { value: 'mohanpur', label: 'Mohanpur', pincode: '182301' },
    { value: 'purani-mandi', label: 'Purani Mandi', pincode: '182301' },
    { value: 'rajouri', label: 'Rajouri', pincode: '185131' },
    { value: 'reasi', label: 'Reasi', pincode: '182311' },
    { value: 'sudh-maidan', label: 'Sudh Maidan', pincode: '182301' },
    { value: 'tariq', label: 'Tariq', pincode: '182301' },
    { value: 'trakota', label: 'Trakota', pincode: '182301' },
    { value: 'vishwakarma', label: 'Vishwakarma', pincode: '182301' }
    ],
  
    'khore': [
    { value: 'adhal', label: 'Adhal', pincode: '185132' },
    { value: 'bagh-e-bahu', label: 'Bagh-e-Bahu', pincode: '180001' },
    { value: 'barmeen', label: 'Barmeen', pincode: '185132' },
    { value: 'bhaderwah', label: 'Bhaderwah', pincode: '182222' },
    { value: 'chowki', label: 'Chowki', pincode: '185132' },
    { value: 'doda', label: 'Doda', pincode: '182202' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jammu', label: 'Jammu', pincode: '180001' },
    { value: 'jindrah', label: 'Jindrah', pincode: '182201' },
    { value: 'khore-town', label: 'Khore Town', pincode: '185132' },
    { value: 'kishtwar', label: 'Kishtwar', pincode: '182204' },
    { value: 'krimchi', label: 'Krimchi', pincode: '185132' },
    { value: 'kullian', label: 'Kullian', pincode: '185132' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '185132' },
    { value: 'nagrota', label: 'Nagrota', pincode: '182205' },
    { value: 'pancheri', label: 'Pancheri', pincode: '185134' },
    { value: 'reasi', label: 'Reasi', pincode: '182311' },
    { value: 'sudh-maidan', label: 'Sudh Maidan', pincode: '182301' },
    { value: 'tariq', label: 'Tariq', pincode: '182301' },
    { value: 'thathri', label: 'Thathri', pincode: '182203' },
    { value: 'villari', label: 'Villari', pincode: '185132' }
    ],
  
    'kupwara': [
    { value: 'arpora', label: 'Arpora', pincode: '193222' },
    { value: 'bandipora', label: 'Bandipora', pincode: '193502' },
    { value: 'baramulla', label: 'Baramulla', pincode: '193101' },
    { value: 'chamran', label: 'Chamran', pincode: '193222' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hapur', label: 'Hapur', pincode: '193222' },
    { value: 'jammu', label: 'Jammu', pincode: '180001' },
    { value: 'kapran', label: 'Kapran', pincode: '193222' },
    { value: 'karnah', label: 'Karnah', pincode: '193221' },
    { value: 'kupwara-town', label: 'Kupwara Town', pincode: '193222' },
    { value: 'mohra', label: 'Mohra', pincode: '193223' },
    { value: 'nowgam', label: 'Nowgam', pincode: '193222' },
    { value: 'poonch', label: 'Poonch', pincode: '185101' },
    { value: 'rampur', label: 'Rampur', pincode: '193222' },
    { value: 'sopore', label: 'Sopore', pincode: '193201' },
    { value: 'tangmarg', label: 'Tangmarg', pincode: '193402' },
    { value: 'tujjar', label: 'Tujjar', pincode: '193202' },
    { value: 'wadar', label: 'Wadar', pincode: '193222' },
    { value: 'zurhama', label: 'Zurhama', pincode: '193222' },
    { value: 'chowkibal', label: 'Chowkibal', pincode: '193223' },
    { value: 'rishipora', label: 'Rishipora', pincode: '193222' },
    { value: 'manigah', label: 'Manigah', pincode: '193223' },
    { value: 'kralpora', label: 'Kralpora', pincode: '193223' },
    { value: 'hatmulla', label: 'Hatmulla', pincode: '193222' },
    { value: 'panzalla', label: 'Panzalla', pincode: '193223' },
    { value: 'maidanpora', label: 'Maidanpora', pincode: '193222' },
    { value: 'rahan', label: 'Rahan', pincode: '193222' }
    ],
  
    'lakhenpur': [
    { value: 'basholi', label: 'Basholi', pincode: '184204' },
    { value: 'chhamb', label: 'Chhamb', pincode: '181301' },
    { value: 'doda', label: 'Doda', pincode: '182202' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jammu-city', label: 'Jammu City', pincode: '180001' },
    { value: 'jammu-district', label: 'Jammu District', pincode: '181121' },
    { value: 'katra', label: 'Katra', pincode: '182301' },
    { value: 'lakhenpur', label: 'Lakhenpur', pincode: '184205' },
    { value: 'latti', label: 'Latti', pincode: '182121' },
    { value: 'mansar', label: 'Mansar', pincode: '182143' },
    { value: 'miran-sahib', label: 'Miran Sahib', pincode: '181101' },
    { value: 'puneja', label: 'Puneja', pincode: '184209' },
    { value: 'reasi', label: 'Reasi', pincode: '182311' },
    { value: 'ramban', label: 'Ramban', pincode: '182144' },
    { value: 'samba', label: 'Samba', pincode: '184121' },
    { value: 'sunderbani', label: 'Sunderbani', pincode: '185151' },
    { value: 'surinsar', label: 'Surinsar', pincode: '182123' },
    { value: 'trikuta-nagar', label: 'Trikuta Nagar', pincode: '180011' },
    { value: 'udhampur', label: 'Udhampur', pincode: '182301' },
    { value: 'vijaypur', label: 'Vijaypur', pincode: '181143' },
    { value: 'akhnoor', label: 'Akhnoor', pincode: '181201' },
    { value: 'raipur', label: 'Raipur', pincode: '184210' },
    { value: 'bari-brahmana', label: 'Bari Brahmana', pincode: '181133' },
    { value: 'billawar', label: 'Billawar', pincode: '184201' }
    ],
  
    'pahalgam': [
    { value: 'achabal', label: 'Achabal', pincode: '192201' },
    { value: 'anumaz', label: 'Anumaz', pincode: '192212' },
    { value: 'baisaran', label: 'Baisaran', pincode: '192126' },
    { value: 'dora', label: 'Dora', pincode: '192125' },
    { value: 'gund', label: 'Gund', pincode: '192202' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kashmir', label: 'Kashmir', pincode: '192102' },
    { value: 'pahalgam', label: 'Pahalgam', pincode: '192126' },
    { value: 'pulwama', label: 'Pulwama', pincode: '192301' },
    { value: 'sherwan', label: 'Sherwan', pincode: '192124' },
    { value: 'verinag', label: 'Verinag', pincode: '192215' },
    { value: 'biharmarg', label: 'Biharmarg', pincode: '192105' },
    { value: 'matan', label: 'Matan', pincode: '192120' },
    { value: 'achabal-village', label: 'Achabal Village', pincode: '192202' },
    { value: 'bijbehara', label: 'Bijbehara', pincode: '192124' },
    { value: 'kanjiwar', label: 'Kanjiwar', pincode: '192209' },
    { value: 'larkipora', label: 'Larkipora', pincode: '192213' },
    { value: 'laripora', label: 'Laripora', pincode: '192126' },
    { value: 'pantha-chowk', label: 'Pantha Chowk', pincode: '192122' },
    { value: 'pahalgam-bazar', label: 'Pahalgam Bazar', pincode: '192126' },
    { value: 'sangam', label: 'Sangam', pincode: '192301' },
    { value: 'sumblar', label: 'Sumblar', pincode: '192204' },
    { value: 'yemberzal', label: 'Yemberzal', pincode: '192126' },
    { value: 'zaznar', label: 'Zaznar', pincode: '192205' }
    ],
  
    'pampore': [
    { value: 'awantipora', label: 'Awantipora', pincode: '192122' },
    { value: 'chak-khawaja', label: 'Chak Khawaja', pincode: '192121' },
    { value: 'damhal-hanjipora', label: 'Damhal Hanjipora', pincode: '192305' },
    { value: 'frestbal', label: 'Frestbal', pincode: '192125' },
    { value: 'kendru', label: 'Kendru', pincode: '192126' },
    { value: 'larnoo', label: 'Larnoo', pincode: '192201' },
    { value: 'mattan', label: 'Mattan', pincode: '192210' },
    { value: 'pampore-town', label: 'Pampore Town', pincode: '192121' },
    { value: 'patan', label: 'Patan', pincode: '192303' },
    { value: 'pulwama', label: 'Pulwama', pincode: '192301' },
    { value: 'srinagar', label: 'Srinagar', pincode: '190001' },
    { value: 'trichal', label: 'Trichal', pincode: '192303' },
    { value: 'zainapora', label: 'Zainapora', pincode: '192204' }
    ],
  
    'poonch': [
    { value: 'azad-gali', label: 'Azad Gali', pincode: '185101' },
    { value: 'chattergala', label: 'Chattergala', pincode: '185102' },
    { value: 'dara', label: 'Dara', pincode: '185106' },
    { value: 'dehra', label: 'Dehra', pincode: '185102' },
    { value: 'deri', label: 'Deri', pincode: '185113' },
    { value: 'dumail', label: 'Dumail', pincode: '185110' },
    { value: 'khari', label: 'Khari', pincode: '185120' },
    { value: 'loro', label: 'Loro', pincode: '185105' },
    { value: 'mendhar', label: 'Mendhar', pincode: '185111' },
    { value: 'noon', label: 'Noon', pincode: '185115' },
    { value: 'poonch-town', label: 'Poonch Town', pincode: '185101' },
    { value: 'razi', label: 'Razi', pincode: '185109' },
    { value: 'sabhna', label: 'Sabhna', pincode: '185102' },
    { value: 'salwah', label: 'Salwah', pincode: '185107' },
    { value: 'sanjota', label: 'Sanjota', pincode: '185119' },
    { value: 'surankote', label: 'Surankote', pincode: '185121' },
    { value: 'tangmarg', label: 'Tangmarg', pincode: '185123' },
    { value: 'tory', label: 'Tory', pincode: '185122' },
    { value: 'balakot', label: 'Balakot', pincode: '185118' },
    { value: 'bagh', label: 'Bagh', pincode: '185104' },
    { value: 'manjari', label: 'Manjari', pincode: '185116' },
    { value: 'chakri', label: 'Chakri', pincode: '185112' },
    { value: 'mangnar', label: 'Mangnar', pincode: '185114' },
    { value: 'rachikote', label: 'Rachikote', pincode: '185108' }
    ],
  
    'pulwama': [
    { value: 'adalatganj', label: 'Adalatganj', pincode: '192301' },
    { value: 'awantipora', label: 'Awantipora', pincode: '192122' },
    { value: 'by-pass-road', label: 'Bypass Road', pincode: '192122' },
    { value: 'chakroi', label: 'Chakroi', pincode: '192121' },
    { value: 'dalipora', label: 'Dalipora', pincode: '192301' },
    { value: 'gundipora', label: 'Gundipora', pincode: '192305' },
    { value: 'kakapora', label: 'Kakapora', pincode: '192305' },
    { value: 'kulgam', label: 'Kulgam', pincode: '192232' },
    { value: 'lachipora', label: 'Lachipora', pincode: '192303' },
    { value: 'mattan', label: 'Mattan', pincode: '192121' },
    { value: 'niyari', label: 'Niyari', pincode: '192303' },
    { value: 'pampore', label: 'Pampore', pincode: '192121' },
    { value: 'pulwama', label: 'Pulwama', pincode: '192301' },
    { value: 'rajoora', label: 'Rajoora', pincode: '192122' },
    { value: 'sambora', label: 'Sambora', pincode: '192121' },
    { value: 'srinagar', label: 'Srinagar', pincode: '190001' },
    { value: 'trali', label: 'Trali', pincode: '192232' },
    { value: 'zainapora', label: 'Zainapora', pincode: '192305' },
    { value: 'bellow', label: 'Bellow', pincode: '192301' },
    { value: 'daddura', label: 'Daddura', pincode: '192121' },
    { value: 'drabshalla', label: 'Drabshalla', pincode: '192305' },
    { value: 'kandizal', label: 'Kandizal', pincode: '192121' },
    { value: 'nowgam', label: 'Nowgam', pincode: '192122' },
    { value: 'shikargah', label: 'Shikargah', pincode: '192301' },
    { value: 'shuhama', label: 'Shuhama', pincode: '192121' },
    { value: 'zaspora', label: 'Zaspora', pincode: '192121' }
    ],
  
    'qaimoh': [
    { value: 'adhal', label: 'Adhal', pincode: '192303' },
    { value: 'arpora', label: 'Arpora', pincode: '192211' },
    { value: 'badroo', label: 'Badroo', pincode: '192212' },
    { value: 'bhagatpur', label: 'Bhagatpur', pincode: '192302' },
    { value: 'bugam', label: 'Bugam', pincode: '192303' },
    { value: 'chakarbal', label: 'Chakarbal', pincode: '192301' },
    { value: 'gundbal', label: 'Gundbal', pincode: '192302' },
    { value: 'kharpora', label: 'Kharpora', pincode: '192303' },
    { value: 'kuthar', label: 'Kuthar', pincode: '192302' },
    { value: 'laiyar', label: 'Laiyar', pincode: '192301' },
    { value: 'mohammadpora', label: 'Mohammadpora', pincode: '192211' },
    { value: 'qaimoh', label: 'Qaimoh', pincode: '192211' },
    { value: 'rahatpora', label: 'Rahatpora', pincode: '192301' },
    { value: 'shamsipora', label: 'Shamsipora', pincode: '192302' },
    { value: 'shariefabad', label: 'Shariefabad', pincode: '192301' },
    { value: 'zainpora', label: 'Zainpora', pincode: '192303' },
    { value: 'bazipora', label: 'Bazipora', pincode: '192305' },
    { value: 'chungipora', label: 'Chungipora', pincode: '192305' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '192211' },
    { value: 'jamalpora', label: 'Jamalpora', pincode: '192211' },
    { value: 'karipora', label: 'Karipora', pincode: '192212' },
    { value: 'khamoo', label: 'Khamoo', pincode: '192305' },
    { value: 'panzath', label: 'Panzath', pincode: '192211' },
    { value: 'pirpora', label: 'Pirpora', pincode: '192301' },
    { value: 'rampora', label: 'Rampora', pincode: '192212' },
    { value: 'sallar', label: 'Sallar', pincode: '192303' },
    { value: 'battal', label: 'Battal', pincode: '192303' },
    { value: 'bishrampora', label: 'Bishrampora', pincode: '192212' },
    { value: 'chandwan', label: 'Chandwan', pincode: '192301' },
    { value: 'darwan', label: 'Darwan', pincode: '192212' },
    { value: 'gundpora', label: 'Gundpora', pincode: '192305' },
    { value: 'kutpora', label: 'Kutpora', pincode: '192301' },
    { value: 'magam', label: 'Magam', pincode: '192301' },
    { value: 'nawabpora', label: 'Nawabpora', pincode: '192211' },
    { value: 'pirbagh', label: 'Pirbagh', pincode: '192301' },
    { value: 'shahpora', label: 'Shahpora', pincode: '192302' },
    { value: 'tulran', label: 'Tulran', pincode: '192301' }
    ],
    
    'qazigund': [
    { value: 'achabal', label: 'Achabal', pincode: '192201' },
    { value: 'banihal', label: 'Banihal', pincode: '192101' },
    { value: 'charsoo', label: 'Charsoo', pincode: '192101' },
    { value: 'dalwach', label: 'Dalwach', pincode: '192201' },
    { value: 'drobshalla', label: 'Drobshalla', pincode: '192201' },
    { value: 'hakripora', label: 'Hakripora', pincode: '192101' },
    { value: 'keller', label: 'Keller', pincode: '192201' },
    { value: 'kulgam', label: 'Kulgam', pincode: '192232' },
    { value: 'pulwama', label: 'Pulwama', pincode: '192301' },
    { value: 'qazigund', label: 'Qazigund', pincode: '192221' },
    { value: 'rahatpora', label: 'Rahatpora', pincode: '192221' },
    { value: 'shamsipora', label: 'Shamsipora', pincode: '192101' },
    { value: 'srigufwara', label: 'Srigufwara', pincode: '192201' },
    { value: 'wanpora', label: 'Wanpora', pincode: '192221' },
    { value: 'ashtangoo', label: 'Ashtangoo', pincode: '192101' },
    { value: 'awantipora', label: 'Awantipora', pincode: '192122' },
    { value: 'battal', label: 'Battal', pincode: '192101' },
    { value: 'bichhilwan', label: 'Bichhilwan', pincode: '192201' },
    { value: 'chatpora', label: 'Chatpora', pincode: '192101' },
    { value: 'gund', label: 'Gund', pincode: '192201' },
    { value: 'lalpora', label: 'Lalpora', pincode: '192202' },
    { value: 'mattan', label: 'Mattan', pincode: '192121' },
    { value: 'mohammadpora', label: 'Mohammadpora', pincode: '192221' },
    { value: 'pahalgam', label: 'Pahalgam', pincode: '192126' },
    { value: 'pulwama-bypass', label: 'Pulwama Bypass', pincode: '192301' },
    { value: 'verinag', label: 'Verinag', pincode: '192302' }
    ],
    
    'ramban': [
    { value: 'batote', label: 'Batote', pincode: '182101' },
    { value: 'banihal', label: 'Banihal', pincode: '192101' },
    { value: 'chareel', label: 'Chareel', pincode: '182101' },
    { value: 'digdol', label: 'Digdol', pincode: '182103' },
    { value: 'khari', label: 'Khari', pincode: '182102' },
    { value: 'magerkote', label: 'Magerkote', pincode: '182101' },
    { value: 'mohre', label: 'Mohre', pincode: '182101' },
    { value: 'patnitop', label: 'Patnitop', pincode: '182142' },
    { value: 'raja-deri', label: 'Raja Deri', pincode: '182141' },
    { value: 'ramsoo', label: 'Ramsoo', pincode: '192101' },
    { value: 'ramban', label: 'Ramban', pincode: '182141' },
    { value: 'sui', label: 'Sui', pincode: '182101' },
    { value: 'thial', label: 'Thial', pincode: '182141' },
    { value: 'arampora', label: 'Arampora', pincode: '182101' },
    { value: 'bagh', label: 'Bagh', pincode: '182141' },
    { value: 'bhalessa', label: 'Bhalessa', pincode: '182101' },
    { value: 'balote', label: 'Balote', pincode: '182101' },
    { value: 'kunda', label: 'Kunda', pincode: '182102' },
    { value: 'kud', label: 'Kud', pincode: '182141' },
    { value: 'manigam', label: 'Manigam', pincode: '182141' },
    { value: 'nashri', label: 'Nashri', pincode: '182141' },
    { value: 'neel', label: 'Neel', pincode: '182102' },
    { value: 'pasan', label: 'Pasan', pincode: '182101' },
    { value: 'ramkote', label: 'Ramkote', pincode: '182101' },
    { value: 'shahdara', label: 'Shahdara', pincode: '182101' },
    { value: 'sumbal', label: 'Sumbal', pincode: '182141' }
    ],
    
    'ranbir-singh-pura': [
    { value: 'abtal', label: 'Abtal', pincode: '181132' },
    { value: 'banotar', label: 'Banotar', pincode: '181132' },
    { value: 'bachian', label: 'Bachian', pincode: '181132' },
    { value: 'chandpur', label: 'Chandpur', pincode: '181132' },
    { value: 'gagian', label: 'Gagian', pincode: '181132' },
    { value: 'jammu', label: 'Jammu', pincode: '180001' },
    { value: 'kachral', label: 'Kachral', pincode: '181132' },
    { value: 'karmal', label: 'Karmal', pincode: '181132' },
    { value: 'madhopur', label: 'Madhopur', pincode: '181132' },
    { value: 'nariyal', label: 'Nariyal', pincode: '181132' },
    { value: 'ranbir-singh-pura', label: 'Ranbir Singh Pura', pincode: '181152' },
    { value: 'sanjay-pura', label: 'Sanjay Pura', pincode: '181132' },
    { value: 'sunderbani', label: 'Sunderbani', pincode: '181132' },
    { value: 'taryan', label: 'Taryan', pincode: '181132' },
    { value: 'thathar', label: 'Thathar', pincode: '181132' },
    { value: 'banglian', label: 'Banglian', pincode: '181132' },
    { value: 'bhour', label: 'Bhour', pincode: '181132' },
    { value: 'chak-miran', label: 'Chak Miran', pincode: '181132' },
    { value: 'chani', label: 'Chani', pincode: '181132' },
    { value: 'dholi', label: 'Dholi', pincode: '181132' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '181132' },
    { value: 'jandial', label: 'Jandial', pincode: '181132' },
    { value: 'kapura', label: 'Kapura', pincode: '181132' },
    { value: 'khour', label: 'Khour', pincode: '181132' },
    { value: 'lachipur', label: 'Lachipur', pincode: '181132' },
    { value: 'mora', label: 'Mora', pincode: '181132' },
    { value: 'pindian', label: 'Pindian', pincode: '181132' },
    { value: 'rangpur', label: 'Rangpur', pincode: '181132' },
    { value: 'sambhar', label: 'Sambhar', pincode: '181132' },
    { value: 'shibban', label: 'Shibban', pincode: '181132' },
    { value: 'tangri', label: 'Tangri', pincode: '181132' },
    { value: 'ambphalla', label: 'Ambphalla', pincode: '181132' },
    { value: 'bandral', label: 'Bandral', pincode: '181132' },
    { value: 'chandral', label: 'Chandral', pincode: '181132' },
    { value: 'deoria', label: 'Deoria', pincode: '181132' },
    { value: 'doli', label: 'Doli', pincode: '181132' },
    { value: 'gundla', label: 'Gundla', pincode: '181132' },
    { value: 'jawala', label: 'Jawala', pincode: '181132' },
    { value: 'karouni', label: 'Karouni', pincode: '181132' },
    { value: 'khor', label: 'Khor', pincode: '181132' },
    { value: 'leela', label: 'Leela', pincode: '181132' },
    { value: 'mandoo', label: 'Mandoo', pincode: '181132' },
    { value: 'pallan', label: 'Pallan', pincode: '181132' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '181132' },
    { value: 'sunnu', label: 'Sunnu', pincode: '181132' }
    ],
    
    'samba': [
    { value: 'adhoiwala', label: 'Adhoiwala', pincode: '181123' },
    { value: 'bari-brahmana', label: 'Bari Brahmana', pincode: '181133' },
    { value: 'chichi', label: 'Chichi', pincode: '181133' },
    { value: 'darbara', label: 'Darbara', pincode: '181123' },
    { value: 'gagore', label: 'Gagore', pincode: '181123' },
    { value: 'jakh', label: 'Jakh', pincode: '181132' },
    { value: 'jammu', label: 'Jammu', pincode: '180001' },
    { value: 'khari', label: 'Khari', pincode: '181132' },
    { value: 'khour', label: 'Khour', pincode: '181123' },
    { value: 'madhopur', label: 'Madhopur', pincode: '181132' },
    { value: 'narayana', label: 'Narayana', pincode: '181132' },
    { value: 'rajpura', label: 'Rajpura', pincode: '181132' },
    { value: 'samba', label: 'Samba', pincode: '181141' },
    { value: 'shahabad', label: 'Shahabad', pincode: '181132' },
    { value: 'sundla', label: 'Sundla', pincode: '181132' },
    { value: 'teli', label: 'Teli', pincode: '181132' },
    { value: 'adli', label: 'Adli', pincode: '181131' },
    { value: 'akali', label: 'Akali', pincode: '181132' },
    { value: 'balehar', label: 'Balehar', pincode: '181131' },
    { value: 'dhanna', label: 'Dhanna', pincode: '181132' },
    { value: 'gangyal', label: 'Gangyal', pincode: '181131' },
    { value: 'jarrwal', label: 'Jarrwal', pincode: '181131' },
    { value: 'kotli', label: 'Kotli', pincode: '181132' },
    { value: 'mangotrian', label: 'Mangotrian', pincode: '181131' },
    { value: 'newa', label: 'Newa', pincode: '181131' },
    { value: 'pachari', label: 'Pachari', pincode: '181131' },
    { value: 'pharma', label: 'Pharma', pincode: '181132' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '181131' },
    { value: 'sherpur', label: 'Sherpur', pincode: '181132' },
    { value: 'sogran', label: 'Sogran', pincode: '181132' },
    { value: 'tata', label: 'Tata', pincode: '181131' }
    ],
  
    'sopore': [
    { value: 'athwajan', label: 'Athwajan', pincode: '193201' },
    { value: 'chinkipora', label: 'Chinkipora', pincode: '193201' },
    { value: 'delina', label: 'Delina', pincode: '193201' },
    { value: 'gundbrath', label: 'Gundbrath', pincode: '193201' },
    { value: 'khanpora', label: 'Khanpora', pincode: '193201' },
    { value: 'linder', label: 'Linder', pincode: '193201' },
    { value: 'main-market', label: 'Main Market', pincode: '193201' },
    { value: 'mohalla-shahabad', label: 'Mohalla Shahabad', pincode: '193201' },
    { value: 'newa', label: 'Newa', pincode: '193201' },
    { value: 'palhalan', label: 'Palhalan', pincode: '193201' },
    { value: 'rafoo-pora', label: 'Rafoo Pora', pincode: '193201' },
    { value: 'sopore', label: 'Sopore', pincode: '193201' },
    { value: 'shahabad', label: 'Shahabad', pincode: '193201' },
    { value: 'takiya', label: 'Takiya', pincode: '193201' },
    { value: 'bagh-e-mazdoor', label: 'Bagh-e-Mazdoor', pincode: '193201' },
    { value: 'balhama', label: 'Balhama', pincode: '193201' },
    { value: 'bargam', label: 'Bargam', pincode: '193201' },
    { value: 'bragam', label: 'Bragam', pincode: '193201' },
    { value: 'chandilora', label: 'Chandilora', pincode: '193201' },
    { value: 'ganjipora', label: 'Ganjipora', pincode: '193201' },
    { value: 'hanjiwara', label: 'Hanjiwara', pincode: '193201' },
    { value: 'kanispora', label: 'Kanispora', pincode: '193201' },
    { value: 'kunduz', label: 'Kunduz', pincode: '193201' },
    { value: 'mohandpora', label: 'Mohandpora', pincode: '193201' },
    { value: 'nagbal', label: 'Nagbal', pincode: '193201' },
    { value: 'ramnagri', label: 'Ramnagri', pincode: '193201' },
    { value: 'sangrama', label: 'Sangrama', pincode: '193201' },
    { value: 'shujabad', label: 'Shujabad', pincode: '193201' },
    { value: 'vijaypur', label: 'Vijaypur', pincode: '193201' }
    ],
  
    'shopian': [
    { value: 'adigam', label: 'Adigam', pincode: '192303' },
    { value: 'aglar', label: 'Aglar', pincode: '192303' },
    { value: 'badriwan', label: 'Badriwan', pincode: '192303' },
    { value: 'blowgam', label: 'Blowgam', pincode: '192303' },
    { value: 'chatragam', label: 'Chatragam', pincode: '192303' },
    { value: 'choudryganj', label: 'Choudryganj', pincode: '192303' },
    { value: 'dandipora', label: 'Dandipora', pincode: '192303' },
    { value: 'herpora', label: 'Herpora', pincode: '192303' },
    { value: 'kakapora', label: 'Kakapora', pincode: '192303' },
    { value: 'kanipora', label: 'Kanipora', pincode: '192303' },
    { value: 'kaprin', label: 'Kaprin', pincode: '192303' },
    { value: 'mattan', label: 'Mattan', pincode: '192303' },
    { value: 'nehalpora', label: 'Nehalpora', pincode: '192303' },
    { value: 'shopian', label: 'Shopian', pincode: '192303' },
    { value: 'sugan', label: 'Sugan', pincode: '192303' },
    { value: 'zainapora', label: 'Zainapora', pincode: '192303' },
    { value: 'benipora', label: 'Benipora', pincode: '192303' },
    { value: 'chirpora', label: 'Chirpora', pincode: '192303' },
    { value: 'damhal', label: 'Damhal', pincode: '192303' },
    { value: 'kanan', label: 'Kanan', pincode: '192303' },
    { value: 'kuntwara', label: 'Kuntwara', pincode: '192303' },
    { value: 'narwani', label: 'Narwani', pincode: '192303' },
    { value: 'pahlipora', label: 'Pahlipora', pincode: '192303' },
    { value: 'sherpura', label: 'Sherpura', pincode: '192303' },
    { value: 'tukroo', label: 'Tukroo', pincode: '192303' },
    { value: 'wachi', label: 'Wachi', pincode: '192303' }
    ],
  
    'sumbal': [
    { value: 'alhama', label: 'Alhama', pincode: '193502' },
    { value: 'ashmuji', label: 'Ashmuji', pincode: '193502' },
    { value: 'bahrampora', label: 'Bahrampora', pincode: '193502' },
    { value: 'bandina', label: 'Bandina', pincode: '193502' },
    { value: 'bangil', label: 'Bangil', pincode: '193502' },
    { value: 'barzulla', label: 'Barzulla', pincode: '193502' },
    { value: 'bepora', label: 'Bepora', pincode: '193502' },
    { value: 'chakpora', label: 'Chakpora', pincode: '193502' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '193502' },
    { value: 'gundpora', label: 'Gundpora', pincode: '193502' },
    { value: 'herpora', label: 'Herpora', pincode: '193502' },
    { value: 'karewa', label: 'Karewa', pincode: '193502' },
    { value: 'khanpora', label: 'Khanpora', pincode: '193502' },
    { value: 'khampora', label: 'Khampora', pincode: '193502' },
    { value: 'malpora', label: 'Malpora', pincode: '193502' },
    { value: 'mohammadpora', label: 'Mohammadpora', pincode: '193502' },
    { value: 'newa', label: 'Newa', pincode: '193502' },
    { value: 'rakhpora', label: 'Rakhpora', pincode: '193502' },
    { value: 'sumbal', label: 'Sumbal', pincode: '193502' },
    { value: 'takipora', label: 'Takipora', pincode: '193502' },
    { value: 'zaloora', label: 'Zaloora', pincode: '193502' },
    { value: 'badrabad', label: 'Badrabad', pincode: '193502' },
    { value: 'dudran', label: 'Dudran', pincode: '193502' },
    { value: 'gagran', label: 'Gagran', pincode: '193502' },
    { value: 'pattan', label: 'Pattan', pincode: '193502' },
    { value: 'shahabad', label: 'Shahabad', pincode: '193502' }
    ],
    
    'sunderbani': [
    { value: 'bagla', label: 'Bagla', pincode: '182142' },
    { value: 'balka', label: 'Balka', pincode: '182142' },
    { value: 'bali', label: 'Bali', pincode: '182141' },
    { value: 'bhatta', label: 'Bhatta', pincode: '182142' },
    { value: 'gohar', label: 'Gohar', pincode: '182142' },
    { value: 'kishanpur', label: 'Kishanpur', pincode: '182142' },
    { value: 'louran', label: 'Louran', pincode: '182142' },
    { value: 'manwal', label: 'Manwal', pincode: '182142' },
    { value: 'narian', label: 'Narian', pincode: '182141' },
    { value: 'pind', label: 'Pind', pincode: '182142' },
    { value: 'rangpur', label: 'Rangpur', pincode: '182142' },
    { value: 'sahra', label: 'Sahra', pincode: '182142' },
    { value: 'sundarbani-town', label: 'Sunderbani Town', pincode: '182142' },
    { value: 'thub', label: 'Thub', pincode: '182142' },
    { value: 'vijaypur', label: 'Vijaypur', pincode: '182141' },
    { value: 'watergali', label: 'Watergali', pincode: '182142' }
    ],
  
    'surankote': [
    { value: 'anantnag', label: 'Anantnag', pincode: '185123' },
    { value: 'balakote', label: 'Balakote', pincode: '185153' },
    { value: 'bata', label: 'Bata', pincode: '185121' },
    { value: 'bhimber', label: 'Bhimber', pincode: '185121' },
    { value: 'burj', label: 'Burj', pincode: '185122' },
    { value: 'chatra', label: 'Chatra', pincode: '185123' },
    { value: 'gursai', label: 'Gursai', pincode: '185122' },
    { value: 'jhullas', label: 'Jhullas', pincode: '185152' },
    { value: 'kherakote', label: 'Kherakote', pincode: '185121' },
    { value: 'ladha', label: 'Ladha', pincode: '185121' },
    { value: 'lal-dhan', label: 'Lal Dhan', pincode: '185122' },
    { value: 'malkote', label: 'Malkote', pincode: '185153' },
    { value: 'manjakote', label: 'Manjakote', pincode: '185121' },
    { value: 'nar', label: 'Nar', pincode: '185121' },
    { value: 'punch-city', label: 'Punch City', pincode: '185101' },
    { value: 'sambal', label: 'Sambal', pincode: '185121' },
    { value: 'surankote-town', label: 'Surankote Town', pincode: '185121' },
    { value: 'tuli', label: 'Tuli', pincode: '185121' },
    { value: 'dhara', label: 'Dhara', pincode: '185122' },
    { value: 'nagrota', label: 'Nagrota', pincode: '185123' },
    { value: 'trikuta', label: 'Trikuta', pincode: '185124' }
    ],
    
    'tangdhar': [
    { value: 'badgaon', label: 'Badgaon', pincode: '193222' },
    { value: 'bachrian', label: 'Bachrian', pincode: '193222' },
    { value: 'dudran', label: 'Dudran', pincode: '193222' },
    { value: 'garkote', label: 'Garkote', pincode: '193222' },
    { value: 'gunner', label: 'Gunner', pincode: '193222' },
    { value: 'herjoo', label: 'Herjoo', pincode: '193222' },
    { value: 'jagran', label: 'Jagran', pincode: '193222' },
    { value: 'jandwal', label: 'Jandwal', pincode: '193222' },
    { value: 'kacha', label: 'Kacha', pincode: '193222' },
    { value: 'kunda', label: 'Kunda', pincode: '193222' },
    { value: 'mangnar', label: 'Mangnar', pincode: '193222' },
    { value: 'najar', label: 'Najar', pincode: '193222' },
    { value: 'pothi', label: 'Pothi', pincode: '193222' },
    { value: 'ragdhan', label: 'Ragdhan', pincode: '193222' },
    { value: 'sadoon', label: 'Sadoon', pincode: '193222' },
    { value: 'safapora', label: 'Safapora', pincode: '193222' },
    { value: 'shangus', label: 'Shangus', pincode: '193222' },
    { value: 'sungri', label: 'Sungri', pincode: '193222' },
    { value: 'tangdhar-town', label: 'Tangdhar Town', pincode: '193222' },
    { value: 'thiru', label: 'Thiru', pincode: '193222' },
    { value: 'udaypur', label: 'Udaypur', pincode: '193222' }
    ],
    
    'thanamandi': [
    { value: 'aristan', label: 'Aristan', pincode: '185212' },
    { value: 'bari-brahmana', label: 'Bari Brahmana', pincode: '185212' },
    { value: 'birwa', label: 'Birwa', pincode: '185212' },
    { value: 'challas', label: 'Challas', pincode: '185212' },
    { value: 'chak-mabbi', label: 'Chak Mabbi', pincode: '185212' },
    { value: 'chattar', label: 'Chattar', pincode: '185212' },
    { value: 'dhar', label: 'Dhar', pincode: '185212' },
    { value: 'gagrote', label: 'Gagrote', pincode: '185212' },
    { value: 'kandi', label: 'Kandi', pincode: '185212' },
    { value: 'khadwana', label: 'Khadwana', pincode: '185212' },
    { value: 'laddu', label: 'Laddu', pincode: '185212' },
    { value: 'malhani', label: 'Malhani', pincode: '185212' },
    { value: 'mandher', label: 'Mandher', pincode: '185212' },
    { value: 'nadhora', label: 'Nadhora', pincode: '185212' },
    { value: 'ranian', label: 'Ranian', pincode: '185212' },
    { value: 'salar', label: 'Salar', pincode: '185212' },
    { value: 'sangram', label: 'Sangram', pincode: '185212' },
    { value: 'thanamandi-town', label: 'Thanamandi Town', pincode: '185212' },
    { value: 'tuli', label: 'Tuli', pincode: '185212' },
    { value: 'udhari', label: 'Udhari', pincode: '185212' },
    { value: 'zainapora', label: 'Zainapora', pincode: '185212' }
    ],
    
    'tral': [
    { value: 'akhal', label: 'Akhal', pincode: '192123' },
    { value: 'aripal', label: 'Aripal', pincode: '192123' },
    { value: 'chakoora', label: 'Chakoora', pincode: '192123' },
    { value: 'chittergul', label: 'Chittergul', pincode: '192123' },
    { value: 'doru', label: 'Doru', pincode: '192123' },
    { value: 'kalampora', label: 'Kalampora', pincode: '192123' },
    { value: 'katriteng', label: 'Katriteng', pincode: '192123' },
    { value: 'koil', label: 'Koil', pincode: '192123' },
    { value: 'larnoo', label: 'Larnoo', pincode: '192123' },
    { value: 'magam', label: 'Magam', pincode: '192123' },
    { value: 'manzgam', label: 'Manzgam', pincode: '192123' },
    { value: 'midoora', label: 'Midoora', pincode: '192123' },
    { value: 'noorabad', label: 'Noorabad', pincode: '192123' },
    { value: 'ralpora', label: 'Ralpora', pincode: '192123' },
    { value: 'shikargah', label: 'Shikargah', pincode: '192123' },
    { value: 'thal', label: 'Thal', pincode: '192123' },
    { value: 'thalwen', label: 'Thalwen', pincode: '192123' },
    { value: 'tral-town', label: 'Tral Town', pincode: '192123' },
    { value: 'waghama', label: 'Waghama', pincode: '192123' },
    { value: 'zagran', label: 'Zagran', pincode: '192123' }
    ],
  
    'uri': [
    { value: 'aragam', label: 'Aragam', pincode: '193123' },
    { value: 'badshah', label: 'Badshah', pincode: '193123' },
    { value: 'chamwari', label: 'Chamwari', pincode: '193123' },
    { value: 'chotipura', label: 'Chotipura', pincode: '193123' },
    { value: 'dardpura', label: 'Dardpura', pincode: '193123' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '193123' },
    { value: 'jamma', label: 'Jamma', pincode: '193123' },
    { value: 'kiran', label: 'Kiran', pincode: '193123' },
    { value: 'kralpora', label: 'Kralpora', pincode: '193123' },
    { value: 'krishanpur', label: 'Krishanpur', pincode: '193123' },
    { value: 'miran', label: 'Miran', pincode: '193123' },
    { value: 'rawalpura', label: 'Rawalpura', pincode: '193123' },
    { value: 'uri-town', label: 'Uri Town', pincode: '193123' },
    { value: 'watnar', label: 'Watnar', pincode: '193123' },
    { value: 'zindshahi', label: 'Zindshahi', pincode: '193123' },
    { value: 'burj', label: 'Burj', pincode: '193123' },
    { value: 'chambla', label: 'Chambla', pincode: '193123' },
    { value: 'dachoo', label: 'Dachoo', pincode: '193123' },
    { value: 'hampora', label: 'Hampora', pincode: '193123' },
    { value: 'kushalpur', label: 'Kushalpur', pincode: '193123' },
    { value: 'nambla', label: 'Nambla', pincode: '193123' },
    { value: 'rawalakot', label: 'Rawalakot', pincode: '193123' },
    { value: 'shahidpura', label: 'Shahidpura', pincode: '193123' }
    ],
  
    'verinag': [
    { value: 'adipora', label: 'Adipora', pincode: '192215' },
    { value: 'bajwan', label: 'Bajwan', pincode: '192215' },
    { value: 'bithari', label: 'Bithari', pincode: '192215' },
    { value: 'chandpura', label: 'Chandpura', pincode: '192215' },
    { value: 'chatral', label: 'Chatral', pincode: '192215' },
    { value: 'gundi', label: 'Gundi', pincode: '192215' },
    { value: 'jagran', label: 'Jagran', pincode: '192215' },
    { value: 'kanad', label: 'Kanad', pincode: '192215' },
    { value: 'kashmirpura', label: 'Kashmirpura', pincode: '192215' },
    { value: 'khrewan', label: 'Khrewan', pincode: '192215' },
    { value: 'merhama', label: 'Merhama', pincode: '192215' },
    { value: 'munan', label: 'Munan', pincode: '192215' },
    { value: 'verinag-town', label: 'Verinag Town', pincode: '192215' },
    { value: 'zandpura', label: 'Zandpura', pincode: '192215' },
    { value: 'danwar', label: 'Danwar', pincode: '192215' },
    { value: 'goripora', label: 'Goripora', pincode: '192215' },
    { value: 'gundwara', label: 'Gundwara', pincode: '192215' },
    { value: 'khushipora', label: 'Khushipora', pincode: '192215' },
    { value: 'manzgam', label: 'Manzgam', pincode: '192215' },
    { value: 'nawapora', label: 'Nawapora', pincode: '192215' },
    { value: 'panjwan', label: 'Panjwan', pincode: '192215' },
    { value: 'sangam', label: 'Sangam', pincode: '192215' }
    ],
  
    'yaripora': [
    { value: 'aglar', label: 'Aglar', pincode: '192301' },
    { value: 'bhatpora', label: 'Bhatpora', pincode: '192301' },
    { value: 'chambi', label: 'Chambi', pincode: '192301' },
    { value: 'chowgam', label: 'Chowgam', pincode: '192301' },
    { value: 'gundipora', label: 'Gundipora', pincode: '192301' },
    { value: 'kangan', label: 'Kangan', pincode: '192301' },
    { value: 'kharpora', label: 'Kharpora', pincode: '192301' },
    { value: 'kulgam', label: 'Kulgam', pincode: '192301' },
    { value: 'lajoora', label: 'Lajoora', pincode: '192301' },
    { value: 'manzgam', label: 'Manzgam', pincode: '192301' },
    { value: 'panzgam', label: 'Panzgam', pincode: '192301' },
    { value: 'srigufwara', label: 'Srigufwara', pincode: '192301' },
    { value: 'yaripora-town', label: 'Yaripora Town', pincode: '192301' },
    { value: 'zainapora', label: 'Zainapora', pincode: '192301' },
    { value: 'chak-e-kulgam', label: 'Chak-e-Kulgam', pincode: '192301' },
    { value: 'dachhan', label: 'Dachhan', pincode: '192301' },
    { value: 'frisal', label: 'Frisal', pincode: '192301' },
    { value: 'khanbal', label: 'Khanbal', pincode: '192301' },
    { value: 'panthachowk', label: 'Panthachowk', pincode: '192301' },
    { value: 'rooftop', label: 'Rooftop', pincode: '192301' },
    { value: 'shamsabad', label: 'Shamsabad', pincode: '192301' },
    { value: 'village-pulwama', label: 'Village Pulwama', pincode: '192301' }
],

//Lakshadweep Areas

'amini': [
  { value: 'akkai', label: 'Akkai', pincode: '682551' },
  { value: 'agatti', label: 'Agatti', pincode: '682553' },
  { value: 'andrott', label: 'Andrott', pincode: '682552' },
  { value: 'bitra', label: 'Bitra', pincode: '682552' },
  { value: 'kadmat', label: 'Kadmat', pincode: '682554' },
  { value: 'kalapeni', label: 'Kalapeni', pincode: '682551' },
  { value: 'kavaratti', label: 'Kavaratti', pincode: '682555' },
  { value: 'minicoy', label: 'Minicoy', pincode: '682560' },
  { value: 'suheli', label: 'Suheli', pincode: '682562' },
  { value: 'parali', label: 'Parali', pincode: '682551' },
  { value: 'tinnakara', label: 'Tinnakara', pincode: '682560' },
  { value: 'viringili', label: 'Viringili', pincode: '682561' },
  { value: 'kiltan', label: 'Kiltan', pincode: '682554' },
  { value: 'chetlat', label: 'Chetlat', pincode: '682552' },
  { value: 'kudlahi', label: 'Kudlahi', pincode: '682552' },
  { value: 'thinnakara', label: 'Thinnakara', pincode: '682560' },
  { value: 'kalapeni', label: 'Kalapeni', pincode: '682551' },
  { value: 'chiriya', label: 'Chiriya', pincode: '682553' }
  ],
  
  'kavaratti': [
  { value: 'agatti', label: 'Agatti', pincode: '682553' },
  { value: 'akkai', label: 'Akkai', pincode: '682551' },
  { value: 'andrott', label: 'Andrott', pincode: '682552' },
  { value: 'bitra', label: 'Bitra', pincode: '682552' },
  { value: 'cadmat', label: 'Kadmat', pincode: '682554' },
  { value: 'chetlat', label: 'Chetlat', pincode: '682552' },
  { value: 'kalapeni', label: 'Kalapeni', pincode: '682551' },
  { value: 'kavaratti', label: 'Kavaratti', pincode: '682555' },
  { value: 'kilton', label: 'Kiltan', pincode: '682554' },
  { value: 'minicoy', label: 'Minicoy', pincode: '682560' },
  { value: 'parali', label: 'Parali', pincode: '682551' },
  { value: 'suheli', label: 'Suheli', pincode: '682562' },
  { value: 'tinnakara', label: 'Tinnakara', pincode: '682560' },
  { value: 'viringili', label: 'Viringili', pincode: '682561' },
  { value: 'agati', label: 'Agati', pincode: '682553' },
  { value: 'kalapeni-1', label: 'Kalapeni-1', pincode: '682551' },
  { value: 'kalapeni-2', label: 'Kalapeni-2', pincode: '682551' },
  { value: 'kudlahi', label: 'Kudlahi', pincode: '682552' },
  { value: 'andrat', label: 'Andrat', pincode: '682552' },
  { value: 'suhelith', label: 'Suhelith', pincode: '682563' }
  ],
  
  'minicoy': [
  { value: 'agatti', label: 'Agatti', pincode: '682553' },
  { value: 'akkai', label: 'Akkai', pincode: '682551' },
  { value: 'androt', label: 'Andrott', pincode: '682552' },
  { value: 'bitra', label: 'Bitra', pincode: '682552' },
  { value: 'cadmat', label: 'Kadmat', pincode: '682554' },
  { value: 'cheltat', label: 'Chetlat', pincode: '682552' },
  { value: 'kalapeni', label: 'Kalapeni', pincode: '682551' },
  { value: 'kilton', label: 'Kiltan', pincode: '682554' },
  { value: 'kavaratti', label: 'Kavaratti', pincode: '682555' },
  { value: 'minicoy', label: 'Minicoy', pincode: '682560' },
  { value: 'parali', label: 'Parali', pincode: '682551' },
  { value: 'suheli', label: 'Suheli', pincode: '682562' },
  { value: 'suhelith', label: 'Suhelith', pincode: '682563' },
  { value: 'tinnakara', label: 'Tinnakara', pincode: '682560' },
  { value: 'viringili', label: 'Viringili', pincode: '682561' },
  { value: 'kalapeni-1', label: 'Kalapeni-1', pincode: '682551' },
  { value: 'kalapeni-2', label: 'Kalapeni-2', pincode: '682551' },
  { value: 'tinnakara-island', label: 'Tinnakara Island', pincode: '682560' },
  { value: 'kilton-island', label: 'Kiltan Island', pincode: '682554' },
  { value: 'cheltat-island', label: 'Chetlat Island', pincode: '682552' },
  { value: 'parali-1', label: 'Parali-1', pincode: '682551' },
  { value: 'parali-2', label: 'Parali-2', pincode: '682551' }
  ],
  
  'minicoy-island': [
  { value: 'agatti', label: 'Agatti', pincode: '682553' },
  { value: 'akkai', label: 'Akkai', pincode: '682551' },
  { value: 'androt', label: 'Andrott', pincode: '682552' },
  { value: 'bitra', label: 'Bitra', pincode: '682552' },
  { value: 'cadmat', label: 'Kadmat', pincode: '682554' },
  { value: 'cheltat', label: 'Chetlat', pincode: '682552' },
  { value: 'kalapeni', label: 'Kalapeni', pincode: '682551' },
  { value: 'kilton', label: 'Kiltan', pincode: '682554' },
  { value: 'kavaratti', label: 'Kavaratti', pincode: '682555' },
  { value: 'minicoy', label: 'Minicoy', pincode: '682560' },
  { value: 'parali', label: 'Parali', pincode: '682551' },
  { value: 'suheli', label: 'Suheli', pincode: '682562' },
  { value: 'suhelith', label: 'Suhelith', pincode: '682563' },
  { value: 'tinnakara', label: 'Tinnakara', pincode: '682560' },
  { value: 'viringili', label: 'Viringili', pincode: '682561' },
  { value: 'minicoy-east', label: 'Minicoy East', pincode: '682560' },
  { value: 'minicoy-west', label: 'Minicoy West', pincode: '682560' },
  { value: 'minicoy-north', label: 'Minicoy North', pincode: '682560' },
  { value: 'minicoy-south', label: 'Minicoy South', pincode: '682560' },
  { value: 'minicoy-central', label: 'Minicoy Central', pincode: '682560' },
  { value: 'minicoy-harbour', label: 'Minicoy Harbour', pincode: '682560' },
  { value: 'minicoy-east-end', label: 'Minicoy East End', pincode: '682560' },
  { value: 'minicoy-west-end', label: 'Minicoy West End', pincode: '682560' },
  { value: 'minicoy-archipelago', label: 'Minicoy Archipelago', pincode: '682560' },
  { value: 'minicoy-sandbar', label: 'Minicoy Sandbar', pincode: '682560' }
  ],
//sikkim areas

'assangthang': [
  { value: 'bhangdara', label: 'Bhangdara', pincode: '500101' },
  { value: 'chep-dhuri', label: 'Chep Dhuri', pincode: '500102' },
  { value: 'chili-kala', label: 'Chili Kala', pincode: '500103' },
  { value: 'dhanwat', label: 'Dhanwat', pincode: '500104' },
  { value: 'gokul-pura', label: 'Gokul Pura', pincode: '500105' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kali-chowk', label: 'Kali Chowk', pincode: '500106' },
  { value: 'kheman-dhara', label: 'Kheman Dhara', pincode: '500107' },
  { value: 'maruti-nagar', label: 'Maruti Nagar', pincode: '500108' },
  { value: 'rajpura', label: 'Rajpura', pincode: '500109' },
  { value: 'sachin-pur', label: 'Sachin Pur', pincode: '500110' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '500111' },
  { value: 'sarai-kala', label: 'Sarai Kala', pincode: '500112' },
  { value: 'shiv-nagar', label: 'Shiv Nagar', pincode: '500113' },
  { value: 'shree-puri', label: 'Shree Puri', pincode: '500114' },
  { value: 'tata-basti', label: 'Tata Basti', pincode: '500115' },
  { value: 'united-colony', label: 'United Colony', pincode: '500116' },
  { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '500117' },
  { value: 'victory-puram', label: 'Victory Puram', pincode: '500118' },
  { value: 'zindabad', label: 'Zindabad', pincode: '500119' },
  { value: 'jagat-nagar', label: 'Jagat Nagar', pincode: '500120' },
  { value: 'kamal-vihar', label: 'Kamal Vihar', pincode: '500121' },
  { value: 'krishna-puram', label: 'Krishna Puram', pincode: '500122' }
  ],

  'barnyak': [
  { value: 'aashirwad-nagar', label: 'Aashirwad Nagar', pincode: '500201' },
  { value: 'balaji-pura', label: 'Balaji Pura', pincode: '500202' },
  { value: 'bhanpura', label: 'Bhanpura', pincode: '500203' },
  { value: 'chak-bazaar', label: 'Chak Bazaar', pincode: '500204' },
  { value: 'dholia', label: 'Dholia', pincode: '500205' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jagdish-nagar', label: 'Jagdish Nagar', pincode: '500206' },
  { value: 'kamalgarh', label: 'Kamalgarh', pincode: '500207' },
  { value: 'kesar-bagh', label: 'Kesar Bagh', pincode: '500208' },
  { value: 'manohar-pura', label: 'Manohar Pura', pincode: '500209' },
  { value: 'puranpura', label: 'Puranpura', pincode: '500210' },
  { value: 'rajesh-nagar', label: 'Rajesh Nagar', pincode: '500211' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '500212' },
  { value: 'sangam-vihar', label: 'Sangam Vihar', pincode: '500213' },
  { value: 'shree-nagar', label: 'Shree Nagar', pincode: '500214' },
  { value: 'vishwakarma', label: 'Vishwakarma', pincode: '500215' },
  { value: 'united-colony', label: 'United Colony', pincode: '500216' },
  { value: 'victory-nagar', label: 'Victory Nagar', pincode: '500217' },
  { value: 'zindabad-basti', label: 'Zindabad Basti', pincode: '500218' },
  { value: 'jagat-vihar', label: 'Jagat Vihar', pincode: '500219' },
  { value: 'kamal-pur', label: 'Kamal Pur', pincode: '500220' },
  { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '500221' },
  { value: 'pragati-nagar', label: 'Pragati Nagar', pincode: '500222' },
  { value: 'suraj-puram', label: 'Suraj Puram', pincode: '500223' }
  ],

  'darap': [
  { value: 'aditya-nagar', label: 'Aditya Nagar', pincode: '500301' },
  { value: 'balaji-pura', label: 'Balaji Pura', pincode: '500302' },
  { value: 'bhanpura', label: 'Bhanpura', pincode: '500303' },
  { value: 'chak-bazaar', label: 'Chak Bazaar', pincode: '500304' },
  { value: 'dholia', label: 'Dholia', pincode: '500305' },
  { value: 'darap-bazaar', label: 'Darap Bazaar', pincode: '500306' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jagdish-nagar', label: 'Jagdish Nagar', pincode: '500307' },
  { value: 'kamalgarh', label: 'Kamalgarh', pincode: '500308' },
  { value: 'kesar-bagh', label: 'Kesar Bagh', pincode: '500309' },
  { value: 'manohar-pura', label: 'Manohar Pura', pincode: '500310' },
  { value: 'puranpura', label: 'Puranpura', pincode: '500311' },
  { value: 'rajesh-nagar', label: 'Rajesh Nagar', pincode: '500312' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '500313' },
  { value: 'sangam-vihar', label: 'Sangam Vihar', pincode: '500314' },
  { value: 'shree-nagar', label: 'Shree Nagar', pincode: '500315' },
  { value: 'vishwakarma', label: 'Vishwakarma', pincode: '500316' },
  { value: 'united-colony', label: 'United Colony', pincode: '500317' },
  { value: 'victory-nagar', label: 'Victory Nagar', pincode: '500318' },
  { value: 'zindabad-basti', label: 'Zindabad Basti', pincode: '500319' },
  { value: 'jagat-vihar', label: 'Jagat Vihar', pincode: '500320' },
  { value: 'kamal-pur', label: 'Kamal Pur', pincode: '500321' },
  { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '500322' },
  { value: 'lalita-nagar', label: 'Lalita Nagar', pincode: '500323' },
  { value: 'mahanagar', label: 'Mahanagar', pincode: '500324' },
  { value: 'new-town', label: 'New Town', pincode: '500325' },
  { value: 'parvati-pura', label: 'Parvati Pura', pincode: '500326' },
  { value: 'ram-vihar', label: 'Ram Vihar', pincode: '500327' },
  { value: 'shankar-nagar', label: 'Shankar Nagar', pincode: '500328' },
  { value: 'tulsi-nagar', label: 'Tulsi Nagar', pincode: '500329' }
  ],

  'gangtok': [
  { value: 'adanthang', label: 'Adanthang', pincode: '737101' },
  { value: 'bakhim', label: 'Bakhim', pincode: '737102' },
  { value: 'chinang', label: 'Chinang', pincode: '737103' },
  { value: 'deorali', label: 'Deorali', pincode: '737104' },
  { value: 'gangtok-bazar', label: 'Gangtok Bazar', pincode: '737105' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kazi-road', label: 'Kazi Road', pincode: '737106' },
  { value: 'lampokhari', label: 'Lampokhari', pincode: '737107' },
  { value: 'lingtam', label: 'Lingtam', pincode: '737108' },
  { value: 'martam', label: 'Martam', pincode: '737109' },
  { value: 'naya-bazar', label: 'Naya Bazar', pincode: '737110' },
  { value: 'pakyong', label: 'Pakyong', pincode: '737111' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '737112' },
  { value: 'tadong', label: 'Tadong', pincode: '737113' },
  { value: 'tintin', label: 'Tintin', pincode: '737114' },
  { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '737115' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737116' },
  { value: 'barapathar', label: 'Barapathar', pincode: '737117' },
  { value: 'changu-lake', label: 'Changu Lake', pincode: '737118' },
  { value: 'khamdong', label: 'Khamdong', pincode: '737119' },
  { value: 'lamahatta', label: 'Lamahatta', pincode: '737120' },
  { value: 'martam-chowk', label: 'Martam Chowk', pincode: '737121' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737122' },
  { value: 'sikkim-nagar', label: 'Sikkim Nagar', pincode: '737123' },
  { value: 'tumin', label: 'Tumin', pincode: '737124' },
  { value: 'west-penlong', label: 'West Penlong', pincode: '737125' }
  ],

  'gyalshing': [
  { value: 'adampool', label: 'Adampool', pincode: '737201' },
  { value: 'barmey', label: 'Barmey', pincode: '737202' },
  { value: 'churung', label: 'Churung', pincode: '737203' },
  { value: 'deothang', label: 'Deothang', pincode: '737204' },
  { value: 'dong', label: 'Dong', pincode: '737205' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karma', label: 'Karma', pincode: '737206' },
  { value: 'khasmahal', label: 'Khasmahal', pincode: '737207' },
  { value: 'lungchok', label: 'Lungchok', pincode: '737208' },
  { value: 'nyersang', label: 'Nyersang', pincode: '737209' },
  { value: 'rangang', label: 'Rangang', pincode: '737210' },
  { value: 'serduk', label: 'Serduk', pincode: '737211' },
  { value: 'siktam', label: 'Siktam', pincode: '737212' },
  { value: 'soreng', label: 'Soreng', pincode: '737213' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737214' },
  { value: 'tokal', label: 'Tokal', pincode: '737215' },
  { value: 'yangyang', label: 'Yangyang', pincode: '737216' },
  { value: 'chewa-bazar', label: 'Chewa Bazar', pincode: '737217' },
  { value: 'lungthung', label: 'Lungthung', pincode: '737218' },
  { value: 'mangten', label: 'Mangten', pincode: '737219' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737220' },
  { value: 'phoktey', label: 'Phoktey', pincode: '737221' },
  { value: 'tamluk', label: 'Tamluk', pincode: '737222' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737223' },
  { value: 'damthang', label: 'Damthang', pincode: '737224' }
  ],

  'jorethang': [
  { value: 'adampool', label: 'Adampool', pincode: '737301' },
  { value: 'barmey', label: 'Barmey', pincode: '737302' },
  { value: 'churung', label: 'Churung', pincode: '737303' },
  { value: 'deothang', label: 'Deothang', pincode: '737304' },
  { value: 'dong', label: 'Dong', pincode: '737305' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karma', label: 'Karma', pincode: '737306' },
  { value: 'khasmahal', label: 'Khasmahal', pincode: '737307' },
  { value: 'lungchok', label: 'Lungchok', pincode: '737308' },
  { value: 'nyersang', label: 'Nyersang', pincode: '737309' },
  { value: 'rangang', label: 'Rangang', pincode: '737310' },
  { value: 'serduk', label: 'Serduk', pincode: '737311' },
  { value: 'siktam', label: 'Siktam', pincode: '737312' },
  { value: 'soreng', label: 'Soreng', pincode: '737313' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737314' },
  { value: 'tokal', label: 'Tokal', pincode: '737315' },
  { value: 'yangyang', label: 'Yangyang', pincode: '737316' },
  { value: 'chewa-bazar', label: 'Chewa Bazar', pincode: '737317' },
  { value: 'lungthung', label: 'Lungthung', pincode: '737318' },
  { value: 'mangten', label: 'Mangten', pincode: '737319' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737320' },
  { value: 'phoktey', label: 'Phoktey', pincode: '737321' },
  { value: 'tamluk', label: 'Tamluk', pincode: '737322' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737323' },
  { value: 'damthang', label: 'Damthang', pincode: '737324' },
  { value: 'salley', label: 'Salley', pincode: '737325' },
  { value: 'sirwani', label: 'Sirwani', pincode: '737326' },
  { value: 'tista', label: 'Tista', pincode: '737327' },
  { value: 'pangthang', label: 'Pangthang', pincode: '737328' },
  { value: 'rimbi', label: 'Rimbi', pincode: '737329' },
  { value: 'yangte', label: 'Yangte', pincode: '737330' }
  ],

  'khamdong': [
  { value: 'adampool', label: 'Adampool', pincode: '737401' },
  { value: 'barmey', label: 'Barmey', pincode: '737402' },
  { value: 'churung', label: 'Churung', pincode: '737403' },
  { value: 'deothang', label: 'Deothang', pincode: '737404' },
  { value: 'dong', label: 'Dong', pincode: '737405' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karma', label: 'Karma', pincode: '737406' },
  { value: 'khasmahal', label: 'Khasmahal', pincode: '737407' },
  { value: 'lungchok', label: 'Lungchok', pincode: '737408' },
  { value: 'nyersang', label: 'Nyersang', pincode: '737409' },
  { value: 'rangang', label: 'Rangang', pincode: '737410' },
  { value: 'serduk', label: 'Serduk', pincode: '737411' },
  { value: 'siktam', label: 'Siktam', pincode: '737412' },
  { value: 'soreng', label: 'Soreng', pincode: '737413' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737414' },
  { value: 'tokal', label: 'Tokal', pincode: '737415' },
  { value: 'yangyang', label: 'Yangyang', pincode: '737416' },
  { value: 'chewa-bazar', label: 'Chewa Bazar', pincode: '737417' },
  { value: 'lungthung', label: 'Lungthung', pincode: '737418' },
  { value: 'mangten', label: 'Mangten', pincode: '737419' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737420' },
  { value: 'phoktey', label: 'Phoktey', pincode: '737421' },
  { value: 'tamluk', label: 'Tamluk', pincode: '737422' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737423' },
  { value: 'damthang', label: 'Damthang', pincode: '737424' },
  { value: 'gairi', label: 'Gairi', pincode: '737425' },
  { value: 'kalijhora', label: 'Kalijhora', pincode: '737426' },
  { value: 'kashyampong', label: 'Kashyampong', pincode: '737427' },
  { value: 'lamahatta', label: 'Lamahatta', pincode: '737428' },
  { value: 'lingtam', label: 'Lingtam', pincode: '737429' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737430' },
  { value: 'phurba', label: 'Phurba', pincode: '737431' },
  { value: 'sindong', label: 'Sindong', pincode: '737432' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737433' }
  ],

  'lachung': [
  { value: 'adampool', label: 'Adampool', pincode: '737501' },
  { value: 'barmey', label: 'Barmey', pincode: '737502' },
  { value: 'churung', label: 'Churung', pincode: '737503' },
  { value: 'deothang', label: 'Deothang', pincode: '737504' },
  { value: 'dong', label: 'Dong', pincode: '737505' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karma', label: 'Karma', pincode: '737506' },
  { value: 'khasmahal', label: 'Khasmahal', pincode: '737507' },
  { value: 'lungchok', label: 'Lungchok', pincode: '737508' },
  { value: 'nyersang', label: 'Nyersang', pincode: '737509' },
  { value: 'rangang', label: 'Rangang', pincode: '737510' },
  { value: 'serduk', label: 'Serduk', pincode: '737511' },
  { value: 'siktam', label: 'Siktam', pincode: '737512' },
  { value: 'soreng', label: 'Soreng', pincode: '737513' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737514' },
  { value: 'tokal', label: 'Tokal', pincode: '737515' },
  { value: 'yangyang', label: 'Yangyang', pincode: '737516' },
  { value: 'chewa-bazar', label: 'Chewa Bazar', pincode: '737517' },
  { value: 'lungthung', label: 'Lungthung', pincode: '737518' },
  { value: 'mangten', label: 'Mangten', pincode: '737519' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737520' },
  { value: 'phoktey', label: 'Phoktey', pincode: '737521' },
  { value: 'tamluk', label: 'Tamluk', pincode: '737522' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737523' },
  { value: 'damthang', label: 'Damthang', pincode: '737524' },
  { value: 'gairi', label: 'Gairi', pincode: '737525' },
  { value: 'kalijhora', label: 'Kalijhora', pincode: '737526' },
  { value: 'kashyampong', label: 'Kashyampong', pincode: '737527' },
  { value: 'lamahatta', label: 'Lamahatta', pincode: '737528' },
  { value: 'lingtam', label: 'Lingtam', pincode: '737529' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737530' },
  { value: 'phurba', label: 'Phurba', pincode: '737531' },
  { value: 'sindong', label: 'Sindong', pincode: '737532' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737533' },
  { value: 'kandey', label: 'Kandey', pincode: '737534' },
  { value: 'lamaten', label: 'Lamaten', pincode: '737535' },
  { value: 'yumesamdong', label: 'Yumesamdong', pincode: '737536' },
  { value: 'lachen', label: 'Lachen', pincode: '737537' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '737538' },
  { value: 'chungthang', label: 'Chungthang', pincode: '737539' },
  { value: 'chongri', label: 'Chongri', pincode: '737540' }
  ],

  'mangan': [
  { value: 'adampool', label: 'Adampool', pincode: '737601' },
  { value: 'barmey', label: 'Barmey', pincode: '737602' },
  { value: 'churung', label: 'Churung', pincode: '737603' },
  { value: 'deothang', label: 'Deothang', pincode: '737604' },
  { value: 'dong', label: 'Dong', pincode: '737605' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karma', label: 'Karma', pincode: '737606' },
  { value: 'khasmahal', label: 'Khasmahal', pincode: '737607' },
  { value: 'lungchok', label: 'Lungchok', pincode: '737608' },
  { value: 'nyersang', label: 'Nyersang', pincode: '737609' },
  { value: 'rangang', label: 'Rangang', pincode: '737610' },
  { value: 'serduk', label: 'Serduk', pincode: '737611' },
  { value: 'siktam', label: 'Siktam', pincode: '737612' },
  { value: 'soreng', label: 'Soreng', pincode: '737613' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737614' },
  { value: 'tokal', label: 'Tokal', pincode: '737615' },
  { value: 'yangyang', label: 'Yangyang', pincode: '737616' },
  { value: 'chewa-bazar', label: 'Chewa Bazar', pincode: '737617' },
  { value: 'lungthung', label: 'Lungthung', pincode: '737618' },
  { value: 'mangten', label: 'Mangten', pincode: '737619' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737620' },
  { value: 'phoktey', label: 'Phoktey', pincode: '737621' },
  { value: 'tamluk', label: 'Tamluk', pincode: '737622' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737623' },
  { value: 'damthang', label: 'Damthang', pincode: '737624' },
  { value: 'gairi', label: 'Gairi', pincode: '737625' },
  { value: 'kalijhora', label: 'Kalijhora', pincode: '737626' },
  { value: 'kashyampong', label: 'Kashyampong', pincode: '737627' },
  { value: 'lamahatta', label: 'Lamahatta', pincode: '737628' },
  { value: 'lingtam', label: 'Lingtam', pincode: '737629' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737630' },
  { value: 'phurba', label: 'Phurba', pincode: '737631' },
  { value: 'sindong', label: 'Sindong', pincode: '737632' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737633' },
  { value: 'kandey', label: 'Kandey', pincode: '737634' },
  { value: 'lamaten', label: 'Lamaten', pincode: '737635' },
  { value: 'yumesamdong', label: 'Yumesamdong', pincode: '737636' },
  { value: 'lachen', label: 'Lachen', pincode: '737637' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '737638' },
  { value: 'chungthang', label: 'Chungthang', pincode: '737639' },
  { value: 'chongri', label: 'Chongri', pincode: '737640' },
  { value: 'bharapathar', label: 'Bharapathar', pincode: '737641' },
  { value: 'berakhola', label: 'Berakhola', pincode: '737642' },
  { value: 'dohara', label: 'Dohara', pincode: '737643' },
  { value: 'sarpang', label: 'Sarpang', pincode: '737644' },
  { value: 'zongu', label: 'Zongu', pincode: '737645' },
  { value: 'sindher', label: 'Sindher', pincode: '737646' },
  { value: 'menbrong', label: 'Menbrong', pincode: '737647' },
  { value: 'apchoo', label: 'Apchoo', pincode: '737648' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737649' }
  ],

  'namchi': [
  { value: 'adampool', label: 'Adampool', pincode: '737601' },
  { value: 'barmey', label: 'Barmey', pincode: '737602' },
  { value: 'churung', label: 'Churung', pincode: '737603' },
  { value: 'deothang', label: 'Deothang', pincode: '737604' },
  { value: 'dong', label: 'Dong', pincode: '737605' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karma', label: 'Karma', pincode: '737606' },
  { value: 'khasmahal', label: 'Khasmahal', pincode: '737607' },
  { value: 'lungchok', label: 'Lungchok', pincode: '737608' },
  { value: 'nyersang', label: 'Nyersang', pincode: '737609' },
  { value: 'rangang', label: 'Rangang', pincode: '737610' },
  { value: 'serduk', label: 'Serduk', pincode: '737611' },
  { value: 'siktam', label: 'Siktam', pincode: '737612' },
  { value: 'soreng', label: 'Soreng', pincode: '737613' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737614' },
  { value: 'tokal', label: 'Tokal', pincode: '737615' },
  { value: 'yangyang', label: 'Yangyang', pincode: '737616' },
  { value: 'chewa-bazar', label: 'Chewa Bazar', pincode: '737617' },
  { value: 'lungthung', label: 'Lungthung', pincode: '737618' },
  { value: 'mangten', label: 'Mangten', pincode: '737619' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737620' },
  { value: 'phoktey', label: 'Phoktey', pincode: '737621' },
  { value: 'tamluk', label: 'Tamluk', pincode: '737622' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737623' },
  { value: 'damthang', label: 'Damthang', pincode: '737624' },
  { value: 'gairi', label: 'Gairi', pincode: '737625' },
  { value: 'kalijhora', label: 'Kalijhora', pincode: '737626' },
  { value: 'kashyampong', label: 'Kashyampong', pincode: '737627' },
  { value: 'lamahatta', label: 'Lamahatta', pincode: '737628' },
  { value: 'lingtam', label: 'Lingtam', pincode: '737629' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737630' },
  { value: 'phurba', label: 'Phurba', pincode: '737631' },
  { value: 'sindong', label: 'Sindong', pincode: '737632' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737633' },
  { value: 'kandey', label: 'Kandey', pincode: '737634' },
  { value: 'lamaten', label: 'Lamaten', pincode: '737635' },
  { value: 'yumesamdong', label: 'Yumesamdong', pincode: '737636' },
  { value: 'lachen', label: 'Lachen', pincode: '737637' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '737638' },
  { value: 'chungthang', label: 'Chungthang', pincode: '737639' },
  { value: 'chongri', label: 'Chongri', pincode: '737640' },
  { value: 'bharapathar', label: 'Bharapathar', pincode: '737641' },
  { value: 'berakhola', label: 'Berakhola', pincode: '737642' },
  { value: 'dohara', label: 'Dohara', pincode: '737643' },
  { value: 'sarpang', label: 'Sarpang', pincode: '737644' },
  { value: 'zongu', label: 'Zongu', pincode: '737645' },
  { value: 'sindher', label: 'Sindher', pincode: '737646' },
  { value: 'menbrong', label: 'Menbrong', pincode: '737647' },
  { value: 'apchoo', label: 'Apchoo', pincode: '737648' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737649' },
  { value: 'fokar', label: 'Fokar', pincode: '737650' },
  { value: 'tadong', label: 'Tadong', pincode: '737651' },
  { value: 'rimbi', label: 'Rimbi', pincode: '737652' },
  { value: 'yangang', label: 'Yangang', pincode: '737653' },
  { value: 'temi', label: 'Temi', pincode: '737654' },
  { value: 'kulung', label: 'Kulung', pincode: '737655' },
  { value: 'zongling', label: 'Zongling', pincode: '737656' },
  { value: 'khamdong', label: 'Khamdong', pincode: '737657' },
  { value: 'namthang', label: 'Namthang', pincode: '737658' },
  { value: 'rayong', label: 'Rayong', pincode: '737659' }
  ],

  'pakyong': [
  { value: 'adampool', label: 'Adampool', pincode: '737601' },
  { value: 'barmey', label: 'Barmey', pincode: '737602' },
  { value: 'churung', label: 'Churung', pincode: '737603' },
  { value: 'deothang', label: 'Deothang', pincode: '737604' },
  { value: 'dong', label: 'Dong', pincode: '737605' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karma', label: 'Karma', pincode: '737606' },
  { value: 'khasmahal', label: 'Khasmahal', pincode: '737607' },
  { value: 'lungchok', label: 'Lungchok', pincode: '737608' },
  { value: 'nyersang', label: 'Nyersang', pincode: '737609' },
  { value: 'rangang', label: 'Rangang', pincode: '737610' },
  { value: 'serduk', label: 'Serduk', pincode: '737611' },
  { value: 'siktam', label: 'Siktam', pincode: '737612' },
  { value: 'soreng', label: 'Soreng', pincode: '737613' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737614' },
  { value: 'tokal', label: 'Tokal', pincode: '737615' },
  { value: 'yangyang', label: 'Yangyang', pincode: '737616' },
  { value: 'chewa-bazar', label: 'Chewa Bazar', pincode: '737617' },
  { value: 'lungthung', label: 'Lungthung', pincode: '737618' },
  { value: 'mangten', label: 'Mangten', pincode: '737619' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737620' },
  { value: 'phoktey', label: 'Phoktey', pincode: '737621' },
  { value: 'tamluk', label: 'Tamluk', pincode: '737622' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737623' },
  { value: 'damthang', label: 'Damthang', pincode: '737624' },
  { value: 'gairi', label: 'Gairi', pincode: '737625' },
  { value: 'kalijhora', label: 'Kalijhora', pincode: '737626' },
  { value: 'kashyampong', label: 'Kashyampong', pincode: '737627' },
  { value: 'lamahatta', label: 'Lamahatta', pincode: '737628' },
  { value: 'lingtam', label: 'Lingtam', pincode: '737629' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737630' },
  { value: 'phurba', label: 'Phurba', pincode: '737631' },
  { value: 'sindong', label: 'Sindong', pincode: '737632' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737633' },
  { value: 'kandey', label: 'Kandey', pincode: '737634' },
  { value: 'lamaten', label: 'Lamaten', pincode: '737635' },
  { value: 'yumesamdong', label: 'Yumesamdong', pincode: '737636' },
  { value: 'lachen', label: 'Lachen', pincode: '737637' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '737638' },
  { value: 'chungthang', label: 'Chungthang', pincode: '737639' },
  { value: 'chongri', label: 'Chongri', pincode: '737640' },
  { value: 'bharapathar', label: 'Bharapathar', pincode: '737641' },
  { value: 'berakhola', label: 'Berakhola', pincode: '737642' },
  { value: 'dohara', label: 'Dohara', pincode: '737643' },
  { value: 'sarpang', label: 'Sarpang', pincode: '737644' },
  { value: 'zongu', label: 'Zongu', pincode: '737645' },
  { value: 'sindher', label: 'Sindher', pincode: '737646' },
  { value: 'menbrong', label: 'Menbrong', pincode: '737647' },
  { value: 'apchoo', label: 'Apchoo', pincode: '737648' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737649' },
  { value: 'fokar', label: 'Fokar', pincode: '737650' },
  { value: 'tadong', label: 'Tadong', pincode: '737651' },
  { value: 'rimbi', label: 'Rimbi', pincode: '737652' },
  { value: 'yangang', label: 'Yangang', pincode: '737653' },
  { value: 'temi', label: 'Temi', pincode: '737654' },
  { value: 'kulung', label: 'Kulung', pincode: '737655' },
  { value: 'zongling', label: 'Zongling', pincode: '737656' },
  { value: 'khamdong', label: 'Khamdong', pincode: '737657' },
  { value: 'namthang', label: 'Namthang', pincode: '737658' },
  { value: 'rayong', label: 'Rayong', pincode: '737659' },
  { value: 'chew-bazar', label: 'Chew Bazar', pincode: '737660' },
  { value: 'danta', label: 'Danta', pincode: '737661' },
  { value: 'kalapathar-bazar', label: 'Kalapathar Bazar', pincode: '737662' },
  { value: 'tilkam', label: 'Tilkam', pincode: '737663' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737664' },
  { value: 'siksila', label: 'Siksila', pincode: '737665' }
  ],

  'pelling': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'barfok', label: 'Barfok', pincode: '737612' },
  { value: 'chongri', label: 'Chongri', pincode: '737613' },
  { value: 'deorali', label: 'Deorali', pincode: '737614' },
  { value: 'fedong', label: 'Fedong', pincode: '737615' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737616' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737617' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737618' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737619' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737620' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737621' },
  { value: 'soreng', label: 'Soreng', pincode: '737622' },
  { value: 'temi', label: 'Temi', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737624' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737625' },
  { value: 'arithang', label: 'Arithang', pincode: '737626' },
  { value: 'sangha', label: 'Sangha', pincode: '737627' },
  { value: 'rimbi', label: 'Rimbi', pincode: '737628' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737629' },
  { value: 'chumbong', label: 'Chumbong', pincode: '737630' },
  { value: 'namchi', label: 'Namchi', pincode: '737631' },
  { value: 'sindong', label: 'Sindong', pincode: '737632' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737633' },
  { value: 'nyukthang', label: 'Nyukthang', pincode: '737634' },
  { value: 'lingchom', label: 'Lingchom', pincode: '737635' },
  { value: 'phurba', label: 'Phurba', pincode: '737636' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737637' },
  { value: 'mae', label: 'Mae', pincode: '737638' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737639' }
  ],

  'ravangla': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongthang', label: 'Bongthang', pincode: '737612' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737613' },
  { value: 'fedong', label: 'Fedong', pincode: '737614' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737615' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737629' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737628' },
  { value: 'sikay', label: 'Sikay', pincode: '737625' },
  { value: 'soreng', label: 'Soreng', pincode: '737621' },
  { value: 'temi', label: 'Temi', pincode: '737622' },
  { value: 'tadong', label: 'Tadong', pincode: '737623' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737627' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737624' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737630' },
  { value: 'sindong', label: 'Sindong', pincode: '737631' },
  { value: 'namchi', label: 'Namchi', pincode: '737632' },
  { value: 'chew-bazar', label: 'Chew Bazar', pincode: '737633' },
  { value: 'temi-bazar', label: 'Temi Bazar', pincode: '737634' }
  ],

  'rhenak': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'soreng', label: 'Soreng', pincode: '737623' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'chew-bazar', label: 'Chew Bazar', pincode: '737630' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' }
  ],

  'singtam': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'soreng', label: 'Soreng', pincode: '737623' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'chew-bazar', label: 'Chew Bazar', pincode: '737630' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'bothey', label: 'Bothey', pincode: '737639' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' }
  ],

  'soreng': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'bothey', label: 'Bothey', pincode: '737639' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' }
  ],

  'geyzing': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'bothey', label: 'Bothey', pincode: '737639' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'chew-bazar', label: 'Chew Bazar', pincode: '737630' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' }
  ],

  'rangpo': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'bothey', label: 'Bothey', pincode: '737639' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'chew-bazar', label: 'Chew Bazar', pincode: '737630' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'ap-danr', label: 'Ap-Danr', pincode: '737642' },
  { value: 'dungra', label: 'Dungra', pincode: '737643' },
  { value: 'lallum', label: 'Lallum', pincode: '737644' },
  { value: 'tendong', label: 'Tendong', pincode: '737645' }
  ],

  'upper-tadong': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'bothey', label: 'Bothey', pincode: '737639' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'chew-bazar', label: 'Chew Bazar', pincode: '737630' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'upper-tadong', label: 'Upper Tadong', pincode: '737645' },
  { value: 'ap-bazar', label: 'Ap Bazar', pincode: '737646' },
  { value: 'changu', label: 'Changu', pincode: '737647' },
  { value: 'lallum', label: 'Lallum', pincode: '737648' },
  { value: 'sikkim-bazar', label: 'Sikkim Bazar', pincode: '737649' }
  ],

  'nayabazar': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'bothey', label: 'Bothey', pincode: '737639' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'chew-bazar', label: 'Chew Bazar', pincode: '737630' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'nayabazar', label: 'Nayabazar', pincode: '737646' },
  { value: 'barmeli', label: 'Barmeli', pincode: '737650' },
  { value: 'sherdup', label: 'Sherdup', pincode: '737651' },
  { value: 'dara-bazar', label: 'Dara Bazar', pincode: '737652' },
  { value: 'kundang', label: 'Kundang', pincode: '737653' },
  { value: 'mankhim', label: 'Mankhim', pincode: '737654' }
  ],

  'rhenock': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'bothey', label: 'Bothey', pincode: '737639' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'chew-bazar', label: 'Chew Bazar', pincode: '737630' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'rhenock', label: 'Rhenock', pincode: '737645' },
  { value: 'chadey', label: 'Chadey', pincode: '737646' },
  { value: 'gajing', label: 'Gajing', pincode: '737647' },
  { value: 'khobong', label: 'Khobong', pincode: '737648' },
  { value: 'makha', label: 'Makha', pincode: '737649' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737650' },
  { value: 'yuksom-bazar', label: 'Yuksom Bazar', pincode: '737651' }
  ],

  'phodong': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'bothey', label: 'Bothey', pincode: '737639' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'phodong', label: 'Phodong', pincode: '737630' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'chadey', label: 'Chadey', pincode: '737647' },
  { value: 'gajing', label: 'Gajing', pincode: '737648' },
  { value: 'khobong', label: 'Khobong', pincode: '737649' },
  { value: 'makha', label: 'Makha', pincode: '737650' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737651' }
  ],

  'majitar': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'bothey', label: 'Bothey', pincode: '737639' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'khasmandap', label: 'Khasmandap', pincode: '737616' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'majitar', label: 'Majitar', pincode: '737629' },
  { value: 'namchi', label: 'Namchi', pincode: '737629' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'chadey', label: 'Chadey', pincode: '737647' },
  { value: 'gajing', label: 'Gajing', pincode: '737648' },
  { value: 'khobong', label: 'Khobong', pincode: '737649' },
  { value: 'makha', label: 'Makha', pincode: '737650' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737651' },
  { value: 'rangpo-bazar', label: 'Rangpo Bazar', pincode: '737652' },
  { value: 'wokha', label: 'Wokha', pincode: '737653' }
  ],

  'lachen': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'lachen', label: 'Lachen', pincode: '737630' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'chadey', label: 'Chadey', pincode: '737647' },
  { value: 'gajing', label: 'Gajing', pincode: '737648' },
  { value: 'khobong', label: 'Khobong', pincode: '737649' },
  { value: 'makha', label: 'Makha', pincode: '737650' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737651' },
  { value: 'rangpo-bazar', label: 'Rangpo Bazar', pincode: '737652' },
  { value: 'wokha', label: 'Wokha', pincode: '737653' }
  ],

  'kaluk': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'karponang-bazar', label: 'Karponang Bazar', pincode: '737615' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'kaluk', label: 'Kaluk', pincode: '737630' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'chadey', label: 'Chadey', pincode: '737647' },
  { value: 'gajing', label: 'Gajing', pincode: '737648' },
  { value: 'khobong', label: 'Khobong', pincode: '737649' },
  { value: 'makha', label: 'Makha', pincode: '737650' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737651' },
  { value: 'rangpo-bazar', label: 'Rangpo Bazar', pincode: '737652' },
  { value: 'wokha', label: 'Wokha', pincode: '737653' },
  { value: 'darmang', label: 'Darmang', pincode: '737654' },
  { value: 'ichang', label: 'Ichang', pincode: '737655' },
  { value: 'khempal', label: 'Khempal', pincode: '737656' },
  { value: 'namchi', label: 'Namchi', pincode: '737657' },
  { value: 'rangpo-district', label: 'Rangpo District', pincode: '737658' },
  { value: 'sindhupalchowk', label: 'Sindhupalchowk', pincode: '737659' },
  { value: 'tokyu', label: 'Tokyu', pincode: '737660' }
  ],

  'tinkitam': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'kaluk', label: 'Kaluk', pincode: '737630' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'chadey', label: 'Chadey', pincode: '737647' },
  { value: 'gajing', label: 'Gajing', pincode: '737648' },
  { value: 'khobong', label: 'Khobong', pincode: '737649' },
  { value: 'makha', label: 'Makha', pincode: '737650' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737651' },
  { value: 'rangpo-bazar', label: 'Rangpo Bazar', pincode: '737652' },
  { value: 'wokha', label: 'Wokha', pincode: '737653' },
  { value: 'darmang', label: 'Darmang', pincode: '737654' },
  { value: 'ichang', label: 'Ichang', pincode: '737655' },
  { value: 'khempal', label: 'Khempal', pincode: '737656' },
  { value: 'namchi', label: 'Namchi', pincode: '737657' },
  { value: 'rangpo-district', label: 'Rangpo District', pincode: '737658' },
  { value: 'sindhupalchowk', label: 'Sindhupalchowk', pincode: '737659' },
  { value: 'tokyu', label: 'Tokyu', pincode: '737660' },
  { value: 'labdeng', label: 'Labdeng', pincode: '737661' },
  { value: 'khamdong', label: 'Khamdong', pincode: '737662' },
  { value: 'tandong', label: 'Tandong', pincode: '737663' },
  { value: 'phedang', label: 'Phedang', pincode: '737664' }
  ],

  'chungthang': [
  { value: 'adampool', label: 'Adampool', pincode: '737611' },
  { value: 'bongdong', label: 'Bongdong', pincode: '737628' },
  { value: 'chingthang', label: 'Chingthang', pincode: '737612' },
  { value: 'damthang', label: 'Damthang', pincode: '737637' },
  { value: 'fedong', label: 'Fedong', pincode: '737613' },
  { value: 'gelling', label: 'Gelling', pincode: '737633' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'karponang', label: 'Karponang', pincode: '737614' },
  { value: 'kumrek', label: 'Kumrek', pincode: '737634' },
  { value: 'lingtem', label: 'Lingtam', pincode: '737617' },
  { value: 'lingzey', label: 'Lingzey', pincode: '737631' },
  { value: 'kaluk', label: 'Kaluk', pincode: '737630' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737618' },
  { value: 'menchukha', label: 'Menchukha', pincode: '737619' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737620' },
  { value: 'rangbhang', label: 'Rangbhang', pincode: '737641' },
  { value: 'rangdong', label: 'Rangdong', pincode: '737632' },
  { value: 'ravangla-bazar', label: 'Ravangla Bazar', pincode: '737621' },
  { value: 'sikay', label: 'Sikay', pincode: '737622' },
  { value: 'sindong', label: 'Sindong', pincode: '737635' },
  { value: 'soreng-bazar', label: 'Soreng Bazar', pincode: '737623' },
  { value: 'tadong', label: 'Tadong', pincode: '737625' },
  { value: 'tarku', label: 'Tarku', pincode: '737640' },
  { value: 'temi', label: 'Temi', pincode: '737624' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737626' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737627' },
  { value: 'tokalung', label: 'Tokalung', pincode: '737638' },
  { value: 'tengbong', label: 'Tengbong', pincode: '737636' },
  { value: 'chadey', label: 'Chadey', pincode: '737647' },
  { value: 'gajing', label: 'Gajing', pincode: '737648' },
  { value: 'khobong', label: 'Khobong', pincode: '737649' },
  { value: 'makha', label: 'Makha', pincode: '737650' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737651' },
  { value: 'rangpo-bazar', label: 'Rangpo Bazar', pincode: '737652' },
  { value: 'wokha', label: 'Wokha', pincode: '737653' },
  { value: 'darmang', label: 'Darmang', pincode: '737654' },
  { value: 'ichang', label: 'Ichang', pincode: '737655' },
  { value: 'khempal', label: 'Khempal', pincode: '737656' },
  { value: 'namchi', label: 'Namchi', pincode: '737657' },
  { value: 'rangpo-district', label: 'Rangpo District', pincode: '737658' },
  { value: 'sindhupalchowk', label: 'Sindhupalchowk', pincode: '737659' },
  { value: 'tokyu', label: 'Tokyu', pincode: '737660' },
  { value: 'labdeng', label: 'Labdeng', pincode: '737661' },
  { value: 'khamdong', label: 'Khamdong', pincode: '737662' },
  { value: 'tandong', label: 'Tandong', pincode: '737663' },
  { value: 'phedang', label: 'Phedang', pincode: '737664' },
  { value: 'yorkey', label: 'Yorkey', pincode: '737665' },
  { value: 'chungtang-bazar', label: 'Chungthang Bazar', pincode: '737666' },
  { value: 'phodong', label: 'Phodong', pincode: '737667' },
  { value: 'linchung', label: 'Linchung', pincode: '737668' },
  { value: 'serkem', label: 'Serkem', pincode: '737669' }
  ],

  'zuluk': [
  { value: 'adarshnagar', label: 'Adarsh Nagar', pincode: '500063' },
  { value: 'bandlaguda', label: 'Bandlaguda', pincode: '500086' },
  { value: 'barkatpura', label: 'Barkatpura', pincode: '500027' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kothapet', label: 'Kothapet', pincode: '500035' },
  { value: 'malkajgiri', label: 'Malkajgiri', pincode: '500047' },
  { value: 'musheerabad', label: 'Musheerabad', pincode: '500020' },
  { value: 'santosh-nagar', label: 'Santosh Nagar', pincode: '500059' },
  { value: 'sultan-bazar', label: 'Sultan Bazar', pincode: '500095' },
  { value: 'tarnaka', label: 'Tarnaka', pincode: '500007' },
  { value: 'yousufguda', label: 'Yousufguda', pincode: '500045' },
  { value: 'habsiguda', label: 'Habsiguda', pincode: '500007' },
  { value: 'lalapet', label: 'Lalapet', pincode: '500017' },
  { value: 'malkamcheruvu', label: 'Malkamcheruvu', pincode: '500030' },
  { value: 'navabharath-nagar', label: 'Navabharath Nagar', pincode: '500062' },
  { value: 'nallakunta', label: 'Nallakunta', pincode: '500044' },
  { value: 'puranapul', label: 'Puranapul', pincode: '500064' }
  ],

  'yuksom': [
  { value: 'barfok', label: 'Barfok', pincode: '737112' },
  { value: 'changey', label: 'Changey', pincode: '737113' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lhari', label: 'Lhari', pincode: '737106' },
  { value: 'manebong', label: 'Manebong', pincode: '737108' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' }
  ],

  'tumlong': [
  { value: 'bargaon', label: 'Bargaon', pincode: '737117' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'lachen', label: 'Lachen', pincode: '737120' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' }
  ],

  'rabdentse': [
  { value: 'barmiok', label: 'Barmiok', pincode: '737101' },
  { value: 'changey', label: 'Changey', pincode: '737113' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' }
  ],

  'singhik': [
  { value: 'barfok', label: 'Barfok', pincode: '737112' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'singhik', label: 'Singhik', pincode: '737102' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' }
  ],

  'rinchenpong': [
  { value: 'barfok', label: 'Barfok', pincode: '737112' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'shergaon', label: 'Shergaon', pincode: '737114' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' }
  ],

  'sumbuk': [
  { value: 'barfok', label: 'Barfok', pincode: '737112' },
  { value: 'changey', label: 'Changey', pincode: '737113' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' }
  ],

  'dikchu': [
  { value: 'barfok', label: 'Barfok', pincode: '737112' },
  { value: 'changey', label: 'Changey', pincode: '737113' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' },
  { value: 'dikchu', label: 'Dikchu', pincode: '737121' },
  { value: 'singhik', label: 'Singhik', pincode: '737102' }
  ],

  'namthang': [
  { value: 'barfok', label: 'Barfok', pincode: '737112' },
  { value: 'changey', label: 'Changey', pincode: '737113' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'namthang', label: 'Namthang', pincode: '737127' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' },
  { value: 'beyong', label: 'Beyong', pincode: '737123' },
  { value: 'doling', label: 'Doling', pincode: '737124' },
  { value: 'karjeeling', label: 'Karjeeling', pincode: '737125' },
  { value: 'namphok', label: 'Namphok', pincode: '737122' }
  ],

  'rongli': [
  { value: 'barfok', label: 'Barfok', pincode: '737112' },
  { value: 'changey', label: 'Changey', pincode: '737113' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'namthang', label: 'Namthang', pincode: '737127' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'rongli', label: 'Rongli', pincode: '737114' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' },
  { value: 'beyong', label: 'Beyong', pincode: '737123' },
  { value: 'doling', label: 'Doling', pincode: '737124' },
  { value: 'karjeeling', label: 'Karjeeling', pincode: '737125' },
  { value: 'namphok', label: 'Namphok', pincode: '737122' }
  ],

  'chalamthang': [
  { value: 'barfok', label: 'Barfok', pincode: '737112' },
  { value: 'changey', label: 'Changey', pincode: '737113' },
  { value: 'chalamthang', label: 'Chalamthang', pincode: '737122' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'namthang', label: 'Namthang', pincode: '737127' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' },
  { value: 'beyong', label: 'Beyong', pincode: '737123' },
  { value: 'doling', label: 'Doling', pincode: '737124' },
  { value: 'karjeeling', label: 'Karjeeling', pincode: '737125' },
  { value: 'namphok', label: 'Namphok', pincode: '737122' },
  { value: 'changthang', label: 'Changthang', pincode: '737106' },
  { value: 'phedong', label: 'Phedong', pincode: '737115' }
  ],

  'bikmat': [
  { value: 'barfok', label: 'Barfok', pincode: '737112' },
  { value: 'bikmat', label: 'Bikmat', pincode: '737108' },
  { value: 'changey', label: 'Changey', pincode: '737113' },
  { value: 'changthang', label: 'Changthang', pincode: '737106' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'namthang', label: 'Namthang', pincode: '737127' },
  { value: 'phedong', label: 'Phedong', pincode: '737115' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' }
  ],

  'sevoke': [
  { value: 'arjunpara', label: 'Arjunpara', pincode: '734001' },
  { value: 'balasan', label: 'Balasan', pincode: '734013' },
  { value: 'bengalgram', label: 'Bengalgram', pincode: '734005' },
  { value: 'binaguri', label: 'Binaguri', pincode: '734015' },
  { value: 'dilaram', label: 'Dilaram', pincode: '734102' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jorebungalow', label: 'Jorebungalow', pincode: '734101' },
  { value: 'kalingpong', label: 'Kalingpong', pincode: '734009' },
  { value: 'kanchenjunga', label: 'Kanchenjunga', pincode: '734103' },
  { value: 'kalimpong', label: 'Kalimpong', pincode: '734301' },
  { value: 'keshabram', label: 'Keshabram', pincode: '734201' },
  { value: 'lohagarh', label: 'Lohagarh', pincode: '734011' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '734115' },
  { value: 'naya-bazar', label: 'Naya Bazar', pincode: '734101' },
  { value: 'rangpo', label: 'Rangpo', pincode: '734021' },
  { value: 'sevok', label: 'Sevok', pincode: '734016' },
  { value: 'sivok', label: 'Sivok', pincode: '734022' },
  { value: 'tista', label: 'Tista', pincode: '734014' },
  { value: 'tuckla', label: 'Tuckla', pincode: '734007' },
  { value: 'bungalow-dara', label: 'Bungalow Dara', pincode: '734006' },
  { value: 'chatakpur', label: 'Chatakpur', pincode: '734008' },
  { value: 'charkhol', label: 'Charkhol', pincode: '734004' },
  { value: 'janglabong', label: 'Janglabong', pincode: '734010' },
  { value: 'lolin', label: 'Lolin', pincode: '734017' },
  { value: 'salbari', label: 'Salbari', pincode: '734019' },
  { value: 'sonada', label: 'Sonada', pincode: '734019' }
  ],

  'damthang': [
  { value: 'arjundhara', label: 'Arjundhara', pincode: '737124' },
  { value: 'beyong', label: 'Beyong', pincode: '737123' },
  { value: 'binaguri', label: 'Binaguri', pincode: '734015' },
  { value: 'chalamthang', label: 'Chalamthang', pincode: '737122' },
  { value: 'chongri', label: 'Chongri', pincode: '737107' },
  { value: 'damthang', label: 'Damthang', pincode: '737129' },
  { value: 'dilaram', label: 'Dilaram', pincode: '734102' },
  { value: 'dzungu', label: 'Dzungu', pincode: '737125' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'janglabong', label: 'Janglabong', pincode: '737130' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737116' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'namthang', label: 'Namthang', pincode: '737127' },
  { value: 'phedong', label: 'Phedong', pincode: '737115' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' },
  { value: 'sivok', label: 'Sivok', pincode: '734022' },
  { value: 'tuckla', label: 'Tuckla', pincode: '734007' },
  { value: 'bungalow-dara', label: 'Bungalow Dara', pincode: '734006' }
  ],

  'lingthem': [
  { value: 'arjundhara', label: 'Arjundhara', pincode: '737124' },
  { value: 'beyong', label: 'Beyong', pincode: '737123' },
  { value: 'binaguri', label: 'Binaguri', pincode: '734015' },
  { value: 'chalamthang', label: 'Chalamthang', pincode: '737122' },
  { value: 'damthang', label: 'Damthang', pincode: '737129' },
  { value: 'dilaram', label: 'Dilaram', pincode: '734102' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'janglabong', label: 'Janglabong', pincode: '737130' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'lingthem', label: 'Lingthem', pincode: '737128' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737116' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'namthang', label: 'Namthang', pincode: '737127' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' },
  { value: 'bungalow-dara', label: 'Bungalow Dara', pincode: '734006' },
  { value: 'chatakpur', label: 'Chatakpur', pincode: '734008' },
  { value: 'charkhol', label: 'Charkhol', pincode: '734004' },
  { value: 'janglabong', label: 'Janglabong', pincode: '737130' },
  { value: 'kollong', label: 'Kollong', pincode: '737121' },
  { value: 'salbari', label: 'Salbari', pincode: '734022' },
  { value: 'sonada', label: 'Sonada', pincode: '734019' }
  ],

  'tarku': [
  { value: 'arjundhara', label: 'Arjundhara', pincode: '737124' },
  { value: 'beyong', label: 'Beyong', pincode: '737123' },
  { value: 'binaguri', label: 'Binaguri', pincode: '734015' },
  { value: 'chalamthang', label: 'Chalamthang', pincode: '737122' },
  { value: 'damthang', label: 'Damthang', pincode: '737129' },
  { value: 'dilaram', label: 'Dilaram', pincode: '734102' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'janglabong', label: 'Janglabong', pincode: '737130' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'lingthem', label: 'Lingthem', pincode: '737128' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737116' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'namthang', label: 'Namthang', pincode: '737127' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'tarku', label: 'Tarku', pincode: '737103' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' },
  { value: 'bungrung', label: 'Bungrung', pincode: '737108' },
  { value: 'chatakpur', label: 'Chatakpur', pincode: '734008' },
  { value: 'charkhol', label: 'Charkhol', pincode: '734004' },
  { value: 'fambong', label: 'Fambong', pincode: '734007' },
  { value: 'janglabong', label: 'Janglabong', pincode: '737130' },
  { value: 'kolbong', label: 'Kolbong', pincode: '737102' },
  { value: 'mangzing', label: 'Mangzing', pincode: '737117' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737139' },
  { value: 'salbari', label: 'Salbari', pincode: '734022' },
  { value: 'sonada', label: 'Sonada', pincode: '734019' }
  ],

  'yangang': [
  { value: 'arjundhara', label: 'Arjundhara', pincode: '737124' },
  { value: 'beyong', label: 'Beyong', pincode: '737123' },
  { value: 'binaguri', label: 'Binaguri', pincode: '734015' },
  { value: 'chalamthang', label: 'Chalamthang', pincode: '737122' },
  { value: 'damthang', label: 'Damthang', pincode: '737129' },
  { value: 'dilaram', label: 'Dilaram', pincode: '734102' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'janglabong', label: 'Janglabong', pincode: '737130' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'lingthem', label: 'Lingthem', pincode: '737128' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737116' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'namthang', label: 'Namthang', pincode: '737127' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yangang', label: 'Yangang', pincode: '737102' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' },
  { value: 'bungrung', label: 'Bungrung', pincode: '737108' },
  { value: 'chatakpur', label: 'Chatakpur', pincode: '734008' },
  { value: 'charkhol', label: 'Charkhol', pincode: '734004' },
  { value: 'fambong', label: 'Fambong', pincode: '734007' },
  { value: 'janglabong', label: 'Janglabong', pincode: '737130' },
  { value: 'kolbong', label: 'Kolbong', pincode: '737102' },
  { value: 'mangzing', label: 'Mangzing', pincode: '737117' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737139' },
  { value: 'salbari', label: 'Salbari', pincode: '734022' },
  { value: 'sonada', label: 'Sonada', pincode: '734019' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737112' },
  { value: 'tukdah', label: 'Tukdah', pincode: '734016' }
  ],

  'pedong': [
  { value: 'arjundhara', label: 'Arjundhara', pincode: '737124' },
  { value: 'beyong', label: 'Beyong', pincode: '737123' },
  { value: 'binaguri', label: 'Binaguri', pincode: '734015' },
  { value: 'chalamthang', label: 'Chalamthang', pincode: '737122' },
  { value: 'damthang', label: 'Damthang', pincode: '737129' },
  { value: 'dilaram', label: 'Dilaram', pincode: '734102' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'janglabong', label: 'Janglabong', pincode: '737130' },
  { value: 'khechuperi', label: 'Khechuperi', pincode: '737101' },
  { value: 'khoplang', label: 'Khoplang', pincode: '737110' },
  { value: 'kyongnosla', label: 'Kyongnosla', pincode: '737105' },
  { value: 'lempang', label: 'Lempang', pincode: '737115' },
  { value: 'lingthem', label: 'Lingthem', pincode: '737128' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '737116' },
  { value: 'namchi', label: 'Namchi', pincode: '737126' },
  { value: 'namthang', label: 'Namthang', pincode: '737127' },
  { value: 'pedong', label: 'Pedong', pincode: '734317' },
  { value: 'rabdentse', label: 'Rabdentse', pincode: '737111' },
  { value: 'rinchenpong', label: 'Rinchenpong', pincode: '737113' },
  { value: 'sangtashiti', label: 'Sangtashiti', pincode: '737104' },
  { value: 'sumbuk', label: 'Sumbuk', pincode: '737120' },
  { value: 'tashiding', label: 'Tashiding', pincode: '737109' },
  { value: 'tumlong', label: 'Tumlong', pincode: '737118' },
  { value: 'yuksom', label: 'Yuksom', pincode: '737100' },
  { value: 'zongu', label: 'Zongu', pincode: '737119' },
  { value: 'bungrung', label: 'Bungrung', pincode: '737108' },
  { value: 'chatakpur', label: 'Chatakpur', pincode: '734008' },
  { value: 'charkhol', label: 'Charkhol', pincode: '734004' },
  { value: 'fambong', label: 'Fambong', pincode: '734007' },
  { value: 'kolbong', label: 'Kolbong', pincode: '737102' },
  { value: 'mangzing', label: 'Mangzing', pincode: '737117' },
  { value: 'rangpo', label: 'Rangpo', pincode: '737139' },
  { value: 'salbari', label: 'Salbari', pincode: '734022' },
  { value: 'sonada', label: 'Sonada', pincode: '734019' },
  { value: 'tharpu', label: 'Tharpu', pincode: '737112' },
  { value: 'tukdah', label: 'Tukdah', pincode: '734016' },
  { value: 'yaldi', label: 'Yaldi', pincode: '737107' },
  { value: 'daragaon', label: 'Daragaon', pincode: '734012' },
  { value: 'kalimpong', label: 'Kalimpong', pincode: '734301' },
  { value: 'mandalgaon', label: 'Mandalgaon', pincode: '734031' }
  ],

  //Rajasthan Areas
  'baran': [
  { value: 'aditya-nagar', label: 'Aditya Nagar', pincode: '325001' },
  { value: 'aligarh', label: 'Aligarh', pincode: '325002' },
  { value: 'barkheda', label: 'Barkheda', pincode: '325003' },
  { value: 'bhageerath', label: 'Bhageerath', pincode: '325004' },
  { value: 'bundi', label: 'Bundi', pincode: '325005' },
  { value: 'charan-dhuwara', label: 'Charan Dhuwara', pincode: '325006' },
  { value: 'chak-dhamani', label: 'Chak Dhamani', pincode: '325007' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '325008' },
  { value: 'gopalpura', label: 'Gopalpura', pincode: '325009' },
  { value: 'jagadamba', label: 'Jagadamba', pincode: '325010' },
  { value: 'johri-ka-para', label: 'Johri Ka Para', pincode: '325011' },
  { value: 'kherwara', label: 'Kherwara', pincode: '325012' },
  { value: 'kota', label: 'Kota', pincode: '325013' },
  { value: 'mangalpura', label: 'Mangalpura', pincode: '325014' },
  { value: 'manoharpura', label: 'Manoharpura', pincode: '325015' },
  { value: 'patel-nagar', label: 'Patel Nagar', pincode: '325016' },
  { value: 'rajgarh', label: 'Rajgarh', pincode: '325017' },
  { value: 'rajori', label: 'Rajori', pincode: '325018' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '325019' },
  { value: 'shree-nagar', label: 'Shree Nagar', pincode: '325020' },
  { value: 'surajpura', label: 'Surajpura', pincode: '325021' },
  { value: 'tulsi-nagar', label: 'Tulsi Nagar', pincode: '325022' },
  { value: 'varah', label: 'Varah', pincode: '325023' },
  { value: 'vishwakarma', label: 'Vishwakarma', pincode: '325024' }
  ],
'pali': [
  { value: 'adityanagar', label: 'Adityanagar', pincode: '500062' },
  { value: 'anjaneya-nagar', label: 'Anjaneya Nagar', pincode: '500043' },
  { value: 'balkampet', label: 'Balkampet', pincode: '500016' },
  { value: 'begum-bazar', label: 'Begum Bazar', pincode: '500012' },
  { value: 'bollarum', label: 'Bollarum', pincode: '500010' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'halyal', label: 'Halyal', pincode: '500060' },
  { value: 'kavuran', label: 'Kavuran', pincode: '500062' },
  { value: 'kothapet', label: 'Kothapet', pincode: '500062' },
  { value: 'lalapet', label: 'Lalapet', pincode: '500017' },
  { value: 'mallapet', label: 'Mallapet', pincode: '500009' },
  { value: 'malkajgiri', label: 'Malkajgiri', pincode: '500047' },
  { value: 'miyapur', label: 'Miyapur', pincode: '500049' },
  { value: 'sardar-patel-nagar', label: 'Sardar Patel Nagar', pincode: '500062' },
  { value: 'shamshabad', label: 'Shamshabad', pincode: '500078' },
  { value: 'trimulgherry', label: 'Trimulgherry', pincode: '500015' },
  { value: 'ulsoor', label: 'Ulsoor', pincode: '500062' },
  { value: 'vengalrao-nagar', label: 'Vengalrao Nagar', pincode: '500028' },
  { value: 'yousufguda', label: 'Yousufguda', pincode: '500045' }
],
'bhilwara': [
  { value: 'adampur', label: 'Adampur', pincode: '311001' },
  { value: 'alakhpura', label: 'Alakhpura', pincode: '311001' },
  { value: 'alniya', label: 'Alniya', pincode: '311603' },
  { value: 'banera', label: 'Banera', pincode: '311021' },
  { value: 'bhilwara-town', label: 'Bhilwara Town', pincode: '311001' },
  { value: 'borkheda', label: 'Borkheda', pincode: '311025' },
  { value: 'danpur', label: 'Danpur', pincode: '311019' },
  { value: 'ghoshpura', label: 'Ghoshpura', pincode: '311801' },
  { value: 'gokalpura', label: 'Gokalpura', pincode: '311204' },
  { value: 'gudan', label: 'Gudan', pincode: '311601' },
  { value: 'kanpur', label: 'Kanpur', pincode: '311301' },
  { value: 'kothari', label: 'Kothari', pincode: '311406' },
  { value: 'mandal', label: 'Mandal', pincode: '311025' },
  { value: 'mandphiya', label: 'Mandphiya', pincode: '311023' },
  { value: 'rajsamand', label: 'Rajsamand', pincode: '311207' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '311001' },
  { value: 'shergarh', label: 'Shergarh', pincode: '311601' },
  { value: 'shivpuri', label: 'Shivpuri', pincode: '311024' },
  { value: 'tonk', label: 'Tonk', pincode: '311804' },
  { value: 'bhilwara-collectorate', label: 'Bhilwara Collectorate', pincode: '311001' },
  { value: 'chandpura', label: 'Chandpura', pincode: '311001' },
  { value: 'gangapur', label: 'Gangapur', pincode: '311604' },
  { value: 'jaitpura', label: 'Jaitpura', pincode: '311203' },
  { value: 'keshavpura', label: 'Keshavpura', pincode: '311604' },
  { value: 'khadakpura', label: 'Khadakpura', pincode: '311001' },
  { value: 'kochipura', label: 'Kochipura', pincode: '311604' },
  { value: 'mehndwas', label: 'Mehndwas', pincode: '311001' },
  { value: 'mohammadpura', label: 'Mohammadpura', pincode: '311204' },
  { value: 'shahpura', label: 'Shahpura', pincode: '311409' },
  { value: 'sursura', label: 'Sursura', pincode: '311801' },
  ],

  'hanumangarh': [
  { value: 'adampur', label: 'Adampur', pincode: '335801' },
  { value: 'bhagatsingh-colony', label: 'Bhagat Singh Colony', pincode: '335512' },
  { value: 'bichwal', label: 'Bichwal', pincode: '335511' },
  { value: 'chak-1ml', label: 'Chak 1ML', pincode: '335802' },
  { value: 'chak-14sm', label: 'Chak 14SM', pincode: '335063' },
  { value: 'chak-24bb', label: 'Chak 24BB', pincode: '335062' },
  { value: 'chak-33gr', label: 'Chak 33GR', pincode: '335063' },
  { value: 'chak-5khm', label: 'Chak 5KHM', pincode: '335512' },
  { value: 'chak-haripura', label: 'Chak Haripura', pincode: '335062' },
  { value: 'dhan-mandi', label: 'Dhan Mandi', pincode: '335513' },
  { value: 'goluwala', label: 'Goluwala', pincode: '335802' },
  { value: 'hanumangarh-junction', label: 'Hanumangarh Junction', pincode: '335512' },
  { value: 'hanumangarh-town', label: 'Hanumangarh Town', pincode: '335513' },
  { value: 'kanwani', label: 'Kanwani', pincode: '335513' },
  { value: 'kisan-basti', label: 'Kisan Basti', pincode: '335513' },
  { value: 'krishi-nagri', label: 'Krishi Nagri', pincode: '335513' },
  { value: 'malerkhera', label: 'Malerkhera', pincode: '335801' },
  { value: 'manaksar', label: 'Manaksar', pincode: '335511' },
  { value: 'meghsar', label: 'Meghsar', pincode: '335801' },
  { value: 'miller-ganj', label: 'Miller Ganj', pincode: '335513' },
  { value: 'nohar', label: 'Nohar', pincode: '335523' },
  { value: 'pilibanga', label: 'Pilibanga', pincode: '335803' },
  { value: 'rawatsar', label: 'Rawatsar', pincode: '335524' },
  { value: 'sadulshahar', label: 'Sadulshahar', pincode: '335062' },
  { value: 'sangaria', label: 'Sangaria', pincode: '335063' },
  { value: 'shivpuri', label: 'Shivpuri', pincode: '335801' },
  { value: 'sri-vijaynagar', label: 'Sri Vijaynagar', pincode: '335704' },
  { value: 'talwara', label: 'Talwara', pincode: '335802' },
  { value: 'vinayak-nagar', label: 'Vinayak Nagar', pincode: '335512' }
  ],

  'dholpur': [
  { value: 'agar-ki-jhopri', label: 'Agar Ki Jhopri', pincode: '328001' },
  { value: 'baghicha', label: 'Baghicha', pincode: '328001' },
  { value: 'bari', label: 'Bari', pincode: '328021' },
  { value: 'baseri', label: 'Baseri', pincode: '328022' },
  { value: 'chopra-colony', label: 'Chopra Colony', pincode: '328001' },
  { value: 'dholpur-city', label: 'Dholpur City', pincode: '328001' },
  { value: 'dholpur-junction', label: 'Dholpur Junction', pincode: '328001' },
  { value: 'ganj-bazar', label: 'Ganj Bazar', pincode: '328001' },
  { value: 'garh-ka-pura', label: 'Garh Ka Pura', pincode: '328026' },
  { value: 'jadhav-ka-nagla', label: 'Jadhav Ka Nagla', pincode: '328027' },
  { value: 'jhirka', label: 'Jhirka', pincode: '328023' },
  { value: 'kaka-ka-nagla', label: 'Kaka Ka Nagla', pincode: '328001' },
  { value: 'kalka-colony', label: 'Kalka Colony', pincode: '328001' },
  { value: 'kundera', label: 'Kundera', pincode: '328029' },
  { value: 'mania', label: 'Mania', pincode: '328024' },
  { value: 'marena', label: 'Marena', pincode: '328025' },
  { value: 'nijampura', label: 'Nijampura', pincode: '328001' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '328001' },
  { value: 'rajakhera', label: 'Rajakhera', pincode: '328025' },
  { value: 'saipau', label: 'Saipau', pincode: '328027' },
  { value: 'shamsabad', label: 'Shamsabad', pincode: '328026' },
  { value: 'sikroda', label: 'Sikroda', pincode: '328001' },
  { value: 'tehsil-chowk', label: 'Tehsil Chowk', pincode: '328001' },
  { value: 'udaipur-khaira', label: 'Udaipur Khaira', pincode: '328030' },
  { value: 'van-vihar', label: 'Van Vihar', pincode: '328001' },
  { value: 'yadav-nagar', label: 'Yadav Nagar', pincode: '328001' }
  ],

  'banswara': [
  { value: 'anand-sagar', label: 'Anand Sagar', pincode: '327001' },
  { value: 'arda', label: 'Arda', pincode: '327034' },
  { value: 'bagida-bari', label: 'Bagida Bari', pincode: '327025' },
  { value: 'banswara-industrial-area', label: 'Banswara Industrial Area', pincode: '327001' },
  { value: 'banswara-junction', label: 'Banswara Junction', pincode: '327001' },
  { value: 'bhimkund', label: 'Bhimkund', pincode: '327027' },
  { value: 'chhoti-sarwan', label: 'Chhoti Sarwan', pincode: '327801' },
  { value: 'danpur', label: 'Danpur', pincode: '327602' },
  { value: 'dungar-pur', label: 'Dungar Pur', pincode: '327023' },
  { value: 'ghotan', label: 'Ghotan', pincode: '327031' },
  { value: 'ghotol', label: 'Ghotol', pincode: '327026' },
  { value: 'godhra-road', label: 'Godhra Road', pincode: '327001' },
  { value: 'hanuman-temple-area', label: 'Hanuman Temple Area', pincode: '327001' },
  { value: 'jhalod-road', label: 'Jhalod Road', pincode: '327001' },
  { value: 'kalinjara', label: 'Kalinjara', pincode: '327025' },
  { value: 'kanji-ka-guda', label: 'Kanji Ka Guda', pincode: '327022' },
  { value: 'khandu-colony', label: 'Khandu Colony', pincode: '327001' },
  { value: 'kushalgarh', label: 'Kushalgarh', pincode: '327801' },
  { value: 'lodha', label: 'Lodha', pincode: '327034' },
  { value: 'mahavirnagar', label: 'Mahavirnagar', pincode: '327001' },
  { value: 'mohankheda', label: 'Mohankheda', pincode: '327026' },
  { value: 'nandni', label: 'Nandni', pincode: '327801' },
  { value: 'partapur', label: 'Partapur', pincode: '327022' },
  { value: 'pipal-khunt', label: 'Pipal Khunt', pincode: '327028' },
  { value: 'pratap-nagar', label: 'Pratap Nagar', pincode: '327001' },
  { value: 'rajsingh-pura', label: 'Rajsingh Pura', pincode: '327601' },
  { value: 'salopat', label: 'Salopat', pincode: '327033' },
  { value: 'shri-vijaypur', label: 'Shri Vijaypur', pincode: '327801' },
  { value: 'talwara', label: 'Talwara', pincode: '327025' },
  { value: 'tripura-sundari', label: 'Tripura Sundari', pincode: '327001' },
  { value: 'udaipur-road', label: 'Udaipur Road', pincode: '327001' },
  { value: 'umarpura', label: 'Umarpura', pincode: '327032' },
  { value: 'van-vihar', label: 'Van Vihar', pincode: '327001' },
  { value: 'village-khamera', label: 'Village Khamera', pincode: '327031' }
  ],

  'beawar': [
  { value: 'ajmer-road', label: 'Ajmer Road', pincode: '305901' },
  { value: 'amrit-kaur-hospital-area', label: 'Amrit Kaur Hospital Area', pincode: '305901' },
  { value: 'ashapura-road', label: 'Ashapura Road', pincode: '305901' },
  { value: 'badi-road', label: 'Badi Road', pincode: '305901' },
  { value: 'bajranggarh', label: 'Bajranggarh', pincode: '305901' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '305901' },
  { value: 'beawar-city', label: 'Beawar City', pincode: '305901' },
  { value: 'beawar-industrial-area', label: 'Beawar Industrial Area', pincode: '305901' },
  { value: 'bhagwan-ganj', label: 'Bhagwan Ganj', pincode: '305901' },
  { value: 'bichun-road', label: 'Bichun Road', pincode: '305901' },
  { value: 'chandgate', label: 'Chandgate', pincode: '305901' },
  { value: 'chhoti-bastan', label: 'Chhoti Bastan', pincode: '305901' },
  { value: 'chungi-naka', label: 'Chungi Naka', pincode: '305901' },
  { value: 'dev-nagar', label: 'Dev Nagar', pincode: '305901' },
  { value: 'ganeshpura', label: 'Ganeshpura', pincode: '305901' },
  { value: 'ghashmandi', label: 'Ghashmandi', pincode: '305901' },
  { value: 'govindpura', label: 'Govindpura', pincode: '305901' },
  { value: 'jagpura', label: 'Jagpura', pincode: '305901' },
  { value: 'khandelwal-colony', label: 'Khandelwal Colony', pincode: '305901' },
  { value: 'koyla-gali', label: 'Koyla Gali', pincode: '305901' },
  { value: 'mahabir-colony', label: 'Mahabir Colony', pincode: '305901' },
  { value: 'makrana-road', label: 'Makrana Road', pincode: '305901' },
  { value: 'manikya-nagar', label: 'Manikya Nagar', pincode: '305901' },
  { value: 'meenawala', label: 'Meenawala', pincode: '305901' },
  { value: 'motipura', label: 'Motipura', pincode: '305901' },
  { value: 'mukherjee-nagar', label: 'Mukherjee Nagar', pincode: '305901' },
  { value: 'nagori-garden', label: 'Nagori Garden', pincode: '305901' },
  { value: 'neem-ka-thana', label: 'Neem Ka Thana', pincode: '305901' },
  { value: 'pali-road', label: 'Pali Road', pincode: '305901' },
  { value: 'pratap-nagar', label: 'Pratap Nagar', pincode: '305901' },
  { value: 'rambagh', label: 'Rambagh', pincode: '305901' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '305901' },
  { value: 'railway-station-road', label: 'Railway Station Road', pincode: '305901' },
  { value: 'ramganj-road', label: 'Ramganj Road', pincode: '305901' },
  { value: 'rani-sati-nagar', label: 'Rani Sati Nagar', pincode: '305901' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '305901' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '305901' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '305901' },
  { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '305901' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '305901' },
  { value: 'vivekananda-colony', label: 'Vivekananda Colony', pincode: '305901' }
  ],

  'hindaun': [
  { value: 'agarwal-colony', label: 'Agarwal Colony', pincode: '322230' },
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '322230' },
  { value: 'bada-bazar', label: 'Bada Bazar', pincode: '322230' },
  { value: 'badi-jawahar-colony', label: 'Badi Jawahar Colony', pincode: '322230' },
  { value: 'banshi-pura', label: 'Banshi Pura', pincode: '322230' },
  { value: 'bhagat-singh-colony', label: 'Bhagat Singh Colony', pincode: '322230' },
  { value: 'bhurawas', label: 'Bhurawas', pincode: '322234' },
  { value: 'chamunda-colony', label: 'Chamunda Colony', pincode: '322230' },
  { value: 'chungi-naka', label: 'Chungi Naka', pincode: '322230' },
  { value: 'dev-nagar', label: 'Dev Nagar', pincode: '322230' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '322230' },
  { value: 'ghantaghar', label: 'Ghantaghar', pincode: '322230' },
  { value: 'govind-nagar', label: 'Govind Nagar', pincode: '322230' },
  { value: 'hindaun-bypass', label: 'Hindaun Bypass', pincode: '322230' },
  { value: 'indra-colony', label: 'Indra Colony', pincode: '322230' },
  { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '322230' },
  { value: 'jheel-colony', label: 'Jheel Colony', pincode: '322230' },
  { value: 'kabir-basti', label: 'Kabir Basti', pincode: '322230' },
  { value: 'kamal-basti', label: 'Kamal Basti', pincode: '322230' },
  { value: 'karanpur', label: 'Karanpur', pincode: '322236' },
  { value: 'kishan-garh', label: 'Kishan Garh', pincode: '322230' },
  { value: 'kothi-colony', label: 'Kothi Colony', pincode: '322230' },
  { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '322230' },
  { value: 'mahavir-nagar', label: 'Mahavir Nagar', pincode: '322230' },
  { value: 'mahwa-road', label: 'Mahwa Road', pincode: '322230' },
  { value: 'mohalla-luharon', label: 'Mohalla Luharon', pincode: '322230' },
  { value: 'nagla', label: 'Nagla', pincode: '322234' },
  { value: 'narayan-nagar', label: 'Narayan Nagar', pincode: '322230' },
  { value: 'neem-ka-thana', label: 'Neem Ka Thana', pincode: '322230' },
  { value: 'pali-road', label: 'Pali Road', pincode: '322230' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '322230' },
  { value: 'rampura', label: 'Rampura', pincode: '322230' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '322230' },
  { value: 'sanwatara', label: 'Sanwatara', pincode: '322234' },
  { value: 'shastri-colony', label: 'Shastri Colony', pincode: '322230' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '322230' },
  { value: 'subhash-colony', label: 'Subhash Colony', pincode: '322230' },
  { value: 'suraj-pol', label: 'Suraj Pol', pincode: '322230' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '322230' },
  { value: 'vivekananda-colony', label: 'Vivekananda Colony', pincode: '322230' }
  ],

  'dungarpur': [
  { value: 'adarsh-colony', label: 'Adarsh Colony', pincode: '314001' },
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '314001' },
  { value: 'banswara-road', label: 'Banswara Road', pincode: '314001' },
  { value: 'bhiluda', label: 'Bhiluda', pincode: '314032' },
  { value: 'bichiwada', label: 'Bichiwada', pincode: '314801' },
  { value: 'civil-lines', label: 'Civil Lines', pincode: '314001' },
  { value: 'dak-bungalow', label: 'Dak Bungalow', pincode: '314001' },
  { value: 'devgarh', label: 'Devgarh', pincode: '314804' },
  { value: 'dhamodar-colony', label: 'Dhamodar Colony', pincode: '314001' },
  { value: 'dungarpur-bypass', label: 'Dungarpur Bypass', pincode: '314001' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '314001' },
  { value: 'govind-nagar', label: 'Govind Nagar', pincode: '314001' },
  { value: 'hanuman-pol', label: 'Hanuman Pol', pincode: '314001' },
  { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '314001' },
  { value: 'jain-mandir-area', label: 'Jain Mandir Area', pincode: '314001' },
  { value: 'kherwara', label: 'Kherwara', pincode: '314803' },
  { value: 'mahavir-nagar', label: 'Mahavir Nagar', pincode: '314001' },
  { value: 'mohammad-colony', label: 'Mohammad Colony', pincode: '314001' },
  { value: 'nagarpalika-road', label: 'Nagarpalika Road', pincode: '314001' },
  { value: 'nava-ghat', label: 'Nava Ghat', pincode: '314001' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '314001' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '314001' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '314001' },
  { value: 'sagwara', label: 'Sagwara', pincode: '314025' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '314001' },
  { value: 'shrinath-colony', label: 'Shrinath Colony', pincode: '314001' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '314001' },
  { value: 'udai-nagar', label: 'Udai Nagar', pincode: '314001' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '314001' },
  { value: 'vivekananda-colony', label: 'Vivekananda Colony', pincode: '314001' },
  { value: 'zadla-road', label: 'Zadla Road', pincode: '314801' }
  ],

  'bhiwadi': [
  { value: 'ashiana-greens', label: 'Ashiana Greens', pincode: '301019' },
  { value: 'ashiana-town', label: 'Ashiana Town', pincode: '301019' },
  { value: 'baba-mohan-ram-colony', label: 'Baba Mohan Ram Colony', pincode: '301019' },
  { value: 'bhagat-singh-colony', label: 'Bhagat Singh Colony', pincode: '301019' },
  { value: 'bhiwadi-industrial-area', label: 'Bhiwadi Industrial Area', pincode: '301019' },
  { value: 'capsule-road', label: 'Capsule Road', pincode: '301019' },
  { value: 'chopanki', label: 'Chopanki', pincode: '301707' },
  { value: 'dharuhera', label: 'Dharuhera', pincode: '301707' },
  { value: 'ghatal', label: 'Ghatal', pincode: '301019' },
  { value: 'gokal-pur', label: 'Gokal Pur', pincode: '301019' },
  { value: 'honda-road', label: 'Honda Road', pincode: '301019' },
  { value: 'housing-board', label: 'Housing Board', pincode: '301019' },
  { value: 'jhiwana', label: 'Jhiwana', pincode: '301707' },
  { value: 'kahrani', label: 'Kahrani', pincode: '301019' },
  { value: 'kaluwas', label: 'Kaluwas', pincode: '301019' },
  { value: 'khalilpur', label: 'Khalilpur', pincode: '301707' },
  { value: 'malerna', label: 'Malerna', pincode: '301019' },
  { value: 'maheshwari', label: 'Maheshwari', pincode: '301019' },
  { value: 'mehandipur', label: 'Mehandipur', pincode: '301019' },
  { value: 'phase-1-industrial-area', label: 'Phase 1 Industrial Area', pincode: '301019' },
  { value: 'phase-2-industrial-area', label: 'Phase 2 Industrial Area', pincode: '301019' },
  { value: 'phase-3-industrial-area', label: 'Phase 3 Industrial Area', pincode: '301019' },
  { value: 'rajendra-garh', label: 'Rajendra Garh', pincode: '301019' },
  { value: 'riico-industrial-area', label: 'RIICO Industrial Area', pincode: '301019' },
  { value: 'rampura', label: 'Rampura', pincode: '301019' },
  { value: 'shahjahanpur', label: 'Shahjahanpur', pincode: '301706' },
  { value: 'siliserh', label: 'Siliserh', pincode: '301001' },
  { value: 'tapukara', label: 'Tapukara', pincode: '301707' },
  { value: 'udhog-vihar', label: 'Udhog Vihar', pincode: '301019' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '301019' },
  { value: 'vijay-mandir', label: 'Vijay Mandir', pincode: '301001' },
  { value: 'vpo-bagwali', label: 'VPO Bagwali', pincode: '301707' },
  { value: 'vpo-khairthal', label: 'VPO Khairthal', pincode: '301405' }
  ],

  'kishangarh': [
  { value: 'ajmer-road', label: 'Ajmer Road', pincode: '305802' },
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '305802' },
  { value: 'bada-bazar', label: 'Bada Bazar', pincode: '305802' },
  { value: 'bhatta-basti', label: 'Bhatta Basti', pincode: '305802' },
  { value: 'bijaynagar-road', label: 'Bijaynagar Road', pincode: '305801' },
  { value: 'chand-pol', label: 'Chand Pol', pincode: '305802' },
  { value: 'charbhuja-nagar', label: 'Charbhuja Nagar', pincode: '305802' },
  { value: 'chopati-road', label: 'Chopati Road', pincode: '305802' },
  { value: 'dev-nagar', label: 'Dev Nagar', pincode: '305802' },
  { value: 'ganesh-colony', label: 'Ganesh Colony', pincode: '305802' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '305802' },
  { value: 'gopalbari', label: 'Gopalbari', pincode: '305802' },
  { value: 'govindpura', label: 'Govindpura', pincode: '305802' },
  { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '305802' },
  { value: 'industrial-area', label: 'Industrial Area', pincode: '305801' },
  { value: 'kishangarh-bypass', label: 'Kishangarh Bypass', pincode: '305802' },
  { value: 'madhav-nagar', label: 'Madhav Nagar', pincode: '305802' },
  { value: 'mahesh-nagar', label: 'Mahesh Nagar', pincode: '305802' },
  { value: 'mali-mohalla', label: 'Mali Mohalla', pincode: '305802' },
  { value: 'mehandipur-balaji-road', label: 'Mehandipur Balaji Road', pincode: '305802' },
  { value: 'nagarpalika-road', label: 'Nagarpalika Road', pincode: '305802' },
  { value: 'naya-bazar', label: 'Naya Bazar', pincode: '305802' },
  { value: 'new-vivekananda-nagar', label: 'New Vivekananda Nagar', pincode: '305802' },
  { value: 'paharia', label: 'Paharia', pincode: '305802' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '305802' },
  { value: 'rampura', label: 'Rampura', pincode: '305802' },
  { value: 'ratanpura', label: 'Ratanpura', pincode: '305802' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '305802' },
  { value: 'sanganer-road', label: 'Sanganer Road', pincode: '305802' },
  { value: 'saradhana-road', label: 'Saradhana Road', pincode: '305802' },
  { value: 'shakti-nagar', label: 'Shakti Nagar', pincode: '305802' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '305802' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '305802' },
  { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '305802' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '305802' },
  { value: 'vivekananda-nagar', label: 'Vivekananda Nagar', pincode: '305802' }
  ],

  'chittorgarh': [
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '312001' },
  { value: 'badi-sadri', label: 'Badi Sadri', pincode: '312403' },
  { value: 'bassi', label: 'Bassi', pincode: '312022' },
  { value: 'bhilwara-road', label: 'Bhilwara Road', pincode: '312001' },
  { value: 'chanderiya', label: 'Chanderiya', pincode: '312021' },
  { value: 'chittorgarh-fort', label: 'Chittorgarh Fort', pincode: '312001' },
  { value: 'dhamotar', label: 'Dhamotar', pincode: '312602' },
  { value: 'fatehnagar-road', label: 'Fatehnagar Road', pincode: '312001' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '312001' },
  { value: 'ghantaghar', label: 'Ghantaghar', pincode: '312001' },
  { value: 'govind-nagar', label: 'Govind Nagar', pincode: '312001' },
  { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '312001' },
  { value: 'indira-nagar', label: 'Indira Nagar', pincode: '312001' },
  { value: 'jain-colony', label: 'Jain Colony', pincode: '312001' },
  { value: 'kumbha-nagar', label: 'Kumbha Nagar', pincode: '312001' },
  { value: 'lok-milan-colony', label: 'Lok Milan Colony', pincode: '312001' },
  { value: 'mahesh-nagar', label: 'Mahesh Nagar', pincode: '312001' },
  { value: 'mandalgarh-road', label: 'Mandalgarh Road', pincode: '312001' },
  { value: 'meera-nagar', label: 'Meera Nagar', pincode: '312001' },
  { value: 'nagarpalika-road', label: 'Nagarpalika Road', pincode: '312001' },
  { value: 'nehru-bazar', label: 'Nehru Bazar', pincode: '312001' },
  { value: 'padmini-marg', label: 'Padmini Marg', pincode: '312001' },
  { value: 'pratap-nagar', label: 'Pratap Nagar', pincode: '312001' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '312001' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '312001' },
  { value: 'rampol', label: 'Rampol', pincode: '312001' },
  { value: 'rawatbhata', label: 'Rawatbhata', pincode: '323307' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '312001' },
  { value: 'santosh-colony', label: 'Santosh Colony', pincode: '312001' },
  { value: 'sarangpur', label: 'Sarangpur', pincode: '312022' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '312001' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '312001' },
  { value: 'shrinath-nagar', label: 'Shrinath Nagar', pincode: '312001' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '312001' },
  { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '312001' },
  { value: 'udaipur-road', label: 'Udaipur Road', pincode: '312001' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '312001' },
  { value: 'vivekananda-nagar', label: 'Vivekananda Nagar', pincode: '312001' }
  ],

  'bundi': [
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '323001' },
  { value: 'balchand-pada', label: 'Balchand Pada', pincode: '323001' },
  { value: 'bundi-fort', label: 'Bundi Fort', pincode: '323001' },
  { value: 'chawani-bazaar', label: 'Chawani Bazaar', pincode: '323001' },
  { value: 'chhawani', label: 'Chhawani', pincode: '323001' },
  { value: 'dhan-mandi', label: 'Dhan Mandi', pincode: '323001' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '323001' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '323001' },
  { value: 'ghantaghar', label: 'Ghantaghar', pincode: '323001' },
  { value: 'govind-nagar', label: 'Govind Nagar', pincode: '323001' },
  { value: 'hanuman-colony', label: 'Hanuman Colony', pincode: '323001' },
  { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '323001' },
  { value: 'indira-market', label: 'Indira Market', pincode: '323001' },
  { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '323001' },
  { value: 'keshav-nagar', label: 'Keshav Nagar', pincode: '323001' },
  { value: 'kota-road', label: 'Kota Road', pincode: '323001' },
  { value: 'krishna-colony', label: 'Krishna Colony', pincode: '323001' },
  { value: 'lanka-gate', label: 'Lanka Gate', pincode: '323001' },
  { value: 'mahavir-nagar', label: 'Mahavir Nagar', pincode: '323001' },
  { value: 'meera-nagar', label: 'Meera Nagar', pincode: '323001' },
  { value: 'nayapura', label: 'Nayapura', pincode: '323001' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '323001' },
  { value: 'rajat-grah', label: 'Rajat Grah', pincode: '323001' },
  { value: 'ramganj', label: 'Ramganj', pincode: '323001' },
  { value: 'rampura', label: 'Rampura', pincode: '323001' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '323001' },
  { value: 'santosh-colony', label: 'Santosh Colony', pincode: '323001' },
  { value: 'sarv-ritu-vihar', label: 'Sarv Ritu Vihar', pincode: '323001' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '323001' },
  { value: 'shivaji-colony', label: 'Shivaji Colony', pincode: '323001' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '323001' },
  { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '323001' },
  { value: 'udaipur-road', label: 'Udaipur Road', pincode: '323001' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '323001' },
  { value: 'vivekananda-nagar', label: 'Vivekananda Nagar', pincode: '323001' }
  ],

  'gangapur': [
  { value: 'ashok-vihar', label: 'Ashok Vihar', pincode: '322201' },
  { value: 'bada-bazar', label: 'Bada Bazar', pincode: '322201' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '322201' },
  { value: 'chand-pol', label: 'Chand Pol', pincode: '322201' },
  { value: 'chungi-naka', label: 'Chungi Naka', pincode: '322202' },
  { value: 'dev-nagar', label: 'Dev Nagar', pincode: '322201' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '322202' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '322201' },
  { value: 'govind-nagar', label: 'Govind Nagar', pincode: '322201' },
  { value: 'hanuman-nagar', label: 'Hanuman Nagar', pincode: '322201' },
  { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '322201' },
  { value: 'indira-market', label: 'Indira Market', pincode: '322201' },
  { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '322201' },
  { value: 'keshav-vihar', label: 'Keshav Vihar', pincode: '322201' },
  { value: 'krishna-colony', label: 'Krishna Colony', pincode: '322201' },
  { value: 'mahavir-nagar', label: 'Mahavir Nagar', pincode: '322201' },
  { value: 'meera-nagar', label: 'Meera Nagar', pincode: '322201' },
  { value: 'nehru-colony', label: 'Nehru Colony', pincode: '322201' },
  { value: 'pipal-mandi', label: 'Pipal Mandi', pincode: '322201' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '322201' },
  { value: 'rampura', label: 'Rampura', pincode: '322202' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '322201' },
  { value: 'sanjay-nagar', label: 'Sanjay Nagar', pincode: '322201' },
  { value: 'santosh-colony', label: 'Santosh Colony', pincode: '322201' },
  { value: 'sarvoday-colony', label: 'Sarvoday Colony', pincode: '322201' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '322201' },
  { value: 'shivaji-colony', label: 'Shivaji Colony', pincode: '322201' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '322201' },
  { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '322201' },
  { value: 'udaipur-road', label: 'Udaipur Road', pincode: '322201' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '322201' },
  { value: 'vivekananda-nagar', label: 'Vivekananda Nagar', pincode: '322201' }
  ],

  'sujangarh': [
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '331507' },
  { value: 'bada-bazar', label: 'Bada Bazar', pincode: '331507' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '331507' },
  { value: 'chand-pol', label: 'Chand Pol', pincode: '331507' },
  { value: 'churu-road', label: 'Churu Road', pincode: '331507' },
  { value: 'dhan-mandi', label: 'Dhan Mandi', pincode: '331507' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '331507' },
  { value: 'ghantaghar', label: 'Ghantaghar', pincode: '331507' },
  { value: 'govind-nagar', label: 'Govind Nagar', pincode: '331507' },
  { value: 'hanuman-colony', label: 'Hanuman Colony', pincode: '331507' },
  { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '331507' },
  { value: 'indira-market', label: 'Indira Market', pincode: '331507' },
  { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '331507' },
  { value: 'keshav-nagar', label: 'Keshav Nagar', pincode: '331507' },
  { value: 'krishna-colony', label: 'Krishna Colony', pincode: '331507' },
  { value: 'mahadev-basti', label: 'Mahadev Basti', pincode: '331507' },
  { value: 'mahavir-nagar', label: 'Mahavir Nagar', pincode: '331507' },
  { value: 'meera-nagar', label: 'Meera Nagar', pincode: '331507' },
  { value: 'moti-bazar', label: 'Moti Bazar', pincode: '331507' },
  { value: 'nehru-bazaar', label: 'Nehru Bazaar', pincode: '331507' },
  { value: 'panchwati', label: 'Panchwati', pincode: '331507' },
  { value: 'pipal-mandi', label: 'Pipal Mandi', pincode: '331507' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '331507' },
  { value: 'rampura', label: 'Rampura', pincode: '331507' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '331507' },
  { value: 'sanjay-colony', label: 'Sanjay Colony', pincode: '331507' },
  { value: 'sarvoday-nagar', label: 'Sarvoday Nagar', pincode: '331507' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '331507' },
  { value: 'shivaji-colony', label: 'Shivaji Colony', pincode: '331507' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '331507' },
  { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '331507' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '331507' },
  { value: 'vivekananda-nagar', label: 'Vivekananda Nagar', pincode: '331507' }
  ],

  'nagaur': [
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '341001' },
  { value: 'bada-bazar', label: 'Bada Bazar', pincode: '341001' },
  { value: 'balaji-colony', label: 'Balaji Colony', pincode: '341001' },
  { value: 'banshi-nagar', label: 'Banshi Nagar', pincode: '341001' },
  { value: 'chand-pol', label: 'Chand Pol', pincode: '341001' },
  { value: 'chhawani', label: 'Chhawani', pincode: '341001' },
  { value: 'dhan-mandi', label: 'Dhan Mandi', pincode: '341001' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '341001' },
  { value: 'ghantaghar', label: 'Ghantaghar', pincode: '341001' },
  { value: 'govind-nagar', label: 'Govind Nagar', pincode: '341001' },
  { value: 'hanuman-basti', label: 'Hanuman Basti', pincode: '341001' },
  { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '341001' },
  { value: 'indira-market', label: 'Indira Market', pincode: '341001' },
  { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '341001' },
  { value: 'keshav-nagar', label: 'Keshav Nagar', pincode: '341001' },
  { value: 'krishna-colony', label: 'Krishna Colony', pincode: '341001' },
  { value: 'mahavir-nagar', label: 'Mahavir Nagar', pincode: '341001' },
  { value: 'meera-colony', label: 'Meera Colony', pincode: '341001' },
  { value: 'nehru-bazaar', label: 'Nehru Bazaar', pincode: '341001' },
  { value: 'panchwati', label: 'Panchwati', pincode: '341001' },
  { value: 'pipal-basti', label: 'Pipal Basti', pincode: '341001' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '341001' },
  { value: 'rampura', label: 'Rampura', pincode: '341001' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '341001' },
  { value: 'sanjay-colony', label: 'Sanjay Colony', pincode: '341001' },
  { value: 'sarvoday-nagar', label: 'Sarvoday Nagar', pincode: '341001' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '341001' },
  { value: 'shivaji-colony', label: 'Shivaji Colony', pincode: '341001' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '341001' },
  { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '341001' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '341001' },
  { value: 'vivekananda-nagar', label: 'Vivekananda Nagar', pincode: '341001' }
  ],

  'jaisalmer': [
  { value: 'amar-sagar', label: 'Amar Sagar', pincode: '345001' },
  { value: 'ashok-colony', label: 'Ashok Colony', pincode: '345001' },
  { value: 'bada-bagh', label: 'Bada Bagh', pincode: '345001' },
  { value: 'badabasti', label: 'Badabasti', pincode: '345001' },
  { value: 'chand-pol', label: 'Chand Pol', pincode: '345001' },
  { value: 'chandraprakash-colony', label: 'Chandraprakash Colony', pincode: '345001' },
  { value: 'dedansar-road', label: 'Dedansar Road', pincode: '345001' },
  { value: 'fort-road', label: 'Fort Road', pincode: '345001' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '345001' },
  { value: 'ghantaghar', label: 'Ghantaghar', pincode: '345001' },
  { value: 'govind-nagar', label: 'Govind Nagar', pincode: '345001' },
  { value: 'hanuman-chowk', label: 'Hanuman Chowk', pincode: '345001' },
  { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '345001' },
  { value: 'indira-colony', label: 'Indira Colony', pincode: '345001' },
  { value: 'jawahar-colony', label: 'Jawahar Colony', pincode: '345001' },
  { value: 'jethwai-road', label: 'Jethwai Road', pincode: '345001' },
  { value: 'khabha', label: 'Khabha', pincode: '345001' },
  { value: 'kuldhara', label: 'Kuldhara', pincode: '345001' },
  { value: 'maheshwari-colony', label: 'Maheshwari Colony', pincode: '345001' },
  { value: 'meera-nagar', label: 'Meera Nagar', pincode: '345001' },
  { value: 'mool-sagar', label: 'Mool Sagar', pincode: '345001' },
  { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '345001' },
  { value: 'panchvati', label: 'Panchvati', pincode: '345001' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '345001' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '345001' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '345001' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '345001' },
  { value: 'shiv-road', label: 'Shiv Road', pincode: '345001' },
  { value: 'shivaji-colony', label: 'Shivaji Colony', pincode: '345001' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '345001' },
  { value: 'sunset-point', label: 'Sunset Point', pincode: '345001' },
  { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '345001' },
  { value: 'udaipur-road', label: 'Udaipur Road', pincode: '345001' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '345001' },
  { value: 'vivekananda-nagar', label: 'Vivekananda Nagar', pincode: '345001' }
  ],

  'churu': [
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '331001' },
  { value: 'bada-bazar', label: 'Bada Bazar', pincode: '331001' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '331001' },
  { value: 'chand-pol', label: 'Chand Pol', pincode: '331001' },
  { value: 'churu-bypass', label: 'Churu Bypass', pincode: '331001' },
  { value: 'dhan-mandi', label: 'Dhan Mandi', pincode: '331001' },
  { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '331001' },
  { value: 'ghantaghar', label: 'Ghantaghar', pincode: '331001' },
  { value: 'govind-nagar', label: 'Govind Nagar', pincode: '331001' },
  { value: 'hanuman-colony', label: 'Hanuman Colony', pincode: '331001' },
  { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '331001' },
  { value: 'indira-market', label: 'Indira Market', pincode: '331001' },
  { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '331001' },
  { value: 'keshav-nagar', label: 'Keshav Nagar', pincode: '331001' },
  { value: 'krishna-colony', label: 'Krishna Colony', pincode: '331001' },
  { value: 'laxmi-nagar', label: 'Laxmi Nagar', pincode: '331001' },
  { value: 'mahadev-basti', label: 'Mahadev Basti', pincode: '331001' },
  { value: 'mahavir-nagar', label: 'Mahavir Nagar', pincode: '331001' },
  { value: 'meera-nagar', label: 'Meera Nagar', pincode: '331001' },
  { value: 'moti-bazar', label: 'Moti Bazar', pincode: '331001' },
  { value: 'nehru-bazaar', label: 'Nehru Bazaar', pincode: '331001' },
  { value: 'panchwati', label: 'Panchwati', pincode: '331001' },
  { value: 'pipal-mandi', label: 'Pipal Mandi', pincode: '331001' },
  { value: 'railway-colony', label: 'Railway Colony', pincode: '331001' },
  { value: 'rampura', label: 'Rampura', pincode: '331001' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '331001' },
  { value: 'sanjay-colony', label: 'Sanjay Colony', pincode: '331001' },
  { value: 'sarvoday-nagar', label: 'Sarvoday Nagar', pincode: '331001' },
  { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '331001' },
  { value: 'shivaji-colony', label: 'Shivaji Colony', pincode: '331001' },
  { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '331001' },
  { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '331001' },
  { value: 'udaipurwati-road', label: 'Udaipurwati Road', pincode: '331001' },
  { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '331001' },
  { value: 'vivekananda-nagar', label: 'Vivekananda Nagar', pincode: '331001' }
  ],

  'jhunjhunu': [
  { value: 'chirawa', label: 'Chirawa', pincode: '333026' },
  { value: 'garh-mukteshwar', label: 'Garh Mukteshwar', pincode: '333303' },
  { value: 'jhun-jhunu', label: 'Jhunjhunu', pincode: '333001' },
  { value: 'khetri', label: 'Khetri', pincode: '333503' },
  { value: 'loharia', label: 'Loharia', pincode: '333023' },
  { value: 'mandawa', label: 'Mandawa', pincode: '333704' },
  { value: 'nawalgarh', label: 'Nawalgarh', pincode: '333042' },
  { value: 'pilani', label: 'Pilani', pincode: '333031' },
  { value: 'udaipurwati', label: 'Udaipurwati', pincode: '333307' },
  { value: 'bissau', label: 'Bissau', pincode: '333506' },
  { value: 'sujangarh', label: 'Sujangarh', pincode: '333515' },
  { value: 'dungar-garh', label: 'Dungar Garh', pincode: '333516' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '333021' },
  { value: 'gadhwa', label: 'Gadhwa', pincode: '333504' },
  { value: 'khetripur', label: 'Khetripur', pincode: '333502' },
  { value: 'malai-khera', label: 'Malai Khera', pincode: '333033' },
  { value: 'surajgarh', label: 'Surajgarh', pincode: '333216' },
  { value: 'reengus', label: 'Reengus', pincode: '333027' },
  { value: 'palsana', label: 'Palsana', pincode: '333223' }
  ],
 
 'jhalawar': [
  { value: 'abadpura', label: 'Abadpura', pincode: '326002' },
  { value: 'bagdara', label: 'Bagdara', pincode: '326014' },
  { value: 'bhawani-mandi', label: 'Bhawani Mandi', pincode: '326502' },
  { value: 'bhonri', label: 'Bhonri', pincode: '326021' },
  { value: 'chanpur', label: 'Chanpur', pincode: '326519' },
  { value: 'dhanora', label: 'Dhanora', pincode: '326524' },
  { value: 'jhalawar', label: 'Jhalawar', pincode: '326001' },
  { value: 'khatamba', label: 'Khatamba', pincode: '326523' },
  { value: 'manoharpura', label: 'Manoharpura', pincode: '326014' },
  { value: 'patan', label: 'Patan', pincode: '326512' },
  { value: 'ramganjmandi', label: 'Ramganjmandi', pincode: '326519' },
  { value: 'shahabad', label: 'Shahabad', pincode: '326021' },
  { value: 'sindhri', label: 'Sindhri', pincode: '326528' },
  { value: 'sunel', label: 'Sunel', pincode: '326037' },
  { value: 'village-tonk', label: 'Village Tonk', pincode: '326529' },
  { value: 'bhainsrodgarh', label: 'Bhainsrodgarh', pincode: '326023' },
  { value: 'jhalrapatan', label: 'Jhalrapatan', pincode: '326023' },
  { value: 'khajuri', label: 'Khajuri', pincode: '326004' },
  { value: 'damoh', label: 'Damoh', pincode: '326519' },
  { value: 'aligarh', label: 'Aligarh', pincode: '326503' }
  ],

  'barmer': [
  { value: 'balotra', label: 'Balotra', pincode: '344022' },
  { value: 'barmer', label: 'Barmer', pincode: '344001' },
  { value: 'baytoo', label: 'Baytoo', pincode: '344022' },
  { value: 'bhinmal', label: 'Bhinmal', pincode: '343029' },
  { value: 'jethrana', label: 'Jethrana', pincode: '344702' },
  { value: 'jodhpur', label: 'Jodhpur', pincode: '344001' },
  { value: 'kachchh', label: 'Kachchh', pincode: '344027' },
  { value: 'kachhuwala', label: 'Kachhuwala', pincode: '344025' },
  { value: 'pachpadra', label: 'Pachpadra', pincode: '344303' },
  { value: 'ramdevra', label: 'Ramdevra', pincode: '344701' },
  { value: 'sindhari', label: 'Sindhari', pincode: '344035' },
  { value: 'singhraj', label: 'Singhraj', pincode: '344024' },
  { value: 'sorpan', label: 'Sorpan', pincode: '344707' },
  { value: 'sudama', label: 'Sudama', pincode: '344302' },
  { value: 'tanot', label: 'Tanot', pincode: '344012' },
  { value: 'uncha', label: 'Uncha', pincode: '344104' },
  { value: 'mohangarh', label: 'Mohangarh', pincode: '344801' },
  { value: 'maliwas', label: 'Maliwas', pincode: '344102' },
  { value: 'kolayat', label: 'Kolayat', pincode: '344302' },
  { value: 'khed', label: 'Khed', pincode: '344027' },
  { value: 'karlan', label: 'Karlan', pincode: '344203' },
  { value: 'ranpura', label: 'Ranpura', pincode: '344701' },
  { value: 'palri', label: 'Palri', pincode: '344604' },
  { value: 'kundan', label: 'Kundan', pincode: '344204' },
  { value: 'dhanana', label: 'Dhanana', pincode: '344404' }
  ],

   'karauli': [
  { value: 'agar', label: 'Agar', pincode: '322215' },
  { value: 'balaran', label: 'Balaran', pincode: '322222' },
  { value: 'bamanwas', label: 'Bamanwas', pincode: '322213' },
  { value: 'bhindora', label: 'Bhindora', pincode: '322209' },
  { value: 'dhakad', label: 'Dhakad', pincode: '322211' },
  { value: 'gopalpura', label: 'Gopalpura', pincode: '322206' },
  { value: 'karauli', label: 'Karauli', pincode: '322241' },
  { value: 'kherli', label: 'Kherli', pincode: '322202' },
  { value: 'kundal', label: 'Kundal', pincode: '322211' },
  { value: 'mandrayal', label: 'Mandrayal', pincode: '322205' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '322214' },
  { value: 'pachonda', label: 'Pachonda', pincode: '322226' },
  { value: 'ramganj', label: 'Ramganj', pincode: '322207' },
  { value: 'sultanpur', label: 'Sultanpur', pincode: '322205' },
  { value: 'tonk', label: 'Tonk', pincode: '322101' },
  { value: 'dholpur', label: 'Dholpur', pincode: '322001' },
  { value: 'naikhera', label: 'Naikhera', pincode: '322207' },
  { value: 'bindayaka', label: 'Bindayaka', pincode: '322202' },
  { value: 'pachar', label: 'Pachar', pincode: '322221' },
  { value: 'balapura', label: 'Balapura', pincode: '322222' }
  ],

  'rajsamand': [
  { value: 'adasa', label: 'Adasa', pincode: '313324' },
  { value: 'arjia', label: 'Arjia', pincode: '313329' },
  { value: 'badi', label: 'Badi', pincode: '313333' },
  { value: 'bhinder', label: 'Bhinder', pincode: '313603' },
  { value: 'bhuvneshwar', label: 'Bhuvneshwar', pincode: '313214' },
  { value: 'hiranmagri', label: 'Hiranmagri', pincode: '313001' },
  { value: 'kanod', label: 'Kanod', pincode: '313331' },
  { value: 'kotda', label: 'Kotda', pincode: '313331' },
  { value: 'kumbhalgarh', label: 'Kumbhalgarh', pincode: '313325' },
  { value: 'lakha', label: 'Lakha', pincode: '313324' },
  { value: 'nathdwara', label: 'Nathdwara', pincode: '313301' },
  { value: 'rajsamand', label: 'Rajsamand', pincode: '313324' },
  { value: 'remeta', label: 'Remeta', pincode: '313332' },
  { value: 'salumber', label: 'Salumber', pincode: '313027' },
  { value: 'sirohi', label: 'Sirohi', pincode: '313401' },
  { value: 'udeepur', label: 'Udeepur', pincode: '313022' },
  { value: 'kankroli', label: 'Kankroli', pincode: '313324' },
  { value: 'vijaynagar', label: 'Vijaynagar', pincode: '313208' },
  { value: 'godwad', label: 'Godwad', pincode: '313202' },
  { value: 'bhindar', label: 'Bhindar', pincode: '313304' },
  { value: 'chitalwana', label: 'Chitalwana', pincode: '313706' },
  { value: 'doongri', label: 'Doongri', pincode: '313026' },
  { value: 'kamblani', label: 'Kamblani', pincode: '313303' },
  { value: 'kunda', label: 'Kunda', pincode: '313212' },
  { value: 'mangrol', label: 'Mangrol', pincode: '313322' },
  { value: 'piplas', label: 'Piplas', pincode: '313008' }
  ],

 'jalor': [
  { value: 'abhaypura', label: 'Abhaypura', pincode: '343001' },
  { value: 'balwara', label: 'Balwara', pincode: '343022' },
  { value: 'bhinmal', label: 'Bhinmal', pincode: '343029' },
  { value: 'chandpur', label: 'Chandpur', pincode: '343035' },
  { value: 'dhanera', label: 'Dhanera', pincode: '343023' },
  { value: 'jalore', label: 'Jalore', pincode: '343001' },
  { value: 'kanpura', label: 'Kanpura', pincode: '343028' },
  { value: 'kishanpura', label: 'Kishanpura', pincode: '343038' },
  { value: 'mankuwala', label: 'Mankuwala', pincode: '343034' },
  { value: 'patan', label: 'Patan', pincode: '343022' },
  { value: 'ramdevpura', label: 'Ramdevpura', pincode: '343016' },
  { value: 'samdari', label: 'Samdari', pincode: '343204' },
  { value: 'sindri', label: 'Sindri', pincode: '343027' },
  { value: 'sirohi', label: 'Sirohi', pincode: '343001' },
  { value: 'thudi', label: 'Thudi', pincode: '343028' },
  { value: 'vijaypura', label: 'Vijaypura', pincode: '343037' },
  { value: 'banetha', label: 'Banetha', pincode: '343035' },
  { value: 'chopra', label: 'Chopra', pincode: '343038' },
  { value: 'salwa', label: 'Salwa', pincode: '343003' },
  { value: 'sangaria', label: 'Sangaria', pincode: '343037' },
  { value: 'badi', label: 'Badi', pincode: '343211' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '343203' },
  { value: 'kishanpura', label: 'Kishanpura', pincode: '343217' },
  { value: 'mahir', label: 'Mahir', pincode: '343011' },
  { value: 'sarada', label: 'Sarada', pincode: '343037' },
  { value: 'sirohi-bhuwana', label: 'Sirohi Bhuwana', pincode: '343101' },
  { value: 'surajpura', label: 'Surajpura', pincode: '343229' },
  { value: 'chandri', label: 'Chandri', pincode: '343042' }
  ],

'dausa': [
  { value: 'agrah', label: 'Agrah', pincode: '303303' },
  { value: 'bada', label: 'Bada', pincode: '303302' },
  { value: 'banskhera', label: 'Banskhera', pincode: '303303' },
  { value: 'badka', label: 'Badka', pincode: '303318' },
  { value: 'bansur', label: 'Bansur', pincode: '303701' },
  { value: 'dausa', label: 'Dausa', pincode: '303303' },
  { value: 'dariyawad', label: 'Dariyawad', pincode: '303305' },
  { value: 'jagir', label: 'Jagir', pincode: '303309' },
  { value: 'jaitpura', label: 'Jaitpura', pincode: '303313' },
  { value: 'kalpura', label: 'Kalpura', pincode: '303306' },
  { value: 'keshwana', label: 'Keshwana', pincode: '303310' },
  { value: 'kothon', label: 'Kothon', pincode: '303308' },
  { value: 'malpura', label: 'Malpura', pincode: '303307' },
  { value: 'pachkhura', label: 'Pachkhura', pincode: '303315' },
  { value: 'pachkheda', label: 'Pachkheda', pincode: '303314' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '303312' },
  { value: 'sankara', label: 'Sankara', pincode: '303320' },
  { value: 'sindra', label: 'Sindra', pincode: '303311' },
  { value: 'tadkeshwar', label: 'Tadkeshwar', pincode: '303316' },
  { value: 'vijaypura', label: 'Vijaypura', pincode: '303317' },
  { value: 'barauli', label: 'Barauli', pincode: '303316' },
  { value: 'bhagalpur', label: 'Bhagalpur', pincode: '303304' },
  { value: 'dholapur', label: 'Dholapur', pincode: '303322' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '303302' },
  { value: 'ganeshpura', label: 'Ganeshpura', pincode: '303308' },
  { value: 'gopalpura', label: 'Gopalpura', pincode: '303319' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '303309' },
  { value: 'mohammadpura', label: 'Mohammadpura', pincode: '303301' },
  { value: 'palpur', label: 'Palpur', pincode: '303317' }
  ],

  'salumbar': [
  { value: 'achalpur', label: 'Achalpur', pincode: '313027' },
  { value: 'badi', label: 'Badi', pincode: '313202' },
  { value: 'bhayla', label: 'Bhayla', pincode: '313302' },
  { value: 'bhinder', label: 'Bhinder', pincode: '313301' },
  { value: 'chandpur', label: 'Chandpur', pincode: '313305' },
  { value: 'chitalwana', label: 'Chitalwana', pincode: '313704' },
  { value: 'dainyani', label: 'Dainyani', pincode: '313203' },
  { value: 'dungarpura', label: 'Dungarpura', pincode: '313308' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '313302' },
  { value: 'goriyan', label: 'Goriyan', pincode: '313331' },
  { value: 'jaitpura', label: 'Jaitpura', pincode: '313202' },
  { value: 'kamari', label: 'Kamari', pincode: '313305' },
  { value: 'karnawati', label: 'Karnawati', pincode: '313304' },
  { value: 'kothan', label: 'Kothan', pincode: '313312' },
  { value: 'maliyo', label: 'Maliyo', pincode: '313203' },
  { value: 'mandap', label: 'Mandap', pincode: '313210' },
  { value: 'pachkhura', label: 'Pachkhura', pincode: '313206' },
  { value: 'piplas', label: 'Piplas', pincode: '313212' },
  { value: 'salumbar', label: 'Salumbar', pincode: '313027' },
  { value: 'samdari', label: 'Samdari', pincode: '313203' },
  { value: 'sarada', label: 'Sarada', pincode: '313213' },
  { value: 'sirohi', label: 'Sirohi', pincode: '313001' },
  { value: 'sirohi-modi', label: 'Sirohi Modi', pincode: '313223' },
  { value: 'surpura', label: 'Surpura', pincode: '313208' },
  { value: 'udaypur', label: 'Udaypur', pincode: '313313' },
  { value: 'badi-khushali', label: 'Badi Khushali', pincode: '313205' },
  { value: 'bhodi', label: 'Bhodi', pincode: '313217' },
  { value: 'chawand', label: 'Chawand', pincode: '313209' },
  { value: 'dedra', label: 'Dedra', pincode: '313301' },
  { value: 'kanod', label: 'Kanod', pincode: '313319' },
  { value: 'mendla', label: 'Mendla', pincode: '313303' },
  { value: 'sadar', label: 'Sadar', pincode: '313216' },
  { value: 'tihra', label: 'Tihra', pincode: '313302' }
  ],

  'pushkar': [
  { value: 'achhrol', label: 'Achhrol', pincode: '305001' },
  { value: 'bagri', label: 'Bagri', pincode: '305022' },
  { value: 'banegaon', label: 'Banegaon', pincode: '305025' },
  { value: 'bari', label: 'Bari', pincode: '305022' },
  { value: 'bawal', label: 'Bawal', pincode: '305023' },
  { value: 'chawandi', label: 'Chawandi', pincode: '305022' },
  { value: 'gagari', label: 'Gagari', pincode: '305022' },
  { value: 'ghoraji', label: 'Ghoraji', pincode: '305022' },
  { value: 'jhunjhunu', label: 'Jhunjhunu', pincode: '305022' },
  { value: 'kalvi', label: 'Kalvi', pincode: '305022' },
  { value: 'khodki', label: 'Khodki', pincode: '305022' },
  { value: 'mangarh', label: 'Mangarh', pincode: '305022' },
  { value: 'pushkar', label: 'Pushkar', pincode: '305022' },
  { value: 'rajmandi', label: 'Rajmandi', pincode: '305022' },
  { value: 'ramgund', label: 'Ramgund', pincode: '305022' },
  { value: 'salamabad', label: 'Salamabad', pincode: '305022' },
  { value: 'shergarh', label: 'Shergarh', pincode: '305022' },
  { value: 'soni', label: 'Soni', pincode: '305022' },
  { value: 'talwada', label: 'Talwada', pincode: '305022' },
  { value: 'udaipura', label: 'Udaipura', pincode: '305022' },
  { value: 'babri', label: 'Babri', pincode: '305022' },
  { value: 'chandkhuri', label: 'Chandkhuri', pincode: '305023' },
  { value: 'dholi', label: 'Dholi', pincode: '305025' },
  { value: 'kherwa', label: 'Kherwa', pincode: '305024' },
  { value: 'kundali', label: 'Kundali', pincode: '305026' },
  { value: 'mau', label: 'Mau', pincode: '305021' },
  { value: 'nadiyad', label: 'Nadiyad', pincode: '305029' },
  { value: 'pachar', label: 'Pachar', pincode: '305021' },
  { value: 'rajpura', label: 'Rajpura', pincode: '305022' },
  { value: 'soni', label: 'Soni', pincode: '305022' }
  ],

  'didwana': [
  { value: 'alampura', label: 'Alampura', pincode: '341303' },
  { value: 'balundra', label: 'Balundra', pincode: '341303' },
  { value: 'bariyani', label: 'Bariyani', pincode: '341305' },
  { value: 'bhankri', label: 'Bhankri', pincode: '341307' },
  { value: 'bhamwa', label: 'Bhamwa', pincode: '341308' },
  { value: 'chandela', label: 'Chandela', pincode: '341308' },
  { value: 'chandpur', label: 'Chandpur', pincode: '341306' },
  { value: 'didwana', label: 'Didwana', pincode: '341303' },
  { value: 'dudhwali', label: 'Dudhwali', pincode: '341310' },
  { value: 'gadia', label: 'Gadia', pincode: '341304' },
  { value: 'jhotwara', label: 'Jhotwara', pincode: '341315' },
  { value: 'khasapura', label: 'Khasapura', pincode: '341309' },
  { value: 'khudwana', label: 'Khudwana', pincode: '341311' },
  { value: 'kishanpura', label: 'Kishanpura', pincode: '341312' },
  { value: 'mahipura', label: 'Mahipura', pincode: '341317' },
  { value: 'manakpura', label: 'Manakpura', pincode: '341318' },
  { value: 'mangalpura', label: 'Mangalpura', pincode: '341316' },
  { value: 'nangal', label: 'Nangal', pincode: '341319' },
  { value: 'pachwara', label: 'Pachwara', pincode: '341320' },
  { value: 'rajsinghpura', label: 'Rajsinghpura', pincode: '341321' },
  { value: 'sindri', label: 'Sindri', pincode: '341322' },
  { value: 'tukra', label: 'Tukra', pincode: '341323' },
  { value: 'wajirpura', label: 'Wajirpura', pincode: '341324' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '341325' },
  { value: 'dholi', label: 'Dholi', pincode: '341326' },
  { value: 'sahpura', label: 'Sahpura', pincode: '341327' }
  ],

  'sirohi': [
  { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '307001' },
  { value: 'bairat', label: 'Bairat', pincode: '307001' },
  { value: 'balapur', label: 'Balapur', pincode: '307001' },
  { value: 'banar', label: 'Banar', pincode: '307001' },
  { value: 'baranjala', label: 'Baranjala', pincode: '307024' },
  { value: 'barna', label: 'Barna', pincode: '307022' },
  { value: 'bavadi', label: 'Bavadi', pincode: '307002' },
  { value: 'dantiwara', label: 'Dantiwara', pincode: '307001' },
  { value: 'jakhri', label: 'Jakhri', pincode: '307001' },
  { value: 'kankra', label: 'Kankra', pincode: '307021' },
  { value: 'kharia', label: 'Kharia', pincode: '307002' },
  { value: 'kheda', label: 'Kheda', pincode: '307004' },
  { value: 'khel', label: 'Khel', pincode: '307020' },
  { value: 'pali', label: 'Pali', pincode: '307011' },
  { value: 'patwadi', label: 'Patwadi', pincode: '307008' },
  { value: 'rampur', label: 'Rampur', pincode: '307023' },
  { value: 'sirohi', label: 'Sirohi', pincode: '307001' },
  { value: 'vankar', label: 'Vankar', pincode: '307009' },
  { value: 'amra', label: 'Amra', pincode: '307012' },
  { value: 'ashapuri', label: 'Ashapuri', pincode: '307014' },
  { value: 'baldara', label: 'Baldara', pincode: '307015' },
  { value: 'baner', label: 'Baner', pincode: '307016' },
  { value: 'bhagal', label: 'Bhagal', pincode: '307017' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '307018' },
  { value: 'godhara', label: 'Godhara', pincode: '307019' },
  { value: 'kosi', label: 'Kosi', pincode: '307025' },
  { value: 'modapura', label: 'Modapura', pincode: '307026' },
  { value: 'sanwara', label: 'Sanwara', pincode: '307027' },
  { value: 'shahpura', label: 'Shahpura', pincode: '307028' }
  ],

  'kotputli': [
  { value: 'adan', label: 'Adan', pincode: '303108' },
  { value: 'alampura', label: 'Alampura', pincode: '303109' },
  { value: 'balwa', label: 'Balwa', pincode: '303108' },
  { value: 'banera', label: 'Banera', pincode: '303106' },
  { value: 'bari', label: 'Bari', pincode: '303106' },
  { value: 'basri', label: 'Basri', pincode: '303103' },
  { value: 'bhagatpura', label: 'Bhagatpura', pincode: '303107' },
  { value: 'bhangroli', label: 'Bhangroli', pincode: '303108' },
  { value: 'chandani', label: 'Chandani', pincode: '303105' },
  { value: 'chhawani', label: 'Chhawani', pincode: '303109' },
  { value: 'dharmpura', label: 'Dharmpura', pincode: '303103' },
  { value: 'gholad', label: 'Gholad', pincode: '303101' },
  { value: 'gundlapura', label: 'Gundlapura', pincode: '303110' },
  { value: 'jagannathpura', label: 'Jagannathpura', pincode: '303111' },
  { value: 'kotputli', label: 'Kotputli', pincode: '303108' },
  { value: 'kushalpura', label: 'Kushalpura', pincode: '303103' },
  { value: 'manpur', label: 'Manpur', pincode: '303106' },
  { value: 'mandhana', label: 'Mandhana', pincode: '303105' },
  { value: 'pachchwara', label: 'Pachchwara', pincode: '303106' },
  { value: 'raju', label: 'Raju', pincode: '303107' },
  { value: 'sahakar', label: 'Sahakar', pincode: '303105' },
  { value: 'shahpura', label: 'Shahpura', pincode: '303104' },
  { value: 'sulabhpura', label: 'Sulabhpura', pincode: '303109' },
  { value: 'talwandi', label: 'Talwandi', pincode: '303107' },
  { value: 'vijaypura', label: 'Vijaypura', pincode: '303112' },
  { value: 'zarkhera', label: 'Zarkhera', pincode: '303113' }
  ],

  'kekri': [
  { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '305404' },
  { value: 'babu-ka-bas', label: 'Babu Ka Bas', pincode: '305404' },
  { value: 'balwa', label: 'Balwa', pincode: '305404' },
  { value: 'banera', label: 'Banera', pincode: '305401' },
  { value: 'bari', label: 'Bari', pincode: '305401' },
  { value: 'bhageerathpura', label: 'Bhageerathpura', pincode: '305404' },
  { value: 'bhagatpura', label: 'Bhagatpura', pincode: '305401' },
  { value: 'bhangroli', label: 'Bhangroli', pincode: '305402' },
  { value: 'chandpura', label: 'Chandpura', pincode: '305403' },
  { value: 'chhawani', label: 'Chhawani', pincode: '305405' },
  { value: 'dadiya', label: 'Dadiya', pincode: '305401' },
  { value: 'gogapura', label: 'Gogapura', pincode: '305402' },
  { value: 'gudur', label: 'Gudur', pincode: '305406' },
  { value: 'kekri', label: 'Kekri', pincode: '305404' },
  { value: 'kushalpura', label: 'Kushalpura', pincode: '305405' },
  { value: 'manpur', label: 'Manpur', pincode: '305401' },
  { value: 'mandhana', label: 'Mandhana', pincode: '305402' },
  { value: 'pachwara', label: 'Pachwara', pincode: '305403' },
  { value: 'raju', label: 'Raju', pincode: '305404' },
  { value: 'sahakar', label: 'Sahakar', pincode: '305406' },
  { value: 'shahpura', label: 'Shahpura', pincode: '305407' },
  { value: 'talwandi', label: 'Talwandi', pincode: '305405' },
  { value: 'vijaypura', label: 'Vijaypura', pincode: '305408' },
  { value: 'bhamla', label: 'Bhamla', pincode: '305410' },
  { value: 'chandni', label: 'Chandni', pincode: '305411' },
  { value: 'gogunda', label: 'Gogunda', pincode: '305412' },
  { value: 'jaitpura', label: 'Jaitpura', pincode: '305413' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '305414' },
  { value: 'khamera', label: 'Khamera', pincode: '305415' },
  { value: 'pachpedi', label: 'Pachpedi', pincode: '305416' },
  { value: 'ranpura', label: 'Ranpura', pincode: '305417' }
  ],

  'ratangarh': [
  { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '331022' },
  { value: 'alampura', label: 'Alampura', pincode: '331023' },
  { value: 'balwa', label: 'Balwa', pincode: '331022' },
  { value: 'banera', label: 'Banera', pincode: '331023' },
  { value: 'bari', label: 'Bari', pincode: '331021' },
  { value: 'bhagatpura', label: 'Bhagatpura', pincode: '331024' },
  { value: 'bhagatwala', label: 'Bhagatwala', pincode: '331022' },
  { value: 'bhangroli', label: 'Bhangroli', pincode: '331025' },
  { value: 'chandpura', label: 'Chandpura', pincode: '331027' },
  { value: 'chhawani', label: 'Chhawani', pincode: '331026' },
  { value: 'dadiya', label: 'Dadiya', pincode: '331028' },
  { value: 'fatehgarh', label: 'Fatehgarh', pincode: '331024' },
  { value: 'gogapura', label: 'Gogapura', pincode: '331029' },
  { value: 'gundlapura', label: 'Gundlapura', pincode: '331030' },
  { value: 'kekri', label: 'Kekri', pincode: '331030' },
  { value: 'kushalpura', label: 'Kushalpura', pincode: '331031' },
  { value: 'manpur', label: 'Manpur', pincode: '331032' },
  { value: 'mandhana', label: 'Mandhana', pincode: '331033' },
  { value: 'pachwara', label: 'Pachwara', pincode: '331034' },
  { value: 'raju', label: 'Raju', pincode: '331035' },
  { value: 'ratangarh', label: 'Ratangarh', pincode: '331001' },
  { value: 'sahakar', label: 'Sahakar', pincode: '331036' },
  { value: 'shahpura', label: 'Shahpura', pincode: '331037' },
  { value: 'shahpura-khurd', label: 'Shahpura Khurd', pincode: '331038' },
  { value: 'talwandi', label: 'Talwandi', pincode: '331039' },
  { value: 'vijaypura', label: 'Vijaypura', pincode: '331040' },
  { value: 'wanpura', label: 'Wanpura', pincode: '331041' },
  { value: 'dhanau', label: 'Dhanau', pincode: '331042' },
  { value: 'makrana', label: 'Makrana', pincode: '331043' },
  { value: 'mohammadpura', label: 'Mohammadpura', pincode: '331044' }
  ],

  'shahpura':  [
  { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '303103' },
  { value: 'balwa', label: 'Balwa', pincode: '303102' },
  { value: 'banera', label: 'Banera', pincode: '303101' },
  { value: 'bari', label: 'Bari', pincode: '303105' },
  { value: 'bhagatpura', label: 'Bhagatpura', pincode: '303104' },
  { value: 'bhankri', label: 'Bhankri', pincode: '303106' },
  { value: 'bhangroli', label: 'Bhangroli', pincode: '303107' },
  { value: 'chandpura', label: 'Chandpura', pincode: '303108' },
  { value: 'chhawani', label: 'Chhawani', pincode: '303109' },
  { value: 'dadiya', label: 'Dadiya', pincode: '303110' },
  { value: 'fatehgarh', label: 'Fatehgarh', pincode: '303111' },
  { value: 'gogapura', label: 'Gogapura', pincode: '303112' },
  { value: 'gudamalani', label: 'Gudamalani', pincode: '303113' },
  { value: 'manpur', label: 'Manpur', pincode: '303114' },
  { value: 'mandhana', label: 'Mandhana', pincode: '303115' },
  { value: 'pachpedi', label: 'Pachpedi', pincode: '303116' },
  { value: 'raju', label: 'Raju', pincode: '303117' },
  { value: 'sahakar', label: 'Sahakar', pincode: '303118' },
  { value: 'shahpura', label: 'Shahpura', pincode: '303119' },
  { value: 'talwandi', label: 'Talwandi', pincode: '303120' },
  { value: 'vijaypura', label: 'Vijaypura', pincode: '303121' },
  { value: 'bhagatwala', label: 'Bhagatwala', pincode: '303122' },
  { value: 'keshavpura', label: 'Keshavpura', pincode: '303123' },
  { value: 'ranipura', label: 'Ranipura', pincode: '303124' },
  { value: 'santoshpura', label: 'Santoshpura', pincode: '303125' },
  { value: 'sujatpura', label: 'Sujatpura', pincode: '303126' },
  { value: 'thakurpura', label: 'Thakurpura', pincode: '303127' },
  { value: 'vishwakarma', label: 'Vishwakarma', pincode: '303128' }
  ],

  'jodhpur': [
    { value: 'airport-road', label: 'Airport Road', pincode: '342037' },
    { value: 'alka-vihar', label: 'Alka Vihar', pincode: '342003' },
    { value: 'arti-nagar', label: 'Arti Nagar', pincode: '342013' },
    { value: 'babasar', label: 'Babasar', pincode: '342003' },
    { value: 'babhaniyon-ka-bass', label: 'Babhaniyon Ka Bass', pincode: '342001' },
    { value: 'bada-mandir', label: 'Bada Mandir', pincode: '342001' },
    { value: 'badiyon-ka-bas', label: 'Badiyon Ka Bas', pincode: '342001' },
    { value: 'bagri-market', label: 'Bagri Market', pincode: '342001' },
    { value: 'bais-godam', label: 'Bais Godam', pincode: '342001' },
    { value: 'balotra', label: 'Balotra', pincode: '342601' },
    { value: 'balkishanpura', label: 'Balkishanpura', pincode: '342011' },
    { value: 'bambora', label: 'Bambora', pincode: '342303' },
    { value: 'barmer-road', label: 'Barmer Road', pincode: '342001' },
    { value: 'bashir-pura', label: 'Bashir Pura', pincode: '342002' },
    { value: 'basni', label: 'Basni', pincode: '342005' },
    { value: 'basni-extension', label: 'Basni Extension', pincode: '342001' },
    { value: 'bawdi', label: 'Bawdi', pincode: '342022' },
    { value: 'bheruji', label: 'Bheruji', pincode: '342025' },
    { value: 'bheruji-ka-bas', label: 'Bheruji Ka Bas', pincode: '342025' },
    { value: 'bhagat-ki-kothi', label: 'Bhagat Ki Kothi', pincode: '342001' },
    { value: 'bhagat-ki-kothi-extension', label: 'Bhagat Ki Kothi Extension', pincode: '342001' },
    { value: 'bhawani-singh-colony', label: 'Bhawani Singh Colony', pincode: '342001' },
    { value: 'bhatta-khera', label: 'Bhatta Khera', pincode: '342002' },
    { value: 'bhurtiya', label: 'Bhurtiya', pincode: '342027' },
    { value: 'bhuri-bhatiyari', label: 'Bhuri Bhatiyari', pincode: '342013' },
    { value: 'chandela', label: 'Chandela', pincode: '342004' },
    { value: 'chandmari', label: 'Chandmari', pincode: '342001' },
    { value: 'chandpole-gate', label: 'Chandpole Gate', pincode: '342001' },
    { value: 'chaugan', label: 'Chaugan', pincode: '342001' },
    { value: 'chopasni', label: 'Chopasni', pincode: '342001' },
    { value: 'chopasni-road', label: 'Chopasni Road', pincode: '342001' },
    { value: 'dhan-mandi', label: 'Dhan Mandi', pincode: '342003' },
    { value: 'dhawa', label: 'Dhawa', pincode: '342003' },
    { value: 'dholi-kheda', label: 'Dholi Kheda', pincode: '342003' },
    { value: 'dudiya-kallan', label: 'Dudiya Kallan', pincode: '342001' },
    { value: 'ganga-sagar', label: 'Ganga Sagar', pincode: '342007' },
    { value: 'ganganagar', label: 'Ganganagar', pincode: '342003' },
    { value: 'ghantaghar', label: 'Ghantaghar', pincode: '342003' },
    { value: 'gulab-sagar', label: 'Gulab Sagar', pincode: '342001' },
    { value: 'gulab-sagar-bazar', label: 'Gulab Sagar Bazar', pincode: '342001' },
    { value: 'gurukul', label: 'Gurukul', pincode: '342003' },
    { value: 'gurudwara', label: 'Gurudwara', pincode: '342003' },
    { value: 'haji-ki-kothi', label: 'Haji Ki Kothi', pincode: '342003' },
    { value: 'hawa-mahal', label: 'Hawa Mahal', pincode: '342002' },
    { value: 'jantanwadi', label: 'Jantanwadi', pincode: '342003' },
    { value: 'jaswantpura', label: 'Jaswantpura', pincode: '342003' },
    { value: 'jhalamand', label: 'Jhalamand', pincode: '342008' },
    { value: 'jhalamand-industrial-area', label: 'Jhalamand Industrial Area', pincode: '342003' },
    { value: 'jhanwar', label: 'Jhanwar', pincode: '342037' },
    { value: 'jharna', label: 'Jharna', pincode: '342027' },
    { value: 'jodhpur-bypass', label: 'Jodhpur Bypass', pincode: '342027' },
    { value: 'jodhpur-development-area', label: 'Jodhpur Development Area', pincode: '342001' },
    { value: 'jodhpur-fort-road', label: 'Jodhpur Fort Road', pincode: '342006' },
    { value: 'jodhpur-industrial-area', label: 'Jodhpur Industrial Area', pincode: '342003' },
    { value: 'jodhpur-marwar', label: 'Jodhpur Marwar', pincode: '342002' },
    { value: 'jodhpur-rural', label: 'Jodhpur Rural', pincode: '342001' },
    { value: 'jodhpur-university', label: 'Jodhpur University', pincode: '342011' },
    { value: 'jodhana', label: 'Jodhana', pincode: '342003' },
    { value: 'kailana', label: 'Kailana', pincode: '342001' },
    { value: 'kailana-lake', label: 'Kailana Lake', pincode: '342001' },
    { value: 'kalyanpura', label: 'Kalyanpura', pincode: '342003' },
    { value: 'kankani', label: 'Kankani', pincode: '342001' },
    { value: 'kanhaiya-nagar', label: 'Kanhaiya Nagar', pincode: '342008' },
    { value: 'karnimata-nagar', label: 'Karnimata Nagar', pincode: '342003' },
    { value: 'kishanpura', label: 'Kishanpura', pincode: '342003' },
    { value: 'kota-road', label: 'Kota Road', pincode: '342001' },
    { value: 'kuchaman', label: 'Kuchaman', pincode: '342801' },
    { value: 'kudi-bhagtasni', label: 'Kudi Bhagtasni', pincode: '342001' },
    { value: 'lal-sagar', label: 'Lal Sagar', pincode: '342001' },
    { value: 'lal-sagar-lake', label: 'Lal Sagar Lake', pincode: '342001' },
    { value: 'loco-colony', label: 'Loco Colony', pincode: '342001' },
    { value: 'mandu-road', label: 'Mandu Road', pincode: '342001' },
    { value: 'mandore-garden', label: 'Mandore Garden', pincode: '342001' },
    { value: 'mandore-road', label: 'Mandore Road', pincode: '342001' },
    { value: 'manak-chowk', label: 'Manak Chowk', pincode: '342001' },
    { value: 'mango-ki-pahadi', label: 'Mango Ki Pahadi', pincode: '342001' },
    { value: 'marwar-junction', label: 'Marwar Junction', pincode: '342002' },
    { value: 'maharana-pratap-nagar', label: 'Maharana Pratap Nagar', pincode: '342008' },
    { value: 'merta-city', label: 'Merta City', pincode: '342021' },
    { value: 'mokalsar', label: 'Mokalsar', pincode: '342003' },
    { value: 'mogra', label: 'Mogra', pincode: '342306' },
    { value: 'moti-katra', label: 'Moti Katra', pincode: '342003' },
    { value: 'mugalwara', label: 'Mugalwara', pincode: '342004' },
    { value: 'murlipura', label: 'Murlipura', pincode: '342003' },
    { value: 'nai-sadak', label: 'Nai Sadak', pincode: '342001' },
    { value: 'nandri', label: 'Nandri', pincode: '342007' },
    { value: 'naya-bazaar', label: 'Naya Bazaar', pincode: '342003' },
    { value: 'naya-mohalla', label: 'Naya Mohalla', pincode: '342001' },
    { value: 'new-pali-road', label: 'New Pali Road', pincode: '342005' },
    { value: 'odhna', label: 'Odhna', pincode: '342003' },
    { value: 'pahadi', label: 'Pahadi', pincode: '342003' },
    { value: 'palanpur', label: 'Palanpur', pincode: '342004' },
    { value: 'pali-road', label: 'Pali Road', pincode: '342005' },
    { value: 'panchla', label: 'Panchla', pincode: '342001' },
    { value: 'pipar-city', label: 'Pipar City', pincode: '342601' },
    { value: 'raghunathpura', label: 'Raghunathpura', pincode: '342003' },
    { value: 'rajendra-nagar', label: 'Rajendra Nagar', pincode: '342003' },
    { value: 'rajiv-nagar', label: 'Rajiv Nagar', pincode: '342003' },
    { value: 'ratanada', label: 'Ratanada', pincode: '342011' },
    { value: 'ratanada-extension', label: 'Ratanada Extension', pincode: '342011' },
    { value: 'rohat', label: 'Rohat', pincode: '342307' },
    { value: 'rohat-road', label: 'Rohat Road', pincode: '342307' },
    { value: 'sadar-bazaar', label: 'Sadar Bazaar', pincode: '342003' },
    { value: 'sadar-market', label: 'Sardar Market', pincode: '342003' },
    { value: 'saraswati-nagar', label: 'Saraswati Nagar', pincode: '342003' },
    { value: 'sardarshahar', label: 'Sardarshahar', pincode: '342001' },
    { value: 'shiv-nagar', label: 'Shiv Nagar', pincode: '342003' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '342003' },
    { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '342003' },
    { value: 'shikargarh', label: 'Shikargarh', pincode: '342001' },
    { value: 'shivpuri', label: 'Shivpuri', pincode: '342001' },
    { value: 'sojati-gate', label: 'Sojati Gate', pincode: '342001' },
    { value: 'sodagaran', label: 'Sodagaran', pincode: '342005' },
    { value: 'surya-vanshi-nagar', label: 'Surya Vanshi Nagar', pincode: '342013' },
    { value: 'umaid-bhawan', label: 'Umaid Bhawan', pincode: '342006' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '342004' },
    { value: 'vishwakarma-industrial-area', label: 'Vishwakarma Industrial Area', pincode: '342003' }
  ],

  'udaipur': [
    { value: 'ahar', label: 'Ahar', pincode: '313001' },
    { value: 'akhara', label: 'Akhara', pincode: '313001' },
    { value: 'alkapuri', label: 'Alkapuri', pincode: '313001' },
    { value: 'amet', label: 'Amet', pincode: '313207' },
    { value: 'ambamata', label: 'Ambamata', pincode: '313001' },
    { value: 'ashwini-bazar', label: 'Ashwini Bazar', pincode: '313001' },
    { value: 'badgaon', label: 'Badgaon', pincode: '313024' },
    { value: 'bajoriya', label: 'Bajoriya', pincode: '313001' },
    { value: 'banswara-road', label: 'Banswara Road', pincode: '313001' },
    { value: 'bapu-bazar', label: 'Bapu Bazar', pincode: '313001' },
    { value: 'bawari', label: 'Bawari', pincode: '313001' },
    { value: 'bawdi', label: 'Bawdi', pincode: '313001' },
    { value: 'bhamashah-mandi', label: 'Bhamashah Mandi', pincode: '313001' },
    { value: 'bhandari-khera', label: 'Bhandari Khera', pincode: '313003' },
    { value: 'bharati-colony', label: 'Bharati Colony', pincode: '313001' },
    { value: 'bhilwara-road', label: 'Bhilwara Road', pincode: '313003' },
    { value: 'bhinder', label: 'Bhinder', pincode: '313603' },
    { value: 'bhuwana', label: 'Bhuwana', pincode: '313001' },
    { value: 'bhuwana-industrial-area', label: 'Bhuwana Industrial Area', pincode: '313001' },
    { value: 'bichhri', label: 'Bichhri', pincode: '313003' },
    { value: 'bichhiwada', label: 'Bichhiwada', pincode: '313023' },
    { value: 'bhojla', label: 'Bhojla', pincode: '313025' },
    { value: 'chandni-chowk', label: 'Chandni Chowk', pincode: '313001' },
    { value: 'chandpole', label: 'Chandpole', pincode: '313001' },
    { value: 'chetak-circle', label: 'Chetak Circle', pincode: '313001' },
    { value: 'chhoti-badi', label: 'Chhoti Badi', pincode: '313001' },
    { value: 'chhoti-sadri', label: 'Chhoti Sadri', pincode: '313701' },
    { value: 'chirwa', label: 'Chirwa', pincode: '313001' },
    { value: 'chitrakoot-nagar', label: 'Chitrakoot Nagar', pincode: '313002' },
    { value: 'dabok', label: 'Dabok', pincode: '313022' },
    { value: 'debari', label: 'Debari', pincode: '313024' },
    { value: 'delwara', label: 'Delwara', pincode: '313202' },
    { value: 'dewali', label: 'Dewali', pincode: '313004' },
    { value: 'dhan-mandi', label: 'Dhan Mandi', pincode: '313001' },
    { value: 'dudh-talai', label: 'Dudh Talai', pincode: '313001' },
    { value: 'fatehpura', label: 'Fatehpura', pincode: '313001' },
    { value: 'fatehsagar', label: 'Fatehsagar', pincode: '313001' },
    { value: 'gajsingh-pura', label: 'Gajsingh Pura', pincode: '313001' },
    { value: 'gajsinghpur', label: 'Gajsinghpur', pincode: '313012' },
    { value: 'gokulpura', label: 'Gokulpura', pincode: '313002' },
    { value: 'goverdhan-vilas', label: 'Goverdhan Vilas', pincode: '313001' },
    { value: 'goverdhan-vilas-extension', label: 'Goverdhan Vilas Extension', pincode: '313001' },
    { value: 'gulab-bagh', label: 'Gulab Bagh', pincode: '313001' },
    { value: 'haldighati', label: 'Haldighati', pincode: '313601' },
    { value: 'himmat-nagar', label: 'Himmat Nagar', pincode: '313001' },
    { value: 'hiran-magri', label: 'Hiran Magri', pincode: '313002' },
    { value: 'hiran-magri-sector-10', label: 'Hiran Magri Sector 10', pincode: '313002' },
    { value: 'indra-colony', label: 'Indra Colony', pincode: '313001' },
    { value: 'jagdish-chowk', label: 'Jagdish Chowk', pincode: '313001' },
    { value: 'jagdish-mandir', label: 'Jagdish Mandir', pincode: '313001' },
    { value: 'jajpur', label: 'Jajpur', pincode: '313001' },
    { value: 'jaddu-nagar', label: 'Jaddu Nagar', pincode: '313001' },
    { value: 'kailashpuri', label: 'Kailashpuri', pincode: '313001' },
    { value: 'kaladwas', label: 'Kaladwas', pincode: '313001' },
    { value: 'kalaroos', label: 'Kalaroos', pincode: '313001' },
    { value: 'kanore', label: 'Kanore', pincode: '313021' },
    { value: 'keshav-nagar', label: 'Keshav Nagar', pincode: '313002' },
    { value: 'kherwara', label: 'Kherwara', pincode: '313803' },
    { value: 'kotra', label: 'Kotra', pincode: '313001' },
    { value: 'lake-palace-road', label: 'Lake Palace Road', pincode: '313001' },
    { value: 'madhuban', label: 'Madhuban', pincode: '313001' },
    { value: 'madhuban-garden', label: 'Madhuban Garden', pincode: '313001' },
    { value: 'maldas-street', label: 'Maldas Street', pincode: '313001' },
    { value: 'malla-talai', label: 'Malla Talai', pincode: '313003' },
    { value: 'mataji-ki-chungi', label: 'Mataji Ki Chungi', pincode: '313001' },
    { value: 'madri', label: 'Madri', pincode: '313002' },
    { value: 'mavli', label: 'Mavli', pincode: '313203' },
    { value: 'mewar-vihar', label: 'Mewar Vihar', pincode: '313001' },
    { value: 'mojhapada', label: 'Mojhapada', pincode: '313002' },
    { value: 'nathdwara', label: 'Nathdwara', pincode: '313301' },
    { value: 'naya-gaon', label: 'Naya Gaon', pincode: '313002' },
    { value: 'naya-khera', label: 'Naya Khera', pincode: '313001' },
    { value: 'pratap-nagar', label: 'Pratap Nagar', pincode: '313001' },
    { value: 'rana-kumbha', label: 'Rana Kumbha', pincode: '313001' },
    { value: 'raja-park', label: 'Raja Park', pincode: '313001' },
    { value: 'rajendra-nagar', label: 'Rajendra Nagar', pincode: '313001' },
    { value: 'rajasthan-housing-board', label: 'Rajasthan Housing Board', pincode: '313001' },
    { value: 'rajasthan-state-road-transport', label: 'Rajasthan State Road Transport', pincode: '313001' },
    { value: 'rajsamand-road', label: 'Rajsamand Road', pincode: '313001' },
    { value: 'rampura', label: 'Rampura', pincode: '313001' },
    { value: 'rashtriya-udyan', label: 'Rashtriya Udyan', pincode: '313001' },
    { value: 'rishabhdev', label: 'Rishabhdev', pincode: '313802' },
    { value: 'rudra-nagar', label: 'Rudra Nagar', pincode: '313001' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '313001' },
    { value: 'saheliyon-ki-bari', label: 'Saheliyon Ki Bari', pincode: '313001' },
    { value: 'sajjangarh', label: 'Sajjangarh', pincode: '313011' },
    { value: 'salumbar', label: 'Salumbar', pincode: '313027' },
    { value: 'sec-12-hiran-magri', label: 'Sec 12 Hiran Magri', pincode: '313002' },
    { value: 'sec-14-hiran-magri', label: 'Sec 14 Hiran Magri', pincode: '313002' },
    { value: 'sec-3-hiran-magri', label: 'Sec 3 Hiran Magri', pincode: '313002' },
    { value: 'sec-4-hiran-magri', label: 'Sector 4 Hiran Magri', pincode: '313002' },
    { value: 'sec-5-hiran-magri', label: 'Sec 5 Hiran Magri', pincode: '313002' },
    { value: 'sec-6-hiran-magri', label: 'Sec 6 Hiran Magri', pincode: '313002' },
    { value: 'sec-8-hiran-magri', label: 'Sec 8 Hiran Magri', pincode: '313002' },
    { value: 'shastri-circle', label: 'Shastri Circle', pincode: '313001' },
    { value: 'shiv-nagar', label: 'Shiv Nagar', pincode: '313001' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '313001' },
    { value: 'shivpuri', label: 'Shivpuri', pincode: '313001' },
    { value: 'shivshakti-nagar', label: 'Shivshakti Nagar', pincode: '313001' },
    { value: 'simalwasa', label: 'Simalwasa', pincode: '313013' },
    { value: 'sukhadia-circle', label: 'Sukhadia Circle', pincode: '313001' },
    { value: 'sukher', label: 'Sukher', pincode: '313002' },
    { value: 'surajpole', label: 'Surajpole', pincode: '313001' },
    { value: 'sursagar', label: 'Sursagar', pincode: '313001' },
    { value: 'suthar-colony', label: 'Suthar Colony', pincode: '313001' },
    { value: 'taj-nagar', label: 'Taj Nagar', pincode: '313001' },
    { value: 'tidi', label: 'Tidi', pincode: '313201' },
    { value: 'udaipur-airport', label: 'Udaipur Airport', pincode: '313022' },
    { value: 'udaipur-extension', label: 'Udaipur Extension', pincode: '313001' },
    { value: 'udaipur-industrial-area', label: 'Udaipur Industrial Area', pincode: '313003' },
    { value: 'udaipur-rural', label: 'Udaipur Rural', pincode: '313001' },
    { value: 'udaipur-university', label: 'Udaipur University', pincode: '313001' },
    { value: 'vallabhnagar', label: 'Vallabhnagar', pincode: '313601' },
    { value: 'vikramshila-nagar', label: 'Vikramshila Nagar', pincode: '313001' },
    { value: 'yadav-colony', label: 'Yadav Colony', pincode: '313001' }
  ],

  'kota': [
    { value: 'aerodrome-Circle', label: 'Aerodrome Circle', pincode: '324007' },
    { value: 'alniya', label: 'Alniya', pincode: '325003' },
    { value: 'anantpura', label: 'Anantpura', pincode: '324005' },
    { value: 'anta', label: 'Anta', pincode: '325202' },
    { value: 'balaji-Nagar', label: 'Balaji Nagar', pincode: '324001' },
    { value: 'bajrang-Nagar', label: 'Bajrang Nagar', pincode: '324005' },
    { value: 'bapawar', label: 'Bapawar', pincode: '325207' },
    { value: 'baran-Road', label: 'Baran Road', pincode: '324001' },
    { value: 'barod', label: 'Barod', pincode: '324006' },
    { value: 'basant-Vihar', label: 'Basant Vihar', pincode: '324009' },
    { value: 'bargaon', label: 'Bargaon', pincode: '325206' },
    { value: 'bhanwarkua', label: 'Bhanwarkua', pincode: '324003' },
    { value: 'binayaka', label: 'Binayaka', pincode: '325201' },
    { value: 'borkhera', label: 'Borkhera', pincode: '324001' },
    { value: 'bundi-Road', label: 'Bundi Road', pincode: '324008' },
    { value: 'chandakheri', label: 'Chandakheri', pincode: '325201' },
    { value: 'chandresal', label: 'Chandresal', pincode: '324003' },
    { value: 'chawani', label: 'Chawani', pincode: '324007' },
    { value: 'chechat', label: 'Chechat', pincode: '326518' },
    { value: 'coaching-Hub', label: 'Coaching Hub', pincode: '324005' },
    { value: 'dadabari', label: 'Dadabari', pincode: '324009' },
    { value: 'dheekoliya', label: 'Dheekoliya', pincode: '325001' },
    { value: 'electronic-Complex', label: 'Electronic Complex', pincode: '324005' },
    { value: 'ganesh-Nagar', label: 'Ganesh Nagar', pincode: '324005' },
    { value: 'goner', label: 'Goner', pincode: '325001' },
    { value: 'govindpura', label: 'Govindpura', pincode: '324005' },
    { value: 'gudla', label: 'Gudla', pincode: '322241' },
    { value: 'gumanpura', label: 'Gumanpura', pincode: '324007' },
    { value: 'indraprastha-Industrial-Area', label: 'Indraprastha Industrial Area', pincode: '324003' },
    { value: 'itawa', label: 'Itawa', pincode: '325004' },
    { value: 'jawahar-Nagar', label: 'Jawahar Nagar', pincode: '324005' },
    { value: 'julmi', label: 'Julmi', pincode: '326519' },
    { value: 'kaithoon', label: 'Kaithoon', pincode: '325001' },
    { value: 'kanwas', label: 'Kanwas', pincode: '325602' },
    { value: 'kansuwa', label: 'Kansuwa', pincode: '324003' },
    { value: 'keshavpura', label: 'Keshavpura', pincode: '324009' },
    { value: 'kherli-Phatak', label: 'Kherli Phatak', pincode: '324001' },
    { value: 'khajuriya', label: 'Khajuriya', pincode: '325001' },
    { value: 'kota-Junction', label: 'Kota Junction', pincode: '324002' },
    { value: 'kota-North', label: 'Kota North', pincode: '324001' },
    { value: 'kunhadi', label: 'Kunhadi', pincode: '324008' },
    { value: 'ladpura', label: 'Ladpura', pincode: '324003' },
    { value: 'landmark-City', label: 'Landmark City', pincode: '324010' },
    { value: 'laxmi-Pura', label: 'Laxmi Pura', pincode: '325214' },
    { value: 'mahaveer-Nagar', label: 'Mahaveer Nagar', pincode: '324005' },
    { value: 'mandana', label: 'Mandana', pincode: '325003' },
    { value: 'mBS-Nagar', label: 'MBS Nagar', pincode: '324005' },
    { value: 'modak', label: 'Modak', pincode: '326517' },
    { value: 'morak', label: 'Morak', pincode: '326517' },
    { value: 'nayapura', label: 'Nayapura', pincode: '324001' },
    { value: 'naya-Nohra', label: 'Naya Nohra', pincode: '325201' },
    { value: 'new-Grain-Mandi', label: 'New Grain Mandi', pincode: '324007' },
    { value: 'pachpahar', label: 'Pachpahar', pincode: '325002' },
    { value: 'patanpol', label: 'Patanpol', pincode: '324006' },
    { value: 'parsoli', label: 'Parsoli', pincode: '325004' },
    { value: 'pipalda', label: 'Pipalda', pincode: '325004' },
    { value: 'prem-Nagar', label: 'Prem Nagar', pincode: '324004' },
    { value: 'rajeev-Gandhi-Nagar', label: 'Rajeev Gandhi Nagar', pincode: '324005' },
    { value: 'rampura', label: 'Rampura', pincode: '324006' },
    { value: 'rampura-Bazaar', label: 'Rampura Bazaar', pincode: '324006' },
    { value: 'rangbari', label: 'Rangbari', pincode: '324010' },
    { value: 'ranpur', label: 'Ranpur', pincode: '325003' },
    { value: 'rawatbhata', label: 'Rawatbhata', pincode: '323305' },
    { value: 'sakatpura', label: 'Sakatpura', pincode: '324008' },
    { value: 'sangod', label: 'Sangod', pincode: '325601' },
    { value: 'shakti-Nagar', label: 'Shakti Nagar', pincode: '324005' },
    { value: 'shastri-Nagar', label: 'Shastri Nagar', pincode: '324001' },
    { value: 'shiv-Colony', label: 'Shiv Colony', pincode: '324001' },
    { value: 'shivaji-Nagar', label: 'Shivaji Nagar', pincode: '324005' },
    { value: 'shivpura', label: 'Shivpura', pincode: '324001' },
    { value: 'sogariya', label: 'Sogariya', pincode: '325003' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '325201' },
    { value: 'talwandi', label: 'Talwandi', pincode: '324005' },
    { value: 'thekra', label: 'Thekra', pincode: '324005' },
    { value: 'tirath', label: 'Tirath', pincode: '325201' },
    { value: 'vigyan-Nagar', label: 'Vigyan Nagar', pincode: '324005' }
  ],

  'pratapgarh': [
    { value: 'abhaypura', label: 'Abhaypura', pincode: '312605' },
    { value: 'anvapada', label: 'Anvapada', pincode: '312604' },
    { value: 'badi-sadri', label: 'Badi Sadri', pincode: '312604' },
    { value: 'banswara', label: 'Banswara', pincode: '312605' },
    { value: 'bhinder', label: 'Bhinder', pincode: '312601' },
    { value: 'chhoti-sadri', label: 'Chhoti Sadri', pincode: '312605' },
    { value: 'dabi', label: 'Dabi', pincode: '312604' },
    { value: 'dhamotar', label: 'Dhamotar', pincode: '312605' },
    { value: 'dharmpura', label: 'Dharmpura', pincode: '312605' },
    { value: 'ganeshpura', label: 'Ganeshpura', pincode: '312601' },
    { value: 'gangapur', label: 'Gangapur', pincode: '312601' },
    { value: 'kanore', label: 'Kanore', pincode: '312603' },
    { value: 'kankra', label: 'Kankra', pincode: '312605' },
    { value: 'lalgarh', label: 'Lalgarh', pincode: '312602' },
    { value: 'manpur', label: 'Manpur', pincode: '312601' },
    { value: 'motisingh-ka-khera', label: 'Motisingh Ka Khera', pincode: '312604' },
    { value: 'paranpur', label: 'Paranpur', pincode: '312605' },
    { value: 'pipalkhunt', label: 'Pipalkhunt', pincode: '312605' },
    { value: 'pratapgarh-city', label: 'Pratapgarh City', pincode: '312605' },
    { value: 'rajpur', label: 'Rajpur', pincode: '312605' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '312602' },
    { value: 'sangaria', label: 'Sangaria', pincode: '312606' },
    { value: 'sardargarh', label: 'Sardargarh', pincode: '312605' },
    { value: 'sukhpur', label: 'Sukhpur', pincode: '312605' },
    { value: 'taranagar', label: 'Taranagar', pincode: '312603' },
    { value: 'thikariya', label: 'Thikariya', pincode: '312603' },
    { value: 'udaypur', label: 'Udaypur', pincode: '312605' }
  ],
  'sawai-madhopur': [
    { value: 'badhora', label: 'Badhora', pincode: '322021' },
    { value: 'baroda', label: 'Baroda', pincode: '322021' },
    { value: 'bherupura', label: 'Bherupura', pincode: '322033' },
    { value: 'chauth-ka-barwara', label: 'Chauth Ka Barwara', pincode: '322701' },
    { value: 'dhamra', label: 'Dhamra', pincode: '322001' },
    { value: 'dholpur', label: 'Dholpur', pincode: '322302' },
    { value: 'gangapur-city', label: 'Gangapur City', pincode: '322201' },
    { value: 'harsh', label: 'Harsh', pincode: '322028' },
    { value: 'kaithun', label: 'Kaithun', pincode: '322028' },
    { value: 'khandar', label: 'Khandar', pincode: '322031' },
    { value: 'khilchipur', label: 'Khilchipur', pincode: '322029' },
    { value: 'madhopur', label: 'Madhopur', pincode: '322001' },
    { value: 'nadiya', label: 'Nadiya', pincode: '322021' },
    { value: 'narayani-dham', label: 'Narayani Dham', pincode: '322701' },
    { value: 'ranthambore', label: 'Ranthambore', pincode: '322001' },
    { value: 'sawai-madhopur', label: 'Sawai Madhopur', pincode: '322001' },
    { value: 'sawai-madhopur-district', label: 'Sawai Madhopur District', pincode: '322001' },
    { value: 'sherpur', label: 'Sherpur', pincode: '322021' },
    { value: 'soorwal', label: 'Soorwal', pincode: '322027' },
    { value: 'tonk', label: 'Tonk', pincode: '322025' },
    { value: 'vijaypur', label: 'Vijaypur', pincode: '322201' },
    { value: 'wadiya', label: 'Wadiya', pincode: '322021' }
  ],

  'sikar': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '332001' },
    { value: 'ajitgarh', label: 'Ajitgarh', pincode: '332701' },
    { value: 'bajaj-gram', label: 'Bajaj Gram', pincode: '332021' },
    { value: 'bansilalpur', label: 'Bansilalpur', pincode: '332001' },
    { value: 'barbari', label: 'Barbari', pincode: '332001' },
    { value: 'churu', label: 'Churu', pincode: '331001' },
    { value: 'dadiya', label: 'Dadiya', pincode: '332001' },
    { value: 'danta-ramgarh', label: 'Danta Ramgarh', pincode: '332702' },
    { value: 'dharamsala', label: 'Dharamsala', pincode: '332001' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '332301' },
    { value: 'ghir', label: 'Ghir', pincode: '332024' },
    { value: 'govindgarh', label: 'Govindgarh', pincode: '332401' },
    { value: 'harsh', label: 'Harsh', pincode: '332001' },
    { value: 'jagmalpura', label: 'Jagmalpura', pincode: '332001' },
    { value: 'jhunjhunu-road', label: 'Jhunjhunu Road', pincode: '332001' },
    { value: 'khandela', label: 'Khandela', pincode: '332715' },
    { value: 'khatu-shyamji', label: 'Khatu Shyamji', pincode: '332602' },
    { value: 'laxmangarh', label: 'Laxmangarh', pincode: '332311' },
    { value: 'losal', label: 'Losal', pincode: '332025' },
    { value: 'manoharpura', label: 'Manoharpura', pincode: '332021' },
    { value: 'meeno-ka-nangal', label: 'Meeno Ka Nangal', pincode: '332027' },
    { value: 'mody-university', label: 'Mody University', pincode: '332311' },
    { value: 'neem-ka-thana', label: 'Neem Ka Thana', pincode: '332713' },
    { value: 'patrakar-colony', label: 'Patrakar Colony', pincode: '332001' },
    { value: 'piprali', label: 'Piprali', pincode: '332029' },
    { value: 'raipur', label: 'Raipur', pincode: '332021' },
    { value: 'reengus', label: 'Reengus', pincode: '332404' },
    { value: 'rulyani', label: 'Rulyani', pincode: '332001' },
    { value: 'sikar-city', label: 'Sikar City', pincode: '332001' },
    { value: 'sikar-district', label: 'Sikar District', pincode: '332001' },
    { value: 'srimadhopur', label: 'Srimadhopur', pincode: '332715' },
    { value: 'tonk', label: 'Tonk', pincode: '332025' },
    { value: 'warasar', label: 'Warasar', pincode: '332001' },
    { value: 'warthaman', label: 'Warthaman', pincode: '332021' }
  ],

  'tonk': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '304001' },
    { value: 'ajmer-road', label: 'Ajmer Road', pincode: '304001' },
    { value: 'aligarh', label: 'Aligarh', pincode: '304001' },
    { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '304001' },
    { value: 'bajju', label: 'Bajju', pincode: '304001' },
    { value: 'baseri', label: 'Baseri', pincode: '304001' },
    { value: 'belwa', label: 'Belwa', pincode: '304024' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '304001' },
    { value: 'bhawani-mandi', label: 'Bhawani Mandi', pincode: '304302' },
    { value: 'bhidawas', label: 'Bhidawas', pincode: '304022' },
    { value: 'chandwa', label: 'Chandwa', pincode: '304021' },
    { value: 'gopalpura', label: 'Gopalpura', pincode: '304501' },
    { value: 'govind-nagar', label: 'Govind Nagar', pincode: '304501' },
    { value: 'gulab-bagh', label: 'Gulab Bagh', pincode: '304001' },
    { value: 'industrial-area', label: 'Industrial Area', pincode: '304504' },
    { value: 'jagatpura', label: 'Jagatpura', pincode: '304001' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '304001' },
    { value: 'kalapathar', label: 'Kalapathar', pincode: '304503' },
    { value: 'kalyan-pura', label: 'Kalyan Pura', pincode: '304021' },
    { value: 'kamla-nehru-colony', label: 'Kamla Nehru Colony', pincode: '304001' },
    { value: 'khanpur', label: 'Khanpur', pincode: '304507' },
    { value: 'khatwada', label: 'Khatwada', pincode: '304515' },
    { value: 'lal-bagh', label: 'Lal Bagh', pincode: '304001' },
    { value: 'malkapur', label: 'Malkapur', pincode: '304504' },
    { value: 'mahatma-gandhi-nagar', label: 'Mahatma Gandhi Nagar', pincode: '304001' },
    { value: 'manoharpura', label: 'Manoharpura', pincode: '304022' },
    { value: 'model-town', label: 'Model Town', pincode: '304022' },
    { value: 'moti-dungri', label: 'Moti Dungri', pincode: '304001' },
    { value: 'nagaur-road', label: 'Nagaur Road', pincode: '304003' },
    { value: 'nehru-colony', label: 'Nehru Colony', pincode: '304001' },
    { value: 'new-colony', label: 'New Colony', pincode: '304001' },
    { value: 'pachpahar', label: 'Pachpahar', pincode: '304023' },
    { value: 'police-line', label: 'Police Line', pincode: '304001' },
    { value: 'pratap-nagar', label: 'Pratap Nagar', pincode: '304001' },
    { value: 'ramganj-mandi', label: 'Ramganj Mandi', pincode: '304202' },
    { value: 'ram-nagar', label: 'Ram Nagar', pincode: '304001' },
    { value: 'safedabad', label: 'Safedabad', pincode: '304001' },
    { value: 'sanjay-nagar', label: 'Sanjay Nagar', pincode: '304001' },
    { value: 'shahpura', label: 'Shahpura', pincode: '304515' },
    { value: 'shivaji-colony', label: 'Shivaji Colony', pincode: '304001' },
    { value: 'shiv-colony', label: 'Shiv Colony', pincode: '304504' },
    { value: 'shivpuri', label: 'Shivpuri', pincode: '304001' },
    { value: 'sita-pura', label: 'Sita Pura', pincode: '304001' },
    { value: 'station-road', label: 'Station Road', pincode: '304001' },
    { value: 'sundar-nagar', label: 'Sundar Nagar', pincode: '304001' },
    { value: 'tonk-cantonment', label: 'Tonk Cantonment', pincode: '304001' },
    { value: 'tonk-city', label: 'Tonk City', pincode: '304001' },
    { value: 'tonk-district', label: 'Tonk District', pincode: '304001' },
    { value: 'tonk-main', label: 'Tonk Main', pincode: '304001' },
    { value: 'vasan', label: 'Vasan', pincode: '304021' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '304001' }
  ],

  'sri-ganganagar': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '335001' },
    { value: 'bhagat-ki-kothi', label: 'Bhagat Ki Kothi', pincode: '335001' },
    { value: 'd-block', label: 'D Block', pincode: '335001' },
    { value: 'ganganagar-cantonment', label: 'Ganganagar Cantonment', pincode: '335001' },
    { value: 'ganganagar-district', label: 'Ganganagar District', pincode: '335001' },
    { value: 'ghansham-village', label: 'Ghansham Village', pincode: '335001' },
    { value: 'hanumangarh', label: 'Hanumangarh', pincode: '335512' },
    { value: 'khuja-bangla', label: 'Khuja Bangla', pincode: '335001' },
    { value: 'madhopur', label: 'Madhopur', pincode: '335024' },
    { value: 'muklaina', label: 'Muklaina', pincode: '335026' },
    { value: 'rakshak', label: 'Rakshak', pincode: '335001' },
    { value: 'ratanpura', label: 'Ratanpura', pincode: '335001' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '335001' },
    { value: 'shakti-nagar', label: 'Shakti Nagar', pincode: '335001' },
    { value: 'sri-ganganagar', label: 'Sri Ganganagar', pincode: '335001' },
    { value: 'suratgarh', label: 'Suratgarh', pincode: '335804' },
    { value: 'vasant-vihar', label: 'Vasant Vihar', pincode: '335001' },
    { value: 'banjara', label: 'Banjara', pincode: '335001' },
    { value: 'gopalpur', label: 'Gopalpur', pincode: '335022' },
    { value: 'jotwara', label: 'Jotwara', pincode: '335022' },
    { value: 'kalpana-chawla-nagar', label: 'Kalpana Chawla Nagar', pincode: '335001' },
    { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '335001' },
    { value: 'pawanpuri', label: 'Pawanpuri', pincode: '335001' },
    { value: 'ranjit-nagar', label: 'Ranjit Nagar', pincode: '335001' },
    { value: 'a-block', label: 'A Block', pincode: '335001' },
    { value: 'kesar-bagh', label: 'Kesar Bagh', pincode: '335001' },
    { value: 'model-town', label: 'Model Town', pincode: '335001' },
    { value: 'railway-station-area', label: 'Railway Station Area', pincode: '335001' },
    { value: 'prem-nagar', label: 'Prem Nagar', pincode: '335001' },
    { value: 'industrial-area', label: 'Industrial Area', pincode: '335001' },
    { value: 'vijay-colony', label: 'Vijay Colony', pincode: '335001' },
    { value: 'jaipur-road', label: 'Jaipur Road', pincode: '335001' },
    { value: 'bhagat-nagar', label: 'Bhagat Nagar', pincode: '335001' },
    { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '335001' },
    { value: 'chandni-chowk', label: 'Chandni Chowk', pincode: '335001' },
    { value: 'kartar-nagar', label: 'Kartar Nagar', pincode: '335001' },
    { value: 'shiv-colony', label: 'Shiv Colony', pincode: '335001' },
    { value: 'azad-nagar', label: 'Azad Nagar', pincode: '335001' },
    { value: 'maharana-pratap-nagar', label: 'Maharana Pratap Nagar', pincode: '335001' },
    { value: 'raghunath-pura', label: 'Raghunath Pura', pincode: '335001' },
    { value: 'new-railway-colony', label: 'New Railway Colony', pincode: '335001' },
    { value: 'old-d-block', label: 'Old D Block', pincode: '335001' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '335001' },
    { value: 'new-subhash-nagar', label: 'New Subhash Nagar', pincode: '335001' }
  ],

  'alwar': [
    { value: 'adda-basti', label: 'Adda Basti', pincode: '301001' },
    { value: 'ashok-vihar', label: 'Ashok Vihar', pincode: '301001' },
    { value: 'bahadurpur', label: 'Bahadurpur', pincode: '301028' },
    { value: 'baldevgarh', label: 'Baldevgarh', pincode: '301001' },
    { value: 'bhagat-singh-colony', label: 'Bhagat Singh Colony', pincode: '301001' },
    { value: 'bhakhera', label: 'Bhakhera', pincode: '301001' },
    { value: 'bhartari', label: 'Bhartari', pincode: '301028' },
    { value: 'budhi-bawal', label: 'Budhi Bawal', pincode: '301707' },
    { value: 'chakari', label: 'Chakari', pincode: '301412' },
    { value: 'chand-pol', label: 'Chand Pol', pincode: '301001' },
    { value: 'dholagarh', label: 'Dholagarh', pincode: '301030' },
    { value: 'gangapur', label: 'Gangapur', pincode: '301001' },
    { value: 'ghasoli', label: 'Ghasoli', pincode: '301707' },
    { value: 'govindgarh', label: 'Govindgarh', pincode: '301604' },
    { value: 'hanuman-chowk', label: 'Hanuman Chowk', pincode: '301001' },
    { value: 'industrial-area', label: 'Industrial Area', pincode: '301030' },
    { value: 'jaipur-road', label: 'Jaipur Road', pincode: '301001' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '301001' },
    { value: 'kalakand-market', label: 'Kalakand Market', pincode: '301001' },
    { value: 'kala-kuan', label: 'Kala Kuan', pincode: '301001' },
    { value: 'kishangarh-bas', label: 'Kishangarh Bas', pincode: '301405' },
    { value: 'kothi', label: 'Kothi', pincode: '301001' },
    { value: 'lohagarh', label: 'Lohagarh', pincode: '301001' },
    { value: 'madan-mohan-chowk', label: 'Madan Mohan Chowk', pincode: '301001' },
    { value: 'madan-pur', label: 'Madan Pur', pincode: '301024' },
    { value: 'moti-dungri', label: 'Moti Dungri', pincode: '301001' },
    { value: 'narain-pur', label: 'Narain Pur', pincode: '301024' },
    { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '301001' },
    { value: 'old-bus-stand', label: 'Old Bus Stand', pincode: '301001' },
    { value: 'parijat-colony', label: 'Parijat Colony', pincode: '301001' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '301001' },
    { value: 'phool-bagh', label: 'Phool Bagh', pincode: '301001' },
    { value: 'raja-ki-take', label: 'Raja Ki Take', pincode: '301001' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '301026' },
    { value: 'samola', label: 'Samola', pincode: '301411' },
    { value: 'shanti-kunj', label: 'Shanti Kunj', pincode: '301001' },
    { value: 'shivaji-park', label: 'Shivaji Park', pincode: '301001' },
    { value: 'shivpuri', label: 'Shivpuri', pincode: '301001' },
    { value: 'siddharth-nagar', label: 'Siddharth Nagar', pincode: '301001' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '301001' },
    { value: 'teekri', label: 'Teekri', pincode: '301707' },
    { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '301001' },
    { value: 'vijay-mandir', label: 'Vijay Mandir', pincode: '301001' }
  ],

  'bharatpur': [
    { value: 'akbarpur', label: 'Akbarpur', pincode: '321001' },
    { value: 'amar-colony', label: 'Amar Colony', pincode: '321001' },
    { value: 'ansal-colony', label: 'Ansal Colony', pincode: '321001' },
    { value: 'ashok-vihar', label: 'Ashok Vihar', pincode: '321001' },
    { value: 'bagh-bahadur', label: 'Bagh Bahadur', pincode: '321001' },
    { value: 'bharatpur-junction', label: 'Bharatpur Junction', pincode: '321001' },
    { value: 'bhusawar', label: 'Bhusawar', pincode: '321406' },
    { value: 'city-hospital-area', label: 'City Hospital Area', pincode: '321001' },
    { value: 'dalal-pura', label: 'Dalal Pura', pincode: '321001' },
    { value: 'deeg', label: 'Deeg', pincode: '321203' },
    { value: 'dholpur-road', label: 'Dholpur Road', pincode: '321001' },
    { value: 'ganga-mandir', label: 'Ganga Mandir', pincode: '321001' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '321001' },
    { value: 'govardhan-road', label: 'Govardhan Road', pincode: '321001' },
    { value: 'hari-kund', label: 'Hari Kund', pincode: '321001' },
    { value: 'indira-colony', label: 'Indira Colony', pincode: '321001' },
    { value: 'jaipur-road', label: 'Jaipur Road', pincode: '321001' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '321001' },
    { value: 'kachahari-road', label: 'Kachahari Road', pincode: '321001' },
    { value: 'kachhpura', label: 'Kachhpura', pincode: '321001' },
    { value: 'kandoli', label: 'Kandoli', pincode: '321001' },
    { value: 'khandar-road', label: 'Khandar Road', pincode: '321001' },
    { value: 'kumbher', label: 'Kumbher', pincode: '321201' },
    { value: 'lakhanpur', label: 'Lakhanpur', pincode: '321001' },
    { value: 'laxman-mandir-area', label: 'Laxman Mandir Area', pincode: '321001' },
    { value: 'lohagarh', label: 'Lohagarh', pincode: '321001' },
    { value: 'mathura-gate', label: 'Mathura Gate', pincode: '321001' },
    { value: 'mayur-vihar', label: 'Mayur Vihar', pincode: '321001' },
    { value: 'meenapada', label: 'Meenapada', pincode: '321001' },
    { value: 'moti-bagh', label: 'Moti Bagh', pincode: '321001' },
    { value: 'nalband-road', label: 'Nalband Road', pincode: '321001' },
    { value: 'new-anjan-colony', label: 'New Anjan Colony', pincode: '321001' },
    { value: 'new-mandi', label: 'New Mandi', pincode: '321001' },
    { value: 'old-power-house-area', label: 'Old Power House Area', pincode: '321001' },
    { value: 'pichuna-bazar', label: 'Pichuna Bazar', pincode: '321001' },
    { value: 'rajendra-nagar', label: 'Rajendra Nagar', pincode: '321001' },
    { value: 'railway-colony', label: 'Railway Colony', pincode: '321001' },
    { value: 'raja-mandi', label: 'Raja Mandi', pincode: '321001' },
    { value: 'rampura', label: 'Rampura', pincode: '321001' },
    { value: 'rani-bagh', label: 'Rani Bagh', pincode: '321001' },
    { value: 'saras-chouraha', label: 'Saras Chouraha', pincode: '321001' },
    { value: 'sarkari-hospital-area', label: 'Sarkari Hospital Area', pincode: '321001' },
    { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '321001' },
    { value: 'shiv-colony', label: 'Shiv Colony', pincode: '321001' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '321001' },
    { value: 'uchchain', label: 'Uchchain', pincode: '321302' },
    { value: 'udaipur', label: 'Udaipur', pincode: '321301' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '321001' },
    { value: 'vrindavan-garden', label: 'Vrindavan Garden', pincode: '321001' }
  ],

  'ajmer': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '305004' },
    { value: 'ajay-nagar', label: 'Ajay Nagar', pincode: '305004' },
    { value: 'anand-nagar', label: 'Anand Nagar', pincode: '305001' },
    { value: 'baldev-nagar', label: 'Baldev Nagar', pincode: '305001' },
    { value: 'bank-colony', label: 'Bank Colony', pincode: '305001' },
    { value: 'beawar', label: 'Beawar', pincode: '305901' },
    { value: 'beawar-road', label: 'Beawar Road', pincode: '305001' },
    { value: 'bhajan-ganj', label: 'Bhajan Ganj', pincode: '305001' },
    { value: 'bhawani-khera', label: 'Bhawani Khera', pincode: '305025' },
    { value: 'bijainagar', label: 'Bijainagar', pincode: '305624' },
    { value: 'bk-kaul-nagar', label: 'BK Kaul Nagar', pincode: '305004' },
    { value: 'chachiyawas', label: 'Chachiyawas', pincode: '305023' },
    { value: 'chanderwadai-nagar', label: 'Chanderwadai Nagar', pincode: '305001' },
    { value: 'chandra-vardai-nagar', label: 'Chandra Vardai Nagar', pincode: '305001' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '305001' },
    { value: 'darga-bazar', label: 'Darga Bazar', pincode: '305001' },
    { value: 'daurai-rural', label: 'Daurai Rural', pincode: '305001' },
    { value: 'dayanand-colony', label: 'Dayanand Colony', pincode: '305001' },
    { value: 'defence-colony', label: 'Defence Colony', pincode: '305001' },
    { value: 'dhola-bhata', label: 'Dhola Bhata', pincode: '305001' },
    { value: 'diggi-bazaar', label: 'Diggi Bazaar', pincode: '305001' },
    { value: 'gagwana', label: 'Gagwana', pincode: '305023' },
    { value: 'ganj', label: 'Ganj', pincode: '305001' },
    { value: 'ghooghra', label: 'Ghooghra', pincode: '305004' },
    { value: 'govindgarh', label: 'Govindgarh', pincode: '305001' },
    { value: 'gulab-bari', label: 'Gulab Bari', pincode: '305001' },
    { value: 'gyan-vihar-colony', label: 'Gyan Vihar Colony', pincode: '305001' },
    { value: 'haribhau-upadhyay-nagar', label: 'Haribhau Upadhyay Nagar', pincode: '305004' },
    { value: 'hathi-khera', label: 'Hathi Khera', pincode: '305001' },
    { value: 'jaipur-road', label: 'Jaipur Road', pincode: '305001' },
    { value: 'jyoti-nagar', label: 'Jyoti Nagar', pincode: '305004' },
    { value: 'kabir-nagar', label: 'Kabir Nagar', pincode: '305001' },
    { value: 'kaiser-ganj', label: 'Kaiser Ganj', pincode: '305001' },
    { value: 'kanchan-nagar', label: 'Kanchan Nagar', pincode: '305004' },
    { value: 'kayad', label: 'Kayad', pincode: '305023' },
    { value: 'kekri', label: 'Kekri', pincode: '305404' },
    { value: 'kishangarh', label: 'Kishangarh', pincode: '305801' },
    { value: 'kishangarh-road', label: 'Kishangarh Road', pincode: '305001' },
    { value: 'kotra', label: 'Kotra', pincode: '305004' },
    { value: 'kundan-nagar', label: 'Kundan Nagar', pincode: '305001' },
    { value: 'lajpat-nagar', label: 'Lajpat Nagar', pincode: '305001' },
    { value: 'loha-khan-colony', label: 'Loha Khan Colony', pincode: '305001' },
    { value: 'lohagal', label: 'Lohagal', pincode: '305004' },
    { value: 'madar', label: 'Madar', pincode: '305001' },
    { value: 'makarwali-road', label: 'Makarwali Road', pincode: '305004' },
    { value: 'makhupura', label: 'Makhupura', pincode: '305002' },
    { value: 'masuda', label: 'Masuda', pincode: '305623' },
    { value: 'nagra', label: 'Nagra', pincode: '305001' },
    { value: 'naka-madar-colony', label: 'Naka Madar Colony', pincode: '305001' },
    { value: 'nasirabad', label: 'Nasirabad', pincode: '305601' },
    { value: 'pahar-ganj', label: 'Pahar Ganj', pincode: '305001' },
    { value: 'pal-bhichala', label: 'Pal Bhichala', pincode: '305001' },
    { value: 'panchsheel-nagar', label: 'Panchsheel Nagar', pincode: '305004' },
    { value: 'parao', label: 'Parao', pincode: '305001' },
    { value: 'parbatpura', label: 'Parbatpura', pincode: '305002' },
    { value: 'pushkar', label: 'Pushkar', pincode: '305022' },
    { value: 'pushkar-road', label: 'Pushkar Road', pincode: '305004' },
    { value: 'ramganj', label: 'Ramganj', pincode: '305001' },
    { value: 'rawat-nagar', label: 'Rawat Nagar', pincode: '305001' },
    { value: 'roopnagar', label: 'Roopnagar', pincode: '305004' },
    { value: 'saradhana', label: 'Saradhana', pincode: '305206' },
    { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '305001' },
    { value: 'shrinagar-road', label: 'Shrinagar Road', pincode: '305004' },
    { value: 'somalpur', label: 'Somalpur', pincode: '305801' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '305001' },
    { value: 'topdara', label: 'Topdara', pincode: '305001' },
    { value: 'vaishali-nagar', label: 'Vaishali Nagar', pincode: '305004' },
    { value: 'vigyan-nagar', label: 'Vigyan Nagar', pincode: '305001' }
  ],

  'jaipur': [
    { value: 'achrol', label: 'Achrol', pincode: '303002' },
    { value: 'adarsh-Nagar', label: 'Adarsh Nagar', pincode: '302004' },
    { value: 'ajmer-Road', label: 'Ajmer Road', pincode: '302006' },
    { value: 'ajmeri-Gate', label: 'Ajmeri Gate', pincode: '302002' },
    { value: 'amrapali-Circle', label: 'Amrapali Circle', pincode: '302021' },
    { value: 'amber-Fort', label: 'Amber Fort', pincode: '302028' },
    { value: 'amer-Road', label: 'Amer Road', pincode: '302002' },
    { value: 'bagru', label: 'Bagru', pincode: '303007' },
    { value: 'bagru-Town', label: 'Bagru Town', pincode: '303007' },
    { value: 'bajaj-Nagar', label: 'Bajaj Nagar', pincode: '302015' },
    { value: 'bani-Park', label: 'Bani Park', pincode: '302016' },
    { value: 'banipark-Extension', label: 'Banipark Extension', pincode: '302016' },
    { value: 'bapu-Bazar', label: 'Bapu Bazar', pincode: '302003' },
    { value: 'bapu-Basti', label: 'Bapu Basti', pincode: '302003' },
    { value: 'bapu-Nagar', label: 'Bapu Nagar', pincode: '302015' },
    { value: 'bassi', label: 'Bassi', pincode: '303301' },
    { value: 'bindayaka', label: 'Bindayaka', pincode: '302012' },
    { value: 'brahmapuri', label: 'Brahmapuri', pincode: '302002' },
    { value: 'c-Scheme', label: 'C Scheme', pincode: '302001' },
    { value: 'chaksu', label: 'Chaksu', pincode: '303901' },
    { value: 'chandpole', label: 'Chandpole', pincode: '302001' },
    { value: 'chandpole-Bazar', label: 'Chandpole Bazar', pincode: '302001' },
    { value: 'chandwaji', label: 'Chandwaji', pincode: '303104' },
    { value: 'char-Darwaza', label: 'Char Darwaza', pincode: '302003' },
    { value: 'chitrakoot', label: 'Chitrakoot', pincode: '302021' },
    { value: 'choti-Chaupar', label: 'Choti Chaupar', pincode: '302001' },
    { value: 'civil-Lines', label: 'Civil Lines', pincode: '302006' },
    { value: 'dantli', label: 'Dantli', pincode: '302031' },
    { value: 'durgapura', label: 'Durgapura', pincode: '302018' },
    { value: 'durgapura-Colony', label: 'Durgapura Colony', pincode: '302018' },
    { value: 'galta-Colony', label: 'Galta Colony', pincode: '302003' },
    { value: 'galta-Gate', label: 'Galta Gate', pincode: '302003' },
    { value: 'gandhi-Nagar', label: 'Gandhi Nagar', pincode: '302015' },
    { value: 'gandhi-Path', label: 'Gandhi Path', pincode: '302021' },
    { value: 'ganpati-Plaza', label: 'Ganpati Plaza', pincode: '302001' },
    { value: 'ghat-Gate', label: 'Ghat Gate', pincode: '302003' },
    { value: 'gopalbari', label: 'Gopalbari', pincode: '302001' },
    { value: 'gopalpura', label: 'Gopalpura', pincode: '302018' },
    { value: 'gopalpura-Bypass', label: 'Gopalpura Bypass', pincode: '302018' },
    { value: 'goner', label: 'Goner', pincode: '302031' },
    { value: 'goner-Road', label: 'Goner Road', pincode: '302031' },
    { value: 'govind-Marg', label: 'Govind Marg', pincode: '302004' },
    { value: 'govindgarh', label: 'Govindgarh', pincode: '303805' },
    { value: 'govindpura', label: 'Govindpura', pincode: '302013' },
    { value: 'harnathapura', label: 'Harnathapura', pincode: '302039' },
    { value: 'harmada', label: 'Harmada', pincode: '302032' },
    { value: 'hawa-Mahal', label: 'Hawa Mahal', pincode: '302002' },
    { value: 'heerawala', label: 'Heerawala', pincode: '302034' },
    { value: 'indira-Bazar', label: 'Indira Bazar', pincode: '302001' },
    { value: 'jagatpura', label: 'Jagatpura', pincode: '302017' },
    { value: 'jagatpura-Sector-8', label: 'Jagatpura Sector 8', pincode: '302017' },
    { value: 'jaisinghpura', label: 'Jaisinghpura', pincode: '302029' },
    { value: 'jal-Mahal', label: 'Jal Mahal', pincode: '302002' },
    { value: 'jamwaramgarh', label: 'Jamwaramgarh', pincode: '303109' },
    { value: 'jawahar-Nagar', label: 'Jawahar Nagar', pincode: '302004' },
    { value: 'jhotwara', label: 'Jhotwara', pincode: '302012' },
    { value: 'jLN-Marg', label: 'JLN Marg', pincode: '302018' },
    { value: 'johari-Bazar', label: 'Johari Bazar', pincode: '302003' },
    { value: 'jobner', label: 'Jobner', pincode: '303328' },
    { value: 'kalwar-Road', label: 'Kalwar Road', pincode: '302012' },
    { value: 'kalwad', label: 'Kalwad', pincode: '303706' },
    { value: 'kalyanpuri', label: 'Kalyanpuri', pincode: '302017' },
    { value: 'kanak-Vihar', label: 'Kanak Vihar', pincode: '302034' },
    { value: 'kanakpura', label: 'Kanakpura', pincode: '302034' },
    { value: 'kanti-Nagar', label: 'Kanti Nagar', pincode: '302016' },
    { value: 'karni-Vihar', label: 'Karni Vihar', pincode: '302019' },
    { value: 'keshopura', label: 'Keshopura', pincode: '302034' },
    { value: 'khatipura', label: 'Khatipura', pincode: '302012' },
    { value: 'khatipura-Road', label: 'Khatipura Road', pincode: '302012' },
    { value: 'kishanpole-Bazar', label: 'Kishanpole Bazar', pincode: '302001' },
    { value: 'kishanpole-Gate', label: 'Kishanpole Gate', pincode: '302001' },
    { value: 'krishna-Nagar', label: 'Krishna Nagar', pincode: '302017' },
    { value: 'kukas', label: 'Kukas', pincode: '302028' },
    { value: 'lal-Kothi', label: 'Lal Kothi', pincode: '302015' },
    { value: 'lalarpura', label: 'Lalarpura', pincode: '302034' },
    { value: 'loha-Mandi', label: 'Loha Mandi', pincode: '302013' },
    { value: 'mahapura', label: 'Mahapura', pincode: '302026' },
    { value: 'mahal-Road', label: 'Mahal Road', pincode: '302033' },
    { value: 'mahesh-Nagar', label: 'Mahesh Nagar', pincode: '302015' },
    { value: 'mahaveer-Nagar', label: 'Mahaveer Nagar', pincode: '302018' },
    { value: 'mahavir-Nagar', label: 'Mahavir Nagar', pincode: '302018' },
    { value: 'malviya-Nagar', label: 'Malviya Nagar', pincode: '302017' },
    { value: 'manoharpura', label: 'Manoharpura', pincode: '303104' },
    { value: 'mansarovar', label: 'Mansarovar', pincode: '302020' },
    { value: 'manoharpura', label: 'Manoharpura', pincode: '303104' },
    { value: 'mansarovar', label: 'Mansarovar', pincode: '302020' },
    { value: 'manpura', label: 'Manpura', pincode: '303805' },
    { value: 'model-Town', label: 'Model Town', pincode: '302017' },
    { value: 'mohana', label: 'Mohana', pincode: '303006' },
    { value: 'mohana-Mandi', label: 'Muhana Mandi', pincode: '302029' },
    { value: 'mundota', label: 'Mundota', pincode: '303706' },
    { value: 'muralipura', label: 'Muralipura', pincode: '302039' },
    { value: 'nahargarh-Fort', label: 'Nahargarh Fort', pincode: '302001' },
    { value: 'narayan-Singh-Circle', label: 'Narayan Singh Circle', pincode: '302004' },
    { value: 'nehru-Bazar', label: 'Nehru Bazar', pincode: '302001' },
    { value: 'new-Sanganer-Road', label: 'New Sanganer Road', pincode: '302019' },
    { value: 'niwaru-Road', label: 'Niwaru Road', pincode: '302012' },
    { value: 'nindar', label: 'Nindar', pincode: '303706' },
    { value: 'nirman-Nagar', label: 'Nirman Nagar', pincode: '302019' },
    { value: 'panchyawala', label: 'Panchyawala', pincode: '302034' },
    { value: 'paota', label: 'Paota', pincode: '303106' },
    { value: 'pital-Factory', label: 'Pital Factory', pincode: '302016' },
    { value: 'phagi', label: 'Phagi', pincode: '303005' },
    { value: 'pratap-Nagar', label: 'Pratap Nagar', pincode: '302033' },
    { value: 'prem-Nagar', label: 'Prem Nagar', pincode: '302029' },
    { value: 'queens-Road', label: 'Queens Road', pincode: '302021' },
    { value: 'ramganj-Bazar', label: 'Ramganj Bazar', pincode: '302003' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '302004' },
    { value: 'ramnagariya', label: 'Ramnagariya', pincode: '302033' },
    { value: 'ramniwas-Bagh', label: 'Ramniwas Bagh', pincode: '302004' },
    { value: 'ramsar', label: 'Ramsar', pincode: '303706' },
    { value: 'raja-Park', label: 'Raja Park', pincode: '302004' },
    { value: 'raj-GPO', label: 'Jaipur GPO', pincode: '302001' },
    { value: 'renwal', label: 'Renwal', pincode: '303603' },
    { value: 'sansar-Chand-Road', label: 'Sansar Chand Road', pincode: '302001' },
    { value: 'sanganer', label: 'Sanganer', pincode: '302029' },
    { value: 'sanganer-Town', label: 'Sanganer Town', pincode: '302029' },
    { value: 'shahpura', label: 'Shahpura', pincode: '303103' },
    { value: 'shanti-Nagar', label: 'Shanti Nagar', pincode: '302019' },
    { value: 'shastri-Nagar', label: 'Shastri Nagar', pincode: '302016' },
    { value: 'shipra-Path', label: 'Shipra Path', pincode: '302020' },
    { value: 'shiv-Shakti-Nagar', label: 'Shiv Shakti Nagar', pincode: '302015' },
    { value: 'siddharth-Nagar', label: 'Siddharth Nagar', pincode: '302017' },
    { value: 'sikar-Road', label: 'Sikar Road', pincode: '302013' },
    { value: 'sirsi-Road', label: 'Sirsi Road', pincode: '302012' },
    { value: 'sitapura', label: 'Sitapura', pincode: '302022' },
    { value: 'sodala', label: 'Sodala', pincode: '302019' },
    { value: 'subhash-Chowk', label: 'Subhash Chowk', pincode: '302002' },
    { value: 'surajpole', label: 'Surajpole', pincode: '302003' },
    { value: 'surya-Nagar', label: 'Surya Nagar', pincode: '302015' },
    { value: 'thadi-Market', label: 'Thadi Market', pincode: '302017' },
    { value: 'tilak-Nagar', label: 'Tilak Nagar', pincode: '302004' },
    { value: 'tonk-Phatak', label: 'Tonk Phatak', pincode: '302015' },
    { value: 'tonk-Road', label: 'Tonk Road', pincode: '302018' },
    { value: 'topkhana-Hazuri', label: 'Topkhana Hazuri', pincode: '302002' },
    { value: 'transport-Nagar', label: 'Transport Nagar', pincode: '302003' },
    { value: 'tripolia-Bazar', label: 'Tripolia Bazar', pincode: '302002' },
    { value: 'tripolia-Gate', label: 'Tripolia Gate', pincode: '302002' },
    { value: 'vaishali-Nagar', label: 'Vaishali Nagar', pincode: '302021' },
    { value: 'vatika', label: 'Vatika', pincode: '302029' },
    { value: 'vidhyadhar-Nagar', label: 'Vidhyadhar Nagar', pincode: '302023' },
    { value: 'vidhyanagar', label: 'Vidhyanagar', pincode: '302022' },
    { value: 'vidyut-Nagar', label: 'Vidyut Nagar', pincode: '302021' },
    { value: 'vivek-Vihar', label: 'Vivek Vihar', pincode: '302015' },
    { value: 'zorawar-Singh-Gate', label: 'Zorawar Singh Gate', pincode: '302002' }
  ],

  'bikaner': [
    { value: 'akanwali', label: 'Akanwali', pincode: '334002' },
    { value: 'ambedkar-colony', label: 'Ambedkar Colony', pincode: '334001' },
    { value: 'amarsinghpura', label: 'Amarsinghpura', pincode: '334004' },
    { value: 'bajju-khalsa', label: 'Bajju Khalsa', pincode: '334001' },
    { value: 'bajju-khurd', label: 'Bajju Khurd', pincode: '334027' },
    { value: 'bandra-baas', label: 'Bandra Baas', pincode: '334004' },
    { value: 'bangla-nagar', label: 'Bangla Nagar', pincode: '334001' },
    { value: 'bhanwatan', label: 'Bhanwatan', pincode: '334006' },
    { value: 'bhinasar', label: 'Bhinasar', pincode: '334001' },
    { value: 'bikaner bypass', label: 'Bikaner Bypass', pincode: '334027' },
    { value: 'bikaner-cantt', label: 'Bikaner Cantt', pincode: '334002' },
    { value: 'brindavan-enclave', label: 'Brindavan Enclave', pincode: '334003' },
    { value: 'chaukhunti-mohalla', label: 'Chaukhunti Mohalla', pincode: '334001' },
    { value: 'chhajju-ki-dhani', label: 'Chhajju Ki Dhani', pincode: '334021' },
    { value: 'chudela', label: 'Chudela', pincode: '334018' },
    { value: 'dagon-ka-mohalla', label: 'Dagon Ka Mohalla', pincode: '334001' },
    { value: 'dantiwada', label: 'Dantiwada', pincode: '334028' },
    { value: 'deshnok', label: 'Deshnok', pincode: '334801' },
    { value: 'gajner-road', label: 'Gajner Road', pincode: '334302' },
    { value: 'gajne', label: 'Gajne', pincode: '334301' },
    { value: 'gangashahar-road', label: 'Gangashahar Road', pincode: '334001' },
    { value: 'ganganagar-bypass-road', label: 'Ganganagar Bypass Road', pincode: '334001' },
    { value: 'hanuman-hatha', label: 'Hanuman Hatha', pincode: '334001' },
    { value: 'industrial-area', label: 'Industrial Area', pincode: '334001' },
    { value: 'jai-narayan vyas-colony', label: 'Jai Narayan Vyas Colony', pincode: '334003' },
    { value: 'jaipur-road', label: 'Jaipur Road', pincode: '334001' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '334003' },
    { value: 'jnv colony', label: 'JNV Colony', pincode: '334003' },
    { value: 'joshiwara', label: 'Joshiwara', pincode: '334001' },
    { value: 'karni-nagar', label: 'Karni Nagar', pincode: '334003' },
    { value: 'karnisar-bhatiyan', label: 'Karnisar Bhatiyan', pincode: '334303' },
    { value: 'khara', label: 'Khara', pincode: '334303' },
    { value: 'khajuwala', label: 'Khajuwala', pincode: '334023' },
    { value: 'kodamdesar', label: 'Kodamdesar', pincode: '334601' },
    { value: 'kote-gate', label: 'Kote Gate', pincode: '334001' },
    { value: 'kuchilpura', label: 'Kuchilpura', pincode: '334001' },
    { value: 'lunkaransar', label: 'Lunkaransar', pincode: '334603' },
    { value: 'm.p-colony', label: 'M.P. Colony', pincode: '334001' },
    { value: 'major-purnasingh-nagar', label: 'Major Purnasingh Nagar', pincode: '334003' },
    { value: 'mandalgarh', label: 'Mandalgarh', pincode: '334029' },
    { value: 'mehron-ka-bas', label: 'Mehron Ka Bas', pincode: '334303' },
    { value: 'mukta-prasad-nagar', label: 'Mukta Prasad Nagar', pincode: '334001' },
    { value: 'murlidhar-vyas-colony', label: 'Murlidhar Vyas Colony', pincode: '334003' },
    { value: 'nal-road', label: 'Nal Road', pincode: '334001' },
    { value: 'nathusar', label: 'Nathusar', pincode: '334010' },
    { value: 'noorsar', label: 'Noorsar', pincode: '334301' },
    { value: 'nokha', label: 'Nokha', pincode: '334803' },
    { value: 'nokha road', label: 'Nokha Road', pincode: '334001' },
    { value: 'pachpadra', label: 'Pachpadra', pincode: '334005' },
    { value: 'palana', label: 'Palana', pincode: '334301' },
    { value: 'pugal', label: 'Pugal', pincode: '334022' },
    { value: 'rani-bazar', label: 'Rani Bazar', pincode: '334001' },
    { value: 'ranisar-bara-bas', label: 'Ranisar Bara Bas', pincode: '334303' },
    { value: 'rath-khana-colony', label: 'Rath Khana Colony', pincode: '334004' },
    { value: 'sadar-bazaar', label: 'Sadar Bazaar', pincode: '334001' },
    { value: 'samastha-nagar', label: 'Samasta Nagar', pincode: '334003' },
    { value: 'samta-nagar', label: 'Samta Nagar', pincode: '334001' },
    { value: 'sardar-patel-colony', label: 'Sardar Patel Colony', pincode: '334001' },
    { value: 'saraswati-vihar', label: 'Saraswati Vihar', pincode: '334008' },
    { value: 'sector-4', label: 'Sector 4', pincode: '334004' },
    { value: 'sector-5', label: 'Sector 5', pincode: '334004' },
    { value: 'sharah-pabi-brahmani', label: 'Sharah Pabi Brahmani', pincode: '334001' },
    { value: 'shardul-colony', label: 'Shardul Colony', pincode: '334004' },
    { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '334001' },
    { value: 'shivbari-rural', label: 'Shivbari Rural', pincode: '334005' },
    { value: 'shri-dungargarh', label: 'Shri Dungargarh', pincode: '334804' },
    { value: 'sikar-road', label: 'Sikar Road', pincode: '334009' },
    { value: 'sinthal', label: 'Sinthal', pincode: '334001' },
    { value: 'sujandesar', label: 'Sujandesar', pincode: '334023' },
    { value: 'sudarshana-nagar', label: 'Sudarshana Nagar', pincode: '334001' },
    { value: 'surajpura-colony', label: 'Surajpura Colony', pincode: '334001' },
    { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '334003' },
    { value: 'udairamsar', label: 'Udairamsar', pincode: '334301' },
    { value: 'vallabh-garden', label: 'Vallabh Garden', pincode: '334003' }
  ],

  'gwalior': [
    { value: 'agarwal-colony', label: 'Agarwal Colony', pincode: '474011' },
    { value: 'agarwal-nagar', label: 'Agarwal Nagar', pincode: '474001' },
    { value: 'ajay-nagar', label: 'Ajay Nagar', pincode: '474020' },
    { value: 'alka-puri', label: 'Alka Puri', pincode: '474001' },
    { value: 'bada-gaon', label: 'Bada Gaon', pincode: '474020' },
    { value: 'bagh-laxmi-bai', label: 'Bagh Laxmi Bai', pincode: '474003' },
    { value: 'bansal-complex', label: 'Bansal Complex', pincode: '474003' },
    { value: 'bargi', label: 'Bargi', pincode: '474005' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '474020' },
    { value: 'bhawani-ganj', label: 'Bhawani Ganj', pincode: '474001' },
    { value: 'bhind-road', label: 'Bhind Road', pincode: '474003' },
    { value: 'bhitarwar', label: 'Bhitarwar', pincode: '474030' },
    { value: 'chandpura', label: 'Chandpura', pincode: '474007' },
    { value: 'chhatri-talao', label: 'Chhatri Talao', pincode: '474008' },
    { value: 'chitani', label: 'Chitani', pincode: '474020' },
    { value: 'city-centre', label: 'City Centre', pincode: '474001' },
    { value: 'daboh', label: 'Daboh', pincode: '474006' },
    { value: 'dabrapur', label: 'Dabrapur', pincode: '474020' },
    { value: 'dewas-ghat', label: 'Dewas Ghat', pincode: '474020' },
    { value: 'dewasgate', label: 'Dewasgate', pincode: '474001' },
    { value: 'dhanwantri-nagar', label: 'Dhanwantri Nagar', pincode: '474011' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '474005' },
    { value: 'gola-ka-mandir', label: 'Gola Ka Mandir', pincode: '474004' },
    { value: 'gurh', label: 'Gurh', pincode: '474010' },
    { value: 'gurjari-market', label: 'Gurjari Market', pincode: '474001' },
    { value: 'gurudwara', label: 'Gurudwara', pincode: '474005' },
    { value: 'gwalior-airport-area', label: 'Gwalior Airport Area', pincode: '474020' },
    { value: 'gwalior-east', label: 'Gwalior East', pincode: '474001' },
    { value: 'gwalior-fort', label: 'Gwalior Fort', pincode: '474008' },
    { value: 'gwalior-fort-area', label: 'Gwalior Fort Area', pincode: '474008' },
    { value: 'gwalior-north', label: 'Gwalior North', pincode: '474009' },
    { value: 'gwalior-railway-station', label: 'Gwalior Railway Station', pincode: '474002' },
    { value: 'gwalior-west', label: 'Gwalior West', pincode: '474003' },
    { value: 'inderganj', label: 'Inderganj', pincode: '474001' },
    { value: 'indra-colony', label: 'Indra Colony', pincode: '474002' },
    { value: 'jahangirabad', label: 'Jahangirabad', pincode: '474003' },
    { value: 'jai-stambh', label: 'Jai Stambh', pincode: '474001' },
    { value: 'jiwaji-ganj', label: 'Jiwaji Ganj', pincode: '474001' },
    { value: 'jiwaji-university', label: 'Jiwaji University', pincode: '474011' },
    { value: 'kailash-nagar', label: 'Kailash Nagar', pincode: '474005' },
    { value: 'kailash-vihar', label: 'Kailash Vihar', pincode: '474011' },
    { value: 'kanchan-bagh', label: 'Kanchan Bagh', pincode: '474007' },
    { value: 'kacheri-road', label: 'Kacheri Road', pincode: '474002' },
    { value: 'khajji-ki-bazar', label: 'Khajji Ki Bazar', pincode: '474002' },
    { value: 'khailar', label: 'Khailar', pincode: '474003' },
    { value: 'laxmi-bai-nagar', label: 'Laxmi Bai Nagar', pincode: '474011' },
    { value: 'laxmi-khera', label: 'Laxmi Khera', pincode: '474001' },
    { value: 'lashkar', label: 'Lashkar', pincode: '474001' },
    { value: 'madan-mahal', label: 'Madan Mahal', pincode: '474004' },
    { value: 'madar-khera', label: 'Madar Khera', pincode: '474006' },
    { value: 'mahal-kacheri', label: 'Mahal Kacheri', pincode: '474001' },
    { value: 'mahalgaon', label: 'Mahalgaon', pincode: '474007' },
    { value: 'maharajpur', label: 'Maharajpur', pincode: '474001' },
    { value: 'maharani-laxmi-bai-road', label: 'Maharani Laxmi Bai Road', pincode: '474001' },
    { value: 'mahatma-gandhi-road', label: 'Mahatma Gandhi Road', pincode: '474001' },
    { value: 'morar', label: 'Morar', pincode: '474006' },
    { value: 'moti-mahal', label: 'Moti Mahal', pincode: '474001' },
    { value: 'moti-mahal-road', label: 'Moti Mahal Road', pincode: '474001' },
    { value: 'narmada-colony', label: 'Narmada Colony', pincode: '474001' },
    { value: 'nayapura', label: 'Nayapura', pincode: '474005' },
    { value: 'new-rajendra-nagar', label: 'New Rajendra Nagar', pincode: '474003' },
    { value: 'pachmadiya', label: 'Pachmadiya', pincode: '474001' },
    { value: 'panchsheel-nagar', label: 'Panchsheel Nagar', pincode: '474001' },
    { value: 'phool-bagh', label: 'Phool Bagh', pincode: '474001' },
    { value: 'pichhore', label: 'Pichhore', pincode: '474002' },
    { value: 'pipliyahana', label: 'Pipliyahana', pincode: '474001' },
    { value: 'purani-chhawani', label: 'Purani Chhawani', pincode: '474005' },
    { value: 'raghuveer-pura', label: 'Raghuveer Pura', pincode: '474001' },
    { value: 'rajakhedi', label: 'Rajakhedi', pincode: '474020' },
    { value: 'rajeev-nagar', label: 'Rajeev Nagar', pincode: '474004' },
    { value: 'rai-ka-bagh', label: 'Rai Ka Bagh', pincode: '474001' },
    { value: 'ram-ghat', label: 'Ram Ghat', pincode: '474008' },
    { value: 'raoji-bazar', label: 'Raoji Bazar', pincode: '474002' },
    { value: 'rohini', label: 'Rohini', pincode: '474020' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '474001' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '474002' },
    { value: 'samar-ganj', label: 'Samar Ganj', pincode: '474002' },
    { value: 'sarai-bazar', label: 'Sarai Bazar', pincode: '474003' },
    { value: 'sarai-mohana', label: 'Sarai Mohana', pincode: '474011' },
    { value: 'shanti-nagar', label: 'Shanti Nagar', pincode: '474005' },
    { value: 'shiv-mandir', label: 'Shiv Mandir', pincode: '474001' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '474010' },
    { value: 'shivpuri', label: 'Shivpuri', pincode: '474002' },
    { value: 'shivpuri-road', label: 'Shivpuri Road', pincode: '474010' },
    { value: 'sikandar-khera', label: 'Sikandar Khera', pincode: '474006' },
    { value: 'sikandari', label: 'Sikandari', pincode: '474002' },
    { value: 'soni-ka-bada', label: 'Soni Ka Bada', pincode: '474001' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '474005' },
    { value: 'surajganj', label: 'Surajganj', pincode: '474001' },
    { value: 'tehsil-office-area', label: 'Tehsil Office Area', pincode: '474001' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '474004' }
  ],
  'goa': [
    { value: 'aldona', label: 'Aldona', pincode: '403508' },
    { value: 'anjuna', label: 'Anjuna', pincode: '403509' },
    { value: 'aquem', label: 'Aquem', pincode: '403601' },
    { value: 'arambol', label: 'Arambol', pincode: '403524' },
    { value: 'bambolim', label: 'Bambolim', pincode: '403201' },
    { value: 'bandora', label: 'Bandora', pincode: '403401' },
    { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
    { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
    { value: 'borim', label: 'Borim', pincode: '403401' },
    { value: 'calangute', label: 'Calangute', pincode: '403516' },
    { value: 'calapor', label: 'Calapor', pincode: '403726' },
    { value: 'canacona', label: 'Canacona', pincode: '403702' },
    { value: 'candola', label: 'Candola', pincode: '403406' },
    { value: 'candolim', label: 'Candolim', pincode: '403515' },
    { value: 'carapur', label: 'Carapur', pincode: '403505' },
    { value: 'chicalim', label: 'Chicalim', pincode: '403711' },
    { value: 'chimbel', label: 'Chimbel', pincode: '403006' },
    { value: 'chinchinim', label: 'Chinchinim', pincode: '403715' },
    { value: 'colvale', label: 'Colvale', pincode: '403513' },
    { value: 'corlim', label: 'Corlim', pincode: '403110' },
    { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
    { value: 'cumbarjua', label: 'Cumbarjua', pincode: '403107' },
    { value: 'cuncolim', label: 'Cuncolim', pincode: '403703' },
    { value: 'curchorem-cacora', label: 'Curchorem-Cacora', pincode: '403706' },
    { value: 'curti', label: 'Curti', pincode: '403401' },
    { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
    { value: 'davorlim', label: 'Davorlim', pincode: '403707' },
    { value: 'goa-velha', label: 'Goa Velha', pincode: '403108' },
    { value: 'guirim', label: 'Guirim', pincode: '403507' },
    { value: 'jua', label: 'Jua', pincode: '403102' },
    { value: 'mandrem', label: 'Mandrem', pincode: '403527' },
    { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
    { value: 'marcaim', label: 'Marcaim', pincode: '403404' },
    { value: 'margao', label: 'Margao', pincode: '403601' },
    { value: 'mercurim', label: 'Mercurim', pincode: '403705' },
    { value: 'moira', label: 'Moira', pincode: '403507' },
    { value: 'morjim', label: 'Morjim', pincode: '403512' },
    { value: 'mormugao', label: 'Mormugao', pincode: '403803' },
    { value: 'murda', label: 'Murda', pincode: '403523' },
    { value: 'navelim', label: 'Navelim', pincode: '403716' },
    { value: 'nerul', label: 'Nerul', pincode: '403114' },
    { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
    { value: 'onda', label: 'Onda', pincode: '403706' },
    { value: 'orgao', label: 'Orgao', pincode: '403504' },
    { value: 'pale', label: 'Pale', pincode: '403105' },
    { value: 'panaji', label: 'Panaji', pincode: '403001' },
    { value: 'parcem', label: 'Parcem', pincode: '403512' },
    { value: 'penha-de-franca', label: 'Penha de Franca', pincode: '403101' },
    { value: 'pernem', label: 'Pernem', pincode: '403512' },
    { value: 'pilerne', label: 'Pilerne', pincode: '403114' },
    { value: 'ponda', label: 'Ponda', pincode: '403401' },
    { value: 'priol', label: 'Priol', pincode: '403404' },
    { value: 'quela', label: 'Quela', pincode: '403706' },
    { value: 'quepem', label: 'Quepem', pincode: '403705' },
    { value: 'raia', label: 'Raia', pincode: '403720' },
    { value: 'reis-magos', label: 'Reis Magos', pincode: '403114' },
    { value: 'saligao', label: 'Saligao', pincode: '403511' },
    { value: 'salvador-do-mundo', label: 'Salvador do Mundo', pincode: '403101' },
    { value: 'sancoale', label: 'Sancoale', pincode: '403726' },
    { value: 'sanguem', label: 'Sanguem', pincode: '403704' },
    { value: 'sanquelim', label: 'Sanquelim', pincode: '403505' },
    { value: 'sanvordem', label: 'Sanvordem', pincode: '403506' },
    { value: 'sao-jose-de-areal', label: 'São José de Areal', pincode: '403709' },
    { value: 'siolim', label: 'Siolim', pincode: '403517' },
    { value: 'socorro', label: 'Socorro', pincode: '403501' },
    { value: 'usgao', label: 'Usgao', pincode: '403406' },
    { value: 'valpoi', label: 'Valpoi', pincode: '403506' },
    { value: 'varca', label: 'Varca', pincode: '403721' },
    { value: 'verna', label: 'Verna', pincode: '403722' },
    { value: 'xeldem', label: 'Xeldem', pincode: '403705' }
  ],
'alorna': [
  { value: 'advalpal', label: 'Advalpal', pincode: '403505' },
  { value: 'alorna', label: 'Alorna', pincode: '403508' },
  { value: 'assonora', label: 'Assonora', pincode: '403505' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403711' },
  { value: 'cuelim', label: 'Cuelim', pincode: '403721' },
  { value: 'dhargal', label: 'Dhargal', pincode: '403507' },
  { value: 'karapur', label: 'Karapur', pincode: '403518' },
  { value: 'kundaim', label: 'Kundaim', pincode: '403115' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'mollem', label: 'Mollem', pincode: '403410' },
  { value: 'mormugao', label: 'Mormugao', pincode: '403803' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'peddem', label: 'Peddem', pincode: '403512' },
  { value: 'pedem', label: 'Pedem', pincode: '403519' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'agonda', label: 'Agonda', pincode: '403702' },
  { value: 'chandor', label: 'Chandor', pincode: '403714' },
  { value: 'sangolda', label: 'Sangolda', pincode: '403511' }
  ],
  
  'anjuna': [
  { value: 'agonda', label: 'Agonda', pincode: '403702' },
  { value: 'anjuna', label: 'Anjuna', pincode: '403509' },
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403711' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'arambol', label: 'Arambol', pincode: '403524' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' }
  ],
  
  'arambol': [
  { value: 'agonda', label: 'Agonda', pincode: '403702' },
  { value: 'arambol', label: 'Arambol', pincode: '403524' },
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403711' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'agassaim', label: 'Agassaim', pincode: '403110' },
  { value: 'alorna', label: 'Alorna', pincode: '403508' },
  { value: 'arambolim', label: 'Arambolim', pincode: '403521' },
  { value: 'assonora', label: 'Assonora', pincode: '403505' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403736' }
  ],
  
  'assonora': [
  { value: 'agonda', label: 'Agonda', pincode: '403702' },
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'assonora', label: 'Assonora', pincode: '403505' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403711' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'agassaim', label: 'Agassaim', pincode: '403110' },
  { value: 'alorna', label: 'Alorna', pincode: '403508' },
  { value: 'arambolim', label: 'Arambolim', pincode: '403521' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'camurlim', label: 'Camurlim', pincode: '403503' },
  { value: 'caranzalem', label: 'Caranzalem', pincode: '403002' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'hellore', label: 'Hellore', pincode: '403102' },
  { value: 'mashem', label: 'Mashem', pincode: '403702' },
  { value: 'pendur', label: 'Pendur', pincode: '403705' }
  ],
  
  'benaulim': [
  { value: 'agonda', label: 'Agonda', pincode: '403702' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403711' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'agassaim', label: 'Agassaim', pincode: '403110' },
  { value: 'alorna', label: 'Alorna', pincode: '403508' },
  { value: 'arambolim', label: 'Arambolim', pincode: '403521' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403711' },
  { value: 'hellore', label: 'Hellore', pincode: '403102' },
  { value: 'madgaon', label: 'Madgaon', pincode: '403701' },
  { value: 'sanvordem', label: 'Sanvordem', pincode: '403704' },
  { value: 'viegas', label: 'Viegas', pincode: '403404' }
  ],
  
  'bhati': [
  { value: 'agonda', label: 'Agonda', pincode: '403702' },
  { value: 'alorna', label: 'Alorna', pincode: '403508' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403711' },
  { value: 'hellore', label: 'Hellore', pincode: '403102' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'agassaim', label: 'Agassaim', pincode: '403110' },
  { value: 'arambolim', label: 'Arambolim', pincode: '403521' },
  { value: 'camurlim', label: 'Camurlim', pincode: '403503' },
  { value: 'caranzalem', label: 'Caranzalem', pincode: '403002' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'dona-paul', label: 'Dona Paul', pincode: '403004' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'siroda', label: 'Siroda', pincode: '403410' },
  { value: 'vaddy', label: 'Vaddy', pincode: '403506' }
  ],
  
  'dicholi': [
  { value: 'agonda', label: 'Agonda', pincode: '403702' },
  { value: 'alorna', label: 'Alorna', pincode: '403508' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403711' },
  { value: 'hellore', label: 'Hellore', pincode: '403102' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'agassaim', label: 'Agassaim', pincode: '403110' },
  { value: 'arambolim', label: 'Arambolim', pincode: '403521' },
  { value: 'camurlim', label: 'Camurlim', pincode: '403503' },
  { value: 'caranzalem', label: 'Caranzalem', pincode: '403002' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'siroda', label: 'Siroda', pincode: '403410' },
  { value: 'vaddy', label: 'Vaddy', pincode: '403506' },
  { value: 'bandora', label: 'Bandora', pincode: '403401' },
  { value: 'betul-bicholim', label: 'Betul-Bicholim', pincode: '403736' },
  { value: 'chalvar', label: 'Chalvar', pincode: '403512' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403717' },
  { value: 'kavali', label: 'Kavali', pincode: '403114' },
  { value: 'loliem', label: 'Loliem', pincode: '403703' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'merces', label: 'Merces', pincode: '403004' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' }
  ],
  
  'candolim': [
  { value: 'agonda', label: 'Agonda', pincode: '403702' },
  { value: 'alorna', label: 'Alorna', pincode: '403508' },
  { value: 'anjuna', label: 'Anjuna', pincode: '403509' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403711' },
  { value: 'dona-paul', label: 'Dona Paul', pincode: '403004' },
  { value: 'hellore', label: 'Hellore', pincode: '403102' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'agassaim', label: 'Agassaim', pincode: '403110' },
  { value: 'arambolim', label: 'Arambolim', pincode: '403521' },
  { value: 'camurlim', label: 'Camurlim', pincode: '403503' },
  { value: 'caranzalem', label: 'Caranzalem', pincode: '403002' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'siroda', label: 'Siroda', pincode: '403410' },
  { value: 'vaddy', label: 'Vaddy', pincode: '403506' },
  { value: 'bandora', label: 'Bandora', pincode: '403401' },
  { value: 'betul-bicholim', label: 'Betul-Bicholim', pincode: '403736' },
  { value: 'chalvar', label: 'Chalvar', pincode: '403512' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403717' },
  { value: 'kavali', label: 'Kavali', pincode: '403114' },
  { value: 'loliem', label: 'Loliem', pincode: '403703' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'merces', label: 'Merces', pincode: '403004' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'betul-quepem', label: 'Betul-Quepem', pincode: '403706' },
  { value: 'panaji', label: 'Panaji', pincode: '403001' },
  { value: 'patnem', label: 'Patnem', pincode: '403702' },
  { value: 'taleigao', label: 'Taleigao', pincode: '403002' },
  { value: 'varca', label: 'Varca', pincode: '403721' },
  { value: 'verem-parra', label: 'Verem-Parra', pincode: '403510' },
  ],
  
  'caranzalem': [
  { value: 'agonda', label: 'Agonda', pincode: '403702' },
  { value: 'alorna', label: 'Alorna', pincode: '403508' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'dona-paul', label: 'Dona Paul', pincode: '403004' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'hellore', label: 'Hellore', pincode: '403102' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'agassaim', label: 'Agassaim', pincode: '403110' },
  { value: 'arambolim', label: 'Arambolim', pincode: '403521' },
  { value: 'camurlim', label: 'Camurlim', pincode: '403503' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'siroda', label: 'Siroda', pincode: '403410' },
  { value: 'vaddy', label: 'Vaddy', pincode: '403506' },
  { value: 'bandora', label: 'Bandora', pincode: '403401' },
  { value: 'betul-bicholim', label: 'Betul-Bicholim', pincode: '403736' },
  { value: 'chalvar', label: 'Chalvar', pincode: '403512' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403717' },
  { value: 'kavali', label: 'Kavali', pincode: '403114' },
  { value: 'loliem', label: 'Loliem', pincode: '403703' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'merces', label: 'Merces', pincode: '403004' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'palem', label: 'Palem', pincode: '403107' },
  { value: 'peddem', label: 'Peddem', pincode: '403501' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'piedade', label: 'Piedade', pincode: '403706' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'merces-bicholim', label: 'Merces-Bicholim', pincode: '403504' }
  ],
  
  'chandor': [
  { value: 'adcolim', label: 'Adcolim', pincode: '403708' },
  { value: 'alorna', label: 'Alorna', pincode: '403508' },
  { value: 'assolna', label: 'Assolna', pincode: '403709' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'dona-paul', label: 'Dona Paul', pincode: '403004' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'siroda', label: 'Siroda', pincode: '403410' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'adpale', label: 'Adpale', pincode: '403403' },
  { value: 'algouba', label: 'Algouba', pincode: '403115' },
  { value: 'altinho', label: 'Altinho', pincode: '403503' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'betul-bicholim', label: 'Betul-Bicholim', pincode: '403736' },
  { value: 'chandor-bicholim', label: 'Chandor-Bicholim', pincode: '403503' },
  { value: 'choimem', label: 'Choimem', pincode: '403717' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403708' },
  { value: 'davli', label: 'Davli', pincode: '403411' },
  { value: 'fatorpa', label: 'Fatorpa', pincode: '403710' },
  { value: 'hempapri', label: 'Hempapri', pincode: '403205' },
  { value: 'hospicio', label: 'Hospicio', pincode: '403601' },
  { value: 'kavali', label: 'Kavali', pincode: '403114' },
  { value: 'loliem', label: 'Loliem', pincode: '403703' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'merces', label: 'Merces', pincode: '403004' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'piedade', label: 'Piedade', pincode: '403706' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'merces-bicholim', label: 'Merces-Bicholim', pincode: '403504' }
  ],
  
  'cansaulim': [
  { value: 'adcolim', label: 'Adcolim', pincode: '403708' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403736' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403708' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'dona-paul', label: 'Dona Paul', pincode: '403004' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'mapusa', label: 'Mapusa', pincode: '403507' },
  { value: 'morjim', label: 'Morjim', pincode: '403512' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santacruz', label: 'Santacruz', pincode: '403402' },
  { value: 'siroda', label: 'Siroda', pincode: '403410' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403510' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'adpale', label: 'Adpale', pincode: '403403' },
  { value: 'algouba', label: 'Algouba', pincode: '403115' },
  { value: 'altinho', label: 'Altinho', pincode: '403503' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'betul-bicholim', label: 'Betul-Bicholim', pincode: '403736' },
  { value: 'chandor-bicholim', label: 'Chandor-Bicholim', pincode: '403503' },
  { value: 'choimem', label: 'Choimem', pincode: '403717' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403708' },
  { value: 'davli', label: 'Davli', pincode: '403411' },
  { value: 'fatorpa', label: 'Fatorpa', pincode: '403710' },
  { value: 'hempapri', label: 'Hempapri', pincode: '403205' },
  { value: 'hospicio', label: 'Hospicio', pincode: '403601' },
  { value: 'kavali', label: 'Kavali', pincode: '403114' },
  { value: 'loliem', label: 'Loliem', pincode: '403703' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'merces', label: 'Merces', pincode: '403004' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'piedade', label: 'Piedade', pincode: '403706' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'merces-bicholim', label: 'Merces-Bicholim', pincode: '403504' },
  { value: 'siroda-bicholim', label: 'Siroda-Bicholim', pincode: '403510' }
  ],
  
  'colva': [
  { value: 'adcolim', label: 'Adcolim', pincode: '403708' },
  { value: 'aldona', label: 'Aldona', pincode: '403508' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'borda', label: 'Borda', pincode: '403601' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403708' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'fatorda', label: 'Fatorda', pincode: '403602' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'hempapri', label: 'Hempapri', pincode: '403205' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'loliem', label: 'Loliem', pincode: '403703' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'merces', label: 'Merces', pincode: '403004' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'siroda', label: 'Siroda', pincode: '403410' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'village', label: 'Village', pincode: '403702' },
  { value: 'piedade', label: 'Piedade', pincode: '403706' },
  { value: 'raia-bicholim', label: 'Raia-Bicholim', pincode: '403717' }
  ],
  
  'cortalim': [
  { value: 'adcolim', label: 'Adcolim', pincode: '403708' },
  { value: 'aldona', label: 'Aldona', pincode: '403508' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'borda', label: 'Borda', pincode: '403601' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'fatorda', label: 'Fatorda', pincode: '403602' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'hempapri', label: 'Hempapri', pincode: '403205' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'loliem', label: 'Loliem', pincode: '403703' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'merces', label: 'Merces', pincode: '403004' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'siroda', label: 'Siroda', pincode: '403410' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'village', label: 'Village', pincode: '403702' },
  { value: 'piedade', label: 'Piedade', pincode: '403706' },
  { value: 'raia-bicholim', label: 'Raia-Bicholim', pincode: '403717' },
  { value: 'sirsaim', label: 'Sirsaim', pincode: '403503' },
  { value: 'vichundrem', label: 'Vichundrem', pincode: '403706' },
  { value: 'chandor', label: 'Chandor', pincode: '403714' },
  { value: 'canacona', label: 'Canacona', pincode: '403702' },
  { value: 'palai', label: 'Palai', pincode: '403719' },
  { value: 'anem', label: 'Anem', pincode: '403401' }
  ],
  
  'curti': [
  { value: 'adcolim', label: 'Adcolim', pincode: '403706' },
  { value: 'aldona', label: 'Aldona', pincode: '403508' },
  { value: 'assonora', label: 'Assonora', pincode: '403503' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'curtorim', label: 'Curtorim', pincode: '403709' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'fatorda', label: 'Fatorda', pincode: '403602' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'hempapri', label: 'Hempapri', pincode: '403205' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'loliem', label: 'Loliem', pincode: '403703' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'merces', label: 'Merces', pincode: '403004' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'siroda', label: 'Siroda', pincode: '403410' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'village', label: 'Village', pincode: '403702' },
  { value: 'piedade', label: 'Piedade', pincode: '403706' },
  { value: 'raia-bicholim', label: 'Raia-Bicholim', pincode: '403717' },
  { value: 'polem-beach', label: 'Polem Beach', pincode: '403702' },
  { value: 'cotigao', label: 'Cotigao', pincode: '403704' },
  { value: 'assolna', label: 'Assolna', pincode: '403701' },
  { value: 'betul', label: 'Betul', pincode: '403724' },
  { value: 'camurlim', label: 'Camurlim', pincode: '403703' },
  { value: 'canacona', label: 'Canacona', pincode: '403702' },
  { value: 'cortalim-bicholim', label: 'Cortalim-Bicholim', pincode: '403718' },
  { value: 'verem', label: 'Verem', pincode: '403105' }
  ],
  
  'dona-paula': [
  { value: 'alta-vidas', label: 'Alta Vidas', pincode: '403004' },
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'betim', label: 'Betim', pincode: '403101' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403718' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'dona-paula', label: 'Dona Paula', pincode: '403004' },
  { value: 'fatorda', label: 'Fatorda', pincode: '403602' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'hempapri', label: 'Hempapri', pincode: '403205' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'merces', label: 'Merces', pincode: '403004' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'velim', label: 'Velim', pincode: '403723' },
  { value: 'cortalim-bicholim', label: 'Cortalim-Bicholim', pincode: '403718' },
  { value: 'loutolim-bicholim', label: 'Loutolim-Bicholim', pincode: '403717' },
  { value: 'polem-beach', label: 'Polem Beach', pincode: '403702' },
  { value: 'raia-sanguem', label: 'Raia-Sanguem', pincode: '403717' },
  { value: 'santa-cruz-bicholim', label: 'Santa Cruz-Bicholim', pincode: '403104' },
  { value: 'assolna', label: 'Assolna', pincode: '403701' },
  { value: 'betul', label: 'Betul', pincode: '403724' },
  { value: 'camurlim', label: 'Camurlim', pincode: '403703' },
  { value: 'canacona', label: 'Canacona', pincode: '403702' },
  { value: 'cotigao', label: 'Cotigao', pincode: '403704' },
  { value: 'verem', label: 'Verem', pincode: '403105' },
  ],
  
  'guirim': [
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403718' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'hempapri', label: 'Hempapri', pincode: '403205' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'batim', label: 'Batim', pincode: '403109' },
  { value: 'cortalim-velim', label: 'Cortalim-Velim', pincode: '403703' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'bhati', label: 'Bhati', pincode: '403105' },
  { value: 'guirim-1', label: 'Guirim-1', pincode: '403507' },
  { value: 'guirim-2', label: 'Guirim-2', pincode: '403507' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'velim', label: 'Velim', pincode: '403723' }
  ],
  
  'kavlem': [
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403718' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'hempapri', label: 'Hempapri', pincode: '403205' },
  { value: 'kavlem', label: 'Kavlem', pincode: '403107' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'batim', label: 'Batim', pincode: '403109' },
  { value: 'kavlem-1', label: 'Kavlem-1', pincode: '403107' },
  { value: 'kavlem-2', label: 'Kavlem-2', pincode: '403107' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'betqui', label: 'Betqui', pincode: '403704' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403706' },
  { value: 'curti', label: 'Curti', pincode: '403703' },
  { value: 'paroda', label: 'Paroda', pincode: '403701' },
  { value: 'cortalim-velim', label: 'Cortalim-Velim', pincode: '403703' },
  { value: 'tonca', label: 'Tonca', pincode: '403601' }
  ],
  
  'loutolim': [
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403718' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'hempapri', label: 'Hempapri', pincode: '403205' },
  { value: 'kavlem', label: 'Kavlem', pincode: '403107' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'loutolim-bhati', label: 'Loutolim Bhati', pincode: '403717' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'old-goa', label: 'Old Goa', pincode: '403402' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'velsao', label: 'Velsao', pincode: '403713' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'batim', label: 'Batim', pincode: '403109' },
  { value: 'betqui', label: 'Betqui', pincode: '403704' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403706' },
  { value: 'curti', label: 'Curti', pincode: '403703' },
  { value: 'paroda', label: 'Paroda', pincode: '403701' },
  { value: 'betul', label: 'Betul', pincode: '403717' },
  { value: 'ramponem', label: 'Ramponem', pincode: '403717' },
  { value: 'raia', label: 'Raia', pincode: '403717' },
  { value: 'zambaulim', label: 'Zambaulim', pincode: '403709' }
  ],
  
  'madgaon': [
  { value: 'assolna', label: 'Assolna', pincode: '403718' },
  { value: 'avadem', label: 'Avadem', pincode: '403704' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403717' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403718' },
  { value: 'curti', label: 'Curti', pincode: '403703' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403706' },
  { value: 'divar', label: 'Divar', pincode: '403403' },
  { value: 'fatorda', label: 'Fatorda', pincode: '403602' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'kavlem', label: 'Kavlem', pincode: '403107' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'rajabhat', label: 'Rajabhat', pincode: '403707' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'santa-cruz', label: 'Santa Cruz', pincode: '403104' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'village-vadla', label: 'Village Vadla', pincode: '403707' },
  { value: 'zambaulim', label: 'Zambaulim', pincode: '403709' }
  ],
  
  'majorda': [
  { value: 'assolna', label: 'Assolna', pincode: '403718' },
  { value: 'awadem', label: 'Awadem', pincode: '403704' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403717' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403718' },
  { value: 'curti', label: 'Curti', pincode: '403703' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403706' },
  { value: 'fatorda', label: 'Fatorda', pincode: '403602' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'kavlem', label: 'Kavlem', pincode: '403107' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'majorda', label: 'Majorda', pincode: '403713' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salcete', label: 'Salcete', pincode: '403708' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'village-vadla', label: 'Village Vadla', pincode: '403707' },
  { value: 'zambaulim', label: 'Zambaulim', pincode: '403709' }
  ],
  
  'mapusa': [
  { value: 'aldona', label: 'Aldona', pincode: '403508' },
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'assonora', label: 'Assonora', pincode: '403501' },
  { value: 'bagmalo', label: 'Bagmalo', pincode: '403507' },
  { value: 'badem', label: 'Badem', pincode: '403507' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'caranzalem', label: 'Caranzalem', pincode: '403002' },
  { value: 'chapora', label: 'Chapora', pincode: '403509' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403718' },
  { value: 'curti', label: 'Curti', pincode: '403703' },
  { value: 'dona-paula', label: 'Dona Paula', pincode: '403004' },
  { value: 'fatorda', label: 'Fatorda', pincode: '403602' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'kavlem', label: 'Kavlem', pincode: '403107' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'maem', label: 'Maem', pincode: '403505' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'parra', label: 'Parra', pincode: '403510' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'salvador-do-mundo', label: 'Salvador do Mundo', pincode: '403507' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403705' },
  { value: 'tivim', label: 'Tivim', pincode: '403507' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'zambaulim', label: 'Zambaulim', pincode: '403709' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'chinchinim', label: 'Chinchinim', pincode: '403705' },
  { value: 'dauna', label: 'Dauna', pincode: '403518' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' }
  ],
  
  'margao': [
  { value: 'assolna', label: 'Assolna', pincode: '403720' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403718' },
  { value: 'fatorda', label: 'Fatorda', pincode: '403602' },
  { value: 'guirdolim', label: 'Guirdolim', pincode: '403507' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'maem', label: 'Maem', pincode: '403505' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'paroda', label: 'Paroda', pincode: '403712' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'zambaulim', label: 'Zambaulim', pincode: '403709' },
  { value: 'mollem', label: 'Mollem', pincode: '403410' },
  { value: 'betalbatim', label: 'Betalbatim', pincode: '403713' },
  { value: 'chinchinim', label: 'Chinchinim', pincode: '403705' },
  { value: 'rajbhag', label: 'Rajbhag', pincode: '403702' },
  { value: 'sanvordem', label: 'Sanvordem', pincode: '403703' },
  { value: 'velim', label: 'Velim', pincode: '403723' },
  { value: 'cavelossim', label: 'Cavelossim', pincode: '403731' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'verem', label: 'Verem', pincode: '403113' },
  { value: 'betul', label: 'Betul', pincode: '403722' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'colva', label: 'Colva', pincode: '403708' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403601' }
  ],
  
  'mollem': [
  { value: 'assolna', label: 'Assolna', pincode: '403720' },
  { value: 'cavelossim', label: 'Cavelossim', pincode: '403731' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'maem', label: 'Maem', pincode: '403505' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'mollem', label: 'Mollem', pincode: '403410' },
  { value: 'paroda', label: 'Paroda', pincode: '403712' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'zambaulim', label: 'Zambaulim', pincode: '403709' },
  { value: 'betul', label: 'Betul', pincode: '403722' },
  { value: 'chinchinim', label: 'Chinchinim', pincode: '403705' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'rangado', label: 'Rangado', pincode: '403705' }
  ],
  
  'monte': [
  { value: 'assolna', label: 'Assolna', pincode: '403720' },
  { value: 'betul', label: 'Betul', pincode: '403722' },
  { value: 'cavelossim', label: 'Cavelossim', pincode: '403731' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'mollem', label: 'Mollem', pincode: '403410' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'paroda', label: 'Paroda', pincode: '403712' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'rangado', label: 'Rangado', pincode: '403705' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'zambaulim', label: 'Zambaulim', pincode: '403709' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
  { value: 'chinchinim', label: 'Chinchinim', pincode: '403705' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'maem', label: 'Maem', pincode: '403505' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'assagao', label: 'Assagao', pincode: '403507' }
  ],
  
  'nuvem': [
  { value: 'assolna', label: 'Assolna', pincode: '403720' },
  { value: 'betul', label: 'Betul', pincode: '403722' },
  { value: 'cavelossim', label: 'Cavelossim', pincode: '403731' },
  { value: 'chinchinim', label: 'Chinchinim', pincode: '403705' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403717' },
  { value: 'maem', label: 'Maem', pincode: '403505' },
  { value: 'mollem', label: 'Mollem', pincode: '403410' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'palolem', label: 'Palolem', pincode: '403702' },
  { value: 'paroda', label: 'Paroda', pincode: '403712' },
  { value: 'polem', label: 'Polem', pincode: '403702' },
  { value: 'rangado', label: 'Rangado', pincode: '403705' },
  { value: 'verna', label: 'Verna', pincode: '403722' },
  { value: 'zambaulim', label: 'Zambaulim', pincode: '403709' },
  { value: 'curti', label: 'Curti', pincode: '403401' },
  { value: 'mardol', label: 'Mardol', pincode: '403410' },
  { value: 'betqui', label: 'Betqui', pincode: '403718' },
  { value: 'icchhpur', label: 'Icchhpur', pincode: '403703' },
  { value: 'salcete', label: 'Salcete', pincode: '403510' },
  { value: 'lilapur', label: 'Lilapur', pincode: '403717' },
  { value: 'gandhiwada', label: 'Gandhiwada', pincode: '403601' }
  ],
  
  'panaji': [
  { value: 'altinho', label: 'Altinho', pincode: '403001' },
  { value: 'alorna', label: 'Alorna', pincode: '403503' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'campal', label: 'Campal', pincode: '403001' },
  { value: 'caranzalem', label: 'Caranzalem', pincode: '403002' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
  { value: 'gallinha', label: 'Gallinha', pincode: '403003' },
  { value: 'panjim', label: 'Panjim', pincode: '403001' },
  { value: 'patto', label: 'Patto', pincode: '403001' },
  { value: 'ribandar', label: 'Ribandar', pincode: '403006' },
  { value: 'santemol', label: 'Santemol', pincode: '403003' },
  { value: 'sadar', label: 'Sadar', pincode: '403002' },
  { value: 'vasco', label: 'Vasco', pincode: '403802' },
  { value: 'vaddem', label: 'Vaddem', pincode: '403707' },
  { value: 'porvorim', label: 'Porvorim', pincode: '403521' },
  { value: 'velim', label: 'Velim', pincode: '403723' },
  { value: 'sangolda', label: 'Sangolda', pincode: '403511' },
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'cortalim-plantation', label: 'Cortalim Plantation', pincode: '403410' },
  { value: 'maem', label: 'Maem', pincode: '403503' },
  { value: 'caranzalem-south', label: 'Caranzalem South', pincode: '403002' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' }
  ],
    
  'pilar': [
  { value: 'adcolaim', label: 'Adcolaim', pincode: '403719' },
  { value: 'agapur', label: 'Agapur', pincode: '403708' },
  { value: 'borda', label: 'Borda', pincode: '403602' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
  { value: 'curdi', label: 'Curdi', pincode: '403707' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403706' },
  { value: 'holapur', label: 'Holapur', pincode: '403510' },
  { value: 'maem', label: 'Maem', pincode: '403503' },
  { value: 'pilar', label: 'Pilar', pincode: '403505' },
  { value: 'raia', label: 'Raia', pincode: '403720' },
  { value: 'samtel', label: 'Samtel', pincode: '403703' },
  { value: 'sanglim', label: 'Sanglim', pincode: '403511' },
  { value: 'sanglima', label: 'Sanglima', pincode: '403706' },
  { value: 'varca', label: 'Varca', pincode: '403721' },
  { value: 'chinchinim', label: 'Chinchinim', pincode: '403705' },
  { value: 'betul', label: 'Betul', pincode: '403703' },
  { value: 'cavellossim', label: 'Cavellossim', pincode: '403703' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403703' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'molem', label: 'Molem', pincode: '403507' },
  { value: 'raia', label: 'Raia', pincode: '403721' }
  ],
  
  'ponda': [
  { value: 'adcolaim', label: 'Adcolaim', pincode: '403401' },
  { value: 'alorna', label: 'Alorna', pincode: '403507' },
  { value: 'bambolim', label: 'Bambolim', pincode: '403206' },
  { value: 'banastarim', label: 'Banastarim', pincode: '403004' },
  { value: 'bapujee', label: 'Bapujee', pincode: '403406' },
  { value: 'borda', label: 'Borda', pincode: '403401' },
  { value: 'curti', label: 'Curti', pincode: '403401' },
  { value: 'dhavali', label: 'Dhavali', pincode: '403406' },
  { value: 'donapaula', label: 'Donapaula', pincode: '403004' },
  { value: 'kupavade', label: 'Kupavade', pincode: '403407' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403703' },
  { value: 'marcel', label: 'Marcel', pincode: '403505' },
  { value: 'ponda', label: 'Ponda', pincode: '403401' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403704' },
  { value: 'shiroda', label: 'Shiroda', pincode: '403103' },
  { value: 'verem', label: 'Verem', pincode: '403108' },
  { value: 'zambaulim', label: 'Zambaulim', pincode: '403702' },
  { value: 'mollem', label: 'Mollem', pincode: '403401' },
  { value: 'savoi-verem', label: 'Savoi Verem', pincode: '403406' },
  { value: 'patnem', label: 'Patnem', pincode: '403702' },
  { value: 'chandor', label: 'Chandor', pincode: '403706' },
  { value: 'ambelim', label: 'Ambelim', pincode: '403607' },
  ],
  
  'quepem': [
  { value: 'adcolaim', label: 'Adcolaim', pincode: '403705' },
  { value: 'assolna', label: 'Assolna', pincode: '403703' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'chinchinim', label: 'Chinchinim', pincode: '403703' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403701' },
  { value: 'curti', label: 'Curti', pincode: '403706' },
  { value: 'kansai', label: 'Kansai', pincode: '403706' },
  { value: 'khareband', label: 'Khareband', pincode: '403703' },
  { value: 'lamgau', label: 'Lamagau', pincode: '403705' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403703' },
  { value: 'mollem', label: 'Mollem', pincode: '403401' },
  { value: 'pansulem', label: 'Pansulem', pincode: '403703' },
  { value: 'patnem', label: 'Patnem', pincode: '403702' },
  { value: 'quepem', label: 'Quepem', pincode: '403705' },
  { value: 'shiroda', label: 'Shiroda', pincode: '403103' },
  { value: 'sirisem', label: 'Sirisem', pincode: '403705' },
  { value: 'verem', label: 'Verem', pincode: '403701' },
  { value: 'bhamtuli', label: 'Bhamtuli', pincode: '403701' },
  { value: 'govanewada', label: 'Govanewada', pincode: '403703' },
  { value: 'kunkalem', label: 'Kunkalem', pincode: '403703' },
  { value: 'tilamol', label: 'Tilamol', pincode: '403704' }
  ],
  
  'rassaim': [
  { value: 'assonora', label: 'Assonora', pincode: '403507' },
  { value: 'carambolim', label: 'Carambolim', pincode: '403101' },
  { value: 'dhargal', label: 'Dhargal', pincode: '403509' },
  { value: 'dona-paula', label: 'Dona Paula', pincode: '403004' },
  { value: 'khareband', label: 'Khareband', pincode: '403705' },
  { value: 'maddel', label: 'Maddel', pincode: '403511' },
  { value: 'marna', label: 'Marna', pincode: '403501' },
  { value: 'panchawadi', label: 'Panchawadi', pincode: '403510' },
  { value: 'rassaim', label: 'Rassaim', pincode: '403507' },
  { value: 'shiroda', label: 'Shiroda', pincode: '403103' },
  { value: 'tilamol', label: 'Tilamol', pincode: '403704' },
  { value: 'assolna', label: 'Assolna', pincode: '403703' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
  { value: 'curti', label: 'Curti', pincode: '403708' },
  { value: 'guirim', label: 'Guirim', pincode: '403508' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403718' },
  { value: 'marlem', label: 'Marlem', pincode: '403703' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403704' }
  ],
  
  'sanguem': [
  { value: 'assolna', label: 'Assolna', pincode: '403703' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
  { value: 'curti', label: 'Curti', pincode: '403708' },
  { value: 'dhargal', label: 'Dhargal', pincode: '403509' },
  { value: 'guirim', label: 'Guirim', pincode: '403508' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403718' },
  { value: 'marlem', label: 'Marlem', pincode: '403703' },
  { value: 'maddel', label: 'Maddel', pincode: '403511' },
  { value: 'panchawadi', label: 'Panchawadi', pincode: '403510' },
  { value: 'ponda', label: 'Ponda', pincode: '403401' },
  { value: 'rassaim', label: 'Rassaim', pincode: '403507' },
  { value: 'sanguem', label: 'Sanguem', pincode: '403704' },
  { value: 'shiroda', label: 'Shiroda', pincode: '403103' },
  { value: 'tilamol', label: 'Tilamol', pincode: '403704' },
  { value: 'verem', label: 'Verem', pincode: '403402' }
  ],
  
  'shiroda': [
  { value: 'assolna', label: 'Assolna', pincode: '403703' },
  { value: 'bicholim', label: 'Bicholim', pincode: '403504' },
  { value: 'curti', label: 'Curti', pincode: '403708' },
  { value: 'dhargal', label: 'Dhargal', pincode: '403509' },
  { value: 'guirim', label: 'Guirim', pincode: '403508' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403718' },
  { value: 'marlem', label: 'Marlem', pincode: '403703' },
  { value: 'maddel', label: 'Maddel', pincode: '403511' },
  { value: 'panchawadi', label: 'Panchawadi', pincode: '403510' },
  { value: 'ponda', label: 'Ponda', pincode: '403401' },
  { value: 'rassaim', label: 'Rassaim', pincode: '403507' },
  { value: 'shiroda', label: 'Shiroda', pincode: '403103' },
  { value: 'siroda', label: 'Siroda', pincode: '403703' },
  { value: 'tilamol', label: 'Tilamol', pincode: '403704' },
  { value: 'verem', label: 'Verem', pincode: '403402' },
  { value: 'moira', label: 'Moira', pincode: '403507' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
  { value: 'padi', label: 'Padi', pincode: '403706' },
  { value: 'mollem', label: 'Mollem', pincode: '403404' },
  { value: 'sattari', label: 'Sattari', pincode: '403502' },
  { value: 'salcete', label: 'Salcete', pincode: '403701' }
  ],
  
  'south-goa': [
  { value: 'assolna', label: 'Assolna', pincode: '403703' },
  { value: 'benaulim', label: 'Benaulim', pincode: '403716' },
  { value: 'betul', label: 'Betul', pincode: '403708' },
  { value: 'canacona', label: 'Canacona', pincode: '403702' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
  { value: 'curti', label: 'Curti', pincode: '403708' },
  { value: 'davorlim', label: 'Davorlim', pincode: '403721' },
  { value: 'dhargal', label: 'Dhargal', pincode: '403509' },
  { value: 'loutolim', label: 'Loutolim', pincode: '403718' },
  { value: 'majorda', label: 'Majorda', pincode: '403713' },
  { value: 'mollem', label: 'Mollem', pincode: '403404' },
  { value: 'nuvem', label: 'Nuvem', pincode: '403604' },
  { value: 'pali', label: 'Pali', pincode: '403723' },
  { value: 'panaji', label: 'Panaji', pincode: '403001' },
  { value: 'pilar', label: 'Pilar', pincode: '403718' },
  { value: 'ponda', label: 'Ponda', pincode: '403401' },
  { value: 'quepem', label: 'Quepem', pincode: '403705' },
  { value: 'rassaim', label: 'Rassaim', pincode: '403507' },
  { value: 'sangolda', label: 'Sangolda', pincode: '403511' },
  { value: 'shiroda', label: 'Shiroda', pincode: '403103' },
  { value: 'siroda', label: 'Siroda', pincode: '403703' },
  { value: 'siroda', label: 'Siroda', pincode: '403704' },
  { value: 'velsao', label: 'Velsao', pincode: '403723' },
  { value: 'verem', label: 'Verem', pincode: '403402' }
  ],
  
  'saligao': [
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'calangute', label: 'Calangute', pincode: '403516' },
  { value: 'caranzalem', label: 'Caranzalem', pincode: '403002' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'maem', label: 'Maem', pincode: '403507' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'sintoda', label: 'Sintoda', pincode: '403513' },
  { value: 'tonca', label: 'Tonca', pincode: '403511' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403507' },
  { value: 'bailan', label: 'Bailan', pincode: '403519' }
  ],
  
  'serula': [
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'caranzalem', label: 'Caranzalem', pincode: '403002' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'maem', label: 'Maem', pincode: '403507' },
  { value: 'mandrem', label: 'Mandrem', pincode: '403527' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'serula', label: 'Serula', pincode: '403505' },
  { value: 'tonca', label: 'Tonca', pincode: '403511' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403507' },
  { value: 'vitorna', label: 'Vitorna', pincode: '403514' },
  { value: 'colvale', label: 'Colvale', pincode: '403513' },
  { value: 'camurlim', label: 'Camurlim', pincode: '403517' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' }
  ],
  
  'tivim': [
  { value: 'assagao', label: 'Assagao', pincode: '403507' },
  { value: 'baga', label: 'Baga', pincode: '403516' },
  { value: 'candolim', label: 'Candolim', pincode: '403515' },
  { value: 'caranzalem', label: 'Caranzalem', pincode: '403002' },
  { value: 'guirim', label: 'Guirim', pincode: '403507' },
  { value: 'maem', label: 'Maem', pincode: '403507' },
  { value: 'mandrem', label: 'Mandrem', pincode: '403527' },
  { value: 'saligao', label: 'Saligao', pincode: '403511' },
  { value: 'serula', label: 'Serula', pincode: '403505' },
  { value: 'tonca', label: 'Tonca', pincode: '403511' },
  { value: 'tivim', label: 'Tivim', pincode: '403502' },
  { value: 'vagator', label: 'Vagator', pincode: '403509' },
  { value: 'verem', label: 'Verem', pincode: '403507' },
  { value: 'vitorna', label: 'Vitorna', pincode: '403514' },
  { value: 'colvale', label: 'Colvale', pincode: '403513' },
  { value: 'camurlim', label: 'Camurlim', pincode: '403517' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
  { value: 'margao', label: 'Margao', pincode: '403601' },
  { value: 'pale', label: 'Pale', pincode: '403511' },
  { value: 'batim', label: 'Batim', pincode: '403703' },
  { value: 'assolna', label: 'Assolna', pincode: '403701' },
  { value: 'quitol', label: 'Quitol', pincode: '403705' },
  { value: 'mollem', label: 'Mollem', pincode: '403405' },
  { value: 'xeldem', label: 'Xeldem', pincode: '403701' }
  ],
  
  'vasco-da-gama': [
  { value: 'alcantim', label: 'Alcantim', pincode: '403710' },
  { value: 'cortalim', label: 'Cortalim', pincode: '403710' },
  { value: 'dabolim', label: 'Dabolim', pincode: '403801' },
  { value: 'chicalim', label: 'Chicalim', pincode: '403711' },
  { value: 'new-vasco', label: 'New Vasco', pincode: '403802' },
  { value: 'old-vasco', label: 'Old Vasco', pincode: '403801' },
  { value: 'sancoale', label: 'Sancoale', pincode: '403711' },
  { value: 'zuarinagar', label: 'Zuarinagar', pincode: '403726' },
  { value: 'vaddem', label: 'Vaddem', pincode: '403802' },
  { value: 'vasco-da-gama', label: 'Vasco da Gama', pincode: '403802' },
  { value: 'cortalim-bazar', label: 'Cortalim Bazar', pincode: '403710' },
  { value: 'mormugao', label: 'Mormugao', pincode: '403803' },
  { value: 'assolna', label: 'Assolna', pincode: '403701' },
  { value: 'Baina', label: 'Baina', pincode: '403802' },
  { value: 'carona', label: 'Carona', pincode: '403724' },
  { value: 'chandor', label: 'Chandor', pincode: '403706' },
  { value: 'cutbona', label: 'Cutbona', pincode: '403709' },
  { value: 'margao', label: 'Margao', pincode: '403601' }
  ],

  'neemuch': [
    { value: 'adampura', label: 'Adampura', pincode: '458111' },
    { value: 'alapur', label: 'Alapur', pincode: '458112' },
    { value: 'anandpura', label: 'Anandpura', pincode: '458118' },
    { value: 'badera', label: 'Badera', pincode: '458441' },
    { value: 'bagguda', label: 'Bagguda', pincode: '458220' },
    { value: 'bahrod', label: 'Bahrod', pincode: '458115' },
    { value: 'banswa', label: 'Banswa', pincode: '458228' },
    { value: 'bhairpura', label: 'Bhairpura', pincode: '458118' },
    { value: 'bhamkheda', label: 'Bhamkheda', pincode: '458112' },
    { value: 'bhavanpura', label: 'Bhavanpura', pincode: '458112' },
    { value: 'bhilwara', label: 'Bhilwara', pincode: '458118' },
    { value: 'bhurguda', label: 'Bhurguda', pincode: '458111' },
    { value: 'chhoti', label: 'Chhoti', pincode: '458220' },
    { value: 'chhuri', label: 'Chhuri', pincode: '458228' },
    { value: 'dhamnod', label: 'Dhamnod', pincode: '458111' },
    { value: 'ganeshpura', label: 'Ganeshpura', pincode: '458111' },
    { value: 'giria', label: 'Giria', pincode: '458441' },
    { value: 'gourpura', label: 'Gourpura', pincode: '458229' },
    { value: 'jamunia', label: 'Jamunia', pincode: '458446' },
    { value: 'jaitpura', label: 'Jaitpura', pincode: '458112' },
    { value: 'kalarpura', label: 'Kalarpura', pincode: '458118' },
    { value: 'kanpura', label: 'Kanpura', pincode: '458222' },
    { value: 'karapura', label: 'Karapura', pincode: '458118' },
    { value: 'kishanpura', label: 'Kishanpura', pincode: '458228' },
    { value: 'manpura', label: 'Manpura', pincode: '458229' },
    { value: 'mohannagar', label: 'Mohannagar', pincode: '458221' },
    { value: 'nimbahera', label: 'Nimbahera', pincode: '458446' },
    { value: 'pachore', label: 'Pachore', pincode: '458115' },
    { value: 'patan', label: 'Patan', pincode: '458115' },
    { value: 'rawatpura', label: 'Rawatpura', pincode: '458112' },
    { value: 'sehli', label: 'Sehli', pincode: '458441' },
    { value: 'shivpura', label: 'Shivpura', pincode: '458118' },
    { value: 'tindora', label: 'Tindora', pincode: '458224' },
    { value: 'umar', label: 'Umar', pincode: '458221' },
    { value: 'vijaypura', label: 'Vijaypura', pincode: '458115' },
    { value: 'yaadpura', label: 'Yaadpura', pincode: '458118' }
  ],
  'guna': [
    { value: 'achhota', label: 'Achhota', pincode: '473001' },
    { value: 'ankarpura', label: 'Ankarpura', pincode: '473001' },
    { value: 'antari', label: 'Antari', pincode: '473001' },
    { value: 'balwadi', label: 'Balwadi', pincode: '473002' },
    { value: 'baroda', label: 'Baroda', pincode: '473001' },
    { value: 'bhachau', label: 'Bhachau', pincode: '473221' },
    { value: 'bhood', label: 'Bhood', pincode: '473111' },
    { value: 'bilaspur', label: 'Bilaspur', pincode: '473331' },
    { value: 'bhojpur', label: 'Bhojpur', pincode: '473334' },
    { value: 'chachoura', label: 'Chachoura', pincode: '473001' },
    { value: 'chandpur', label: 'Chandpur', pincode: '473001' },
    { value: 'chhattarpur', label: 'Chhattarpur', pincode: '473225' },
    { value: 'dharamsala', label: 'Dharamsala', pincode: '473222' },
    { value: 'guna-city', label: 'Guna City', pincode: '473001' },
    { value: 'jhagarpura', label: 'Jhagarpura', pincode: '473331' },
    { value: 'khaniyavli', label: 'Khaniyavli', pincode: '473112' },
    { value: 'kothi', label: 'Kothi', pincode: '473001' },
    { value: 'kumher', label: 'Kumher', pincode: '473221' },
    { value: 'kusumkhera', label: 'Kusumkhera', pincode: '473001' },
    { value: 'kushalpura', label: 'Kushalpura', pincode: '473222' },
    { value: 'lahoria', label: 'Lahoria', pincode: '473001' },
    { value: 'laskhara', label: 'Laskhara', pincode: '473222' },
    { value: 'madhogarh', label: 'Madhogarh', pincode: '473331' },
    { value: 'mangaliyas', label: 'Mangaliyas', pincode: '473001' },
    { value: 'manwar', label: 'Manwar', pincode: '473332' },
    { value: 'mehandi', label: 'Mehandi', pincode: '473333' },
    { value: 'pachpedi', label: 'Pachpedi', pincode: '473001' },
    { value: 'patwapur', label: 'Patwapur', pincode: '473112' },
    { value: 'pura', label: 'Pura', pincode: '473001' },
    { value: 'rajgarh', label: 'Rajgarh', pincode: '473222' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '473331' },
    { value: 'saketnagar', label: 'Saket Nagar', pincode: '473001' },
    { value: 'satnara', label: 'Satnara', pincode: '473331' },
    { value: 'sherpura', label: 'Sherpura', pincode: '473222' },
    { value: 'siddhpur', label: 'Siddhpur', pincode: '473001' },
    { value: 'sonakheda', label: 'Sonakheda', pincode: '473331' },
    { value: 'tehri', label: 'Tehri', pincode: '473333' },
    { value: 'tikari', label: 'Tikari', pincode: '473111' },
    { value: 'uncha', label: 'Uncha', pincode: '473333' },
    { value: 'vishwasnagar', label: 'Vishwasnagar', pincode: '473001' }
  ],
  'vidisha': [
    { value: 'anandpur', label: 'Anandpur', pincode: '464001' },
    { value: 'bareth', label: 'Bareth', pincode: '464113' },
    { value: 'baripura', label: 'Baripura', pincode: '464002' },
    { value: 'basoda', label: 'Basoda', pincode: '464221' },
    { value: 'bikampur', label: 'Bikampur', pincode: '464114' },
    { value: 'ganjbasoda', label: 'Ganjbasoda', pincode: '464221' },
    { value: 'gulabganj', label: 'Gulabganj', pincode: '464022' },
    { value: 'kurwai', label: 'Kurwai', pincode: '464224' },
    { value: 'lalitpur-chowk', label: 'Lalitpur Chowk', pincode: '464001' },
    { value: 'madanpur', label: 'Madanpur', pincode: '464115' },
    { value: 'nateran', label: 'Nateran', pincode: '464111' },
    { value: 'pachama', label: 'Pachama', pincode: '464001' },
    { value: 'ramsagar', label: 'Ramsagar', pincode: '464118' },
    { value: 'shamsabad', label: 'Shamsabad', pincode: '464125' },
    { value: 'sironj', label: 'Sironj', pincode: '464228' },
    { value: 'suhaya', label: 'Suhaya', pincode: '464229' },
    { value: 'tilli-road', label: 'Tilli Road', pincode: '464001' },
    { value: 'vidisha', label: 'Vidisha City', pincode: '464001' }
  ],
  'satna': [
    { value: 'adampur', label: 'Adampur', pincode: '485001' },
    { value: 'aligarh', label: 'Aligarh', pincode: '485001' },
    { value: 'amraikala', label: 'Amraikala', pincode: '485001' },
    { value: 'ankapur', label: 'Ankapur', pincode: '485001' },
    { value: 'bajhera', label: 'Bajhera', pincode: '485001' },
    { value: 'bandhogarh', label: 'Bandhogarh', pincode: '485331' },
    { value: 'bansipur', label: 'Bansipur', pincode: '485001' },
    { value: 'belahi', label: 'Belahi', pincode: '485110' },
    { value: 'biratpur', label: 'Biratpur', pincode: '485336' },
    { value: 'chandaniya', label: 'Chandaniya', pincode: '485001' },
    { value: 'chhatarpur', label: 'Chhatarpur', pincode: '485445' },
    { value: 'chhuriya', label: 'Chhuriya', pincode: '485223' },
    { value: 'darripura', label: 'Darripura', pincode: '485001' },
    { value: 'deori', label: 'Deori', pincode: '485331' },
    { value: 'devgan', label: 'Devgan', pincode: '485001' },
    { value: 'dhurwas', label: 'Dhurwas', pincode: '485224' },
    { value: 'gadhwara', label: 'Gadhwara', pincode: '485111' },
    { value: 'garhka', label: 'Garhka', pincode: '485331' },
    { value: 'gharri', label: 'Gharri', pincode: '485226' },
    { value: 'godhari', label: 'Godhari', pincode: '485116' },
    { value: 'goulri', label: 'Goulri', pincode: '485221' },
    { value: 'gudha', label: 'Gudha', pincode: '485226' },
    { value: 'jamli', label: 'Jamli', pincode: '485331' },
    { value: 'jaitwara', label: 'Jaitwara', pincode: '485335' },
    { value: 'jalari', label: 'Jalari', pincode: '485335' },
    { value: 'jhalon', label: 'Jhalon', pincode: '485332' },
    { value: 'jhukni', label: 'Jhukni', pincode: '485226' },
    { value: 'kaharwa', label: 'Kaharwa', pincode: '485335' },
    { value: 'katni', label: 'Katni', pincode: '485001' },
    { value: 'khamaria', label: 'Khamaria', pincode: '485115' },
    { value: 'kharsia', label: 'Kharsia', pincode: '485111' },
    { value: 'khoriya', label: 'Khoriya', pincode: '485335' },
    { value: 'kothar', label: 'Kothar', pincode: '485110' },
    { value: 'kudwa', label: 'Kudwa', pincode: '485222' },
    { value: 'kundara', label: 'Kundara', pincode: '485331' },
    { value: 'kunwarpur', label: 'Kunwarpur', pincode: '485334' },
    { value: 'kusumkhera', label: 'Kusumkhera', pincode: '485001' },
    { value: 'madhavganj', label: 'Madhavganj', pincode: '485334' },
    { value: 'makhdumpur', label: 'Makhdumpur', pincode: '485331' },
    { value: 'malahni', label: 'Malahni', pincode: '485332' },
    { value: 'manjharia', label: 'Manjharia', pincode: '485334' },
    { value: 'marauda', label: 'Marauda', pincode: '485115' },
    { value: 'mau', label: 'Mau', pincode: '485225' },
    { value: 'pachwara', label: 'Pachwara', pincode: '485111' },
    { value: 'patari', label: 'Patari', pincode: '485111' },
    { value: 'rajamau', label: 'Rajamau', pincode: '485225' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '485221' },
    { value: 'rithi', label: 'Rithi', pincode: '485334' },
    { value: 'sahila', label: 'Sahila', pincode: '485115' },
    { value: 'samdariya', label: 'Samdariya', pincode: '485335' },
    { value: 'satna', label: 'Satna', pincode: '485001' },
    { value: 'sirmour', label: 'Sirmour', pincode: '485333' },
    { value: 'somini', label: 'Somini', pincode: '485332' },
    { value: 'tendua', label: 'Tendua', pincode: '485226' },
    { value: 'thumra', label: 'Thumra', pincode: '485331' },
    { value: 'vijaypur', label: 'Vijaypur', pincode: '485225' }
  ],
  'rewa': [
    { value: 'badgaon', label: 'Badgaon', pincode: '486001' },
    { value: 'badauda', label: 'Badauda', pincode: '486115' },
    { value: 'bansia', label: 'Bansia', pincode: '486330' },
    { value: 'baraundha', label: 'Baraundha', pincode: '486226' },
    { value: 'bharwara', label: 'Bharwara', pincode: '486550' },
    { value: 'bichiya', label: 'Bichiya', pincode: '486225' },
    { value: 'chandni', label: 'Chandni', pincode: '486001' },
    { value: 'churhat', label: 'Churhat', pincode: '486775' },
    { value: 'dabra', label: 'Dabra', pincode: '486001' },
    { value: 'deori', label: 'Deori', pincode: '486221' },
    { value: 'dilari', label: 'Dilari', pincode: '486221' },
    { value: 'garh', label: 'Garh', pincode: '486001' },
    { value: 'gonda', label: 'Gonda', pincode: '486001' },
    { value: 'gurh', label: 'Gurh', pincode: '486001' },
    { value: 'japapur', label: 'Japapur', pincode: '486227' },
    { value: 'kailashpur', label: 'Kailashpur', pincode: '486115' },
    { value: 'kishunpur', label: 'Kishunpur', pincode: '486001' },
    { value: 'khaurhi', label: 'Khaurhi', pincode: '486221' },
    { value: 'kotma', label: 'Kotma', pincode: '486446' },
    { value: 'lakhanpur', label: 'Lakhanpur', pincode: '486448' },
    { value: 'mauganj', label: 'Mauganj', pincode: '486331' },
    { value: 'morwa', label: 'Morwa', pincode: '486450' },
    { value: 'nivan', label: 'Nivan', pincode: '486001' },
    { value: 'pachgaon', label: 'Pachgaon', pincode: '486226' },
    { value: 'patna', label: 'Patna', pincode: '486221' },
    { value: 'patar', label: 'Patar', pincode: '486331' },
    { value: 'rajamau', label: 'Rajamau', pincode: '486331' },
    { value: 'rajpur', label: 'Rajpur', pincode: '486331' },
    { value: 'rakha', label: 'Rakha', pincode: '486002' },
    { value: 'rewa-town', label: 'Rewa Town', pincode: '486001' },
    { value: 'sirmour', label: 'Sirmour', pincode: '486551' },
    { value: 'sumerpur', label: 'Sumerpur', pincode: '486226' },
    { value: 'teliya', label: 'Teliya', pincode: '486001' }
  ],
  'sagar': [
    { value: 'aralagodu', label: 'Aralagodu', pincode: '577408' },
    { value: 'bentur', label: 'Bentur', pincode: '577429' },
    { value: 'bhimavaram', label: 'Bhimavaram', pincode: '577401' },
    { value: 'chandragiri', label: 'Chandragiri', pincode: '577422' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '577432' },
    { value: 'chikkamallapura', label: 'Chikkamallapura', pincode: '577410' },
    { value: 'doddakere', label: 'Doddakere', pincode: '577433' },
    { value: 'hakavada', label: 'Hakavada', pincode: '577413' },
    { value: 'harihar', label: 'Harihar', pincode: '577401' },
    { value: 'jagadishpur', label: 'Jagadishpur', pincode: '577427' },
    { value: 'kambada', label: 'Kambada', pincode: '577412' },
    { value: 'kammaradi', label: 'Kammaradi', pincode: '577402' },
    { value: 'kudligi', label: 'Kudligi', pincode: '577402' },
    { value: 'kustagi', label: 'Kustagi', pincode: '577422' },
    { value: 'lakshmipura', label: 'Lakshmipura', pincode: '577440' },
    { value: 'malasavadi', label: 'Malasavadi', pincode: '577441' },
    { value: 'masagalli', label: 'Masagalli', pincode: '577431' },
    { value: 'mirzapur', label: 'Mirzapur', pincode: '577426' },
    { value: 'nandi', label: 'Nandi', pincode: '577424' },
    { value: 'narayanapura', label: 'Narayanapura', pincode: '577421' },
    { value: 'sadikhanpet', label: 'Sadikhanpet', pincode: '577414' },
    { value: 'sagar-town', label: 'Sagar Town', pincode: '577401' },
    { value: 'santhegowda', label: 'Santhegowda', pincode: '577415' },
    { value: 'srinivasapura', label: 'Srinivasapura', pincode: '577428' },
    { value: 'suryanagar', label: 'Suryanagar', pincode: '577405' }
  ],

'burhanpur': [
  { value: 'babashera', label: 'Babashera', pincode: '450331' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '450331' },
  { value: 'baba-nagar', label: 'Baba Nagar', pincode: '450332' },
  { value: 'bhagirath-pura', label: 'Bhagirath Pura', pincode: '450334' },
  { value: 'bhagwanpura', label: 'Bhagwanpura', pincode: '450335' },
  { value: 'chandni-chowk', label: 'Chandni Chowk', pincode: '450336' },
  { value: 'fateh-nagar', label: 'Fateh Nagar', pincode: '450337' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '450338' },
  { value: 'gobindpura', label: 'Gobindpura', pincode: '450339' },
  { value: 'jain-nagar', label: 'Jain Nagar', pincode: '450340' },
  { value: 'kamala-nagar', label: 'Kamala Nagar', pincode: '450341' },
  { value: 'koyla-pura', label: 'Koyla Pura', pincode: '450342' },
  { value: 'madhupura', label: 'Madhupura', pincode: '450343' },
  { value: 'mahalaxmi-nagar', label: 'Mahalaxmi Nagar', pincode: '450344' },
  { value: 'manikbagh', label: 'Manikbagh', pincode: '450345' },
  { value: 'muktidham', label: 'Muktidham', pincode: '450346' },
  { value: 'nanakpura', label: 'Nanakpura', pincode: '450347' },
  { value: 'panchvati', label: 'Panchvati', pincode: '450348' },
  { value: 'patanjali-nagar', label: 'Patanjali Nagar', pincode: '450349' },
  { value: 'rajpura', label: 'Rajpura', pincode: '450350' },
  { value: 'ravi-nagar', label: 'Ravi Nagar', pincode: '450351' },
  { value: 'shiv-nagar', label: 'Shiv Nagar', pincode: '450352' },
  { value: 'singh-pura', label: 'Singh Pura', pincode: '450353' },
  { value: 'sri-nagar', label: 'Sri Nagar', pincode: '450354' },
  { value: 'talav-pura', label: 'Talav Pura', pincode: '450355' },
  { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '450356' },
  { value: 'nazar-pura', label: 'Nazar Pura', pincode: '450357' },
  { value: 'santosh-nagar', label: 'Santosh Nagar', pincode: '450358' },
  { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '450359' },
  { value: 'prabhat-nagar', label: 'Prabhat Nagar', pincode: '450360' },
  { value: 'bhim-nagar', label: 'Bhim Nagar', pincode: '450361' },
  { value: 'jagannath-pura', label: 'Jagannath Pura', pincode: '450362' },
  { value: 'shankar-nagar', label: 'Shankar Nagar', pincode: '450363' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '450364' }
  ],

  'chhindwara':  [
  { value: 'adgaon', label: 'Adgaon', pincode: '480001' },
  { value: 'alapur', label: 'Alapur', pincode: '480002' },
  { value: 'balajipuram', label: 'Balajipuram', pincode: '480003' },
  { value: 'bargi', label: 'Bargi', pincode: '480004' },
  { value: 'berdi', label: 'Berdi', pincode: '480005' },
  { value: 'bhakheda', label: 'Bhakheda', pincode: '480006' },
  { value: 'chandpur', label: 'Chandpur', pincode: '480007' },
  { value: 'chhinkapur', label: 'Chhinkapur', pincode: '480008' },
  { value: 'chhindwara-town', label: 'Chhindwara Town', pincode: '480009' },
  { value: 'gankar', label: 'Gankar', pincode: '480010' },
  { value: 'godhani', label: 'Godhani', pincode: '480011' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '480012' },
  { value: 'khandwa', label: 'Khandwa', pincode: '480013' },
  { value: 'maurawan', label: 'Maurawan', pincode: '480014' },
  { value: 'mohgaon', label: 'Mohgaon', pincode: '480015' },
  { value: 'nariyali', label: 'Nariyali', pincode: '480016' },
  { value: 'parasia', label: 'Parasia', pincode: '480017' },
  { value: 'panchgani', label: 'Panchgani', pincode: '480018' },
  { value: 'patawar', label: 'Patawar', pincode: '480019' },
  { value: 'ramakona', label: 'Ramakona', pincode: '480020' },
  { value: 'sai-dham', label: 'Sai Dham', pincode: '480021' },
  { value: 'shahpur', label: 'Shahpur', pincode: '480022' },
  { value: 'tandula', label: 'Tandula', pincode: '480023' },
  { value: 'tikarli', label: 'Tikrali', pincode: '480024' },
  { value: 'tirora', label: 'Tirora', pincode: '480025' },
  { value: 'umarkheda', label: 'Umarkheda', pincode: '480026' },
  { value: 'bichhua', label: 'Bichhua', pincode: '480027' },
  { value: 'chandpur-chhinkapur', label: 'Chandpur-Chhinkapur', pincode: '480028' },
  { value: 'dongaon', label: 'Dongaon', pincode: '480029' },
  { value: 'gajraula', label: 'Gajraula', pincode: '480030' },
  { value: 'jambharkheda', label: 'Jambharkheda', pincode: '480031' },
  { value: 'khandvi', label: 'Khandvi', pincode: '480032' },
  { value: 'kuteda', label: 'Kuteda', pincode: '480033' },
  { value: 'mauda', label: 'Mauda', pincode: '480034' },
  { value: 'mohgaon-rural', label: 'Mohgaon Rural', pincode: '480035' },
  { value: 'nagpur-kala', label: 'Nagpur Kala', pincode: '480036' },
  { value: 'parwa', label: 'Parwa', pincode: '480037' },
  { value: 'rajwara', label: 'Rajwara', pincode: '480038' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '480039' },
  { value: 'waddha', label: 'Waddha', pincode: '480040' }
  ],

  'dewas': [
  { value: 'agar', label: 'Agar', pincode: '455001' },
  { value: 'bagra', label: 'Bagra', pincode: '455002' },
  { value: 'bhikangaon', label: 'Bhikangaon', pincode: '455003' },
  { value: 'bilawali', label: 'Bilawali', pincode: '455004' },
  { value: 'dewas-town', label: 'Dewas Town', pincode: '455001' },
  { value: 'gaonkheda', label: 'Gaonkheda', pincode: '455005' },
  { value: 'goyla', label: 'Goyla', pincode: '455006' },
  { value: 'guradia', label: 'Guradia', pincode: '455007' },
  { value: 'jaisingh-nagar', label: 'Jaisingh Nagar', pincode: '455008' },
  { value: 'kanchmandi', label: 'Kanchmandi', pincode: '455009' },
  { value: 'khalwa', label: 'Khalwa', pincode: '455010' },
  { value: 'kurawad', label: 'Kurawad', pincode: '455011' },
  { value: 'mahalaxmi-nagar', label: 'Mahalaxmi Nagar', pincode: '455012' },
  { value: 'malhargarh', label: 'Malhargarh', pincode: '455013' },
  { value: 'narwar', label: 'Narwar', pincode: '455014' },
  { value: 'padlya', label: 'Padlya', pincode: '455015' },
  { value: 'piplia', label: 'Piplia', pincode: '455016' },
  { value: 'rangwasa', label: 'Rangwasa', pincode: '455017' },
  { value: 'satwas', label: 'Satwas', pincode: '455018' },
  { value: 'shivpur', label: 'Shivpur', pincode: '455019' },
  { value: 'silvani', label: 'Silvani', pincode: '455020' },
  { value: 'sundrani', label: 'Sundrani', pincode: '455021' },
  { value: 'tehsil', label: 'Tehsil', pincode: '455022' },
  { value: 'tungabad', label: 'Tungabad', pincode: '455023' },
  { value: 'udaynagar', label: 'Udaynagar', pincode: '455024' },
  { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '455025' },
  { value: 'bakhatgarh', label: 'Bakhatgarh', pincode: '455026' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '455027' },
  { value: 'chakia', label: 'Chakia', pincode: '455028' },
  { value: 'dewas-rural', label: 'Dewas Rural', pincode: '455029' },
  { value: 'jaggabadi', label: 'Jaggabadi', pincode: '455030' },
  { value: 'kausal', label: 'Kausal', pincode: '455031' },
  { value: 'lalgaon', label: 'Lalgaon', pincode: '455032' },
  { value: 'malkheda', label: 'Malkheda', pincode: '455033' },
  { value: 'rahatgarh', label: 'Rahatgarh', pincode: '455034' },
  { value: 'sajawa', label: 'Sajawa', pincode: '455035' },
  { value: 'sawantpura', label: 'Sawantpura', pincode: '455036' },
  { value: 'tejpura', label: 'Tejpura', pincode: '455037' },
  { value: 'vishwasnagar', label: 'Vishwasnagar', pincode: '455038' }
],

  'damoh':  [
  { value: 'baksura', label: 'Baksura', pincode: '470661' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '470661' },
  { value: 'baldeogarh', label: 'Baldeogarh', pincode: '470667' },
  { value: 'chandpur', label: 'Chandpur', pincode: '470001' },
  { value: 'damoh-town', label: 'Damoh Town', pincode: '470001' },
  { value: 'giri-damoh', label: 'Giri Damoh', pincode: '470003' },
  { value: 'jabalpur', label: 'Jabalpur', pincode: '470005' },
  { value: 'jaitwara', label: 'Jaitwara', pincode: '470661' },
  { value: 'kachhpura', label: 'Kachhpura', pincode: '470669' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '470661' },
  { value: 'karaiya', label: 'Karaiya', pincode: '470667' },
  { value: 'khirwai', label: 'Khirwai', pincode: '470669' },
  { value: 'kolaras', label: 'Kolaras', pincode: '470667' },
  { value: 'maheswara', label: 'Maheswara', pincode: '470661' },
  { value: 'majhera', label: 'Majhera', pincode: '470661' },
  { value: 'manpur', label: 'Manpur', pincode: '470661' },
  { value: 'mohgaon', label: 'Mohgaon', pincode: '470661' },
  { value: 'parahant', label: 'Parahant', pincode: '470661' },
  { value: 'rampura', label: 'Rampura', pincode: '470661' },
  { value: 'sagoni', label: 'Sagoni', pincode: '470661' },
  { value: 'saraid', label: 'Saraid', pincode: '470661' },
  { value: 'shahpura', label: 'Shahpura', pincode: '470661' },
  { value: 'sivni', label: 'Sivni', pincode: '470661' },
  { value: 'tendukheda', label: 'Tendukheda', pincode: '470669' },
  { value: 'tilli', label: 'Tilli', pincode: '470661' },
  { value: 'uraria', label: 'Uraria', pincode: '470661' },
  { value: 'alapur', label: 'Alapur', pincode: '470661' },
  { value: 'andharra', label: 'Andharra', pincode: '470667' },
  { value: 'bagroda', label: 'Bagroda', pincode: '470661' },
  { value: 'bhidgaon', label: 'Bhidgaon', pincode: '470669' },
  { value: 'charkheda', label: 'Charkheda', pincode: '470669' },
  { value: 'damoh-rural', label: 'Damoh Rural', pincode: '470001' },
  { value: 'ganeshganj', label: 'Ganeshganj', pincode: '470667' },
  { value: 'ghatigaon', label: 'Ghatigaon', pincode: '470661' },
  { value: 'jagoriya', label: 'Jagoriya', pincode: '470669' },
  { value: 'kamta', label: 'Kamta', pincode: '470661' },
  { value: 'kerwa', label: 'Kerwa', pincode: '470667' },
  { value: 'kolhua', label: 'Kolhua', pincode: '470661' },
  { value: 'patan', label: 'Patan', pincode: '470669' },
  { value: 'rai', label: 'Rai', pincode: '470661' },
  { value: 'sijora', label: 'Sijora', pincode: '470661' },
  { value: 'sonkhedi', label: 'Sonkhedi', pincode: '470669' },
  { value: 'tilgaon', label: 'Tilgaon', pincode: '470661' },
  { value: 'udaypur', label: 'Udaypur', pincode: '470661' }
  ],

  'khargone': [
  { value: 'adgaon', label: 'Adgaon', pincode: '451001' },
  { value: 'alapur', label: 'Alapur', pincode: '451002' },
  { value: 'balapur', label: 'Balapur', pincode: '451003' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '451004' },
  { value: 'barkheda', label: 'Barkheda', pincode: '451005' },
  { value: 'batwara', label: 'Batwara', pincode: '451006' },
  { value: 'bhagwanpura', label: 'Bhagwanpura', pincode: '451007' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '451008' },
  { value: 'chhota-khandwa', label: 'Chhota Khandwa', pincode: '451009' },
  { value: 'chowki', label: 'Chowki', pincode: '451010' },
  { value: 'damda', label: 'Damda', pincode: '451011' },
  { value: 'gadiya', label: 'Gadiya', pincode: '451012' },
  { value: 'ghansore', label: 'Ghansore', pincode: '451013' },
  { value: 'gokulpura', label: 'Gokulpura', pincode: '451014' },
  { value: 'jambharkheda', label: 'Jambharkheda', pincode: '451015' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '451016' },
  { value: 'kachan', label: 'Kachan', pincode: '451017' },
  { value: 'khargone-town', label: 'Khargone Town', pincode: '451001' },
  { value: 'khandwa', label: 'Khandwa', pincode: '451018' },
  { value: 'khargone-rural', label: 'Khargone Rural', pincode: '451019' },
  { value: 'kumhari', label: 'Kumhari', pincode: '451020' },
  { value: 'lakhangaon', label: 'Lakhangaon', pincode: '451021' },
  { value: 'loni', label: 'Loni', pincode: '451022' },
  { value: 'malharganj', label: 'Malharganj', pincode: '451023' },
  { value: 'narmada-nagar', label: 'Narmada Nagar', pincode: '451024' },
  { value: 'pachora', label: 'Pachora', pincode: '451025' },
  { value: 'piplia', label: 'Piplia', pincode: '451026' },
  { value: 'rajgarh', label: 'Rajgarh', pincode: '451027' },
  { value: 'sagada', label: 'Sagada', pincode: '451028' },
  { value: 'salona', label: 'Salona', pincode: '451029' },
  { value: 'sindhi', label: 'Sindhi', pincode: '451030' },
  { value: 'talab', label: 'Talab', pincode: '451031' },
  { value: 'tendua', label: 'Tendua', pincode: '451032' },
  { value: 'thimkheda', label: 'Thimkheda', pincode: '451033' },
  { value: 'vishwakarma', label: 'Vishwakarma', pincode: '451034' },
  { value: 'wadar', label: 'Wadar', pincode: '451035' },
  { value: 'yakubpur', label: 'Yakubpur', pincode: '451036' }
  ],

  'morena':  [
  { value: 'alampur', label: 'Alampur', pincode: '476001' },
  { value: 'badagaon', label: 'Badagaon', pincode: '476001' },
  { value: 'balapura', label: 'Balapura', pincode: '476002' },
  { value: 'banegaon', label: 'Banegaon', pincode: '476003' },
  { value: 'bhind', label: 'Bhind', pincode: '476001' },
  { value: 'bhanwar', label: 'Bhanwar', pincode: '476004' },
  { value: 'bhikampur', label: 'Bhikampur', pincode: '476005' },
  { value: 'chhapi', label: 'Chhapi', pincode: '476006' },
  { value: 'chandpur', label: 'Chandpur', pincode: '476007' },
  { value: 'dalpur', label: 'Dalpur', pincode: '476008' },
  { value: 'dharmpura', label: 'Dharmpura', pincode: '476009' },
  { value: 'gajraula', label: 'Gajraula', pincode: '476010' },
  { value: 'gormi', label: 'Gormi', pincode: '476011' },
  { value: 'hanumanpura', label: 'Hanumanpura', pincode: '476012' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '476013' },
  { value: 'jagdishpura', label: 'Jagdishpura', pincode: '476014' },
  { value: 'kherkheda', label: 'Kherkheda', pincode: '476015' },
  { value: 'kolaras', label: 'Kolaras', pincode: '476016' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '476017' },
  { value: 'mahgaon', label: 'Mahgaon', pincode: '476018' },
  { value: 'mau', label: 'Mau', pincode: '476019' },
  { value: 'morena-town', label: 'Morena Town', pincode: '476001' },
  { value: 'nagdaha', label: 'Nagdaha', pincode: '476020' },
  { value: 'panwar', label: 'Panwar', pincode: '476021' },
  { value: 'patara', label: 'Patara', pincode: '476022' },
  { value: 'piplia', label: 'Piplia', pincode: '476023' },
  { value: 'rangoli', label: 'Rangoli', pincode: '476024' },
  { value: 'rithaura', label: 'Rithaura', pincode: '476025' },
  { value: 'sailana', label: 'Sailana', pincode: '476026' },
  { value: 'sagra', label: 'Sagra', pincode: '476027' },
  { value: 'sandpura', label: 'Sandpura', pincode: '476028' },
  { value: 'sarvarya', label: 'Sarvarya', pincode: '476029' },
  { value: 'soni', label: 'Soni', pincode: '476030' },
  { value: 'surajpur', label: 'Surajpur', pincode: '476031' },
  { value: 'tikamgarh', label: 'Tikamgarh', pincode: '476032' },
  { value: 'tundla', label: 'Tundla', pincode: '476033' },
  { value: 'udaipur', label: 'Udaipur', pincode: '476034' },
  { value: 'jagannathpura', label: 'Jagannathpura', pincode: '476035' },
  { value: 'chhapparia', label: 'Chhapparia', pincode: '476036' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '476037' },
  { value: 'kherli', label: 'Kherli', pincode: '476038' },
  { value: 'ghanshyampur', label: 'Ghanshyampur', pincode: '476039' },
  { value: 'bhajwara', label: 'Bhajwara', pincode: '476040' },
  { value: 'kumbhraj', label: 'Kumbhraj', pincode: '476041' },
  { value: 'babra', label: 'Babra', pincode: '476042' },
  { value: 'pali', label: 'Pali', pincode: '476043' }
  ],

  'narmadapuram':  [
  { value: 'agar', label: 'Agar', pincode: '462001' },
  { value: 'bhagwanpura', label: 'Bhagwanpura', pincode: '462002' },
  { value: 'bhilpura', label: 'Bhilpura', pincode: '462003' },
  { value: 'bina', label: 'Bina', pincode: '462004' },
  { value: 'chalgaon', label: 'Chalgaon', pincode: '462005' },
  { value: 'chhapra', label: 'Chhapra', pincode: '462006' },
  { value: 'chhipaner', label: 'Chhipaner', pincode: '462007' },
  { value: 'dabra', label: 'Dabra', pincode: '462008' },
  { value: 'ganj', label: 'Ganj', pincode: '462009' },
  { value: 'gourjhamar', label: 'Gourjhamar', pincode: '462010' },
  { value: 'jaitpura', label: 'Jaitpura', pincode: '462011' },
  { value: 'kachauda', label: 'Kachauda', pincode: '462012' },
  { value: 'kanvra', label: 'Kanvra', pincode: '462013' },
  { value: 'kolar', label: 'Kolar', pincode: '462014' },
  { value: 'malherkheda', label: 'Malherkheda', pincode: '462015' },
  { value: 'mohamadpur', label: 'Mohamadpur', pincode: '462016' },
  { value: 'narmadapuram-town', label: 'Narmadapuram Town', pincode: '462017' },
  { value: 'pachra', label: 'Pachra', pincode: '462018' },
  { value: 'panchgaon', label: 'Panchgaon', pincode: '462019' },
  { value: 'pachmarhi', label: 'Pachmarhi', pincode: '462020' },
  { value: 'rasuli', label: 'Rasuli', pincode: '462021' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '462022' },
  { value: 'tanra', label: 'Tanra', pincode: '462023' },
  { value: 'ugra', label: 'Ugra', pincode: '462024' },
  { value: 'vihirgaon', label: 'Vihirgaon', pincode: '462025' },
  { value: 'wala', label: 'Wala', pincode: '462026' },
  { value: 'bawdi', label: 'Bawdi', pincode: '462027' },
  { value: 'belkheda', label: 'Belkheda', pincode: '462028' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '462029' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '462030' },
  { value: 'chandni', label: 'Chandni', pincode: '462031' },
  { value: 'chaukdi', label: 'Chaukdi', pincode: '462032' },
  { value: 'godpura', label: 'Godpura', pincode: '462033' },
  { value: 'goregaon', label: 'Goregaon', pincode: '462034' },
  { value: 'jholi', label: 'Jholi', pincode: '462035' },
  { value: 'kankarwadi', label: 'Kankarwadi', pincode: '462036' },
  { value: 'mandwa', label: 'Mandwa', pincode: '462037' },
  { value: 'mankheda', label: 'Mankheda', pincode: '462038' },
  { value: 'raipur', label: 'Raipur', pincode: '462039' },
  { value: 'rahmapur', label: 'Rahmapur', pincode: '462040' },
  { value: 'ranipura', label: 'Ranipura', pincode: '462041' },
  { value: 'sagbara', label: 'Sagbara', pincode: '462042' },
  { value: 'sandwaha', label: 'Sandwaha', pincode: '462043' },
  { value: 'sikri', label: 'Sikri', pincode: '462044' },
  { value: 'tukum', label: 'Tukum', pincode: '462045' },
  { value: 'udgaon', label: 'Udgaon', pincode: '462046' }
  ],
  
  'katni': [
  { value: 'adampur', label: 'Adampur', pincode: '483501' },
  { value: 'alampur', label: 'Alampur', pincode: '483502' },
  { value: 'amarpur', label: 'Amarpur', pincode: '483503' },
  { value: 'baihar', label: 'Baihar', pincode: '483504' },
  { value: 'balaghat', label: 'Balaghat', pincode: '483505' },
  { value: 'chandia', label: 'Chandia', pincode: '483506' },
  { value: 'chandpur', label: 'Chandpur', pincode: '483507' },
  { value: 'chiriya', label: 'Chiriya', pincode: '483508' },
  { value: 'gadiya', label: 'Gadiya', pincode: '483509' },
  { value: 'ghansore', label: 'Ghansore', pincode: '483510' },
  { value: 'gorakhpur', label: 'Gorakhpur', pincode: '483511' },
  { value: 'jhira', label: 'Jhira', pincode: '483512' },
  { value: 'katni-town', label: 'Katni Town', pincode: '483513' },
  { value: 'khurai', label: 'Khurai', pincode: '483514' },
  { value: 'kotal', label: 'Kotal', pincode: '483515' },
  { value: 'madhavgarh', label: 'Madhavgarh', pincode: '483516' },
  { value: 'malanjkhand', label: 'Malanjkhand', pincode: '483517' },
  { value: 'manjhi', label: 'Manjhi', pincode: '483518' },
  { value: 'mohpura', label: 'Mohpura', pincode: '483519' },
  { value: 'narsinghpur', label: 'Narsinghpur', pincode: '483520' },
  { value: 'pachgaon', label: 'Pachgaon', pincode: '483521' },
  { value: 'panchal', label: 'Panchal', pincode: '483522' },
  { value: 'raipura', label: 'Raipura', pincode: '483523' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '483524' },
  { value: 'rangwasa', label: 'Rangwasa', pincode: '483525' },
  { value: 'sagar', label: 'Sagar', pincode: '483526' },
  { value: 'sikandarabad', label: 'Sikandarabad', pincode: '483527' },
  { value: 'sudama', label: 'Sudama', pincode: '483528' },
  { value: 'tendua', label: 'Tendua', pincode: '483529' },
  { value: 'jaitwara', label: 'Jaitwara', pincode: '483530' },
  { value: 'jhumri', label: 'Jhumri', pincode: '483531' },
  { value: 'kailwara', label: 'Kailwara', pincode: '483532' },
  { value: 'katangi', label: 'Katangi', pincode: '483533' },
  { value: 'kotma', label: 'Kotma', pincode: '483534' },
  { value: 'mahabharat', label: 'Mahabharat', pincode: '483535' },
  { value: 'manegaon', label: 'Manegaon', pincode: '483536' },
  { value: 'mohgaon', label: 'Mohgaon', pincode: '483537' },
  { value: 'patharia', label: 'Patharia', pincode: '483538' },
  { value: 'pindwara', label: 'Pindwara', pincode: '483539' },
  { value: 'rajendranagar', label: 'Rajendranagar', pincode: '483540' },
  { value: 'rohand', label: 'Rohand', pincode: '483541' },
  { value: 'sarai', label: 'Sarai', pincode: '483542' },
  { value: 'siddhpur', label: 'Siddhpur', pincode: '483543' },
  { value: 'umaria', label: 'Umaria', pincode: '483544' }
  ],

  'pithampur': [
  { value: 'adampur', label: 'Adampur', pincode: '454774' },
  { value: 'balaji', label: 'Balaji', pincode: '454775' },
  { value: 'bypass', label: 'Bypass', pincode: '454776' },
  { value: 'dhamnod', label: 'Dhamnod', pincode: '454777' },
  { value: 'dhanora', label: 'Dhanora', pincode: '454778' },
  { value: 'gajraula', label: 'Gajraula', pincode: '454779' },
  { value: 'gogawa', label: 'Gogawa', pincode: '454780' },
  { value: 'gorakhpur', label: 'Gorakhpur', pincode: '454781' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '454782' },
  { value: 'kanwan', label: 'Kanwan', pincode: '454783' },
  { value: 'khargone', label: 'Khargone', pincode: '454784' },
  { value: 'khedi', label: 'Khedi', pincode: '454785' },
  { value: 'malwa', label: 'Malwa', pincode: '454786' },
  { value: 'mandal', label: 'Mandal', pincode: '454787' },
  { value: 'manpur', label: 'Manpur', pincode: '454788' },
  { value: 'megha', label: 'Megha', pincode: '454789' },
  { value: 'modi', label: 'Modi', pincode: '454790' },
  { value: 'pithampur-industrial-area', label: 'Pithampur Industrial Area', pincode: '454791' },
  { value: 'raigarh', label: 'Raigarh', pincode: '454792' },
  { value: 'rohtak', label: 'Rohtak', pincode: '454793' },
  { value: 'sagda', label: 'Sagda', pincode: '454794' },
  { value: 'shankar', label: 'Shankar', pincode: '454795' },
  { value: 'shirpur', label: 'Shirpur', pincode: '454796' },
  { value: 'thana', label: 'Thana', pincode: '454797' },
  { value: 'hira', label: 'Hira', pincode: '454798' },
  { value: 'kolaras', label: 'Kolaras', pincode: '454799' },
  { value: 'lavkushnagar', label: 'Lavkushnagar', pincode: '454800' },
  { value: 'mhow', label: 'Mhow', pincode: '454801' },
  { value: 'narmada', label: 'Narmada', pincode: '454802' },
  { value: 'pithampur-village', label: 'Pithampur Village', pincode: '454803' },
  { value: 'shivnagar', label: 'Shivnagar', pincode: '454804' },
  { value: 'umrali', label: 'Umrali', pincode: '454805' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '454806' },
  { value: 'wadhona', label: 'Wadhona', pincode: '454807' }
  ],

  'chhatarpur': [
  { value: 'amarpura', label: 'Amarpura', pincode: '471001' },
  { value: 'bajna', label: 'Bajna', pincode: '471002' },
  { value: 'barhi', label: 'Barhi', pincode: '471003' },
  { value: 'birsinghpur', label: 'Birsinghpur', pincode: '471004' },
  { value: 'chhatarpur-town', label: 'Chhatarpur Town', pincode: '471005' },
  { value: 'chandla', label: 'Chandla', pincode: '471006' },
  { value: 'chhatarpur-village', label: 'Chhatarpur Village', pincode: '471007' },
  { value: 'galaun', label: 'Galaun', pincode: '471008' },
  { value: 'jhansia', label: 'Jhansia', pincode: '471009' },
  { value: 'khamaria', label: 'Khamaria', pincode: '471010' },
  { value: 'khajuraho', label: 'Khajuraho', pincode: '471011' },
  { value: 'khamera', label: 'Khamera', pincode: '471012' },
  { value: 'manjhan', label: 'Manjhan', pincode: '471013' },
  { value: 'mauganj', label: 'Mauganj', pincode: '471014' },
  { value: 'nepanagar', label: 'Nepanagar', pincode: '471015' },
  { value: 'pahuj', label: 'Pahuj', pincode: '471016' },
  { value: 'panwar', label: 'Panwar', pincode: '471017' },
  { value: 'patari', label: 'Patari', pincode: '471018' },
  { value: 'raghopur', label: 'Raghopur', pincode: '471019' },
  { value: 'rajnagar', label: 'Rajnagar', pincode: '471020' },
  { value: 'samri', label: 'Samri', pincode: '471021' },
  { value: 'saundha', label: 'Saundha', pincode: '471022' },
  { value: 'sihora', label: 'Sihora', pincode: '471023' },
  { value: 'tori', label: 'Tori', pincode: '471024' },
  { value: 'bargawan', label: 'Bargawan', pincode: '471025' },
  { value: 'gopalpura', label: 'Gopalpura', pincode: '471026' },
  { value: 'jangala', label: 'Jangala', pincode: '471027' },
  { value: 'khajuri', label: 'Khajuri', pincode: '471028' },
  { value: 'khirgaon', label: 'Khirgaon', pincode: '471029' },
  { value: 'kutni', label: 'Kutni', pincode: '471030' },
  { value: 'ladwa', label: 'Ladwa', pincode: '471031' },
  { value: 'mau', label: 'Mau', pincode: '471032' },
  { value: 'pangra', label: 'Pangra', pincode: '471033' },
  { value: 'pipariya', label: 'Pipariya', pincode: '471034' },
  { value: 'rajamau', label: 'Rajamau', pincode: '471035' },
  { value: 'semra', label: 'Semra', pincode: '471036' },
  { value: 'sindwara', label: 'Sindwara', pincode: '471037' }
  ],

  'khandwa': [
  { value: 'ahira-bhatpura', label: 'Ahira Bhatpura', pincode: '450001' },
  { value: 'anwa', label: 'Anwa', pincode: '450002' },
  { value: 'badgaon', label: 'Badgaon', pincode: '450003' },
  { value: 'bamhori', label: 'Bamhori', pincode: '450004' },
  { value: 'banegaon', label: 'Banegaon', pincode: '450005' },
  { value: 'baranjala', label: 'Baranjala', pincode: '450006' },
  { value: 'bargaon', label: 'Bargaon', pincode: '450007' },
  { value: 'borda', label: 'Borda', pincode: '450008' },
  { value: 'chandpur', label: 'Chandpur', pincode: '450009' },
  { value: 'chhatrasa', label: 'Chhatrasa', pincode: '450010' },
  { value: 'devpur', label: 'Devpur', pincode: '450011' },
  { value: 'gokulpur', label: 'Gokulpur', pincode: '450012' },
  { value: 'khandwa-town', label: 'Khandwa Town', pincode: '450013' },
  { value: 'khedi', label: 'Khedi', pincode: '450014' },
  { value: 'mahanpur', label: 'Mahanpur', pincode: '450015' },
  { value: 'manpur', label: 'Manpur', pincode: '450016' },
  { value: 'narayanpura', label: 'Narayanpura', pincode: '450017' },
  { value: 'pachora', label: 'Pachora', pincode: '450018' },
  { value: 'pithampur', label: 'Pithampur', pincode: '450019' },
  { value: 'rahatgaon', label: 'Rahatgaon', pincode: '450020' },
  { value: 'rampura', label: 'Rampura', pincode: '450021' },
  { value: 'sarni', label: 'Sarni', pincode: '450022' },
  { value: 'seoni', label: 'Seoni', pincode: '450023' },
  { value: 'tikari', label: 'Tikari', pincode: '450024' },
  { value: 'umari', label: 'Umari', pincode: '450025' },
  { value: 'wairat', label: 'Wairat', pincode: '450026' },
  { value: 'ajanta', label: 'Ajanta', pincode: '450027' },
  { value: 'banspada', label: 'Banspada', pincode: '450028' },
  { value: 'baranjala', label: 'Baranjala', pincode: '450029' },
  { value: 'dhamnod', label: 'Dhamnod', pincode: '450030' },
  { value: 'indora', label: 'Indora', pincode: '450031' },
  { value: 'karkheda', label: 'Karkheda', pincode: '450032' },
  { value: 'malkapur', label: 'Malkapur', pincode: '450033' },
  { value: 'nandni', label: 'Nandni', pincode: '450034' },
  { value: 'pachora', label: 'Pachora', pincode: '450035' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '450036' },
  { value: 'rajpur', label: 'Rajpur', pincode: '450037' },
  { value: 'sakurdi', label: 'Sakurdi', pincode: '450038' },
  { value: 'shahpur', label: 'Shahpur', pincode: '450039' },
  { value: 'tirla', label: 'Tirla', pincode: '450040' }
  ],

  'mandsaur': [
  { value: 'abhadiya', label: 'Abhadiya', pincode: '458001' },
  { value: 'agar', label: 'Agar', pincode: '458002' },
  { value: 'alampur', label: 'Alampur', pincode: '458003' },
  { value: 'badgaon', label: 'Badgaon', pincode: '458004' },
  { value: 'banegaon', label: 'Banegaon', pincode: '458005' },
  { value: 'bargaon', label: 'Bargaon', pincode: '458006' },
  { value: 'bharwada', label: 'Bharwada', pincode: '458007' },
  { value: 'borkheda', label: 'Borkheda', pincode: '458008' },
  { value: 'chhoti-sindri', label: 'Chhoti Sindri', pincode: '458009' },
  { value: 'chhatrasa', label: 'Chhatrasa', pincode: '458010' },
  { value: 'dallana', label: 'Dallana', pincode: '458011' },
  { value: 'dhamnod', label: 'Dhamnod', pincode: '458012' },
  { value: 'jhiri', label: 'Jhiri', pincode: '458013' },
  { value: 'kankadkheda', label: 'Kankadkheda', pincode: '458014' },
  { value: 'kheda', label: 'Kheda', pincode: '458015' },
  { value: 'kothariya', label: 'Kothariya', pincode: '458016' },
  { value: 'mandsaur-town', label: 'Mandsaur Town', pincode: '458017' },
  { value: 'manpur', label: 'Manpur', pincode: '458018' },
  { value: 'narayanpura', label: 'Narayanpura', pincode: '458019' },
  { value: 'pachora', label: 'Pachora', pincode: '458020' },
  { value: 'rampura', label: 'Rampura', pincode: '458021' },
  { value: 'sanawad', label: 'Sanawad', pincode: '458022' },
  { value: 'sejawata', label: 'Sejawata', pincode: '458023' },
  { value: 'sindri', label: 'Sindri', pincode: '458024' },
  { value: 'sujalpur', label: 'Sujalpur', pincode: '458025' },
  { value: 'tukda', label: 'Tukda', pincode: '458026' },
  { value: 'umari', label: 'Umari', pincode: '458027' },
  { value: 'village-shahpura', label: 'Village Shahpura', pincode: '458028' },
  { value: 'banswa', label: 'Banswa', pincode: '458029' },
  { value: 'charwaha', label: 'Charwaha', pincode: '458030' },
  { value: 'dhulawad', label: 'Dhulawad', pincode: '458031' },
  { value: 'goladiya', label: 'Goladiya', pincode: '458032' },
  { value: 'keshampura', label: 'Keshampura', pincode: '458033' },
  { value: 'koyla', label: 'Koyla', pincode: '458034' },
  { value: 'kutra', label: 'Kutra', pincode: '458035' },
  { value: 'pachoriya', label: 'Pachoriya', pincode: '458036' },
  { value: 'pichhadiya', label: 'Pichhadiya', pincode: '458037' },
  { value: 'raun', label: 'Raun', pincode: '458038' },
  { value: 'rishabhdeo', label: 'Rishabhdeo', pincode: '458039' },
  { value: 'thada', label: 'Thada', pincode: '458040' }
  ],

  'sehore': [
  { value: 'abdala', label: 'Abdala', pincode: '466661' },
  { value: 'ashta', label: 'Ashta', pincode: '466116' },
  { value: 'badnagar', label: 'Badnagar', pincode: '466001' },
  { value: 'barodia', label: 'Barodia', pincode: '466001' },
  { value: 'bhairunda', label: 'Bhairunda', pincode: '466111' },
  { value: 'bilkisganj', label: 'Bilkisganj', pincode: '466114' },
  { value: 'chandbarh', label: 'Chandbarh', pincode: '466120' },
  { value: 'ichhawar', label: 'Ichhawar', pincode: '466115' },
  { value: 'jawar', label: 'Jawar', pincode: '466112' },
  { value: 'juni indore', label: 'Juni Indore', pincode: '466001' },
  { value: 'kannod', label: 'Kannod', pincode: '466121' },
  { value: 'kothri', label: 'Kothri', pincode: '466113' },
  { value: 'kurawar', label: 'Kurawar', pincode: '466118' },
  { value: 'laharshri', label: 'Laharshri', pincode: '466111' },
  { value: 'nasrullaganj', label: 'Nasrullaganj', pincode: '466117' },
  { value: 'nawali', label: 'Nawali', pincode: '466001' },
  { value: 'raisen road', label: 'Raisen Road', pincode: '466001' },
  { value: 'rehti', label: 'Rehti', pincode: '466446' },
  { value: 'sehore', label: 'Sehore', pincode: '466001' },
  { value: 'shyampur', label: 'Shyampur', pincode: '466118' },
  { value: 'sonkachh', label: 'Sonkachh', pincode: '466122' },
  { value: 'tanda', label: 'Tanda', pincode: '466223' }
  ],

  'shivpuri': [
  { value: 'amola', label: 'Amola', pincode: '473670' },
  { value: 'anikpur', label: 'Anikpur', pincode: '473774' },
  { value: 'badarwas', label: 'Badarwas', pincode: '473885' },
  { value: 'bairad', label: 'Bairad', pincode: '473793' },
  { value: 'chakranagar', label: 'Chakranagar', pincode: '473770' },
  { value: 'chharch', label: 'Chharch', pincode: '473781' },
  { value: 'gaonri', label: 'Gaonri', pincode: '473665' },
  { value: 'gudawali', label: 'Gudawali', pincode: '473662' },
  { value: 'jatara', label: 'Jatara', pincode: '473774' },
  { value: 'karera', label: 'Karera', pincode: '473660' },
  { value: 'khaniyadhana', label: 'Khaniyadhana', pincode: '473990' },
  { value: 'kolaras', label: 'Kolaras', pincode: '473770' },
  { value: 'mahoba', label: 'Mahoba', pincode: '473774' },
  { value: 'mohini sagar', label: 'Mohini Sagar', pincode: '473551' },
  { value: 'narwar', label: 'Narwar', pincode: '473665' },
  { value: 'pichhore', label: 'Pichhore', pincode: '473995' },
  { value: 'pohrar', label: 'Pohrar', pincode: '473775' },
  { value: 'purani shivpuri', label: 'Purani Shivpuri', pincode: '473551' },
  { value: 'satpura', label: 'Satpura', pincode: '473660' },
  { value: 'shivpuri', label: 'Shivpuri', pincode: '473551' },
  { value: 'sironj', label: 'Sironj', pincode: '473662' },
  { value: 'sukhpura', label: 'Sukhpura', pincode: '473660' },
  { value: 'tara-pur', label: 'Tara Pur', pincode: '473665' },
  { value: 'thandipani', label: 'Thandipani', pincode: '473775' },
  { value: 'tilawali', label: 'Tilawali', pincode: '473661' },
  { value: 'tindwara', label: 'Tindwara', pincode: '473881' }
  ],

  'singrauli': [
  { value: 'amlohri', label: 'Amlohri', pincode: '486887' },
  { value: 'anjaniya', label: 'Anjaniya', pincode: '486892' },
  { value: 'bara', label: 'Bara', pincode: '486886' },
  { value: 'bargawan', label: 'Bargawan', pincode: '486886' },
  { value: 'bijuri', label: 'Bijuri', pincode: '486661' },
  { value: 'chakradharnagar', label: 'Chakradharnagar', pincode: '486886' },
  { value: 'chhatta', label: 'Chhatta', pincode: '486889' },
  { value: 'chitrangi', label: 'Chitrangi', pincode: '486882' },
  { value: 'daga', label: 'Daga', pincode: '486889' },
  { value: 'debadand', label: 'Debadand', pincode: '486884' },
  { value: 'devsar', label: 'Devsar', pincode: '486881' },
  { value: 'jorpa', label: 'Jorpa', pincode: '486892' },
  { value: 'kauriya', label: 'Kauriya', pincode: '486886' },
  { value: 'khadia', label: 'Khadia', pincode: '486888' },
  { value: 'khalari', label: 'Khalari', pincode: '486885' },
  { value: 'kohka', label: 'Kohka', pincode: '486887' },
  { value: 'koylanchal', label: 'Koylanchal', pincode: '486889' },
  { value: 'kundwa', label: 'Kundwa', pincode: '486887' },
  { value: 'madhauli', label: 'Madhauli', pincode: '486886' },
  { value: 'maihar', label: 'Maihar', pincode: '486771' },
  { value: 'madhwa', label: 'Madhwa', pincode: '486888' },
  { value: 'naudiha', label: 'Naudiha', pincode: '486886' },
  { value: 'nepanagar', label: 'Nepanagar', pincode: '486888' },
  { value: 'nighai', label: 'Nighai', pincode: '486890' },
  { value: 'parsa', label: 'Parsa', pincode: '486889' },
  { value: 'rajmilan', label: 'Rajmilan', pincode: '486881' },
  { value: 'renukoot', label: 'Renukoot', pincode: '486880' },
  { value: 'sarai', label: 'Sarai', pincode: '486884' },
  { value: 'shaktinagar', label: 'Shaktinagar', pincode: '486889' },
  { value: 'sidhi', label: 'Sidhi', pincode: '486661' },
  { value: 'singrauli', label: 'Singrauli', pincode: '486889' },
  { value: 'vindhyanagar', label: 'Vindhyanagar', pincode: '486885' },
  { value: 'waidhan', label: 'Waidhan', pincode: '486886' }
  ],

  'nagda': [
  { value: 'ambedkar nagar', label: 'Ambedkar Nagar', pincode: '456335' },
  { value: 'birlagram', label: 'Birlagram', pincode: '456331' },
  { value: 'chhoti khatua', label: 'Chhoti Khatua', pincode: '456335' },
  { value: 'dattapura', label: 'Dattapura', pincode: '456337' },
  { value: 'dewas road', label: 'Dewas Road', pincode: '456331' },
  { value: 'gadi adda', label: 'Gadi Adda', pincode: '456331' },
  { value: 'ganesh colony', label: 'Ganesh Colony', pincode: '456331' },
  { value: 'industrial area', label: 'Industrial Area', pincode: '456331' },
  { value: 'jaysinghpura', label: 'Jaysinghpura', pincode: '456336' },
  { value: 'kachnara', label: 'Kachnara', pincode: '456335' },
  { value: 'kamadpur', label: 'Kamadpur', pincode: '456336' },
  { value: 'lalgaon', label: 'Lalgaon', pincode: '456332' },
  { value: 'mahidpur road', label: 'Mahidpur Road', pincode: '456331' },
  { value: 'manasa', label: 'Manasa', pincode: '456333' },
  { value: 'mohammadkheri', label: 'Mohammadkheri', pincode: '456334' },
  { value: 'nagda junction', label: 'Nagda Junction', pincode: '456335' },
  { value: 'nayan', label: 'Nayan', pincode: '456336' },
  { value: 'pipalya kalan', label: 'Pipalya Kalan', pincode: '456334' },
  { value: 'railway colony', label: 'Railway Colony', pincode: '456331' },
  { value: 'ratlam road', label: 'Ratlam Road', pincode: '456331' },
  { value: 'sanjay nagar', label: 'Sanjay Nagar', pincode: '456337' },
  { value: 'shankarpura', label: 'Shankarpura', pincode: '456336' },
  { value: 'shivaji nagar', label: 'Shivaji Nagar', pincode: '456331' },
  { value: 'vikram nagar', label: 'Vikram Nagar', pincode: '456331' },
  { value: 'villipur', label: 'Villipur', pincode: '456334' },
  { value: 'ward no. 10', label: 'Ward No. 10', pincode: '456331' },
  { value: 'ward no. 15', label: 'Ward No. 15', pincode: '456331' }
  ],

  'itarsi': [
  { value: 'ankit vihar', label: 'Ankit Vihar', pincode: '461111' },
  { value: 'ashok colony', label: 'Ashok Colony', pincode: '461111' },
  { value: 'badapahad', label: 'Badapahad', pincode: '461115' },
  { value: 'bandrabhan', label: 'Bandrabhan', pincode: '461110' },
  { value: 'bharat nagar', label: 'Bharat Nagar', pincode: '461111' },
  { value: 'bhatkhedi', label: 'Bhatkhedi', pincode: '461114' },
  { value: 'chandni chowk', label: 'Chandni Chowk', pincode: '461111' },
  { value: 'college road', label: 'College Road', pincode: '461111' },
  { value: 'gandhi nagar', label: 'Gandhi Nagar', pincode: '461111' },
  { value: 'gandhigram', label: 'Gandhigram', pincode: '461115' },
  { value: 'gulari ghati', label: 'Gulari Ghati', pincode: '461116' },
  { value: 'housing board colony', label: 'Housing Board Colony', pincode: '461111' },
  { value: 'indira colony', label: 'Indira Colony', pincode: '461111' },
  { value: 'itarsi junction', label: 'Itarsi Junction', pincode: '461111' },
  { value: 'jagdish nagar', label: 'Jagdish Nagar', pincode: '461114' },
  { value: 'jawahar bazar', label: 'Jawahar Bazar', pincode: '461111' },
  { value: 'kalapatha', label: 'Kalapatha', pincode: '461110' },
  { value: 'kolar dam', label: 'Kolar Dam', pincode: '461115' },
  { value: 'kothibazar', label: 'Kothibazar', pincode: '461111' },
  { value: 'mahendra colony', label: 'Mahendra Colony', pincode: '461116' },
  { value: 'malakhedi', label: 'Malakhedi', pincode: '461114' },
  { value: 'model town', label: 'Model Town', pincode: '461111' },
  { value: 'nehru colony', label: 'Nehru Colony', pincode: '461111' },
  { value: 'new yard colony', label: 'New Yard Colony', pincode: '461115' },
  { value: 'old itarsi', label: 'Old Itarsi', pincode: '461114' },
  { value: 'patel nagar', label: 'Patel Nagar', pincode: '461111' },
  { value: 'railway colony', label: 'Railway Colony', pincode: '461111' },
  { value: 'ranjana nagar', label: 'Ranjana Nagar', pincode: '461115' },
  { value: 'sadar bazar', label: 'Sadar Bazar', pincode: '461111' },
  { value: 'shivpuri colony', label: 'Shivpuri Colony', pincode: '461114' },
  { value: 'subhash nagar', label: 'Subhash Nagar', pincode: '461110' },
  { value: 'sunil nagar', label: 'Sunil Nagar', pincode: '461116' },
  { value: 'vijay nagar', label: 'Vijay Nagar', pincode: '461116' },
  { value: 'ward no. 6', label: 'Ward No. 6', pincode: '461111' },
  { value: 'ward no. 11', label: 'Ward No. 11', pincode: '461111' }
  ],

  'shahdol': [
  { value: 'amarkantak', label: 'Amarkantak', pincode: '484886' },
  { value: 'baihar', label: 'Baihar', pincode: '484440' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '484001' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kotra', label: 'Kotra', pincode: '484660' },
  { value: 'maurawan', label: 'Maurawan', pincode: '484221' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '484110' },
  { value: 'shahdol-city', label: 'Shahdol City', pincode: '484001' },
  { value: 'shahnagar', label: 'Shahnagar', pincode: '484229' },
  { value: 'shivnagar', label: 'Shiv Nagar', pincode: '484004' },
  { value: 'sondwa', label: 'Sondwa', pincode: '484242' },
  { value: 'tori', label: 'Tori', pincode: '484220' },
  { value: 'umariya', label: 'Umariya', pincode: '484330' }
  ],

  'seoni': [
  { value: 'bamhani', label: 'Bamhani', pincode: '480661' },
  { value: 'balaghat', label: 'Balaghat', pincode: '481001' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jaisinghpur', label: 'Jaisinghpur', pincode: '480661' },
  { value: 'katangi', label: 'Katangi', pincode: '480001' },
  { value: 'maharajpur', label: 'Maharajpur', pincode: '480661' },
  { value: 'seoni-city', label: 'Seoni City', pincode: '480661' },
  { value: 'shivpur', label: 'Shivpur', pincode: '480661' },
  { value: 'tendukheda', label: 'Tendukheda', pincode: '480669' },
  { value: 'waraseoni', label: 'Waraseoni', pincode: '480551' },
  { value: 'chhapparia', label: 'Chhapparia', pincode: '480881' },
  { value: 'chandpur', label: 'Chandpur', pincode: '480774' },
  { value: 'deori', label: 'Deori', pincode: '480551' },
  { value: 'khamaria', label: 'Khamaria', pincode: '480672' },
  { value: 'khapa', label: 'Khapa', pincode: '480881' },
  { value: 'mohgaon', label: 'Mohgaon', pincode: '480881' },
  { value: 'pachgaon', label: 'Pachgaon', pincode: '480661' },
  { value: 'sikarpur', label: 'Sikarpur', pincode: '480669' },
  { value: 'sirali', label: 'Sirali', pincode: '480661' }
  ],

  'barwaha': [
  { value: 'barwaha-city', label: 'Barwaha City', pincode: '451115' },
  { value: 'bhadi', label: 'Bhadi', pincode: '451117' },
  { value: 'bhamori', label: 'Bhamori', pincode: '451111' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '451111' },
  { value: 'chinchli', label: 'Chinchli', pincode: '451118' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '451112' },
  { value: 'kakda', label: 'Kakda', pincode: '451116' },
  { value: 'kareli', label: 'Kareli', pincode: '451119' },
  { value: 'khandwa', label: 'Khandwa', pincode: '451001' },
  { value: 'kundi', label: 'Kundi', pincode: '451126' },
  { value: 'madhopur', label: 'Madhopur', pincode: '451110' },
  { value: 'mohadi', label: 'Mohadi', pincode: '451114' },
  { value: 'piplai', label: 'Piplai', pincode: '451113' },
  { value: 'raipura', label: 'Raipura', pincode: '451120' },
  { value: 'sankheda', label: 'Sankheda', pincode: '451121' },
  { value: 'sardar-kheda', label: 'Sardar Kheda', pincode: '451125' },
  { value: 'semli', label: 'Semli', pincode: '451122' },
  { value: 'sukhi', label: 'Sukhi', pincode: '451123' },
  { value: 'takwani', label: 'Takwani', pincode: '451124' }
  ],

  'betul': [
  { value: 'adgaon', label: 'Adgaon', pincode: '460001' },
  { value: 'alapur', label: 'Alapur', pincode: '460014' },
  { value: 'ankapur', label: 'Ankapur', pincode: '460009' },
  { value: 'betul-city', label: 'Betul City', pincode: '460001' },
  { value: 'bhatpur', label: 'Bhatpur', pincode: '460003' },
  { value: 'bihari', label: 'Bihari', pincode: '460016' },
  { value: 'chicholi', label: 'Chicholi', pincode: '460227' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jada', label: 'Jada', pincode: '460112' },
  { value: 'jankpur', label: 'Jankpur', pincode: '460115' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '460110' },
  { value: 'kala-amb', label: 'Kala Amb', pincode: '460008' },
  { value: 'kamthi', label: 'Kamthi', pincode: '460017' },
  { value: 'kesla', label: 'Kesla', pincode: '460221' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '460121' },
  { value: 'malkapur', label: 'Malkapur', pincode: '460111' },
  { value: 'manpur', label: 'Manpur', pincode: '460017' },
  { value: 'pachora', label: 'Pachora', pincode: '460119' },
  { value: 'piplani', label: 'Piplani', pincode: '460015' },
  { value: 'rani-pur', label: 'Rani Pur', pincode: '460109' },
  { value: 'seonikhurd', label: 'Seoni Khurd', pincode: '460030' },
  { value: 'shahpur', label: 'Shahpur', pincode: '460003' },
  { value: 'sindhi', label: 'Sindhi', pincode: '460118' },
  { value: 'tendukheda', label: 'Tendukheda', pincode: '460224' },
  { value: 'vishnu-kheda', label: 'Vishnu Kheda', pincode: '460008' },
  { value: 'zari', label: 'Zari', pincode: '460010' },
  { value: 'chakroda', label: 'Chakroda', pincode: '460223' },
  { value: 'jhiri', label: 'Jhiri', pincode: '460027' },
  { value: 'kandri', label: 'Kandri', pincode: '460013' },
  { value: 'pachpauli', label: 'Pachpauli', pincode: '460222' },
  { value: 'rajendra-nagar', label: 'Rajendra Nagar', pincode: '460014' }
  ],
  
  'bhind': [
  { value: 'alampur', label: 'Alampur', pincode: '477001' },
  { value: 'bhind-city', label: 'Bhind City', pincode: '477001' },
  { value: 'birauli', label: 'Birauli', pincode: '477110' },
  { value: 'dabra', label: 'Dabra', pincode: '477002' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '477222' },
  { value: 'kanchana', label: 'Kanchana', pincode: '477102' },
  { value: 'karera', label: 'Karera', pincode: '477106' },
  { value: 'khander', label: 'Khander', pincode: '477104' },
  { value: 'manpur', label: 'Manpur', pincode: '477201' },
  { value: 'murwai', label: 'Murwai', pincode: '477120' },
  { value: 'pachgaon', label: 'Pachgaon', pincode: '477121' },
  { value: 'pipalya', label: 'Pipalya', pincode: '477103' },
  { value: 'raigad', label: 'Raigad', pincode: '477100' },
  { value: 'sewar', label: 'Sewar', pincode: '477105' },
  { value: 'siwan', label: 'Siwan', pincode: '477107' },
  { value: 'chakrampur', label: 'Chakrampur', pincode: '477125' },
  { value: 'jamuniya', label: 'Jamuniya', pincode: '477111' },
  { value: 'kailaras', label: 'Kailaras', pincode: '477109' },
  { value: 'khajuri', label: 'Khajuri', pincode: '477108' },
  { value: 'manikpur', label: 'Manikpur', pincode: '477122' },
  { value: 'naugawan', label: 'Naugawan', pincode: '477124' },
  { value: 'padri', label: 'Padri', pincode: '477123' },
  { value: 'raja-ka-pur', label: 'Raja Ka Pur', pincode: '477126' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '477001' },
  { value: 'samla', label: 'Samla', pincode: '477127' },
  { value: 'sikri', label: 'Sikri', pincode: '477128' },
  { value: 'sonpur', label: 'Sonpur', pincode: '477129' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '477130' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '477131' },
  { value: 'panwadi', label: 'Panwadi', pincode: '477132' },
  { value: 'chandpur', label: 'Chandpur', pincode: '477133' },
  { value: 'harda', label: 'Harda', pincode: '477134' },
  { value: 'bari', label: 'Bari', pincode: '477135' },
  { value: 'bajna', label: 'Bajna', pincode: '477136' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '477137' },
  { value: 'ranpur', label: 'Ranpur', pincode: '477138' }
  ],

  'dhar': [
  { value: 'alapur', label: 'Alapur', pincode: '454001' },
  { value: 'badnawar', label: 'Badnawar', pincode: '454200' },
  { value: 'bajna', label: 'Bajna', pincode: '454116' },
  { value: 'chhota-udaypur', label: 'Chhota Udaypur', pincode: '454222' },
  { value: 'dhar-city', label: 'Dhar City', pincode: '454001' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jholi', label: 'Jholi', pincode: '454106' },
  { value: 'kherwara', label: 'Kherwara', pincode: '454222' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '454332' },
  { value: 'manawar', label: 'Manawar', pincode: '454221' },
  { value: 'mohadi', label: 'Mohadi', pincode: '454110' },
  { value: 'nalchha', label: 'Nalchha', pincode: '454223' },
  { value: 'rathore', label: 'Rathore', pincode: '454228' },
  { value: 'sanjay-gram', label: 'Sanjay Gram', pincode: '454205' },
  { value: 'sejgaon', label: 'Sejgaon', pincode: '454204' },
  { value: 'sihora', label: 'Sihora', pincode: '454333' },
  { value: 'sundrel', label: 'Sundrel', pincode: '454332' },
  { value: 'bansal', label: 'Bansal', pincode: '454001' },
  { value: 'belkheda', label: 'Belkheda', pincode: '454330' },
  { value: 'dharampuri', label: 'Dharampuri', pincode: '454301' },
  { value: 'khaknar', label: 'Khaknar', pincode: '454212' },
  { value: 'mangroli', label: 'Mangroli', pincode: '454223' },
  { value: 'pithampur', label: 'Pithampur', pincode: '454774' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '454314' },
  { value: 'taroha', label: 'Taroha', pincode: '454209' },
  { value: 'ajwa', label: 'Ajwa', pincode: '454221' },
  { value: 'chandpur', label: 'Chandpur', pincode: '454117' },
  { value: 'borkheda', label: 'Borkheda', pincode: '454124' },
  { value: 'dondia', label: 'Dondia', pincode: '454118' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '454229' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '454115' },
  { value: 'kalyanpura', label: 'Kalyanpura', pincode: '454230' },
  { value: 'laxmipura', label: 'Laxmipura', pincode: '454231' },
  { value: 'manikheda', label: 'Manikheda', pincode: '454232' }
  ],

  'anjad': [
  { value: 'anjad-city', label: 'Anjad City', pincode: '454221' },
  { value: 'badgaon', label: 'Badgaon', pincode: '454555' },
  { value: 'bawdi', label: 'Bawdi', pincode: '454222' },
  { value: 'chandpur', label: 'Chandpur', pincode: '454222' },
  { value: 'dhamnod', label: 'Dhamnod', pincode: '454552' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jamner', label: 'Jamner', pincode: '454230' },
  { value: 'jholi', label: 'Jholi', pincode: '454233' },
  { value: 'kankroli', label: 'Kankroli', pincode: '454226' },
  { value: 'kheda', label: 'Kheda', pincode: '454229' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '454234' },
  { value: 'manpur', label: 'Manpur', pincode: '454225' },
  { value: 'mohadi', label: 'Mohadi', pincode: '454215' },
  { value: 'naupur', label: 'Naupur', pincode: '454222' },
  { value: 'pachora', label: 'Pachora', pincode: '454221' },
  { value: 'patel-nagar', label: 'Patel Nagar', pincode: '454221' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '454553' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '454555' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '454551' },
  { value: 'ambadi', label: 'Ambadi', pincode: '454232' },
  { value: 'balwada', label: 'Balwada', pincode: '454220' },
  { value: 'bhamkheda', label: 'Bhamkheda', pincode: '454238' },
  { value: 'bhimpura', label: 'Bhimpura', pincode: '454239' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '454240' },
  { value: 'chikhli', label: 'Chikhli', pincode: '454241' },
  { value: 'garoth', label: 'Garoth', pincode: '454242' },
  { value: 'jambhadi', label: 'Jambhadi', pincode: '454243' },
  { value: 'kamnada', label: 'Kamnada', pincode: '454244' },
  { value: 'khilchipur', label: 'Khilchipur', pincode: '454245' },
  { value: 'piplia', label: 'Piplia', pincode: '454246' },
  { value: 'sundli', label: 'Sundli', pincode: '454247' }
  ],

  'shajapur': [
  { value: 'alampur', label: 'Alampur', pincode: '465001' },
  { value: 'badagaon', label: 'Badagaon', pincode: '465450' },
  { value: 'bajna', label: 'Bajna', pincode: '465223' },
  { value: 'bargi', label: 'Bargi', pincode: '465441' },
  { value: 'chandpur', label: 'Chandpur', pincode: '465444' },
  { value: 'dahod', label: 'Dahod', pincode: '465447' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jaggatpura', label: 'Jaggatpura', pincode: '465118' },
  { value: 'jholi', label: 'Jholi', pincode: '465122' },
  { value: 'khudkheda', label: 'Khudkheda', pincode: '465451' },
  { value: 'manpur', label: 'Manpur', pincode: '465441' },
  { value: 'mohadi', label: 'Mohadi', pincode: '465442' },
  { value: 'nalchha', label: 'Nalchha', pincode: '465450' },
  { value: 'pachora', label: 'Pachora', pincode: '465440' },
  { value: 'patel-nagar', label: 'Patel Nagar', pincode: '465220' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '465450' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '465455' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '465452' },
  { value: 'ajwa', label: 'Ajwa', pincode: '465224' },
  { value: 'badnawar', label: 'Badnawar', pincode: '465106' },
  { value: 'dharampuri', label: 'Dharampuri', pincode: '465123' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '465210' },
  { value: 'kheda', label: 'Kheda', pincode: '465211' },
  { value: 'khilchipur', label: 'Khilchipur', pincode: '465212' },
  { value: 'kothri', label: 'Kothri', pincode: '465207' },
  { value: 'mahdal', label: 'Mahdal', pincode: '465209' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '465205' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '465216' },
  { value: 'sundli', label: 'Sundli', pincode: '465217' }
  ],

  'dindori': [
  { value: 'alapur', label: 'Alapur', pincode: '481880' },
  { value: 'badwara', label: 'Badwara', pincode: '481881' },
  { value: 'banegaon', label: 'Banegaon', pincode: '481886' },
  { value: 'baranjala', label: 'Baranjala', pincode: '481895' },
  { value: 'dhamanwara', label: 'Dhamanwara', pincode: '481884' },
  { value: 'dindori-city', label: 'Dindori City', pincode: '481880' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jholi', label: 'Jholi', pincode: '481882' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '481885' },
  { value: 'kheda', label: 'Kheda', pincode: '481896' },
  { value: 'manpur', label: 'Manpur', pincode: '481883' },
  { value: 'mohadi', label: 'Mohadi', pincode: '481887' },
  { value: 'nalchha', label: 'Nalchha', pincode: '481888' },
  { value: 'pachora', label: 'Pachora', pincode: '481889' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '481890' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '481891' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '481892' },
  { value: 'tanda', label: 'Tanda', pincode: '481893' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '481894' },
  { value: 'harnath', label: 'Harnath', pincode: '481897' },
  { value: 'rampur', label: 'Rampur', pincode: '481898' },
  { value: 'sahpura', label: 'Sahpura', pincode: '481899' },
  { value: 'dohad', label: 'Dohad', pincode: '481900' }
  ],

  'maihar': [
  { value: 'alampur', label: 'Alampur', pincode: '485771' },
  { value: 'badgaon', label: 'Badgaon', pincode: '485772' },
  { value: 'bargawan', label: 'Bargawan', pincode: '485775' },
  { value: 'bhikhampur', label: 'Bhikhampur', pincode: '485789' },
  { value: 'chandpur', label: 'Chandpur', pincode: '485774' },
  { value: 'dhamanwara', label: 'Dhamanwara', pincode: '485778' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jholi', label: 'Jholi', pincode: '485779' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '485773' },
  { value: 'kheda', label: 'Kheda', pincode: '485790' },
  { value: 'manpur', label: 'Manpur', pincode: '485776' },
  { value: 'mohadi', label: 'Mohadi', pincode: '485777' },
  { value: 'nalchha', label: 'Nalchha', pincode: '485780' },
  { value: 'pachora', label: 'Pachora', pincode: '485781' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '485782' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '485783' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '485784' },
  { value: 'tanda', label: 'Tanda', pincode: '485785' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '485786' },
  { value: 'adampur', label: 'Adampur', pincode: '485791' },
  { value: 'banegaon', label: 'Banegaon', pincode: '485792' },
  { value: 'bargawan', label: 'Bargawan', pincode: '485775' },
  { value: 'mahilpur', label: 'Mahilpur', pincode: '485793' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '485794' }
  ],

  'narsinghpur': [
  { value: 'alapur', label: 'Alapur', pincode: '487001' },
  { value: 'badgaon', label: 'Badgaon', pincode: '487002' },
  { value: 'banegaon', label: 'Banegaon', pincode: '487003' },
  { value: 'baranjala', label: 'Baranjala', pincode: '487017' },
  { value: 'chandpur', label: 'Chandpur', pincode: '487004' },
  { value: 'dhamanwara', label: 'Dhamanwara', pincode: '487005' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jholi', label: 'Jholi', pincode: '487006' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '487007' },
  { value: 'kheda', label: 'Kheda', pincode: '487018' },
  { value: 'manpur', label: 'Manpur', pincode: '487008' },
  { value: 'mohadi', label: 'Mohadi', pincode: '487009' },
  { value: 'nalchha', label: 'Nalchha', pincode: '487010' },
  { value: 'pachora', label: 'Pachora', pincode: '487011' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '487012' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '487013' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '487014' },
  { value: 'tanda', label: 'Tanda', pincode: '487015' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '487016' },
  { value: 'adampur', label: 'Adampur', pincode: '487019' },
  { value: 'banegaon-bhuri', label: 'Banegaon Bhuri', pincode: '487020' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '487021' },
  { value: 'kamaria', label: 'Kamaria', pincode: '487022' },
  { value: 'kheda-village', label: 'Kheda Village', pincode: '487023' },
  { value: 'mandhata', label: 'Mandhata', pincode: '487024' },
  { value: 'puranpura', label: 'Puranpura', pincode: '487025' },
  { value: 'rasoolabad', label: 'Rasoolabad', pincode: '487026' }
  ],

  'datia': [
  { value: 'alampur', label: 'Alampur', pincode: '475661' },
  { value: 'badgaon', label: 'Badgaon', pincode: '475662' },
  { value: 'banegaon', label: 'Banegaon', pincode: '475663' },
  { value: 'baranjala', label: 'Baranjala', pincode: '475677' },
  { value: 'chandpur', label: 'Chandpur', pincode: '475664' },
  { value: 'dhamanwara', label: 'Dhamanwara', pincode: '475665' },
  { value: 'datia-city', label: 'Datia City', pincode: '475661' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jholi', label: 'Jholi', pincode: '475666' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '475667' },
  { value: 'kheda', label: 'Kheda', pincode: '475678' },
  { value: 'manpur', label: 'Manpur', pincode: '475668' },
  { value: 'mohadi', label: 'Mohadi', pincode: '475669' },
  { value: 'nalchha', label: 'Nalchha', pincode: '475670' },
  { value: 'pachora', label: 'Pachora', pincode: '475671' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '475672' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '475673' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '475674' },
  { value: 'tanda', label: 'Tanda', pincode: '475675' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '475676' },
  { value: 'adampur', label: 'Adampur', pincode: '475679' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '475680' },
  { value: 'kamariya', label: 'Kamariya', pincode: '475681' },
  { value: 'mandhata', label: 'Mandhata', pincode: '475682' },
  { value: 'puranpura', label: 'Puranpura', pincode: '475683' },
  { value: 'rasoolabad', label: 'Rasoolabad', pincode: '475684' }
  ],

  'barwāni': [
  { value: 'alapur', label: 'Alapur', pincode: '451551' },
  { value: 'badgaon', label: 'Badgaon', pincode: '451552' },
  { value: 'banegaon', label: 'Banegaon', pincode: '451553' },
  { value: 'barwāni-city', label: 'Barwāni City', pincode: '451551' },
  { value: 'baranjala', label: 'Baranjala', pincode: '451567' },
  { value: 'chandpur', label: 'Chandpur', pincode: '451554' },
  { value: 'dhamanwara', label: 'Dhamanwara', pincode: '451555' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jholi', label: 'Jholi', pincode: '451556' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '451557' },
  { value: 'kheda', label: 'Kheda', pincode: '451568' },
  { value: 'manpur', label: 'Manpur', pincode: '451558' },
  { value: 'mohadi', label: 'Mohadi', pincode: '451559' },
  { value: 'nalchha', label: 'Nalchha', pincode: '451560' },
  { value: 'pachora', label: 'Pachora', pincode: '451561' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '451562' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '451563' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '451564' },
  { value: 'tanda', label: 'Tanda', pincode: '451565' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '451566' },
  { value: 'adampur', label: 'Adampur', pincode: '451569' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '451570' },
  { value: 'kamariya', label: 'Kamariya', pincode: '451571' },
  { value: 'mandhata', label: 'Mandhata', pincode: '451572' },
  { value: 'puranpura', label: 'Puranpura', pincode: '451573' },
  { value: 'rasoolabad', label: 'Rasoolabad', pincode: '451574' },
  { value: 'dhangaon', label: 'Dhangaon', pincode: '451575' }
  ],

  'khajuraho': [
  { value: 'badgaon', label: 'Badgaon', pincode: '471606' },
  { value: 'banegaon', label: 'Banegaon', pincode: '471607' },
  { value: 'baranjala', label: 'Baranjala', pincode: '471620' },
  { value: 'chandpur', label: 'Chandpur', pincode: '471608' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jhansi-road', label: 'Jhansi Road', pincode: '471609' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '471610' },
  { value: 'kheda', label: 'Kheda', pincode: '471611' },
  { value: 'khajuraho-city', label: 'Khajuraho City', pincode: '471606' },
  { value: 'manpur', label: 'Manpur', pincode: '471612' },
  { value: 'mohadi', label: 'Mohadi', pincode: '471613' },
  { value: 'nalchha', label: 'Nalchha', pincode: '471614' },
  { value: 'pachora', label: 'Pachora', pincode: '471615' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '471616' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '471617' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '471618' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '471619' },
  { value: 'adampur', label: 'Adampur', pincode: '471621' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '471622' },
  { value: 'kamariya', label: 'Kamariya', pincode: '471623' },
  { value: 'mandhata', label: 'Mandhata', pincode: '471624' },
  { value: 'puranpura', label: 'Puranpura', pincode: '471625' },
  { value: 'rasoolabad', label: 'Rasoolabad', pincode: '471626' },
  { value: 'chhatarpur', label: 'Chhatarpur', pincode: '471627' },
  { value: 'garh', label: 'Garh', pincode: '471628' }
  ],

  'chanderi': [
  { value: 'adampur', label: 'Adampur', pincode: '473675' },
  { value: 'badgaon', label: 'Badgaon', pincode: '473661' },
  { value: 'banegaon', label: 'Banegaon', pincode: '473662' },
  { value: 'baranjala', label: 'Baranjala', pincode: '473676' },
  { value: 'chandpur', label: 'Chandpur', pincode: '473663' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jhansi-road', label: 'Jhansi Road', pincode: '473664' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '473665' },
  { value: 'kheda', label: 'Kheda', pincode: '473666' },
  { value: 'khajuraho', label: 'Khajuraho', pincode: '473677' },
  { value: 'manpur', label: 'Manpur', pincode: '473667' },
  { value: 'mohadi', label: 'Mohadi', pincode: '473668' },
  { value: 'nalchha', label: 'Nalchha', pincode: '473669' },
  { value: 'pachora', label: 'Pachora', pincode: '473670' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '473671' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '473672' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '473673' },
  { value: 'tanda', label: 'Tanda', pincode: '473678' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '473674' }
  ],

  'maheshwar': [
  { value: 'adampur', label: 'Adampur', pincode: '451238' },
  { value: 'badgaon', label: 'Badgaon', pincode: '451224' },
  { value: 'banegaon', label: 'Banegaon', pincode: '451225' },
  { value: 'chandpur', label: 'Chandpur', pincode: '451226' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jhansi-road', label: 'Jhansi Road', pincode: '451227' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '451228' },
  { value: 'kheda', label: 'Kheda', pincode: '451229' },
  { value: 'maheshwar-town', label: 'Maheshwar Town', pincode: '451224' },
  { value: 'manpur', label: 'Manpur', pincode: '451230' },
  { value: 'mohadi', label: 'Mohadi', pincode: '451231' },
  { value: 'nalchha', label: 'Nalchha', pincode: '451232' },
  { value: 'pachora', label: 'Pachora', pincode: '451233' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '451234' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '451235' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '451236' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '451237' },
  { value: 'kalan', label: 'Kalan', pincode: '451239' },
  { value: 'piplia', label: 'Piplia', pincode: '451240' },
  { value: 'shahpur', label: 'Shahpur', pincode: '451241' },
  { value: 'jijamandal', label: 'Jijamandal', pincode: '451242' },
  { value: 'rangwasa', label: 'Rangwasa', pincode: '451243' },
  { value: 'chandwad', label: 'Chandwad', pincode: '451244' },
  { value: 'surajganj', label: 'Surajganj', pincode: '451245' }
  ],

  'chitrakoot': [
  { value: 'adampur', label: 'Adampur', pincode: '210205' },
  { value: 'badgaon', label: 'Badgaon', pincode: '210201' },
  { value: 'banegaon', label: 'Banegaon', pincode: '210202' },
  { value: 'chandpur', label: 'Chandpur', pincode: '210203' },
  { value: 'chitrakoot-dham', label: 'Chitrakoot Dham', pincode: '210204' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jhansi-road', label: 'Jhansi Road', pincode: '210206' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '210207' },
  { value: 'kheda', label: 'Kheda', pincode: '210208' },
  { value: 'maheshwar', label: 'Maheshwar', pincode: '210209' },
  { value: 'manpur', label: 'Manpur', pincode: '210210' },
  { value: 'mohadi', label: 'Mohadi', pincode: '210211' },
  { value: 'nalchha', label: 'Nalchha', pincode: '210212' },
  { value: 'pachora', label: 'Pachora', pincode: '210213' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '210214' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '210215' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '210216' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '210217' },
  { value: 'bamhori', label: 'Bamhori', pincode: '210218' },
  { value: 'belva', label: 'Belva', pincode: '210219' },
  { value: 'bhagwanpur', label: 'Bhagwanpur', pincode: '210220' },
  { value: 'dudhan', label: 'Dudhan', pincode: '210221' },
  { value: 'kapchora', label: 'Kapchora', pincode: '210222' },
  { value: 'manikpur', label: 'Manikpur', pincode: '210223' },
  { value: 'sitarampur', label: 'Sitarampur', pincode: '210224' }
  ],

  'alirajpur': [
  { value: 'adampur', label: 'Adampur', pincode: '457887' },
  { value: 'alirajpur-town', label: 'Alirajpur Town', pincode: '457887' },
  { value: 'badgaon', label: 'Badgaon', pincode: '457888' },
  { value: 'banegaon', label: 'Banegaon', pincode: '457889' },
  { value: 'bihariyapada', label: 'Bihariyapada', pincode: '457903' },
  { value: 'chandpur', label: 'Chandpur', pincode: '457890' },
  { value: 'chhota-bagda', label: 'Chhota Bagda', pincode: '457904' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jhansi-road', label: 'Jhansi Road', pincode: '457891' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '457892' },
  { value: 'kheda', label: 'Kheda', pincode: '457893' },
  { value: 'manpur', label: 'Manpur', pincode: '457895' },
  { value: 'mohadi', label: 'Mohadi', pincode: '457896' },
  { value: 'nalchha', label: 'Nalchha', pincode: '457897' },
  { value: 'pachora', label: 'Pachora', pincode: '457898' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '457899' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '457900' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '457901' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '457902' },
  { value: 'piplia', label: 'Piplia', pincode: '457905' },
  { value: 'rangwasa', label: 'Rangwasa', pincode: '457906' },
  { value: 'sonkhedi', label: 'Sonkhedi', pincode: '457907' },
  { value: 'surajganj', label: 'Surajganj', pincode: '457908' },
  { value: 'takarbardi', label: 'Takarbardi', pincode: '457909' },
  { value: 'baiswada', label: 'Baiswada', pincode: '457910' },
  { value: 'khajuri', label: 'Khajuri', pincode: '457911' }
  ],

  'panna': [
  { value: 'adampur', label: 'Adampur', pincode: '488001' },
  { value: 'badgaon', label: 'Badgaon', pincode: '488002' },
  { value: 'banegaon', label: 'Banegaon', pincode: '488003' },
  { value: 'chandpur', label: 'Chandpur', pincode: '488004' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jhansi-road', label: 'Jhansi Road', pincode: '488005' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '488006' },
  { value: 'kheda', label: 'Kheda', pincode: '488007' },
  { value: 'manpur', label: 'Manpur', pincode: '488008' },
  { value: 'mohadi', label: 'Mohadi', pincode: '488009' },
  { value: 'nalchha', label: 'Nalchha', pincode: '488010' },
  { value: 'pachora', label: 'Pachora', pincode: '488011' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '488012' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '488013' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '488014' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '488015' },
  { value: 'agaria', label: 'Agaria', pincode: '488016' },
  { value: 'bihariyapada', label: 'Bihariyapada', pincode: '488017' },
  { value: 'dehri', label: 'Dehri', pincode: '488018' },
  { value: 'khajuri', label: 'Khajuri', pincode: '488019' },
  { value: 'mochapur', label: 'Mochapur', pincode: '488020' },
  { value: 'madhavpur', label: 'Madhavpur', pincode: '488021' },
  { value: 'panna-dham', label: 'Panna Dham', pincode: '488022' },
  { value: 'sihora', label: 'Sihora', pincode: '488023' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '488024' }
  ],

  'tikamgarh': [
  { value: 'adampur', label: 'Adampur', pincode: '472001' },
  { value: 'badgaon', label: 'Badgaon', pincode: '472002' },
  { value: 'banegaon', label: 'Banegaon', pincode: '472003' },
  { value: 'chandpur', label: 'Chandpur', pincode: '472004' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jhansi-road', label: 'Jhansi Road', pincode: '472005' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '472006' },
  { value: 'kheda', label: 'Kheda', pincode: '472007' },
  { value: 'manpur', label: 'Manpur', pincode: '472008' },
  { value: 'mohadi', label: 'Mohadi', pincode: '472009' },
  { value: 'nalchha', label: 'Nalchha', pincode: '472010' },
  { value: 'pachora', label: 'Pachora', pincode: '472011' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '472012' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '472013' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '472014' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '472015' },
  { value: 'piplai', label: 'Piplai', pincode: '472016' },
  { value: 'rangwasa', label: 'Rangwasa', pincode: '472017' },
  { value: 'sonkhedi', label: 'Sonkhedi', pincode: '472018' },
  { value: 'surajganj', label: 'Surajganj', pincode: '472019' },
  { value: 'barwan', label: 'Barwan', pincode: '472020' },
  { value: 'bhairopur', label: 'Bhairopur', pincode: '472021' },
  { value: 'bhitarwar', label: 'Bhitarwar', pincode: '472022' },
  { value: 'chhatarpur', label: 'Chhatarpur', pincode: '472023' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '472024' },
  { value: 'kharwa', label: 'Kharwa', pincode: '472025' },
  { value: 'kundeshwar', label: 'Kundeshwar', pincode: '472026' },
  { value: 'lakhno', label: 'Lakhno', pincode: '472027' },
  { value: 'nawagaon', label: 'Nawagaon', pincode: '472028' },
  { value: 'raajgarh', label: 'Raajgarh', pincode: '472029' }
  ],

  'mauganj': [
  { value: 'adampur', label: 'Adampur', pincode: '484001' },
  { value: 'badgaon', label: 'Badgaon', pincode: '484002' },
  { value: 'banegaon', label: 'Banegaon', pincode: '484003' },
  { value: 'chandpur', label: 'Chandpur', pincode: '484004' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jhansi-road', label: 'Jhansi Road', pincode: '484005' },
  { value: 'khamkheda', label: 'Khamkheda', pincode: '484006' },
  { value: 'kheda', label: 'Kheda', pincode: '484007' },
  { value: 'manpur', label: 'Manpur', pincode: '484008' },
  { value: 'mohadi', label: 'Mohadi', pincode: '484009' },
  { value: 'nalchha', label: 'Nalchha', pincode: '484010' },
  { value: 'pachora', label: 'Pachora', pincode: '484011' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '484012' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '484013' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '484014' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '484015' },
  { value: 'piplai', label: 'Piplai', pincode: '484016' },
  { value: 'rangwasa', label: 'Rangwasa', pincode: '484017' },
  { value: 'sonkhedi', label: 'Sonkhedi', pincode: '484018' },
  { value: 'surajganj', label: 'Surajganj', pincode: '484019' },
  { value: 'amarpur', label: 'Amarpur', pincode: '484020' },
  { value: 'babhani', label: 'Babhani', pincode: '484021' },
  { value: 'barahi', label: 'Barahi', pincode: '484022' },
  { value: 'chhattar', label: 'Chhattar', pincode: '484023' },
  { value: 'dharmpur', label: 'Dharmpur', pincode: '484024' },
  { value: 'mauganj-bazar', label: 'Mauganj Bazar', pincode: '484025' },
  { value: 'pachora-khurd', label: 'Pachora Khurd', pincode: '484026' },
  { value: 'sitaramgarh', label: 'Sitaramgarh', pincode: '484027' },
  { value: 'sundra', label: 'Sundra', pincode: '484028' }
  ],

  'raisen': [
  { value: 'adampur', label: 'Adampur', pincode: '464551' },
  { value: 'badkheda', label: 'Badkheda', pincode: '464552' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '464553' },
  { value: 'bhikampur', label: 'Bhikampur', pincode: '464554' },
  { value: 'chandpur', label: 'Chandpur', pincode: '464555' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jhansi-road', label: 'Jhansi Road', pincode: '464556' },
  { value: 'kheda', label: 'Kheda', pincode: '464557' },
  { value: 'mahaspur', label: 'Mahaspur', pincode: '464558' },
  { value: 'mauganj', label: 'Mauganj', pincode: '464559' },
  { value: 'nalchha', label: 'Nalchha', pincode: '464560' },
  { value: 'pachora', label: 'Pachora', pincode: '464561' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '464562' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '464563' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '464564' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '464565' },
  { value: 'sitaramgarh', label: 'Sitaramgarh', pincode: '464566' },
  { value: 'rangwasa', label: 'Rangwasa', pincode: '464567' },
  { value: 'bairagarh', label: 'Bairagarh', pincode: '464568' },
  { value: 'piplai', label: 'Piplai', pincode: '464569' },
  { value: 'bhagora', label: 'Bhagora', pincode: '464570' },
  { value: 'bilkheda', label: 'Bilkheda', pincode: '464571' },
  { value: 'chicholi', label: 'Chicholi', pincode: '464572' },
  { value: 'ghanshyampur', label: 'Ghanshyampur', pincode: '464573' },
  { value: 'nandra', label: 'Nandra', pincode: '464574' },
  { value: 'patan', label: 'Patan', pincode: '464575' },
  { value: 'shahpura', label: 'Shahpura', pincode: '464576' },
  { value: 'sitarampur', label: 'Sitarampur', pincode: '464577' }
  ],

  'bhopal': [
    { value: 'agarwal-nagar', label: 'Agarwal Nagar', pincode: '462002' },
    { value: 'aishbagh', label: 'Aishbagh', pincode: '462023' },
    { value: 'arera-colony', label: 'Arera Colony', pincode: '462016' },
    { value: 'arera-hills', label: 'Arera Hills', pincode: '462016' },
    { value: 'ayodhya-bypass', label: 'Ayodhya Bypass', pincode: '462041' },
    { value: 'ayodhya-bypass-road', label: 'Ayodhya Bypass Road', pincode: '462041' },
    { value: 'bagmugalia', label: 'Bagmugalia', pincode: '462023' },
    { value: 'bairagarh', label: 'Bairagarh', pincode: '462030' },
    { value: 'bairagarh-kalan', label: 'Bairagarh Kalan', pincode: '462030' },
    { value: 'barkheda', label: 'Barkheda', pincode: '462001' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '462026' },
    { value: 'bhagwan-nagar', label: 'Bhagwan Nagar', pincode: '462023' },
    { value: 'bheem-nagar', label: 'Bheem Nagar', pincode: '462003' },
    { value: 'bhopal-bairagarh', label: 'Bhopal Bairagarh', pincode: '462029' },
    { value: 'bhopal-cantt', label: 'Bhopal Cantt', pincode: '462001' },
    { value: 'bhopal-extension', label: 'Bhopal Extension', pincode: '462022' },
    { value: 'bhopal-huzur', label: 'Bhopal Huzur', pincode: '462001' },
    { value: 'bhopal-industrial-area', label: 'Bhopal Industrial Area', pincode: '462023' },
    { value: 'bhopal-railway-station', label: 'Bhopal Railway Station', pincode: '462001' },
    { value: 'bhopal-railway-station-area', label: 'Bhopal Railway Station Area', pincode: '462001' },
    { value: 'bhopal-sector-1', label: 'Bhopal Sector 1', pincode: '462021' },
    { value: 'bhopal-university', label: 'Bhopal University', pincode: '462026' },
    { value: 'brahmanpura', label: 'Brahmanpura', pincode: '462002' },
    { value: 'cultural-zone', label: 'Cultural Zone', pincode: '462016' },
    { value: 'chandbad', label: 'Chandbad', pincode: '462044' },
    { value: 'chetak-bridge-area', label: 'Chetak Bridge Area', pincode: '462001' },
    { value: 'chhola', label: 'Chhola', pincode: '462002' },
    { value: 'chhola-road', label: 'Chhola Road', pincode: '462002' },
    { value: 'chunabhatti', label: 'Chunabhatti', pincode: '462023' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '462033' },
    { value: 'gandhinagar', label: 'Gandhinagar', pincode: '462023' },
    { value: 'govindpura', label: 'Govindpura', pincode: '462023' },
    { value: 'gulmohar-colony', label: 'Gulmohar Colony', pincode: '462003' },
    { value: 'gunga', label: 'Gunga', pincode: '462026' },
    { value: 'gwalior-naka', label: 'Gwalior Naka', pincode: '462001' },
    { value: 'habibganj', label: 'Habibganj', pincode: '462024' },
    { value: 'hathaikheda', label: 'Hathaikheda', pincode: '462041' },
    { value: 'hathikhana', label: 'Hathikhana', pincode: '462001' },
    { value: 'hoshangabad-road', label: 'Hoshangabad Road', pincode: '462026' },
    { value: 'itwara', label: 'Itwara', pincode: '462002' },
    { value: 'jabriya', label: 'Jabriya', pincode: '462038' },
    { value: 'jahangirabad', label: 'Jahangirabad', pincode: '462008' },
    { value: 'jaitpura', label: 'Jaitpura', pincode: '462010' },
    { value: 'jail-road', label: 'Jail Road', pincode: '462002' },
    { value: 'jawahar-chowk', label: 'Jawahar Chowk', pincode: '462001' },
    { value: 'karond', label: 'Karond', pincode: '462038' },
    { value: 'karond-circle', label: 'Karond Circle', pincode: '462038' },
    { value: 'katara-hills', label: 'Katara Hills', pincode: '462044' },
    { value: 'khajuri-kalan', label: 'Khajuri Kalan', pincode: '462022' },
    { value: 'khamkheda', label: 'Khamkheda', pincode: '462044' },
    { value: 'kolar', label: 'Kolar', pincode: '462042' },
    { value: 'kolar-road', label: 'Kolar Road', pincode: '462042' },
    { value: 'kolar-road-extension', label: 'Kolar Road Extension', pincode: '462042' },
    { value: 'kotra-sultanabad', label: 'Kotra Sultanabad', pincode: '462002' },
    { value: 'lakherapura', label: 'Lakherapura', pincode: '462001' },
    { value: 'lalghati', label: 'Lalghati', pincode: '462030' },
    { value: 'mahalakshmi-nagar', label: 'Mahalakshmi Nagar', pincode: '462001' },
    { value: 'maharana-pratap-nagar', label: 'Maharana Pratap Nagar', pincode: '462001' },
    { value: 'mandideep', label: 'Mandideep', pincode: '462046' },
    { value: 'mandir-hasaud', label: 'Mandir Hasaud', pincode: '462041' },
    { value: 'mangalwara', label: 'Mangalwara', pincode: '462001' },
    { value: 'minal-residency', label: 'Minal Residency', pincode: '462023' },
    { value: 'misrod', label: 'Misrod', pincode: '462047' },
    { value: 'misrod-road', label: 'Misrod Road', pincode: '462047' },
    { value: 'moti-masjid', label: 'Moti Masjid', pincode: '462001' },
    { value: 'mp-nagar', label: 'MP Nagar', pincode: '462011' },
    { value: 'new-market', label: 'New Market', pincode: '462003' },
    { value: 'old-bhopal', label: 'Old Bhopal', pincode: '462001' },
    { value: 'pachaur', label: 'Pachaur', pincode: '462002' },
    { value: 'pachmarhi', label: 'Pachmarhi', pincode: '462002' },
    { value: 'pardeshipura', label: 'Pardeshipura', pincode: '462003' },
    { value: 'phanda', label: 'Phanda', pincode: '462022' },
    { value: 'pichhore', label: 'Pichhore', pincode: '462036' },
    { value: 'piplani', label: 'Piplani', pincode: '462021' },
    { value: 'pipliyahana', label: 'Pipliyahana', pincode: '462021' },
    { value: 'rachna-nagar', label: 'Rachna Nagar', pincode: '462022' },
    { value: 'rahatgarh', label: 'Rahatgarh', pincode: '462020' },
    { value: 'rajeev-nagar', label: 'Rajeev Nagar', pincode: '462023' },
    { value: 'rajnagar', label: 'Rajnagar', pincode: '462023' },
    { value: 'ratanpur', label: 'Ratanpur', pincode: '462044' },
    { value: 'ravindra-nath-tagore-nagar', label: 'Ravindra Nath Tagore Nagar', pincode: '462023' },
    { value: 'ravishankar-nagar', label: 'Ravishankar Nagar', pincode: '462022' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '462001' },
    { value: 'sagar', label: 'Sagar', pincode: '462003' },
    { value: 'saket-nagar', label: 'Saket Nagar', pincode: '462024' },
    { value: 'samardha', label: 'Samardha', pincode: '462002' },
    { value: 'sangam-nagar', label: 'Sangam Nagar', pincode: '462022' },
    { value: 'sanjay-nagar', label: 'Sanjay Nagar', pincode: '462021' },
    { value: 'saraswati-nagar', label: 'Saraswati Nagar', pincode: '462022' },
    { value: 'sarai', label: 'Sarai', pincode: '462001' },
    { value: 'sarai-subedar', label: 'Sarai Subedar', pincode: '462038' },
    { value: 'sehore-road', label: 'Sehore Road', pincode: '462020' },
    { value: 'shahpura', label: 'Shahpura', pincode: '462001' },
    { value: 'shahpura-lake', label: 'Shahpura Lake', pincode: '462039' },
    { value: 'shankaracharya-nagar', label: 'Shankaracharya Nagar', pincode: '462002' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '462010' },
    { value: 'sindhi-colony', label: 'Sindhi Colony', pincode: '462001' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '462020' },
    { value: 'sultania-road', label: 'Sultania Road', pincode: '462001' },
    { value: 'sundar-nagar', label: 'Sundar Nagar', pincode: '462003' },
    { value: 't-t-nagar', label: 'T T Nagar', pincode: '462003' },
    { value: 'vidisha-road', label: 'Vidisha Road', pincode: '462041' },
    { value: 'vidyasagar', label: 'Vidyasagar', pincode: '462004' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '462010' },
    { value: 'vikram-khand', label: 'Vikram Khand', pincode: '462038' },
    { value: 'vivekanand-nagar', label: 'Vivekanand Nagar', pincode: '462010' }
  ],

  'jabalpur': [
    { value: 'adarsh-Nagar', label: 'Adarsh Nagar', pincode: '482001' },
    { value: 'adhartal', label: 'Adhartal', pincode: '482004' },
    { value: 'amkhera-Road', label: 'Amkhera Road', pincode: '482003' },
    { value: 'anuradha-Colony', label: 'Anuradha Colony', pincode: '482001' },
    { value: 'ashok-Vihar', label: 'Ashok Vihar', pincode: '482002' },
    { value: 'awadhpuri-Colony', label: 'Awadhpuri Colony', pincode: '482003' },
    { value: 'badi-Omti', label: 'Badi Omti', pincode: '482001' },
    { value: 'bai-Ka-Bageecha', label: 'Bai Ka Bageecha', pincode: '482002' },
    { value: 'barela-Road', label: 'Barela Road', pincode: '482003' },
    { value: 'bargi', label: 'Bargi', pincode: '482018' },
    { value: 'bheda-Ghat', label: 'Bheda Ghat', pincode: '482002' },
    { value: 'bhita', label: 'Bhita', pincode: '482002' },
    { value: 'bilhari', label: 'Bilhari', pincode: '482001' },
    { value: 'cantt', label: 'Cantt', pincode: '482001' },
    { value: 'chargawan', label: 'Chargawan', pincode: '482003' },
    { value: 'civil-Line', label: 'Civil Line', pincode: '482001' },
    { value: 'dhanvantri-Nagar', label: 'Dhanvantri Nagar', pincode: '482003' },
    { value: 'dumna-Nature-Reserve', label: 'Dumna Nature Reserve', pincode: '482005' },
    { value: 'ganga-Nagar', label: 'Ganga Nagar', pincode: '482004' },
    { value: 'ganjipura', label: 'Ganjipura', pincode: '482001' },
    { value: 'garha', label: 'Garha', pincode: '482003' },
    { value: 'ghamapur', label: 'Ghamapur', pincode: '482002' },
    { value: 'gohalpur', label: 'Gohalpur', pincode: '482002' },
    { value: 'gora-Bazar', label: 'Gora Bazar', pincode: '482001' },
    { value: 'gorakhpur', label: 'Gorakhpur', pincode: '482002' },
    { value: 'govind-Bhavan-Colony', label: 'Govind Bhavan Colony', pincode: '482003' },
    { value: 'gupteshwar', label: 'Gupteshwar', pincode: '482003' },
    { value: 'gurandi', label: 'Gurandi', pincode: '482001' },
    { value: 'gwarighat-Road', label: 'Gwarighat Road', pincode: '482003' },
    { value: 'hathital', label: 'Hathital', pincode: '482003' },
    { value: 'janki-Nagar', label: 'Janki Nagar', pincode: '482002' },
    { value: 'jasuja-City', label: 'Jasuja City', pincode: '482003' },
    { value: 'kachhpura', label: 'Kachhpura', pincode: '482003' },
    { value: 'kakartala', label: 'Kakartala', pincode: '482004' },
    { value: 'kanchan-Vihar', label: 'Kanchan Vihar', pincode: '482002' },
    { value: 'kanch-Ghar', label: 'Kanch Ghar', pincode: '482003' },
    { value: 'karmeta', label: 'Karmeta', pincode: '482002' },
    { value: 'katanga', label: 'Katanga', pincode: '482003' },
    { value: 'katangi', label: 'Katangi', pincode: '482002' },
    { value: 'kathoda', label: 'Kathoda', pincode: '482002' },
    { value: 'khamaria', label: 'Khamaria', pincode: '482001' },
    { value: 'kudwari', label: 'Kudwari', pincode: '482004' },
    { value: 'kusner', label: 'Kusner', pincode: '482003' },
    { value: 'lamheta-Ghat', label: 'Lamheta Ghat', pincode: '482002' },
    { value: 'lamti', label: 'Lamti', pincode: '482003' },
    { value: 'madan-Mahal', label: 'Madan Mahal', pincode: '482001' },
    { value: 'maharajpur', label: 'Maharajpur', pincode: '482003' },
    { value: 'maitri-Nagar', label: 'Maitri Nagar', pincode: '482002' },
    { value: 'majholi', label: 'Majholi', pincode: '482002' },
    { value: 'mandla', label: 'Mandla', pincode: '482003' },
    { value: 'marhatal', label: 'Marhatal', pincode: '482001' },
    { value: 'medical-College-Colony', label: 'Medical College Colony', pincode: '482003' },
    { value: 'napier-Town', label: 'Napier Town', pincode: '482001' },
    { value: 'narmada-Road', label: 'Narmada Road', pincode: '482001' },
    { value: 'nayagaon', label: 'Nayagaon', pincode: '482002' },
    { value: 'neemkheda', label: 'Neemkheda', pincode: '482004' },
    { value: 'pachpedi', label: 'Pachpedi', pincode: '482003' },
    { value: 'panagar', label: 'Panagar', pincode: '482001' },
    { value: 'patan', label: 'Patan', pincode: '482003' },
    { value: 'pipariya-Kalan', label: 'Pipariya Kalan', pincode: '482004' },
    { value: 'priyadarshni-Colony', label: 'Priyadarshni Colony', pincode: '482002' },
    { value: 'ranital', label: 'Ranital', pincode: '482003' },
    { value: 'ranjhi', label: 'Ranjhi', pincode: '482005' },
    { value: 'ronsra', label: 'Ronsra', pincode: '482003' },
    { value: 'saliwara', label: 'Saliwara', pincode: '482001' },
    { value: 'sanghi', label: 'Sanghi', pincode: '482002' },
    { value: 'sanjeevani-Nagar', label: 'Sanjeevani Nagar', pincode: '482003' },
    { value: 'sarvodaya-Nagar', label: 'Sarvodaya Nagar', pincode: '482003' },
    { value: 'shakti-Nagar', label: 'Shakti Nagar', pincode: '482002' },
    { value: 'shastri-Nagar', label: 'Shastri Nagar', pincode: '482001' },
    { value: 'sheetalpuri', label: 'Sheetalpuri', pincode: '482003' },
    { value: 'shiv-Nagar-Colony', label: 'Shiv Nagar Colony', pincode: '482003' },
    { value: 'sihora', label: 'Sihora', pincode: '482002' },
    { value: 'silgaur', label: 'Silgaur', pincode: '482002' },
    { value: 'sneh-Nagar', label: 'Sneh Nagar', pincode: '482002' },
    { value: 'suhagi', label: 'Suhagi', pincode: '482003' },
    { value: 'sukha', label: 'Sukha', pincode: '482001' },
    { value: 'tilhari', label: 'Tilhari', pincode: '482003' },
    { value: 'tilwara', label: 'Tilwara', pincode: '482003' },
    { value: 'trimurti-Nagar', label: 'Trimurti Nagar', pincode: '482002' },
    { value: 'umria', label: 'Umria', pincode: '482003' },
    { value: 'uprainganj', label: 'Uprainganj', pincode: '482003' },
    { value: 'vijay-Nagar', label: 'Vijay Nagar', pincode: '482001' },
    { value: 'vikas-Nagar', label: 'Vikas Nagar', pincode: '482002' },
    { value: 'wright-Town', label: 'Wright Town', pincode: '482003' },
    { value: 'yadav-Colony', label: 'Yadav Colony', pincode: '482003' }
  ],

  'ratlam': [
    { value: 'agar-Road', label: 'Agar Road', pincode: '457001' },
    { value: 'alka-Nagar', label: 'Alka Nagar', pincode: '457001' },
    { value: 'amba-Nagar', label: 'Amba Nagar', pincode: '457001' },
    { value: 'ashok Nagar', label: 'Ashok Nagar', pincode: '457001' },
    { value: 'ashok-Vihar', label: 'Ashok Vihar', pincode: '457001' },
    { value: 'baba-Ki-Kothi', label: 'Baba Ki Kothi', pincode: '457001' },
    { value: 'bagli-Road', label: 'Bagli Road', pincode: '457001' },
    { value: 'bajrang-Nagar', label: 'Bajrang Nagar', pincode: '457001' },
    { value: 'bavdi-Gate', label: 'Bavdi Gate', pincode: '457001' },
    { value: 'bhatpachlana', label: 'Bhatpachlana', pincode: '457001' },
    { value: 'bhilwara', label: 'Bhilwara', pincode: '457002' },
    { value: 'bohra-Bazar', label: 'Bohra Bazar', pincode: '457001' },
    { value: 'borekheda', label: 'Borekheda', pincode: '457001' },
    { value: 'chandni-Chowk', label: 'Chandni Chowk', pincode: '457001' },
    { value: 'chandralok-Colony', label: 'Chandralok Colony', pincode: '457001' },
    { value: 'chhoti-Bazar', label: 'Chhoti Bazar', pincode: '457001' },
    { value: 'chhoti-Gali', label: 'Chhoti Gali', pincode: '457001' },
    { value: 'civil-Lines', label: 'Civil Lines', pincode: '457001' },
    { value: 'daleep-Nagar', label: 'Daleep Nagar', pincode: '457001' },
    { value: 'dewas-Naka', label: 'Dewas Naka', pincode: '457001' },
    { value: 'fatehnagar', label: 'Fatehnagar', pincode: '457001' },
    { value: 'furqan-Colony', label: 'Furqan Colony', pincode: '457001' },
    { value: 'gandhi-Nagar', label: 'Gandhi Nagar', pincode: '457001' },
    { value: 'ganga-Nagar', label: 'Ganga Nagar', pincode: '457001' },
    { value: 'garib-Nawaz-Nagar', label: 'Garib Nawaz Nagar', pincode: '457001' },
    { value: 'gole-ka-Mandir', label: 'Gole ka Mandir', pincode: '457001' },
    { value: 'gopi-Nath-Colony', label: 'Gopi Nath Colony', pincode: '457001' },
    { value: 'gunjal-Nagar', label: 'Gunjal Nagar', pincode: '457001' },
    { value: 'hawa-Bagh', label: 'Hawa Bagh', pincode: '457001' },
    { value: 'hiranagar', label: 'Hiranagar', pincode: '457001' },
    { value: 'indira-Nagar', label: 'Indira Nagar', pincode: '457001' },
    { value: 'jain-Mandir-Road', label: 'Jain Mandir Road', pincode: '457001' },
    { value: 'jitendra-Nagar', label: 'Jitendra Nagar', pincode: '457001' },
    { value: 'kailash-Nagar', label: 'Kailash Nagar', pincode: '457001' },
    { value: 'kalyan-Nagar', label: 'Kalyan Nagar', pincode: '457001' },
    { value: 'kamla-Nagar', label: 'Kamla Nagar', pincode: '457001' },
    { value: 'kesarbagh', label: 'Kesarbagh', pincode: '457001' },
    { value: 'kishanganj', label: 'Kishanganj', pincode: '457001' },
    { value: 'lakshminagar', label: 'Lakshminagar', pincode: '457001' },
    { value: 'laxminarayan-Nagar', label: 'Laxminarayan Nagar', pincode: '457001' },
    { value: 'madhav-Nagar', label: 'Madhav Nagar', pincode: '457001' },
    { value: 'madhur-Colony', label: 'Madhur Colony', pincode: '457001' },
    { value: 'malanpur', label: 'Malanpur', pincode: '457001' },
    { value: 'mangal-Nagar', label: 'Mangal Nagar', pincode: '457001' },
    { value: 'mohan-Nagar', label: 'Mohan Nagar', pincode: '457001' },
    { value: 'moti-Nagar', label: 'Moti Nagar', pincode: '457001' },
    { value: 'narmada-Nagar', label: 'Narmada Nagar', pincode: '457001' },
    { value: 'navratan-Bagh', label: 'Navratan Bagh', pincode: '457001' },
    { value: 'new', label: 'New', pincode: '457001' },
    { value: 'nirala-Nagar', label: 'Nirala Nagar', pincode: '457001' },
    { value: 'niranja-Colony', label: 'Niranjan Colony', pincode: '457001' },
    { value: 'panchayat-Nagar', label: 'Panchayat Nagar', pincode: '457001' },
    { value: 'panchwati', label: 'Panchwati', pincode: '457001' },
    { value: 'pashupati-Nagar', label: 'Pashupati Nagar', pincode: '457001' },
    { value: 'prakash Nagar', label: 'Prakash Nagar', pincode: '457001' },
    { value: 'radhakrishnan-Nagar', label: 'Radhakrishnan Nagar', pincode: '457001' },
    { value: 'rishabh-Nagar', label: 'Rishabh Nagar', pincode: '457001' },
    { value: 'rishabh-Vihar', label: 'Rishabh Vihar', pincode: '457001' },
    { value: 'rukmani-Nagar', label: 'Rukmani Nagar', pincode: '457001' },
    { value: 'sadar-Bazar', label: 'Sadar Bazar', pincode: '457001' },
    { value: 'saraswati-Nagar', label: 'Saraswati Nagar', pincode: '457001' },
    { value: 'sardar-Patel-Nagar', label: 'Sardar Patel Nagar', pincode: '457001' },
    { value: 'shiv-Nagar', label: 'Shiv Nagar', pincode: '457001' },
    { value: 'shivaji-Nagar', label: 'Shivaji Nagar', pincode: '457001' },
    { value: 'shivam-Colony', label: 'Shivam Colony', pincode: '457001' },
    { value: 'shyam-Nagar', label: 'Shyam Nagar', pincode: '457001' },
    { value: 'sunder-Nagar', label: 'Sunder Nagar', pincode: '457001' },
    { value: 'suraj-Nagar', label: 'Suraj Nagar', pincode: '457001' },
    { value: 'tantia-Bazar', label: 'Tantia Bazar', pincode: '457001' },
    { value: 'thakur-Ji-Ka-Bagh', label: 'Thakur Ji Ka Bagh', pincode: '457001' },
    { value: 'tilak-Nagar', label: 'Tilak Nagar', pincode: '457001' },
    { value: 'triveni-Nagar', label: 'Triveni Nagar', pincode: '457001' },
    { value: 'udyog-Nagar', label: 'Udyog Nagar', pincode: '457001' },
    { value: 'vijay-Nagar', label: 'Vijay Nagar', pincode: '457001' },
    { value: 'vikas-Nagar', label: 'Vikas Nagar', pincode: '457001' },
    { value: 'vikram-Nagar', label: 'Vikram Nagar', pincode: '457001' },
    { value: 'vishwakarma-Nagar', label: 'Vishwakarma Nagar', pincode: '457001' },
    { value: 'wadi', label: 'Wadi', pincode: '457001' },
    { value: 'zalawad Colony', label: 'Zalawad Colony', pincode: '457001' },
    { value: 'zaveri-Bazar', label: 'Zaveri Bazar', pincode: '457001' },
    { value: 'Zandod', label: 'Zandod', pincode: '457001' }
  ],

  'indore': [
    { value: 'ab-bypass-road', label: 'AB Bypass Road', pincode: '452001' },
    { value: 'ab-road', label: 'AB Road', pincode: '452001' },
    { value: 'agra-bombay bypass', label: 'Agra-Bombay Bypass', pincode: '452001' },
    { value: 'agrasen-nagar', label: 'Agrasen Nagar', pincode: '452003' },
    { value: 'alok-nagar', label: 'Alok Nagar', pincode: '452010' },
    { value: 'ambedkar-nagar', label: 'Ambedkar Nagar', pincode: '452010' },
    { value: 'anand-nagar', label: 'Anand Nagar', pincode: '452001' },
    { value: 'anoop-nagar', label: 'Anoop Nagar', pincode: '452008' },
    { value: 'anurag-nagar', label: 'Anurag Nagar', pincode: '452001' },
    { value: 'azad-nagar', label: 'Azad Nagar', pincode: '452003' },
    { value: 'bada-bangarda', label: 'Bada Bangarda', pincode: '453001' },
    { value: 'banganga', label: 'Banganga', pincode: '452001' },
    { value: 'barfani', label: 'Barfani', pincode: '452001' },
    { value: 'bengali-square', label: 'Bengali Square', pincode: '452003' },
    { value: 'bhawrasla', label: 'Bhawrasla', pincode: '452022' },
    { value: 'bhicholi-mardana', label: 'Bhicholi Mardana', pincode: '452016' },
    { value: 'bicholi-road', label: 'Bicholi Road', pincode: '452016' },
    { value: 'bijalpur', label: 'Bijalpur', pincode: '452001' },
    { value: 'brijeshwari-annexe', label: 'Brijeshwari Annexe', pincode: '452010' },
    { value: 'bulandshahr', label: 'Bulandshahr', pincode: '452003' },
    { value: 'chhatrapati-nagar', label: 'Chhatrapati Nagar', pincode: '452010' },
    { value: 'chhatribagh', label: 'Chhatribagh', pincode: '452002' },
    { value: 'chhavni', label: 'Chhavni', pincode: '452001' },
    { value: 'chhoti-gwaltoli', label: 'Chhoti Gwaltoli', pincode: '452001' },
    { value: 'datoda', label: 'Datoda', pincode: '452010' },
    { value: 'ddu-nagar', label: 'DDU Nagar', pincode: '452010' },
    { value: 'depalpur', label: 'Depalpur', pincode: '453115' },
    { value: 'dewas-naka', label: 'Dewas Naka', pincode: '452001' },
    { value: 'dhar-road', label: 'Dhar Road', pincode: '452001' },
    { value: 'dudhia', label: 'Dudhia', pincode: '452016' },
    { value: 'dwarkapuri', label: 'Dwarkapuri', pincode: '452001' },
    { value: 'gadi-adda', label: 'Gadi Adda', pincode: '452001' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '452003' },
    { value: 'geeta-nagar', label: 'Geeta Nagar', pincode: '452001' },
    { value: 'girdhar-nagar', label: 'Girdhar Nagar', pincode: '452009' },
    { value: 'goyal-nagar', label: 'Goyal Nagar', pincode: '452001' },
    { value: 'goyal-vihar', label: 'Goyal Vihar', pincode: '452010' },
    { value: 'greater-brijeshwari-annexe', label: 'Greater Brijeshwari Annexe', pincode: '452010' },
    { value: 'gumasta-nagar', label: 'Gumasta Nagar', pincode: '452009' },
    { value: 'harnya-khedi', label: 'Harnya Khedi', pincode: '452010' },
    { value: 'hasalpur', label: 'Hasalpur', pincode: '452022' },
    { value: 'hathipala', label: 'Hathipala', pincode: '452010' },
    { value: 'hatod', label: 'Hatod', pincode: '453001' },
    { value: 'indira-gandhi-nagar', label: 'Indira Gandhi Nagar', pincode: '452001' },
    { value: 'indore-bypass-road', label: 'Indore Bypass Road', pincode: '452001' },
    { value: 'indra-puri-colony', label: 'Indra Puri Colony', pincode: '452010' },
    { value: 'industrial-estate', label: 'Industrial Estate', pincode: '452001' },
    { value: 'jabran-colony', label: 'Jabran Colony', pincode: '452010' },
    { value: 'jawahar-marg', label: 'Jawahar Marg', pincode: '452003' },
    { value: 'jhalaria', label: 'Jhalaria', pincode: '452001' },
    { value: 'joshi-guradiya', label: 'Joshi Guradiya', pincode: '452010' },
    { value: 'kalani-nagar', label: 'Kalani Nagar', pincode: '452001' },
    { value: 'kalindi-kunj', label: 'Kalindi Kunj', pincode: '452001' },
    { value: 'kalindi-midtown', label: 'Kalindi Midtown', pincode: '452010' },
    { value: 'kamla-nagar', label: 'Kamla Nagar', pincode: '452010' },
    { value: 'kanadia-road', label: 'Kanadia Road', pincode: '452001' },
    { value: 'khajrana', label: 'Khajrana', pincode: '452001' },
    { value: 'khandwa-road', label: 'Khandwa Road', pincode: '452001' },
    { value: 'kordia-barda', label: 'Kordia Barda', pincode: '452016' },
    { value: 'krishi-mandi', label: 'Krishi Mandi', pincode: '452001' },
    { value: 'krishnodaya-nagar', label: 'Krishnodaya Nagar', pincode: '452010' },
    { value: 'lig-colony', label: 'LIG Colony', pincode: '452010' },
    { value: 'lalaram-nagar', label: 'Lalaram Nagar', pincode: '452001' },
    { value: 'lasudia-mori', label: 'Lasudia Mori', pincode: '452010' },
    { value: 'limbodi', label: 'Limbodi', pincode: '452001' },
    { value: 'lokmanya-nagar', label: 'Lokmanya Nagar', pincode: '452009' },
    { value: 'mahalaxmi-nagar', label: 'Mahalaxmi Nagar', pincode: '452010' },
    { value: 'maharaja-tukoji-rao-holker-cloth-market', label: 'Maharaja Tukoji Rao Holker Cloth Market', pincode: '452002' },
    { value: 'maksi', label: 'Maksi', pincode: '453132' },
    { value: 'malhar-ganj', label: 'Malhar Ganj', pincode: '452001' },
    { value: 'manavta-nagar', label: 'Manavta Nagar', pincode: '452010' },
    { value: 'manbhavan-nagar', label: 'Manbhavan Nagar', pincode: '452010' },
    { value: 'manglia', label: 'Manglia', pincode: '453771' },
    { value: 'manik-bagh-road', label: 'Manik Bagh Road', pincode: '452001' },
    { value: 'manishpuri', label: 'Manishpuri', pincode: '452010' },
    { value: 'manorama-ganj', label: 'Manorama Ganj', pincode: '452001' },
    { value: 'mari-mata-square', label: 'Mari Mata Square', pincode: '452002' },
    { value: 'mayakhedi', label: 'Mayakhedi', pincode: '452020' },
    { value: 'mg-road', label: 'MG Road', pincode: '452001' },
    { value: 'mhow', label: 'Mhow', pincode: '453441' },
    { value: 'mirjapur', label: 'Mirjapur', pincode: '452016' },
    { value: 'mog-lines', label: 'MOG Lines', pincode: '452001' },
    { value: 'morod', label: 'Morod', pincode: '452001' },
    { value: 'mr-10', label: 'MR-10', pincode: '452001' },
    { value: 'mr-11', label: 'MR-11', pincode: '452010' },
    { value: 'murai-mohalla', label: 'Murai Mohalla', pincode: '452001' },
    { value: 'musakhedi', label: 'Musakhedi', pincode: '452001' },
    { value: 'nagar-nigam', label: 'Nagar Nigam', pincode: '452001' },
    { value: 'nagda', label: 'Nagda', pincode: '452001' },
    { value: 'nainod', label: 'Nainod', pincode: '452022' },
    { value: 'nanda-nagar', label: 'Nanda Nagar', pincode: '452011' },
    { value: 'navlakha', label: 'Navlakha', pincode: '452001' },
    { value: 'new-palasia', label: 'New Palasia', pincode: '452001' },
    { value: 'new-rani-bagh', label: 'New Rani Bagh', pincode: '452001' },
    { value: 'nihalpur-mandi', label: 'Nihalpur Mandi', pincode: '452017' },
    { value: 'nipania', label: 'Nipania', pincode: '452001' },
    { value: 'niranjanpur', label: 'Niranjanpur', pincode: '452010' },
    { value: 'noorani-nagar', label: 'Noorani Nagar', pincode: '452003' },
    { value: 'old-palasia', label: 'Old Palasia', pincode: '452001' },
    { value: 'pachore', label: 'Pachore', pincode: '453115' },
    { value: 'palakhedi', label: 'Palakhedi', pincode: '452016' },
    { value: 'palda', label: 'Palda', pincode: '452020' },
    { value: 'paliya-haidar', label: 'Paliya Haidar', pincode: '452016' },
    { value: 'palsikar-colony', label: 'Palsikar Colony', pincode: '452001' },
    { value: 'panchderiya', label: 'Panchderiya', pincode: '452020' },
    { value: 'panchvati-colony', label: 'Panchvati Colony', pincode: '452001' },
    { value: 'paraspar-nagar', label: 'Paraspar Nagar', pincode: '452001' },
    { value: 'pardesi-pura', label: 'Pardesi Pura', pincode: '452002' },
    { value: 'patni-pura', label: 'Patni Pura', pincode: '452003' },
    { value: 'pigdambar', label: 'Pigdambar', pincode: '452020' },
    { value: 'pipliya-kumar', label: 'Pipliya Kumar', pincode: '452010' },
    { value: 'piplyahana', label: 'Piplyahana', pincode: '452014' },
    { value: 'pithampur', label: 'Pithampur', pincode: '454774' },
    { value: 'race-course-road', label: 'Race Course Road', pincode: '452003' },
    { value: 'raj-mohalla', label: 'Raj Mohalla', pincode: '452001' },
    { value: 'rajendra-nagar', label: 'Rajendra Nagar', pincode: '452012' },
    { value: 'rajmahal', label: 'Rajmahal', pincode: '452002' },
    { value: 'rajwada', label: 'Rajwada', pincode: '452002' },
    { value: 'rala-mandal', label: 'Rala Mandal', pincode: '452016' },
    { value: 'rambag', label: 'Rambag', pincode: '452001' },
    { value: 'rangwasa', label: 'Rangwasa', pincode: '452020' },
    { value: 'rau', label: 'Rau', pincode: '453331' },
    { value: 'rau-dewas-bypass', label: 'Rau-Dewas Bypass', pincode: '452016' },
    { value: 'rau-pithampur-road', label: 'Rau Pithampur Road', pincode: '453441' },
    { value: 'ravi-shankar-shukla', label: 'Ravi Shankar Shukla', pincode: '452009' },
    { value: 'ring-road', label: 'Ring Road', pincode: '452010' },
    { value: 'sadar-bazar', label: 'Sadar Bazaar', pincode: '452001' },
    { value: 'sai-kripa-colony', label: 'Sai Kripa Colony', pincode: '452001' },
    { value: 'sanchar-nagar-main', label: 'Sanchar Nagar Main', pincode: '452014' },
    { value: 'sangam-nagar', label: 'Sangam Nagar', pincode: '452010' },
    { value: 'sanvid-nagar', label: 'Sanvid Nagar', pincode: '452001' },
    { value: 'sanwer', label: 'Sanwer', pincode: '453552' },
    { value: 'sarv-suvidha', label: 'Sarv Suvidha', pincode: '452010' },
    { value: 'sarvsampanna', label: 'Sarvsampanna', pincode: '452001' },
    { value: 'scheme-140', label: 'Scheme 140', pincode: '453001' },
    { value: 'scheme-94', label: 'Scheme 94', pincode: '452010' },
    { value: 'scheme-no-103', label: 'Scheme No 103', pincode: '452010' },
    { value: 'scheme-no-114', label: 'Scheme No 114', pincode: '452001' },
    { value: 'scheme-no-134', label: 'Scheme No 134', pincode: '452010' },
    { value: 'scheme-no-51', label: 'Scheme No 51', pincode: '452010' },
    { value: 'scheme-no-54', label: 'Scheme No 54', pincode: '452010' },
    { value: 'scheme-no-71', label: 'Scheme No 71', pincode: '452001' },
    { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '452001' },
    { value: 'shivmoti-nagar', label: 'Shivmoti Nagar', pincode: '452010' },
    { value: 'shri-nagar-extension', label: 'Shri Nagar Extension', pincode: '452010' },
    { value: 'shri-ram-nagar', label: 'Shri Ram Nagar', pincode: '452001' },
    { value: 'shripuram', label: 'Shripuram', pincode: '452020' },
    { value: 'silicon-city', label: 'Silicon City', pincode: '452010' },
    { value: 'sneh-lata-ganj', label: 'Sneh Lata Ganj', pincode: '452003' },
    { value: 'south-tukoganj', label: 'South Tukoganj', pincode: '452001' },
    { value: 'sudama-nagar', label: 'Sudama Nagar', pincode: '452001' },
    { value: 'super-corridor', label: 'Super Corridor', pincode: '452020' },
    { value: 'talawali-chanda', label: 'Talawali Chanda', pincode: '452020' },
    { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '452010' },
    { value: 'ujjain-road', label: 'Ujjain Road', pincode: '452001' },
    { value: 'vaibhav-nagar', label: 'Vaibhav Nagar', pincode: '452010' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '452010' },
    { value: 'vindhyanchal-nagar', label: 'Vindhyanchal Nagar', pincode: '452010' },
    { value: 'vishnupuri-colony', label: 'Vishnupuri Colony', pincode: '452010' },
    { value: 'white-church-colony', label: 'White Church Colony', pincode: '452001' }
  ],

  'kanpur': [
    { value: 'akbarpur', label: 'Akbarpur', pincode: '209101' },
    { value: 'allahabad-road', label: 'Allahabad Road', pincode: '208001' },
    { value: 'azad-nagar', label: 'Azad Nagar', pincode: '208002' },
    { value: 'barra', label: 'Barra', pincode: '208027' },
    { value: 'bhauti-pratappur', label: 'Bhauti Pratappur', pincode: '208020' },
    { value: 'bilhaur', label: 'Bilhaur', pincode: '209201' },
    { value: 'bithoor', label: 'Bithoor', pincode: '209201' },
    { value: 'bithoor-road', label: 'Bithoor Road', pincode: '209201' },
    { value: 'chakeri', label: 'Chakeri', pincode: '208007' },
    { value: 'chaubepur', label: 'Chaubepur', pincode: '209202' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '208001' },
    { value: 'colonelganj', label: 'Colonelganj', pincode: '208001' },
    { value: 'dabauli', label: 'Dabauli', pincode: '208021' },
    { value: 'daheli-sujanpur', label: 'Daheli Sujanpur', pincode: '208021' },
    { value: 'damodar-nagar', label: 'Damodar Nagar', pincode: '208012' },
    { value: 'darshan-purwa', label: 'Darshan Purwa', pincode: '208007' },
    { value: 'fazal-ganj', label: 'Fazal Ganj', pincode: '208001' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '208012' },
    { value: 'gandhigram', label: 'Gandhigram', pincode: '208008' },
    { value: 'general-ganj', label: 'General Ganj', pincode: '208001' },
    { value: 'ghatampur', label: 'Ghatampur', pincode: '209206' },
    { value: 'govind-nagar', label: 'Govind Nagar', pincode: '208006' },
    { value: 'gujaini', label: 'Gujaini', pincode: '209304' },
    { value: 'hanspuram', label: 'Hanspuram', pincode: '208025' },
    { value: 'harsh-nagar', label: 'Harsh Nagar', pincode: '208012' },
    { value: 'highway-city', label: 'Highway City', pincode: '208015' },
    { value: 'indira-nagar', label: 'Indira Nagar', pincode: '208026' },
    { value: 'jajmau', label: 'Jajmau', pincode: '208010' },
    { value: 'jarauli', label: 'Jarauli', pincode: '208021' },
    { value: 'jawahar-puram', label: 'Jawahar Puram', pincode: '208011' },
    { value: 'jk-puri', label: 'J K Puri', pincode: '208014' },
    { value: 'juhi', label: 'Juhi', pincode: '208014' },
    { value: 'kakadeo', label: 'Kakadeo', pincode: '208019' },
    { value: 'kalyanpur', label: 'Kalyanpur', pincode: '208017' },
    { value: 'karbigwan', label: 'Karbigwan', pincode: '208022' },
    { value: 'kaushalpuri', label: 'Kaushalpuri', pincode: '208003' },
    { value: 'keshavpuram', label: 'Keshavpuram', pincode: '208024' },
    { value: 'khalasi-line', label: 'Khalasi Line', pincode: '208004' },
    { value: 'khujaupur', label: 'Khujaupur', pincode: '209303' },
    { value: 'khyora', label: 'Khyora', pincode: '208011' },
    { value: 'kidwai-nagar', label: 'Kidwai Nagar', pincode: '208011' },
    { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '208022' },
    { value: 'krishnapuram', label: 'Krishnapuram', pincode: '208021' },
    { value: 'lajpat-nagar', label: 'Lajpat Nagar', pincode: '208005' },
    { value: 'lal-bangla', label: 'Lal Bangla', pincode: '208012' },
    { value: 'mainawati-marg', label: 'Mainawati Marg', pincode: '208004' },
    { value: 'maitha', label: 'Maitha', pincode: '209213' },
    { value: 'majhawan', label: 'Majhawan', pincode: '209306' },
    { value: 'makri-kheora', label: 'Makri Kheora', pincode: '209303' },
    { value: 'mall-road', label: 'Mall Road', pincode: '208001' },
    { value: 'mandhana', label: 'Mandhana', pincode: '209303' },
    { value: 'maswanpur', label: 'Maswanpur', pincode: '208022' },
    { value: 'meharban-singh-ka-purva', label: 'Meharban Singh Ka Purva', pincode: '208021' },
    { value: 'mirpur', label: 'Mirpur', pincode: '209306' },
    { value: 'naramau', label: 'Naramau', pincode: '209305' },
    { value: 'naubasta', label: 'Naubasta', pincode: '208021' },
    { value: 'nawabganj', label: 'Nawabganj', pincode: '209305' },
    { value: 'om-nagar', label: 'Om Nagar', pincode: '208023' },
    { value: 'pandu-nagar', label: 'Pandu Nagar', pincode: '208023' },
    { value: 'panki', label: 'Panki', pincode: '208020' },
    { value: 'parade', label: 'Parade', pincode: '208001' },
    { value: 'parwati-bagla-road', label: 'Parwati Bagla Road', pincode: '208012' },
    { value: 'patkapur', label: 'Patkapur', pincode: '208003' },
    { value: 'patrakarpuram', label: 'Patrakarpuram', pincode: '208019' },
    { value: 'permat', label: 'Permat', pincode: '209303' },
    { value: 'purana', label: 'Purana', pincode: '208001' },
    { value: 'rai-purwa', label: 'Rai Purwa', pincode: '208021' },
    { value: 'ram-bagh', label: 'Ram Bagh', pincode: '208012' },
    { value: 'ramaipur', label: 'Ramaipur', pincode: '209202' },
    { value: 'ratan-lal-nagar', label: 'Ratan Lal Nagar', pincode: '208022' },
    { value: 'ravidas-puram', label: 'Ravidas Puram', pincode: '208025' },
    { value: 'rawatpur', label: 'Rawatpur', pincode: '208019' },
    { value: 'rooma', label: 'Rooma', pincode: '208024' },
    { value: 'rura', label: 'Rura', pincode: '209303' },
    { value: 'saket-nagar', label: 'Saket Nagar', pincode: '208014' },
    { value: 'sarvodaya-nagar', label: 'Sarvodaya Nagar', pincode: '208005' },
    { value: 'sharda-nagar', label: 'Sharda Nagar', pincode: '208025' },
    { value: 'shashtri-nagar', label: 'Shashtri Nagar', pincode: '208025' },
    { value: 'shivarajpur', label: 'Shivarajpur', pincode: '209301' },
    { value: 'shuklaganj', label: 'Shuklaganj', pincode: '209331' },
    { value: 'shyam-nagar', label: 'Shyam Nagar', pincode: '208013' },
    { value: 'singhpur', label: 'Singhpur', pincode: '209304' },
    { value: 'swaroop-nagar', label: 'Swaroop Nagar', pincode: '208002' },
    { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '208003' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '208001' },
    { value: 'vip-road', label: 'VIP Road', pincode: '208007' },
    { value: 'vishnu-puri', label: 'Vishnu Puri', pincode: '208023' },
    { value: 'yashoda-nagar', label: 'Yashoda Nagar', pincode: '208011' }
  ],

  'karnal': [
    { value: 'alipur-khalsa', label: 'Alipur Khalsa', pincode: '132040' },
    { value: 'arpana-hospital-area', label: 'Arpana Hospital Area', pincode: '132001' },
    { value: 'assandh', label: 'Assandh', pincode: '132039' },
    { value: 'baldi-bypass', label: 'Baldi Bypass', pincode: '132001' },
    { value: 'bastara', label: 'Bastara', pincode: '132037' },
    { value: 'bhootnath-mandir-area', label: 'Bhootnath Mandir Area', pincode: '132001' },
    { value: 'char-chowk', label: 'Char Chowk', pincode: '132001' },
    { value: 'dayal-singh-colony', label: 'Dayal Singh Colony', pincode: '132001' },
    { value: 'deenbandhu-chowk', label: 'Deenbandhu Chowk', pincode: '132001' },
    { value: 'gagsina', label: 'Gagsina', pincode: '132038' },
    { value: 'ghogripur', label: 'Ghogripur', pincode: '132040' },
    { value: 'indri', label: 'Indri', pincode: '132041' },
    { value: 'itawa', label: 'Itawa', pincode: '132040' },
    { value: 'jalmana', label: 'Jalmana', pincode: '132036' },
    { value: 'jundla', label: 'Jundla', pincode: '132033' },
    { value: 'kamboj-nagar', label: 'Kamboj Nagar', pincode: '132001' },
    { value: 'karnal-cooperative-society-area', label: 'Karnal Cooperative Society Area', pincode: '132001' },
    { value: 'kavi-nagar', label: 'Kavi Nagar', pincode: '132001' },
    { value: 'khera-khurd', label: 'Khera Khurd', pincode: '132001' },
    { value: 'kunjpura', label: 'Kunjpura', pincode: '132022' },
    { value: 'madhuban', label: 'Madhuban', pincode: '132001' },
    { value: 'main-bazaar', label: 'Main Bazaar', pincode: '132001' },
    { value: 'model-town', label: 'Model Town', pincode: '132001' },
    { value: 'mugal-majra', label: 'Mugal Majra', pincode: '132040' },
    { value: 'nalvi', label: 'Nalvi', pincode: '132022' },
    { value: 'namastey-chowk', label: 'Namastey Chowk', pincode: '132001' },
    { value: 'nirankari-colony', label: 'Nirankari Colony', pincode: '132001' },
    { value: 'nissing', label: 'Nissing', pincode: '132024' },
    { value: 'old-gt-road', label: 'Old GT Road', pincode: '132001' },
    { value: 'phusgarh', label: 'Phusgarh', pincode: '132001' },
    { value: 'pipli', label: 'Pipli', pincode: '132001' },
    { value: 'prem-nagar', label: 'Prem Nagar', pincode: '132001' },
    { value: 'ram-nagar', label: 'Ram Nagar', pincode: '132001' },
    { value: 'ram-thaman-village', label: 'Ram Thaman Village', pincode: '132040' },
    { value: 'ranwar', label: 'Ranwar', pincode: '132040' },
    { value: 'sector-12', label: 'Sector 12', pincode: '132001' },
    { value: 'sector-13', label: 'Sector 13', pincode: '132001' },
    { value: 'sector-14', label: 'Sector 14', pincode: '132001' },
    { value: 'sector-6', label: 'Sector 6', pincode: '132001' },
    { value: 'shakti-colony', label: 'Shakti Colony', pincode: '132001' },
    { value: 'taraori', label: 'Taraori', pincode: '132116' },
    { value: 'uchana', label: 'Uchana', pincode: '132001' },
    { value: 'village-balla', label: 'Village Balla', pincode: '132027' },
    { value: 'village-chirao', label: 'Village Chirao', pincode: '132035' },
    { value: 'village-kachhwa', label: 'Village Kachhwa', pincode: '132001' },
    { value: 'village-phurlak', label: 'Village Phurlak', pincode: '132040' },
    { value: 'village-sagga', label: 'Village Sagga', pincode: '132040' },
    { value: 'village-salwan', label: 'Village Salwan', pincode: '132046' },
    { value: 'village-taraori', label: 'Village Taraori', pincode: '132116' }
  ],

  'ambala': [
    { value: 'ambala-cantt', label: 'Ambala Cantt', pincode: '134003' },
    { value: 'ambala-city', label: 'Ambala City', pincode: '134002' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '134005' },
    { value: 'athiala', label: 'Athiala', pincode: '134203' },
    { value: 'azad-nagar', label: 'Azad Nagar', pincode: '134007' },
    { value: 'bahadurgarh', label: 'Bahadurgarh', pincode: '134507' },
    { value: 'baldev-nagar', label: 'Baldev Nagar', pincode: '134005' },
    { value: 'banwala', label: 'Banwala', pincode: '134201' },
    { value: 'banspura', label: 'Banspura', pincode: '134302' },
    { value: 'behl', label: 'Behl', pincode: '134206' },
    { value: 'bishanpura', label: 'Bishanpura', pincode: '134209' },
    { value: 'budhiana', label: 'Budhiana', pincode: '134207' },
    { value: 'chhabli', label: 'Chhabli', pincode: '134204' },
    { value: 'chhoti-line', label: 'Chhoti Line', pincode: '134003' },
    { value: 'chirri', label: 'Chirri', pincode: '134302' },
    { value: 'danoda', label: 'Danoda', pincode: '134004' },
    { value: 'dhulkot', label: 'Dhulkot', pincode: '134301' },
    { value: 'duliana', label: 'Duliana', pincode: '134207' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '134205' },
    { value: 'ghelri', label: 'Ghelri', pincode: '134302' },
    { value: 'ghakhar', label: 'Ghakhar', pincode: '134503' },
    { value: 'ghusgarhi', label: 'Ghusgarhi', pincode: '134208' },
    { value: 'govind-nagar', label: 'Govind Nagar', pincode: '134005' },
    { value: 'indu-nagar', label: 'Indu Nagar', pincode: '134007' },
    { value: 'ishtgarh', label: 'Ishtgarh', pincode: '134204' },
    { value: 'jandli', label: 'Jandli', pincode: '134003' },
    { value: 'jangpura', label: 'Jangpura', pincode: '134201' },
    { value: 'kathgarh', label: 'Kathgarh', pincode: '134203' },
    { value: 'khera', label: 'Khera', pincode: '134301' },
    { value: 'kishangarh', label: 'Kishangarh', pincode: '134005' },
    { value: 'kulari', label: 'Kulari', pincode: '134205' },
    { value: 'laxman-vihar', label: 'Laxman Vihar', pincode: '134007' },
    { value: 'mangal-bazar', label: 'Mangal Bazar', pincode: '134003' },
    { value: 'manoharpur', label: 'Manoharpur', pincode: '134208' },
    { value: 'mohali', label: 'Mohali', pincode: '134103' },
    { value: 'nalvi', label: 'Nalvi', pincode: '134208' },
    { value: 'naraingarh', label: 'Naraingarh', pincode: '134203' },
    { value: 'nehru-colony', label: 'Nehru Colony', pincode: '134007' },
    { value: 'pansara', label: 'Pansara', pincode: '134204' },
    { value: 'prem-nagar', label: 'Prem Nagar', pincode: '134004' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '134206' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '134205' },
    { value: 'rampur', label: 'Rampur', pincode: '134202' },
    { value: 'ratan-garh', label: 'Ratan Garh', pincode: '134203' },
    { value: 'sector-10', label: 'Sector 10', pincode: '134104' },
    { value: 'sector-11', label: 'Sector 11', pincode: '134104' },
    { value: 'sector-17', label: 'Sector 17', pincode: '134001' },
    { value: 'sector-9', label: 'Sector 9', pincode: '134104' },
    { value: 'shahabad', label: 'Shahabad', pincode: '134202' },
    { value: 'shivpuri', label: 'Shivpuri', pincode: '134005' },
    { value: 'sulkhani', label: 'Sulkhani', pincode: '134105' },
    { value: 'takarla', label: 'Takarla', pincode: '134304' },
    { value: 'topkhana', label: 'Topkhana', pincode: '134003' },
    { value: 'village-budhan', label: 'Village Budhan', pincode: '134205' },
    { value: 'village-kapuri', label: 'Village Kapuri', pincode: '134207' },
    { value: 'village-nanhera', label: 'Village Nanhera', pincode: '134203' },
    { value: 'village-shahpur', label: 'Village Shahpur', pincode: '134208' }
  ],
  'hisar': [
    { value: 'adampur', label: 'Adampur', pincode: '125052' },
    { value: 'aggrawal-colony-hisar', label: 'Aggarwal Colony Hisar', pincode: '125001' },
    { value: 'arya-nagar-hisar', label: 'Arya Nagar Hisar', pincode: '125001' },
    { value: 'azad-nagar-hisar', label: 'Azad Nagar Hisar', pincode: '125001' },
    { value: 'bamnoli', label: 'Bamnoli', pincode: '125121' },
    { value: 'barwala', label: 'Barwala', pincode: '125121' },
    { value: 'barwala-hisar', label: 'Barwala Hisar', pincode: '125121' },
    { value: 'bhamashah-nagar-hisar', label: 'Bhamashah Nagar Hisar', pincode: '125001' },
    { value: 'bhattu', label: 'Bhattu', pincode: '125105' },
    { value: 'bhp-colony-hisar', label: 'BHP Colony Hisar', pincode: '125005' },
    { value: 'bilaspur', label: 'Bilaspur', pincode: '125124' },
    { value: 'chirag', label: 'Chirag', pincode: '125118' },
    { value: 'dabra', label: 'Dabra', pincode: '125107' },
    { value: 'daulatpur-hisar', label: 'Daulatpur Hisar', pincode: '125005' },
    { value: 'ekta-vihar-colony-hisar', label: 'Ekta Vihar Colony Hisar', pincode: '125005' },
    { value: 'ganwa-hisar', label: 'Gangwa Hisar', pincode: '125001' },
    { value: 'helsing', label: 'Helsing', pincode: '125101' },
    { value: 'hansi', label: 'Hansi', pincode: '125033' },
    { value: 'hansi-hisar', label: 'Hansi Hisar', pincode: '125033' },
    { value: 'hisar-cantt', label: 'Hisar Cantt', pincode: '125001' },
    { value: 'hisar-cantt-hisar', label: 'Hisar Cantt Hisar', pincode: '125001' },
    { value: 'hisar-city', label: 'Hisar City', pincode: '125005' },
    { value: 'jhajjar', label: 'Jhajjar', pincode: '125001' },
    { value: 'kanwarpura', label: 'Kanwarpura', pincode: '125052' },
    { value: 'kheri', label: 'Kheri', pincode: '125056' },
    { value: 'khokhra', label: 'Khokhra', pincode: '125004' },
    { value: 'kiloi', label: 'Kiloi', pincode: '125115' },
    { value: 'krishna-nagar-hisar', label: 'Krishna Nagar Hisar', pincode: '125001' },
    { value: 'mandi', label: 'Mandi', pincode: '125004' },
    { value: 'mehta-nagar-hisar', label: 'Mehta Nagar Hisar', pincode: '125005' },
    { value: 'milakpur', label: 'Milakpur', pincode: '125004' },
    { value: 'model-town-hisar', label: 'Model Town Hisar', pincode: '125005' },
    { value: 'narwana', label: 'Narwana', pincode: '125103' },
    { value: 'narnaund', label: 'Narnaund', pincode: '125037' },
    { value: 'navdeep-colony-hisar', label: 'Navdeep Colony Hisar', pincode: '125001' },
    { value: 'nawan', label: 'Nawan', pincode: '125111' },
    { value: 'patel-nagar-hisar', label: 'Patel Nagar Hisar', pincode: '125005' },
    { value: 'phusgarh', label: 'Phusgarh', pincode: '125103' },
    { value: 'police-line-area-hisar', label: 'Police Line Area Hisar', pincode: '125001' },
    { value: 'poonia', label: 'Poonia', pincode: '125017' },
    { value: 'professor-colony-hisar', label: 'Professor Colony Hisar', pincode: '125005' },
    { value: 'rajeev-nagar-hisar', label: 'Rajeev Nagar Hisar', pincode: '125001' },
    { value: 'rahmapur', label: 'Rahmapur', pincode: '125103' },
    { value: 'rohtak', label: 'Rohtak', pincode: '125110' },
    { value: 'sadiq', label: 'Sadiq', pincode: '125110' },
    { value: 'satrod-khas-hisar', label: 'Satrod Khas Hisar', pincode: '125001' },
    { value: 'satrod-khurd-hisar', label: 'Satrod Khurd Hisar', pincode: '125001' },
    { value: 'sector-1-4-hisar', label: 'Sector 1-4 Hisar', pincode: '125005' },
    { value: 'sector-11-hisar', label: 'Sector-11 Hisar', pincode: '125005' },
    { value: 'sector-13-hisar', label: 'Sector 13 Hisar', pincode: '125005' },
    { value: 'sector-14-hisar', label: 'Sector-14 Hisar', pincode: '125005' },
    { value: 'sector-15a-hisar', label: 'Sector-15A Hisar', pincode: '125005' },
    { value: 'sector-16-hisar', label: 'Sector-16 Hisar', pincode: '125005' },
    { value: 'sector-3-hisar', label: 'Sector-3 Hisar', pincode: '125005' },
    { value: 'sector-33-hisar', label: 'Sector-33 Hisar', pincode: '125005' },
    { value: 'sector-4-hisar', label: 'Sector-4 Hisar', pincode: '125005' },
    { value: 'sector-5-hisar', label: 'Sector-5 Hisar', pincode: '125005' },
    { value: 'sector-9-hisar', label: 'Sector-9 Hisar', pincode: '125005' },
    { value: 'shahpur', label: 'Shahpur', pincode: '125010' },
    { value: 'shanti-nagar-hisar', label: 'Shanti Nagar Hisar', pincode: '125005' },
    { value: 'shastri-nagar-hisar', label: 'Shastri Nagar Hisar', pincode: '125005' },
    { value: 'shiv-colony-hisar', label: 'Shiv Colony Hisar', pincode: '125005' },
    { value: 'sungra', label: 'Sungra', pincode: '125006' },
    { value: 'surya-nagar-hisar', label: 'Surya Nagar Hisar', pincode: '125005' },
    { value: 'tobri', label: 'Tobri', pincode: '125110' },
    { value: 'tosham-road-hisar', label: 'Tosham Road Hisar', pincode: '125001' },
    { value: 'uchana', label: 'Uchana', pincode: '125001' },
    { value: 'urban-estate-ii-hisar', label: 'Urban Estate II Hisar', pincode: '125001' },
    { value: 'vikas-nagar-hisar', label: 'Vikas Nagar Hisar', pincode: '125001' },
    { value: 'village-chandana', label: 'Village Chandana', pincode: '125014' },
    { value: 'village-kachhwa', label: 'Village Kachhwa', pincode: '125001' },
    { value: 'village-kiloi', label: 'Village Kiloi', pincode: '125115' }
  ],

  'palwal': [
    { value: 'alampur', label: 'Alampur', pincode: '121103' },
    { value: 'badkhal', label: 'Badkhal', pincode: '121001' },
    { value: 'ballabgarh', label: 'Ballabgarh', pincode: '121004' },
    { value: 'bapora', label: 'Bapora', pincode: '121102' },
    { value: 'bhandore', label: 'Bhandore', pincode: '121107' },
    { value: 'chandpur', label: 'Chandpur', pincode: '121102' },
    { value: 'charora', label: 'Charora', pincode: '121103' },
    { value: 'dhanora', label: 'Dhanora', pincode: '121106' },
    { value: 'dhigawali', label: 'Dhigawali', pincode: '121104' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '121101' },
    { value: 'gadhmukteshwar', label: 'Gadhmukteshwar', pincode: '121106' },
    { value: 'gokulpur', label: 'Gokulpur', pincode: '121104' },
    { value: 'kanjhawala', label: 'Kanjhawala', pincode: '121105' },
    { value: 'kheda', label: 'Kheda', pincode: '121107' },
    { value: 'kheri', label: 'Kheri', pincode: '121101' },
    { value: 'kherli', label: 'Kherli', pincode: '121104' },
    { value: 'khatoli', label: 'Khatoli', pincode: '121105' },
    { value: 'khawaspur', label: 'Khawaspur', pincode: '121108' },
    { value: 'kishorpur', label: 'Kishorpur', pincode: '121104' },
    { value: 'manjhawali', label: 'Manjhawali', pincode: '121106' },
    { value: 'manglaur', label: 'Manglaur', pincode: '121105' },
    { value: 'matlauda', label: 'Matlauda', pincode: '121108' },
    { value: 'milakpur', label: 'Milakpur', pincode: '121108' },
    { value: 'moujpur', label: 'Moujpur', pincode: '121102' },
    { value: 'nangla', label: 'Nangla', pincode: '121107' },
    { value: 'pali', label: 'Pali', pincode: '121110' },
    { value: 'pali-babarpur', label: 'Pali Babarpur', pincode: '121110' },
    { value: 'palwal-cantt', label: 'Palwal Cantt', pincode: '121102' },
    { value: 'palwal-city', label: 'Palwal City', pincode: '121102' },
    { value: 'pataudi', label: 'Pataudi', pincode: '121109' },
    { value: 'rohadi', label: 'Rohadi', pincode: '121101' },
    { value: 'sahupura', label: 'Sahupura', pincode: '121101' },
    { value: 'shahpur', label: 'Shahpur', pincode: '121107' },
    { value: 'sikri', label: 'Sikri', pincode: '121106' },
    { value: 'siwani', label: 'Siwani', pincode: '121101' },
    { value: 'tatarpur', label: 'Tatarpur', pincode: '121109' }
  ],

  'rewari': [
    { value: 'adampur', label: 'Adampur', pincode: '123303' },
    { value: 'alipur', label: 'Alipur', pincode: '123401' },
    { value: 'bapora', label: 'Bapora', pincode: '123303' },
    { value: 'bhagatgarh', label: 'Bhagatgarh', pincode: '123401' },
    { value: 'bhiwadi', label: 'Bhiwadi', pincode: '123401' },
    { value: 'chhatta', label: 'Chhatta', pincode: '123302' },
    { value: 'dharuhera', label: 'Dharuhera', pincode: '123106' },
    { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '123401' },
    { value: 'ganaur', label: 'Ganaur', pincode: '123303' },
    { value: 'gohna', label: 'Gohna', pincode: '123102' },
    { value: 'gojra', label: 'Gojra', pincode: '123302' },
    { value: 'jhundpura', label: 'Jhundpura', pincode: '123401' },
    { value: 'kaithwas', label: 'Kaithwas', pincode: '123304' },
    { value: 'kalanaur', label: 'Kalanaur', pincode: '123302' },
    { value: 'khairthal', label: 'Khairthal', pincode: '123106' },
    { value: 'khojkipur', label: 'Khojkipur', pincode: '123303' },
    { value: 'kulheri', label: 'Kulheri', pincode: '123305' },
    { value: 'mandawar', label: 'Mandawar', pincode: '123103' },
    { value: 'mandothi', label: 'Mandothi', pincode: '123304' },
    { value: 'matani', label: 'Matani', pincode: '123302' },
    { value: 'meham', label: 'Meham', pincode: '123401' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '123304' },
    { value: 'modi-bakhtawar', label: 'Modi Bakhtawar', pincode: '123303' },
    { value: 'nangal-bavli', label: 'Nangal Bavli', pincode: '123303' },
    { value: 'nangla', label: 'Nangla', pincode: '123305' },
    { value: 'palhawas', label: 'Palhawas', pincode: '123303' },
    { value: 'pali', label: 'Pali', pincode: '123305' },
    { value: 'patli', label: 'Patli', pincode: '123103' },
    { value: 'pataudi', label: 'Pataudi', pincode: '123001' },
    { value: 'pohli', label: 'Pohli', pincode: '123305' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '123301' },
    { value: 'rewari-cantt', label: 'Rewari Cantt', pincode: '123401' },
    { value: 'rewari-city', label: 'Rewari City', pincode: '123401' },
    { value: 'safedabad', label: 'Safedabad', pincode: '123305' },
    { value: 'sikri', label: 'Sikri', pincode: '123302' },
    { value: 'sodhi', label: 'Sodhi', pincode: '123302' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '123401' },
    { value: 'tatarpur', label: 'Tatarpur', pincode: '123303' },
    { value: 'udhampur', label: 'Udhampur', pincode: '123401' },
    { value: 'village-bamnoli', label: 'Village Bamnoli', pincode: '123303' },
    { value: 'village-chirag', label: 'Village Chirag', pincode: '123118' },
    { value: 'village-ghusgarhi', label: 'Village Ghusgarhi', pincode: '123208' },
    { value: 'village-kheri', label: 'Village Kheri', pincode: '123302' },
    { value: 'village-mundahera', label: 'Village Mundahera', pincode: '123303' },
    { value: 'village-nuh', label: 'Village Nuh', pincode: '123001' },
    { value: 'village-rewari', label: 'Village Rewari', pincode: '123401' },
    { value: 'village-shahpur', label: 'Village Shahpur', pincode: '123305' }
  ],

  'bhiwani': [
    { value: 'adampur', label: 'Adampur', pincode: '127021' },
    { value: 'ajit-nagar', label: 'Ajit Nagar', pincode: '127021' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '127021' },
    { value: 'baba-nagar', label: 'Baba Nagar', pincode: '127021' },
    { value: 'badra', label: 'Badra', pincode: '127310' },
    { value: 'banda', label: 'Banda', pincode: '127028' },
    { value: 'banwari', label: 'Banwari', pincode: '127021' },
    { value: 'barnala-road', label: 'Barnala Road', pincode: '127021' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '127030' },
    { value: 'bhorkheri', label: 'Bhorkheri', pincode: '127021' },
    { value: 'bhiwani-cantt', label: 'Bhiwani Cantt', pincode: '127021' },
    { value: 'bhiwani-city', label: 'Bhiwani City', pincode: '127021' },
    { value: 'bhiwani-road', label: 'Bhiwani Road', pincode: '127021' },
    { value: 'bhood', label: 'Bhood', pincode: '127305' },
    { value: 'chhappar', label: 'Chhappar', pincode: '127021' },
    { value: 'chhibramajra', label: 'Chhibramajra', pincode: '127025' },
    { value: 'chhuchhakwas', label: 'Chhuchhakwas', pincode: '127310' },
    { value: 'dabra', label: 'Dabra', pincode: '127029' },
    { value: 'dhamani', label: 'Dhamani', pincode: '127029' },
    { value: 'dhanwasi', label: 'Dhanwasi', pincode: '127029' },
    { value: 'faridabad', label: 'Faridabad', pincode: '127021' },
    { value: 'gokul-pur', label: 'Gokul Pur', pincode: '127021' },
    { value: 'gokulpur', label: 'Gokulpur', pincode: '127021' },
    { value: 'haluwas', label: 'Haluwas', pincode: '127301' },
    { value: 'hasanpur', label: 'Hasanpur', pincode: '127310' },
    { value: 'holi-dhani', label: 'Holi Dhani', pincode: '127302' },
    { value: 'jagadhri', label: 'Jagadhri', pincode: '127030' },
    { value: 'jagmal-pur', label: 'Jagmal Pur', pincode: '127026' },
    { value: 'jhatta', label: 'Jhatta', pincode: '127021' },
    { value: 'jhojhu-khera', label: 'Jhojhu Khera', pincode: '127301' },
    { value: 'kalian', label: 'Kalian', pincode: '127307' },
    { value: 'kathura', label: 'Kathura', pincode: '127310' },
    { value: 'khera', label: 'Khera', pincode: '127027' },
    { value: 'khiroka', label: 'Khiroka', pincode: '127029' },
    { value: 'koyla', label: 'Koyla', pincode: '127029' },
    { value: 'mandi', label: 'Mandi', pincode: '127021' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '127023' },
    { value: 'nand-ram', label: 'Nand Ram', pincode: '127301' },
    { value: 'patri', label: 'Patri', pincode: '127027' },
    { value: 'pehowa', label: 'Pehowa', pincode: '127031' },
    { value: 'puranpur', label: 'Puranpur', pincode: '127309' },
    { value: 'rai-ka-bagh', label: 'Rai Ka Bagh', pincode: '127024' },
    { value: 'raikhera', label: 'Raikhera', pincode: '127027' },
    { value: 'ram-nagar', label: 'Ram Nagar', pincode: '127031' },
    { value: 'rawatsar', label: 'Rawatsar', pincode: '127306' },
    { value: 'singhana', label: 'Singhana', pincode: '127023' },
    { value: 'sultana', label: 'Sultana', pincode: '127310' },
    { value: 'taharpur', label: 'Taharpur', pincode: '127308' }
  ],

  'kurukshetra': [
    { value: 'abadi', label: 'Abadi', pincode: '136101' },
    { value: 'aligarh', label: 'Aligarh', pincode: '136109' },
    { value: 'ambernath', label: 'Ambernath', pincode: '136118' },
    { value: 'ban-jagat', label: 'Ban Jagat', pincode: '136119' },
    { value: 'bhuranpur', label: 'Bhuranpur', pincode: '136118' },
    { value: 'bhood', label: 'Bhood', pincode: '136115' },
    { value: 'chandigarh-road', label: 'Chandigarh Road', pincode: '136118' },
    { value: 'charor', label: 'Charor', pincode: '136119' },
    { value: 'chhajpur', label: 'Chhajpur', pincode: '136119' },
    { value: 'choudhary-colony', label: 'Choudhary Colony', pincode: '136102' },
    { value: 'dadupur', label: 'Dadupur', pincode: '136115' },
    { value: 'dholi', label: 'Dholi', pincode: '136110' },
    { value: 'dhurkot', label: 'Dhurkot', pincode: '136119' },
    { value: 'faridpur', label: 'Faridpur', pincode: '136108' },
    { value: 'garh-jaror', label: 'Garh Jaror', pincode: '136118' },
    { value: 'garhi', label: 'Garhi', pincode: '136115' },
    { value: 'gita-bhavan', label: 'Gita Bhavan', pincode: '136118' },
    { value: 'gurgaon-road', label: 'Gurgaon Road', pincode: '136118' },
    { value: 'halena', label: 'Halena', pincode: '136119' },
    { value: 'jagadhari', label: 'Jagadhari', pincode: '136118' },
    { value: 'kailash-pur', label: 'Kailash Pur', pincode: '136115' },
    { value: 'karkhana', label: 'Karkhana', pincode: '136119' },
    { value: 'kiran-khera', label: 'Kiran Khera', pincode: '136115' },
    { value: 'kkr-vihar', label: 'KKR Vihar', pincode: '136105' },
    { value: 'kosli', label: 'Kosli', pincode: '136118' },
    { value: 'kuchpura', label: 'Kuchpura', pincode: '136119' },
    { value: 'madlauda', label: 'Madlauda', pincode: '136119' },
    { value: 'mahendra-colony', label: 'Mahendra Colony', pincode: '136118' },
    { value: 'manohar-pur', label: 'Manohar Pur', pincode: '136119' },
    { value: 'mehsana', label: 'Mehsana', pincode: '136118' },
    { value: 'mohammadpur', label: 'Mohammad Pur', pincode: '136119' },
    { value: 'mohna', label: 'Mohna', pincode: '136118' },
    { value: 'model-town', label: 'Model Town', pincode: '136119' },
    { value: 'new-pur', label: 'New Pur', pincode: '136118' },
    { value: 'pali', label: 'Pali', pincode: '136119' },
    { value: 'patri', label: 'Patri', pincode: '136115' },
    { value: 'raipur', label: 'Raipur', pincode: '136115' },
    { value: 'raipur-kalan', label: 'Raipur Kalan', pincode: '136118' },
    { value: 'ranjha', label: 'Ranjha', pincode: '136106' },
    { value: 'sahadeo', label: 'Sahadeo', pincode: '136119' },
    { value: 'saini', label: 'Saini', pincode: '136115' },
    { value: 'shahpur', label: 'Shahpur', pincode: '136119' },
    { value: 'sonpura', label: 'Sonpura', pincode: '136118' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '136107' },
    { value: 'suryapuri', label: 'Suryapuri', pincode: '136119' },
    { value: 'sushant-colony', label: 'Sushant Colony', pincode: '136104' },
    { value: 'titiksha', label: 'Titiksha', pincode: '136118' },
    { value: 'vishnu-pur', label: 'Vishnu Pur', pincode: '136119' }
  ],

  'sirsa': [
    { value: 'agroha-nagar', label: 'Agroha Nagar', pincode: '125055' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '125055' },
    { value: 'barnala-road', label: 'Barnala Road', pincode: '125055' },
    { value: 'bishnoi-mandir-area', label: 'Bishnoi Mandir Area', pincode: '125055' },
    { value: 'bypass-road', label: 'Bypass Road', pincode: '125055' },
    { value: 'chautala-road', label: 'Chautala Road', pincode: '125055' },
    { value: 'darbi', label: 'Darbi', pincode: '125055' },
    { value: 'devinagar', label: 'Devinagar', pincode: '125055' },
    { value: 'friends-colony', label: 'Friends Colony', pincode: '125055' },
    { value: 'gurunanak-nagar', label: 'Guru Nanak Nagar', pincode: '125055' },
    { value: 'huda-sector-19', label: 'HUDA Sector 19', pincode: '125055' },
    { value: 'huda-sector-20', label: 'HUDA Sector 20', pincode: '125055' },
    { value: 'industrial-area', label: 'Industrial Area', pincode: '125055' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '125055' },
    { value: 'kangan-pur-road', label: 'Kangan Pur Road', pincode: '125055' },
    { value: 'kharian-road', label: 'Kharian Road', pincode: '125055' },
    { value: 'mohana-road', label: 'Mohana Road', pincode: '125055' },
    { value: 'model-town', label: 'Model Town', pincode: '125055' },
    { value: 'nehru-colony', label: 'Nehru Colony', pincode: '125055' },
    { value: 'new-housing-board-colony', label: 'New Housing Board Colony', pincode: '125055' },
    { value: 'old-court-road', label: 'Old Court Road', pincode: '125055' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '125055' },
    { value: 'prem-nagar', label: 'Prem Nagar', pincode: '125055' },
    { value: 'rania-road', label: 'Rania Road', pincode: '125055' },
    { value: 'rohtak-road', label: 'Rohtak Road', pincode: '125055' },
    { value: 'shastri-colony', label: 'Shastri Colony', pincode: '125055' },
    { value: 'sirsa-town', label: 'Sirsa Town', pincode: '125055' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '125055' },
    { value: 'urban-estate', label: 'Urban Estate', pincode: '125055' },
    { value: 'vidhya-nagar', label: 'Vidhya Nagar', pincode: '125055' },
    { value: 'yogi-nagar', label: 'Yogi Nagar', pincode: '125055' }
  ],

  'jind': [
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '126102' },
    { value: 'bishan-sarup-colony', label: 'Bishan Sarup Colony', pincode: '126102' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '126102' },
    { value: 'devnagar', label: 'Devnagar', pincode: '126112' },
    { value: 'ghir', label: 'Ghir', pincode: '126103' },
    { value: 'haibowal', label: 'Haibowal', pincode: '126114' },
    { value: 'huda-sector-11', label: 'HUDA Sector 11', pincode: '126110' },
    { value: 'huda-sector-6', label: 'HUDA Sector 6', pincode: '126102' },
    { value: 'indira-colony', label: 'Indira Colony', pincode: '126110' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '126102' },
    { value: 'model-town', label: 'Model Town', pincode: '126102' },
    { value: 'nehru-colony', label: 'Nehru Colony', pincode: '126110' },
    { value: 'raja-garden', label: 'Raja Garden', pincode: '126102' },
    { value: 'rajgarh-road', label: 'Rajgarh Road', pincode: '126103' },
    { value: 'rohtak-road', label: 'Rohtak Road', pincode: '126103' },
    { value: 'safidon-road', label: 'Safidon Road', pincode: '126110' },
    { value: 'shiv-colony', label: 'Shiv Colony', pincode: '126112' },
    { value: 'urban-estate', label: 'Urban Estate', pincode: '126102' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '126110' },
    { value: 'vivekanand-colony', label: 'Vivekanand Colony', pincode: '126102' },
    { value: 'ward-6', label: 'Ward 6', pincode: '126103' },
    { value: 'ward-8', label: 'Ward 8', pincode: '126102' }
  ],

//haryana areas
'yamuna-nagar': [
  { value: 'adhoiwala', label: 'Adhoiwala', pincode: '135103' },
  { value: 'barauli', label: 'Barauli', pincode: '135003' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '135102' },
  { value: 'buria', label: 'Buria', pincode: '135101' },
  { value: 'camp area', label: 'Camp Area', pincode: '135001' },
  { value: 'chhachhrauli', label: 'Chhachhrauli', pincode: '135103' },
  { value: 'dayalgarh', label: 'Dayalgarh', pincode: '135102' },
  { value: 'farakpur', label: 'Farakpur', pincode: '135001' },
  { value: 'gobindpuri', label: 'Gobindpuri', pincode: '135002' },
  { value: 'gogarpur', label: 'Gogarpur', pincode: '135101' },
  { value: 'haryana colony', label: 'Haryana Colony', pincode: '135001' },
  { value: 'jagadhri', label: 'Jagadhri', pincode: '135003' },
  { value: 'jaloli', label: 'Jaloli', pincode: '135021' },
  { value: 'kala amb', label: 'Kala Amb', pincode: '135001' },
  { value: 'karnal road', label: 'Karnal Road', pincode: '135001' },
  { value: 'khizrabad', label: 'Khizrabad', pincode: '135106' },
  { value: 'manakpur', label: 'Manakpur', pincode: '135003' },
  { value: 'model town', label: 'Model Town', pincode: '135001' },
  { value: 'mustafabad', label: 'Mustafabad', pincode: '133103' },
  { value: 'pratap nagar', label: 'Pratap Nagar', pincode: '135103' },
  { value: 'radour', label: 'Radour', pincode: '135133' },
  { value: 'rampura', label: 'Rampura', pincode: '135002' },
  { value: 'sabzi mandi', label: 'Sabzi Mandi', pincode: '135001' },
  { value: 'sarswati nagar', label: 'Sarswati Nagar', pincode: '135101' },
  { value: 'shahbad', label: 'Shahbad', pincode: '135135' },
  { value: 'tepla', label: 'Tepla', pincode: '135102' },
  { value: 'vishal nagar', label: 'Vishal Nagar', pincode: '135001' },
  { value: 'yarn market', label: 'Yarn Market', pincode: '135001' }
  ],

'bawal': [
  { value: 'ajnawas', label: 'Ajnawas', pincode: '123501' },
  { value: 'bawal-industrial-area', label: 'Bawal Industrial Area', pincode: '123501' },
  { value: 'bawal-town', label: 'Bawal Town', pincode: '123501' },
  { value: 'bhandor', label: 'Bhandor', pincode: '123503' },
  { value: 'dungerwas', label: 'Dungerwas', pincode: '123506' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jangla-village', label: 'Jangla Village', pincode: '123506' },
  { value: 'kanhaiya-vihar', label: 'Kanhaiya Vihar', pincode: '123502' },
  { value: 'kharkhara', label: 'Kharkhara', pincode: '123503' },
  { value: 'kund', label: 'Kund', pincode: '123507' },
  { value: 'malpura', label: 'Malpura', pincode: '123508' },
  { value: 'rai-singh-nagar', label: 'Rai Singh Nagar', pincode: '123503' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '123509' },
  { value: 'sangwari', label: 'Sangwari', pincode: '123502' },
  { value: 'shakti-nagar', label: 'Shakti Nagar', pincode: '123504' },
  { value: 'shiv-colony', label: 'Shiv Colony', pincode: '123505' },
  { value: 'suthana', label: 'Suthana', pincode: '123510' },
  { value: 'tikli', label: 'Tikli', pincode: '123511' },
  { value: 'uthrala', label: 'Uthrala', pincode: '123512' }
  ],

  'bawani-khera': [
  { value: 'bawani-khera-town', label: 'Bawani Khera Town', pincode: '127032' },
  { value: 'biran', label: 'Biran', pincode: '127035' },
  { value: 'dhanana', label: 'Dhanana', pincode: '127029' },
  { value: 'dighal', label: 'Dighal', pincode: '127111' },
  { value: 'gahri', label: 'Gahri', pincode: '127046' },
  { value: 'ghatakhera', label: 'Ghatakhera', pincode: '127047' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jamalpur', label: 'Jamalpur', pincode: '127041' },
  { value: 'kachrouli', label: 'Kachrouli', pincode: '127036' },
  { value: 'kharak-kalan', label: 'Kharak Kalan', pincode: '127114' },
  { value: 'kharak-ramji', label: 'Kharak Ramji', pincode: '127114' },
  { value: 'kundi', label: 'Kundi', pincode: '127045' },
  { value: 'mandhana', label: 'Mandhana', pincode: '127050' },
  { value: 'nandha', label: 'Nandha', pincode: '127043' },
  { value: 'ramalwas', label: 'Ramalwas', pincode: '127038' },
  { value: 'rohilla', label: 'Rohilla', pincode: '127031' },
  { value: 'sarsa', label: 'Sarsa', pincode: '127048' },
  { value: 'sishwala', label: 'Sishwala', pincode: '127039' },
  { value: 'sorda', label: 'Sorda', pincode: '127030' },
  { value: 'udaipur', label: 'Udaipur', pincode: '127037' },
  { value: 'viran', label: 'Viran', pincode: '127051' }
  ],

  'chhachhrauli': [
  { value: 'amadalpur', label: 'Amadalpur', pincode: '135103' },
  { value: 'banhera', label: 'Banhera', pincode: '135104' },
  { value: 'bataur', label: 'Bataur', pincode: '135105' },
  { value: 'chakarpur', label: 'Chakarpur', pincode: '135103' },
  { value: 'chhachhrauli-town', label: 'Chhachhrauli Town', pincode: '135103' },
  { value: 'darwa', label: 'Darwa', pincode: '135106' },
  { value: 'harnol', label: 'Harnol', pincode: '135102' },
  { value: 'juddi', label: 'Juddi', pincode: '135103' },
  { value: 'kachnore', label: 'Kachnore', pincode: '135107' },
  { value: 'kalesar', label: 'Kalesar', pincode: '135106' },
  { value: 'kalyana', label: 'Kalyana', pincode: '135108' },
  { value: 'khandwa', label: 'Khandwa', pincode: '135105' },
  { value: 'mahiyari', label: 'Mahiyari', pincode: '135103' },
  { value: 'manakpur', label: 'Manakpur', pincode: '135104' },
  { value: 'nahra', label: 'Nahra', pincode: '135103' },
  { value: 'nathauri', label: 'Nathauri', pincode: '135103' },
  { value: 'panchmukhi', label: 'Panchmukhi', pincode: '135105' },
  { value: 'rampur', label: 'Rampur', pincode: '135103' },
  { value: 'sarawan', label: 'Sarawan', pincode: '135102' },
  { value: 'sugh', label: 'Sugh', pincode: '135106' },
  { value: 'sukhpur', label: 'Sukhpur', pincode: '135109' },
  { value: 'tapu-khera', label: 'Tapu Khera', pincode: '135104' },
  { value: 'tibbi', label: 'Tibbi', pincode: '135103' },
  { value: 'uddhamgarh', label: 'Uddhamgarh', pincode: '135110' },
  { value: 'yara', label: 'Yara', pincode: '135111' }
  ],

  'hathin': [
  { value: 'alaipur', label: 'Alaipur', pincode: '121103' },
  { value: 'andhop', label: 'Andhop', pincode: '121106' },
  { value: 'badarpur', label: 'Badarpur', pincode: '121115' },
  { value: 'bamani-khera', label: 'Bamani Khera', pincode: '121109' },
  { value: 'bhiduki', label: 'Bhiduki', pincode: '121104' },
  { value: 'chakri', label: 'Chakri', pincode: '121105' },
  { value: 'deeg', label: 'Deeg', pincode: '121104' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'gorauta', label: 'Gorauta', pincode: '121107' },
  { value: 'hathin-town', label: 'Hathin Town', pincode: '121103' },
  { value: 'jalhaka', label: 'Jalhaka', pincode: '121102' },
  { value: 'kithwari', label: 'Kithwari', pincode: '121108' },
  { value: 'ladamka', label: 'Ladamka', pincode: '121116' },
  { value: 'mandkola', label: 'Mandkola', pincode: '121102' },
  { value: 'mewli', label: 'Mewli', pincode: '121110' },
  { value: 'mirzapur', label: 'Mirzapur', pincode: '121111' },
  { value: 'nangal', label: 'Nangal', pincode: '121113' },
  { value: 'panchgaon', label: 'Panchgaon', pincode: '121111' },
  { value: 'raipur', label: 'Raipur', pincode: '121105' },
  { value: 'rakhota', label: 'Rakhota', pincode: '121106' },
  { value: 'ronija', label: 'Ronija', pincode: '121112' },
  { value: 'sehsola', label: 'Sehsola', pincode: '121109' },
  { value: 'sikrona', label: 'Sikrona', pincode: '121107' },
  { value: 'sirohi', label: 'Sirohi', pincode: '121113' },
  { value: 'uthan', label: 'Uthan', pincode: '121115' },
  { value: 'zingla', label: 'Zingla', pincode: '121114' }
  ],

  'kardhan': [
  { value: 'akhbarpur', label: 'Akhbarpur', pincode: '134203' },
  { value: 'badsui', label: 'Badsui', pincode: '134204' },
  { value: 'balaur', label: 'Balaur', pincode: '134202' },
  { value: 'chakarpur', label: 'Chakarpur', pincode: '134206' },
  { value: 'darwa', label: 'Darwa', pincode: '134209' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kalsi', label: 'Kalsi', pincode: '134203' },
  { value: 'kardhan-town', label: 'Kardhan Town', pincode: '134203' },
  { value: 'karsan', label: 'Karsan', pincode: '134205' },
  { value: 'mandlai', label: 'Mandlai', pincode: '134207' },
  { value: 'mohan-nagar', label: 'Mohan Nagar', pincode: '134204' },
  { value: 'nandiali', label: 'Nandiali', pincode: '134206' },
  { value: 'narayangarh', label: 'Narayangarh', pincode: '134203' },
  { value: 'palka', label: 'Palka', pincode: '134208' },
  { value: 'rajouli', label: 'Rajouli', pincode: '134202' },
  { value: 'sahjra', label: 'Sahjra', pincode: '134210' },
  { value: 'sherpur', label: 'Sherpur', pincode: '134209' },
  { value: 'sukhdarshan-nagar', label: 'Sukhdarshan Nagar', pincode: '134205' },
  { value: 'tundli', label: 'Tundli', pincode: '134204' },
  { value: 'udhampur', label: 'Udhampur', pincode: '134211' }
  ],

  'loharu': [
  { value: 'bahal', label: 'Bahal', pincode: '127201' },
  { value: 'bariwas', label: 'Bariwas', pincode: '127102' },
  { value: 'birsinghpur', label: 'Birsinghpur', pincode: '127003' },
  { value: 'chandpur', label: 'Chandpur', pincode: '127301' },
  { value: 'jahanpur', label: 'Jahanpur', pincode: '127307' },
  { value: 'kalka', label: 'Kalka', pincode: '127001' },
  { value: 'lohgarh', label: 'Lohgarh', pincode: '127304' },
  { value: 'loharu-town', label: 'Loharu Town', pincode: '127201' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '127206' },
  { value: 'nangal', label: 'Nangal', pincode: '127205' },
  { value: 'palra', label: 'Palra', pincode: '127309' },
  { value: 'sahuwas', label: 'Sahuwas', pincode: '127204' },
  { value: 'sultanpur', label: 'Sultanpur', pincode: '127306' },
  { value: 'tapa', label: 'Tapa', pincode: '127305' },
  { value: 'umarwas', label: 'Umarwas', pincode: '127302' },
  { value: 'vishwas', label: 'Vishwas', pincode: '127303' }
  ],

  'sasauli': [
  { value: 'alipur', label: 'Alipur', pincode: '127022' },
  { value: 'bariwas', label: 'Bariwas', pincode: '127105' },
  { value: 'chandpur', label: 'Chandpur', pincode: '127103' },
  { value: 'dholera', label: 'Dholera', pincode: '127108' },
  { value: 'ghaggar', label: 'Ghaggar', pincode: '127112' },
  { value: 'kali', label: 'Kali', pincode: '127110' },
  { value: 'khalilpur', label: 'Khalilpur', pincode: '127116' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '127107' },
  { value: 'nangal', label: 'Nangal', pincode: '127104' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '127114' },
  { value: 'sasauli-town', label: 'Sasauli Town', pincode: '127120' },
  { value: 'sulaipur', label: 'Sulaipur', pincode: '127109' },
  { value: 'tapa', label: 'Tapa', pincode: '127106' },
  { value: 'vasundhara', label: 'Vasundhara', pincode: '127115' },
  { value: 'village-panchayat', label: 'Village Panchayat', pincode: '127113' }
  ],

  'siwani': [
  { value: 'bahal', label: 'Bahal', pincode: '127021' },
  { value: 'bariwas', label: 'Bariwas', pincode: '127105' },
  { value: 'chandpur', label: 'Chandpur', pincode: '127113' },
  { value: 'dholera', label: 'Dholera', pincode: '127107' },
  { value: 'ghaggar', label: 'Ghaggar', pincode: '127118' },
  { value: 'kali', label: 'Kali', pincode: '127110' },
  { value: 'khalilpur', label: 'Khalilpur', pincode: '127116' },
  { value: 'kherdi', label: 'Kherdi', pincode: '127111' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '127106' },
  { value: 'nangal', label: 'Nangal', pincode: '127115' },
  { value: 'pabuwas', label: 'Pabuwas', pincode: '127119' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '127114' },
  { value: 'siwani-town', label: 'Siwani Town', pincode: '127046' },
  { value: 'sulaipur', label: 'Sulaipur', pincode: '127109' },
  { value: 'tapa', label: 'Tapa', pincode: '127107' },
  { value: 'vishwas', label: 'Vishwas', pincode: '127119' },
  { value: 'wanwari', label: 'Wanwari', pincode: '127120' },
  { value: 'zainpur', label: 'Zainpur', pincode: '127112' }
  ],

  'tauru': [
  { value: 'adampur', label: 'Adampur', pincode: '122018' },
  { value: 'bariwas', label: 'Bariwas', pincode: '122102' },
  { value: 'chandpur', label: 'Chandpur', pincode: '122102' },
  { value: 'dholera', label: 'Dholera', pincode: '122107' },
  { value: 'ghaggar', label: 'Ghaggar', pincode: '122116' },
  { value: 'kali', label: 'Kali', pincode: '122105' },
  { value: 'khera', label: 'Khera', pincode: '122106' },
  { value: 'kushkhera', label: 'Kushkhera', pincode: '122119' },
  { value: 'lohara', label: 'Lohara', pincode: '122110' },
  { value: 'madhogarh', label: 'Madhogarh', pincode: '122107' },
  { value: 'nangal', label: 'Nangal', pincode: '122104' },
  { value: 'pabuwas', label: 'Pabuwas', pincode: '122109' },
  { value: 'palra', label: 'Palra', pincode: '122103' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '122112' },
  { value: 'siwani', label: 'Siwani', pincode: '122115' },
  { value: 'tauru-town', label: 'Tauru Town', pincode: '122001' },
  { value: 'tapa', label: 'Tapa', pincode: '122105' },
  { value: 'vishwas', label: 'Vishwas', pincode: '122113' },
  { value: 'wanwari', label: 'Wanwari', pincode: '122120' },
  { value: 'zainpur', label: 'Zainpur', pincode: '122117' }
  ],

  'kaithal': [
    { value: 'adampur', label: 'Adampur', pincode: '136027' },
    { value: 'banwala', label: 'Banwala', pincode: '136027' },
    { value: 'bhaini', label: 'Bhaini', pincode: '136027' },
    { value: 'birsinghpur', label: 'Birsinghpur', pincode: '136027' },
    { value: 'chandpura', label: 'Chandpura', pincode: '136027' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jagadhri', label: 'Jagadhri', pincode: '135003' },
    { value: 'kaithal-bazar', label: 'Kaithal Bazar', pincode: '136027' },
    { value: 'kharak', label: 'Kharak', pincode: '136027' },
    { value: 'malkheri', label: 'Malkheri', pincode: '136027' },
    { value: 'manheru', label: 'Manheru', pincode: '136027' },
    { value: 'nukra', label: 'Nukra', pincode: '136027' },
    { value: 'piplanwali', label: 'Piplanwali', pincode: '136027' },
    { value: 'rajound', label: 'Rajound', pincode: '136027' },
    { value: 'sadalpur', label: 'Sadalpur', pincode: '136027' },
    { value: 'sangwan', label: 'Sangwan', pincode: '136027' },
    { value: 'sirsal', label: 'Sirsal', pincode: '136027' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '136027' },
    { value: 'tehur', label: 'Tehur', pincode: '136027' },
    { value: 'khudda', label: 'Khudda', pincode: '136027' },
    { value: 'loharan', label: 'Loharan', pincode: '136027' },
    { value: 'machhiwara', label: 'Machhiwara', pincode: '136027' },
    { value: 'rajuwas', label: 'Rajuwas', pincode: '136027' },
    { value: 'rukhi', label: 'Rukhi', pincode: '136027' },
    { value: 'shahpur', label: 'Shahpur', pincode: '136027' },
    { value: 'udail', label: 'Udail', pincode: '136027' },
    { value: 'wazidpur', label: 'Wazidpur', pincode: '136027' }
    ],

      'panchkula': [
    { value: 'agroha', label: 'Agroha', pincode: '134114' },
    { value: 'badheri', label: 'Badheri', pincode: '134113' },
    { value: 'baldevnagar', label: 'Baldev Nagar', pincode: '134109' },
    { value: 'chandimandir', label: 'Chandimandir', pincode: '134107' },
    { value: 'dharampur', label: 'Dharampur', pincode: '134107' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kalu-ram', label: 'Kalu Ram', pincode: '134113' },
    { value: 'kandri', label: 'Kandri', pincode: '134113' },
    { value: 'manimajra', label: 'Manimajra', pincode: '160101' },
    { value: 'matour', label: 'Matour', pincode: '134114' },
    { value: 'mohali', label: 'Mohali', pincode: '140301' },
    { value: 'panchkula-bazar', label: 'Panchkula Bazar', pincode: '134102' },
    { value: 'raipur-kalan', label: 'Raipur Kalan', pincode: '134113' },
    { value: 'sector-10', label: 'Sector 10', pincode: '134109' },
    { value: 'sector-11', label: 'Sector 11', pincode: '134113' },
    { value: 'sector-12', label: 'Sector 12', pincode: '134112' },
    { value: 'sector-14', label: 'Sector 14', pincode: '134114' },
    { value: 'sector-15', label: 'Sector 15', pincode: '134113' },
    { value: 'sector-16', label: 'Sector 16', pincode: '134114' },
    { value: 'sector-17', label: 'Sector 17', pincode: '134107' },
    { value: 'sector-18', label: 'Sector 18', pincode: '134107' },
    { value: 'sector-19', label: 'Sector 19', pincode: '134103' },
    { value: 'sector-20', label: 'Sector 20', pincode: '134104' },
    { value: 'sector-21', label: 'Sector 21', pincode: '134113' },
    { value: 'sector-22', label: 'Sector 22', pincode: '134105' },
    { value: 'sector-23', label: 'Sector 23', pincode: '134106' },
    { value: 'sector-25', label: 'Sector 25', pincode: '134111' },
    { value: 'sector-26', label: 'Sector 26', pincode: '134113' },
    { value: 'sector-27', label: 'Sector 27', pincode: '134106' },
    { value: 'sector-28', label: 'Sector 28', pincode: '134107' },
    { value: 'sector-29', label: 'Sector 29', pincode: '134107' },
    { value: 'kaushik-colony', label: 'Kaushik Colony', pincode: '134109' },
    { value: 'khera', label: 'Khera', pincode: '134103' },
    { value: 'neelam-bahadur', label: 'Neelam Bahadur', pincode: '134109' },
    { value: 'ranjit-nagar', label: 'Ranjit Nagar', pincode: '134104' },
    { value: 'sector-31', label: 'Sector 31', pincode: '134115' },
    { value: 'sector-32', label: 'Sector 32', pincode: '134116' },
    { value: 'sector-33', label: 'Sector 33', pincode: '134117' }
    ],
  
    'thanesar': [
    { value: 'ambala-road', label: 'Ambala Road', pincode: '136118' },
    { value: 'barna', label: 'Barna', pincode: '136119' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '136118' },
    { value: 'chota-bazar', label: 'Chota Bazar', pincode: '136118' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '136118' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'gtb-colony', label: 'GTB Colony', pincode: '136118' },
    { value: 'jyotisar', label: 'Jyotisar', pincode: '136119' },
    { value: 'madhuban-colony', label: 'Madhuban Colony', pincode: '136118' },
    { value: 'model-town', label: 'Model Town', pincode: '136118' },
    { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '136118' },
    { value: 'old-town', label: 'Old Town', pincode: '136118' },
    { value: 'pehowa', label: 'Pehowa', pincode: '136128' },
    { value: 'rishi-nagar', label: 'Rishi Nagar', pincode: '136118' },
    { value: 'shiv-colony', label: 'Shiv Colony', pincode: '136118' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '136118' },
    { value: 'umri', label: 'Umri', pincode: '136131' },
    { value: 'urban-estate', label: 'Urban Estate', pincode: '136118' }
    ],
  
    'jagadhri': [
    { value: 'adhoiwala', label: 'Adhoiwala', pincode: '135003' },
    { value: 'ambala-road', label: 'Ambala Road', pincode: '135003' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '135003' },
    { value: 'badi-line', label: 'Badi Line', pincode: '135003' },
    { value: 'badi-majra', label: 'Badi Majra', pincode: '135101' },
    { value: 'basant-nagar', label: 'Basant Nagar', pincode: '135003' },
    { value: 'bhopa-road', label: 'Bhopa Road', pincode: '135003' },
    { value: 'chhoti-line', label: 'Chhoti Line', pincode: '135003' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '135003' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '135101' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '135003' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'gopi-nagar', label: 'Gopi Nagar', pincode: '135003' },
    { value: 'hanuman-colony', label: 'Hanuman Colony', pincode: '135003' },
    { value: 'industrial-area', label: 'Industrial Area', pincode: '135001' },
    { value: 'jain-colony', label: 'Jain Colony', pincode: '135003' },
    { value: 'kalanour', label: 'Kalanour', pincode: '135001' },
    { value: 'khanpur', label: 'Khanpur', pincode: '135101' },
    { value: 'khanpur-khurd', label: 'Khanpur Khurd', pincode: '135101' },
    { value: 'model-town', label: 'Model Town', pincode: '135003' },
    { value: 'nehru-park', label: 'Nehru Park', pincode: '135003' },
    { value: 'panchayat-bhavan', label: 'Panchayat Bhavan', pincode: '135003' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '135003' },
    { value: 'preet-nagar', label: 'Preet Nagar', pincode: '135003' },
    { value: 'railway-road', label: 'Railway Road', pincode: '135003' },
    { value: 'rampura', label: 'Rampura', pincode: '135003' },
    { value: 'roop-nagar', label: 'Roop Nagar', pincode: '135003' },
    { value: 'saraswati-vihar', label: 'Saraswati Vihar', pincode: '135003' },
    { value: 'shanti-colony', label: 'Shanti Colony', pincode: '135003' },
    { value: 'shivaji-colony', label: 'Shivaji Colony', pincode: '135003' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '135101' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '135003' },
    { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '135003' },
    { value: 'yamunanagar-road', label: 'Yamunanagar Road', pincode: '135003' }
    ],
    
    'narnaul': [
    { value: 'adampur', label: 'Adampur', pincode: '123001' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '123001' },
    { value: 'bada-bazaar', label: 'Bada Bazaar', pincode: '123001' },
    { value: 'bhagat-singh-colony', label: 'Bhagat Singh Colony', pincode: '123001' },
    { value: 'bus-stand-area', label: 'Bus Stand Area', pincode: '123001' },
    { value: 'charkhi-road', label: 'Charkhi Road', pincode: '123001' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '123001' },
    { value: 'dhobi-ghat', label: 'Dhobi Ghat', pincode: '123001' },
    { value: 'fateh-nagar', label: 'Fateh Nagar', pincode: '123001' },
    { value: 'ganpati-colony', label: 'Ganpati Colony', pincode: '123001' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '123001' },
    { value: 'indira-colony', label: 'Indira Colony', pincode: '123001' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '123001' },
    { value: 'kanina-road', label: 'Kanina Road', pincode: '123001' },
    { value: 'kath-mandi', label: 'Kath Mandi', pincode: '123001' },
    { value: 'mahavir-chowk', label: 'Mahavir Chowk', pincode: '123001' },
    { value: 'mahendragarh-road', label: 'Mahendragarh Road', pincode: '123001' },
    { value: 'mandi-area', label: 'Mandi Area', pincode: '123001' },
    { value: 'model-town', label: 'Model Town', pincode: '123001' },
    { value: 'mohindergarh-chowk', label: 'Mohindergarh Chowk', pincode: '123001' },
    { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '123001' },
    { value: 'new-bus-stand', label: 'New Bus Stand', pincode: '123001' },
    { value: 'punjab-colony', label: 'Punjab Colony', pincode: '123001' },
    { value: 'railway-colony', label: 'Railway Colony', pincode: '123001' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '123001' },
    { value: 'roop-basant-colony', label: 'Roop Basant Colony', pincode: '123001' },
    { value: 'sadar-bazaar', label: 'Sadar Bazaar', pincode: '123001' },
    { value: 'sarai-qila', label: 'Sarai Qila', pincode: '123001' },
    { value: 'shanti-nagar', label: 'Shanti Nagar', pincode: '123001' },
    { value: 'shiv-colony', label: 'Shiv Colony', pincode: '123001' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '123001' },
    { value: 'vishwakarma-nagar', label: 'Vishwakarma Nagar', pincode: '123001' },
    { value: 'yadav-nagar', label: 'Yadav Nagar', pincode: '123001' }
    ],
  
    'hansi': [
    { value: 'adampur-road', label: 'Adampur Road', pincode: '125033' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '125033' },
    { value: 'bada-bazaar', label: 'Bada Bazaar', pincode: '125033' },
    { value: 'baldev-nagar', label: 'Baldev Nagar', pincode: '125033' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '125033' },
    { value: 'bhagat-singh-colony', label: 'Bhagat Singh Colony', pincode: '125033' },
    { value: 'bus-stand-area', label: 'Bus Stand Area', pincode: '125033' },
    { value: 'chota-bazaar', label: 'Chota Bazaar', pincode: '125033' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '125033' },
    { value: 'dabra-road', label: 'Dabra Road', pincode: '125033' },
    { value: 'dev-nagar', label: 'Dev Nagar', pincode: '125033' },
    { value: 'ganesh-nagar', label: 'Ganesh Nagar', pincode: '125033' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '125033' },
    { value: 'indira-colony', label: 'Indira Colony', pincode: '125033' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '125033' },
    { value: 'kanwari-road', label: 'Kanwari Road', pincode: '125033' },
    { value: 'krishna-colony', label: 'Krishna Colony', pincode: '125033' },
    { value: 'mahavir-colony', label: 'Mahavir Colony', pincode: '125033' },
    { value: 'model-town', label: 'Model Town', pincode: '125033' },
    { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '125033' },
    { value: 'new-hansi-town', label: 'New Hansi Town', pincode: '125033' },
    { value: 'old-bus-stand', label: 'Old Bus Stand', pincode: '125033' },
    { value: 'panchayat-bhavan', label: 'Panchayat Bhavan', pincode: '125033' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '125033' },
    { value: 'preet-nagar', label: 'Preet Nagar', pincode: '125033' },
    { value: 'railway-road', label: 'Railway Road', pincode: '125033' },
    { value: 'ram-nagar', label: 'Ram Nagar', pincode: '125033' },
    { value: 'sadar-bazaar', label: 'Sadar Bazaar', pincode: '125033' },
    { value: 'saraswati-colony', label: 'Saraswati Colony', pincode: '125033' },
    { value: 'sector-6', label: 'Sector 6', pincode: '125033' },
    { value: 'sector-8', label: 'Sector 8', pincode: '125033' },
    { value: 'shanti-nagar', label: 'Shanti Nagar', pincode: '125033' },
    { value: 'shiv-colony', label: 'Shiv Colony', pincode: '125033' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '125033' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '125033' },
    { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '125033' },
    { value: 'yadav-colony', label: 'Yadav Colony', pincode: '125033' },
    { value: 'yadav-nagar', label: 'Yadav Nagar', pincode: '125033' }
    ],
  
    'fatehabad': [
    { value: 'aggarwal-colony', label: 'Aggarwal Colony', pincode: '125050' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '125050' },
    { value: 'baba-nagar', label: 'Baba Nagar', pincode: '125050' },
    { value: 'bajigar-colony', label: 'Bajigar Colony', pincode: '125050' },
    { value: 'bansal-colony', label: 'Bansal Colony', pincode: '125050' },
    { value: 'bhagwan-nagar', label: 'Bhagwan Nagar', pincode: '125050' },
    { value: 'bhodia-khera', label: 'Bhodia Khera', pincode: '125050' },
    { value: 'bhuna-road', label: 'Bhuna Road', pincode: '125050' },
    { value: 'bus-stand-area', label: 'Bus Stand Area', pincode: '125050' },
    { value: 'chandigarh-road', label: 'Chandigarh Road', pincode: '125050' },
    { value: 'chandni-bagh', label: 'Chandni Bagh', pincode: '125050' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '125050' },
    { value: 'dev-nagar', label: 'Dev Nagar', pincode: '125050' },
    { value: 'fouji-colony', label: 'Fouji Colony', pincode: '125050' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'gurukul-road', label: 'Gurukul Road', pincode: '125050' },
    { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '125050' },
    { value: 'indira-colony', label: 'Indira Colony', pincode: '125050' },
    { value: 'janta-colony', label: 'Janta Colony', pincode: '125050' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '125050' },
    { value: 'kailash-nagar', label: 'Kailash Nagar', pincode: '125050' },
    { value: 'kamla-nagar', label: 'Kamla Nagar', pincode: '125050' },
    { value: 'krishna-nagar', label: 'Krishna Nagar', pincode: '125050' },
    { value: 'mahaveer-colony', label: 'Mahaveer Colony', pincode: '125050' },
    { value: 'mohan-nagar', label: 'Mohan Nagar', pincode: '125050' },
    { value: 'model-town', label: 'Model Town', pincode: '125050' },
    { value: 'nehru-colony', label: 'Nehru Colony', pincode: '125050' },
    { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '125050' },
    { value: 'new-anaj-mandi', label: 'New Anaj Mandi', pincode: '125050' },
    { value: 'old-bus-stand', label: 'Old Bus Stand', pincode: '125050' },
    { value: 'panchayat-road', label: 'Panchayat Road', pincode: '125050' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '125050' },
    { value: 'preet-nagar', label: 'Preet Nagar', pincode: '125050' },
    { value: 'rampura-basti', label: 'Rampura Basti', pincode: '125050' },
    { value: 'rukmani-vihar', label: 'Rukmani Vihar', pincode: '125050' },
    { value: 'sadar-bazaar', label: 'Sadar Bazaar', pincode: '125050' },
    { value: 'saraswati-nagar', label: 'Saraswati Nagar', pincode: '125050' },
    { value: 'sector-4', label: 'Sector 4', pincode: '125050' },
    { value: 'sector-8', label: 'Sector 8', pincode: '125050' },
    { value: 'shakti-nagar', label: 'Shakti Nagar', pincode: '125050' },
    { value: 'shiv-colony', label: 'Shiv Colony', pincode: '125050' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '125050' },
    { value: 'udaipur-basti', label: 'Udaipur Basti', pincode: '125050' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '125050' },
    { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '125050' },
    { value: 'yadav-colony', label: 'Yadav Colony', pincode: '125050' }
    ],
  
    'jhajjar': [
    { value: 'asodha', label: 'Asodha', pincode: '124105' },
    { value: 'badli', label: 'Badli', pincode: '124105' },
    { value: 'bahadurgarh', label: 'Bahadurgarh', pincode: '124507' },
    { value: 'beri', label: 'Beri', pincode: '124201' },
    { value: 'chhara', label: 'Chhara', pincode: '124504' },
    { value: 'dadri-toye', label: 'Dadri Toye', pincode: '124106' },
    { value: 'dighal', label: 'Dighal', pincode: '124107' },
    { value: 'dubaldhan', label: 'Dubaldhan', pincode: '124108' },
    { value: 'goria', label: 'Goria', pincode: '124109' },
    { value: 'jahangirpur', label: 'Jahangirpur', pincode: '124103' },
    { value: 'jhajjar', label: 'Jhajjar', pincode: '124103' },
    { value: 'kanonda', label: 'Kanonda', pincode: '124109' },
    { value: 'kheri-jasaur', label: 'Kheri Jasaur', pincode: '124104' },
    { value: 'kulana', label: 'Kulana', pincode: '124111' },
    { value: 'machrauli', label: 'Machrauli', pincode: '124146' },
    { value: 'mataur', label: 'Mataur', pincode: '124141' },
    { value: 'salhawas', label: 'Salhawas', pincode: '124146' },
    { value: 'sankhol', label: 'Sankhol', pincode: '124507' },
    { value: 'sehlang', label: 'Sehlang', pincode: '124104' },
    { value: 'silani', label: 'Silani', pincode: '124106' }
    ],
  
    'nuh': [
    { value: 'abdulapur-nuh', label: 'Abdulapur Nuh', pincode: '122107' },
    { value: 'adbar', label: 'Adbar', pincode: '122108' },
    { value: 'anwali', label: 'Anwali', pincode: '122104' },
    { value: 'barkali', label: 'Barkali', pincode: '122107' },
    { value: 'bichhor', label: 'Bichhor', pincode: '122103' },
    { value: 'bighopur', label: 'Bighopur', pincode: '122105' },
    { value: 'chandeni', label: 'Chandeni', pincode: '122107' },
    { value: 'firozpur-jhirka', label: 'Firozpur Jhirka', pincode: '122104' },
    { value: 'firozpur-namak', label: 'Firozpur Namak', pincode: '122107' },
    { value: 'ghaghas', label: 'Ghaghas', pincode: '122108' },
    { value: 'ghata-jhijhoti', label: 'Ghata Jhijhoti', pincode: '122104' },
    { value: 'gokalpur', label: 'Gokalpur', pincode: '122104' },
    { value: 'hasanpur', label: 'Hasanpur', pincode: '122104' },
    { value: 'indri', label: 'Indri', pincode: '122108' },
    { value: 'jalalpur-nuh', label: 'Jalalpur Nuh', pincode: '122107' },
    { value: 'jharpuri', label: 'Jharpuri', pincode: '122105' },
    { value: 'kalwari', label: 'Kalwari', pincode: '122108' },
    { value: 'khori-kalan', label: 'Khori Kalan', pincode: '122108' },
    { value: 'malab', label: 'Malab', pincode: '122107' },
    { value: 'mandikhera', label: 'Mandikhera', pincode: '122108' },
    { value: 'meoli', label: 'Meoli', pincode: '122103' },
    { value: 'mirojpur', label: 'Mirojpur', pincode: '122108' },
    { value: 'nagina', label: 'Nagina', pincode: '122108' },
    { value: 'nuh', label: 'Nuh', pincode: '122107' },
    { value: 'punhana', label: 'Punhana', pincode: '122508' },
    { value: 'rozka-meo', label: 'Rozka Meo', pincode: '122103' },
    { value: 'shikrawa', label: 'Shikrawa', pincode: '122107' },
    { value: 'silakhari', label: 'Silakhari', pincode: '122108' },
    { value: 'tauru', label: 'Tauru', pincode: '122105' },
    { value: 'udhanwas', label: 'Udhanwas', pincode: '122108' }
    ],
  
    'bahadurgarh': [
    { value: 'anand-parbat', label: 'Anand Parbat', pincode: '124507' },
    { value: 'bahadurgarh-city', label: 'Bahadurgarh City', pincode: '124507' },
    { value: 'baba-khande-wali', label: 'Baba Khande Wali', pincode: '124507' },
    { value: 'chandrawali', label: 'Chandrawali', pincode: '124507' },
    { value: 'dakha', label: 'Dakha', pincode: '124507' },
    { value: 'gobindpuri', label: 'Gobindpuri', pincode: '124507' },
    { value: 'jagdev-khera', label: 'Jagdev Khera', pincode: '124507' },
    { value: 'jindal-colony', label: 'Jindal Colony', pincode: '124507' },
    { value: 'khera-mundi', label: 'Khera Mundi', pincode: '124507' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '124507' },
    { value: 'nangal', label: 'Nangal', pincode: '124507' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '124507' },
    { value: 'raju-khera', label: 'Raju Khera', pincode: '124507' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '124507' },
    { value: 'tisra', label: 'Tisra', pincode: '124507' },
    { value: 'vishnu-garden', label: 'Vishnu Garden', pincode: '124507' },
    { value: 'zundla', label: 'Zundla', pincode: '124507' }
    ],
  
    'mahendragarh': [
    { value: 'alipur', label: 'Alipur', pincode: '123029' },
    { value: 'bamnoli', label: 'Bamnoli', pincode: '123029' },
    { value: 'bawani-khera', label: 'Bawani Khera', pincode: '123029' },
    { value: 'chaudhary-dham', label: 'Chaudhary Dham', pincode: '123029' },
    { value: 'dhani-bhattu', label: 'Dhani Bhattu', pincode: '123029' },
    { value: 'ganpati-pura', label: 'Ganpati Pura', pincode: '123029' },
    { value: 'gharit', label: 'Gharit', pincode: '123029' },
    { value: 'gunna-khera', label: 'Gunna Khera', pincode: '123029' },
    { value: 'kanjhawala', label: 'Kanjhawala', pincode: '123029' },
    { value: 'mahal', label: 'Mahal', pincode: '123029' },
    { value: 'mahendragarh-town', label: 'Mahendragarh Town', pincode: '123029' },
    { value: 'mangali', label: 'Mangali', pincode: '123029' },
    { value: 'modinagar', label: 'Modinagar', pincode: '123029' },
    { value: 'palwal', label: 'Palwal', pincode: '123029' },
    { value: 'raipur', label: 'Raipur', pincode: '123029' },
    { value: 'santoshpur', label: 'Santoshpur', pincode: '123029' },
    { value: 'sihi', label: 'Sihi', pincode: '123029' },
    { value: 'tijara', label: 'Tijara', pincode: '123029' },
    { value: 'village-ramnagar', label: 'Village Ramnagar', pincode: '123029' }
    ],
  
    'narwana': [
    { value: 'alipur', label: 'Alipur', pincode: '126116' },
    { value: 'barwas', label: 'Barwas', pincode: '126116' },
    { value: 'bhakri', label: 'Bhakri', pincode: '126116' },
    { value: 'bhulana', label: 'Bhulana', pincode: '126116' },
    { value: 'garh-kheri', label: 'Garh Kheri', pincode: '126116' },
    { value: 'jandli', label: 'Jandli', pincode: '126116' },
    { value: 'kalian', label: 'Kalian', pincode: '126116' },
    { value: 'kanjhawala', label: 'Kanjhawala', pincode: '126116' },
    { value: 'manpura', label: 'Manpura', pincode: '126116' },
    { value: 'narwana-city', label: 'Narwana City', pincode: '126116' },
    { value: 'patran', label: 'Patran', pincode: '126116' },
    { value: 'raipur', label: 'Raipur', pincode: '126116' },
    { value: 'sadiq-pura', label: 'Sadiq Pura', pincode: '126116' },
    { value: 'sarauni', label: 'Sarauni', pincode: '126116' },
    { value: 'tijara', label: 'Tijara', pincode: '126116' },
    { value: 'village-mukandpura', label: 'Village Mukandpura', pincode: '126116' },
    { value: 'khera', label: 'Khera', pincode: '126116' },
    { value: 'dhanora', label: 'Dhanora', pincode: '126116' },
    { value: 'khizrabad', label: 'Khizrabad', pincode: '126116' },
    { value: 'jassuwal', label: 'Jassuwal', pincode: '126116' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '126116' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '126116' }
    ],
  
    'safidon': [
    { value: 'abho-pur', label: 'Abho Pur', pincode: '126112' },
    { value: 'baba-rampur', label: 'Baba Rampur', pincode: '126112' },
    { value: 'baddu-pur', label: 'Baddu Pur', pincode: '126112' },
    { value: 'barwala', label: 'Barwala', pincode: '126112' },
    { value: 'chhajpur', label: 'Chhajpur', pincode: '126112' },
    { value: 'danauli', label: 'Danauli', pincode: '126112' },
    { value: 'fateh-pur', label: 'Fateh Pur', pincode: '126112' },
    { value: 'ganesh-pur', label: 'Ganesh Pur', pincode: '126112' },
    { value: 'gothra', label: 'Gothra', pincode: '126112' },
    { value: 'jagmal-pur', label: 'Jagmal Pur', pincode: '126112' },
    { value: 'jind-road', label: 'Jind Road', pincode: '126112' },
    { value: 'khera', label: 'Khera', pincode: '126112' },
    { value: 'manpura', label: 'Manpura', pincode: '126112' },
    { value: 'safidon-city', label: 'Safidon City', pincode: '126112' },
    { value: 'salem-pur', label: 'Salem Pur', pincode: '126112' },
    { value: 'salam-pur', label: 'Salam Pur', pincode: '126112' },
    { value: 'shergarh', label: 'Shergarh', pincode: '126112' },
    { value: 'sulthana', label: 'Sulthana', pincode: '126112' },
    { value: 'pundri', label: 'Pundri', pincode: '126112' },
    { value: 'tijara', label: 'Tijara', pincode: '126112' },
    { value: 'mohammad-pur', label: 'Mohammad Pur', pincode: '126112' }
    ],
  
    'pundri': [
    { value: 'agarwa', label: 'Agarwa', pincode: '136131' },
    { value: 'balian', label: 'Balian', pincode: '136131' },
    { value: 'barwa', label: 'Barwa', pincode: '136131' },
    { value: 'bhaini', label: 'Bhaini', pincode: '136131' },
    { value: 'chandpur', label: 'Chandpur', pincode: '136131' },
    { value: 'dholpur', label: 'Dholpur', pincode: '136131' },
    { value: 'gillan', label: 'Gillan', pincode: '136131' },
    { value: 'gothra', label: 'Gothra', pincode: '136131' },
    { value: 'kamalu', label: 'Kamalu', pincode: '136131' },
    { value: 'kheri', label: 'Kheri', pincode: '136131' },
    { value: 'manpura', label: 'Manpura', pincode: '136131' },
    { value: 'mankera', label: 'Mankera', pincode: '136131' },
    { value: 'manpur', label: 'Manpur', pincode: '136131' },
    { value: 'pundri-city', label: 'Pundri City', pincode: '136131' },
    { value: 'raipur', label: 'Raipur', pincode: '136131' },
    { value: 'sarauni', label: 'Sarauni', pincode: '136131' },
    { value: 'shahpur', label: 'Shahpur', pincode: '136131' },
    { value: 'sulthana', label: 'Sulthana', pincode: '136131' },
    { value: 'tijara', label: 'Tijara', pincode: '136131' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '136131' },
    { value: 'zundla', label: 'Zundla', pincode: '136131' }
    ],
  
    'pinjore': [
    { value: 'bapora', label: 'Bapora', pincode: '134102' },
    { value: 'bhalai', label: 'Bhalai', pincode: '134102' },
    { value: 'bhogpur', label: 'Bhogpur', pincode: '134102' },
    { value: 'dhamala', label: 'Dhamala', pincode: '134102' },
    { value: 'gorkha', label: 'Gorkha', pincode: '134102' },
    { value: 'jandli', label: 'Jandli', pincode: '134102' },
    { value: 'kali-mata', label: 'Kali Mata', pincode: '134102' },
    { value: 'kalka', label: 'Kalka', pincode: '134203' },
    { value: 'kamli', label: 'Kamli', pincode: '134102' },
    { value: 'manakpur', label: 'Manakpur', pincode: '134102' },
    { value: 'pinjore-city', label: 'Pinjore City', pincode: '134102' },
    { value: 'raipur', label: 'Raipur', pincode: '134102' },
    { value: 'sadhora', label: 'Sadhora', pincode: '134102' },
    { value: 'sai-mata', label: 'Sai Mata', pincode: '134102' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '134102' },
    { value: 'sukhdev-pur', label: 'Sukhdev Pur', pincode: '134102' },
    { value: 'thapli', label: 'Thapli', pincode: '134102' },
    { value: 'madanpur', label: 'Madanpur', pincode: '134102' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '134102' },
    { value: 'chandimandir', label: 'Chandimandir', pincode: '134107' }
    ],
  
    'gohana': [
    { value: 'ada-bhagat', label: 'Ada Bhagat', pincode: '124301' },
    { value: 'agar', label: 'Agar', pincode: '124301' },
    { value: 'bapora', label: 'Bapora', pincode: '124301' },
    { value: 'bariya', label: 'Bariya', pincode: '124301' },
    { value: 'bhuri', label: 'Bhuri', pincode: '124301' },
    { value: 'ganj', label: 'Ganj', pincode: '124301' },
    { value: 'gohana-city', label: 'Gohana City', pincode: '124301' },
    { value: 'gothra', label: 'Gothra', pincode: '124301' },
    { value: 'gularia', label: 'Gularia', pincode: '124301' },
    { value: 'jagmal-pur', label: 'Jagmal Pur', pincode: '124301' },
    { value: 'kaithal', label: 'Kaithal', pincode: '124301' },
    { value: 'khera', label: 'Khera', pincode: '124301' },
    { value: 'manpura', label: 'Manpura', pincode: '124301' },
    { value: 'mohammad-pur', label: 'Mohammad Pur', pincode: '124301' },
    { value: 'naultha', label: 'Naultha', pincode: '124301' },
    { value: 'patra', label: 'Patra', pincode: '124301' },
    { value: 'pundri', label: 'Pundri', pincode: '124301' },
    { value: 'raipur', label: 'Raipur', pincode: '124301' },
    { value: 'sadhora', label: 'Sadhora', pincode: '124301' },
    { value: 'shahpur', label: 'Shahpur', pincode: '124301' },
    { value: 'tijara', label: 'Tijara', pincode: '124301' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '124301' },
    { value: 'zundla', label: 'Zundla', pincode: '124301' }
    ],
  
    'naraingarh': [
    { value: 'ajrana', label: 'Ajrana', pincode: '134203' },
    { value: 'bapora', label: 'Bapora', pincode: '134203' },
    { value: 'bansur', label: 'Bansur', pincode: '134203' },
    { value: 'barwala', label: 'Barwala', pincode: '134203' },
    { value: 'bharthala', label: 'Bharthala', pincode: '134203' },
    { value: 'chandpur', label: 'Chandpur', pincode: '134203' },
    { value: 'dhamla', label: 'Dhamla', pincode: '134203' },
    { value: 'gharhi', label: 'Gharhi', pincode: '134203' },
    { value: 'gohari', label: 'Gohari', pincode: '134203' },
    { value: 'jandli', label: 'Jandli', pincode: '134203' },
    { value: 'khera', label: 'Khera', pincode: '134203' },
    { value: 'kotla', label: 'Kotla', pincode: '134203' },
    { value: 'manpura', label: 'Manpura', pincode: '134203' },
    { value: 'naraingarh-city', label: 'Naraingarh City', pincode: '134203' },
    { value: 'raipur', label: 'Raipur', pincode: '134203' },
    { value: 'sahpur', label: 'Sahpur', pincode: '134203' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '134203' },
    { value: 'tijara', label: 'Tijara', pincode: '134203' },
    { value: 'udhywala', label: 'Udhywala', pincode: '134203' },
    { value: 'vishnu-pur', label: 'Vishnu Pur', pincode: '134203' },
    { value: 'zundla', label: 'Zundla', pincode: '134203' }
    ],
  
    'ellenabad': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '125102' },
    { value: 'balasar', label: 'Balasar', pincode: '125102' },
    { value: 'bapora', label: 'Bapora', pincode: '125102' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '125102' },
    { value: 'chandpur', label: 'Chandpur', pincode: '125102' },
    { value: 'dhamla', label: 'Dhamla', pincode: '125102' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '125102' },
    { value: 'goharwas', label: 'Goharwas', pincode: '125102' },
    { value: 'ellenabad-city', label: 'Ellenabad City', pincode: '125102' },
    { value: 'haryana', label: 'Haryana', pincode: '125102' },
    { value: 'jandli', label: 'Jandli', pincode: '125102' },
    { value: 'kheri', label: 'Kheri', pincode: '125102' },
    { value: 'khojewala', label: 'Khojewala', pincode: '125102' },
    { value: 'manpura', label: 'Manpura', pincode: '125102' },
    { value: 'naultha', label: 'Naultha', pincode: '125102' },
    { value: 'raipur', label: 'Raipur', pincode: '125102' },
    { value: 'sadhora', label: 'Sadhora', pincode: '125102' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '125102' },
    { value: 'tijara', label: 'Tijara', pincode: '125102' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '125102' },
    { value: 'zundla', label: 'Zundla', pincode: '125102' },
    { value: 'kharak', label: 'Kharak', pincode: '125102' },
    { value: 'khanda', label: 'Khanda', pincode: '125102' },
    { value: 'singhana', label: 'Singhana', pincode: '125102' }
    ],
  
    'samalkha': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '132101' },
    { value: 'bahadur-pur', label: 'Bahadur Pur', pincode: '132101' },
    { value: 'balra', label: 'Balra', pincode: '132101' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '132101' },
    { value: 'chandpur', label: 'Chandpur', pincode: '132101' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '132101' },
    { value: 'gherkha', label: 'Gherkha', pincode: '132101' },
    { value: 'gohari', label: 'Gohari', pincode: '132101' },
    { value: 'kalwa', label: 'Kalwa', pincode: '132101' },
    { value: 'khera', label: 'Khera', pincode: '132101' },
    { value: 'khojewala', label: 'Khojewala', pincode: '132101' },
    { value: 'manpura', label: 'Manpura', pincode: '132101' },
    { value: 'miranpur', label: 'Miranpur', pincode: '132101' },
    { value: 'samalkha-city', label: 'Samalkha City', pincode: '132101' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '132101' },
    { value: 'tijara', label: 'Tijara', pincode: '132101' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '132101' },
    { value: 'zundla', label: 'Zundla', pincode: '132101' },
    { value: 'bapora', label: 'Bapora', pincode: '132101' },
    { value: 'raipur', label: 'Raipur', pincode: '132101' },
    { value: 'nangal', label: 'Nangal', pincode: '132101' },
    { value: 'bajara', label: 'Bajara', pincode: '132101' }
    ],
  
    'tohana': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '125120' },
    { value: 'balasar', label: 'Balasar', pincode: '125120' },
    { value: 'bapora', label: 'Bapora', pincode: '125120' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '125120' },
    { value: 'chandpur', label: 'Chandpur', pincode: '125120' },
    { value: 'dhani-bihari', label: 'Dhani Bihari', pincode: '125120' },
    { value: 'dhani-dharan', label: 'Dhani Dharan', pincode: '125120' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '125120' },
    { value: 'gohari', label: 'Gohari', pincode: '125120' },
    { value: 'khera', label: 'Khera', pincode: '125120' },
    { value: 'khojewala', label: 'Khojewala', pincode: '125120' },
    { value: 'manpura', label: 'Manpura', pincode: '125120' },
    { value: 'miranpur', label: 'Miranpur', pincode: '125120' },
    { value: 'nangla', label: 'Nangla', pincode: '125120' },
    { value: 'raipur', label: 'Raipur', pincode: '125120' },
    { value: 'samalkha', label: 'Samalkha', pincode: '125120' },
    { value: 'tohana-city', label: 'Tohana City', pincode: '125120' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '125120' },
    { value: 'zundla', label: 'Zundla', pincode: '125120' },
    { value: 'baba-pur', label: 'Baba Pur', pincode: '125120' },
    { value: 'fateh-pur', label: 'Fateh Pur', pincode: '125120' },
    { value: 'khera-bani', label: 'Khera Bani', pincode: '125120' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '125120' }
    ],
  
    'ratia': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '125051' },
    { value: 'baba-pur', label: 'Baba Pur', pincode: '125051' },
    { value: 'balasar', label: 'Balasar', pincode: '125051' },
    { value: 'bapora', label: 'Bapora', pincode: '125051' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '125051' },
    { value: 'chandpur', label: 'Chandpur', pincode: '125051' },
    { value: 'dhani-bihari', label: 'Dhani Bihari', pincode: '125051' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '125051' },
    { value: 'gohari', label: 'Gohari', pincode: '125051' },
    { value: 'jandli', label: 'Jandli', pincode: '125051' },
    { value: 'khera', label: 'Khera', pincode: '125051' },
    { value: 'khojewala', label: 'Khojewala', pincode: '125051' },
    { value: 'manpura', label: 'Manpura', pincode: '125051' },
    { value: 'miranpur', label: 'Miranpur', pincode: '125051' },
    { value: 'raipur', label: 'Raipur', pincode: '125051' },
    { value: 'ratia-city', label: 'Ratia City', pincode: '125051' },
    { value: 'sadhora', label: 'Sadhora', pincode: '125051' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '125051' },
    { value: 'tijara', label: 'Tijara', pincode: '125051' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '125051' },
    { value: 'zundla', label: 'Zundla', pincode: '125051' },
    { value: 'fateh-pur', label: 'Fateh Pur', pincode: '125051' },
    { value: 'bapora', label: 'Bapora', pincode: '125051' },
    { value: 'khera-bani', label: 'Khera Bani', pincode: '125051' },
    { value: 'bajra', label: 'Bajra', pincode: '125051' }
    ],
  
    'pehowa': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '136128' },
    { value: 'baba-pur', label: 'Baba Pur', pincode: '136128' },
    { value: 'balasar', label: 'Balasar', pincode: '136128' },
    { value: 'bapora', label: 'Bapora', pincode: '136128' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '136128' },
    { value: 'chandpur', label: 'Chandpur', pincode: '136128' },
    { value: 'dhani-bihari', label: 'Dhani Bihari', pincode: '136128' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '136128' },
    { value: 'gohari', label: 'Gohari', pincode: '136128' },
    { value: 'jandli', label: 'Jandli', pincode: '136128' },
    { value: 'khera', label: 'Khera', pincode: '136128' },
    { value: 'khojewala', label: 'Khojewala', pincode: '136128' },
    { value: 'manpura', label: 'Manpura', pincode: '136128' },
    { value: 'miranpur', label: 'Miranpur', pincode: '136128' },
    { value: 'pehowa-city', label: 'Pehowa City', pincode: '136128' },
    { value: 'raipur', label: 'Raipur', pincode: '136128' },
    { value: 'ratia', label: 'Ratia', pincode: '136128' },
    { value: 'sadhora', label: 'Sadhora', pincode: '136128' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '136128' },
    { value: 'tijara', label: 'Tijara', pincode: '136128' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '136128' },
    { value: 'zundla', label: 'Zundla', pincode: '136128' },
    { value: 'fateh-pur', label: 'Fateh Pur', pincode: '136128' },
    { value: 'bajara', label: 'Bajara', pincode: '136128' },
    { value: 'baba-brahman', label: 'Baba Brahman', pincode: '136128' },
    { value: 'kotla', label: 'Kotla', pincode: '136128' },
    { value: 'madhopur', label: 'Madhopur', pincode: '136128' }
    ],
  
    'gharaunda': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '132114' },
    { value: 'baba-pur', label: 'Baba Pur', pincode: '132114' },
    { value: 'balasar', label: 'Balasar', pincode: '132114' },
    { value: 'bapora', label: 'Bapora', pincode: '132114' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '132114' },
    { value: 'chandpur', label: 'Chandpur', pincode: '132114' },
    { value: 'dhani-bihari', label: 'Dhani Bihari', pincode: '132114' },
    { value: 'fateh-pur', label: 'Fateh Pur', pincode: '132114' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '132114' },
    { value: 'gohari', label: 'Gohari', pincode: '132114' },
    { value: 'jandli', label: 'Jandli', pincode: '132114' },
    { value: 'khera', label: 'Khera', pincode: '132114' },
    { value: 'khojewala', label: 'Khojewala', pincode: '132114' },
    { value: 'kotla', label: 'Kotla', pincode: '132114' },
    { value: 'manpura', label: 'Manpura', pincode: '132114' },
    { value: 'miranpur', label: 'Miranpur', pincode: '132114' },
    { value: 'raipur', label: 'Raipur', pincode: '132114' },
    { value: 'ratia', label: 'Ratia', pincode: '132114' },
    { value: 'sadhora', label: 'Sadhora', pincode: '132114' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '132114' },
    { value: 'tijara', label: 'Tijara', pincode: '132114' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '132114' },
    { value: 'zundla', label: 'Zundla', pincode: '132114' },
    { value: 'bajra', label: 'Bajra', pincode: '132114' },
    { value: 'bhori', label: 'Bhori', pincode: '132114' },
    { value: 'chowki', label: 'Chowki', pincode: '132114' },
    { value: 'darya-pur', label: 'Darya Pur', pincode: '132114' },
    { value: 'islamabad', label: 'Islamabad', pincode: '132114' }
    ],
  
    'punhana': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '122508' },
    { value: 'alipur', label: 'Alipur', pincode: '122508' },
    { value: 'baba-pur', label: 'Baba Pur', pincode: '122508' },
    { value: 'balasar', label: 'Balasar', pincode: '122508' },
    { value: 'bapora', label: 'Bapora', pincode: '122508' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '122508' },
    { value: 'chandpur', label: 'Chandpur', pincode: '122508' },
    { value: 'dhani-bihari', label: 'Dhani Bihari', pincode: '122508' },
    { value: 'dholi', label: 'Dholi', pincode: '122508' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '122508' },
    { value: 'gohari', label: 'Gohari', pincode: '122508' },
    { value: 'jandli', label: 'Jandli', pincode: '122508' },
    { value: 'khera', label: 'Khera', pincode: '122508' },
    { value: 'khojewala', label: 'Khojewala', pincode: '122508' },
    { value: 'manpura', label: 'Manpura', pincode: '122508' },
    { value: 'miranpur', label: 'Miranpur', pincode: '122508' },
    { value: 'palwan', label: 'Palwan', pincode: '122508' },
    { value: 'raipur', label: 'Raipur', pincode: '122508' },
    { value: 'ratia', label: 'Ratia', pincode: '122508' },
    { value: 'sadhora', label: 'Sadhora', pincode: '122508' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '122508' },
    { value: 'tijara', label: 'Tijara', pincode: '122508' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '122508' },
    { value: 'zundla', label: 'Zundla', pincode: '122508' },
    { value: 'bajra', label: 'Bajra', pincode: '122508' },
    { value: 'kotla', label: 'Kotla', pincode: '122508' },
    { value: 'islamabad', label: 'Islamabad', pincode: '122508' },
    { value: 'bajra-basti', label: 'Bajra Basti', pincode: '122508' },
    { value: 'madhopur', label: 'Madhopur', pincode: '122508' }
    ],
  
    'pataudi': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '122503' },
    { value: 'alipur', label: 'Alipur', pincode: '122503' },
    { value: 'baba-pur', label: 'Baba Pur', pincode: '122503' },
    { value: 'balasar', label: 'Balasar', pincode: '122503' },
    { value: 'bapora', label: 'Bapora', pincode: '122503' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '122503' },
    { value: 'chandpur', label: 'Chandpur', pincode: '122503' },
    { value: 'dhani-bihari', label: 'Dhani Bihari', pincode: '122503' },
    { value: 'dholi', label: 'Dholi', pincode: '122503' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '122503' },
    { value: 'gohari', label: 'Gohari', pincode: '122503' },
    { value: 'jandli', label: 'Jandli', pincode: '122503' },
    { value: 'khera', label: 'Khera', pincode: '122503' },
    { value: 'khojewala', label: 'Khojewala', pincode: '122503' },
    { value: 'manpura', label: 'Manpura', pincode: '122503' },
    { value: 'miranpur', label: 'Miranpur', pincode: '122503' },
    { value: 'palwan', label: 'Palwan', pincode: '122503' },
    { value: 'raipur', label: 'Raipur', pincode: '122503' },
    { value: 'ratia', label: 'Ratia', pincode: '122503' },
    { value: 'sadhora', label: 'Sadhora', pincode: '122503' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '122503' },
    { value: 'tijara', label: 'Tijara', pincode: '122503' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '122503' },
    { value: 'zundla', label: 'Zundla', pincode: '122503' },
    { value: 'bajra', label: 'Bajra', pincode: '122503' },
    { value: 'bajra-basti', label: 'Bajra Basti', pincode: '122503' },
    { value: 'islamabad', label: 'Islamabad', pincode: '122503' },
    { value: 'kotla', label: 'Kotla', pincode: '122503' },
    { value: 'madhopur', label: 'Madhopur', pincode: '122503' },
    { value: 'manesar', label: 'Manesar', pincode: '122051' },
    { value: 'narayankhed', label: 'Narayankhed', pincode: '122503' },
    { value: 'pali', label: 'Pali', pincode: '122503' },
    { value: 'sara', label: 'Sara', pincode: '122503' },
    { value: 'shahpur', label: 'Shahpur', pincode: '122503' }
    ],
  
    'assandh': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '132039' },
    { value: 'alipur', label: 'Alipur', pincode: '132039' },
    { value: 'baba-pur', label: 'Baba Pur', pincode: '132039' },
    { value: 'balasar', label: 'Balasar', pincode: '132039' },
    { value: 'bapora', label: 'Bapora', pincode: '132039' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '132039' },
    { value: 'chandpur', label: 'Chandpur', pincode: '132039' },
    { value: 'dhani-bihari', label: 'Dhani Bihari', pincode: '132039' },
    { value: 'dholi', label: 'Dholi', pincode: '132039' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '132039' },
    { value: 'gohari', label: 'Gohari', pincode: '132039' },
    { value: 'jandli', label: 'Jandli', pincode: '132039' },
    { value: 'khera', label: 'Khera', pincode: '132039' },
    { value: 'khojewala', label: 'Khojewala', pincode: '132039' },
    { value: 'manpura', label: 'Manpura', pincode: '132039' },
    { value: 'miranpur', label: 'Miranpur', pincode: '132039' },
    { value: 'palwan', label: 'Palwan', pincode: '132039' },
    { value: 'raipur', label: 'Raipur', pincode: '132039' },
    { value: 'ratia', label: 'Ratia', pincode: '132039' },
    { value: 'sadhora', label: 'Sadhora', pincode: '132039' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '132039' },
    { value: 'tijara', label: 'Tijara', pincode: '132039' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '132039' },
    { value: 'zundla', label: 'Zundla', pincode: '132039' },
    { value: 'bajra', label: 'Bajra', pincode: '132039' },
    { value: 'bajra-basti', label: 'Bajra Basti', pincode: '132039' },
    { value: 'islamabad', label: 'Islamabad', pincode: '132039' },
    { value: 'kotla', label: 'Kotla', pincode: '132039' },
    { value: 'madhopur', label: 'Madhopur', pincode: '132039' },
    { value: 'manesar', label: 'Manesar', pincode: '132051' },
    { value: 'nayan-pura', label: 'Nayan Pura', pincode: '132039' },
    { value: 'pali', label: 'Pali', pincode: '132039' },
    { value: 'sara', label: 'Sara', pincode: '132039' },
    { value: 'shahpur', label: 'Shahpur', pincode: '132039' },
    { value: 'amla', label: 'Amla', pincode: '132039' },
    { value: 'anwal', label: 'Anwal', pincode: '132039' },
    { value: 'gobindpur', label: 'Gobindpur', pincode: '132039' },
    { value: 'jaitpur', label: 'Jaitpur', pincode: '132039' },
    { value: 'kheri', label: 'Kheri', pincode: '132039' },
    { value: 'khabra', label: 'Khabra', pincode: '132039' },
    { value: 'lohari', label: 'Lohari', pincode: '132039' },
    { value: 'rahi', label: 'Rahi', pincode: '132039' }
    ],
  
    'ganaur': [
    { value: 'ajit-pura', label: 'Ajit Pura', pincode: '131101' },
    { value: 'alipur', label: 'Alipur', pincode: '131101' },
    { value: 'banwari', label: 'Banwari', pincode: '131101' },
    { value: 'bapora', label: 'Bapora', pincode: '131101' },
    { value: 'bhainswan', label: 'Bhainswan', pincode: '131101' },
    { value: 'bholi', label: 'Bholi', pincode: '131101' },
    { value: 'chandpur', label: 'Chandpur', pincode: '131101' },
    { value: 'dadiya', label: 'Dadiya', pincode: '131101' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '131101' },
    { value: 'gohari', label: 'Gohari', pincode: '131101' },
    { value: 'khera', label: 'Khera', pincode: '131101' },
    { value: 'khojewala', label: 'Khojewala', pincode: '131101' },
    { value: 'manpura', label: 'Manpura', pincode: '131101' },
    { value: 'miranpur', label: 'Miranpur', pincode: '131101' },
    { value: 'palwan', label: 'Palwan', pincode: '131101' },
    { value: 'raipur', label: 'Raipur', pincode: '131101' },
    { value: 'ratia', label: 'Ratia', pincode: '131101' },
    { value: 'sadhora', label: 'Sadhora', pincode: '131101' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '131101' },
    { value: 'tijara', label: 'Tijara', pincode: '131101' },
    { value: 'vishnu-pura', label: 'Vishnu Pura', pincode: '131101' },
    { value: 'zundla', label: 'Zundla', pincode: '131101' },
    { value: 'bajra', label: 'Bajra', pincode: '131101' },
    { value: 'islamabad', label: 'Islamabad', pincode: '131101' },
    { value: 'kotla', label: 'Kotla', pincode: '131101' },
    { value: 'manesar', label: 'Manesar', pincode: '132051' },
    { value: 'nayan-pura', label: 'Nayan Pura', pincode: '131101' },
    { value: 'pali', label: 'Pali', pincode: '131101' },
    { value: 'sara', label: 'Sara', pincode: '131101' },
    { value: 'shahpur', label: 'Shahpur', pincode: '131101' },
    { value: 'rahi', label: 'Rahi', pincode: '131101' },
    { value: 'baba-pur', label: 'Baba Pur', pincode: '131101' },
    { value: 'chhajpur', label: 'Chhajpur', pincode: '131101' },
    { value: 'gandhi-pura', label: 'Gandhi Pura', pincode: '131101' },
    { value: 'jaitpur', label: 'Jaitpur', pincode: '131101' },
    { value: 'kamna-pura', label: 'Kamna Pura', pincode: '131101' },
    { value: 'kherpur', label: 'Kherpur', pincode: '131101' },
    { value: 'madhopur', label: 'Madhopur', pincode: '131101' },
    { value: 'manthri', label: 'Manthri', pincode: '131101' },
    { value: 'pal-wali', label: 'Pal Wali', pincode: '131101' },
    { value: 'saini', label: 'Saini', pincode: '131101' },
    { value: 'sher-pur', label: 'Sher Pur', pincode: '131101' }
    ],
  
    'firozpur-jhirka': [
    { value: 'alampur', label: 'Alampur', pincode: '122104' },
    { value: 'anwal', label: 'Anwal', pincode: '122104' },
    { value: 'baghpur', label: 'Baghpur', pincode: '122104' },
    { value: 'bhagatpura', label: 'Bhagatpura', pincode: '122104' },
    { value: 'bhanpur', label: 'Bhanpur', pincode: '122104' },
    { value: 'chand-pura', label: 'Chand Pura', pincode: '122104' },
    { value: 'chhappar', label: 'Chhappar', pincode: '122104' },
    { value: 'dailpura', label: 'Dailpura', pincode: '122104' },
    { value: 'dharampura', label: 'Dharampura', pincode: '122104' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '122104' },
    { value: 'garh-pur', label: 'Garh Pur', pincode: '122104' },
    { value: 'ghayal-pura', label: 'Ghayal Pura', pincode: '122104' },
    { value: 'golpura', label: 'Golpura', pincode: '122104' },
    { value: 'jhajhar', label: 'Jhajhar', pincode: '122104' },
    { value: 'jhipa', label: 'Jhipa', pincode: '122104' },
    { value: 'khera', label: 'Khera', pincode: '122104' },
    { value: 'kotla', label: 'Kotla', pincode: '122104' },
    { value: 'manpura', label: 'Manpura', pincode: '122104' },
    { value: 'mukimpura', label: 'Mukimpura', pincode: '122104' },
    { value: 'nalai', label: 'Nalai', pincode: '122104' },
    { value: 'palwan', label: 'Palwan', pincode: '122104' },
    { value: 'purana', label: 'Purana', pincode: '122104' },
    { value: 'rajpura', label: 'Rajpura', pincode: '122104' },
    { value: 'sahabpura', label: 'Sahabpura', pincode: '122104' },
    { value: 'sajidpur', label: 'Sajidpur', pincode: '122104' },
    { value: 'sulajpur', label: 'Sulajpur', pincode: '122104' },
    { value: 'surajpur', label: 'Surajpur', pincode: '122104' },
    { value: 'zandpura', label: 'Zandpura', pincode: '122104' },
    { value: 'bhagatgarh', label: 'Bhagatgarh', pincode: '122104' },
    { value: 'jhajhar-pura', label: 'Jhajhar Pura', pincode: '122104' },
    { value: 'kudail', label: 'Kudail', pincode: '122104' },
    { value: 'muradpur', label: 'Muradpur', pincode: '122104' },
    { value: 'nizampur', label: 'Nizampur', pincode: '122104' },
    { value: 'pahari', label: 'Pahari', pincode: '122104' },
    { value: 'pindwara', label: 'Pindwara', pincode: '122104' },
    { value: 'rathiwas', label: 'Rathiwas', pincode: '122104' },
    { value: 'sirsala', label: 'Sirsala', pincode: '122104' },
    { value: 'sukhpura', label: 'Sukhpura', pincode: '122104' },
    { value: 'tampur', label: 'Tampur', pincode: '122104' }
    ],
  
    'kansapur': [
    { value: 'alipur', label: 'Alipur', pincode: '131101' },
    { value: 'baghpur', label: 'Baghpur', pincode: '131101' },
    { value: 'bihli', label: 'Bihli', pincode: '131101' },
    { value: 'chand-pura', label: 'Chand Pura', pincode: '131101' },
    { value: 'dharmshala', label: 'Dharmshala', pincode: '131101' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '131101' },
    { value: 'jagdeep-pura', label: 'Jagdeep Pura', pincode: '131101' },
    { value: 'khera', label: 'Khera', pincode: '131101' },
    { value: 'kotla', label: 'Kotla', pincode: '131101' },
    { value: 'manpura', label: 'Manpura', pincode: '131101' },
    { value: 'mukimpura', label: 'Mukimpura', pincode: '131101' },
    { value: 'nalai', label: 'Nalai', pincode: '131101' },
    { value: 'palwan', label: 'Palwan', pincode: '131101' },
    { value: 'purana', label: 'Purana', pincode: '131101' },
    { value: 'rajpura', label: 'Rajpura', pincode: '131101' },
    { value: 'sahabpura', label: 'Sahabpura', pincode: '131101' },
    { value: 'sajidpur', label: 'Sajidpur', pincode: '131101' },
    { value: 'surajpur', label: 'Surajpur', pincode: '131101' },
    { value: 'tampur', label: 'Tampur', pincode: '131101' },
    { value: 'zandpura', label: 'Zandpura', pincode: '131101' },
    { value: 'barkatpur', label: 'Barkatpur', pincode: '131101' },
    { value: 'bhanpur', label: 'Bhanpur', pincode: '131101' },
    { value: 'gorewala', label: 'Gorewala', pincode: '131101' },
    { value: 'gulabpur', label: 'Gulabpur', pincode: '131101' },
    { value: 'jhipa', label: 'Jhipa', pincode: '131101' },
    { value: 'kaimari', label: 'Kaimari', pincode: '131101' },
    { value: 'kansapur-village', label: 'Kansapur Village', pincode: '131101' },
    { value: 'kashipur', label: 'Kashipur', pincode: '131101' },
    { value: 'raipur', label: 'Raipur', pincode: '131101' },
    { value: 'sirsala', label: 'Sirsala', pincode: '131101' },
    { value: 'tulsi-pura', label: 'Tulsi Pura', pincode: '131101' }
    ],
  
    'meham': [
    { value: 'ajitpura', label: 'Ajitpura', pincode: '124112' },
    { value: 'alampur', label: 'Alampur', pincode: '124112' },
    { value: 'baghpur', label: 'Baghpur', pincode: '124112' },
    { value: 'bhagatpura', label: 'Bhagatpura', pincode: '124112' },
    { value: 'bilochpura', label: 'Bilochpura', pincode: '124112' },
    { value: 'chirpura', label: 'Chirpura', pincode: '124112' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '124112' },
    { value: 'gokalpur', label: 'Gokalpur', pincode: '124112' },
    { value: 'gurukul', label: 'Gurukul', pincode: '124112' },
    { value: 'jagmalpura', label: 'Jagmalpura', pincode: '124112' },
    { value: 'jindpura', label: 'Jindpura', pincode: '124112' },
    { value: 'kailashpura', label: 'Kailashpura', pincode: '124112' },
    { value: 'kanheli', label: 'Kanheli', pincode: '124112' },
    { value: 'khempura', label: 'Khempura', pincode: '124112' },
    { value: 'ladhpur', label: 'Ladhpur', pincode: '124112' },
    { value: 'manakpura', label: 'Manakpura', pincode: '124112' },
    { value: 'manoharpura', label: 'Manoharpura', pincode: '124112' },
    { value: 'mohanpura', label: 'Mohanpura', pincode: '124112' },
    { value: 'mubarakpura', label: 'Mubarakpura', pincode: '124112' },
    { value: 'naultha', label: 'Naultha', pincode: '124112' },
    { value: 'patelpura', label: 'Patelpura', pincode: '124112' },
    { value: 'puranpura', label: 'Puranpura', pincode: '124112' },
    { value: 'ratanpura', label: 'Ratanpura', pincode: '124112' },
    { value: 'roopnagar', label: 'Roopnagar', pincode: '124112' },
    { value: 'sadhuwala', label: 'Sadhuwala', pincode: '124112' },
    { value: 'sikri', label: 'Sikri', pincode: '124112' },
    { value: 'singhpura', label: 'Singhpura', pincode: '124112' },
    { value: 'sukhpura', label: 'Sukhpura', pincode: '124112' },
    { value: 'tughlakpura', label: 'Tughlakpura', pincode: '124112' },
    { value: 'bhanpur', label: 'Bhanpur', pincode: '124112' },
    { value: 'dharampura', label: 'Dharampura', pincode: '124112' },
    { value: 'gokulpura', label: 'Gokulpura', pincode: '124112' },
    { value: 'kheripura', label: 'Kheripura', pincode: '124112' },
    { value: 'meham-village', label: 'Meham Village', pincode: '124112' },
    { value: 'patilpura', label: 'Patilpura', pincode: '124112' },
    { value: 'sikarpura', label: 'Sikarpura', pincode: '124112' }
    ],
  
  'panipat': [
    { value: 'agarwal-colony', label: 'Agarwal Colony', pincode: '132103' },
    { value: 'alipur', label: 'Alipur', pincode: '132103' },
    { value: 'anand-colony', label: 'Anand Colony', pincode: '132103' },
    { value: 'ashok-vihar', label: 'Ashok Vihar', pincode: '132103' },
    { value: 'bapoli', label: 'Bapoli', pincode: '132103' },
    { value: 'bara-pul', label: 'Bara Pul', pincode: '132103' },
    { value: 'bhadas', label: 'Bhadas', pincode: '132107' },
    { value: 'bhapra', label: 'Bhapra', pincode: '132103' },
    { value: 'bilaspur', label: 'Bilaspur', pincode: '132105' },
    { value: 'chandoli', label: 'Chandoli', pincode: '132103' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '132104' },
    { value: 'chauki', label: 'Chauki', pincode: '132104' },
    { value: 'choudhary-colony', label: 'Choudhary Colony', pincode: '132107' },
    { value: 'desraj-colony', label: 'Desraj Colony', pincode: '132103' },
    { value: 'geong', label: 'Geong', pincode: '132104' },
    { value: 'haryana-bagh', label: 'Haryana Bagh', pincode: '132103' },
    { value: 'indu-pur', label: 'Indu Pur', pincode: '132103' },
    { value: 'jattal-road', label: 'Jattal Road', pincode: '132103' },
    { value: 'jewanpur', label: 'Jewanpur', pincode: '132103' },
    { value: 'kailash-nagar', label: 'Kailash Nagar', pincode: '132107' },
    { value: 'kakra', label: 'Kakra', pincode: '132107' },
    { value: 'kalyan', label: 'Kalyan', pincode: '132104' },
    { value: 'kamal-pur', label: 'Kamal Pur', pincode: '132103' },
    { value: 'kanal', label: 'Kanal', pincode: '132105' },
    { value: 'khera-sadiq', label: 'Khera Sadiq', pincode: '132103' },
    { value: 'kishan-pur', label: 'Kishan Pur', pincode: '132106' },
    { value: 'kishanpura', label: 'Kishanpura', pincode: '132106' },
    { value: 'kunj-pur', label: 'Kunj Pur', pincode: '132107' },
    { value: 'ladwa', label: 'Ladwa', pincode: '132104' },
    { value: 'madhuban-enclave', label: 'Madhuban Enclave', pincode: '132103' },
    { value: 'matarpur', label: 'Matarpur', pincode: '132103' },
    { value: 'mohammad-pur', label: 'Mohammad Pur', pincode: '132104' },
    { value: 'model-town', label: 'Model Town', pincode: '132103' },
    { value: 'nangal-kheri', label: 'Nangal Kheri', pincode: '132105' },
    { value: 'nawada', label: 'Nawada', pincode: '132105' },
    { value: 'noorwala', label: 'Noorwala', pincode: '132103' },
    { value: 'pali', label: 'Pali', pincode: '132104' },
    { value: 'palwal', label: 'Palwal', pincode: '132107' },
    { value: 'panipat-cantt', label: 'Panipat Cantt', pincode: '132103' },
    { value: 'panipat-city', label: 'Panipat City', pincode: '132103' },
    { value: 'puri', label: 'Puri', pincode: '132105' },
    { value: 'rajiv-colony', label: 'Rajiv Colony', pincode: '132103' },
    { value: 'rajpur', label: 'Rajpur', pincode: '132105' },
    { value: 'rathdana', label: 'Rathdana', pincode: '132106' },
    { value: 'rishalgarh', label: 'Rishalgarh', pincode: '132106' },
    { value: 'roshan-pura', label: 'Roshan Pura', pincode: '132103' },
    { value: 'sahajpur', label: 'Sahajpur', pincode: '132107' },
    { value: 'saini', label: 'Saini', pincode: '132107' },
    { value: 'satyam-pur', label: 'Satyam Pur', pincode: '132104' },
    { value: 'sehwani', label: 'Sehwani', pincode: '132106' },
    { value: 'sikri', label: 'Sikri', pincode: '132106' },
    { value: 'singhpura', label: 'Singhpura', pincode: '132107' },
    { value: 'sujjanpur', label: 'Sujjanpur', pincode: '132103' },
    { value: 'sunjhani', label: 'Sunjhani', pincode: '132105' },
    { value: 'suraj-pur', label: 'Suraj Pur', pincode: '132107' },
    { value: 'tata-pur', label: 'Tata Pur', pincode: '132107' },
    { value: 'usherpur', label: 'Usherpur', pincode: '132106' },
    { value: 'vishal-pur', label: 'Vishal Pur', pincode: '132107' }
  ],

  'sonipat': [
    { value: 'abad-pur', label: 'Abad Pur', pincode: '131001' },
    { value: 'agarwal-colony', label: 'Agarwal Colony', pincode: '131001' },
    { value: 'alipur', label: 'Alipur', pincode: '131021' },
    { value: 'badli', label: 'Badli', pincode: '131022' },
    { value: 'bahal', label: 'Bahal', pincode: '131101' },
    { value: 'baroda', label: 'Baroda', pincode: '131101' },
    { value: 'barwala', label: 'Barwala', pincode: '131023' },
    { value: 'bhiwani', label: 'Bhiwani', pincode: '131022' },
    { value: 'bhagana', label: 'Bhagana', pincode: '131023' },
    { value: 'boparai', label: 'Boparai', pincode: '131027' },
    { value: 'bubka', label: 'Bubka', pincode: '131001' },
    { value: 'chandpur', label: 'Chandpur', pincode: '131022' },
    { value: 'chauhan-badli', label: 'Chauhan Badli', pincode: '131028' },
    { value: 'dhatura', label: 'Dhatura', pincode: '131021' },
    { value: 'ganaur', label: 'Ganaur', pincode: '131101' },
    { value: 'garhi', label: 'Garhi', pincode: '131026' },
    { value: 'garh-baba', label: 'Garh Baba', pincode: '131024' },
    { value: 'garh-khera', label: 'Garh Khera', pincode: '131028' },
    { value: 'garhri', label: 'Garhri', pincode: '131022' },
    { value: 'hansi', label: 'Hansi', pincode: '131028' },
    { value: 'israna', label: 'Israna', pincode: '131102' },
    { value: 'kakra', label: 'Kakra', pincode: '131023' },
    { value: 'kasan', label: 'Kasan', pincode: '131022' },
    { value: 'kathura', label: 'Kathura', pincode: '131003' },
    { value: 'khera', label: 'Khera', pincode: '131025' },
    { value: 'kiloi', label: 'Kiloi', pincode: '131026' },
    { value: 'manesar', label: 'Manesar', pincode: '131021' },
    { value: 'matanhail', label: 'Matanhail', pincode: '131102' },
    { value: 'meerut-road', label: 'Meerut Road', pincode: '131001' },
    { value: 'mewri', label: 'Mewri', pincode: '131029' },
    { value: 'model-town', label: 'Model Town', pincode: '131001' },
    { value: 'nawada', label: 'Nawada', pincode: '131001' },
    { value: 'pabni', label: 'Pabni', pincode: '131021' },
    { value: 'pali', label: 'Pali', pincode: '131003' },
    { value: 'panipat-road', label: 'Panipat Road', pincode: '131001' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '131002' },
    { value: 'rai', label: 'Rai', pincode: '131029' },
    { value: 'rithala', label: 'Rithala', pincode: '131028' },
    { value: 'safidon', label: 'Safidon', pincode: '131024' },
    { value: 'sahar-khera', label: 'Sahar Khera', pincode: '131028' },
    { value: 'sikri', label: 'Sikri', pincode: '131027' },
    { value: 'sonipat-cantt', label: 'Sonipat Cantt', pincode: '131001' },
    { value: 'sonipat-city', label: 'Sonipat City', pincode: '131001' },
    { value: 'soni', label: 'Soni', pincode: '131001' },
    { value: 'soni-pur', label: 'Soni Pur', pincode: '131029' },
    { value: 'tatarpur', label: 'Tatarpur', pincode: '131023' },
    { value: 'yash-pur', label: 'Yash Pur', pincode: '131025' }
  ],

  'gurugram': [
    { value: 'bhiwadi', label: 'Bhiwadi', pincode: '301019' },
    { value: 'bilaspur', label: 'Bilaspur', pincode: '122413' },
    { value: 'dlf-city', label: 'DLF City', pincode: '122002' },
    { value: 'dlf-phase-1', label: 'DLF Phase 1', pincode: '122002' },
    { value: 'dlf-phase-2', label: 'DLF Phase 2', pincode: '122002' },
    { value: 'dlf-phase-3', label: 'DLF Phase 3', pincode: '122002' },
    { value: 'dlf-phase-4', label: 'DLF Phase 4', pincode: '122002' },
    { value: 'dlf-phase-5', label: 'DLF Phase 5', pincode: '122009' },
    { value: 'golf-course-road', label: 'Golf Course Road', pincode: '122001' },
    { value: 'gurugram-city', label: 'Gurugram City', pincode: '122018' },
    { value: 'hero-honda-chowk', label: 'Hero Honda Chowk', pincode: '122018' },
    { value: 'imt-manesar', label: 'IMT Manesar', pincode: '122052' },
    { value: 'jaisinghpura', label: 'Jaisinghpura', pincode: '122018' },
    { value: 'jyoti-park', label: 'Jyoti Park', pincode: '122001' },
    { value: 'kapashera', label: 'Kapashera', pincode: '110037' },
    { value: 'katwaria-sarai', label: 'Katwaria Sarai', pincode: '122001' },
    { value: 'palam-vihar', label: 'Palam Vihar', pincode: '122017' },
    { value: 'pataudi-road', label: 'Pataudi Road', pincode: '122001' },
    { value: 'sector-10', label: 'Sector 10', pincode: '122001' },
    { value: 'sector-11', label: 'Sector 11', pincode: '122001' },
    { value: 'sector-12', label: 'Sector 12', pincode: '122001' },
    { value: 'sector-13', label: 'Sector 13', pincode: '122001' },
    { value: 'sector-14', label: 'Sector 14', pincode: '122001' },
    { value: 'sector-15', label: 'Sector 15', pincode: '122001' },
    { value: 'sector-16', label: 'Sector 16', pincode: '122001' },
    { value: 'sector-17', label: 'Sector 17', pincode: '122001' },
    { value: 'sector-18', label: 'Sector 18', pincode: '122001' },
    { value: 'sector-19', label: 'Sector 19', pincode: '122001' },
    { value: 'sector-20', label: 'Sector 20', pincode: '122001' },
    { value: 'sector-21', label: 'Sector 21', pincode: '122001' },
    { value: 'sector-22', label: 'Sector 22', pincode: '122018' },
    { value: 'sector-23', label: 'Sector 23', pincode: '122018' },
    { value: 'sector-24', label: 'Sector 24', pincode: '122018' },
    { value: 'sector-25', label: 'Sector 25', pincode: '122018' },
    { value: 'sector-26', label: 'Sector 26', pincode: '122018' },
    { value: 'sector-27', label: 'Sector 27', pincode: '122018' },
    { value: 'sector-28', label: 'Sector 28', pincode: '122018' },
    { value: 'sector-29', label: 'Sector 29', pincode: '122018' },
    { value: 'sector-30', label: 'Sector 30', pincode: '122018' },
    { value: 'sector-31', label: 'Sector 31', pincode: '122018' },
    { value: 'sector-32', label: 'Sector 32', pincode: '122018' },
    { value: 'sector-33', label: 'Sector 33', pincode: '122001' },
    { value: 'sector-34', label: 'Sector 34', pincode: '122001' },
    { value: 'sector-35', label: 'Sector 35', pincode: '122001' },
    { value: 'sector-36', label: 'Sector 36', pincode: '122001' },
    { value: 'sector-37', label: 'Sector 37', pincode: '122001' },
    { value: 'sector-38', label: 'Sector 38', pincode: '122001' },
    { value: 'sector-39', label: 'Sector 39', pincode: '122001' },
    { value: 'sector-40', label: 'Sector 40', pincode: '122001' },
    { value: 'sector-41', label: 'Sector 41', pincode: '122001' },
    { value: 'sector-42', label: 'Sector 42', pincode: '122001' },
    { value: 'sector-43', label: 'Sector 43', pincode: '122003' },
    { value: 'sector-44', label: 'Sector 44', pincode: '122003' },
    { value: 'sector-45', label: 'Sector 45', pincode: '122001' },
    { value: 'sector-46', label: 'Sector 46', pincode: '122001' },
    { value: 'sector-47', label: 'Sector 47', pincode: '122001' },
    { value: 'sector-48', label: 'Sector 48', pincode: '122018' },
    { value: 'sector-49', label: 'Sector 49', pincode: '122018' },
    { value: 'sector-50', label: 'Sector 50', pincode: '122001' },
    { value: 'sector-51', label: 'Sector 51', pincode: '122011' },
    { value: 'sector-52', label: 'Sector 52', pincode: '122011' },
    { value: 'sector-53', label: 'Sector 53', pincode: '122011' },
    { value: 'sector-54', label: 'Sector 54', pincode: '122011' },
    { value: 'sector-55', label: 'Sector 55', pincode: '122011' },
    { value: 'sector-56', label: 'Sector 56', pincode: '122011' },
    { value: 'sector-57', label: 'Sector 57', pincode: '122011' },
    { value: 'sector-58', label: 'Sector 58', pincode: '122011' },
    { value: 'sector-59', label: 'Sector 59', pincode: '122011' },
    { value: 'sector-60', label: 'Sector 60', pincode: '122011' }
  ],
  'rohtak': [
    { value: 'anaj-mandi', label: 'Anaj Mandi', pincode: '124001' },
    { value: 'ashoka-chowk', label: 'Ashoka Chowk', pincode: '124001' },
    { value: 'ashok-vihar', label: 'Ashok Vihar', pincode: '124001' },
    { value: 'bhiwani-stand', label: 'Bhiwani Stand', pincode: '124001' },
    { value: 'bhuteshwar-colony', label: 'Bhuteshwar Colony', pincode: '124001' },
    { value: 'chankyapuri', label: 'Chankyapuri', pincode: '124001' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '124001' },
    { value: 'dlf-colony', label: 'DLF Colony', pincode: '124001' },
    { value: 'ganpati-nagar', label: 'Ganpati Nagar', pincode: '124001' },
    { value: 'govind-nagar', label: 'Govind Nagar', pincode: '124001' },
    { value: 'hissar-road', label: 'Hissar Road', pincode: '124001' },
    { value: 'housing-board-colony', label: 'Housing Board Colony', pincode: '124001' },
    { value: 'huda-sector-1', label: 'HUDA Sector 1', pincode: '124001' },
    { value: 'huda-sector-13', label: 'HUDA Sector 13', pincode: '124001' },
    { value: 'huda-sector-14', label: 'HUDA Sector 14', pincode: '124001' },
    { value: 'huda-sector-3', label: 'HUDA Sector 3', pincode: '124001' },
    { value: 'huda-sector-4', label: 'HUDA Sector 4', pincode: '124001' },
    { value: 'huda-sector-6', label: 'HUDA Sector 6', pincode: '124001' },
    { value: 'indira-colony', label: 'Indira Colony', pincode: '124001' },
    { value: 'islam-nagar', label: 'Islam Nagar', pincode: '124001' },
    { value: 'janta-colony', label: 'Janta Colony', pincode: '124001' },
    { value: 'kaithal-road', label: 'Kaithal Road', pincode: '124001' },
    { value: 'kath-mandi', label: 'Kath Mandi', pincode: '124001' },
    { value: 'khera-sadh', label: 'Khera Sadh', pincode: '124021' },
    { value: 'krishna-colony', label: 'Krishna Colony', pincode: '124001' },
    { value: 'ladhaut-road', label: 'Ladhaut Road', pincode: '124001' },
    { value: 'mahavir-colony', label: 'Mahavir Colony', pincode: '124001' },
    { value: 'manmohan-nagar', label: 'Manmohan Nagar', pincode: '124001' },
    { value: 'model-town', label: 'Model Town', pincode: '124001' },
    { value: 'parijat-chowk', label: 'Parijat Chowk', pincode: '124001' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '124001' },
    { value: 'pehowa-road', label: 'Pehowa Road', pincode: '124001' },
    { value: 'prem-nagar', label: 'Prem Nagar', pincode: '124001' },
    { value: 'qila-road', label: 'Qila Road', pincode: '124001' },
    { value: 'railway-road', label: 'Railway Road', pincode: '124001' },
    { value: 'ram-gopal-colony', label: 'Ram Gopal Colony', pincode: '124001' },
    { value: 'rohtak-bypass', label: 'Rohtak Bypass', pincode: '124001' },
    { value: 'rohtak-gaon', label: 'Rohtak Gaon', pincode: '124001' },
    { value: 'sainik-colony', label: 'Sainik Colony', pincode: '124001' },
    { value: 'sampla', label: 'Sampla', pincode: '124501' },
    { value: 'sector-2', label: 'Sector 2', pincode: '124001' },
    { value: 'sector-4', label: 'Sector 4', pincode: '124001' },
    { value: 'sector-6', label: 'Sector 6', pincode: '124001' },
    { value: 'shivaji-colony', label: 'Shivaji Colony', pincode: '124001' },
    { value: 'shyam-colony', label: 'Shyam Colony', pincode: '124001' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '124001' },
    { value: 'sukhpura-chowk', label: 'Sukhpura Chowk', pincode: '124001' },
    { value: 'sunderpura', label: 'Sunderpura', pincode: '124001' },
    { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '124001' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '124001' },
    { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '124001' },
    { value: 'yogendra-colony', label: 'Yogendra Colony', pincode: '124001' }
  ],

  'faridabad': [
    { value: 'anand-van', label: 'Anand Van', pincode: '121009' },
    { value: 'ashoka-enclave', label: 'Ashoka Enclave', pincode: '121003' },
    { value: 'badkhal', label: 'Badkhal', pincode: '121001' },
    { value: 'ballabgarh', label: 'Ballabgarh', pincode: '121004' },
    { value: 'bptp', label: 'BPTP', pincode: '121002' },
    { value: 'chandawali', label: 'Chandawali', pincode: '121004' },
    { value: 'chawla-colony', label: 'Chawla Colony', pincode: '121004' },
    { value: 'charmwood-village', label: 'Charmwood Village', pincode: '121009' },
    { value: 'dabua-colony', label: 'Dabua Colony', pincode: '121005' },
    { value: 'dayal-bagh', label: 'Dayal Bagh', pincode: '121009' },
    { value: 'fatehpur-chandela', label: 'Fatehpur Chandela', pincode: '121101' },
    { value: 'green-field-colony', label: 'Green Field Colony', pincode: '121010' },
    { value: 'indraprastha-colony', label: 'Indraprastha Colony', pincode: '121003' },
    { value: 'jasana', label: 'Jasana', pincode: '121004' },
    { value: 'kheri-road', label: 'Kheri Road', pincode: '121002' },
    { value: 'mathura-road', label: 'Mathura Road', pincode: '121003' },
    { value: 'milestone', label: 'Milestone', pincode: '121003' },
    { value: 'neharpar', label: 'Neharpar', pincode: '121002' },
    { value: 'nit', label: 'NIT (New Industrial Town)', pincode: '121001' },
    { value: 'old-faridabad', label: 'Old Faridabad', pincode: '121002' },
    { value: 'pali', label: 'Pali', pincode: '121004' },
    { value: 'rajendra-colony', label: 'Rajendra Colony', pincode: '121005' },
    { value: 'sanjay-colony', label: 'Sanjay Colony', pincode: '121005' },
    { value: 'sarai-khaja', label: 'Sarai Khaja', pincode: '121003' },
    { value: 'sarai-khwaja', label: 'Sarai Khwaja', pincode: '121003' },
    { value: 'sector-12', label: 'Sector 12', pincode: '121007' },
    { value: 'sector-14', label: 'Sector 14', pincode: '121007' },
    { value: 'sector-15', label: 'Sector 15', pincode: '121007' },
    { value: 'sector-16', label: 'Sector 16', pincode: '121002' },
    { value: 'sector-17', label: 'Sector 17', pincode: '121002' },
    { value: 'sector-19', label: 'Sector 19', pincode: '121003' },
    { value: 'sector-21', label: 'Sector 21', pincode: '121001' },
    { value: 'sector-28', label: 'Sector 28', pincode: '121008' },
    { value: 'sector-29', label: 'Sector 29', pincode: '121008' },
    { value: 'sector-31', label: 'Sector 31', pincode: '121003' },
    { value: 'sector-37', label: 'Sector 37', pincode: '121003' },
    { value: 'sector-45', label: 'Sector 45', pincode: '121010' },
    { value: 'sector-46', label: 'Sector 46', pincode: '121010' },
    { value: 'spring-field-colony', label: 'Spring Field Colony', pincode: '121003' },
    { value: 'surajkund', label: 'Surajkund', pincode: '121009' },
    { value: 'tilpat', label: 'Tilpat', pincode: '121003' }
  ],

  // Bihar Areas

  'bhagalpur': [
    { value: 'adampur', label: 'Adampur', pincode: '812001' },
    { value: 'aliganj', label: 'Aliganj', pincode: '812001' },
    { value: 'bahadurpur', label: 'Bahadurpur', pincode: '812007' },
    { value: 'bakhtiyarpur', label: 'Bakhtiyarpur', pincode: '812005' },
    { value: 'bariyarpur', label: 'Bariyarpur', pincode: '812004' },
    { value: 'barari', label: 'Barari', pincode: '812005' },
    { value: 'bhagalpur-cantt', label: 'Bhagalpur Cantt', pincode: '812001' },
    { value: 'bhagalpur-sadar', label: 'Bhagalpur Sadar', pincode: '812006' },
    { value: 'bihariganj', label: 'Bihariganj', pincode: '813202' },
    { value: 'bhusra', label: 'Bhusra', pincode: '812302' },
    { value: 'chandanpura', label: 'Chandanpura', pincode: '812007' },
    { value: 'chhathdih', label: 'Chhathdih', pincode: '812004' },
    { value: 'dainikbhaskar', label: 'Dainik Bhaskar', pincode: '812002' },
    { value: 'ekangarsarai', label: 'Ekangarsarai', pincode: '812003' },
    { value: 'gogri', label: 'Gogri', pincode: '813209' },
    { value: 'hatipar', label: 'Hatipar', pincode: '812004' },
    { value: 'jalalabad', label: 'Jalalabad', pincode: '812001' },
    { value: 'jagdishpur', label: 'Jagdishpur', pincode: '812007' },
    { value: 'kahalgaon', label: 'Kahalgaon', pincode: '813203' },
    { value: 'kamakhya', label: 'Kamakhya', pincode: '812003' },
    { value: 'karanpura', label: 'Karanpura', pincode: '812005' },
    { value: 'khirgaon', label: 'Khirgaon', pincode: '812005' },
    { value: 'kolar', label: 'Kolar', pincode: '812003' },
    { value: 'kumarjore', label: 'Kumarjore', pincode: '813210' },
    { value: 'madhopur', label: 'Madhopur', pincode: '812002' },
    { value: 'muradpur', label: 'Muradpur', pincode: '812002' },
    { value: 'nathnagar', label: 'Nathnagar', pincode: '812001' },
    { value: 'naulakha', label: 'Naulakha', pincode: '812007' },
    { value: 'patwa', label: 'Patwa', pincode: '812006' },
    { value: 'rahmapur', label: 'Rahmapur', pincode: '812003' },
    { value: 'rampur', label: 'Rampur', pincode: '812003' },
    { value: 'sadar', label: 'Sadar', pincode: '812001' },
    { value: 'sahibganj', label: 'Sahibganj', pincode: '812001' },
    { value: 'sahpur', label: 'Sahpur', pincode: '812007' },
    { value: 'sitarampur', label: 'Sitarampur', pincode: '812005' },
    { value: 'sultanganj', label: 'Sultanganj', pincode: '813213' },
    { value: 'takia', label: 'Takia', pincode: '812003' },
    { value: 'telihar', label: 'Telihar', pincode: '812004' },
    { value: 'tilkamanjhi', label: 'Tilkamanjhi', pincode: '812002' },
    { value: 'vasudevganj', label: 'Vasudevganj', pincode: '812005' }
  ],

  'nawada': [
    { value: 'adampur', label: 'Adampur', pincode: '805109' },
    { value: 'alapur', label: 'Alapur', pincode: '805140' },
    { value: 'bahadurpur', label: 'Bahadurpur', pincode: '805141' },
    { value: 'bajitpur', label: 'Bajitpur', pincode: '805110' },
    { value: 'bajrahi', label: 'Bajrahi', pincode: '805143' },
    { value: 'barahi', label: 'Barahi', pincode: '805111' },
    { value: 'bihariganj', label: 'Bihariganj', pincode: '805112' },
    { value: 'biharsharif', label: 'Bihar Sharif', pincode: '805113' },
    { value: 'bhairo', label: 'Bhairo', pincode: '805142' },
    { value: 'bhutaha', label: 'Bhutaha', pincode: '805114' },
    { value: 'chakdah', label: 'Chakdah', pincode: '805116' },
    { value: 'chandrapura', label: 'Chandrapura', pincode: '805117' },
    { value: 'chandwara', label: 'Chandwara', pincode: '805115' },
    { value: 'chiraiya', label: 'Chiraiya', pincode: '805118' },
    { value: 'gaya', label: 'Gaya', pincode: '805119' },
    { value: 'gokul', label: 'Gokul', pincode: '805144' },
    { value: 'gopalganj', label: 'Gopalganj', pincode: '805145' },
    { value: 'jatwa', label: 'Jatwa', pincode: '805120' },
    { value: 'jakri', label: 'Jakri', pincode: '805146' },
    { value: 'kachhapar', label: 'Kachhapar', pincode: '805121' },
    { value: 'kajra', label: 'Kajra', pincode: '805147' },
    { value: 'kaimur', label: 'Kaimur', pincode: '805122' },
    { value: 'khanpur', label: 'Khanpur', pincode: '805148' },
    { value: 'kharak', label: 'Kharak', pincode: '805149' },
    { value: 'khushpur', label: 'Khushpur', pincode: '805150' },
    { value: 'kundan', label: 'Kundan', pincode: '805123' },
    { value: 'kurmuri', label: 'Kurmuri', pincode: '805151' },
    { value: 'kurtha', label: 'Kurtha', pincode: '805124' },
    { value: 'latifpur', label: 'Latifpur', pincode: '805152' },
    { value: 'maheshpur', label: 'Maheshpur', pincode: '805153' },
    { value: 'manpur', label: 'Manpur', pincode: '805125' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '805126' },
    { value: 'mohani', label: 'Mohani', pincode: '805154' },
    { value: 'narainpur', label: 'Narainpur', pincode: '805128' },
    { value: 'nawada-bazar', label: 'Nawada Bazar', pincode: '805127' },
    { value: 'patahi', label: 'Patahi', pincode: '805129' },
    { value: 'patna', label: 'Patna', pincode: '805130' },
    { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '805155' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '805132' },
    { value: 'rasulpur', label: 'Rasulpur', pincode: '805156' },
    { value: 'rajauli', label: 'Rajauli', pincode: '805131' },
    { value: 'sandesh', label: 'Sandesh', pincode: '805133' },
    { value: 'sherpur', label: 'Sherpur', pincode: '805134' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '805158' },
    { value: 'sitaram', label: 'Sitaram', pincode: '805136' },
    { value: 'sonhula', label: 'Sonhula', pincode: '805159' },
    { value: 'sudama', label: 'Sudama', pincode: '805135' },
    { value: 'takiya', label: 'Takiya', pincode: '805137' },
    { value: 'tariyani', label: 'Tariyani', pincode: '805138' },
    { value: 'umrah', label: 'Umrah', pincode: '805160' },
    { value: 'wazirganj', label: 'Wazirganj', pincode: '805139' },
    { value: 'zari', label: 'Zari', pincode: '805161' }
  ],

  'moradabad': [
  { value: 'aligarh', label: 'Aligarh', pincode: '244001' },
  { value: 'bhagatpur', label: 'Bhagatpur', pincode: '244204' },
  { value: 'bilari', label: 'Bilari', pincode: '244301' },
  { value: 'chandausi', label: 'Chandausi', pincode: '244412' },
  { value: 'dholana', label: 'Dholana', pincode: '244302' },
  { value: 'gajraula', label: 'Gajraula', pincode: '244223' },
  { value: 'juma-bazar', label: 'Juma Bazar', pincode: '244403' },
  { value: 'katghar', label: 'Katghar', pincode: '244001' },
  { value: 'kashipur', label: 'Kashipur', pincode: '244713' },
  { value: 'khamaria', label: 'Khamaria', pincode: '244102' },
  { value: 'kunda', label: 'Kunda', pincode: '244102' },
  { value: 'lal-kua', label: 'Lal Kua', pincode: '244001' },
  { value: 'mandi-dyala', label: 'Mandi Dyala', pincode: '244301' },
  { value: 'mahalakshmi-vihar', label: 'Mahalakshmi Vihar', pincode: '244001' },
  { value: 'majhola', label: 'Majhola', pincode: '244104' },
  { value: 'mohammad-nagar', label: 'Mohammad Nagar', pincode: '244404' },
  { value: 'mohanpuri', label: 'Mohanpuri', pincode: '244001' },
  { value: 'mughalpura', label: 'Mughalpura', pincode: '244001' },
  { value: 'patli-khera', label: 'Patli Khera', pincode: '244303' },
  { value: 'ramgali', label: 'Ramgali', pincode: '244001' },
  { value: 'roza', label: 'Roza', pincode: '244402' },
  { value: 'shahbad', label: 'Shahbad', pincode: '244412' },
  { value: 'shekhar-vihar', label: 'Shekhar Vihar', pincode: '244001' },
  { value: 'tanda', label: 'Tanda', pincode: '244303' },
  { value: 'tariq-nagar', label: 'Tariq Nagar', pincode: '244304' },
  { value: 'tikri', label: 'Tikri', pincode: '244212' },
  { value: 'udai-ganj', label: 'Udai Ganj', pincode: '244004' },
  { value: 'zafarabad', label: 'Zafarabad', pincode: '244402' },
  { value: 'alampur', label: 'Alampur', pincode: '244203' },
  { value: 'badsahpur', label: 'Badsahpur', pincode: '244211' },
  { value: 'garh-mohammadpur', label: 'Garh Mohammadpur', pincode: '244201' },
  { value: 'ganeshpur', label: 'Ganeshpur', pincode: '244211' },
  { value: 'jhuggi-jhopdi', label: 'Jhuggi Jhopdi', pincode: '244211' },
  { value: 'kaithal', label: 'Kaithal', pincode: '244221' },
  { value: 'kasampur', label: 'Kasampur', pincode: '244201' },
  { value: 'khatoli', label: 'Khatoli', pincode: '244303' },
  { value: 'khujra', label: 'Khujra', pincode: '244204' },
  { value: 'manglaur', label: 'Manglaur', pincode: '244401' },
  { value: 'mohanpur', label: 'Mohanpur', pincode: '244202' },
  { value: 'naushera', label: 'Naushera', pincode: '244303' },
  { value: 'purwa', label: 'Purwa', pincode: '244301' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '244301' },
  { value: 'saharabad', label: 'Saharabad', pincode: '244102' },
  { value: 'village-pipalia', label: 'Village Pipalia', pincode: '244302' }
  ],

  'raebareli': [
  { value: 'amalipur', label: 'Amalipur', pincode: '229001' },
  { value: 'babhani', label: 'Babhani', pincode: '229001' },
  { value: 'barchha', label: 'Barchha', pincode: '229101' },
  { value: 'barwan', label: 'Barwan', pincode: '229204' },
  { value: 'chhatrapur', label: 'Chhatrapur', pincode: '229101' },
  { value: 'chaturbhujpur', label: 'Chaturbhujpur', pincode: '229010' },
  { value: 'dalmau', label: 'Dalmau', pincode: '229205' },
  { value: 'harbanspur', label: 'Harbanspur', pincode: '229204' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '229302' },
  { value: 'jhalon', label: 'Jhalon', pincode: '229205' },
  { value: 'khwaja-begum', label: 'Khwaja Begum', pincode: '229302' },
  { value: 'kunda', label: 'Kunda', pincode: '229204' },
  { value: 'maurawan', label: 'Maurawan', pincode: '229305' },
  { value: 'parsi-tola', label: 'Parsi Tola', pincode: '229101' },
  { value: 'rampur', label: 'Rampur', pincode: '229301' },
  { value: 'raebareli', label: 'Raebareli', pincode: '229001' },
  { value: 'sarai-babool', label: 'Sarai Babool', pincode: '229203' },
  { value: 'sitauli', label: 'Sitauli', pincode: '229204' },
  { value: 'sudama-pur', label: 'Sudama Pur', pincode: '229306' },
  { value: 'taharpur', label: 'Taharpur', pincode: '229305' },
  { value: 'tatarpur', label: 'Tatarpur', pincode: '229307' },
  { value: 'afgan-pur', label: 'Afgan Pur', pincode: '229204' },
  { value: 'bakshi-pur', label: 'Bakshi Pur', pincode: '229305' },
  { value: 'bhurwal', label: 'Bhurwal', pincode: '229306' },
  { value: 'bichhiya', label: 'Bichhiya', pincode: '229204' },
  { value: 'deoband', label: 'Deoband', pincode: '229307' },
  { value: 'ganesh-pur', label: 'Ganesh Pur', pincode: '229308' },
  { value: 'ishwar-pur', label: 'Ishwar Pur', pincode: '229302' },
  { value: 'jiyan-pur', label: 'Jiyan Pur', pincode: '229202' },
  { value: 'kamrauli', label: 'Kamrauli', pincode: '229204' },
  { value: 'karari', label: 'Karari', pincode: '229307' },
  { value: 'krishnapur', label: 'Krishnapur', pincode: '229306' },
  { value: 'mohammad-pur', label: 'Mohammad Pur', pincode: '229201' },
  { value: 'mukund-pur', label: 'Mukund Pur', pincode: '229305' },
  { value: 'nandpur', label: 'Nandpur', pincode: '229307' },
  { value: 'noorpur', label: 'Noorpur', pincode: '229301' },
  { value: 'pali', label: 'Pali', pincode: '229301' },
  { value: 'parichha', label: 'Parichha', pincode: '229301' },
  { value: 'sarauli', label: 'Sarauli', pincode: '229305' },
  { value: 'shahpur', label: 'Shahpur', pincode: '229202' },
  { value: 'sultanpur', label: 'Sultanpur', pincode: '229301' },
  { value: 'taj-pur', label: 'Taj Pur', pincode: '229302' }
  ],

  //Madhya Pradesh Areas
  'ujjain': [
  { value: 'abeel', label: 'Abeel', pincode: '456001' },
  { value: 'anaj-mandi', label: 'Anaj Mandi', pincode: '456010' },
  { value: 'bal-nagar', label: 'Bal Nagar', pincode: '456010' },
  { value: 'bhairavgarh', label: 'Bhairavgarh', pincode: '456006' },
  { value: 'bilakhedi', label: 'Bilakhedi', pincode: '456001' },
  { value: 'chimanganj', label: 'Chimanganj', pincode: '456001' },
  { value: 'dharampuri', label: 'Dharampuri', pincode: '456006' },
  { value: 'ghatgate', label: 'Ghatgate', pincode: '456001' },
  { value: 'gopalpura', label: 'Gopalpura', pincode: '456010' },
  { value: 'ghosi', label: 'Ghosi', pincode: '456007' },
  { value: 'jaisinghpura', label: 'Jaisinghpura', pincode: '456001' },
  { value: 'kalapathar', label: 'Kalapathar', pincode: '456006' },
  { value: 'kishanpura', label: 'Kishanpura', pincode: '456006' },
  { value: 'khalwada', label: 'Khalwada', pincode: '456001' },
  { value: 'mahakal', label: 'Mahakal', pincode: '456001' },
  { value: 'malipura', label: 'Malipura', pincode: '456007' },
  { value: 'mangal-nagar', label: 'Mangal Nagar', pincode: '456010' },
  { value: 'mandi', label: 'Mandi', pincode: '456010' },
  { value: 'neelganga', label: 'Neelganga', pincode: '456003' },
  { value: 'pahadi', label: 'Pahadi', pincode: '456006' },
  { value: 'panchpavdi', label: 'Panchpavdi', pincode: '456010' },
  { value: 'pipal-gaon', label: 'Pipal Gaon', pincode: '456001' },
  { value: 'paranjpe-nagar', label: 'Paranjpe Nagar', pincode: '456001' },
  { value: 'ramghat', label: 'Ramghat', pincode: '456006' },
  { value: 'ranipura', label: 'Ranipura', pincode: '456001' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '456001' },
  { value: 'sahastra-dham', label: 'Sahastra Dham', pincode: '456001' },
  { value: 'satnami-nagar', label: 'Satnami Nagar', pincode: '456001' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '456010' },
  { value: 'sudama-nagar', label: 'Sudama Nagar', pincode: '456006' },
  { value: 'tankiya', label: 'Tankiya', pincode: '456001' },
  { value: 'upkothi', label: 'Upkothi', pincode: '456001' },
  { value: 'vishwakarma-nagar', label: 'Vishwakarma Nagar', pincode: '456010' },
  { value: 'badi-bari', label: 'Badi Bari', pincode: '456001' },
  { value: 'bara-pahadi', label: 'Bara Pahadi', pincode: '456010' },
  { value: 'basant-vihar', label: 'Basant Vihar', pincode: '456010' },
  { value: 'bhanwarkuan', label: 'Bhanwarkuan', pincode: '456002' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '456002' },
  { value: 'khadki', label: 'Khadki', pincode: '456010' },
  { value: 'kothi', label: 'Kothi', pincode: '456001' },
  { value: 'mohammad-pura', label: 'Mohammad Pura', pincode: '456010' },
  { value: 'naulakha', label: 'Naulakha', pincode: '456001' }
  ],

   //Maharastra Areas
  'aurangabad': [
  { value: 'adgaon', label: 'Adgaon', pincode: '431001' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '431006' },
  { value: 'cidco', label: 'Cidco', pincode: '431003' },
  { value: 'ekmala', label: 'Ekmala', pincode: '431003' },
  { value: 'garkheda', label: 'Garkheda', pincode: '431001' },
  { value: 'godavari', label: 'Godavari', pincode: '431002' },
  { value: 'jambhli', label: 'Jambhli', pincode: '431006' },
  { value: 'karmad', label: 'Karmad', pincode: '431001' },
  { value: 'khandvi', label: 'Khandvi', pincode: '431002' },
  { value: 'kriti-nagar', label: 'Kriti Nagar', pincode: '431005' },
  { value: 'lokmanya-nagar', label: 'Lokmanya Nagar', pincode: '431002' },
  { value: 'mahalaxmi', label: 'Mahalaxmi', pincode: '431003' },
  { value: 'mitha-nagar', label: 'Mitha Nagar', pincode: '431005' },
  { value: 'navkhanda', label: 'Navkhanda', pincode: '431004' },
  { value: 'railway-station', label: 'Railway Station', pincode: '431001' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '431001' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '431001' },
  { value: 'shahnoor', label: 'Shahnoor', pincode: '431001' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '431001' },
  { value: 'siddharth-nagar', label: 'Siddharth Nagar', pincode: '431003' },
  { value: 'telenkheda', label: 'Telenkheda', pincode: '431003' },
  { value: 'vishnupuri', label: 'Vishnupuri', pincode: '431003' },
  { value: 'waluj', label: 'Waluj', pincode: '431136' },
  { value: 'malwadi', label: 'Malwadi', pincode: '431002' },
  { value: 'madhavnagar', label: 'Madhavnagar', pincode: '431002' },
  { value: 'tirupati-nagar', label: 'Tirupati Nagar', pincode: '431003' },
  { value: 'bibi-ka-maqbara', label: 'Bibi Ka Maqbara', pincode: '431001' },
  { value: 'paithan', label: 'Paithan', pincode: '431107' },
  { value: 'sant-nagar', label: 'Sant Nagar', pincode: '431003' },
  { value: 'arunoday', label: 'Arunoday', pincode: '431002' },
  { value: 'belura', label: 'Belura', pincode: '431114' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '431101' },
  { value: 'chikhalthana', label: 'Chikhalthana', pincode: '431003' },
  { value: 'dehugaon', label: 'Dehugaon', pincode: '431004' },
  { value: 'jadhavwadi', label: 'Jadhavwadi', pincode: '431005' },
  { value: 'kaula', label: 'Kaula', pincode: '431102' },
  { value: 'kothali', label: 'Kothali', pincode: '431005' },
  { value: 'majrewadi', label: 'Majrewadi', pincode: '431004' },
  { value: 'manjlegaon', label: 'Manjlegaon', pincode: '431003' },
  { value: 'muktapur', label: 'Muktapur', pincode: '431105' },
  { value: 'nimbalkheda', label: 'Nimbalkheda', pincode: '431106' },
  { value: 'pimpalwadi', label: 'Pimpalwadi', pincode: '431005' },
  { value: 'rishipura', label: 'Rishipura', pincode: '431005' },
  { value: 'sanghavi', label: 'Sanghavi', pincode: '431002' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '431003' },
  { value: 'sonari', label: 'Sonari', pincode: '431001' },
  { value: 'tuljapur', label: 'Tuljapur', pincode: '431001' },
  { value: 'vaygaon', label: 'Vaygaon', pincode: '431108' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '431004' },
  { value: 'boradi', label: 'Boradi', pincode: '431101' },
  { value: 'malkapur', label: 'Malkapur', pincode: '431107' },
  { value: 'pachod', label: 'Pachod', pincode: '431115' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '431004' },
  { value: 'kankori', label: 'Kankori', pincode: '431106' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '431101' },
  { value: 'waluj-industrial-estate', label: 'Waluj Industrial Estate', pincode: '431136' },
  { value: 'dundahera', label: 'Dundahera', pincode: '431001' },
  { value: 'andherwadi', label: 'Andherwadi', pincode: '431106' },
  { value: 'nagapur', label: 'Nagapur', pincode: '431002' }
  ],

  //Gujarat Areas
  
  'surat': [
  { value: 'adajan', label: 'Adajan', pincode: '395009' },
  { value: 'althan', label: 'Althan', pincode: '395017' },
  { value: 'bhatar', label: 'Bhatar', pincode: '395007' },
  { value: 'city-light', label: 'City Light', pincode: '395007' },
  { value: 'gopipura', label: 'Gopipura', pincode: '395001' },
  { value: 'icc', label: 'ICC', pincode: '395003' },
  { value: 'kadodra', label: 'Kadodra', pincode: '394107' },
  { value: 'lambha', label: 'Lambha', pincode: '394107' },
  { value: 'mota-varachha', label: 'Mota Varachha', pincode: '394107' },
  { value: 'nana-varachha', label: 'Nana Varachha', pincode: '395006' },
  { value: 'pandesara', label: 'Pandesara', pincode: '394107' },
  { value: 'parvat-pate', label: 'Parvat Pate', pincode: '395001' },
  { value: 'piplod', label: 'Piplod', pincode: '395007' },
  { value: 'railwaystation', label: 'Railway Station', pincode: '395003' },
  { value: 'sachin', label: 'Sachin', pincode: '394107' },
  { value: 'sarangpur', label: 'Sarangpur', pincode: '395002' },
  { value: 'sudama-nagar', label: 'Sudama Nagar', pincode: '395007' },
  { value: 'tapi-nagar', label: 'Tapi Nagar', pincode: '395003' },
  { value: 'umra', label: 'Umra', pincode: '395007' },
  { value: 'vadodara-road', label: 'Vadodara Road', pincode: '394107' },
  { value: 'vanz', label: 'Vanz', pincode: '395002' },
  { value: 'vesu', label: 'Vesu', pincode: '395007' },
  { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '395007' },
  { value: 'alipore', label: 'Alipore', pincode: '395002' },
  { value: 'bajwa', label: 'Bajwa', pincode: '394107' },
  { value: 'dumas', label: 'Dumas', pincode: '395007' },
  { value: 'fulpada', label: 'Fulpada', pincode: '394107' },
  { value: 'gondal', label: 'Gondal', pincode: '394107' },
  { value: 'gulabnagar', label: 'Gulabnagar', pincode: '395002' },
  { value: 'jahangirpura', label: 'Jahangirpura', pincode: '395005' },
  { value: 'khadki', label: 'Khadki', pincode: '394107' },
  { value: 'lalbaug', label: 'Lalbaug', pincode: '395003' },
  { value: 'makarpura', label: 'Makarpura', pincode: '394107' },
  { value: 'manjalpur', label: 'Manjalpur', pincode: '395007' },
  { value: 'mota-varachha', label: 'Mota Varachha', pincode: '394107' },
  { value: 'narmada-nagar', label: 'Narmada Nagar', pincode: '395005' },
  { value: 'narayan-nagar', label: 'Narayan Nagar', pincode: '395010' },
  { value: 'sudama-nagar', label: 'Sudama Nagar', pincode: '395007' },
  { value: 'surat-railwaystation', label: 'Surat Railway Station', pincode: '395003' },
  { value: 'tapi-nagar', label: 'Tapi Nagar', pincode: '395003' },
  { value: 'uma-nagar', label: 'Uma Nagar', pincode: '395003' },
  { value: 'varachha', label: 'Varachha', pincode: '394107' }
  ],


'vadodara': [
  { value: 'airport-harni-main-road', label: 'Airport Harni Main Road', pincode: '390022' },
  { value: 'ajwa-road', label: 'Ajwa Road', pincode: '390019' },
  { value: 'akota', label: 'Akota', pincode: '390020' },
  { value: 'akota-road', label: 'Akota Road', pincode: '390020' },
  { value: 'alkapuri', label: 'Alkapuri', pincode: '390007' },
  { value: 'asoj', label: 'Asoj', pincode: '391510' },
  { value: 'atladara', label: 'Atladara', pincode: '390012' },
  { value: 'bajwa', label: 'Bajwa', pincode: '391310' },
  { value: 'bakrawadi', label: 'Bakrawadi', pincode: '390008' },
  { value: 'bapunagar', label: 'Bapunagar', pincode: '390022' },
  { value: 'bhayli', label: 'Bhayli', pincode: '391410' },
  { value: 'bhayli-road', label: 'Bhayli Road', pincode: '391410' },
  { value: 'bil-chapad-road', label: 'Bil-Chapad Road', pincode: '390017' },
  { value: 'bill-road', label: 'Bill Road', pincode: '390001' },
  { value: 'chhani', label: 'Chhani', pincode: '390024' },
  { value: 'chhani-jakat-naka', label: 'Chhani Jakat Naka', pincode: '390024' },
  { value: 'chipad', label: 'Chipad', pincode: '391240' },
  { value: 'chokshi-bazar', label: 'Chokshi Bazar', pincode: '390001' },
  { value: 'dabhoi', label: 'Dabhoi', pincode: '391110' },
  { value: 'dabhoi-road', label: 'Dabhoi Road', pincode: '390015' },
  { value: 'dandia-bazar', label: 'Dandia Bazar', pincode: '390001' },
  { value: 'danteshwar', label: 'Danteshwar', pincode: '390004' },
  { value: 'darshali', label: 'Darshali', pincode: '391510' },
  { value: 'dashrath', label: 'Dashrath', pincode: '391107' },
  { value: 'diwalipura', label: 'Diwalipura', pincode: '390002' },
  { value: 'dumad', label: 'Dumad', pincode: '391110' },
  { value: 'ellora-park', label: 'Ellora Park', pincode: '390023' },
  { value: 'fatehgunj', label: 'Fatehgunj', pincode: '390002' },
  { value: 'gorwa', label: 'Gorwa', pincode: '390016' },
  { value: 'gotri', label: 'Gotri', pincode: '390021' },
  { value: 'gotri-road', label: 'Gotri Road', pincode: '390021' },
  { value: 'halol', label: 'Halol', pincode: '391520' },
  { value: 'harinagar', label: 'Harinagar', pincode: '390022' },
  { value: 'haripura', label: 'Haripura', pincode: '390001' },
  { value: 'harni', label: 'Harni', pincode: '390022' },
  { value: 'harni-road', label: 'Harni Road', pincode: '390022' },
  { value: 'jambubet', label: 'Jambubet', pincode: '390019' },
  { value: 'jambuva', label: 'Jambuva', pincode: '391110' },
  { value: 'jarod', label: 'Jarod', pincode: '391510' },
  { value: 'jaspur', label: 'Jaspur', pincode: '391310' },
  { value: 'jetalpur-road', label: 'Jetalpur Road', pincode: '390004' },
  { value: 'kalali', label: 'Kalali', pincode: '390026' },
  { value: 'kalali-road', label: 'Kalali Road', pincode: '390026' },
  { value: 'kapurai-village', label: 'Kapurai Village', pincode: '391520' },
  { value: 'karadiya', label: 'Karadiya', pincode: '391510' },
  { value: 'karelibaug', label: 'Karelibaug', pincode: '390018' },
  { value: 'karjan', label: 'Karjan', pincode: '391240' },
  { value: 'kendranagar', label: 'Kendranagar', pincode: '390023' },
  { value: 'kevdabaug', label: 'Kevdabaug', pincode: '390001' },
  { value: 'khanpur', label: 'Khanpur', pincode: '390001' },
  { value: 'khatamba', label: 'Khatamba', pincode: '391530' },
  { value: 'kishanwadi', label: 'Kishanwadi', pincode: '391240' },
  { value: 'kodarvaya', label: 'Kodarvaya', pincode: '391520' },
  { value: 'koyali', label: 'Koyali', pincode: '391330' },
  { value: 'lalbaug', label: 'Lalbaug', pincode: '390002' },
  { value: 'laxmipura', label: 'Laxmipura', pincode: '391101' },
  { value: 'madhavpura', label: 'Madhavpura', pincode: '390004' },
  { value: 'mahapura', label: 'Mahapura', pincode: '391510' },
  { value: 'makarpura', label: 'Makarpura', pincode: '390010' },
  { value: 'mandvi', label: 'Mandvi', pincode: '390001' },
  { value: 'maneja', label: 'Maneja', pincode: '391240' },
  { value: 'manjalpur', label: 'Manjalpur', pincode: '390011' },
  { value: 'manjusar', label: 'Manjusar', pincode: '391740' },
  { value: 'moghul-wada', label: 'Moghul Wada', pincode: '390001' },
  { value: 'muj-mahuda', label: 'Muj Mahuda', pincode: '391240' },
  { value: 'mujar-gamdi', label: 'Mujar Gamdi', pincode: '391520' },
  { value: 'nagarwada', label: 'Nagarwada', pincode: '391310' },
  { value: 'nandesari', label: 'Nandesari', pincode: '391340' },
  { value: 'nani-bapod', label: 'Nani Bapod', pincode: '391240' },
  { value: 'navapura', label: 'Navapura', pincode: '390001' },
  { value: 'new-alkapuri', label: 'New Alkapuri', pincode: '390007' },
  { value: 'new-karelibaug', label: 'New Karelibaug', pincode: '390018' },
  { value: 'new-sama', label: 'New Sama', pincode: '390008' },
  { value: 'new-sama-bhadran-nagar', label: 'New Sama Bhadran Nagar', pincode: '390008' },
  { value: 'new-sama-road', label: 'New Sama Road', pincode: '390008' },
  { value: 'new-vip-road', label: 'New VIP Road', pincode: '390019' },
  { value: 'nizampura', label: 'Nizampura', pincode: '390002' },
  { value: 'old-padra-road', label: 'Old Padra Road', pincode: '390020' },
  { value: 'padra', label: 'Padra', pincode: '391440' },
  { value: 'padra-road', label: 'Padra Road', pincode: '391440' },
  { value: 'panchvati', label: 'Panchvati', pincode: '390006' },
  { value: 'parda-road', label: 'Parda Road', pincode: '391240' },
  { value: 'pratapgunj', label: 'Pratapgunj', pincode: '390002' },
  { value: 'pratham-upvan', label: 'Pratham Upvan', pincode: '390019' },
  { value: 'productivity-road', label: 'Productivity Road', pincode: '390007' },
  { value: 'puniyad', label: 'Puniyad', pincode: '391240' },
  { value: 'race-course', label: 'Race Course', pincode: '390007' },
  { value: 'ramwadi', label: 'Ramwadi', pincode: '390019' },
  { value: 'ranoli', label: 'Ranoli', pincode: '391350' },
  { value: 'raopura', label: 'Raopura', pincode: '390001' },
  { value: 'rasulabad', label: 'Rasulabad', pincode: '390004' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '391510' },
  { value: 'ravaliya-mahudevegon', label: 'Ravaliya Mahudevegon', pincode: '391520' },
  { value: 'saiyed-vasna', label: 'Saiyed Vasna', pincode: '390008' },
  { value: 'sama', label: 'Sama', pincode: '390008' },
  { value: 'sama-savil-road', label: 'Sama-Savil Road', pincode: '390008' },
  { value: 'samta', label: 'Samta', pincode: '391520' },
  { value: 'sangma', label: 'Sangma', pincode: '391240' },
  { value: 'sankarda', label: 'Sankarda', pincode: '391240' },
  { value: 'sankhyad', label: 'Sankhyad', pincode: '391510' },
  { value: 'sayaji-park-society', label: 'Sayaji Park Society', pincode: '390005' },
  { value: 'sayajigunj', label: 'Sayajigunj', pincode: '390005' },
  { value: 'sevasi', label: 'Sevasi', pincode: '391101' },
  { value: 'sherkhi', label: 'Sherkhi', pincode: '391510' },
  { value: 'shiyabaug', label: 'Shiyabaug', pincode: '390001' },
  { value: 'shukla-nagar', label: 'Shukla Nagar', pincode: '390001' },
  { value: 'siddharth-nagar', label: 'Siddharth Nagar', pincode: '390001' },
  { value: 'sokhda', label: 'Sokhda', pincode: '391240' },
  { value: 'soma-talav', label: 'Soma Talav', pincode: '390019' },
  { value: 'somnath-nagar', label: 'Somnath Nagar', pincode: '390022' },
  { value: 'subhanpura', label: 'Subhanpura', pincode: '390023' },
  { value: 'sultanpura', label: 'Sultanpura', pincode: '390001' },
  { value: 'sun-pharma-road', label: 'Sun Pharma Road', pincode: '390019' },
  { value: 'suryanagar', label: 'Suryanagar', pincode: '390022' },
  { value: 'talsat', label: 'Talsat', pincode: '391520' },
  { value: 'tandalja', label: 'Tandalja', pincode: '390012' },
  { value: 'tarsali', label: 'Tarsali', pincode: '391240' },
  { value: 'umeta', label: 'Umeta', pincode: '391120' },
  { value: 'undera', label: 'Undera', pincode: '391120' },
  { value: 'anklav-road', label: 'Anklav Road', pincode: '391510' },
  { value: 'halol-highway', label: 'Halol Highway', pincode: '391510' },
  { value: 'vadsar', label: 'Vadsar', pincode: '391340' },
  { value: 'vasna', label: 'Vasna', pincode: '390015' },
  { value: 'vasna-road', label: 'Vasna Road', pincode: '390015' },
  { value: 'vasna-bhayli-road', label: 'Vasna-Bhayli Road', pincode: '391410' },
  { value: 'vemali', label: 'Vemali', pincode: '391740' },
  { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '390019' },
  { value: 'vip-road', label: 'VIP Road', pincode: '390019' },
  { value: 'vishwamitri', label: 'Vishwamitri', pincode: '390011' },
  { value: 'wadi', label: 'Wadi', pincode: '391520' },
  { value: 'waghodia', label: 'Waghodia', pincode: '391760' },
  { value: 'waghodia-road', label: 'Waghodia Road', pincode: '391760' },
  { value: 'warasiya', label: 'Warasiya', pincode: '390025' }
  ],
  //Chattisgarh Areas
  'kondagaon.': [
  { value: 'adpar', label: 'Adpar', pincode: '494226' },
  { value: 'balod', label: 'Balod', pincode: '494001' },
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '493332' },
  { value: 'barmuda', label: 'Barmuda', pincode: '494441' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '494449' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '494116' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'dharsiwa', label: 'Dharsiwa', pincode: '493539' },
  { value: 'futera', label: 'Futera', pincode: '494313' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jaitala', label: 'Jaitala', pincode: '494440' },
  { value: 'kanhan', label: 'Kanhan', pincode: '494117' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '494226' },
  { value: 'kutelabod', label: 'Kutelabod', pincode: '494230' },
  { value: 'kurud', label: 'Kurud', pincode: '494277' },
  { value: 'latapara', label: 'Latapara', pincode: '494230' },
  { value: 'manpur', label: 'Manpur', pincode: '494331' },
  { value: 'mohla', label: 'Mohla', pincode: '494334' },
  { value: 'nailkanta', label: 'Nailkanta', pincode: '494347' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'tilda', label: 'Tilda', pincode: '493003' },
  { value: 'tulsi', label: 'Tulsi', pincode: '494339' },
  { value: 'urla', label: 'Urla', pincode: '494107' },
  { value: 'waraseoni', label: 'Waraseoni', pincode: '494234' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'bhilai-charoda', label: 'Bhilai Charoda', pincode: '490025' },
  { value: 'sirsa', label: 'Sirsa', pincode: '491333' },
  { value: 'patan', label: 'Patan', pincode: '494115' },
  { value: 'padampur', label: 'Padampur', pincode: '494448' },
  { value: 'kerakachhar', label: 'Kerakachhar', pincode: '494113' },
  { value: 'beldongri', label: 'Beldongri', pincode: '491229' },
  { value: 'jamgaon', label: 'Jamgaon', pincode: '494340' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '494343' },
  { value: 'pargahan', label: 'Pargahan', pincode: '494229' },
  { value: 'sihora', label: 'Sihora', pincode: '494114' }
  ],

  'nagri': [
  { value: 'adpar', label: 'Adpar', pincode: '494226' },
  { value: 'balod', label: 'Balod', pincode: '494001' },
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '493332' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '494449' },
  { value: 'buddhanagar', label: 'Buddhanagar', pincode: '494226' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '494116' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'dharsiwa', label: 'Dharsiwa', pincode: '493539' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jamgaon', label: 'Jamgaon', pincode: '494447' },
  { value: 'jaitala', label: 'Jaitala', pincode: '494440' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '494226' },
  { value: 'kutelabod', label: 'Kutelabod', pincode: '494230' },
  { value: 'kurud', label: 'Kurud', pincode: '494277' },
  { value: 'latapara', label: 'Latapara', pincode: '494230' },
  { value: 'manpur', label: 'Manpur', pincode: '494331' },
  { value: 'mohla', label: 'Mohla', pincode: '494334' },
  { value: 'nailkanta', label: 'Nailkanta', pincode: '494347' },
  { value: 'padampur', label: 'Padampur', pincode: '494448' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '494343' },
  { value: 'sirsa', label: 'Sirsa', pincode: '491333' },
  { value: 'tilda', label: 'Tilda', pincode: '493003' },
  { value: 'tulsi', label: 'Tulsi', pincode: '494339' },
  { value: 'urla', label: 'Urla', pincode: '494107' },
  { value: 'waraseoni', label: 'Waraseoni', pincode: '494234' }
  ],

  'antagarh': [
  { value: 'antagarh', label: 'Antagarh', pincode: '494661' },
  { value: 'baihar', label: 'Baihar', pincode: '494223' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '494662' },
  { value: 'dudhapara', label: 'Dudhapara', pincode: '494663' },
  { value: 'ghatakesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jagdalpur', label: 'Jagdalpur', pincode: '494001' },
  { value: 'kanker', label: 'Kanker', pincode: '494334' },
  { value: 'kudegaon', label: 'Kudegaon', pincode: '494665' },
  { value: 'mahasamund', label: 'Mahasamund', pincode: '493445' },
  { value: 'nagarnar', label: 'Nagarnar', pincode: '494001' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '494661' },
  { value: 'pallid', label: 'Pallid', pincode: '494337' },
  { value: 'patwadhara', label: 'Patwadhara', pincode: '494332' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'rajapara', label: 'Rajapara', pincode: '494339' },
  { value: 'sarapali', label: 'Sarapali', pincode: '494337' },
  { value: 'tirathgarh', label: 'Tirathgarh', pincode: '494233' },
  { value: 'bijapur', label: 'Bijapur', pincode: '494444' },
  { value: 'boregaon', label: 'Boregaon', pincode: '494449' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '494667' },
  { value: 'chhattisgarh', label: 'Chhattisgarh', pincode: '494001' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '494333' },
  { value: 'gunja', label: 'Gunja', pincode: '494232' },
  { value: 'kutru', label: 'Kutru', pincode: '494119' },
  { value: 'kudegaon', label: 'Kudegaon', pincode: '494666' },
  { value: 'mandirhasaud', label: 'Mandirhasaud', pincode: '492001' },
  { value: 'sarguja', label: 'Sarguja', pincode: '497001' },
  { value: 'shivani', label: 'Shivani', pincode: '494322' },
  { value: 'sukma', label: 'Sukma', pincode: '494111' },
  { value: 'surajpur', label: 'Surajpur', pincode: '497229' },
  { value: 'tirathgarh', label: 'Tirathgarh', pincode: '494233' },
  { value: 'tokapal', label: 'Tokapal', pincode: '494114' }
  ],

  'baikunthpur': [
  { value: 'baikunthpur', label: 'Baikunthpur', pincode: '497335' },
  { value: 'babhani', label: 'Babhani', pincode: '497335' },
  { value: 'balhajar', label: 'Balhajar', pincode: '497336' },
  { value: 'bandhpur', label: 'Bandhpur', pincode: '497332' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '497337' },
  { value: 'boregaon', label: 'Boregaon', pincode: '497338' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '497340' },
  { value: 'chhattisgarh', label: 'Chhattisgarh', pincode: '497341' },
  { value: 'dakshin', label: 'Dakshin', pincode: '497332' },
  { value: 'dabra', label: 'Dabra', pincode: '497333' },
  { value: 'gariyaband', label: 'Gariyaband', pincode: '497344' },
  { value: 'jhitku', label: 'Jhitku', pincode: '497335' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '497337' },
  { value: 'kharsia', label: 'Kharsia', pincode: '497346' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '497331' },
  { value: 'kondgaon', label: 'Kondgaon', pincode: '497334' },
  { value: 'manpur', label: 'Manpur', pincode: '497338' },
  { value: 'pathalgaon', label: 'Pathalgaon', pincode: '497344' },
  { value: 'raigarh', label: 'Raigarh', pincode: '496001' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '497345' },
  { value: 'rawan', label: 'Rawan', pincode: '497343' },
  { value: 'sarangarh', label: 'Sarangarh', pincode: '497347' },
  { value: 'shivrinarayan', label: 'Shivrinarayan', pincode: '497348' },
  { value: 'tendua', label: 'Tendua', pincode: '497349' },
  { value: 'tulsi', label: 'Tulsi', pincode: '497350' },
  { value: 'khairagarh', label: 'Khairagarh', pincode: '491881' },
  { value: 'ponmuda', label: 'Ponmuda', pincode: '497351' },
  { value: 'lailunga', label: 'Lailunga', pincode: '497352' },
  { value: 'kawardha', label: 'Kawardha', pincode: '491995' },
  { value: 'dondilohara', label: 'Dondilohara', pincode: '491773' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '495001' },
  { value: 'seoni', label: 'Seoni', pincode: '497353' },
  { value: 'pali', label: 'Pali', pincode: '497354' },
  { value: 'tamar', label: 'Tamar', pincode: '497355' },
  { value: 'berla', label: 'Berla', pincode: '491335' }
  ],

  'balod': [
  { value: 'balod', label: 'Balod', pincode: '491227' },
  { value: 'bhatauli', label: 'Bhatauli', pincode: '491228' },
  { value: 'bharatpur', label: 'Bharatpur', pincode: '491229' },
  { value: 'birsinghpur', label: 'Birsinghpur', pincode: '491230' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '491231' },
  { value: 'dondi', label: 'Dondi', pincode: '491232' },
  { value: 'gundardehi', label: 'Gundardehi', pincode: '491233' },
  { value: 'kurud', label: 'Kurud', pincode: '491234' },
  { value: 'mohgaon', label: 'Mohgaon', pincode: '491235' },
  { value: 'pali', label: 'Pali', pincode: '491236' },
  { value: 'pendri', label: 'Pendri', pincode: '491237' },
  { value: 'raikheda', label: 'Raikheda', pincode: '491238' },
  { value: 'sakur', label: 'Sakur', pincode: '491239' },
  { value: 'samri', label: 'Samri', pincode: '491240' },
  { value: 'turiya', label: 'Turiya', pincode: '491241' },
  { value: 'bhatapara', label: 'Bhatapara', pincode: '491442' },
  { value: 'dhamdha', label: 'Dhamdha', pincode: '491226' },
  { value: 'jamul', label: 'Jamul', pincode: '491289' },
  { value: 'khamharia', label: 'Khamharia', pincode: '491243' },
  { value: 'kuchadapara', label: 'Kuchadapara', pincode: '491244' },
  { value: 'mohpa', label: 'Mohpa', pincode: '491245' },
  { value: 'nawagaon', label: 'Nawagaon', pincode: '491246' },
  { value: 'neora', label: 'Neora', pincode: '491247' },
  { value: 'patan', label: 'Patan', pincode: '491248' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'sonakhan', label: 'Sonakhan', pincode: '491249' },
  { value: 'baroud', label: 'Baroud', pincode: '491250' },
  { value: 'bhanwar', label: 'Bhanwar', pincode: '491251' },
  { value: 'chikhli', label: 'Chikhli', pincode: '491252' },
  { value: 'dharsiwa', label: 'Dharsiwa', pincode: '492010' },
  { value: 'katora', label: 'Katora', pincode: '491253' },
  { value: 'kudri', label: 'Kudri', pincode: '491254' },
  { value: 'kundel', label: 'Kundel', pincode: '491255' },
  { value: 'raikhedi', label: 'Raikhedi', pincode: '491256' },
  { value: 'saja', label: 'Saja', pincode: '491257' },
  { value: 'salkha', label: 'Salkha', pincode: '491258' },
  { value: 'tilda', label: 'Tilda', pincode: '491159' },
  { value: 'mohandi', label: 'Mohandi', pincode: '491259' }
  ],

  'baloda-bazar': [
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '493332' },
  { value: 'bajabachra', label: 'Bajabachra', pincode: '493333' },
  { value: 'bhendra', label: 'Bhendra', pincode: '493334' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'gorakhpur', label: 'Gorakhpur', pincode: '493335' },
  { value: 'janjgir', label: 'Janjgir', pincode: '493441' },
  { value: 'kawardha', label: 'Kawardha', pincode: '491995' },
  { value: 'khursura', label: 'Khursura', pincode: '493336' },
  { value: 'koni', label: 'Koni', pincode: '493337' },
  { value: 'kudri', label: 'Kudri', pincode: '493338' },
  { value: 'mohandi', label: 'Mohandi', pincode: '493339' },
  { value: 'nawapara', label: 'Nawapara', pincode: '493340' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'saja', label: 'Saja', pincode: '493341' },
  { value: 'salkha', label: 'Salkha', pincode: '493342' },
  { value: 'tilda', label: 'Tilda', pincode: '491159' },
  { value: 'barbahra', label: 'Barbahra', pincode: '493343' },
  { value: 'bhanwar', label: 'Bhanwar', pincode: '493344' },
  { value: 'chirri', label: 'Chirri', pincode: '493345' },
  { value: 'gunderdehi', label: 'Gunderdehi', pincode: '493346' },
  { value: 'katorapara', label: 'Katorapara', pincode: '493347' },
  { value: 'khadari', label: 'Khadari', pincode: '493348' },
  { value: 'pachpedi', label: 'Pachpedi', pincode: '493349' },
  { value: 'raikheda', label: 'Raikheda', pincode: '493350' },
  { value: 'saragaon', label: 'Saragaon', pincode: '493351' },
  { value: 'sonakhan', label: 'Sonakhan', pincode: '493352' },
  { value: 'tulsi', label: 'Tulsi', pincode: '493353' },
  { value: 'pathalgaon', label: 'Pathalgaon', pincode: '493354' },
  { value: 'singhpur', label: 'Singhpur', pincode: '493355' },
  { value: 'belha', label: 'Belha', pincode: '493356' },
  { value: 'bhoriya', label: 'Bhoriya', pincode: '493357' },
  { value: 'dongargarh', label: 'Dongargarh', pincode: '491445' },
  { value: 'kachewani', label: 'Kachewani', pincode: '493358' },
  { value: 'mohgaon', label: 'Mohgaon', pincode: '493359' },
  { value: 'pali', label: 'Pali', pincode: '493360' },
  { value: 'dhamdha', label: 'Dhamdha', pincode: '493361' },
  { value: 'nausar', label: 'Nausar', pincode: '493362' },
  { value: 'saddu', label: 'Saddu', pincode: '493363' },
  { value: 'tokri', label: 'Tokri', pincode: '493364' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '493365' }
  ],

  'bijapur': [
  { value: 'bijapur', label: 'Bijapur', pincode: '494441' },
  { value: 'bastar', label: 'Bastar', pincode: '494001' },
  { value: 'bori', label: 'Bori', pincode: '494442' },
  { value: 'dhanora', label: 'Dhanora', pincode: '494443' },
  { value: 'goundara', label: 'Goundara', pincode: '494444' },
  { value: 'jagdalpur', label: 'Jagdalpur', pincode: '494001' },
  { value: 'kamalur', label: 'Kamalur', pincode: '494445' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '494226' },
  { value: 'kutul', label: 'Kutul', pincode: '494446' },
  { value: 'luxmanpur', label: 'Luxmanpur', pincode: '494447' },
  { value: 'madhya', label: 'Madhya', pincode: '494448' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '494661' },
  { value: 'padar', label: 'Padar', pincode: '494449' },
  { value: 'ramsagar', label: 'Ramsagar', pincode: '494450' },
  { value: 'tumnar', label: 'Tumnar', pincode: '494451' },
  { value: 'wajirpur', label: 'Wajirpur', pincode: '494452' },
  { value: 'chhindgarh', label: 'Chhindgarh', pincode: '494453' },
  { value: 'kacherigaon', label: 'Kacherigaon', pincode: '494454' },
  { value: 'kirandul', label: 'Kirandul', pincode: '494455' },
  { value: 'konta', label: 'Konta', pincode: '494456' },
  { value: 'kutru', label: 'Kutru', pincode: '494457' },
  { value: 'marenga', label: 'Marenga', pincode: '494458' },
  { value: 'narayanpur-2', label: 'Narayanpur-2', pincode: '494459' },
  { value: 'peddagudem', label: 'Peddagudem', pincode: '494460' },
  { value: 'ponga', label: 'Ponga', pincode: '494461' },
  { value: 'rampur', label: 'Rampur', pincode: '494462' },
  { value: 'saxena', label: 'Saxena', pincode: '494463' },
  { value: 'selba', label: 'Selba', pincode: '494464' },
  { value: 'tulsi-2', label: 'Tulsi-2', pincode: '494465' },
  { value: 'sarapalli', label: 'Sarapalli', pincode: '494466' },
  { value: 'bada-gaon', label: 'Bada Gaon', pincode: '494467' },
  { value: 'bhairamgarh', label: 'Bhairamgarh', pincode: '494468' },
  { value: 'chatra', label: 'Chatra', pincode: '494469' },
  { value: 'kashpur', label: 'Kashpur', pincode: '494470' },
  { value: 'konda', label: 'Konda', pincode: '494471' },
  { value: 'mandva', label: 'Mandva', pincode: '494472' },
  { value: 'navegaon', label: 'Navegaon', pincode: '494473' },
  { value: 'paltan', label: 'Paltan', pincode: '494474' },
  { value: 'pachpal', label: 'Pachpal', pincode: '494475' },
  { value: 'somni', label: 'Somni', pincode: '494476' },
  { value: 'tondgaon', label: 'Tondgaon', pincode: '494477' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '494478' },
  { value: 'wajidpur', label: 'Wajidpur', pincode: '494479' }
  ],

  'bilha': [
  { value: 'bilaspur', label: 'Bilaspur', pincode: '495001' },
  { value: 'bihpuria', label: 'Bihpuria', pincode: '495002' },
  { value: 'darsi', label: 'Darsi', pincode: '495003' },
  { value: 'ghogha', label: 'Ghogha', pincode: '495004' },
  { value: 'khutghat', label: 'Khutghat', pincode: '495005' },
  { value: 'koni', label: 'Koni', pincode: '495006' },
  { value: 'mohla', label: 'Mohla', pincode: '495007' },
  { value: 'radhapara', label: 'Radhapara', pincode: '495008' },
  { value: 'tifra', label: 'Tifra', pincode: '495009' },
  { value: 'pali', label: 'Pali', pincode: '495010' },
  { value: 'parasi', label: 'Parasi', pincode: '495011' },
  { value: 'raigarh', label: 'Raigarh', pincode: '495001' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'saragaon', label: 'Saragaon', pincode: '495012' },
  { value: 'selud', label: 'Selud', pincode: '495013' },
  { value: 'jamsara', label: 'Jamsara', pincode: '495014' },
  { value: 'bhalumada', label: 'Bhalumada', pincode: '495015' },
  { value: 'baikhora', label: 'Baikhora', pincode: '495016' },
  { value: 'bilha-urban', label: 'Bilha Urban', pincode: '495017' },
  { value: 'dondilohara', label: 'Dondilohara', pincode: '495018' },
  { value: 'kachandur', label: 'Kachandur', pincode: '495019' },
  { value: 'korba', label: 'Korba', pincode: '495677' },
  { value: 'mohandih', label: 'Mohandih', pincode: '495020' },
  { value: 'rahatgarh', label: 'Rahatgarh', pincode: '495021' },
  { value: 'shivrinarayan', label: 'Shivrinarayan', pincode: '495022' },
  { value: 'tumbah', label: 'Tumbah', pincode: '495023' },
  { value: 'pachri', label: 'Pachri', pincode: '495024' },
  { value: 'basna', label: 'Basna', pincode: '495025' },
  { value: 'kotma', label: 'Kotma', pincode: '495026' },
  { value: 'manendragarh', label: 'Manendragarh', pincode: '495027' },
  { value: 'gatora', label: 'Gatora', pincode: '495028' },
  { value: 'kanera', label: 'Kanera', pincode: '495029' },
  { value: 'jambad', label: 'Jambad', pincode: '495030' },
  { value: 'manjhra', label: 'Manjhra', pincode: '495031' },
  { value: 'akaltara', label: 'Akaltara', pincode: '495003' },
  { value: 'chalun', label: 'Chalun', pincode: '495032' },
  { value: 'kotri', label: 'Kotri', pincode: '495033' },
  { value: 'kandri', label: 'Kandri', pincode: '495034' },
  { value: 'nandanpur', label: 'Nandanpur', pincode: '495035' },
  { value: 'pachgaon', label: 'Pachgaon', pincode: '495036' },
  { value: 'bharsuli', label: 'Bharsuli', pincode: '495037' },
  { value: 'manegaon', label: 'Manegaon', pincode: '495038' },
  { value: 'pati', label: 'Pati', pincode: '495039' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '495040' },
  { value: 'sirsa', label: 'Sirsa', pincode: '495041' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '495042' },
  { value: 'ganjam', label: 'Ganjam', pincode: '495043' }
  ],

  'bishrampur': [
  { value: 'bandha', label: 'Bandha', pincode: '495226' },
  { value: 'bamhani', label: 'Bamhani', pincode: '495227' },
  { value: 'bishrampur', label: 'Bishrampur', pincode: '495227' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '495228' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '495229' },
  { value: 'devri', label: 'Devri', pincode: '495230' },
  { value: 'jhadgaon', label: 'Jhadgaon', pincode: '495231' },
  { value: 'kamta', label: 'Kamta', pincode: '495232' },
  { value: 'karwahi', label: 'Karwahi', pincode: '495233' },
  { value: 'katghora', label: 'Katghora', pincode: '495234' },
  { value: 'khadki', label: 'Khadki', pincode: '495235' },
  { value: 'kuchai', label: 'Kuchai', pincode: '495236' },
  { value: 'malgaon', label: 'Malgaon', pincode: '495237' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '495238' },
  { value: 'sarsi', label: 'Sarsi', pincode: '495239' },
  { value: 'sarai', label: 'Sarai', pincode: '495240' },
  { value: 'sikra', label: 'Sikra', pincode: '495241' },
  { value: 'sonhat', label: 'Sonhat', pincode: '495242' },
  { value: 'tifra', label: 'Tifra', pincode: '495243' },
  { value: 'agondhi', label: 'Agondhi', pincode: '495244' },
  { value: 'badgaon', label: 'Badgaon', pincode: '495245' },
  { value: 'balda', label: 'Balda', pincode: '495246' },
  { value: 'bari', label: 'Bari', pincode: '495247' },
  { value: 'belha', label: 'Belha', pincode: '495248' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '495249' },
  { value: 'gadra', label: 'Gadra', pincode: '495250' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '495251' },
  { value: 'kalmadi', label: 'Kalmadi', pincode: '495252' },
  { value: 'kanhera', label: 'Kanhera', pincode: '495253' },
  { value: 'katyani', label: 'Katyani', pincode: '495254' },
  { value: 'khairi', label: 'Khairi', pincode: '495255' },
  { value: 'kundra', label: 'Kundra', pincode: '495256' },
  { value: 'magri', label: 'Magri', pincode: '495257' },
  { value: 'malhara', label: 'Malhara', pincode: '495258' },
  { value: 'patra', label: 'Patra', pincode: '495259' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' }
  ],

  'champa': [
  { value: 'babhani', label: 'Babhani', pincode: '495001' },
  { value: 'bamar', label: 'Bamar', pincode: '495002' },
  { value: 'champa', label: 'Champa', pincode: '495001' },
  { value: 'darrabhata', label: 'Darrabhata', pincode: '495003' },
  { value: 'jora', label: 'Jora', pincode: '495004' },
  { value: 'kamaripali', label: 'Kamaripali', pincode: '495005' },
  { value: 'kandri', label: 'Kandri', pincode: '495006' },
  { value: 'khairi', label: 'Khairi', pincode: '495007' },
  { value: 'kuchai', label: 'Kuchai', pincode: '495008' },
  { value: 'lilahi', label: 'Lilahi', pincode: '495009' },
  { value: 'manora', label: 'Manora', pincode: '495010' },
  { value: 'nagra', label: 'Nagra', pincode: '495011' },
  { value: 'pachra', label: 'Pachra', pincode: '495012' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '495013' },
  { value: 'sakri', label: 'Sakri', pincode: '495014' },
  { value: 'sivpur', label: 'Sivpur', pincode: '495015' },
  { value: 'sonadih', label: 'Sonadih', pincode: '495016' },
  { value: 'tifra', label: 'Tifra', pincode: '495017' },
  { value: 'urla', label: 'Urla', pincode: '495018' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '495019' },
  { value: 'ajitpur', label: 'Ajitpur', pincode: '495020' },
  { value: 'balapur', label: 'Balapur', pincode: '495021' },
  { value: 'bhalia', label: 'Bhalia', pincode: '495022' },
  { value: 'belha', label: 'Belha', pincode: '495023' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '495024' },
  { value: 'chhura', label: 'Chhura', pincode: '495025' },
  { value: 'gadhwa', label: 'Gadhwa', pincode: '495026' },
  { value: 'jhiriya', label: 'Jhiriya', pincode: '495027' },
  { value: 'karkeli', label: 'Karkeli', pincode: '495028' },
  { value: 'kishanpur', label: 'Kishanpur', pincode: '495029' },
  { value: 'kumhari', label: 'Kumhari', pincode: '495030' },
  { value: 'manpur', label: 'Manpur', pincode: '495031' },
  { value: 'mohli', label: 'Mohli', pincode: '495032' },
  { value: 'nagaria', label: 'Nagaria', pincode: '495033' },
  { value: 'pachbhai', label: 'Pachbhai', pincode: '495034' },
  { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '495035' },
  { value: 'sonkhar', label: 'Sonkhar', pincode: '495036' }
  ],

  'chhura': [
  { value: 'adari', label: 'Adari', pincode: '495225' },
  { value: 'bhatha', label: 'Bhatha', pincode: '495226' },
  { value: 'chhura', label: 'Chhura', pincode: '495227' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '495228' },
  { value: 'gadhwa', label: 'Gadhwa', pincode: '495229' },
  { value: 'jora', label: 'Jora', pincode: '495230' },
  { value: 'kanhera', label: 'Kanhera', pincode: '495231' },
  { value: 'katghora', label: 'Katghora', pincode: '495232' },
  { value: 'khairi', label: 'Khairi', pincode: '495233' },
  { value: 'khushalpur', label: 'Khushalpur', pincode: '495234' },
  { value: 'kuchai', label: 'Kuchai', pincode: '495235' },
  { value: 'manora', label: 'Manora', pincode: '495236' },
  { value: 'nagra', label: 'Nagra', pincode: '495237' },
  { value: 'pachra', label: 'Pachra', pincode: '495238' },
  { value: 'rajpur', label: 'Rajpur', pincode: '495239' },
  { value: 'sakri', label: 'Sakri', pincode: '495240' },
  { value: 'sivpur', label: 'Sivpur', pincode: '495241' },
  { value: 'sonadih', label: 'Sonadih', pincode: '495242' },
  { value: 'tifra', label: 'Tifra', pincode: '495243' },
  { value: 'urla', label: 'Urla', pincode: '495244' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '495245' },
  { value: 'balapur', label: 'Balapur', pincode: '495246' },
  { value: 'boregaon', label: 'Boregaon', pincode: '495247' },
  { value: 'chakri', label: 'Chakri', pincode: '495248' },
  { value: 'dharmapuri', label: 'Dharmapuri', pincode: '495249' },
  { value: 'gohari', label: 'Gohari', pincode: '495250' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '495251' },
  { value: 'kanhergaon', label: 'Kanhergaon', pincode: '495252' },
  { value: 'kardaha', label: 'Kardaha', pincode: '495253' },
  { value: 'kolba', label: 'Kolba', pincode: '495254' },
  { value: 'mohli', label: 'Mohli', pincode: '495255' },
  { value: 'nawapara', label: 'Nawapara', pincode: '495256' },
  { value: 'patrapali', label: 'Patrapali', pincode: '495257' },
  { value: 'raikheda', label: 'Raikheda', pincode: '495258' },
  { value: 'sarsara', label: 'Sarsara', pincode: '495259' }
  ],
  
  'chhuikhadan': [
  { value: 'abhaypur', label: 'Abhaypur', pincode: '495334' },
  { value: 'babhani', label: 'Babhani', pincode: '495335' },
  { value: 'chhuikhadan', label: 'Chhuikhadan', pincode: '495336' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '495337' },
  { value: 'ghotia', label: 'Ghotia', pincode: '495338' },
  { value: 'jora', label: 'Jora', pincode: '495339' },
  { value: 'kanhera', label: 'Kanhera', pincode: '495340' },
  { value: 'katghora', label: 'Katghora', pincode: '495341' },
  { value: 'khushalpur', label: 'Khushalpur', pincode: '495342' },
  { value: 'kuchai', label: 'Kuchai', pincode: '495343' },
  { value: 'manora', label: 'Manora', pincode: '495344' },
  { value: 'nagra', label: 'Nagra', pincode: '495345' },
  { value: 'pachra', label: 'Pachra', pincode: '495346' },
  { value: 'rajpur', label: 'Rajpur', pincode: '495347' },
  { value: 'sakri', label: 'Sakri', pincode: '495348' },
  { value: 'sonadih', label: 'Sonadih', pincode: '495349' },
  { value: 'tifra', label: 'Tifra', pincode: '495350' },
  { value: 'urla', label: 'Urla', pincode: '495351' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '495352' },
  { value: 'balapur', label: 'Balapur', pincode: '495353' },
  { value: 'boregaon', label: 'Boregaon', pincode: '495354' },
  { value: 'chakri', label: 'Chakri', pincode: '495355' },
  { value: 'dharmapuri', label: 'Dharmapuri', pincode: '495356' },
  { value: 'gohari', label: 'Gohari', pincode: '495357' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '495358' },
  { value: 'kanhergaon', label: 'Kanhergaon', pincode: '495359' },
  { value: 'kardaha', label: 'Kardaha', pincode: '495360' },
  { value: 'kolba', label: 'Kolba', pincode: '495361' },
  { value: 'mohli', label: 'Mohli', pincode: '495362' },
  { value: 'nawapara', label: 'Nawapara', pincode: '495363' },
  { value: 'patrapali', label: 'Patrapali', pincode: '495364' },
  { value: 'raikheda', label: 'Raikheda', pincode: '495365' },
  { value: 'sarsara', label: 'Sarsara', pincode: '495366' },
  { value: 'bhamori', label: 'Bhamori', pincode: '495367' },
  { value: 'bhorki', label: 'Bhorki', pincode: '495368' },
  { value: 'kalma', label: 'Kalma', pincode: '495369' },
  { value: 'manjhi', label: 'Manjhi', pincode: '495370' },
  { value: 'sihora', label: 'Sihora', pincode: '495371' }
  ],

  'chirimiri': [
  { value: 'alibhata', label: 'Alibhata', pincode: '497771' },
  { value: 'amgaon', label: 'Amgaon', pincode: '497787' },
  { value: 'bansipur', label: 'Bansipur', pincode: '497772' },
  { value: 'birkoni', label: 'Birkoni', pincode: '497788' },
  { value: 'chakradhar', label: 'Chakradhar', pincode: '497789' },
  { value: 'chirimiri', label: 'Chirimiri', pincode: '497773' },
  { value: 'dainik', label: 'Dainik', pincode: '497774' },
  { value: 'gajraula', label: 'Gajraula', pincode: '497775' },
  { value: 'gurguri', label: 'Gurguri', pincode: '497790' },
  { value: 'kaimora', label: 'Kaimora', pincode: '497776' },
  { value: 'kanchana', label: 'Kanchana', pincode: '497777' },
  { value: 'kharsia', label: 'Kharsia', pincode: '497791' },
  { value: 'khodri', label: 'Khodri', pincode: '497778' },
  { value: 'korba', label: 'Korba', pincode: '497779' },
  { value: 'kudra', label: 'Kudra', pincode: '497780' },
  { value: 'lailunga', label: 'Lailunga', pincode: '497792' },
  { value: 'mohara', label: 'Mohara', pincode: '497793' },
  { value: 'paharpur', label: 'Paharpur', pincode: '497781' },
  { value: 'raigarh', label: 'Raigarh', pincode: '497794' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '497782' },
  { value: 'salwa', label: 'Salwa', pincode: '497783' },
  { value: 'sarishta', label: 'Sarishta', pincode: '497795' },
  { value: 'tarpur', label: 'Tarpur', pincode: '497784' },
  { value: 'tikar', label: 'Tikhar', pincode: '497796' },
  { value: 'umariya', label: 'Umariya', pincode: '497785' },
  { value: 'wasad', label: 'Wasad', pincode: '497786' }
  ],

  'dongargaon': [
  { value: 'ajit-para', label: 'Ajit Para', pincode: '495688' },
  { value: 'bhalukona', label: 'Bhalukona', pincode: '495662' },
  { value: 'dongargaon', label: 'Dongargaon', pincode: '495688' },
  { value: 'gandai', label: 'Gandai', pincode: '495660' },
  { value: 'gurur', label: 'Gurur', pincode: '495684' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '495665' },
  { value: 'mahamaya', label: 'Mahamaya', pincode: '495671' },
  { value: 'nayanpur', label: 'Nayanpur', pincode: '495672' },
  { value: 'pahanda', label: 'Pahanda', pincode: '495661' },
  { value: 'rawan', label: 'Rawan', pincode: '495691' },
  { value: 'sankara', label: 'Sankara', pincode: '495670' },
  { value: 'shahpuri', label: 'Shahpuri', pincode: '495682' },
  { value: 'tulsi-para', label: 'Tulsi Para', pincode: '495679' },
  { value: 'vill-ramkheda', label: 'Ramkheda', pincode: '495681' },
  { value: 'wasudev', label: 'Wasudev', pincode: '495673' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'kurud', label: 'Kurud', pincode: '493663' },
  { value: 'bhatagaon', label: 'Bhatagaon', pincode: '495001' },
  { value: 'chakabuda', label: 'Chakabuda', pincode: '495660' },
  { value: 'kakripara', label: 'Kakripara', pincode: '495665' },
  { value: 'mohlimala', label: 'Mohlimala', pincode: '495669' },
  { value: 'kharkhara', label: 'Kharkhara', pincode: '495667' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '495002' },
  { value: 'sagarpali', label: 'Sagarpali', pincode: '495678' },
  { value: 'budhpur', label: 'Budhpur', pincode: '495670' },
  { value: 'baradwar', label: 'Baradwar', pincode: '495665' },
  { value: 'chatrapur', label: 'Chatrapur', pincode: '495679' },
  { value: 'dholkal', label: 'Dholkal', pincode: '495661' },
  { value: 'kandul', label: 'Kandul', pincode: '495676' },
  { value: 'jamul', label: 'Jamul', pincode: '495010' },
  { value: 'panchayat-nagar', label: 'Panchayat Nagar', pincode: '495674' },
  { value: 'adampur', label: 'Adampur', pincode: '495660' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '495667' },
  { value: 'kesarwani', label: 'Kesarwani', pincode: '495689' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'gundardehi', label: 'Gundardehi', pincode: '495775' }
  ],

  'fingeshwar': [
  { value: 'bajna', label: 'Bajna', pincode: '493993' },
  { value: 'bhatauli', label: 'Bhatauli', pincode: '493996' },
  { value: 'chandkhuri', label: 'Chandkhuri', pincode: '493998' },
  { value: 'dhanora', label: 'Dhanora', pincode: '493998' },
  { value: 'fingeshwar', label: 'Fingeshwar', pincode: '493995' },
  { value: 'kharsia', label: 'Kharsia', pincode: '493661' },
  { value: 'kakod', label: 'Kakod', pincode: '493993' },
  { value: 'kolar', label: 'Kolar', pincode: '493995' },
  { value: 'malda', label: 'Malda', pincode: '493994' },
  { value: 'mardum', label: 'Mardum', pincode: '493999' },
  { value: 'murra', label: 'Murra', pincode: '493996' },
  { value: 'ponrra', label: 'Ponrra', pincode: '493997' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' }, // Near Fingeshwar
  { value: 'sihora', label: 'Sihora', pincode: '493991' },
  { value: 'sindur', label: 'Sindur', pincode: '493995' },
  { value: 'tulsi', label: 'Tulsi', pincode: '493992' },
  { value: 'belhi', label: 'Belhi', pincode: '493990' },
  { value: 'banjara', label: 'Banjara', pincode: '493998' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '494226' },
  { value: 'tandula', label: 'Tandula', pincode: '493992' },
  { value: 'bansoori', label: 'Bansoori', pincode: '493991' },
  { value: 'godhi', label: 'Godhi', pincode: '493993' },
  { value: 'salhe', label: 'Salhe', pincode: '493995' },
  { value: 'pudpara', label: 'Pudpara', pincode: '493992' },
  { value: 'dabra', label: 'Dabra', pincode: '493664' },
  { value: 'nawapara', label: 'Nawapara', pincode: '493995' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '493996' },
  { value: 'patpar', label: 'Patpar', pincode: '493991' },
  { value: 'tirda', label: 'Tirda', pincode: '493995' }
  ],

  'gaurella': [
  { value: 'barpali', label: 'Barpali', pincode: '495119' },
  { value: 'bhairopali', label: 'Bhairopali', pincode: '495113' },
  { value: 'bhimpar', label: 'Bhimpar', pincode: '495112' },
  { value: 'gaurella', label: 'Gaurella', pincode: '495115' },
  { value: 'ghoghapali', label: 'Ghoghapali', pincode: '495118' },
  { value: 'jethli', label: 'Jethli', pincode: '495115' },
  { value: 'jhabra', label: 'Jhabra', pincode: '495116' },
  { value: 'khamhri', label: 'Khamhri', pincode: '495119' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '495117' },
  { value: 'kamarai', label: 'Kamarai', pincode: '495120' },
  { value: 'kankar', label: 'Kankar', pincode: '495111' },
  { value: 'malgund', label: 'Malgund', pincode: '495114' },
  { value: 'salhi', label: 'Salhi', pincode: '495113' },
  { value: 'sinduri', label: 'Sinduri', pincode: '495112' },
  { value: 'mohli', label: 'Mohli', pincode: '495116' },
  { value: 'majur', label: 'Majur', pincode: '495117' },
  { value: 'pankhudi', label: 'Pankhudi', pincode: '495119' },
  { value: 'sarai', label: 'Sarai', pincode: '495118' },
  { value: 'tirkedi', label: 'Tirkedi', pincode: '495115' },
  { value: 'tikrapara', label: 'Tikrapara', pincode: '495120' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '495119' },
  { value: 'dehlon', label: 'Dehlon', pincode: '495113' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '495110' },
  { value: 'khachhar', label: 'Khachhar', pincode: '495121' },
  { value: 'kalawari', label: 'Kalawari', pincode: '495122' },
  { value: 'gandai', label: 'Gandai', pincode: '495119' },
  { value: 'kotri', label: 'Kotri', pincode: '495111' },
  { value: 'raikheda', label: 'Raikheda', pincode: '495113' },
  { value: 'nagla', label: 'Nagla', pincode: '495115' }
  ],

  'gariyaband': [
  { value: 'bhalupara', label: 'Bhalupara', pincode: '493889' },
  { value: 'bhelwapara', label: 'Bhelwapara', pincode: '493881' },
  { value: 'chicholi', label: 'Chicholi', pincode: '493881' },
  { value: 'dhamdha', label: 'Dhamdha', pincode: '493775' },
  { value: 'gariyaband', label: 'Gariyaband', pincode: '493889' },
  { value: 'gandai', label: 'Gandai', pincode: '495119' },
  { value: 'gariyaband-2', label: 'Gariyaband 2', pincode: '493880' },
  { value: 'khairkheda', label: 'Khairkheda', pincode: '493888' },
  { value: 'mahtari', label: 'Mahtari', pincode: '493885' },
  { value: 'mohli', label: 'Mohli', pincode: '493883' },
  { value: 'pankhudi', label: 'Pankhudi', pincode: '493889' },
  { value: 'raikheda', label: 'Raikheda', pincode: '493885' },
  { value: 'sihora', label: 'Sihora', pincode: '493880' },
  { value: 'tandula', label: 'Tandula', pincode: '493884' },
  { value: 'kekra', label: 'Kekra', pincode: '493887' },
  { value: 'baloda', label: 'Baloda', pincode: '493886' },
  { value: 'dharmpura', label: 'Dharmpura', pincode: '493888' },
  { value: 'poddarpara', label: 'Poddarpara', pincode: '493885' },
  { value: 'jhalmala', label: 'Jhalmala', pincode: '493882' },
  { value: 'santoshpur', label: 'Santoshpur', pincode: '493885' },
  { value: 'tilda', label: 'Tilda', pincode: '493772' },
  { value: 'bhanpuri', label: 'Bhanpuri', pincode: '493881' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '493883' },
  { value: 'ravigram', label: 'Ravigram', pincode: '493885' },
  { value: 'malkapur', label: 'Malkapur', pincode: '493882' },
  { value: 'dharmja', label: 'Dharmja', pincode: '493777' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'bamhni', label: 'Bamhni', pincode: '493777' },
  { value: 'karanjia', label: 'Karanjia', pincode: '493779' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '494226' },
  { value: 'dallirajhara', label: 'Dallirajhara', pincode: '493114' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '495114' },
  { value: 'pachperwa', label: 'Pachperwa', pincode: '493777' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '493779' },
  { value: 'bhendri', label: 'Bhendri', pincode: '493775' },
  { value: 'palari', label: 'Palari', pincode: '493774' },
  { value: 'jaitpuri', label: 'Jaitpuri', pincode: '493776' },
  { value: 'belda', label: 'Belda', pincode: '493775' }
  ],

  'gundardehi': [
  { value: 'bemetara', label: 'Bemetara', pincode: '491335' },
  { value: 'bhansi', label: 'Bhansi', pincode: '491337' },
  { value: 'bhatagaon', label: 'Bhatagaon', pincode: '491995' },
  { value: 'gundardehi', label: 'Gundardehi', pincode: '491665' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jagatpur', label: 'Jagatpur', pincode: '491661' },
  { value: 'kawardha', label: 'Kawardha', pincode: '491995' },
  { value: 'khairagarh', label: 'Khairagarh', pincode: '491881' },
  { value: 'kuchada', label: 'Kuchada', pincode: '491662' },
  { value: 'mohla', label: 'Mohla', pincode: '491888' },
  { value: 'mohali', label: 'Mohali', pincode: '491775' },
  { value: 'nawapara', label: 'Nawapara', pincode: '491559' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'sakri', label: 'Sakri', pincode: '491444' },
  { value: 'sarangarh', label: 'Sarangarh', pincode: '491227' },
  { value: 'saragaon', label: 'Saragaon', pincode: '491881' },
  { value: 'sejbahar', label: 'Sejbahar', pincode: '491331' },
  { value: 'tilda', label: 'Tilda', pincode: '491114' },
  { value: 'banjara', label: 'Banjara', pincode: '491242' },
  { value: 'berla', label: 'Berla', pincode: '491335' },
  { value: 'chandkhuri', label: 'Chandkhuri', pincode: '491890' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'fingeshwar', label: 'Fingeshwar', pincode: '493993' }
  ],

  'jagdalpur': [
  { value: 'adwa', label: 'Adwa', pincode: '494001' },
  { value: 'andhiyad', label: 'Andhiyad', pincode: '494111' },
  { value: 'barsoor', label: 'Barsoor', pincode: '494228' },
  { value: 'bailadila', label: 'Bailadila', pincode: '494551' },
  { value: 'bastar', label: 'Bastar', pincode: '494001' },
  { value: 'bhairamgarh', label: 'Bhairamgarh', pincode: '494661' },
  { value: 'bhanupratappur', label: 'Bhanupratappur', pincode: '494661' },
  { value: 'chhattisgarh', label: 'Chhattisgarh', pincode: '494110' },
  { value: 'chitrakote', label: 'Chitrakote', pincode: '494001' },
  { value: 'darbha', label: 'Darbha', pincode: '494001' },
  { value: 'dhanora', label: 'Dhanora', pincode: '494221' },
  { value: 'durgukondal', label: 'Durgukondal', pincode: '494229' },
  { value: 'jagdalpur', label: 'Jagdalpur', pincode: '494001' },
  { value: 'jandhrapara', label: 'Jandhrapara', pincode: '494220' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '494226' },
  { value: 'konta', label: 'Konta', pincode: '494114' },
  { value: 'konta-bastar', label: 'Konta Bastar', pincode: '494114' },
  { value: 'kutru', label: 'Kutru', pincode: '494229' },
  { value: 'lataguri', label: 'Lataguri', pincode: '494441' },
  { value: 'mainpur', label: 'Mainpur', pincode: '494441' },
  { value: 'nalaghat', label: 'Nalaghat', pincode: '494335' },
  { value: 'pangidi', label: 'Pangidi', pincode: '494118' },
  { value: 'parpa', label: 'Parpa', pincode: '494001' },
  { value: 'tokapal', label: 'Tokapal', pincode: '494223' },
  { value: 'langapara', label: 'Langapara', pincode: '494335' },
  { value: 'malewahi', label: 'Malewahi', pincode: '494110' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '494661' },
  { value: 'rakhi', label: 'Rakhi', pincode: '494220' },
  { value: 'sarapal', label: 'Sarapal', pincode: '494335' },
  { value: 'tendumadhupur', label: 'Tendumadhupur', pincode: '494122' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '494229' }
  ],

  'jashpur-nagar': [
  { value: 'bagicha', label: 'Bagicha', pincode: '496224' },
  { value: 'balenga', label: 'Balenga', pincode: '496331' },
  { value: 'balod', label: 'Balod', pincode: '496441' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '496222' },
  { value: 'duldula', label: 'Duldula', pincode: '496331' },
  { value: 'jashpur', label: 'Jashpur', pincode: '496331' },
  { value: 'jashpur-town', label: 'Jashpur Town', pincode: '496331' },
  { value: 'kunkuri', label: 'Kunkuri', pincode: '496225' },
  { value: 'kanker', label: 'Kanker', pincode: '496445' },
  { value: 'kumhari', label: 'Kumhari', pincode: '496223' },
  { value: 'manora', label: 'Manora', pincode: '496222' },
  { value: 'mohalla', label: 'Mohalla', pincode: '496117' },
  { value: 'nawapara', label: 'Nawapara', pincode: '496118' },
  { value: 'pathalgaon', label: 'Pathalgaon', pincode: '496118' },
  { value: 'patthalgaon', label: 'Patthalgaon', pincode: '496118' },
  { value: 'ramanujganj', label: 'Ramanujganj', pincode: '496218' },
  { value: 'raigarh', label: 'Raigarh', pincode: '496001' },
  { value: 'tonda', label: 'Tonda', pincode: '496117' },
  { value: 'udaypur', label: 'Udaypur', pincode: '496221' },
  { value: 'balegaon', label: 'Balegaon', pincode: '496225' },
  { value: 'belpahari', label: 'Belpahari', pincode: '496446' },
  { value: 'chhattisgarh', label: 'Chhattisgarh', pincode: '496222' },
  { value: 'dondilohara', label: 'Dondilohara', pincode: '496441' },
  { value: 'gathiya', label: 'Gathiya', pincode: '496331' },
  { value: 'jangla', label: 'Jangla', pincode: '496220' },
  { value: 'kapsi', label: 'Kapsi', pincode: '496445' },
  { value: 'mantralaya', label: 'Mantralaya', pincode: '496336' },
  { value: 'raigarh-civil-lines', label: 'Raigarh Civil Lines', pincode: '496001' },
  { value: 'rajpur', label: 'Rajpur', pincode: '496227' },
  { value: 'sargu', label: 'Sargu', pincode: '496224' },
  { value: 'siltara', label: 'Siltara', pincode: '496330' },
  { value: 'tendupathar', label: 'Tendupathar', pincode: '496112' },
  { value: 'barbadia', label: 'Barbadia', pincode: '496445' },
  { value: 'purani-basti', label: 'Purani Basti', pincode: '496118' },
  { value: 'kudari', label: 'Kudari', pincode: '496223' }
  ],

  'kanker': [
  { value: 'adwari', label: 'Adwari', pincode: '494331' },
  { value: 'babhani', label: 'Babhani', pincode: '494331' },
  { value: 'bhanupratappur', label: 'Bhanupratappur', pincode: '494661' },
  { value: 'dallirajhara', label: 'Dallirajhara', pincode: '494444' },
  { value: 'durgukondal', label: 'Durgukondal', pincode: '494229' },
  { value: 'gidhpuri', label: 'Gidhpuri', pincode: '494229' },
  { value: 'jakhira', label: 'Jakhira', pincode: '494229' },
  { value: 'kanker', label: 'Kanker', pincode: '494334' },
  { value: 'kanker-town', label: 'Kanker Town', pincode: '494334' },
  { value: 'kardong', label: 'Kardong', pincode: '494337' },
  { value: 'katgora', label: 'Katgora', pincode: '494224' },
  { value: 'kapsi', label: 'Kapsi', pincode: '494228' },
  { value: 'koilibeda', label: 'Koilibeda', pincode: '494334' },
  { value: 'kumhari', label: 'Kumhari', pincode: '494220' },
  { value: 'nalghar', label: 'Nalghar', pincode: '494336' },
  { value: 'nalgarha', label: 'Nalgarha', pincode: '494336' },
  { value: 'nawapara', label: 'Nawapara', pincode: '494228' },
  { value: 'pathalgaon', label: 'Pathalgaon', pincode: '496118' },
  { value: 'punjari', label: 'Punjari', pincode: '494228' },
  { value: 'rangapara', label: 'Rangapara', pincode: '494220' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '494224' },
  { value: 'sirasgaon', label: 'Sirasgaon', pincode: '494228' },
  { value: 'korgaon', label: 'Korgaon', pincode: '494336' },
  { value: 'gorkhpur', label: 'Gorkhpur', pincode: '494227' },
  { value: 'khamharia', label: 'Khamharia', pincode: '494331' },
  { value: 'malgaon', label: 'Malgaon', pincode: '494334' },
  { value: 'chikhli', label: 'Chikhli', pincode: '494229' },
  { value: 'naubasta', label: 'Naubasta', pincode: '494228' },
  { value: 'khodri', label: 'Khodri', pincode: '494334' },
  { value: 'padri', label: 'Padri', pincode: '494336' },
  { value: 'bandhar', label: 'Bandhar', pincode: '494334' },
  { value: 'temri', label: 'Temri', pincode: '494227' },
  { value: 'manpur', label: 'Manpur', pincode: '494220' },
  { value: 'murumkasa', label: 'Murumkasa', pincode: '494229' },
  { value: 'khairwa', label: 'Khairwa', pincode: '494229' },
  { value: 'sagargote', label: 'Sagargote', pincode: '494220' },
  { value: 'masulkar', label: 'Masulkar', pincode: '494220' }
  ],

  'kawardha': [
  { value: 'balaghat', label: 'Balaghat', pincode: '491995' },
  { value: 'bastar', label: 'Bastar', pincode: '491229' },
  { value: 'bhatapara', label: 'Bhatapara', pincode: '491111' },
  { value: 'bhorya', label: 'Bhorya', pincode: '491335' },
  { value: 'dabhra', label: 'Dabhra', pincode: '491888' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '491001' },
  { value: 'kawardha', label: 'Kawardha', pincode: '491995' },
  { value: 'katora', label: 'Katora', pincode: '491226' },
  { value: 'khamaria', label: 'Khamaria', pincode: '491229' },
  { value: 'khurmu', label: 'Khurmu', pincode: '491332' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '491226' },
  { value: 'kurud', label: 'Kurud', pincode: '491222' },
  { value: 'manpur', label: 'Manpur', pincode: '491997' },
  { value: 'nayapara', label: 'Nayapara', pincode: '491335' },
  { value: 'pandar', label: 'Pandar', pincode: '491223' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '491111' },
  { value: 'sarsi', label: 'Sarsi', pincode: '491998' },
  { value: 'takhatpur', label: 'Takhatpur', pincode: '491222' },
  { value: 'jogimara', label: 'Jogimara', pincode: '491220' },
  { value: 'chhuri', label: 'Chhuri', pincode: '491226' },
  { value: 'dhamtari-town', label: 'Dhamtari Town', pincode: '491001' },
  { value: 'amabhath', label: 'Amabhath', pincode: '491223' },
  { value: 'saragaon', label: 'Saragaon', pincode: '491220' },
  { value: 'khariar', label: 'Khariar', pincode: '491558' },
  { value: 'gariaband', label: 'Gariaband', pincode: '491887' },
  { value: 'salhi', label: 'Salhi', pincode: '491331' },
  { value: 'sankara', label: 'Sankara', pincode: '491111' },
  { value: 'rawan', label: 'Rawan', pincode: '491229' }
  ],

  'khairagarh': [
  { value: 'badkulla', label: 'Badkulla', pincode: '491881' },
  { value: 'balod', label: 'Balod', pincode: '491226' },
  { value: 'bengaluru', label: 'Bengaluru', pincode: '491331' },
  { value: 'bhawani', label: 'Bhawani', pincode: '491332' },
  { value: 'chicholi', label: 'Chicholi', pincode: '491331' },
  { value: 'chhuri', label: 'Chhuri', pincode: '491227' },
  { value: 'dabhra', label: 'Dabhra', pincode: '491888' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '491001' },
  { value: 'khairagarh', label: 'Khairagarh', pincode: '491881' },
  { value: 'khairagarh-town', label: 'Khairagarh Town', pincode: '491881' },
  { value: 'khamharia', label: 'Khamharia', pincode: '491332' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '491226' },
  { value: 'kurud', label: 'Kurud', pincode: '491222' },
  { value: 'manpur', label: 'Manpur', pincode: '491997' },
  { value: 'nayapara', label: 'Nayapara', pincode: '491335' },
  { value: 'pandar', label: 'Pandar', pincode: '491223' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '491111' },
  { value: 'salhi', label: 'Salhi', pincode: '491331' },
  { value: 'sarsi', label: 'Sarsi', pincode: '491998' },
  { value: 'takhatpur', label: 'Takhatpur', pincode: '491222' },
  { value: 'sonpuri', label: 'Sonpuri', pincode: '491227' },
  { value: 'jogimara', label: 'Jogimara', pincode: '491220' },
  { value: 'ravi', label: 'Ravi', pincode: '491229' },
  { value: 'barpali', label: 'Barpali', pincode: '491223' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '491111' },
  { value: 'boregaon', label: 'Boregaon', pincode: '491330' },
  { value: 'gidhpuri', label: 'Gidhpuri', pincode: '491221' },
  { value: 'dudhmohar', label: 'Dudhmohar', pincode: '491226' },
  { value: 'boridand', label: 'Boridand', pincode: '491332' },
  { value: 'kuchwa', label: 'Kuchwa', pincode: '491331' },
  { value: 'bijapur', label: 'Bijapur', pincode: '491331' },
  { value: 'tarapur', label: 'Tarapur', pincode: '491331' },
  { value: 'jagdalpur', label: 'Jagdalpur', pincode: '491441' },
  { value: 'belgaon', label: 'Belgaon', pincode: '491226' },
  { value: 'kasdol', label: 'Kasdol', pincode: '491332' },
  { value: 'bemetara', label: 'Bemetara', pincode: '491335' },
  { value: 'dharampur', label: 'Dharampur', pincode: '491222' },
  { value: 'gourbhanja', label: 'Gourbhanja', pincode: '491226' },
  { value: 'mohli', label: 'Mohli', pincode: '491330' }
  ],

  'kumhari': [
  { value: 'bavli', label: 'Bavli', pincode: '491209' },
  { value: 'bemetara', label: 'Bemetara', pincode: '491335' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'dhamdha', label: 'Dhamdha', pincode: '490023' },
  { value: 'kumhari', label: 'Kumhari', pincode: '491001' },
  { value: 'kumhari-town', label: 'Kumhari Town', pincode: '491001' },
  { value: 'mana', label: 'Mana', pincode: '490024' },
  { value: 'nagpura', label: 'Nagpura', pincode: '490025' },
  { value: 'sakti', label: 'Sakti', pincode: '491111' },
  { value: 'tarba', label: 'Tarba', pincode: '491221' },
  { value: 'tandula', label: 'Tandula', pincode: '491111' },
  { value: 'umaria', label: 'Umaria', pincode: '491222' },
  { value: 'rawabhatha', label: 'Rawabhatha', pincode: '491000' },
  { value: 'dhamdha-town', label: 'Dhamdha Town', pincode: '490023' },
  { value: 'nawapara', label: 'Nawapara', pincode: '491001' },
  { value: 'nayanpur', label: 'Nayanpur', pincode: '491209' },
  { value: 'bhilai-3', label: 'Bhilai 3', pincode: '490021' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'fedra', label: 'Fedra', pincode: '491335' },
  { value: 'karbala', label: 'Karbala', pincode: '490024' },
  { value: 'khursipar', label: 'Khursipar', pincode: '490029' },
  { value: 'parawada', label: 'Parawada', pincode: '491001' },
  { value: 'pindrai', label: 'Pindrai', pincode: '491335' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '491221' },
  { value: 'tilda', label: 'Tilda', pincode: '491114' },
  { value: 'banegaon', label: 'Banegaon', pincode: '491213' },
  { value: 'chapparia', label: 'Chapparia', pincode: '491212' },
  { value: 'jokhira', label: 'Jokhira', pincode: '491113' },
  { value: 'kotmi', label: 'Kotmi', pincode: '491208' },
  { value: 'kudgaon', label: 'Kudgaon', pincode: '491221' },
  { value: 'magarlod', label: 'Magarlod', pincode: '491220' },
  { value: 'nexapara', label: 'Nexapara', pincode: '491227' },
  { value: 'pendri', label: 'Pendri', pincode: '491228' },
  { value: 'sagpur', label: 'Sagpur', pincode: '491219' },
  { value: 'sihora', label: 'Sihora', pincode: '491115' }
  ],

  'kunkuri': [
  { value: 'alipur', label: 'Alipur', pincode: '494665' },
  { value: 'banjar', label: 'Banjar', pincode: '494667' },
  { value: 'barpali', label: 'Barpali', pincode: '494222' },
  { value: 'bemetara', label: 'Bemetara', pincode: '491335' },
  { value: 'belpar', label: 'Belpar', pincode: '494334' },
  { value: 'chhattisgarh', label: 'Chhattisgarh', pincode: '494001' },
  { value: 'dindori', label: 'Dindori', pincode: '494229' },
  { value: 'kunkuri', label: 'Kunkuri', pincode: '494661' },
  { value: 'kunkuri-town', label: 'Kunkuri Town', pincode: '494661' },
  { value: 'mohli', label: 'Mohli', pincode: '494665' },
  { value: 'nawapara', label: 'Nawapara', pincode: '494331' },
  { value: 'pendri', label: 'Pendri', pincode: '494668' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '494229' },
  { value: 'sakti', label: 'Sakti', pincode: '491113' },
  { value: 'sardha', label: 'Sardha', pincode: '494330' },
  { value: 'tandula', label: 'Tandula', pincode: '491114' },
  { value: 'bagbahra', label: 'Bagbahra', pincode: '494661' },
  { value: 'bandhapara', label: 'Bandhapara', pincode: '494664' },
  { value: 'bhulia', label: 'Bhulia', pincode: '494669' },
  { value: 'chakarbhata', label: 'Chakarbhata', pincode: '494650' },
  { value: 'chandkhuri', label: 'Chandkhuri', pincode: '494446' },
  { value: 'katorna', label: 'Katorna', pincode: '494667' },
  { value: 'khadapara', label: 'Khadapara', pincode: '494661' },
  { value: 'khapri', label: 'Khapri', pincode: '494228' },
  { value: 'mohali', label: 'Mohali', pincode: '494663' },
  { value: 'palari', label: 'Palari', pincode: '494660' },
  { value: 'rahul', label: 'Rahul', pincode: '494229' },
  { value: 'shivrinarayan', label: 'Shivrinarayan', pincode: '494336' },
  { value: 'takhatpur', label: 'Takhatpur', pincode: '494333' }
  ],

  'kurud': [
  { value: 'baroda', label: 'Baroda', pincode: '491223' },
  { value: 'belda', label: 'Belda', pincode: '491224' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '491228' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '491001' },
  { value: 'kurud', label: 'Kurud', pincode: '491222' },
  { value: 'kurud-town', label: 'Kurud Town', pincode: '491222' },
  { value: 'manpur', label: 'Manpur', pincode: '491228' },
  { value: 'nawapara', label: 'Nawapara', pincode: '491225' },
  { value: 'pendri', label: 'Pendri', pincode: '491225' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '491227' },
  { value: 'sakti', label: 'Sakti', pincode: '491113' },
  { value: 'sihora', label: 'Sihora', pincode: '491115' },
  { value: 'tandula', label: 'Tandula', pincode: '491114' },
  { value: 'bagbahra', label: 'Bagbahra', pincode: '491220' },
  { value: 'barpali', label: 'Barpali', pincode: '491213' },
  { value: 'belpar', label: 'Belpar', pincode: '491220' },
  { value: 'bhuriya', label: 'Bhuriya', pincode: '491225' },
  { value: 'chakradhar', label: 'Chakradhar', pincode: '491222' },
  { value: 'gundardehi', label: 'Gundardehi', pincode: '491222' },
  { value: 'kankeri', label: 'Kankeri', pincode: '491223' },
  { value: 'keshla', label: 'Keshla', pincode: '491224' },
  { value: 'patna', label: 'Patna', pincode: '491223' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'takhatpur', label: 'Takhatpur', pincode: '491442' }
  ],

  'manendragarh': [
  { value: 'babhani', label: 'Babhani', pincode: '497778' },
  { value: 'bandhan', label: 'Bandhan', pincode: '497771' },
  { value: 'baloda', label: 'Baloda', pincode: '497778' },
  { value: 'bhamra', label: 'Bhamra', pincode: '497770' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '497777' },
  { value: 'gajraula', label: 'Gajraula', pincode: '497779' },
  { value: 'ghongha', label: 'Ghongha', pincode: '497770' },
  { value: 'khairagarh', label: 'Khairagarh', pincode: '497778' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '497773' },
  { value: 'kodra', label: 'Kodra', pincode: '497775' },
  { value: 'manendragarh', label: 'Manendragarh', pincode: '497001' },
  { value: 'manendragarh-town', label: 'Manendragarh Town', pincode: '497001' },
  { value: 'mohla', label: 'Mohla', pincode: '497774' },
  { value: 'pendra', label: 'Pendra', pincode: '497225' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '497221' },
  { value: 'sakti', label: 'Sakti', pincode: '491113' },
  { value: 'salhepur', label: 'Salhepur', pincode: '497773' },
  { value: 'sihora', label: 'Sihora', pincode: '497225' },
  { value: 'tilda', label: 'Tilda', pincode: '491114' },
  { value: 'amraipar', label: 'Amraipar', pincode: '497777' },
  { value: 'bandhara', label: 'Bandhara', pincode: '497776' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '497772' },
  { value: 'gundardehi', label: 'Gundardehi', pincode: '497774' },
  { value: 'kanan', label: 'Kanan', pincode: '497775' },
  { value: 'pali', label: 'Pali', pincode: '497777' },
  { value: 'pithora', label: 'Pithora', pincode: '497775' },
  { value: 'sugwa', label: 'Sugwa', pincode: '497777' },
  { value: 'banka', label: 'Banka', pincode: '497776' },
  { value: 'rajhara', label: 'Rajhara', pincode: '497773' },
  { value: 'rewa', label: 'Rewa', pincode: '497778' },
  { value: 'khodri', label: 'Khodri', pincode: '497775' },
  { value: 'kumhari', label: 'Kumhari', pincode: '497774' },
  { value: 'ghoghan', label: 'Ghoghan', pincode: '497770' }
  ],

  'mungeli': [
  { value: 'babhani', label: 'Babhani', pincode: '495334' },
  { value: 'balaghat', label: 'Balaghat', pincode: '495334' },
  { value: 'birsinghpur', label: 'Birsinghpur', pincode: '495334' },
  { value: 'chhuri', label: 'Chhuri', pincode: '495335' },
  { value: 'dharamjaigarh', label: 'Dharamjaigarh', pincode: '495116' },
  { value: 'ghotia', label: 'Ghotia', pincode: '495332' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '495331' },
  { value: 'katora', label: 'Katora', pincode: '495337' },
  { value: 'khopdi', label: 'Khopdi', pincode: '495336' },
  { value: 'madhubhan', label: 'Madhubhan', pincode: '495334' },
  { value: 'mangmari', label: 'Mangmari', pincode: '495335' },
  { value: 'mendka', label: 'Mendka', pincode: '495336' },
  { value: 'mungeli', label: 'Mungeli', pincode: '495334' },
  { value: 'mungeli-town', label: 'Mungeli Town', pincode: '495334' },
  { value: 'nawapara', label: 'Nawapara', pincode: '495334' },
  { value: 'pendri', label: 'Pendri', pincode: '495335' },
  { value: 'pithora', label: 'Pithora', pincode: '495112' },
  { value: 'rajpur', label: 'Rajpur', pincode: '495336' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '495335' },
  { value: 'sakti', label: 'Sakti', pincode: '491113' },
  { value: 'sihora', label: 'Sihora', pincode: '495114' },
  { value: 'tilda', label: 'Tilda', pincode: '491114' },
  { value: 'wada', label: 'Wada', pincode: '495337' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '495338' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '495334' },
  { value: 'ranidih', label: 'Ranidih', pincode: '495332' },
  { value: 'barpali', label: 'Barpali', pincode: '495339' },
  { value: 'bihiya', label: 'Bihiya', pincode: '495337' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '495335' },
  { value: 'bengal', label: 'Bengal', pincode: '495335' },
  { value: 'rahatgaon', label: 'Rahatgaon', pincode: '495334' },
  { value: 'malgaon', label: 'Malgaon', pincode: '495336' },
  { value: 'birgaon', label: 'Birgaon', pincode: '495334' },
  { value: 'lalpur', label: 'Lalpur', pincode: '495337' },
  { value: 'beldara', label: 'Beldara', pincode: '495335' },
  { value: 'rangadih', label: 'Rangadih', pincode: '495335' },
  { value: 'singhpur', label: 'Singhpur', pincode: '495336' },
  { value: 'pali', label: 'Pali', pincode: '495338' },
  { value: 'baloda', label: 'Baloda', pincode: '495334' },
  { value: 'patwari', label: 'Patwari', pincode: '495334' }
  ],

  'ramanujganj': [
  { value: 'akhra', label: 'Akhra', pincode: '497220' },
  { value: 'bahuti', label: 'Bahuti', pincode: '497220' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '497221' },
  { value: 'bhuria', label: 'Bhuria', pincode: '497220' },
  { value: 'dudhani', label: 'Dudhani', pincode: '497222' },
  { value: 'gobra', label: 'Gobra', pincode: '497223' },
  { value: 'gothgaon', label: 'Gothgaon', pincode: '497221' },
  { value: 'kharsia', label: 'Kharsia', pincode: '497334' },
  { value: 'kurud', label: 'Kurud', pincode: '497222' },
  { value: 'mana', label: 'Mana', pincode: '497223' },
  { value: 'manpur', label: 'Manpur', pincode: '497220' },
  { value: 'ramanujganj', label: 'Ramanujganj', pincode: '497220' },
  { value: 'ramanujganj-town', label: 'Ramanujganj Town', pincode: '497220' },
  { value: 'sakti', label: 'Sakti', pincode: '491113' },
  { value: 'tilda', label: 'Tilda', pincode: '491114' },
  { value: 'kumhari', label: 'Kumhari', pincode: '495334' },
  { value: 'devpur', label: 'Devpur', pincode: '497223' },
  { value: 'kharra', label: 'Kharra', pincode: '497221' },
  { value: 'patharia', label: 'Patharia', pincode: '497220' },
  { value: 'patli', label: 'Patli', pincode: '497222' },
  { value: 'rajpura', label: 'Rajpura', pincode: '497221' },
  { value: 'sarsi', label: 'Sarsi', pincode: '497220' },
  { value: 'sidhi', label: 'Sidhi', pincode: '497220' },
  { value: 'titri', label: 'Titri', pincode: '497222' }
  ],

  'rajim': [
  { value: 'adampur', label: 'Adampur', pincode: '500070' },
  { value: 'balaji-nagar', label: 'Balaji Nagar', pincode: '500051' },
  { value: 'borabanda', label: 'Borabanda', pincode: '500018' },
  { value: 'chirag-ali-bazar', label: 'Chirag Ali Bazar', pincode: '500001' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'hussainialam', label: 'Hussainialam', pincode: '500064' },
  { value: 'i-branch', label: 'I Branch', pincode: '500040' },
  { value: 'koti', label: 'Koti', pincode: '500095' },
  { value: 'malkajgiri', label: 'Malkajgiri', pincode: '500047' },
  { value: 'musheerabad', label: 'Musheerabad', pincode: '500020' },
  { value: 'nampally', label: 'Nampally', pincode: '500001' },
  { value: 'padmarao-nagar', label: 'Padmarao Nagar', pincode: '500025' },
  { value: 'secunderabad', label: 'Secunderabad', pincode: '500003' },
  { value: 'somajiguda', label: 'Somajiguda', pincode: '500082' },
  { value: 'tarnaka', label: 'Tarnaka', pincode: '500017' },
  { value: 'warasiguda', label: 'Warasiguda', pincode: '500061' },
  { value: 'ameerpet', label: 'Ameerpet', pincode: '500016' },
  { value: 'balkampet', label: 'Balkampet', pincode: '500018' },
  { value: 'bandlaguda', label: 'Bandlaguda', pincode: '500005' },
  { value: 'bansilalpet', label: 'Bansilalpet', pincode: '500029' },
  { value: 'begumpet', label: 'Begumpet', pincode: '500016' },
  { value: 'borabanda', label: 'Borabanda', pincode: '500018' },
  { value: 'chandrayangutta', label: 'Chandrayangutta', pincode: '500005' },
  { value: 'chikkadpally', label: 'Chikkadpally', pincode: '500020' },
  { value: 'chilkur', label: 'Chilkur', pincode: '500075' },
  { value: 'dilsukhnagar', label: 'Dilsukhnagar', pincode: '500060' },
  { value: 'hitech-city', label: 'Hitech City', pincode: '500081' },
  { value: 'kukatpally', label: 'Kukatpally', pincode: '500072' },
  { value: 'lalkapul', label: 'Lalkapul', pincode: '500004' },
  { value: 'madhapur', label: 'Madhapur', pincode: '500081' },
  { value: 'mallapur', label: 'Mallapur', pincode: '500076' },
  { value: 'musheerabad', label: 'Musheerabad', pincode: '500020' },
  { value: 'old-bowenpally', label: 'Old Bowenpally', pincode: '500011' },
  { value: 'panjagutta', label: 'Panjagutta', pincode: '500082' },
  { value: 'patancheru', label: 'Patancheru', pincode: '500032' },
  { value: 'rahatabad', label: 'Rahatabad', pincode: '500018' },
  { value: 'ravindranath-thota', label: 'Ravindranath Thota', pincode: '500014' },
  { value: 'vengalrao-nagar', label: 'Vengalrao Nagar', pincode: '500038' },
  { value: 'zebra-chowk', label: 'Zebra Chowk', pincode: '500029' }
  ],

  'ratanpur': [
  { value: 'alwal', label: 'Alwal', pincode: '500010' },
  { value: 'barkas', label: 'Barkas', pincode: '500039' },
  { value: 'chandrayangutta', label: 'Chandrayangutta', pincode: '500005' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kubera', label: 'Kubera', pincode: '500078' },
  { value: 'malkajgiri', label: 'Malkajgiri', pincode: '500047' },
  { value: 'nagole', label: 'Nagole', pincode: '500068' },
  { value: 'ramantapur', label: 'Ramantapur', pincode: '500013' },
  { value: 'sainikpuri', label: 'Sainikpuri', pincode: '500062' },
  { value: 'saroornagar', label: 'Saroornagar', pincode: '500035' },
  { value: 'shamshabad', label: 'Shamshabad', pincode: '500128' },
  { value: 'tamka', label: 'Tamka', pincode: '500027' },
  { value: 'warasiguda', label: 'Warasiguda', pincode: '500061' },
  { value: 'dilsukhnagar', label: 'Dilsukhnagar', pincode: '500060' },
  { value: 'uppal', label: 'Uppal', pincode: '500039' },
  { value: 'kothapet', label: 'Kothapet', pincode: '500035' },
  { value: 'safilguda', label: 'Safilguda', pincode: '500056' },
  { value: 'balanagar', label: 'Balanagar', pincode: '500037' },
  { value: 'miyapur', label: 'Miyapur', pincode: '500049' },
  { value: 'aushapur', label: 'Aushapur', pincode: '500082' },
  { value: 'alwal-badi', label: 'Alwal Badi', pincode: '500010' },
  { value: 'paradise', label: 'Paradise', pincode: '500003' },
  { value: 'tarnaka', label: 'Tarnaka', pincode: '500007' },
  { value: 'kukatpally', label: 'Kukatpally', pincode: '500072' },
  { value: 'boduppal', label: 'Boduppal', pincode: '500062' },
  { value: 'lbnagar', label: 'LB Nagar', pincode: '500074' },
  { value: 'jambagh', label: 'Jambagh', pincode: '500095' },
  { value: 'habsiguda', label: 'Habsiguda', pincode: '500007' },
  { value: 'meenambakkam', label: 'Meenambakkam', pincode: '500060' },
  { value: 'banjara-hills', label: 'Banjara Hills', pincode: '500034' },
  { value: 'attapur', label: 'Attapur', pincode: '500048' },
  ],

  'sakti': [
  { value: 'arjuni', label: 'Arjuni', pincode: '495681' },
  { value: 'bhatapara', label: 'Bhatapara', pincode: '495224' },
  { value: 'belha', label: 'Belha', pincode: '495113' },
  { value: 'bijapath', label: 'Bijapath', pincode: '495325' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '495663' },
  { value: 'dabhra', label: 'Dabhra', pincode: '495690' },
  { value: 'dongargaon', label: 'Dongargaon', pincode: '495682' },
  { value: 'gaon', label: 'Gaon', pincode: '495654' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jashpur', label: 'Jashpur', pincode: '495001' },
  { value: 'kharsia', label: 'Kharsia', pincode: '495672' },
  { value: 'kharora', label: 'Kharora', pincode: '495665' },
  { value: 'kurud', label: 'Kurud', pincode: '495674' },
  { value: 'kunkuri', label: 'Kunkuri', pincode: '495684' },
  { value: 'malkangiri', label: 'Malkangiri', pincode: '495005' },
  { value: 'manora', label: 'Manora', pincode: '495323' },
  { value: 'pendra', label: 'Pendra', pincode: '495119' },
  { value: 'raigarh', label: 'Raigarh', pincode: '495001' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'sakti', label: 'Sakti', pincode: '495689' },
  { value: 'saragaon', label: 'Saragaon', pincode: '495331' },
  { value: 'tilda', label: 'Tilda', pincode: '495230' },
  { value: 'udra', label: 'Udra', pincode: '495116' },
  { value: 'fingeshwar', label: 'Fingeshwar', pincode: '495291' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '493332' },
  { value: 'bijapur', label: 'Bijapur', pincode: '495224' },
  { value: 'champa', label: 'Champa', pincode: '495671' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '495669' },
  { value: 'devpuri', label: 'Devpuri', pincode: '495661' },
  { value: 'khadgaon', label: 'Khadgaon', pincode: '495004' },
  { value: 'gariaband', label: 'Gariaband', pincode: '493889' },
  { value: 'pathalgaon', label: 'Pathalgaon', pincode: '495220' },
  { value: 'jindal', label: 'Jindal', pincode: '495117' },
  { value: 'kashipara', label: 'Kashipara', pincode: '495118' },
  ],

'sarangarh': [
  { value: 'arjuni', label: 'Arjuni', pincode: '495681' },
  { value: 'balod', label: 'Balod', pincode: '491226' },
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '493332' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '495688' },
  { value: 'bijapath', label: 'Bijapath', pincode: '495325' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '495116' },
  { value: 'champa', label: 'Champa', pincode: '495671' },
  { value: 'dabhra', label: 'Dabhra', pincode: '495690' },
  { value: 'deobhog', label: 'Deobhog', pincode: '495685' },
  { value: 'dongargaon', label: 'Dongargaon', pincode: '495682' },
  { value: 'gaon', label: 'Gaon', pincode: '495654' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jashpur', label: 'Jashpur', pincode: '495001' },
  { value: 'kharora', label: 'Kharora', pincode: '495665' },
  { value: 'kharsia', label: 'Kharsia', pincode: '495672' },
  { value: 'kurud', label: 'Kurud', pincode: '495674' },
  { value: 'malkangiri', label: 'Malkangiri', pincode: '495005' },
  { value: 'manora', label: 'Manora', pincode: '495323' },
  { value: 'pendra', label: 'Pendra', pincode: '495119' },
  { value: 'pathalgaon', label: 'Pathalgaon', pincode: '495220' },
  { value: 'raigarh', label: 'Raigarh', pincode: '495001' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'sarangarh', label: 'Sarangarh', pincode: '495689' },
  { value: 'saragaon', label: 'Saragaon', pincode: '495331' },
  { value: 'tilda', label: 'Tilda', pincode: '495230' },
  { value: 'udra', label: 'Udra', pincode: '495116' },
  { value: 'fingeshwar', label: 'Fingeshwar', pincode: '495291' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '495669' },
  { value: 'balrampur', label: 'Balrampur', pincode: '495551' },
  { value: 'kunkuri', label: 'Kunkuri', pincode: '495684' },
  { value: 'devpuri', label: 'Devpuri', pincode: '495661' },
  { value: 'bhatauli', label: 'Bhatauli', pincode: '495229' },
  ],
  
  'simga': [
  { value: 'arjuni', label: 'Arjuni', pincode: '495681' },
  { value: 'barpali', label: 'Barpali', pincode: '495449' },
  { value: 'balod', label: 'Balod', pincode: '491226' },
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '493332' },
  { value: 'bhatapara', label: 'Bhatapara', pincode: '495224' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'champa', label: 'Champa', pincode: '495671' },
  { value: 'dharsiwa', label: 'Dharsiwa', pincode: '492001' },
  { value: 'dongargaon', label: 'Dongargaon', pincode: '495682' },
  { value: 'fingeshwar', label: 'Fingeshwar', pincode: '495291' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jashpur', label: 'Jashpur', pincode: '495001' },
  { value: 'kharsia', label: 'Kharsia', pincode: '495672' },
  { value: 'kunkuri', label: 'Kunkuri', pincode: '495684' },
  { value: 'kurud', label: 'Kurud', pincode: '495674' },
  { value: 'manora', label: 'Manora', pincode: '495323' },
  { value: 'pendra', label: 'Pendra', pincode: '495119' },
  { value: 'raigarh', label: 'Raigarh', pincode: '495001' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'simga', label: 'Simga', pincode: '495005' },
  { value: 'sarsi', label: 'Sarsi', pincode: '495333' },
  { value: 'tilda', label: 'Tilda', pincode: '495230' },
  { value: 'udra', label: 'Udra', pincode: '495116' },
  { value: 'belha', label: 'Belha', pincode: '495113' },
  { value: 'balrampur', label: 'Balrampur', pincode: '495551' },
  { value: 'kharora', label: 'Kharora', pincode: '495665' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '495669' },
  { value: 'pathalgaon', label: 'Pathalgaon', pincode: '495220' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '495688' },
  { value: 'bhatauli', label: 'Bhatauli', pincode: '495229' }
  ],
  
  'sukma': [
  { value: 'bastar', label: 'Bastar', pincode: '494001' },
  { value: 'bhairamgarh', label: 'Bhairamgarh', pincode: '494229' },
  { value: 'chintagufa', label: 'Chintagufa', pincode: '494100' },
  { value: 'darbha', label: 'Darbha', pincode: '494110' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'jagdalpur', label: 'Jagdalpur', pincode: '494001' },
  { value: 'kanker', label: 'Kanker', pincode: '494334' },
  { value: 'kirandul', label: 'Kirandul', pincode: '494557' },
  { value: 'konta', label: 'Konta', pincode: '494112' },
  { value: 'korar', label: 'Korar', pincode: '494229' },
  { value: 'maad', label: 'Maad', pincode: '494221' },
  { value: 'manpur', label: 'Manpur', pincode: '494221' },
  { value: 'mavli', label: 'Mavli', pincode: '494223' },
  { value: 'naryanpur', label: 'Naryanpur', pincode: '494661' },
  { value: 'sukma', label: 'Sukma', pincode: '494111' },
  { value: 'tadmetla', label: 'Tadmetla', pincode: '494111' },
  { value: 'tokapal', label: 'Tokapal', pincode: '494221' },
  { value: 'vishrampuri', label: 'Vishrampuri', pincode: '494114' },
  { value: 'dondai', label: 'Dondai', pincode: '494225' },
  { value: 'bhamragarh', label: 'Bhamragarh', pincode: '494221' },
  { value: 'sarapaka', label: 'Sarapaka', pincode: '494222' },
  { value: 'tirathgarh', label: 'Tirathgarh', pincode: '494661' },
  { value: 'keshkal', label: 'Keshkal', pincode: '494337' },
  { value: 'boregaon', label: 'Boregaon', pincode: '494229' },
  { value: 'dilapidha', label: 'Dilapidha', pincode: '494110' },
  { value: 'bhatpal', label: 'Bhatpal', pincode: '494220' },
  { value: 'ajodhya', label: 'Ajodhya', pincode: '494112' },
  { value: 'kholapathar', label: 'Kholapathar', pincode: '494220' },
  { value: 'kutru', label: 'Kutru', pincode: '494112' },
  { value: 'pallampara', label: 'Pallampara', pincode: '494114' }
  ],

  'surajpur': [
  { value: 'adari', label: 'Adari', pincode: '497229' },
  { value: 'akra', label: 'Akra', pincode: '497229' },
  { value: 'andhiyari', label: 'Andhiyari', pincode: '497229' },
  { value: 'baloda', label: 'Baloda', pincode: '497115' },
  { value: 'bhaiyathan', label: 'Bhaiyathan', pincode: '497229' },
  { value: 'bhpuri', label: 'Bhpuri', pincode: '497229' },
  { value: 'champa', label: 'Champa', pincode: '495671' },
  { value: 'chhata', label: 'Chhata', pincode: '497115' },
  { value: 'chhuri', label: 'Chhuri', pincode: '497229' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jarra', label: 'Jarra', pincode: '497229' },
  { value: 'katora', label: 'Katora', pincode: '497229' },
  { value: 'khasmohar', label: 'Khasmohar', pincode: '497229' },
  { value: 'manora', label: 'Manora', pincode: '497335' },
  { value: 'pangdi', label: 'Pangdi', pincode: '497229' },
  { value: 'patelpara', label: 'Patelpara', pincode: '497229' },
  { value: 'raigarh', label: 'Raigarh', pincode: '495001' },
  { value: 'sarangpur', label: 'Sarangpur', pincode: '497221' },
  { value: 'surajpur', label: 'Surajpur', pincode: '497229' },
  { value: 'tenduwa', label: 'Tenduwa', pincode: '497228' },
  { value: 'tokapal', label: 'Tokapal', pincode: '497330' },
  { value: 'udra', label: 'Udra', pincode: '497229' },
  { value: 'wadal', label: 'Wadal', pincode: '497229' },
  { value: 'kudal', label: 'Kudal', pincode: '497229' },
  { value: 'jhilmili', label: 'Jhilmili', pincode: '497330' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '497229' },
  { value: 'kondatarai', label: 'Kondatarai', pincode: '497229' },
  { value: 'durgapur', label: 'Durgapur', pincode: '497229' },
  { value: 'katghora', label: 'Katghora', pincode: '495447' }
  ],

  'takhatpur': [
  { value: 'adampur', label: 'Adampur', pincode: '495114' },
  { value: 'ambagarh', label: 'Ambagarh', pincode: '495116' },
  { value: 'balod', label: 'Balod', pincode: '491226' },
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '493332' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'bhilai-durg', label: 'Bhilai Durg', pincode: '490001' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '495224' },
  { value: 'chhuri', label: 'Chhuri', pincode: '495226' },
  { value: 'dhamdha', label: 'Dhamdha', pincode: '491331' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jamboni', label: 'Jamboni', pincode: '495335' },
  { value: 'kamath', label: 'Kamath', pincode: '495007' },
  { value: 'karhi', label: 'Karhi', pincode: '495112' },
  { value: 'kharora', label: 'Kharora', pincode: '495673' },
  { value: 'khursipar', label: 'Khursipar', pincode: '491001' },
  { value: 'mohadi', label: 'Mohadi', pincode: '495674' },
  { value: 'patan', label: 'Patan', pincode: '495006' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'saraipali', label: 'Saraipali', pincode: '495338' },
  { value: 'takhatpur', label: 'Takhatpur', pincode: '495119' },
  { value: 'tilda', label: 'Tilda', pincode: '495230' },
  { value: 'udra', label: 'Udra', pincode: '495221' },
  { value: 'bemetara', label: 'Bemetara', pincode: '491335' }
  ],

  'katghora': [
  { value: 'adampur', label: 'Adampur', pincode: '495113' },
  { value: 'ambagarh', label: 'Ambagarh', pincode: '495116' },
  { value: 'babhani', label: 'Babhani', pincode: '495442' },
  { value: 'balco', label: 'Balco', pincode: '495113' },
  { value: 'baloda', label: 'Baloda', pincode: '495338' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '495224' },
  { value: 'bemetara', label: 'Bemetara', pincode: '491335' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'bhilai-durg', label: 'Bhilai Durg', pincode: '490001' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '495225' },
  { value: 'chhuri', label: 'Chhuri', pincode: '495226' },
  { value: 'dhamdha', label: 'Dhamdha', pincode: '491331' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jamboni', label: 'Jamboni', pincode: '495335' },
  { value: 'kamath', label: 'Kamath', pincode: '495007' },
  { value: 'katghora', label: 'Katghora', pincode: '495445' },
  { value: 'kudni', label: 'Kudni', pincode: '495113' },
  { value: 'khursipar', label: 'Khursipar', pincode: '491001' },
  { value: 'manpur', label: 'Manpur', pincode: '495335' },
  { value: 'mohadi', label: 'Mohadi', pincode: '495674' },
  { value: 'padmapur', label: 'Padmapur', pincode: '495226' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'raigarh', label: 'Raigarh', pincode: '495001' },
  { value: 'saraipali', label: 'Saraipali', pincode: '495338' },
  { value: 'takhatpur', label: 'Takhatpur', pincode: '495119' },
  { value: 'tilda', label: 'Tilda', pincode: '495230' },
  { value: 'udra', label: 'Udra', pincode: '495221' },
  { value: 'gurur', label: 'Gurur', pincode: '495679' },
  { value: 'kondatarai', label: 'Kondatarai', pincode: '495227' },
  { value: 'patan', label: 'Patan', pincode: '495112' },
  { value: 'kesla', label: 'Kesla', pincode: '495111' },
  { value: 'rajpur', label: 'Rajpur', pincode: '495221' },
  { value: 'pachpedi', label: 'Pachpedi', pincode: '495001' }
  ],

  'pandatarai': [
  { value: 'adampur', label: 'Adampur', pincode: '495114' },
  { value: 'ambagarh', label: 'Ambagarh', pincode: '495116' },
  { value: 'baloda', label: 'Baloda', pincode: '495338' },
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '493332' },
  { value: 'balod', label: 'Balod', pincode: '491226' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '495225' },
  { value: 'dhamdha', label: 'Dhamdha', pincode: '491331' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jamboni', label: 'Jamboni', pincode: '495335' },
  { value: 'kamath', label: 'Kamath', pincode: '495007' },
  { value: 'katghora', label: 'Katghora', pincode: '495445' },
  { value: 'kudni', label: 'Kudni', pincode: '495113' },
  { value: 'khursipar', label: 'Khursipar', pincode: '491001' },
  { value: 'manpur', label: 'Manpur', pincode: '495335' },
  { value: 'mohadi', label: 'Mohadi', pincode: '495674' },
  { value: 'padmapur', label: 'Padmapur', pincode: '495226' },
  { value: 'patan', label: 'Patan', pincode: '495112' },
  { value: 'pachpedi', label: 'Pachpedi', pincode: '495001' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'raigarh', label: 'Raigarh', pincode: '495001' },
  { value: 'saraipali', label: 'Saraipali', pincode: '495338' },
  { value: 'takhatpur', label: 'Takhatpur', pincode: '495119' },
  { value: 'tilda', label: 'Tilda', pincode: '495230' },
  { value: 'udra', label: 'Udra', pincode: '495221' },
  { value: 'gurur', label: 'Gurur', pincode: '495679' },
  { value: 'kondatarai', label: 'Kondatarai', pincode: '495227' },
  { value: 'kesla', label: 'Kesla', pincode: '495111' },
  { value: 'rajpur', label: 'Rajpur', pincode: '495221' },
  { value: 'padkhera', label: 'Padkhera', pincode: '495229' },
  { value: 'jogi', label: 'Jogi', pincode: '495008' },
  { value: 'pahanda', label: 'Pahanda', pincode: '495202' },
  { value: 'malkharoda', label: 'Malkharoda', pincode: '495336' }
  ],

  'bilaspur': [
  { value: 'akhra', label: 'Akhra', pincode: '495001' },
  { value: 'bandhan', label: 'Bandhan', pincode: '495004' },
  { value: 'bara-bazar', label: 'Bara Bazar', pincode: '495001' },
  { value: 'bilaspur-civil-lines', label: 'Bilaspur Civil Lines', pincode: '495001' },
  { value: 'bilaspur-durgapur', label: 'Bilaspur Durgapur', pincode: '495004' },
  { value: 'bilaspur-gandhi-market', label: 'Bilaspur Gandhi Market', pincode: '495001' },
  { value: 'bilaspur-mandla', label: 'Bilaspur Mandla', pincode: '495004' },
  { value: 'bilaspur-railway-station', label: 'Bilaspur Railway Station', pincode: '495004' },
  { value: 'bilaspur-sadar-bazar', label: 'Bilaspur Sadar Bazar', pincode: '495001' },
  { value: 'chakarbhata', label: 'Chakarbhata', pincode: '495004' },
  { value: 'chapra', label: 'Chapra', pincode: '495001' },
  { value: 'durgapur', label: 'Durgapur', pincode: '495004' },
  { value: 'gokul', label: 'Gokul', pincode: '495006' },
  { value: 'hirapur', label: 'Hirapur', pincode: '495004' },
  { value: 'jagnath', label: 'Jagnath', pincode: '495003' },
  { value: 'koni', label: 'Koni', pincode: '495006' },
  { value: 'kurud', label: 'Kurud', pincode: '495002' },
  { value: 'lakholi', label: 'Lakholi', pincode: '495007' },
  { value: 'moharipara', label: 'Moharipara', pincode: '495001' },
  { value: 'new-bilaspur', label: 'New Bilaspur', pincode: '495004' },
  { value: 'old-bilaspur', label: 'Old Bilaspur', pincode: '495001' },
  { value: 'pendra', label: 'Pendra', pincode: '495119' },
  { value: 'pali', label: 'Pali', pincode: '495449' },
  { value: 'raigarh', label: 'Raigarh', pincode: '495001' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '495005' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '495001' },
  { value: 'sakti', label: 'Sakti', pincode: '495689' },
  { value: 'sita-nagar', label: 'Sita Nagar', pincode: '495003' },
  { value: 'tulsi-nagar', label: 'Tulsi Nagar', pincode: '495005' },
  { value: 'vidyut-nagar', label: 'Vidyut Nagar', pincode: '495006' },
  { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '495004' },
  { value: 'wrs-colony', label: 'WRS Colony', pincode: '495004' }
  ],

  'ambikapur': [
  { value: 'ambikapur-bazar', label: 'Ambikapur Bazar', pincode: '497001' },
  { value: 'ambikapur-ganj', label: 'Ambikapur Ganj', pincode: '497001' },
  { value: 'ambikapur-mandi', label: 'Ambikapur Mandi', pincode: '497001' },
  { value: 'balera', label: 'Balera', pincode: '497001' },
  { value: 'balrampur', label: 'Balrampur', pincode: '497119' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '497001' },
  { value: 'bhuriya', label: 'Bhuriya', pincode: '497001' },
  { value: 'chichgaon', label: 'Chichgaon', pincode: '497001' },
  { value: 'deora', label: 'Deora', pincode: '497001' },
  { value: 'dundra', label: 'Dundra', pincode: '497001' },
  { value: 'garhgaon', label: 'Garhgaon', pincode: '497001' },
  { value: 'jaspur', label: 'Jaspur', pincode: '497554' },
  { value: 'kakra', label: 'Kakra', pincode: '497001' },
  { value: 'kanker', label: 'Kanker', pincode: '497331' },
  { value: 'kapu', label: 'Kapu', pincode: '497001' },
  { value: 'kharsia', label: 'Kharsia', pincode: '497778' },
  { value: 'koni', label: 'Koni', pincode: '497001' },
  { value: 'kosam', label: 'Kosam', pincode: '497001' },
  { value: 'maheshpur', label: 'Maheshpur', pincode: '497001' },
  { value: 'mangla', label: 'Mangla', pincode: '497001' },
  { value: 'mohdi', label: 'Mohdi', pincode: '497001' },
  { value: 'pali', label: 'Pali', pincode: '497107' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '497001' },
  { value: 'sakti', label: 'Sakti', pincode: '497689' },
  { value: 'shankargarh', label: 'Shankargarh', pincode: '497111' },
  { value: 'sulga', label: 'Sulga', pincode: '497001' },
  { value: 'takiya', label: 'Takiya', pincode: '497001' },
  { value: 'tutar', label: 'Tutar', pincode: '497001' },
  { value: 'budhwari', label: 'Budhwari', pincode: '497001' },
  { value: 'bandhapara', label: 'Bandhapara', pincode: '497001' },
  { value: 'kharora', label: 'Kharora', pincode: '497101' },
  { value: 'amargarh', label: 'Amargarh', pincode: '497001' },
  { value: 'barachhapar', label: 'Barachhapar', pincode: '497001' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '497111' },
  { value: 'kondtarai', label: 'Kondtarai', pincode: '497001' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '497001' },
  { value: 'sanwari', label: 'Sanwari', pincode: '497111' },
  { value: 'maliwara', label: 'Maliwara', pincode: '497001' },
  { value: 'kodiya', label: 'Kodiya', pincode: '497001' },
  { value: 'surajpur', label: 'Surajpur', pincode: '497229' },
  { value: 'dabra', label: 'Dabra', pincode: '497001' }
  ],

  //Andhra Pradesh Areas
  'ongole': [
  { value: 'aluru', label: 'Aluru', pincode: '523271' },
  { value: 'bommidala', label: 'Bommidala', pincode: '523101' },
  { value: 'china-koduru', label: 'China Koduru', pincode: '523289' },
  { value: 'chinaganjam', label: 'Chinaganjam', pincode: '523234' },
  { value: 'dukutunta', label: 'Dukutunta', pincode: '523286' },
  { value: 'gadigudur', label: 'Gadigudur', pincode: '523185' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gollapalli', label: 'Gollapalli', pincode: '523220' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kakarlapudi', label: 'Kakarlapudi', pincode: '523112' },
  { value: 'kandukur', label: 'Kandukur', pincode: '523105' },
  { value: 'kosigi', label: 'Kosigi', pincode: '523107' },
  { value: 'marripudi', label: 'Marripudi', pincode: '523294' },
  { value: 'nellore', label: 'Nellore', pincode: '524001' },
  { value: 'ongole', label: 'Ongole', pincode: '523001' },
  { value: 'peda-guduru', label: 'Peda Guduru', pincode: '523168' },
  { value: 'pedda-koduru', label: 'Pedda Koduru', pincode: '523287' },
  { value: 'perupalem', label: 'Perupalem', pincode: '523225' },
  { value: 'ramayapalem', label: 'Ramayapalem', pincode: '523292' },
  { value: 'santapet', label: 'Santapet', pincode: '523266' },
  { value: 'srinivasapuram', label: 'Srinivasapuram', pincode: '523186' },
  { value: 'surareddy-puram', label: 'Surareddy Puram', pincode: '523248' },
  { value: 'vaddepalem', label: 'Vaddepalem', pincode: '523160' },
  { value: 'varagapudi', label: 'Varagapudi', pincode: '523269' },
  { value: 'vengamukkala', label: 'Vengamukkala', pincode: '523248' },
  { value: 'yerramreddy', label: 'Yerramreddy', pincode: '523215' },
  { value: 'bapatla', label: 'Bapatla', pincode: '523325' },
  { value: 'burugupudi', label: 'Burugupudi', pincode: '523297' },
  { value: 'kothapatnam', label: 'Kothapatnam', pincode: '523308' },
  { value: 'movva', label: 'Movva', pincode: '523113' },
  { value: 'nizampatnam', label: 'Nizampatnam', pincode: '523287' },
  { value: 'peddaganjam', label: 'Peddaganjam', pincode: '523201' },
  { value: 'peddamaddur', label: 'Peddamaddur', pincode: '523314' },
  { value: 'repalle', label: 'Repalle', pincode: '523175' },
  { value: 'singarayakonda', label: 'Singarayakonda', pincode: '523101' },
  { value: 'suryaraopeta', label: 'Suryaraopeta', pincode: '523164' },
  { value: 'yerragondapalem', label: 'Yerragondapalem', pincode: '523202' }
  ],

  'guntur': [
  { value: 'adavi', label: 'Adavi', pincode: '522508' },
  { value: 'amma-cheruvu', label: 'Amma Cheruvu', pincode: '522314' },
  { value: 'annavaram', label: 'Annavaram', pincode: '522111' },
  { value: 'chakrayapalem', label: 'Chakrayapalem', pincode: '522213' },
  { value: 'donka-vari-peta', label: 'Donka Vari Peta', pincode: '522002' },
  { value: 'gandhinagar', label: 'Gandhinagar', pincode: '522002' },
  { value: 'gundlapalli', label: 'Gundlapalli', pincode: '522235' },
  { value: 'kolluru', label: 'Kolluru', pincode: '522401' },
  { value: 'krishna-lanka', label: 'Krishna Lanka', pincode: '522001' },
  { value: 'labbipet', label: 'Labbipet', pincode: '522007' },
  { value: 'mangalagiri', label: 'Mangalagiri', pincode: '522503' },
  { value: 'manipal', label: 'Manipal', pincode: '522503' },
  { value: 'murali-nagar', label: 'Murali Nagar', pincode: '522004' },
  { value: 'nagaram', label: 'Nagaram', pincode: '522203' },
  { value: 'nallapadu', label: 'Nallapadu', pincode: '522005' },
  { value: 'pedakakani', label: 'Pedakakani', pincode: '522509' },
  { value: 'pedanandipadu', label: 'Pedanandipadu', pincode: '522235' },
  { value: 'prathipadu', label: 'Prathipadu', pincode: '522019' },
  { value: 'pundlapadu', label: 'Pundlapadu', pincode: '522401' },
  { value: 'sattenapalle', label: 'Sattenapalle', pincode: '522403' },
  { value: 'tenali', label: 'Tenali', pincode: '522201' },
  { value: 'vijayapuri', label: 'Vijayapuri', pincode: '522301' },
  { value: 'vipparla', label: 'Vipparla', pincode: '522306' },
  { value: 'ward-5', label: 'Ward 5', pincode: '522004' },
  { value: 'ward-9', label: 'Ward 9', pincode: '522003' },
  { value: 'yaswanthapuram', label: 'Yaswanthapuram', pincode: '522004' }
  ],

  'dharmavaram': [
  { value: 'addagudur', label: 'Addagudur', pincode: '515672' },
  { value: 'avilala', label: 'Avilala', pincode: '515673' },
  { value: 'chandrayapeta', label: 'Chandrayapeta', pincode: '515671' },
  { value: 'chennur', label: 'Chennur', pincode: '515677' },
  { value: 'dharmavaram-town', label: 'Dharmavaram Town', pincode: '515671' },
  { value: 'garimellapalle', label: 'Garimellapalle', pincode: '515671' },
  { value: 'gokavaram', label: 'Gokavaram', pincode: '515673' },
  { value: 'kanumuru', label: 'Kanumuru', pincode: '515678' },
  { value: 'kandikayapalli', label: 'Kandikayapalli', pincode: '515674' },
  { value: 'kothapeta', label: 'Kothapeta', pincode: '515674' },
  { value: 'maddimadugu', label: 'Maddimadugu', pincode: '515672' },
  { value: 'nallacheruvu', label: 'Nallacheruvu', pincode: '515675' },
  { value: 'pillalamarri', label: 'Pillalamarri', pincode: '515673' },
  { value: 'ragampeta', label: 'Ragampeta', pincode: '515674' },
  { value: 'rajupalem', label: 'Rajupalem', pincode: '515673' },
  { value: 'ramachandrapur', label: 'Ramachandrapur', pincode: '515675' },
  { value: 'srisailam', label: 'Srisailam', pincode: '515677' },
  { value: 'takkellapadu', label: 'Takkellapadu', pincode: '515678' },
  { value: 'vempalli', label: 'Vempalli', pincode: '515671' },
  { value: 'valapureddipalle', label: 'Valapureddipalle', pincode: '515675' },
  { value: 'yerragunta', label: 'Yerragunta', pincode: '515674' },
  { value: 'yanadapalle', label: 'Yanadapalle', pincode: '515674' },
  { value: 'koppur', label: 'Koppur', pincode: '515677' },
  { value: 'gudipalle', label: 'Gudipalle', pincode: '515673' }
  ],

  'chittoor': [
  { value: 'achireddipalli', label: 'Achireddipalli', pincode: '517569' },
  { value: 'alapakkam', label: 'Alapakkam', pincode: '517001' },
  { value: 'bariyapuram', label: 'Bariyapuram', pincode: '517415' },
  { value: 'chandragiri', label: 'Chandragiri', pincode: '517101' },
  { value: 'chittoor-town', label: 'Chittoor Town', pincode: '517001' },
  { value: 'damalcheruvu', label: 'Damalcheruvu', pincode: '517432' },
  { value: 'jonnalagadda', label: 'Jonnalagadda', pincode: '517254' },
  { value: 'karvetnagar', label: 'Karvetnagar', pincode: '517582' },
  { value: 'kattamanchi', label: 'Kattamanchi', pincode: '517227' },
  { value: 'kothapalli', label: 'Kothapalli', pincode: '517412' },
  { value: 'krishnapuram', label: 'Krishnapuram', pincode: '517411' },
  { value: 'murukambattu', label: 'Murukambattu', pincode: '517421' },
  { value: 'nagalapuram', label: 'Nagalapuram', pincode: '517587' },
  { value: 'puttaparthi', label: 'Puttaparthi', pincode: '517002' },
  { value: 'reddipalli', label: 'Reddipalli', pincode: '517003' },
  { value: 'satyavedu', label: 'Satyavedu', pincode: '517588' },
  { value: 'sri-kalahasti', label: 'Sri Kalahasti', pincode: '517644' },
  { value: 'tangutur', label: 'Tangutur', pincode: '517536' },
  { value: 'vengalamma', label: 'Vengalamma', pincode: '517467' },
  { value: 'vellore', label: 'Vellore', pincode: '517570' },
  { value: 'balayapalli', label: 'Balayapalli', pincode: '517002' },
  { value: 'bukkarayasamudram', label: 'Bukkarayasamudram', pincode: '517611' },
  { value: 'chandramoulinagar', label: 'Chandramoulinagar', pincode: '517415' },
  { value: 'harijanapalli', label: 'Harijanapalli', pincode: '517331' },
  { value: 'kanipakam', label: 'Kanipakam', pincode: '517194' },
  { value: 'kothacheruvu', label: 'Kothacheruvu', pincode: '517235' },
  { value: 'kothur', label: 'Kothur', pincode: '517411' },
  { value: 'nagari', label: 'Nagari', pincode: '517590' },
  { value: 'peddakuppam', label: 'Peddakuppam', pincode: '517121' },
  { value: 'tummalapalle', label: 'Tummalapalle', pincode: '517267' },
  { value: 'vallur', label: 'Vallur', pincode: '517335' },
  { value: 'vayalapalli', label: 'Vayalapalli', pincode: '517292' },
  { value: 'venkatagirikota', label: 'Venkatagirikota', pincode: '517424' }
  ],

  'chilakaluripet': [
  { value: 'annadhana', label: 'Annadhana', pincode: '522616' },
  { value: 'chilakaluripet-town', label: 'Chilakaluripet Town', pincode: '522616' },
  { value: 'chinamandem', label: 'Chinamandem', pincode: '522612' },
  { value: 'donakonda', label: 'Donakonda', pincode: '522618' },
  { value: 'gannavaram', label: 'Gannavaram', pincode: '522616' },
  { value: 'gundlapalli', label: 'Gundlapalli', pincode: '522612' },
  { value: 'kothapeta', label: 'Kothapeta', pincode: '522618' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '522616' },
  { value: 'madhurapuri', label: 'Madhurapuri', pincode: '522616' },
  { value: 'manepalli', label: 'Manepalli', pincode: '522613' },
  { value: 'matha-bazar', label: 'Matha Bazar', pincode: '522614' },
  { value: 'ponduru', label: 'Ponduru', pincode: '522616' },
  { value: 'ravi-nagar', label: 'Ravi Nagar', pincode: '522616' },
  { value: 'venkatapuram', label: 'Venkatapuram', pincode: '522617' },
  { value: 'nagulapalem', label: 'Nagulapalem', pincode: '522616' },
  { value: 'nallapadu', label: 'Nallapadu', pincode: '522618' },
  { value: 'palakollu', label: 'Palakollu', pincode: '522612' },
  { value: 'pedakakani', label: 'Pedakakani', pincode: '522617' },
  { value: 'tangellapadu', label: 'Tangellapadu', pincode: '522619' },
  { value: 'vempadu', label: 'Vempadu', pincode: '522616' }
  ],

  'amaravati': [
  { value: 'ananthavaram', label: 'Ananthavaram', pincode: '522020' },
  { value: 'amaravati-town', label: 'Amaravati Town', pincode: '522020' },
  { value: 'chandralapadu', label: 'Chandralapadu', pincode: '522237' },
  { value: 'gannavaram', label: 'Gannavaram', pincode: '521202' },
  { value: 'gollapudi', label: 'Gollapudi', pincode: '522302' },
  { value: 'jaggayyapeta', label: 'Jaggayyapeta', pincode: '521175' },
  { value: 'kankipadu', label: 'Kankipadu', pincode: '522508' },
  { value: 'kuduru', label: 'Kuduru', pincode: '522408' },
  { value: 'kurumalayapalli', label: 'Kurumalayapalli', pincode: '522413' },
  { value: 'mandadam', label: 'Mandadam', pincode: '522503' },
  { value: 'mangalagiri', label: 'Mangalagiri', pincode: '522503' },
  { value: 'mylavaram', label: 'Mylavaram', pincode: '521230' },
  { value: 'pattiseema', label: 'Pattiseema', pincode: '522302' },
  { value: 'penumaka', label: 'Penumaka', pincode: '522410' },
  { value: 'siddhartha-nagar', label: 'Siddhartha Nagar', pincode: '522402' },
  { value: 'sangam', label: 'Sangam', pincode: '522402' },
  { value: 'tadigadapa', label: 'Tadigadapa', pincode: '522237' },
  { value: 'tulluru', label: 'Tulluru', pincode: '522237' },
  { value: 'uppalapadu', label: 'Uppalapadu', pincode: '522303' },
  { value: 'venkatrayapuram', label: 'Venkatrayapuram', pincode: '522233' },
  { value: 'vijayawada', label: 'Vijayawada', pincode: '520001' },
  { value: 'vuyyuru', label: 'Vuyyuru', pincode: '521165' },
  { value: 'waltair', label: 'Waltair', pincode: '522210' },
  { value: 'vijayapuri', label: 'Vijayapuri', pincode: '522235' },
  { value: 'boggula', label: 'Boggula', pincode: '522238' },
  { value: 'peddagarlapadu', label: 'Peddagarlapadu', pincode: '522410' },
  { value: 'rayanapadu', label: 'Rayanapadu', pincode: '522302' },
  { value: 'kudumulu', label: 'Kudumulu', pincode: '522612' }
  ],

  'bhimavaram': [
  { value: 'aravapalli', label: 'Aravapalli', pincode: '534202' },
  { value: 'bhimavaram-town', label: 'Bhimavaram Town', pincode: '534201' },
  { value: 'chandramoulipuram', label: 'Chandramoulipuram', pincode: '534205' },
  { value: 'chinna-veeranam', label: 'Chinna Veeranam', pincode: '534205' },
  { value: 'gundugolanu', label: 'Gundugolanu', pincode: '534207' },
  { value: 'kadiyam', label: 'Kadiyam', pincode: '534006' },
  { value: 'kothapeta', label: 'Kothapeta', pincode: '534204' },
  { value: 'mandapeta', label: 'Mandapeta', pincode: '534227' },
  { value: 'narasapuram', label: 'Narasapuram', pincode: '534275' },
  { value: 'palakoderu', label: 'Palakoderu', pincode: '534208' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '534292' },
  { value: 'siripuram', label: 'Siripuram', pincode: '534204' },
  { value: 'tadepalligudem', label: 'Tadepalligudem', pincode: '534101' },
  { value: 'tarlupadu', label: 'Tarlupadu', pincode: '534212' },
  { value: 'veeravaram', label: 'Veeravaram', pincode: '534251' },
  { value: 'borepalli', label: 'Borepalli', pincode: '534209' },
  { value: 'chukkapalli', label: 'Chukkapalli', pincode: '534234' },
  { value: 'edlapadu', label: 'Edlapadu', pincode: '534223' },
  { value: 'hamsavaram', label: 'Hamsavaram', pincode: '534210' },
  { value: 'kanaparthi', label: 'Kanaparthi', pincode: '534231' },
  { value: 'kothuru', label: 'Kothuru', pincode: '534229' },
  { value: 'mummidivaram', label: 'Mummidivaram', pincode: '534236' },
  { value: 'rajamahendravaram', label: 'Rajamahendravaram', pincode: '534101' },
  { value: 'singarayakonda', label: 'Singarayakonda', pincode: '534260' }
  ],

  'adoni': [
  { value: 'adoni-town', label: 'Adoni Town', pincode: '518301' },
  { value: 'annapura', label: 'Annapura', pincode: '518301' },
  { value: 'bande', label: 'Bande', pincode: '518302' },
  { value: 'bhutpur', label: 'Bhutpur', pincode: '518301' },
  { value: 'chandrapalli', label: 'Chandrapalli', pincode: '518302' },
  { value: 'gudur', label: 'Gudur', pincode: '518301' },
  { value: 'jammulamadugu', label: 'Jammulamadugu', pincode: '518315' },
  { value: 'kadiri', label: 'Kadiri', pincode: '518303' },
  { value: 'kamalapur', label: 'Kamalapur', pincode: '518303' },
  { value: 'mantralayam', label: 'Mantralayam', pincode: '518345' },
  { value: 'mudigubba', label: 'Mudigubba', pincode: '518001' },
  { value: 'peddapalli', label: 'Peddapalli', pincode: '518303' },
  { value: 'rajalapuram', label: 'Rajalapuram', pincode: '518303' },
  { value: 'saptagiri', label: 'Saptagiri', pincode: '518302' },
  { value: 'venkatapuram', label: 'Venkatapuram', pincode: '518301' },
  { value: 'balapalli', label: 'Balapalli', pincode: '518302' },
  { value: 'chinnapet', label: 'Chinnapet', pincode: '518303' },
  { value: 'gurukul', label: 'Gurukul', pincode: '518305' },
  { value: 'kethavaram', label: 'Kethavaram', pincode: '518303' },
  { value: 'kondapur', label: 'Kondapur', pincode: '518305' },
  { value: 'nalluru', label: 'Nalluru', pincode: '518310' },
  { value: 'ramapuram', label: 'Ramapuram', pincode: '518310' },
  { value: 'sri-peddapalli', label: 'Sri Peddapalli', pincode: '518306' },
  { value: 'yerragunta', label: 'Yerragunta', pincode: '518304' }
  ],


  'anantapur': [
  { value: 'adoni', label: 'Adoni', pincode: '518301' },
  { value: 'anantapur-town', label: 'Anantapur Town', pincode: '515001' },
  { value: 'bukkapatnam', label: 'Bukkapatnam', pincode: '515611' },
  { value: 'chikkaballapur', label: 'Chikkaballapur', pincode: '515581' },
  { value: 'dharmavaram', label: 'Dharmavaram', pincode: '515671' },
  { value: 'gonabadi', label: 'Gonabadi', pincode: '515261' },
  { value: 'guntakal', label: 'Guntakal', pincode: '515801' },
  { value: 'kalyandurg', label: 'Kalyandurg', pincode: '515761' },
  { value: 'kuderu', label: 'Kuderu', pincode: '515651' },
  { value: 'lepakshi', label: 'Lepakshi', pincode: '515331' },
  { value: 'naidupet', label: 'Naidupet', pincode: '515563' },
  { value: 'nallacheruvu', label: 'Nallacheruvu', pincode: '515621' },
  { value: 'penukonda', label: 'Penukonda', pincode: '515110' },
  { value: 'puttaparthi', label: 'Puttaparthi', pincode: '515134' },
  { value: 'rayadurg', label: 'Rayadurg', pincode: '515865' },
  { value: 'settur', label: 'Settur', pincode: '515643' },
  { value: 'tadipatri', label: 'Tadipatri', pincode: '515411' },
  { value: 'yalal', label: 'Yalal', pincode: '515865' }
  ],


  'srikakulam': [
  { value: 'amaravathi', label: 'Amaravathi', pincode: '532201' },
  { value: 'cheepurupalli', label: 'Cheepurupalli', pincode: '532403' },
  { value: 'danthada', label: 'Danthada', pincode: '532122' },
  { value: 'etapaka', label: 'Etapaka', pincode: '532123' },
  { value: 'gummalaxmipuram', label: 'Gummalaxmipuram', pincode: '532121' },
  { value: 'palakonda', label: 'Palakonda', pincode: '532440' },
  { value: 'peddagummuluru', label: 'Peddagummuluru', pincode: '532158' },
  { value: 'sarubujjili', label: 'Sarubujjili', pincode: '532284' },
  { value: 'srikakulam-city', label: 'Srikakulam City', pincode: '532001' },
  { value: 'tekkali', label: 'Tekkali', pincode: '532201' },
  { value: 'unmadu', label: 'Unmadu', pincode: '532279' },
  { value: 'veedhi', label: 'Veedhi', pincode: '532225' },
  { value: 'vruddhachalam', label: 'Vruddhachalam', pincode: '532432' },
  { value: 'zindavali', label: 'Zindavali', pincode: '532206' },
  { value: 'boddapadu', label: 'Boddapadu', pincode: '532286' },
  { value: 'dilipnagar', label: 'Dilipnagar', pincode: '532204' },
  { value: 'kacharlapeta', label: 'Kacharlapeta', pincode: '532151' },
  { value: 'kotturu', label: 'Kotturu', pincode: '532312' },
  { value: 'narasannapeta', label: 'Narasannapeta', pincode: '532420' },
  { value: 'pathapatnam', label: 'Pathapatnam', pincode: '532213' },
  { value: 'rajam', label: 'Rajam', pincode: '532127' },
  { value: 'santha', label: 'Santha', pincode: '532298' },
  { value: 'sompeta', label: 'Sompeta', pincode: '532287' },
  { value: 'srikakulam-rural', label: 'Srikakulam Rural', pincode: '532202' },
  { value: 'tanguturu', label: 'Tanguturu', pincode: '532162' }
  ],

  'rajamundry': [
  { value: 'achanta', label: 'Achanta', pincode: '534278' },
  { value: 'bhimavaram', label: 'Bhimavaram', pincode: '534202' },
  { value: 'chagallu', label: 'Chagallu', pincode: '534222' },
  { value: 'dowleswaram', label: 'Dowleswaram', pincode: '533125' },
  { value: 'gachibowli', label: 'Gachibowli', pincode: '500032' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'hanuman-junction', label: 'Hanuman Junction', pincode: '521105' },
  { value: 'huggalapalli', label: 'Huggalapalli', pincode: '533107' },
  { value: 'jaggampeta', label: 'Jaggampeta', pincode: '533435' },
  { value: 'karapa', label: 'Karapa', pincode: '533455' },
  { value: 'korukonda', label: 'Korukonda', pincode: '533211' },
  { value: 'kuchipudi', label: 'Kuchipudi', pincode: '534273' },
  { value: 'kummari-pet', label: 'Kummari Pet', pincode: '533103' },
  { value: 'maredumilli', label: 'Maredumilli', pincode: '533294' },
  { value: 'peddapuram', label: 'Peddapuram', pincode: '533437' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '533255' },
  { value: 'rajahmundry', label: 'Rajahmundry', pincode: '533101' },
  { value: 'rampachodavaram', label: 'Rampachodavaram', pincode: '533288' },
  { value: 'rajapalayam', label: 'Rajapalayam', pincode: '533117' },
  { value: 'samalkot', label: 'Samalkot', pincode: '533440' },
  { value: 'sarpavaram', label: 'Sarpavaram', pincode: '533245' },
  { value: 'tadepalligudem', label: 'Tadepalligudem', pincode: '534101' },
  { value: 'udayagiri', label: 'Udayagiri', pincode: '533330' },
  { value: 'viravasaram', label: 'Viravasaram', pincode: '533333' },
  { value: 'nidadavolu', label: 'Nidadavolu', pincode: '534301' },
  { value: 'pedapudi', label: 'Pedapudi', pincode: '533436' },
  { value: 'perumallapalle', label: 'Perumallapalle', pincode: '533447' },
  { value: 'prathipadu', label: 'Prathipadu', pincode: '533249' },
  { value: 'rajupalem', label: 'Rajupalem', pincode: '533291' },
  { value: 'ramachandrapuram', label: 'Ramachandrapuram', pincode: '533255' },
  { value: 'ramavaram', label: 'Ramavaram', pincode: '533429' },
  { value: 'seethanagaram', label: 'Seethanagaram', pincode: '533253' },
  { value: 'sivakodu', label: 'Sivakodu', pincode: '533102' },
  { value: 'yanam', label: 'Yanam', pincode: '533464' }
  ],

  'purnia': [
    { value: 'abdpur', label: 'Abdpur', pincode: '854301' },
    { value: 'akhtiyarpur', label: 'Akhtiyarpur', pincode: '854302' },
    { value: 'andharatharhi', label: 'Andharatharhi', pincode: '854338' },
    { value: 'bairia', label: 'Bairia', pincode: '854303' },
    { value: 'balbhadrapur', label: 'Balbhadrapur', pincode: '854304' },
    { value: 'bakhri', label: 'Bakhri', pincode: '854339' },
    { value: 'banmankhi', label: 'Banmankhi', pincode: '854362' },
    { value: 'bariyarpur', label: 'Bariyarpur', pincode: '854361' },
    { value: 'bazar', label: 'Bazar', pincode: '854305' },
    { value: 'bhabua', label: 'Bhabua', pincode: '854374' },
    { value: 'bhagalpur', label: 'Bhagalpur', pincode: '854340' },
    { value: 'bhawanipur', label: 'Bhawanipur', pincode: '854363' },
    { value: 'bhogatpur', label: 'Bhogatpur', pincode: '854364' },
    { value: 'bihariganj', label: 'Bihariganj', pincode: '854306' },
    { value: 'biharpur', label: 'Biharpur', pincode: '854307' },
    { value: 'bihpur', label: 'Bihpur', pincode: '854360' },
    { value: 'bishanpur', label: 'Bishanpur', pincode: '854308' },
    { value: 'chandpur', label: 'Chandpur', pincode: '854341' },
    { value: 'chhatapur', label: 'Chhatapur', pincode: '854342' },
    { value: 'dahiyarpur', label: 'Dahiyarpur', pincode: '854365' },
    { value: 'dalsingsarai', label: 'Dalsingsarai', pincode: '854309' },
    { value: 'dhamdaha', label: 'Dhamdaha', pincode: '854310' },
    { value: 'dumaria', label: 'Dumaria', pincode: '854343' },
    { value: 'dularpur', label: 'Dularpur', pincode: '854311' },
    { value: 'east-bihar', label: 'East Bihar', pincode: '854312' },
    { value: 'ganga-bazar', label: 'Ganga Bazar', pincode: '854313' },
    { value: 'ganga-vihar', label: 'Ganga Vihar', pincode: '854314' },
    { value: 'ghogha', label: 'Ghogha', pincode: '854344' },
    { value: 'gopalpur', label: 'Gopalpur', pincode: '854366' },
    { value: 'gopi', label: 'Gopi', pincode: '854315' },
    { value: 'hasanpur', label: 'Hasanpur', pincode: '854345' },
    { value: 'hussainabad', label: 'Hussainabad', pincode: '854346' },
    { value: 'jagdishpur', label: 'Jagdishpur', pincode: '854316' },
    { value: 'jalah', label: 'Jalah', pincode: '854317' },
    { value: 'jameshpur', label: 'Jameshpur', pincode: '854318' },
    { value: 'johari', label: 'Johari', pincode: '854347' },
    { value: 'kajraha', label: 'Kajraha', pincode: '854348' },
    { value: 'kaimur', label: 'Kaimur', pincode: '854319' },
    { value: 'kaliaganj', label: 'Kaliaganj', pincode: '854367' },
    { value: 'katihar', label: 'Katihar', pincode: '854320' },
    { value: 'khetri', label: 'Khetri', pincode: '854349' },
    { value: 'kishanganj', label: 'Kishanganj', pincode: '854350' },
    { value: 'maharajganj', label: 'Maharajganj', pincode: '854321' },
    { value: 'madhubani', label: 'Madhubani', pincode: '854368' },
    { value: 'madhusudan', label: 'Madhusudan', pincode: '854351' },
    { value: 'maheshpur', label: 'Maheshpur', pincode: '854352' },
    { value: 'manihari', label: 'Manihari', pincode: '854370' },
    { value: 'matihani', label: 'Matihani', pincode: '854353' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '854354' },
    { value: 'muradpur', label: 'Muradpur', pincode: '854355' },
    { value: 'nawada', label: 'Nawada', pincode: '854323' },
    { value: 'niranjanpur', label: 'Niranjanpur', pincode: '854324' },
    { value: 'patwa', label: 'Patwa', pincode: '854325' },
    { value: 'purnea-bazar', label: 'Purnea Bazar', pincode: '854326' },
    { value: 'purnea-municipal', label: 'Purnea Municipal', pincode: '854327' },
    { value: 'purbi', label: 'Purbi', pincode: '854371' },
    { value: 'rajaun', label: 'Rajaun', pincode: '854356' },
    { value: 'rajnagar', label: 'Rajnagar', pincode: '854357' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '854328' },
    { value: 'saharsa', label: 'Saharsa', pincode: '854359' },
    { value: 'samastipur', label: 'Samastipur', pincode: '854329' },
    { value: 'sarahri', label: 'Sarahri', pincode: '854330' },
    { value: 'sarsi', label: 'Sarsi', pincode: '854331' },
    { value: 'shahpur', label: 'Shahpur', pincode: '854332' },
    { value: 'sikaria', label: 'Sikaria', pincode: '854333' },
    { value: 'sitaram', label: 'Sitaram', pincode: '854334' },
    { value: 'south-purnea', label: 'South Purnea', pincode: '854335' },
    { value: 'tufanganj', label: 'Tufanganj', pincode: '854336' },
    { value: 'west-purnea', label: 'West Purnea', pincode: '854337' }
  ],

  'muzaffarpur': [
    { value: 'ahsaanpur', label: 'Ahsaanpur', pincode: '842001' },
    { value: 'asthana', label: 'Asthana', pincode: '842028' },
    { value: 'bairiya', label: 'Bairiya', pincode: '842015' },
    { value: 'bajitpur', label: 'Bajitpur', pincode: '842029' },
    { value: 'bajpatti', label: 'Bajpatti', pincode: '842063' },
    { value: 'bandra', label: 'Bandra', pincode: '842064' },
    { value: 'banja', label: 'Banja', pincode: '842030' },
    { value: 'barauni', label: 'Barauni', pincode: '842031' },
    { value: 'barharwa', label: 'Barharwa', pincode: '842032' },
    { value: 'barsi', label: 'Barsi', pincode: '842065' },
    { value: 'beldaur', label: 'Beldaur', pincode: '842066' },
    { value: 'belwa', label: 'Belwa', pincode: '842002' },
    { value: 'beri', label: 'Beri', pincode: '842016' },
    { value: 'bihariganj', label: 'Bihariganj', pincode: '842003' },
    { value: 'bihpur', label: 'Bihpur', pincode: '842033' },
    { value: 'bihpurash', label: 'Bihpurash', pincode: '842067' },
    { value: 'bhatauli', label: 'Bhatauli', pincode: '842034' },
    { value: 'bhikhanpur', label: 'Bhikhanpur', pincode: '842068' },
    { value: 'bhora', label: 'Bhora', pincode: '842035' },
    { value: 'bukauli', label: 'Bukauli', pincode: '842036' },
    { value: 'chini-kothi', label: 'Chini Kothi', pincode: '842004' },
    { value: 'chiraiya', label: 'Chiraiya', pincode: '842069' },
    { value: 'chandpur', label: 'Chandpur', pincode: '842017' },
    { value: 'chhata', label: 'Chhata', pincode: '842018' },
    { value: 'chhavi', label: 'Chhavi', pincode: '842019' },
    { value: 'dhaka', label: 'Dhaka', pincode: '842038' },
    { value: 'dharmashala', label: 'Dharmashala', pincode: '842039' },
    { value: 'dumari', label: 'Dumari', pincode: '842037' },
    { value: 'gangaul', label: 'Gangaul', pincode: '842070' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gokhula', label: 'Gokhula', pincode: '842040' },
    { value: 'gora-bagh', label: 'Gora Bagh', pincode: '842005' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'hathura', label: 'Hathura', pincode: '842041' },
    { value: 'jaitha', label: 'Jaitha', pincode: '842042' },
    { value: 'jalalpur', label: 'Jalalpur', pincode: '842071' },
    { value: 'jafarpur', label: 'Jafarpur', pincode: '842020' },
    { value: 'kabirpur', label: 'Kabirpur', pincode: '842006' },
    { value: 'kakori', label: 'Kakori', pincode: '842072' },
    { value: 'karpoori-thakur', label: 'Karpoori Thakur', pincode: '842007' },
    { value: 'kanti', label: 'Kanti', pincode: '842021' },
    { value: 'katihar', label: 'Katihar', pincode: '842043' },
    { value: 'kaushalpur', label: 'Kaushalpur', pincode: '842073' },
    { value: 'khadi-kothi', label: 'Khadi Kothi', pincode: '842008' },
    { value: 'madhopur', label: 'Madhopur', pincode: '842044' },
    { value: 'madhusudanpur', label: 'Madhusudanpur', pincode: '842074' },
    { value: 'manjhaul', label: 'Manjhaul', pincode: '842009' },
    { value: 'manjhol', label: 'Manjhol', pincode: '842022' },
    { value: 'moti-pur', label: 'Moti Pur', pincode: '842011' },
    { value: 'motipur', label: 'Motipur', pincode: '842010' },
    { value: 'muraul', label: 'Muraul', pincode: '842045' },
    { value: 'muzaffarpur-urban', label: 'Muzaffarpur Urban', pincode: '842023' },
    { value: 'nalanda', label: 'Nalanda', pincode: '842046' },
    { value: 'narayanpur', label: 'Narayanpur', pincode: '842075' },
    { value: 'patahi', label: 'Patahi', pincode: '842024' },
    { value: 'parsa', label: 'Parsa', pincode: '842047' },
    { value: 'patori', label: 'Patori', pincode: '842048' },
    { value: 'purnea', label: 'Purnea', pincode: '842049' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '842012' },
    { value: 'sadar', label: 'Sadar', pincode: '842025' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '842076' },
    { value: 'samarai', label: 'Samari', pincode: '842051' },
    { value: 'santhwara', label: 'Santhwara', pincode: '842052' },
    { value: 'sarma', label: 'Sarma', pincode: '842053' },
    { value: 'saraiya', label: 'Saraiya', pincode: '842013' },
    { value: 'saraiyawan', label: 'Saraiyawan', pincode: '842077' },
    { value: 'sarsa', label: 'Sarsa', pincode: '842050' },
    { value: 'shankarpur', label: 'Shankarpur', pincode: '842054' },
    { value: 'sherpur', label: 'Sherpur', pincode: '842055' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '842056' },
    { value: 'singhpur', label: 'Singhpur', pincode: '842057' },
    { value: 'sita-pur', label: 'Sita Pur', pincode: '842026' },
    { value: 'sonbhadra', label: 'Sonbhadra', pincode: '842058' },
    { value: 'suggi', label: 'Suggi', pincode: '842014' },
    { value: 'takia', label: 'Takia', pincode: '842059' },
    { value: 'tara', label: 'Tara', pincode: '842060' },
    { value: 'tariya', label: 'Tariya', pincode: '842027' },
    { value: 'vishunpur', label: 'Vishunpur', pincode: '842061' },
    { value: 'wadina', label: 'Wadina', pincode: '842062' }
  ],

  'darbhanga': [
    { value: 'adampur', label: 'Adampur', pincode: '846004' },
    { value: 'bahadurpur', label: 'Bahadurpur', pincode: '847210' },
    { value: 'baheri', label: 'Baheri', pincode: '847101' },
    { value: 'balbhadrapur', label: 'Balbhadrapur', pincode: '846004' },
    { value: 'balhi', label: 'Balhi', pincode: '847103' },
    { value: 'benaipur', label: 'Benaipur', pincode: '847203' },
    { value: 'bhatauli', label: 'Bhatauli', pincode: '847303' },
    { value: 'bhikhanpur', label: 'Bhikhanpur', pincode: '847305' },
    { value: 'bindwar', label: 'Bindwar', pincode: '847206' },
    { value: 'biraul', label: 'Biraul', pincode: '847203' },
    { value: 'chandni', label: 'Chandni', pincode: '847101' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '847202' },
    { value: 'darbhanga-cantt', label: 'Darbhanga Cantt', pincode: '846001' },
    { value: 'darbhanga-municipal', label: 'Darbhanga Municipal', pincode: '846004' },
    { value: 'darbhanga-sadar', label: 'Darbhanga Sadar', pincode: '846005' },
    { value: 'darshan', label: 'Darshan', pincode: '846003' },
    { value: 'dhaurhara', label: 'Dhaurhara', pincode: '847105' },
    { value: 'gobindpur', label: 'Gobindpur', pincode: '847402' },
    { value: 'gothra', label: 'Gothra', pincode: '847303' },
    { value: 'harhar', label: 'Harhar', pincode: '847301' },
    { value: 'harinagar', label: 'Harinagar', pincode: '847101' },
    { value: 'jhanjharpur', label: 'Jhanjharpur', pincode: '847403' },
    { value: 'kamtaul', label: 'Kamtaul', pincode: '847304' },
    { value: 'khajura', label: 'Khajura', pincode: '846005' },
    { value: 'khodabaks', label: 'Khodabaks', pincode: '847201' },
    { value: 'kotwa', label: 'Kotwa', pincode: '847101' },
    { value: 'kusheshwar', label: 'Kusheshwar', pincode: '847108' },
    { value: 'lauriya', label: 'Lauriya', pincode: '847104' },
    { value: 'mahadevpur', label: 'Mahadevpur', pincode: '847207' },
    { value: 'maharajganj', label: 'Maharajganj', pincode: '847303' },
    { value: 'maurawan', label: 'Maurawan', pincode: '846003' },
    { value: 'madhubani', label: 'Madhubani', pincode: '847211' },
    { value: 'manigachhi', label: 'Manigachhi', pincode: '846005' },
    { value: 'manjhaul', label: 'Manjhaul', pincode: '847101' },
    { value: 'mirzapur', label: 'Mirzapur', pincode: '847106' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '847203' },
    { value: 'nathnagar', label: 'Nathnagar', pincode: '846001' },
    { value: 'nirmali', label: 'Nirmali', pincode: '847300' },
    { value: 'pachrukhi', label: 'Pachrukhi', pincode: '846002' },
    { value: 'purnahiya', label: 'Purnahiya', pincode: '847204' },
    { value: 'rajapur', label: 'Rajapur', pincode: '847102' },
    { value: 'rakama', label: 'Rakama', pincode: '847302' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '847110' },
    { value: 'raniganj', label: 'Raniganj', pincode: '847212' },
    { value: 'rasoolpur', label: 'Rasoolpur', pincode: '847209' },
    { value: 'rukunpur', label: 'Rukunpur', pincode: '847101' },
    { value: 'sahpur', label: 'Sahpur', pincode: '847209' },
    { value: 'samaspur', label: 'Samaspur', pincode: '847207' },
    { value: 'shahrukhpur', label: 'Shahrukhpur', pincode: '847301' },
    { value: 'shankarpur', label: 'Shankarpur', pincode: '846002' },
    { value: 'sidhwara', label: 'Sidhwara', pincode: '847106' },
    { value: 'singhwara', label: 'Singhwara', pincode: '847302' },
    { value: 'sonbarsa', label: 'Sonbarsa', pincode: '847104' },
    { value: 'sukhasan', label: 'Sukhasan', pincode: '847301' },
    { value: 'tardih', label: 'Tardih', pincode: '847302' },
    { value: 'tilkamanjhi', label: 'Tilkamanjhi', pincode: '846002' }
  ],

  'chhapra': [
    { value: 'adampur', label: 'Adampur', pincode: '841301' },
    { value: 'bairia', label: 'Bairia', pincode: '841203' },
    { value: 'banda', label: 'Banda', pincode: '841202' },
    { value: 'barhara', label: 'Barhara', pincode: '841303' },
    { value: 'belanbagh', label: 'Belanbagh', pincode: '841304' },
    { value: 'chhapra-cantt', label: 'Chhapra Cantt', pincode: '841301' },
    { value: 'daudpur', label: 'Daudpur', pincode: '841204' },
    { value: 'dighwara', label: 'Dighwara', pincode: '841207' },
    { value: 'jalalpur', label: 'Jalalpur', pincode: '841210' },
    { value: 'karjaha', label: 'Karjaha', pincode: '841221' },
    { value: 'keshwar', label: 'Keshwar', pincode: '841223' },
    { value: 'khaspur', label: 'Khaspur', pincode: '841211' },
    { value: 'kothi', label: 'Kothi', pincode: '841222' },
    { value: 'mahalwar', label: 'Mahalwar', pincode: '841208' },
    { value: 'madhopur', label: 'Madhopur', pincode: '841222' },
    { value: 'manjhi', label: 'Manjhi', pincode: '841214' },
    { value: 'marhaura', label: 'Marhaura', pincode: '841418' },
    { value: 'nagra', label: 'Nagra', pincode: '841218' },
    { value: 'prakashpur', label: 'Prakashpur', pincode: '841219' },
    { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '841209' },
    { value: 'rampur', label: 'Rampur', pincode: '841305' },
    { value: 'sadar', label: 'Sadar', pincode: '841101' },
    { value: 'saran', label: 'Saran', pincode: '841225' },
    { value: 'saraiya', label: 'Saraiya', pincode: '841213' },
    { value: 'shahganj', label: 'Shahganj', pincode: '841226' },
    { value: 'sonpur', label: 'Sonpur', pincode: '841101' },
    { value: 'tarkulwa', label: 'Tarkulwa', pincode: '841220' },
    { value: 'tetua', label: 'Tetua', pincode: '841212' },
    { value: 'turki', label: 'Turki', pincode: '841213' },
    { value: 'vishunpur', label: 'Vishunpur', pincode: '841206' }
  ],

  'buxar': [
    { value: 'andar', label: 'Andar', pincode: '802119' },
    { value: 'babhani', label: 'Babhani', pincode: '802118' },
    { value: 'buxar-cantt', label: 'Buxar Cantt', pincode: '802101' },
    { value: 'chandpura', label: 'Chandpura', pincode: '802116' },
    { value: 'chausa', label: 'Chausa', pincode: '802302' },
    { value: 'dehri', label: 'Dehri', pincode: '802117' },
    { value: 'dharhara', label: 'Dharhara', pincode: '802112' },
    { value: 'dildarnagar', label: 'Dildarnagar', pincode: '802121' },
    { value: 'gangapur', label: 'Gangapur', pincode: '802103' },
    { value: 'kailaras', label: 'Kailaras', pincode: '802104' },
    { value: 'khushhalganj', label: 'Khushhalganj', pincode: '802102' },
    { value: 'madhuban', label: 'Madhuban', pincode: '802120' },
    { value: 'manjhaul', label: 'Manjhaul', pincode: '802105' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '802122' },
    { value: 'naya-bazar', label: 'Naya Bazar', pincode: '802101' },
    { value: 'pachgaon', label: 'Pachgaon', pincode: '802123' },
    { value: 'pali', label: 'Pali', pincode: '802124' },
    { value: 'parsa', label: 'Parsa', pincode: '802125' },
    { value: 'rahsitpur', label: 'Rahsitpur', pincode: '802111' },
    { value: 'rajauli', label: 'Rajauli', pincode: '802106' },
    { value: 'rajauli-bazar', label: 'Rajauli Bazar', pincode: '802126' },
    { value: 'rangpur', label: 'Rangpur', pincode: '802107' },
    { value: 'rawatpur', label: 'Rawatpur', pincode: '802127' },
    { value: 'saur', label: 'Saur', pincode: '802108' },
    { value: 'selaiya', label: 'Selaiya', pincode: '802109' },
    { value: 'shahpur', label: 'Shahpur', pincode: '802110' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '802113' },
    { value: 'sikandarpur-bazar', label: 'Sikandarpur Bazar', pincode: '802128' },
    { value: 'tarari', label: 'Tarari', pincode: '802129' },
    { value: 'tikari', label: 'Tikari', pincode: '802114' },
    { value: 'umraon', label: 'Umraon', pincode: '802115' }
  ],

'aurangabad.': [
  { value: 'amraur', label: 'Amraur', pincode: '824103' },
  { value: 'baba-ganj', label: 'Baba Ganj', pincode: '824202' },
  { value: 'bariyarpur', label: 'Bariyarpur', pincode: '824121' },
  { value: 'belchhi', label: 'Belchhi', pincode: '824207' },
  { value: 'chiraiya', label: 'Chiraiya', pincode: '824122' },
  { value: 'daudnagar', label: 'Daudnagar', pincode: '824132' },
  { value: 'deo', label: 'Deo', pincode: '824204' },
  { value: 'forbesganj', label: 'Forbesganj', pincode: '824101' },
  { value: 'guraru', label: 'Guraru', pincode: '824107' },
  { value: 'hulasganj', label: 'Hulasganj', pincode: '824123' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '824201' },
  { value: 'kaimur', label: 'Kaimur', pincode: '824104' },
  { value: 'kutubpur', label: 'Kutubpur', pincode: '824205' },
  { value: 'mohammadganj', label: 'Mohammadganj', pincode: '824106' },
  { value: 'nabinagar', label: 'Nabinagar', pincode: '824311' },
  { value: 'rafiganj', label: 'Rafiganj', pincode: '824115' },
  { value: 'rehal', label: 'Rehal', pincode: '824124' },
  { value: 'tankuppa', label: 'Tankuppa', pincode: '824110' },
  { value: 'teda', label: 'Teda', pincode: '824111' },
  { value: 'barun', label: 'Barun', pincode: '824203' },
  { value: 'bibhutpur', label: 'Bibhutpur', pincode: '824105' },
  { value: 'bhimabad', label: 'Bhimabad', pincode: '824108' },
  { value: 'chapra', label: 'Chapra', pincode: '824109' },
  { value: 'chakapara', label: 'Chakapara', pincode: '824112' },
  { value: 'kotwa', label: 'Kotwa', pincode: '824116' },
  { value: 'patkhauli', label: 'Patkhauli', pincode: '824117' },
  { value: 'peepra', label: 'Peepra', pincode: '824118' },
  { value: 'sikandara', label: 'Sikandara', pincode: '824119' },
  { value: 'khujra', label: 'Khujra', pincode: '824120' },
  { value: 'babhnauli', label: 'Babhnauli', pincode: '824125' },
  { value: 'ghalibganj', label: 'Ghalibganj', pincode: '824126' },
  { value: 'kandh', label: 'Kandh', pincode: '824127' },
  { value: 'moda', label: 'Moda', pincode: '824128' },
  { value: 'parjanya', label: 'Parjanya', pincode: '824129' },
  { value: 'shamshabad', label: 'Shamshabad', pincode: '824130' },
  { value: 'tal', label: 'Tal', pincode: '824131' },
  { value: 'urda', label: 'Urda', pincode: '824133' },
  { value: 'ankum', label: 'Ankum', pincode: '824134' },
  { value: 'alapur', label: 'Alapur', pincode: '824135' },
  { value: 'bhanauli', label: 'Bhanauli', pincode: '824136' },
  { value: 'chandauli', label: 'Chandauli', pincode: '824137' },
  { value: 'dandai', label: 'Dandai', pincode: '824138' },
  { value: 'gopalganj', label: 'Gopalganj', pincode: '824139' },
  { value: 'karhara', label: 'Karhara', pincode: '824140' },
  { value: 'madhopur', label: 'Madhopur', pincode: '824141' },
  { value: 'mehta', label: 'Mehta', pincode: '824142' },
  { value: 'narainpur', label: 'Narainpur', pincode: '824143' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '824144' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '824145' }
  ],

  'begusarai': [
    { value: 'alampur', label: 'Alampur', pincode: '851129' },
    { value: 'amarpur', label: 'Amarpur', pincode: '851129' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '851132' },
    { value: 'balidih', label: 'Balidih', pincode: '851126' },
    { value: 'banjariya', label: 'Banjariya', pincode: '851111' },
    { value: 'barauni', label: 'Barauni', pincode: '851305' },
    { value: 'barhara', label: 'Barhara', pincode: '851144' },
    { value: 'beldaripur', label: 'Beldaripur', pincode: '851145' },
    { value: 'begusarai', label: 'Begusarai', pincode: '851101' },
    { value: 'bhagalpur', label: 'Bhagalpur', pincode: '851133' },
    { value: 'bhagwanpur', label: 'Bhagwanpur', pincode: '851115' },
    { value: 'bihat', label: 'Bihat', pincode: '851101' },
    { value: 'bishanpur', label: 'Bishanpur', pincode: '851116' },
    { value: 'chandpur', label: 'Chandpur', pincode: '851146' },
    { value: 'chhapra', label: 'Chhapra', pincode: '851128' },
    { value: 'chhaurahi', label: 'Chhaurahi', pincode: '851121' },
    { value: 'darbhanga', label: 'Darbhanga', pincode: '851147' },
    { value: 'dohri', label: 'Dohri', pincode: '851134' },
    { value: 'duhuri', label: 'Duhuri', pincode: '851114' },
    { value: 'fatwah', label: 'Fatwah', pincode: '851135' },
    { value: 'gaonbihari', label: 'Gaonbihari', pincode: '851107' },
    { value: 'harhar', label: 'Harhar', pincode: '851118' },
    { value: 'jageshwar', label: 'Jageshwar', pincode: '851136' },
    { value: 'jamalpur', label: 'Jamalpur', pincode: '851131' },
    { value: 'jogapatti', label: 'Jogapatti', pincode: '851137' },
    { value: 'jokihat', label: 'Jokihat', pincode: '851131' },
    { value: 'kalyanpur', label: 'Kalyanpur', pincode: '851138' },
    { value: 'khagaria-road', label: 'Khagaria Road', pincode: '851101' },
    { value: 'kharmachak', label: 'Kharmachak', pincode: '851148' },
    { value: 'khodabandpur', label: 'Khodabandpur', pincode: '851118' },
    { value: 'lakhminia', label: 'Lakhminia', pincode: '851101' },
    { value: 'manjhaul', label: 'Manjhaul', pincode: '851123' },
    { value: 'mangrauni', label: 'Mangrauni', pincode: '851119' },
    { value: 'mathurapur', label: 'Mathurapur', pincode: '851139' },
    { value: 'mohiuddinagar', label: 'Mohiuddinagar', pincode: '851117' },
    { value: 'mohanpur', label: 'Mohanpur', pincode: '851140' },
    { value: 'nauhatta', label: 'Nauhatta', pincode: '851122' },
    { value: 'patahi', label: 'Patahi', pincode: '851149' },
    { value: 'patira', label: 'Patira', pincode: '851150' },
    { value: 'purnahi', label: 'Purnahi', pincode: '851151' },
    { value: 'rampur', label: 'Rampur', pincode: '851141' },
    { value: 'rauti', label: 'Rauti', pincode: '851125' },
    { value: 'sadhapur', label: 'Sadhapur', pincode: '851152' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '851102' },
    { value: 'safipur', label: 'Safipur', pincode: '851153' },
    { value: 'samastipur-road', label: 'Samastipur Road', pincode: '851101' },
    { value: 'samho', label: 'Samho', pincode: '851130' },
    { value: 'sangrampur', label: 'Sangrampur', pincode: '851143' },
    { value: 'sarai', label: 'Sarai', pincode: '851120' },
    { value: 'satrunji', label: 'Satrunji', pincode: '851154' },
    { value: 'sihma', label: 'Sihma', pincode: '851124' },
    { value: 'sihori', label: 'Sihori', pincode: '851116' },
    { value: 'sultanganj', label: 'Sultanganj', pincode: '851108' }
  ],

  'patna': [
    { value: 'adilabad-colony', label: 'Adilabad Colony', pincode: '800002' },
    { value: 'anandpuri', label: 'Anandpuri', pincode: '800024' },
    { value: 'anisabad', label: 'Anisabad', pincode: '800002' },
    { value: 'ashiana-nagar', label: 'Ashiana Nagar', pincode: '800025' },
    { value: 'bairiya', label: 'Bairiya', pincode: '800004' },
    { value: 'bakerganj', label: 'Bakerganj', pincode: '800004' },
    { value: 'bankipur', label: 'Bankipur', pincode: '800004' },
    { value: 'bari-pahari', label: 'Bari Pahari', pincode: '800007' },
    { value: 'begampur', label: 'Begampur', pincode: '800008' },
    { value: 'beur', label: 'Beur', pincode: '800002' },
    { value: 'bihar-school-examination-board', label: 'Bihar School Examination Board', pincode: '800014' },
    { value: 'boring-road', label: 'Boring Road', pincode: '800001' },
    { value: 'buddha-colony', label: 'Buddha Colony', pincode: '800001' },
    { value: 'digha', label: 'Digha', pincode: '800011' },
    { value: 'digha-ghat', label: 'Digha Ghat', pincode: '800011' },
    { value: 'fraser-road', label: 'Fraser Road', pincode: '800001' },
    { value: 'gandanibagh', label: 'Gandanibagh', pincode: '800001' },
    { value: 'gandhi-maidan', label: 'Gandhi Maidan', pincode: '800001' },
    { value: 'gulzarbagh-field', label: 'Gulzarbagh Field', pincode: '800007' },
    { value: 'hanuman-nagar', label: 'Hanuman Nagar', pincode: '800020' },
    { value: 'jakkanpur', label: 'Jakkanpur', pincode: '800001' },
    { value: 'jamal-road', label: 'Jamal Road', pincode: '800001' },
    { value: 'kadam-kuan', label: 'Kadam Kuan', pincode: '800003' },
    { value: 'kalianpur', label: 'Kalianpur', pincode: '800026' },
    { value: 'kankarbagh', label: 'Kankarbagh', pincode: '800020' },
    { value: 'keshri-nagar', label: 'Keshri Nagar', pincode: '800024' },
    { value: 'khajpura', label: 'Khajpura', pincode: '800014' },
    { value: 'kidwai-puri', label: 'Kidwai Puri', pincode: '800020' },
    { value: 'kurji', label: 'Kurji', pincode: '800010' },
    { value: 'kurthaul', label: 'Kurthaul', pincode: '800027' },
    { value: 'lodipur', label: 'Lodipur', pincode: '800001' },
    { value: 'lohia-nagar', label: 'Lohia Nagar', pincode: '800020' },
    { value: 'machhua-toli', label: 'Machhua Toli', pincode: '800004' },
    { value: 'mahendru', label: 'Mahendru', pincode: '800006' },
    { value: 'malahi-pakri-road', label: 'Malahi Pakri Road', pincode: '800001' },
    { value: 'marufganj', label: 'Marufganj', pincode: '800004' },
    { value: 'mithapur', label: 'Mithapur', pincode: '800001' },
    { value: 'muradpur', label: 'Muradpur', pincode: '800004' },
    { value: 'nandlal-chhapra', label: 'Nandlal Chhapra', pincode: '800002' },
    { value: 'new-punaichak', label: 'New Punaichak', pincode: '800023' },
    { value: 'old-jakkanpur', label: 'Old Jakkanpur', pincode: '800001' },
    { value: 'patliputra-colony', label: 'Patliputra Colony', pincode: '800013' },
    { value: 'patna-city-chowk', label: 'Patna City Chowk', pincode: '800008' },
    { value: 'patna-high-court', label: 'Patna High Court', pincode: '800001' },
    { value: 'phulwari-sharif', label: 'Phulwari Sharif', pincode: '800002' },
    { value: 'raja-bazar', label: 'Raja Bazar', pincode: '800014' },
    { value: 'raj-bhavan', label: 'Raj Bhavan', pincode: '800022' },
    { value: 'rajapur', label: 'Rajapur', pincode: '800027' },
    { value: 'rukanpura', label: 'Rukanpura', pincode: '800014' },
    { value: 'sadikpur', label: 'Sadikpur', pincode: '800008' },
    { value: 'saidpur', label: 'Saidpur', pincode: '800005' },
    { value: 'sdaquat-ashram', label: 'Sdaquat Ashram', pincode: '800026' },
    { value: 'secretariat', label: 'Secretariat', pincode: '800015' },
    { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '800023' },
    { value: 'sheikhpura', label: 'Sheikhpura', pincode: '800014' },
    { value: 'sipara', label: 'Sipara', pincode: '800002' },
    { value: 'sri-krishnapuri', label: 'Sri Krishnapuri', pincode: '800001' }
  ],
'bagaha': [
  { value: 'bagaha', label: 'Bagaha', pincode: '845101' },
  { value: 'barwa', label: 'Barwa', pincode: '845103' },
  { value: 'banshidhar', label: 'Banshidhar', pincode: '845102' },
  { value: 'belwa', label: 'Belwa', pincode: '845103' },
  { value: 'chandpur', label: 'Chandpur', pincode: '845101' },
  { value: 'chhatauni', label: 'Chhatauni', pincode: '845101' },
  { value: 'darbhanga', label: 'Darbhanga', pincode: '845101' },
  { value: 'dhanha', label: 'Dhanha', pincode: '845103' },
  { value: 'dihra', label: 'Dihra', pincode: '845101' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '845105' },
  { value: 'khajuri', label: 'Khajuri', pincode: '845104' },
  { value: 'madhopur', label: 'Madhopur', pincode: '845101' },
  { value: 'manjhwa', label: 'Manjhwa', pincode: '845103' },
  { value: 'mithauli', label: 'Mithauli', pincode: '845101' },
  { value: 'murho', label: 'Murho', pincode: '845101' },
  { value: 'puraini', label: 'Puraini', pincode: '845103' },
  { value: 'rajarampur', label: 'Rajarampur', pincode: '845102' },
  { value: 'rampur', label: 'Rampur', pincode: '845104' },
  { value: 'saraiya', label: 'Saraiya', pincode: '845105' },
  { value: 'sonbarsa', label: 'Sonbarsa', pincode: '845103' },
  { value: 'sugauli', label: 'Sugauli', pincode: '845102' },
  { value: 'tilakpur', label: 'Tilakpur', pincode: '845101' },
  { value: 'bairiya', label: 'Bairiya', pincode: '845106' },
  { value: 'balha', label: 'Balha', pincode: '845107' },
  { value: 'chauka', label: 'Chauka', pincode: '845108' },
  { value: 'chhataiya', label: 'Chhataiya', pincode: '845109' },
  { value: 'ghorahi', label: 'Ghorahi', pincode: '845110' },
  { value: 'hatni', label: 'Hatni', pincode: '845111' },
  { value: 'nautna', label: 'Nautna', pincode: '845112' }
  ],
  
  'bettiah': [
  { value: 'bettiah', label: 'Bettiah', pincode: '845438' },
  { value: 'bahadurganj', label: 'Bahadurganj', pincode: '845438' },
  { value: 'barharia', label: 'Barharia', pincode: '845412' },
  { value: 'basantpur', label: 'Basantpur', pincode: '845426' },
  { value: 'belha', label: 'Belha', pincode: '845416' },
  { value: 'bairia', label: 'Bairia', pincode: '845417' },
  { value: 'dhamdaha', label: 'Dhamdaha', pincode: '845406' },
  { value: 'gaur', label: 'Gaur', pincode: '845417' },
  { value: 'lauriya', label: 'Lauriya', pincode: '845453' },
  { value: 'motihari', label: 'Motihari', pincode: '845401' },
  { value: 'narkatiaganj', label: 'Narkatiaganj', pincode: '845455' },
  { value: 'patahi', label: 'Patahi', pincode: '845417' },
  { value: 'ratanpura', label: 'Ratanpura', pincode: '845437' },
  { value: 'sagauli', label: 'Sagauli', pincode: '845310' },
  { value: 'samsherpur', label: 'Samsherpur', pincode: '845417' },
  { value: 'sheohar', label: 'Sheohar', pincode: '843329' },
  { value: 'shivpur', label: 'Shivpur', pincode: '845438' },
  { value: 'sugauli', label: 'Sugauli', pincode: '845467' },
  { value: 'tetaria', label: 'Tetaria', pincode: '845429' },
  { value: 'thakurganj', label: 'Thakurganj', pincode: '845438' },
  { value: 'adapur', label: 'Adapur', pincode: '845456' },
  { value: 'gandak', label: 'Gandak', pincode: '845451' },
  { value: 'keshopur', label: 'Keshopur', pincode: '845455' },
  { value: 'khairwa', label: 'Khairwa', pincode: '845437' },
  { value: 'kudari', label: 'Kudari', pincode: '845411' },
  { value: 'maurawan', label: 'Maurawan', pincode: '845454' },
  { value: 'mochhupur', label: 'Mochhupur', pincode: '845457' },
  { value: 'raunahi', label: 'Raunahi', pincode: '845453' },
  { value: 'sonauli', label: 'Sonauli', pincode: '845455' },
  { value: 'udaypur', label: 'Udaypur', pincode: '845451' }
  ],
  
  'danapur': [
  { value: 'danapur', label: 'Danapur', pincode: '801503' },
  { value: 'bairiya', label: 'Bairiya', pincode: '801105' },
  { value: 'belbari', label: 'Belbari', pincode: '801505' },
  { value: 'bishanpur', label: 'Bishanpur', pincode: '801102' },
  { value: 'chakram', label: 'Chakram', pincode: '801105' },
  { value: 'chakradharpur', label: 'Chakradharpur', pincode: '801102' },
  { value: 'chhath', label: 'Chhath', pincode: '801104' },
  { value: 'digha', label: 'Digha', pincode: '801105' },
  { value: 'ganeshganj', label: 'Ganeshganj', pincode: '801103' },
  { value: 'kesariya', label: 'Kesariya', pincode: '801503' },
  { value: 'khagaul', label: 'Khagaul', pincode: '801105' },
  { value: 'kunwarpur', label: 'Kunwarpur', pincode: '801105' },
  { value: 'manpur', label: 'Manpur', pincode: '801504' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '801506' },
  { value: 'nabinagar', label: 'Nabinagar', pincode: '801501' },
  { value: 'patna', label: 'Patna', pincode: '801503' },
  { value: 'phulwari', label: 'Phulwari', pincode: '801505' },
  { value: 'puranapul', label: 'Puranapul', pincode: '801104' },
  { value: 'rajauli', label: 'Rajauli', pincode: '801507' },
  { value: 'sarsabad', label: 'Sarsabad', pincode: '801504' },
  { value: 'sokra', label: 'Sokra', pincode: '801503' },
  { value: 'talpur', label: 'Talpur', pincode: '801505' },
  { value: 'amrauli', label: 'Amrauli', pincode: '801502' },
  { value: 'akilpur', label: 'Akilpur', pincode: '801507' },
  { value: 'bansdih', label: 'Bansdih', pincode: '801504' },
  { value: 'bihariganj', label: 'Bihariganj', pincode: '801508' },
  { value: 'chandni', label: 'Chandni', pincode: '801503' },
  { value: 'gurua', label: 'Gurua', pincode: '801502' },
  { value: 'hajipur', label: 'Hajipur', pincode: '801504' },
  { value: 'jokihat', label: 'Jokihat', pincode: '801505' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '801507' },
  { value: 'mohanpur', label: 'Mohanpur', pincode: '801506' },
  { value: 'raunjha', label: 'Raunjha', pincode: '801507' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '801503' }
  ],
  
  'dehri': [
  { value: 'dehri', label: 'Dehri', pincode: '821307' },
  { value: 'bairiya', label: 'Bairiya', pincode: '821307' },
  { value: 'bibhutpur', label: 'Bibhutpur', pincode: '821307' },
  { value: 'chakari', label: 'Chakari', pincode: '821307' },
  { value: 'chakbandhi', label: 'Chakbandhi', pincode: '821305' },
  { value: 'gamharia', label: 'Gamharia', pincode: '821307' },
  { value: 'khapra', label: 'Khapra', pincode: '821305' },
  { value: 'kharari', label: 'Kharari', pincode: '821307' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '821308' },
  { value: 'mohanpur', label: 'Mohanpur', pincode: '821307' },
  { value: 'nayatola', label: 'Nayatola', pincode: '821307' },
  { value: 'patra', label: 'Patra', pincode: '821305' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '821307' },
  { value: 'sitarampur', label: 'Sitarampur', pincode: '821307' },
  { value: 'sudama', label: 'Sudama', pincode: '821307' },
  { value: 'tara', label: 'Tara', pincode: '821307' },
  { value: 'telkupi', label: 'Telkupi', pincode: '821307' },
  { value: 'babhani', label: 'Babhani', pincode: '821305' },
  { value: 'banjari', label: 'Banjari', pincode: '821307' },
  { value: 'bishanpur', label: 'Bishanpur', pincode: '821307' },
  { value: 'chhatri', label: 'Chhatri', pincode: '821307' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '821307' },
  { value: 'jandaha', label: 'Jandaha', pincode: '821308' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '821307' },
  { value: 'kushwaha', label: 'Kushwaha', pincode: '821308' },
  { value: 'mohania', label: 'Mohania', pincode: '821306' },
  { value: 'pakari', label: 'Pakari', pincode: '821305' },
  { value: 'purbi', label: 'Purbi', pincode: '821307' }
  ],
  
  'hajipur': [
  { value: 'hajipur', label: 'Hajipur', pincode: '844101' },
  { value: 'alampur', label: 'Alampur', pincode: '844101' },
  { value: 'bansur', label: 'Bansur', pincode: '844101' },
  { value: 'chhath', label: 'Chhath', pincode: '844102' },
  { value: 'digha', label: 'Digha', pincode: '844103' },
  { value: 'ganeshganj', label: 'Ganeshganj', pincode: '844102' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '844105' },
  { value: 'madhopur', label: 'Madhopur', pincode: '844103' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '844104' },
  { value: 'naubatpur', label: 'Naubatpur', pincode: '844101' },
  { value: 'patra', label: 'Patra', pincode: '844106' },
  { value: 'rajanpur', label: 'Rajanpur', pincode: '844107' },
  { value: 'sarsabad', label: 'Sarsabad', pincode: '844102' },
  { value: 'shahpur', label: 'Shahpur', pincode: '844106' },
  { value: 'talpur', label: 'Talpur', pincode: '844105' },
  { value: 'vishunpura', label: 'Vishunpura', pincode: '844108' },
  { value: 'badpur', label: 'Badpur', pincode: '844108' },
  { value: 'barahra', label: 'Barahra', pincode: '844104' },
  { value: 'bihari', label: 'Bihari', pincode: '844101' },
  { value: 'bhikhpur', label: 'Bhikhpur', pincode: '844105' },
  { value: 'bishunpur', label: 'Bishunpur', pincode: '844103' },
  { value: 'chakmashra', label: 'Chakmashra', pincode: '844101' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '844107' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '844105' },
  { value: 'kapasia', label: 'Kapasia', pincode: '844102' },
  { value: 'kararia', label: 'Kararia', pincode: '844106' },
  { value: 'manojpur', label: 'Manojpur', pincode: '844101' },
  { value: 'musahari', label: 'Musahari', pincode: '844104' },
  { value: 'shahpur-north', label: 'Shahpur North', pincode: '844106' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '844107' }
  ],
  
  'jamalpur': [
  { value: 'jamalpur', label: 'Jamalpur', pincode: '811214' },
  { value: 'balidih', label: 'Balidih', pincode: '811214' },
  { value: 'barh', label: 'Barh', pincode: '811101' },
  { value: 'bariyarpur', label: 'Bariyarpur', pincode: '811214' },
  { value: 'beldaur', label: 'Beldaur', pincode: '811214' },
  { value: 'bhabhua', label: 'Bhabhua', pincode: '811214' },
  { value: 'dahiyari', label: 'Dahiyari', pincode: '811213' },
  { value: 'giriak', label: 'Giriak', pincode: '811213' },
  { value: 'kabra', label: 'Kabra', pincode: '811214' },
  { value: 'mananpur', label: 'Mananpur', pincode: '811214' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '811213' },
  { value: 'patuli', label: 'Patuli', pincode: '811214' },
  { value: 'raghopur', label: 'Raghopur', pincode: '811214' },
  { value: 'rajapur', label: 'Rajapur', pincode: '811214' },
  { value: 'sahpur', label: 'Sahpur', pincode: '811214' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '811214' },
  { value: 'teldih', label: 'Teldih', pincode: '811214' },
  { value: 'sarania', label: 'Sarania', pincode: '811214' },
  { value: 'chauparia', label: 'Chauparia', pincode: '811213' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '811214' },
  { value: 'chandpur', label: 'Chandpur', pincode: '811213' },
  { value: 'kushumbha', label: 'Kushumbha', pincode: '811214' },
  { value: 'madhupur', label: 'Madhupur', pincode: '811213' },
  { value: 'mohania', label: 'Mohania', pincode: '811213' },
  { value: 'chhoti', label: 'Chhoti', pincode: '811214' },
  { value: 'sikandarabad', label: 'Sikandarabad', pincode: '811214' }
  ],
  
  'jehanabad': [
  { value: 'jehanabad', label: 'Jehanabad', pincode: '804408' },
  { value: 'alipur', label: 'Alipur', pincode: '804401' },
  { value: 'bairi', label: 'Bairi', pincode: '804408' },
  { value: 'bandh', label: 'Bandh', pincode: '804402' },
  { value: 'barauli', label: 'Barauli', pincode: '804407' },
  { value: 'belchhi', label: 'Belchhi', pincode: '804402' },
  { value: 'dariyapur', label: 'Dariyapur', pincode: '804408' },
  { value: 'gajpur', label: 'Gajpur', pincode: '804407' },
  { value: 'gandhi-maidan', label: 'Gandhi Maidan', pincode: '804401' },
  { value: 'kothiya', label: 'Kothiya', pincode: '804406' },
  { value: 'madanganj', label: 'Madanganj', pincode: '804401' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '804405' },
  { value: 'mohania', label: 'Mohania', pincode: '804409' },
  { value: 'mulhoul', label: 'Mulhoul', pincode: '804406' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '804402' },
  { value: 'saranpur', label: 'Saranpur', pincode: '804409' },
  { value: 'tirhuti', label: 'Tirhuti', pincode: '804407' },
  { value: 'chandanpur', label: 'Chandanpur', pincode: '804403' },
  { value: 'dularpur', label: 'Dularpur', pincode: '804409' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '804403' },
  { value: 'khajuri', label: 'Khajuri', pincode: '804406' },
  { value: 'mahmadpur', label: 'Mahmadpur', pincode: '804402' },
  { value: 'raipur', label: 'Raipur', pincode: '804407' },
  { value: 'salempur', label: 'Salempur', pincode: '804408' },
  { value: 'shivanandpur', label: 'Shivanandpur', pincode: '804401' },
  { value: 'tughlaqpur', label: 'Tughlaqpur', pincode: '804404' }
  ],
  
  'kishanganj': [
  { value: 'agwa', label: 'Agwa', pincode: '855107' },
  { value: 'alipur', label: 'Alipur', pincode: '855107' },
  { value: 'araria', label: 'Araria', pincode: '855105' },
  { value: 'bahadurpur', label: 'Bahadurpur', pincode: '855106' },
  { value: 'bairi', label: 'Bairi', pincode: '855108' },
  { value: 'banmali', label: 'Banmali', pincode: '855107' },
  { value: 'barari', label: 'Barari', pincode: '855115' },
  { value: 'barmasia', label: 'Barmasia', pincode: '855109' },
  { value: 'chhathara', label: 'Chhathara', pincode: '855108' },
  { value: 'dalkola', label: 'Dalkola', pincode: '855102' },
  { value: 'dharmapur', label: 'Dharmapur', pincode: '855110' },
  { value: 'gopalganj', label: 'Gopalganj', pincode: '855101' },
  { value: 'jahidpur', label: 'Jahidpur', pincode: '855107' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '855113' },
  { value: 'kishanganj', label: 'Kishanganj', pincode: '855107' },
  { value: 'madhubani', label: 'Madhubani', pincode: '855111' },
  { value: 'manihari', label: 'Manihari', pincode: '855109' },
  { value: 'muradpur', label: 'Muradpur', pincode: '855115' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '855101' },
  { value: 'sayedpur', label: 'Sayedpur', pincode: '855106' },
  { value: 'tangapara', label: 'Tangapara', pincode: '855115' },
  { value: 'bahadurganj', label: 'Bahadurganj', pincode: '855116' },
  { value: 'bajitpur', label: 'Bajitpur', pincode: '855105' },
  { value: 'beldari', label: 'Beldari', pincode: '855104' },
  { value: 'chandpur', label: 'Chandpur', pincode: '855110' },
  { value: 'dadpur', label: 'Dadpur', pincode: '855103' },
  { value: 'dhanpura', label: 'Dhanpura', pincode: '855114' },
  { value: 'ghandaria', label: 'Ghandaria', pincode: '855117' },
  { value: 'khajuri', label: 'Khajuri', pincode: '855112' },
  { value: 'kolar', label: 'Kolar', pincode: '855118' },
  { value: 'majhergram', label: 'Majhergram', pincode: '855109' },
  { value: 'ramganj', label: 'Ramganj', pincode: '855105' },
  { value: 'sonapath', label: 'Sonapath', pincode: '855101' },
  { value: 'tola', label: 'Tola', pincode: '855119' }
  ],
  
  'munger': [
  { value: 'barkagaon', label: 'Barkagaon', pincode: '811201' },
  { value: 'bihpur', label: 'Bihpur', pincode: '811201' },
  { value: 'chandpur', label: 'Chandpur', pincode: '811210' },
  { value: 'deoghar', label: 'Deoghar', pincode: '811211' },
  { value: 'kharagpur', label: 'Kharagpur', pincode: '811204' },
  { value: 'manpur', label: 'Manpur', pincode: '811211' },
  { value: 'madhopur', label: 'Madhopur', pincode: '811204' },
  { value: 'mau', label: 'Mau', pincode: '811212' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '811205' },
  { value: 'pachna', label: 'Pachna', pincode: '811213' },
  { value: 'rahtoli', label: 'Rahtoli', pincode: '811210' },
  { value: 'ratwara', label: 'Ratwara', pincode: '811207' },
  { value: 'sadar', label: 'Sadar', pincode: '811201' },
  { value: 'sangrampur', label: 'Sangrampur', pincode: '811207' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '811208' },
  { value: 'singrauli', label: 'Singrauli', pincode: '811206' },
  { value: 'sultanganj', label: 'Sultanganj', pincode: '811213' },
  { value: 'gogri', label: 'Gogri', pincode: '811204' },
  { value: 'islampur', label: 'Islampur', pincode: '811202' },
  { value: 'kasimabad', label: 'Kasimabad', pincode: '811205' },
  { value: 'kharik', label: 'Kharik', pincode: '811206' },
  { value: 'kachhiyawan', label: 'Kachhiyawan', pincode: '811209' },
  { value: 'tardih', label: 'Tardih', pincode: '811212' },
  { value: 'beldaur', label: 'Beldaur', pincode: '811205' },
  { value: 'lakhisarai', label: 'Lakhisarai', pincode: '811210' },
  { value: 'salempur', label: 'Salempur', pincode: '811213' },
  { value: 'sonepur', label: 'Sonepur', pincode: '811209' },
  { value: 'patelganj', label: 'Patelganj', pincode: '811208' }
  ],
  
  'motihari': [
  { value: 'amrauli', label: 'Amrauli', pincode: '845401' },
  { value: 'bankat', label: 'Bankat', pincode: '845455' },
  { value: 'bariyarpur', label: 'Bariyarpur', pincode: '845411' },
  { value: 'bhatauli', label: 'Bhatauli', pincode: '845455' },
  { value: 'birsinghpur', label: 'Birsinghpur', pincode: '845429' },
  { value: 'chandmari', label: 'Chandmari', pincode: '845437' },
  { value: 'chhatauni', label: 'Chhatauni', pincode: '845416' },
  { value: 'ganeshpur', label: 'Ganeshpur', pincode: '845424' },
  { value: 'gopalganj', label: 'Gopalganj', pincode: '845455' },
  { value: 'harsinghpur', label: 'Harsinghpur', pincode: '845456' },
  { value: 'jagarnathganj', label: 'Jagarnathganj', pincode: '845430' },
  { value: 'kotwa', label: 'Kotwa', pincode: '845412' },
  { value: 'madhubani', label: 'Madhubani', pincode: '845453' },
  { value: 'motihari', label: 'Motihari', pincode: '845401' },
  { value: 'muradpur', label: 'Muradpur', pincode: '845457' },
  { value: 'nawalpur', label: 'Nawalpur', pincode: '845415' },
  { value: 'pachna', label: 'Pachna', pincode: '845458' },
  { value: 'rahtoli', label: 'Rahtoli', pincode: '845436' },
  { value: 'sadar', label: 'Sadar', pincode: '845402' },
  { value: 'sangrampur', label: 'Sangrampur', pincode: '845411' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '845414' },
  { value: 'sonpur', label: 'Sonpur', pincode: '845459' },
  { value: 'sultanganj', label: 'Sultanganj', pincode: '845420' },
  { value: 'tola', label: 'Tola', pincode: '845425' },
  { value: 'bairiya', label: 'Bairiya', pincode: '845420' },
  { value: 'balua', label: 'Balua', pincode: '845431' },
  { value: 'khandwa', label: 'Khandwa', pincode: '845454' },
  { value: 'chhathwara', label: 'Chhathwara', pincode: '845433' },
  { value: 'kushwaha', label: 'Kushwaha', pincode: '845438' },
  { value: 'basraha', label: 'Basraha', pincode: '845451' },
  { value: 'jokhiya', label: 'Jokhiya', pincode: '845452' },
  { value: 'pauli', label: 'Pauli', pincode: '845449' },
  { value: 'pindara', label: 'Pindara', pincode: '845423' },
  { value: 'sikti', label: 'Sikti', pincode: '845440' },
  { value: 'dariya', label: 'Dariya', pincode: '845428' }
  ],
  
  'saharsa': [
  { value: 'bihariganj', label: 'Bihariganj', pincode: '852101' },
  { value: 'dhamdaha', label: 'Dhamdaha', pincode: '852111' },
  { value: 'gopalpur', label: 'Gopalpur', pincode: '852213' },
  { value: 'kamarjag', label: 'Kamarjag', pincode: '852212' },
  { value: 'madhubani', label: 'Madhubani', pincode: '852131' },
  { value: 'nigam', label: 'Nigam', pincode: '852124' },
  { value: 'raipura', label: 'Raipura', pincode: '852114' },
  { value: 'saharsa', label: 'Saharsa', pincode: '852201' },
  { value: 'sadar', label: 'Sadar', pincode: '852201' },
  { value: 'sangrampur', label: 'Sangrampur', pincode: '852112' },
  { value: 'tariyani', label: 'Tariyani', pincode: '852132' },
  { value: 'triya', label: 'Triya', pincode: '852133' },
  { value: 'veshpur', label: 'Veshpur', pincode: '852113' },
  { value: 'bariyarpur', label: 'Bariyarpur', pincode: '852206' },
  { value: 'chhatauni', label: 'Chhatauni', pincode: '852205' },
  { value: 'kashipur', label: 'Kashipur', pincode: '852107' },
  { value: 'kochadham', label: 'Kochadham', pincode: '852210' },
  { value: 'malhar', label: 'Malhar', pincode: '852104' },
  { value: 'manihari', label: 'Manihari', pincode: '852106' },
  { value: 'mujhiyar', label: 'Mujhiyar', pincode: '852102' },
  { value: 'rauri', label: 'Rauri', pincode: '852109' },
  { value: 'sahari', label: 'Sahari', pincode: '852105' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '852103' }
  ],
  
  'sasaram': [
  { value: 'adampur', label: 'Adampur', pincode: '821115' },
  { value: 'baba-bihar', label: 'Baba Bihar', pincode: '821301' },
  { value: 'baligaon', label: 'Baligaon', pincode: '821120' },
  { value: 'bhadaura', label: 'Bhadaura', pincode: '821103' },
  { value: 'bhikampur', label: 'Bhikampur', pincode: '821127' },
  { value: 'chakri', label: 'Chakri', pincode: '821132' },
  { value: 'chakmadhur', label: 'Chakmadhur', pincode: '821101' },
  { value: 'dilawarpur', label: 'Dilawarpur', pincode: '821132' },
  { value: 'gokulganj', label: 'Gokulganj', pincode: '821104' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '821105' },
  { value: 'kala-gaon', label: 'Kala Gaon', pincode: '821136' },
  { value: 'keshopur', label: 'Keshopur', pincode: '821103' },
  { value: 'kudra', label: 'Kudra', pincode: '821119' },
  { value: 'manpur', label: 'Manpur', pincode: '821128' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '821118' },
  { value: 'nawada', label: 'Nawada', pincode: '821106' },
  { value: 'parasi', label: 'Parasi', pincode: '821107' },
  { value: 'sahkund', label: 'Sahkund', pincode: '821130' },
  { value: 'sasaram', label: 'Sasaram', pincode: '821115' },
  { value: 'sikandra', label: 'Sikandra', pincode: '821141' },
  { value: 'tahsil', label: 'Tahsil', pincode: '821108' },
  { value: 'amraipur', label: 'Amraipur', pincode: '821113' },
  { value: 'babhana', label: 'Babhana', pincode: '821133' },
  { value: 'bhikpur', label: 'Bhikpur', pincode: '821122' },
  { value: 'dehri', label: 'Dehri', pincode: '821304' },
  { value: 'gulsar', label: 'Gulsar', pincode: '821121' },
  { value: 'jahidpur', label: 'Jahidpur', pincode: '821125' },
  { value: 'kachhawa', label: 'Kachhawa', pincode: '821137' },
  { value: 'mohania', label: 'Mohania', pincode: '821109' },
  { value: 'pachma', label: 'Pachma', pincode: '821116' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '821119' },
  { value: 'sadhopur', label: 'Sadhopur', pincode: '821129' }
  ],
  
  'sharif-arrah': [
  { value: 'adampur', label: 'Adampur', pincode: '802206' },
  { value: 'bikramganj', label: 'Bikramganj', pincode: '802212' },
  { value: 'chakmakhan', label: 'Chakmakhan', pincode: '802215' },
  { value: 'gangauli', label: 'Gangauli', pincode: '802213' },
  { value: 'jagdishpur', label: 'Jagdishpur', pincode: '802216' },
  { value: 'keshavganj', label: 'Keshavganj', pincode: '802205' },
  { value: 'khandawa', label: 'Khandawa', pincode: '802208' },
  { value: 'mahipur', label: 'Mahipur', pincode: '802210' },
  { value: 'manjhaul', label: 'Manjhaul', pincode: '802211' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '802220' },
  { value: 'rajauli', label: 'Rajauli', pincode: '802218' },
  { value: 'sahpur', label: 'Sahpur', pincode: '802217' },
  { value: 'sarai', label: 'Sarai', pincode: '802214' },
  { value: 'sharif-arrah', label: 'Sharif Arrah', pincode: '802202' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '802223' },
  { value: 'tariyani', label: 'Tariyani', pincode: '802219' },
  { value: 'uttar-pur', label: 'Uttar Pur', pincode: '802207' },
  { value: 'vishunpur', label: 'Vishunpur', pincode: '802209' }
  ],
  
  'siwan': [
  { value: 'akbarpur', label: 'Akbarpur', pincode: '841227' },
  { value: 'babhnauli', label: 'Babhnauli', pincode: '841235' },
  { value: 'banaras', label: 'Banaras', pincode: '841226' },
  { value: 'bhor', label: 'Bhor', pincode: '841245' },
  { value: 'chandpura', label: 'Chandpura', pincode: '841242' },
  { value: 'gopalganj', label: 'Gopalganj', pincode: '841232' },
  { value: 'harpur', label: 'Harpur', pincode: '841246' },
  { value: 'jamo', label: 'Jamo', pincode: '841248' },
  { value: 'khajuri', label: 'Khajuri', pincode: '841249' },
  { value: 'kudhani', label: 'Kudhani', pincode: '841257' },
  { value: 'makhdumpur', label: 'Makhdumpur', pincode: '841256' },
  { value: 'manjha', label: 'Manjha', pincode: '841247' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '841250' },
  { value: 'moti-ganj', label: 'Moti Ganj', pincode: '841239' },
  { value: 'muradpur', label: 'Muradpur', pincode: '841251' },
  { value: 'siwan', label: 'Siwan', pincode: '841226' },
  { value: 'sirajpur', label: 'Sirajpur', pincode: '841253' },
  { value: 'tariyani', label: 'Tariyani', pincode: '841258' },
  { value: 'vishunpur', label: 'Vishunpur', pincode: '841255' },
  { value: 'tharuhat', label: 'Tharuhat', pincode: '841259' },
  { value: 'rajauli', label: 'Rajauli', pincode: '841230' },
  { value: 'bariyarpur', label: 'Bariyarpur', pincode: '841234' },
  { value: 'bahor', label: 'Bahor', pincode: '841237' },
  { value: 'kabilpur', label: 'Kabilpur', pincode: '841231' }
  ],
  
  'sitamarhi': [
  { value: 'bagahi', label: 'Bagahi', pincode: '843302' },
  { value: 'balwa', label: 'Balwa', pincode: '843322' },
  { value: 'bariyarpur', label: 'Bariyarpur', pincode: '843301' },
  { value: 'bisfi', label: 'Bisfi', pincode: '843335' },
  { value: 'bairia', label: 'Bairia', pincode: '843325' },
  { value: 'damodarpur', label: 'Damodarpur', pincode: '843324' },
  { value: 'dudhahi', label: 'Dudhahi', pincode: '843323' },
  { value: 'ghogha', label: 'Ghogha', pincode: '843333' },
  { value: 'janki-nagar', label: 'Janki Nagar', pincode: '843335' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '843336' },
  { value: 'manjharia', label: 'Manjharia', pincode: '843331' },
  { value: 'narkatiaganj', label: 'Narkatiaganj', pincode: '843314' },
  { value: 'patahi', label: 'Patahi', pincode: '843319' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '843337' },
  { value: 'sitamarhi', label: 'Sitamarhi', pincode: '843301' },
  { value: 'sursand', label: 'Sursand', pincode: '843329' },
  { value: 'tariyani', label: 'Tariyani', pincode: '843330' },
  { value: 'kuchaikot', label: 'Kuchaikot', pincode: '843338' },
  { value: 'sikrahna', label: 'Sikrahna', pincode: '843339' },
  { value: 'sursand-bazar', label: 'Sursand Bazar', pincode: '843340' },
  { value: 'biraul', label: 'Biraul', pincode: '843355' },
  { value: 'pachrukhi', label: 'Pachrukhi', pincode: '843343' },
  { value: 'nawada', label: 'Nawada', pincode: '843344' },
  { value: 'dharmshala', label: 'Dharmshala', pincode: '843345' },
  { value: 'chandpur', label: 'Chandpur', pincode: '843346' },
  { value: 'khajuri', label: 'Khajuri', pincode: '843347' },
  { value: 'kurhani', label: 'Kurhani', pincode: '843348' }
  ],

  'gaya': [
    { value: 'a-p-colony', label: 'A.P. Colony', pincode: '823001' },
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '823001' },
    { value: 'ajay-bhawan', label: 'Ajay Bhawan', pincode: '823001' },
    { value: 'aliganj', label: 'Aliganj', pincode: '823002' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '823001' },
    { value: 'atri', label: 'Atri', pincode: '823311' },
    { value: 'bankey-bazar', label: 'Bankey Bazar', pincode: '824217' },
    { value: 'barachatti', label: 'Barachatti', pincode: '824220' },
    { value: 'belaganj', label: 'Belaganj', pincode: '804403' },
    { value: 'bhagalpur-colony', label: 'Bhagalpur Colony', pincode: '823001' },
    { value: 'bhatt-bigha', label: 'Bhatt Bigha', pincode: '823001' },
    { value: 'bodhgaya', label: 'Bodhgaya', pincode: '824231' },
    { value: 'chandauti', label: 'Chandauti', pincode: '823001' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '823001' },
    { value: 'deo-kothi', label: 'Deo Kothi', pincode: '824206' },
    { value: 'dumariya', label: 'Dumariya', pincode: '824206' },
    { value: 'durga-bari', label: 'Durga Bari', pincode: '823003' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '804405' },
    { value: 'gandhi-maidan', label: 'Gandhi Maidan', pincode: '823002' },
    { value: 'gautam-budh-colony', label: 'Gautam Budh Colony', pincode: '824231' },
    { value: 'gewal-bigha', label: 'Gewal Bigha', pincode: '823001' },
    { value: 'girija-market', label: 'Girija Market', pincode: '823001' },
    { value: 'gol-bagicha', label: 'Gol Bagicha', pincode: '823001' },
    { value: 'guraru', label: 'Guraru', pincode: '824211' },
    { value: 'gurua', label: 'Gurua', pincode: '824205' },
    { value: 'hanuman-nagar', label: 'Hanuman Nagar', pincode: '823001' },
    { value: 'imamganj', label: 'Imamganj', pincode: '824206' },
    { value: 'ishapur', label: 'Ishapur', pincode: '823003' },
    { value: 'jagdeo-nagar', label: 'Jagdeo Nagar', pincode: '823002' },
    { value: 'janta-colony', label: 'Janta Colony', pincode: '823003' },
    { value: 'jaiprakash-nagar', label: 'Jaiprakash Nagar', pincode: '823002' },
    { value: 'katari-hill', label: 'Katari Hill', pincode: '823002' },
    { value: 'keshav-nagar', label: 'Keshav Nagar', pincode: '823001' },
    { value: 'kharkhura', label: 'Kharkhura', pincode: '823004' },
    { value: 'khizarsarai', label: 'Khizarsarai', pincode: '824233' },
    { value: 'konch', label: 'Konch', pincode: '824207' },
    { value: 'lalit-nagar', label: 'Lalit Nagar', pincode: '823001' },
    { value: 'lakhan-pura', label: 'Lakhan Pura', pincode: '824233' },
    { value: 'loco-colony', label: 'Loco Colony', pincode: '823001' },
    { value: 'luxmipur', label: 'Luxmipur', pincode: '804404' },
    { value: 'manpur', label: 'Manpur', pincode: '823003' },
    { value: 'maranpur', label: 'Maranpur', pincode: '823002' },
    { value: 'maroof-ganj', label: 'Maroof Ganj', pincode: '823003' },
    { value: 'mohan-nagar', label: 'Mohan Nagar', pincode: '823003' },
    { value: 'murarpur', label: 'Murarpur', pincode: '823004' },
    { value: 'nawab-colony', label: 'Nawab Colony', pincode: '823001' },
    { value: 'pantnagar', label: 'Pantnagar', pincode: '824233' },
    { value: 'paraiya', label: 'Paraiya', pincode: '824209' },
    { value: 'ram-nagar-colony', label: 'Ram Nagar Colony', pincode: '823001' },
    { value: 'ram-pur', label: 'Ram Pur', pincode: '824232' },
    { value: 'ramshila', label: 'Ramshila', pincode: '823002' },
    { value: 'santosh-nagar', label: 'Santosh Nagar', pincode: '823001' },
    { value: 'sherghati', label: 'Sherghati', pincode: '824211' },
    { value: 'shanti-bagh', label: 'Shanti Bagh', pincode: '824232' },
    { value: 'taj-colony', label: 'Taj Colony', pincode: '823002' },
    { value: 'tekari-road', label: 'Tekari Road', pincode: '824236' },
    { value: 'wazirganj', label: 'Wazirganj', pincode: '805131' }
  ],

  'vijayawada': [
    { value: 'arul-nagar', label: 'Arul Nagar', pincode: '520007' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '520012' },
    { value: 'auto-nagar', label: 'Auto Nagar', pincode: '520007' },
    { value: 'ayodhya-nagar', label: 'Ayodhya Nagar', pincode: '520003' },
    { value: 'ayyappa-nagar', label: 'Ayyappa Nagar', pincode: '520008' },
    { value: 'bandar-road', label: 'Bandar Road', pincode: '520001' },
    { value: 'bapanayyanagar', label: 'Bapanayyanagar', pincode: '520010' },
    { value: 'bavajipet', label: 'Bavajipet', pincode: '520001' },
    { value: 'benz-circle', label: 'Benz Circle', pincode: '520010' },
    { value: 'bhagat-singh-nagar', label: 'Bhagat Singh Nagar', pincode: '520007' },
    { value: 'bharathi-nagar', label: 'Bharathi Nagar', pincode: '520008' },
    { value: 'bhavanipuram', label: 'Bhavanipuram', pincode: '520012' },
    { value: 'bhimannavaripeta', label: 'Bhimannavaripeta', pincode: '520001' },
    { value: 'bramanadha-reddy-nagar', label: 'Bramanadha Reddy Nagar', pincode: '520010' },
    { value: 'canal-road', label: 'Canal Road', pincode: '520008' },
    { value: 'chalasani-nagar', label: 'Chalasani Nagar', pincode: '520008' },
    { value: 'chittinagar', label: 'Chittinagar', pincode: '520004' },
    { value: 'chowdhary-pet', label: 'Chowdhary Pet', pincode: '520001' },
    { value: 'christurajupuram', label: 'Christurajupuram', pincode: '520003' },
    { value: 'currency-nagar', label: 'Currency Nagar', pincode: '520008' },
    { value: 'devi-nagar', label: 'Devi Nagar', pincode: '520008' },
    { value: 'durga-agraharam', label: 'Durga Agraharam', pincode: '520003' },
    { value: 'enikepadu', label: 'Enikepadu', pincode: '521108' },
    { value: 'fakirgudem', label: 'Fakirgudem', pincode: '520011' },
    { value: 'fraserpeta', label: 'Fraserpeta', pincode: '520027' },
    { value: 'gayatri-nagar', label: 'Gayatri Nagar', pincode: '520008' },
    { value: 'gollapudi', label: 'Gollapudi', pincode: '521125' },
    { value: 'governorpet', label: 'Governorpet', pincode: '520002' },
    { value: 'gunadala', label: 'Gunadala', pincode: '520004' },
    { value: 'hanumanpet', label: 'Hanumanpet', pincode: '520003' },
    { value: 'jojinagar', label: 'Jojinagar', pincode: '520003' },
    { value: 'kaleswara-rao-market', label: 'Kaleswara Rao Market', pincode: '520001' },
    { value: 'kamayyathopu', label: 'Kamayyathopu', pincode: '520008' },
    { value: 'kanuru', label: 'Kanuru', pincode: '521134' },
    { value: 'krishnalanka', label: 'Krishnalanka', pincode: '520013' },
    { value: 'labbipeta', label: 'Labbipeta', pincode: '520010' },
    { value: 'lept-icon', label: 'LEPL Icon', pincode: '520008' },
    { value: 'lic-colony', label: 'LIC Colony', pincode: '520008' },
    { value: 'lurdhunagar', label: 'Lurdhunagar', pincode: '520004' },
    { value: 'mallikarjunapeta', label: 'Mallikarjunapeta', pincode: '520003' },
    { value: 'milk-colony', label: 'Milk Colony', pincode: '520008' },
    { value: 'moghalrajpuram', label: 'Moghalrajpuram', pincode: '520010' },
    { value: 'mylavaram-vari-street', label: 'Mylavaram Vari Street', pincode: '521230' },
    { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '520008' },
    { value: 'new-rajarajeswaripeta', label: 'New Rajarajeswaripeta', pincode: '520003' },
    { value: 'nh-9', label: 'NH-9', pincode: '521137' },
    { value: 'nidamanuru', label: 'Nidamanuru', pincode: '521104' },
    { value: 'patamata', label: 'Patamata', pincode: '520010' },
    { value: 'payakapuram', label: 'Payakapuram', pincode: '520015' },
    { value: 'pnt-colony', label: 'PNT Colony', pincode: '520003' },
    { value: 'poranki', label: 'Poranki', pincode: '521137' },
    { value: 'ramalingeswara-nagar', label: 'Ramalingeswara Nagar', pincode: '520012' },
    { value: 'ramarajunagar', label: 'Ramarajunagar', pincode: '520008' },
    { value: 'ramavarapupadu', label: 'Ramavarapupadu', pincode: '521106' },
    { value: 'ranga-nagar', label: 'Ranga Nagar', pincode: '520010' },
    { value: 'ranigaritota', label: 'Ranigaritota', pincode: '520001' },
    { value: 'rr-nagar', label: 'RR Nagar', pincode: '520010' },
    { value: 'rtc-colony', label: 'RTC Colony', pincode: '520008' },
    { value: 'sanath-nagar', label: 'Sanath Nagar', pincode: '520008' },
    { value: 'satyanarayanapuram-main-road', label: 'Satyanarayanapuram Main Road', pincode: '520011' },
    { value: 'satyaranayana-puram', label: 'Satyaranayana Puram', pincode: '520011' },
    { value: 'sidhartha-nagar', label: 'Sidhartha Nagar', pincode: '520010' },
    { value: 'sri-ramachandra-nagar', label: 'Sri Ramachandra Nagar', pincode: '520008' }
  ],

  'visakhapatnam': [
    { value: '100-Pepsi-Road', label: '100 Pepsi Road', pincode: '530041' },
    { value: '40-Feet-Old-NH-5-Road', label: '40 Feet Old NH-5 Road', pincode: '530041' },
    { value: 'achutapuram-Road', label: 'Achutapuram Road', pincode: '531011' },
    { value: 'adarsh-Nagar', label: 'Adarsh Nagar', pincode: '530028' },
    { value: 'agnampudi', label: 'Agnampudi', pincode: '530043' },
    { value: 'akkayyapalem', label: 'Akkayyapalem', pincode: '530016' },
    { value: 'akkireddypalem', label: 'Akkireddypalem', pincode: '530018' },
    { value: 'alamanda', label: 'Alamanda', pincode: '531011' },
    { value: 'allipuram', label: 'Allipuram', pincode: '530003' },
    { value: 'amalapuram', label: 'Amalapuram', pincode: '533201' },
    { value: 'amanam', label: 'Amanam', pincode: '531021' },
    { value: 'anakapalle', label: 'Anakapalle', pincode: '531001' },
    { value: 'anandapuram', label: 'Anandapuram', pincode: '531001' },
    { value: 'annavaram', label: 'Annavaram', pincode: '533406' },
    { value: 'araku', label: 'Araku', pincode: '531149' },
    { value: 'arilova', label: 'Arilova', pincode: '530040' },
    { value: 'asilmetta', label: 'Asilmetta', pincode: '530003' },
    { value: 'assam-Gardens', label: 'Assam Gardens', pincode: '530003' },
    { value: 'atchutapuram', label: 'Atchutapuram', pincode: '531011' },
    { value: 'auto-Nagar', label: 'Auto Nagar', pincode: '530012' },
    { value: 'avasomavaram', label: 'Avasomavaram', pincode: '531019' },
    { value: 'balayya-Sastri-Layout', label: 'Balayya Sastri Layout', pincode: '530013' },
    { value: 'beach-Road', label: 'Beach Road', pincode: '530002' },
    { value: 'bheemili', label: 'Bheemili', pincode: '531163' },
    { value: 'bheemili-Road', label: 'Bheemili Road', pincode: '531162' },
    { value: 'bheemunipatnam', label: 'Bheemunipatnam', pincode: '531163' },
    { value: 'bhogapuram', label: 'Bhogapuram', pincode: '531162' },
    { value: 'bowdara-Road', label: 'Bowdara Road', pincode: '530002' },
    { value: 'boyapalem', label: 'Boyapalem', pincode: '530014' },
    { value: 'bucchirajupalam', label: 'Bucchirajupalam', pincode: '531001' },
    { value: 'cBM-Compound', label: 'CBM Compound', pincode: '530003' },
    { value: 'chaitanyanagar', label: 'Chaitanyanagar', pincode: '530029' },
    { value: 'chepala-Kancheru', label: 'Chepala Kancheru', pincode: '531019' },
    { value: 'chinna-Waltair', label: 'Chinna Waltair', pincode: '530017' },
    { value: 'chinnamushidivada', label: 'Chinnamushidivada', pincode: '531027' },
    { value: 'chippada', label: 'Chippada', pincode: '531162' },
    { value: 'chodavaram', label: 'Chodavaram', pincode: '531035' },
    { value: 'daba-Gardens', label: 'Daba Gardens', pincode: '530020' },
    { value: 'dasapalla-Hills', label: 'Dasapalla Hills', pincode: '530003' },
    { value: 'desa-Pathrunipalem', label: 'Desa Pathrunipalem', pincode: '530041' },
    { value: 'dondaparthy', label: 'Dondaparthy', pincode: '530016' },
    { value: 'dopperla', label: 'Dopperla', pincode: '531029' },
    { value: 'duvvada', label: 'Duvvada', pincode: '531023' },
    { value: 'dwaraka-Nagar', label: 'Dwaraka Nagar', pincode: '530016' },
    { value: 'east-Point-Colony', label: 'East Point Colony', pincode: '530017' },
    { value: 'endada', label: 'Endada', pincode: '530046' },
    { value: 'gajuwaka', label: 'Gajuwaka', pincode: '530026' },
    { value: 'gambhiram', label: 'Gambhiram', pincode: '531162' },
    { value: 'ganapathi-Temple-Road', label: 'Ganapathi Temple Road', pincode: '530012' },
    { value: 'gandigundam', label: 'Gandigundam', pincode: '530012' },
    { value: 'gidijala', label: 'Gidijala', pincode: '531081' },
    { value: 'gokhale-Road', label: 'Gokhale Road', pincode: '530020' },
    { value: 'gollala-Yendada', label: 'Gollala Yendada', pincode: '530048' },
    { value: 'gopalapatnam', label: 'Gopalapatnam', pincode: '530027' },
    { value: 'gudilova', label: 'Gudilova', pincode: '531025' },
    { value: 'guntur', label: 'Guntur', pincode: '522001' },
    { value: 'hB-Colony', label: 'HB Colony', pincode: '530022' },
    { value: 'hitech-City-Road', label: 'Hitech City Road', pincode: '530063' },
    { value: 'iruvada', label: 'Iruvada', pincode: '531032' },
    { value: 'isakathota', label: 'Isakathota', pincode: '530014' },
    { value: 'jagadamba-Junction', label: 'Jagadamba Junction', pincode: '530020' },
    { value: 'jaggarajupeta', label: 'Jaggarajupeta', pincode: '530012' },
    { value: 'jonnada-Road', label: 'Jonnada Road', pincode: '531024' },
    { value: 'juttada-Road', label: 'Juttada Road', pincode: '530014' },
    { value: 'jyothinagar', label: 'Jyothinagar', pincode: '530027' },
    { value: 'kailasapuram', label: 'Kailasapuram', pincode: '530016' },
    { value: 'kakani-Nagar', label: 'Kakani Nagar', pincode: '530016' },
    { value: 'kancharapalem', label: 'Kancharapalem', pincode: '530008' },
    { value: 'kantakapalle', label: 'Kantakapalle', pincode: '531002' },
    { value: 'kapuluppada', label: 'Kapuluppada', pincode: '531113' },
    { value: 'khandepalli', label: 'Khandepalli', pincode: '531021' },
    { value: 'kirlampudi-Layout ', label: 'Kirlampudi Layout ', pincode: '530027' },
    { value: 'kommadi', label: 'Kommadi', pincode: '531173' },
    { value: 'kondakarla-Ava', label: 'Kondakarla Ava', pincode: '531020' },
    { value: 'korada', label: 'Korada', pincode: '531019' },
    { value: 'kothaguda-T-Junction', label: 'Kothaguda T Junction', pincode: '530061' },
    { value: 'kothavalasa', label: 'Kothavalasa', pincode: '531020' },
    { value: 'krishna-Nagar', label: 'Krishna Nagar', pincode: '530016' },
    { value: 'kRM-Colony', label: 'KRM Colony', pincode: '530007' },
    { value: 'kurmannapalem', label: 'Kurmannapalem', pincode: '530046' },
    { value: 'lakkavarapu-Kota', label: 'Lakkavarapu Kota', pincode: '531002' },
    { value: 'lalitha-Nagar-Colony', label: 'Lalitha Nagar Colony', pincode: '530027' },
    { value: 'lankelapalem', label: 'Lankelapalem', pincode: '531001' },
    { value: 'lawsonsbay-Colony', label: 'Lawsonsbay Colony', pincode: '530017' },
    { value: 'maddilapalem', label: 'Maddilapalem', pincode: '530027' },
    { value: 'madduturu', label: 'Madduturu', pincode: '531016' },
    { value: 'madhavadhara', label: 'Madhavadhara', pincode: '530007' },
    { value: 'madhura-Nagar', label: 'Madhura Nagar', pincode: '530003' },
    { value: 'madhurawada', label: 'Madhurawada', pincode: '530041' },
    { value: 'maharani-Peta', label: 'Maharani Peta', pincode: '530002' },
    { value: 'majjivalasa', label: 'Majjivalasa', pincode: '531201' },
    { value: 'mamidipalem', label: 'Mamidipalem', pincode: '531022' },
    { value: 'marikavasala', label: 'Marikavasala', pincode: '530007' },
    { value: 'marripalem', label: 'Marripalem', pincode: '531021' },
    { value: 'mopada', label: 'Mopada', pincode: '531162' },
    { value: 'murali-Nagar', label: 'Murali Nagar', pincode: '530007' },
    { value: ',mVP-Colony', label: 'MVP Colony', pincode: '530017' },
    { value: 'nad-Junction', label: 'Nad Junction', pincode: '531028' },
    { value: 'nAD-Kottha-Road', label: 'NAD Kottha Road', pincode: '530028' },
    { value: 'naidu-Thota', label: 'Naidu Thota', pincode: '530017' },
    { value: 'narasimhanagar', label: 'Narasimhanagar', pincode: '530028' },
    { value: 'narsipatnam', label: 'Narsipatnam', pincode: '531116' },
    { value: 'nH-43', label: 'NH-43', pincode: '531001' },
    { value: 'nH-5', label: 'NH-5', pincode: '530019' },
    { value: 'one-Town', label: 'One Town', pincode: '530001' },
    { value: 'paanduranga-Puram', label: 'Paanduranga Puram', pincode: '530027' },
    { value: 'padmanabha Nagar', label: 'Padmanabha Nagar', pincode: '530027' },
    { value: 'palacherla', label: 'Palacherla', pincode: '531115' },
    { value: 'paradesipalem', label: 'Paradesipalem', pincode: '531011' },
    { value: 'paravada', label: 'Paravada', pincode: '531020' },
    { value: 'payakaraopeta', label: 'Payakaraopeta', pincode: '531126' },
    { value: 'peda-Narava', label: 'Peda Narava', pincode: '531161' },
    { value: 'pedagadi', label: 'Pedagadi', pincode: '531149' },
    { value: 'pedagantyada', label: 'Pedagantyada', pincode: '530044' },
    { value: 'pedda-Gadhili', label: 'Pedda Gadhili', pincode: '531019' },
    { value: 'pedda-Waltair', label: 'Pedda Waltair', pincode: '530017' },
    { value: 'pendurthi', label: 'Pendurthi', pincode: '530044' },
    { value: 'pinagadi', label: 'Pinagadi', pincode: '531124' },
    { value: 'pithapuram-Colony', label: 'Pithapuram Colony', pincode: '531010' },
    { value: 'port-Area', label: 'Port Area', pincode: '530001' },
    { value: 'pothinamallayya-Palem', label: 'Pothinamallayya Palem', pincode: '530041' },
    { value: 'prahaladapuram', label: 'Prahaladapuram', pincode: '530016' },
    { value: 'pravada', label: 'Pravada', pincode: '531023' },
    { value: 'pudimadaka-Road', label: 'Pudimadaka Road', pincode: '531114' },
    { value: 'pulaganipalem-Road', label: 'Pulaganipalem Road', pincode: '531020' },
    { value: 'purna-Market', label: 'Purna Market', pincode: '530001' },
    { value: 'r.K.-Beach', label: 'R.K. Beach', pincode: '530003' },
    { value: 'railway-New-Colony', label: 'Railway New Colony', pincode: '530009' },
    { value: 'rajamundry', label: 'Rajamundry', pincode: '533101' },
    { value: 'rajapulova-Junction', label: 'Rajapulova Junction', pincode: '530020' },
    { value: 'rajeev-Nagar', label: 'Rajeev Nagar', pincode: '530016' },
    { value: 'ram-Nagar', label: 'Ram Nagar', pincode: '530002' },
    { value: 'ramachandra-Nagar', label: 'Ramachandra Nagar', pincode: '530008' },
    { value: 'rambilli', label: 'Rambilli', pincode: '531066' },
    { value: 'resapuvanipalem', label: 'Resapuvanipalem', pincode: '530029' },
    { value: 'resavani-Palem', label: 'Resavani Palem', pincode: '531126' },
    { value: 'revidi', label: 'Revidi', pincode: '531021' },
    { value: 'rushikonda', label: 'Rushikonda', pincode: '530045' },
    { value: 'sabbavaram', label: 'Sabbavaram', pincode: '531035' },
    { value: 'sagar-Nagar', label: 'Sagar Nagar', pincode: '530027' },
    { value: 'sankaramatam-Road', label: 'Sankaramatam Road', pincode: '530026' },
    { value: 'santhi-Nagar', label: 'Santhi Nagar', pincode: '530016' },
    { value: 'sathagalli', label: 'Sathagalli', pincode: '530002' },
    { value: 'seelam-Nookaraju-Road', label: 'Seelam Nookaraju Road', pincode: '530016' },
    { value: 'seethamma-Peta', label: 'Seethamma Peta', pincode: '530003' },
    { value: 'seethammadhara', label: 'Seethammadhara', pincode: '530013' },
    { value: 'seshadrinagar', label: 'Seshadrinagar', pincode: '530016' },
    { value: 'shanti-Nagar', label: 'Shanti Nagar', pincode: '530016' },
    { value: 'sheela-Nagar', label: 'Sheela Nagar', pincode: '530027' },
    { value: 'simhachalam', label: 'Simhachalam', pincode: '530028' },
    { value: 'siripuram', label: 'Siripuram', pincode: '530003' },
    { value: 'sivajipalem', label: 'Sivajipalem', pincode: '530028' },
    { value: 'soldier-Pet', label: 'Soldier Pet', pincode: '530003' },
    { value: 'sontyam', label: 'Sontyam', pincode: '531042' },
    { value: 'sriharipuram', label: 'Sriharipuram', pincode: '530028' },
    { value: 'subba-Raju-Layout', label: 'Subba Raju Layout', pincode: '530008' },
    { value: 'sujatha-Nagar', label: 'Sujatha Nagar', pincode: '530027' },
    { value: 'sundar Nagar', label: 'Sundar Nagar', pincode: '530027' },
    { value: 'suryabagh', label: 'Suryabagh', pincode: '530020' },
    { value: 'susarla-Colony', label: 'Susarla Colony', pincode: '530022' },
    { value: 'tallapalem', label: 'Tallapalem', pincode: '531011' },
    { value: 'tallavalasa', label: 'Tallavalasa', pincode: '531163' },
    { value: 'thagarapuvalasa', label: 'Thagarapuvalasa', pincode: '531162' },
    { value: 'thatichetlapalem', label: 'Thatichetlapalem', pincode: '530027' },
    { value: 'town-Kotha-Road', label: 'Town Kotha Road', pincode: '530004' },
    { value: 'tSN-Colony', label: 'TSN Colony', pincode: '530028' },
    { value: 'tungalam', label: 'Tungalam', pincode: '531022' },
    { value: 'uplands', label: 'Uplands', pincode: '530019' },
    { value: 'uppada', label: 'Uppada', pincode: '531203' },
    { value: 'vadlapudi', label: 'Vadlapudi', pincode: '530042' },
    { value: 'venkatapuram', label: 'Venkatapuram', pincode: '530016' },
    { value: 'venkojipalem', label: 'Venkojipalem', pincode: '530028' },
    { value: 'vepagunta', label: 'Vepagunta', pincode: '530047' },
    { value: 'vijayanagar', label: 'Vijayanagar', pincode: '530043' },
    { value: 'viman-Nagar', label: 'Viman Nagar', pincode: '530018' },
    { value: 'vIP-Road', label: 'VIP Road', pincode: '530027' },
    { value: 'visalakshi-Nagar', label: 'Visalakshi Nagar', pincode: '530027' },
    { value: 'visveswarayya-Nagar', label: 'Visveswarayya Nagar', pincode: '530007' },
    { value: 'vizianagaram', label: 'Vizianagaram', pincode: '535001' },
    { value: 'waltair-Uplands', label: 'Waltair Uplands', pincode: '530003' },
    { value: 'yelamanchili', label: 'Yelamanchili', pincode: '531055' },
    { value: 'zilla-Parishad', label: 'Zilla Parishad', pincode: '530012' },
  ],

  'nellore': [
    { value: 'ananthasagaram', label: 'Ananthasagaram', pincode: '524305' },
    { value: 'anumasamudrampeta', label: 'Anumasamudrampeta', pincode: '524126' },
    { value: 'apparao-palem', label: 'Apparao Palem', pincode: '524311' },
    { value: 'balayapalle', label: 'Balayapalle', pincode: '524138' },
    { value: 'basinenipalli', label: 'Basinenipalli', pincode: '524314' },
    { value: 'bheemavarappadu', label: 'Bheemavarappadu', pincode: '524302' },
    { value: 'bitragunta', label: 'Bitragunta', pincode: '524115' },
    { value: 'bogole', label: 'Bogole', pincode: '524228' },
    { value: 'botikarlapadu', label: 'Botikarlapadu', pincode: '524211' },
    { value: 'chaganam-rajupalem', label: 'Chaganam Rajupalem', pincode: '524306' },
    { value: 'cheerla-vari-kandrika', label: 'Cheerla Vari Kandrika', pincode: '524102' },
    { value: 'chejerla', label: 'Chejerla', pincode: '524137' },
    { value: 'chennavarappadu', label: 'Chennavarappadu', pincode: '524304' },
    { value: 'chennur', label: 'Chennur', pincode: '524318' },
    { value: 'chillakur', label: 'Chillakur', pincode: '524412' },
    { value: 'chintalapalem', label: 'Chintalapalem', pincode: '524106' },
    { value: 'chittamur', label: 'Chittamur', pincode: '524129' },
    { value: 'd-velampalli', label: 'D. Velampalli', pincode: '524404' },
    { value: 'dagadarthi', label: 'Dagadarthi', pincode: '524411' },
    { value: 'daggavolu', label: 'Daggavolu', pincode: '524310' },
    { value: 'dakkili', label: 'Dakkili', pincode: '524311' },
    { value: 'damaramadugu', label: 'Damaramadugu', pincode: '524228' },
    { value: 'damegunta', label: 'Damegunta', pincode: '524134' },
    { value: 'dharmavaram', label: 'Dharmavaram', pincode: '524404' },
    { value: 'doravarisatram', label: 'Doravarisatram', pincode: '524314' },
    { value: 'duggunta', label: 'Duggunta', pincode: '524315' },
    { value: 'duttalur', label: 'Duttalur', pincode: '524314' },
    { value: 'gandipalem', label: 'Gandipalem', pincode: '524302' },
    { value: 'indukurupeta', label: 'Indukurupeta', pincode: '524308' },
    { value: 'jaladanki', label: 'Jaladanki', pincode: '524207' },
    { value: 'jonnawada', label: 'Jonnawada', pincode: '524221' },
    { value: 'kaligiri', label: 'Kaligiri', pincode: '524216' },
    { value: 'kaluvoya', label: 'Kaluvoya', pincode: '524137' },
    { value: 'kammapalli', label: 'Kammapalli', pincode: '524138' },
    { value: 'kammavaari-palem', label: 'Kammavaari Palem', pincode: '524129' },
    { value: 'kammavari-palli', label: 'Kammavari Palli', pincode: '524225' },
    { value: 'kodavalur', label: 'Kodavalur', pincode: '524314' },
    { value: 'kodivaka', label: 'Kodivaka', pincode: '524136' },
    { value: 'kokkupalem', label: 'Kokkupalem', pincode: '524302' },
    { value: 'komatigunta-rajupalem', label: 'Komatigunta Rajupalem', pincode: '524228' },
    { value: 'konagaluru', label: 'Konagaluru', pincode: '524208' },
    { value: 'kondapuram', label: 'Kondapuram', pincode: '524411' },
    { value: 'koneti-raju-palem', label: 'Koneti Raju Palem', pincode: '524303' },
    { value: 'kota', label: 'Kota', pincode: '524413' },
    { value: 'kothapalli', label: 'Kothapalli', pincode: '524137' },
    { value: 'madamanuru', label: 'Madamanuru', pincode: '524208' },
    { value: 'mangalampadu', label: 'Mangalampadu', pincode: '524137' },
    { value: 'manubolu', label: 'Manubolu', pincode: '524230' },
    { value: 'marlagunta', label: 'Marlagunta', pincode: '524201' },
    { value: 'marripadu', label: 'Marripadu', pincode: '524125' },
    { value: 'menakuru', label: 'Menakuru', pincode: '524220' },
    { value: 'mittatmakur', label: 'Mittatmakur', pincode: '524301' },
    { value: 'mudivarthi', label: 'Mudivarthi', pincode: '524301' },
    { value: 'muthukur', label: 'Muthukur', pincode: '524344' },
    { value: 'mypadu', label: 'Mypadu', pincode: '524319' },
    { value: 'n-kothapalli', label: 'N. Kothapalli', pincode: '524412' },
    { value: 'narrawada', label: 'Narrawada', pincode: '524402' },
    { value: 'nelapattu', label: 'Nelapattu', pincode: '524320' },
    { value: 'nellatur', label: 'Nellatur', pincode: '524137' },
    { value: 'north-rajupalem', label: 'North Rajupalem', pincode: '524308' },
    { value: 'ojili', label: 'Ojili', pincode: '524309' },
    { value: 'pangili', label: 'Pangili', pincode: '524123' },
    { value: 'pellakur', label: 'Pellakur', pincode: '524160' },
    { value: 'penchalakona', label: 'Penchalakona', pincode: '524216' },
    { value: 'pennepalli', label: 'Pennepalli', pincode: '524202' },
    { value: 'pepala-vari-palem', label: 'Pepala Vari Palem', pincode: '524317' },
    { value: 'periyavaram', label: 'Periyavaram', pincode: '524137' },
    { value: 'podalakur', label: 'Podalakur', pincode: '524001' },
    { value: 'puttamraju-kandriga', label: 'Puttamraju Kandriga', pincode: '524135' },
    { value: 'rama-reddy-palem', label: 'Rama Reddy Palem', pincode: '524324' },
    { value: 'ramanapalem', label: 'Ramanapalem', pincode: '524217' },
    { value: 'ramapuram', label: 'Ramapuram', pincode: '524126' },
    { value: 'rebala', label: 'Rebala', pincode: '524140' },
    { value: 'saipeta', label: 'Saipeta', pincode: '524415' },
    { value: 'sangam', label: 'Sangam', pincode: '524309' },
    { value: 'sarvepalli', label: 'Sarvepalli', pincode: '524146' },
    { value: 'seetharamapuram', label: 'Seetharamapuram', pincode: '524306' },
    { value: 'shar-project', label: 'Shar Project', pincode: '524413' },
    { value: 'siddana-konduru', label: 'Siddana Konduru', pincode: '524231' },
    { value: 'siddareddy-palem', label: 'Siddareddy Palem', pincode: '524317' },
    { value: 'sydapuram', label: 'Sydapuram', pincode: '524305' },
    { value: 'tada', label: 'Tada', pincode: '524401' },
    { value: 'thinnelapudi', label: 'Thinnelapudi', pincode: '524412' },
    { value: 'thippavarappadu', label: 'Thippavarappadu', pincode: '524205' },
    { value: 'thirumalamma-palem', label: 'Thirumalamma Palem', pincode: '524315' },
    { value: 'thoorpu-dubagunta', label: 'Thoorpu Dubagunta', pincode: '524137' },
    { value: 'thotapalligudur', label: 'Thotapalligudur', pincode: '524135' },
    { value: 'thummalapenta', label: 'Thummalapenta', pincode: '524211' },
    { value: 'ulavapalli', label: 'Ulavapalli', pincode: '524143' },
    { value: 'utukur', label: 'Utukur', pincode: '524145' },
    { value: 'upputuru', label: 'Upputuru', pincode: '524317' },
    { value: 'vakadu', label: 'Vakadu', pincode: '524123' },
    { value: 'varikuntapadu', label: 'Varikuntapadu', pincode: '524413' },
    { value: 'veguru', label: 'Veguru', pincode: '524307' },
    { value: 'venadu', label: 'Venadu', pincode: '524126' },
    { value: 'vendodu', label: 'Vendodu', pincode: '524319' },
    { value: 'vidavalur', label: 'Vidavalur', pincode: '524230' },
    { value: 'vinjamur', label: 'Vinjamur', pincode: '524225' },
    { value: 'viruvur', label: 'Viruvur', pincode: '524305' },
    { value: 'yellayapalem', label: 'Yellayapalem', pincode: '524137' },
    { value: 'yerradoddipalli', label: 'Yerradoddipalli', pincode: '524315' }
  ],
//assam areas
'gauripur': [
  { value: 'balapara', label: 'Balapara', pincode: '783331' },
  { value: 'baramari', label: 'Baramari', pincode: '783331' },
  { value: 'bholaguri', label: 'Bholaguri', pincode: '783331' },
  { value: 'bongaigaon', label: 'Bongaigaon', pincode: '783380' },
  { value: 'burigaon', label: 'Burigaon', pincode: '783331' },
  { value: 'gauripur', label: 'Gauripur', pincode: '783331' },
  { value: 'gogumara', label: 'Gogumara', pincode: '783380' },
  { value: 'kanara', label: 'Kanara', pincode: '783331' },
  { value: 'kharangajuli', label: 'Kharangajuli', pincode: '783331' },
  { value: 'madhapur', label: 'Madhapur', pincode: '783338' },
  { value: 'malachuburi', label: 'Malachuburi', pincode: '783331' },
  { value: 'namati', label: 'Namati', pincode: '783330' },
  { value: 'phulguri', label: 'Phulguri', pincode: '783331' },
  { value: 'sukchar', label: 'Sukchar', pincode: '783331' },
  { value: 'sundaridiya', label: 'Sundaridiya', pincode: '783331' },
  { value: 'tulsipara', label: 'Tulsipara', pincode: '783380' },
  { value: 'uchida', label: 'Uchida', pincode: '783331' },
  { value: 'ujjalkuri', label: 'Ujjalkuri', pincode: '783338' }
  ],
  
  'sivasagar': [
  { value: 'amguri', label: 'Amguri', pincode: '785620' },
  { value: 'barkuriha', label: 'Barkuriha', pincode: '785640' },
  { value: 'dergaon', label: 'Dergaon', pincode: '785614' },
  { value: 'ghoramara', label: 'Ghoramara', pincode: '785682' },
  { value: 'gogamukh', label: 'Gogamukh', pincode: '785688' },
  { value: 'jatia', label: 'Jatia', pincode: '785620' },
  { value: 'joypur', label: 'Joypur', pincode: '785682' },
  { value: 'kakodonga', label: 'Kakodonga', pincode: '785640' },
  { value: 'kherajkhat', label: 'Kherajkhat', pincode: '785682' },
  { value: 'lekhajan', label: 'Lekhajan', pincode: '785664' },
  { value: 'nazira', label: 'Nazira', pincode: '785685' },
  { value: 'sivasagar', label: 'Sivasagar', pincode: '785640' },
  { value: 'sonari', label: 'Sonari', pincode: '785671' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '785614' },
  { value: 'telpani', label: 'Telpani', pincode: '785687' },
  { value: 'bali-sagor', label: 'Bali Sagor', pincode: '785670' },
  { value: 'burhi-majuli', label: 'Burhi Majuli', pincode: '785688' },
  { value: 'dhekiakhowa', label: 'Dhekiakhowa', pincode: '785639' },
  { value: 'lahoal', label: 'Lahoal', pincode: '785611' },
  { value: 'majan', label: 'Majan', pincode: '785620' },
  { value: 'mariani', label: 'Mariani', pincode: '785634' },
  { value: 'moran', label: 'Moran', pincode: '785670' },
  { value: 'raikhola', label: 'Raikhola', pincode: '785643' }
  ],

'amguri': [
  { value: 'amguri', label: 'Amguri', pincode: '785140' },
  { value: 'barnihat', label: 'Barnihat', pincode: '785140' },
  { value: 'bijni', label: 'Bijni', pincode: '785101' },
  { value: 'boginadi', label: 'Boginadi', pincode: '785614' },
  { value: 'dhekiajuli', label: 'Dhekiajuli', pincode: '785124' },
  { value: 'ghughuapathar', label: 'Ghughuapathar', pincode: '785140' },
  { value: 'gohpur', label: 'Gohpur', pincode: '785601' },
  { value: 'kolongpara', label: 'Kolongpara', pincode: '785140' },
  { value: 'koraibari', label: 'Koraibari', pincode: '785123' },
  { value: 'makum', label: 'Makum', pincode: '785125' },
  { value: 'rajabari', label: 'Rajabari', pincode: '785140' },
  { value: 'teteliguri', label: 'Teteliguri', pincode: '785140' },
  { value: 'thengal', label: 'Thengal', pincode: '785140' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '785106' },
  { value: 'dhemaji', label: 'Dhemaji', pincode: '787057' },
  { value: 'kashmiri', label: 'Kashmiri', pincode: '785150' },
  { value: 'manja', label: 'Manja', pincode: '785112' },
  { value: 'nalbari', label: 'Nalbari', pincode: '785106' },
  { value: 'pathalgaon', label: 'Pathalgaon', pincode: '785160' },
  { value: 'rajgarh', label: 'Rajgarh', pincode: '785140' },
  { value: 'sadiya', label: 'Sadiya', pincode: '785685' }
  ],
  
  'baksa': [
  { value: 'bajari', label: 'Bajari', pincode: '781364' },
  { value: 'baska', label: 'Baska', pincode: '781376' },
  { value: 'batabari', label: 'Batabari', pincode: '781364' },
  { value: 'bijni', label: 'Bijni', pincode: '781125' },
  { value: 'dakhin-bangaon', label: 'Dakhin Bangaon', pincode: '781364' },
  { value: 'dakhin-dhupguri', label: 'Dakhin Dhupguri', pincode: '781364' },
  { value: 'fakhrabad', label: 'Fakhrabad', pincode: '781364' },
  { value: 'gosaibari', label: 'Gosaibari', pincode: '781364' },
  { value: 'hazipur', label: 'Hazipur', pincode: '781364' },
  { value: 'jibonjhuli', label: 'Jibonjhuli', pincode: '781364' },
  { value: 'kacharigaon', label: 'Kacharigaon', pincode: '781364' },
  { value: 'kudra', label: 'Kudra', pincode: '781364' },
  { value: 'maligaon', label: 'Maligaon', pincode: '781364' },
  { value: 'manabari', label: 'Manabari', pincode: '781364' },
  { value: 'rajapara', label: 'Rajapara', pincode: '781364' },
  { value: 'sapkata', label: 'Sapkata', pincode: '781364' },
  { value: 'sarupeta', label: 'Sarupeta', pincode: '781364' },
  { value: 'sivshakti', label: 'Sivshakti', pincode: '781364' },
  { value: 'howly', label: 'Howly', pincode: '781372' },
  { value: 'bhotguri', label: 'Bhotguri', pincode: '781364' },
  { value: 'charipara', label: 'Charipara', pincode: '781364' },
  { value: 'kaliapara', label: 'Kaliapara', pincode: '781364' },
  { value: 'kichulakata', label: 'Kichulakata', pincode: '781364' },
  { value: 'krishnai', label: 'Krishnai', pincode: '781373' },
  { value: 'kunkura', label: 'Kunkura', pincode: '781364' },
  { value: 'moirabari', label: 'Moirabari', pincode: '781364' },
  { value: 'sillapara', label: 'Sillapara', pincode: '781364' }
  ],
  
  'barpeta': [
  { value: 'algapur', label: 'Algapur', pincode: '781302' },
  { value: 'bailung', label: 'Bailung', pincode: '781301' },
  { value: 'barpeta', label: 'Barpeta', pincode: '781314' },
  { value: 'barpeta-road', label: 'Barpeta Road', pincode: '781314' },
  { value: 'bhabanipur', label: 'Bhabanipur', pincode: '781302' },
  { value: 'bholagaon', label: 'Bholagaon', pincode: '781303' },
  { value: 'chandkuchi', label: 'Chandkuchi', pincode: '781314' },
  { value: 'chandmari', label: 'Chandmari', pincode: '781303' },
  { value: 'kalgachia', label: 'Kalgachia', pincode: '781306' },
  { value: 'kakripara', label: 'Kakripara', pincode: '781306' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '781301' },
  { value: 'madhapur', label: 'Madhapur', pincode: '781304' },
  { value: 'mouza', label: 'Mouza', pincode: '781303' },
  { value: 'nalbari', label: 'Nalbari', pincode: '781303' },
  { value: 'sialmari', label: 'Sialmari', pincode: '781305' },
  { value: 'taparia', label: 'Taparia', pincode: '781306' },
  { value: 'titabar', label: 'Titabar', pincode: '781307' },
  { value: 'ulubari', label: 'Ulubari', pincode: '781302' },
  { value: 'gagalmari', label: 'Gagalmari', pincode: '781308' },
  { value: 'sorkhuri', label: 'Sorkhuri', pincode: '781309' },
  { value: 'jengraimukh', label: 'Jengraimukh', pincode: '781310' },
  { value: 'fagunarbhita', label: 'Fagunarbhita', pincode: '781311' },
  { value: 'duguri', label: 'Duguri', pincode: '781312' },
  { value: 'nizarapar', label: 'Nizarapar', pincode: '781313' },
  { value: 'kapalibari', label: 'Kapalibari', pincode: '781315' }
  ],
  
  'bijni': [
  { value: 'bailung', label: 'Bailung', pincode: '781125' },
  { value: 'barigog', label: 'Barigog', pincode: '781125' },
  { value: 'bijni', label: 'Bijni', pincode: '781125' },
  { value: 'chandmari', label: 'Chandmari', pincode: '781125' },
  { value: 'dakhin-bangalipara', label: 'Dakhin Bangalipara', pincode: '781125' },
  { value: 'gopalbari', label: 'Gopalbari', pincode: '781125' },
  { value: 'jathia', label: 'Jathia', pincode: '781125' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '781125' },
  { value: 'mouza', label: 'Mouza', pincode: '781125' },
  { value: 'nalbari', label: 'Nalbari', pincode: '781125' },
  { value: 'rampur', label: 'Rampur', pincode: '781125' },
  { value: 'satariduba', label: 'Satariduba', pincode: '781125' },
  { value: 'sialmari', label: 'Sialmari', pincode: '781125' },
  { value: 'taparia', label: 'Taparia', pincode: '781125' },
  { value: 'titabar', label: 'Titabar', pincode: '781125' },
  { value: 'adabari', label: 'Adabari', pincode: '781125' },
  { value: 'birpur', label: 'Birpur', pincode: '781125' },
  { value: 'dhakua', label: 'Dhakua', pincode: '781125' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '781125' },
  { value: 'niz-titirabari', label: 'Niz Titirabari', pincode: '781125' },
  { value: 'patharigaon', label: 'Patharigaon', pincode: '781125' },
  { value: 'sijubari', label: 'Sijubari', pincode: '781125' },
  { value: 'talpara', label: 'Talpara', pincode: '781125' },
  { value: 'tilgram', label: 'Tilgram', pincode: '781125' }
  ],
  
  'biswanath-charali': [
  { value: 'adabari', label: 'Adabari', pincode: '784176' },
  { value: 'biswanath-chariali', label: 'Biswanath Chariali', pincode: '784176' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '784176' },
  { value: 'digaru', label: 'Digaru', pincode: '784176' },
  { value: 'jantua', label: 'Jantua', pincode: '784176' },
  { value: 'kamalabari', label: 'Kamalabari', pincode: '784176' },
  { value: 'kapowal', label: 'Kapowal', pincode: '784176' },
  { value: 'khaikha', label: 'Khaikha', pincode: '784176' },
  { value: 'kharjan', label: 'Kharjan', pincode: '784176' },
  { value: 'kushalgaon', label: 'Kushalgaon', pincode: '784176' },
  { value: 'madhupur', label: 'Madhupur', pincode: '784176' },
  { value: 'nagaon', label: 'Nagaon', pincode: '784176' },
  { value: 'pragjyotishpur', label: 'Pragjyotishpur', pincode: '784176' },
  { value: 'sarangpur', label: 'Sarangpur', pincode: '784176' },
  { value: 'sujanpur', label: 'Sujanpur', pincode: '784176' },
  { value: 'barbaruah', label: 'Barbaruah', pincode: '784176' },
  { value: 'borholla', label: 'Borholla', pincode: '784176' },
  { value: 'howli', label: 'Howli', pincode: '784176' },
  { value: 'kajali', label: 'Kajali', pincode: '784176' },
  { value: 'morigaon', label: 'Morigaon', pincode: '784176' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '784176' },
  { value: 'tamuli', label: 'Tamuli', pincode: '784176' },
  { value: 'tebhaga', label: 'Tebhaga', pincode: '784176' }
  ],
  
  'bongaigaon': [
  { value: 'bongaigaon', label: 'Bongaigaon', pincode: '783380' },
  { value: 'barpara', label: 'Barpara', pincode: '783381' },
  { value: 'bhurbandha', label: 'Bhurbandha', pincode: '783380' },
  { value: 'binapara', label: 'Binapara', pincode: '783380' },
  { value: 'dhaligaon', label: 'Dhaligaon', pincode: '783385' },
  { value: 'gobindapur', label: 'Gobindapur', pincode: '783380' },
  { value: 'gopi', label: 'Gopi', pincode: '783380' },
  { value: 'khagorijan', label: 'Khagorijan', pincode: '783380' },
  { value: 'niz-bongaigaon', label: 'Niz Bongaigaon', pincode: '783380' },
  { value: 'ruksin', label: 'Ruksin', pincode: '783380' },
  { value: 'sarma', label: 'Sarma', pincode: '783380' },
  { value: 'simlaguri', label: 'Simlaguri', pincode: '783380' },
  { value: 'south-bongaigaon', label: 'South Bongaigaon', pincode: '783380' },
  { value: 'swarnacharan', label: 'Swarnacharan', pincode: '783380' },
  { value: 'tengakhat', label: 'Tengakhat', pincode: '783385' },
  { value: 'dhorimath', label: 'Dhorimath', pincode: '783382' },
  { value: 'foolbari', label: 'Foolbari', pincode: '783384' },
  { value: 'tutikata', label: 'Tutikata', pincode: '783387' },
  { value: 'chapaguri', label: 'Chapaguri', pincode: '783389' }
  ],
  
  'chabua-town': [
  { value: 'amguri', label: 'Amguri', pincode: '786184' },
  { value: 'chabua', label: 'Chabua', pincode: '786184' },
  { value: 'chukmuh', label: 'Chukmuh', pincode: '786184' },
  { value: 'dullung', label: 'Dullung', pincode: '786184' },
  { value: 'hollongi', label: 'Hollongi', pincode: '786184' },
  { value: 'jagtal', label: 'Jagtal', pincode: '786184' },
  { value: 'janoigarh', label: 'Janoigarh', pincode: '786184' },
  { value: 'kashimnagar', label: 'Kashimnagar', pincode: '786184' },
  { value: 'maipani', label: 'Maipani', pincode: '786184' },
  { value: 'mohong', label: 'Mohong', pincode: '786184' },
  { value: 'pahumara', label: 'Pahumara', pincode: '786184' },
  { value: 'patakhola', label: 'Patakhola', pincode: '786184' },
  { value: 'sapekhati', label: 'Sapekhati', pincode: '786184' },
  { value: 'silanghat', label: 'Silanghat', pincode: '786184' },
  { value: 'tinkhuti', label: 'Tinkhuti', pincode: '786184' },
  { value: 'batgharia', label: 'Batgharia', pincode: '786184' },
  { value: 'bujung', label: 'Bujung', pincode: '786184' },
  { value: 'jagiroad', label: 'Jagiroad', pincode: '786184' },
  { value: 'kamargaon', label: 'Kamargaon', pincode: '786184' },
  { value: 'kheda', label: 'Kheda', pincode: '786184' },
  { value: 'mikirbheta', label: 'Mikirbheta', pincode: '786184' },
  { value: 'murkhaguri', label: 'Murkhaguri', pincode: '786184' },
  { value: 'nalbari', label: 'Nalbari', pincode: '786184' },
  { value: 'patilung', label: 'Patilung', pincode: '786184' }
  ],
  
  'chapar': [
  { value: 'abhoipur', label: 'Abhoipur', pincode: '783373' },
  { value: 'babrimari', label: 'Babrimari', pincode: '783373' },
  { value: 'bhusimari', label: 'Bhusimari', pincode: '783373' },
  { value: 'chapar', label: 'Chapar', pincode: '783373' },
  { value: 'dimowal', label: 'Dimowal', pincode: '783373' },
  { value: 'dudhnai', label: 'Dudhnai', pincode: '783373' },
  { value: 'kalibari', label: 'Kalibari', pincode: '783373' },
  { value: 'kamalsan', label: 'Kamalsan', pincode: '783373' },
  { value: 'kauwakhat', label: 'Kauwakhat', pincode: '783373' },
  { value: 'kherbari', label: 'Kherbari', pincode: '783373' },
  { value: 'kochpara', label: 'Kochpara', pincode: '783373' },
  { value: 'lakhimpur', label: 'Lakhimpur', pincode: '783373' },
  { value: 'mukalmua', label: 'Mukalmua', pincode: '783373' },
  { value: 'pachambari', label: 'Pachambari', pincode: '783373' },
  { value: 'salapara', label: 'Salapara', pincode: '783373' },
  { value: 'baligaon', label: 'Baligaon', pincode: '783373' },
  { value: 'baribari', label: 'Baribari', pincode: '783373' },
  { value: 'pangkati', label: 'Pangkati', pincode: '783373' },
  { value: 'rampur', label: 'Rampur', pincode: '783373' },
  { value: 'sorimukh', label: 'Sorimukh', pincode: '783373' },
  { value: 'tengabari', label: 'Tengabari', pincode: '783373' }
  ],
  
  'dhemaji': [
  { value: 'amreng', label: 'Amreng', pincode: '787057' },
  { value: 'balijan', label: 'Balijan', pincode: '787057' },
  { value: 'boronimoti', label: 'Boronimoti', pincode: '787057' },
  { value: 'dhemaji', label: 'Dhemaji', pincode: '787057' },
  { value: 'dumunichowki', label: 'Dumunichowki', pincode: '787057' },
  { value: 'katoni', label: 'Katoni', pincode: '787057' },
  { value: 'kulhati', label: 'Kulhati', pincode: '787057' },
  { value: 'lajpattia', label: 'Lajpattia', pincode: '787057' },
  { value: 'mariadom', label: 'Mariadom', pincode: '787057' },
  { value: 'mirigaon', label: 'Mirigaon', pincode: '787057' },
  { value: 'phulbari', label: 'Phulbari', pincode: '787057' },
  { value: 'sikhar', label: 'Sikhar', pincode: '787057' },
  { value: 'sisso', label: 'Sisso', pincode: '787057' },
  { value: 'sonapur', label: 'Sonapur', pincode: '787057' },
  { value: 'teok', label: 'Teok', pincode: '787057' },
  { value: 'berhampur', label: 'Berhampur', pincode: '787057' },
  { value: 'hatichung', label: 'Hatichung', pincode: '787057' },
  { value: 'jalukbari', label: 'Jalukbari', pincode: '787057' },
  { value: 'khetiapara', label: 'Khetiapara', pincode: '787057' },
  { value: 'morigaon', label: 'Morigaon', pincode: '787057' },
  { value: 'nakari', label: 'Nakari', pincode: '787057' },
  { value: 'rampur', label: 'Rampur', pincode: '787057' },
  { value: 'salapathar', label: 'Salapathar', pincode: '787057' },
  { value: 'simaluguri', label: 'Simaluguri', pincode: '787057' },
  { value: 'sundari', label: 'Sundari', pincode: '787057' },
  { value: 'tangla', label: 'Tangla', pincode: '787057' }
  ],
  
  'digboi': [
  { value: 'balaram', label: 'Balaram', pincode: '786171' },
  { value: 'bongmara', label: 'Bongmara', pincode: '786171' },
  { value: 'digboi', label: 'Digboi', pincode: '786171' },
  { value: 'dulungmukh', label: 'Dulungmukh', pincode: '786171' },
  { value: 'jorhat', label: 'Jorhat', pincode: '786171' },
  { value: 'jorhat-rly', label: 'Jorhat Rly', pincode: '786171' },
  { value: 'moran', label: 'Moran', pincode: '786171' },
  { value: 'mothola', label: 'Mothola', pincode: '786171' },
  { value: 'ramkham', label: 'Ramkham', pincode: '786171' },
  { value: 'rengon', label: 'Rengon', pincode: '786171' },
  { value: 'sonari', label: 'Sonari', pincode: '786171' },
  { value: 'tengakhat', label: 'Tengakhat', pincode: '786171' },
  { value: 'tinsukia', label: 'Tinsukia', pincode: '786171' },
  { value: 'bojali', label: 'Bojali', pincode: '786171' },
  { value: 'fukon', label: 'Fukon', pincode: '786171' },
  { value: 'gundumora', label: 'Gundumora', pincode: '786171' },
  { value: 'joypur', label: 'Joypur', pincode: '786171' },
  { value: 'madhupur', label: 'Madhupur', pincode: '786171' },
  { value: 'mulukga', label: 'Mulukga', pincode: '786171' },
  { value: 'phukan', label: 'Phukan', pincode: '786171' },
  { value: 'raomora', label: 'Raomora', pincode: '786171' },
  { value: 'sadiya', label: 'Sadiya', pincode: '786171' },
  { value: 'shibpur', label: 'Shibpur', pincode: '786171' }
  ],
  
  'diphu': [
  { value: 'adabari', label: 'Adabari', pincode: '782460' },
  { value: 'bhalukmari', label: 'Bhalukmari', pincode: '782460' },
  { value: 'diphu', label: 'Diphu', pincode: '782460' },
  { value: 'halflong', label: 'Halflong', pincode: '782460' },
  { value: 'harigaon', label: 'Harigaon', pincode: '782460' },
  { value: 'japon', label: 'Japon', pincode: '782460' },
  { value: 'khalihamari', label: 'Khalihamari', pincode: '782460' },
  { value: 'khatkhati', label: 'Khatkhati', pincode: '782460' },
  { value: 'kokilabari', label: 'Kokilabari', pincode: '782460' },
  { value: 'longnit', label: 'Longnit', pincode: '782460' },
  { value: 'manja', label: 'Manja', pincode: '782460' },
  { value: 'namdang', label: 'Namdang', pincode: '782460' },
  { value: 'pathar', label: 'Pathar', pincode: '782460' },
  { value: 'rikajuli', label: 'Rikajuli', pincode: '782460' },
  { value: 'tularam', label: 'Tularam', pincode: '782460' },
  { value: 'baghor', label: 'Baghor', pincode: '782460' },
  { value: 'bhalukpung', label: 'Bhalukpung', pincode: '782460' },
  { value: 'bokakhat', label: 'Bokakhat', pincode: '782460' },
  { value: 'dokmoka', label: 'Dokmoka', pincode: '782460' },
  { value: 'gillgaon', label: 'Gillgaon', pincode: '782460' },
  { value: 'kuchugaon', label: 'Kuchugaon', pincode: '782460' },
  { value: 'lakhipathar', label: 'Lakhipathar', pincode: '782460' },
  { value: 'namkha', label: 'Namkha', pincode: '782460' },
  { value: 'simaluguri', label: 'Simaluguri', pincode: '782460' },
  { value: 'tingkhong', label: 'Tingkhong', pincode: '782460' }
  ],
  
  'hajo': [
  { value: 'baliadangi', label: 'Baliadangi', pincode: '781101' },
  { value: 'gandhibari', label: 'Gandhibari', pincode: '781101' },
  { value: 'hajo', label: 'Hajo', pincode: '781101' },
  { value: 'japarkuchi', label: 'Japarkuchi', pincode: '781101' },
  { value: 'kamarkuchi', label: 'Kamarkuchi', pincode: '781101' },
  { value: 'khangkhoi', label: 'Khangkhoi', pincode: '781101' },
  { value: 'khatabari', label: 'Khatabari', pincode: '781101' },
  { value: 'laruachigaon', label: 'Laruachigaon', pincode: '781101' },
  { value: 'mordoi', label: 'Mordoi', pincode: '781101' },
  { value: 'murkuchi', label: 'Murkuchi', pincode: '781101' },
  { value: 'nizbari', label: 'Nizbari', pincode: '781101' },
  { value: 'sonapur', label: 'Sonapur', pincode: '781101' },
  { value: 'tangla', label: 'Tangla', pincode: '781101' },
  { value: 'bhakatpara', label: 'Bhakatpara', pincode: '781101' },
  { value: 'deodhai', label: 'Deodhai', pincode: '781101' },
  { value: 'ghagrapar', label: 'Ghagrapar', pincode: '781101' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '781101' },
  { value: 'khonaguri', label: 'Khonaguri', pincode: '781101' },
  { value: 'kumarpara', label: 'Kumarpara', pincode: '781101' },
  { value: 'sualkuchi', label: 'Sualkuchi', pincode: '781101' },
  { value: 'tengani', label: 'Tengani', pincode: '781101' }
  ],
  
  'haflong': [
  { value: 'badarpur', label: 'Badarpur', pincode: '788105' },
  { value: 'borkhola', label: 'Borkhola', pincode: '788105' },
  { value: 'halflong', label: 'Haflong', pincode: '788819' },
  { value: 'harinagar', label: 'Harinagar', pincode: '788105' },
  { value: 'kaki', label: 'Kaki', pincode: '788819' },
  { value: 'khatkhati', label: 'Khatkhati', pincode: '788819' },
  { value: 'lumding', label: 'Lumding', pincode: '788818' },
  { value: 'namrup', label: 'Namrup', pincode: '788818' },
  { value: 'shalang', label: 'Shalang', pincode: '788819' },
  { value: 'tinsukia', label: 'Tinsukia', pincode: '788819' },
  { value: 'tingrai', label: 'Tingrai', pincode: '788819' },
  { value: 'dongband', label: 'Dongband', pincode: '788105' },
  { value: 'dima-hasao', label: 'Dima Hasao', pincode: '788819' },
  { value: 'kalachara', label: 'Kalachara', pincode: '788105' },
  { value: 'maibang', label: 'Maibang', pincode: '788115' },
  { value: 'mikir-gaon', label: 'Mikir Gaon', pincode: '788819' },
  { value: 'umrangso', label: 'Umrangso', pincode: '788821' },
  { value: 'maharani', label: 'Maharani', pincode: '788105' },
  { value: 'silchar', label: 'Silchar', pincode: '788001' }
  ],
  
  'hojai': [
  { value: 'bhelowguri', label: 'Bhelowguri', pincode: '782435' },
  { value: 'hojai', label: 'Hojai', pincode: '782435' },
  { value: 'kathiatoli', label: 'Kathiatoli', pincode: '782435' },
  { value: 'khonamukh', label: 'Khonamukh', pincode: '782435' },
  { value: 'kurwai', label: 'Kurwai', pincode: '782435' },
  { value: 'lauri', label: 'Laury', pincode: '782435' },
  { value: 'longding', label: 'Longding', pincode: '782435' },
  { value: 'nokhuli', label: 'Nokhuli', pincode: '782435' },
  { value: 'pacharia', label: 'Pacharia', pincode: '782435' },
  { value: 'purani', label: 'Purani', pincode: '782435' },
  { value: 'rangamatia', label: 'Rangamatia', pincode: '782435' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '782435' },
  { value: 'tapowan', label: 'Tapowan', pincode: '782435' },
  { value: 'tengapukhuri', label: 'Tengapukhuri', pincode: '782435' },
  { value: 'bajali', label: 'Bajali', pincode: '782435' },
  { value: 'belona', label: 'Belona', pincode: '782435' },
  { value: 'johatia', label: 'Johatia', pincode: '782435' },
  { value: 'kaliabhomora', label: 'Kaliabhomora', pincode: '782435' },
  { value: 'nangalbari', label: 'Nangalbari', pincode: '782435' },
  { value: 'patharkandi', label: 'Patharkandi', pincode: '782435' },
  { value: 'sarupathar', label: 'Sarupathar', pincode: '782435' },
  { value: 'semkhor', label: 'Semkhor', pincode: '782435' }
  ],
  
  'hailakandi': [
  { value: 'adabari', label: 'Adabari', pincode: '788151' },
  { value: 'barkanduli', label: 'Barkanduli', pincode: '788151' },
  { value: 'bengalipara', label: 'Bengalipara', pincode: '788151' },
  { value: 'buxar', label: 'Buxar', pincode: '788151' },
  { value: 'hailakandi', label: 'Hailakandi', pincode: '788151' },
  { value: 'katlicherra', label: 'Katlicherra', pincode: '788157' },
  { value: 'khasipur', label: 'Khasipur', pincode: '788151' },
  { value: 'lajumajum', label: 'Lajumajum', pincode: '788151' },
  { value: 'madhurbond', label: 'Madhurbond', pincode: '788151' },
  { value: 'narupara', label: 'Narupara', pincode: '788151' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '788151' },
  { value: 'sailakupa', label: 'Sailakupa', pincode: '788151' },
  { value: 'shambhuganj', label: 'Shambhuganj', pincode: '788151' },
  { value: 'tangani', label: 'Tangani', pincode: '788151' },
  { value: 'tinsukia', label: 'Tinsukia', pincode: '788151' },
  { value: 'bhogpur', label: 'Bhogpur', pincode: '788157' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '788151' },
  { value: 'duganj', label: 'Duganji', pincode: '788151' },
  { value: 'jaigir', label: 'Jaigir', pincode: '788151' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '788151' },
  { value: 'mothabari', label: 'Mothabari', pincode: '788151' },
  { value: 'purbapara', label: 'Purbapara', pincode: '788151' },
  { value: 'santipur', label: 'Santipur', pincode: '788151' }
  ],
  
  'jatinga': [
  { value: 'angratoli', label: 'Angratoli', pincode: '788151' },
  { value: 'jatinga', label: 'Jatinga', pincode: '788152' },
  { value: 'jatinga-dormain', label: 'Jatinga Dormain', pincode: '788151' },
  { value: 'kathalguri', label: 'Kathalguri', pincode: '788151' },
  { value: 'nagaon', label: 'Nagaon', pincode: '788151' },
  { value: 'puroni', label: 'Puroni', pincode: '788151' },
  { value: 'rengbeng', label: 'Rengbeng', pincode: '788151' },
  { value: 'singlong', label: 'Singlong', pincode: '788151' },
  { value: 'sukali', label: 'Sukali', pincode: '788151' },
  { value: 'tirap', label: 'Tirap', pincode: '788151' },
  { value: 'amchong', label: 'Amchong', pincode: '788151' },
  { value: 'bangalpukhuri', label: 'Bangalpukhuri', pincode: '788151' },
  { value: 'balijan', label: 'Balijan', pincode: '788151' },
  { value: 'khatkhati', label: 'Khatkhati', pincode: '788151' },
  { value: 'longoijan', label: 'Longoijan', pincode: '788151' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '788151' },
  { value: 'nepali-basti', label: 'Nepali Basti', pincode: '788151' },
  { value: 'phuloni', label: 'Phuloni', pincode: '788151' },
  { value: 'tengapathar', label: 'Tengapathar', pincode: '788151' }
  ],
  
  'jogighopa': [
  { value: 'bajengdoba', label: 'Bajengdoba', pincode: '783380' },
  { value: 'baligaon', label: 'Baligaon', pincode: '783380' },
  { value: 'betbari', label: 'Betbari', pincode: '783380' },
  { value: 'borkhuti', label: 'Borkhuti', pincode: '783380' },
  { value: 'jogighopa', label: 'Jogighopa', pincode: '783380' },
  { value: 'karmabari', label: 'Karmabari', pincode: '783380' },
  { value: 'kolajuli', label: 'Kolajuli', pincode: '783380' },
  { value: 'lakhimpur', label: 'Lakhimpur', pincode: '783380' },
  { value: 'mangaldai', label: 'Mangaldai', pincode: '783380' },
  { value: 'matiabari', label: 'Matiabari', pincode: '783380' },
  { value: 'ramjankati', label: 'Ramjankati', pincode: '783380' },
  { value: 'rupnagar', label: 'Rupnagar', pincode: '783380' },
  { value: 'santipur', label: 'Santipur', pincode: '783380' },
  { value: 'sikni', label: 'Sikni', pincode: '783380' },
  { value: 'sukhari', label: 'Sukhari', pincode: '783380' },
  { value: 'adabari', label: 'Adabari', pincode: '783381' },
  { value: 'azadnagar', label: 'Azadnagar', pincode: '783381' },
  { value: 'bagribari', label: 'Bagribari', pincode: '783381' },
  { value: 'bhatkuchi', label: 'Bhatkuchi', pincode: '783381' },
  { value: 'lalmati', label: 'Lalmati', pincode: '783381' },
  { value: 'mahabharat', label: 'Mahabharat', pincode: '783381' },
  { value: 'madhukuri', label: 'Madhukuri', pincode: '783381' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '783381' },
  { value: 'sonapur', label: 'Sonapur', pincode: '783381' }
  ],
  
  'kokrajhar': [
  { value: 'banargaon', label: 'Banargaon', pincode: '783344' },
  { value: 'bongaon', label: 'Bongaon', pincode: '783344' },
  { value: 'chakradharpur', label: 'Chakradharpur', pincode: '783344' },
  { value: 'kokrajhar', label: 'Kokrajhar', pincode: '783370' },
  { value: 'kuthibil', label: 'Kuthibil', pincode: '783344' },
  { value: 'mowamari', label: 'Mowamari', pincode: '783344' },
  { value: 'patarikuri', label: 'Patarikuri', pincode: '783344' },
  { value: 'rajbari', label: 'Rajbari', pincode: '783344' },
  { value: 'ramfalbill', label: 'Ramfalbill', pincode: '783344' },
  { value: 'rangapara', label: 'Rangapara', pincode: '783344' },
  { value: 'salakati', label: 'Salakati', pincode: '783344' },
  { value: 'sapkura', label: 'Sapkura', pincode: '783344' },
  { value: 'sardanga', label: 'Sardanga', pincode: '783344' },
  { value: 'sukhjora', label: 'Sukhjora', pincode: '783344' },
  { value: 'tulsibil', label: 'Tulsibil', pincode: '783344' },
  { value: 'amguri', label: 'Amguri', pincode: '783344' },
  { value: 'banglapara', label: 'Banglapara', pincode: '783344' },
  { value: 'bilasipara', label: 'Bilasipara', pincode: '783390' },
  { value: 'bongshijhora', label: 'Bongshijhora', pincode: '783344' },
  { value: 'dandapara', label: 'Dandapara', pincode: '783344' },
  { value: 'dudhnai', label: 'Dudhnai', pincode: '783344' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '783344' },
  { value: 'kaliabhomora', label: 'Kaliabhomora', pincode: '783344' },
  { value: 'santoshpur', label: 'Santoshpur', pincode: '783344' },
  { value: 'sukladhari', label: 'Sukladhari', pincode: '783344' }
  ],
  
  'lanka': [
  { value: 'balijan', label: 'Balijan', pincode: '782447' },
  { value: 'bhelowguri', label: 'Bhelowguri', pincode: '782447' },
  { value: 'bhutiachang', label: 'Bhutiachang', pincode: '782447' },
  { value: 'bortokhula', label: 'Bortokhula', pincode: '782447' },
  { value: 'lanka', label: 'Lanka', pincode: '782447' },
  { value: 'madhabnagar', label: 'Madhabnagar', pincode: '782447' },
  { value: 'merapara', label: 'Merapara', pincode: '782447' },
  { value: 'nagrijuli', label: 'Nagrijuli', pincode: '782447' },
  { value: 'patharuguri', label: 'Patharuguri', pincode: '782447' },
  { value: 'sankarpara', label: 'Sankarpara', pincode: '782447' },
  { value: 'sualkuchi', label: 'Sualkuchi', pincode: '782447' },
  { value: 'tazpur', label: 'Tazpur', pincode: '782447' },
  { value: 'tinkunia', label: 'Tinkunia', pincode: '782447' },
  { value: 'alipukhuri', label: 'Alipukhuri', pincode: '782447' },
  { value: 'bijni', label: 'Bijni', pincode: '782448' },
  { value: 'bochapara', label: 'Bochapara', pincode: '782447' },
  { value: 'burapathar', label: 'Burapathar', pincode: '782447' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '782447' },
  { value: 'dharmapur', label: 'Dharmapur', pincode: '782447' },
  { value: 'jatigaon', label: 'Jatigaon', pincode: '782447' },
  { value: 'jorguri', label: 'Jorguri', pincode: '782447' },
  { value: 'murapara', label: 'Murapara', pincode: '782447' },
  { value: 'na-pather', label: 'Na-Pather', pincode: '782447' },
  { value: 'santipur', label: 'Santipur', pincode: '782447' },
  { value: 'sivabari', label: 'Sivabari', pincode: '782447' }
  ],
  
  'maibang': [
  { value: 'amchang', label: 'Amchang', pincode: '782459' },
  { value: 'bakerjang', label: 'Bakerjang', pincode: '782459' },
  { value: 'borbil', label: 'Borbil', pincode: '782459' },
  { value: 'buri-cherra', label: 'Buri Cherra', pincode: '782459' },
  { value: 'japori', label: 'Japori', pincode: '782459' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '782459' },
  { value: 'maibang', label: 'Maibang', pincode: '782459' },
  { value: 'manubari', label: 'Manubari', pincode: '782459' },
  { value: 'monipur', label: 'Monipur', pincode: '782459' },
  { value: 'patharkandi', label: 'Patharkandi', pincode: '782459' },
  { value: 'sadarbari', label: 'Sadarbari', pincode: '782459' },
  { value: 'satpukhuri', label: 'Satpukhuri', pincode: '782459' },
  { value: 'tingrai', label: 'Tingrai', pincode: '782459' },
  { value: 'ulupani', label: 'Ulupani', pincode: '782459' },
  { value: 'wangbal', label: 'Wangbal', pincode: '782459' }
  ],
  
  'mankachar': [
  { value: 'balijana', label: 'Balijana', pincode: '783135' },
  { value: 'barakpur', label: 'Barakpur', pincode: '783135' },
  { value: 'bilasipara', label: 'Bilasipara', pincode: '783131' },
  { value: 'chakla', label: 'Chakla', pincode: '783135' },
  { value: 'kherbari', label: 'Kherbari', pincode: '783135' },
  { value: 'kumarpara', label: 'Kumarpara', pincode: '783135' },
  { value: 'mankachar', label: 'Mankachar', pincode: '783135' },
  { value: 'morigaon', label: 'Morigaon', pincode: '783135' },
  { value: 'purani-kachari', label: 'Purani Kachari', pincode: '783135' },
  { value: 'satkuta', label: 'Satkuta', pincode: '783135' },
  { value: 'shuklapur', label: 'Shuklapur', pincode: '783135' },
  { value: 'simlaguri', label: 'Simlaguri', pincode: '783135' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '783135' },
  { value: 'tonkuri', label: 'Tonkuri', pincode: '783135' },
  { value: 'vijaynagar', label: 'Vijaynagar', pincode: '783135' }
  ],
  
  'mariani': [
  { value: 'amguri', label: 'Amguri', pincode: '785634' },
  { value: 'bhalukmari', label: 'Bhalukmari', pincode: '785634' },
  { value: 'buridoloni', label: 'Buridoloni', pincode: '785634' },
  { value: 'charaideo', label: 'Charaideo', pincode: '785634' },
  { value: 'dokmoka', label: 'Dokmoka', pincode: '785634' },
  { value: 'garampani', label: 'Garampani', pincode: '785634' },
  { value: 'gohain', label: 'Gohain', pincode: '785634' },
  { value: 'jakhalabandha', label: 'Jakhalabandha', pincode: '785634' },
  { value: 'jengraimukh', label: 'Jengraimukh', pincode: '785634' },
  { value: 'luhitpar', label: 'Luhitpar', pincode: '785634' },
  { value: 'mariani', label: 'Mariani', pincode: '785634' },
  { value: 'mohonguri', label: 'Mohonguri', pincode: '785634' },
  { value: 'naginijan', label: 'Naginijan', pincode: '785634' },
  { value: 'nizarapathar', label: 'Nizarapathar', pincode: '785634' },
  { value: 'salbari', label: 'Salbari', pincode: '785634' },
  { value: 'saring', label: 'Saring', pincode: '785634' },
  { value: 'sonari', label: 'Sonari', pincode: '785634' },
  { value: 'sulia', label: 'Sulia', pincode: '785634' },
  { value: 'tangla', label: 'Tangla', pincode: '785634' },
  { value: 'thakurbari', label: 'Thakurbari', pincode: '785634' }
  ],
  
  'moranhat': [
  { value: 'amguri', label: 'Amguri', pincode: '785670' },
  { value: 'balijan', label: 'Balijan', pincode: '785670' },
  { value: 'barpathar', label: 'Barpathar', pincode: '785670' },
  { value: 'dholchhara', label: 'Dholchhara', pincode: '785670' },
  { value: 'ghograpar', label: 'Ghograpar', pincode: '785670' },
  { value: 'jorewagra', label: 'Jorewagra', pincode: '785670' },
  { value: 'moranhat', label: 'Moranhat', pincode: '785670' },
  { value: 'nizbari', label: 'Nizbari', pincode: '785670' },
  { value: 'puroni-bari', label: 'Puroni Bari', pincode: '785670' },
  { value: 'sitalmari', label: 'Sitalmari', pincode: '785670' },
  { value: 'sonari', label: 'Sonari', pincode: '785670' },
  { value: 'sunsari', label: 'Sunsari', pincode: '785670' },
  { value: 'surjapur', label: 'Surjapur', pincode: '785670' },
  { value: 'hatidura', label: 'Hatidura', pincode: '785670' },
  { value: 'jatial', label: 'Jatial', pincode: '785670' },
  { value: 'khuwabari', label: 'Khuwabari', pincode: '785670' },
  { value: 'lakhipur', label: 'Lakhipur', pincode: '785670' },
  { value: 'phuloni', label: 'Phuloni', pincode: '785670' },
  { value: 'rangagora', label: 'Rangagora', pincode: '785670' },
  { value: 'sodari', label: 'Sodari', pincode: '785670' }
  ],
  
  'morigaon': [
  { value: 'amjonga', label: 'Amjonga', pincode: '782120' },
  { value: 'bakhari', label: 'Bakhari', pincode: '782120' },
  { value: 'barpeta', label: 'Barpeta', pincode: '782120' },
  { value: 'bhurbandha', label: 'Bhurbandha', pincode: '782120' },
  { value: 'bihpuria', label: 'Bihpuria', pincode: '782120' },
  { value: 'jorhat', label: 'Jorhat', pincode: '782120' },
  { value: 'kamari', label: 'Kamari', pincode: '782120' },
  { value: 'kharupetia', label: 'Kharupetia', pincode: '782120' },
  { value: 'morigaon', label: 'Morigaon', pincode: '782001' },
  { value: 'moran', label: 'Moran', pincode: '782120' },
  { value: 'nagaon', label: 'Nagaon', pincode: '782120' },
  { value: 'rahmapur', label: 'Rahmapur', pincode: '782120' },
  { value: 'rangamati', label: 'Rangamati', pincode: '782120' },
  { value: 'sadar', label: 'Sadar', pincode: '782120' },
  { value: 'sengapara', label: 'Sengapara', pincode: '782120' },
  { value: 'sukanta', label: 'Sukanta', pincode: '782120' },
  { value: 'dergaon', label: 'Dergaon', pincode: '782120' },
  { value: 'disangmukh', label: 'Disangmukh', pincode: '782120' },
  { value: 'gogamukh', label: 'Gogamukh', pincode: '782120' },
  { value: 'kakodonga', label: 'Kakodonga', pincode: '782120' },
  { value: 'khagori', label: 'Khagori', pincode: '782120' },
  { value: 'thengal', label: 'Thengal', pincode: '782120' }
  ],
  
  'mushalpur': [
  { value: 'baidara', label: 'Baidara', pincode: '781345' },
  { value: 'barama', label: 'Barama', pincode: '781345' },
  { value: 'ghubona', label: 'Ghubona', pincode: '781345' },
  { value: 'kaimur', label: 'Kaimur', pincode: '781345' },
  { value: 'lakhimpur', label: 'Lakhimpur', pincode: '781345' },
  { value: 'mushalpur', label: 'Mushalpur', pincode: '781345' },
  { value: 'nalbari', label: 'Nalbari', pincode: '781345' },
  { value: 'sialmari', label: 'Sialmari', pincode: '781345' },
  { value: 'sivdola', label: 'Sivdola', pincode: '781345' },
  { value: 'pandu', label: 'Pandu', pincode: '781345' },
  { value: 'sorbhog', label: 'Sorbhog', pincode: '781345' },
  { value: 'kakra', label: 'Kakra', pincode: '781345' },
  { value: 'balipara', label: 'Balipara', pincode: '781345' },
  { value: 'bentur', label: 'Bentur', pincode: '781345' },
  { value: 'berpeta', label: 'Berpeta', pincode: '781345' },
  { value: 'tihu', label: 'Tihu', pincode: '781345' },
  { value: 'patabari', label: 'Patabari', pincode: '781345' },
  { value: 'chambhaguri', label: 'Chambhaguri', pincode: '781345' }
  ],
  
  'nagaon': [
  { value: 'adabari', label: 'Adabari', pincode: '782003' },
  { value: 'bahdali', label: 'Bahdali', pincode: '782003' },
  { value: 'bhurbandha', label: 'Bhurbandha', pincode: '782003' },
  { value: 'chapanala', label: 'Chapanala', pincode: '782003' },
  { value: 'dhing', label: 'Dhing', pincode: '782123' },
  { value: 'gogamukh', label: 'Gogamukh', pincode: '782003' },
  { value: 'kapili', label: 'Kapili', pincode: '782003' },
  { value: 'khagori', label: 'Khagori', pincode: '782003' },
  { value: 'lakhipur', label: 'Lakhipur', pincode: '782003' },
  { value: 'morigaon', label: 'Morigaon', pincode: '782001' },
  { value: 'nagaon', label: 'Nagaon', pincode: '782001' },
  { value: 'puranigudam', label: 'Puranigudam', pincode: '782003' },
  { value: 'samaguri', label: 'Samaguri', pincode: '782003' },
  { value: 'sorbhog', label: 'Sorbhog', pincode: '782003' },
  { value: 'tinsukia', label: 'Tinsukia', pincode: '782003' },
  { value: 'upadhyaya', label: 'Upadhyaya', pincode: '782003' },
  { value: 'batadrava', label: 'Batadrava', pincode: '782128' },
  { value: 'bezera', label: 'Bezera', pincode: '782136' },
  { value: 'halakura', label: 'Halakura', pincode: '782007' },
  { value: 'juria', label: 'Juria', pincode: '782131' },
  { value: 'kaliabor', label: 'Kaliabor', pincode: '782137' },
  { value: 'kathiatoli', label: 'Kathiatoli', pincode: '782107' },
  { value: 'koliabor', label: 'Koliabor', pincode: '782130' },
  { value: 'krishnai', label: 'Krishnai', pincode: '782115' },
  { value: 'mikirbheta', label: 'Mikirbheta', pincode: '782001' },
  { value: 'morom', label: 'Morom', pincode: '782103' }
  ],
  
  'nalbari': [
  { value: 'adabari', label: 'Adabari', pincode: '781341' },
  { value: 'barbhag', label: 'Barbhag', pincode: '781341' },
  { value: 'bengbari', label: 'Bengbari', pincode: '781341' },
  { value: 'bhalkat', label: 'Bhalkat', pincode: '781341' },
  { value: 'bhubangari', label: 'Bhubangari', pincode: '781341' },
  { value: 'bhojkuchi', label: 'Bhojkuchi', pincode: '781341' },
  { value: 'bongora', label: 'Bongora', pincode: '781341' },
  { value: 'chalakura', label: 'Chalakura', pincode: '781341' },
  { value: 'nalbari', label: 'Nalbari', pincode: '781335' },
  { value: 'nayanpur', label: 'Nayanpur', pincode: '781341' },
  { value: 'saikia', label: 'Saikia', pincode: '781341' },
  { value: 'saliahati', label: 'Saliahati', pincode: '781341' },
  { value: 'sankardev', label: 'Sankardev', pincode: '781341' },
  { value: 'sorbhog', label: 'Sorbhog', pincode: '781345' },
  { value: 'tihu', label: 'Tihu', pincode: '781365' },
  { value: 'upadhyaya', label: 'Upadhyaya', pincode: '781341' },
  { value: 'zoo-para', label: 'Zoo Para', pincode: '781341' },
  { value: 'bilashipara', label: 'Bilashipara', pincode: '781338' },
  { value: 'bindukuri', label: 'Bindukuri', pincode: '781341' },
  { value: 'bochagaon', label: 'Bochagaon', pincode: '781341' },
  { value: 'dharapur', label: 'Dharapur', pincode: '781341' },
  { value: 'jantola', label: 'Jantola', pincode: '781341' },
  { value: 'kuchmaria', label: 'Kuchmaria', pincode: '781341' },
  { value: 'manikpur', label: 'Manikpur', pincode: '781341' },
  { value: 'mirzapur', label: 'Mirzapur', pincode: '781341' },
  { value: 'salarpara', label: 'Salarpara', pincode: '781341' }
  ],
  
  'nazira': [
  { value: 'bhuragaon', label: 'Bhuragaon', pincode: '785685' },
  { value: 'borkathani', label: 'Borkathani', pincode: '785685' },
  { value: 'jogijan', label: 'Jogijan', pincode: '785685' },
  { value: 'kaliapathar', label: 'Kaliapathar', pincode: '785685' },
  { value: 'kahibari', label: 'Kahibari', pincode: '785685' },
  { value: 'kharika', label: 'Kharika', pincode: '785685' },
  { value: 'kherbari', label: 'Kherbari', pincode: '785685' },
  { value: 'khorahat', label: 'Khorahat', pincode: '785685' },
  { value: 'nazira', label: 'Nazira', pincode: '785685' },
  { value: 'niz-nazira', label: 'Niz Nazira', pincode: '785685' },
  { value: 'panchmile', label: 'Panchmile', pincode: '785685' },
  { value: 'rampur', label: 'Rampur', pincode: '785685' },
  { value: 'silapathar', label: 'Silapathar', pincode: '785685' },
  { value: 'sundarbari', label: 'Sundarbari', pincode: '785685' },
  { value: 'dergaon', label: 'Dergaon', pincode: '785614' },
  { value: 'digboi', label: 'Digboi', pincode: '785601' },
  { value: 'mukhurigaon', label: 'Mukhurigaon', pincode: '785685' },
  { value: 'morikolong', label: 'Morikolong', pincode: '785685' },
  { value: 'sadia', label: 'Sadia', pincode: '785684' },
  { value: 'sapphram', label: 'Sapphram', pincode: '785684' }
  ],
  
  'pathsala': [
  { value: 'banskati', label: 'Banskati', pincode: '781325' },
  { value: 'bihpuria', label: 'Bihpuria', pincode: '781325' },
  { value: 'charaideo', label: 'Charaideo', pincode: '781325' },
  { value: 'damdama', label: 'Damdama', pincode: '781325' },
  { value: 'ghonigaon', label: 'Ghonigaon', pincode: '781325' },
  { value: 'kochpara', label: 'Kochpara', pincode: '781325' },
  { value: 'kothalguri', label: 'Kothalguri', pincode: '781325' },
  { value: 'madhapur', label: 'Madhapur', pincode: '781325' },
  { value: 'pathsala', label: 'Pathsala', pincode: '781325' },
  { value: 'pahumara', label: 'Pahumara', pincode: '781325' },
  { value: 'rajaram', label: 'Rajarama', pincode: '781325' },
  { value: 'sontoli', label: 'Sontoli', pincode: '781325' },
  { value: 'sukhigaon', label: 'Sukhigaon', pincode: '781325' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '781325' },
  { value: 'nalbari', label: 'Nalbari', pincode: '781335' },
  { value: 'srirampur', label: 'Srirampur', pincode: '781335' },
  { value: 'sankarjyoti', label: 'Sankarjyoti', pincode: '781325' },
  { value: 'khairkata', label: 'Khairkata', pincode: '781325' },
  { value: 'bhutmari', label: 'Bhutmari', pincode: '781325' },
  { value: 'lalmati', label: 'Lalmati', pincode: '781325' }
  ],
  
  'sonari': [
  { value: 'amguri', label: 'Amguri', pincode: '785690' },
  { value: 'balijan', label: 'Balijan', pincode: '785690' },
  { value: 'bihpuria', label: 'Bihpuria', pincode: '785690' },
  { value: 'darga', label: 'Darga', pincode: '785690' },
  { value: 'kamakhya', label: 'Kamakhya', pincode: '785690' },
  { value: 'kuliya', label: 'Kuliya', pincode: '785690' },
  { value: 'madhupur', label: 'Madhupur', pincode: '785690' },
  { value: 'monai', label: 'Monai', pincode: '785690' },
  { value: 'pathari', label: 'Pathari', pincode: '785690' },
  { value: 'sonari', label: 'Sonari', pincode: '785690' },
  { value: 'sudhiyadi', label: 'Sudhiyadi', pincode: '785690' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '785690' },
  { value: 'tulapur', label: 'Tulapur', pincode: '785690' },
  { value: 'ulubari', label: 'Ulubari', pincode: '785690' },
  { value: 'jampani', label: 'Jampani', pincode: '785690' },
  { value: 'jatan', label: 'Jatan', pincode: '785690' },
  { value: 'kathalgaon', label: 'Kathalgaon', pincode: '785690' }
  ],
  
  'sonitpur': [
  { value: 'abbasapur', label: 'Abbasapur', pincode: '784001' },
  { value: 'bakeka', label: 'Bakeka', pincode: '784002' },
  { value: 'balipara', label: 'Balipara', pincode: '784101' },
  { value: 'batabari', label: 'Batabari', pincode: '784102' },
  { value: 'bhalukmari', label: 'Bhalukmari', pincode: '784143' },
  { value: 'bihpuria', label: 'Bihpuria', pincode: '784154' },
  { value: 'dhekiajuli', label: 'Dhekiajuli', pincode: '784110' },
  { value: 'gaon', label: 'Gaon', pincode: '784147' },
  { value: 'gharbara', label: 'Gharbara', pincode: '784003' },
  { value: 'jaljali', label: 'Jaljali', pincode: '784144' },
  { value: 'kothia', label: 'Kothia', pincode: '784105' },
  { value: 'mahali', label: 'Mahali', pincode: '784125' },
  { value: 'mao', label: 'Mao', pincode: '784150' },
  { value: 'meleng', label: 'Meleng', pincode: '784152' },
  { value: 'pathar', label: 'Pathar', pincode: '784160' },
  { value: 'sonitpur', label: 'Sonitpur', pincode: '784001' },
  { value: 'tezpur', label: 'Tezpur', pincode: '784001' },
  { value: 'barpothia', label: 'Barpothia', pincode: '784144' },
  { value: 'biroj', label: 'Biroj', pincode: '784112' },
  { value: 'bharalumukh', label: 'Bharalumukh', pincode: '784155' },
  { value: 'chapari', label: 'Chapari', pincode: '784126' },
  { value: 'kaharpara', label: 'Kaharpara', pincode: '784138' },
  { value: 'khairabari', label: 'Khairabari', pincode: '784141' },
  { value: 'makhiyal', label: 'Makhiyal', pincode: '784119' }
  ],
  
  'teok': [
  { value: 'bajali', label: 'Bajali', pincode: '785106' },
  { value: 'chandmari', label: 'Chandmari', pincode: '785126' },
  { value: 'harigaon', label: 'Harigaon', pincode: '785101' },
  { value: 'jalukonibari', label: 'Jalukonibari', pincode: '785125' },
  { value: 'kampur', label: 'Kampur', pincode: '785104' },
  { value: 'kachari', label: 'Kachari', pincode: '785103' },
  { value: 'makum', label: 'Makum', pincode: '785121' },
  { value: 'mehman', label: 'Mehman', pincode: '785111' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '785124' },
  { value: 'teok', label: 'Teok', pincode: '785101' },
  { value: 'tedong', label: 'Tedong', pincode: '785122' },
  { value: 'tupkhana', label: 'Tupkhana', pincode: '785107' },
  { value: 'disangmukh', label: 'Disangmukh', pincode: '785108' },
  { value: 'ghogomari', label: 'Ghogomari', pincode: '785115' },
  { value: 'koliapani', label: 'Koliapani', pincode: '785118' },
  { value: 'moridhal', label: 'Moridhal', pincode: '785120' },
  { value: 'sarupathar', label: 'Sarupathar', pincode: '785128' },
  { value: 'sadiya', label: 'Sadiya', pincode: '785129' }
  ],
  
  'tihu': [
  { value: 'borkhola', label: 'Borkhola', pincode: '785640' },
  { value: 'bunjani', label: 'Bunjani', pincode: '785602' },
  { value: 'ghugurapathar', label: 'Ghugurapathar', pincode: '785620' },
  { value: 'kalag', label: 'Kalag', pincode: '785608' },
  { value: 'kajalimukh', label: 'Kajalimukh', pincode: '785615' },
  { value: 'kamarbandha', label: 'Kamarbandha', pincode: '785617' },
  { value: 'khagori', label: 'Khagori', pincode: '785614' },
  { value: 'muguri', label: 'Muguri', pincode: '785616' },
  { value: 'rangia', label: 'Rangia', pincode: '781354' },
  { value: 'saphai', label: 'Saphai', pincode: '785611' },
  { value: 'sariha', label: 'Sariha', pincode: '785612' },
  { value: 'tihu', label: 'Tihu', pincode: '785640' },
  { value: 'manikpur', label: 'Manikpur', pincode: '785636' },
  { value: 'suguri', label: 'Suguri', pincode: '785645' },
  { value: 'noonmati', label: 'Noonmati', pincode: '785625' },
  { value: 'padharpukhuri', label: 'Padharpukhuri', pincode: '785618' }
  ],
  
  'titabar': [
  { value: 'barhampur', label: 'Barhampur', pincode: '785620' },
  { value: 'borkhola', label: 'Borkhola', pincode: '785623' },
  { value: 'jubarajbari', label: 'Jubarajbari', pincode: '785622' },
  { value: 'kalpataru', label: 'Kalpataru', pincode: '785635' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '785625' },
  { value: 'madhabnagar', label: 'Madhabnagar', pincode: '785634' },
  { value: 'pachimpathar', label: 'Pachimpathar', pincode: '785631' },
  { value: 'ranganadi', label: 'Ranganadi', pincode: '785641' },
  { value: 'simaluguri', label: 'Simaluguri', pincode: '785626' },
  { value: 'titabar', label: 'Titabar', pincode: '785640' },
  { value: 'tularam', label: 'Tularam', pincode: '785632' },
  { value: 'zoo', label: 'Zoo', pincode: '785636' },
  { value: 'holongapar', label: 'Holongapar', pincode: '785633' },
  { value: 'chakbandha', label: 'Chakbandha', pincode: '785624' }
  ],
  
  'udalguri': [
  { value: 'bajali', label: 'Bajali', pincode: '784514' },
  { value: 'borthali', label: 'Borthali', pincode: '784526' },
  { value: 'chungajan', label: 'Chungajan', pincode: '784530' },
  { value: 'dhekiajuli', label: 'Dhekiajuli', pincode: '784503' },
  { value: 'dhaijan', label: 'Dhaijan', pincode: '784512' },
  { value: 'dokmoka', label: 'Dokmoka', pincode: '784510' },
  { value: 'dudunijuri', label: 'Dudunijuri', pincode: '784528' },
  { value: 'ghogora', label: 'Ghogora', pincode: '784532' },
  { value: 'gohpur', label: 'Gohpur', pincode: '784176' },
  { value: 'jalah', label: 'Jalah', pincode: '784528' },
  { value: 'jaljali', label: 'Jaljali', pincode: '784505' },
  { value: 'kaithalkuchi', label: 'Kaithalkuchi', pincode: '784514' },
  { value: 'kharupetia', label: 'Kharupetia', pincode: '784159' },
  { value: 'kushdhowa', label: 'Kushdhowa', pincode: '784516' },
  { value: 'mandal', label: 'Mandal', pincode: '784504' },
  { value: 'pathalgaon', label: 'Pathalgaon', pincode: '784511' },
  { value: 'udalguri', label: 'Udalguri', pincode: '784509' },
  { value: 'bherbheri', label: 'Bherbheri', pincode: '784527' },
  { value: 'chowkham', label: 'Chowkham', pincode: '784525' },
  { value: 'heralung', label: 'Heralung', pincode: '784520' },
  { value: 'kolongpar', label: 'Kolongpar', pincode: '784505' },
  { value: 'north-kharupetia', label: 'North Kharupetia', pincode: '784158' }
  ],
  
  'lakhipur': [
  { value: 'baihata', label: 'Baihata', pincode: '782446' },
  { value: 'bihpuria', label: 'Bihpuria', pincode: '782462' },
  { value: 'dakhin-melajan', label: 'Dakhin Melajan', pincode: '782458' },
  { value: 'lakhipur', label: 'Lakhipur', pincode: '782447' },
  { value: 'mahatari', label: 'Mahatari', pincode: '782462' },
  { value: 'nagaon', label: 'Nagaon', pincode: '782461' },
  { value: 'palasbari', label: 'Palasbari', pincode: '782449' },
  { value: 'tengakhat', label: 'Tengakhat', pincode: '782450' },
  { value: 'undang', label: 'Undang', pincode: '782451' },
  { value: 'rathipur', label: 'Rathipur', pincode: '782454' }
  ],
  
  'bilasipara': [
  { value: 'bilasipara', label: 'Bilasipara', pincode: '783348' },
  { value: 'dharmapur', label: 'Dharmapur', pincode: '783346' },
  { value: 'golakganj', label: 'Golakganj', pincode: '783348' },
  { value: 'jalukbari', label: 'Jalukbari', pincode: '783344' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '783353' },
  { value: 'moukhuli', label: 'Moukhuli', pincode: '783349' },
  { value: 'rangia', label: 'Rangia', pincode: '783354' },
  { value: 'salguri', label: 'Salguri', pincode: '783352' },
  { value: 'tihu', label: 'Tihu', pincode: '783355' },
  { value: 'ulubari', label: 'Ulubari', pincode: '783350' }
  ],
  
  'lumding': [
  { value: 'bihpuria', label: 'Bihpuria', pincode: '782447' },
  { value: 'bojali', label: 'Bojali', pincode: '782447' },
  { value: 'lumding', label: 'Lumding', pincode: '782447' },
  { value: 'mohura', label: 'Mohura', pincode: '782447' },
  { value: 'nagaon', label: 'Nagaon', pincode: '782447' },
  { value: 'nalbari', label: 'Nalbari', pincode: '782447' },
  { value: 'north-lumding', label: 'North Lumding', pincode: '782447' },
  { value: 'paharigaon', label: 'Paharigaon', pincode: '782447' },
  { value: 'south-lumding', label: 'South Lumding', pincode: '782447' },
  { value: 'baralimari', label: 'Baralimari', pincode: '782447' },
  { value: 'changma', label: 'Changma', pincode: '782447' },
  { value: 'kochugaon', label: 'Kochugaon', pincode: '782447' },
  { value: 'nepali-basti', label: 'Nepali Basti', pincode: '782447' },
  { value: 'rajamukhi', label: 'Rajamukhi', pincode: '782447' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '782447' }
  ],
  
  'silchar': [
  { value: 'admangpur', label: 'Admangpur', pincode: '788001' },
  { value: 'baliabill', label: 'Baliabill', pincode: '788001' },
  { value: 'baraljuri', label: 'Baraljuri', pincode: '788001' },
  { value: 'darbeshnagar', label: 'Darbeshnagar', pincode: '788001' },
  { value: 'fatikchhara', label: 'Fatikchhara', pincode: '788004' },
  { value: 'karimganj-road', label: 'Karimganj Road', pincode: '788005' },
  { value: 'matinagar', label: 'Matinagar', pincode: '788003' },
  { value: 'monacherra', label: 'Monacherra', pincode: '788014' },
  { value: 'nemuikhali', label: 'Nemuikhali', pincode: '788014' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '788007' },
  { value: 'sonai', label: 'Sonai', pincode: '788020' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '788015' },
  { value: 'kumarpara', label: 'Kumarpara', pincode: '788008' },
  { value: 'golepara', label: 'Golepara', pincode: '788011' },
  { value: 'panchgram', label: 'Panchgram', pincode: '788120' }
  ],
  
  'palasbari': [
  { value: 'balipara', label: 'Balipara', pincode: '781366' },
  { value: 'borkhata', label: 'Borkhata', pincode: '781352' },
  { value: 'deorigaon', label: 'Deorigaon', pincode: '781352' },
  { value: 'gopalbari', label: 'Gopalbari', pincode: '781366' },
  { value: 'jalah', label: 'Jalah', pincode: '781352' },
  { value: 'khatkhati', label: 'Khatkhati', pincode: '781366' },
  { value: 'kothari', label: 'Kothari', pincode: '781352' },
  { value: 'moina', label: 'Moina', pincode: '781366' },
  { value: 'palasbari-town', label: 'Palasbari Town', pincode: '781366' },
  { value: 'sujanbari', label: 'Sujanbari', pincode: '781366' },
  { value: 'hatipara', label: 'Hatipara', pincode: '781352' },
  { value: 'teok', label: 'Teok', pincode: '781367' },
  { value: 'borjhar', label: 'Borjhar', pincode: '781366' },
  { value: 'kokilamukh', label: 'Kokilamukh', pincode: '781366' },
  { value: 'ranipukhuri', label: 'Ranipukhuri', pincode: '781352' },
  { value: 'sahar', label: 'Sahar', pincode: '781366' },
  { value: 'kaliabar', label: 'Kaliabar', pincode: '781366' }
  ],
  
  'doom-dooma': [
  { value: 'boha', label: 'Boha', pincode: '786150' },
  { value: 'chokihola', label: 'Chokihola', pincode: '786150' },
  { value: 'doorgokhana', label: 'Doorgokhana', pincode: '786150' },
  { value: 'doomdooma-town', label: 'Doomdooma Town', pincode: '786151' },
  { value: 'hatisola', label: 'Hatisola', pincode: '786150' },
  { value: 'kathalguri', label: 'Kathalguri', pincode: '786150' },
  { value: 'lakoigaon', label: 'Lakoigaon', pincode: '786150' },
  { value: 'mohgram', label: 'Mohgram', pincode: '786150' },
  { value: 'rangajan', label: 'Rangajan', pincode: '786150' },
  { value: 'sukhamoypur', label: 'Sukhamoypur', pincode: '786150' },
  { value: 'teok', label: 'Teok', pincode: '786150' },
  { value: 'tinali', label: 'Tinali', pincode: '786150' },
  { value: 'barpatia', label: 'Barpatia', pincode: '786150' },
  { value: 'changma', label: 'Changma', pincode: '786150' },
  { value: 'dihar', label: 'Dihar', pincode: '786150' },
  { value: 'johran', label: 'Johran', pincode: '786150' },
  { value: 'kakilamukh', label: 'Kakilamukh', pincode: '786150' },
  { value: 'kajalgaon', label: 'Kajalgaon', pincode: '786150' },
  { value: 'morai', label: 'Morai', pincode: '786150' },
  { value: 'mukalmua', label: 'Mukalmua', pincode: '786150' },
  { value: 'patharichuk', label: 'Patharichuk', pincode: '786150' },
  { value: 'tiribari', label: 'Tiribari', pincode: '786150' }
  ],
  
  'kharupetia': [
  { value: 'amguri', label: 'Amguri', pincode: '784145' },
  { value: 'balijan', label: 'Balijan', pincode: '784145' },
  { value: 'barkanda', label: 'Barkanda', pincode: '784145' },
  { value: 'bhakatpara', label: 'Bhakatpara', pincode: '784145' },
  { value: 'borigaon', label: 'Borigaon', pincode: '784145' },
  { value: 'bunderia', label: 'Bunderia', pincode: '784145' },
  { value: 'kakodonga', label: 'Kakodonga', pincode: '784145' },
  { value: 'kharupetia-town', label: 'Kharupetia Town', pincode: '784145' },
  { value: 'khatangani', label: 'Khatangani', pincode: '784145' },
  { value: 'majbari', label: 'Majbari', pincode: '784145' },
  { value: 'manoharchuk', label: 'Manoharchuk', pincode: '784145' },
  { value: 'niz-jarabari', label: 'Niz Jarabari', pincode: '784145' },
  { value: 'patharighat', label: 'Patharighat', pincode: '784145' },
  { value: 'sarihapara', label: 'Sarihapara', pincode: '784145' },
  { value: 'silangpathar', label: 'Silangpathar', pincode: '784145' },
  { value: 'sunari', label: 'Sunari', pincode: '784145' },
  { value: 'tirual', label: 'Tirual', pincode: '784145' },
  { value: 'batabari', label: 'Batabari', pincode: '784145' },
  { value: 'samtal', label: 'Samtal', pincode: '784145' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '784145' },
  { value: 'nalbari-gaon', label: 'Nalbari Gaon', pincode: '784145' },
  { value: 'nangla', label: 'Nangla', pincode: '784145' },
  { value: 'mishra', label: 'Mishra', pincode: '784145' },
  { value: 'churang', label: 'Churang', pincode: '784145' }
  ],
  
  'rangapara': [
  { value: 'amarai', label: 'Amarai', pincode: '784505' },
  { value: 'baligaon', label: 'Baligaon', pincode: '784505' },
  { value: 'barubari', label: 'Barubari', pincode: '784505' },
  { value: 'buraburi', label: 'Buraburi', pincode: '784505' },
  { value: 'chapakhowa', label: 'Chapakhowa', pincode: '784505' },
  { value: 'dharmapathar', label: 'Dharmapathar', pincode: '784505' },
  { value: 'kakoi', label: 'Kakoi', pincode: '784505' },
  { value: 'kamarbari', label: 'Kamarbari', pincode: '784505' },
  { value: 'kathalbari', label: 'Kathalbari', pincode: '784505' },
  { value: 'kothalgaon', label: 'Kothalgaon', pincode: '784505' },
  { value: 'lengtimari', label: 'Lengtimari', pincode: '784505' },
  { value: 'murkongselek', label: 'Murkongselek', pincode: '784505' },
  { value: 'namgaon', label: 'Namgaon', pincode: '784505' },
  { value: 'rangapara-town', label: 'Rangapara Town', pincode: '784505' },
  { value: 'sadar', label: 'Sadar', pincode: '784505' },
  { value: 'salmora', label: 'Salmora', pincode: '784505' },
  { value: 'sundarbari', label: 'Sundarbari', pincode: '784505' },
  { value: 'tetelikhuti', label: 'Tetelikhuti', pincode: '784505' },
  { value: 'tiroth', label: 'Tiroth', pincode: '784505' },
  { value: 'borkherabari', label: 'Borkherabari', pincode: '784505' },
  { value: 'deoshree', label: 'Deoshree', pincode: '784505' },
  { value: 'dhekiajuli', label: 'Dhekiajuli', pincode: '784503' },
  { value: 'damra', label: 'Damra', pincode: '784505' },
  { value: 'holakhan', label: 'Holakhan', pincode: '784505' },
  { value: 'jilangsiri', label: 'Jilangsiri', pincode: '784505' },
  { value: 'lakhipur', label: 'Lakhipur', pincode: '784505' },
  { value: 'niz-kothalgaon', label: 'Niz Kothalgaon', pincode: '784505' }
  ],
  
  'mangaldoi': [
  { value: 'ali-khata', label: 'Ali Khata', pincode: '784125' },
  { value: 'amkadhora', label: 'Amkadhora', pincode: '784125' },
  { value: 'badher-gaon', label: 'Badher Gaon', pincode: '784125' },
  { value: 'banbhag', label: 'Banbhag', pincode: '784125' },
  { value: 'barbari', label: 'Barbari', pincode: '784125' },
  { value: 'chandmari', label: 'Chandmari', pincode: '784125' },
  { value: 'fakharuddin-para', label: 'Fakharuddin Para', pincode: '784125' },
  { value: 'halem', label: 'Halem', pincode: '784125' },
  { value: 'hamranga', label: 'Hamranga', pincode: '784125' },
  { value: 'janaka', label: 'Janaka', pincode: '784125' },
  { value: 'khatkhati', label: 'Khatkhati', pincode: '784125' },
  { value: 'khandikar', label: 'Khandikar', pincode: '784125' },
  { value: 'kholapathar', label: 'Kholapathar', pincode: '784125' },
  { value: 'kongchua', label: 'Kongchua', pincode: '784125' },
  { value: 'mangaldoi-town', label: 'Mangaldoi Town', pincode: '784125' },
  { value: 'mandia', label: 'Mandia', pincode: '784125' },
  { value: 'mohamaya', label: 'Mohamaya', pincode: '784125' },
  { value: 'murkuchi', label: 'Murkuchi', pincode: '784125' },
  { value: 'namoni', label: 'Namoni', pincode: '784125' },
  { value: 'rangapara', label: 'Rangapara', pincode: '784125' },
  { value: 'salmora', label: 'Salmora', pincode: '784125' },
  { value: 'samaguri', label: 'Samaguri', pincode: '784125' },
  { value: 'sankardev-nagar', label: 'Sankardev Nagar', pincode: '784125' },
  { value: 'sonapur', label: 'Sonapur', pincode: '784125' },
  { value: 'sorabhaga', label: 'Sorabhaga', pincode: '784125' },
  { value: 'tekeliapara', label: 'Tekeliapara', pincode: '784125' },
  { value: 'tikania', label: 'Tikania', pincode: '784125' },
  { value: 'tulungia', label: 'Tulungia', pincode: '784125' },
  { value: 'bhanukula', label: 'Bhanukula', pincode: '784125' },
  { value: 'bahadurpur', label: 'Bahadurpur', pincode: '784125' },
  { value: 'janpar', label: 'Janpar', pincode: '784125' },
  { value: 'pachali', label: 'Pachali', pincode: '784125' },
  { value: 'sundaridang', label: 'Sundaridang', pincode: '784125' }
  ],
  
  'dhekiajuli': [
  { value: 'adabari', label: 'Adabari', pincode: '784110' },
  { value: 'banbhag', label: 'Banbhag', pincode: '784110' },
  { value: 'barbari', label: 'Barbari', pincode: '784110' },
  { value: 'baruajani', label: 'Baruajani', pincode: '784110' },
  { value: 'bhuragaon', label: 'Bhuragaon', pincode: '784110' },
  { value: 'chowkigaon', label: 'Chowkigaon', pincode: '784110' },
  { value: 'dakhin-pachim', label: 'Dakhin Pachim', pincode: '784110' },
  { value: 'dhekiajuli-town', label: 'Dhekiajuli Town', pincode: '784110' },
  { value: 'fakharuddin-para', label: 'Fakharuddin Para', pincode: '784110' },
  { value: 'jhargaon', label: 'Jhargaon', pincode: '784110' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '784110' },
  { value: 'khatkhati', label: 'Khatkhati', pincode: '784110' },
  { value: 'kholapathar', label: 'Kholapathar', pincode: '784110' },
  { value: 'maibong', label: 'Maibong', pincode: '784110' },
  { value: 'mangaldai', label: 'Mangaldai', pincode: '784110' },
  { value: 'mangaldai-town', label: 'Mangaldai Town', pincode: '784110' },
  { value: 'phulbari', label: 'Phulbari', pincode: '784110' },
  { value: 'rangapara', label: 'Rangapara', pincode: '784110' },
  { value: 'safagaon', label: 'Safagaon', pincode: '784110' },
  { value: 'sundaridang', label: 'Sundaridang', pincode: '784110' },
  { value: 'tekeliapara', label: 'Tekeliapara', pincode: '784110' },
  { value: 'tukrajuri', label: 'Tukrajuri', pincode: '784110' },
  { value: 'nalbari-town', label: 'Nalbari Town', pincode: '781335' },
  { value: 'bhelowguri', label: 'Bhelowguri', pincode: '784110' },
  { value: 'thelahati', label: 'Thelahati', pincode: '784110' },
  { value: 'negalgaon', label: 'Negalgaon', pincode: '784110' },
  { value: 'garbhanga', label: 'Garbhanga', pincode: '784110' }
  ],
  
  'dergaon': [
  { value: 'adabari', label: 'Adabari', pincode: '785614' },
  { value: 'amguri', label: 'Amguri', pincode: '785614' },
  { value: 'barpothar', label: 'Barpothar', pincode: '785614' },
  { value: 'dergaon-bazar', label: 'Dergaon Bazar', pincode: '785614' },
  { value: 'dergaon-town', label: 'Dergaon Town', pincode: '785614' },
  { value: 'jhargaon', label: 'Jhargaon', pincode: '785614' },
  { value: 'khanpara', label: 'Khanpara', pincode: '785614' },
  { value: 'kharparia', label: 'Kharparia', pincode: '785614' },
  { value: 'merapathar', label: 'Merapathar', pincode: '785614' },
  { value: 'mongalpur', label: 'Mongalpur', pincode: '785614' },
  { value: 'morongi', label: 'Morongi', pincode: '785614' },
  { value: 'nokhrola', label: 'Nokhrola', pincode: '785614' },
  { value: 'rahmari', label: 'Rahmari', pincode: '785614' },
  { value: 'sarupathar', label: 'Sarupathar', pincode: '785614' },
  { value: 'sialmari', label: 'Sialmari', pincode: '785614' },
  { value: 'sukhanjan', label: 'Sukhanjan', pincode: '785614' },
  { value: 'tekeliapathar', label: 'Tekeliapathar', pincode: '785614' },
  { value: 'bokajan', label: 'Bokajan', pincode: '785618' },
  { value: 'borchapori', label: 'Borchapori', pincode: '785614' },
  { value: 'demow', label: 'Demow', pincode: '785671' },
  { value: 'kherajkhat', label: 'Kherajkhat', pincode: '785614' },
  { value: 'latumoni', label: 'Latumoni', pincode: '785614' },
  { value: 'longa', label: 'Longa', pincode: '785614' },
  { value: 'nalbari', label: 'Nalbari', pincode: '785616' },
  { value: 'sohpur', label: 'Sohpur', pincode: '785614' }
  ],
  
  'bokakhat': [
  { value: 'amguri', label: 'Amguri', pincode: '785612' },
  { value: 'baliapathar', label: 'Baliapathar', pincode: '785612' },
  { value: 'bokakhat-bazar', label: 'Bokakhat Bazar', pincode: '785612' },
  { value: 'borchapori', label: 'Borchapori', pincode: '785612' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '785612' },
  { value: 'doraimari', label: 'Doraimari', pincode: '785612' },
  { value: 'jijamara', label: 'Jijamara', pincode: '785612' },
  { value: 'jokai', label: 'Jokai', pincode: '785612' },
  { value: 'kachari', label: 'Kachari', pincode: '785612' },
  { value: 'kajalimukh', label: 'Kajalimukh', pincode: '785612' },
  { value: 'kathalbari', label: 'Kathalbari', pincode: '785612' },
  { value: 'kherkatia', label: 'Kherkatia', pincode: '785612' },
  { value: 'khumtai', label: 'Khumtai', pincode: '785612' },
  { value: 'kokilamukh', label: 'Kokilamukh', pincode: '785612' },
  { value: 'mohikhal', label: 'Mohikhal', pincode: '785612' },
  { value: 'sidhabari', label: 'Sidhabari', pincode: '785612' },
  { value: 'sukhanjan', label: 'Sukhanjan', pincode: '785612' },
  { value: 'tukeruguri', label: 'Tukeruguri', pincode: '785612' },
  { value: 'uthali', label: 'Uthali', pincode: '785612' },
  { value: 'yakubpur', label: 'Yakubpur', pincode: '785612' },
  { value: 'bhimnagar', label: 'Bhimnagar', pincode: '785612' },
  { value: 'mangaldai', label: 'Mangaldai', pincode: '785612' },
  { value: 'halem', label: 'Halem', pincode: '785612' },
  { value: 'barihimpur', label: 'Barihimpur', pincode: '785612' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '785612' }
  ],
  
  'rangia': [
  { value: 'bihpuria', label: 'Bihpuria', pincode: '781354' },
  { value: 'bhora', label: 'Bhora', pincode: '781354' },
  { value: 'chariali', label: 'Chariali', pincode: '781354' },
  { value: 'dabaka', label: 'Dabaka', pincode: '781354' },
  { value: 'goroimari', label: 'Goroimari', pincode: '781354' },
  { value: 'goroimari-bazar', label: 'Goroimari Bazar', pincode: '781354' },
  { value: 'jhorhat', label: 'Jhorhat', pincode: '781354' },
  { value: 'kalapahar', label: 'Kalapahar', pincode: '781354' },
  { value: 'kamalabari', label: 'Kamalabari', pincode: '781354' },
  { value: 'kampur', label: 'Kampur', pincode: '781354' },
  { value: 'kumarikata', label: 'Kumarikata', pincode: '781354' },
  { value: 'longa', label: 'Longa', pincode: '781354' },
  { value: 'majhergaon', label: 'Majhergaon', pincode: '781354' },
  { value: 'nalbari', label: 'Nalbari', pincode: '781354' },
  { value: 'niz-rampara', label: 'Niz Rampara', pincode: '781354' },
  { value: 'saraibari', label: 'Saraibari', pincode: '781354' },
  { value: 'sikajuli', label: 'Sikajuli', pincode: '781354' },
  { value: 'sivbari', label: 'Sivbari', pincode: '781354' },
  { value: 'timalguri', label: 'Timalguri', pincode: '781354' },
  { value: 'uruli', label: 'Uruli', pincode: '781354' },
  { value: 'wrangapara', label: 'Wrangapara', pincode: '781354' },
  { value: 'rajapara', label: 'Rajapara', pincode: '781354' },
  { value: 'chowkherenga', label: 'Chowkherenga', pincode: '781354' },
  { value: 'borkhata', label: 'Borkhata', pincode: '781354' },
  { value: 'bhangnamari', label: 'Bhangnamari', pincode: '781354' }
  ],
  
  'margherita': [
  { value: 'basupathar', label: 'Basupathar', pincode: '785690' },
  { value: 'bengbari', label: 'Bengbari', pincode: '785690' },
  { value: 'buri-dihing', label: 'Buri Dihing', pincode: '785690' },
  { value: 'gogamukh', label: 'Gogamukh', pincode: '785690' },
  { value: 'haslong', label: 'Haslong', pincode: '785690' },
  { value: 'kapanjuri', label: 'Kapanjuri', pincode: '785690' },
  { value: 'khagorijan', label: 'Khagorijan', pincode: '785690' },
  { value: 'laho', label: 'Laho', pincode: '785690' },
  { value: 'margherita-town', label: 'Margherita Town', pincode: '785690' },
  { value: 'phuloni', label: 'Phuloni', pincode: '785690' },
  { value: 'salakati', label: 'Salakati', pincode: '785690' },
  { value: 'sibasari', label: 'Sibasari', pincode: '785690' },
  { value: 'sorbung', label: 'Sorbung', pincode: '785690' },
  { value: 'sunitpur', label: 'Sunitpur', pincode: '785690' },
  { value: 'titan', label: 'Titan', pincode: '785690' },
  { value: 'tirap', label: 'Tirap', pincode: '785690' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '785690' },
  { value: 'kharjan', label: 'Kharjan', pincode: '785690' },
  { value: 'rangajan', label: 'Rangajan', pincode: '785690' },
  { value: 'darak', label: 'Darak', pincode: '785690' },
  { value: 'jirikinding', label: 'Jirikinding', pincode: '785690' }
  ],
  
  'silapathar': [
  { value: 'abhoipathar', label: 'Abhoipathar', pincode: '784165' },
  { value: 'bandardewa', label: 'Bandardewa', pincode: '784165' },
  { value: 'barkot', label: 'Barkot', pincode: '784165' },
  { value: 'garupara', label: 'Garupara', pincode: '784165' },
  { value: 'kordung', label: 'Kordung', pincode: '784165' },
  { value: 'madonpur', label: 'Madonpur', pincode: '784165' },
  { value: 'phulaguri', label: 'Phulaguri', pincode: '784165' },
  { value: 'silapathar-town', label: 'Silapathar Town', pincode: '784165' },
  { value: 'solmari', label: 'Solmari', pincode: '784165' },
  { value: 'sundrapur', label: 'Sundrapur', pincode: '784165' },
  { value: 'tinkhuti', label: 'Tinkhuti', pincode: '784165' },
  { value: 'tinisukia', label: 'Tinisukia', pincode: '784165' },
  { value: 'utiya', label: 'Utiya', pincode: '784165' },
  { value: 'chirang', label: 'Chirang', pincode: '784165' },
  { value: 'rongkhem', label: 'Rongkhem', pincode: '784165' },
  { value: 'balijan', label: 'Balijan', pincode: '784165' },
  { value: 'balisipu', label: 'Balisipu', pincode: '784165' },
  { value: 'khamar', label: 'Khamar', pincode: '784165' },
  { value: 'solmari-bazaar', label: 'Solmari Bazaar', pincode: '784165' },
  { value: 'sonapur', label: 'Sonapur', pincode: '784165' },
  { value: 'naoapathar', label: 'Naoapathar', pincode: '784165' }
  ],
  
  'tangla': [
  { value: 'barengapara', label: 'Barengapara', pincode: '784521' },
  { value: 'bhakatgaon', label: 'Bhakatgaon', pincode: '784521' },
  { value: 'bongapara', label: 'Bongapara', pincode: '784521' },
  { value: 'chakchaka', label: 'Chakchaka', pincode: '784521' },
  { value: 'gariapara', label: 'Gariapara', pincode: '784521' },
  { value: 'kanketa', label: 'Kanketa', pincode: '784521' },
  { value: 'kathalguri', label: 'Kathalguri', pincode: '784521' },
  { value: 'kochpara', label: 'Kochpara', pincode: '784521' },
  { value: 'kolongpara', label: 'Kolongpara', pincode: '784521' },
  { value: 'maruguri', label: 'Maruguri', pincode: '784521' },
  { value: 'tangla-town', label: 'Tangla Town', pincode: '784521' },
  { value: 'terabari', label: 'Terabari', pincode: '784521' },
  { value: 'tengapara', label: 'Tengapara', pincode: '784521' },
  { value: 'bhutiapara', label: 'Bhutiapara', pincode: '784521' },
  { value: 'sengjan', label: 'Sengjan', pincode: '784521' },
  { value: 'tarali', label: 'Tarali', pincode: '784521' },
  { value: 'sonajuli', label: 'Sonajuli', pincode: '784521' },
  { value: 'bheluguri', label: 'Bheluguri', pincode: '784521' },
  { value: 'chamdi', label: 'Chamdi', pincode: '784521' },
  { value: 'tengakhat', label: 'Tengakhat', pincode: '784521' },
  { value: 'ramchandrapara', label: 'Ramchandrapara', pincode: '784521' },
  { value: 'panchalapara', label: 'Panchalapara', pincode: '784521' },
  { value: 'chandrapara', label: 'Chandrapara', pincode: '784521' },
  { value: 'khowa', label: 'Khowa', pincode: '784521' },
  { value: 'tanglabari', label: 'Tanglabari', pincode: '784521' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '784521' }
  ],

'goalpara': [
  { value: 'agia', label: 'Agia', pincode: '783120' },
  { value: 'balijana', label: 'Balijana', pincode: '783120' },
  { value: 'bardamal', label: 'Bardamal', pincode: '783125' },
  { value: 'bhimajuli', label: 'Bhimajuli', pincode: '783129' },
  { value: 'chowkighat', label: 'Chowkighat', pincode: '783120' },
  { value: 'dhupdhara', label: 'Dhupdhara', pincode: '783123' },
  { value: 'dudhnoi', label: 'Dudhnoi', pincode: '783124' },
  { value: 'fakirdhasha', label: 'Fakirdhasha', pincode: '783101' },
  { value: 'goalpara-town', label: 'Goalpara Town', pincode: '783101' },
  { value: 'jaleswar', label: 'Jaleswar', pincode: '783132' },
  { value: 'kharmuza', label: 'Kharmuza', pincode: '783133' },
  { value: 'krishnai', label: 'Krishnai', pincode: '783126' },
  { value: 'kumarkata', label: 'Kumarkata', pincode: '783125' },
  { value: 'lakhipur', label: 'Lakhipur', pincode: '783129' },
  { value: 'mendima', label: 'Mendima', pincode: '783133' },
  { value: 'mornai', label: 'Mornai', pincode: '783124' },
  { value: 'pachania', label: 'Pachania', pincode: '783130' },
  { value: 'rangjuli', label: 'Rangjuli', pincode: '783131' },
  { value: 'simlitola', label: 'Simlitola', pincode: '783121' },
  { value: 'solmari', label: 'Solmari', pincode: '783101' },
  ],

  'jorhat': [
  { value: 'amlapatty', label: 'Amlapatty', pincode: '785001' },
  { value: 'bachagaon', label: 'Bachagaon', pincode: '785004' },
  { value: 'barbheta', label: 'Barbheta', pincode: '785101' },
  { value: 'bhogamukh', label: 'Bhogamukh', pincode: '785682' },
  { value: 'choladhara', label: 'Choladhara', pincode: '785001' },
  { value: 'cinnamara', label: 'Cinnamara', pincode: '785008' },
  { value: 'dakhinghat', label: 'Dakhinghat', pincode: '785110' },
  { value: 'deka-guwalgaon', label: 'Deka Guwalgaon', pincode: '785704' },
  { value: 'garamur', label: 'Garamur', pincode: '785106' },
  { value: 'garmur-mission', label: 'Garmur Mission', pincode: '785108' },
  { value: 'gohain-tekela', label: 'Gohain Tekela', pincode: '785111' },
  { value: 'jorhat-town', label: 'Jorhat Town', pincode: '785001' },
  { value: 'katakipukhuri', label: 'Katakipukhuri', pincode: '785105' },
  { value: 'khalihamari', label: 'Khalihamari', pincode: '785001' },
  { value: 'kokilamukh', label: 'Kokilamukh', pincode: '785107' },
  { value: 'lakhimi-nagar', label: 'Lakhimi Nagar', pincode: '785004' },
  { value: 'malow-ali', label: 'Malow Ali', pincode: '785001' },
  { value: 'mariani', label: 'Mariani', pincode: '785635' },
  { value: 'moriani-town', label: 'Moriani Town', pincode: '785635' },
  { value: 'puranimati', label: 'Puranimati', pincode: '785111' },
  { value: 'rowriah', label: 'Rowriah', pincode: '785006' },
  { value: 'sapekhati', label: 'Sapekhati', pincode: '785682' },
  { value: 'sarbaibandha', label: 'Sarbaibandha', pincode: '785007' },
  { value: 'sonari-gaon', label: 'Sonari Gaon', pincode: '785636' },
  { value: 'tilikiam', label: 'Tilikiam', pincode: '785632' },
  ],

  'dibrugarh': [
  { value: 'amolapatty', label: 'Amolapatty', pincode: '786001' },
  { value: 'barbari', label: 'Barbari', pincode: '786003' },
  { value: 'boiragimoth', label: 'Boiragimoth', pincode: '786003' },
  { value: 'chakalia', label: 'Chakalia', pincode: '786101' },
  { value: 'chalihua', label: 'Chalihua', pincode: '786004' },
  { value: 'dibrugarh-university', label: 'Dibrugarh University', pincode: '786004' },
  { value: 'dibrugarh-town', label: 'Dibrugarh Town', pincode: '786001' },
  { value: 'grahambazar', label: 'Graham Bazar', pincode: '786001' },
  { value: 'jhalukpara', label: 'Jhalukpara', pincode: '786005' },
  { value: 'katakipukhuri', label: 'Katakipukhuri', pincode: '786004' },
  { value: 'khanikar', label: 'Khanikar', pincode: '786010' },
  { value: 'kodomoni', label: 'Kodomoni', pincode: '786005' },
  { value: 'lahowal', label: 'Lahowal', pincode: '786010' },
  { value: 'lakhimipath', label: 'Lakhimipath', pincode: '786003' },
  { value: 'lepetkata', label: 'Lepetkata', pincode: '786006' },
  { value: 'mancotta', label: 'Mancotta', pincode: '786003' },
  { value: 'milan-nagar', label: 'Milan Nagar', pincode: '786003' },
  { value: 'mohanaghat', label: 'Mohanaghat', pincode: '786008' },
  { value: 'naliapool', label: 'Naliapool', pincode: '786001' },
  { value: 'new-market', label: 'New Market', pincode: '786001' },
  { value: 'paltanbazar', label: 'Paltan Bazar', pincode: '786001' },
  { value: 'rahmaria', label: 'Rahmaria', pincode: '786007' },
  { value: 'rangagara', label: 'Rangagara', pincode: '786003' },
  { value: 'sessa', label: 'Sessa', pincode: '786002' },
  { value: 'tengakhat', label: 'Tengakhat', pincode: '786103' },
  { value: 'thana-chariali', label: 'Thana Chariali', pincode: '786001' },
  { value: 'tipling', label: 'Tipling', pincode: '786010' },
  ],

  'tezpur': [
  { value: 'adabari', label: 'Adabari', pincode: '784027' },
  { value: 'banipathar', label: 'Banipathar', pincode: '784178' },
  { value: 'batamari', label: 'Batamari', pincode: '784027' },
  { value: 'bhairabpad', label: 'Bhairabpad', pincode: '784102' },
  { value: 'bindukuri', label: 'Bindukuri', pincode: '784028' },
  { value: 'borghat', label: 'Borghat', pincode: '784501' },
  { value: 'chitralekha-nagar', label: 'Chitralekha Nagar', pincode: '784001' },
  { value: 'dekargaon', label: 'Dekargaon', pincode: '784501' },
  { value: 'dhekiajuli', label: 'Dhekiajuli', pincode: '784110' },
  { value: 'gabharu', label: 'Gabharu', pincode: '784105' },
  { value: 'ganeshguri', label: 'Ganeshguri', pincode: '784001' },
  { value: 'gaonburha-chuk', label: 'Gaonburha Chuk', pincode: '784506' },
  { value: 'ghatbor', label: 'Ghatbor', pincode: '784506' },
  { value: 'jalukbari', label: 'Jalukbari', pincode: '784505' },
  { value: 'kaliabhomora', label: 'Kaliabhomora', pincode: '784105' },
  { value: 'kanaklata-path', label: 'Kanaklata Path', pincode: '784001' },
  { value: 'khelmati', label: 'Khelmati', pincode: '784001' },
  { value: 'kolibari', label: 'Kolibari', pincode: '784105' },
  { value: 'mohabhairab', label: 'Mohabhairab', pincode: '784001' },
  { value: 'nameri', label: 'Nameri', pincode: '784177' },
  { value: 'paruwa', label: 'Paruwa', pincode: '784153' },
  { value: 'poruwa', label: 'Poruwa', pincode: '784001' },
  { value: 'ranga-mati', label: 'Ranga Mati', pincode: '784110' },
  { value: 'sootea', label: 'Sootea', pincode: '784175' },
  { value: 'tezpur-town', label: 'Tezpur Town', pincode: '784001' },
  { value: 'tezpur-university', label: 'Tezpur University', pincode: '784028' },
  { value: 'thakurbari', label: 'Thakurbari', pincode: '784154' },
  { value: 'uttrakuchi', label: 'Uttrakuchi', pincode: '784501' },
  ],

  'guwahati': [
  { value: 'ajanta-path', label: 'Ajanta Path', pincode: '781019' },
  { value: 'ananda-nagar', label: 'Ananda Nagar', pincode: '781012' },
  { value: 'ashok-path', label: 'Ashok Path', pincode: '781006' },
  { value: 'azara', label: 'Azara', pincode: '781017' },
  { value: 'baghorbori-tiniali', label: 'Baghorbori Tiniali', pincode: '781023' },
  { value: 'bamunimaidan', label: 'Bamunimaidan', pincode: '781021' },
  { value: 'basistha-chariali', label: 'Basistha Chariali', pincode: '781029' },
  { value: 'beharbari-chariali', label: 'Beharbari Chariali', pincode: '781022' },
  { value: 'beltola', label: 'Beltola', pincode: '781028' },
  { value: 'beltola-tiniali', label: 'Beltola Tiniali', pincode: '781028' },
  { value: 'bhangagarh', label: 'Bhangagarh', pincode: '781005' },
  { value: 'bharalumukh', label: 'Bharalumukh', pincode: '781009' },
  { value: 'bhetapara', label: 'Bhetapara', pincode: '781028' },
  { value: 'bhetapara-ghoramara-road', label: 'Bhetapara Ghoramara Road', pincode: '781028' },
  { value: 'bhubaneswar-barua-road', label: 'Bhubaneswar Barua Road', pincode: '781003' },
  { value: 'bishnu-rabha-path', label: 'Bishnu Rabha Path', pincode: '781029' },
  { value: 'borbari', label: 'Borbari', pincode: '781171' },
  { value: 'borjhar', label: 'Borjhar', pincode: '781015' },
  { value: 'chandmari', label: 'Chandmari', pincode: '781003' },
  { value: 'chatribari', label: 'Chatribari', pincode: '781008' },
  { value: 'chenikuthi', label: 'Chenikuthi', pincode: '781003' },
  { value: 'christian-basti', label: 'Christian Basti', pincode: '781005' },
  { value: 'dharapur', label: 'Dharapur', pincode: '781014' },
  { value: 'dispur', label: 'Dispur', pincode: '781006' },
  { value: 'dr-bhabendra-nath-saikia-path', label: 'Dr Bhabendra Nath Saikia Path', pincode: '781006' },
  { value: 'fatasil-bazaar', label: 'Fatasil Bazaar', pincode: '781009' },
  { value: 'gandhi-basti', label: 'Gandhi Basti', pincode: '781003' },
  { value: 'ganesh-mandir-road', label: 'Ganesh Mandir Road', pincode: '781006' },
  { value: 'ganeshguri', label: 'Ganeshguri', pincode: '781006' },
  { value: 'garchuk', label: 'Garchuk', pincode: '781035' },
  { value: 'geetanagar', label: 'Geetanagar', pincode: '781024' },
  { value: 'gs-road', label: 'GS Road', pincode: '781005' },
  { value: 'hatigaon', label: 'Hatigaon', pincode: '781038' },
  { value: 'hengerabari', label: 'Hengerabari', pincode: '781036' },
  { value: 'jalukbari', label: 'Jalukbari', pincode: '781013' },
  { value: 'japorigog', label: 'Japorigog', pincode: '781005' },
  { value: 'jayanagar-road', label: 'Jayanagar Road', pincode: '781034' },
  { value: 'jorpukhuri', label: 'Jorpukhuri', pincode: '781001' },
  { value: 'juripar-path', label: 'Juripar Path', pincode: '781005' },
  { value: 'jyotinagar-road', label: 'Jyotinagar Road', pincode: '781021' },
  { value: 'kahi-kuchi', label: 'Kahi Kuchi', pincode: '781017' },
  { value: 'kahilipara', label: 'Kahilipara', pincode: '781019' },
  { value: 'kala-pahar', label: 'Kala Pahar', pincode: '781018' },
  { value: 'kedar-road', label: 'Kedar Road', pincode: '781001' },
  { value: 'khanapara', label: 'Khanapara', pincode: '781022' },
  { value: 'kharghuli-hills', label: 'Kharghuli Hills', pincode: '781004' },
  { value: 'kk-road', label: 'KK Road', pincode: '781005' },
  { value: 'lakhimi-nagar', label: 'Lakhimi Nagar', pincode: '781006' },
  { value: 'lal-ganesh', label: 'Lal Ganesh', pincode: '781034' },
  { value: 'lokhra', label: 'Lokhra', pincode: '781034' },
  { value: 'lokhra-road', label: 'Lokhra Road', pincode: '781034' },
  { value: 'maligaon', label: 'Maligaon', pincode: '781011' },
  { value: 'manik-nagar', label: 'Manik Nagar', pincode: '781007' },
  { value: 'mother-teresa-road', label: 'Mother Teresa Road', pincode: '781028' },
  { value: 'narengi-tinali', label: 'Narengi Tinali', pincode: '781026' },
  { value: 'narikalbasti', label: 'Narikalbasti', pincode: '781005' },
  { value: 'nh-37', label: 'NH-37', pincode: '781017' },
  { value: 'noonmati', label: 'Noonmati', pincode: '781020' },
  { value: 'panjabari', label: 'Panjabari', pincode: '781037' },
  { value: 'pator-kuchi', label: 'Pator Kuchi', pincode: '781037' },
  { value: 'pngb-road', label: 'PNGB Road', pincode: '781003' },
  { value: 'rajgarh', label: 'Rajgarh', pincode: '781003' },
  { value: 'rehabari', label: 'Rehabari', pincode: '781008' },
  { value: 'rg-baruah-road', label: 'RG Baruah Road', pincode: '781005' },
  { value: 'rukmini-gaon', label: 'Rukmini Gaon', pincode: '781036' },
  { value: 'rukmininagar', label: 'Rukmininagar', pincode: '781036' },
  { value: 'rupnagar-road', label: 'Rupnagar Road', pincode: '781032' },
  { value: 'sachal-road', label: 'Sachal Road', pincode: '781036' },
  { value: 'sewali-path', label: 'Sewali Path', pincode: '781003' },
  { value: 'silpukhuri', label: 'Silpukhuri', pincode: '781003' },
  { value: 'six-mile', label: 'Six Mile', pincode: '781036' },
  { value: 'sreenagar', label: 'Sreenagar', pincode: '781007' },
  { value: 'tarun-nagar', label: 'Tarun Nagar', pincode: '781005' },
  { value: 'ulubari', label: 'Ulubari', pincode: '781007' },
  { value: 'uzan-bazaar', label: 'Uzan Bazaar', pincode: '781001' },
  { value: 'vip-road', label: 'VIP Road', pincode: '781036' },
  { value: 'zoo-narengi-road', label: 'Zoo Narengi Road', pincode: '781024' },
  { value: 'zoo-road', label: 'Zoo Road', pincode: '781024' }
  ],

'tinsukia': [
{ value: 'barekuri', label: 'Barekuri', pincode: '786125' },
{ value: 'dangari', label: 'Dangari', pincode: '786182' },
{ value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
{ value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
{ value: 'harmoti', label: 'Harmoti', pincode: '786151' },
{ value: 'kachomari', label: 'Kachomari', pincode: '786163' },
{ value: 'kamalabari', label: 'Kamalabari', pincode: '786181' },
{ value: 'maijon', label: 'Maijon', pincode: '786180' },
{ value: 'nepapara', label: 'Nepapara', pincode: '786148' },
{ value: 'panitola', label: 'Panitola', pincode: '786182' },
{ value: 'sapekhati', label: 'Sapekhati', pincode: '786183' },
{ value: 'tinsukia-town', label: 'Tinsukia Town', pincode: '786125' },
{ value: 'tinsukia-rly-stn', label: 'Tinsukia Railway Station', pincode: '786125' },
{ value: 'tingrai', label: 'Tingrai', pincode: '786153' },
{ value: 'banargaon', label: 'Banargaon', pincode: '786149' },
{ value: 'bherjan', label: 'Bherjan', pincode: '786183' },
{ value: 'borbari', label: 'Borbari', pincode: '786160' },
{ value: 'dibrugarh-road', label: 'Dibrugarh Road', pincode: '786143' },
{ value: 'khowang', label: 'Khowang', pincode: '786150' },
{ value: 'makum', label: 'Makum', pincode: '786123' },
{ value: 'margerita', label: 'Margarita', pincode: '786181' },
{ value: 'namrup', label: 'Namrup', pincode: '786623' },
{ value: 'rajagarh', label: 'Rajagarh', pincode: '786152' }
],

'karimganj': [
{ value: 'ashiganj', label: 'Ashiganj', pincode: '788710' },
{ value: 'badarpur', label: 'Badarpur', pincode: '788103' },
{ value: 'bhairabnagar', label: 'Bhairabnagar', pincode: '788151' },
{ value: 'chandpur', label: 'Chandpur', pincode: '788149' },
{ value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
{ value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
{ value: 'karimganj-town', label: 'Karimganj Town', pincode: '788711' },
{ value: 'kallipur', label: 'Kallipur', pincode: '788171' },
{ value: 'lathitilla', label: 'Lathitilla', pincode: '788705' },
{ value: 'moheshkhala', label: 'Moheshkhala', pincode: '788712' },
{ value: 'patharkandi', label: 'Patharkandi', pincode: '788723' },
{ value: 'rajarbag', label: 'Rajarbag', pincode: '788704' },
{ value: 'ramkrishna-nagar', label: 'Ramkrishna Nagar', pincode: '788711' },
{ value: 'srirampur', label: 'Srirampur', pincode: '788711' },
{ value: 'tulagram', label: 'Tulagram', pincode: '788706' },
{ value: 'udarbond', label: 'Udarbond', pincode: '788123' }
],

'golaghat': [
{ value: 'golaghat-town', label: 'Golaghat Town', pincode: '785621' },
{ value: 'bhogpur', label: 'Bhogpur', pincode: '785612' },
{ value: 'dergaon', label: 'Dergaon', pincode: '785614' },
{ value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
{ value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
{ value: 'jharnapathar', label: 'Jharnapathar', pincode: '785634' },
{ value: 'kaliapathar', label: 'Kaliapathar', pincode: '785616' },
{ value: 'kharupetia', label: 'Kharupetia', pincode: '785634' },
{ value: 'margerita', label: 'Margerita', pincode: '785690' },
{ value: 'morongi', label: 'Morongi', pincode: '785645' },
{ value: 'numaligarh', label: 'Numaligarh', pincode: '785615' },
{ value: 'pobitora', label: 'Pobitora', pincode: '785617' },
{ value: 'rangajan', label: 'Rangajan', pincode: '785603' },
{ value: 'barpathar', label: 'Barpathar', pincode: '785625' },
{ value: 'bogaon', label: 'Bogaon', pincode: '785628' },
{ value: 'kachomari', label: 'Kachomari', pincode: '785629' },
{ value: 'kuliabali', label: 'Kuliabali', pincode: '785622' },
{ value: 'namrup', label: 'Namrup', pincode: '785613' },
{ value: 'tengakhat', label: 'Tengakhat', pincode: '785631' }
],

'dhubri': [
{ value: 'balajan', label: 'Balajan', pincode: '783324' },
{ value: 'chandmari', label: 'Chandmari', pincode: '783301' },
{ value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
{ value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
{ value: 'dhubri-town', label: 'Dhubri Town', pincode: '783301' },
{ value: 'halakura', label: 'Halakura', pincode: '783302' },
{ value: 'jaleswar', label: 'Jaleswar', pincode: '783345' },
{ value: 'kamrup', label: 'Kamrup', pincode: '783338' },
{ value: 'lakhipur', label: 'Lakhipur', pincode: '783343' },
{ value: 'mankachar', label: 'Mankachar', pincode: '783136' },
{ value: 'mahadevpur', label: 'Mahadevpur', pincode: '783314' },
{ value: 'patamari', label: 'Patamari', pincode: '783340' },
{ value: 'patarghat', label: 'Patarghat', pincode: '783332' },
{ value: 'sarsmari', label: 'Sarsmari', pincode: '783311' },
{ value: 'sukhchar', label: 'Sukhchar', pincode: '783332' },
{ value: 'tulshibil', label: 'Tulshibil', pincode: '783345' },
{ value: 'bilasipara', label: 'Bilasipara', pincode: '783348' }
],

'north-lakhimpur': [
{ value: 'balijan', label: 'Balijan', pincode: '787001' },
{ value: 'bihpuria', label: 'Bihpuria', pincode: '787026' },
{ value: 'dhekiajuli', label: 'Dhekiajuli', pincode: '787027' },
{ value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
{ value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
{ value: 'khelmati', label: 'Khelmati', pincode: '787001' },
{ value: 'lakhipur', label: 'Lakhipur', pincode: '787052' },
{ value: 'majhergaon', label: 'Majhergaon', pincode: '787056' },
{ value: 'namti', label: 'Namti', pincode: '787002' },
{ value: 'north-lakhimpur-town', label: 'North Lakhimpur Town', pincode: '787001' },
{ value: 'nalbari', label: 'Nalbari', pincode: '787053' },
{ value: 'simaluguri', label: 'Simaluguri', pincode: '787056' },
{ value: 'tinisukia', label: 'Tinisukia', pincode: '787045' },
{ value: 'urmila', label: 'Urmila', pincode: '787055' },
{ value: 'phulbari', label: 'Phulbari', pincode: '787034' },
{ value: 'tamluk', label: 'Tamluk', pincode: '787025' },
{ value: 'burhi-teesta', label: 'Burhi Teesta', pincode: '787033' },
{ value: 'chandmari', label: 'Chandmari', pincode: '787042' }
],

//gujarat areas
 'gandhinagar': [
  { value: 'adani-port', label: 'Adani Port', pincode: '382420' },
  { value: 'bhat', label: 'Bhat', pincode: '382428' },
  { value: 'chandlodia', label: 'Chandlodia', pincode: '382481' },
  { value: 'chandranagar', label: 'Chandranagar', pincode: '382424' },
  { value: 'gandhinagar', label: 'Gandhinagar', pincode: '382010' },
  { value: 'gaon', label: 'Gaon', pincode: '382424' },
  { value: 'gift-city', label: 'Gift City', pincode: '382355' },
  { value: 'kalol', label: 'Kalol', pincode: '382721' },
  { value: 'khodiyar', label: 'Khodiyar', pincode: '382423' },
  { value: 'mahemdabad', label: 'Mahemdabad', pincode: '382320' },
  { value: 'maninagar', label: 'Maninagar', pincode: '382845' },
  { value: 'mansa', label: 'Mansa', pincode: '382845' },
  { value: 'satelite', label: 'Satelite', pincode: '382421' },
  { value: 'sarkhej', label: 'Sarkhej', pincode: '382465' },
  { value: 'santej', label: 'Santej', pincode: '382721' },
  { value: 'sector-1', label: 'Sector 1', pincode: '382010' },
  { value: 'sector-10', label: 'Sector 10', pincode: '382010' },
  { value: 'sector-11', label: 'Sector 11', pincode: '382010' },
  { value: 'sector-21', label: 'Sector 21', pincode: '382010' },
  { value: 'sector-30', label: 'Sector 30', pincode: '382010' },
  { value: 'university-road', label: 'University Road', pincode: '382016' },
  { value: 'vadsar', label: 'Vadsar', pincode: '382420' },
  { value: 'vasna', label: 'Vasna', pincode: '382465' }
  ],
  
  'siddhpur': [
  { value: 'adroj', label: 'Adroj', pincode: '384151' },
  { value: 'bhatvadi', label: 'Bhatvadi', pincode: '384151' },
  { value: 'dakshineshwar', label: 'Dakshineshwar', pincode: '384151' },
  { value: 'ganj', label: 'Ganj', pincode: '384151' },
  { value: 'jodhpur', label: 'Jodhpur', pincode: '384151' },
  { value: 'kachhiya', label: 'Kachhiya', pincode: '384151' },
  { value: 'kadi', label: 'Kadi', pincode: '384151' },
  { value: 'kaladhari', label: 'Kaladhari', pincode: '384151' },
  { value: 'khirri', label: 'Khirri', pincode: '384151' },
  { value: 'mota', label: 'Mota', pincode: '384151' },
  { value: 'nava', label: 'Nava', pincode: '384151' },
  { value: 'rahnan', label: 'Rahanan', pincode: '384151' },
  { value: 'siddhpur', label: 'Siddhpur', pincode: '384151' },
  { value: 'unjha', label: 'Unjha', pincode: '384170' },
  { value: 'vav', label: 'Vav', pincode: '384151' },
  { value: 'vithlapur', label: 'Vithlapur', pincode: '384151' },
  { value: 'wala', label: 'Wala', pincode: '384151' }
  ],

  'navsari': [
    { value: 'abhapur', label: 'Abhapur', pincode: '396440' },
    { value: 'adri', label: 'Adri', pincode: '396107' },
    { value: 'balapur', label: 'Balapur', pincode: '396107' },
    { value: 'bansda', label: 'Bansda', pincode: '396580' },
    { value: 'baranjala', label: 'Baranjala', pincode: '396445' },
    { value: 'bhilad', label: 'Bhilad', pincode: '396105' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '396107' },
    { value: 'chikhli', label: 'Chikhli', pincode: '396521' },
    { value: 'devpur', label: 'Devpur', pincode: '396421' },
    { value: 'dhanmora', label: 'Dhanmora', pincode: '396421' },
    { value: 'fatehpura', label: 'Fatehpura', pincode: '396428' },
    { value: 'gariyadhar', label: 'Gariyadhar', pincode: '396421' },
    { value: 'godadra', label: 'Godadra', pincode: '396440' },
    { value: 'jalalpore', label: 'Jalalpore', pincode: '396107' },
    { value: 'kaliad', label: 'Kaliad', pincode: '396107' },
    { value: 'kankraj', label: 'Kankraj', pincode: '396107' },
    { value: 'khergam', label: 'Khergam', pincode: '396140' },
    { value: 'kodia', label: 'Kodia', pincode: '396450' },
    { value: 'kudasan', label: 'Kudasan', pincode: '396107' },
    { value: 'mahal', label: 'Mahal', pincode: '396107' },
    { value: 'mandva', label: 'Mandva', pincode: '396460' },
    { value: 'mandvi', label: 'Mandvi', pincode: '396115' },
    { value: 'mangrol', label: 'Mangrol', pincode: '396140' },
    { value: 'navsari', label: 'Navsari', pincode: '396445' },
    { value: 'navsari-rural', label: 'Navsari Rural', pincode: '396445' },
    { value: 'palsana', label: 'Palsana', pincode: '396107' },
    { value: 'parvat', label: 'Parvat', pincode: '396440' },
    { value: 'rajmachi', label: 'Rajmachi', pincode: '396421' },
    { value: 'sahar', label: 'Sahar', pincode: '396421' },
    { value: 'sangani', label: 'Sangani', pincode: '396107' },
    { value: 'sarthana', label: 'Sarthana', pincode: '396107' },
    { value: 'umra', label: 'Umra', pincode: '396445' },
    { value: 'vankal', label: 'Vankal', pincode: '396445' },
    { value: 'vaso', label: 'Vaso', pincode: '396191' }
  ],

  'morbi': [
    { value: 'adhoi', label: 'Adhoi', pincode: '363641' },
    { value: 'bhanvad', label: 'Bhanvad', pincode: '360510' },
    { value: 'bhimnath', label: 'Bhimnath', pincode: '363641' },
    { value: 'chakvad', label: 'Chakvad', pincode: '363621' },
    { value: 'dhoraji', label: 'Dhoraji', pincode: '360410' },
    { value: 'halvad', label: 'Halvad', pincode: '363330' },
    { value: 'jambudi', label: 'Jambudi', pincode: '363650' },
    { value: 'kerala', label: 'Kerala', pincode: '363641' },
    { value: 'maliya', label: 'Maliya', pincode: '363660' },
    { value: 'mangrol', label: 'Mangrol', pincode: '362225' },
    { value: 'mehsana', label: 'Mehsana', pincode: '384001' },
    { value: 'mojap', label: 'Mojap', pincode: '363201' },
    { value: 'morbi', label: 'Morbi', pincode: '363641' },
    { value: 'nandedi', label: 'Nandedi', pincode: '363641' },
    { value: 'naliya', label: 'Naliya', pincode: '363650' },
    { value: 'paddhari', label: 'Paddhari', pincode: '363020' },
    { value: 'rajkot', label: 'Rajkot', pincode: '360001' },
    { value: 'ranavav', label: 'Ranavav', pincode: '360550' },
    { value: 'sangwa', label: 'Sangwa', pincode: '363622' },
    { value: 'sijpur', label: 'Sijpur', pincode: '363004' },
    { value: 'tangarva', label: 'Tangarva', pincode: '362210' },
    { value: 'tundav', label: 'Tundav', pincode: '363002' },
    { value: 'vavdi', label: 'Vavdi', pincode: '363122' },
    { value: 'wankaner', label: 'Wankaner', pincode: '363621' },
    { value: 'zampur', label: 'Zampur', pincode: '363651' }
  ],

  'mehsana': [
    { value: 'adraj', label: 'Adraj', pincode: '384120' },
    { value: 'amraiwadi', label: 'Amraiwadi', pincode: '384120' },
    { value: 'bariyani', label: 'Bariyani', pincode: '384002' },
    { value: 'bhalgam', label: 'Bhalgam', pincode: '384212' },
    { value: 'chhapi', label: 'Chhapi', pincode: '384003' },
    { value: 'dhamanwada', label: 'Dhamanwada', pincode: '384002' },
    { value: 'dholka', label: 'Dholka', pincode: '382260' },
    { value: 'gadhavi', label: 'Gadhavi', pincode: '384151' },
    { value: 'kadi', label: 'Kadi', pincode: '382715' },
    { value: 'kanodar', label: 'Kanodar', pincode: '384115' },
    { value: 'khedbrahma', label: 'Khedbrahma', pincode: '383255' },
    { value: 'kheralu', label: 'Kheralu', pincode: '384325' },
    { value: 'kishanpura', label: 'Kishanpura', pincode: '384120' },
    { value: 'kothamba', label: 'Kothamba', pincode: '384003' },
    { value: 'mehmadabad', label: 'Mehmadabad', pincode: '382130' },
    { value: 'mehsana', label: 'Mehsana', pincode: '384001' },
    { value: 'modhera', label: 'Modhera', pincode: '384212' },
    { value: 'moti-vas', label: 'Moti Vas', pincode: '384002' },
    { value: 'nalva', label: 'Nalva', pincode: '384120' },
    { value: 'palanpur', label: 'Palanpur', pincode: '385001' },
    { value: 'patelvas', label: 'Patelvas', pincode: '384205' },
    { value: 'radhanpur', label: 'Radhanpur', pincode: '385340' },
    { value: 'ranipur', label: 'Ranipur', pincode: '384220' },
    { value: 'sachin', label: 'Sachin', pincode: '384001' },
    { value: 'sarna', label: 'Sarna', pincode: '384120' },
    { value: 'sidhpur', label: 'Sidhpur', pincode: '384151' },
    { value: 'tadgam', label: 'Tadgam', pincode: '384315' },
    { value: 'umra', label: 'Umra', pincode: '384001' },
    { value: 'unza', label: 'Unza', pincode: '384120' },
    { value: 'vadnagar', label: 'Vadnagar', pincode: '384355' },
    { value: 'vatva', label: 'Vatva', pincode: '384150' },
    { value: 'vijapur', label: 'Vijapur', pincode: '388170' },
    { value: 'visnagar', label: 'Visnagar', pincode: '384315' }
  ],

  'godhra': [
    { value: 'adhoi', label: 'Adhoi', pincode: '389001' },
    { value: 'alindra', label: 'Alindra', pincode: '389001' },
    { value: 'ambapur', label: 'Ambapur', pincode: '389001' },
    { value: 'andada', label: 'Andada', pincode: '389001' },
    { value: 'balasinor', label: 'Balasinor', pincode: '389320' },
    { value: 'bandhi', label: 'Bandhi', pincode: '389110' },
    { value: 'bavla', label: 'Bavla', pincode: '389001' },
    { value: 'bhadiyad', label: 'Bhadiyad', pincode: '389110' },
    { value: 'bilodra', label: 'Bilodra', pincode: '389110' },
    { value: 'chandpur', label: 'Chandpur', pincode: '389001' },
    { value: 'chandrol', label: 'Chandrol', pincode: '389110' },
    { value: 'chhotaudepur', label: 'Chhota Udepur', pincode: '391165' },
    { value: 'devpur', label: 'Devpur', pincode: '389150' },
    { value: 'dholka', label: 'Dholka', pincode: '389130' },
    { value: 'gadhada', label: 'Gadhada', pincode: '389110' },
    { value: 'gadhka', label: 'Gadhka', pincode: '389001' },
    { value: 'godhra', label: 'Godhra', pincode: '389001' },
    { value: 'hadad', label: 'Hadad', pincode: '389001' },
    { value: 'karod', label: 'Karod', pincode: '389001' },
    { value: 'kheda', label: 'Kheda', pincode: '389001' },
    { value: 'kheda-rural', label: 'Kheda Rural', pincode: '389170' },
    { value: 'kothamba', label: 'Kothamba', pincode: '389160' },
    { value: 'kothari', label: 'Kothari', pincode: '389110' },
    { value: 'mahuva', label: 'Mahuva', pincode: '389001' },
    { value: 'malpur', label: 'Malpur', pincode: '389110' },
    { value: 'manal', label: 'Manal', pincode: '389001' },
    { value: 'mangrol', label: 'Mangrol', pincode: '389110' },
    { value: 'nandod', label: 'Nandod', pincode: '391110' },
    { value: 'nanpur', label: 'Nanpur', pincode: '389110' },
    { value: 'padar', label: 'Padar', pincode: '389110' },
    { value: 'pati', label: 'Pati', pincode: '389001' },
    { value: 'rangpur', label: 'Rangpur', pincode: '389001' },
    { value: 'rasulabad', label: 'Rasulabad', pincode: '389001' },
    { value: 'ravipura', label: 'Ravipura', pincode: '389110' },
    { value: 'sangpura', label: 'Sangpura', pincode: '389220' },
    { value: 'sarad', label: 'Sarad', pincode: '389001' },
    { value: 'sarthebari', label: 'Sarthebari', pincode: '393130' },
    { value: 'savli', label: 'Savli', pincode: '389110' },
    { value: 'sherpura', label: 'Sherpura', pincode: '389110' },
    { value: 'sundarpura', label: 'Sundarpura', pincode: '389250' },
    { value: 'umeta', label: 'Umeta', pincode: '389001' },
    { value: 'vav', label: 'Vav', pincode: '389370' }
  ],

  'kheda': [
    { value: 'ankleshwar', label: 'Ankleshwar', pincode: '393001' },
    { value: 'balasinor', label: 'Balasinor', pincode: '388255' },
    { value: 'baranjala', label: 'Baranjala', pincode: '387001' },
    { value: 'bhojpur', label: 'Bhojpur', pincode: '387002' },
    { value: 'changa', label: 'Changa', pincode: '388001' },
    { value: 'dakor', label: 'Dakor', pincode: '388225' },
    { value: 'dhadhar', label: 'Dhadhar', pincode: '388005' },
    { value: 'gavsar', label: 'Gavsar', pincode: '387015' },
    { value: 'kakod', label: 'Kakod', pincode: '388201' },
    { value: 'kheda', label: 'Kheda', pincode: '387001' },
    { value: 'lakhdhirpur', label: 'Lakhdhirpur', pincode: '388102' },
    { value: 'mahanpur', label: 'Mahanpur', pincode: '388202' },
    { value: 'mahim', label: 'Mahim', pincode: '388001' },
    { value: 'manipur', label: 'Manipur', pincode: '388225' },
    { value: 'matar', label: 'Matar', pincode: '388001' },
    { value: 'nadiad', label: 'Nadiad', pincode: '387001' },
    { value: 'pansora', label: 'Pansora', pincode: '388001' },
    { value: 'piplod', label: 'Piplod', pincode: '388204' },
    { value: 'rakhiyal', label: 'Rakhiyal', pincode: '388001' },
    { value: 'ravipura', label: 'Ravipura', pincode: '388230' },
    { value: 'sarkhej', label: 'Sarkhej', pincode: '387023' },
    { value: 'umreth', label: 'Umreth', pincode: '388220' },
    { value: 'vadnagar', label: 'Vadnagar', pincode: '388145' },
    { value: 'vadodara', label: 'Vadodara', pincode: '390001' },
    { value: 'vadsar', label: 'Vadsar', pincode: '388007' },
    { value: 'vaghpura', label: 'Vaghpura', pincode: '388240' },
    { value: 'vijapur', label: 'Vijapur', pincode: '388170' },
    { value: 'vithalpur', label: 'Vithalpur', pincode: '388260' }
  ],

  'junagadh': [
    { value: 'adhoi', label: 'Adhoi', pincode: '362020' },
    { value: 'ambardi', label: 'Ambardi', pincode: '362020' },
    { value: 'balana', label: 'Balana', pincode: '362032' },
    { value: 'baldana', label: 'Baldana', pincode: '362240' },
    { value: 'balikha', label: 'Balikha', pincode: '362030' },
    { value: 'bavla', label: 'Bavla', pincode: '362010' },
    { value: 'bhesan', label: 'Bhesan', pincode: '362020' },
    { value: 'bhagvati', label: 'Bhagvati', pincode: '362001' },
    { value: 'bhatiya', label: 'Bhatiya', pincode: '362020' },
    { value: 'bilkha', label: 'Bilkha', pincode: '362260' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '362010' },
    { value: 'chhaya', label: 'Chhaya', pincode: '362021' },
    { value: 'chorvad', label: 'Chorvad', pincode: '362255' },
    { value: 'dhanpara', label: 'Dhanpara', pincode: '362255' },
    { value: 'dhoraji', label: 'Dhoraji', pincode: '360410' },
    { value: 'gadhada', label: 'Gadhada', pincode: '362110' },
    { value: 'gondal', label: 'Gondal', pincode: '360311' },
    { value: 'junagadh', label: 'Junagadh', pincode: '362001' },
    { value: 'juna-vadaj', label: 'Juna Vadaj', pincode: '362110' },
    { value: 'kadiyani', label: 'Kadiyani', pincode: '362030' },
    { value: 'kapadvanj', label: 'Kapadvanj', pincode: '387620' },
    { value: 'kathivav', label: 'Kathivav', pincode: '362030' },
    { value: 'khadia', label: 'Khadia', pincode: '362024' },
    { value: 'khambhaliya', label: 'Khambhaliya', pincode: '362620' },
    { value: 'khodiyar', label: 'Khodiyar', pincode: '362030' },
    { value: 'koyali', label: 'Koyali', pincode: '362010' },
    { value: 'kunkavav', label: 'Kunkavav', pincode: '362240' },
    { value: 'lalpur', label: 'Lalpur', pincode: '362110' },
    { value: 'madhupur', label: 'Madhupur', pincode: '362255' },
    { value: 'maliwad', label: 'Maliwad', pincode: '362001' },
    { value: 'manavadar', label: 'Manavadar', pincode: '362630' },
    { value: 'manekpara', label: 'Manekpara', pincode: '362010' },
    { value: 'mangrol', label: 'Mangrol', pincode: '362225' },
    { value: 'melvadi', label: 'Melvadi', pincode: '362220' },
    { value: 'palitana', label: 'Palitana', pincode: '362220' },
    { value: 'paddhari', label: 'Paddhari', pincode: '360110' },
    { value: 'patan', label: 'Patan', pincode: '362250' },
    { value: 'raghavi', label: 'Raghavi', pincode: '362240' },
    { value: 'rajkot', label: 'Rajkot', pincode: '360001' },
    { value: 'rajula', label: 'Rajula', pincode: '362150' },
    { value: 'sagwadi', label: 'Sagwadi', pincode: '362005' },
    { value: 'shapar', label: 'Shapar', pincode: '362220' },
    { value: 'sulab', label: 'Sulab', pincode: '362100' },
    { value: 'talala', label: 'Talala', pincode: '362150' },
    { value: 'tavdi', label: 'Tavdi', pincode: '362150' },
    { value: 'thana', label: 'Thana', pincode: '362260' },
    { value: 'tulsi', label: 'Tulsi', pincode: '362002' },
    { value: 'vadhwan', label: 'Vadhwan', pincode: '362030' },
    { value: 'vavdi', label: 'Vavdi', pincode: '362110' },
    { value: 'vijaynagar', label: 'Vijaynagar', pincode: '362330' }
  ],

  'ankleshwar': [
    { value: 'ankleshwar', label: 'Ankleshwar', pincode: '393001' },
    { value: 'bajwa', label: 'Bajwa', pincode: '393110' },
    { value: 'bhankoda', label: 'Bhankoda', pincode: '393110' },
    { value: 'bharthana', label: 'Bharthana', pincode: '393015' },
    { value: 'bhathena', label: 'Bhathena', pincode: '393001' },
    { value: 'bhimpor', label: 'Bhimpor', pincode: '393105' },
    { value: 'chhatrala', label: 'Chhatrala', pincode: '393105' },
    { value: 'dahej', label: 'Dahej', pincode: '392130' },
    { value: 'dungri', label: 'Dungri', pincode: '393110' },
    { value: 'gadepada', label: 'Gadepada', pincode: '393015' },
    { value: 'gavadka', label: 'Gavadka', pincode: '393010' },
    { value: 'godhra', label: 'Godhra', pincode: '393110' },
    { value: 'hindia', label: 'Hindia', pincode: '393110' },
    { value: 'jambusar', label: 'Jambusar', pincode: '393120' },
    { value: 'kagvad', label: 'Kagvad', pincode: '393105' },
    { value: 'kansara', label: 'Kansara', pincode: '393110' },
    { value: 'karad', label: 'Karad', pincode: '393120' },
    { value: 'kathwada', label: 'Kathwada', pincode: '393110' },
    { value: 'kheda', label: 'Kheda', pincode: '393130' },
    { value: 'kotharia', label: 'Kotharia', pincode: '393015' },
    { value: 'lilpur', label: 'Lilpur', pincode: '393130' },
    { value: 'malekpor', label: 'Malekpor', pincode: '393110' },
    { value: 'mangrol', label: 'Mangrol', pincode: '393110' },
    { value: 'mohammadpura', label: 'Mohammadpura', pincode: '393130' },
    { value: 'moti-bijapur', label: 'Moti Bijapur', pincode: '393105' },
    { value: 'naranpura', label: 'Naranpura', pincode: '393110' },
    { value: 'narmada', label: 'Narmada', pincode: '393015' },
    { value: 'padra', label: 'Padra', pincode: '393120' },
    { value: 'panoli', label: 'Panoli', pincode: '393110' },
    { value: 'patan', label: 'Patan', pincode: '393120' },
    { value: 'rajpardi', label: 'Rajpardi', pincode: '393100' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '393002' },
    { value: 'sachin', label: 'Sachin', pincode: '393120' },
    { value: 'sadarbadi', label: 'Sadarbadi', pincode: '393110' },
    { value: 'sardarpura', label: 'Sardarpura', pincode: '393110' },
    { value: 'sarthana', label: 'Sarthana', pincode: '393110' },
    { value: 'sarthebari', label: 'Sarthebari', pincode: '393130' },
    { value: 'tarsali', label: 'Tarsali', pincode: '393002' },
    { value: 'vadhvana', label: 'Vadhvana', pincode: '393001' }
  ],

  'anand': [
    { value: 'akhada', label: 'Akhada', pincode: '388001' },
    { value: 'ankleshwar', label: 'Ankleshwar', pincode: '393001' },
    { value: 'balasinor', label: 'Balasinor', pincode: '388255' },
    { value: 'bavla', label: 'Bavla', pincode: '388003' },
    { value: 'bhadran', label: 'Bhadran', pincode: '388530' },
    { value: 'borsad', label: 'Borsad', pincode: '388540' },
    { value: 'bujpur', label: 'Bujpur', pincode: '388201' },
    { value: 'chikhli', label: 'Chikhli', pincode: '388512' },
    { value: 'dahej', label: 'Dahej', pincode: '392130' },
    { value: 'dakor', label: 'Dakor', pincode: '388225' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gopalpura', label: 'Gopalpura', pincode: '388010' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'halol', label: 'Halol', pincode: '389350' },
    { value: 'jambughoda', label: 'Jambughoda', pincode: '389150' },
    { value: 'karamsad', label: 'Karamsad', pincode: '388325' },
    { value: 'khambhat', label: 'Khambhat', pincode: '388620' },
    { value: 'mandal', label: 'Mandal', pincode: '388001' },
    { value: 'mansa', label: 'Mansa', pincode: '388100' },
    { value: 'modasa', label: 'Modasa', pincode: '383315' },
    { value: 'nadiad', label: 'Nadiad', pincode: '387001' },
    { value: 'petlad', label: 'Petlad', pincode: '388450' },
    { value: 'sardar-vallabhbhai', label: 'Sardar Vallabhbhai', pincode: '388204' },
    { value: 'thasra', label: 'Thasra', pincode: '388230' },
    { value: 'umla', label: 'Umla', pincode: '388209' },
    { value: 'umreth', label: 'Umreth', pincode: '388220' },
    { value: 'vada', label: 'Vada', pincode: '388320' },
    { value: 'vasad', label: 'Vasad', pincode: '388306' },
    { value: 'vav', label: 'Vav', pincode: '385570' },
    { value: 'vidyanagar', label: 'Vidyanagar', pincode: '388120' },
    { value: 'zankhvav', label: 'Zankhvav', pincode: '388225' }
  ],

  'amreli': [
    { value: 'adhelai', label: 'Adhelai', pincode: '365601' },
    { value: 'amreli', label: 'Amreli', pincode: '365601' },
    { value: 'bagasara', label: 'Bagasara', pincode: '365440' },
    { value: 'bavla', label: 'Bavla', pincode: '365610' },
    { value: 'bhesan', label: 'Bhesan', pincode: '365601' },
    { value: 'bholav', label: 'Bholav', pincode: '365640' },
    { value: 'bhavpur', label: 'Bhavpur', pincode: '365601' },
    { value: 'botad', label: 'Botad', pincode: '364710' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '365610' },
    { value: 'chavand', label: 'Chavand', pincode: '365610' },
    { value: 'chhatrala', label: 'Chhatrala', pincode: '365641' },
    { value: 'devgadh', label: 'Devgadh', pincode: '365630' },
    { value: 'gadhada', label: 'Gadhada', pincode: '365730' },
    { value: 'gothra', label: 'Gothra', pincode: '365630' },
    { value: 'hurada', label: 'Hurada', pincode: '365650' },
    { value: 'jafrabad', label: 'Jafrabad', pincode: '365540' },
    { value: 'kankot', label: 'Kankot', pincode: '365610' },
    { value: 'kanod', label: 'Kanod', pincode: '365601' },
    { value: 'kherdi', label: 'Kherdi', pincode: '365621' },
    { value: 'khodiyar', label: 'Khodiyar', pincode: '365601' },
    { value: 'kotda', label: 'Kotda', pincode: '365620' },
    { value: 'madhavpur', label: 'Madhavpur', pincode: '365602' },
    { value: 'malvan', label: 'Malvan', pincode: '365601' },
    { value: 'manavadar', label: 'Manavadar', pincode: '362630' },
    { value: 'mangrol', label: 'Mangrol', pincode: '365530' },
    { value: 'mota-heda', label: 'Mota Heda', pincode: '365603' },
    { value: 'padadhari', label: 'Padadhari', pincode: '365400' },
    { value: 'rajkot', label: 'Rajkot', pincode: '360001' },
    { value: 'rajula', label: 'Rajula', pincode: '365150' },
    { value: 'sankhda', label: 'Sankhda', pincode: '365240' },
    { value: 'saras', label: 'Saras', pincode: '365650' },
    { value: 'sartanpada', label: 'Sartanpada', pincode: '365702' },
    { value: 'savaj', label: 'Savaj', pincode: '365601' },
    { value: 'saverkheda', label: 'Saverkheda', pincode: '365630' },
    { value: 'shihor', label: 'Shihor', pincode: '365240' },
    { value: 'simar', label: 'Simar', pincode: '365620' },
    { value: 'sorath', label: 'Sorath', pincode: '365630' },
    { value: 'tulsi', label: 'Tulsi', pincode: '365650' },
    { value: 'thadi', label: 'Thadi', pincode: '365730' },
    { value: 'vadadla', label: 'Vadadla', pincode: '365640' },
    { value: 'vadi', label: 'Vadi', pincode: '365601' },
    { value: 'valad', label: 'Valad', pincode: '365602' },
    { value: 'vav', label: 'Vav', pincode: '365611' },
    { value: 'vavdi', label: 'Vavdi', pincode: '365621' },
    { value: 'vijapur', label: 'Vijapur', pincode: '365610' },
    { value: 'vithalapur', label: 'Vithalapur', pincode: '365630' },
    { value: 'wadhwan', label: 'Wadhwan', pincode: '365730' }
  ],

'ahwa': [
  { "value": "ahwa", "label": "Ahwa", "pincode": "394710" },
  { "value": "ahwadangs", "label": "Ahwadangs", "pincode": "394710" },
  { "value": "barkhandhia", "label": "Barkhandhia", "pincode": "394730" },
  { "value": "bhavandgad", "label": "Bhavandgad", "pincode": "394710" },
  { "value": "borkhal", "label": "Borkhal", "pincode": "394710" },
  { "value": "chankhal", "label": "Chankhal", "pincode": "394710" },
  { "value": "chikar", "label": "Chikar", "pincode": "394730" },
  { "value": "chikatia", "label": "Chikatia", "pincode": "394710" },
  { "value": "chinchli", "label": "Chinchli", "pincode": "394710" },
  { "value": "dagadiamba", "label": "Dagadiamba", "pincode": "394730" },
  { "value": "dhavlidhod", "label": "Dhavlidhod", "pincode": "394710" },
  { "value": "galkund", "label": "Galkund", "pincode": "394710" },
  { "value": "garakhadi", "label": "Garakhadi", "pincode": "394710" },
  { "value": "ghadvi", "label": "Ghadvi", "pincode": "394710" },
  { "value": "gondalvihir", "label": "Gondalvihir", "pincode": "394710" },
  { "value": "jakhana", "label": "Jakhana", "pincode": "394710" },
  { "value": "jhavda", "label": "Jhavda", "pincode": "394710" },
  { "value": "kadmal", "label": "Kadmal", "pincode": "394710" },
  { "value": "keshbandh", "label": "Keshbandh", "pincode": "394710" },
  { "value": "khambhala", "label": "Khambhala", "pincode": "394710" },
  { "value": "lavchali", "label": "Lavchali", "pincode": "394710" },
  { "value": "linga", "label": "Linga", "pincode": "394710" },
  { "value": "mahalpada", "label": "Mahalpada", "pincode": "394710" },
  { "value": "mahwshkatri", "label": "Mahwshkatri", "pincode": "394710" },
  { "value": "malegaon", "label": "Malegaon", "pincode": "394710" },
  { "value": "manmodi", "label": "Manmodi", "pincode": "394710" },
  { "value": "morzira", "label": "Morzira", "pincode": "394710" },
  { "value": "nadagchond", "label": "Nadagchond", "pincode": "394710" },
  { "value": "nakatia-hanvant", "label": "Nakatia Hanvant", "pincode": "394710" },
  { "value": "nanapada", "label": "Nanapada", "pincode": "394710" },
  { "value": "nishana", "label": "Nishana", "pincode": "394710" },
  { "value": "pandva", "label": "Pandva", "pincode": "394710" },
  { "value": "pimpri", "label": "Pimpri", "pincode": "394715" },
  { "value": "piplaidevi", "label": "Piplaidevi", "pincode": "394710" },
  { "value": "rambhas", "label": "Rambhas", "pincode": "394710" },
  { "value": "sakarpatal", "label": "Sakarpatal", "pincode": "394710" },
  { "value": "samgahan", "label": "Samgahan", "pincode": "394710" },
  { "value": "saputara", "label": "Saputara", "pincode": "394720" },
  { "value": "singana", "label": "Singana", "pincode": "394710" },
  { "value": "subir", "label": "Subir", "pincode": "394716" },
  { "value": "tanklipada", "label": "Tanklipada", "pincode": "394710" },
  { "value": "vasurna", "label": "Vasurna", "pincode": "394710" },
  { "value": "waghai", "label": "Waghai", "pincode": "394730" }
  ],
  
  'botad': [
  { "value": "bambhan", "label": "Bambhan", "pincode": "364710" },
  { "value": "bhadravadi", "label": "Bhadravadi", "pincode": "364710" },
  { "value": "bhimdad", "label": "Bhimdad", "pincode": "364710" },
  { "value": "botad", "label": "Botad", "pincode": "364710" },
  { "value": "botad-station-road", "label": "Botad Station Road", "pincode": "364710" },
  { "value": "botad-town", "label": "Botad Town", "pincode": "364710" },
  { "value": "dhakania", "label": "Dhakania", "pincode": "364710" },
  { "value": "haddad", "label": "Haddad", "pincode": "364710" },
  { "value": "kariyani", "label": "Kariyani", "pincode": "364710" },
  { "value": "lathidad", "label": "Lathidad", "pincode": "364710" },
  { "value": "nagalpar", "label": "Nagalpar", "pincode": "364710" },
  { "value": "rangpur", "label": "Rangpur", "pincode": "364710" },
  { "value": "salaiya", "label": "Salaiya", "pincode": "364710" },
  { "value": "samadhiyala-no-1", "label": "Samadhiyala No. 1", "pincode": "364710" },
  { "value": "samadhiyala-no-2", "label": "Samadhiyala No. 2", "pincode": "364710" },
  { "value": "sangvadar", "label": "Sangvadar", "pincode": "364710" },
  { "value": "sherthali", "label": "Sherthali", "pincode": "364710" },
  { "value": "tajpar", "label": "Tajpar", "pincode": "364710" },
  { "value": "targhara", "label": "Targhara", "pincode": "364710" },
  { "value": "turkha", "label": "Turkha", "pincode": "364710" },
  { "value": "zamrala", "label": "Zamrala", "pincode": "364710" }
  ],
  
  'patan': [
  { "value": "abiyana", "label": "Abiyana", "pincode": "385360" },
  { "value": "abluva", "label": "Abluva", "pincode": "384285" },
  { "value": "adgam", "label": "Adgam", "pincode": "384245" },
  { "value": "adiya", "label": "Adiya", "pincode": "384255" },
  { "value": "aghar", "label": "Aghar", "pincode": "384265" },
  { "value": "agichana", "label": "Agichana", "pincode": "385360" },
  { "value": "ajimana", "label": "Ajimana", "pincode": "384265" },
  { "value": "allahabad", "label": "Allahabad", "pincode": "385340" },
  { "value": "amrapura", "label": "Amrapura", "pincode": "384245" },
  { "value": "anawada", "label": "Anawada", "pincode": "384265" },
  { "value": "anvarpura", "label": "Anvarpura", "pincode": "384245" },
  { "value": "aritha", "label": "Aritha", "pincode": "384240" },
  { "value": "arjansar", "label": "Arjansar", "pincode": "385340" },
  { "value": "babra", "label": "Babra", "pincode": "385360" },
  { "value": "balisana", "label": "Balisana", "pincode": "384110" },
  { "value": "bamroli", "label": "Bamroli", "pincode": "385360" },
  { "value": "bandhvad", "label": "Bandhvad", "pincode": "385340" },
  { "value": "baspa", "label": "Baspa", "pincode": "384245" },
  { "value": "bepadar", "label": "Bepadar", "pincode": "384272" },
  { "value": "bhadrada", "label": "Bhadrada", "pincode": "384245" },
  { "value": "bhatsan", "label": "Bhatsan", "pincode": "384285" },
  { "value": "bhilot", "label": "Bhilot", "pincode": "385340" },
  { "value": "bhilvan", "label": "Bhilvan", "pincode": "384285" },
  { "value": "bilian", "label": "Bilian", "pincode": "384240" },
  { "value": "bilian", "label": "Bilian", "pincode": "384151" },
  { "value": "bolera", "label": "Bolera", "pincode": "384246" },
  { "value": "boratwada", "label": "Boratwada", "pincode": "384240" },
  { "value": "borsan", "label": "Borsan", "pincode": "384275" },
  { "value": "brahmanwada", "label": "Brahmanwada", "pincode": "384220" },
  { "value": "chalvada", "label": "Chalvada", "pincode": "385340" },
  { "value": "chanasma", "label": "Chanasma", "pincode": "384220" },
  { "value": "chandravati", "label": "Chandravati", "pincode": "384151" },
  { "value": "chandrumana", "label": "Chandrumana", "pincode": "384255" },
  { "value": "chandur-moti", "label": "Chandur Moti", "pincode": "384241" },
  { "value": "chandur-nani", "label": "Chandur Nani", "pincode": "384245" },
  { "value": "charanka", "label": "Charanka", "pincode": "385350" }
  ],
  
  'chaklasi': [
  { "value": "abhripur", "label": "Abhripur", "pincode": "387335" },
  { "value": "abvel", "label": "Abvel", "pincode": "387650" },
  { "value": "agichana", "label": "Agichana", "pincode": "385360" },
  { "value": "ajupura", "label": "Ajupura", "pincode": "388225" },
  { "value": "akhdol", "label": "Akhdol", "pincode": "387355" },
  { "value": "alina", "label": "Alina", "pincode": "387305" },
  { "value": "ambav", "label": "Ambav", "pincode": "388250" },
  { "value": "angadi", "label": "Angadi", "pincode": "388250" },
  { "value": "barbirpur", "label": "Barbirpur", "pincode": "388265" },
  { "value": "bhadrasa", "label": "Bhadrasa", "pincode": "388230" },
  { "value": "bhanthala", "label": "Bhanthala", "pincode": "388255" },
  { "value": "bharodi", "label": "Bharodi", "pincode": "388260" },
  { "value": "bhavan-s-college", "label": "Bhavan S College", "pincode": "388225" },
  { "value": "birpur", "label": "Birpur", "pincode": "388260" },
  { "value": "bordikheda", "label": "Bordikheda", "pincode": "388225" },
  { "value": "chandasar", "label": "Chandasar", "pincode": "388225" },
  { "value": "chetarsumba", "label": "Chetarsumba", "pincode": "388225" },
  { "value": "chitlav", "label": "Chitlav", "pincode": "388230" },
  { "value": "dabhali", "label": "Dabhali", "pincode": "388250" },
  { "value": "dakor", "label": "Dakor", "pincode": "388225" },
  { "value": "debharivirpur", "label": "Debharivirpur", "pincode": "388260" },
  { "value": "devbalasinor", "label": "Devbalasinor", "pincode": "388265" },
  { "value": "dhunadra", "label": "Dhunadra", "pincode": "388230" },
  { "value": "dhundi", "label": "Dhundi", "pincode": "388250" },
  { "value": "felsani", "label": "Felsani", "pincode": "388255" }
  ],
  
  
  'chhota-udepur': [
  { "value": "ambala", "label": "Ambala", "pincode": "391165" },
  { "value": "bodeli", "label": "Bodeli", "pincode": "391135" },
  { "value": "chhota-udepur", "label": "Chhota Udepur", "pincode": "391165" },
  { "value": "chisadiya", "label": "Chisadiya", "pincode": "391165" },
  { "value": "dhandhoda", "label": "Dhandhoda", "pincode": "391165" },
  { "value": "dholi-simal", "label": "Dholi Simal", "pincode": "391165" },
  { "value": "dolaria", "label": "Dolaria", "pincode": "391165" },
  { "value": "ekalbada", "label": "Ekalbada", "pincode": "391165" },
  { "value": "ghelawant", "label": "Ghelawant", "pincode": "391165" },
  { "value": "khadkhad", "label": "Khadkhad", "pincode": "391165" },
  { "value": "kundal", "label": "Kundal", "pincode": "391165" },
  { "value": "mandlava", "label": "Mandlava", "pincode": "391165" },
  { "value": "mithibor", "label": "Mithibor", "pincode": "391165" },
  { "value": "padharwant", "label": "Padharwant", "pincode": "391165" },
  { "value": "puniavant", "label": "Puniavant", "pincode": "391165" },
  { "value": "rangpurz", "label": "Rangpurz", "pincode": "391165" },
  { "value": "sanada", "label": "Sanada", "pincode": "391165" },
  { "value": "surkheda", "label": "Surkheda", "pincode": "391165" },
  { "value": "virpur", "label": "Virpur", "pincode": "391165" },
  { "value": "zoz", "label": "Zoz", "pincode": "391165" }
  ],
  
  
  'dahod': [
  { "value": "agavada", "label": "Agavada", "pincode": "389154" },
  { "value": "bavka", "label": "Bavka", "pincode": "389152" },
  { "value": "bharamkheda", "label": "Bharamkheda", "pincode": "389160" },
  { "value": "chakalia", "label": "Chakalia", "pincode": "389180" },
  { "value": "dahod", "label": "Dahod", "pincode": "389151" },
  { "value": "dholi-simal", "label": "Dholi Simal", "pincode": "391165" },
  { "value": "dudhia", "label": "Dudhia", "pincode": "389146" },
  { "value": "dungri", "label": "Dungri", "pincode": "389180" },
  { "value": "freelandganj", "label": "Freelandganj", "pincode": "389160" },
  { "value": "gamdi", "label": "Gamdi", "pincode": "389170" },
  { "value": "gangardi", "label": "Gangardi", "pincode": "389155" },
  { "value": "jhalod", "label": "Jhalod", "pincode": "389170" },
  { "value": "jhamri", "label": "Jhamri", "pincode": "389175" },
  { "value": "kali-dungri", "label": "Kali Dungri", "pincode": "389380" },
  { "value": "kaliarai", "label": "Kaliarai", "pincode": "389180" },
  { "value": "kaliavad", "label": "Kaliavad", "pincode": "389152" },
  { "value": "kheda", "label": "Kheda", "pincode": "389151" },
  { "value": "limkheda", "label": "Limkheda", "pincode": "389140" },
  { "value": "machhelai", "label": "Machhelai", "pincode": "389130" },
  { "value": "mandli", "label": "Mandli", "pincode": "389175" },
  { "value": "mandor", "label": "Mandor", "pincode": "389155" },
  { "value": "manli", "label": "Manli", "pincode": "389140" },
  { "value": "moli", "label": "Moli", "pincode": "389175" },
  { "value": "nava-nagar", "label": "Nava Nagar", "pincode": "389155" },
  { "value": "nava-vadia", "label": "Nava Vadia", "pincode": "389146" },
  { "value": "navagam", "label": "Navagam", "pincode": "389151" },
  { "value": "padharwant", "label": "Padharwant", "pincode": "391165" },
  { "value": "puniavant", "label": "Puniavant", "pincode": "391165" },
  { "value": "rangpurz", "label": "Rangpurz", "pincode": "391165" },
  { "value": "sanada", "label": "Sanada", "pincode": "391165" },
  { "value": "surkheda", "label": "Surkheda", "pincode": "391165" },
  { "value": "virpur", "label": "Virpur", "pincode": "391165" },
  { "value": "zoz", "label": "Zoz", "pincode": "391165" }
  ],
  
  'dhoraji': [
  { "value": "agavada", "label": "Agavada", "pincode": "360410" },
  { "value": "bhader", "label": "Bhader", "pincode": "360410" },
  { "value": "bhola", "label": "Bhola", "pincode": "360410" },
  { "value": "bhukhi", "label": "Bhukhi", "pincode": "360410" },
  { "value": "chhadvavadar", "label": "Chhadvavadar", "pincode": "360410" },
  { "value": "chhatrasa", "label": "Chhatrasa", "pincode": "360410" },
  { "value": "chikhaliya", "label": "Chikhaliya", "pincode": "360410" },
  { "value": "dhoraji", "label": "Dhoraji", "pincode": "360410" },
  { "value": "dudhivadar", "label": "Dudhivadar", "pincode": "360410" },
  { "value": "jamnavad", "label": "Jamnavad", "pincode": "360410" },
  { "value": "kalana", "label": "Kalana", "pincode": "360410" },
  { "value": "nagalkhada", "label": "Nagalkhada", "pincode": "360410" },
  { "value": "pipaliya", "label": "Pipaliya", "pincode": "360410" },
  { "value": "raidi", "label": "Raidi", "pincode": "360410" },
  { "value": "roghel", "label": "Roghel", "pincode": "360410" },
  { "value": "vadodar", "label": "Vadodar", "pincode": "360410" }
  ],
  
  
  'dudhrej': [
  { "value": "bakarthali", "label": "Bakarthali", "pincode": "363040" },
  { "value": "bhadreshi", "label": "Bhadreshi", "pincode": "363040" },
  { "value": "chamaraj", "label": "Chamaraj", "pincode": "363040" },
  { "value": "dudhrej", "label": "Dudhrej", "pincode": "363040" },
  { "value": "gujarvadi", "label": "Gujarvadi", "pincode": "363040" },
  { "value": "katuda", "label": "Katuda", "pincode": "363040" },
  { "value": "khodu", "label": "Khodu", "pincode": "363040" },
  { "value": "mota-ankevaliya", "label": "Mota Ankevaliya", "pincode": "363040" },
  { "value": "nagra", "label": "Nagra", "pincode": "363040" },
  { "value": "ravaliyavadar", "label": "Ravaliyavadar", "pincode": "363040" },
  { "value": "velavadar", "label": "Velavadar", "pincode": "363040" }
  ],
  
  'dwarka.': [
  { "value": "baradia", "label": "Baradia", "pincode": "361335" },
  { "value": "charakala", "label": "Charakala", "pincode": "361335" },
  { "value": "dhinki", "label": "Dhinki", "pincode": "361335" },
  { "value": "dwarka", "label": "Dwarka", "pincode": "361335" },
  { "value": "dwarka-town", "label": "Dwarka Town", "pincode": "361335" },
  { "value": "gadhechi", "label": "Gadhechi", "pincode": "361335" },
  { "value": "kalyanpur", "label": "Kalyanpur", "pincode": "361335" },
  { "value": "khatumba", "label": "Khatumba", "pincode": "361335" },
  { "value": "kuranga", "label": "Kuranga", "pincode": "361335" },
  { "value": "nanabhavda", "label": "Nanabhavda", "pincode": "361335" },
  { "value": "okhamadhi", "label": "Okhamadhi", "pincode": "361335" },
  { "value": "positra", "label": "Positra", "pincode": "361335" },
  { "value": "rajpara", "label": "Rajpara", "pincode": "361335" },
  { "value": "tupni", "label": "Tupni", "pincode": "361335" },
  { "value": "varvala", "label": "Varvala", "pincode": "361335" },
  { "value": "vasai", "label": "Vasai", "pincode": "361335" },
  { "value": "vadinar", "label": "Vadinar", "pincode": "361010" }
  ],
  
  'gondal': [
  { "value": "adbalka", "label": "Adbalka", "pincode": "360110" },
  { "value": "ajmer", "label": "Ajmer", "pincode": "360055" },
  { "value": "akala", "label": "Akala", "pincode": "360360" },
  { "value": "amarnagar", "label": "Amarnagar", "pincode": "364485" },
  { "value": "amrapar-jasdan", "label": "Amrapar Jasdan", "pincode": "360055" },
  { "value": "amrapar-upleta", "label": "Amrapar Upleta", "pincode": "360490" },
  { "value": "anandpar-morbi", "label": "Anandpar Morbi", "pincode": "360003" },
  { "value": "anandpar-navagam", "label": "Anandpar Navagam", "pincode": "360003" },
  { "value": "atkot", "label": "Atkot", "pincode": "360040" },
  { "value": "bhayavadar", "label": "Bhayavadar", "pincode": "360450" },
  { "value": "jam-kandorana", "label": "Jam Kandorana", "pincode": "360405" },
  { "value": "jetpur", "label": "Jetpur", "pincode": "360370" },
  { "value": "kotda-sangani", "label": "Kotda Sangani", "pincode": "360030" },
  { "value": "lodhika", "label": "Lodhika", "pincode": "360035" },
  { "value": "paddhari", "label": "Paddhari", "pincode": "360110" },
  { "value": "rajkot", "label": "Rajkot", "pincode": "360001" },
  { "value": "vinchhiya", "label": "Vinchhiya", "pincode": "360055" }
  ],
  
  'jasdan': [
  { "value": "ajmer", "label": "Ajmer", "pincode": "360055" },
  { "value": "amrapar", "label": "Amrapar", "pincode": "360055" },
  { "value": "atkot", "label": "Atkot", "pincode": "360040" },
  { "value": "bakhalvad", "label": "Bakhalvad", "pincode": "360050" },
  { "value": "bhadala", "label": "Bhadala", "pincode": "360050" },
  { "value": "gokhlana", "label": "Gokhlana", "pincode": "360050" },
  { "value": "kaduka", "label": "Kaduka", "pincode": "360050" },
  { "value": "kalasar", "label": "Kalasar", "pincode": "360050" },
  { "value": "lilapur", "label": "Lilapur", "pincode": "360050" },
  { "value": "vadod", "label": "Vadod", "pincode": "360050" },
  { "value": "vajsurpara", "label": "Vajsurpara", "pincode": "360050" }
  ],
  
  'jetpur': [
  { "value": "akala", "label": "Akala", "pincode": "360360" },
  { "value": "amarnagar", "label": "Amarnagar", "pincode": "364485" },
  { "value": "bava-pipaliya", "label": "Bava Pipaliya", "pincode": "360360" },
  { "value": "champrajpur", "label": "Champrajpur", "pincode": "360370" },
  { "value": "charania", "label": "Charania", "pincode": "365480" },
  { "value": "derdi", "label": "Derdi", "pincode": "360370" },
  { "value": "devki-galol", "label": "Devki Galol", "pincode": "360370" },
  { "value": "fareni", "label": "Fareni", "pincode": "360370" },
  { "value": "jambudi", "label": "Jambudi", "pincode": "360370" },
  { "value": "jetpur", "label": "Jetpur", "pincode": "360370" },
  { "value": "jetpur-f-w-nd-t-s-o", "label": "Jetpur F.W. ND T.S.O", "pincode": "360370" },
  { "value": "jetpur-k-b-nd-t-s-o", "label": "Jetpur K.B. ND T.S.O", "pincode": "360370" },
  { "value": "kerali", "label": "Kerali", "pincode": "360370" },
  { "value": "kharachiya", "label": "Kharachiya", "pincode": "360370" },
  { "value": "mandlikpur", "label": "Mandlikpur", "pincode": "360370" },
  { "value": "mevasa", "label": "Mevasa", "pincode": "360370" },
  { "value": "mota-gundala", "label": "Mota Gundala", "pincode": "360370" },
  { "value": "panch-pipla", "label": "Panch Pipla", "pincode": "360370" },
  { "value": "pedhla", "label": "Pedhla", "pincode": "360370" },
  { "value": "pithadia", "label": "Pithadia", "pincode": "360370" },
  { "value": "premgadh", "label": "Premgadh", "pincode": "360370" },
  { "value": "rabarika", "label": "Rabarika", "pincode": "360370" },
  { "value": "reshamdi-galol", "label": "Reshamdi Galol", "pincode": "360370" },
  { "value": "samadhiyala", "label": "Samadhiyala", "pincode": "360370" },
  { "value": "thana-galol", "label": "Thana Galol", "pincode": "360370" }
  ],
  
  'kandla': [
  { value: 'abdasa', label: 'Abdasa', pincode: '370601' },
  { value: 'adipur', label: 'Adipur', pincode: '370205' },
  { value: 'bhuj', label: 'Bhuj', pincode: '370001' },
  { value: 'bhujodi', label: 'Bhujodi', pincode: '370020' },
  { value: 'gandhidham', label: 'Gandhidham', pincode: '370201' },
  { value: 'mandvi', label: 'Mandvi', pincode: '370465' },
  { value: 'mukteshwar', label: 'Mukteshwar', pincode: '370417' },
  { value: 'shikarpur', label: 'Shikarpur', pincode: '370409' },
  { value: 'vijayvadi', label: 'Vijayvadi', pincode: '370459' },
  { value: 'tunda', label: 'Tunda', pincode: '370460' },
  { value: 'khavda', label: 'Khavda', pincode: '370620' },
  { value: 'nakhtrana', label: 'Nakhtrana', pincode: '370601' },
  { value: 'mundra', label: 'Mundra', pincode: '370421' },
  { value: 'mithi', label: 'Mithi', pincode: '370446' },
  { value: 'kunj', label: 'Kunj', pincode: '370205' },
  { value: 'dholavira', label: 'Dholavira', pincode: '370510' },
  { value: 'vandh', label: 'Vandh', pincode: '370415' },
  { value: 'kandalgate', label: 'Kandalgate', pincode: '370201' },
  ],
  
  'katihar': [
  { value: 'agarwa', label: 'Agarwa', pincode: '854101' },
  { value: 'balrampur', label: 'Balrampur', pincode: '854105' },
  { value: 'bhagalpur', label: 'Bhagalpur', pincode: '854101' },
  { value: 'chandpur', label: 'Chandpur', pincode: '854213' },
  { value: 'dholbani', label: 'Dholbani', pincode: '854108' },
  { value: 'katihar', label: 'Katihar', pincode: '854105' },
  { value: 'kharibari', label: 'Kharibari', pincode: '854114' },
  { value: 'kishanganj', label: 'Kishanganj', pincode: '854105' },
  { value: 'manihari', label: 'Manihari', pincode: '854113' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '854111' },
  { value: 'nawanagar', label: 'Nawanagar', pincode: '854207' },
  { value: 'purnia', label: 'Purnia', pincode: '854301' },
  { value: 'raiganj', label: 'Raiganj', pincode: '854205' },
  { value: 'samaspur', label: 'Samaspur', pincode: '854108' },
  { value: 'sahabganj', label: 'Sahabganj', pincode: '854102' },
  { value: 'saraigarh', label: 'Saraigarh', pincode: '854202' },
  { value: 'sultanganj', label: 'Sultanganj', pincode: '854210' },
  { value: 'thakurganj', label: 'Thakurganj', pincode: '854206' },
  { value: 'sonadih', label: 'Sonadih', pincode: '854101' },
  { value: 'amraipur', label: 'Amraipur', pincode: '854203' },
  { value: 'hasanpur', label: 'Hasanpur', pincode: '854109' },
  { value: 'bahadurpur', label: 'Bahadurpur', pincode: '854104' },
  { value: 'keshopur', label: 'Keshopur', pincode: '854210' },
  { value: 'patwaria', label: 'Patwaria', pincode: '854107' },
  { value: 'pothia', label: 'Pothia', pincode: '854208' }
  ],
  
  'khambhalia': [
  { value: 'bhadiya', label: 'Bhadiya', pincode: '361305' },
  { value: 'bajana', label: 'Bajana', pincode: '361210' },
  { value: 'chhapar', label: 'Chhapar', pincode: '361210' },
  { value: 'dhrol', label: 'Dhrol', pincode: '361210' },
  { value: 'khambhalia', label: 'Khambhalia', pincode: '361305' },
  { value: 'kumbharia', label: 'Kumbharia', pincode: '361305' },
  { value: 'lodhiya', label: 'Lodhiyal', pincode: '361220' },
  { value: 'manavadar', label: 'Manavadar', pincode: '361220' },
  { value: 'miyani', label: 'Miyani', pincode: '361305' },
  { value: 'palitana', label: 'Palitana', pincode: '361220' },
  { value: 'rajpara', label: 'Rajpara', pincode: '361305' },
  { value: 'sangdara', label: 'Sangdara', pincode: '361305' },
  { value: 'sanjan', label: 'Sanjan', pincode: '361305' },
  { value: 'tundav', label: 'Tundav', pincode: '361305' },
  { value: 'bhayavadar', label: 'Bhayavadar', pincode: '361320' },
  { value: 'gondal', label: 'Gondal', pincode: '361230' },
  { value: 'madhapar', label: 'Madhapar', pincode: '361001' },
  { value: 'veraval', label: 'Veraval', pincode: '361200' },
  { value: 'ranpur', label: 'Ranpur', pincode: '361210' },
  { value: 'vavdi', label: 'Vavdi', pincode: '361305' },
  { value: 'bhayavadar', label: 'Bhayavadar', pincode: '361320' }
  ],
  
  'khambhat': [
  { value: 'adkoli', label: 'Adkoli', pincode: '388620' },
  { value: 'bajwa', label: 'Bajwa', pincode: '388620' },
  { value: 'bhavanipura', label: 'Bhavanipura', pincode: '388620' },
  { value: 'bhrampur', label: 'Bhrampur', pincode: '388620' },
  { value: 'dholera', label: 'Dholera', pincode: '388150' },
  { value: 'ghorawadi', label: 'Ghorawadi', pincode: '388620' },
  { value: 'khambhat', label: 'Khambhat', pincode: '388620' },
  { value: 'khambhat-port', label: 'Khambhat Port', pincode: '388620' },
  { value: 'kharwa', label: 'Kharwa', pincode: '388620' },
  { value: 'mandvi', label: 'Mandvi', pincode: '388640' },
  { value: 'moti-porbandar', label: 'Moti Porbandar', pincode: '388620' },
  { value: 'nadiad', label: 'Nadiad', pincode: '388001' },
  { value: 'piplod', label: 'Piplod', pincode: '388620' },
  { value: 'rajpur', label: 'Rajpur', pincode: '388650' },
  { value: 'sarthana', label: 'Sarthana', pincode: '388620' },
  { value: 'sundarwadi', label: 'Sundarwadi', pincode: '388620' },
  { value: 'vavdi', label: 'Vavdi', pincode: '388620' },
  { value: 'zampa', label: 'Zampa', pincode: '388620' },
  { value: 'kheda', label: 'Kheda', pincode: '388620' },
  { value: 'lavachha', label: 'Lavachha', pincode: '388620' },
  { value: 'moti-porbandar-bhavanipura', label: 'Moti Porbandar Bhavanipura', pincode: '388620' },
  { value: 'narmada', label: 'Narmada', pincode: '388620' },
  { value: 'rampura', label: 'Rampura', pincode: '388620' },
  { value: 'samsara', label: 'Samsara', pincode: '388620' },
  { value: 'sithpur', label: 'Sithpur', pincode: '388620' }
  ],
  
  'limkheda': [
  { value: 'adval', label: 'Adval', pincode: '391110' },
  { value: 'bhalod', label: 'Bhalod', pincode: '391120' },
  { value: 'bhilvadi', label: 'Bhilvadi', pincode: '391110' },
  { value: 'dhanpur', label: 'Dhanpur', pincode: '391110' },
  { value: 'gokal', label: 'Gokal', pincode: '391110' },
  { value: 'khandvi', label: 'Khandvi', pincode: '391140' },
  { value: 'limkheda', label: 'Limkheda', pincode: '391140' },
  { value: 'manjrol', label: 'Manjrol', pincode: '391120' },
  { value: 'nareshwar', label: 'Nareshwar', pincode: '391110' },
  { value: 'pataliya', label: 'Pataliya', pincode: '391110' },
  { value: 'rajkot', label: 'Rajkot', pincode: '391120' },
  { value: 'saranvadi', label: 'Saranvadi', pincode: '391140' },
  { value: 'suryapur', label: 'Suryapur', pincode: '391110' },
  { value: 'valasan', label: 'Valasan', pincode: '391140' },
  { value: 'vancha', label: 'Vancha', pincode: '391110' },
  { value: 'bhamai', label: 'Bhamai', pincode: '391110' },
  { value: 'chela', label: 'Chela', pincode: '391110' },
  { value: 'dolatpara', label: 'Dolatpara', pincode: '391110' },
  { value: 'ganjari', label: 'Ganjari', pincode: '391110' },
  { value: 'kanzara', label: 'Kanzara', pincode: '391110' },
  { value: 'kheda', label: 'Kheda', pincode: '391110' }
  ],
  
  'lathi': [
  { value: 'adraj', label: 'Adraj', pincode: '364230' },
  { value: 'baliyasan', label: 'Baliyasan', pincode: '364220' },
  { value: 'bujang', label: 'Bujang', pincode: '364235' },
  { value: 'gundlav', label: 'Gundlav', pincode: '364220' },
  { value: 'lathi', label: 'Lathi', pincode: '364230' },
  { value: 'mandvi', label: 'Mandvi', pincode: '364245' },
  { value: 'nani-kosamba', label: 'Nani Kosamba', pincode: '364245' },
  { value: 'pansar', label: 'Pansar', pincode: '364230' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '364220' },
  { value: 'samlaya', label: 'Samlaya', pincode: '364220' },
  { value: 'sanjeli', label: 'Sanjeli', pincode: '364245' },
  { value: 'sarthana', label: 'Sarthana', pincode: '364240' },
  { value: 'thana', label: 'Thana', pincode: '364230' },
  { value: 'vadhvaniya', label: 'Vadhvaniya', pincode: '364220' },
  { value: 'valasan', label: 'Valasan', pincode: '364230' },
  { value: 'vavdi', label: 'Vavdi', pincode: '364230' },
  { value: 'anjani', label: 'Anjani', pincode: '364235' },
  { value: 'bhadi', label: 'Bhadi', pincode: '364220' },
  { value: 'boria', label: 'Boria', pincode: '364220' },
  { value: 'dharmani', label: 'Dharmani', pincode: '364230' },
  { value: 'kosamba', label: 'Kosamba', pincode: '364245' },
  { value: 'manjhi', label: 'Manjhi', pincode: '364245' },
  { value: 'rajpur', label: 'Rajpur', pincode: '364240' },
  { value: 'sarmastpur', label: 'Sarmastpur', pincode: '364220' }
  ],
  
  'lunawada': [
  { value: 'adad', label: 'Adad', pincode: '389230' },
  { value: 'bajwa', label: 'Bajwa', pincode: '389230' },
  { value: 'bhadari', label: 'Bhadari', pincode: '389230' },
  { value: 'bhilvadi', label: 'Bhilvadi', pincode: '389230' },
  { value: 'dudhrej', label: 'Dudhrej', pincode: '389230' },
  { value: 'karesa', label: 'Karesa', pincode: '389230' },
  { value: 'kharwa', label: 'Kharwa', pincode: '389230' },
  { value: 'kheda', label: 'Kheda', pincode: '389230' },
  { value: 'khodiya', label: 'Khodiya', pincode: '389230' },
  { value: 'limdi', label: 'Limdi', pincode: '389150' },
  { value: 'lunawada', label: 'Lunawada', pincode: '389230' },
  { value: 'mandva', label: 'Mandva', pincode: '389230' },
  { value: 'nadiad', label: 'Nadiad', pincode: '389001' },
  { value: 'nani-bhadi', label: 'Nani Bhadi', pincode: '389230' },
  { value: 'pansar', label: 'Pansar', pincode: '389230' },
  { value: 'rampur', label: 'Rampur', pincode: '389230' },
  { value: 'sarthana', label: 'Sarthana', pincode: '389230' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '389230' },
  { value: 'thana', label: 'Thana', pincode: '389230' },
  { value: 'vavdi', label: 'Vavdi', pincode: '389230' },
  { value: 'zampa', label: 'Zampa', pincode: '389230' },
  { value: 'adraj', label: 'Adraj', pincode: '389230' },
  { value: 'balpur', label: 'Balpur', pincode: '389230' },
  { value: 'bhadi', label: 'Bhadi', pincode: '389230' },
  { value: 'bhavnagar', label: 'Bhavnagar', pincode: '389230' },
  { value: 'dholka', label: 'Dholka', pincode: '389230' },
  { value: 'khodiar', label: 'Khodiar', pincode: '389230' },
  { value: 'mota', label: 'Mota', pincode: '389230' }
  ],
  
  'modasa': [
  { value: 'adhelai', label: 'Adhelai', pincode: '383315' },
  { value: 'balasinor', label: 'Balasinor', pincode: '383315' },
  { value: 'bhayla', label: 'Bhayla', pincode: '383315' },
  { value: 'dakha', label: 'Dakha', pincode: '383325' },
  { value: 'dholka', label: 'Dholka', pincode: '383320' },
  { value: 'kanpur', label: 'Kanpur', pincode: '383315' },
  { value: 'khatalwada', label: 'Khatalwada', pincode: '383325' },
  { value: 'modasa', label: 'Modasa', pincode: '383315' },
  { value: 'madhunagar', label: 'Madhunagar', pincode: '383315' },
  { value: 'nakhatrana', label: 'Nakhatrana', pincode: '383315' },
  { value: 'nava', label: 'Nava', pincode: '383320' },
  { value: 'patdi', label: 'Patdi', pincode: '383315' },
  { value: 'rampura', label: 'Rampura', pincode: '383315' },
  { value: 'sachin', label: 'Sachin', pincode: '383315' },
  { value: 'simalwada', label: 'Simalwada', pincode: '383315' },
  { value: 'sodhiya', label: 'Sodhiya', pincode: '383315' },
  { value: 'tharad', label: 'Tharad', pincode: '383325' },
  { value: 'valasan', label: 'Valasan', pincode: '383315' },
  { value: 'vav', label: 'Vav', pincode: '383325' },
  { value: 'zingra', label: 'Zingra', pincode: '383315' },
  { value: 'abheti', label: 'Abheti', pincode: '383315' },
  { value: 'khodiyar', label: 'Khodiyar', pincode: '383320' },
  { value: 'sartal', label: 'Sartal', pincode: '383315' },
  { value: 'lalpur', label: 'Lalpur', pincode: '383315' },
  { value: 'gunj', label: 'Gunj', pincode: '383315' },
  { value: 'shivrajpur', label: 'Shivrajpur', pincode: '383315' }
  ],
  
  'paddhari': [
  { value: 'adroj', label: 'Adroj', pincode: '360110' },
  { value: 'bajri', label: 'Bajri', pincode: '360110' },
  { value: 'baradia', label: 'Baradia', pincode: '360110' },
  { value: 'bavadi', label: 'Bavadi', pincode: '360110' },
  { value: 'dindrol', label: 'Dindrol', pincode: '360110' },
  { value: 'gadhada', label: 'Gadhada', pincode: '360110' },
  { value: 'jambuda', label: 'Jambuda', pincode: '360110' },
  { value: 'kadi', label: 'Kadi', pincode: '360110' },
  { value: 'kankot', label: 'Kankot', pincode: '360110' },
  { value: 'laxmipura', label: 'Laxmipura', pincode: '360110' },
  { value: 'modhiya', label: 'Modhiya', pincode: '360110' },
  { value: 'paddhari', label: 'Paddhari', pincode: '360110' },
  { value: 'rampara', label: 'Rampara', pincode: '360110' },
  { value: 'rangpur', label: 'Rangpur', pincode: '360110' },
  { value: 'sadar', label: 'Sadar', pincode: '360110' },
  { value: 'sukhpur', label: 'Sukhpur', pincode: '360110' },
  { value: 'thavdi', label: 'Thavdi', pincode: '360110' },
  { value: 'vavdi', label: 'Vavdi', pincode: '360110' },
  { value: 'vishalpur', label: 'Vishalpur', pincode: '360110' },
  { value: 'bhadi', label: 'Bhadi', pincode: '360110' },
  { value: 'bhavanipur', label: 'Bhavanipur', pincode: '360110' },
  { value: 'bori', label: 'Bori', pincode: '360110' },
  { value: 'chandrakal', label: 'Chandrakal', pincode: '360110' },
  { value: 'kothariya', label: 'Kothariya', pincode: '360110' },
  { value: 'tapi', label: 'Tapi', pincode: '360110' },
  { value: 'wadhwana', label: 'Wadhwana', pincode: '360110' }
  ],
  
  'palanpur': [
  { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '385001' },
  { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '385001' },
  { value: 'balaram', label: 'Balaram', pincode: '385001' },
  { value: 'balda', label: 'Balda', pincode: '385001' },
  { value: 'banasana', label: 'Banasana', pincode: '385001' },
  { value: 'bhadran', label: 'Bhadran', pincode: '385001' },
  { value: 'bileshwar', label: 'Bileshwar', pincode: '385001' },
  { value: 'deesa', label: 'Deesa', pincode: '385535' },
  { value: 'gadhada', label: 'Gadhada', pincode: '385001' },
  { value: 'kankrej', label: 'Kankrej', pincode: '385555' },
  { value: 'kheralu', label: 'Kheralu', pincode: '384325' },
  { value: 'manishnagar', label: 'Manishnagar', pincode: '385001' },
  { value: 'modhera', label: 'Modhera', pincode: '384212' },
  { value: 'palanpur', label: 'Palanpur', pincode: '385001' },
  { value: 'patela', label: 'Patela', pincode: '385001' },
  { value: 'radhanpur', label: 'Radhanpur', pincode: '385340' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '385001' },
  { value: 'sankheda', label: 'Sankheda', pincode: '385001' },
  { value: 'shahpur', label: 'Shahpur', pincode: '385001' },
  { value: 'sundhiya', label: 'Sundhiya', pincode: '385001' },
  { value: 'suraj', label: 'Suraj', pincode: '385001' },
  { value: 'vav', label: 'Vav', pincode: '385001' },
  { value: 'vishnupura', label: 'Vishnupura', pincode: '385001' },
  { value: 'dariyapur', label: 'Dariyapur', pincode: '385001' },
  { value: 'jodhpur', label: 'Jodhpur', pincode: '385001' },
  { value: 'khodiyar', label: 'Khodiyar', pincode: '385001' },
  { value: 'laxmipura', label: 'Laxmipura', pincode: '385001' },
  { value: 'navapura', label: 'Navapura', pincode: '385001' },
  { value: 'patel-nagar', label: 'Patel Nagar', pincode: '385001' },
  { value: 'rangpur', label: 'Rangpur', pincode: '385001' },
  { value: 'vavdi', label: 'Vavdi', pincode: '385001' }
  ],
  
  'porbandar': [
  { value: 'adityanagar', label: 'Adityanagar', pincode: '360575' },
  { value: 'bavla', label: 'Bavla', pincode: '360575' },
  { value: 'bhidi', label: 'Bhidi', pincode: '360575' },
  { value: 'gondal', label: 'Gondal', pincode: '360311' },
  { value: 'haripar', label: 'Haripar', pincode: '360575' },
  { value: 'jaliya', label: 'Jaliya', pincode: '360575' },
  { value: 'khambhalia', label: 'Khambhalia', pincode: '361305' },
  { value: 'kutch', label: 'Kutch', pincode: '360575' },
  { value: 'madhavpur', label: 'Madhavpur', pincode: '360440' },
  { value: 'mandvi', label: 'Mandvi', pincode: '360490' },
  { value: 'porbandar', label: 'Porbandar', pincode: '360575' },
  { value: 'radhakishan', label: 'Radhakishan', pincode: '360575' },
  { value: 'rajkot', label: 'Rajkot', pincode: '360001' },
  { value: 'sindhi', label: 'Sindhi', pincode: '360575' },
  { value: 'surdhi', label: 'Suradhi', pincode: '360575' },
  { value: 'tithal', label: 'Tithal', pincode: '360590' },
  { value: 'vanthali', label: 'Vanthali', pincode: '360040' },
  { value: 'vanzari', label: 'Vanzari', pincode: '360575' },
  { value: 'bhojpara', label: 'Bhojpara', pincode: '360575' },
  { value: 'bagvadi', label: 'Bagvadi', pincode: '360575' },
  { value: 'dharmani', label: 'Dharmani', pincode: '360575' },
  { value: 'mangrol', label: 'Mangrol', pincode: '362225' },
  { value: 'mithi', label: 'Mithi', pincode: '360575' },
  { value: 'ramnath', label: 'Ramnath', pincode: '360575' },
  { value: 'sartanpar', label: 'Sartanpar', pincode: '360575' },
  { value: 'shankarwadi', label: 'Shankarwadi', pincode: '360575' },
  { value: 'shyampura', label: 'Shyampura', pincode: '360575' },
  { value: 'vavdi', label: 'Vavdi', pincode: '360575' },
  { value: 'village-patana', label: 'Village Patana', pincode: '360575' },
  { value: 'vijaynagar', label: 'Vijaynagar', pincode: '360575' }
  ],
  
  'prantij': [
  { value: 'adroj', label: 'Adroj', pincode: '383205' },
  { value: 'baladia', label: 'Baladia', pincode: '383205' },
  { value: 'bhandu', label: 'Bhandu', pincode: '383120' },
  { value: 'bhatta', label: 'Bhatta', pincode: '383205' },
  { value: 'chandrapura', label: 'Chandrapura', pincode: '383205' },
  { value: 'dholka', label: 'Dholka', pincode: '383205' },
  { value: 'jalampur', label: 'Jalampur', pincode: '383205' },
  { value: 'jambudi', label: 'Jambudi', pincode: '383205' },
  { value: 'kadi', label: 'Kadi', pincode: '383205' },
  { value: 'madhupura', label: 'Madhupura', pincode: '383205' },
  { value: 'manapur', label: 'Manapur', pincode: '383205' },
  { value: 'matanamadh', label: 'Matanamadh', pincode: '383205' },
  { value: 'panchal', label: 'Panchal', pincode: '383205' },
  { value: 'prantij', label: 'Prantij', pincode: '383205' },
  { value: 'rampara', label: 'Rampara', pincode: '383205' },
  { value: 'rangpur', label: 'Rangpur', pincode: '383205' },
  { value: 'sadar', label: 'Sadar', pincode: '383205' },
  { value: 'sankheda', label: 'Sankheda', pincode: '383205' },
  { value: 'santaram', label: 'Santaram', pincode: '383205' },
  { value: 'suraj', label: 'Suraj', pincode: '383205' },
  { value: 'thavdi', label: 'Thavdi', pincode: '383205' },
  { value: 'vav', label: 'Vav', pincode: '383205' },
  { value: 'vijapur', label: 'Vijapur', pincode: '383410' },
  { value: 'village-bavla', label: 'Village Bavla', pincode: '383205' }
  ],
  
  'rajpipla': [
  { value: 'advalia', label: 'Advalia', pincode: '393145' },
  { value: 'bariya', label: 'Bariya', pincode: '393140' },
  { value: 'bhadran', label: 'Bhadran', pincode: '393145' },
  { value: 'bhayli', label: 'Bhayli', pincode: '393145' },
  { value: 'devpura', label: 'Devpura', pincode: '393140' },
  { value: 'ghumli', label: 'Ghumli', pincode: '393145' },
  { value: 'jambughoda', label: 'Jambughoda', pincode: '393110' },
  { value: 'kanha', label: 'Kanha', pincode: '393145' },
  { value: 'kheda', label: 'Kheda', pincode: '393145' },
  { value: 'khumbaria', label: 'Khumbaria', pincode: '393145' },
  { value: 'patel-nagar', label: 'Patel Nagar', pincode: '393145' },
  { value: 'rajpipla', label: 'Rajpipla', pincode: '393145' },
  { value: 'rathodnagar', label: 'Rathodnagar', pincode: '393145' },
  { value: 'sardarpur', label: 'Sardarpur', pincode: '393145' },
  { value: 'sankheda', label: 'Sankheda', pincode: '393145' },
  { value: 'surkhi', label: 'Surkhi', pincode: '393145' },
  { value: 'tarsam', label: 'Tarsam', pincode: '393145' },
  { value: 'vadi', label: 'Vadi', pincode: '393145' },
  { value: 'vithalpur', label: 'Vithalpur', pincode: '393145' },
  { value: 'waghodia', label: 'Waghodia', pincode: '393145' },
  { value: 'bambhrol', label: 'Bambhrol', pincode: '393145' },
  { value: 'dhanvav', label: 'Dhanvav', pincode: '393145' },
  { value: 'kathwada', label: 'Kathwada', pincode: '393145' },
  { value: 'kishorpura', label: 'Kishorpura', pincode: '393145' },
  { value: 'madhopur', label: 'Madhopur', pincode: '393145' },
  { value: 'manpur', label: 'Manpur', pincode: '393145' },
  { value: 'mota', label: 'Mota', pincode: '393145' },
  { value: 'patan', label: 'Patan', pincode: '393145' },
  { value: 'salun', label: 'Salun', pincode: '393145' },
  { value: 'sikotar', label: 'Sikotar', pincode: '393145' },
  { value: 'surajpura', label: 'Surajpura', pincode: '393145' },
  { value: 'vavdi', label: 'Vavdi', pincode: '393145' }
  ],
  
  'radhanpur': [
  { value: 'adpur', label: 'Adpur', pincode: '385340' },
  { value: 'bada', label: 'Bada', pincode: '385340' },
  { value: 'bhadra', label: 'Bhadra', pincode: '385340' },
  { value: 'bhadiyad', label: 'Bhadiyad', pincode: '385340' },
  { value: 'chandpur', label: 'Chandpur', pincode: '385340' },
  { value: 'datar', label: 'Datar', pincode: '385340' },
  { value: 'gajipur', label: 'Gajipur', pincode: '385340' },
  { value: 'garbada', label: 'Garbada', pincode: '385340' },
  { value: 'jhalod', label: 'Jhalod', pincode: '385340' },
  { value: 'kakadva', label: 'Kakdva', pincode: '385340' },
  { value: 'karadi', label: 'Karadi', pincode: '385340' },
  { value: 'koliwad', label: 'Koliwad', pincode: '385340' },
  { value: 'mangadh', label: 'Mangadh', pincode: '385340' },
  { value: 'moti', label: 'Moti', pincode: '385340' },
  { value: 'nani', label: 'Nani', pincode: '385340' },
  { value: 'patelvadi', label: 'Patelvadi', pincode: '385340' },
  { value: 'radhanpur', label: 'Radhanpur', pincode: '385340' },
  { value: 'sanjan', label: 'Sanjan', pincode: '385340' },
  { value: 'sarvan', label: 'Sarvan', pincode: '385340' },
  { value: 'sindhvai', label: 'Sindhvai', pincode: '385340' },
  { value: 'surajpura', label: 'Surajpura', pincode: '385340' },
  { value: 'vadi', label: 'Vadi', pincode: '385340' },
  { value: 'vadra', label: 'Vadra', pincode: '385340' },
  { value: 'vithalpur', label: 'Vithalpur', pincode: '385340' },
  { value: 'bhilar', label: 'Bhilar', pincode: '385340' },
  { value: 'bhimnath', label: 'Bhimnath', pincode: '385340' },
  { value: 'dolatpura', label: 'Dolatpura', pincode: '385340' },
  { value: 'fatehpura', label: 'Fatehpura', pincode: '385340' },
  { value: 'gopipur', label: 'Gopipur', pincode: '385340' },
  { value: 'jambhudi', label: 'Jambhudi', pincode: '385340' },
  { value: 'karanpura', label: 'Karanpura', pincode: '385340' },
  { value: 'kushalpura', label: 'Kushalpura', pincode: '385340' },
  { value: 'mangla', label: 'Mangla', pincode: '385340' },
  { value: 'paladi', label: 'Paladi', pincode: '385340' },
  { value: 'patalvadi', label: 'Patalvadi', pincode: '385340' },
  { value: 'purvadi', label: 'Purvadi', pincode: '385340' }
  ],
  
  'siddpur': [
  { value: 'adpur', label: 'Adpur', pincode: '384151' },
  { value: 'bada', label: 'Bada', pincode: '384151' },
  { value: 'balva', label: 'Balva', pincode: '384151' },
  { value: 'dakor', label: 'Dakor', pincode: '384151' },
  { value: 'gajipur', label: 'Gajipur', pincode: '384151' },
  { value: 'gundla', label: 'Gundla', pincode: '384151' },
  { value: 'jhagadia', label: 'Jhagadia', pincode: '384151' },
  { value: 'kadiyad', label: 'Kadiyad', pincode: '384151' },
  { value: 'karadi', label: 'Karadi', pincode: '384151' },
  { value: 'khijadiya', label: 'Khijadiya', pincode: '384151' },
  { value: 'madhapur', label: 'Madhapur', pincode: '384151' },
  { value: 'manpur', label: 'Manpur', pincode: '384151' },
  { value: 'patelvadi', label: 'Patelvadi', pincode: '384151' },
  { value: 'siddpur', label: 'Siddpur', pincode: '384151' },
  { value: 'sikotar', label: 'Sikotar', pincode: '384151' },
  { value: 'sukhsar', label: 'Sukhsar', pincode: '384151' },
  { value: 'tarnapur', label: 'Tarnapur', pincode: '384151' },
  { value: 'vadhva', label: 'Vadhva', pincode: '384151' },
  { value: 'vadi', label: 'Vadi', pincode: '384151' },
  { value: 'bhalak', label: 'Bhalak', pincode: '384151' },
  { value: 'bhiloda', label: 'Bhiloda', pincode: '384151' },
  { value: 'chandpur', label: 'Chandpur', pincode: '384151' },
  { value: 'dholi', label: 'Dholi', pincode: '384151' },
  { value: 'ghoghva', label: 'Ghoghva', pincode: '384151' },
  { value: 'jambhudi', label: 'Jambhudi', pincode: '384151' },
  { value: 'kavitha', label: 'Kavitha', pincode: '384151' },
  { value: 'kothariya', label: 'Kothariya', pincode: '384151' },
  { value: 'mahilpur', label: 'Mahilpur', pincode: '384151' },
  { value: 'patalvadi', label: 'Patalvadi', pincode: '384151' },
  { value: 'piplod', label: 'Piplod', pincode: '384151' },
  { value: 'rajpur', label: 'Rajpur', pincode: '384151' },
  { value: 'savli', label: 'Savli', pincode: '384151' },
  { value: 'sanand', label: 'Sanand', pincode: '384151' }
  ],
  
  'sihor': [
  { value: 'adpur', label: 'Adpur', pincode: '364240' },
  { value: 'bada', label: 'Bada', pincode: '364240' },
  { value: 'baldi', label: 'Baldi', pincode: '364240' },
  { value: 'bhalgam', label: 'Bhalgam', pincode: '364240' },
  { value: 'bhalodia', label: 'Bhalodia', pincode: '364240' },
  { value: 'bhojpur', label: 'Bhojpur', pincode: '364240' },
  { value: 'chandpur', label: 'Chandpur', pincode: '364240' },
  { value: 'dhobaniya', label: 'Dhobaniya', pincode: '364240' },
  { value: 'dholi', label: 'Dholi', pincode: '364240' },
  { value: 'dholpur', label: 'Dholpur', pincode: '364240' },
  { value: 'gundlav', label: 'Gundlav', pincode: '364240' },
  { value: 'kanaliyad', label: 'Kanaliyad', pincode: '364240' },
  { value: 'karadi', label: 'Karadi', pincode: '364240' },
  { value: 'kharvadi', label: 'Kharvadi', pincode: '364240' },
  { value: 'madhapur', label: 'Madhapur', pincode: '364240' },
  { value: 'manpur', label: 'Manpur', pincode: '364240' },
  { value: 'sihor', label: 'Sihor', pincode: '364240' },
  { value: 'sukhsar', label: 'Sukhsar', pincode: '364240' },
  { value: 'vadhva', label: 'Vadhva', pincode: '364240' },
  { value: 'vadi', label: 'Vadi', pincode: '364240' },
  { value: 'waghodia', label: 'Waghodia', pincode: '364240' },
  { value: 'bava', label: 'Bava', pincode: '364240' },
  { value: 'dungarpur', label: 'Dungarpur', pincode: '364240' },
  { value: 'suryavadi', label: 'Suryavadi', pincode: '364240' },
  { value: 'gajipur', label: 'Gajipur', pincode: '364240' },
  { value: 'bavadia', label: 'Bavadia', pincode: '364240' },
  { value: 'chakaliya', label: 'Chakaliya', pincode: '364240' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '364240' },
  { value: 'godhan', label: 'Godhan', pincode: '364240' },
  { value: 'jambudi', label: 'Jambudi', pincode: '364240' },
  { value: 'kanpura', label: 'Kanpura', pincode: '364240' },
  { value: 'kotda', label: 'Kotda', pincode: '364240' },
  { value: 'mangadh', label: 'Mangadh', pincode: '364240' },
  { value: 'mansa', label: 'Mansa', pincode: '364240' },
  { value: 'patelvadi', label: 'Patelvadi', pincode: '364240' },
  { value: 'pipli', label: 'Pipli', pincode: '364240' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '364240' },
  { value: 'sajod', label: 'Sajod', pincode: '364240' },
  { value: 'sarvoday', label: 'Sarvoday', pincode: '364240' },
  { value: 'vavdi', label: 'Vavdi', pincode: '364240' },
  { value: 'vav', label: 'Vav', pincode: '364240' }
  ],
  
  'songadh': [
  { value: 'adpur', label: 'Adpur', pincode: '394107' },
  { value: 'bajum', label: 'Bajum', pincode: '394107' },
  { value: 'bhagal', label: 'Bhagal', pincode: '394107' },
  { value: 'bhavnagar', label: 'Bhavnagar', pincode: '394107' },
  { value: 'chandpur', label: 'Chandpur', pincode: '394107' },
  { value: 'dholka', label: 'Dholka', pincode: '394107' },
  { value: 'gadhoda', label: 'Gadhoda', pincode: '394107' },
  { value: 'gundla', label: 'Gundla', pincode: '394107' },
  { value: 'jambhudi', label: 'Jambhudi', pincode: '394107' },
  { value: 'kanpura', label: 'Kanpura', pincode: '394107' },
  { value: 'karadi', label: 'Karadi', pincode: '394107' },
  { value: 'khijadiya', label: 'Khijadiya', pincode: '394107' },
  { value: 'madhapur', label: 'Madhapur', pincode: '394107' },
  { value: 'manpur', label: 'Manpur', pincode: '394107' },
  { value: 'sanghi', label: 'Sanghi', pincode: '394107' },
  { value: 'songadh', label: 'Songadh', pincode: '394107' },
  { value: 'tarnapur', label: 'Tarnapur', pincode: '394107' },
  { value: 'vadhva', label: 'Vadhva', pincode: '394107' },
  { value: 'vadi', label: 'Vadi', pincode: '394107' },
  { value: 'vavdi', label: 'Vavdi', pincode: '394107' },
  { value: 'wadhwan', label: 'Wadhwan', pincode: '394107' },
  { value: 'bhalgam', label: 'Bhalgam', pincode: '394107' },
  { value: 'bavla', label: 'Bavla', pincode: '394107' },
  { value: 'baval', label: 'Baval', pincode: '394107' },
  { value: 'dhanpur', label: 'Dhanpur', pincode: '394107' },
  { value: 'gadhka', label: 'Gadhka', pincode: '394107' },
  { value: 'galiyana', label: 'Galiyana', pincode: '394107' },
  { value: 'kanpura', label: 'Kanpura', pincode: '394107' },
  { value: 'laskana', label: 'Laskana', pincode: '394107' },
  { value: 'mahamadpur', label: 'Mahamadpur', pincode: '394107' },
  { value: 'malvad', label: 'Malvad', pincode: '394107' },
  { value: 'narmada', label: 'Narmada', pincode: '394107' },
  { value: 'piplod', label: 'Piplod', pincode: '394107' },
  { value: 'puranpura', label: 'Puranpura', pincode: '394107' },
  { value: 'vavdi', label: 'Vavdi', pincode: '394107' }
  ],
  
  'upleta': [
  { value: 'adpur', label: 'Adpur', pincode: '360490' },
  { value: 'bada', label: 'Bada', pincode: '360490' },
  { value: 'baldi', label: 'Baldi', pincode: '360490' },
  { value: 'bhadiya', label: 'Bhadiya', pincode: '360490' },
  { value: 'bhalgam', label: 'Bhalgam', pincode: '360490' },
  { value: 'bajum', label: 'Bajum', pincode: '360490' },
  { value: 'bhagal', label: 'Bhagal', pincode: '360490' },
  { value: 'dhamdhama', label: 'Dhamdhama', pincode: '360490' },
  { value: 'gandhiyad', label: 'Gandhiyad', pincode: '360490' },
  { value: 'gundlav', label: 'Gundlav', pincode: '360490' },
  { value: 'kanpura', label: 'Kanpura', pincode: '360490' },
  { value: 'karadi', label: 'Karadi', pincode: '360490' },
  { value: 'khijadiya', label: 'Khijadiya', pincode: '360490' },
  { value: 'madhapur', label: 'Madhapur', pincode: '360490' },
  { value: 'manpur', label: 'Manpur', pincode: '360490' },
  { value: 'sanghi', label: 'Sanghi', pincode: '360490' },
  { value: 'songadh', label: 'Songadh', pincode: '360490' },
  { value: 'suryavadi', label: 'Suryavadi', pincode: '360490' },
  { value: 'vadhva', label: 'Vadhva', pincode: '360490' },
  { value: 'vadi', label: 'Vadi', pincode: '360490' },
  { value: 'vavdi', label: 'Vavdi', pincode: '360490' },
  { value: 'wadhwan', label: 'Wadhwan', pincode: '360490' },
  { value: 'gadhka', label: 'Gadhka', pincode: '360490' },
  { value: 'piplod', label: 'Piplod', pincode: '360490' },
  { value: 'saurashtra', label: 'Saurashtra', pincode: '360490' },
  { value: 'maldhari', label: 'Maldhari', pincode: '360490' },
  { value: 'bhitari', label: 'Bhitari', pincode: '360490' },
  { value: 'dhamjijod', label: 'Dhamjijod', pincode: '360490' },
  { value: 'lalpur', label: 'Lalpur', pincode: '360490' },
  { value: 'sarasvati', label: 'Sarasvati', pincode: '360490' },
  { value: 'dholka', label: 'Dholka', pincode: '360490' },
  { value: 'bhesan', label: 'Bhesan', pincode: '360490' },
  { value: 'patelvadi', label: 'Patelvadi', pincode: '360490' },
  { value: 'vav', label: 'Vav', pincode: '360490' },
  { value: 'dharan', label: 'Dharan', pincode: '360490' },
  { value: 'jethpur', label: 'Jethpur', pincode: '360490' },
  { value: 'babhari', label: 'Babhari', pincode: '360490' }
  ],
  
  'valsad': [
  { value: 'ankleshwar', label: 'Ankleshwar', pincode: '393001' },
  { value: 'bhilad', label: 'Bhilad', pincode: '396105' },
  { value: 'bulsar', label: 'Bulsar', pincode: '396001' },
  { value: 'chhapra', label: 'Chhapra', pincode: '396005' },
  { value: 'dolara', label: 'Dolara', pincode: '396107' },
  { value: 'dongri', label: 'Dongri', pincode: '396107' },
  { value: 'gaviyapada', label: 'Gaviyapada', pincode: '396105' },
  { value: 'gothangam', label: 'Gothangam', pincode: '396107' },
  { value: 'kalsar', label: 'Kalsar', pincode: '396105' },
  { value: 'khergam', label: 'Khergam', pincode: '396105' },
  { value: 'kumbhardi', label: 'Kumbhardi', pincode: '396001' },
  { value: 'lavad', label: 'Lavad', pincode: '396105' },
  { value: 'nani-daman', label: 'Nani Daman', pincode: '396210' },
  { value: 'navsari', label: 'Navsari', pincode: '396445' },
  { value: 'pardi', label: 'Pardi', pincode: '396125' },
  { value: 'pati', label: 'Pati', pincode: '396107' },
  { value: 'umargam', label: 'Umargam', pincode: '396171' },
  { value: 'valsad', label: 'Valsad', pincode: '396001' },
  { value: 'vapi', label: 'Vapi', pincode: '396191' },
  { value: 'vansda', label: 'Vansda', pincode: '396580' },
  { value: 'vijalpur', label: 'Vijalpur', pincode: '396107' },
  { value: 'zari', label: 'Zari', pincode: '396115' },
  { value: 'arjundhara', label: 'Arjundhara', pincode: '396170' },
  { value: 'bordi', label: 'Bordi', pincode: '396150' },
  { value: 'chaudhari', label: 'Chaudhari', pincode: '396105' },
  { value: 'dhamdachha', label: 'Dhamdachha', pincode: '396105' },
  { value: 'gogha', label: 'Gogha', pincode: '396105' },
  { value: 'kampa', label: 'Kampa', pincode: '396170' },
  { value: 'mota-daman', label: 'Mota Daman', pincode: '396212' },
  { value: 'morai', label: 'Morai', pincode: '396105' },
  { value: 'narmada', label: 'Narmada', pincode: '396107' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '396170' },
  { value: 'sardar-vadi', label: 'Sardar Vadi', pincode: '396105' },
  { value: 'vasai', label: 'Vasai', pincode: '396105' }
  ],
  
  'veraval': [
  { value: 'adityana', label: 'Adityana', pincode: '362220' },
  { value: 'amarapar', label: 'Amarapara', pincode: '362240' },
  { value: 'bharuch', label: 'Bharuch', pincode: '392001' },
  { value: 'bhid', label: 'Bhid', pincode: '362265' },
  { value: 'chandranagar', label: 'Chandranagar', pincode: '362265' },
  { value: 'chaudhari', label: 'Chaudhari', pincode: '362265' },
  { value: 'dhoraji', label: 'Dhoraji', pincode: '362240' },
  { value: 'gariadhar', label: 'Gariadhar', pincode: '362110' },
  { value: 'ghanshyam', label: 'Ghanshyam', pincode: '362250' },
  { value: 'kavant', label: 'Kavant', pincode: '362215' },
  { value: 'kudasan', label: 'Kudasan', pincode: '362260' },
  { value: 'mangrol', label: 'Mangrol', pincode: '362225' },
  { value: 'mavdi', label: 'Mavdi', pincode: '362265' },
  { value: 'paddhari', label: 'Paddhari', pincode: '362240' },
  { value: 'rajkot', label: 'Rajkot', pincode: '360001' },
  { value: 'rangpur', label: 'Rangpur', pincode: '362240' },
  { value: 'ranuj', label: 'Ranuj', pincode: '362240' },
  { value: 'sangam', label: 'Sangam', pincode: '362210' },
  { value: 'shapar', label: 'Shapar', pincode: '362205' },
  { value: 'sika', label: 'Sika', pincode: '362265' },
  { value: 'veraval', label: 'Veraval', pincode: '362265' },
  { value: 'vijapur', label: 'Vijapur', pincode: '362220' },
  { value: 'vithalwadi', label: 'Vithalwadi', pincode: '362225' },
  { value: 'zavad', label: 'Zavad', pincode: '362225' },
  { value: 'borkhadi', label: 'Borkhadi', pincode: '362220' },
  { value: 'chandresh', label: 'Chandresh', pincode: '362200' },
  { value: 'dhanpar', label: 'Dhanpar', pincode: '362225' },
  { value: 'gadhada', label: 'Gadhada', pincode: '362220' },
  { value: 'kadiad', label: 'Kadiad', pincode: '362230' },
  { value: 'lavad', label: 'Lavad', pincode: '362245' },
  { value: 'manavadar', label: 'Manavadar', pincode: '362630' },
  { value: 'moti-daman', label: 'Moti Daman', pincode: '396220' },
  { value: 'parvad', label: 'Parvad', pincode: '362220' },
  { value: 'shihor', label: 'Shihor', pincode: '362240' },
  { value: 'siddhpur', label: 'Siddhpur', pincode: '362275' }
  ],
  
  'vyara': [
  { value: 'adgam', label: 'Adgam', pincode: '394107' },
  { value: 'bavisa', label: 'Bavisa', pincode: '394107' },
  { value: 'bhalej', label: 'Bhalej', pincode: '394107' },
  { value: 'chikhali', label: 'Chikhali', pincode: '394107' },
  { value: 'dhamdod', label: 'Dhamdod', pincode: '394107' },
  { value: 'dharampur', label: 'Dharampur', pincode: '394107' },
  { value: 'gajra', label: 'Gajra', pincode: '394107' },
  { value: 'jalalpore', label: 'Jalalpore', pincode: '394107' },
  { value: 'khundh', label: 'Khundh', pincode: '394107' },
  { value: 'mangrol', label: 'Mangrol', pincode: '394107' },
  { value: 'mota-bhagal', label: 'Mota Bhagal', pincode: '394107' },
  { value: 'narmada', label: 'Narmada', pincode: '394107' },
  { value: 'pratapnagar', label: 'Pratapnagar', pincode: '394107' },
  { value: 'rajan', label: 'Rajan', pincode: '394107' },
  { value: 'sangali', label: 'Sangali', pincode: '394107' },
  { value: 'santrampur', label: 'Santrampur', pincode: '394107' },
  { value: 'thasra', label: 'Thasra', pincode: '394107' },
  { value: 'vaghodia', label: 'Vaghodia', pincode: '394107' },
  { value: 'vyara', label: 'Vyara', pincode: '394107' },
  { value: 'zankhvav', label: 'Zankhvav', pincode: '394107' },
  { value: 'bapsi', label: 'Bapsi', pincode: '394107' },
  { value: 'bhesan', label: 'Bhesan', pincode: '394107' },
  { value: 'dharkhadi', label: 'Dharkhadi', pincode: '394107' },
  { value: 'fatepura', label: 'Fatepura', pincode: '394107' },
  { value: 'koliwad', label: 'Koliwad', pincode: '394107' },
  { value: 'ladol', label: 'Ladol', pincode: '394107' },
  { value: 'manikpur', label: 'Manikpur', pincode: '394107' },
  { value: 'mota-ubharai', label: 'Mota Ubharai', pincode: '394107' },
  { value: 'nana-bhagal', label: 'Nana Bhagal', pincode: '394107' },
  { value: 'rapar', label: 'Rapar', pincode: '394107' },
  { value: 'sajan', label: 'Sajan', pincode: '394107' },
  { value: 'sundha', label: 'Sundha', pincode: '394107' }
  ],

  'ahmedabad': [
    { value: 'ambawadi', label: 'Ambawadi', pincode: '380006' },
    { value: 'anisabad', label: 'Anisabad', pincode: '380007' },
    { value: 'ashram-road', label: 'Ashram Road', pincode: '380009' },
    { value: 'ashtamurti', label: 'Ashtamurti', pincode: '380010' },
    { value: 'bapunagar', label: 'Bapunagar', pincode: '380024' },
    { value: 'bodakdev', label: 'Bodakdev', pincode: '380054' },
    { value: 'bopal', label: 'Bopal', pincode: '380058' },
    { value: 'cg-road', label: 'CG Road', pincode: '380009' },
    { value: 'chandkheda', label: 'Chandkheda', pincode: '382424' },
    { value: 'changodar', label: 'Changodar', pincode: '382213' },
    { value: 'dariapur', label: 'Dariapur', pincode: '380001' },
    { value: 'ellisbridge', label: 'Ellisbridge', pincode: '380006' },
    { value: 'gandhinagar', label: 'Gandhinagar', pincode: '382010' },
    { value: 'ghatlodia', label: 'Ghatlodia', pincode: '380061' },
    { value: 'ghodasar', label: 'Ghodasar', pincode: '380050' },
    { value: 'gita-mandir', label: 'Gita Mandir', pincode: '380022' },
    { value: 'gulbai-tekra', label: 'Gulbai Tekra', pincode: '380006' },
    { value: 'gurukul', label: 'Gurukul', pincode: '380052' },
    { value: 'hatkeshwar', label: 'Hatkeshwar', pincode: '380026' },
    { value: 'isanpur', label: 'Isanpur', pincode: '382443' },
    { value: 'jivraj-park', label: 'Jivraj Park', pincode: '380051' },
    { value: 'kali', label: 'Kali', pincode: '382330' },
    { value: 'kankaria', label: 'Kankaria', pincode: '380022' },
    { value: 'kathwada', label: 'Kathwada', pincode: '382430' },
    { value: 'khohram', label: 'Khohram', pincode: '382345' },
    { value: 'khokhra', label: 'Khokhra', pincode: '380008' },
    { value: 'kuber-nagar', label: 'Kuber Nagar', pincode: '382340' },
    { value: 'manek-chowk', label: 'Manek Chowk', pincode: '380001' },
    { value: 'maninagar', label: 'Maninagar', pincode: '380008' },
    { value: 'memco', label: 'Memco', pincode: '380025' },
    { value: 'memnagar', label: 'Memnagar', pincode: '380052' },
    { value: 'narol', label: 'Narol', pincode: '382405' },
    { value: 'naroda', label: 'Naroda', pincode: '382330' },
    { value: 'navarangpura', label: 'Navarangpura', pincode: '380009' },
    { value: 'nikol', label: 'Nikol', pincode: '382350' },
    { value: 'odhav', label: 'Odhav', pincode: '382415' },
    { value: 'paldi', label: 'Paldi', pincode: '380007' },
    { value: 'prahlad-nagar', label: 'Prahlad Nagar', pincode: '380015' },
    { value: 'raipur', label: 'Raipur', pincode: '380001' },
    { value: 'ranip', label: 'Ranip', pincode: '382480' },
    { value: 'sarkhej', label: 'Sarkhej', pincode: '382210' },
    { value: 'satellite', label: 'Satellite', pincode: '380015' },
    { value: 'shah-alam', label: 'Shah Alam', pincode: '380028' },
    { value: 'shahibaug', label: 'Shahibaug', pincode: '380004' },
    { value: 'thaltej', label: 'Thaltej', pincode: '380059' },
    { value: 'vatva', label: 'Vatva', pincode: '382440' },
    { value: 'vastral', label: 'Vastral', pincode: '382418' },
    { value: 'vastrapur', label: 'Vastrapur', pincode: '380015' },
    { value: 'vijay-nagar', label: 'Vijay Nagar', pincode: '380013' },
    { value: 'vishala', label: 'Vishala', pincode: '380022' },
    { value: 'vishwakarma-nagar', label: 'Vishwakarma Nagar', pincode: '382415' },
    { value: 'vithalpur', label: 'Vithalpur', pincode: '382430' }
  ],

  'bharuch': [
    { value: 'ahmed-nagar', label: 'Ahmed Nagar', pincode: '392001' },
    { value: 'amod', label: 'Amod', pincode: '392110' },
    { value: 'angadiya-bazar', label: 'Angadiya Bazar', pincode: '392001' },
    { value: 'ankleshwar-gidc', label: 'Ankleshwar GIDC', pincode: '393002' },
    { value: 'ankleshwar-industrial-area', label: 'Ankleshwar Industrial Area', pincode: '393001' },
    { value: 'ashirwad-nagar', label: 'Ashirwad Nagar', pincode: '392001' },
    { value: 'bharuch-city', label: 'Bharuch City', pincode: '392001' },
    { value: 'bharuch-gidc', label: 'Bharuch GIDC', pincode: '392015' },
    { value: 'bholav', label: 'Bholav', pincode: '392012' },
    { value: 'dahej-gidc', label: 'Dahej GIDC', pincode: '392130' },
    { value: 'dahej-road', label: 'Dahej Road', pincode: '392130' },
    { value: 'dandiya-bazar', label: 'Dandiya Bazar', pincode: '392001' },
    { value: 'deepa-nagar', label: 'Deepa Nagar', pincode: '392012' },
    { value: 'gajanand-park', label: 'Gajanand Park', pincode: '392001' },
    { value: 'gnfc-township', label: 'GNFC Township', pincode: '392012' },
    { value: 'gulshan-nagar', label: 'Gulshan Nagar', pincode: '392011' },
    { value: 'hansot', label: 'Hansot', pincode: '394810' },
    { value: 'jambusar', label: 'Jambusar', pincode: '392150' },
    { value: 'jambusar-road', label: 'Jambusar Road', pincode: '392150' },
    { value: 'kapodra', label: 'Kapodra', pincode: '393001' },
    { value: 'kavi', label: 'Kavi', pincode: '392170' },
    { value: 'kosamba', label: 'Kosamba', pincode: '394120' },
    { value: 'maktampur', label: 'Maktampur', pincode: '392001' },
    { value: 'narmada-nagar', label: 'Narmada Nagar', pincode: '392015' },
    { value: 'navjivan-city', label: 'Navjivan City', pincode: '392001' },
    { value: 'old-town', label: 'Old Town', pincode: '392001' },
    { value: 'palej', label: 'Palej', pincode: '392220' },
    { value: 'panch-batti', label: 'Panch Batti', pincode: '392001' },
    { value: 'railway-station-road', label: 'Railway Station Road', pincode: '392001' },
    { value: 'sarod', label: 'Sarod', pincode: '392040' },
    { value: 'shravan-chokdi', label: 'Shravan Chokdi', pincode: '392011' },
    { value: 'shukla-nagar', label: 'Shukla Nagar', pincode: '392001' },
    { value: 'vadiya-road', label: 'Vadiya Road', pincode: '392020' },
    { value: 'vangar', label: 'Vangar', pincode: '392025' },
    { value: 'vilayat-gidc', label: 'Vilayat GIDC', pincode: '392012' },
    { value: 'zadeshwar', label: 'Zadeshwar', pincode: '392011' },
    { value: 'zadeshwar-chokdi', label: 'Zadeshwar Chokdi', pincode: '392011' }
  ],

  'jamnagar': [
    { value: 'abhalpur', label: 'Abhalpur', pincode: '361001' },
    { value: 'adhav', label: 'Adhav', pincode: '361120' },
    { value: 'baradia', label: 'Baradia', pincode: '361040' },
    { value: 'bavla', label: 'Bavla', pincode: '361205' },
    { value: 'besai', label: 'Besai', pincode: '361200' },
    { value: 'bhanvad', label: 'Bhanvad', pincode: '361530' },
    { value: 'bhadiya', label: 'Bhadiya', pincode: '361130' },
    { value: 'bhatia', label: 'Bhatia', pincode: '361220' },
    { value: 'bhayavadar', label: 'Bhayavadar', pincode: '361220' },
    { value: 'bhidiya', label: 'Bhidiya', pincode: '361210' },
    { value: 'bhesan', label: 'Bhesan', pincode: '361010' },
    { value: 'chandrayani', label: 'Chandrayani', pincode: '361110' },
    { value: 'chudi', label: 'Chudi', pincode: '361030' },
    { value: 'dadvadi', label: 'Dadvadi', pincode: '361220' },
    { value: 'dharmani', label: 'Dharmani', pincode: '361120' },
    { value: 'dhamanva', label: 'Dhamanva', pincode: '361150' },
    { value: 'devpur', label: 'Devpur', pincode: '361160' },
    { value: 'doongar', label: 'Doongar', pincode: '361200' },
    { value: 'fatarva', label: 'Fatarva', pincode: '361150' },
    { value: 'fatorada', label: 'Fatorada', pincode: '361220' },
    { value: 'gharari', label: 'Gharari', pincode: '361110' },
    { value: 'ghanshyam', label: 'Ghanshyam', pincode: '361025' },
    { value: 'gokhivav', label: 'Gokhivav', pincode: '361110' },
    { value: 'gothivav', label: 'Gothivav', pincode: '361105' },
    { value: 'hansot', label: 'Hansot', pincode: '361225' },
    { value: 'haripur', label: 'Haripur', pincode: '361220' },
    { value: 'ikhar', label: 'Ikhar', pincode: '361130' },
    { value: 'jambhudih', label: 'Jambhudih', pincode: '361135' },
    { value: 'jambuda', label: 'Jambuda', pincode: '361120' },
    { value: 'jamsa', label: 'Jamsa', pincode: '361150' },
    { value: 'jatir', label: 'Jatir', pincode: '361120' },
    { value: 'kalar', label: 'Kalar', pincode: '361160' },
    { value: 'kambhoj', label: 'Kambhoj', pincode: '361100' },
    { value: 'kanakpur', label: 'Kanakpur', pincode: '361115' },
    { value: 'kandala', label: 'Kandala', pincode: '361002' },
    { value: 'kankot', label: 'Kankot', pincode: '361005' },
    { value: 'kavadia', label: 'Kavadia', pincode: '361110' },
    { value: 'khamasa', label: 'Khamasa', pincode: '361130' },
    { value: 'khambhalia', label: 'Khambhalia', pincode: '361305' },
    { value: 'khodiyarpur', label: 'Khodiyarpur', pincode: '361115' },
    { value: 'kotda', label: 'Kotda', pincode: '361050' },
    { value: 'kotda-sangani', label: 'Kotda Sangani', pincode: '361000' },
    { value: 'koyali', label: 'Koyali', pincode: '361215' },
    { value: 'kumbharwada', label: 'Kumbharwada', pincode: '361025' },
    { value: 'kushal', label: 'Kushal', pincode: '361215' },
    { value: 'lalpur', label: 'Lalpur', pincode: '361170' },
    { value: 'mali', label: 'Mali', pincode: '361210' },
    { value: 'malhar', label: 'Malhar', pincode: '361110' },
    { value: 'mandvi', label: 'Mandvi', pincode: '361110' },
    { value: 'manavadar', label: 'Manavadar', pincode: '361220' },
    { value: 'mangrol', label: 'Mangrol', pincode: '361305' },
    { value: 'moti-bhagal', label: 'Moti Bhagal', pincode: '361001' },
    { value: 'moti-bhavani', label: 'Moti Bhavani', pincode: '361004' },
    { value: 'nana-mor', label: 'Nana Mor', pincode: '361020' },
    { value: 'navagam', label: 'Navagam', pincode: '361015' },
    { value: 'nawa', label: 'Nawa', pincode: '361040' },
    { value: 'padamvav', label: 'Padamvav', pincode: '361210' },
    { value: 'pipri', label: 'Pipri', pincode: '361150' },
    { value: 'rajalakshmi', label: 'Rajalakshmi', pincode: '361200' },
    { value: 'rajamani', label: 'Rajamani', pincode: '361220' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '361004' },
    { value: 'rohit', label: 'Rohit', pincode: '361225' },
    { value: 'sadar', label: 'Sadar', pincode: '361130' },
    { value: 'samgadh', label: 'Samgadh', pincode: '361220' },
    { value: 'sanand', label: 'Sanand', pincode: '361125' },
    { value: 'sankheda', label: 'Sankheda', pincode: '361050' },
    { value: 'saraiya', label: 'Saraiya', pincode: '361100' },
    { value: 'shil', label: 'Shil', pincode: '361120' },
    { value: 'sijpur', label: 'Sijpur', pincode: '361020' },
    { value: 'sikka', label: 'Sikka', pincode: '361140' },
    { value: 'sukhpur', label: 'Sukhpur', pincode: '361010' },
    { value: 'talan', label: 'Talan', pincode: '361150' },
    { value: 'torda', label: 'Torda', pincode: '361140' },
    { value: 'vaghana', label: 'Vaghana', pincode: '361225' },
    { value: 'vithalpur', label: 'Vithalpur', pincode: '361100' },
    { value: 'zampa', label: 'Zampa', pincode: '361005' }
  ],

  'bhavnagar': [
    { value: 'adityapur', label: 'Adityapur', pincode: '364001' },
    { value: 'alidar', label: 'Alidar', pincode: '364001' },
    { value: 'bhairav-park', label: 'Bhairav Park', pincode: '364001' },
    { value: 'bhavnagar-city', label: 'Bhavnagar City', pincode: '364001' },
    { value: 'bhavnagar-district', label: 'Bhavnagar District', pincode: '364001' },
    { value: 'bhavnagar-west', label: 'Bhavnagar West', pincode: '364002' },
    { value: 'chitra', label: 'Chitra', pincode: '364002' },
    { value: 'gadhda', label: 'Gadhda', pincode: '364110' },
    { value: 'gopi-nagar', label: 'Gopi Nagar', pincode: '364001' },
    { value: 'haripar', label: 'Haripar', pincode: '364001' },
    { value: 'jaliwala', label: 'Jaliwala', pincode: '364001' },
    { value: 'kaliyabid', label: 'Kaliyabid', pincode: '364001' },
    { value: 'kanak-nagar', label: 'Kanak Nagar', pincode: '364001' },
    { value: 'kumbhardi', label: 'Kumbhardi', pincode: '364003' },
    { value: 'lambadi', label: 'Lambadi', pincode: '364001' },
    { value: 'mangalsiya', label: 'Mangalsiya', pincode: '364002' },
    { value: 'moti-bazaar', label: 'Moti Bazaar', pincode: '364001' },
    { value: 'palitana', label: 'Palitana', pincode: '364270' },
    { value: 'sardar-nagar', label: 'Sardar Nagar', pincode: '364001' },
    { value: 'shihor', label: 'Shihor', pincode: '364240' },
    { value: 'sikka', label: 'Sikka', pincode: '364501' },
    { value: 'sundvadi', label: 'Sundvadi', pincode: '364002' },
    { value: 'vagheshwar', label: 'Vagheshwar', pincode: '364001' },
    { value: 'vav', label: 'Vav', pincode: '364030' },
    { value: 'vithal-park', label: 'Vithal Park', pincode: '364002' },
    { value: 'madhavpura', label: 'Madhavpura', pincode: '364003' },
    { value: 'bhagwat-vadi', label: 'Bhagwat Vadi', pincode: '364004' },
    { value: 'rambaug', label: 'Rambaug', pincode: '364002' },
    { value: 'manek-park', label: 'Manek Park', pincode: '364002' },
    { value: 'rangpur', label: 'Rangpur', pincode: '364220' },
    { value: 'mota-bhagal', label: 'Mota Bhagal', pincode: '364001' },
    { value: 'chhaya', label: 'Chhaya', pincode: '364030' },
    { value: 'abhepura', label: 'Abhepura', pincode: '364002' },
    { value: 'nikora', label: 'Nikora', pincode: '364120' },
    { value: 'bhayavadar', label: 'Bhayavadar', pincode: '364740' },
    { value: 'bholav', label: 'Bholav', pincode: '364001' },
    { value: 'balasar', label: 'Balasar', pincode: '364030' },
    { value: 'damanwala', label: 'Damanwala', pincode: '364040' },
    { value: 'devgadh', label: 'Devgadh', pincode: '364130' },
    { value: 'dholera', label: 'Dholera', pincode: '364250' },
    { value: 'desalpur', label: 'Desalpur', pincode: '364101' },
    { value: 'ghodvadhar', label: 'Ghodvadhar', pincode: '364101' },
    { value: 'hariyala', label: 'Hariyala', pincode: '364120' },
    { value: 'keshod', label: 'Keshod', pincode: '364120' },
    { value: 'khijadiya', label: 'Khijadiya', pincode: '364210' },
    { value: 'lathi', label: 'Lathi', pincode: '364220' },
    { value: 'maliyas', label: 'Maliyas', pincode: '364100' },
    { value: 'mangrol', label: 'Mangrol', pincode: '364405' },
    { value: 'piplana', label: 'Piplana', pincode: '364250' },
    { value: 'sankheda', label: 'Sankheda', pincode: '364105' }
  ],

  'rajkot': [
    { value: 'adipur', label: 'Adipur', pincode: '360001' },
    { value: 'bapsa', label: 'Bapsa', pincode: '360001' },
    { value: 'bhaktinagar', label: 'Bhaktinagar', pincode: '360002' },
    { value: 'bhidbhanjan', label: 'Bhidbhanjan', pincode: '360002' },
    { value: 'bhalgam', label: 'Bhalgam', pincode: '360003' },
    { value: 'bhatia', label: 'Bhatia', pincode: '360004' },
    { value: 'chakradharpur', label: 'Chakradharpur', pincode: '360010' },
    { value: 'chandreshnagar', label: 'Chandreshnagar', pincode: '360005' },
    { value: 'chandresh', label: 'Chandresh', pincode: '360006' },
    { value: 'dhoraji', label: 'Dhoraji', pincode: '360110' },
    { value: 'gajanan-nagar', label: 'Gajanan Nagar', pincode: '360010' },
    { value: 'jalana', label: 'Jalana', pincode: '360020' },
    { value: 'jubeli', label: 'Jubeli', pincode: '360030' },
    { value: 'krishnagar', label: 'Krishnagar', pincode: '360001' },
    { value: 'lalpari', label: 'Lalpari', pincode: '360003' },
    { value: 'madhapar', label: 'Madhapar', pincode: '360005' },
    { value: 'mavdi', label: 'Mavdi', pincode: '360010' },
    { value: 'prajapati-vas', label: 'Prajapati Vas', pincode: '360004' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '360001' },
    { value: 'rajkot-sadar', label: 'Rajkot Sadar', pincode: '360007' },
    { value: 'rajkot-north', label: 'Rajkot North', pincode: '360001' },
    { value: 'rajkot-south', label: 'Rajkot South', pincode: '360008' },
    { value: 'rasulpura', label: 'Rasulpura', pincode: '360011' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '360002' },
    { value: 'shastri-nagar', label: 'Shastri Nagar', pincode: '360004' },
    { value: 'shriji-nagar', label: 'Shriji Nagar', pincode: '360005' },
    { value: 'vavdi', label: 'Vavdi', pincode: '360025' },
    { value: 'veraval', label: 'Veraval', pincode: '360020' },
    { value: 'vidyanagar', label: 'Vidyanagar', pincode: '360001' },
    { value: 'yoginagar', label: 'Yoginagar', pincode: '360014' },
    { value: 'amar-nagar', label: 'Amar Nagar', pincode: '360008' },
    { value: 'baroda-nagar', label: 'Baroda Nagar', pincode: '360004' },
    { value: 'bhuvaneshwar', label: 'Bhuvaneshwar', pincode: '360001' },
    { value: 'chandreshnagar-2', label: 'Chandreshnagar 2', pincode: '360005' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '360011' },
    { value: 'gokul-nagar', label: 'Gokul Nagar', pincode: '360014' },
    { value: 'gopalnagar', label: 'Gopal Nagar', pincode: '360002' },
    { value: 'jadeshwar', label: 'Jadeshwar', pincode: '360010' },
    { value: 'kalavad', label: 'Kalavad', pincode: '360021' },
    { value: 'kanak-nagar', label: 'Kanak Nagar', pincode: '360022' },
    { value: 'kishan-nagar', label: 'Kishan Nagar', pincode: '360003' },
    { value: 'madhav-nagar', label: 'Madhav Nagar', pincode: '360014' },
    { value: 'mandvi', label: 'Mandvi', pincode: '360001' },
    { value: 'navagam', label: 'Navagam', pincode: '360024' },
    { value: 'parle-point', label: 'Parle Point', pincode: '360003' },
    { value: 'rampara', label: 'Rampara', pincode: '360015' },
    { value: 'shakti-nagar', label: 'Shakti Nagar', pincode: '360002' },
    { value: 'sudama-nagar', label: 'Sudama Nagar', pincode: '360001' },
    { value: 'swaminarayan', label: 'Swaminarayan', pincode: '360008' },
    { value: 'tilak-nagar', label: 'Tilak Nagar', pincode: '360001' },
    { value: 'vikram-nagar', label: 'Vikram Nagar', pincode: '360004' },
    { value: 'shivshakti-nagar', label: 'Shivshakti Nagar', pincode: '360009' },
    { value: 'shree-krishna-nagar', label: 'Shree Krishna Nagar', pincode: '360008' },
    { value: 'ashok-nagar', label: 'Ashok Nagar', pincode: '360004' },
    { value: 'sardar-nagar', label: 'Sardar Nagar', pincode: '360012' },
    { value: 'sarvoday-nagar', label: 'Sarvoday Nagar', pincode: '360013' },
    { value: 'mahesana-nagar', label: 'Mahesana Nagar', pincode: '360004' },
    { value: 'rajnagar', label: 'Rajnagar', pincode: '360010' },
    { value: 'gopal-nagar', label: 'Gopal Nagar', pincode: '360014' },
    { value: 'madhur-nagar', label: 'Madhur Nagar', pincode: '360003' }
  ],

  'kapurthala': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '144205' },
    { value: 'alipur', label: 'Alipur', pincode: '144601' },
    { value: 'badshahpur', label: 'Badshahpur', pincode: '144602' },
    { value: 'balpur', label: 'Balpur', pincode: '144205' },
    { value: 'basti-hindwan', label: 'Basti Hindwan', pincode: '144205' },
    { value: 'basti-purana', label: 'Basti Purana', pincode: '144205' },
    { value: 'basti-sadar', label: 'Basti Sadar', pincode: '144205' },
    { value: 'bhogpur', label: 'Bhogpur', pincode: '144205' },
    { value: 'chandpur', label: 'Chandpur', pincode: '144205' },
    { value: 'chhoti-mandi', label: 'Chhoti Mandi', pincode: '144205' },
    { value: 'chopran', label: 'Chopran', pincode: '144601' },
    { value: 'dhanowali', label: 'Dhanowali', pincode: '144205' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '144205' },
    { value: 'gill', label: 'Gill', pincode: '144205' },
    { value: 'gulab-wala', label: 'Gulab Wala', pincode: '144205' },
    { value: 'gurdev', label: 'Gurdev', pincode: '144205' },
    { value: 'hargobindpura', label: 'Hargobindpura', pincode: '144205' },
    { value: 'jahangir', label: 'Jahangir', pincode: '144205' },
    { value: 'kabir-wala', label: 'Kabir Wala', pincode: '144205' },
    { value: 'kalianwala', label: 'Kalianwala', pincode: '144205' },
    { value: 'kalianwala-bhatian', label: 'Kalianwala Bhatian', pincode: '144205' },
    { value: 'kapurthala-city', label: 'Kapurthala City', pincode: '144205' },
    { value: 'khera', label: 'Khera', pincode: '144603' },
    { value: 'khurd', label: 'Khurd', pincode: '144205' },
    { value: 'kotla', label: 'Kotla', pincode: '144206' },
    { value: 'mawan', label: 'Mawan', pincode: '144205' },
    { value: 'mawan-abad', label: 'Mawan Abad', pincode: '144205' },
    { value: 'mitha-talwandi', label: 'Mitha Talwandi', pincode: '144205' },
    { value: 'nangal', label: 'Nangal', pincode: '144205' },
    { value: 'patiala-bazar', label: 'Patiala Bazar', pincode: '144205' },
    { value: 'phillaur', label: 'Phillaur', pincode: '144205' },
    { value: 'phool-pur', label: 'Phool Pur', pincode: '144205' },
    { value: 'rajanpur', label: 'Rajanpur', pincode: '144205' },
    { value: 'ram-wala', label: 'Ram Wala', pincode: '144205' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '144205' },
    { value: 'rana', label: 'Rana', pincode: '144205' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '144205' },
    { value: 'shahkot', label: 'Shahkot', pincode: '144205' },
    { value: 'shankar', label: 'Shankar', pincode: '144205' },
    { value: 'sidhwan-bet', label: 'Sidhwan Bet', pincode: '144205' },
    { value: 'sikanderpura', label: 'Sikanderpura', pincode: '144205' },
    { value: 'sunjwan', label: 'Sunjwan', pincode: '144205' },
    { value: 'talwandi', label: 'Talwandi', pincode: '144604' },
    { value: 'wariana', label: 'Wariana', pincode: '144205' }
  ],

  'zirakpur': [
    { value: 'action-area', label: 'Action Area', pincode: '140603' },
    { value: 'ayal-pur', label: 'Ayal Pur', pincode: '140603' },
    { value: 'baba-bakra', label: 'Baba Bakra', pincode: '140603' },
    { value: 'bhagat-singh-colony', label: 'Bhagat Singh Colony', pincode: '140603' },
    { value: 'broadway-enclave', label: 'Broadway Enclave', pincode: '140603' },
    { value: 'chandigarh-ambala-road', label: 'Chandigarh Ambala Road', pincode: '140603' },
    { value: 'chandigarh-road', label: 'Chandigarh Road', pincode: '140603' },
    { value: 'derabassi', label: 'Derabassi', pincode: '140507' },
    { value: 'devnagar', label: 'Devnagar', pincode: '140603' },
    { value: 'dhanas', label: 'Dhanas', pincode: '160014' },
    { value: 'dubanchi', label: 'Dubanchi', pincode: '140603' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '140603' },
    { value: 'gandhi-park', label: 'Gandhi Park', pincode: '140603' },
    { value: 'gas-plant-road', label: 'Gas Plant Road', pincode: '140603' },
    { value: 'green-city', label: 'Green City', pincode: '140603' },
    { value: 'gurukul-enclave', label: 'Gurukul Enclave', pincode: '140603' },
    { value: 'hamidpur', label: 'Hamidpur', pincode: '140603' },
    { value: 'jagdish-park', label: 'Jagdish Park', pincode: '140603' },
    { value: 'jhande-wala', label: 'Jhande Wala', pincode: '140603' },
    { value: 'kant-enclave', label: 'Kant Enclave', pincode: '140603' },
    { value: 'khuda-alisher', label: 'Khuda Alisher', pincode: '140603' },
    { value: 'khuda-ali-rahim', label: 'Khuda Ali Rahim', pincode: '140603' },
    { value: 'mahaluxmi-villa', label: 'Mahaluxmi Villa', pincode: '140603' },
    { value: 'manimajra', label: 'Manimajra', pincode: '160101' },
    { value: 'masu-wali', label: 'Masu Wali', pincode: '140603' },
    { value: 'mohali', label: 'Mohali', pincode: '160062' },
    { value: 'new-era', label: 'New Era', pincode: '140603' },
    { value: 'new-rajendra-park', label: 'New Rajendra Park', pincode: '140603' },
    { value: 'north-park', label: 'North Park', pincode: '140603' },
    { value: 'patiala-road', label: 'Patiala Road', pincode: '140603' },
    { value: 'phase-1', label: 'Phase 1', pincode: '140603' },
    { value: 'phase-2', label: 'Phase 2', pincode: '140603' },
    { value: 'railway-road', label: 'Railway Road', pincode: '140603' },
    { value: 'rajinder-nagar', label: 'Rajinder Nagar', pincode: '140603' },
    { value: 'sector-20', label: 'Sector 20', pincode: '140603' },
    { value: 'sector-21', label: 'Sector 21', pincode: '140603' },
    { value: 'sector-22', label: 'Sector 22', pincode: '140603' },
    { value: 'sector-23', label: 'Sector 23', pincode: '140603' },
    { value: 'shivalik-enclave', label: 'Shivalik Enclave', pincode: '140603' },
    { value: 'swastik-enclave', label: 'Swastik Enclave', pincode: '140603' },
    { value: 'vishal-enclave', label: 'Vishal Enclave', pincode: '140603' }
  ],

  'tarn-taran-sahib': [
    { value: 'adda-tarn-taran', label: 'Adda Tarn Taran', pincode: '143401' },
    { value: 'a-district', label: 'A District', pincode: '143401' },
    { value: 'baba-bakula', label: 'Baba Bakula', pincode: '143401' },
    { value: 'bhikhi-wali', label: 'Bhikhi Wali', pincode: '143401' },
    { value: 'chandpur', label: 'Chandpur', pincode: '143401' },
    { value: 'dhamran', label: 'Dhamran', pincode: '143401' },
    { value: 'dharmkot', label: 'Dharmkot', pincode: '143401' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '143401' },
    { value: 'fatehgarh-modi', label: 'Fatehgarh Modi', pincode: '143401' },
    { value: 'gurdwara-roza', label: 'Gurdwara Roza', pincode: '143401' },
    { value: 'jandiala', label: 'Jandiala', pincode: '143401' },
    { value: 'kaleran', label: 'Kaleran', pincode: '143401' },
    { value: 'kalra', label: 'Kalra', pincode: '143401' },
    { value: 'kotli', label: 'Kotli', pincode: '143401' },
    { value: 'kotli-maur', label: 'Kotli Maur', pincode: '143401' },
    { value: 'makhan-wala', label: 'Makhan Wala', pincode: '143401' },
    { value: 'mitha-tarwara', label: 'Mitha Tarwara', pincode: '143401' },
    { value: 'nawan-pind', label: 'Nawan Pind', pincode: '143401' },
    { value: 'patti', label: 'Patti', pincode: '143401' },
    { value: 'rahat-kot', label: 'Rahat Kot', pincode: '143401' },
    { value: 'rajapur', label: 'Rajapur', pincode: '143401' },
    { value: 'ramdas', label: 'Ramdas', pincode: '143401' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '143401' },
    { value: 'shahzada', label: 'Shahzada', pincode: '143401' },
    { value: 'sultanwind', label: 'Sultanwind', pincode: '143401' },
    { value: 'tarn-taran-basti', label: 'Tarn Taran Basti', pincode: '143401' },
    { value: 'village-tarn-taran', label: 'Village Tarn Taran', pincode: '143401' },
    { value: 'wadera', label: 'Wadera', pincode: '143401' }
  ],

  'sangrur': [
    { value: 'adda-sangrur', label: 'Adda Sangrur', pincode: '148001' },
    { value: 'bain-wali', label: 'Bain Wali', pincode: '148001' },
    { value: 'bara-rahm', label: 'Bara Rahm', pincode: '148001' },
    { value: 'dara-sarai', label: 'Dara Sarai', pincode: '148001' },
    { value: 'dhamtan', label: 'Dhamtan', pincode: '148001' },
    { value: 'gurdwara-road', label: 'Gurdwara Road', pincode: '148001' },
    { value: 'hussa-pur', label: 'Hussa Pur', pincode: '148001' },
    { value: 'jamsher', label: 'Jamsher', pincode: '148001' },
    { value: 'kali-nadi', label: 'Kali Nadi', pincode: '148001' },
    { value: 'madhopur', label: 'Madhopur', pincode: '148001' },
    { value: 'maur', label: 'Maur', pincode: '148001' },
    { value: 'nawan-pind', label: 'Nawan Pind', pincode: '148001' },
    { value: 'patiala-road', label: 'Patiala Road', pincode: '148001' },
    { value: 'railway-road', label: 'Railway Road', pincode: '148001' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '148001' },
    { value: 'sirhind-road', label: 'Sirhind Road', pincode: '148001' },
    { value: 'tata-nagar', label: 'Tata Nagar', pincode: '148001' },
    { value: 'village-sangrur', label: 'Village Sangrur', pincode: '148001' },
    { value: 'wali-bhatti', label: 'Wali Bhatti', pincode: '148001' },
    { value: 'bassi-wali', label: 'Bassi Wali', pincode: '148001' },
    { value: 'chand-bhagat', label: 'Chand Bhagat', pincode: '148001' },
    { value: 'ganaur', label: 'Ganaur', pincode: '148001' },
    { value: 'gurgarh', label: 'Gurgarh', pincode: '148001' },
    { value: 'jhanji', label: 'Jhanji', pincode: '148001' },
    { value: 'kanjla', label: 'Kanjla', pincode: '148001' },
    { value: 'krishan-pura', label: 'Krishan Pura', pincode: '148001' },
    { value: 'mitha-tarwara', label: 'Mitha Tarwara', pincode: '148001' },
    { value: 'bagrian', label: 'Bagrian', pincode: '148001' },
    { value: 'bhullar-basti', label: 'Bhullar Basti', pincode: '148001' },
    { value: 'chak-pannu', label: 'Chak Pannu', pincode: '148001' },
    { value: 'dhuri', label: 'Dhuri', pincode: '148024' },
    { value: 'fatehpur-banga', label: 'Fatehpur Banga', pincode: '148001' },
    { value: 'hardyal-nagar', label: 'Hardyal Nagar', pincode: '148001' },
    { value: 'kamalpura', label: 'Kamalpura', pincode: '148001' },
    { value: 'longowal', label: 'Longowal', pincode: '148106' },
    { value: 'malerkotla', label: 'Malerkotla', pincode: '148023' },
    { value: 'pharwahi', label: 'Pharwahi', pincode: '148001' },
    { value: 'rangian', label: 'Rangian', pincode: '148001' },
    { value: 'sanghera', label: 'Sanghera', pincode: '148001' },
    { value: 'sunam', label: 'Sunam', pincode: '148028' }
  ],

  'rajpura': [
    { value: 'adda-rajpura', label: 'Adda Rajpura', pincode: '140401' },
    { value: 'baba-bakala', label: 'Baba Bakala', pincode: '140401' },
    { value: 'bhara-bhuri', label: 'Bhara Bhuri', pincode: '140401' },
    { value: 'chandpur', label: 'Chandpur', pincode: '140401' },
    { value: 'darbara', label: 'Darbara', pincode: '140401' },
    { value: 'dholan', label: 'Dholan', pincode: '140401' },
    { value: 'gunduwal', label: 'Gunduwal', pincode: '140401' },
    { value: 'industrial-area', label: 'Industrial Area', pincode: '140401' },
    { value: 'jandiala', label: 'Jandiala', pincode: '140401' },
    { value: 'khera', label: 'Khera', pincode: '140401' },
    { value: 'madhopur', label: 'Madhopur', pincode: '140401' },
    { value: 'maur', label: 'Maur', pincode: '140401' },
    { value: 'mohar-singh', label: 'Mohar Singh', pincode: '140401' },
    { value: 'new-rajpura', label: 'New Rajpura', pincode: '140401' },
    { value: 'rahat-pur', label: 'Rahat Pur', pincode: '140401' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '140401' },
    { value: 'shahpur', label: 'Shahpur', pincode: '140401' },
    { value: 'sirhind-road', label: 'Sirhind Road', pincode: '140401' },
    { value: 'tata-nagar', label: 'Tata Nagar', pincode: '140401' },
    { value: 'village-pur', label: 'Village Pur', pincode: '140401' },
    { value: 'khemkaran', label: 'Khemkaran', pincode: '140401' },
    { value: 'panjab-nagar', label: 'Punjab Nagar', pincode: '140401' },
    { value: 'shahzadpur', label: 'Shahzadpur', pincode: '140401' },
    { value: 'raju-ram', label: 'Raju Ram', pincode: '140401' },
    { value: 'bhatian', label: 'Bhatian', pincode: '140401' },
    { value: 'dhanora', label: 'Dhanora', pincode: '140401' },
    { value: 'gurdaspur-basti', label: 'Gurdaspur Basti', pincode: '140401' },
    { value: 'shuker-basti', label: 'Shuker Basti', pincode: '140401' },
    { value: 'model-town', label: 'Model Town', pincode: '140401' },
    { value: 'green-city', label: 'Green City', pincode: '140401' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '140401' },
    { value: 'royal-enclave', label: 'Royal Enclave', pincode: '140401' },
    { value: 'leela-bhawan', label: 'Leela Bhawan', pincode: '140401' },
    { value: 'urban-estate', label: 'Urban Estate', pincode: '140401' },
    { value: 'kansal-colony', label: 'Kansal Colony', pincode: '140401' },
    { value: 'bhupindra-road', label: 'Bhupindra Road', pincode: '140401' },
    { value: 'patel-nagar', label: 'Patel Nagar', pincode: '140401' },
    { value: 'dev-nagar', label: 'Dev Nagar', pincode: '140401' },
    { value: 'ranjit-nagar', label: 'Ranjit Nagar', pincode: '140401' }
  ],

  'patiala': [
    { value: 'adda-patiala', label: 'Adda Patiala', pincode: '147001' },
    { value: 'bahadurgarh', label: 'Bahadurgarh', pincode: '147001' },
    { value: 'bhupinder-nagar', label: 'Bhupinder Nagar', pincode: '147001' },
    { value: 'bibiwala', label: 'Bibiwala', pincode: '147001' },
    { value: 'chandni-bagh', label: 'Chandni Bagh', pincode: '147001' },
    { value: 'charan-bagh', label: 'Charan Bagh', pincode: '147001' },
    { value: 'chirag-bagh', label: 'Chirag Bagh', pincode: '147001' },
    { value: 'dagran', label: 'Dagran', pincode: '147001' },
    { value: 'gurunani', label: 'Gurunani', pincode: '147001' },
    { value: 'harna-baba', label: 'Harna Baba', pincode: '147001' },
    { value: 'industrial-area', label: 'Industrial Area', pincode: '147001' },
    { value: 'ishwar-puri', label: 'Ishwar Puri', pincode: '147001' },
    { value: 'madhopur', label: 'Madhopur', pincode: '147001' },
    { value: 'maur', label: 'Maur', pincode: '147001' },
    { value: 'mehar-singh', label: 'Mehar Singh', pincode: '147001' },
    { value: 'miani', label: 'Miani', pincode: '147001' },
    { value: 'nawan-pind', label: 'Nawan Pind', pincode: '147001' },
    { value: 'new-patiala', label: 'New Patiala', pincode: '147001' },
    { value: 'railway-road', label: 'Railway Road', pincode: '147001' },
    { value: 'raja-bagh', label: 'Raja Bagh', pincode: '147001' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '147001' },
    { value: 'sirhind-road', label: 'Sirhind Road', pincode: '147001' },
    { value: 'tata-nagar', label: 'Tata Nagar', pincode: '147001' },
    { value: 'walled-city', label: 'Walled City', pincode: '147001' },
    { value: 'bansawala', label: 'Bansawala', pincode: '147001' },
    { value: 'gurudwara-bagh', label: 'Gurudwara Bagh', pincode: '147001' },
    { value: 'jail-road', label: 'Jail Road', pincode: '147001' },
    { value: 'jassian', label: 'Jassian', pincode: '147001' },
    { value: 'khera', label: 'Khera', pincode: '147001' },
    { value: 'kirpal-pur', label: 'Kirpal Pur', pincode: '147001' },
    { value: 'majri', label: 'Majri', pincode: '147001' },
    { value: 'mananwala', label: 'Mananwala', pincode: '147001' },
    { value: 'mohindra-colony', label: 'Mohindra Colony', pincode: '147001' },
    { value: 'nada', label: 'Nada', pincode: '147001' },
    { value: 'rahat-bagh', label: 'Rahat Bagh', pincode: '147001' },
    { value: 'sanghera', label: 'Sanghera', pincode: '147001' },
    { value: 'shergarh', label: 'Shergarh', pincode: '147001' },
    { value: 'baradari-gardens', label: 'Baradari Gardens', pincode: '147001' },
    { value: 'leela-bhawan', label: 'Leela Bhawan', pincode: '147001' },
    { value: 'green-park', label: 'Green Park', pincode: '147001' },
    { value: 'nabha-road', label: 'Nabha Road', pincode: '147001' },
    { value: 'tripuri-town', label: 'Tripuri Town', pincode: '147001' },
    { value: 'urban-estate', label: 'Urban Estate', pincode: '147002' },
    { value: 'anjuman', label: 'Anjuman', pincode: '147001' },
    { value: 'royal-enclave', label: 'Royal Enclave', pincode: '147001' }
  ],

  'pathankot': [
    { value: 'adda-pathankot', label: 'Adda Pathankot', pincode: '145001' },
    { value: 'alampur', label: 'Alampur', pincode: '145001' },
    { value: 'baddowal', label: 'Baddowal', pincode: '145001' },
    { value: 'balwal', label: 'Balwal', pincode: '145001' },
    { value: 'bari', label: 'Bari', pincode: '145001' },
    { value: 'bhalla', label: 'Bhalla', pincode: '145001' },
    { value: 'bhanohar', label: 'Bhanohar', pincode: '145001' },
    { value: 'chhani', label: 'Chhani', pincode: '145001' },
    { value: 'chakki-bank', label: 'Chakki Bank', pincode: '145001' },
    { value: 'dalhousie-road', label: 'Dalhousie Road', pincode: '145001' },
    { value: 'dhar', label: 'Dhar', pincode: '145001' },
    { value: 'dharowal', label: 'Dharowal', pincode: '145001' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '145001' },
    { value: 'haripur', label: 'Haripur', pincode: '145001' },
    { value: 'jammu-road', label: 'Jammu Road', pincode: '145001' },
    { value: 'jandial', label: 'Jandial', pincode: '145001' },
    { value: 'jandiala', label: 'Jandiala', pincode: '145001' },
    { value: 'kali-dab', label: 'Kali Dab', pincode: '145001' },
    { value: 'kampur', label: 'Kampur', pincode: '145001' },
    { value: 'kathlor', label: 'Kathlor', pincode: '145001' },
    { value: 'khadwal', label: 'Khadwal', pincode: '145001' },
    { value: 'kotli', label: 'Kotli', pincode: '145001' },
    { value: 'madhopur', label: 'Madhopur', pincode: '145001' },
    { value: 'mandi-pathankot', label: 'Mandi Pathankot', pincode: '145001' },
    { value: 'manwal', label: 'Manwal', pincode: '145001' },
    { value: 'mehtab-pur', label: 'Mehtab Pur', pincode: '145001' },
    { value: 'nagni', label: 'Nagni', pincode: '145001' },
    { value: 'nurpur', label: 'Nurpur', pincode: '145001' },
    { value: 'pathankot-city', label: 'Pathankot City', pincode: '145001' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '145001' },
    { value: 'sujanpur', label: 'Sujanpur', pincode: '145023' },
    { value: 'shahpur', label: 'Shahpur', pincode: '145001' },
    { value: 'shahpura', label: 'Shahpura', pincode: '145001' },
    { value: 'taragarh', label: 'Taragarh', pincode: '145001' },
    { value: 'zindrawan', label: 'Zindrawan', pincode: '145001' },
    { value: 'zirakpur', label: 'Zirakpur', pincode: '145001' }
  ],

  'moga': [
    { value: 'adda-moga', label: 'Adda Moga', pincode: '142001' },
    { value: 'aheer-wala', label: 'Aheer Wala', pincode: '142001' },
    { value: 'bajakhana', label: 'Bajakhana', pincode: '142001' },
    { value: 'bhulath', label: 'Bhulath', pincode: '142001' },
    { value: 'chhajjal-wala', label: 'Chhajjal Wala', pincode: '142001' },
    { value: 'dalewal', label: 'Dalewal', pincode: '142001' },
    { value: 'dehlon', label: 'Dehlon', pincode: '142001' },
    { value: 'dhamika', label: 'Dhamika', pincode: '142001' },
    { value: 'dhudike', label: 'Dhudike', pincode: '142001' },
    { value: 'fatehpur-kalan', label: 'Fatehpur Kalan', pincode: '142001' },
    { value: 'gattu-wala', label: 'Gattu Wala', pincode: '142001' },
    { value: 'gill-kalan', label: 'Gill Kalan', pincode: '142001' },
    { value: 'gill-wala', label: 'Gill Wala', pincode: '142001' },
    { value: 'jagraon-road', label: 'Jagraon Road', pincode: '142001' },
    { value: 'jodha-wala', label: 'Jodha Wala', pincode: '142001' },
    { value: 'kamal-wala', label: 'Kamal Wala', pincode: '142001' },
    { value: 'manuke', label: 'Manuke', pincode: '142001' },
    { value: 'mandi-kalan', label: 'Mandi Kalan', pincode: '142001' },
    { value: 'mian-wala', label: 'Mian Wala', pincode: '142001' },
    { value: 'moga-city', label: 'Moga City', pincode: '142001' },
    { value: 'new-moga', label: 'New Moga', pincode: '142001' },
    { value: 'punjab-garden', label: 'Punjab Garden', pincode: '142001' },
    { value: 'rangpur', label: 'Rangpur', pincode: '142001' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '142001' },
    { value: 'sahib-wala', label: 'Sahib Wala', pincode: '142001' },
    { value: 'sikri', label: 'Sikri', pincode: '142001' },
    { value: 'sundar-das', label: 'Sundar Das', pincode: '142001' },
    { value: 'talwandi-sabo', label: 'Talwandi Sabo', pincode: '142001' },
    { value: 'zira', label: 'Zira', pincode: '142047' }
  ],

  'mansa': [
    { value: 'addar-pur', label: 'Addar Pur', pincode: '151001' },
    { value: 'bhagatpura', label: 'Bhagatpura', pincode: '151001' },
    { value: 'bhanewal', label: 'Bhanewal', pincode: '151001' },
    { value: 'chatta-pur', label: 'Chatta Pur', pincode: '151001' },
    { value: 'darbara', label: 'Darbara', pincode: '151001' },
    { value: 'dharamsal', label: 'Dharamsal', pincode: '151001' },
    { value: 'fazil-pur', label: 'Fazil Pur', pincode: '151001' },
    { value: 'fatehabad', label: 'Fatehabad', pincode: '151001' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '151001' },
    { value: 'gajuwala', label: 'Gajuwala', pincode: '151001' },
    { value: 'gill-mandi', label: 'Gill Mandi', pincode: '151001' },
    { value: 'jot-pur', label: 'Jot Pur', pincode: '151001' },
    { value: 'kandhla', label: 'Kandhla', pincode: '151001' },
    { value: 'kheri', label: 'Kheri', pincode: '151001' },
    { value: 'khudi', label: 'Khudi', pincode: '151001' },
    { value: 'manchana', label: 'Manchana', pincode: '151001' },
    { value: 'mansa-city', label: 'Mansa City', pincode: '151001' },
    { value: 'mehmadpur', label: 'Mehmadpur', pincode: '151001' },
    { value: 'raian', label: 'Raian', pincode: '151001' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '151001' },
    { value: 'rauni', label: 'Rauni', pincode: '151001' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '151001' },
    { value: 'singhwala', label: 'Singhwala', pincode: '151001' },
    { value: 'sundarwala', label: 'Sundarwala', pincode: '151001' },
    { value: 'tangra', label: 'Tangra', pincode: '151001' },
    { value: 'tariwala', label: 'Tariwala', pincode: '151001' },
    { value: 'tillu-pur', label: 'Tillu Pur', pincode: '151001' },
    { value: 'ugra-pur', label: 'Ugra Pur', pincode: '151001' }
  ],

  'ludhiana': [
    { value: 'adda-ludhiana', label: 'Adda Ludhiana', pincode: '141001' },
    { value: 'aliwal', label: 'Aliwal', pincode: '141104' },
    { value: 'bajwa', label: 'Bajwa', pincode: '141002' },
    { value: 'basti-jodhewal', label: 'Basti Jodhewal', pincode: '141007' },
    { value: 'basti-nau', label: 'Basti Nau', pincode: '141003' },
    { value: 'bharat-nagar', label: 'Bharat Nagar', pincode: '141001' },
    { value: 'bhamian', label: 'Bhamian', pincode: '141001' },
    { value: 'bhai-randhir-singh-nagar', label: 'Bhai Randhir Singh Nagar', pincode: '141012' },
    { value: 'chand-bhuri', label: 'Chand Bhuri', pincode: '141003' },
    { value: 'chipiana', label: 'Chipiana', pincode: '141001' },
    { value: 'civil-lines', label: 'Civil Lines', pincode: '141001' },
    { value: 'daba', label: 'Daba', pincode: '141001' },
    { value: 'dhandari', label: 'Dhandari', pincode: '141014' },
    { value: 'dhandra', label: 'Dhandra', pincode: '141008' },
    { value: 'duggri', label: 'Dugri', pincode: '141014' },
    { value: 'fatehabad', label: 'Fatehabad', pincode: '141006' },
    { value: 'fattuwal', label: 'Fattuwal', pincode: '141001' },
    { value: 'field-gunj', label: 'Field Gunj', pincode: '141001' },
    { value: 'focal-point', label: 'Focal Point', pincode: '141010' },
    { value: 'gangian', label: 'Gangian', pincode: '141001' },
    { value: 'gill-road', label: 'Gill Road', pincode: '141001' },
    { value: 'gurdev-nagar', label: 'Gurdev Nagar', pincode: '141001' },
    { value: 'haibowal', label: 'Haibowal', pincode: '141001' },
    { value: 'jagraon', label: 'Jagraon', pincode: '142026' },
    { value: 'jamalpur', label: 'Jamalpur', pincode: '141010' },
    { value: 'kitchlu-nagar', label: 'Kitchlu Nagar', pincode: '141002' },
    { value: 'kitchlu-nagar-extension', label: 'Kitchlu Nagar Extension', pincode: '141002' },
    { value: 'khanna-road', label: 'Khanna Road', pincode: '141001' },
    { value: 'ludhiana-city', label: 'Ludhiana City', pincode: '141001' },
    { value: 'manak-mandi', label: 'Manak Mandi', pincode: '141001' },
    { value: 'miller-ganj', label: 'Miller Ganj', pincode: '141001' },
    { value: 'model-town', label: 'Model Town', pincode: '141001' },
    { value: 'model-town-extension', label: 'Model Town Extension', pincode: '141002' },
    { value: 'new-colony', label: 'New Colony', pincode: '141008' },
    { value: 'new-ludhiana', label: 'New Ludhiana', pincode: '141001' },
    { value: 'opposite-railway-station', label: 'Opposite Railway Station', pincode: '141001' },
    { value: 'pakhowal', label: 'Pakhowal', pincode: '141001' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '141001' },
    { value: 'sarabha-nagar', label: 'Sarabha Nagar', pincode: '141001' },
    { value: 'sherpur', label: 'Sherpur', pincode: '141010' },
    { value: 'sudhar', label: 'Sudhar', pincode: '141001' },
    { value: 'surjit-nagar', label: 'Surjit Nagar', pincode: '141001' },
    { value: 'takhat-singh', label: 'Takhat Singh', pincode: '141001' },
    { value: 'vishwakarma', label: 'Vishwakarma', pincode: '141001' },
  ],

  'khanna': [
    { value: 'adda-khanna', label: 'Adda Khanna', pincode: '141401' },
    { value: 'bachha-pur', label: 'Bachha Pur', pincode: '141401' },
    { value: 'balad', label: 'Balad', pincode: '141401' },
    { value: 'bajwa', label: 'Bajwa', pincode: '141401' },
    { value: 'bassi', label: 'Bassi', pincode: '141401' },
    { value: 'behlolpur', label: 'Behlolpur', pincode: '141401' },
    { value: 'bhagatpura', label: 'Bhagatpura', pincode: '141401' },
    { value: 'bhaini', label: 'Bhaini', pincode: '141401' },
    { value: 'bhamian', label: 'Bhamian', pincode: '141401' },
    { value: 'chandigarh-road', label: 'Chandigarh Road', pincode: '141401' },
    { value: 'dhanuri', label: 'Dhanuri', pincode: '141401' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '141401' },
    { value: 'ganeshpura', label: 'Ganeshpura', pincode: '141401' },
    { value: 'gill-kalan', label: 'Gill Kalan', pincode: '141401' },
    { value: 'gill-mohalla', label: 'Gill Mohalla', pincode: '141401' },
    { value: 'gill-pur', label: 'Gill Pur', pincode: '141401' },
    { value: 'gurujagroan', label: 'Gurujagroan', pincode: '141401' },
    { value: 'jalalabad', label: 'Jalalabad', pincode: '141401' },
    { value: 'kadian', label: 'Kadian', pincode: '141401' },
    { value: 'khanna-city', label: 'Khanna City', pincode: '141401' },
    { value: 'kotla', label: 'Kotla', pincode: '141401' },
    { value: 'makhan-majra', label: 'Makhan Majra', pincode: '141401' },
    { value: 'mauli', label: 'Mauli', pincode: '141401' },
    { value: 'mohla', label: 'Mohla', pincode: '141401' },
    { value: 'mohammadpur', label: 'Mohammadpur', pincode: '141401' },
    { value: 'mughal-pur', label: 'Mughal Pur', pincode: '141401' },
    { value: 'nanhera', label: 'Nanhera', pincode: '141401' },
    { value: 'nawan', label: 'Nawan', pincode: '141401' },
    { value: 'nehal-wala', label: 'Nehal Wala', pincode: '141401' },
    { value: 'patiala-road', label: 'Patiala Road', pincode: '141401' },
    { value: 'patti-sultan', label: 'Patti Sultan', pincode: '141401' },
    { value: 'rajan-wala', label: 'Rajan Wala', pincode: '141401' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '141401' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '141401' },
    { value: 'sarai', label: 'Sarai', pincode: '141401' },
    { value: 'sikri', label: 'Sikri', pincode: '141401' },
    { value: 'sundar-mandi', label: 'Sundar Mandi', pincode: '141401' },
    { value: 'tanda', label: 'Tanda', pincode: '141401' },
    { value: 'tiba', label: 'Tiba', pincode: '141401' },
    { value: 'vijay-pur', label: 'Vijay Pur', pincode: '141401' }
  ],

  'khamanon': [
    { value: 'adda-khamanon', label: 'Adda Khamanon', pincode: '141801' },
    { value: 'bassi-pathana', label: 'Bassi Pathana', pincode: '141803' },
    { value: 'bhajauli', label: 'Bhajauli', pincode: '141802' },
    { value: 'bhari', label: 'Bhari', pincode: '141804' },
    { value: 'chakki', label: 'Chakki', pincode: '141805' },
    { value: 'chandpura', label: 'Chandpura', pincode: '141806' },
    { value: 'dhamot', label: 'Dhamot', pincode: '141807' },
    { value: 'dohar', label: 'Dohar', pincode: '141808' },
    { value: 'gobindgarh', label: 'Gobindgarh', pincode: '141809' },
    { value: 'guru-pura', label: 'Guru Pura', pincode: '141810' },
    { value: 'hargobindpura', label: 'Hargobindpura', pincode: '141811' },
    { value: 'jandiala', label: 'Jandiala', pincode: '141812' },
    { value: 'khamanon-city', label: 'Khamanon City', pincode: '141801' },
    { value: 'khera', label: 'Khera', pincode: '141802' },
    { value: 'kotla', label: 'Kotla', pincode: '141805' },
    { value: 'ladha-manki', label: 'Ladha Manki', pincode: '141804' },
    { value: 'madhopur', label: 'Madhopur', pincode: '141802' },
    { value: 'mangewal', label: 'Mangewal', pincode: '141806' },
    { value: 'mohali', label: 'Mohali', pincode: '141802' },
    { value: 'nangal', label: 'Nangal', pincode: '141803' },
    { value: 'patiala-road', label: 'Patiala Road', pincode: '141801' },
    { value: 'phirni', label: 'Phirni', pincode: '141804' },
    { value: 'rajgarh', label: 'Rajgarh', pincode: '141805' },
    { value: 'sangrur', label: 'Sangrur', pincode: '141807' },
    { value: 'sidhwan', label: 'Sidhwan', pincode: '141806' },
    { value: 'sukhdev-nagar', label: 'Sukhdev Nagar', pincode: '141801' },
    { value: 'talwandi', label: 'Talwandi', pincode: '141810' },
    { value: 'wala', label: 'Wala', pincode: '141807' }
  ],

  'jalandhar': [
    { value: 'adda-jalandhar', label: 'Adda Jalandhar', pincode: '144205' },
    { value: 'alampur', label: 'Alampur', pincode: '144207' },
    { value: 'alipur', label: 'Alipur', pincode: '144205' },
    { value: 'bajwa', label: 'Bajwa', pincode: '144205' },
    { value: 'basti-bawa-khel', label: 'Basti Bawa Khel', pincode: '144205' },
    { value: 'basti-noor-ganj', label: 'Basti Noor Ganj', pincode: '144205' },
    { value: 'basti-shahpur', label: 'Basti Shahpur', pincode: '144205' },
    { value: 'basti-sumera', label: 'Basti Sumera', pincode: '144205' },
    { value: 'bhogpur', label: 'Bhogpur', pincode: '144205' },
    { value: 'chandigarh', label: 'Chandigarh', pincode: '144204' },
    { value: 'chheharta', label: 'Chheharta', pincode: '144205' },
    { value: 'chhoti', label: 'Chhoti', pincode: '144205' },
    { value: 'chuharpur', label: 'Chuharpur', pincode: '144204' },
    { value: 'dalewal', label: 'Dalewal', pincode: '144207' },
    { value: 'fatehpur', label: 'Fatehpur', pincode: '144205' },
    { value: 'gill', label: 'Gill', pincode: '144207' },
    { value: 'gurdwara', label: 'Gurdwara', pincode: '144207' },
    { value: 'harbanspura', label: 'Harbanspura', pincode: '144204' },
    { value: 'jalalabad', label: 'Jalalabad', pincode: '144205' },
    { value: 'jalalpur', label: 'Jalalpur', pincode: '144205' },
    { value: 'jaleb', label: 'Jaleb', pincode: '144205' },
    { value: 'jattpura', label: 'Jattpura', pincode: '144204' },
    { value: 'kadian', label: 'Kadian', pincode: '144205' },
    { value: 'karol-bagh', label: 'Karol Bagh', pincode: '144205' },
    { value: 'keematpur', label: 'Keematpur', pincode: '144207' },
    { value: 'khatri', label: 'Khatri', pincode: '144205' },
    { value: 'kishanpura', label: 'Kishanpura', pincode: '144205' },
    { value: 'kunnian', label: 'Kunnian', pincode: '144204' },
    { value: 'madhopur', label: 'Madhopur', pincode: '144207' },
    { value: 'madrian', label: 'Madrian', pincode: '144205' },
    { value: 'makhanpur', label: 'Makhanpur', pincode: '144207' },
    { value: 'manjipur', label: 'Manjipur', pincode: '144205' },
    { value: 'mangewal', label: 'Mangewal', pincode: '144205' },
    { value: 'mawan', label: 'Mawan', pincode: '144205' },
    { value: 'miani', label: 'Miani', pincode: '144207' },
    { value: 'nanakpur', label: 'Nanakpur', pincode: '144205' },
    { value: 'naushara', label: 'Naushara', pincode: '144204' },
    { value: 'patti', label: 'Patti', pincode: '144204' },
    { value: 'phillaur', label: 'Phillaur', pincode: '144410' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '144205' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '144205' },
    { value: 'rana', label: 'Rana', pincode: '144205' },
    { value: 'rangila', label: 'Rangila', pincode: '144204' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '144205' },
    { value: 'shahkot', label: 'Shahkot', pincode: '144205' },
    { value: 'sialkoti', label: 'Sialkoti', pincode: '144205' },
    { value: 'sunder-nagar', label: 'Sunder Nagar', pincode: '144205' },
    { value: 'suri', label: 'Suri', pincode: '144205' },
    { value: 'tara-wali', label: 'Tara Wali', pincode: '144205' },
    { value: 'village-bahram', label: 'Village Bahram', pincode: '144205' },
    { value: 'wahidpur', label: 'Wahidpur', pincode: '144205' },
    { value: 'wariana', label: 'Wariana', pincode: '144205' }
  ],

  'hoshiarpur': [
    { value: 'adda-hoshiarpur', label: 'Adda Hoshiarpur', pincode: '146001' },
    { value: 'agwanpur', label: 'Agwanpur', pincode: '146105' },
    { value: 'balahir', label: 'Balahir', pincode: '146102' },
    { value: 'bambuwal', label: 'Bambuwal', pincode: '146111' },
    { value: 'bariyan', label: 'Bariyan', pincode: '146101' },
    { value: 'banbari', label: 'Banbari', pincode: '146115' },
    { value: 'barian', label: 'Barian', pincode: '146112' },
    { value: 'chak-baba', label: 'Chak Baba', pincode: '146103' },
    { value: 'chak-kerian', label: 'Chak Kerian', pincode: '146115' },
    { value: 'chamkaur-sahib', label: 'Chamkaur Sahib', pincode: '146104' },
    { value: 'chheharta', label: 'Chheharta', pincode: '146115' },
    { value: 'dhamo', label: 'Dhamo', pincode: '146101' },
    { value: 'fattuwal', label: 'Fattuwal', pincode: '146104' },
    { value: 'gaddian', label: 'Gaddian', pincode: '146111' },
    { value: 'ganeshpur', label: 'Ganeshpur', pincode: '146102' },
    { value: 'garia', label: 'Garia', pincode: '146103' },
    { value: 'gharana', label: 'Gharana', pincode: '146102' },
    { value: 'hamidpur', label: 'Hamidpur', pincode: '146111' },
    { value: 'hasra', label: 'Hasra', pincode: '146115' },
    { value: 'hassanpur', label: 'Hassanpur', pincode: '146110' },
    { value: 'hoshiarpur-city', label: 'Hoshiarpur City', pincode: '146001' },
    { value: 'jallian', label: 'Jallian', pincode: '146103' },
    { value: 'jatwal', label: 'Jatwal', pincode: '146104' },
    { value: 'kaharwan', label: 'Kaharwan', pincode: '146105' },
    { value: 'kamir', label: 'Kamir', pincode: '146101' },
    { value: 'kandiala', label: 'Kandiala', pincode: '146105' },
    { value: 'karian', label: 'Karian', pincode: '146104' },
    { value: 'khajuri', label: 'Khajuri', pincode: '146101' },
    { value: 'kotla', label: 'Kotla', pincode: '146111' },
    { value: 'malakwal', label: 'Malakwal', pincode: '146104' },
    { value: 'malowal', label: 'Malowal', pincode: '146106' },
    { value: 'manakpur', label: 'Manakpur', pincode: '146104' },
    { value: 'mangewal', label: 'Mangewal', pincode: '146111' },
    { value: 'nara', label: 'Nara', pincode: '146115' },
    { value: 'nawanpind', label: 'Nawanpind', pincode: '146104' },
    { value: 'phagwara', label: 'Phagwara', pincode: '144205' },
    { value: 'punja', label: 'Punja', pincode: '146115' },
    { value: 'raipur', label: 'Raipur', pincode: '146105' },
    { value: 'ranjitpura', label: 'Ranjitpura', pincode: '146102' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '146001' },
    { value: 'sahowal', label: 'Sahowal', pincode: '146105' },
    { value: 'sallan', label: 'Sallan', pincode: '146102' },
    { value: 'sangrur', label: 'Sangrur', pincode: '146103' },
    { value: 'sehra', label: 'Sehra', pincode: '146103' },
    { value: 'sidhpur', label: 'Sidhpur', pincode: '146104' },
    { value: 'sohana', label: 'Sohana', pincode: '146105' },
    { value: 'talwandi', label: 'Talwandi', pincode: '146101' },
    { value: 'wala', label: 'Wala', pincode: '146105' }
  ],

  'gurdaspur': [
    { value: 'adda-gurdaspur', label: 'Adda Gurdaspur', pincode: '143521' },
    { value: 'aima', label: 'Aima', pincode: '143514' },
    { value: 'bagrian', label: 'Bagrian', pincode: '143511' },
    { value: 'bhalwal', label: 'Bhalwal', pincode: '143520' },
    { value: 'bhattian', label: 'Bhattian', pincode: '143510' },
    { value: 'chak-bilga', label: 'Chak Bilga', pincode: '143505' },
    { value: 'chak-ramdas', label: 'Chak Ramdas', pincode: '143505' },
    { value: 'chandpur', label: 'Chandpur', pincode: '143505' },
    { value: 'chheharta', label: 'Chheharta', pincode: '143512' },
    { value: 'dhewa', label: 'Dhewa', pincode: '143502' },
    { value: 'dharmkot', label: 'Dharmkot', pincode: '143516' },
    { value: 'dina', label: 'Dina', pincode: '143506' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '143515' },
    { value: 'fatehgarh-churian', label: 'Fatehgarh Churian', pincode: '143514' },
    { value: 'farashpur', label: 'Farashpur', pincode: '143510' },
    { value: 'gurdaspur-city', label: 'Gurdaspur City', pincode: '143521' },
    { value: 'gursar', label: 'Gursar', pincode: '143513' },
    { value: 'hadiabad', label: 'Hadiabad', pincode: '143521' },
    { value: 'jalalabad', label: 'Jalalabad', pincode: '143512' },
    { value: 'jammu-road', label: 'Jammu Road', pincode: '143510' },
    { value: 'jandiala', label: 'Jandiala', pincode: '143502' },
    { value: 'kalandri', label: 'Kalandri', pincode: '143514' },
    { value: 'kapurthala', label: 'Kapurthala', pincode: '143506' },
    { value: 'khara', label: 'Khara', pincode: '143520' },
    { value: 'kotli', label: 'Kotli', pincode: '143505' },
    { value: 'kutba', label: 'Kutba', pincode: '143513' },
    { value: 'ladhuwal', label: 'Ladhuwal', pincode: '143510' },
    { value: 'mangewal', label: 'Mangewal', pincode: '143502' },
    { value: 'maur', label: 'Maur', pincode: '143512' },
    { value: 'mianwala', label: 'Mianwala', pincode: '143510' },
    { value: 'mirza', label: 'Mirza', pincode: '143515' },
    { value: 'nawan-pind', label: 'Nawan Pind', pincode: '143521' },
    { value: 'nawan-sarai', label: 'Nawan Sarai', pincode: '143520' },
    { value: 'phillaur', label: 'Phillaur', pincode: '143506' },
    { value: 'ranian', label: 'Ranian', pincode: '143512' },
    { value: 'ranjitpura', label: 'Ranjitpura', pincode: '143512' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '143510' },
    { value: 'talwandi', label: 'Talwandi', pincode: '143511' },
    { value: 'talwandi-bhawan', label: 'Talwandi Bhawan', pincode: '143514' },
    { value: 'wala', label: 'Wala', pincode: '143520' }
  ],

  'fazilka': [
    { value: 'adda-fazilka', label: 'Adda Fazilka', pincode: '152123' },
    { value: 'bhadaur', label: 'Bhadaur', pincode: '152124' },
    { value: 'bhikhiwind', label: 'Bhikhiwind', pincode: '152124' },
    { value: 'chandpura', label: 'Chandpura', pincode: '152124' },
    { value: 'chak-ramdas', label: 'Chak Ramdas', pincode: '152124' },
    { value: 'charik', label: 'Charik', pincode: '152123' },
    { value: 'dadoh', label: 'Dadoh', pincode: '152123' },
    { value: 'dhanjal', label: 'Dhanjal', pincode: '152124' },
    { value: 'dharmkot', label: 'Dharmkot', pincode: '152124' },
    { value: 'fazilka-city', label: 'Fazilka City', pincode: '152123' },
    { value: 'gadhari', label: 'Gadhari', pincode: '152123' },
    { value: 'gursar', label: 'Gursar', pincode: '152123' },
    { value: 'jalalabad', label: 'Jalalabad', pincode: '152103' },
    { value: 'jandwala', label: 'Jandwala', pincode: '152124' },
    { value: 'kadian', label: 'Kadian', pincode: '152124' },
    { value: 'kalab', label: 'Kalab', pincode: '152124' },
    { value: 'kotla', label: 'Kotla', pincode: '152123' },
    { value: 'ladhuwal', label: 'Ladhuwal', pincode: '152123' },
    { value: 'loharka', label: 'Loharka', pincode: '152124' },
    { value: 'mangalpura', label: 'Mangalpura', pincode: '152123' },
    { value: 'maur', label: 'Maur', pincode: '152123' },
    { value: 'mukandpura', label: 'Mukandpura', pincode: '152123' },
    { value: 'nawan-shahar', label: 'Nawan Shahar', pincode: '152124' },
    { value: 'phillaur', label: 'Phillaur', pincode: '152124' },
    { value: 'ranian', label: 'Ranian', pincode: '152124' },
    { value: 'ropar', label: 'Ropar', pincode: '152124' },
    { value: 'sadiq', label: 'Sadiq', pincode: '152123' },
    { value: 'sukhera', label: 'Sukhera', pincode: '152123' },
    { value: 'sultan-wala', label: 'Sultan Wala', pincode: '152123' },
    { value: 'talwandi', label: 'Talwandi', pincode: '152124' },
    { value: 'wala', label: 'Wala', pincode: '152124' }
  ],

  'faridkot': [
    { value: 'adda-faridkot', label: 'Adda Faridkot', pincode: '151203' },
    { value: 'adda-khushalpura', label: 'Adda Khushalpura', pincode: '151203' },
    { value: 'aleem-pura', label: 'Aleem Pura', pincode: '151203' },
    { value: 'arifke', label: 'Arifke', pincode: '151206' },
    { value: 'bandran', label: 'Bandran', pincode: '151203' },
    { value: 'badhai', label: 'Badhai', pincode: '151203' },
    { value: 'bari', label: 'Bari', pincode: '151203' },
    { value: 'bariwala', label: 'Bariwala', pincode: '151205' },
    { value: 'barwala', label: 'Barwala', pincode: '151203' },
    { value: 'bhikhiwind', label: 'Bhikhiwind', pincode: '151203' },
    { value: 'bhinder', label: 'Bhinder', pincode: '151203' },
    { value: 'bihla', label: 'Bihla', pincode: '151204' },
    { value: 'burj-pipal', label: 'Burj Pipal', pincode: '151205' },
    { value: 'chandpur', label: 'Chandpur', pincode: '151204' },
    { value: 'chandpura', label: 'Chandpura', pincode: '151203' },
    { value: 'charanwali', label: 'Charanwali', pincode: '151203' },
    { value: 'chhatriwala', label: 'Chhatriwala', pincode: '151205' },
    { value: 'cheema', label: 'Cheema', pincode: '151204' },
    { value: 'chhajjal', label: 'Chhajjal', pincode: '151203' },
    { value: 'dalla', label: 'Dalla', pincode: '151205' },
    { value: 'darbara', label: 'Darbara', pincode: '151205' },
    { value: 'dhaner', label: 'Dhaner', pincode: '151206' },
    { value: 'dina', label: 'Dina', pincode: '151203' },
    { value: 'dodewal', label: 'Dodewal', pincode: '151203' },
    { value: 'faridkot-city', label: 'Faridkot City', pincode: '151203' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '151204' },
    { value: 'fazilka', label: 'Fazilka', pincode: '151203' },
    { value: 'jandwala', label: 'Jandwala', pincode: '151205' },
    { value: 'jandwala-bhusewala', label: 'Jandwala Bhusewala', pincode: '151205' },
    { value: 'kapura', label: 'Kapura', pincode: '151206' },
    { value: 'khaspur', label: 'Khaspur', pincode: '151204' },
    { value: 'kotli', label: 'Kotli', pincode: '151203' },
    { value: 'kotli-bhusewala', label: 'Kotli Bhusewala', pincode: '151203' },
    { value: 'kumarwala', label: 'Kumarwala', pincode: '151204' },
    { value: 'kuttiwala', label: 'Kuttiwala', pincode: '151204' },
    { value: 'lohara', label: 'Lohara', pincode: '151206' },
    { value: 'lohar-pura', label: 'Lohar Pura', pincode: '151204' },
    { value: 'malkana', label: 'Malkana', pincode: '151204' },
    { value: 'maur', label: 'Maur', pincode: '151204' },
    { value: 'mehta', label: 'Mehta', pincode: '151206' },
    { value: 'phularwan', label: 'Phularwan', pincode: '151205' },
    { value: 'rampura', label: 'Rampura', pincode: '151205' },
    { value: 'ranian', label: 'Ranian', pincode: '151203' },
    { value: 'sadda', label: 'Sadda', pincode: '151206' },
    { value: 'sadiq', label: 'Sadiq', pincode: '151204' },
    { value: 'sikandarpura', label: 'Sikandarpura', pincode: '151204' },
    { value: 'sultan-abad', label: 'Sultan Abad', pincode: '151203' },
    { value: 'talwandi', label: 'Talwandi', pincode: '151203' },
    { value: 'tappa-bhusewala', label: 'Tappa Bhusewala', pincode: '151204' },
    { value: 'tarkhanwala', label: 'Tarkhanwala', pincode: '151205' },
    { value: 'wala', label: 'Wala', pincode: '151205' },
    { value: 'wala-jattan', label: 'Wala Jattan', pincode: '151204' }
  ],

  'batala': [
    { value: 'achhal', label: 'Achhal', pincode: '143505' },
    { value: 'adda-khan', label: 'Adda Khan', pincode: '143505' },
    { value: 'adda-mirpur', label: 'Adda Mirpur', pincode: '143505' },
    { value: 'andhu-wala', label: 'Andhu Wala', pincode: '143505' },
    { value: 'bahadur-ke', label: 'Bahadur Ke', pincode: '143505' },
    { value: 'bakhshiwala-batala', label: 'Bakhshiwala Batala', pincode: '143505' },
    { value: 'baliawal', label: 'Baliawal', pincode: '143505' },
    { value: 'ballewal', label: 'Ballewal', pincode: '143505' },
    { value: 'bakshiwala', label: 'Bakshiwala', pincode: '143505' },
    { value: 'bari', label: 'Bari', pincode: '143505' },
    { value: 'batala-city', label: 'Batala City', pincode: '143505' },
    { value: 'bhikhian', label: 'Bhikhian', pincode: '143505' },
    { value: 'bhura-wala', label: 'Bhura Wala', pincode: '143505' },
    { value: 'bir-ramdas', label: 'Bir Ramdas', pincode: '143505' },
    { value: 'chandpur', label: 'Chandpur', pincode: '143505' },
    { value: 'chak-aman', label: 'Chak Aman', pincode: '143505' },
    { value: 'chak-ramdas', label: 'Chak Ramdas', pincode: '143505' },
    { value: 'cheema', label: 'Cheema', pincode: '143505' },
    { value: 'chhanna', label: 'Chhanna', pincode: '143505' },
    { value: 'chhota-batala', label: 'Chhota Batala', pincode: '143505' },
    { value: 'dhakewal', label: 'Dhakewal', pincode: '143505' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '143505' },
    { value: 'ganesan', label: 'Ganesan', pincode: '143505' },
    { value: 'gill', label: 'Gill', pincode: '143505' },
    { value: 'gurdaspur', label: 'Gurdaspur', pincode: '143521' },
    { value: 'jammu-adda', label: 'Jammu Adda', pincode: '143505' },
    { value: 'jandiala', label: 'Jandiala', pincode: '143505' },
    { value: 'jhok-ke', label: 'Jhok Ke', pincode: '143505' },
    { value: 'kadian', label: 'Kadian', pincode: '143505' },
    { value: 'kalra', label: 'Kalra', pincode: '143505' },
    { value: 'khandewal', label: 'Khandewal', pincode: '143505' },
    { value: 'khanpur', label: 'Khanpur', pincode: '143505' },
    { value: 'kotli', label: 'Kotli', pincode: '143505' },
    { value: 'loharka', label: 'Loharka', pincode: '143505' },
    { value: 'madho-ramdas', label: 'Madho Ramdas', pincode: '143505' },
    { value: 'miani', label: 'Miani', pincode: '143505' },
    { value: 'ramdas', label: 'Ramdas', pincode: '143505' },
    { value: 'rampur', label: 'Rampur', pincode: '143505' },
    { value: 'sadar-batala', label: 'Sadar Batala', pincode: '143505' },
    { value: 'sakhian', label: 'Sakhian', pincode: '143505' },
    { value: 'sikandarpur', label: 'Sikandarpur', pincode: '143505' },
    { value: 'sultan-ke', label: 'Sultan Ke', pincode: '143505' },
    { value: 'tarkhan-wala', label: 'Tarkhan Wala', pincode: '143505' },
    { value: 'wala', label: 'Wala', pincode: '143505' }
  ],

  'firozpur': [
  { value: 'adampur', label: 'Adampur', pincode: '152002' },
  { value: 'ali-ke', label: 'Ali Ke', pincode: '152001' },
  { value: 'bakhar', label: 'Bakhar', pincode: '152101' },
  { value: 'bilga', label: 'Bilga', pincode: '152104' },
  { value: 'firozpur-city', label: 'Firozpur City', pincode: '152002' },
  { value: 'firozpur-district', label: 'Firozpur District', pincode: '152001' },
  { value: 'khera', label: 'Khera', pincode: '152002' },
  { value: 'kot-masoom', label: 'Kot Masoom', pincode: '152002' },
  { value: 'muktsar', label: 'Muktsar', pincode: '152026' },
  { value: 'phirni-bhulath', label: 'Phirni Bhulath', pincode: '152003' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '152002' },
  { value: 'shahjahan', label: 'Shahjahan', pincode: '152005' },
  { value: 'sultankhera', label: 'Sultankhera', pincode: '152002' },
  { value: 'tarn-taran', label: 'Tarn Taran', pincode: '143401' },
  { value: 'zafarwal', label: 'Zafarwal', pincode: '152110' },
  { value: 'kacha-pind', label: 'Kacha Pind', pincode: '152001' },
  { value: 'daspur', label: 'Daspur', pincode: '152001' },
  { value: 'bhikhiwind', label: 'Bhikhiwind', pincode: '143204' }
  ],
  
  'gobindgarh': [
  { value: 'baba-bakale', label: 'Baba Bakale', pincode: '147301' },
  { value: 'dhanansu', label: 'Dhanansu', pincode: '147301' },
  { value: 'fatehgarh-sahib', label: 'Fatehgarh Sahib', pincode: '140406' },
  { value: 'gobindgarh', label: 'Gobindgarh', pincode: '147301' },
  { value: 'gurdaspur', label: 'Gurdaspur', pincode: '147301' },
  { value: 'kala-afghana', label: 'Kala Afghana', pincode: '147301' },
  { value: 'khamano', label: 'Khamano', pincode: '147204' },
  { value: 'khera', label: 'Khera', pincode: '147302' },
  { value: 'kot-kalan', label: 'Kot Kalan', pincode: '147301' },
  { value: 'mandi-kalan', label: 'Mandi Kalan', pincode: '147301' },
  { value: 'new-purani', label: 'New Purani', pincode: '147301' },
  { value: 'rajanpur', label: 'Rajanpur', pincode: '147301' },
  { value: 'tahli', label: 'Tahli', pincode: '147301' },
  { value: 'raota', label: 'Raota', pincode: '147301' },
  { value: 'samaon', label: 'Samaon', pincode: '147301' },
  { value: 'sanghol', label: 'Sanghol', pincode: '147301' },
  { value: 'sarai', label: 'Sarai', pincode: '147301' },
  { value: 'new-gobindgarh', label: 'New Gobindgarh', pincode: '147301' },
  { value: 'bhaini', label: 'Bhaini', pincode: '147301' }
  ],
  
  'maur': [
  { value: 'bhaini', label: 'Bhaini', pincode: '151509' },
  { value: 'bharan', label: 'Bharan', pincode: '151509' },
  { value: 'chandbhi', label: 'Chandbhi', pincode: '151509' },
  { value: 'gill-kalan', label: 'Gill Kalan', pincode: '151509' },
  { value: 'gill-wali', label: 'Gill Wali', pincode: '151509' },
  { value: 'gurusar', label: 'Gurusar', pincode: '151509' },
  { value: 'joga', label: 'Joga', pincode: '151509' },
  { value: 'maur', label: 'Maur', pincode: '151509' },
  { value: 'new-maur', label: 'New Maur', pincode: '151509' },
  { value: 'nawanshahr', label: 'Nawanshahr', pincode: '151509' },
  { value: 'rajewal', label: 'Rajewal', pincode: '151509' },
  { value: 'ram-wali', label: 'Ram Wali', pincode: '151509' },
  { value: 'sainiwali', label: 'Sainiwali', pincode: '151509' },
  { value: 'sanaur', label: 'Sanaur', pincode: '151509' },
  { value: 'talan', label: 'Talan', pincode: '151509' },
  { value: 'nangal', label: 'Nangal', pincode: '151509' },
  { value: 'kalanwali', label: 'Kalanwali', pincode: '151509' },
  { value: 'bhaini-kalan', label: 'Bhaini Kalan', pincode: '151509' },
  { value: 'baba-nagar', label: 'Baba Nagar', pincode: '151509' }
  ],
  
  'rampura-phul': [
  { value: 'bhaini', label: 'Bhaini', pincode: '151103' },
  { value: 'bajakhana', label: 'Bajakhana', pincode: '151103' },
  { value: 'chakar', label: 'Chakar', pincode: '151103' },
  { value: 'fatehgarh', label: 'Fatehgarh', pincode: '151103' },
  { value: 'ganeshpur', label: 'Ganeshpur', pincode: '151103' },
  { value: 'gill-pur', label: 'Gill Pur', pincode: '151103' },
  { value: 'gopalpur', label: 'Gopalpur', pincode: '151103' },
  { value: 'kali', label: 'Kali', pincode: '151103' },
  { value: 'ramanwali', label: 'Ramanwali', pincode: '151103' },
  { value: 'rampura-phul', label: 'Rampura Phul', pincode: '151103' },
  { value: 'samaon', label: 'Samaon', pincode: '151103' },
  { value: 'sahnewal', label: 'Sahnewal', pincode: '151103' },
  { value: 'sulaimanke', label: 'Sulaimanke', pincode: '151103' },
  { value: 'taliwala', label: 'Taliwala', pincode: '151103' },
  { value: 'baba-nagar', label: 'Baba Nagar', pincode: '151103' },
  { value: 'bilga', label: 'Bilga', pincode: '151103' },
  { value: 'mullana', label: 'Mullana', pincode: '151103' },
  { value: 'dhandra', label: 'Dhandra', pincode: '151103' }
  ],
  
  'rupnagar': [
  { value: 'baba-bakale', label: 'Baba Bakale', pincode: '140001' },
  { value: 'bada-bakra', label: 'Bada Bakra', pincode: '140001' },
  { value: 'bakhshiwal', label: 'Bakhshiwal', pincode: '140001' },
  { value: 'bilga', label: 'Bilga', pincode: '140001' },
  { value: 'chandpur', label: 'Chandpur', pincode: '140001' },
  { value: 'dhanas', label: 'Dhanas', pincode: '140001' },
  { value: 'fatehgarh', label: 'Fatehgarh', pincode: '140001' },
  { value: 'khara', label: 'Khara', pincode: '140001' },
  { value: 'kiratpur-sahib', label: 'Kiratpur Sahib', pincode: '140114' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '140001' },
  { value: 'naya-gaon', label: 'Naya Gaon', pincode: '140001' },
  { value: 'phagwara', label: 'Phagwara', pincode: '140001' },
  { value: 'punj-gurudwara', label: 'Punj Gurudwara', pincode: '140001' },
  { value: 'rupnagar', label: 'Rupnagar', pincode: '140001' },
  { value: 'sahnewal', label: 'Sahnewal', pincode: '140001' },
  { value: 'sarsa', label: 'Sarsa', pincode: '140001' },
  { value: 'shahpur', label: 'Shahpur', pincode: '140001' },
  { value: 'talwara', label: 'Talwara', pincode: '140115' },
  { value: 'tikar', label: 'Tikar', pincode: '140001' },
  { value: 'gagret', label: 'Gagret', pincode: '140001' },
  { value: 'bholath', label: 'Bholath', pincode: '140001' },
  { value: 'hadiabad', label: 'Hadiabad', pincode: '140001' },
  { value: 'karpura', label: 'Karpura', pincode: '140115' },
  { value: 'nangal-bhatia', label: 'Nangal Bhatia', pincode: '140115' },
  { value: 'shahbazpur', label: 'Shahbazpur', pincode: '140001' }
  ],

  'bathinda': [
    { value: 'adda-bhakna', label: 'Adda Bhakna', pincode: '151101' },
    { value: 'adda-khushalpura', label: 'Adda Khushalpura', pincode: '151101' },
    { value: 'adampur', label: 'Adampur', pincode: '151301' },
    { value: 'amaniwala', label: 'Amaniwala', pincode: '151103' },
    { value: 'bariwala', label: 'Bariwala', pincode: '151101' },
    { value: 'bara-pind', label: 'Bara Pind', pincode: '151102' },
    { value: 'bhandari', label: 'Bhandari', pincode: '151302' },
    { value: 'bhucho-mandi', label: 'Bhucho Mandi', pincode: '151023' },
    { value: 'bibiwala', label: 'Bibiwala', pincode: '151001' },
    { value: 'bikram-pura', label: 'Bikram Pura', pincode: '151101' },
    { value: 'chak-bahgwan', label: 'Chak Bahgwan', pincode: '151103' },
    { value: 'cheema', label: 'Cheema', pincode: '151104' },
    { value: 'chuharwala', label: 'Chuharwala', pincode: '151102' },
    { value: 'dhamo', label: 'Dhamo', pincode: '151107' },
    { value: 'dina', label: 'Dina', pincode: '151101' },
    { value: 'ghumman', label: 'Ghumman', pincode: '151101' },
    { value: 'gill', label: 'Gill', pincode: '151106' },
    { value: 'gudda', label: 'Gudda', pincode: '151103' },
    { value: 'jogi-pura', label: 'Jogi Pura', pincode: '151101' },
    { value: 'kotli', label: 'Kotli', pincode: '151103' },
    { value: 'kotra', label: 'Kotra', pincode: '151101' },
    { value: 'mahalpur', label: 'Mahalpur', pincode: '151101' },
    { value: 'malkana', label: 'Malkana', pincode: '151103' },
    { value: 'mangat-pura', label: 'Mangat Pura', pincode: '151104' },
    { value: 'maur-mandi', label: 'Maur Mandi', pincode: '151509' },
    { value: 'muthiya', label: 'Muthiya', pincode: '151103' },
    { value: 'naugarh', label: 'Naugarh', pincode: '151101' },
    { value: 'patti-malkana', label: 'Patti Malkana', pincode: '151103' },
    { value: 'ramdaspura', label: 'Ramdaspura', pincode: '151106' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '151103' },
    { value: 'rampura', label: 'Rampura', pincode: '151502' },
    { value: 'singh-pura', label: 'Singh Pura', pincode: '151101' },
    { value: 'sultanpur', label: 'Sultanpur', pincode: '151101' },
    { value: 'sultanpura', label: 'Sultanpura', pincode: '151101' },
    { value: 'talwandi', label: 'Talwandi', pincode: '151101' },
    { value: 'tarkhwan', label: 'Tarkhwan', pincode: '151103' },
    { value: 'wazirabad', label: 'Wazirabad', pincode: '151106' }
  ],

  'barnala': [
    { value: 'amar-bhawan', label: 'Amar Bhawan', pincode: '148101' },
    { value: 'amarpura', label: 'Amarpura', pincode: '148101' },
    { value: 'balraampura', label: 'Balraampura', pincode: '148101' },
    { value: 'balrampura', label: 'Balrampura', pincode: '148101' },
    { value: 'birsingh-pura', label: 'Birsingh Pura', pincode: '148103' },
    { value: 'bhucho-mandi', label: 'Bhucho Mandi', pincode: '148023' },
    { value: 'bhullar', label: 'Bhullar', pincode: '148109' },
    { value: 'bolina', label: 'Bolina', pincode: '148102' },
    { value: 'chandiala', label: 'Chandiala', pincode: '148104' },
    { value: 'chandpura', label: 'Chandpura', pincode: '148101' },
    { value: 'dhamo', label: 'Dhamo', pincode: '148107' },
    { value: 'dhanura', label: 'Dhanura', pincode: '148103' },
    { value: 'dharmkot', label: 'Dharmkot', pincode: '148107' },
    { value: 'gajjuwal', label: 'Gajjuwal', pincode: '148103' },
    { value: 'gill-kalan', label: 'Gill Kalan', pincode: '148104' },
    { value: 'gill-khurd', label: 'Gill Khurd', pincode: '148104' },
    { value: 'jandwala', label: 'Jandwala', pincode: '148102' },
    { value: 'jassowal', label: 'Jassowal', pincode: '148102' },
    { value: 'jogewal', label: 'Jogewal', pincode: '148101' },
    { value: 'kachiwal', label: 'Kachiwal', pincode: '148107' },
    { value: 'kandela', label: 'Kandela', pincode: '148109' },
    { value: 'kandhar', label: 'Kandhar', pincode: '148103' },
    { value: 'killa-puran', label: 'Killa Puran', pincode: '148106' },
    { value: 'khokhar', label: 'Khokhar', pincode: '148103' },
    { value: 'maur', label: 'Maur', pincode: '148101' },
    { value: 'mangal', label: 'Mangal', pincode: '148101' },
    { value: 'new-barnala', label: 'New Barnala', pincode: '148101' },
    { value: 'nizampura', label: 'Nizampura', pincode: '148101' },
    { value: 'rajewal', label: 'Rajewal', pincode: '148103' },
    { value: 'raipur', label: 'Raipur', pincode: '148109' },
    { value: 'ramdaspura', label: 'Ramdaspura', pincode: '148106' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '148102' },
    { value: 'saluja', label: 'Saluja', pincode: '148103' },
    { value: 'sangatpura', label: 'Sangatpura', pincode: '148101' },
    { value: 'samana', label: 'Samana', pincode: '148101' },
    { value: 'tahliwala', label: 'Tahliwala', pincode: '148103' },
    { value: 'tarkhwan', label: 'Tarkhwan', pincode: '148107' },
    { value: 'wala', label: 'Wala', pincode: '148103' }
  ],
'ajitgarh': [
  { value: 'amloh', label: 'Amloh', pincode: '147203' },
  { value: 'bassi', label: 'Bassi', pincode: '147301' },
  { value: 'bhikhi', label: 'Bhikhi', pincode: '151504' },
  { value: 'dhaner', label: 'Dhaner', pincode: '147202' },
  { value: 'fattuwal', label: 'Fattuwal', pincode: '147111' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kherabad', label: 'Kherabad', pincode: '147202' },
  { value: 'khiala', label: 'Khiala', pincode: '147206' },
  { value: 'koral', label: 'Koral', pincode: '147205' },
  { value: 'mohali', label: 'Mohali', pincode: '160062' },
  { value: 'patiala', label: 'Patiala', pincode: '147001' },
  { value: 'rajpura', label: 'Rajpura', pincode: '140401' },
  { value: 'sangrur', label: 'Sangrur', pincode: '148001' },
  { value: 'sunam', label: 'Sunam', pincode: '148028' },
  { value: 'tandewal', label: 'Tandewal', pincode: '147301' },
  { value: 'wazirabad', label: 'Wazirabad', pincode: '147201' },
  { value: 'balachaur', label: 'Balachaur', pincode: '144205' },
  { value: 'banur', label: 'Banur', pincode: '140601' },
  { value: 'bhunerheri', label: 'Bhunerheri', pincode: '160055' },
  { value: 'fatehgarh', label: 'Fatehgarh', pincode: '147001' },
  { value: 'kadian', label: 'Kadian', pincode: '144205' },
  { value: 'khamano', label: 'Khamano', pincode: '140119' },
  { value: 'longowal', label: 'Longowal', pincode: '148106' },
  { value: 'malerkotla', label: 'Malerkotla', pincode: '148023' },
  { value: 'nabha', label: 'Nabha', pincode: '147201' },
  { value: 'patran', label: 'Patran', pincode: '147105' },
  { value: 'raikot', label: 'Raikot', pincode: '142035' },
  { value: 'sadda', label: 'Sadda', pincode: '147202' },
  { value: 'shahpur', label: 'Shahpur', pincode: '147202' },
  { value: 'tarn-taran', label: 'Tarn Taran', pincode: '143401' }
  ],
  
  'amloh': [
  { value: 'baran', label: 'Baran', pincode: '147301' },
  { value: 'bassi', label: 'Bassi', pincode: '147301' },
  { value: 'bhikhi', label: 'Bhikhi', pincode: '151504' },
  { value: 'dhaner', label: 'Dhaner', pincode: '147202' },
  { value: 'fattuwal', label: 'Fattuwal', pincode: '147111' },
  { value: 'ghat', label: 'Ghat', pincode: '147202' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kherabad', label: 'Kherabad', pincode: '147202' },
  { value: 'khiala', label: 'Khiala', pincode: '147206' },
  { value: 'koral', label: 'Koral', pincode: '147205' },
  { value: 'longowal', label: 'Longowal', pincode: '148106' },
  { value: 'mohali', label: 'Mohali', pincode: '160062' },
  { value: 'patiala', label: 'Patiala', pincode: '147001' },
  { value: 'raikot', label: 'Raikot', pincode: '142035' },
  { value: 'sangrur', label: 'Sangrur', pincode: '148001' },
  { value: 'sunam', label: 'Sunam', pincode: '148028' },
  { value: 'tandewal', label: 'Tandewal', pincode: '147301' },
  { value: 'wazirabad', label: 'Wazirabad', pincode: '147201' }
  ],
  
  'bassi-pathana': [
  { value: 'bassi', label: 'Bassi', pincode: '147301' },
  { value: 'bhikhi', label: 'Bhikhi', pincode: '151504' },
  { value: 'chandigarh-road', label: 'Chandigarh Road', pincode: '147301' },
  { value: 'dhaner', label: 'Dhaner', pincode: '147202' },
  { value: 'fatehgarh', label: 'Fatehgarh', pincode: '147301' },
  { value: 'ghat', label: 'Ghat', pincode: '147202' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'khiala', label: 'Khiala', pincode: '147206' },
  { value: 'koral', label: 'Koral', pincode: '147205' },
  { value: 'longowal', label: 'Longowal', pincode: '148106' },
  { value: 'mohali', label: 'Mohali', pincode: '160062' },
  { value: 'patiala', label: 'Patiala', pincode: '147001' },
  { value: 'raikot', label: 'Raikot', pincode: '142035' },
  { value: 'sangrur', label: 'Sangrur', pincode: '148001' },
  { value: 'sunam', label: 'Sunam', pincode: '148028' },
  { value: 'tandewal', label: 'Tandewal', pincode: '147301' },
  { value: 'wazirabad', label: 'Wazirabad', pincode: '147201' },
  { value: 'baran', label: 'Baran', pincode: '147301' },
  { value: 'banur', label: 'Banur', pincode: '140601' },
  { value: 'bhunerheri', label: 'Bhunerheri', pincode: '160055' },
  { value: 'dhotian', label: 'Dhotian', pincode: '147202' },
  { value: 'jandali', label: 'Jandali', pincode: '147105' },
  { value: 'khanna', label: 'Khanna', pincode: '141401' },
  { value: 'malerkotla', label: 'Malerkotla', pincode: '148023' },
  { value: 'nabha', label: 'Nabha', pincode: '147201' },
  { value: 'patran', label: 'Patran', pincode: '147105' },
  { value: 'sadda', label: 'Sadda', pincode: '147202' },
  { value: 'shahpur', label: 'Shahpur', pincode: '147202' },
  { value: 'tarn-taran', label: 'Tarn Taran', pincode: '143401' },
  { value: 'zarifabad', label: 'Zarifabad', pincode: '147301' }
  ],
  
  'dinanagar': [
  { value: 'alour', label: 'Alour', pincode: '143531' },
  { value: 'bham', label: 'Bham', pincode: '143502' },
  { value: 'bhogpur', label: 'Bhogpur', pincode: '143533' },
  { value: 'chandpur', label: 'Chandpur', pincode: '143505' },
  { value: 'dinanagar', label: 'Dinanagar', pincode: '143531' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '143511' },
  { value: 'gill', label: 'Gill', pincode: '143503' },
  { value: 'gursehri', label: 'Gursehri', pincode: '143523' },
  { value: 'kadian', label: 'Kadian', pincode: '143514' },
  { value: 'kotli', label: 'Kotli', pincode: '143522' },
  { value: 'lahrian', label: 'Lahrian', pincode: '143503' },
  { value: 'malakpur', label: 'Malakpur', pincode: '143504' },
  { value: 'malkwal', label: 'Malkwal', pincode: '143523' },
  { value: 'patiala', label: 'Patiala', pincode: '147001' },
  { value: 'rahon', label: 'Rahon', pincode: '143109' },
  { value: 'rahon-kalan', label: 'Rahon Kalan', pincode: '143109' },
  { value: 'sahiwal', label: 'Sahiwal', pincode: '143503' },
  { value: 'tapa', label: 'Tapa', pincode: '143533' },
  { value: 'wazirabad', label: 'Wazirabad', pincode: '143502' },
  { value: 'padhiana', label: 'Padhiana', pincode: '143507' },
  { value: 'sahibzada-ajit-singh', label: 'Sahibzada Ajit Singh', pincode: '143514' },
  { value: 'sarai', label: 'Sarai', pincode: '143532' },
  { value: 'tirath', label: 'Tirath', pincode: '143510' },
  { value: 'zailpur', label: 'Zailpur', pincode: '143520' }
  ],
  
  'fatehgarh-churian': [
  { value: 'barwal', label: 'Barwal', pincode: '143510' },
  { value: 'bhogpur', label: 'Bhogpur', pincode: '143509' },
  { value: 'chandpur', label: 'Chandpur', pincode: '143505' },
  { value: 'fatehgarh-churian', label: 'Fatehgarh Churian', pincode: '143515' },
  { value: 'gudduwala', label: 'Gudduwala', pincode: '143517' },
  { value: 'jhander', label: 'Jhander', pincode: '143510' },
  { value: 'kadian', label: 'Kadian', pincode: '143514' },
  { value: 'kotli', label: 'Kotli', pincode: '143522' },
  { value: 'lahrian', label: 'Lahrian', pincode: '143503' },
  { value: 'malakpur', label: 'Malakpur', pincode: '143504' },
  { value: 'malkwal', label: 'Malkwal', pincode: '143523' },
  { value: 'patiala', label: 'Patiala', pincode: '147001' },
  { value: 'rahon', label: 'Rahon', pincode: '143109' },
  { value: 'rahon-kalan', label: 'Rahon Kalan', pincode: '143109' },
  { value: 'sahiwal', label: 'Sahiwal', pincode: '143503' },
  { value: 'shergarh', label: 'Shergarh', pincode: '143519' },
  { value: 'wazirabad', label: 'Wazirabad', pincode: '143502' },
  { value: 'malewal', label: 'Malewal', pincode: '143515' },
  { value: 'baba-bakala', label: 'Baba Bakala', pincode: '143516' },
  { value: 'bhola', label: 'Bhola', pincode: '143520' },
  { value: 'dakha', label: 'Dakha', pincode: '143518' },
  { value: 'ghumman', label: 'Ghumman', pincode: '143509' },
  { value: 'marauli', label: 'Marauli', pincode: '143521' }
  ],
  
  'gidderbaha': [
  { value: 'abad-pur', label: 'Abad Pur', pincode: '152101' },
  { value: 'aguwal', label: 'Aguwal', pincode: '152106' },
  { value: 'bahram', label: 'Bahram', pincode: '152104' },
  { value: 'bhai-rup', label: 'Bhai Rup', pincode: '152105' },
  { value: 'chand-pur', label: 'Chand Pur', pincode: '152103' },
  { value: 'dilawarpur', label: 'Dilawarpur', pincode: '152107' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '152108' },
  { value: 'gidderbaha', label: 'Gidderbaha', pincode: '152101' },
  { value: 'hamidpur', label: 'Hamidpur', pincode: '152105' },
  { value: 'harike', label: 'Harike', pincode: '152108' },
  { value: 'jamsher', label: 'Jamsher', pincode: '152104' },
  { value: 'kahanwal', label: 'Kahanwal', pincode: '152102' },
  { value: 'kaluwal', label: 'Kaluwal', pincode: '152105' },
  { value: 'madhopur', label: 'Madhopur', pincode: '152109' },
  { value: 'mukandpur', label: 'Mukandpur', pincode: '152106' },
  { value: 'pind-sultanpur', label: 'Pind Sultanpur', pincode: '152108' },
  { value: 'sahnewal', label: 'Sahnewal', pincode: '152107' },
  { value: 'sultanpur', label: 'Sultanpur', pincode: '152108' },
  { value: 'tappa', label: 'Tappa', pincode: '152103' },
  { value: 'walipur', label: 'Walipur', pincode: '152109' },
  { value: 'wazirabad', label: 'Wazirabad', pincode: '152110' }
  ],
  
  'jaito': [
  { value: 'baba-bakala', label: 'Baba Bakala', pincode: '151204' },
  { value: 'bhikhari', label: 'Bhikhari', pincode: '151207' },
  { value: 'dhanupura', label: 'Dhanupura', pincode: '151213' },
  { value: 'jaito', label: 'Jaito', pincode: '151202' },
  { value: 'kharak', label: 'Kharak', pincode: '151205' },
  { value: 'kotli', label: 'Kotli', pincode: '151210' },
  { value: 'mahonpur', label: 'Mahonpur', pincode: '151206' },
  { value: 'raipura', label: 'Raipura', pincode: '151203' },
  { value: 'sahnewal', label: 'Sahnewal', pincode: '151209' },
  { value: 'tanda', label: 'Tanda', pincode: '151208' },
  { value: 'wandri', label: 'Wandri', pincode: '151211' },
  { value: 'alisar', label: 'Alisar', pincode: '151212' },
  { value: 'chandpur', label: 'Chandpur', pincode: '151214' },
  { value: 'chheharta', label: 'Chheharta', pincode: '151215' },
  { value: 'garhshankar', label: 'Garhshankar', pincode: '151216' },
  { value: 'rai-bhago', label: 'Rai Bhago', pincode: '151217' },
  { value: 'tapa', label: 'Tapa', pincode: '151218' }
  ],
  
  'kasur': [
  { value: 'allahabad', label: 'Allahabad', pincode: '393001' },
  { value: 'ballah', label: 'Ballah', pincode: '393030' },
  { value: 'basra', label: 'Basra', pincode: '393032' },
  { value: 'chandpura', label: 'Chandpura', pincode: '393010' },
  { value: 'chawinda', label: 'Chawinda', pincode: '393029' },
  { value: 'fatehgarh', label: 'Fatehgarh', pincode: '393028' },
  { value: 'jalandhar', label: 'Jalandhar', pincode: '393021' },
  { value: 'kasur', label: 'Kasur', pincode: '393050' },
  { value: 'khokhar', label: 'Khokhar', pincode: '393031' },
  { value: 'kotri', label: 'Kotri', pincode: '393020' },
  { value: 'mughalpura', label: 'Mughalpura', pincode: '393040' },
  { value: 'nawanpind', label: 'Nawanpind', pincode: '393025' },
  { value: 'shahdara', label: 'Shahdara', pincode: '393060' },
  { value: 'tariqabad', label: 'Tariqabad', pincode: '393015' },
  { value: 'wala', label: 'Wala', pincode: '393016' },
  { value: 'wazirabad', label: 'Wazirabad', pincode: '393022' },
  { value: 'zanad', label: 'Zanad', pincode: '393027' }
  ],
  
  'kharar': [
  { value: 'bassi', label: 'Bassi', pincode: '140301' },
  { value: 'bhago-majra', label: 'Bhago Majra', pincode: '140301' },
  { value: 'chhat', label: 'Chhat', pincode: '140304' },
  { value: 'fatehgarh-sahib', label: 'Fatehgarh Sahib', pincode: '140406' },
  { value: 'kharar', label: 'Kharar', pincode: '140301' },
  { value: 'kurali', label: 'Kurali', pincode: '140103' },
  { value: 'mohali', label: 'Mohali', pincode: '160062' },
  { value: 'raipur-kalan', label: 'Raipur Kalan', pincode: '140306' },
  { value: 'saharanpur', label: 'Saharanpur', pincode: '140306' },
  { value: 'swaran-enclave', label: 'Swarn Enclave', pincode: '140301' },
  { value: 'vill-bunga', label: 'Vill Bunga', pincode: '140306' },
  { value: 'vill-panjab', label: 'Vill Punjab', pincode: '140301' },
  { value: 'vill-thatti', label: 'Vill Thatti', pincode: '140302' },
  { value: 'zirakpur', label: 'Zirakpur', pincode: '140603' },
  { value: 'zira', label: 'Zira', pincode: '140302' },
  { value: 'balongi', label: 'Balongi', pincode: '160018' },
  { value: 'dharampur', label: 'Dharampur', pincode: '140306' },
  { value: 'mandigobindgarh', label: 'Mandi Gobindgarh', pincode: '147301' },
  { value: 'nagar', label: 'Nagar', pincode: '140301' }
  ],
  
  'kot-kapura': [
  { value: 'bhora', label: 'Bhora', pincode: '151204' },
  { value: 'chhajli', label: 'Chhajli', pincode: '151203' },
  { value: 'dhamalwala', label: 'Dhamalwala', pincode: '151213' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '151214' },
  { value: 'kot-kapura', label: 'Kot Kapura', pincode: '151204' },
  { value: 'lohianwala', label: 'Lohianwala', pincode: '151205' },
  { value: 'madhopur', label: 'Madhopur', pincode: '151207' },
  { value: 'manoj', label: 'Manoj', pincode: '151208' },
  { value: 'raja-wala', label: 'Raja Wala', pincode: '151209' },
  { value: 'sultanpur', label: 'Sultanpur', pincode: '151210' },
  { value: 'tappa', label: 'Tappa', pincode: '151211' },
  { value: 'zafarabad', label: 'Zafarabad', pincode: '151212' },
  { value: 'kamla', label: 'Kamla', pincode: '151206' },
  { value: 'balwara', label: 'Balwara', pincode: '151215' },
  { value: 'ajitwal', label: 'Ajitwal', pincode: '151216' },
  { value: 'manbari', label: 'Manbari', pincode: '151217' }
  ],
  
  'maler-kotla': [
  { value: 'chhajli', label: 'Chhajli', pincode: '148023' },
  { value: 'fatehgarh', label: 'Fatehgarh', pincode: '148022' },
  { value: 'khanpur', label: 'Khanpur', pincode: '148024' },
  { value: 'malerkotla', label: 'Malerkotla', pincode: '148023' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '148026' },
  { value: 'moti-bagh', label: 'Moti Bagh', pincode: '148027' },
  { value: 'raipur', label: 'Raipur', pincode: '148020' },
  { value: 'sangwal', label: 'Sangwal', pincode: '148028' },
  { value: 'tapa', label: 'Tapa', pincode: '148029' },
  { value: 'village-sarai', label: 'Village Sarai', pincode: '148025' },
  { value: 'agarh', label: 'Agarh', pincode: '148032' },
  { value: 'badshahpur', label: 'Badshahpur', pincode: '148030' },
  { value: 'chand-khera', label: 'Chand Khera', pincode: '148021' },
  { value: 'hariana', label: 'Hariana', pincode: '148031' },
  { value: 'kadian', label: 'Kadian', pincode: '148033' },
  { value: 'mandi', label: 'Mandi', pincode: '148034' },
  { value: 'ranjit-pur', label: 'Ranjit Pur', pincode: '148035' }
  ],
  
  'malout': [
  { value: 'bhai-ke', label: 'Bhai Ke', pincode: '152107' },
  { value: 'chand-pur', label: 'Chand Pur', pincode: '152108' },
  { value: 'fatehgarh', label: 'Fatehgarh', pincode: '152110' },
  { value: 'ghilowal', label: 'Ghilowal', pincode: '152102' },
  { value: 'janjgir', label: 'Janjgir', pincode: '152113' },
  { value: 'kalanwali', label: 'Kalanwali', pincode: '152112' },
  { value: 'malout', label: 'Malout', pincode: '152107' },
  { value: 'mandi', label: 'Mandi', pincode: '152101' },
  { value: 'manjranwali', label: 'Manjranwali', pincode: '152114' },
  { value: 'ranian', label: 'Ranian', pincode: '152104' },
  { value: 'sadhuwali', label: 'Sadhuwali', pincode: '152109' },
  { value: 'saiwala', label: 'Saiwala', pincode: '152105' },
  { value: 'sant-nagar', label: 'Sant Nagar', pincode: '152115' },
  { value: 'village-kotli', label: 'Village Kotli', pincode: '152106' },
  { value: 'village-ratan', label: 'Village Ratan', pincode: '152116' }
  ],
  
  'mandi-gobindgarh': [
  { value: 'akali-basti', label: 'Akali Basti', pincode: '147301' },
  { value: 'bhangu-kalan', label: 'Bhangu Kalan', pincode: '147302' },
  { value: 'chalwandi', label: 'Chalwandi', pincode: '147301' },
  { value: 'gillpura', label: 'Gillpura', pincode: '147305' },
  { value: 'goindwal', label: 'Goindwal', pincode: '147303' },
  { value: 'gurdaspur', label: 'Gurdaspur', pincode: '147306' },
  { value: 'jalalabad', label: 'Jalalabad', pincode: '147308' },
  { value: 'khanpur', label: 'Khanpur', pincode: '147315' },
  { value: 'mandi-gobindgarh', label: 'Mandi Gobindgarh', pincode: '147301' },
  { value: 'naraingarh', label: 'Naraingarh', pincode: '147310' },
  { value: 'raipur', label: 'Raipur', pincode: '147312' },
  { value: 'sarai-mesh', label: 'Sarai Mesh', pincode: '147307' },
  { value: 'suthra', label: 'Suthra', pincode: '147309' },
  { value: 'wazir-pur', label: 'Wazir Pur', pincode: '147311' },
  { value: 'kotli-barewala', label: 'Kotli Barewala', pincode: '147314' },
  { value: 'sahibpur', label: 'Sahibpur', pincode: '147313' }
  ],
  
  'muktsar': [
  { value: 'bhaini', label: 'Bhaini', pincode: '152026' },
  { value: 'dharmkot', label: 'Dharmkot', pincode: '152027' },
  { value: 'fattuwal', label: 'Fattuwal', pincode: '152020' },
  { value: 'gallan', label: 'Gallan', pincode: '152024' },
  { value: 'makhdum', label: 'Makhdum', pincode: '152021' },
  { value: 'muktsar', label: 'Muktsar', pincode: '152026' },
  { value: 'patti', label: 'Patti', pincode: '152029' },
  { value: 'rajanwali', label: 'Rajanwali', pincode: '152023' },
  { value: 'sankhera', label: 'Sankhera', pincode: '152025' },
  { value: 'sodhian', label: 'Sodhian', pincode: '152028' },
  { value: 'bhagi-wala', label: 'Bhagi Wala', pincode: '152030' },
  { value: 'bajakhana', label: 'Bajakhana', pincode: '152022' },
  { value: 'gheora', label: 'Gheora', pincode: '152031' },
  { value: 'jodha-wala', label: 'Jodha Wala', pincode: '152032' },
  { value: 'tappa-khurian', label: 'Tappa Khurian', pincode: '152033' },
  { value: 'santpura', label: 'Santpura', pincode: '152034' }
  ],
  
  'nangal': [
  { value: 'babu-pur', label: 'Babu Pur', pincode: '144205' },
  { value: 'dhamo', label: 'Dhamo', pincode: '144204' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '144206' },
  { value: 'gagret', label: 'Gagret', pincode: '144209' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '144207' },
  { value: 'mandi', label: 'Mandi', pincode: '144210' },
  { value: 'nangal', label: 'Nangal', pincode: '144205' },
  { value: 'nangal-dam', label: 'Nangal Dam', pincode: '144205' },
  { value: 'raipur', label: 'Raipur', pincode: '144208' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '144210' },
  { value: 'singhpur', label: 'Singhpur', pincode: '144203' },
  { value: 'suraj-pur', label: 'Suraj Pur', pincode: '144207' },
  { value: 'tapa', label: 'Tapa', pincode: '144202' },
  { value: 'village-kotla', label: 'Village Kotla', pincode: '144211' },
  { value: 'kuchman', label: 'Kuchman', pincode: '144212' }
  ],
  
  'nayagaon': [
  { value: 'bahadurpur', label: 'Bahadurpur', pincode: '140125' },
  { value: 'dhanas', label: 'Dhanas', pincode: '140124' },
  { value: 'khuda-alisher', label: 'Khuda Alisher', pincode: '140104' },
  { value: 'khuda-lubana', label: 'Khuda Lubana', pincode: '140108' },
  { value: 'manimajra', label: 'Manimajra', pincode: '140103' },
  { value: 'nayagaon', label: 'Nayagaon', pincode: '140125' },
  { value: 'railway-road', label: 'Railway Road', pincode: '140106' },
  { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '140110' },
  { value: 'village-nayagaon', label: 'Village Nayagaon', pincode: '140125' },
  { value: 'balongi', label: 'Balongi', pincode: '140114' },
  { value: 'banur', label: 'Banur', pincode: '140506' },
  { value: 'chandigarh-road', label: 'Chandigarh Road', pincode: '140103' },
  { value: 'dappar', label: 'Dappar', pincode: '140506' },
  { value: 'majri', label: 'Majri', pincode: '140110' },
  { value: 'mirzapur', label: 'Mirzapur', pincode: '140112' }
  ],
  
  'nawanshahr': [
  { value: 'bhogpur', label: 'Bhogpur', pincode: '144205' },
  { value: 'chaheru', label: 'Chaheru', pincode: '144206' },
  { value: 'darbara', label: 'Darbara', pincode: '144222' },
  { value: 'garshankar', label: 'Garshankar', pincode: '144205' },
  { value: 'jandiala', label: 'Jandiala', pincode: '144221' },
  { value: 'kala-amb', label: 'Kala Amb', pincode: '144223' },
  { value: 'mashwi', label: 'Mashwi', pincode: '144225' },
  { value: 'nawanshahr', label: 'Nawanshahr', pincode: '144514' },
  { value: 'raipur', label: 'Raipur', pincode: '144225' },
  { value: 'sainwala', label: 'Sainwala', pincode: '144226' },
  { value: 'sujanpur', label: 'Sujanpur', pincode: '144224' },
  { value: 'village-panje', label: 'Village Panje', pincode: '144223' },
  { value: 'baddowal', label: 'Baddowal', pincode: '144213' },
  { value: 'chandpur', label: 'Chandpur', pincode: '144218' },
  { value: 'dherian', label: 'Dherian', pincode: '144227' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '144210' },
  { value: 'kotli', label: 'Kotli', pincode: '144212' },
  { value: 'mugla', label: 'Mugla', pincode: '144215' },
  { value: 'rajasian', label: 'Rajasian', pincode: '144216' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '144219' },
  { value: 'sangha', label: 'Sangha', pincode: '144220' }
  ],
  
  'patti': [
  { value: 'baba-bhude', label: 'Baba Bhude', pincode: '143416' },
  { value: 'bihar-pur', label: 'Bihar Pur', pincode: '143405' },
  { value: 'chuk-mor', label: 'Chuk Mor', pincode: '143416' },
  { value: 'dulla-bhatti', label: 'Dulla Bhatti', pincode: '143412' },
  { value: 'gudiyal', label: 'Gudiyal', pincode: '143413' },
  { value: 'gurh', label: 'Gurh', pincode: '143414' },
  { value: 'jandiala', label: 'Jandiala', pincode: '143405' },
  { value: 'kalanwali', label: 'Kalanwali', pincode: '143421' },
  { value: 'manjitpura', label: 'Manjitpura', pincode: '143420' },
  { value: 'patiala-bazaar', label: 'Patiala Bazaar', pincode: '143409' },
  { value: 'patti', label: 'Patti', pincode: '143416' },
  { value: 'ram-daspur', label: 'Ram Daspur', pincode: '143410' },
  { value: 'sainwala', label: 'Sainwala', pincode: '143420' },
  { value: 'tiba', label: 'Tiba', pincode: '143409' },
  { value: 'village-mangat', label: 'Village Mangat', pincode: '143406' },
  { value: 'village-patti', label: 'Village Patti', pincode: '143422' },
  { value: 'wala', label: 'Wala', pincode: '143411' }
  ],
  
  'phagwara': [
  { value: 'alawalpur', label: 'Alawalpur', pincode: '144205' },
  { value: 'baddowal', label: 'Baddowal', pincode: '144205' },
  { value: 'chandpur', label: 'Chandpur', pincode: '144203' },
  { value: 'dhotian', label: 'Dhotian', pincode: '144208' },
  { value: 'fatehpur', label: 'Fatehpur', pincode: '144201' },
  { value: 'jammu-wali', label: 'Jammu Wali', pincode: '144210' },
  { value: 'khokhar', label: 'Khokhar', pincode: '144206' },
  { value: 'phagwara', label: 'Phagwara', pincode: '144401' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '144201' },
  { value: 'rangran', label: 'Rangran', pincode: '144205' },
  { value: 'sainwala', label: 'Sainwala', pincode: '144204' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '144208' },
  { value: 'village-bhagwanpur', label: 'Village Bhagwanpur', pincode: '144205' },
  { value: 'village-dhama', label: 'Village Dhama', pincode: '144207' },
  { value: 'village-rangran', label: 'Village Rangran', pincode: '144205' },
  { value: 'waryam-pur', label: 'Waryam Pur', pincode: '144209' }
  ],
  
  'sansarpur': [
  { value: 'bara-pur', label: 'Bara Pur', pincode: '144205' },
  { value: 'chhoti-sansarpur', label: 'Chhoti Sansarpur', pincode: '144206' },
  { value: 'garh-shahpur', label: 'Garh Shahpur', pincode: '144210' },
  { value: 'ghar-kalan', label: 'Ghar Kalan', pincode: '144208' },
  { value: 'jattan-wali', label: 'Jattan Wali', pincode: '144207' },
  { value: 'mandi-sansarpur', label: 'Mandi Sansarpur', pincode: '144207' },
  { value: 'nanakpur', label: 'Nanakpur', pincode: '144210' },
  { value: 'patel-ki-dharti', label: 'Patel Ki Dharti', pincode: '144211' },
  { value: 'sansarpur', label: 'Sansarpur', pincode: '144205' },
  { value: 'sawaria', label: 'Sawaria', pincode: '144206' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '144209' },
  { value: 'village-babarpur', label: 'Village Babarpur', pincode: '144207' },
  { value: 'village-sansarpur', label: 'Village Sansarpur', pincode: '144205' },
  { value: 'village-kalsian', label: 'Village Kalsian', pincode: '144208' },
  { value: 'wadhpur', label: 'Wadhpur', pincode: '144205' }
  ],
  
  'shahkot': [
  { value: 'bassi-pur', label: 'Bassi Pur', pincode: '144205' },
  { value: 'chak-pattan', label: 'Chak Pattan', pincode: '144203' },
  { value: 'jattal', label: 'Jattal', pincode: '144210' },
  { value: 'mahon-pur', label: 'Mahoon Pur', pincode: '144206' },
  { value: 'miani', label: 'Miani', pincode: '144213' },
  { value: 'naru-pur', label: 'Naru Pur', pincode: '144212' },
  { value: 'pakhoke', label: 'Pakhoke', pincode: '144201' },
  { value: 'pattian', label: 'Pattian', pincode: '144207' },
  { value: 'shahkot', label: 'Shahkot', pincode: '144205' },
  { value: 'village-bathwala', label: 'Village Bathwala', pincode: '144206' },
  { value: 'village-chheharta', label: 'Village Chheharta', pincode: '144209' },
  { value: 'village-kalri', label: 'Village Kalri', pincode: '144211' },
  { value: 'village-narowal', label: 'Village Narowal', pincode: '144208' },
  { value: 'bahramwala', label: 'Bahramwala', pincode: '144214' },
  { value: 'khajura', label: 'Khajura', pincode: '144215' },
  { value: 'ropar', label: 'Ropar', pincode: '144216' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '144205' },
  { value: 'village-ghatt', label: 'Village Ghatt', pincode: '144217' }
  ],
  
  'sri-muktsar-sahib': [
  { value: 'bhattiwala', label: 'Bhattiwala', pincode: '152026' },
  { value: 'bidhwan', label: 'Bidhwan', pincode: '152025' },
  { value: 'darbara', label: 'Darbara', pincode: '152019' },
  { value: 'dhanewala', label: 'Dhanewala', pincode: '152023' },
  { value: 'gurusar-sadhan', label: 'Gurusar Sadhan', pincode: '152025' },
  { value: 'jagdevkhera', label: 'Jagdevkhera', pincode: '152022' },
  { value: 'kachiwala', label: 'Kachiwala', pincode: '152018' },
  { value: 'kallanwali', label: 'Kallanwali', pincode: '152027' },
  { value: 'muktsar', label: 'Muktsar', pincode: '152026' },
  { value: 'rai-sarai', label: 'Rai Sarai', pincode: '152026' },
  { value: 'rajewal', label: 'Rajewal', pincode: '152025' },
  { value: 'sadiq', label: 'Sadiq', pincode: '152024' },
  { value: 'sri-muktsar-sahib', label: 'Sri Muktsar Sahib', pincode: '152026' },
  { value: 'village-bhaniwala', label: 'Village Bhaniwala', pincode: '152029' },
  { value: 'village-muktsar', label: 'Village Muktsar', pincode: '152026' },
  { value: 'village-nawanpind', label: 'Village Nawanpind', pincode: '152022' },
  { value: 'village-punnu', label: 'Village Punnu', pincode: '152028' },
  { value: 'wadhpur', label: 'Wadhpur', pincode: '152021' }
  ],
  
  'sujanpur': [
  { value: 'bhatti', label: 'Bhatti', pincode: '144205' },
  { value: 'chakriwala', label: 'Chakriwala', pincode: '144211' },
  { value: 'gill-pur', label: 'Gill Pur', pincode: '144220' },
  { value: 'gharachon', label: 'Gharachon', pincode: '144215' },
  { value: 'jandiala', label: 'Jandiala', pincode: '144204' },
  { value: 'kalsian', label: 'Kalsian', pincode: '144212' },
  { value: 'mullanpur', label: 'Mullanpur', pincode: '144223' },
  { value: 'sujanpur', label: 'Sujanpur', pincode: '144206' },
  { value: 'village-hariyana', label: 'Village Hariyana', pincode: '144219' },
  { value: 'village-shahpur', label: 'Village Shahpur', pincode: '144217' },
  { value: 'village-chandpur', label: 'Village Chandpur', pincode: '144218' },
  { value: 'village-pindi', label: 'Village Pindi', pincode: '144209' },
  { value: 'wadhpur', label: 'Wadhpur', pincode: '144218' }
  ],
  
  'sunam-udham-singh-wala': [
  { value: 'bandi', label: 'Bandi', pincode: '148028' },
  { value: 'chak-mehma', label: 'Chak Mehma', pincode: '148029' },
  { value: 'chak-purana', label: 'Chak Purana', pincode: '148029' },
  { value: 'chhajpur', label: 'Chhajpur', pincode: '148029' },
  { value: 'chhoti-mirzapur', label: 'Chhoti Mirzapur', pincode: '148028' },
  { value: 'dhindsa', label: 'Dhindsa', pincode: '148029' },
  { value: 'khudi', label: 'Khudi', pincode: '148027' },
  { value: 'malkewal', label: 'Malkewal', pincode: '148029' },
  { value: 'saddiwal', label: 'Saddiwal', pincode: '148029' },
  { value: 'sunam', label: 'Sunam', pincode: '148028' },
  { value: 'udham-singh-wala', label: 'Udham Singh Wala', pincode: '148028' },
  { value: 'village-bhagwanpura', label: 'Village Bhagwanpura', pincode: '148027' },
  { value: 'village-jhaggar', label: 'Village Jhaggar', pincode: '148027' },
  { value: 'village-puni', label: 'Village Puni', pincode: '148027' },
  { value: 'village-segri', label: 'Village Segri', pincode: '148029' },
  { value: 'village-patran', label: 'Village Patran', pincode: '148030' },
  { value: 'village-ratanpur', label: 'Village Ratanpur', pincode: '148027' }
  ],
  
  'talwandi-sabo': [
  { value: 'abad-pura', label: 'Abad Pura', pincode: '151302' },
  { value: 'bharwan', label: 'Bharwan', pincode: '151302' },
  { value: 'chak-khurd', label: 'Chak Khurd', pincode: '151302' },
  { value: 'dhanwan', label: 'Dhanwan', pincode: '151302' },
  { value: 'gurdwara', label: 'Gurdwara', pincode: '151302' },
  { value: 'khai-pur', label: 'Khai Pur', pincode: '151302' },
  { value: 'mehmuwal', label: 'Mehmuwal', pincode: '151302' },
  { value: 'nawanshahr', label: 'Nawanshahr', pincode: '151302' },
  { value: 'talwandi', label: 'Talwandi', pincode: '151302' },
  { value: 'udhi-pur', label: 'Udhi Pur', pincode: '151302' },
  { value: 'village-bhakna', label: 'Village Bhakna', pincode: '151302' },
  { value: 'village-dalel-wala', label: 'Village Dalel Wala', pincode: '151302' },
  { value: 'village-bilga', label: 'Village Bilga', pincode: '151302' },
  { value: 'village-ladian', label: 'Village Ladian', pincode: '151303' },
  { value: 'village-raman', label: 'Village Raman', pincode: '151303' },
  { value: 'village-kheri', label: 'Village Kheri', pincode: '151303' },
  { value: 'village-bari', label: 'Village Bari', pincode: '151303' },
  { value: 'village-chuhar', label: 'Village Chuhar', pincode: '151302' }
  ],
  
  'tapa': [
  { value: 'alipur', label: 'Alipur', pincode: '142055' },
  { value: 'badshahpur', label: 'Badshahpur', pincode: '142055' },
  { value: 'bajakhana', label: 'Bajakhana', pincode: '142055' },
  { value: 'chak-danewala', label: 'Chak Danewala', pincode: '142055' },
  { value: 'chak-mohammadpur', label: 'Chak Mohammadpur', pincode: '142055' },
  { value: 'dhindsa', label: 'Dhindsa', pincode: '142055' },
  { value: 'manjh', label: 'Manjh', pincode: '142055' },
  { value: 'moranwali', label: 'Moranwali', pincode: '142055' },
  { value: 'tapa', label: 'Tapa', pincode: '142055' },
  { value: 'village-bilga', label: 'Village Bilga', pincode: '142055' },
  { value: 'village-sunam', label: 'Village Sunam', pincode: '142058' },
  { value: 'village-rangpur', label: 'Village Rangpur', pincode: '142055' },
  { value: 'village-khurshid-wala', label: 'Village Khurshid Wala', pincode: '142055' },
  { value: 'village-dalewala', label: 'Village Dalewala', pincode: '142055' },
  { value: 'village-purewala', label: 'Village Purewala', pincode: '142055' },
  { value: 'village-sunari', label: 'Village Sunari', pincode: '142055' },
  { value: 'village-malian', label: 'Village Malian', pincode: '142055' },
  { value: 'village-mohinder', label: 'Village Mohinder', pincode: '142055' }
  ],
  
  'zira': [
  { value: 'akhbarpur', label: 'Akhbarpur', pincode: '142039' },
  { value: 'alampur', label: 'Alampur', pincode: '142039' },
  { value: 'baba-nanak', label: 'Baba Nanak', pincode: '142039' },
  { value: 'balachaur', label: 'Balachaur', pincode: '142039' },
  { value: 'chak-bhuje', label: 'Chak Bhuje', pincode: '142039' },
  { value: 'chak-raman', label: 'Chak Raman', pincode: '142039' },
  { value: 'gill-bari', label: 'Gill Bari', pincode: '142039' },
  { value: 'gondwal', label: 'Gondwal', pincode: '142039' },
  { value: 'kangan', label: 'Kangan', pincode: '142039' },
  { value: 'manak', label: 'Manak', pincode: '142039' },
  { value: 'mitha-sadha', label: 'Mitha Sadha', pincode: '142039' },
  { value: 'nawanshahr', label: 'Nawanshahr', pincode: '142039' },
  { value: 'naran', label: 'Naran', pincode: '142039' },
  { value: 'sahibwala', label: 'Sahibwala', pincode: '142039' },
  { value: 'talwandi', label: 'Talwandi', pincode: '142039' },
  { value: 'zira', label: 'Zira', pincode: '142039' },
  { value: 'village-danewala', label: 'Village Danewala', pincode: '142039' },
  { value: 'village-sadhan', label: 'Village Sadhan', pincode: '142039' },
  { value: 'village-sunam', label: 'Village Sunam', pincode: '142039' }
  ],

  'amritsar': [
    { value: 'accopal', label: 'Accopal', pincode: '143001' },
    { value: 'adampur', label: 'Adampur', pincode: '143104' },
    { value: 'akhbarwala', label: 'Akhbarwala', pincode: '143105' },
    { value: 'alipur', label: 'Alipur', pincode: '143001' },
    { value: 'attari', label: 'Attari', pincode: '143202' },
    { value: 'bapuwal', label: 'Bapuwal', pincode: '143103' },
    { value: 'bawa-puran', label: 'Bawa Puran', pincode: '143204' },
    { value: 'bhandari', label: 'Bhandari', pincode: '143105' },
    { value: 'chatiwind', label: 'Chatiwind', pincode: '143104' },
    { value: 'chheharta', label: 'Chheharta', pincode: '143105' },
    { value: 'dehwan', label: 'Dehwan', pincode: '143113' },
    { value: 'fatehgarh', label: 'Fatehgarh', pincode: '143506' },
    { value: 'fattuwal', label: 'Fattuwal', pincode: '143201' },
    { value: 'gill', label: 'Gill', pincode: '143106' },
    { value: 'gopipur', label: 'Gopipur', pincode: '143113' },
    { value: 'jalluwal', label: 'Jalluwal', pincode: '143201' },
    { value: 'kandola', label: 'Kandola', pincode: '143206' },
    { value: 'khalsa', label: 'Khalsa', pincode: '143206' },
    { value: 'khanna', label: 'Khanna', pincode: '143001' },
    { value: 'kharal', label: 'Kharal', pincode: '143113' },
    { value: 'khemkaran', label: 'Khemkaran', pincode: '143205' },
    { value: 'kucha-mithu', label: 'Kucha Mithu', pincode: '143001' },
    { value: 'lalyani', label: 'Lalyani', pincode: '143204' },
    { value: 'maholi', label: 'Maholi', pincode: '143107' },
    { value: 'majbata', label: 'Majbata', pincode: '143204' },
    { value: 'maur', label: 'Maur', pincode: '143204' },
    { value: 'mohindra', label: 'Mohindra', pincode: '143209' },
    { value: 'nawanpind', label: 'Nawanpind', pincode: '143102' },
    { value: 'nishatpura', label: 'Nishatpura', pincode: '143115' },
    { value: 'pajjian', label: 'Pajjian', pincode: '143105' },
    { value: 'panjokhara', label: 'Panjokhara', pincode: '143105' },
    { value: 'rajpura', label: 'Rajpura', pincode: '143108' },
    { value: 'ramdas', label: 'Ramdas', pincode: '143206' },
    { value: 'ramgarh', label: 'Ramgarh', pincode: '143113' },
    { value: 'rural-pind', label: 'Rural Pind', pincode: '143003' },
    { value: 'sabzwal', label: 'Sabzwal', pincode: '143103' },
    { value: 'sultanwind', label: 'Sultanwind', pincode: '143002' },
    { value: 'tarn-taran', label: 'Tarn Taran', pincode: '143401' },
    { value: 'village-bad', label: 'Village Bad', pincode: '143105' },
    { value: 'village-dina', label: 'Village Dina', pincode: '143107' },
    { value: 'village-mall', label: 'Village Mall', pincode: '143001' },
    { value: 'village-pakka', label: 'Village Pakka', pincode: '143003' },
    { value: 'vishnu', label: 'Vishnu', pincode: '143115' },
    { value: 'walhuwal', label: 'Walhuwal', pincode: '143001' }
  ],

  'abohar': [
    { value: 'abohar-nagar', label: 'Abohar Nagar', pincode: '152116' },
    { value: 'adampur', label: 'Adampur', pincode: '152116' },
    { value: 'bhidowal', label: 'Bhidowal', pincode: '152116' },
    { value: 'bhikhiwind', label: 'Bhikhiwind', pincode: '152116' },
    { value: 'bhuttiwala', label: 'Bhuttiwala', pincode: '152116' },
    { value: 'chugha', label: 'Chugha', pincode: '152116' },
    { value: 'dalla', label: 'Dalla', pincode: '152116' },
    { value: 'darbara', label: 'Darbara', pincode: '152116' },
    { value: 'devpura', label: 'Devpura', pincode: '152116' },
    { value: 'gadhwala', label: 'Gadhwala', pincode: '152116' },
    { value: 'gali-shahzada', label: 'Gali Shahzada', pincode: '152116' },
    { value: 'gharachon', label: 'Gharachon', pincode: '152116' },
    { value: 'ghirath', label: 'Ghirath', pincode: '152116' },
    { value: 'kandian', label: 'Kandian', pincode: '152116' },
    { value: 'kanwarnagar', label: 'Kanwarnagar', pincode: '152116' },
    { value: 'kissanpura', label: 'Kissanpura', pincode: '152116' },
    { value: 'mohammadpura', label: 'Mohammadpura', pincode: '152116' },
    { value: 'palewala', label: 'Palewala', pincode: '152116' },
    { value: 'pannaher', label: 'Pannaher', pincode: '152116' },
    { value: 'ramjotpura', label: 'Ramjotpura', pincode: '152116' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '152116' },
    { value: 'satnampura', label: 'Satnampura', pincode: '152116' },
    { value: 'shergarh', label: 'Shergarh', pincode: '152116' },
    { value: 'sita', label: 'Sita', pincode: '152116' },
    { value: 'tavipura', label: 'Tavipura', pincode: '152116' },
    { value: 'turiwala', label: 'Turiwala', pincode: '152116' },
    { value: 'village-nainwala', label: 'Village Nainwala', pincode: '152116' }
  ],
  //Jammu and Kashmir

  'pattan': [
    { value: 'amberpet', label: 'Amberpet', pincode: '500013' },
    { value: 'attapur', label: 'Attapur', pincode: '500048' },
    { value: 'baghlingampally', label: 'Bagh Lingampally', pincode: '500044' },
    { value: 'barkatpura', label: 'Barkatpura', pincode: '500027' },
    { value: 'chandrayangutta', label: 'Chandrayangutta', pincode: '500005' },
    { value: 'charminar', label: 'Charminar', pincode: '500002' },
    { value: 'dilsukhnagar', label: 'Dilsukhnagar', pincode: '500060' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'habsiguda', label: 'Habsiguda', pincode: '500007' },
    { value: 'hitech-city', label: 'Hitech City', pincode: '500081' },
    { value: 'kacheguda', label: 'Kacheguda', pincode: '500027' },
    { value: 'kukatpally', label: 'Kukatpally', pincode: '500072' },
    { value: 'malakpet', label: 'Malakpet', pincode: '500036' },
    { value: 'madhapur', label: 'Madhapur', pincode: '500081' },
    { value: 'malkajgiri', label: 'Malkajgiri', pincode: '500047' },
    { value: 'mehdipatnam', label: 'Mehdipatnam', pincode: '500028' },
    { value: 'medchal', label: 'Medchal', pincode: '501401' },
    { value: 'nampally', label: 'Nampally', pincode: '500001' },
    { value: 'shamirpet', label: 'Shamirpet', pincode: '500101' },
    { value: 'shilparamam', label: 'Shilparamam', pincode: '500075' },
    { value: 'subedari', label: 'Subedari', pincode: '500068' },
    { value: 'tolichowki', label: 'Tolichowki', pincode: '500008' },
    { value: 'uppal', label: 'Uppal', pincode: '500039' },
    { value: 'yousufguda', label: 'Yousufguda', pincode: '500045' },
    { value: 'alwal', label: 'Alwal', pincode: '500010' },
    { value: 'balanagar', label: 'Balanagar', pincode: '500037' },
    { value: 'banjara-hills', label: 'Banjara Hills', pincode: '500034' },
    { value: 'barmaja', label: 'Barmaja', pincode: '500072' },
    { value: 'bhavanipuram', label: 'Bhavanipuram', pincode: '500058' },
    { value: 'bore-well', label: 'Bore Well', pincode: '500090' },
    { value: 'chilkalguda', label: 'Chilkalguda', pincode: '500061' },
    { value: 'gajularamaram', label: 'Gajularamaram', pincode: '500055' },
    { value: 'hussain-sagar', label: 'Hussain Sagar', pincode: '500004' },
    { value: 'jambagh', label: 'Jambagh', pincode: '500095' },
    { value: 'keshavan', label: 'Keshavan', pincode: '500018' },
    { value: 'kothapet', label: 'Kothapet', pincode: '500035' },
    { value: 'mallapur', label: 'Mallapur', pincode: '500076' },
    { value: 'meenakshi', label: 'Meenakshi', pincode: '500038' },
    { value: 'miyapur', label: 'Miyapur', pincode: '500049' },
    { value: 'nagole', label: 'Nagole', pincode: '500068' },
    { value: 'paradise', label: 'Paradise', pincode: '500003' },
    { value: 'pethalapally', label: 'Pethalapally', pincode: '500098' },
    { value: 'puranapul', label: 'Puranapul', pincode: '500064' },
    { value: 'ramchandrapuram', label: 'Ramchandrapuram', pincode: '500062' },
    { value: 'sainikpuri', label: 'Sainikpuri', pincode: '500094' },
    { value: 'shivajinagar', label: 'Shivajinagar', pincode: '500032' },
    { value: 'st-johns', label: 'St. John\'s', pincode: '500029' },
    { value: 'suraram', label: 'Suraram', pincode: '500055' },
    { value: 'tarnaka', label: 'Tarnaka', pincode: '500017' },
    { value: 'vijayawada', label: 'Vijayawada', pincode: '500009' },
    { value: 'wargal', label: 'Wargal', pincode: '500050' },
    { value: 'zafarguda', label: 'Zafarguda', pincode: '500050' }
    ],
  
    'kulgam': [
    { value: 'akhran', label: 'Akhran', pincode: '192232' },
    { value: 'anantnag', label: 'Anantnag', pincode: '192101' },
    { value: 'bejbhera', label: 'Bejbhera', pincode: '192123' },
    { value: 'dharmund', label: 'Dharmund', pincode: '192201' },
    { value: 'frisal', label: 'Frisal', pincode: '192303' },
    { value: 'kulgam-town', label: 'Kulgam Town', pincode: '192231' },
    { value: 'marhama', label: 'Marhama', pincode: '192211' },
    { value: 'pelwama', label: 'Pelwama', pincode: '192301' },
    { value: 'qazigund', label: 'Qazigund', pincode: '192221' },
    { value: 'shahabad', label: 'Shahabad', pincode: '192232' },
    { value: 'yaripora', label: 'Yaripora', pincode: '192201' },
    { value: 'chatpora', label: 'Chatpora', pincode: '192132' },
    { value: 'dailgam', label: 'Dailgam', pincode: '192202' },
    { value: 'duderhama', label: 'Duderhama', pincode: '192204' },
    { value: 'hazratbal', label: 'Hazratbal', pincode: '192213' },
    { value: 'helmand', label: 'Helmand', pincode: '192215' },
    { value: 'kesho', label: 'Kesho', pincode: '192233' },
    { value: 'khanpora', label: 'Khanpora', pincode: '192221' },
    { value: 'kramo', label: 'Kramo', pincode: '192205' },
    { value: 'kulgam', label: 'Kulgam', pincode: '192232' },
    { value: 'nagbal', label: 'Nagbal', pincode: '192301' },
    { value: 'raizal', label: 'Raizal', pincode: '192211' },
    { value: 'shamsabad', label: 'Shamsabad', pincode: '192202' },
    { value: 'south-kulgam', label: 'South Kulgam', pincode: '192236' }
    ],
  
    'awantipora': [
    { value: 'awantipora-town', label: 'Awantipora Town', pincode: '192122' },
    { value: 'bub', label: 'Bub', pincode: '192123' },
    { value: 'chandhar', label: 'Chandhar', pincode: '192122' },
    { value: 'dadasara', label: 'Dadasara', pincode: '192121' },
    { value: 'dangerpora', label: 'Dangerpora', pincode: '192125' },
    { value: 'fatemabad', label: 'Fatemabad', pincode: '192124' },
    { value: 'ladoo', label: 'Ladoo', pincode: '192124' },
    { value: 'nambal', label: 'Nambal', pincode: '192121' },
    { value: 'naristan', label: 'Naristan', pincode: '192125' },
    { value: 'sheenbagh', label: 'Sheenbagh', pincode: '192122' },
    { value: 'singhpora', label: 'Singhpora', pincode: '192126' },
    { value: 'tralon', label: 'Tralon', pincode: '192127' },
    { value: 'arampora', label: 'Arampora', pincode: '192122' },
    { value: 'chak-urhama', label: 'Chak Urhama', pincode: '192128' },
    { value: 'koil', label: 'Koil', pincode: '192128' },
    { value: 'kulgam', label: 'Kulgam', pincode: '192231' },
    { value: 'mohammadpora', label: 'Mohammadpora', pincode: '192129' },
    { value: 'nazneenpora', label: 'Nazneenpora', pincode: '192122' },
    { value: 'niloora', label: 'Niloora', pincode: '192120' },
    { value: 'parigam', label: 'Parigam', pincode: '192125' },
    { value: 'pahalgam', label: 'Pahalgam', pincode: '192126' },
    { value: 'rajpora', label: 'Rajpora', pincode: '192125' },
    { value: 'sallar', label: 'Sallar', pincode: '192131' },
    { value: 'samadpora', label: 'Samadpora', pincode: '192129' },
    { value: 'shemian', label: 'Shemian', pincode: '192124' }
    ],
  
    'muzaffarabad': [
    { value: 'bagh', label: 'Bagh', pincode: '12100' },
    { value: 'chaliana', label: 'Chaliana', pincode: '12101' },
    { value: 'chikkar', label: 'Chikkar', pincode: '12102' },
    { value: 'dhirkot', label: 'Dhirkot', pincode: '12103' },
    { value: 'gari', label: 'Gari', pincode: '12104' },
    { value: 'hattian-bala', label: 'Hattian Bala', pincode: '12105' },
    { value: 'khaigala', label: 'Khaigala', pincode: '12106' },
    { value: 'koza', label: 'Koza', pincode: '12107' },
    { value: 'muzaffarabad-town', label: 'Muzaffarabad Town', pincode: '12100' },
    { value: 'neelum-valley', label: 'Neelum Valley', pincode: '12108' },
    { value: 'rawalakot', label: 'Rawalakot', pincode: '12109' },
    { value: 'sirinagar', label: 'Sirinagar', pincode: '12110' },
    { value: 'sundar-bani', label: 'Sundar Bani', pincode: '12111' },
    { value: 'thotha', label: 'Thotha', pincode: '12112' },
    { value: 'toli-pur', label: 'Toli Pur', pincode: '12113' },
    { value: 'athmuqam', label: 'Athmuqam', pincode: '12114' },
    { value: 'darshan', label: 'Darshan', pincode: '12115' },
    { value: 'jagran', label: 'Jagran', pincode: '12116' },
    { value: 'kandhal', label: 'Kandhal', pincode: '12117' },
    { value: 'kundi', label: 'Kundi', pincode: '12118' },
    { value: 'muzaffarabad-kohala', label: 'Muzaffarabad Kohala', pincode: '12119' },
    { value: 'paliana', label: 'Paliana', pincode: '12120' },
    { value: 'potha', label: 'Potha', pincode: '12121' },
    { value: 'ramkot', label: 'Ramkot', pincode: '12122' },
    { value: 'sharda', label: 'Sharda', pincode: '12123' },
    { value: 'tolipora', label: 'Tolipora', pincode: '12124' },
    { value: 'halqua', label: 'Halqua', pincode: '12125' },
    { value: 'jagir', label: 'Jagir', pincode: '12126' },
    { value: 'kairo', label: 'Kairo', pincode: '12127' },
    { value: 'patwatan', label: 'Patwatan', pincode: '12128' },
    { value: 'chattian', label: 'Chattian', pincode: '12129' },
    { value: 'seri', label: 'Seri', pincode: '12130' },
    { value: 'muzaffarabad-sheikh', label: 'Muzaffarabad Sheikh', pincode: '12131' },
    { value: 'rangpur', label: 'Rangpur', pincode: '12132' },
    { value: 'raees-abad', label: 'Raees Abad', pincode: '12133' },
    { value: 'sarai', label: 'Sarai', pincode: '12134' },
    { value: 'toli-gali', label: 'Toli Gali', pincode: '12135' }
    ],
  
    'srinagar': [
    { value: 'badami-bagh-cantonment', label: 'Badami Bagh Cantonment', pincode: '190010' },
    { value: 'bagh-e-mehtab', label: 'Bagh-e-Mehtab', pincode: '190004' },
    { value: 'balgarden', label: 'Balgarden', pincode: '190007' },
    { value: 'bemina', label: 'Bemina', pincode: '190018' },
    { value: 'buchpora', label: 'Buchpora', pincode: '190020' },
    { value: 'budgam', label: 'Budgam', pincode: '191111' },
    { value: 'elachi-bagh', label: 'Elachi Bagh', pincode: '190008' },
    { value: 'habba-kadal', label: 'Habba Kadal', pincode: '190001' },
    { value: 'hamdaniya-colony', label: 'Hamdaniya Colony', pincode: '190001' },
    { value: 'harwan', label: 'Harwan', pincode: '190014' },
    { value: 'hyderpora', label: 'Hyderpora', pincode: '190014' },
    { value: 'jawahar-nagar', label: 'Jawahar Nagar', pincode: '190008' },
    { value: 'kalnat-pura', label: 'Kalnat Pura', pincode: '190012' },
    { value: 'khanmoh', label: 'Khanmoh', pincode: '190010' },
    { value: 'lal-bazar', label: 'Lal Bazar', pincode: '190001' },
    { value: 'lal-chowk', label: 'Lal Chowk', pincode: '190001' },
    { value: 'lal-gam', label: 'Lal Gam', pincode: '190020' },
    { value: 'lasjan', label: 'Lasjan', pincode: '190001' },
    { value: 'lawypora', label: 'Lawaypora', pincode: '190005' },
    { value: 'mehjoor-nagar', label: 'Mehjoor Nagar', pincode: '190010' },
    { value: 'mujgund', label: 'Mujgund', pincode: '190012' },
    { value: 'mustafabad', label: 'Mustafabad', pincode: '190005' },
    { value: 'naseem-bagh', label: 'Naseem Bagh', pincode: '190006' },
    { value: 'natipora', label: 'Natipora', pincode: '190005' },
    { value: 'nawakadal', label: 'Nawakadal', pincode: '190002' },
    { value: 'nishat', label: 'Nishat', pincode: '190003' },
    { value: 'nowhatta', label: 'Nowhatta', pincode: '190011' },
    { value: 'pantha-chowk', label: 'Pantha Chowk', pincode: '190020' },
    { value: 'peerbagh', label: 'Peerbagh', pincode: '190005' },
    { value: 'qamarwari', label: 'Qamarwari', pincode: '190018' },
    { value: 'rajbagh', label: 'Rajbagh', pincode: '190008' },
    { value: 'ram-bagh', label: 'Ram Bagh', pincode: '190008' },
    { value: 'sanat-nagar', label: 'Sanat Nagar', pincode: '190005' },
    { value: 'shalimar', label: 'Shalimar', pincode: '190014' },
    { value: 'shiv-pora', label: 'Shiv Pora', pincode: '190012' },
    { value: 'soura', label: 'Soura', pincode: '190010' },
    { value: 'sumbal-sonawari', label: 'Sumbal Sonawari', pincode: '193501' },
    { value: 'wathora', label: 'Wathora', pincode: '190005' },
    { value: 'zainakote', label: 'Zainakote', pincode: '190010' }
    ],
  
    'udhampur': [
    { value: 'adash-e-bhandari', label: 'Adash-e-Bhandari', pincode: '182101' },
    { value: 'balota', label: 'Balota', pincode: '182121' },
    { value: 'banihal', label: 'Banihal', pincode: '182123' },
    { value: 'bali', label: 'Bali', pincode: '182101' },
    { value: 'chak-dhiyala', label: 'Chak Dhiyala', pincode: '182122' },
    { value: 'dudu', label: 'Dudu', pincode: '182204' },
    { value: 'galiote', label: 'Galiote', pincode: '182121' },
    { value: 'jib', label: 'Jib', pincode: '182124' },
    { value: 'kanthgali', label: 'Kanthgali', pincode: '182101' },
    { value: 'kail', label: 'Kail', pincode: '182202' },
    { value: 'kulwanta', label: 'Kulwanta', pincode: '182101' },
    { value: 'manwal', label: 'Manwal', pincode: '182115' },
    { value: 'narsoo', label: 'Narssoo', pincode: '182122' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '182146' },
    { value: 'reasi', label: 'Reasi', pincode: '182311' },
    { value: 'sudhmahadev', label: 'Sudhmahadev', pincode: '182123' },
    { value: 'udham-pur', label: 'Udhampur', pincode: '182101' },
    { value: 'village-kherian', label: 'Village Kherian', pincode: '182101' },
    { value: 'village-panchari', label: 'Village Panchari', pincode: '182121' },
    { value: 'villages-krimchi', label: 'Villages Krimchi', pincode: '182124' },
    { value: 'balen', label: 'Balen', pincode: '182112' },
    { value: 'patherli', label: 'Patherli', pincode: '182145' },
    { value: 'patta', label: 'Patta', pincode: '182122' },
    { value: 'chack-brahmana', label: 'Chack Brahmana', pincode: '182120' },
    { value: 'battu', label: 'Battu', pincode: '182120' },
    { value: 'bhugter', label: 'Bhugter', pincode: '182141' },
    { value: 'chanchal', label: 'Chanchal', pincode: '182101' },
    { value: 'banota', label: 'Banota', pincode: '182113' }
    ],
  
    'anantnag': [
    { value: 'achabal', label: 'Achabal', pincode: '192221' },
    { value: 'adigam', label: 'Adigam', pincode: '192305' },
    { value: 'alnoor', label: 'Alnoor', pincode: '192102' },
    { value: 'ashajipora', label: 'Ashajipora', pincode: '192101' },
    { value: 'bailu', label: 'Bailu', pincode: '192131' },
    { value: 'bangad', label: 'Bangad', pincode: '192101' },
    { value: 'bijbehara', label: 'Bijbehara', pincode: '192124' },
    { value: 'burzhama', label: 'Burzhama', pincode: '192211' },
    { value: 'chak-bazaar', label: 'Chak Bazaar', pincode: '192101' },
    { value: 'dailgam', label: 'Dailgam', pincode: '192201' },
    { value: 'dora', label: 'Dora', pincode: '192124' },
    { value: 'dooru', label: 'Dooru', pincode: '192202' },
    { value: 'ganai', label: 'Ganai', pincode: '192132' },
    { value: 'kendru', label: 'Kendru', pincode: '192123' },
    { value: 'lal-chowk', label: 'Lal Chowk', pincode: '192101' },
    { value: 'mattan', label: 'Mattan', pincode: '192126' },
    { value: 'pinglish', label: 'Pinglish', pincode: '192124' },
    { value: 'pulwama', label: 'Pulwama', pincode: '192301' },
    { value: 'qazigund', label: 'Qazigund', pincode: '192221' },
    { value: 'qureshi', label: 'Qureshi', pincode: '192305' },
    { value: 'shanapora', label: 'Shanapora', pincode: '192101' },
    { value: 'siranwal', label: 'Siranwal', pincode: '192132' },
    { value: 'village-begum', label: 'Village Begum', pincode: '192101' },
    { value: 'village-nadimarg', label: 'Village Nadimarg', pincode: '192123' },
    { value: 'village-pampore', label: 'Village Pampore', pincode: '192121' },
    { value: 'village-sheikhpora', label: 'Village Sheikhpora', pincode: '192211' },
    { value: 'khull', label: 'Khull', pincode: '192125' },
    { value: 'kund', label: 'Kund', pincode: '192126' }
    ],
  
    'rajouri': [
    { value: 'anjani', label: 'Anjani', pincode: '185131' },
    { value: 'bagh', label: 'Bagh', pincode: '185131' },
    { value: 'baljarallan', label: 'Baljarallan', pincode: '185131' },
    { value: 'banihal', label: 'Banihal', pincode: '185130' },
    { value: 'bartu', label: 'Bartu', pincode: '185101' },
    { value: 'chakrali', label: 'Chakrali', pincode: '185102' },
    { value: 'dhara', label: 'Dhara', pincode: '185131' },
    { value: 'kandi', label: 'Kandi', pincode: '185152' },
    { value: 'kotranka', label: 'Kotranka', pincode: '185131' },
    { value: 'laam', label: 'Laam', pincode: '185121' },
    { value: 'manjari', label: 'Manjari', pincode: '185102' },
    { value: 'rajouri-town', label: 'Rajouri Town', pincode: '185131' },
    { value: 'sunderbani', label: 'Sunderbani', pincode: '185142' },
    { value: 'taryath', label: 'Taryath', pincode: '185151' },
    { value: 'thandapani', label: 'Thandapani', pincode: '185102' },
    { value: 'arrah', label: 'Arrah', pincode: '185152' },
    { value: 'channi', label: 'Channi', pincode: '185101' },
    { value: 'darhal', label: 'Darhal', pincode: '185131' },
    { value: 'dhangri', label: 'Dhangri', pincode: '185121' },
    { value: 'dhoke', label: 'Dhoke', pincode: '185131' },
    { value: 'gundah', label: 'Gundah', pincode: '185131' },
    { value: 'jandrah', label: 'Jandrah', pincode: '185102' },
    { value: 'kalsian', label: 'Kalsian', pincode: '185121' },
    { value: 'madhopur', label: 'Madhopur', pincode: '185101' },
    { value: 'mansar', label: 'Mansar', pincode: '185132' },
    { value: 'narian', label: 'Narian', pincode: '185101' },
    { value: 'nowshera', label: 'Nowshera', pincode: '185151' },
    { value: 'seri', label: 'Seri', pincode: '185132' }
    ],
  
    'kokernag': [
    { value: 'achabal', label: 'Achabal', pincode: '192221' },
    { value: 'arampora', label: 'Arampora', pincode: '192201' },
    { value: 'baltal', label: 'Baltal', pincode: '192212' },
    { value: 'baroosa', label: 'Baroosa', pincode: '192211' },
    { value: 'bela', label: 'Bela', pincode: '192202' },
    { value: 'bungam', label: 'Bungam', pincode: '192212' },
    { value: 'chandrigam', label: 'Chandrigam', pincode: '192201' },
    { value: 'chutran', label: 'Chutran', pincode: '192213' },
    { value: 'dailgam', label: 'Dailgam', pincode: '192201' },
    { value: 'frestbal', label: 'Frestbal', pincode: '192212' },
    { value: 'gund', label: 'Gund', pincode: '192212' },
    { value: 'gulabagh', label: 'Gulabagh', pincode: '192202' },
    { value: 'halqa', label: 'Halqa', pincode: '192121' },
    { value: 'harwan', label: 'Harwan', pincode: '192210' },
    { value: 'khrew', label: 'Khrew', pincode: '192204' },
    { value: 'kandhol', label: 'Kandhol', pincode: '192223' },
    { value: 'kokernag', label: 'Kokernag', pincode: '192101' },
    { value: 'larnoo', label: 'Larnoo', pincode: '192223' },
    { value: 'mangam', label: 'Mangam', pincode: '192211' },
    { value: 'mattan', label: 'Mattan', pincode: '192126' },
    { value: 'neel', label: 'Neel', pincode: '192202' },
    { value: 'naddar', label: 'Naddar', pincode: '192223' },
    { value: 'rishipora', label: 'Rishipora', pincode: '192202' },
    { value: 'shamsipora', label: 'Shamsipora', pincode: '192202' },
    { value: 'shangus', label: 'Shangus', pincode: '192212' },
    { value: 'sofru', label: 'Sofru', pincode: '192211' },
    { value: 'sirinagar', label: 'Sirinagar', pincode: '192202' },
    { value: 'tangar', label: 'Tangar', pincode: '192223' },
    { value: 'verinag', label: 'Verinag', pincode: '192211' },
    { value: 'wachi', label: 'Wachi', pincode: '192202' },
    { value: 'watlab', label: 'Watlab', pincode: '192211' }
    ],
  
    'leh': [
    { value: 'choglamsar', label: 'Choglamsar', pincode: '194101' },
    { value: 'chushul', label: 'Chushul', pincode: '194104' },
    { value: 'dah', label: 'Dah', pincode: '194201' },
    { value: 'durbuk', label: 'Durbuk', pincode: '194105' },
    { value: 'ghatakesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'khardung-la', label: 'Khardung La', pincode: '194101' },
    { value: 'kargil', label: 'Kargil', pincode: '194105' },
    { value: 'khaltse', label: 'Khaltse', pincode: '194109' },
    { value: 'leh-town', label: 'Leh Town', pincode: '194101' },
    { value: 'lukhung', label: 'Lukhung', pincode: '194106' },
    { value: 'manali-leh', label: 'Manali Leh', pincode: '194101' },
    { value: 'nimmu', label: 'Nimmu', pincode: '194109' },
    { value: 'pangong', label: 'Pangong', pincode: '194101' },
    { value: 'phyang', label: 'Phyang', pincode: '194102' },
    { value: 'ramree', label: 'Ramree', pincode: '194105' },
    { value: 'sankar', label: 'Sankar', pincode: '194101' },
    { value: 'shey', label: 'Shey', pincode: '194103' },
    { value: 'spituk', label: 'Spituk', pincode: '194101' },
    { value: 'sumdo', label: 'Sumdo', pincode: '194103' },
    { value: 'turtuk', label: 'Turtuk', pincode: '194201' },
    { value: 'thiksey', label: 'Thiksey', pincode: '194106' },
    { value: 'zanaskar', label: 'Zanaskar', pincode: '194302' },
    { value: 'changthang', label: 'Changthang', pincode: '194302' },
    { value: 'hunder', label: 'Hunder', pincode: '194201' },
    { value: 'diskit', label: 'Diskit', pincode: '194201' },
    { value: 'nubra', label: 'Nubra', pincode: '194201' },
    { value: 'tso-moriri', label: 'Tso Moriri', pincode: '194404' },
    { value: 'rangdum', label: 'Rangdum', pincode: '194302' },
    { value: 'lamayuru', label: 'Lamayuru', pincode: '194106' },
    { value: 'koyul', label: 'Koyul', pincode: '194103' },
    { value: 'zanskar', label: 'Zanskar', pincode: '194302' },
    { value: 'marigund', label: 'Marigund', pincode: '194102' }
    ],

  //Chhattisgarh
  'raipur': [
  { value: 'aditya-vihar', label: 'Aditya Vihar', pincode: '492001' },
  { value: 'ambedkar-nagar', label: 'Ambedkar Nagar', pincode: '492001' },
  { value: 'bhatagaon', label: 'Bhatagaon', pincode: '492007' },
  { value: 'bhatapara', label: 'Bhatapara', pincode: '493118' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'chhota-munga', label: 'Chhota Munga', pincode: '492013' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'devpuri', label: 'Devpuri', pincode: '492013' },
  { value: 'gandhi-maidan', label: 'Gandhi Maidan', pincode: '492004' },
  { value: 'gangrela', label: 'Gangrela', pincode: '492005' },
  { value: 'jayendra', label: 'Jayendra', pincode: '492016' },
  { value: 'kachandur', label: 'Kachandur', pincode: '492013' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '492004' },
  { value: 'khursipar', label: 'Khursipar', pincode: '492004' },
  { value: 'mana', label: 'Mana', pincode: '492010' },
  { value: 'mandir-hasaud', label: 'Mandir Hasaud', pincode: '492001' },
  { value: 'new-shivnath', label: 'New Shivnath', pincode: '492014' },
  { value: 'raikheda', label: 'Raikheda', pincode: '492008' },
  { value: 'raipur-taluqa', label: 'Raipur Taluqa', pincode: '492010' },
  { value: 'sundar-kheri', label: 'Sundar Kheri', pincode: '492004' },
  { value: 'takhatpur', label: 'Takhatpur', pincode: '492015' },
  { value: 'tilda', label: 'Tilda', pincode: '493101' },
  { value: 'tirathgarh', label: 'Tirathgarh', pincode: '492004' },
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '493332' },
  { value: 'belha', label: 'Belha', pincode: '492013' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '492015' },
  { value: 'bilaspur', label: 'Bilaspur', pincode: '495001' },
  { value: 'katora-tola', label: 'Katora Tola', pincode: '492010' },
  { value: 'keshlal', label: 'Keshlal', pincode: '492004' },
  { value: 'mantralaya', label: 'Mantralaya', pincode: '492001' },
  { value: 'mankodi', label: 'Mankodi', pincode: '492010' },
  { value: 'modi-basti', label: 'Modi Basti', pincode: '492002' },
  { value: 'raipur-naka', label: 'Raipur Naka', pincode: '492015' },
  { value: 'sakri', label: 'Sakri', pincode: '492004' },
  { value: 'shankar-basti', label: 'Shankar Basti', pincode: '492007' },
  { value: 'sundra', label: 'Sundra', pincode: '492010' }
  ],

  'korba': [
  { value: 'adampur', label: 'Adampur', pincode: '495674' },
  { value: 'bailadila', label: 'Bailadila', pincode: '495684' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '495685' },
  { value: 'chirhula', label: 'Chirhula', pincode: '495677' },
  { value: 'durgapur', label: 'Durgapur', pincode: '495678' },
  { value: 'janjgir', label: 'Janjgir', pincode: '495668' },
  { value: 'kapa', label: 'Kapa', pincode: '495684' },
  { value: 'karbhi', label: 'Karbhi', pincode: '495685' },
  { value: 'katghora', label: 'Katghora', pincode: '495444' },
  { value: 'korbi', label: 'Korbi', pincode: '495669' },
  { value: 'kosabadi', label: 'Kosabadi', pincode: '495684' },
  { value: 'manpur', label: 'Manpur', pincode: '495675' },
  { value: 'mohla', label: 'Mohla', pincode: '495677' },
  { value: 'raikheda', label: 'Raikheda', pincode: '495666' },
  { value: 'ramkola', label: 'Ramkola', pincode: '495664' },
  { value: 'sarora', label: 'Sarora', pincode: '495682' },
  { value: 'sekama', label: 'Sekama', pincode: '495661' },
  { value: 'sonadih', label: 'Sonadih', pincode: '495668' },
  { value: 'tatibandh', label: 'Tatibandh', pincode: '495684' },
  { value: 'chhuri', label: 'Chhuri', pincode: '495683' },
  { value: 'kharangja', label: 'Kharangja', pincode: '495681' },
  { value: 'kuddi', label: 'Kuddi', pincode: '495679' },
  { value: 'kutsara', label: 'Kutsara', pincode: '495663' },
  { value: 'mohagaon', label: 'Mohagaon', pincode: '495685' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '495665' },
  { value: 'sakti', label: 'Sakti', pincode: '495689' },
  { value: 'sonhat', label: 'Sonhat', pincode: '495669' },
  { value: 'tudri', label: 'Tudri', pincode: '495680' },
  { value: 'wadegaon', label: 'Wadegaon', pincode: '495682' }
  ],

  'durg': [
  { value: 'adampur', label: 'Adampur', pincode: '491001' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'bhilai-ghar', label: 'Bhilai Ghar', pincode: '490026' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '491111' },
  { value: 'borkheda', label: 'Borkheda', pincode: '491001' },
  { value: 'chakrabhata', label: 'Chakrabhata', pincode: '491001' },
  { value: 'chhatauna', label: 'Chhatauna', pincode: '491221' },
  { value: 'dhamdha', label: 'Dhamdha', pincode: '491223' },
  { value: 'devpuri', label: 'Devpuri', pincode: '491225' },
  { value: 'durga', label: 'Durga', pincode: '491001' },
  { value: 'durgapur', label: 'Durgapur', pincode: '491222' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '491001' },
  { value: 'kachandur', label: 'Kachandur', pincode: '491221' },
  { value: 'katora-tola', label: 'Katora Tola', pincode: '491002' },
  { value: 'khursipar', label: 'Khursipar', pincode: '491001' },
  { value: 'mana', label: 'Mana', pincode: '491002' },
  { value: 'naugaon', label: 'Naugaon', pincode: '491227' },
  { value: 'new-durg', label: 'New Durg', pincode: '491001' },
  { value: 'raikheda', label: 'Raikheda', pincode: '491229' },
  { value: 'raipur', label: 'Raipur', pincode: '491001' },
  { value: 'sarora', label: 'Sarora', pincode: '491222' },
  { value: 'sonakhan', label: 'Sonakhan', pincode: '491332' },
  { value: 'tilda', label: 'Tilda', pincode: '491223' },
  { value: 'bhatapara', label: 'Bhatapara', pincode: '491118' },
  { value: 'bhimgarh', label: 'Bhimgarh', pincode: '491222' },
  { value: 'hasda', label: 'Hasda', pincode: '491224' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '491225' },
  { value: 'mohgaon', label: 'Mohgaon', pincode: '491226' },
  { value: 'nalpad', label: 'Nalpad', pincode: '491221' },
  { value: 'parsi', label: 'Parsi', pincode: '491227' },
  { value: 'raikheda', label: 'Raikheda', pincode: '491229' },
  { value: 'sawari', label: 'Sawari', pincode: '491222' },
  { value: 'tela', label: 'Tela', pincode: '491229' },
  { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '491001' }
  ],

  'rajnandgaon': [
  { value: 'adampur', label: 'Adampur', pincode: '491441' },
  { value: 'amgaon', label: 'Amgaon', pincode: '491444' },
  { value: 'balod', label: 'Balod', pincode: '491227' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'boria', label: 'Boria', pincode: '491444' },
  { value: 'dalli-rajhara', label: 'Dalli Rajhara', pincode: '491228' },
  { value: 'dhimarkheda', label: 'Dhimarkheda', pincode: '491225' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'gadhwa', label: 'Gadhwa', pincode: '491335' },
  { value: 'gondia', label: 'Gondia', pincode: '491551' },
  { value: 'jaitpur', label: 'Jaitpur', pincode: '491447' },
  { value: 'kanker', label: 'Kanker', pincode: '491335' },
  { value: 'katangimuda', label: 'Katangimuda', pincode: '491226' },
  { value: 'kharsia', label: 'Kharsia', pincode: '491224' },
  { value: 'kishorpur', label: 'Kishorpur', pincode: '491221' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'sundari', label: 'Sundari', pincode: '491445' },
  { value: 'tilda', label: 'Tilda', pincode: '491223' },
  { value: 'waraseoni', label: 'Waraseoni', pincode: '491443' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '491337' },
  { value: 'bhilai-purani', label: 'Bhilai Purani', pincode: '490027' },
  { value: 'jogidih', label: 'Jogidih', pincode: '491451' },
  { value: 'kansabel', label: 'Kansabel', pincode: '491447' },
  { value: 'khairagarh', label: 'Khairagarh', pincode: '491881' },
  { value: 'kirandul', label: 'Kirandul', pincode: '491114' },
  { value: 'mandla', label: 'Mandla', pincode: '491355' },
  { value: 'raikheda', label: 'Raikheda', pincode: '491449' },
  { value: 'sarangarh', label: 'Sarangarh', pincode: '491444' },
  { value: 'tala', label: 'Tala', pincode: '491452' }
  ],

  'dhamtari': [
  { value: 'balod', label: 'Balod', pincode: '491226' },
  { value: 'bemetara', label: 'Bemetara', pincode: '491335' },
  { value: 'chicholi', label: 'Chicholi', pincode: '491447' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'dhamtari-town', label: 'Dhamtari Town', pincode: '493773' },
  { value: 'dondi', label: 'Dondi', pincode: '491222' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kanker', label: 'Kanker', pincode: '491336' },
  { value: 'kurud', label: 'Kurud', pincode: '493663' },
  { value: 'manpur', label: 'Manpur', pincode: '493558' },
  { value: 'nagari', label: 'Nagari', pincode: '493778' },
  { value: 'patan', label: 'Patan', pincode: '493554' },
  { value: 'sihawa', label: 'Sihawa', pincode: '493778' },
  { value: 'charama', label: 'Charama', pincode: '491885' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '494226' },
  { value: 'kuthri', label: 'Kuthri', pincode: '491441' },
  { value: 'bhanupratappur', label: 'Bhanupratappur', pincode: '491335' },
  { value: 'mohala', label: 'Mohala', pincode: '491665' },
  { value: 'tilda', label: 'Tilda', pincode: '493005' },
  { value: 'dhamtari-rural', label: 'Dhamtari Rural', pincode: '493773' },
  { value: 'baroda', label: 'Baroda', pincode: '491331' },
  { value: 'balodabazar', label: 'Balodabazar', pincode: '491441' },
  { value: 'champa', label: 'Champa', pincode: '495671' },
  { value: 'rajim', label: 'Rajim', pincode: '493885' },
  { value: 'arang', label: 'Arang', pincode: '493441' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '493281' },
  { value: 'malkangiri', label: 'Malkangiri', pincode: '493441' },
  { value: 'berla', label: 'Berla', pincode: '491333' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' }
  ],

  'mahasamund': [
  { value: 'bhatapara', label: 'Bhatapara', pincode: '493118' },
  { value: 'belha', label: 'Belha', pincode: '493557' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '493662' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'garh', label: 'Garh', pincode: '493555' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'janjgir', label: 'Janjgir', pincode: '495668' },
  { value: 'mahasamund', label: 'Mahasamund', pincode: '493445' },
  { value: 'mohala', label: 'Mohala', pincode: '491665' },
  { value: 'patan', label: 'Patan', pincode: '493554' },
  { value: 'raigarh', label: 'Raigarh', pincode: '496001' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'sihawa', label: 'Sihawa', pincode: '493778' },
  { value: 'tilda', label: 'Tilda', pincode: '493005' },
  { value: 'bamhani', label: 'Bamhani', pincode: '493881' },
  { value: 'kurud', label: 'Kurud', pincode: '493663' },
  { value: 'kanker', label: 'Kanker', pincode: '491336' },
  { value: 'turekela', label: 'Turekela', pincode: '493881' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'balod', label: 'Balod', pincode: '491226' },
  { value: 'kushalpur', label: 'Kushalpur', pincode: '493221' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '495445' }
  ],
  
  'kondagaon': [
  { value: 'bhanupratappur', label: 'Bhanupratappur', pincode: '491335' },
  { value: 'bemetara', label: 'Bemetara', pincode: '491335' },
  { value: 'charama', label: 'Charama', pincode: '491885' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'dondi', label: 'Dondi', pincode: '491222' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kanker', label: 'Kanker', pincode: '491336' },
  { value: 'kondagaon', label: 'Kondagaon', pincode: '494226' },
  { value: 'kurud', label: 'Kurud', pincode: '493663' },
  { value: 'manpur', label: 'Manpur', pincode: '493558' },
  { value: 'nagari', label: 'Nagari', pincode: '493778' },
  { value: 'patan', label: 'Patan', pincode: '493554' },
  { value: 'sihawa', label: 'Sihawa', pincode: '493778' },
  { value: 'tilda', label: 'Tilda', pincode: '493005' },
  { value: 'kuthri', label: 'Kuthri', pincode: '491441' },
  { value: 'berla', label: 'Berla', pincode: '491333' },
  { value: 'bhatapara', label: 'Bhatapara', pincode: '493118' },
  { value: 'balod', label: 'Balod', pincode: '491226' },
  { value: 'balodabazar', label: 'Balodabazar', pincode: '491441' },
  { value: 'sangwani', label: 'Sangwani', pincode: '493442' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '493281' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '495445' },
  { value: 'raigarh', label: 'Raigarh', pincode: '496001' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'turekela', label: 'Turekela', pincode: '493881' },
  { value: 'janjgir', label: 'Janjgir', pincode: '495668' },
  { value: 'kondagaon-town', label: 'Kondagaon Town', pincode: '494226' }
  ],

  'dantewada': [
  { value: 'bacheli', label: 'Bacheli', pincode: '494553' },
  { value: 'bhansi', label: 'Bhansi', pincode: '494553' },
  { value: 'barsoor', label: 'Barsoor', pincode: '494442' },
  { value: 'dantewada', label: 'Dantewada', pincode: '494449' },
  { value: 'dholkal', label: 'Dholkal', pincode: '494555' },
  { value: 'dongargaon', label: 'Dongargaon', pincode: '494441' },
  { value: 'geedam', label: 'Geedam', pincode: '494441' },
  { value: 'gondpalli', label: 'Gondpalli', pincode: '494553' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kirandul', label: 'Kirandul', pincode: '494556' },
  { value: 'kumakoleng', label: 'Kumakoleng', pincode: '494553' },
  { value: 'konta', label: 'Konta', pincode: '494553' },
  { value: 'manpur', label: 'Manpur', pincode: '493558' },
  { value: 'mohla', label: 'Mohla', pincode: '491665' },
  { value: 'nagar', label: 'Nagar', pincode: '494449' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '494661' },
  { value: 'pindke', label: 'Pindke', pincode: '494553' },
  { value: 'sukma', label: 'Sukma', pincode: '494111' },
  { value: 'bijapur', label: 'Bijapur', pincode: '494444' },
  { value: 'tirathgarh', label: 'Tirathgarh', pincode: '494555' },
  { value: 'wakaner', label: 'Wakaner', pincode: '494555' },
  { value: 'chintalnar', label: 'Chintalnar', pincode: '494553' },
  { value: 'madded', label: 'Madded', pincode: '494552' },
  { value: 'pedakonta', label: 'Pedakonta', pincode: '494442' },
  { value: 'sarayapal', label: 'Sarayapal', pincode: '494553' },
  { value: 'basaguda', label: 'Basaguda', pincode: '494222' },
  { value: 'komreng', label: 'Komreng', pincode: '494555' },
  { value: 'tulsi', label: 'Tulsi', pincode: '494222' }
  ],
  
  'kharod': [
  { value: 'bansul', label: 'Bansul', pincode: '493338' },
  { value: 'basna', label: 'Basna', pincode: '493554' },
  { value: 'chhuri', label: 'Chhuri', pincode: '493551' },
  { value: 'dhamtari', label: 'Dhamtari', pincode: '493773' },
  { value: 'gariaband', label: 'Gariaband', pincode: '493889' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jandaha', label: 'Jandaha', pincode: '493558' },
  { value: 'kharod', label: 'Kharod', pincode: '493337' },
  { value: 'manpur', label: 'Manpur', pincode: '493558' },
  { value: 'parsan', label: 'Parsan', pincode: '493559' },
  { value: 'raigarh', label: 'Raigarh', pincode: '496001' },
  { value: 'raipur', label: 'Raipur', pincode: '492001' },
  { value: 'tilda', label: 'Tilda', pincode: '493005' },
  { value: 'kurud', label: 'Kurud', pincode: '493663' },
  { value: 'nariyara', label: 'Nariyara', pincode: '493118' },
  { value: 'pithora', label: 'Pithora', pincode: '493551' },
  { value: 'sakti', label: 'Sakti', pincode: '496440' },
  { value: 'bhatapara', label: 'Bhatapara', pincode: '493118' },
  { value: 'balod', label: 'Balod', pincode: '491226' },
  { value: 'balodabazar', label: 'Balodabazar', pincode: '491441' },
  { value: 'sirpur', label: 'Sirpur', pincode: '493228' },
  { value: 'champa', label: 'Champa', pincode: '495671' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'dondida', label: 'Dondida', pincode: '493660' },
  { value: 'gunderdehi', label: 'Gunderdehi', pincode: '491225' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'baloda-bazar', label: 'Baloda Bazar', pincode: '491441' }
  ],

  'raigarh': [
  { value: 'alakhapuri', label: 'Alakhapuri', pincode: '496001' },
  { value: 'balco', label: 'Balco', pincode: '496001' },
  { value: 'baloda', label: 'Baloda', pincode: '496661' },
  { value: 'belpar', label: 'Belpar', pincode: '496001' },
  { value: 'bhayatarai', label: 'Bhayatarai', pincode: '496661' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '496001' },
  { value: 'chhattisgarh-nagar', label: 'Chhattisgarh Nagar', pincode: '496001' },
  { value: 'chhal', label: 'Chhal', pincode: '496001' },
  { value: 'deori', label: 'Deori', pincode: '496107' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jashpur', label: 'Jashpur', pincode: '496001' },
  { value: 'karanjia', label: 'Karanjia', pincode: '496001' },
  { value: 'katora', label: 'Katora', pincode: '496001' },
  { value: 'kharsia', label: 'Kharsia', pincode: '496661' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '496001' },
  { value: 'raigarh', label: 'Raigarh', pincode: '496001' },
  { value: 'ratanpur', label: 'Ratanpur', pincode: '496001' },
  { value: 'saraswatipur', label: 'Saraswatipur', pincode: '496001' },
  { value: 'shivrinarayan', label: 'Shivrinarayan', pincode: '495691' },
  { value: 'sikosa', label: 'Sikosa', pincode: '496001' },
  { value: 'tilda', label: 'Tilda', pincode: '493005' },
  { value: 'belbag', label: 'Belbag', pincode: '496660' },
  { value: 'bagbahra', label: 'Bagbahra', pincode: '496001' },
  { value: 'godhi', label: 'Godhi', pincode: '496660' },
  { value: 'rathora', label: 'Rathora', pincode: '496661' },
  { value: 'sirsiri', label: 'Sirsiri', pincode: '496661' },
  { value: 'kamta', label: 'Kamta', pincode: '496001' },
  { value: 'bhatgaon', label: 'Bhatgaon', pincode: '496554' },
  { value: 'kothari', label: 'Kothari', pincode: '496661' },
  { value: 'pali', label: 'Pali', pincode: '496554' },
  { value: 'sarangarh', label: 'Sarangarh', pincode: '496445' },
  { value: 'kuchdi', label: 'Kuchdi', pincode: '496661' },
  { value: 'ladma', label: 'Ladma', pincode: '496661' },
  { value: 'lawan', label: 'Lawan', pincode: '496221' },
  { value: 'manendragarh', label: 'Manendragarh', pincode: '496001' }
  ],

    'bhilai': [
  { value: 'adoor', label: 'Adoor', pincode: '490001' },
  { value: 'bhatapara', label: 'Bhatapara', pincode: '493118' },
  { value: 'bhilai', label: 'Bhilai', pincode: '490001' },
  { value: 'bhilai-nagar', label: 'Bhilai Nagar', pincode: '490001' },
  { value: 'bhilai-purani', label: 'Bhilai Purani', pincode: '490020' },
  { value: 'chhawani', label: 'Chhawani', pincode: '490020' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'fauji-colony', label: 'Fauji Colony', pincode: '490023' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '490006' },
  { value: 'ghatagaon', label: 'Ghatagaon', pincode: '490023' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'goel-nagar', label: 'Goel Nagar', pincode: '490023' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'kamal-vihar', label: 'Kamal Vihar', pincode: '490023' },
  { value: 'khursipar', label: 'Khursipar', pincode: '490011' },
  { value: 'korba', label: 'Korba', pincode: '495677' },
  { value: 'mohendri', label: 'Mohendri', pincode: '491661' },
  { value: 'nehru-nagar', label: 'Nehru Nagar', pincode: '490020' },
  { value: 'new-bhilai', label: 'New Bhilai', pincode: '490001' },
  { value: 'rupali', label: 'Rupali', pincode: '490023' },
  { value: 'shankar-nagar', label: 'Shankar Nagar', pincode: '490023' },
  { value: 'sri-ram-colony', label: 'Sri Ram Colony', pincode: '490023' },
  { value: 'supela', label: 'Supela', pincode: '490023' },
  { value: 'tala-bhatta', label: 'Tala Bhatta', pincode: '490020' },
  { value: 'tatibandh', label: 'Tatibandh', pincode: '490022' },
  { value: 'sector-1', label: 'Sector 1', pincode: '490001' },
  { value: 'sector-10', label: 'Sector 10', pincode: '490022' },
  { value: 'sector-15', label: 'Sector 15', pincode: '490026' },
  { value: 'sector-27', label: 'Sector 27', pincode: '490025' },
  { value: 'sector-3', label: 'Sector 3', pincode: '490022' },
  { value: 'sector-4', label: 'Sector 4', pincode: '490023' },
  { value: 'sector-6', label: 'Sector 6', pincode: '490021' },
  { value: 'sector-9', label: 'Sector 9', pincode: '490025' },
  { value: 'janta-colony', label: 'Janta Colony', pincode: '490011' },
  { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '490026' },
  { value: 'chhuri', label: 'Chhuri', pincode: '490023' },
  { value: 'khursipar', label: 'Khursipar', pincode: '490011' },
  { value: 'sadar-bazaar', label: 'Sadar Bazaar', pincode: '490020' },
  { value: 'patan', label: 'Patan', pincode: '491111' },
  { value: 'kapa', label: 'Kapa', pincode: '490023' }
  ],


  'bemetara': [
  { value: 'bemetara', label: 'Bemetara', pincode: '491335' },
  { value: 'bhainsa', label: 'Bhainsa', pincode: '491335' },
  { value: 'bhilaya', label: 'Bhilaya', pincode: '491335' },
  { value: 'champa', label: 'Champa', pincode: '495671' },
  { value: 'dharsi', label: 'Dharsi', pincode: '491336' },
  { value: 'durg', label: 'Durg', pincode: '491001' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'jagdalpur', label: 'Jagdalpur', pincode: '494001' },
  { value: 'kapsi', label: 'Kapsi', pincode: '491335' },
  { value: 'khamtarai', label: 'Khamtarai', pincode: '491337' },
  { value: 'kutel', label: 'Kutel', pincode: '491335' },
  { value: 'mandhar', label: 'Mandhar', pincode: '491336' },
  { value: 'mohendri', label: 'Mohendri', pincode: '491661' },
  { value: 'new-bemetara', label: 'New Bemetara', pincode: '491335' },
  { value: 'patan', label: 'Patan', pincode: '491111' },
  { value: 'raigarh', label: 'Raigarh', pincode: '496001' },
  { value: 'rajnandgaon', label: 'Rajnandgaon', pincode: '491441' },
  { value: 'sadar-bazaar', label: 'Sadar Bazaar', pincode: '491336' },
  { value: 'supela', label: 'Supela', pincode: '490023' },
  { value: 'tala-bhatta', label: 'Tala Bhatta', pincode: '491337' },
  { value: 'tilda', label: 'Tilda', pincode: '493005' },
  { value: 'belparakhas', label: 'Belparakhas', pincode: '491335' },
  { value: 'gundardehi', label: 'Gundardehi', pincode: '491337' },
  { value: 'khaira', label: 'Khaira', pincode: '491335' },
  { value: 'khatgaon', label: 'Khatgaon', pincode: '491336' },
  { value: 'kudri', label: 'Kudri', pincode: '491335' },
  { value: 'manpur', label: 'Manpur', pincode: '491335' },
  { value: 'nawagaon', label: 'Nawagaon', pincode: '491335' },
  { value: 'pachgachia', label: 'Pachgachia', pincode: '491335' },
  { value: 'sarangarh', label: 'Sarangarh', pincode: '496445' }
  ],

  // West Bengal Areas
  'bidhannagar': [
  { value: 'baguihati', label: 'Baguihati', pincode: '700059' },
  { value: 'bidhannagar', label: 'Bidhannagar', pincode: '700064' },
  { value: 'bengal-ambuja', label: 'Bengal Ambuja', pincode: '700090' },
  { value: 'bidhannagar-nd', label: 'Bidhannagar ND', pincode: '700091' },
  { value: 'chhoto-bazar', label: 'Chhoto Bazar', pincode: '700027' },
  { value: 'dharmatala', label: 'Dharmatala', pincode: '700027' },
  { value: 'rajpur', label: 'Rajpur', pincode: '700149' },
  { value: 'salt-lake', label: 'Salt Lake', pincode: '700091' },
  { value: 'sector-1', label: 'Sector 1', pincode: '700064' },
  { value: 'sector-2', label: 'Sector 2', pincode: '700091' },
  { value: 'sector-3', label: 'Sector 3', pincode: '700097' },
  { value: 'sector-4', label: 'Sector 4', pincode: '700106' },
  { value: 'sector-5', label: 'Sector 5', pincode: '700091' },
  { value: 'sector-6', label: 'Sector 6', pincode: '700100' },
  { value: 'sector-7', label: 'Sector 7', pincode: '700091' },
  { value: 'sector-8', label: 'Sector 8', pincode: '700091' },
  { value: 'sector-9', label: 'Sector 9', pincode: '700091' },
  { value: 'teghoria', label: 'Teghoria', pincode: '700157' },
  { value: 'akalpur', label: 'Akalpur', pincode: '700107' },
  { value: 'ballygunge', label: 'Ballygunge', pincode: '700019' },
  { value: 'belgachia', label: 'Belgachia', pincode: '700037' },
  { value: 'dumdum', label: 'Dumdum', pincode: '700028' },
  { value: 'garia', label: 'Garia', pincode: '700084' },
  { value: 'gitanjali-park', label: 'Gitanjali Park', pincode: '700084' },
  { value: 'kestopur', label: 'Kestopur', pincode: '700101' },
  { value: 'maniktala', label: 'Maniktala', pincode: '700054' },
  { value: 'new-town', label: 'New Town', pincode: '700156' },
  { value: 'rahara', label: 'Rahara', pincode: '700118' },
  { value: 'sodepur', label: 'Sodepur', pincode: '700110' }
  ],

  'baduria': [
  { value: 'baduria-town', label: 'Baduria Town', pincode: '743201' },
  { value: 'barunari', label: 'Barunari', pincode: '743222' },
  { value: 'chandipur', label: 'Chandipur', pincode: '743230' },
  { value: 'dharmapur', label: 'Dharmapur', pincode: '743204' },
  { value: 'gosaba', label: 'Gosaba', pincode: '743370' },
  { value: 'kaikhali', label: 'Kaikhali', pincode: '743312' },
  { value: 'kola', label: 'Kola', pincode: '743291' },
  { value: 'kultali', label: 'Kultali', pincode: '743349' },
  { value: 'madhabpur', label: 'Madhabpur', pincode: '743244' },
  { value: 'mouchak', label: 'Mouchak', pincode: '743239' },
  { value: 'nariyara', label: 'Nariyara', pincode: '743276' },
  { value: 'satgachhi', label: 'Satgachhi', pincode: '743218' },
  { value: 'shibpur', label: 'Shibpur', pincode: '743210' },
  { value: 'sonakhali', label: 'Sonakhali', pincode: '743355' },
  { value: 'sundarban', label: 'Sundarban', pincode: '743357' },
  { value: 'taldangra', label: 'Taldangra', pincode: '743231' },
  { value: 'berai', label: 'Berai', pincode: '743243' },
  { value: 'benachapra', label: 'Benachapra', pincode: '743262' },
  { value: 'chandpur', label: 'Chandpur', pincode: '743233' },
  { value: 'digambarpur', label: 'Digambarpur', pincode: '743278' },
  { value: 'gokulpur', label: 'Gokulpur', pincode: '743242' },
  { value: 'jatarbati', label: 'Jatarbati', pincode: '743283' },
  { value: 'kumarikata', label: 'Kumarikata', pincode: '743225' },
  { value: 'naobhanga', label: 'Naobhanga', pincode: '743251' },
  { value: 'purba-durgapur', label: 'Purba Durgapur', pincode: '743211' }
  ],
  
  'bally': [
  { value: 'bally-town', label: 'Bally Town', pincode: '711201' },
  { value: 'bally-bazar', label: 'Bally Bazar', pincode: '711202' },
  { value: 'bally-chandrapur', label: 'Bally Chandrapur', pincode: '711205' },
  { value: 'bally-ghat', label: 'Bally Ghat', pincode: '711204' },
  { value: 'bally-madhabpur', label: 'Bally Madhabpur', pincode: '711208' },
  { value: 'baranagar', label: 'Baranagar', pincode: '711223' },
  { value: 'kolar', label: 'Kolar', pincode: '711203' },
  { value: 'kundaghat', label: 'Kundaghat', pincode: '711222' },
  { value: 'kunderpara', label: 'Kunderpara', pincode: '711206' },
  { value: 'nayerhat', label: 'Nayerhat', pincode: '711211' },
  { value: 'pachim-bally', label: 'Pachim Bally', pincode: '711214' },
  { value: 'rajapara', label: 'Rajapara', pincode: '711207' },
  { value: 'sreepur', label: 'Sreepur', pincode: '711209' },
  { value: 'sudharampur', label: 'Sudharampur', pincode: '711210' },
  { value: 'surul', label: 'Surul', pincode: '711212' },
  { value: 'abadi', label: 'Abadi', pincode: '711215' },
  { value: 'gobindapur', label: 'Gobindapur', pincode: '711217' },
  { value: 'jagaddal', label: 'Jagaddal', pincode: '711218' },
  { value: 'kathalbagan', label: 'Kathalbagan', pincode: '711219' },
  { value: 'kumarpara', label: 'Kumarpara', pincode: '711220' },
  { value: 'manikpara', label: 'Manikpara', pincode: '711221' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '711213' }
  ],
  
  'balurghat': [
  { value: 'balurghat-town', label: 'Balurghat Town', pincode: '733101' },
  { value: 'balurghat-bazar', label: 'Balurghat Bazar', pincode: '733102' },
  { value: 'balurghat-railway-station', label: 'Balurghat Railway Station', pincode: '733103' },
  { value: 'balurghat-market', label: 'Balurghat Market', pincode: '733104' },
  { value: 'balurghat-durgapur', label: 'Balurghat Durgapur', pincode: '733105' },
  { value: 'balurghat-ranirbazar', label: 'Balurghat Ranirbazar', pincode: '733106' },
  { value: 'balurghat-chandipur', label: 'Balurghat Chandipur', pincode: '733107' },
  { value: 'balurghat-madhabnagar', label: 'Balurghat Madhabnagar', pincode: '733108' },
  { value: 'balurghat-kotwali', label: 'Balurghat Kotwali', pincode: '733109' },
  { value: 'balurghat-south', label: 'Balurghat South', pincode: '733110' },
  { value: 'balurghat-north', label: 'Balurghat North', pincode: '733111' },
  { value: 'balurghat-kalbari', label: 'Balurghat Kalbari', pincode: '733112' },
  { value: 'balurghat-jotbahar', label: 'Balurghat Jotbahar', pincode: '733113' },
  { value: 'balurghat-ghonapara', label: 'Balurghat Ghonapara', pincode: '733114' },
  { value: 'balurghat-kolkata-road', label: 'Balurghat Kolkata Road', pincode: '733115' },
  { value: 'balurghat-birpara', label: 'Balurghat Birpara', pincode: '733116' },
  { value: 'balurghat-bidhannagar', label: 'Balurghat Bidhannagar', pincode: '733117' },
  { value: 'balurghat-shibnagar', label: 'Balurghat Shibnagar', pincode: '733118' },
  { value: 'balurghat-rajarampur', label: 'Balurghat Rajarampur', pincode: '733119' },
  { value: 'balurghat-tasgaon', label: 'Balurghat Tasgaon', pincode: '733120' },
  { value: 'balurghat-narayanpur', label: 'Balurghat Narayanpur', pincode: '733121' }
  ],
  
  'bangaon': [
  { value: 'baro-bagan', label: 'Baro Bagan', pincode: '743235' },
  { value: 'bangaon-town', label: 'Bangaon Town', pincode: '743252' },
  { value: 'khunipara', label: 'Khunipara', pincode: '743253' },
  { value: 'madhusree', label: 'Madhusree', pincode: '743255' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '743206' },
  { value: 'panpur', label: 'Panpur', pincode: '743232' },
  { value: 'shyampur', label: 'Shyampur', pincode: '743211' },
  { value: 'sonakhali', label: 'Sonakhali', pincode: '743234' },
  { value: 'southbangaon', label: 'South Bangaon', pincode: '743256' },
  { value: 'westbangaon', label: 'West Bangaon', pincode: '743231' }
  ],
  
  'baranagar': [
  { value: 'adarshnagar', label: 'Adarshnagar', pincode: '700036' },
  { value: 'baranagar-bazar', label: 'Baranagar Bazar', pincode: '700036' },
  { value: 'baranagar-station-road', label: 'Baranagar Station Road', pincode: '700036' },
  { value: 'bhadra-pur', label: 'Bhadra Pur', pincode: '700036' },
  { value: 'dakshin-madhyamgram', label: 'Dakshin Madhyamgram', pincode: '700130' },
  { value: 'gopalnagar', label: 'Gopalnagar', pincode: '700027' },
  { value: 'jitpur', label: 'Jitpur', pincode: '700036' },
  { value: 'kanchanpara', label: 'Kanchanpara', pincode: '700036' },
  { value: 'majherhat', label: 'Majherhat', pincode: '700034' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '700035' },
  { value: 'banerjee-para', label: 'Banerjee Para', pincode: '700036' },
  { value: 'gandhi-para', label: 'Gandhi Para', pincode: '700036' },
  { value: 'ashoknagar', label: 'Ashoknagar', pincode: '700036' },
  { value: 'panchali', label: 'Panchali', pincode: '700036' },
  { value: 'sahidnagar', label: 'Sahidnagar', pincode: '700036' }
  ],
  
  'barasat': [
  { value: 'amraipur', label: 'Amraipur', pincode: '700124' },
  { value: 'barasat-bazar', label: 'Barasat Bazar', pincode: '700124' },
  { value: 'biranpur', label: 'Biranpur', pincode: '700126' },
  { value: 'chhoto-ramchandrapur', label: 'Chhoto Ramchandrapur', pincode: '700127' },
  { value: 'gopalpur', label: 'Gopalpur', pincode: '700125' },
  { value: 'jakpur', label: 'Jakpur', pincode: '700126' },
  { value: 'jessore-road', label: 'Jessore Road', pincode: '700128' },
  { value: 'kali-mandir', label: 'Kali Mandir', pincode: '700124' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '700124' },
  { value: 'madhusree', label: 'Madhusree', pincode: '700125' },
  { value: 'manikpur', label: 'Manikpur', pincode: '700127' },
  { value: 'sudhirpally', label: 'Sudhirpally', pincode: '700126' },
  { value: 'subhash-palli', label: 'Subhash Palli', pincode: '700125' },
  { value: 'sultana', label: 'Sultana', pincode: '700128' },
  { value: 'tegharia', label: 'Tegharia', pincode: '700127' },
  { value: 'rajnagar', label: 'Rajnagar', pincode: '700124' },
  { value: 'sonarpara', label: 'Sonarpara', pincode: '700125' },
  { value: 'teghoria', label: 'Teghoria', pincode: '700127' },
  { value: 'duttapara', label: 'Duttapara', pincode: '700125' },
  { value: 'padmapukur', label: 'Padmapukur', pincode: '700125' },
  { value: 'debishtala', label: 'Debishtala', pincode: '700128' },
  { value: 'haldia', label: 'Haldia', pincode: '700128' },
  { value: 'north-daspur', label: 'North Daspur', pincode: '700128' }
  ],
  
  'barrackpur-cantonment': [
  { value: 'anchal-mandir', label: 'Anchal Mandir', pincode: '700120' },
  { value: 'barrackpore-cantonment', label: 'Barrackpore Cantonment', pincode: '700120' },
  { value: 'barrackpore-railway', label: 'Barrackpore Railway', pincode: '700120' },
  { value: 'bhandardaha', label: 'Bhandardaha', pincode: '700122' },
  { value: 'bengal-harness', label: 'Bengal Harness', pincode: '700120' },
  { value: 'gangeshwar', label: 'Gangeshwar', pincode: '700120' },
  { value: 'holabagan', label: 'Holabagan', pincode: '700120' },
  { value: 'kamarhati', label: 'Kamarhati', pincode: '700058' },
  { value: 'kamarkundu', label: 'Kamarkundu', pincode: '700120' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '700120' },
  { value: 'mahamaya', label: 'Mahamaya', pincode: '700122' },
  { value: 'maheshbati', label: 'Maheshbati', pincode: '700120' },
  { value: 'north-barrackpore', label: 'North Barrackpore', pincode: '700122' },
  { value: 'patharghata', label: 'Patharghata', pincode: '700120' },
  { value: 'santoshpur', label: 'Santoshpur', pincode: '700120' },
  { value: 'siddheshwar', label: 'Siddheshwar', pincode: '700120' },
  { value: 'sundarbagan', label: 'Sundarbagan', pincode: '700120' },
  { value: 'tekari', label: 'Tekari', pincode: '700120' },
  { value: 'vishnu-ganj', label: 'Vishnu Ganj', pincode: '700120' },
  { value: 'belgachhia', label: 'Belgachhia', pincode: '700056' },
  { value: 'chandpara', label: 'Chandpara', pincode: '700120' },
  { value: 'jagannath-bari', label: 'Jagannath Bari', pincode: '700120' },
  { value: 'krishnachura', label: 'Krishnachura', pincode: '700120' },
  { value: 'madhyamgram', label: 'Madhyamgram', pincode: '700130' },
  { value: 'mahishbathan', label: 'Mahishbathan', pincode: '700120' },
  { value: 'south-barrackpore', label: 'South Barrackpore', pincode: '700120' },
  { value: 'taki-road', label: 'Taki Road', pincode: '700123' }
  ],
  
  'basirhat': [
  { value: 'adibasi-palli', label: 'Adibasi Palli', pincode: '743411' },
  { value: 'bakhrahat', label: 'Bakhrahat', pincode: '743414' },
  { value: 'basirhat', label: 'Basirhat', pincode: '743411' },
  { value: 'beliaghata', label: 'Beliaghata', pincode: '743411' },
  { value: 'birati', label: 'Birati', pincode: '743425' },
  { value: 'dharmapur', label: 'Dharmapur', pincode: '743426' },
  { value: 'gopalnagar', label: 'Gopalnagar', pincode: '743429' },
  { value: 'hazi-baba', label: 'Hazi Baba', pincode: '743419' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '743413' },
  { value: 'kachua', label: 'Kachua', pincode: '743422' },
  { value: 'kamaldaha', label: 'Kamaldaha', pincode: '743410' },
  { value: 'khalina', label: 'Khalina', pincode: '743412' },
  { value: 'makhal', label: 'Makhal', pincode: '743415' },
  { value: 'mangalkot', label: 'Mangalkot', pincode: '743428' },
  { value: 'modhupur', label: 'Modhupur', pincode: '743417' },
  { value: 'raipur', label: 'Raipur', pincode: '743418' },
  { value: 'shyamnagar', label: 'Shyamnagar', pincode: '743427' },
  { value: 'sonagaon', label: 'Sonagaon', pincode: '743416' },
  { value: 'sonarpur', label: 'Sonarpur', pincode: '743423' },
  { value: 'tapan', label: 'Tapan', pincode: '743420' },
  { value: 'udaypur', label: 'Udaypur', pincode: '743424' },
  { value: 'chandipur', label: 'Chandipur', pincode: '743430' },
  { value: 'dholagari', label: 'Dholagari', pincode: '743431' },
  { value: 'fultala', label: 'Fultala', pincode: '743432' },
  { value: 'jagannathganj', label: 'Jagannathganj', pincode: '743433' },
  { value: 'khagrabari', label: 'Khagrabari', pincode: '743434' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '743435' },
  { value: 'nayanagar', label: 'Nayanagar', pincode: '743436' },
  { value: 'parulia', label: 'Parulia', pincode: '743437' },
  { value: 'rajarampur', label: 'Rajarampur', pincode: '743438' }
  ],
  
  'berhampore': [
  { value: 'alambazar', label: 'Alambazar', pincode: '742101' },
  { value: 'baliganj', label: 'Baliganj', pincode: '742121' },
  { value: 'beldanga', label: 'Beldanga', pincode: '742133' },
  { value: 'berhampore', label: 'Berhampore', pincode: '742101' },
  { value: 'bhelagachhi', label: 'Bhelagachhi', pincode: '742140' },
  { value: 'bhitarbari', label: 'Bhitarbari', pincode: '742101' },
  { value: 'chakdah', label: 'Chakdah', pincode: '742122' },
  { value: 'dahapara', label: 'Dahapara', pincode: '742132' },
  { value: 'domkal', label: 'Domkal', pincode: '742303' },
  { value: 'fatepur', label: 'Fatepur', pincode: '742111' },
  { value: 'jalangi', label: 'Jalangi', pincode: '742314' },
  { value: 'kismat', label: 'Kismat', pincode: '742140' },
  { value: 'kotwali', label: 'Kotwali', pincode: '742101' },
  { value: 'mashal', label: 'Mashal', pincode: '742122' },
  { value: 'monoharpur', label: 'Monoharpur', pincode: '742141' },
  { value: 'muluk', label: 'Muluk', pincode: '742151' },
  { value: 'raiganj', label: 'Raiganj', pincode: '742135' },
  { value: 'rampur', label: 'Rampur', pincode: '742131' },
  { value: 'sadar', label: 'Sadar', pincode: '742102' },
  { value: 'samserganj', label: 'Samserganj', pincode: '742220' },
  { value: 'sarsabad', label: 'Sarsabad', pincode: '742124' },
  { value: 'shibnagar', label: 'Shibnagar', pincode: '742130' },
  { value: 'sonamukhi', label: 'Sonamukhi', pincode: '742105' },
  { value: 'tangramari', label: 'Tangramari', pincode: '742111' },
  { value: 'tapan', label: 'Tapan', pincode: '742117' },
  { value: 'amraipur', label: 'Amraipur', pincode: '742111' },
  { value: 'bhagalpur', label: 'Bhagalpur', pincode: '742125' },
  { value: 'kalinagar', label: 'Kalinagar', pincode: '742134' },
  { value: 'kushumgram', label: 'Kushumgram', pincode: '742129' },
  { value: 'machmari', label: 'Machmari', pincode: '742114' },
  { value: 'nalhati', label: 'Nalhati', pincode: '742113' },
  { value: 'raipur', label: 'Raipur', pincode: '742116' },
  { value: 'saha', label: 'Saha', pincode: '742110' }
  ],
  
  'bhadreswar': [
  { value: 'chandannagar', label: 'Chandannagar', pincode: '712136' },
  { value: 'chapdani', label: 'Chapdani', pincode: '712124' },
  { value: 'dharmatar', label: 'Dharmatar', pincode: '712212' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '712245' },
  { value: 'goghat', label: 'Goghat', pincode: '712702' },
  { value: 'jaggatnagar', label: 'Jaggatnagar', pincode: '712221' },
  { value: 'kalachand', label: 'Kalachand', pincode: '712228' },
  { value: 'kolsur', label: 'Kolsur', pincode: '712305' },
  { value: 'kudghat', label: 'Kudghat', pincode: '712243' },
  { value: 'kushumpur', label: 'Kushumpur', pincode: '712230' },
  { value: 'madhusree', label: 'Madhusree', pincode: '712115' },
  { value: 'mahamaya', label: 'Mahamaya', pincode: '712218' },
  { value: 'mahilabari', label: 'Mahilabari', pincode: '712209' },
  { value: 'mukundapur', label: 'Mukundapur', pincode: '712209' },
  { value: 'murari', label: 'Murari', pincode: '712123' },
  { value: 'nadiyapur', label: 'Nadiyapur', pincode: '712112' },
  { value: 'padmapur', label: 'Padmapur', pincode: '712213' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '712102' },
  { value: 'sarsabad', label: 'Sarsabad', pincode: '712115' },
  { value: 'shibpur', label: 'Shibpur', pincode: '712156' },
  { value: 'sitalpur', label: 'Sitalpur', pincode: '712105' },
  { value: 'shyambazar', label: 'Shyambazar', pincode: '712103' },
  { value: 'tulshi-nagar', label: 'Tulshi Nagar', pincode: '712238' },
  { value: 'uttarpara', label: 'Uttarpara', pincode: '712258' },
  { value: 'west-bhadreswar', label: 'West Bhadreswar', pincode: '712244' },
  { value: 'beside-railway-station', label: 'Beside Railway Station', pincode: '712220' },
  { value: 'chhoto-bhagalpur', label: 'Chhoto Bhagalpur', pincode: '712205' },
  { value: 'baba-bhagalpur', label: 'Baba Bhagalpur', pincode: '712206' },
  { value: 'ghosaldanga', label: 'Ghosaldanga', pincode: '712221' },
  { value: 'kanainagar', label: 'Kanainagar', pincode: '712111' },
  { value: 'gopalnagar', label: 'Gopalnagar', pincode: '712230' }
  ],
  
  'birbhum': [
  { value: 'aduria', label: 'Aduria', pincode: '731102' },
  { value: 'bolpur', label: 'Bolpur', pincode: '731204' },
  { value: 'bongabari', label: 'Bongabari', pincode: '731121' },
  { value: 'buktibari', label: 'Buktibari', pincode: '731121' },
  { value: 'chak-digri', label: 'Chak Digri', pincode: '731204' },
  { value: 'chak-purulia', label: 'Chak Purulia', pincode: '731103' },
  { value: 'durgapur', label: 'Durgapur', pincode: '731217' },
  { value: 'fultala', label: 'Fultala', pincode: '731124' },
  { value: 'godda', label: 'Godda', pincode: '731220' },
  { value: 'gopalganj', label: 'Gopalganj', pincode: '731125' },
  { value: 'gokulpur', label: 'Gokulpur', pincode: '731204' },
  { value: 'haldi', label: 'Haldi', pincode: '731124' },
  { value: 'jamalpur', label: 'Jamalpur', pincode: '731206' },
  { value: 'jaypur', label: 'Jaypur', pincode: '731125' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '731125' },
  { value: 'khatranga', label: 'Khatranga', pincode: '731213' },
  { value: 'kolancha', label: 'Kolancha', pincode: '731227' },
  { value: 'kunduli', label: 'Kunduli', pincode: '731123' },
  { value: 'madhupur', label: 'Madhupur', pincode: '731213' },
  { value: 'manirampur', label: 'Manirampur', pincode: '731229' },
  { value: 'mukutmanipur', label: 'Mukutmanipur', pincode: '731121' },
  { value: 'murarai', label: 'Murarai', pincode: '731219' },
  { value: 'nabagram', label: 'Nabagram', pincode: '731105' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '731221' },
  { value: 'patuli', label: 'Patuli', pincode: '731212' },
  { value: 'purulia', label: 'Purulia', pincode: '731221' },
  { value: 'raiganj', label: 'Raiganj', pincode: '731227' },
  { value: 'sainthia', label: 'Sainthia', pincode: '731234' },
  { value: 'sarbari', label: 'Sarbari', pincode: '731238' },
  { value: 'shibpur', label: 'Shibpur', pincode: '731208' },
  { value: 'shibpur-2', label: 'Shibpur-2', pincode: '731210' },
  { value: 'shonatala', label: 'Shonatala', pincode: '731123' },
  { value: 'sriniketan', label: 'Sriniketan', pincode: '731236' },
  { value: 'tapu', label: 'Tapu', pincode: '731123' },
  { value: 'tarapith', label: 'Tarapith', pincode: '731233' },
  { value: 'tengra', label: 'Tengra', pincode: '731228' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '731225' },
  { value: 'rampur', label: 'Rampur', pincode: '731212' },
  { value: 'sadhua', label: 'Sadhua', pincode: '731211' }
  ],
  
  'chandannagar': [
  { value: 'baganpara', label: 'Baganpara', pincode: '712136' },
  { value: 'bhanga-kandi', label: 'Bhanga Kandi', pincode: '712123' },
  { value: 'bholanath-pur', label: 'Bholanath Pur', pincode: '712101' },
  { value: 'chandannagar', label: 'Chandannagar', pincode: '712136' },
  { value: 'chandannagar-town', label: 'Chandannagar Town', pincode: '712136' },
  { value: 'chowdhurypara', label: 'Chowdhurypara', pincode: '712136' },
  { value: 'gopalnagar', label: 'Gopalnagar', pincode: '712136' },
  { value: 'jhikra', label: 'Jhikra', pincode: '712137' },
  { value: 'kolar', label: 'Kolar', pincode: '712137' },
  { value: 'nagarbari', label: 'Nagarbari', pincode: '712104' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '712136' },
  { value: 'srirampur', label: 'Srirampur', pincode: '712201' },
  { value: 'tulsipur', label: 'Tulsipur', pincode: '712137' },
  { value: 'kushumgram', label: 'Kushumgram', pincode: '712138' },
  { value: 'asannagar', label: 'Asannagar', pincode: '712124' }
  ],
  
  'chinsurah': [
  { value: 'aamgachhi', label: 'Aamgachhi', pincode: '712102' },
  { value: 'bansdroni', label: 'Bansdroni', pincode: '712102' },
  { value: 'bansberia', label: 'Bansberia', pincode: '712502' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '712102' },
  { value: 'chinsurah', label: 'Chinsurah', pincode: '712101' },
  { value: 'chinsurah-municipal', label: 'Chinsurah Municipal', pincode: '712101' },
  { value: 'chitpur', label: 'Chitpur', pincode: '712104' },
  { value: 'gongabaria', label: 'Gongabaria', pincode: '712103' },
  { value: 'gouranga-nagar', label: 'Gouranga Nagar', pincode: '712101' },
  { value: 'kankinara', label: 'Kankinara', pincode: '712123' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '741101' },
  { value: 'mangalkote', label: 'Mangalkote', pincode: '712303' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '712105' },
  { value: 'rajarhat', label: 'Rajarhat', pincode: '712106' },
  { value: 'santipur', label: 'Santipur', pincode: '712101' },
  { value: 'sarenga', label: 'Sarenga', pincode: '712107' },
  { value: 'srirampur', label: 'Srirampur', pincode: '712104' },
  { value: 'tarakeswar', label: 'Tarakeswar', pincode: '712410' },
  { value: 'turf-ganj', label: 'Turf Ganj', pincode: '712103' }
  ],
  
  'cooch-behar': [
  { value: 'alipurduar', label: 'Alipurduar', pincode: '736121' },
  { value: 'arandangi', label: 'Arandangi', pincode: '736135' },
  { value: 'balarampur', label: 'Balarampur', pincode: '736106' },
  { value: 'balapara', label: 'Balapara', pincode: '736146' },
  { value: 'bhurbandha', label: 'Bhurbandha', pincode: '736142' },
  { value: 'bosepara', label: 'Bosepara', pincode: '736156' },
  { value: 'cahapara', label: 'Cahapara', pincode: '736132' },
  { value: 'damdim', label: 'Damdim', pincode: '736151' },
  { value: 'garopara', label: 'Garopara', pincode: '736127' },
  { value: 'jatrapur', label: 'Jatrapur', pincode: '736134' },
  { value: 'kanthalguri', label: 'Kanthalguri', pincode: '736160' },
  { value: 'kismat', label: 'Kismat', pincode: '736130' },
  { value: 'mainaguri', label: 'Mainaguri', pincode: '736147' },
  { value: 'mathabhanga', label: 'Mathabhanga', pincode: '736146' },
  { value: 'monakhali', label: 'Monakhali', pincode: '736149' },
  { value: 'radhanagar', label: 'Radhanagar', pincode: '736122' },
  { value: 'sabari', label: 'Sabari', pincode: '736152' },
  { value: 'samshernagar', label: 'Samshernagar', pincode: '736153' },
  { value: 'tufanganj', label: 'Tufanganj', pincode: '736160' },
  { value: 'rajdanga', label: 'Rajdanga', pincode: '736147' },
  { value: 'dinhata', label: 'Dinhata', pincode: '736135' }
  ],
  
  'dhupguri': [
  { value: 'balarampur', label: 'Balarampur', pincode: '736121' },
  { value: 'baroipara', label: 'Baroipara', pincode: '736122' },
  { value: 'chakchaka', label: 'Chakchaka', pincode: '736141' },
  { value: 'dhupguri-para', label: 'Dhupguri Para', pincode: '736146' },
  { value: 'gonapur', label: 'Gonapur', pincode: '736145' },
  { value: 'jharbari', label: 'Jharbari', pincode: '736143' },
  { value: 'kismat', label: 'Kismat', pincode: '736140' },
  { value: 'madhuguri', label: 'Madhuguri', pincode: '736124' },
  { value: 'nadanghat', label: 'Nadanghat', pincode: '736142' },
  { value: 'new-dhupguri', label: 'New Dhupguri', pincode: '736127' },
  { value: 'rangdah', label: 'Rangdah', pincode: '736144' },
  { value: 'samuktala', label: 'Samuktala', pincode: '736130' },
  { value: 'sankarpur', label: 'Sankarpur', pincode: '736128' },
  { value: 'tirpai', label: 'Tirpai', pincode: '736125' },
  { value: 'rahat', label: 'Rahat', pincode: '736126' },
  { value: 'dhandabari', label: 'Dhandabari', pincode: '736129' },
  { value: 'bhelabari', label: 'Bhelabari', pincode: '736123' },
  { value: 'beranagar', label: 'Beranagar', pincode: '736131' }
  ],
  
  'egra': [
  { value: 'alampur', label: 'Alampur', pincode: '721440' },
  { value: 'andarkhali', label: 'Andarkhali', pincode: '721443' },
  { value: 'barul', label: 'Barul', pincode: '721447' },
  { value: 'belda', label: 'Belda', pincode: '721424' },
  { value: 'bhogpur', label: 'Bhogpur', pincode: '721438' },
  { value: 'broadgate', label: 'Broadgate', pincode: '721456' },
  { value: 'duerambur', label: 'Duerambur', pincode: '721421' },
  { value: 'egra', label: 'Egra', pincode: '721429' },
  { value: 'ghola', label: 'Ghola', pincode: '721457' },
  { value: 'goraghat', label: 'Goraghat', pincode: '721437' },
  { value: 'jatilapur', label: 'Jatilapur', pincode: '721421' },
  { value: 'jhitia', label: 'Jhitia', pincode: '721423' },
  { value: 'kismat', label: 'Kismat', pincode: '721436' },
  { value: 'kuchlani', label: 'Kuchlani', pincode: '721422' },
  { value: 'manikpara', label: 'Manikpara', pincode: '721425' },
  { value: 'mousuni', label: 'Mousuni', pincode: '721441' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '721431' },
  { value: 'sitarampur', label: 'Sitarampur', pincode: '721430' },
  { value: 'sunderban', label: 'Sunderban', pincode: '721448' },
  { value: 'taltola', label: 'Taltola', pincode: '721439' },
  { value: 'bhupatinagar', label: 'Bhupatinagar', pincode: '721454' }
  ],
  
  'jamuria': [
  { value: 'adampur', label: 'Adampur', pincode: '713359' },
  { value: 'alampur', label: 'Alampur', pincode: '713354' },
  { value: 'barjora', label: 'Barjora', pincode: '713401' },
  { value: 'bansberia', label: 'Bansberia', pincode: '713333' },
  { value: 'bhiringi', label: 'Bhiringi', pincode: '713362' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '713330' },
  { value: 'diguli', label: 'Diguli', pincode: '713328' },
  { value: 'goaltore', label: 'Goaltore', pincode: '713316' },
  { value: 'jamuria', label: 'Jamuria', pincode: '713335' },
  { value: 'jhitia', label: 'Jhitia', pincode: '713318' },
  { value: 'kashipur', label: 'Kashipur', pincode: '713363' },
  { value: 'kultikri', label: 'Kultikri', pincode: '713343' },
  { value: 'kusumgram', label: 'Kusumgram', pincode: '713354' },
  { value: 'manigram', label: 'Manigram', pincode: '713340' },
  { value: 'margram', label: 'Margram', pincode: '713339' },
  { value: 'murarai', label: 'Murarai', pincode: '713318' },
  { value: 'pachami', label: 'Pachami', pincode: '713142' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '713331' },
  { value: 'santrajpur', label: 'Santrajpur', pincode: '713321' },
  { value: 'saurini', label: 'Saurini', pincode: '713324' },
  { value: 'udaypur', label: 'Udaypur', pincode: '713322' },
  { value: 'belarampur', label: 'Belarampur', pincode: '713317' },
  { value: 'sadaipur', label: 'Sadaipur', pincode: '713337' }
  ],
  
  'jaynagar-mazilpur': [
  { value: 'aizul', label: 'Aizul', pincode: '743347' },
  { value: 'baligori', label: 'Baligori', pincode: '743357' },
  { value: 'bansdroni', label: 'Bansdroni', pincode: '743336' },
  { value: 'banspara', label: 'Banspara', pincode: '743355' },
  { value: 'bhagabatipur', label: 'Bhagabatipur', pincode: '743314' },
  { value: 'bhandar', label: 'Bhandar', pincode: '743318' },
  { value: 'charghat', label: 'Charghat', pincode: '743324' },
  { value: 'chandipur', label: 'Chandipur', pincode: '743336' },
  { value: 'jaynagar-mazilpur', label: 'Jaynagar Mazilpur', pincode: '743337' },
  { value: 'kamarpur', label: 'Kamarpur', pincode: '743343' },
  { value: 'khodambari', label: 'Khodambari', pincode: '743331' },
  { value: 'kulgachia', label: 'Kulgachia', pincode: '743346' },
  { value: 'mandirbazar', label: 'Mandirbazar', pincode: '743375' },
  { value: 'mazilpur', label: 'Mazilpur', pincode: '743337' },
  { value: 'panchberia', label: 'Panchberia', pincode: '743333' },
  { value: 'rahimpur', label: 'Rahimpur', pincode: '743350' },
  { value: 'sonarpur', label: 'Sonarpur', pincode: '743368' },
  { value: 'tollygunge', label: 'Tollygunge', pincode: '743307' },
  { value: 'bongram', label: 'Bongram', pincode: '743318' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '743345' },
  { value: 'dobson', label: 'Dobson', pincode: '743323' },
  { value: 'kedar', label: 'Kedar', pincode: '743332' },
  { value: 'murarai', label: 'Murarai', pincode: '743314' },
  { value: 'rajapur', label: 'Rajapur', pincode: '743340' },
  { value: 'shyambazar', label: 'Shyambazar', pincode: '743363' },
  { value: 'sukanta', label: 'Sukanta', pincode: '743365' }
  ],
  
  'kalyani': [
  { value: 'adhirampur', label: 'Adhirampur', pincode: '741235' },
  { value: 'agarpara', label: 'Agarpara', pincode: '743177' },
  { value: 'bhagabanpur', label: 'Bhagabanpur', pincode: '741232' },
  { value: 'bongram', label: 'Bongram', pincode: '741246' },
  { value: 'chandannagar', label: 'Chandannagar', pincode: '741101' },
  { value: 'chhoto-jalangi', label: 'Chhoto Jalangi', pincode: '741248' },
  { value: 'dakshin-krishnanagar', label: 'Dakshin Krishnanagar', pincode: '741235' },
  { value: 'kalyani', label: 'Kalyani', pincode: '741235' },
  { value: 'kamarkundu', label: 'Kamarkundu', pincode: '741253' },
  { value: 'khandaghosh', label: 'Khandaghosh', pincode: '741249' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '741101' },
  { value: 'mahishbath', label: 'Mahishbath', pincode: '741249' },
  { value: 'nabagram', label: 'Nabagram', pincode: '741234' },
  { value: 'nadia', label: 'Nadia', pincode: '741220' },
  { value: 'pachambari', label: 'Pachambari', pincode: '741248' },
  { value: 'panchanantala', label: 'Panchanantala', pincode: '741222' },
  { value: 'rajarampur', label: 'Rajarampur', pincode: '741247' },
  { value: 'rasulpur', label: 'Rasulpur', pincode: '741232' },
  { value: 'shibpur', label: 'Shibpur', pincode: '741256' },
  { value: 'tamanghat', label: 'Tamanghat', pincode: '741234' },
  { value: 'banshkhali', label: 'Banshkhali', pincode: '741257' },
  { value: 'bhattacharjeepara', label: 'Bhattacharjeepara', pincode: '741235' }
  ],
  
  'kamarhati': [
  { value: 'agarpara', label: 'Agarpara', pincode: '700109' },
  { value: 'baranagar', label: 'Baranagar', pincode: '700036' },
  { value: 'belgharia', label: 'Belgharia', pincode: '700056' },
  { value: 'cossipore', label: 'Cossipore', pincode: '700002' },
  { value: 'dunlop', label: 'Dunlop', pincode: '700108' },
  { value: 'kamarhati', label: 'Kamarhati', pincode: '700058' },
  { value: 'khardah', label: 'Khardah', pincode: '700117' },
  { value: 'panihati', label: 'Panihati', pincode: '700114' },
  { value: 'patulia', label: 'Patulia', pincode: '700119' },
  { value: 'sinthee', label: 'Sinthee', pincode: '700050' },
  { value: 'sodepur', label: 'Sodepur', pincode: '700110' },
  { value: 'tala', label: 'Tala', pincode: '700002' },
  { value: 'titagarh', label: 'Titagarh', pincode: '700119' }
  ],
  
  'kanchrapara': [
  { value: 'aamghata', label: 'Aamghata', pincode: '743145' },
  { value: 'ashoknagar', label: 'Ashoknagar', pincode: '743222' },
  { value: 'babanpur', label: 'Babanpur', pincode: '743145' },
  { value: 'halisahar', label: 'Halisahar', pincode: '743134' },
  { value: 'ichapur', label: 'Ichapur', pincode: '743144' },
  { value: 'kanchrapara-bazar', label: 'Kanchrapara Bazar', pincode: '743145' },
  { value: 'kanchrapara-railway-colony', label: 'Kanchrapara Railway Colony', pincode: '743145' },
  { value: 'kampa', label: 'Kampa', pincode: '743193' },
  { value: 'malancha', label: 'Malancha', pincode: '743145' },
  { value: 'mistry-ghat', label: 'Mistry Ghat', pincode: '743145' },
  { value: 'natagarh', label: 'Natagarh', pincode: '743193' },
  { value: 'noapara', label: 'Noapara', pincode: '743193' },
  { value: 'rathtala', label: 'Rathtala', pincode: '743145' },
  { value: 'sebagram', label: 'Sebagram', pincode: '743144' },
  { value: 'shyamnagar', label: 'Shyamnagar', pincode: '743127' },
  { value: 'simultala', label: 'Simultala', pincode: '743145' },
  { value: 'talpukur', label: 'Talpukur', pincode: '743145' },
  { value: 'west-kalyani', label: 'West Kalyani', pincode: '743145' }
  ],
  
  'khardaha': [
  { value: 'agarpara', label: 'Agarpara', pincode: '700109' },
  { value: 'banhooghly', label: 'Banhooghly', pincode: '700108' },
  { value: 'barasat-road', label: 'Barasat Road', pincode: '700117' },
  { value: 'bengal-chemical', label: 'Bengal Chemical', pincode: '700108' },
  { value: 'bilkanda', label: 'Bilkanda', pincode: '700113' },
  { value: 'bosepukur', label: 'Bosepukur', pincode: '700110' },
  { value: 'dakhindari', label: 'Dakhindari', pincode: '700107' },
  { value: 'ghola', label: 'Ghola', pincode: '700111' },
  { value: 'gobardanga', label: 'Gobardanga', pincode: '700110' },
  { value: 'jagatdal', label: 'Jagatdal', pincode: '743125' },
  { value: 'khardaha-bazar', label: 'Khardaha Bazar', pincode: '700117' },
  { value: 'madhyamgram', label: 'Madhyamgram', pincode: '700129' },
  { value: 'natagarh', label: 'Natagarh', pincode: '700113' },
  { value: 'noapara', label: 'Noapara', pincode: '700113' },
  { value: 'panihati', label: 'Panihati', pincode: '700114' },
  { value: 'rahara', label: 'Rahara', pincode: '700118' },
  { value: 'sodepur', label: 'Sodepur', pincode: '700110' },
  { value: 'talpukur', label: 'Talpukur', pincode: '700117' },
  { value: 'titagarh', label: 'Titagarh', pincode: '700119' }
  ],
  
  'krishnanagar': [
  { value: 'abarari', label: 'Abarari', pincode: '741126' },
  { value: 'arashulia', label: 'Arashulia', pincode: '741101' },
  { value: 'bablari-dobson', label: 'Bablari Dobson', pincode: '741140' },
  { value: 'bhandarkhola', label: 'Bhandarkhola', pincode: '741138' },
  { value: 'chakdaha', label: 'Chakdaha', pincode: '741222' },
  { value: 'chupipota', label: 'Chupipota', pincode: '741103' },
  { value: 'dwijendrapally', label: 'Dwijendrapally', pincode: '741102' },
  { value: 'ghurni', label: 'Ghurni', pincode: '741103' },
  { value: 'gopalpur', label: 'Gopalpur', pincode: '741235' },
  { value: 'hanskhali', label: 'Hanskhali', pincode: '741505' },
  { value: 'haranagar', label: 'Haranagar', pincode: '741154' },
  { value: 'kalikapur', label: 'Kalikapur', pincode: '741101' },
  { value: 'krishnanagar-bazar', label: 'Krishnanagar Bazar', pincode: '741101' },
  { value: 'kulgachi', label: 'Kulgachi', pincode: '741152' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '741125' },
  { value: 'madhupur', label: 'Madhupur', pincode: '741140' },
  { value: 'mokrampur', label: 'Mokrampur', pincode: '741150' },
  { value: 'nabadwip', label: 'Nabadwip', pincode: '741302' },
  { value: 'palpara', label: 'Palpara', pincode: '741102' },
  { value: 'phulia', label: 'Phulia', pincode: '741402' },
  { value: 'ranaghat', label: 'Ranaghat', pincode: '741201' },
  { value: 'santipur', label: 'Santipur', pincode: '741404' },
  { value: 'shibpur', label: 'Shibpur', pincode: '741105' },
  { value: 'subarnapur', label: 'Subarnapur', pincode: '741124' },
  { value: 'tehatta', label: 'Tehatta', pincode: '741160' },
  { value: 'uttarpara', label: 'Uttarpara', pincode: '741103' }
  ],
  
  'mathabhanga': [
  { value: 'baradi', label: 'Baradi', pincode: '736146' },
  { value: 'basanti', label: 'Basanti', pincode: '743312' },
  { value: 'bhutnagar', label: 'Bhutnagar', pincode: '736147' },
  { value: 'bhutpur', label: 'Bhutpur', pincode: '736145' },
  { value: 'garia', label: 'Garia', pincode: '743358' },
  { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
  { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '741101' },
  { value: 'mathabhanga', label: 'Mathabhanga', pincode: '736146' },
  { value: 'nityanandapur', label: 'Nityanandapur', pincode: '736143' },
  { value: 'purba-medinipur', label: 'Purba Medinipur', pincode: '721101' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '743318' },
  { value: 'sailmari', label: 'Sailmari', pincode: '736148' },
  { value: 'sundarpur', label: 'Sundarpur', pincode: '736149' },
  { value: 'bibhutipur', label: 'Bibhutipur', pincode: '736150' },
  { value: 'bongram', label: 'Bongram', pincode: '736151' },
  { value: 'purulia', label: 'Purulia', pincode: '723101' },
  { value: 'manikpur', label: 'Manikpur', pincode: '736152' }
  ],
  
  'midnapore': [
  { value: 'adda', label: 'Adda', pincode: '721101' },
  { value: 'balarampur', label: 'Balarampur', pincode: '721303' },
  { value: 'bhupatinagar', label: 'Bhupatinagar', pincode: '721101' },
  { value: 'chandrakona', label: 'Chandrakona', pincode: '721201' },
  { value: 'garbeta', label: 'Garbeta', pincode: '721127' },
  { value: 'ghatsila', label: 'Ghatsila', pincode: '721212' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '721227' },
  { value: 'jhargram', label: 'Jhargram', pincode: '721507' },
  { value: 'keshpur', label: 'Keshpur', pincode: '721150' },
  { value: 'khirpai', label: 'Khirpai', pincode: '721149' },
  { value: 'khulna', label: 'Khulna', pincode: '721228' },
  { value: 'midnapore', label: 'Midnapore', pincode: '721101' },
  { value: 'mourigram', label: 'Mourigram', pincode: '721303' },
  { value: 'sainthia', label: 'Sainthia', pincode: '721602' },
  { value: 'salboni', label: 'Salboni', pincode: '721104' },
  { value: 'sonamukhi', label: 'Sonamukhi', pincode: '721101' },
  { value: 'sonarpur', label: 'Sonarpur', pincode: '721213' },
  { value: 'tamluk', label: 'Tamluk', pincode: '721636' },
  { value: 'kamdebpur', label: 'Kamdebpur', pincode: '721253' },
  { value: 'kolar', label: 'Kolar', pincode: '721137' },
  { value: 'kotshila', label: 'Kotshila', pincode: '721232' },
  { value: 'mahabharat', label: 'Mahabharat', pincode: '721302' },
  { value: 'midhighar', label: 'Midhighar', pincode: '721236' },
  { value: 'saldah', label: 'Saldah', pincode: '721305' }
  ],
  
  'nabadwip': [
  { value: 'adampur', label: 'Adampur', pincode: '741223' },
  { value: 'banshbaria', label: 'Banshbaria', pincode: '741227' },
  { value: 'baragram', label: 'Baragram', pincode: '741305' },
  { value: 'bithari', label: 'Bithari', pincode: '741222' },
  { value: 'chhoto-beguni', label: 'Chhoto Beguni', pincode: '741252' },
  { value: 'daha', label: 'Daha', pincode: '741238' },
  { value: 'domkal', label: 'Domkal', pincode: '741226' },
  { value: 'goaldaha', label: 'Goaldaha', pincode: '741152' },
  { value: 'goragram', label: 'Goragram', pincode: '741228' },
  { value: 'kalinagar', label: 'Kalinagar', pincode: '741209' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '741313' },
  { value: 'madhusudanpur', label: 'Madhusudanpur', pincode: '741305' },
  { value: 'nabadwip', label: 'Nabadwip', pincode: '741302' },
  { value: 'palpara', label: 'Palpara', pincode: '741246' },
  { value: 'ramkrishnanagar', label: 'Ramkrishnanagar', pincode: '741203' },
  { value: 'santipur', label: 'Santipur', pincode: '741404' },
  { value: 'shibnagar', label: 'Shibnagar', pincode: '741311' },
  { value: 'sudharnagar', label: 'Sudharnagar', pincode: '741220' },
  { value: 'ukilpara', label: 'Ukilpara', pincode: '741308' },
  { value: 'uttarpur', label: 'Uttarpur', pincode: '741230' },
  { value: 'belpukur', label: 'Belpukur', pincode: '741234' },
  { value: 'chandpur', label: 'Chandpur', pincode: '741245' },
  { value: 'khagarpur', label: 'Khagarpur', pincode: '741247' },
  { value: 'madalpur', label: 'Madalpur', pincode: '741202' },
  { value: 'rajarampur', label: 'Rajarampur', pincode: '741241' },
  { value: 'sashipur', label: 'Sashipur', pincode: '741215' }
  ],
  
  'nadia': [
  { value: 'adampur', label: 'Adampur', pincode: '741223' },
  { value: 'banshbaria', label: 'Banshbaria', pincode: '741227' },
  { value: 'baragram', label: 'Baragram', pincode: '741305' },
  { value: 'bithari', label: 'Bithari', pincode: '741222' },
  { value: 'chandpur', label: 'Chandpur', pincode: '741245' },
  { value: 'chandmari', label: 'Chandmari', pincode: '741240' },
  { value: 'daha', label: 'Daha', pincode: '741238' },
  { value: 'domkal', label: 'Domkal', pincode: '741226' },
  { value: 'goaldaha', label: 'Goaldaha', pincode: '741152' },
  { value: 'goragram', label: 'Goragram', pincode: '741228' },
  { value: 'kalinagar', label: 'Kalinagar', pincode: '741209' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '741313' },
  { value: 'madalpur', label: 'Madalpur', pincode: '741202' },
  { value: 'majherhat', label: 'Majherhat', pincode: '741221' },
  { value: 'nabadwip', label: 'Nabadwip', pincode: '741302' },
  { value: 'palpara', label: 'Palpara', pincode: '741246' },
  { value: 'ramkrishnanagar', label: 'Ramkrishnanagar', pincode: '741203' },
  { value: 'santipur', label: 'Santipur', pincode: '741404' },
  { value: 'shibnagar', label: 'Shibnagar', pincode: '741311' },
  { value: 'sudharnagar', label: 'Sudharnagar', pincode: '741220' },
  { value: 'ukilpara', label: 'Ukilpara', pincode: '741308' },
  { value: 'uttarpur', label: 'Uttarpur', pincode: '741230' },
  { value: 'belpukur', label: 'Belpukur', pincode: '741234' },
  { value: 'khagarpur', label: 'Khagarpur', pincode: '741247' },
  { value: 'rajarampur', label: 'Rajarampur', pincode: '741241' },
  { value: 'sashipur', label: 'Sashipur', pincode: '741215' },
  { value: 'srirampur', label: 'Srirampur', pincode: '741242' },
  { value: 'tanribil', label: 'Tanribil', pincode: '741244' },
  { value: 'tapan', label: 'Tapan', pincode: '741226' },
  { value: 'balipur', label: 'Balipur', pincode: '741202' },
  { value: 'berhampore', label: 'Berhampore', pincode: '742101' },
  { value: 'khatanga', label: 'Khatanga', pincode: '741309' },
  { value: 'sundargram', label: 'Sundargram', pincode: '741243' },
  { value: 'bagda', label: 'Bagda', pincode: '741244' }
  ],
  
  'naihati': [
  { value: 'adambari', label: 'Adambari', pincode: '743123' },
  { value: 'baranagar', label: 'Baranagar', pincode: '743201' },
  { value: 'bargachia', label: 'Bargachia', pincode: '743166' },
  { value: 'bhadrakali', label: 'Bhadrakali', pincode: '743121' },
  { value: 'chakdah', label: 'Chakdah', pincode: '741222' },
  { value: 'chandannagar', label: 'Chandannagar', pincode: '712136' },
  { value: 'ghoshpara', label: 'Ghoshpara', pincode: '743165' },
  { value: 'jadabpur', label: 'Jadabpur', pincode: '743166' },
  { value: 'jangalpara', label: 'Jangalpara', pincode: '743153' },
  { value: 'jirat', label: 'Jirat', pincode: '743199' },
  { value: 'kamarkundu', label: 'Kamarkundu', pincode: '743129' },
  { value: 'kalyani', label: 'Kalyani', pincode: '741235' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '743144' },
  { value: 'naidunia', label: 'Naidunia', pincode: '743164' },
  { value: 'naihati', label: 'Naihati', pincode: '743165' },
  { value: 'sankrail', label: 'Sankrail', pincode: '743133' },
  { value: 'shibpur', label: 'Shibpur', pincode: '743179' },
  { value: 'sodepur', label: 'Sodepur', pincode: '743178' },
  { value: 'baidyabati', label: 'Baidyabati', pincode: '712222' },
  { value: 'bansberia', label: 'Bansberia', pincode: '712502' },
  { value: 'bibhuti-bhushan', label: 'Bibhuti Bhushan', pincode: '743161' },
  { value: 'kankinara', label: 'Kankinara', pincode: '743126' },
  { value: 'laskarpur', label: 'Laskarpur', pincode: '743135' },
  { value: 'madhusree', label: 'Madhusree', pincode: '743148' },
  { value: 'manmathnagar', label: 'Manmathnagar', pincode: '743136' },
  { value: 'rampur', label: 'Rampur', pincode: '743145' },
  { value: 'sonarpur', label: 'Sonarpur', pincode: '743166' }
  ],
  
  'panihati': [
  { value: 'adamni', label: 'Adamni', pincode: '743130' },
  { value: 'baligori', label: 'Baligori', pincode: '743168' },
  { value: 'baranagar', label: 'Baranagar', pincode: '743201' },
  { value: 'barrackpore', label: 'Barrackpore', pincode: '743101' },
  { value: 'bishnupur', label: 'Bishnupur', pincode: '743122' },
  { value: 'gopalpur', label: 'Gopalpur', pincode: '743123' },
  { value: 'ghoshpara', label: 'Ghoshpara', pincode: '743165' },
  { value: 'jagatdal', label: 'Jagatdal', pincode: '743125' },
  { value: 'kamarpara', label: 'Kamarpara', pincode: '743144' },
  { value: 'kamarkundu', label: 'Kamarkundu', pincode: '743129' },
  { value: 'kalyani', label: 'Kalyani', pincode: '741235' },
  { value: 'kankinara', label: 'Kankinara', pincode: '743126' },
  { value: 'panihati', label: 'Panihati', pincode: '743160' },
  { value: 'sankrail', label: 'Sankrail', pincode: '743133' },
  { value: 'shibpur', label: 'Shibpur', pincode: '743179' },
  { value: 'sodepur', label: 'Sodepur', pincode: '743178' },
  { value: 'southpanihati', label: 'South Panihati', pincode: '743137' },
  { value: 'tulsiberia', label: 'Tulsiberia', pincode: '743135' },
  { value: 'belghoria', label: 'Belghoria', pincode: '700056' },
  { value: 'bally', label: 'Bally', pincode: '711201' },
  { value: 'belgachia', label: 'Belgachia', pincode: '711203' },
  { value: 'bhiringi', label: 'Bhiringi', pincode: '743134' },
  { value: 'jagacha', label: 'Jagacha', pincode: '711112' },
  { value: 'kanailalchak', label: 'Kanailalchak', pincode: '743126' },
  { value: 'maniktala', label: 'Maniktala', pincode: '700054' },
  { value: 'madhyamgram', label: 'Madhyamgram', pincode: '700130' },
  { value: 'panihati-rs', label: 'Panihati RS', pincode: '743170' }
  ],
  
  'purba-bardhaman': [
  { value: 'ankuria', label: 'Ankuria', pincode: '713128' },
  { value: 'ashoknagar', label: 'Ashoknagar', pincode: '713205' },
  { value: 'bardhaman', label: 'Bardhaman', pincode: '713101' },
  { value: 'balarampur', label: 'Balarampur', pincode: '713202' },
  { value: 'bhatar', label: 'Bhatar', pincode: '713125' },
  { value: 'bonnagar', label: 'Bonnagar', pincode: '713146' },
  { value: 'burdwan', label: 'Burdwan', pincode: '713103' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '713212' },
  { value: 'durgapur', label: 'Durgapur', pincode: '713201' },
  { value: 'ghatakpukur', label: 'Ghatakpukur', pincode: '713154' },
  { value: 'hazra', label: 'Hazra', pincode: '713122' },
  { value: 'kundberia', label: 'Kundberia', pincode: '713135' },
  { value: 'matkatpur', label: 'Matkatpur', pincode: '713205' },
  { value: 'madhabdihi', label: 'Madhabdihi', pincode: '713103' },
  { value: 'memari', label: 'Memari', pincode: '713146' },
  { value: 'mogra', label: 'Mogra', pincode: '713141' },
  { value: 'rajgram', label: 'Rajgram', pincode: '713131' },
  { value: 'santiniketan', label: 'Santiniketan', pincode: '731235' },
  { value: 'shibpur', label: 'Shibpur', pincode: '713171' },
  { value: 'suri', label: 'Suri', pincode: '731101' },
  { value: 'tapan', label: 'Tapan', pincode: '713145' },
  { value: 'guskara', label: 'Guskara', pincode: '713128' },
  { value: 'jokapathar', label: 'Jokapathar', pincode: '713202' },
  { value: 'kalna', label: 'Kalna', pincode: '713409' },
  { value: 'khandra', label: 'Khandra', pincode: '713140' },
  { value: 'madhusudannagar', label: 'Madhusudannagar', pincode: '713147' },
  { value: 'nandgram', label: 'Nandgram', pincode: '713206' },
  { value: 'nandipur', label: 'Nandipur', pincode: '713101' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '713201' },
  { value: 'rajarhat', label: 'Rajarhat', pincode: '713129' },
  { value: 'tengra', label: 'Tengra', pincode: '713132' }
  ],
  
  'purulia': [
  { value: 'adhra', label: 'Adhra', pincode: '723151' },
  { value: 'alampur', label: 'Alampur', pincode: '723201' },
  { value: 'bandwan', label: 'Bandwan', pincode: '723129' },
  { value: 'barabazar', label: 'Barabazar', pincode: '723101' },
  { value: 'balarampur', label: 'Balarampur', pincode: '723143' },
  { value: 'balarampur-ii', label: 'Balarampur II', pincode: '723143' },
  { value: 'balrampur', label: 'Balrampur', pincode: '723152' },
  { value: 'belpahari', label: 'Belpahari', pincode: '723143' },
  { value: 'beral', label: 'Beral', pincode: '723101' },
  { value: 'berahampur', label: 'Berahampur', pincode: '723131' },
  { value: 'chandil', label: 'Chandil', pincode: '723144' },
  { value: 'daltonganj', label: 'Daltonganj', pincode: '823101' },
  { value: 'garhbeta', label: 'Garhbeta', pincode: '721127' },
  { value: 'kashipur', label: 'Kashipur', pincode: '723145' },
  { value: 'kudu', label: 'Kudu', pincode: '723201' },
  { value: 'kumirdaha', label: 'Kumirdaha', pincode: '723144' },
  { value: 'murarai', label: 'Murarai', pincode: '723158' },
  { value: 'parbhatpur', label: 'Parbhatpur', pincode: '723165' },
  { value: 'purulia', label: 'Purulia', pincode: '723101' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '723151' },
  { value: 'sarsabad', label: 'Sarsabad', pincode: '723144' },
  { value: 'tapan', label: 'Tapan', pincode: '723153' },
  { value: 'torabari', label: 'Torabari', pincode: '723102' },
  { value: 'amraipur', label: 'Amraipur', pincode: '723153' },
  { value: 'beliatore', label: 'Beliatore', pincode: '723156' },
  { value: 'bukti', label: 'Bukti', pincode: '723120' },
  { value: 'chitra', label: 'Chitra', pincode: '723212' },
  { value: 'gharmuri', label: 'Gharmuri', pincode: '723102' },
  { value: 'jalchak', label: 'Jalchak', pincode: '723157' },
  { value: 'manbazar', label: 'Manbazar', pincode: '723131' },
  { value: 'murarai-ii', label: 'Murarai II', pincode: '723154' },
  { value: 'padmapukur', label: 'Padmapukur', pincode: '723145' },
  { value: 'rasulpur', label: 'Rasulpur', pincode: '723121' },
  { value: 'sahebganj', label: 'Sahebganj', pincode: '723132' },
  { value: 'shibpur', label: 'Shibpur', pincode: '723161' }
  ],
  
  'raiganj': [
  { value: 'balarampur', label: 'Balarampur', pincode: '733134' },
  { value: 'bandu', label: 'Bandu', pincode: '733138' },
  { value: 'belgram', label: 'Belgram', pincode: '733125' },
  { value: 'bhatpara', label: 'Bhatpara', pincode: '733133' },
  { value: 'dharmatala', label: 'Dharmatala', pincode: '733101' },
  { value: 'duarsini', label: 'Duarsini', pincode: '733125' },
  { value: 'kaliganj', label: 'Kaliganj', pincode: '733129' },
  { value: 'mahespur', label: 'Mahespur', pincode: '733125' },
  { value: 'mangalkot', label: 'Mangalkot', pincode: '733146' },
  { value: 'raiganj', label: 'Raiganj', pincode: '733134' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '733132' },
  { value: 'sadarbari', label: 'Sadarbari', pincode: '733141' },
  { value: 'suryanagar', label: 'Suryanagar', pincode: '733141' },
  { value: 'tapan', label: 'Tapan', pincode: '733133' },
  { value: 'tangon', label: 'Tangon', pincode: '733137' },
  { value: 'barapukuria', label: 'Barapukuria', pincode: '733115' },
  { value: 'bahula', label: 'Bahula', pincode: '733120' },
  { value: 'chakla', label: 'Chakla', pincode: '733147' },
  { value: 'godhanpur', label: 'Godhanpur', pincode: '733111' },
  { value: 'kola', label: 'Kola', pincode: '733121' },
  { value: 'madhusudannagar', label: 'Madhusudannagar', pincode: '733130' },
  { value: 'malancha', label: 'Malancha', pincode: '733112' },
  { value: 'nandigram', label: 'Nandigram', pincode: '733118' },
  { value: 'rajgram', label: 'Rajgram', pincode: '733113' },
  { value: 'sarakpur', label: 'Sarakpur', pincode: '733116' },
  { value: 'shibpur', label: 'Shibpur', pincode: '733119' }
  ],
  
  'ranaghat': [
  { value: 'barui', label: 'Barui', pincode: '741201' },
  { value: 'beharampur', label: 'Beharampur', pincode: '741220' },
  { value: 'benipur', label: 'Benipur', pincode: '741252' },
  { value: 'chakdaha', label: 'Chakdaha', pincode: '741222' },
  { value: 'debagram', label: 'Debagram', pincode: '741301' },
  { value: 'gangapur', label: 'Gangapur', pincode: '741235' },
  { value: 'kalabaria', label: 'Kalabaria', pincode: '741139' },
  { value: 'kamrabad', label: 'Kamrabad', pincode: '741201' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '741101' },
  { value: 'nadia', label: 'Nadia', pincode: '741105' },
  { value: 'ranaghat', label: 'Ranaghat', pincode: '741201' },
  { value: 'shibpur', label: 'Shibpur', pincode: '741122' },
  { value: 'sonadanga', label: 'Sonadanga', pincode: '741127' },
  { value: 'srinagar', label: 'Srinagar', pincode: '741242' },
  { value: 'tangra', label: 'Tangra', pincode: '741136' },
  { value: 'balia', label: 'Balia', pincode: '741244' },
  { value: 'barasat', label: 'Barasat', pincode: '741222' },
  { value: 'benoykrishna', label: 'Benoykrishna', pincode: '741155' },
  { value: 'chandpara', label: 'Chandpara', pincode: '741235' },
  { value: 'falta', label: 'Falta', pincode: '741229' },
  { value: 'gopalnagar', label: 'Gopalnagar', pincode: '741244' },
  { value: 'harishpur', label: 'Harishpur', pincode: '741220' },
  { value: 'haringhata', label: 'Haringhata', pincode: '741251' },
  { value: 'khordaha', label: 'Khordaha', pincode: '741124' },
  { value: 'malancha', label: 'Malancha', pincode: '741230' },
  { value: 'mogra', label: 'Mogra', pincode: '741132' },
  { value: 'shyamnagar', label: 'Shyamnagar', pincode: '741222' },
  { value: 'sindurpur', label: 'Sindurpur', pincode: '741233' },
  { value: 'sirajdighi', label: 'Sirajdighi', pincode: '741235' }
  ],
  
  'santipur': [
  { value: 'baligaon', label: 'Baligaon', pincode: '741404' },
  { value: 'baragram', label: 'Baragram', pincode: '741404' },
  { value: 'banagram', label: 'Banagram', pincode: '741404' },
  { value: 'bhogpur', label: 'Bhogpur', pincode: '741404' },
  { value: 'chakdaha', label: 'Chakdaha', pincode: '741222' },
  { value: 'dakshinpara', label: 'Dakshinpara', pincode: '741404' },
  { value: 'gobindapur', label: 'Gobindapur', pincode: '741402' },
  { value: 'haripur', label: 'Haripur', pincode: '741406' },
  { value: 'jagatpur', label: 'Jagatpur', pincode: '741404' },
  { value: 'kamarkundu', label: 'Kamarkundu', pincode: '741402' },
  { value: 'manmatha', label: 'Manmatha', pincode: '741407' },
  { value: 'mohanpur', label: 'Mohanpur', pincode: '741406' },
  { value: 'nadia', label: 'Nadia', pincode: '741125' },
  { value: 'panchgram', label: 'Panchgram', pincode: '741401' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '741403' },
  { value: 'santipur', label: 'Santipur', pincode: '741404' },
  { value: 'shibpur', label: 'Shibpur', pincode: '741406' },
  { value: 'sonadanga', label: 'Sonadanga', pincode: '741407' },
  { value: 'srinagar', label: 'Srinagar', pincode: '741404' },
  { value: 'tangramara', label: 'Tangramara', pincode: '741402' },
  { value: 'uluberia', label: 'Uluberia', pincode: '741221' },
  { value: 'panchanandapur', label: 'Panchanandapur', pincode: '741407' },
  { value: 'rajgram', label: 'Rajgram', pincode: '741405' }
  ],
  
  'serampore': [
  { value: 'abhaynagar', label: 'Abhaynagar', pincode: '712201' },
  { value: 'baganpara', label: 'Baganpara', pincode: '712202' },
  { value: 'balidanga', label: 'Balidanga', pincode: '712201' },
  { value: 'bantul', label: 'Bantul', pincode: '712203' },
  { value: 'gachhpara', label: 'Gachhpara', pincode: '712205' },
  { value: 'gobindapur', label: 'Gobindapur', pincode: '712207' },
  { value: 'jhulan', label: 'Jhulan', pincode: '712204' },
  { value: 'katwa', label: 'Katwa', pincode: '712201' },
  { value: 'manickpara', label: 'Manickpara', pincode: '712202' },
  { value: 'mollarpur', label: 'Mollarpur', pincode: '712203' },
  { value: 'muragachha', label: 'Muragachha', pincode: '712204' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '712206' },
  { value: 'serampore', label: 'Serampore', pincode: '712201' },
  { value: 'sundarban', label: 'Sundarban', pincode: '712202' },
  { value: 'tolaram', label: 'Tolaram', pincode: '712207' },
  { value: 'rajendranagar', label: 'Rajendranagar', pincode: '712208' },
  { value: 'ahiritola', label: 'Ahiritola', pincode: '712212' },
  { value: 'banakhal', label: 'Banakhal', pincode: '712209' },
  { value: 'bandipur', label: 'Bandipur', pincode: '712210' },
  { value: 'barui', label: 'Barui', pincode: '712210' },
  { value: 'belari', label: 'Belari', pincode: '712212' },
  { value: 'chanditala', label: 'Chanditala', pincode: '712224' },
  { value: 'chakdabari', label: 'Chakdabari', pincode: '712230' },
  { value: 'debdanga', label: 'Debdanga', pincode: '712220' },
  { value: 'jagadhari', label: 'Jagadhari', pincode: '712211' },
  { value: 'kachari', label: 'Kachari', pincode: '712223' },
  { value: 'muragachha', label: 'Muragachha', pincode: '712204' },
  { value: 'sonarpur', label: 'Sonarpur', pincode: '712209' }
  ],
  
  'titagarh': [
  { value: 'amraipur', label: 'Amraipur', pincode: '743130' },
  { value: 'belgharia', label: 'Belgharia', pincode: '743202' },
  { value: 'ganganagar', label: 'Ganganagar', pincode: '743144' },
  { value: 'kaikhali', label: 'Kaikhali', pincode: '743127' },
  { value: 'kamarkundu', label: 'Kamarkundu', pincode: '743130' },
  { value: 'kolaripara', label: 'Kolaripara', pincode: '743128' },
  { value: 'kachrapara', label: 'Kachrapara', pincode: '743148' },
  { value: 'madhyamgram', label: 'Madhyamgram', pincode: '743261' },
  { value: 'naoda', label: 'Naoda', pincode: '743130' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '743124' },
  { value: 'titagarh', label: 'Titagarh', pincode: '743130' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '743126' },
  { value: 'sodepur', label: 'Sodepur', pincode: '743178' },
  { value: 'srirampur', label: 'Srirampur', pincode: '743201' },
  { value: 'taltala', label: 'Taltala', pincode: '743134' },
  { value: 'taraknagar', label: 'Taraknagar', pincode: '743133' },
  { value: 'dabgram', label: 'Dabgram', pincode: '743135' },
  { value: 'chandrapara', label: 'Chandrapara', pincode: '743131' },
  { value: 'gopalnagar', label: 'Gopalnagar', pincode: '743138' },
  { value: 'hospitals', label: 'Hospitals', pincode: '743120' },
  { value: 'khanakul', label: 'Khanakul', pincode: '743137' },
  { value: 'lalkuthi', label: 'Lalkuthi', pincode: '743132' },
  { value: 'malancha', label: 'Malancha', pincode: '743136' },
  { value: 'madhusree', label: 'Madhusree', pincode: '743129' },
  { value: 'panagarh', label: 'Panagarh', pincode: '743122' },
  { value: 'pradhannagar', label: 'Pradhannagar', pincode: '743141' },
  { value: 'rampurhat', label: 'Rampurhat', pincode: '743142' }
  ],
  
  'uluberia': [
  { value: 'alambazar', label: 'Alambazar', pincode: '711315' },
  { value: 'bansberia', label: 'Bansberia', pincode: '712502' },
  { value: 'barijhati', label: 'Barijhati', pincode: '711314' },
  { value: 'biringi', label: 'Biringi', pincode: '711318' },
  { value: 'birlapur', label: 'Birlapur', pincode: '711307' },
  { value: 'uluberia', label: 'Uluberia', pincode: '711315' },
  { value: 'gachha', label: 'Gachha', pincode: '711310' },
  { value: 'kaikhali', label: 'Kaikhali', pincode: '711306' },
  { value: 'kamarhati', label: 'Kamarhati', pincode: '711314' },
  { value: 'kamarpukur', label: 'Kamarpukur', pincode: '711304' },
  { value: 'kolarbari', label: 'Kolarbari', pincode: '711316' },
  { value: 'kundal', label: 'Kundal', pincode: '711317' },
  { value: 'madhusree', label: 'Madhusree', pincode: '711319' },
  { value: 'manmatha', label: 'Manmatha', pincode: '711311' },
  { value: 'panchkura', label: 'Panchkura', pincode: '711312' },
  { value: 'ramchandrapur', label: 'Ramchandrapur', pincode: '711303' },
  { value: 'sonakhali', label: 'Sonakhali', pincode: '711313' },
  { value: 'barachak', label: 'Barachak', pincode: '711320' },
  { value: 'bekra', label: 'Bekra', pincode: '711321' },
  { value: 'damodarpur', label: 'Damodarpur', pincode: '711322' },
  { value: 'gokulpur', label: 'Gokulpur', pincode: '711323' },
  { value: 'harishpur', label: 'Harishpur', pincode: '711324' },
  { value: 'jambunia', label: 'Jambunia', pincode: '711325' },
  { value: 'jotgobindapur', label: 'Jot Gobindapur', pincode: '711326' },
  { value: 'mogra', label: 'Mogra', pincode: '711327' },
  { value: 'nabadwip', label: 'Nabadwip', pincode: '711328' },
  { value: 'patuli', label: 'Patuli', pincode: '711329' },
  { value: 'rampur', label: 'Rampur', pincode: '711330' },
  { value: 'sonapara', label: 'Sonapara', pincode: '711331' },
  { value: 'tangra', label: 'Tangra', pincode: '711332' }
  ],
  
  'uttarpara': [
  { value: 'bally', label: 'Bally', pincode: '711201' },
  { value: 'bansberia', label: 'Bansberia', pincode: '712502' },
  { value: 'basudebpur', label: 'Basudebpur', pincode: '711107' },
  { value: 'chandannagar', label: 'Chandannagar', pincode: '712136' },
  { value: 'halsi', label: 'Halsi', pincode: '711107' },
  { value: 'hasnabad', label: 'Hasnabad', pincode: '743233' },
  { value: 'kolar', label: 'Kolar', pincode: '711105' },
  { value: 'naldanga', label: 'Naldanga', pincode: '711102' },
  { value: 'saptapar', label: 'Saptapar', pincode: '711122' },
  { value: 'sodepur', label: 'Sodepur', pincode: '743178' },
  { value: 'srirampur', label: 'Srirampur', pincode: '712201' },
  { value: 'uttarpara', label: 'Uttarpara', pincode: '712258' },
  { value: 'maheshtala', label: 'Maheshtala', pincode: '700141' },
  { value: 'kadambagachi', label: 'Kadambagachi', pincode: '711105' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '741101' },
  { value: 'ghatkopar', label: 'Ghatkopar', pincode: '711106' },
  { value: 'dankuni', label: 'Dankuni', pincode: '712311' },
  { value: 'belur', label: 'Belur', pincode: '711202' },
  { value: 'ghoramara', label: 'Ghoramara', pincode: '711204' },
  { value: 'ishwarpur', label: 'Ishwarpur', pincode: '711203' },
  { value: 'sonarpur', label: 'Sonarpur', pincode: '743222' },
  { value: 'baroj', label: 'Baroj', pincode: '711101' },
  { value: 'panchla', label: 'Panchla', pincode: '711306' },
  { value: 'kamarkundu', label: 'Kamarkundu', pincode: '711107' },
  { value: 'durgapur', label: 'Durgapur', pincode: '711299' },
  { value: 'rajarhat', label: 'Rajarhat', pincode: '700135' }
  ],
  
  'alipurduar': [
  { value: 'alipurduar', label: 'Alipurduar', pincode: '736121' },
  { value: 'dalgaon', label: 'Dalgaon', pincode: '736122' },
  { value: 'dhulabari', label: 'Dhulabari', pincode: '736123' },
  { value: 'jateshwar', label: 'Jateshwar', pincode: '736124' },
  { value: 'kumargram', label: 'Kumargram', pincode: '736125' },
  { value: 'madarihat', label: 'Madarihat', pincode: '736126' },
  { value: 'mangalbari', label: 'Mangalbari', pincode: '736127' },
  { value: 'mathabhanga', label: 'Mathabhanga', pincode: '736128' },
  { value: 'nagrakata', label: 'Nagrakata', pincode: '736129' },
  { value: 'falakata', label: 'Falakata', pincode: '736130' },
  { value: 'samsing', label: 'Samsing', pincode: '736131' },
  { value: 'siliguri', label: 'Siliguri', pincode: '734001' },
  { value: 'bashbari', label: 'Bashbari', pincode: '736132' },
  { value: 'bhatpara', label: 'Bhatpara', pincode: '736133' },
  { value: 'chhitma', label: 'Chhitma', pincode: '736134' },
  { value: 'dhipjhora', label: 'Dhipjhora', pincode: '736135' },
  { value: 'gajol', label: 'Gajol', pincode: '736136' },
  { value: 'jholong', label: 'Jholong', pincode: '736137' },
  { value: 'kochubari', label: 'Kochubari', pincode: '736138' },
  { value: 'lataguri', label: 'Lataguri', pincode: '736139' },
  { value: 'madhupur', label: 'Madhupur', pincode: '736140' },
  { value: 'rangdhamali', label: 'Rangdhamali', pincode: '736141' }
  ],
  
  'baidyabati': [
  { value: 'abhirampur', label: 'Abhirampur', pincode: '712222' },
  { value: 'balarampur', label: 'Balarampur', pincode: '712222' },
  { value: 'baidyabati', label: 'Baidyabati', pincode: '712222' },
  { value: 'balidha', label: 'Balidha', pincode: '712223' },
  { value: 'bikrampur', label: 'Bikrampur', pincode: '712221' },
  { value: 'chakdaha', label: 'Chakdaha', pincode: '712226' },
  { value: 'damodarpur', label: 'Damodarpur', pincode: '712227' },
  { value: 'gopalnagar', label: 'Gopalnagar', pincode: '712224' },
  { value: 'jatrapur', label: 'Jatrapur', pincode: '712225' },
  { value: 'madhusree', label: 'Madhusree', pincode: '712228' },
  { value: 'new-baidyabati', label: 'New Baidyabati', pincode: '712229' },
  { value: 'raipur', label: 'Raipur', pincode: '712230' },
  { value: 'bandhanpada', label: 'Bandhanpada', pincode: '712231' },
  { value: 'bara-pur', label: 'Bara Pur', pincode: '712232' },
  { value: 'bhattarhati', label: 'Bhattarhati', pincode: '712233' },
  { value: 'dharmapur', label: 'Dharmapur', pincode: '712234' },
  { value: 'harinavi', label: 'Harinavi', pincode: '712235' },
  { value: 'jhitki', label: 'Jhitki', pincode: '712236' },
  { value: 'kaliabari', label: 'Kaliabari', pincode: '712237' },
  { value: 'maniknagar', label: 'Maniknagar', pincode: '712238' },
  { value: 'nagarberia', label: 'Nagarberia', pincode: '712239' },
  { value: 'rajanagar', label: 'Rajanagar', pincode: '712240' }
  ],
  
  'suri': [
  { value: 'suri', label: 'Suri', pincode: '731101' },
  { value: 'alampur', label: 'Alampur', pincode: '731102' },
  { value: 'andul', label: 'Andul', pincode: '731103' },
  { value: 'bansdroni', label: 'Bansdroni', pincode: '731104' },
  { value: 'barabagan', label: 'Barabagan', pincode: '731105' },
  { value: 'barodighi', label: 'Barodighi', pincode: '731106' },
  { value: 'birsingha', label: 'Birsingha', pincode: '731107' },
  { value: 'daspur', label: 'Daspur', pincode: '731108' },
  { value: 'gopalmath', label: 'Gopalmath', pincode: '731109' },
  { value: 'kotaldanga', label: 'Kotaldanga', pincode: '731110' },
  { value: 'murarai', label: 'Murarai', pincode: '731111' },
  { value: 'panagarh', label: 'Panagarh', pincode: '731112' },
  { value: 'purba-basirhat', label: 'Purba Basirhat', pincode: '731113' },
  { value: 'rajgram', label: 'Rajgram', pincode: '731114' },
  { value: 'sankrail', label: 'Sankrail', pincode: '731115' },
  { value: 'shibpur', label: 'Shibpur', pincode: '731116' },
  { value: 'uluberia', label: 'Uluberia', pincode: '731117' },
  { value: 'bengalipur', label: 'Bengalipur', pincode: '731118' },
  { value: 'bhatar', label: 'Bhatar', pincode: '731119' },
  { value: 'kolarpada', label: 'Kolarpada', pincode: '731120' },
  { value: 'kundagram', label: 'Kundagram', pincode: '731121' },
  { value: 'madhusree', label: 'Madhusree', pincode: '731122' },
  { value: 'rajarhat', label: 'Rajarhat', pincode: '731123' },
  { value: 'saharpur', label: 'Saharpur', pincode: '731124' },
  { value: 'suri-town', label: 'Suri Town', pincode: '731125' },
  { value: 'taldangra', label: 'Taldangra', pincode: '731126' },
  { value: 'tota', label: 'Tota', pincode: '731127' }
  ],
  
  'dubrajpur': [
  { value: 'dubrajpur', label: 'Dubrajpur', pincode: '731123' },
  { value: 'amraipur', label: 'Amraipur', pincode: '731124' },
  { value: 'balarampur', label: 'Balarampur', pincode: '731125' },
  { value: 'bhuli', label: 'Bhuli', pincode: '731126' },
  { value: 'chandpur', label: 'Chandpur', pincode: '731127' },
  { value: 'dhandabari', label: 'Dhandabari', pincode: '731128' },
  { value: 'garh', label: 'Garh', pincode: '731129' },
  { value: 'kamardaha', label: 'Kamardaha', pincode: '731130' },
  { value: 'madhusree', label: 'Madhusree', pincode: '731131' },
  { value: 'patuli', label: 'Patuli', pincode: '731132' },
  { value: 'sijua', label: 'Sijua', pincode: '731133' },
  { value: 'sushilpur', label: 'Sushilpur', pincode: '731134' },
  { value: 'ujjaini', label: 'Ujjaini', pincode: '731135' },
  { value: 'belpahari', label: 'Belpahari', pincode: '731136' },
  { value: 'bikramganj', label: 'Bikramganj', pincode: '731137' },
  { value: 'dakshindihi', label: 'Dakshindihi', pincode: '731138' },
  { value: 'garhbhanga', label: 'Garhbhanga', pincode: '731139' },
  { value: 'kaliapathar', label: 'Kaliapathar', pincode: '731140' },
  { value: 'manpur', label: 'Manpur', pincode: '731141' },
  { value: 'mathurapur', label: 'Mathurapur', pincode: '731142' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '731143' },
  { value: 'sankarpur', label: 'Sankarpur', pincode: '731144' },
  { value: 'sonaripur', label: 'Sonaripur', pincode: '731145' },
  { value: 'tulungia', label: 'Tulungia', pincode: '731146' }
  ],
  
  'hooghly': [
  { value: 'hooghly', label: 'Hooghly', pincode: '712101' },
  { value: 'arpur', label: 'Arpur', pincode: '712102' },
  { value: 'bansberia', label: 'Bansberia', pincode: '712103' },
  { value: 'chanditala', label: 'Chanditala', pincode: '712104' },
  { value: 'chinsurah', label: 'Chinsurah', pincode: '712101' },
  { value: 'haribasant', label: 'Haribasant', pincode: '712105' },
  { value: 'jirat', label: 'Jirat', pincode: '712106' },
  { value: 'kancharapara', label: 'Kancharapara', pincode: '712107' },
  { value: 'khanakul', label: 'Khanakul', pincode: '712108' },
  { value: 'magra', label: 'Magra', pincode: '712109' },
  { value: 'polba', label: 'Polba', pincode: '712110' },
  { value: 'santipur', label: 'Santipur', pincode: '712111' },
  { value: 'serampore', label: 'Serampore', pincode: '712201' },
  { value: 'shibpur', label: 'Shibpur', pincode: '712202' },
  { value: 'tarakeswar', label: 'Tarakeswar', pincode: '712410' },
  { value: 'taldangra', label: 'Taldangra', pincode: '712411' },
  { value: 'uluberia', label: 'Uluberia', pincode: '711315' },
  { value: 'balagarh', label: 'Balagarh', pincode: '712502' },
  { value: 'belmuri', label: 'Belmuri', pincode: '712504' },
  { value: 'chandannagar', label: 'Chandannagar', pincode: '712136' },
  { value: 'dundal', label: 'Dundal', pincode: '712513' },
  { value: 'ghoramora', label: 'Ghoramora', pincode: '712514' },
  { value: 'haripal', label: 'Haripal', pincode: '712403' },
  { value: 'kanrra', label: 'Kanrra', pincode: '712518' },
  { value: 'mogra', label: 'Mogra', pincode: '712503' },
  { value: 'sankrail', label: 'Sankrail', pincode: '712231' },
  { value: 'shyamnagar', label: 'Shyamnagar', pincode: '712220' },
  { value: 'srirampur', label: 'Srirampur', pincode: '712204' },
  { value: 'tamluk', label: 'Tamluk', pincode: '721636' },
  { value: 'taki', label: 'Taki', pincode: '743429' }
  ],
  
  'dum-dum': [
  { value: 'dum-dum', label: 'Dum Dum', pincode: '700028' },
  { value: 'baranagar', label: 'Baranagar', pincode: '700036' },
  { value: 'belghoria', label: 'Belghoria', pincode: '700056' },
  { value: 'barrackpore', label: 'Barrackpore', pincode: '700120' },
  { value: 'chiriamore', label: 'Chiriamore', pincode: '700035' },
  { value: 'ghoshpara', label: 'Ghoshpara', pincode: '700065' },
  { value: 'ghughu', label: 'Ghughu', pincode: '700058' },
  { value: 'kaikhali', label: 'Kaikhali', pincode: '700052' },
  { value: 'kamarhati', label: 'Kamarhati', pincode: '700058' },
  { value: 'kudghat', label: 'Kudghat', pincode: '700052' },
  { value: 'mahishbathan', label: 'Mahishbathan', pincode: '700059' },
  { value: 'manicktala', label: 'Manicktala', pincode: '700054' },
  { value: 'sodepur', label: 'Sodepur', pincode: '700110' },
  { value: 'south-dum-dum', label: 'South Dum Dum', pincode: '700074' },
  { value: 'subhaspally', label: 'Subhaspally', pincode: '700061' },
  { value: 'ashoknagar', label: 'Ashoknagar', pincode: '700110' },
  { value: 'belghoria-bazar', label: 'Belghoria Bazar', pincode: '700056' },
  { value: 'cossipore', label: 'Cossipore', pincode: '700002' },
  { value: 'dumdum-cantonment', label: 'Dum Dum Cantonment', pincode: '700065' },
  { value: 'laketown', label: 'Laketown', pincode: '700089' },
  { value: 'north-dum-dum', label: 'North Dum Dum', pincode: '700074' },
  { value: 'patuli', label: 'Patuli', pincode: '700027' },
  { value: 'prince-anjali', label: 'Prince Anjali', pincode: '700072' },
  { value: 'siliguri', label: 'Siliguri', pincode: '700031' },
  { value: 'sreebhumi', label: 'Sreebhumi', pincode: '700048' }
  ],
  
  'maheshtala': [
  { value: 'maheshtala', label: 'Maheshtala', pincode: '700141' },
  { value: 'bansdroni', label: 'Bansdroni', pincode: '700070' },
  { value: 'bhawanipur', label: 'Bhawanipur', pincode: '700027' },
  { value: 'chanditala', label: 'Chanditala', pincode: '700152' },
  { value: 'dabgram', label: 'Dabgram', pincode: '700146' },
  { value: 'ghatakpukur', label: 'Ghatakpukur', pincode: '700153' },
  { value: 'khidderpore', label: 'Khidderpore', pincode: '700023' },
  { value: 'kolar', label: 'Kolar', pincode: '700071' },
  { value: 'kurmital', label: 'Kurmital', pincode: '700136' },
  { value: 'lalkuthi', label: 'Lalkuthi', pincode: '700054' },
  { value: 'sudhirpally', label: 'Sudhirpally', pincode: '700143' },
  { value: 'talpukur', label: 'Talpukur', pincode: '700145' },
  { value: 'thakurpukur', label: 'Thakurpukur', pincode: '700063' },
  { value: 'tollygunge', label: 'Tollygunge', pincode: '700033' },
  { value: 'ward-no-1', label: 'Ward No 1', pincode: '700115' },
  { value: 'ward-no-2', label: 'Ward No 2', pincode: '700116' },
  { value: 'garia', label: 'Garia', pincode: '700084' },
  { value: 'kolkata-outer', label: 'Kolkata Outer', pincode: '700106' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '700113' },
  { value: 'palpara', label: 'Palpara', pincode: '700144' },
  { value: 'rajpur', label: 'Rajpur', pincode: '700149' },
  { value: 'sreebhumi', label: 'Sreebhumi', pincode: '700049' }
  ],
  
  'jhargram': [
  { value: 'jhargram', label: 'Jhargram', pincode: '721507' },
  { value: 'barra', label: 'Barra', pincode: '721301' },
  { value: 'beliatore', label: 'Beliatore', pincode: '721121' },
  { value: 'binpur', label: 'Binpur', pincode: '721126' },
  { value: 'deuli', label: 'Deuli', pincode: '721514' },
  { value: 'ghera', label: 'Ghera', pincode: '721506' },
  { value: 'gopiballavpur', label: 'Gopiballavpur', pincode: '721232' },
  { value: 'howrah', label: 'Howrah', pincode: '711102' },
  { value: 'jalchak', label: 'Jalchak', pincode: '721121' },
  { value: 'kamarpukur', label: 'Kamarpukur', pincode: '721507' },
  { value: 'kashijora', label: 'Kashijora', pincode: '721517' },
  { value: 'kenda', label: 'Kenda', pincode: '721132' },
  { value: 'kharikamathani', label: 'Kharikamathani', pincode: '721507' },
  { value: 'kumirdaha', label: 'Kumirdaha', pincode: '721521' },
  { value: 'lalgarh', label: 'Lalgarh', pincode: '721507' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '721132' },
  { value: 'raijora', label: 'Raijora', pincode: '721102' },
  { value: 'sarsabad', label: 'Sarsabad', pincode: '721128' },
  { value: 'silda', label: 'Silda', pincode: '721146' },
  { value: 'sundargram', label: 'Sundargram', pincode: '721127' },
  { value: 'bagdah', label: 'Bagdah', pincode: '721137' },
  { value: 'betai', label: 'Betai', pincode: '721133' },
  { value: 'dalilpur', label: 'Dalilpur', pincode: '721135' },
  { value: 'jamunatola', label: 'Jamunatola', pincode: '721139' },
  { value: 'narul', label: 'Narul', pincode: '721504' },
  { value: 'rampur', label: 'Rampur', pincode: '721509' }
  ],
  
  'kalimpong': [
  { value: 'kalimpong', label: 'Kalimpong', pincode: '734301' },
  { value: 'alubari', label: 'Alubari', pincode: '734301' },
  { value: 'dara', label: 'Dara', pincode: '734301' },
  { value: 'dhotrey', label: 'Dhotrey', pincode: '734319' },
  { value: 'gorubathan', label: 'Gorubathan', pincode: '734318' },
  { value: 'jorebungalow', label: 'Jorebungalow', pincode: '734101' },
  { value: 'kenjock', label: 'Kenjock', pincode: '734314' },
  { value: 'lindsey', label: 'Lindsey', pincode: '734312' },
  { value: 'munsong', label: 'Munsong', pincode: '734312' },
  { value: 'pedong', label: 'Pedong', pincode: '734322' },
  { value: 'rangli', label: 'Rangli', pincode: '734309' },
  { value: 'siddheshwar', label: 'Siddheshwar', pincode: '734302' },
  { value: 'sukhiapokhri', label: 'Sukhiapokhri', pincode: '734315' },
  { value: 'tinchuley', label: 'Tinchuley', pincode: '734302' },
  { value: 'pangchen', label: 'Pangchen', pincode: '734324' },
  { value: 'chinchula', label: 'Chinchula', pincode: '734326' },
  { value: 'ramitay', label: 'Ramitay', pincode: '734327' },
  { value: 'soreng', label: 'Soreng', pincode: '734329' },
  { value: 'chota-mangwa', label: 'Chota Mangwa', pincode: '734320' }
  ],

  'asansol': [
    { value: 'adityapur', label: 'Adityapur', pincode: '713301' },
    { value: 'amarmahal', label: 'Amarmahal', pincode: '713302' },
    { value: 'andal', label: 'Andal', pincode: '713321' },
    { value: 'ashoknagar', label: 'Ashoknagar', pincode: '713303' },
    { value: 'baraboni', label: 'Baraboni', pincode: '713325' },
    { value: 'bhatbandh', label: 'Bhatbandh', pincode: '713335' },
    { value: 'bhitaran', label: 'Bhitaran', pincode: '713305' },
    { value: 'chhatabad', label: 'Chhatabad', pincode: '713330' },
    { value: 'chakulia', label: 'Chakulia', pincode: '713314' },
    { value: 'chandrapur', label: 'Chandrapur', pincode: '713356' },
    { value: 'chini', label: 'Chini', pincode: '713302' },
    { value: 'dumka', label: 'Dumka', pincode: '713322' },
    { value: 'giridih', label: 'Giridih', pincode: '713312' },
    { value: 'jamtara', label: 'Jamtara', pincode: '713214' },
    { value: 'kalyanpur', label: 'Kalyanpur', pincode: '713304' },
    { value: 'kenduadih', label: 'Kenduadih', pincode: '713318' },
    { value: 'kulti', label: 'Kulti', pincode: '713343' },
    { value: 'madhusudannagar', label: 'Madhusudannagar', pincode: '713312' },
    { value: 'maithon', label: 'Maithon', pincode: '713205' },
    { value: 'manoharpur', label: 'Manoharpur', pincode: '713318' },
    { value: 'nada', label: 'Nada', pincode: '713335' },
    { value: 'nuna', label: 'Nuna', pincode: '713303' },
    { value: 'palashdanga', label: 'Palashdanga', pincode: '713303' },
    { value: 'raniganj', label: 'Raniganj', pincode: '713347' },
    { value: 'sapgram', label: 'Sapgram', pincode: '713351' },
    { value: 'satgram', label: 'Satgram', pincode: '713305' },
    { value: 'sitarampur', label: 'Sitarampur', pincode: '713336' },
    { value: 'sudamdih', label: 'Sudamdih', pincode: '713325' },
    { value: 'sonartari', label: 'Sonartari', pincode: '713303' },
    { value: 'sundarpur', label: 'Sundarpur', pincode: '713302' },
    { value: 'bahula', label: 'Bahula', pincode: '713314' },
    { value: 'bankura', label: 'Bankura', pincode: '713334' },
    { value: 'bansdih', label: 'Bansdih', pincode: '713302' },
    { value: 'bansbaria', label: 'Bansbaria', pincode: '713302' },
    { value: 'biharinath', label: 'Biharinath', pincode: '713311' },
    { value: 'dumka town', label: 'Dumka Town', pincode: '713311' },
    { value: 'kenduadih', label: 'Kenduadih', pincode: '713318' },
    { value: 'sudamdih village', label: 'Sudamdih Village', pincode: '713317' },
    { value: 'maithon town', label: 'Maithon Town', pincode: '713205' },
    { value: 'baranjora', label: 'Baranjora', pincode: '713332' }
  ],

  'durgapur': [
    { value: 'a-zone', label: 'A-Zone', pincode: '713204' },
    { value: 'b-zone', label: 'B-Zone', pincode: '713205' },
    { value: 'c-zone', label: 'C-Zone', pincode: '713206' },
    { value: 'd-zone', label: 'D-Zone', pincode: '713207' },
    { value: 'e-zone', label: 'E-Zone', pincode: '713208' },
    { value: 'f-zone', label: 'F-Zone', pincode: '713209' },
    { value: 'g-t-market', label: 'G.T. Market', pincode: '713201' },
    { value: 'kamla-bag', label: 'Kamla Bag', pincode: '713202' },
    { value: 'kumardaha', label: 'Kumardaha', pincode: '713213' },
    { value: 'mayapur', label: 'Mayapur', pincode: '713216' },
    { value: 'new-town', label: 'New Town', pincode: '713212' },
    { value: 'old-durgapur', label: 'Old Durgapur', pincode: '713201' },
    { value: 'raigarh', label: 'Raigarh', pincode: '713205' },
    { value: 'rajbandh', label: 'Rajbandh', pincode: '713232' },
    { value: 'sonapur', label: 'Sonapur', pincode: '713219' },
    { value: 'steel-town', label: 'Steel Town', pincode: '713207' },
    { value: 'subhas-pally', label: 'Subhas Pally', pincode: '713202' },
    { value: 'tata-town', label: 'Tata Town', pincode: '713208' },
    { value: 'bengal-chemical', label: 'Bengal Chemical', pincode: '713209' },
    { value: 'bengal-fur', label: 'Bengal Fur', pincode: '713210' },
    { value: 'bhukailash', label: 'Bhukailash', pincode: '713211' },
    { value: 'coal-belt', label: 'Coal Belt', pincode: '713213' },
    { value: 'hijuli', label: 'Hijuli', pincode: '713230' },
    { value: 'kanainatpur', label: 'Kanainatpur', pincode: '713227' },
    { value: 'kachrapara', label: 'Kachrapara', pincode: '713208' },
    { value: 'jhantipahari', label: 'Jhantipahari', pincode: '713221' },
    { value: 'kuleswar', label: 'Kuleswar', pincode: '713230' },
    { value: 'sukanta-nagar', label: 'Sukanta Nagar', pincode: '713205' },
    { value: 'sapapur', label: 'Sapapur', pincode: '713217' },
    { value: 'suryakanta', label: 'Suryakanta', pincode: '713216' },
    { value: 'panchanantala', label: 'Panchanantala', pincode: '713220' },
    { value: 'surul', label: 'Surul', pincode: '713231' },
    { value: 'vishnupur', label: 'Vishnupur', pincode: '713232' }
  ],

  'bardhaman': [
    { value: 'bhatar', label: 'Bhatar', pincode: '713125' },
    { value: 'bengal-chemical', label: 'Bengal Chemical', pincode: '713204' },
    { value: 'bistupur', label: 'Bistupur', pincode: '713205' },
    { value: 'bardhaman-district-court', label: 'Bardhaman District Court', pincode: '713101' },
    { value: 'belgachia', label: 'Belgachia', pincode: '713106' },
    { value: 'galsi', label: 'Galsi', pincode: '713402' },
    { value: 'guskara', label: 'Guskara', pincode: '713128' },
    { value: 'hanan', label: 'Hanan', pincode: '713104' },
    { value: 'jaigir', label: 'Jaigir', pincode: '713151' },
    { value: 'jirat', label: 'Jirat', pincode: '713142' },
    { value: 'katwa', label: 'Katwa', pincode: '713130' },
    { value: 'kolar', label: 'Kolar', pincode: '713143' },
    { value: 'kundalia', label: 'Kundalia', pincode: '713130' },
    { value: 'madhabgram', label: 'Madhabgram', pincode: '713126' },
    { value: 'mogra', label: 'Mogra', pincode: '713143' },
    { value: 'nandanpur', label: 'Nandanpur', pincode: '713103' },
    { value: 'rampurhat', label: 'Rampurhat', pincode: '713147' },
    { value: 'sonamukhi', label: 'Sonamukhi', pincode: '713204' },
    { value: 'suri', label: 'Suri', pincode: '713101' },
    { value: 'udayan', label: 'Udayan', pincode: '713102' },
    { value: 'ushagram', label: 'Ushagram', pincode: '713211' },
    { value: 'bansberia', label: 'Bansberia', pincode: '713207' },
    { value: 'khandra', label: 'Khandra', pincode: '713127' },
    { value: 'raipur', label: 'Raipur', pincode: '713146' },
    { value: 'saharpur', label: 'Saharpur', pincode: '713135' },
    { value: 'krishnanagar', label: 'Krishnanagar', pincode: '713121' },
    { value: 'mejia', label: 'Mejia', pincode: '713147' },
    { value: 'mandirbazar', label: 'Mandirbazar', pincode: '713143' },
    { value: 'singur', label: 'Singur', pincode: '713128' }
  ],

  'north-24-parganas': [
    { value: 'agarpara', label: 'Agarpara', pincode: '700109' },
    { value: 'ashoknagar', label: 'Ashoknagar', pincode: '743204' },
    { value: 'barasat', label: 'Barasat', pincode: '700124' },
    { value: 'basirhat', label: 'Basirhat', pincode: '743411' },
    { value: 'barrackpore', label: 'Barrackpore', pincode: '700120' },
    { value: 'belgharia', label: 'Belgharia', pincode: '700056' },
    { value: 'bongaon', label: 'Bongaon', pincode: '743235' },
    { value: 'chakdaha', label: 'Chakdaha', pincode: '741222' },
    { value: 'chandpara', label: 'Chandpara', pincode: '743290' },
    { value: 'dagapur', label: 'Dagapur', pincode: '743249' },
    { value: 'dabgram', label: 'Dabgram', pincode: '743221' },
    { value: 'ghola', label: 'Ghola', pincode: '700080' },
    { value: 'habra', label: 'Habra', pincode: '743263' },
    { value: 'kamarhati', label: 'Kamarhati', pincode: '700058' },
    { value: 'ketugram', label: 'Ketugram', pincode: '713513' },
    { value: 'lakshmikantapur', label: 'Lakshmikantapur', pincode: '743355' },
    { value: 'nandigram', label: 'Nandigram', pincode: '743357' },
    { value: 'netaji-nagar', label: 'Netaji Nagar', pincode: '700040' },
    { value: 'rishra', label: 'Rishra', pincode: '712248' },
    { value: 'sandeshkhali', label: 'Sandeshkhali', pincode: '743439' },
    { value: 'sodepur', label: 'Sodepur', pincode: '700110' },
    { value: 'sonarpur', label: 'Sonarpur', pincode: '700150' },
    { value: 'titagarh', label: 'Titagarh', pincode: '700119' },
    { value: 'uluberia', label: 'Uluberia', pincode: '711315' },
    { value: 'west-barrackpore', label: 'West Barrackpore', pincode: '700122' },
    { value: 'dumdum', label: 'Dumdum', pincode: '700028' },
    { value: 'kamarhati', label: 'Kamarhati', pincode: '700058' },
    { value: 'dumdum-park', label: 'Dumdum Park', pincode: '700030' },
    { value: 'salap', label: 'Salap', pincode: '711109' }
  ],

  'haldia': [
    { value: 'aul', label: 'Aul', pincode: '721601' },
    { value: 'bahadurpur', label: 'Bahadurpur', pincode: '721628' },
    { value: 'banerjee-para', label: 'Banerjee Para', pincode: '721657' },
    { value: 'chalchalia', label: 'Chalchalia', pincode: '721641' },
    { value: 'chakbazar', label: 'Chakbazar', pincode: '721633' },
    { value: 'chakmohanan', label: 'Chakmohanan', pincode: '721651' },
    { value: 'dumurjola', label: 'Dumurjola', pincode: '721651' },
    { value: 'haldia', label: 'Haldia', pincode: '721657' },
    { value: 'jagannathpur', label: 'Jagannathpur', pincode: '721655' },
    { value: 'jhitkibari', label: 'Jhitkibari', pincode: '721623' },
    { value: 'khejuri', label: 'Khejuri', pincode: '721403' },
    { value: 'madhusree', label: 'Madhusree', pincode: '721631' },
    { value: 'mahammadpur', label: 'Mahammadpur', pincode: '721635' },
    { value: 'manikber', label: 'Manikber', pincode: '721646' },
    { value: 'mukundapur', label: 'Mukundapur', pincode: '721616' },
    { value: 'new-bazar', label: 'New Bazar', pincode: '721631' },
    { value: 'princep', label: 'Princep', pincode: '721636' },
    { value: 'purba-barat', label: 'Purba Barat', pincode: '721601' },
    { value: 'rasulpur', label: 'Rasulpur', pincode: '721627' },
    { value: 'rajarampur', label: 'Rajarampur', pincode: '721643' },
    { value: 'samsabad', label: 'Samsabad', pincode: '721641' },
    { value: 'sararampur', label: 'Sararampur', pincode: '721635' },
    { value: 'tangra', label: 'Tangra', pincode: '721612' },
    { value: 'tardaha', label: 'Tardaha', pincode: '721613' },
    { value: 'bichali', label: 'Bichali', pincode: '721615' },
    { value: 'kumargram', label: 'Kumargram', pincode: '721631' },
    { value: 'mallikpara', label: 'Mallikpara', pincode: '721627' },
    { value: 'manmathapur', label: 'Manmathapur', pincode: '721631' },
    { value: 'minapur', label: 'Minapur', pincode: '721618' },
    { value: 'rajarampur-ii', label: 'Rajarampur II', pincode: '721636' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '721612' },
    { value: 'sankarpur', label: 'Sankarpur', pincode: '721640' },
    { value: 'santoshpur', label: 'Santoshpur', pincode: '721627' },
    { value: 'srirampur', label: 'Srirampur', pincode: '721634' }
  ],

  'darjeeling': [
    { value: 'bajrapathar', label: 'Bajrapathar', pincode: '734123' },
    { value: 'batasia', label: 'Batasia', pincode: '734101' },
    { value: 'bonghat', label: 'Bonghat', pincode: '734104' },
    { value: 'darjeeling', label: 'Darjeeling', pincode: '734101' },
    { value: 'darjeeling-bazar', label: 'Darjeeling Bazar', pincode: '734101' },
    { value: 'dingboche', label: 'Dingboche', pincode: '734103' },
    { value: 'ghoom', label: 'Ghoom', pincode: '734102' },
    { value: 'jorebungalow', label: 'Jorebungalow', pincode: '734102' },
    { value: 'kalimpong', label: 'Kalimpong', pincode: '734301' },
    { value: 'karmatar', label: 'Karmatar', pincode: '734101' },
    { value: 'kurseong', label: 'Kurseong', pincode: '734203' },
    { value: 'lalkothi', label: 'Lalkothi', pincode: '734103' },
    { value: 'lewdale', label: 'Lewdale', pincode: '734124' },
    { value: 'mohanbari', label: 'Mohanbari', pincode: '734124' },
    { value: 'northeys', label: 'Northeys', pincode: '734101' },
    { value: 'pechheypari', label: 'Pechheypari', pincode: '734102' },
    { value: 'rajbari', label: 'Rajbari', pincode: '734101' },
    { value: 'rangmohan', label: 'Rangmohan', pincode: '734102' },
    { value: 'sadar-bazar', label: 'Sadar Bazar', pincode: '734101' },
    { value: 'siliguri', label: 'Siliguri', pincode: '734005' },
    { value: 'sonada', label: 'Sonada', pincode: '734213' },
    { value: 'sukhia', label: 'Sukhia', pincode: '734106' },
    { value: 'tindharia', label: 'Tindharia', pincode: '734102' },
    { value: 'tirpai', label: 'Tirpai', pincode: '734102' },
    { value: 'toongsoong', label: 'Toongsoong', pincode: '734121' },
    { value: 'fagu', label: 'Fagu', pincode: '734108' },
    { value: 'jhandi', label: 'Jhandi', pincode: '734120' },
    { value: 'manjushree', label: 'Manjushree', pincode: '734101' },
    { value: 'mangaldham', label: 'Mangaldham', pincode: '734102' },
    { value: 'naya-bazar', label: 'Naya Bazar', pincode: '734102' },
    { value: 'neora', label: 'Neora', pincode: '734201' },
    { value: 'netaji', label: 'Netaji', pincode: '734116' },
    { value: 'paharigura', label: 'Paharigura', pincode: '734101' },
    { value: 'ramdhura', label: 'Ramdhura', pincode: '734125' },
    { value: 'rangapara', label: 'Rangapara', pincode: '734126' }
  ],

  'bankura': [
    { value: 'ankurhati', label: 'Ankurhati', pincode: '722102' },
    { value: 'bankura', label: 'Bankura', pincode: '722101' },
    { value: 'barjora', label: 'Barjora', pincode: '722202' },
    { value: 'bishnupur', label: 'Bishnupur', pincode: '722122' },
    { value: 'bolpur', label: 'Bolpur', pincode: '722204' },
    { value: 'chatra', label: 'Chatra', pincode: '722147' },
    { value: 'chandrakona', label: 'Chandrakona', pincode: '722135' },
    { value: 'dabgram', label: 'Dabgram', pincode: '722126' },
    { value: 'durgapur', label: 'Durgapur', pincode: '722143' },
    { value: 'gokulnagar', label: 'Gokulnagar', pincode: '722151' },
    { value: 'jatrapur', label: 'Jatrapur', pincode: '722103' },
    { value: 'kanai', label: 'Kanai', pincode: '722116' },
    { value: 'kenduadihi', label: 'Kenduadihi', pincode: '722122' },
    { value: 'kolsora', label: 'Kolsora', pincode: '722143' },
    { value: 'mejia', label: 'Mejia', pincode: '722143' },
    { value: 'murarai', label: 'Murarai', pincode: '722215' },
    { value: 'raipur', label: 'Raipur', pincode: '722160' },
    { value: 'salbari', label: 'Salbari', pincode: '722106' },
    { value: 'sonamukhi', label: 'Sonamukhi', pincode: '722207' },
    { value: 'taldangra', label: 'Taldangra', pincode: '722151' },
    { value: 'tilaboni', label: 'Tilaboni', pincode: '722104' },
    { value: 'bhagatdihi', label: 'Bhagatdihi', pincode: '722107' },
    { value: 'bhulabheda', label: 'Bhulabheda', pincode: '722122' },
    { value: 'kamarpur', label: 'Kamarpur', pincode: '722136' },
    { value: 'kanakpur', label: 'Kanakpur', pincode: '722147' },
    { value: 'lalpur', label: 'Lalpur', pincode: '722125' },
    { value: 'ramkrishna', label: 'Ramkrishna', pincode: '722159' },
    { value: 'satra', label: 'Satra', pincode: '722138' },
    { value: 'tilabari', label: 'Tilabari', pincode: '722149' }
],

  'jalpaiguri': [
    { value: 'alipurduar', label: 'Alipurduar', pincode: '736121' },
    { value: 'alupatta', label: 'Alupatta', pincode: '736135' },
    { value: 'bhuttabari', label: 'Bhuttabari', pincode: '736157' },
    { value: 'chakraberia', label: 'Chakraberia', pincode: '736129' },
    { value: 'dengmara', label: 'Dengmara', pincode: '736127' },
    { value: 'garhkatuli', label: 'Garhkatuli', pincode: '736122' },
    { value: 'jagdishpur', label: 'Jagdishpur', pincode: '736135' },
    { value: 'jalpaiguri', label: 'Jalpaiguri', pincode: '736101' },
    { value: 'japla', label: 'Japla', pincode: '736132' },
    { value: 'krishnapara', label: 'Krishnapara', pincode: '736126' },
    { value: 'kumargram', label: 'Kumargram', pincode: '736155' },
    { value: 'manashar', label: 'Manashar', pincode: '736136' },
    { value: 'manglamari', label: 'Manglamari', pincode: '736152' },
    { value: 'matia', label: 'Matia', pincode: '736150' },
    { value: 'maynaguri', label: 'Maynaguri', pincode: '736220' },
    { value: 'moniari', label: 'Moniari', pincode: '736144' },
    { value: 'mukhra', label: 'Mukhra', pincode: '736149' },
    { value: 'nagrakata', label: 'Nagrakata', pincode: '736185' },
    { value: 'nayanjhora', label: 'Nayanjhora', pincode: '736153' },
    { value: 'netaji', label: 'Netaji', pincode: '736120' },
    { value: 'sadarbari', label: 'Sadarbari', pincode: '736122' },
    { value: 'salmara', label: 'Salmara', pincode: '736156' },
    { value: 'samsadpur', label: 'Samsadpur', pincode: '736123' },
    { value: 'sangram', label: 'Sangram', pincode: '736139' },
    { value: 'sukna', label: 'Sukna', pincode: '736107' },
    { value: 'sundarati', label: 'Sundarati', pincode: '736114' },
    { value: 'tufanganj', label: 'Tufanganj', pincode: '736159' },
    { value: 'vijaynagar', label: 'Vijaynagar', pincode: '736137' },
    { value: 'alambazar', label: 'Alambazar', pincode: '736119' },
    { value: 'banshihari', label: 'Banshihari', pincode: '736139' },
    { value: 'chopra', label: 'Chopra', pincode: '736157' },
    { value: 'dhupguri', label: 'Dhupguri', pincode: '736171' },
    { value: 'hailakandi', label: 'Hailakandi', pincode: '736204' },
    { value: 'kharibari', label: 'Kharibari', pincode: '736160' },
    { value: 'matigara', label: 'Matigara', pincode: '736102' },
    { value: 'naodara', label: 'Naodara', pincode: '736143' }
  ],

  'kolkata': [
    { value: '24-parganas', label: '24 Parganas', pincode: '743263' },
    { value: '24-parganas-south', label: '24 Parganas South', pincode: '700027' },
    { value: 'acharya-jagadish-chandra-bose-road', label: 'Acharya Jagadish Chandra Bose Road', pincode: '700020' },
    { value: 'acharya-profulla-chandra-road', label: 'Acharya Profulla Chandra Road', pincode: '700009' },
    { value: 'agarpara', label: 'Agarpara', pincode: '700109' },
    { value: 'alambazar', label: 'Alambazar', pincode: '743168' },
    { value: 'alipur', label: 'Alipur', pincode: '700027' },
    { value: 'alipur-road', label: 'Alipur Road', pincode: '700027' },
    { value: 'alipore', label: 'Alipore', pincode: '700027' },
    { value: 'amartala-street', label: 'Amartala Street', pincode: '700017' },
    { value: 'amherst-street', label: 'Amherst Street', pincode: '700009' },
    { value: 'amtala', label: 'Amtala', pincode: '743503' },
    { value: 'anandpur', label: 'Anandpur', pincode: '700107' },
    { value: 'andul-road', label: 'Andul Road', pincode: '700027' },
    { value: 'ariadaha', label: 'Ariadaha', pincode: '700057' },
    { value: 'armenian-street', label: 'Armenian Street', pincode: '700001' },
    { value: 'ashutosh-mukherjee-road', label: 'Ashutosh Mukherjee Road', pincode: '700026' },
    { value: 'b.b.d-bag-dalhousie-square', label: 'B.B.D Bag Dalhousie Square', pincode: '700001' },
    { value: 'bagh-bazar', label: 'Bagh Bazar', pincode: '700003' },
    { value: 'bagha-jatin', label: 'Bagha Jatin', pincode: '700086' },
    { value: 'baguiati', label: 'Baguiati', pincode: '700059' },
    { value: 'baguihati', label: 'Baguihati', pincode: '700059' },
    { value: 'bally', label: 'Bally', pincode: '700001' },
    { value: 'ballygunge', label: 'Ballygunge', pincode: '700019' },
    { value: 'ballygunge-circular-road', label: 'Ballygunge Circular Road', pincode: '700019' },
    { value: 'ballygunge-phari', label: 'Ballygunge Phari', pincode: '700029' },
    { value: 'ballygunge-place', label: 'Ballygunge Place', pincode: '700019' },
    { value: 'bandel', label: 'Bandel', pincode: '712123' },
    { value: 'bangur-avenue', label: 'Bangur Avenue', pincode: '700055' },
    { value: 'bansdroni', label: 'Bansdroni', pincode: '700070' },
    { value: 'barabazar', label: 'Barabazar', pincode: '700007' },
    { value: 'barahanagar', label: 'Barahanagar', pincode: '700036' },
    { value: 'barasat', label: 'Barasat', pincode: '700124' },
    { value: 'baruipur', label: 'Baruipur', pincode: '700144' },
    { value: 'barisha', label: 'Barisha', pincode: '700008' },
    { value: 'barrackpore', label: 'Barrackpore', pincode: '700120' },
    { value: 'barrackpore-trunk-road', label: 'Barrackpore Trunk Road', pincode: '700063' },
    { value: 'bata-nagar', label: 'Bata Nagar', pincode: '700023' },
    { value: 'beadon-street', label: 'Beadon Street', pincode: '700006' },
    { value: 'beck-bagan', label: 'Beck Bagan', pincode: '700017' },
    { value: 'behala', label: 'Behala', pincode: '700034' },
    { value: 'behala-chowrasta', label: 'Behala Chowrasta', pincode: '700060' },
    { value: 'belgachia', label: 'Belgachia', pincode: '700037' },
    { value: 'belghoriya', label: 'Belghoriya', pincode: '700056' },
    { value: 'beliaghata', label: 'Beliaghata', pincode: '700010' },
    { value: 'belur', label: 'Belur', pincode: '711202' },
    { value: 'bentick-street', label: 'Bentick Street', pincode: '700007' },
    { value: 'bepin-behari-ganguly-street', label: 'Bepin Behari Ganguly Street', pincode: '700012' },
    { value: 'bhawanipur', label: 'Bhawanipur', pincode: '700025' },
    { value: 'bidhan-nagar', label: 'Bidhan Nagar', pincode: '700064' },
    { value: 'bidhan-sarani', label: 'Bidhan Sarani', pincode: '700006' },
    { value: 'binoy-badal-dinesh-bag', label: 'Binoy Badal Dinesh Bag', pincode: '700031' },
    { value: 'birati', label: 'Birati', pincode: '700051' },
    { value: 'bon-hoogly', label: 'Bon Hoogly', pincode: '700082' },
    { value: 'bow-bazar', label: 'Bow Bazar', pincode: '700012' },
    { value: 'brabourne-road', label: 'Brabourne Road', pincode: '700001' },
    { value: 'brace-bridge-road', label: 'Brace Bridge Road', pincode: '700070' },
    { value: 'british-india-street', label: 'British India Street', pincode: '700069' },
    { value: 'budge-budge-road', label: 'Budge Budge Road', pincode: '700137' },
    { value: 'burrabazar', label: 'Burrabazar', pincode: '700007' },
    { value: 'burtolla-street', label: 'Burtolla Street', pincode: '700007' },
    { value: 'camac-street', label: 'Camac Street', pincode: '700016' },
    { value: 'canning-street', label: 'Canning Street', pincode: '700001' },
    { value: 'chandannagar', label: 'Chandannagar', pincode: '712136' },
    { value: 'chandni-chowk', label: 'Chandni Chowk', pincode: '700001' },
    { value: 'chinsurah', label: 'Chinsurah', pincode: '712101' },
    { value: 'cit-scheme', label: 'C I T Scheme', pincode: '700014' },
    { value: 'clive-row', label: 'Clive Row', pincode: '700020' },
    { value: 'college-square', label: 'College Square', pincode: '700073' },
    { value: 'college-street', label: 'College Street', pincode: '700073' },
    { value: 'cossipore', label: 'Cossipore', pincode: '700002' },
    { value: 'dakshineswar', label: 'Dakshineswar', pincode: '700035' },
    { value: 'dunlop', label: 'Dunlop', pincode: '700108' },
    { value: 'e.m-bypass', label: 'E.M Bypass', pincode: '700107' },
    { value: 'garia', label: 'Garia', pincode: '700084' },
    { value: 'gariahat', label: 'Gariahat', pincode: '700029' },
    { value: 'jadavpur', label: 'Jadavpur', pincode: '700032' },
    { value: 'kankurgachi', label: 'Kankurgachi', pincode: '700054' },
    { value: 'lake-town', label: 'Lake Town', pincode: '700089' },
    { value: 'narendrapur', label: 'Narendrapur', pincode: '700103' },
    { value: 'rajarhat', label: 'Rajarhat', pincode: '700135' },
    { value: 'santoshpur', label: 'Santoshpur', pincode: '700075' },
    { value: 'tollygunge', label: 'Tollygunge', pincode: '700033' }
  ],

  'howrah': [
    { value: 'bally', label: 'Bally', pincode: '711201' },
    { value: 'bauria', label: 'Bauria', pincode: '711310' },
    { value: 'belur', label: 'Belur', pincode: '711202' },
    { value: 'dankuni', label: 'Dankuni', pincode: '712311' },
    { value: 'dasnagar', label: 'Dasnagar', pincode: '711105' },
    { value: 'domjur', label: 'Domjur', pincode: '711405' },
    { value: 'ghusuri', label: 'Ghusuri', pincode: '711107' },
    { value: 'howrah-Maidan', label: 'Howrah Maidan', pincode: '711101' },
    { value: 'howrah-Railway-Station', label: 'Howrah Railway Station', pincode: '711101' },
    { value: 'jagatballavpur', label: 'Jagatballavpur', pincode: '711408' },
    { value: 'kadamtala', label: 'Kadamtala', pincode: '711101' },
    { value: 'liluah', label: 'Liluah', pincode: '711204' },
    { value: 'mali-Panchghara', label: 'Mali Panchghara', pincode: '711106' },
    { value: 'ramrajatala', label: 'Ramrajatala', pincode: '711104' },
    { value: 'salap', label: 'Salap', pincode: '711409' },
    { value: 'salkia', label: 'Salkia', pincode: '711106' },
    { value: 'santragachi', label: 'Santragachi', pincode: '711104' },
    { value: 'shibpur', label: 'Shibpur', pincode: '711102' },
    { value: 'uluberia', label: 'Uluberia', pincode: '711315' }
  ],

  'siliguri': [
    { value: 'a-block', label: 'A Block', pincode: '734003' },
    { value: 'amin-para', label: 'Amin Para', pincode: '734002' },
    { value: 'ashram-para', label: 'Ashram Para', pincode: '734003' },
    { value: 'bagrakote', label: 'Bagrakote', pincode: '734424' },
    { value: 'bairatisal', label: 'Bairatisal', pincode: '734427' },
    { value: 'balkrishna-para', label: 'Balkrishna Para', pincode: '734010' },
    { value: 'bari-para', label: 'Bari Para', pincode: '734001' },
    { value: 'bengal-silks', label: 'Bengal Silks', pincode: '734001' },
    { value: 'bhatara', label: 'Bhatara', pincode: '734015' },
    { value: 'bhaktinagar', label: 'Bhaktinagar', pincode: '734401' },
    { value: 'bidaan', label: 'Bidaan', pincode: '734405' },
    { value: 'bengal-silks', label: 'Bengal Silks', pincode: '734001' },
    { value: 'chhathia-para', label: 'Chhathia Para', pincode: '734002' },
    { value: 'chhota-mahananda', label: 'Chhota Mahananda', pincode: '734008' },
    { value: 'chowk-bazar', label: 'Chowk Bazar', pincode: '734001' },
    { value: 'dholbasha', label: 'Dholbasha', pincode: '734003' },
    { value: 'dhupguri', label: 'Dhupguri', pincode: '734504' },
    { value: 'dighi', label: 'Dighi', pincode: '734011' },
    { value: 'fulbari', label: 'Fulbari', pincode: '734004' },
    { value: 'gajoldoba', label: 'Gajoldoba', pincode: '734015' },
    { value: 'gorkha-para', label: 'Gorkha Para', pincode: '734010' },
    { value: 'gosanimari', label: 'Gosanimari', pincode: '734006' },
    { value: 'jalpai-bazar', label: 'Jalpai Bazar', pincode: '734427' },
    { value: 'jalpaiguri-road', label: 'Jalpaiguri Road', pincode: '734013' },
    { value: 'jorbunglow', label: 'Jorbunglow', pincode: '734011' },
    { value: 'jorhat', label: 'Jorhat', pincode: '734004' },
    { value: 'kali-mandir', label: 'Kali Mandir', pincode: '734002' },
    { value: 'kali-mandir-road', label: 'Kali Mandir Road', pincode: '734002' },
    { value: 'kamarpara', label: 'Kamarpara', pincode: '734005' },
    { value: 'kanchenjunga-para', label: 'Kanchenjunga Para', pincode: '734005' },
    { value: 'khalpara', label: 'Khalpara', pincode: '734005' },
    { value: 'khaprail', label: 'Khaprail', pincode: '734402' },
    { value: 'kharibari', label: 'Kharibari', pincode: '734202' },
    { value: 'kumani', label: 'Kumani', pincode: '734402' },
    { value: 'kumani-bazar', label: 'Kumani Bazar', pincode: '734402' },
    { value: 'kuttimani', label: 'Kuttimani', pincode: '734405' },
    { value: 'madhubari', label: 'Madhubari', pincode: '734407' },
    { value: 'madhupur', label: 'Madhupur', pincode: '734015' },
    { value: 'madhupur-bazar', label: 'Madhupur Bazar', pincode: '734015' },
    { value: 'madhyapara', label: 'Madhyapara', pincode: '734005' },
    { value: 'mahananda-ghat', label: 'Mahananda Ghat', pincode: '734003' },
    { value: 'matigara', label: 'Matigara', pincode: '734010' },
    { value: 'matigara-bazaar', label: 'Matigara Bazaar', pincode: '734010' },
    { value: 'matigara-chowk', label: 'Matigara Chowk', pincode: '734010' },
    { value: 'mohanpara', label: 'Mohanpara', pincode: '734004' },
    { value: 'naxalbari', label: 'Naxalbari', pincode: '734429' },
    { value: 'naxalbari-bazar', label: 'Naxalbari Bazar', pincode: '734429' },
    { value: 'paharpur', label: 'Paharpur', pincode: '734013' },
    { value: 'panitanki', label: 'Panitanki', pincode: '734422' },
    { value: 'panchayat-bhavan', label: 'Panchayat Bhavan', pincode: '734001' },
    { value: 'phansidewa', label: 'Phansidewa', pincode: '734216' },
    { value: 'phansidewa-bazar', label: 'Phansidewa Bazar', pincode: '734216' },
    { value: 'pradhannagar', label: 'Pradhannagar', pincode: '734003' },
    { value: 'rangapani-bazar', label: 'Rangapani Bazar', pincode: '734009' },
    { value: 'rungamutti', label: 'Rungamutti', pincode: '734013' },
    { value: 'salugara', label: 'Salugara', pincode: '734008' },
    { value: 'salugara-bazar', label: 'Salugara Bazar', pincode: '734008' },
    { value: 'sevoke-bazaar', label: 'Sevoke Bazaar', pincode: '734008' },
    { value: 'sevoke-road', label: 'Sevoke Road', pincode: '734008' },
    { value: 'shib-mandir', label: 'Shib Mandir', pincode: '734002' },
    { value: 'shib-mandir-road', label: 'Shib Mandir Road', pincode: '734002' },
    { value: 'shikarpur', label: 'Shikarpur', pincode: '734419' },
    { value: 'siliguri-airport-area', label: 'Siliguri Airport Area', pincode: '734014' },
    { value: 'siliguri-bazar', label: 'Siliguri Bazar', pincode: '734001' },
    { value: 'siliguri-college-road', label: 'Siliguri College Road', pincode: '734001' },
    { value: 'siliguri-hill-cart-road', label: 'Siliguri Hill Cart Road', pincode: '734003' },
    { value: 'siliguri-junction', label: 'Siliguri Junction', pincode: '734014' },
    { value: 'siliguri-town', label: 'Siliguri Town', pincode: '734001' },
    { value: 'siliguri-town-hall', label: 'Siliguri Town Hall', pincode: '734001' },
    { value: 'subhash-nagar', label: 'Subhash Nagar', pincode: '734003' },
    { value: 'sukna', label: 'Sukna', pincode: '734009' },
    { value: 'tungidara', label: 'Tungidara', pincode: '734009' },
    { value: 'tungidara-bazar', label: 'Tungidara Bazar', pincode: '734009' },
    { value: 'ward-no-5', label: 'Ward No 5', pincode: '734003' }
  ],
  'malda': [
    { value: 'aiho', label: 'Aiho', pincode: '732207' },
    { value: 'alipur', label: 'Alipur', pincode: '732141' },
    { value: 'baksinagar', label: 'Baksinagar', pincode: '732201' },
    { value: 'baliadanga', label: 'Baliadanga', pincode: '732142' },
    { value: 'bamangram', label: 'Bamangram', pincode: '732126' },
    { value: 'bandhail', label: 'Bandhail', pincode: '732201' },
    { value: 'bara-suzapur', label: 'Bara Suzapur', pincode: '732138' },
    { value: 'bagbari', label: 'Bagbari', pincode: '732126' },
    { value: 'birodhi', label: 'Birodhi', pincode: '732205' },
    { value: 'chanchal', label: 'Chanchal', pincode: '732123' },
    { value: 'chaspara', label: 'Chaspara', pincode: '732122' },
    { value: 'chhatinamor', label: 'Chhatinamor', pincode: '732135' },
    { value: 'chhota-suzapur', label: 'Chhota Suzapur', pincode: '732138' },
    { value: 'gauḍa', label: 'Gauḍa', pincode: '732124' },
    { value: 'gazole-town', label: 'Gazole Town', pincode: '732124' },
    { value: 'jadupur', label: 'Jadupur', pincode: '732145' },
    { value: 'jagannatphur', label: 'Jagannatphur', pincode: '700002' },
    { value: 'jalalpur', label: 'Jalalpur', pincode: '732126' },
    { value: 'jhangra', label: 'Jhangra', pincode: '732129' },
    { value: 'kachu-pukur', label: 'Kachu Pukur', pincode: '732126' },
    { value: 'kaliachak', label: 'Kaliachak', pincode: '700002' },
    { value: 'karari-chandpur', label: 'Karari Chandpur', pincode: '732202' },
    { value: 'kendua', label: 'Kendua', pincode: '732101' },
    { value: 'krishnapur', label: 'Krishnapur', pincode: '732126' },
    { value: 'mangal-bari', label: 'Mangal Bari', pincode: '732101' },
    { value: 'milki', label: 'Milki', pincode: '732101' },
    { value: 'nazirpur', label: 'Nazirpur', pincode: '732201' },
    { value: 'old-malda', label: 'Old Malda', pincode: '732203' },
    { value: 'rangabhita', label: 'Rangabhita', pincode: '732102' },
    { value: 'sahapur', label: 'Sahapur', pincode: '732139' },
    { value: 'silampur', label: 'Silampur', pincode: '732124' },
    { value: 'sonatala', label: 'Sonatala', pincode: '732207' },
    { value: 'sujapur', label: 'Sujapur', pincode: '732126' }
  ],

//Uttarakhand
'gangotri': [
  { value: 'bhatwari', label: 'Bhatwari', pincode: '249175' },
  { value: 'gangotri', label: 'Gangotri', pincode: '249175' },
  { value: 'ganganani', label: 'Ganganani', pincode: '249175' },
  { value: 'jhalla', label: 'Jhalla', pincode: '249175' },
  { value: 'kedar', label: 'Kedar', pincode: '249161' },
  { value: 'kumayun', label: 'Kumayun', pincode: '249175' },
  { value: 'mukwas', label: 'Mukwas', pincode: '249175' },
  { value: 'rishikesh', label: 'Rishikesh', pincode: '249137' },
  { value: 'tapt-kund', label: 'Tapt Kund', pincode: '249175' },
  { value: 'yogadhyan', label: 'Yogadhyan', pincode: '249175' },
  { value: 'bhairav-ganj', label: 'Bhairav Ganj', pincode: '249145' },
  { value: 'chamba', label: 'Chamba', pincode: '249145' },
  { value: 'dehradun', label: 'Dehradun', pincode: '248001' },
  { value: 'haridwar', label: 'Haridwar', pincode: '249401' },
  { value: 'kankhal', label: 'Kankhal', pincode: '249408' },
  { value: 'lakshman-jhula', label: 'Lakshman Jhula', pincode: '249302' },
  { value: 'neelkanth', label: 'Neelkanth', pincode: '249311' },
  { value: 'swargashram', label: 'Swargashram', pincode: '249304' }
  ],

'almora': [
  { value: 'almora', label: 'Almora', pincode: '263601' },
  { value: 'bajun', label: 'Bajun', pincode: '263655' },
  { value: 'banar', label: 'Banar', pincode: '263652' },
  { value: 'bhikiyasen', label: 'Bhikiyasen', pincode: '263640' },
  { value: 'dhakrani', label: 'Dhakrani', pincode: '263651' },
  { value: 'ghatari', label: 'Ghatari', pincode: '263652' },
  { value: 'haldwani', label: 'Haldwani', pincode: '263139' },
  { value: 'jageshwar', label: 'Jageshwar', pincode: '263623' },
  { value: 'kanda', label: 'Kanda', pincode: '263647' },
  { value: 'katarmal', label: 'Katarmal', pincode: '263642' },
  { value: 'mohangad', label: 'Mohangad', pincode: '263644' },
  { value: 'ramgarh', label: 'Ramgarh', pincode: '263137' },
  { value: 'sultan', label: 'Sultan', pincode: '263652' },
  { value: 'talla', label: 'Talla', pincode: '263642' },
  { value: 'dunagiri', label: 'Dunagiri', pincode: '263663' },
  { value: 'bageshwar', label: 'Bageshwar', pincode: '263642' },
  { value: 'beershakal', label: 'Beershakal', pincode: '263633' },
  { value: 'didihat', label: 'Didihat', pincode: '263653' },
  { value: 'garur', label: 'Garur', pincode: '263853' },
  { value: 'kosi', label: 'Kosi', pincode: '263165' }
  ],
  
  'champawat': [
  { value: 'champawat', label: 'Champawat', pincode: '262523' },
  { value: 'amrigaon', label: 'Amrigaon', pincode: '262526' },
  { value: 'badiyakot', label: 'Badiyakot', pincode: '262531' },
  { value: 'balti', label: 'Balti', pincode: '262530' },
  { value: 'banbasa', label: 'Banbasa', pincode: '262310' },
  { value: 'bhageshwar', label: 'Bhageshwar', pincode: '262535' },
  { value: 'bhatta', label: 'Bhatta', pincode: '262521' },
  { value: 'chandani', label: 'Chandani', pincode: '262522' },
  { value: 'chhoti', label: 'Chhoti', pincode: '262520' },
  { value: 'dhanari', label: 'Dhanari', pincode: '262524' },
  { value: 'dudhiya', label: 'Dudhiya', pincode: '262536' },
  { value: 'guruva', label: 'Guruva', pincode: '262527' },
  { value: 'johari', label: 'Johari', pincode: '262528' },
  { value: 'kaladhungi', label: 'Kaladhungi', pincode: '263140' },
  { value: 'kailash', label: 'Kailash', pincode: '262529' },
  { value: 'kanda', label: 'Kanda', pincode: '262525' },
  { value: 'mangola', label: 'Mangola', pincode: '262537' },
  { value: 'pali', label: 'Pali', pincode: '262532' },
  { value: 'pangar', label: 'Pangar', pincode: '262535' },
  { value: 'pithoragarh', label: 'Pithoragarh', pincode: '262501' },
  { value: 'serag', label: 'Serag', pincode: '262533' },
  { value: 'sinduri', label: 'Sinduri', pincode: '262534' },
  { value: 'takula', label: 'Takula', pincode: '262520' },
  { value: 'toli', label: 'Toli', pincode: '262538' },
  { value: 'vishnupriya', label: 'Vishnupriya', pincode: '262539' }
  ],
  
  'dharchula': [
  { value: 'dharchula', label: 'Dharchula', pincode: '262545' },
  { value: 'bagal', label: 'Bagal', pincode: '262552' },
  { value: 'baskot', label: 'Baskot', pincode: '262551' },
  { value: 'bhatkot', label: 'Bhatkot', pincode: '262548' },
  { value: 'chawani', label: 'Chawani', pincode: '262546' },
  { value: 'dharpuri', label: 'Dharpuri', pincode: '262547' },
  { value: 'jhulaghat', label: 'Jhulaghat', pincode: '262550' },
  { value: 'kandai', label: 'Kandai', pincode: '262549' },
  { value: 'kedar', label: 'Kedar', pincode: '262553' },
  { value: 'laipang', label: 'Laipang', pincode: '262544' },
  { value: 'maholi', label: 'Maholi', pincode: '262543' },
  { value: 'malli', label: 'Malli', pincode: '262542' },
  { value: 'maneshwar', label: 'Maneshwar', pincode: '262541' },
  { value: 'munsiyari', label: 'Munsiyari', pincode: '262554' },
  { value: 'panchachuli', label: 'Panchachuli', pincode: '262556' },
  { value: 'tawaghat', label: 'Tawaghat', pincode: '262555' }
  ],
  
  'gairsain': [
  { value: 'gairsain', label: 'Gairsain', pincode: '246278' },
  { value: 'badikot', label: 'Badikot', pincode: '246275' },
  { value: 'banoli', label: 'Banoli', pincode: '246276' },
  { value: 'bardha', label: 'Bardha', pincode: '246277' },
  { value: 'chanchula', label: 'Chanchula', pincode: '246279' },
  { value: 'chhatrakot', label: 'Chhatrakot', pincode: '246280' },
  { value: 'dhoulakot', label: 'Dhoulakot', pincode: '246273' },
  { value: 'dholan', label: 'Dholan', pincode: '246274' },
  { value: 'dongri', label: 'Dongri', pincode: '246288' },
  { value: 'dungari', label: 'Dungari', pincode: '246281' },
  { value: 'jhajra', label: 'Jhajra', pincode: '246272' },
  { value: 'kailana', label: 'Kailana', pincode: '246289' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '246290' },
  { value: 'kanda', label: 'Kanda', pincode: '246291' },
  { value: 'mangali', label: 'Mangali', pincode: '246282' },
  { value: 'mohalla', label: 'Mohalla', pincode: '246283' },
  { value: 'pindari', label: 'Pindari', pincode: '246284' },
  { value: 'pohli', label: 'Pohli', pincode: '246285' },
  { value: 'salmora', label: 'Salmora', pincode: '246286' },
  { value: 'suni', label: 'Suni', pincode: '246292' },
  { value: 'tanda', label: 'Tanda', pincode: '246287' },
  { value: 'tehri', label: 'Tehri', pincode: '246293' },
  { value: 'thapli', label: 'Thapli', pincode: '246294' }
  ],
  
  'harsil': [
  { value: 'harsil', label: 'Harsil', pincode: '249135' },
  { value: 'bhatwari', label: 'Bhatwari', pincode: '249135' },
  { value: 'bhirgad', label: 'Bhirgad', pincode: '249135' },
  { value: 'gangotri', label: 'Gangotri', pincode: '249135' },
  { value: 'jhala', label: 'Jhala', pincode: '249136' },
  { value: 'kedar', label: 'Kedar', pincode: '249137' },
  { value: 'kharadi', label: 'Kharadi', pincode: '249138' },
  { value: 'maneri', label: 'Maneri', pincode: '249139' },
  { value: 'mori', label: 'Mori', pincode: '249140' },
  { value: 'nagni', label: 'Nagni', pincode: '249141' },
  { value: 'raithal', label: 'Raithal', pincode: '249142' },
  { value: 'rangoon', label: 'Rangoon', pincode: '249143' },
  { value: 'sataun', label: 'Sataun', pincode: '249144' },
  { value: 'udiyari', label: 'Udiyari', pincode: '249145' },
  { value: 'chhoti', label: 'Chhoti', pincode: '249146' },
  { value: 'gagaad', label: 'Gagaad', pincode: '249147' },
  { value: 'chamba', label: 'Chamba', pincode: '249148' },
  { value: 'rishikesh', label: 'Rishikesh', pincode: '249149' },
  { value: 'suriya', label: 'Suriya', pincode: '249150' },
  { value: 'chandrapuri', label: 'Chandrapuri', pincode: '249151' },
  { value: 'neelkanth', label: 'Neelkanth', pincode: '249152' },
  { value: 'nalah', label: 'Nalah', pincode: '249153' }
  ],
  
  'kashipur': [
  { value: 'kashipur', label: 'Kashipur', pincode: '244713' },
  { value: 'akbarpur', label: 'Akbarpur', pincode: '244714' },
  { value: 'amraipur', label: 'Amraipur', pincode: '244715' },
  { value: 'banwasa', label: 'Banwasa', pincode: '244716' },
  { value: 'bhurapur', label: 'Bhurapur', pincode: '244717' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '244718' },
  { value: 'dholkhera', label: 'Dholkhera', pincode: '244719' },
  { value: 'gaon', label: 'Gaon', pincode: '244720' },
  { value: 'goida', label: 'Goida', pincode: '244721' },
  { value: 'gurdwara', label: 'Gurdwara', pincode: '244722' },
  { value: 'hassanpur', label: 'Hassanpur', pincode: '244723' },
  { value: 'jagjitpur', label: 'Jagjitpur', pincode: '244724' },
  { value: 'jhanjhana', label: 'Jhanjhana', pincode: '244725' },
  { value: 'kanhiya', label: 'Kanhiya', pincode: '244726' },
  { value: 'kotra', label: 'Kotra', pincode: '244727' },
  { value: 'madhuban', label: 'Madhuban', pincode: '244728' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '244729' },
  { value: 'nandpur', label: 'Nandpur', pincode: '244730' },
  { value: 'rajnagar', label: 'Rajnagar', pincode: '244731' },
  { value: 'sarswati', label: 'Sarswati', pincode: '244732' },
  { value: 'singhpur', label: 'Singhpur', pincode: '244733' },
  { value: 'sudarpur', label: 'Sudarpur', pincode: '244734' },
  { value: 'bahadarpur', label: 'Bahadarpur', pincode: '244735' },
  { value: 'bharatpur', label: 'Bharatpur', pincode: '244736' },
  { value: 'bhimtal', label: 'Bhimtal', pincode: '244737' },
  { value: 'bhupalpur', label: 'Bhupalpur', pincode: '244738' },
  { value: 'chandrawali', label: 'Chandrawali', pincode: '244739' },
  { value: 'dhamaria', label: 'Dhamaria', pincode: '244740' },
  { value: 'devpur', label: 'Devpur', pincode: '244741' },
  { value: 'gargari', label: 'Gargari', pincode: '244742' },
  { value: 'jakhani', label: 'Jakhani', pincode: '244743' },
  { value: 'jhanpura', label: 'Jhanpura', pincode: '244744' },
  { value: 'krishnapur', label: 'Krishnapur', pincode: '244745' },
  { value: 'meerapur', label: 'Meerapur', pincode: '244746' },
  { value: 'mandawali', label: 'Mandawali', pincode: '244747' },
  { value: 'naupur', label: 'Naupur', pincode: '244748' }
  ],
  
  'kotdwar': [
  { value: 'kotdwar', label: 'Kotdwar', pincode: '246149' },
  { value: 'dhamma', label: 'Dhamma', pincode: '246142' },
  { value: 'gadi', label: 'Gadi', pincode: '246141' },
  { value: 'jaspur', label: 'Jaspur', pincode: '246170' },
  { value: 'kandoli', label: 'Kandoli', pincode: '246142' },
  { value: 'kandrigad', label: 'Kandrigad', pincode: '246146' },
  { value: 'manglaur', label: 'Manglaur', pincode: '246155' },
  { value: 'mohand', label: 'Mohand', pincode: '246162' },
  { value: 'patlian', label: 'Patlian', pincode: '246143' },
  { value: 'rajpura', label: 'Rajpura', pincode: '246150' },
  { value: 'rishikesh', label: 'Rishikesh', pincode: '246171' },
  { value: 'sardi', label: 'Sardi', pincode: '246161' },
  { value: 'sital', label: 'Sital', pincode: '246151' },
  { value: 'sudha', label: 'Sudha', pincode: '246152' },
  { value: 'tehri', label: 'Tehri', pincode: '246153' },
  { value: 'tanda', label: 'Tanda', pincode: '246154' },
  { value: 'belda', label: 'Belda', pincode: '246145' },
  { value: 'bhali', label: 'Bhali', pincode: '246157' },
  { value: 'chhidkuli', label: 'Chhidkuli', pincode: '246158' },
  { value: 'daudpur', label: 'Daudpur', pincode: '246159' },
  { value: 'jhajra', label: 'Jhajra', pincode: '246160' },
  { value: 'kailashpur', label: 'Kailashpur', pincode: '246164' },
  { value: 'kheera', label: 'Kheera', pincode: '246165' },
  { value: 'patthargarh', label: 'Patthargarh', pincode: '246166' },
  { value: 'ranikhet', label: 'Ranikhet', pincode: '246167' },
  { value: 'sardarpur', label: 'Sardarpur', pincode: '246168' },
  { value: 'shivpur', label: 'Shivpur', pincode: '246169' },
  { value: 'tikri', label: 'Tikri', pincode: '246172' },
  { value: 'vishwakarma', label: 'Vishwakarma', pincode: '246173' }
  ],
  
  'laksar': [
  { value: 'laksar', label: 'Laksar', pincode: '247663' },
  { value: 'adampur', label: 'Adampur', pincode: '247667' },
  { value: 'bandi', label: 'Bandi', pincode: '247664' },
  { value: 'banthla', label: 'Banthla', pincode: '247665' },
  { value: 'bikapur', label: 'Bikapur', pincode: '247666' },
  { value: 'bhadanpur', label: 'Bhadanpur', pincode: '247668' },
  { value: 'jhinjhana', label: 'Jhinjhana', pincode: '247669' },
  { value: 'kaliyar', label: 'Kaliyar', pincode: '247670' },
  { value: 'kanheri', label: 'Kanheri', pincode: '247671' },
  { value: 'khandri', label: 'Khandri', pincode: '247672' },
  { value: 'manakpur', label: 'Manakpur', pincode: '247673' },
  { value: 'manglaur', label: 'Manglaur', pincode: '247674' },
  { value: 'mehdipur', label: 'Mehdipur', pincode: '247675' },
  { value: 'sahranpur', label: 'Sahranpur', pincode: '247676' },
  { value: 'surauli', label: 'Surauli', pincode: '247677' },
  { value: 'raipur', label: 'Raipur', pincode: '247678' },
  { value: 'dhanora', label: 'Dhanora', pincode: '247679' },
  { value: 'satpuli', label: 'Satpuli', pincode: '247680' },
  { value: 'kheri', label: 'Kheri', pincode: '247681' },
  { value: 'sai', label: 'Sai', pincode: '247682' },
  { value: 'siddhpur', label: 'Siddhpur', pincode: '247683' },
  { value: 'bhudpur', label: 'Bhudpur', pincode: '247684' },
  { value: 'rampur', label: 'Rampur', pincode: '247685' },
  { value: 'pali', label: 'Pali', pincode: '247686' },
  { value: 'bhainsora', label: 'Bhainsora', pincode: '247687' },
  { value: 'jagjeetpur', label: 'Jagjeetpur', pincode: '247688' }
  ],
  
  'landour': [
  { value: 'landour', label: 'Landour', pincode: '248179' },
  { value: 'barkot', label: 'Barkot', pincode: '248128' },
  { value: 'charleville', label: 'Charleville', pincode: '248179' },
  { value: 'darjeeling', label: 'Darjeeling', pincode: '248179' },
  { value: 'feltham', label: 'Feltham', pincode: '248179' },
  { value: 'gunsheri', label: 'Gunsheri', pincode: '248179' },
  { value: 'kanshiyara', label: 'Kanshiyara', pincode: '248179' },
  { value: 'kulri', label: 'Kulri', pincode: '248179' },
  { value: 'mashobra', label: 'Mashobra', pincode: '248179' },
  { value: 'mussoorie', label: 'Mussoorie', pincode: '248179' },
  { value: 'naga', label: 'Naga', pincode: '248179' },
  { value: 'pendari', label: 'Pendari', pincode: '248179' },
  { value: 'rocky', label: 'Rocky', pincode: '248179' },
  { value: 'sahaspur', label: 'Sahaspur', pincode: '248179' },
  { value: 'saratoga', label: 'Saratoga', pincode: '248179' },
  { value: 'saur', label: 'Saur', pincode: '248179' },
  { value: 'andrews', label: 'Andrews', pincode: '248179' },
  { value: 'brash', label: 'Brash', pincode: '248179' },
  { value: 'cambridge', label: 'Cambridge', pincode: '248179' },
  { value: 'candler', label: 'Candler', pincode: '248179' },
  { value: 'dhanolti', label: 'Dhanolti', pincode: '248001' },
  { value: 'heathcote', label: 'Heathcote', pincode: '248179' },
  { value: 'johnson', label: 'Johnson', pincode: '248179' },
  { value: 'lansdowne', label: 'Lansdowne', pincode: '248179' },
  { value: 'tiger-hill', label: 'Tiger Hill', pincode: '248179' },
  { value: 'twynam', label: 'Twynam', pincode: '248179' }
  ],

  'pantnagar': [
  { value: 'pantnagar', label: 'Pantnagar', pincode: '263145' },
  { value: 'balwakhurd', label: 'Balwakhurd', pincode: '263145' },
  { value: 'banbasa', label: 'Banbasa', pincode: '263160' },
  { value: 'basdila', label: 'Basdila', pincode: '263148' },
  { value: 'chakarpur', label: 'Chakarpur', pincode: '263141' },
  { value: 'chhidkila', label: 'Chhidkila', pincode: '263146' },
  { value: 'haldwani', label: 'Haldwani', pincode: '263139' },
  { value: 'jaspur', label: 'Jaspur', pincode: '263151' },
  { value: 'kailashpur', label: 'Kailashpur', pincode: '263149' },
  { value: 'kandoli', label: 'Kandoli', pincode: '263152' },
  { value: 'kashipur', label: 'Kashipur', pincode: '263148' },
  { value: 'kotabagh', label: 'Kotabagh', pincode: '263159' },
  { value: 'krishnanagar', label: 'Krishnanagar', pincode: '263140' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '263160' },
  { value: 'nainital', label: 'Nainital', pincode: '263002' },
  { value: 'padhampur', label: 'Padhampur', pincode: '263153' },
  { value: 'raipura', label: 'Raipura', pincode: '263147' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '263139' },
  { value: 'sudhowala', label: 'Sudhowala', pincode: '263155' },
  { value: 'badiakot', label: 'Badiakot', pincode: '263147' },
  { value: 'daulatpur', label: 'Daulatpur', pincode: '263153' },
  { value: 'dhanour', label: 'Dhanour', pincode: '263157' },
  { value: 'gopeshwar', label: 'Gopeshwar', pincode: '263144' },
  { value: 'khatima', label: 'Khatima', pincode: '263148' },
  { value: 'khudabagh', label: 'Khudabagh', pincode: '263156' },
  { value: 'kumarhatti', label: 'Kumarhatti', pincode: '263150' },
  { value: 'lalpur', label: 'Lalpur', pincode: '263154' },
  { value: 'lalkuan', label: 'Lalkuan', pincode: '263139' },
  { value: 'sitarampur', label: 'Sitarampur', pincode: '263160' },
  { value: 'tallkhet', label: 'Tallkhet', pincode: '263158' }
  ],
  
  'pithoragarh': [
  { value: 'pithoragarh', label: 'Pithoragarh', pincode: '262501' },
  { value: 'almora', label: 'Almora', pincode: '263601' },
  { value: 'barakote', label: 'Barakote', pincode: '262561' },
  { value: 'bageshwar', label: 'Bageshwar', pincode: '263642' },
  { value: 'didiha', label: 'Didiha', pincode: '262502' },
  { value: 'dharchula', label: 'Dharchula', pincode: '262550' },
  { value: 'jhulaghat', label: 'Jhulaghat', pincode: '262551' },
  { value: 'munsyari', label: 'Munsyari', pincode: '262554' },
  { value: 'thulidhar', label: 'Thulidhar', pincode: '262553' },
  { value: 'kafni', label: 'Kafni', pincode: '262552' },
  { value: 'chandika', label: 'Chandika', pincode: '262561' },
  { value: 'tungnath', label: 'Tungnath', pincode: '262560' },
  { value: 'sunderdhunga', label: 'Sunderdhunga', pincode: '262551' },
  { value: 'berinag', label: 'Berinag', pincode: '262529' },
  { value: 'kapkot', label: 'Kapkot', pincode: '262527' },
  { value: 'barkot', label: 'Barkot', pincode: '262528' },
  { value: 'chinchini', label: 'Chinchini', pincode: '262530' },
  { value: 'khet', label: 'Khet', pincode: '262531' },
  { value: 'dandeshwar', label: 'Dandeshwar', pincode: '262532' },
  { value: 'dasholi', label: 'Dasholi', pincode: '262503' },
  { value: 'dholi', label: 'Dholi', pincode: '262504' },
  { value: 'joshimath', label: 'Joshimath', pincode: '262571' },
  { value: 'kandari', label: 'Kandari', pincode: '262505' },
  { value: 'khal', label: 'Khal', pincode: '262506' },
  { value: 'kandali', label: 'Kandali', pincode: '262507' },
  { value: 'pancheshwar', label: 'Pancheshwar', pincode: '262508' },
  { value: 'koshiyar', label: 'Koshiyar', pincode: '262509' },
  { value: 'tiyali', label: 'Tiyali', pincode: '262510' },
  { value: 'chaukori', label: 'Chaukori', pincode: '262522' },
  { value: 'rikhikhal', label: 'Rikhikhal', pincode: '262511' },
  { value: 'dhalwala', label: 'Dhalwala', pincode: '262512' },
  { value: 'patal', label: 'Patal', pincode: '262513' },
  { value: 'garbyang', label: 'Garbyang', pincode: '262514' },
  { value: 'gunji', label: 'Gunji', pincode: '262515' }
  ],
  
  'roorkee': [
  { value: 'roorkee', label: 'Roorkee', pincode: '247667' },
  { value: 'alipur', label: 'Alipur', pincode: '247667' },
  { value: 'bariyad', label: 'Bariyad', pincode: '247662' },
  { value: 'bhuapur', label: 'Bhuapur', pincode: '247667' },
  { value: 'chandpur', label: 'Chandpur', pincode: '247666' },
  { value: 'chhijarsi', label: 'Chhijarsi', pincode: '247667' },
  { value: 'dandhera', label: 'Dandhera', pincode: '247667' },
  { value: 'garh-mukteshwar', label: 'Garh Mukteshwar', pincode: '247667' },
  { value: 'gohri', label: 'Gohri', pincode: '247667' },
  { value: 'gorakhpur', label: 'Gorakhpur', pincode: '247667' },
  { value: 'idgaah', label: 'Idgaah', pincode: '247667' },
  { value: 'jaspur', label: 'Jaspur', pincode: '247672' },
  { value: 'kanalsi', label: 'Kanalsi', pincode: '247667' },
  { value: 'manglaur', label: 'Manglaur', pincode: '247663' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '247667' },
  { value: 'najibabad', label: 'Najibabad', pincode: '247342' },
  { value: 'shahpur', label: 'Shahpur', pincode: '247667' },
  { value: 'sughad', label: 'Sughad', pincode: '247667' },
  { value: 'surajbari', label: 'Surajbari', pincode: '247667' },
  { value: 'village-abhaypur', label: 'Village Abhaypur', pincode: '247667' },
  { value: 'villageshivpur', label: 'Village Shivpur', pincode: '247667' },
  { value: 'bhimgoda', label: 'Bhimgoda', pincode: '247667' },
  { value: 'dudhli', label: 'Dudhli', pincode: '247661' },
  { value: 'gotawan', label: 'Gotawan', pincode: '247667' },
  { value: 'haridwar-roorkee', label: 'Haridwar Roorkee', pincode: '247667' },
  { value: 'jori', label: 'Jori', pincode: '247667' },
  { value: 'khadri', label: 'Khadri', pincode: '247667' },
  { value: 'kalanwalla', label: 'Kalanwalla', pincode: '247667' },
  { value: 'kantar', label: 'Kantar', pincode: '247667' },
  { value: 'manoharpur', label: 'Manoharpur', pincode: '247667' },
  { value: 'madhuban', label: 'Madhuban', pincode: '247667' },
  { value: 'mangarh', label: 'Mangarh', pincode: '247667' },
  { value: 'mohkampur', label: 'Mohkampur', pincode: '247667' },
  { value: 'panipat', label: 'Panipat', pincode: '247667' },
  { value: 'patli', label: 'Patli', pincode: '247667' },
  { value: 'sahaspur', label: 'Sahaspur', pincode: '247667' },
  { value: 'sikandarpur', label: 'Sikandarpur', pincode: '247667' },
  { value: 'singhpur', label: 'Singhpur', pincode: '247667' },
  { value: 'surajkund', label: 'Surajkund', pincode: '247667' },
  { value: 'wajidpur', label: 'Wajidpur', pincode: '247667' }
  ],

'dehradun': [
  { value: 'ajabpur', label: 'Ajabpur', pincode: '248001' },
  { value: 'andheri', label: 'Andheri', pincode: '248001' },
  { value: 'ballupur', label: 'Ballupur', pincode: '248001' },
  { value: 'chakrata-road', label: 'Chakrata Road', pincode: '248001' },
  { value: 'dakpathar', label: 'Dakpathar', pincode: '248125' },
  { value: 'dehradun-cantonment', label: 'Dehradun Cantonment', pincode: '248001' },
  { value: 'haridwar-by-pass', label: 'Haridwar By-pass', pincode: '248001' },
  { value: 'kargi', label: 'Kargi', pincode: '248140' },
  { value: 'manak-mandi', label: 'Manak Mandi', pincode: '248001' },
  { value: 'malsi', label: 'Malsi', pincode: '248001' },
  { value: 'nehrugram', label: 'Nehrugram', pincode: '248001' },
  { value: 'paltan-bazar', label: 'Paltan Bazar', pincode: '248001' },
  { value: 'raipur', label: 'Raipur', pincode: '248001' },
  { value: 'raja-road', label: 'Raja Road', pincode: '248001' },
  { value: 'sahastradhara-road', label: 'Sahastradhara Road', pincode: '248001' },
  { value: 'sardar-bazar', label: 'Sardar Bazar', pincode: '248001' },
  { value: 'shahastradhara', label: 'Shahastradhara', pincode: '248001' },
  { value: 'singh-niwas', label: 'Singh Niwas', pincode: '248001' },
  { value: 'vishnu-garden', label: 'Vishnu Garden', pincode: '248001' },
  { value: 'abhay-rajpur', label: 'Abhay Rajpur', pincode: '248145' },
  { value: 'bhauwala', label: 'Bhauwala', pincode: '248142' },
  { value: 'bhagatpur', label: 'Bhagatpur', pincode: '248009' },
  { value: 'buddhiwala', label: 'Buddhiwala', pincode: '248001' },
  { value: 'chiddarwala', label: 'Chiddarwala', pincode: '248141' },
  { value: 'doiwala', label: 'Doiwala', pincode: '248140' },
  { value: 'gandhi-road', label: 'Gandhi Road', pincode: '248001' },
  { value: 'ghantaghar', label: 'Ghantaghar', pincode: '248001' },
  { value: 'hathi-ki-dungri', label: 'Hathi Ki Dungri', pincode: '248195' },
  { value: 'isbt-road', label: 'ISBT Road', pincode: '248002' },
  { value: 'kansyapur', label: 'Kansyapur', pincode: '248006' },
  { value: 'keshav-pur', label: 'Keshav Pur', pincode: '248001' },
  { value: 'kmvn-road', label: 'KMVN Road', pincode: '248001' },
  { value: 'moti-bazaar', label: 'Moti Bazaar', pincode: '248001' },
  { value: 'mussoorie-road', label: 'Mussoorie Road', pincode: '248001' },
  { value: 'nehrugram-ii', label: 'Nehrugram II', pincode: '248001' },
  { value: 'prem-nagar', label: 'Prem Nagar', pincode: '248007' },
  { value: 'raipur-ii', label: 'Raipur II', pincode: '248001' },
  { value: 'rishikesh-road', label: 'Rishikesh Road', pincode: '248001' },
  { value: 'sahastradhara-extension', label: 'Sahastradhara Extension', pincode: '248001' },
  { value: 'tandwala', label: 'Tandwala', pincode: '248001' },
  { value: 'tirath-road', label: 'Tirath Road', pincode: '248001' },
  { value: 'vikas-nagar', label: 'Vikas Nagar', pincode: '248198' },
  { value: 'vishnu-puram', label: 'Vishnu Puram', pincode: '248003' }
  ],
  
  'nainital': [
  { value: 'balmiki-basti', label: 'Balmiki Basti', pincode: '263001' },
  { value: 'bhotia-patthar', label: 'Bhotia Patthar', pincode: '263001' },
  { value: 'binakhand', label: 'Binakhand', pincode: '263126' },
  { value: 'dalgaad', label: 'Dalgaad', pincode: '263135' },
  { value: 'devi-kot', label: 'Devi Kot', pincode: '263137' },
  { value: 'gaya-gad', label: 'Gaya Gad', pincode: '263157' },
  { value: 'gularbhoj', label: 'Gularbhoj', pincode: '263132' },
  { value: 'hala-dhar', label: 'Hala Dhar', pincode: '263135' },
  { value: 'kathgodam', label: 'Kathgodam', pincode: '263126' },
  { value: 'khurpatal', label: 'Khurpatal', pincode: '263001' },
  { value: 'mahananda', label: 'Mahananda', pincode: '263001' },
  { value: 'mall-road', label: 'Mall Road', pincode: '263001' },
  { value: 'nainital-cantonment', label: 'Nainital Cantonment', pincode: '263001' },
  { value: 'naini-lake', label: 'Naini Lake', pincode: '263001' },
  { value: 'patri-bhagwan', label: 'Patri Bhagwan', pincode: '263139' },
  { value: 'pinnath', label: 'Pinnath', pincode: '263001' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '244715' },
  { value: 'tallital', label: 'Tallital', pincode: '263001' },
  { value: 'tunga', label: 'Tunga', pincode: '263158' },
  { value: 'zoo-road', label: 'Zoo Road', pincode: '263001' },
  { value: 'amdhara', label: 'Amdhara', pincode: '263158' },
  { value: 'barkot', label: 'Barkot', pincode: '263124' },
  { value: 'bhimtal', label: 'Bhimtal', pincode: '263136' },
  { value: 'buda-kote', label: 'Buda Kote', pincode: '263126' },
  { value: 'dhanachuli', label: 'Dhanachuli', pincode: '263132' },
  { value: 'haldwani', label: 'Haldwani', pincode: '263139' },
  { value: 'khairna', label: 'Khairna', pincode: '263124' },
  { value: 'khud-bhimtal', label: 'Khud Bhimtal', pincode: '263136' },
  { value: 'kosi', label: 'Kosi', pincode: '263136' },
  { value: 'lalkuan', label: 'Lalkuan', pincode: '263139' },
  { value: 'marchula', label: 'Marchula', pincode: '263132' },
  { value: 'nainital-garh', label: 'Nainital Garh', pincode: '263001' },
  { value: 'new-shimla', label: 'New Shimla', pincode: '263135' },
  { value: 'ramganga', label: 'Ramganga', pincode: '263135' },
  { value: 'sattal', label: 'Sattal', pincode: '263136' },
  { value: 'shyamlatal', label: 'Shyamlatal', pincode: '263136' },
  { value: 'tallital-extension', label: 'Tallital Extension', pincode: '263001' },
  { value: 'tota-ka-talli', label: 'Tota Ka Talli', pincode: '263127' }
  ],
  
  'haridwar': [
  { value: 'ashram-bhoomi', label: 'Ashram Bhoomi', pincode: '249401' },
  { value: 'bhupatwala', label: 'Bhupatwala', pincode: '249408' },
  { value: 'chandi-ghat', label: 'Chandi Ghat', pincode: '249401' },
  { value: 'devpura', label: 'Devpura', pincode: '249401' },
  { value: 'dhandera', label: 'Dhandera', pincode: '249404' },
  { value: 'har-ki-pauri', label: 'Har Ki Pauri', pincode: '249401' },
  { value: 'jhanda-mandi', label: 'Jhanda Mandi', pincode: '249401' },
  { value: 'kankhal', label: 'Kankhal', pincode: '249408' },
  { value: 'mansa-devi', label: 'Mansa Devi', pincode: '249401' },
  { value: 'mundal', label: 'Mundal', pincode: '249404' },
  { value: 'niketan', label: 'Niketan', pincode: '249408' },
  { value: 'roorkee', label: 'Roorkee', pincode: '247667' },
  { value: 'sapt-rishi', label: 'Sapt Rishi', pincode: '249401' },
  { value: 'shiv-mandir', label: 'Shiv Mandir', pincode: '249401' },
  { value: 'shivalik-nagar', label: 'Shivalik Nagar', pincode: '249403' },
  { value: 'sidcul', label: 'SIDCUL', pincode: '249403' },
  { value: 'sitarampur', label: 'Sitarampur', pincode: '249402' },
  { value: 'tirathraj', label: 'Tirathraj', pincode: '249408' },
  { value: 'ved-mandir', label: 'Ved Mandir', pincode: '249401' },
  { value: 'vishwakarma', label: 'Vishwakarma', pincode: '249401' },
  { value: 'yogi-bhavans', label: 'Yogi Bhavans', pincode: '249404' },
  { value: 'bhel', label: 'BHEL', pincode: '249403' },
  { value: 'bhimgoda', label: 'Bhimgoda', pincode: '249401' },
  { value: 'bhoodi', label: 'Bhoodi', pincode: '249402' },
  { value: 'chandpur', label: 'Chandpur', pincode: '249407' },
  { value: 'haridwar-railway-station', label: 'Haridwar Railway Station', pincode: '249401' },
  { value: 'kanalsi', label: 'Kanalsi', pincode: '249401' },
  { value: 'kishanpur', label: 'Kishanpur', pincode: '249406' },
  { value: 'motichur', label: 'Motichur', pincode: '249403' },
  { value: 'nanak-mandi', label: 'Nanak Mandi', pincode: '249401' },
  { value: 'roorkee-bypass', label: 'Roorkee Bypass', pincode: '247667' },
  { value: 'shivalik-enclave', label: 'Shivalik Enclave', pincode: '249403' }
  ],
  
  'haldwani': [
  { value: 'aliganj', label: 'Aliganj', pincode: '263139' },
  { value: 'balawala', label: 'Balawala', pincode: '263139' },
  { value: 'banbasa', label: 'Banbasa', pincode: '263139' },
  { value: 'chorgalia', label: 'Chorgalia', pincode: '263139' },
  { value: 'gauravpur', label: 'Gauravpur', pincode: '263139' },
  { value: 'haldwani-bypass', label: 'Haldwani Bypass', pincode: '263139' },
  { value: 'kathgodam', label: 'Kathgodam', pincode: '263126' },
  { value: 'khaspura', label: 'Khaspura', pincode: '263139' },
  { value: 'mukteshwar', label: 'Mukteshwar', pincode: '263138' },
  { value: 'nainital-road', label: 'Nainital Road', pincode: '263139' },
  { value: 'patparganj', label: 'Patparganj', pincode: '263139' },
  { value: 'phoolbagh', label: 'Phoolbagh', pincode: '263139' },
  { value: 'sitaram', label: 'Sitaram', pincode: '263139' },
  { value: 'sonanadi', label: 'Sonanadi', pincode: '263129' },
  { value: 'sukhatal', label: 'Sukhatal', pincode: '263126' },
  { value: 'talli', label: 'Talli', pincode: '263139' },
  { value: 'tata-wala', label: 'Tata Wala', pincode: '263139' },
  { value: 'tirathpuri', label: 'Tirathpuri', pincode: '263139' },
  { value: 'vikramshila', label: 'Vikramshila', pincode: '263139' },
  { value: 'choudhary', label: 'Choudhary', pincode: '263139' },
  { value: 'dhoura', label: 'Dhoura', pincode: '263139' },
  { value: 'fattehpur', label: 'Fattehpur', pincode: '263139' },
  { value: 'gagaon', label: 'Gagaon', pincode: '263139' },
  { value: 'jainpur', label: 'Jainpur', pincode: '263139' },
  { value: 'kali-mandi', label: 'Kali Mandi', pincode: '263139' },
  { value: 'khatima', label: 'Khatima', pincode: '263139' },
  { value: 'madhupur', label: 'Madhupur', pincode: '263139' },
  { value: 'rishikesh', label: 'Rishikesh', pincode: '263139' },
  { value: 'sidcul', label: 'SIDCUL', pincode: '263139' }
  ],
  
  'ramnagar': [
  { value: 'ashram', label: 'Ashram', pincode: '244715' },
  { value: 'bajpur', label: 'Bajpur', pincode: '244712' },
  { value: 'banoli', label: 'Banoli', pincode: '244715' },
  { value: 'bhagatpur', label: 'Bhagatpur', pincode: '244715' },
  { value: 'chhapparia', label: 'Chhapparia', pincode: '244715' },
  { value: 'chilla', label: 'Chilla', pincode: '244715' },
  { value: 'haripur', label: 'Haripur', pincode: '244715' },
  { value: 'kathgodam', label: 'Kathgodam', pincode: '263126' },
  { value: 'khamariya', label: 'Khamariya', pincode: '244715' },
  { value: 'kosi', label: 'Kosi', pincode: '244715' },
  { value: 'manglaur', label: 'Manglaur', pincode: '244715' },
  { value: 'nanakmatta', label: 'Nanakmatta', pincode: '244713' },
  { value: 'ranipur', label: 'Ranipur', pincode: '244715' },
  { value: 'rishikesh', label: 'Rishikesh', pincode: '244715' },
  { value: 'sonarpur', label: 'Sonarpur', pincode: '244715' },
  { value: 'sukhata', label: 'Sukhata', pincode: '244715' },
  { value: 'talla', label: 'Talla', pincode: '244715' },
  { value: 'villageroad', label: 'Village Road', pincode: '244715' },
  { value: 'chamari', label: 'Chamari', pincode: '244715' },
  { value: 'dehra', label: 'Dehra', pincode: '244715' },
  { value: 'ganganagar', label: 'Ganganagar', pincode: '244715' },
  { value: 'hawaijala', label: 'Hawaijala', pincode: '244715' },
  { value: 'jagjitpur', label: 'Jagjitpur', pincode: '244715' },
  { value: 'kaulgarh', label: 'Kaulgarh', pincode: '244715' },
  { value: 'khawajapur', label: 'Khawajapur', pincode: '244715' },
  { value: 'lalpur', label: 'Lalpur', pincode: '244715' },
  { value: 'manpur', label: 'Manpur', pincode: '244715' },
  { value: 'neembi', label: 'Neembi', pincode: '244715' },
  { value: 'panapada', label: 'Panapada', pincode: '244715' }
  ],
  
  'uttarkashi': [
  { value: 'bhatwari', label: 'Bhatwari', pincode: '249193' },
  { value: 'chinyalisaur', label: 'Chinyalisaur', pincode: '249192' },
  { value: 'dharasu', label: 'Dharasu', pincode: '249184' },
  { value: 'gangotri', label: 'Gangotri', pincode: '249175' },
  { value: 'janaki', label: 'Janaki', pincode: '249193' },
  { value: 'maneri', label: 'Maneri', pincode: '249193' },
  { value: 'nakuri', label: 'Nakuri', pincode: '249193' },
  { value: 'naugaon', label: 'Naugaon', pincode: '249193' },
  { value: 'pulbari', label: 'Pulbari', pincode: '249193' },
  { value: 'rishikesh', label: 'Rishikesh', pincode: '249201' },
  { value: 'sarikot', label: 'Sarikot', pincode: '249193' },
  { value: 'sherpur', label: 'Sherpur', pincode: '249193' },
  { value: 'thangdhar', label: 'Thangdhar', pincode: '249193' },
  { value: 'tila', label: 'Tila', pincode: '249193' },
  { value: 'tirthi', label: 'Tirthi', pincode: '249193' },
  { value: 'uttarkashi-town', label: 'Uttarkashi Town', pincode: '249193' },
  { value: 'virbhadra', label: 'Virbhadra', pincode: '249201' },
  { value: 'chamba', label: 'Chamba', pincode: '249145' },
  { value: 'gaon', label: 'Gaon', pincode: '249196' },
  { value: 'kandai', label: 'Kandai', pincode: '249193' },
  { value: 'keshavpur', label: 'Keshavpur', pincode: '249193' },
  { value: 'kharsali', label: 'Kharsali', pincode: '249175' },
  { value: 'maiden', label: 'Maiden', pincode: '249193' },
  { value: 'neelkanth', label: 'Neelkanth', pincode: '249201' },
  { value: 'rakshak', label: 'Rakshak', pincode: '249193' },
  { value: 'sangam', label: 'Sangam', pincode: '249193' },
  { value: 'sumera', label: 'Sumera', pincode: '249193' }
  ],
    
  'rudraprayag': [
  { value: 'adwani', label: 'Adwani', pincode: '246171' },
  { value: 'chopta', label: 'Chopta', pincode: '246475' },
  { value: 'devprayag', label: 'Devprayag', pincode: '246175' },
  { value: 'garud', label: 'Garud', pincode: '246171' },
  { value: 'guptkashi', label: 'Guptkashi', pincode: '246439' },
  { value: 'kalyani', label: 'Kalyani', pincode: '246171' },
  { value: 'kedar', label: 'Kedar', pincode: '246471' },
  { value: 'mandal', label: 'Mandal', pincode: '246171' },
  { value: 'okhalkandi', label: 'Okhalkandi', pincode: '246171' },
  { value: 'rudraprayag-town', label: 'Rudraprayag Town', pincode: '246171' },
  { value: 'srinagar', label: 'Srinagar', pincode: '246174' },
  { value: 'takla', label: 'Takla', pincode: '246171' },
  { value: 'triund', label: 'Triund', pincode: '246471' },
  { value: 'bhiri', label: 'Bhiri', pincode: '246171' },
  { value: 'byasi', label: 'Byasi', pincode: '246171' },
  { value: 'chinyalisaur', label: 'Chinyalisaur', pincode: '246193' },
  { value: 'jalna', label: 'Jalna', pincode: '246171' },
  { value: 'kangani', label: 'Kangani', pincode: '246171' },
  { value: 'kankhal', label: 'Kankhal', pincode: '246171' },
  { value: 'nanda-kot', label: 'Nanda Kot', pincode: '246171' },
  { value: 'saur', label: 'Saur', pincode: '246171' },
  { value: 'tihri', label: 'Tihri', pincode: '246171' },
  { value: 'ukhimath', label: 'Ukhimath', pincode: '246469' }
  ],
  
  'rudrapur': [
  { value: 'balapura', label: 'Balapura', pincode: '263153' },
  { value: 'banbasa', label: 'Banbasa', pincode: '263153' },
  { value: 'bahadarabad', label: 'Bahadarabad', pincode: '263153' },
  { value: 'chamkoria', label: 'Chamkoria', pincode: '263153' },
  { value: 'gulabhpur', label: 'Gulabhpur', pincode: '263153' },
  { value: 'jhunjhunu', label: 'Jhunjhunu', pincode: '263153' },
  { value: 'kalyanpur', label: 'Kalyanpur', pincode: '263153' },
  { value: 'kashipur', label: 'Kashipur', pincode: '263153' },
  { value: 'khatima', label: 'Khatima', pincode: '263153' },
  { value: 'madhupur', label: 'Madhupur', pincode: '263153' },
  { value: 'nagal', label: 'Nagal', pincode: '263153' },
  { value: 'rudrapur-town', label: 'Rudrapur Town', pincode: '263153' },
  { value: 'satpuli', label: 'Satpuli', pincode: '263153' },
  { value: 'sukhpura', label: 'Sukhpura', pincode: '263153' },
  { value: 'tanda', label: 'Tanda', pincode: '263153' },
  { value: 'baladew', label: 'Baladew', pincode: '263153' },
  { value: 'chakarpur', label: 'Chakarpur', pincode: '263153' },
  { value: 'dineshpur', label: 'Dineshpur', pincode: '263153' },
  { value: 'jaspur', label: 'Jaspur', pincode: '263155' },
  { value: 'karanpur', label: 'Karanpur', pincode: '263153' },
  { value: 'keshoapur', label: 'Keshoapur', pincode: '263153' },
  { value: 'kudiyal', label: 'Kudiyal', pincode: '263153' },
  { value: 'madhopur', label: 'Madhopur', pincode: '263153' },
  { value: 'patna', label: 'Patna', pincode: '263153' },
  { value: 'rudrapur-bazar', label: 'Rudrapur Bazar', pincode: '263153' },
  { value: 'satpura', label: 'Satpura', pincode: '263153' }
  ],
  
  'bageshwar': [
  { value: 'bageshwar-town', label: 'Bageshwar Town', pincode: '263642' },
  { value: 'baijnath', label: 'Baijnath', pincode: '263661' },
  { value: 'barakot', label: 'Barakot', pincode: '263642' },
  { value: 'bharadi', label: 'Bharadi', pincode: '263642' },
  { value: 'chakori', label: 'Chakori', pincode: '263642' },
  { value: 'garur', label: 'Garur', pincode: '263641' },
  { value: 'jakh', label: 'Jakh', pincode: '263642' },
  { value: 'kanthari', label: 'Kanthari', pincode: '263642' },
  { value: 'kapat', label: 'Kapat', pincode: '263642' },
  { value: 'khyari', label: 'Khyari', pincode: '263642' },
  { value: 'kumaon', label: 'Kumaon', pincode: '263642' },
  { value: 'pali', label: 'Pali', pincode: '263642' },
  { value: 'ramganga', label: 'Ramganga', pincode: '263642' },
  { value: 'rithani', label: 'Rithani', pincode: '263642' },
  { value: 'seema', label: 'Seema', pincode: '263642' },
  { value: 'sugari', label: 'Sugari', pincode: '263642' },
  { value: 'adampur', label: 'Adampur', pincode: '263642' },
  { value: 'alipur', label: 'Alipur', pincode: '263642' },
  { value: 'bandi', label: 'Bandi', pincode: '263642' },
  { value: 'bela', label: 'Bela', pincode: '263642' },
  { value: 'dudiyal', label: 'Dudiyal', pincode: '263642' },
  { value: 'jitpur', label: 'Jitpur', pincode: '263642' },
  { value: 'khanpur', label: 'Khanpur', pincode: '263642' },
  { value: 'khunt', label: 'Khunt', pincode: '263642' },
  { value: 'mashwara', label: 'Mashwara', pincode: '263642' },
  { value: 'okhalkanda', label: 'Okhalkanda', pincode: '263641' },
  { value: 'palri', label: 'Palri', pincode: '263642' },
  { value: 'purnagiri', label: 'Purnagiri', pincode: '263642' },
  { value: 'satpuli', label: 'Satpuli', pincode: '263642' }
  ],
  
  'badrinath': [
  { value: 'badrinath-town', label: 'Badrinath Town', pincode: '246422' },
  { value: 'brahmakapal', label: 'Brahma Kapal', pincode: '246422' },
  { value: 'chamoli', label: 'Chamoli', pincode: '246419' },
  { value: 'garur', label: 'Garur', pincode: '246419' },
  { value: 'gurudwara', label: 'Gurudwara', pincode: '246422' },
  { value: 'joshimath', label: 'Joshimath', pincode: '246443' },
  { value: 'kalpeshwar', label: 'Kalpeshwar', pincode: '246442' },
  { value: 'mana-village', label: 'Mana Village', pincode: '246422' },
  { value: 'malari', label: 'Malari', pincode: '246428' },
  { value: 'nilkanth', label: 'Nilkanth', pincode: '246422' },
  { value: 'pangti-village', label: 'Pangti Village', pincode: '246443' },
  { value: 'phata', label: 'Phata', pincode: '246424' },
  { value: 'srinagar', label: 'Srinagar', pincode: '246174' },
  { value: 'vishnu-prayer', label: 'Vishnu Prayer', pincode: '246422' },
  { value: 'bamsar', label: 'Bamsar', pincode: '246424' },
  { value: 'bhari', label: 'Bhari', pincode: '246419' },
  { value: 'council-garh', label: 'Council Garh', pincode: '246443' },
  { value: 'dhungri', label: 'Dhungri', pincode: '246419' },
  { value: 'kalu', label: 'Kalu', pincode: '246425' },
  { value: 'kund', label: 'Kund', pincode: '246425' },
  { value: 'kirtinagar', label: 'Kirtinagar', pincode: '246431' },
  { value: 'tatachham', label: 'Tatachham', pincode: '246443' }
  ],
  
  'kedarnath': [
  { value: 'badrinath-town', label: 'Badrinath Town', pincode: '246422' },
  { value: 'brahmakapal', label: 'Brahma Kapal', pincode: '246422' },
  { value: 'chamoli', label: 'Chamoli', pincode: '246419' },
  { value: 'garur', label: 'Garur', pincode: '246419' },
  { value: 'gurudwara', label: 'Gurudwara', pincode: '246422' },
  { value: 'joshimath', label: 'Joshimath', pincode: '246443' },
  { value: 'kalpeshwar', label: 'Kalpeshwar', pincode: '246442' },
  { value: 'kedarnath-town', label: 'Kedarnath Town', pincode: '246445' },
  { value: 'kund', label: 'Kund', pincode: '246425' },
  { value: 'mana-village', label: 'Mana Village', pincode: '246422' },
  { value: 'malari', label: 'Malari', pincode: '246428' },
  { value: 'nilkanth', label: 'Nilkanth', pincode: '246422' },
  { value: 'phata', label: 'Phata', pincode: '246424' },
  { value: 'srinagar', label: 'Srinagar', pincode: '246174' },
  { value: 'vishnu-prayer', label: 'Vishnu Prayer', pincode: '246422' },
  { value: 'bamsar', label: 'Bamsar', pincode: '246424' },
  { value: 'kalu', label: 'Kalu', pincode: '246425' },
  { value: 'kirtinagar', label: 'Kirtinagar', pincode: '246431' },
  { value: 'dhungri', label: 'Dhungri', pincode: '246419' },
  { value: 'council-garh', label: 'Council Garh', pincode: '246443' },
  { value: 'tatachham', label: 'Tatachham', pincode: '246443' },
  { value: 'garh-brahmakamal', label: 'Garh Brahmakamal', pincode: '246443' }
  ],

//Manipur
  'imphal': [
  { value: 'awang-leikai', label: 'Awang Leikai', pincode: '795001' },
  { value: 'bishnupur', label: 'Bishnupur', pincode: '795126' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '795003' },
  { value: 'cheirap', label: 'Cheirap', pincode: '795004' },
  { value: 'chinga', label: 'Chinga', pincode: '795009' },
  { value: 'hiyangthang', label: 'Hiyangthang', pincode: '795001' },
  { value: 'khurai', label: 'Khurai', pincode: '795010' },
  { value: 'lamphel', label: 'Lamphel', pincode: '795004' },
  { value: 'lilong', label: 'Lilong', pincode: '795130' },
  { value: 'mantripukhri', label: 'Mantripukhri', pincode: '795002' },
  { value: 'mingal', label: 'Mingal', pincode: '795014' },
  { value: 'moirang', label: 'Moirang', pincode: '795133' },
  { value: 'nambol', label: 'Nambol', pincode: '795134' },
  { value: 'ngorong', label: 'Ngorong', pincode: '795130' },
  { value: 'pangong', label: 'Pangong', pincode: '795138' },
  { value: 'sangaiprou', label: 'Sangaiprou', pincode: '795008' },
  { value: 'sangakpham', label: 'Sangakpham', pincode: '795004' },
  { value: 'sekmai', label: 'Sekmai', pincode: '795114' },
  { value: 'shangshak', label: 'Shangshak', pincode: '795123' },
  { value: 'thangmeiband', label: 'Thangmeiband', pincode: '795001' },
  { value: 'tubung', label: 'Tubung', pincode: '795127' },
  { value: 'pangei', label: 'Pangei', pincode: '795009' },
  { value: 'tingri', label: 'Tingri', pincode: '795126' },
  { value: 'mangjiri', label: 'Mangjiri', pincode: '795130' },
  { value: 'yalipok', label: 'Yalipok', pincode: '795003' },
  { value: 'wangkhei', label: 'Wangkhei', pincode: '795002' },
  { value: 'tulihal', label: 'Tulihal', pincode: '795014' },
  { value: 'heirango', label: 'Heirango', pincode: '795016' },
  { value: 'khabam', label: 'Khabam', pincode: '795004' }
  ],
  
  'ukhrul': [
  { value: 'angou-khullen', label: 'Angou Khullen', pincode: '795142' },
  { value: 'apangthong', label: 'Apangthong', pincode: '795141' },
  { value: 'chingshany', label: 'Chingshany', pincode: '795142' },
  { value: 'khayang', label: 'Khayang', pincode: '795143' },
  { value: 'kharasom', label: 'Kharasom', pincode: '795144' },
  { value: 'khamasom', label: 'Khamasom', pincode: '795141' },
  { value: 'khuimang', label: 'Khuimang', pincode: '795141' },
  { value: 'kungai', label: 'Kungai', pincode: '795142' },
  { value: 'kuthing', label: 'Kuthing', pincode: '795141' },
  { value: 'mangrei', label: 'Mangrei', pincode: '795140' },
  { value: 'phungyar', label: 'Phungyar', pincode: '795149' },
  { value: 'phungyar-village', label: 'Phungyar Village', pincode: '795149' },
  { value: 'rangkhung', label: 'Rangkhung', pincode: '795143' },
  { value: 'tunggam', label: 'Tunggam', pincode: '795146' },
  { value: 'ukhrul-town', label: 'Ukhrul Town', pincode: '795142' },
  { value: 'zeme', label: 'Zeme', pincode: '795145' },
  { value: 'shikhong', label: 'Shikhong', pincode: '795147' },
  { value: 'chawang', label: 'Chawang', pincode: '795148' },
  { value: 'hapta', label: 'Hapta', pincode: '795142' },
  { value: 'khoijang', label: 'Khoijang', pincode: '795142' },
  { value: 'khangkhui', label: 'Khangkhui', pincode: '795141' },
  { value: 'khangkhui-village', label: 'Khangkhui Village', pincode: '795141' },
  { value: 'phungshak', label: 'Phungshak', pincode: '795143' }
  ],
  
  'churachandpur': [
  { value: 'bongjang', label: 'Bongjang', pincode: '795128' },
  { value: 'churachandpur-town', label: 'Churachandpur Town', pincode: '795128' },
  { value: 'haolai', label: 'Haolai', pincode: '795133' },
  { value: 'hurhuran', label: 'Hurhuran', pincode: '795134' },
  { value: 'khangpao', label: 'Khangpao', pincode: '795135' },
  { value: 'khuljang', label: 'Khuljang', pincode: '795136' },
  { value: 'khoijang', label: 'Khoijang', pincode: '795137' },
  { value: 'lamka', label: 'Lamka', pincode: '795128' },
  { value: 'lailong', label: 'Lailong', pincode: '795132' },
  { value: 'lienthang', label: 'Lienthang', pincode: '795138' },
  { value: 'mualphai', label: 'Mualphai', pincode: '795129' },
  { value: 'new-lamka', label: 'New Lamka', pincode: '795130' },
  { value: 'thangjing', label: 'Thangjing', pincode: '795131' },
  { value: 'tuibong', label: 'Tuibong', pincode: '795141' },
  { value: 'vengnuom', label: 'Vengnuom', pincode: '795139' },
  { value: 'lempong', label: 'Lempong', pincode: '795137' },
  { value: 'songphel', label: 'Songphel', pincode: '795135' },
  { value: 'rangte', label: 'Rangte', pincode: '795136' },
  { value: 'senvai', label: 'Senvai', pincode: '795138' },
  { value: 'kumbi', label: 'Kumbi', pincode: '795130' }
  ],
  
  'chandel': [
  { value: 'bamon', label: 'Bamon', pincode: '795129' },
  { value: 'chandel-town', label: 'Chandel Town', pincode: '795127' },
  { value: 'heirom', label: 'Heirom', pincode: '795130' },
  { value: 'khongjaron', label: 'Khongjaron', pincode: '795132' },
  { value: 'kumbi', label: 'Kumbi', pincode: '795131' },
  { value: 'leimatak', label: 'Leimatak', pincode: '795128' },
  { value: 'lokchao', label: 'Lokchao', pincode: '795133' },
  { value: 'mayai', label: 'Mayai', pincode: '795134' },
  { value: 'phouma', label: 'Phouma', pincode: '795135' },
  { value: 'samurou', label: 'Samurou', pincode: '795136' },
  { value: 'sehlon', label: 'Sehlon', pincode: '795137' },
  { value: 'tengnoupal', label: 'Tengnoupal', pincode: '795139' },
  { value: 'thongjao', label: 'Thongjao', pincode: '795140' },
  { value: 'awangkhul', label: 'Awangkhul', pincode: '795141' },
  { value: 'thangjing', label: 'Thangjing', pincode: '795142' },
  { value: 'waithou', label: 'Waithou', pincode: '795143' },
  { value: 'phailen', label: 'Phailen', pincode: '795144' },
  { value: 'pallel', label: 'Pallel', pincode: '795145' },
  { value: 'sangaithel', label: 'Sangaithel', pincode: '795146' },
  { value: 'nungba', label: 'Nungba', pincode: '795147' }
  ],

  'imphal-east': [
  { value: 'imphal', label: 'Imphal', pincode: '795001' },
  { value: 'kangchup', label: 'Kangchup', pincode: '795107' },
  { value: 'karong', label: 'Karong', pincode: '795148' },
  { value: 'lilong', label: 'Lilong', pincode: '795134' },
  { value: 'churachandpur', label: 'Churachandpur', pincode: '795128' },
  { value: 'keirao', label: 'Keirao', pincode: '795116' },
  { value: 'sangakpham', label: 'Sangakpham', pincode: '795146' },
  { value: 'chakpikarong', label: 'Chakpikarong', pincode: '795105' },
  { value: 'bamon kampu', label: 'Bamon Kampu', pincode: '795126' },
  { value: 'patsoi', label: 'Patsoi', pincode: '795148' },
  { value: 'thoubal', label: 'Thoubal', pincode: '795138' },
  { value: 'kakhulong', label: 'Kakhulong', pincode: '795134' },
  { value: 'phailen', label: 'Phailen', pincode: '795142' },
  { value: 'kangla', label: 'Kangla', pincode: '795101' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '795145' },
  { value: 'moirang', label: 'Moirang', pincode: '795127' },
  { value: 'waikhong', label: 'Waikhong', pincode: '795105' },
  { value: 'kumbi', label: 'Kumbi', pincode: '795132' },
  { value: 'shikhong', label: 'Shikhong', pincode: '795124' },
  { value: 'loishang', label: 'Loishang', pincode: '795119' },
  { value: 'kakching', label: 'Kakching', pincode: '795103' },
  { value: 'nongpok sekmai', label: 'Nongpok Sekmai', pincode: '795135' },
  { value: 'phayeng', label: 'Phayeng', pincode: '795121' },
  { value: 'tangkhul', label: 'Tangkhul', pincode: '795122' }
  ],
  
  'imphal-west': [
  { value: 'imphal', label: 'Imphal', pincode: '795001' },
  { value: 'lamphel', label: 'Lamphel', pincode: '795004' },
  { value: 'kongba', label: 'Kongba', pincode: '795002' },
  { value: 'patsoi', label: 'Patsoi', pincode: '795148' },
  { value: 'sangaiprou', label: 'Sangaiprou', pincode: '795010' },
  { value: 'khabam', label: 'Khabam', pincode: '795003' },
  { value: 'kakwa', label: 'Kakwa', pincode: '795008' },
  { value: 'babupara', label: 'Babupara', pincode: '795110' },
  { value: 'keishamthong', label: 'Keishamthong', pincode: '795001' },
  { value: 'thangal bazar', label: 'Thangal Bazar', pincode: '795001' },
  { value: 'khoijuman', label: 'Khoijuman', pincode: '795002' },
  { value: 'mayang imphal', label: 'Mayang Imphal', pincode: '795114' },
  { value: 'yangdong', label: 'Yangdong', pincode: '795111' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '795105' },
  { value: 'uripok', label: 'Uripok', pincode: '795001' },
  { value: 'lamphelpat', label: 'Lamphelpat', pincode: '795004' },
  { value: 'porompat', label: 'Porompat', pincode: '795010' },
  { value: 'langol', label: 'Langol', pincode: '795103' },
  { value: 'ningombam', label: 'Ningombam', pincode: '795118' },
  { value: 'mantripukhri', label: 'Mantripukhri', pincode: '795004' },
  { value: 'chajing', label: 'Chajing', pincode: '795122' },
  { value: 'sangaiyumpham', label: 'Sangaiyumpham', pincode: '795116' },
  { value: 'keirao bitra', label: 'Keirao Bitra', pincode: '795130' }
  ],
  
  'kakching': [
  { value: 'alung', label: 'Alung', pincode: '795103' },
  { value: 'andro', label: 'Andro', pincode: '795129' },
  { value: 'boljang', label: 'Boljang', pincode: '795118' },
  { value: 'chakpikarong', label: 'Chakpikarong', pincode: '795132' },
  { value: 'kachikhul', label: 'Kachikhul', pincode: '795103' },
  { value: 'kaothel', label: 'Kaothel', pincode: '795135' },
  { value: 'kakching khunou', label: 'Kakching Khunou', pincode: '795103' },
  { value: 'kakching waikhong', label: 'Kakching Waikhong', pincode: '795112' },
  { value: 'lamding', label: 'Lamding', pincode: '795103' },
  { value: 'machi', label: 'Machi', pincode: '795126' },
  { value: 'mayang imphal', label: 'Mayang Imphal', pincode: '795114' },
  { value: 'phayeng', label: 'Phayeng', pincode: '795131' },
  { value: 'pokpi', label: 'Pokpi', pincode: '795101' },
  { value: 'sangaiprou', label: 'Sangaiprou', pincode: '795110' },
  { value: 'sangaiyumpham', label: 'Sangaiyumpham', pincode: '795116' },
  { value: 'thoubal', label: 'Thoubal', pincode: '795138' },
  { value: 'kumbi', label: 'Kumbi', pincode: '795132' },
  { value: 'chakpa', label: 'Chakpa', pincode: '795127' },
  { value: 'wadung', label: 'Wadung', pincode: '795105' },
  { value: 'irengbam', label: 'Irengbam', pincode: '795129' },
  { value: 'loitang', label: 'Loitang', pincode: '795115' },
  { value: 'kongba', label: 'Kongba', pincode: '795114' },
  { value: 'chando', label: 'Chando', pincode: '795134' }
  ],
  
  'kamjong': [
  { value: 'akutpa', label: 'Akutpa', pincode: '795102' },
  { value: 'kamjong town', label: 'Kamjong Town', pincode: '795104' },
  { value: 'kachai', label: 'Kachai', pincode: '795103' },
  { value: 'kangchup', label: 'Kangchup', pincode: '795119' },
  { value: 'khuning', label: 'Khuning', pincode: '795113' },
  { value: 'leimakhong', label: 'Leimakhong', pincode: '795120' },
  { value: 'nambol', label: 'Nambol', pincode: '795126' },
  { value: 'somdal', label: 'Somdal', pincode: '795122' },
  { value: 'sugnu', label: 'Sugnu', pincode: '795125' },
  { value: 'yairipok', label: 'Yairipok', pincode: '795128' },
  { value: 'tangjeng', label: 'Tangjeng', pincode: '795114' },
  { value: 'shangshak', label: 'Shangshak', pincode: '795130' },
  { value: 'phungyar', label: 'Phungyar', pincode: '795121' },
  { value: 'khunou', label: 'Khunou', pincode: '795107' },
  { value: 'sora', label: 'Sora', pincode: '795106' },
  { value: 'waching', label: 'Waching', pincode: '795110' },
  { value: 'ramgaijang', label: 'Ramgaijang', pincode: '795105' },
  { value: 'kamjong khunou', label: 'Kamjong Khunou', pincode: '795104' },
  { value: 'maraiphai', label: 'Maraiphai', pincode: '795108' },
  { value: 'katang', label: 'Katang', pincode: '795109' },
  { value: 'longmai', label: 'Longmai', pincode: '795111' }
  ],
  
  'kangpokpi': [
  { value: 'alangkhu', label: 'Alangkhu', pincode: '795107' },
  { value: 'kangpokpi town', label: 'Kangpokpi Town', pincode: '795122' },
  { value: 'keithelmanbi', label: 'Keithelmanbi', pincode: '795126' },
  { value: 'khongnem', label: 'Khongnem', pincode: '795119' },
  { value: 'komlathabi', label: 'Komlathabi', pincode: '795114' },
  { value: 'kuki', label: 'Kuki', pincode: '795130' },
  { value: 'leimakhong', label: 'Leimakhong', pincode: '795120' },
  { value: 'luangmang', label: 'Luangmang', pincode: '795131' },
  { value: 'nambol', label: 'Nambol', pincode: '795126' },
  { value: 'new kate', label: 'New Kate', pincode: '795123' },
  { value: 'ongma', label: 'Ongma', pincode: '795110' },
  { value: 'pangjang', label: 'Pangjang', pincode: '795121' },
  { value: 'saitu', label: 'Saitu', pincode: '795118' },
  { value: 'tiddim road', label: 'Tiddim Road', pincode: '795102' },
  { value: 'tollong', label: 'Tollong', pincode: '795120' },
  { value: 'tunghung', label: 'Tunghung', pincode: '795127' },
  { value: 'singhat', label: 'Singhat', pincode: '795116' },
  { value: 'churachandpur', label: 'Churachandpur', pincode: '795103' },
  { value: 'phai', label: 'Phai', pincode: '795115' },
  { value: 'kangkhul', label: 'Kangkhul', pincode: '795128' },
  { value: 'heibong', label: 'Heibong', pincode: '795124' },
  { value: 'uripok', label: 'Uripok', pincode: '795109' }
  ],
  
  'pherzawl': [
  { value: 'bungmual', label: 'Bungmual', pincode: '795121' },
  { value: 'churachandpur', label: 'Churachandpur', pincode: '795103' },
  { value: 'longkhai', label: 'Longkhai', pincode: '795132' },
  { value: 'pulsang', label: 'Pulsang', pincode: '795130' },
  { value: 'rengkai', label: 'Rengkai', pincode: '795124' },
  { value: 'samulamlan', label: 'Samulamlan', pincode: '795123' },
  { value: 'sihai', label: 'Sihai', pincode: '795125' },
  { value: 'thangjing', label: 'Thangjing', pincode: '795122' },
  { value: 'tualmang', label: 'Tualmang', pincode: '795133' },
  { value: 'vangai', label: 'Vangai', pincode: '795131' },
  { value: 'zoveng', label: 'Zoveng', pincode: '795134' },
  { value: 'haokha', label: 'Haokha', pincode: '795137' },
  { value: 'kaingang', label: 'Kaingang', pincode: '795138' },
  { value: 'lamka', label: 'Lamka', pincode: '795135' },
  { value: 'khudengthabi', label: 'Khudengthabi', pincode: '795136' },
  { value: 'ngamkhai', label: 'Ngamkhai', pincode: '795139' },
  { value: 'phaileng', label: 'Phaileng', pincode: '795140' },
  { value: 'serlui', label: 'Serlui', pincode: '795141' },
  { value: 'thadou', label: 'Thadou', pincode: '795142' },
  { value: 'tlangsam', label: 'Tlangsam', pincode: '795143' }
  ],

  'noney': [
  { value: 'bungmual', label: 'Bungmual', pincode: '795149' },
  { value: 'chungchung', label: 'Chungchung', pincode: '795148' },
  { value: 'khamrong', label: 'Khamrong', pincode: '795150' },
  { value: 'longmai', label: 'Longmai', pincode: '795151' },
  { value: 'noney-town', label: 'Noney Town', pincode: '795152' },
  { value: 'samurou', label: 'Samurou', pincode: '795153' },
  { value: 'tudeng', label: 'Tudeng', pincode: '795154' },
  { value: 'bazar', label: 'Bazar', pincode: '795155' },
  { value: 'koirao', label: 'Koirao', pincode: '795156' },
  { value: 'nungshong', label: 'Nungshong', pincode: '795157' },
  { value: 'phungchung', label: 'Phungchung', pincode: '795158' },
  { value: 'rengpang', label: 'Rengpang', pincode: '795159' },
  { value: 'sengmai', label: 'Sengmai', pincode: '795160' },
  { value: 'tobu', label: 'Tobu', pincode: '795161' }
  ],
  
  'tamenglong': [
  { value: 'adang', label: 'Adang', pincode: '795141' },
  { value: 'bairou', label: 'Bairou', pincode: '795142' },
  { value: 'haripung', label: 'Haripung', pincode: '795143' },
  { value: 'kaiphung', label: 'Kaiphung', pincode: '795144' },
  { value: 'khamnang', label: 'Khamnang', pincode: '795151' },
  { value: 'longmai', label: 'Longmai', pincode: '795145' },
  { value: 'nungba', label: 'Nungba', pincode: '795146' },
  { value: 'ramting', label: 'Ramting', pincode: '795152' },
  { value: 'tamenglong-town', label: 'Tamenglong Town', pincode: '795147' },
  { value: 'tangdai', label: 'Tangdai', pincode: '795148' },
  { value: 'tousem', label: 'Tousem', pincode: '795149' },
  { value: 'tsunghai', label: 'Tsunghai', pincode: '795150' },
  { value: 'vengpui', label: 'Vengpui', pincode: '795153' },
  { value: 'zaikhom', label: 'Zaikhom', pincode: '795154' }
  ],
  
  'jiribam': [
  { value: 'akhup', label: 'Akhup', pincode: '795116' },
  { value: 'baba-khullen', label: 'Baba Khullen', pincode: '795117' },
  { value: 'bango', label: 'Bango', pincode: '795118' },
  { value: 'damdeh', label: 'Damdeh', pincode: '795119' },
  { value: 'gajak', label: 'Gajak', pincode: '795126' },
  { value: 'jitpur', label: 'Jitpur', pincode: '795127' },
  { value: 'jiribam-town', label: 'Jiribam Town', pincode: '795120' },
  { value: 'khumji', label: 'Khumji', pincode: '795121' },
  { value: 'lukhambi', label: 'Lukhambi', pincode: '795128' },
  { value: 'noney', label: 'Noney', pincode: '795122' },
  { value: 'sadar', label: 'Sadar', pincode: '795123' },
  { value: 'sunoubung', label: 'Sunoubung', pincode: '795124' },
  { value: 'tupul', label: 'Tupul', pincode: '795125' },
  { value: 'vengpui', label: 'Vengpui', pincode: '795129' },
  { value: 'warom', label: 'Warom', pincode: '795130' }
  ],
  
  'oinam': [
  { value: 'angol', label: 'Angol', pincode: '795140' },
  { value: 'changou', label: 'Changou', pincode: '795141' },
  { value: 'koni', label: 'Koni', pincode: '795142' },
  { value: 'loktak', label: 'Loktak', pincode: '795143' },
  { value: 'makha', label: 'Makha', pincode: '795144' },
  { value: 'nambol', label: 'Nambol', pincode: '795151' },
  { value: 'oinam-bazar', label: 'Oinam Bazar', pincode: '795145' },
  { value: 'phayeng', label: 'Phayeng', pincode: '795152' },
  { value: 'poumai', label: 'Poumai', pincode: '795146' },
  { value: 'saitu', label: 'Saitu', pincode: '795147' },
  { value: 'takhel', label: 'Takhel', pincode: '795148' },
  { value: 'thangjing', label: 'Thangjing', pincode: '795149' },
  { value: 'toubul', label: 'Toubul', pincode: '795150' },
  { value: 'vengjoi', label: 'Vengjoi', pincode: '795153' },
  { value: 'wangoo', label: 'Wangoo', pincode: '795154' }
  ],
  
  'thoubal': [
  { value: 'andro', label: 'Andro', pincode: '795148' },
  { value: 'changam', label: 'Changam', pincode: '795149' },
  { value: 'kakching', label: 'Kakching', pincode: '795132' },
  { value: 'lamding', label: 'Lamding', pincode: '795133' },
  { value: 'maninglong', label: 'Maninglong', pincode: '795134' },
  { value: 'moirang', label: 'Moirang', pincode: '795133' },
  { value: 'seijang', label: 'Seijang', pincode: '795135' },
  { value: 'sekmai', label: 'Sekmai', pincode: '795145' },
  { value: 'shangshak', label: 'Shangshak', pincode: '795149' },
  { value: 'singhat', label: 'Singhat', pincode: '795136' },
  { value: 'thoubal-bazar', label: 'Thoubal Bazar', pincode: '795138' },
  { value: 'thoubal-municipal', label: 'Thoubal Municipal', pincode: '795139' },
  { value: 'uchathol', label: 'Uchathol', pincode: '795137' },
  { value: 'wangjing', label: 'Wangjing', pincode: '795146' },
  { value: 'yairipok', label: 'Yairipok', pincode: '795151' }
  ],
  
  'bishnupur': [
  { value: 'bishnupur-bazar', label: 'Bishnupur Bazar', pincode: '795126' },
  { value: 'churachandpur', label: 'Churachandpur', pincode: '795128' },
  { value: 'hiyanglam', label: 'Hiyanglam', pincode: '795134' },
  { value: 'kakching', label: 'Kakching', pincode: '795132' },
  { value: 'kongjengbam', label: 'Kongjengbam', pincode: '795125' },
  { value: 'lamding', label: 'Lamding', pincode: '795133' },
  { value: 'mangchung', label: 'Mangchung', pincode: '795124' },
  { value: 'moirang', label: 'Moirang', pincode: '795133' },
  { value: 'nongpok', label: 'Nongpok', pincode: '795135' },
  { value: 'shangshak', label: 'Shangshak', pincode: '795149' },
  { value: 'thoubal', label: 'Thoubal', pincode: '795138' },
  { value: 'wangjing', label: 'Wangjing', pincode: '795146' },
  { value: 'tungnam', label: 'Tungnam', pincode: '795150' },
  { value: 'sekmai', label: 'Sekmai', pincode: '795145' },
  { value: 'moirangpurel', label: 'Moirangpurel', pincode: '795131' },
  { value: 'ningthoukhong', label: 'Ningthoukhong', pincode: '795137' },
  { value: 'phayeng', label: 'Phayeng', pincode: '795139' },
  { value: 'thongju', label: 'Thongju', pincode: '795140' }
  ],
  
  'tengnoupal': [
  { value: 'babloi', label: 'Babloi', pincode: '795148' },
  { value: 'heirok', label: 'Heirok', pincode: '795149' },
  { value: 'kandhamal', label: 'Kandhamal', pincode: '795141' },
  { value: 'khangabok', label: 'Khangabok', pincode: '795142' },
  { value: 'langmeidong', label: 'Langmeidong', pincode: '795143' },
  { value: 'lokchao', label: 'Lokchao', pincode: '795144' },
  { value: 'moirang', label: 'Moirang', pincode: '795144' },
  { value: 'nonei', label: 'Nonei', pincode: '795145' },
  { value: 'phungyar', label: 'Phungyar', pincode: '795146' },
  { value: 'senthong', label: 'Senthong', pincode: '795147' },
  { value: 'taobungkhok', label: 'Taobungkhok', pincode: '795150' },
  { value: 'tengnoupal-bazar', label: 'Tengnoupal Bazar', pincode: '795151' },
  { value: 'chandonpokpi', label: 'Chandonpokpi', pincode: '795152' },
  { value: 'charou', label: 'Charou', pincode: '795153' },
  { value: 'pallel', label: 'Pallel', pincode: '795154' },
  { value: 'sapermina', label: 'Sapermina', pincode: '795155' },
  { value: 'wangjing', label: 'Wangjing', pincode: '795156' }
  ],
  
  'lilong': [
  { value: 'babloi', label: 'Babloi', pincode: '795148' },
  { value: 'heibong', label: 'Heibong', pincode: '795149' },
  { value: 'khangabok', label: 'Khangabok', pincode: '795150' },
  { value: 'khongjom', label: 'Khongjom', pincode: '795151' },
  { value: 'lilong-bazar', label: 'Lilong Bazar', pincode: '795152' },
  { value: 'mariyang', label: 'Mariyang', pincode: '795153' },
  { value: 'nambol', label: 'Nambol', pincode: '795154' },
  { value: 'paoyi', label: 'Paoyi', pincode: '795155' },
  { value: 'phalem', label: 'Phalem', pincode: '795156' },
  { value: 'singhat', label: 'Singhat', pincode: '795157' },
  { value: 'wangjing', label: 'Wangjing', pincode: '795158' },
  { value: 'yairipok', label: 'Yairipok', pincode: '795159' },
  { value: 'andro', label: 'Andro', pincode: '795160' },
  { value: 'chandel', label: 'Chandel', pincode: '795161' },
  { value: 'kakching', label: 'Kakching', pincode: '795162' },
  { value: 'khujai', label: 'Khujai', pincode: '795163' },
  { value: 'longa', label: 'Longa', pincode: '795164' },
  { value: 'lilong-north', label: 'Lilong North', pincode: '795165' },
  { value: 'loktak', label: 'Loktak', pincode: '795166' },
  { value: 'moreh', label: 'Moreh', pincode: '795167' },
  { value: 'shangshak', label: 'Shangshak', pincode: '795168' },
  { value: 'tengnoupal', label: 'Tengnoupal', pincode: '795169' }
  ],

//Nagaland
'englan': [
  { value: 'akuk', label: 'Akuk', pincode: '798621' },
  { value: 'chingmang', label: 'Chingmang', pincode: '798623' },
  { value: 'chishi', label: 'Chishi', pincode: '798620' },
  { value: 'khelma', label: 'Khelma', pincode: '798622' },
  { value: 'longchum', label: 'Longchum', pincode: '798624' },
  { value: 'mangkolemba', label: 'Mangkolemba', pincode: '798625' },
  { value: 'meriema', label: 'Meriema', pincode: '798626' },
  { value: 'nguza', label: 'Nguza', pincode: '798627' },
  { value: 'tebomo', label: 'Tebomo', pincode: '798628' },
  { value: 'bachu', label: 'Bachu', pincode: '798629' },
  { value: 'chashad', label: 'Chashad', pincode: '798630' },
  { value: 'holongi', label: 'Holongi', pincode: '798631' },
  { value: 'hukiye', label: 'Hukiye', pincode: '798632' },
  { value: 'khutovi', label: 'Khutovi', pincode: '798633' },
  { value: 'mazung', label: 'Mazung', pincode: '798634' },
  { value: 'sophruma', label: 'Sophruma', pincode: '798635' }
  ],
  
  'mokokchung': [
  { value: 'aliba', label: 'Aliba', pincode: '798601' },
  { value: 'chuchuyimlang', label: 'Chuchuyimlang', pincode: '798603' },
  { value: 'khensa', label: 'Khensa', pincode: '798602' },
  { value: 'merangkong', label: 'Merangkong', pincode: '798604' },
  { value: 'mokokchung-town', label: 'Mokokchung Town', pincode: '798601' },
  { value: 'mongsenyimti', label: 'Mongsenyimti', pincode: '798612' },
  { value: 'nanglong', label: 'Nanglong', pincode: '798613' },
  { value: 'tsurangkong', label: 'Tsurangkong', pincode: '798614' },
  { value: 'yimyu', label: 'Yimyu', pincode: '798615' },
  { value: 'chishi', label: 'Chishi', pincode: '798616' },
  { value: 'longsa', label: 'Longsa', pincode: '798617' },
  { value: 'lukphuk', label: 'Lukphuk', pincode: '798618' },
  { value: 'ngaiphung', label: 'Ngaiphung', pincode: '798619' },
  { value: 'tsurangkong-khel', label: 'Tsurangkong Khel', pincode: '798620' }
  ],
  
  'mon-village': [
  { value: 'changki', label: 'Changki', pincode: '798621' },
  { value: 'chen', label: 'Chen', pincode: '798622' },
  { value: 'hopong', label: 'Hopong', pincode: '798623' },
  { value: 'longwa', label: 'Longwa', pincode: '798624' },
  { value: 'mongkong', label: 'Mongkong', pincode: '798625' },
  { value: 'mon-town', label: 'Mon Town', pincode: '798601' },
  { value: 'phomching', label: 'Phomching', pincode: '798626' },
  { value: 'shan', label: 'Shan', pincode: '798627' },
  { value: 'thangjam', label: 'Thangjam', pincode: '798628' },
  { value: 'vongkhao', label: 'Vongkhao', pincode: '798629' },
  { value: 'achik', label: 'Achik', pincode: '798630' },
  { value: 'bungtang', label: 'Bungtang', pincode: '798631' },
  { value: 'changdong', label: 'Changdong', pincode: '798632' },
  { value: 'kongan', label: 'Kongan', pincode: '798633' },
  { value: 'mokokchung-road', label: 'Mokokchung Road', pincode: '798634' }
  ],
  
  'naginimora-hq': [
  { value: 'assam-royal', label: 'Assam Royal', pincode: '798611' },
  { value: 'dimapur-road', label: 'Dimapur Road', pincode: '798612' },
  { value: 'kutsuk', label: 'Kutsuk', pincode: '798613' },
  { value: 'longkhim', label: 'Longkhim', pincode: '798614' },
  { value: 'mongyim', label: 'Mongyim', pincode: '798615' },
  { value: 'naginimora', label: 'Naginimora', pincode: '798610' },
  { value: 'nagwan', label: 'Nagwan', pincode: '798616' },
  { value: 'ngami', label: 'Ngami', pincode: '798617' },
  { value: 'tsutsung', label: 'Tsutsung', pincode: '798618' },
  { value: 'vonglang', label: 'Vonglang', pincode: '798619' },
  { value: 'angkai', label: 'Angkai', pincode: '798620' },
  { value: 'hongpan', label: 'Hongpan', pincode: '798621' },
  { value: 'manglong', label: 'Manglong', pincode: '798622' },
  { value: 'noksen', label: 'Noksen', pincode: '798623' },
  { value: 'semang', label: 'Semang', pincode: '798624' }
  ],
  
  'phek': [
  { value: 'chizami', label: 'Chizami', pincode: '798401' },
  { value: 'khezhakeno', label: 'Khezhakeno', pincode: '798402' },
  { value: 'kongwang', label: 'Kongwang', pincode: '798403' },
  { value: 'phek-town', label: 'Phek Town', pincode: '798400' },
  { value: 'phuvishe', label: 'Phuvishe', pincode: '798404' },
  { value: 'tselagami', label: 'Tselagami', pincode: '798405' },
  { value: 'vijaypur', label: 'Vijaypur', pincode: '798406' },
  { value: 'pukhai', label: 'Pukhai', pincode: '798407' },
  { value: 'zulu', label: 'Zulu', pincode: '798408' },
  { value: 'ikong', label: 'Ikong', pincode: '798409' },
  { value: 'mokokchung-bazar', label: 'Mokokchung Bazar', pincode: '798410' },
  { value: 'kopamo', label: 'Kopamo', pincode: '798411' },
  { value: 'thele', label: 'Thele', pincode: '798412' }
  ],
  
  'tuensang': [
  { value: 'changtongya', label: 'Changtongya', pincode: '798612' },
  { value: 'chizami', label: 'Chizami', pincode: '798620' },
  { value: 'longkhim', label: 'Longkhim', pincode: '798613' },
  { value: 'noklak', label: 'Noklak', pincode: '798615' },
  { value: 'shamator', label: 'Shamator', pincode: '798616' },
  { value: 'tuensang-town', label: 'Tuensang Town', pincode: '798601' },
  { value: 'yangli', label: 'Yangli', pincode: '798602' },
  { value: 'khongsa', label: 'Khongsa', pincode: '798604' },
  { value: 'changlang', label: 'Changlang', pincode: '798617' },
  { value: 'tsangla', label: 'Tsangla', pincode: '798618' },
  { value: 'vongkhao', label: 'Vongkhao', pincode: '798619' },
  { value: 'youthang', label: 'Youthang', pincode: '798603' },
  { value: 'tholong', label: 'Tholong', pincode: '798614' }
  ],
'chümoukedima': [
  { value: 'bharalu', label: 'Bharalu', pincode: '797110' },
  { value: 'chümoukedima-town', label: 'Chümoukedima Town', pincode: '797111' },
  { value: 'dilong', label: 'Dilong', pincode: '797112' },
  { value: 'gaonbura', label: 'Gaonbura', pincode: '797113' },
  { value: 'ghaspani', label: 'Ghaspani', pincode: '797114' },
  { value: 'kakochung', label: 'Kakochung', pincode: '797115' },
  { value: 'kalimpong', label: 'Kalimpong', pincode: '797116' },
  { value: 'khukhruma', label: 'Khukhruma', pincode: '797117' },
  { value: 'longsa', label: 'Longsa', pincode: '797118' },
  { value: 'mangkolemba', label: 'Mangkolemba', pincode: '797119' },
  { value: 'niuland', label: 'Niuland', pincode: '797120' },
  { value: 'phusachod', label: 'Phusachod', pincode: '797121' },
  { value: 'samtapur', label: 'Samtapur', pincode: '797122' },
  { value: 'sechü-zubza', label: 'Sechü-Zubza', pincode: '797123' },
  { value: 'shokhuvi', label: 'Shokhuvi', pincode: '797124' },
  { value: 'thüchü', label: 'Thüchü', pincode: '797125' },
  { value: 'tsüzi', label: 'Tsüzi', pincode: '797126' },
  { value: 'urabasti', label: 'Urabasti', pincode: '797127' },
  { value: 'zunheboto', label: 'Zunheboto', pincode: '797128' },
  { value: 'longkhim', label: 'Longkhim', pincode: '797129' },
  { value: 'chandmari', label: 'Chandmari', pincode: '797130' },
  { value: 'pudumoni', label: 'Pudumoni', pincode: '797131' },
  { value: 'thepfu', label: 'Thepfu', pincode: '797132' },
  { value: 'bamunigam', label: 'Bamunigam', pincode: '797133' },
  { value: 'old-kohima', label: 'Old Kohima', pincode: '797134' },
  { value: 'new-kohima', label: 'New Kohima', pincode: '797135' },
  { value: 'tsüzu', label: 'Tsüzu', pincode: '797136' }
  ],
  
  'zunheboto': [
  { value: 'achi', label: 'Achi', pincode: '797111' },
  { value: 'bokajan', label: 'Bokajan', pincode: '797112' },
  { value: 'chishol', label: 'Chishol', pincode: '797113' },
  { value: 'doyang', label: 'Doyang', pincode: '797114' },
  { value: 'kalotha', label: 'Kalotha', pincode: '797115' },
  { value: 'khiamniungan', label: 'Khiamniungan', pincode: '797116' },
  { value: 'khughoto', label: 'Khughoto', pincode: '797117' },
  { value: 'lukhai', label: 'Lukhai', pincode: '797118' },
  { value: 'mongsen', label: 'Mongsen', pincode: '797119' },
  { value: 'new-zunheboto', label: 'New Zunheboto', pincode: '797120' },
  { value: 'old-zunheboto', label: 'Old Zunheboto', pincode: '797121' },
  { value: 'sangphur', label: 'Sangphur', pincode: '797122' },
  { value: 'sukhalu', label: 'Sukhalu', pincode: '797123' },
  { value: 'tizu', label: 'Tizu', pincode: '797124' },
  { value: 'zutho', label: 'Zutho', pincode: '797125' }
  ],
  
  'kohima': [
  { value: 'aradur', label: 'Aradur', pincode: '797001' },
  { value: 'bethel', label: 'Bethel', pincode: '797002' },
  { value: 'bypass', label: 'Bypass', pincode: '797003' },
  { value: 'chen', label: 'Chen', pincode: '797004' },
  { value: 'diu', label: 'Diu', pincode: '797005' },
  { value: 'highway', label: 'Highway', pincode: '797006' },
  { value: 'kedi', label: 'Kedi', pincode: '797007' },
  { value: 'khuzama', label: 'Khuzama', pincode: '797008' },
  { value: 'kohima-cantt', label: 'Kohima Cantt', pincode: '797009' },
  { value: 'mokho', label: 'Mokho', pincode: '797010' },
  { value: 'new-kohima', label: 'New Kohima', pincode: '797011' },
  { value: 'old-kohima', label: 'Old Kohima', pincode: '797012' },
  { value: 'pioneer', label: 'Pioneer', pincode: '797013' },
  { value: 'salamati', label: 'Salamati', pincode: '797014' },
  { value: 'shilloi', label: 'Shilloi', pincode: '797015' },
  { value: 'super-market', label: 'Super Market', pincode: '797016' },
  { value: 'viswema', label: 'Viswema', pincode: '797017' },
  { value: 'vishwema', label: 'Vishwema', pincode: '797018' }
  ],
  
  'wokha': [
  { value: 'akuk', label: 'Akuk', pincode: '797111' },
  { value: 'aliba', label: 'Aliba', pincode: '797112' },
  { value: 'chukitong', label: 'Chukitong', pincode: '797113' },
  { value: 'dibu', label: 'Dibu', pincode: '797114' },
  { value: 'khezhakeno', label: 'Khezhakeno', pincode: '797119' },
  { value: 'longsa', label: 'Longsa', pincode: '797120' },
  { value: 'pukhumi', label: 'Pukhumi', pincode: '797115' },
  { value: 'sanis', label: 'Sanis', pincode: '797116' },
  { value: 'thewati', label: 'Thewati', pincode: '797117' },
  { value: 'tsuimi', label: 'Tsuimi', pincode: '797121' },
  { value: 'wokha-town', label: 'Wokha Town', pincode: '797118' }
  ],
  
  'pfutsero': [
  { value: 'bokajan', label: 'Bokajan', pincode: '797105' },
  { value: 'chen', label: 'Chen', pincode: '797106' },
  { value: 'chizami', label: 'Chizami', pincode: '797107' },
  { value: 'khiamniungan', label: 'Khiamniungan', pincode: '797108' },
  { value: 'lahorijan', label: 'Lahorijan', pincode: '797109' },
  { value: 'longmisa', label: 'Longmisa', pincode: '797110' },
  { value: 'pfutsero-town', label: 'Pfutsero Town', pincode: '797111' },
  { value: 'sangtam', label: 'Sangtam', pincode: '797112' },
  { value: 'tsuimi', label: 'Tsuimi', pincode: '797113' },
  { value: 'phek', label: 'Phek', pincode: '797114' },
  { value: 'zunheboto', label: 'Zunheboto', pincode: '797115' },
  { value: 'kiphire', label: 'Kiphire', pincode: '797116' },
  { value: 'meluri', label: 'Meluri', pincode: '797117' },
  { value: 'chuchuyimlang', label: 'Chuchuyimlang', pincode: '797118' },
  { value: 'akhoya', label: 'Akhoya', pincode: '797119' },
  { value: 'tsulon', label: 'Tsulon', pincode: '797120' }
  ],
  
  'peren': [
  { value: 'bokajan', label: 'Bokajan', pincode: '797102' },
  { value: 'chizami', label: 'Chizami', pincode: '797103' },
  { value: 'kozi', label: 'Kozi', pincode: '797104' },
  { value: 'longmai', label: 'Longmai', pincode: '797105' },
  { value: 'napaam', label: 'Napaam', pincode: '797106' },
  { value: 'pfütsero', label: 'Pfütsero', pincode: '797107' },
  { value: 'peren-town', label: 'Peren Town', pincode: '797108' },
  { value: 'tening', label: 'Tening', pincode: '797109' },
  { value: 'teru', label: 'Teru', pincode: '797110' },
  { value: 'yimchung', label: 'Yimchung', pincode: '797111' },
  { value: 'yohmi', label: 'Yohmi', pincode: '797112' }
  ],
  
  'kiphire': [
  { value: 'arol', label: 'Arol', pincode: '797111' },
  { value: 'chare', label: 'Chare', pincode: '797112' },
  { value: 'kiphire-town', label: 'Kiphire Town', pincode: '797113' },
  { value: 'kuthur', label: 'Kuthur', pincode: '797114' },
  { value: 'longmatra', label: 'Longmatra', pincode: '797115' },
  { value: 'noklak', label: 'Noklak', pincode: '797116' },
  { value: 'pungro', label: 'Pungro', pincode: '797117' },
  { value: 'salomi', label: 'Salomi', pincode: '797118' },
  { value: 'shamator', label: 'Shamator', pincode: '797119' },
  { value: 'tsuikhu', label: 'Tsuikhu', pincode: '797120' },
  { value: 'khomi', label: 'Khomi', pincode: '797121' },
  { value: 'naga-kiphire', label: 'Naga Kiphire', pincode: '797122' }
  ],
  
  'noklak': [
  { value: 'chongkho', label: 'Chongkho', pincode: '797131' },
  { value: 'khomi', label: 'Khomi', pincode: '797132' },
  { value: 'longkhim', label: 'Longkhim', pincode: '797133' },
  { value: 'noklak-town', label: 'Noklak Town', pincode: '797134' },
  { value: 'pungro', label: 'Pungro', pincode: '797135' },
  { value: 'tsuikhu', label: 'Tsuikhu', pincode: '797136' },
  { value: 'bonger', label: 'Bonger', pincode: '797137' },
  { value: 'nanglam', label: 'Nanglam', pincode: '797138' },
  { value: 'nokchen', label: 'Nokchen', pincode: '797139' },
  { value: 'chumoukedima', label: 'Chumoukedima', pincode: '797140' }
  ],
  
   //Tripura
   'belbari': [
  { value: 'badharghat', label: 'Badharghat', pincode: '799014' },
  { value: 'barjala', label: 'Barjala', pincode: '799103' },
  { value: 'belbari', label: 'Belbari', pincode: '799201' },
  { value: 'bengali-bazar', label: 'Bengali Bazar', pincode: '799001' },
  { value: 'biddhanagar', label: 'Biddhanagar', pincode: '799003' },
  { value: 'dakshinbagan', label: 'Dakshinbagan', pincode: '799202' },
  { value: 'durganagar', label: 'Durganagar', pincode: '799017' },
  { value: 'ganganagar', label: 'Ganganagar', pincode: '799105' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '799015' },
  { value: 'jirania', label: 'Jirania', pincode: '799045' },
  { value: 'kallyanpur', label: 'Kallyanpur', pincode: '799008' },
  { value: 'kanchanpur', label: 'Kanchanpur', pincode: '799270' },
  { value: 'karbook', label: 'Karbook', pincode: '799010' },
  { value: 'khowai', label: 'Khowai', pincode: '799203' },
  { value: 'maheshkhala', label: 'Maheshkhala', pincode: '799107' },
  { value: 'manu', label: 'Manu', pincode: '799290' },
  { value: 'mohanpur', label: 'Mohanpur', pincode: '799250' },
  { value: 'north-tripura', label: 'North Tripura', pincode: '799280' },
  { value: 'south-tripura', label: 'South Tripura', pincode: '799006' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'west-tripura', label: 'West Tripura', pincode: '799007' }
  ],
  
  'dukli': [
  { value: 'adampur', label: 'Adampur', pincode: '799011' },
  { value: 'barjala', label: 'Barjala', pincode: '799103' },
  { value: 'bengali-bazar', label: 'Bengali Bazar', pincode: '799001' },
  { value: 'biddhanagar', label: 'Biddhanagar', pincode: '799003' },
  { value: 'dakshinbagan', label: 'Dakshinbagan', pincode: '799202' },
  { value: 'dukli', label: 'Dukli', pincode: '799107' },
  { value: 'ganganagar', label: 'Ganganagar', pincode: '799105' },
  { value: 'jagannathpur', label: 'Jagannathpur', pincode: '799015' },
  { value: 'jirania', label: 'Jirania', pincode: '799045' },
  { value: 'kallyanpur', label: 'Kallyanpur', pincode: '799008' },
  { value: 'kanchanpur', label: 'Kanchanpur', pincode: '799270' },
  { value: 'karbook', label: 'Karbook', pincode: '799010' },
  { value: 'khowai', label: 'Khowai', pincode: '799203' },
  { value: 'maheshkhala', label: 'Maheshkhala', pincode: '799107' },
  { value: 'mohanpur', label: 'Mohanpur', pincode: '799250' },
  { value: 'north-tripura', label: 'North Tripura', pincode: '799280' },
  { value: 'south-tripura', label: 'South Tripura', pincode: '799006' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'west-tripura', label: 'West Tripura', pincode: '799007' }
  ],
  
  'gomati': [
  { value: 'belonia', label: 'Belonia', pincode: '799155' },
  { value: 'bhatpara', label: 'Bhatpara', pincode: '799103' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '799111' },
  { value: 'gandhigram', label: 'Gandhigram', pincode: '799157' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '799153' },
  { value: 'gomati', label: 'Gomati', pincode: '799112' },
  { value: 'jampuijala', label: 'Jampuijala', pincode: '799152' },
  { value: 'kumirmura', label: 'Kumirmura', pincode: '799147' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799156' },
  { value: 'manu', label: 'Manu', pincode: '799290' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '799154' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799145' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799159' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799161' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
  { value: 'nalua', label: 'Nalua', pincode: '799141' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799142' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799143' },
  { value: 'kaiserpura', label: 'Kaiserpura', pincode: '799146' },
  { value: 'purba-bishramganj', label: 'Purba Bishramganj', pincode: '799139' }
  ],
  
  'hezamara': [
  { value: 'adarbari', label: 'Adarbari', pincode: '799150' },
  { value: 'bambora', label: 'Bambora', pincode: '799104' },
  { value: 'chakmaghat', label: 'Chakmaghat', pincode: '799154' },
  { value: 'govindabari', label: 'Govindabari', pincode: '799171' },
  { value: 'hezamara', label: 'Hezamara', pincode: '799145' },
  { value: 'jangalia', label: 'Jangalia', pincode: '799145' },
  { value: 'kanpur', label: 'Kanpur', pincode: '799105' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799156' },
  { value: 'manu', label: 'Manu', pincode: '799290' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799145' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799159' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799161' },
  { value: 'kumirmura', label: 'Kumirmura', pincode: '799147' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '799147' },
  { value: 'mahabirpara', label: 'Mahabirpara', pincode: '799155' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799143' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799142' },
  { value: 'rajupara', label: 'Rajupara', pincode: '799160' },
  { value: 'sonachura', label: 'Sonachura', pincode: '799141' }
  ],
  
  'hrishyamukh': [
  { value: 'adampur', label: 'Adampur', pincode: '799007' },
  { value: 'babhulbari', label: 'Babhulbari', pincode: '799151' },
  { value: 'banamalipur', label: 'Banamalipur', pincode: '799157' },
  { value: 'chakmaghat', label: 'Chakmaghat', pincode: '799154' },
  { value: 'hempur', label: 'Hempur', pincode: '799011' },
  { value: 'hrishyamukh', label: 'Hrishyamukh', pincode: '799271' },
  { value: 'jampuijala', label: 'Jampuijala', pincode: '799152' },
  { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799275' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799156' },
  { value: 'manu', label: 'Manu', pincode: '799290' },
  { value: 'mahabirpara', label: 'Mahabirpara', pincode: '799155' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799145' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799159' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799161' },
  { value: 'kumirmura', label: 'Kumirmura', pincode: '799147' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '799147' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799143' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799142' },
  { value: 'rajupara', label: 'Rajupara', pincode: '799160' },
  { value: 'sonachura', label: 'Sonachura', pincode: '799141' },
  { value: 'purbabishramganj', label: 'Purba Bishramganj', pincode: '799139' }
  ],
  
  'jirania': [
  { value: 'adampur', label: 'Adampur', pincode: '799011' },
  { value: 'babhulbari', label: 'Babhulbari', pincode: '799151' },
  { value: 'banamalipur', label: 'Banamalipur', pincode: '799157' },
  { value: 'chakmaghat', label: 'Chakmaghat', pincode: '799154' },
  { value: 'gandhigram', label: 'Gandhigram', pincode: '799157' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '799153' },
  { value: 'govindabari', label: 'Govindabari', pincode: '799171' },
  { value: 'hezamara', label: 'Hezamara', pincode: '799145' },
  { value: 'jangalia', label: 'Jangalia', pincode: '799145' },
  { value: 'jirania', label: 'Jirania', pincode: '799045' },
  { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799275' },
  { value: 'kanpur', label: 'Kanpur', pincode: '799105' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799156' },
  { value: 'manu', label: 'Manu', pincode: '799290' },
  { value: 'mahabirpara', label: 'Mahabirpara', pincode: '799155' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799145' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799159' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799161' },
  { value: 'kumirmura', label: 'Kumirmura', pincode: '799147' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '799147' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799143' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799142' },
  { value: 'rajupara', label: 'Rajupara', pincode: '799160' },
  { value: 'sonachura', label: 'Sonachura', pincode: '799141' },
  { value: 'purbabishramganj', label: 'Purba Bishramganj', pincode: '799139' },
  { value: 'durgapur', label: 'Durgapur', pincode: '799149' },
  { value: 'jangalpara', label: 'Jangalpara', pincode: '799172' },
  { value: 'shilachhara', label: 'Shilachhara', pincode: '799104' },
  { value: 'purba-sagarpara', label: 'Purba Sagarpara', pincode: '799111' },
  { value: 'chakradhar', label: 'Chakradhar', pincode: '799165' }
  ],
  
  'jolaibari': [
  { value: 'adampur', label: 'Adampur', pincode: '799011' },
  { value: 'agartala', label: 'Agartala', pincode: '799001' },
  { value: 'babhulbari', label: 'Babhulbari', pincode: '799151' },
  { value: 'banamalipur', label: 'Banamalipur', pincode: '799157' },
  { value: 'chakmaghat', label: 'Chakmaghat', pincode: '799154' },
  { value: 'gandhigram', label: 'Gandhigram', pincode: '799157' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '799153' },
  { value: 'govindabari', label: 'Govindabari', pincode: '799171' },
  { value: 'hezamara', label: 'Hezamara', pincode: '799145' },
  { value: 'jangalia', label: 'Jangalia', pincode: '799145' },
  { value: 'jolaibari', label: 'Jolaibari', pincode: '799131' },
  { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799275' },
  { value: 'kanpur', label: 'Kanpur', pincode: '799105' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799156' },
  { value: 'manu', label: 'Manu', pincode: '799290' },
  { value: 'mahabirpara', label: 'Mahabirpara', pincode: '799155' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799145' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799159' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799161' },
  { value: 'kumirmura', label: 'Kumirmura', pincode: '799147' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '799147' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799143' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799142' },
  { value: 'rajupara', label: 'Rajupara', pincode: '799160' },
  { value: 'sonachura', label: 'Sonachura', pincode: '799141' },
  { value: 'purbabishramganj', label: 'Purba Bishramganj', pincode: '799139' },
  { value: 'durgapur', label: 'Durgapur', pincode: '799149' },
  { value: 'jangalpara', label: 'Jangalpara', pincode: '799172' },
  { value: 'shilachhara', label: 'Shilachhara', pincode: '799104' },
  { value: 'purba-sagarpara', label: 'Purba Sagarpara', pincode: '799111' },
  { value: 'chakradhar', label: 'Chakradhar', pincode: '799165' },
  { value: 'ramchandraghat', label: 'Ramchandraghat', pincode: '799113' },
  { value: 'manikpur', label: 'Manikpur', pincode: '799111' },
  { value: 'kachukhali', label: 'Kachukhali', pincode: '799120' }
  ],
  
  'kadamtala.': [
  { value: 'adampur', label: 'Adampur', pincode: '799011' },
  { value: 'babhulbari', label: 'Babhulbari', pincode: '799151' },
  { value: 'banamalipur', label: 'Banamalipur', pincode: '799157' },
  { value: 'chakmaghat', label: 'Chakmaghat', pincode: '799154' },
  { value: 'gandhigram', label: 'Gandhigram', pincode: '799157' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '799153' },
  { value: 'govindabari', label: 'Govindabari', pincode: '799171' },
  { value: 'hezamara', label: 'Hezamara', pincode: '799145' },
  { value: 'jangalia', label: 'Jangalia', pincode: '799145' },
  { value: 'kadamtala', label: 'Kadamtala', pincode: '799154' },
  { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799275' },
  { value: 'kanpur', label: 'Kanpur', pincode: '799105' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799156' },
  { value: 'manu', label: 'Manu', pincode: '799290' },
  { value: 'mahabirpara', label: 'Mahabirpara', pincode: '799155' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799145' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799159' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799161' },
  { value: 'kumirmura', label: 'Kumirmura', pincode: '799147' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '799147' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799143' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799142' },
  { value: 'rajupara', label: 'Rajupara', pincode: '799160' },
  { value: 'sonachura', label: 'Sonachura', pincode: '799141' },
  { value: 'purbabishramganj', label: 'Purba Bishramganj', pincode: '799139' },
  { value: 'durgapur', label: 'Durgapur', pincode: '799149' },
  { value: 'jangalpara', label: 'Jangalpara', pincode: '799172' },
  { value: 'shilachhara', label: 'Shilachhara', pincode: '799104' },
  { value: 'purba-sagarpara', label: 'Purba Sagarpara', pincode: '799111' },
  { value: 'chakradhar', label: 'Chakradhar', pincode: '799165' },
  { value: 'ramchandraghat', label: 'Ramchandraghat', pincode: '799113' },
  { value: 'manikpur', label: 'Manikpur', pincode: '799111' },
  { value: 'kachukhali', label: 'Kachukhali', pincode: '799120' },
  { value: 'barkathal', label: 'Barkathal', pincode: '799152' },
  { value: 'brindaban', label: 'Brindaban', pincode: '799132' },
  { value: 'barjala', label: 'Barjala', pincode: '799011' },
  { value: 'jolapan', label: 'Jolapan', pincode: '799133' },
  { value: 'kamdebpara', label: 'Kamdebpara', pincode: '799155' },
  { value: 'nabinagar', label: 'Nabinagar', pincode: '799122' }
  ],
  
  'kamalpur': [
  { value: 'adampur', label: 'Adampur', pincode: '799011' },
  { value: 'babhulbari', label: 'Babhulbari', pincode: '799151' },
  { value: 'banamalipur', label: 'Banamalipur', pincode: '799157' },
  { value: 'chakmaghat', label: 'Chakmaghat', pincode: '799154' },
  { value: 'gandhigram', label: 'Gandhigram', pincode: '799157' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '799153' },
  { value: 'govindabari', label: 'Govindabari', pincode: '799171' },
  { value: 'hezamara', label: 'Hezamara', pincode: '799145' },
  { value: 'jangalia', label: 'Jangalia', pincode: '799145' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '799275' },
  { value: 'kanpur', label: 'Kanpur', pincode: '799105' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799156' },
  { value: 'manu', label: 'Manu', pincode: '799290' },
  { value: 'mahabirpara', label: 'Mahabirpara', pincode: '799155' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799145' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799159' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799161' },
  { value: 'kumirmura', label: 'Kumirmura', pincode: '799147' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '799147' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799143' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799142' },
  { value: 'rajupara', label: 'Rajupara', pincode: '799160' },
  { value: 'sonachura', label: 'Sonachura', pincode: '799141' },
  { value: 'purbabishramganj', label: 'Purba Bishramganj', pincode: '799139' },
  { value: 'durgapur', label: 'Durgapur', pincode: '799149' },
  { value: 'jangalpara', label: 'Jangalpara', pincode: '799172' },
  { value: 'shilachhara', label: 'Shilachhara', pincode: '799104' },
  { value: 'purba-sagarpara', label: 'Purba Sagarpara', pincode: '799111' },
  { value: 'chakradhar', label: 'Chakradhar', pincode: '799165' },
  { value: 'ramchandraghat', label: 'Ramchandraghat', pincode: '799113' },
  { value: 'manikpur', label: 'Manikpur', pincode: '799111' },
  { value: 'kachukhali', label: 'Kachukhali', pincode: '799120' },
  { value: 'barkathal', label: 'Barkathal', pincode: '799152' },
  { value: 'brindaban', label: 'Brindaban', pincode: '799132' },
  { value: 'barjala', label: 'Barjala', pincode: '799011' },
  { value: 'jolapan', label: 'Jolapan', pincode: '799133' },
  { value: 'kamdebpara', label: 'Kamdebpara', pincode: '799155' },
  { value: 'nabinagar', label: 'Nabinagar', pincode: '799122' },
  { value: 'sindurpur', label: 'Sindurpur', pincode: '799138' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '799170' },
  { value: 'madhyapara', label: 'Madhyapara', pincode: '799160' },
  { value: 'subhashnagar', label: 'Subhashnagar', pincode: '799161' },
  { value: 'borkhali', label: 'Borkhali', pincode: '799173' },
  { value: 'karmachara', label: 'Karmachara', pincode: '799175' },
  { value: 'naranpur', label: 'Naranpur', pincode: '799174' },
  { value: 'rameshchandra', label: 'Rameshchandra', pincode: '799172' }
  ],
  
  'north-tripura': [
  { value: 'adampur', label: 'Adampur', pincode: '799011' },
  { value: 'barkathal', label: 'Barkathal', pincode: '799152' },
  { value: 'babhulbari', label: 'Babhulbari', pincode: '799151' },
  { value: 'banamalipur', label: 'Banamalipur', pincode: '799157' },
  { value: 'chakmaghat', label: 'Chakmaghat', pincode: '799154' },
  { value: 'gandhigram', label: 'Gandhigram', pincode: '799157' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '799153' },
  { value: 'govindabari', label: 'Govindabari', pincode: '799171' },
  { value: 'hezamara', label: 'Hezamara', pincode: '799145' },
  { value: 'jangalia', label: 'Jangalia', pincode: '799145' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '799275' },
  { value: 'kanpur', label: 'Kanpur', pincode: '799105' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799156' },
  { value: 'manu', label: 'Manu', pincode: '799290' },
  { value: 'mahabirpara', label: 'Mahabirpara', pincode: '799155' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799145' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799159' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799103' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799161' },
  { value: 'kumirmura', label: 'Kumirmura', pincode: '799147' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '799147' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799143' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799142' },
  { value: 'rajupara', label: 'Rajupara', pincode: '799160' },
  { value: 'sonachura', label: 'Sonachura', pincode: '799141' },
  { value: 'purbabishramganj', label: 'Purba Bishramganj', pincode: '799139' },
  { value: 'durgapur', label: 'Durgapur', pincode: '799149' },
  { value: 'jangalpara', label: 'Jangalpara', pincode: '799172' },
  { value: 'shilachhara', label: 'Shilachhara', pincode: '799104' },
  { value: 'purba-sagarpara', label: 'Purba Sagarpara', pincode: '799111' },
  { value: 'chakradhar', label: 'Chakradhar', pincode: '799165' },
  { value: 'ramchandraghat', label: 'Ramchandraghat', pincode: '799113' },
  { value: 'manikpur', label: 'Manikpur', pincode: '799111' },
  { value: 'kachukhali', label: 'Kachukhali', pincode: '799120' },
  { value: 'brindaban', label: 'Brindaban', pincode: '799132' },
  { value: 'barjala', label: 'Barjala', pincode: '799011' },
  { value: 'jolapan', label: 'Jolapan', pincode: '799133' },
  { value: 'kamdebpara', label: 'Kamdebpara', pincode: '799155' },
  { value: 'nabinagar', label: 'Nabinagar', pincode: '799122' },
  { value: 'sindurpur', label: 'Sindurpur', pincode: '799138' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '799170' },
  { value: 'madhyapara', label: 'Madhyapara', pincode: '799160' },
  { value: 'subhashnagar', label: 'Subhashnagar', pincode: '799161' },
  { value: 'borkhali', label: 'Borkhali', pincode: '799173' },
  { value: 'karmachara', label: 'Karmachara', pincode: '799175' },
  { value: 'naranpur', label: 'Naranpur', pincode: '799174' },
  { value: 'rameshchandra', label: 'Rameshchandra', pincode: '799172' },
  { value: 'angargaria', label: 'Angargaria', pincode: '799182' },
  { value: 'baidyanath', label: 'Baidyanath', pincode: '799180' },
  { value: 'balughat', label: 'Balughat', pincode: '799179' },
  { value: 'baropara', label: 'Baropara', pincode: '799184' },
  { value: 'bhatpara', label: 'Bhatpara', pincode: '799183' },
  { value: 'khamarpara', label: 'Khamarpara', pincode: '799185' },
  { value: 'kumarghat', label: 'Kumarghat', pincode: '799166' },
  { value: 'laxmipur', label: 'Laxmipur', pincode: '799169' },
  { value: 'madhusree', label: 'Madhusree', pincode: '799167' },
  { value: 'patuli', label: 'Patuli', pincode: '799168' }
  ],

  'sabroom': [
  { value: 'adampur', label: 'Adampur', pincode: '799110' },
  { value: 'barkathal', label: 'Barkathal', pincode: '799181' },
  { value: 'banamalipur', label: 'Banamalipur', pincode: '799112' },
  { value: 'chakmaghat', label: 'Chakmaghat', pincode: '799120' },
  { value: 'gandhigram', label: 'Gandhigram', pincode: '799121' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '799113' },
  { value: 'govindabari', label: 'Govindabari', pincode: '799115' },
  { value: 'hezamara', label: 'Hezamara', pincode: '799141' },
  { value: 'jangalia', label: 'Jangalia', pincode: '799123' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '799125' },
  { value: 'kanpur', label: 'Kanpur', pincode: '799127' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799126' },
  { value: 'manu', label: 'Manu', pincode: '799135' },
  { value: 'mahabirpara', label: 'Mahabirpara', pincode: '799133' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799136' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799137' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799138' },
  { value: 'sabroom', label: 'Sabroom', pincode: '799145' },
  { value: 'teliamura', label: 'Teliamura', pincode: '799200' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799139' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799140' },
  { value: 'kumirmura', label: 'Kumirmura', pincode: '799142' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '799143' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799144' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799146' },
  { value: 'rajupara', label: 'Rajupara', pincode: '799147' },
  { value: 'sonachura', label: 'Sonachura', pincode: '799148' },
  { value: 'purbabishramganj', label: 'Purba Bishramganj', pincode: '799149' },
  { value: 'durgapur', label: 'Durgapur', pincode: '799150' },
  { value: 'jangalpara', label: 'Jangalpara', pincode: '799151' },
  { value: 'shilachhara', label: 'Shilachhara', pincode: '799152' },
  { value: 'purba-sagarpara', label: 'Purba Sagarpara', pincode: '799153' },
  { value: 'chakradhar', label: 'Chakradhar', pincode: '799154' },
  { value: 'ramchandraghat', label: 'Ramchandraghat', pincode: '799155' },
  { value: 'manikpur', label: 'Manikpur', pincode: '799156' },
  { value: 'kachukhali', label: 'Kachukhali', pincode: '799157' },
  { value: 'brindaban', label: 'Brindaban', pincode: '799158' },
  { value: 'barjala', label: 'Barjala', pincode: '799159' },
  { value: 'jolapan', label: 'Jolapan', pincode: '799160' },
  { value: 'kamdebpara', label: 'Kamdebpara', pincode: '799161' },
  { value: 'nabinagar', label: 'Nabinagar', pincode: '799162' },
  { value: 'sindurpur', label: 'Sindurpur', pincode: '799163' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '799164' },
  { value: 'madhyapara', label: 'Madhyapara', pincode: '799165' },
  { value: 'subhashnagar', label: 'Subhashnagar', pincode: '799166' },
  { value: 'borkhali', label: 'Borkhali', pincode: '799167' },
  { value: 'karmachara', label: 'Karmachara', pincode: '799168' },
  { value: 'naranpur', label: 'Naranpur', pincode: '799169' },
  { value: 'rameshchandra', label: 'Rameshchandra', pincode: '799170' },
  { value: 'angargaria', label: 'Angargaria', pincode: '799171' },
  { value: 'baidyanath', label: 'Baidyanath', pincode: '799172' },
  { value: 'balughat', label: 'Balughat', pincode: '799173' },
  { value: 'baropara', label: 'Baropara', pincode: '799174' },
  { value: 'bhatpara', label: 'Bhatpara', pincode: '799175' },
  { value: 'khamarpara', label: 'Khamarpara', pincode: '799176' },
  { value: 'kumarghat', label: 'Kumarghat', pincode: '799177' },
  { value: 'laxmipur', label: 'Laxmipur', pincode: '799178' },
  { value: 'madhusree', label: 'Madhusree', pincode: '799179' },
  { value: 'patuli', label: 'Patuli', pincode: '799180' }
  ],

  'sonamura': [
  { value: 'agartala', label: 'Agartala', pincode: '799001' },
  { value: 'banamalipur', label: 'Banamalipur', pincode: '799115' },
  { value: 'barjala', label: 'Barjala', pincode: '799159' },
  { value: 'chakmaghat', label: 'Chakmaghat', pincode: '799120' },
  { value: 'gandhigram', label: 'Gandhigram', pincode: '799121' },
  { value: 'gokulnagar', label: 'Gokulnagar', pincode: '799113' },
  { value: 'govindabari', label: 'Govindabari', pincode: '799114' },
  { value: 'hezamara', label: 'Hezamara', pincode: '799141' },
  { value: 'jangalia', label: 'Jangalia', pincode: '799123' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '799125' },
  { value: 'kurtumukh', label: 'Kurtumukh', pincode: '799126' },
  { value: 'manu', label: 'Manu', pincode: '799135' },
  { value: 'mahabirpara', label: 'Mahabirpara', pincode: '799133' },
  { value: 'raishyabari', label: 'Raishyabari', pincode: '799136' },
  { value: 'sabroom', label: 'Sabroom', pincode: '799145' },
  { value: 'sagarpur', label: 'Sagarpur', pincode: '799137' },
  { value: 'sonamura', label: 'Sonamura', pincode: '799138' },
  { value: 'sonachura', label: 'Sonachura', pincode: '799148' },
  { value: 'vishalgarh', label: 'Vishalgarh', pincode: '799140' },
  { value: 'unsanghati', label: 'Unsanghati', pincode: '799139' },
  { value: 'kamdebpara', label: 'Kamdebpara', pincode: '799161' },
  { value: 'lakshmipur', label: 'Lakshmipur', pincode: '799143' },
  { value: 'panchabati', label: 'Panchabati', pincode: '799144' },
  { value: 'padmapur', label: 'Padmapur', pincode: '799146' },
  { value: 'rajupara', label: 'Rajupara', pincode: '799147' },
  { value: 'subhashnagar', label: 'Subhashnagar', pincode: '799166' },
  { value: 'borkhali', label: 'Borkhali', pincode: '799167' },
  { value: 'karmachara', label: 'Karmachara', pincode: '799168' },
  { value: 'naranpur', label: 'Naranpur', pincode: '799169' },
  { value: 'rameshchandra', label: 'Rameshchandra', pincode: '799170' },
  { value: 'belonia', label: 'Belonia', pincode: '799155' },
  { value: 'sankari', label: 'Sankari', pincode: '799156' },
  { value: 'south-dhalai', label: 'South Dhalai', pincode: '799173' },
  { value: 'naitong', label: 'Naitong', pincode: '799174' },
  { value: 'kudabari', label: 'Kudabari', pincode: '799175' },
  { value: 'dobani', label: 'Dobani', pincode: '799176' },
  { value: 'kamranga', label: 'Kamranga', pincode: '799177' },
  { value: 'jagarani', label: 'Jagarani', pincode: '799178' },
  { value: 'madhusree', label: 'Madhusree', pincode: '799179' }
  ],

   'agartala': [
    { value: 'adarshanagar', label: 'Adarshanagar', pincode: '799003' },
    { value: 'agartala-city', label: 'Agartala City', pincode: '799001' },
    { value: 'badarghat', label: 'Badarghat', pincode: '799014' },
    { value: 'balaram-para', label: 'Balaram Para', pincode: '799006' },
    { value: 'garia-bazar', label: 'Garia Bazar', pincode: '799002' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'howrah', label: 'Howrah', pincode: '799005' },
    { value: 'jagannath-pur', label: 'Jagannath Pur', pincode: '799007' },
    { value: 'manu-mangla', label: 'Manu Mangla', pincode: '799017' },
    { value: 'prakash-nagar', label: 'Prakash Nagar', pincode: '799010' },
    { value: 'railway-station-area', label: 'Railway Station Area', pincode: '799015' },
    { value: 'shantipara', label: 'Shantipara', pincode: '799008' },
    { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
    { value: 'teliamura', label: 'Teliamura', pincode: '799205' },
    { value: 'tilla-road', label: 'Tilla Road', pincode: '799004' },
    { value: 'uttarayon', label: 'Uttarayon', pincode: '799027' },
    { value: 'vishal-nagar', label: 'Vishal Nagar', pincode: '799013' },
    { value: 'shyamali-bazar', label: 'Shyamali Bazar', pincode: '799020' }
    ],
    
    'dharmanagar': [
    { value: 'badarpur', label: 'Badarpur', pincode: '799251' },
    { value: 'dharmanagar-city', label: 'Dharmanagar City', pincode: '799250' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kailashahar', label: 'Kailashahar', pincode: '799277' },
    { value: 'kanchanpur', label: 'Kanchanpur', pincode: '799285' },
    { value: 'mangalka', label: 'Mangalka', pincode: '799259' },
    { value: 'nalkata', label: 'Nalkata', pincode: '799248' },
    { value: 'panisagar', label: 'Panisagar', pincode: '799242' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '799260' },
    { value: 'satchand', label: 'Satchand', pincode: '799231' },
    { value: 'sidhai', label: 'Sidhai', pincode: '799232' },
    { value: 'amar-nagar', label: 'Amar Nagar', pincode: '799246' },
    { value: 'baliguma', label: 'Baliguma', pincode: '799240' },
    { value: 'bardowali', label: 'Bardowali', pincode: '799273' },
    { value: 'belonia', label: 'Belonia', pincode: '799155' },
    { value: 'jatrapur', label: 'Jatrapur', pincode: '799254' },
    { value: 'mahatma-gandhi-nagar', label: 'Mahatma Gandhi Nagar', pincode: '799261' },
    { value: 'manikbari', label: 'Manikbari', pincode: '799249' },
    { value: 'subhashnagar', label: 'Subhashnagar', pincode: '799233' },
    { value: 'tulsi-nagar', label: 'Tulsi Nagar', pincode: '799263' }
    ],
    
    'udaipur-': [
    { value: 'adalchara', label: 'Adalchara', pincode: '799120' },
    { value: 'amarpur', label: 'Amarpur', pincode: '799101' },
    { value: 'bashbari', label: 'Bashbari', pincode: '799117' },
    { value: 'bhuvaneshwari', label: 'Bhuvaneshwari', pincode: '799113' },
    { value: 'gathal', label: 'Gathal', pincode: '799130' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jatanbari', label: 'Jatanbari', pincode: '799125' },
    { value: 'karbook', label: 'Karbook', pincode: '799104' },
    { value: 'killa', label: 'Killa', pincode: '799105' },
    { value: 'rajnagar', label: 'Rajnagar', pincode: '799106' },
    { value: 'sadarbari', label: 'Sadarbari', pincode: '799110' },
    { value: 'south-udaipur', label: 'South Udaipur', pincode: '799111' },
    { value: 'udaipur-town', label: 'Udaipur Town', pincode: '799103' },
    { value: 'zodinthara', label: 'Zodinthara', pincode: '799109' }
    ],
    
    'kailashahar': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '799277' },
    { value: 'bashbari', label: 'Bashbari', pincode: '799276' },
    { value: 'bebra', label: 'Bebra', pincode: '799271' },
    { value: 'bhairabnagar', label: 'Bhairabnagar', pincode: '799270' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kailashahar-town', label: 'Kailashahar Town', pincode: '799277' },
    { value: 'karbook', label: 'Karbook', pincode: '799104' },
    { value: 'mahalchhara', label: 'Mahalchhara', pincode: '799278' },
    { value: 'manu', label: 'Manu', pincode: '799278' },
    { value: 'radhanagar', label: 'Radhanagar', pincode: '799279' },
    { value: 'sadarbari', label: 'Sadarbari', pincode: '799275' },
    { value: 'santipur', label: 'Santipur', pincode: '799274' },
    { value: 'south-kailashahar', label: 'South Kailashahar', pincode: '799276' },
    { value: 'tadadi', label: 'Tadadi', pincode: '799280' },
    { value: 'zodinthara', label: 'Zodinthara', pincode: '799279' }
    ],
    
    'bishalgarh': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '799154' },
    { value: 'amarpur', label: 'Amarpur', pincode: '799150' },
    { value: 'bashbari', label: 'Bashbari', pincode: '799153' },
    { value: 'bhanpur', label: 'Bhanpur', pincode: '799155' },
    { value: 'bishalgarh-town', label: 'Bishalgarh Town', pincode: '799102' },
    { value: 'chandipur', label: 'Chandipur', pincode: '799120' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799121' },
    { value: 'killa', label: 'Killa', pincode: '799104' },
    { value: 'manu', label: 'Manu', pincode: '799105' },
    { value: 'mohachara', label: 'Mohachara', pincode: '799157' },
    { value: 'ramnagar', label: 'Ramnagar', pincode: '799152' },
    { value: 'shantipur', label: 'Shantipur', pincode: '799154' },
    { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
    { value: 'south-bishalgarh', label: 'South Bishalgarh', pincode: '799103' },
    { value: 'sudhirnagar', label: 'Sudhirnagar', pincode: '799156' },
    { value: 'zodinthara', label: 'Zodinthara', pincode: '799109' }
    ],
    
    'teliamura': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '799205' },
    { value: 'barabandh', label: 'Barabandh', pincode: '799205' },
    { value: 'bashbari', label: 'Bashbari', pincode: '799205' },
    { value: 'belonia', label: 'Belonia', pincode: '799155' },
    { value: 'chakchaka', label: 'Chakchaka', pincode: '799206' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'jagannath-nagar', label: 'Jagannath Nagar', pincode: '799206' },
    { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799209' },
    { value: 'kailashahar', label: 'Kailashahar', pincode: '799277' },
    { value: 'manu', label: 'Manu', pincode: '799105' },
    { value: 'south-teliamura', label: 'South Teliamura', pincode: '799205' },
    { value: 'teliamura-town', label: 'Teliamura Town', pincode: '799205' },
    { value: 'ukharkura', label: 'Ukharkura', pincode: '799204' },
    { value: 'zodinthara', label: 'Zodinthara', pincode: '799203' }
    ],
  
    'belonia': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '799155' },
    { value: 'bairagi', label: 'Bairagi', pincode: '799156' },
    { value: 'belonia-town', label: 'Belonia Town', pincode: '799155' },
    { value: 'boraibari', label: 'Boraibari', pincode: '799155' },
    { value: 'chakchaka', label: 'Chakchaka', pincode: '799157' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799121' },
    { value: 'killa', label: 'Killa', pincode: '799104' },
    { value: 'manu', label: 'Manu', pincode: '799105' },
    { value: 'nalkata', label: 'Nalkata', pincode: '799152' },
    { value: 'rajnagar', label: 'Rajnagar', pincode: '799150' },
    { value: 'sadarbari', label: 'Sadarbari', pincode: '799153' },
    { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
    { value: 'south-belonia', label: 'South Belonia', pincode: '799155' },
    { value: 'south-rajnagar', label: 'South Rajnagar', pincode: '799150' },
    { value: 'tangrakhura', label: 'Tangrakhura', pincode: '799155' },
    { value: 'udayachhara', label: 'Udayachhara', pincode: '799154' }
    ],
    
    
    'melaghar': [
    { value: 'amarpur', label: 'Amarpur', pincode: '799151' },
    { value: 'bailongchhara', label: 'Bailongchhara', pincode: '799151' },
    { value: 'belonia', label: 'Belonia', pincode: '799155' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kalacherra', label: 'Kalacherra', pincode: '799154' },
    { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799121' },
    { value: 'killa', label: 'Killa', pincode: '799104' },
    { value: 'melaghar-town', label: 'Melaghar Town', pincode: '799151' },
    { value: 'manu', label: 'Manu', pincode: '799105' },
    { value: 'nalkata', label: 'Nalkata', pincode: '799152' },
    { value: 'south-melaghar', label: 'South Melaghar', pincode: '799151' },
    { value: 'tadadi', label: 'Tadadi', pincode: '799150' }
    ],
    
    'mohanpur': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '799105' },
    { value: 'bailongchhara', label: 'Bailongchhara', pincode: '799107' },
    { value: 'kalacherra', label: 'Kalacherra', pincode: '799154' },
    { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799121' },
    { value: 'killa', label: 'Killa', pincode: '799104' },
    { value: 'manu', label: 'Manu', pincode: '799105' },
    { value: 'mohanpur-town', label: 'Mohanpur Town', pincode: '799106' },
    { value: 'nalkata', label: 'Nalkata', pincode: '799152' },
    { value: 'south-mohanpur', label: 'South Mohanpur', pincode: '799106' },
    { value: 'sudhirnagar', label: 'Sudhirnagar', pincode: '799107' },
    { value: 'zodinthara', label: 'Zodinthara', pincode: '799103' }
    ],
    
    'ambassa': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '799202' },
    { value: 'ambassa-town', label: 'Ambassa Town', pincode: '799202' },
    { value: 'bairagi', label: 'Bairagi', pincode: '799204' },
    { value: 'barabandh', label: 'Barabandh', pincode: '799202' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799121' },
    { value: 'killa', label: 'Killa', pincode: '799104' },
    { value: 'manu', label: 'Manu', pincode: '799105' },
    { value: 'south-ambassa', label: 'South Ambassa', pincode: '799202' },
    { value: 'sadarbari', label: 'Sadarbari', pincode: '799203' },
    { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
    { value: 'tangrakhura', label: 'Tangrakhura', pincode: '799203' }
    ],
    
    'ranirbazar': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '799013' },
    { value: 'bailongchhara', label: 'Bailongchhara', pincode: '799015' },
    { value: 'barabandh', label: 'Barabandh', pincode: '799014' },
    { value: 'belonia', label: 'Belonia', pincode: '799155' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kalacherra', label: 'Kalacherra', pincode: '799154' },
    { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799121' },
    { value: 'killa', label: 'Killa', pincode: '799104' },
    { value: 'manu', label: 'Manu', pincode: '799105' },
    { value: 'ranirbazar-town', label: 'Ranirbazar Town', pincode: '799013' },
    { value: 'south-ranirbazar', label: 'South Ranirbazar', pincode: '799013' },
    { value: 'sadarbari', label: 'Sadarbari', pincode: '799013' },
    { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
    { value: 'tangrakhura', label: 'Tangrakhura', pincode: '799014' },
    { value: 'udayachhara', label: 'Udayachhara', pincode: '799154' },
    { value: 'zodinthara', label: 'Zodinthara', pincode: '799010' },
    { value: 'sonamura-town', label: 'Sonamura Town', pincode: '799131' },
    { value: 'north-ranirbazar', label: 'North Ranirbazar', pincode: '799016' }
    ],
    
    'santirbazar': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '799144' },
    { value: 'bailongchhara', label: 'Bailongchhara', pincode: '799145' },
    { value: 'barabandh', label: 'Barabandh', pincode: '799146' },
    { value: 'belonia', label: 'Belonia', pincode: '799155' },
    { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799121' },
    { value: 'killa', label: 'Killa', pincode: '799104' },
    { value: 'manu', label: 'Manu', pincode: '799105' },
    { value: 'ranirbazar', label: 'Ranirbazar', pincode: '799013' },
    { value: 'sadarbari', label: 'Sadarbari', pincode: '799146' },
    { value: 'santirbazar-town', label: 'Santirbazar Town', pincode: '799144' },
    { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
    { value: 'south-santirbazar', label: 'South Santirbazar', pincode: '799144' },
    { value: 'tangrakhura', label: 'Tangrakhura', pincode: '799147' },
    { value: 'zodinthara', label: 'Zodinthara', pincode: '799010' },
    { value: 'durganagar', label: 'Durganagar', pincode: '799147' },
    { value: 'north-santirbazar', label: 'North Santirbazar', pincode: '799144' }
    ],
    
    'kumarghat': [
    { value: 'adarsh-nagar', label: 'Adarsh Nagar', pincode: '799261' },
    { value: 'bailongchhara', label: 'Bailongchhara', pincode: '799260' },
    { value: 'barabandh', label: 'Barabandh', pincode: '799261' },
    { value: 'belonia', label: 'Belonia', pincode: '799155' },
    { value: 'ghatkesar', label: 'Ghatkesar', pincode: '500088' },
    { value: 'gosha-mahal', label: 'Gosha Mahal', pincode: '500012' },
    { value: 'kamalnagar', label: 'Kamalnagar', pincode: '799121' },
    { value: 'killa', label: 'Killa', pincode: '799104' },
    { value: 'kumarghat-town', label: 'Kumarghat Town', pincode: '799261' },
    { value: 'manu', label: 'Manu', pincode: '799105' },
    { value: 'nalkata', label: 'Nalkata', pincode: '799262' },
    { value: 'ranirbazar', label: 'Ranirbazar', pincode: '799013' },
    { value: 'sadarbari', label: 'Sadarbari', pincode: '799263' },
    { value: 'sonamura', label: 'Sonamura', pincode: '799131' },
    { value: 'tangrakhura', label: 'Tangrakhura', pincode: '799264' },
    { value: 'udayachhara', label: 'Udayachhara', pincode: '799154' },
    { value: 'zodinthara', label: 'Zodinthara', pincode: '799010' },
    { value: 'south-kumarghat', label: 'South Kumarghat', pincode: '799261' },
    { value: 'north-kumarghat', label: 'North Kumarghat', pincode: '799262' }
    ],

  'nagpur': [
    { value: 'abhyankar-Nagar', label: 'Abhyankar Nagar', pincode: '440010' },
    { value: 'ajni', label: 'Ajni', pincode: '440003' },
    { value: 'alagondi', label: 'Alagondi', pincode: '441108' },
    { value: 'ambazari', label: 'Ambazari', pincode: '440022' },
    { value: 'amravati-Road', label: 'Amravati Road', pincode: '440001' },
    { value: 'anant-Nagar', label: 'Anant Nagar', pincode: '440013' },
    { value: 'angulima-lNagar', label: 'Angulimal Nagar', pincode: '440026' },
    { value: 'ansar-Nagar', label: 'Ansar Nagar', pincode: '440015' },
    { value: 'ashirwad-Nagar', label: 'Ashirwad Nagar', pincode: '440024' },
    { value: 'ayodhya-Nagar', label: 'Ayodhya Nagar', pincode: '440024' },
    { value: 'azmashah-Layout', label: 'Azamshah Layout', pincode: '440024' },
    { value: 'bagadganj', label: 'Bagadganj', pincode: '440008' },
    { value: 'bajaj-Nagar', label: 'Bajaj Nagar', pincode: '440010' },
    { value: 'balabhaupeth', label: 'Balabhaupeth', pincode: '440017' },
    { value: 'bajeria', label: 'Bajeria', pincode: '440018' },
    { value: 'banwadi', label: 'Banwadi', pincode: '441108' },
    { value: 'bela', label: 'Bela', pincode: '441108' },
    { value: 'beltarodi', label: 'Beltarodi', pincode: '440015' },
    { value: 'besa', label: 'Besa', pincode: '440037' },
    { value: 'besa-PiplaRoad', label: 'Besa-Pipla Road', pincode: '440037' },
    { value: 'besa-Road', label: 'Besa Road', pincode: '440037' },
    { value: 'bhagwan-Nagar', label: 'Bhagwan Nagar', pincode: '440027' },
    { value: 'bhandewadi', label: 'Bhandewadi', pincode: '440035' },
    { value: 'bharat-Nagar', label: 'Bharat Nagar', pincode: '440001' },
    { value: 'bhartwada', label: 'Bhartwada', pincode: '440035' },
    { value: 'bhilgaon', label: 'Bhilgaon', pincode: '440026' },
    { value: 'bhiwapur', label: 'Bhiwapur', pincode: '441201' },
    { value: 'bhokara', label: 'Bhokara', pincode: '441111' },
    { value: 'binaki', label: 'Binaki', pincode: '440017' },
    { value: 'borkhedi', label: 'Borkhedi', pincode: '441108' },
    { value: 'buti-Bori', label: 'Buti Bori', pincode: '441122' },
    { value: 'chandan-Nagar', label: 'Chandan Nagar', pincode: '440024' },
    { value: 'chargaon', label: 'Chargaon', pincode: '441302' },
    { value: 'chatrapati-Nagar', label: 'Chatrapati Nagar', pincode: '440015' },
    { value: 'civil-Lines', label: 'Civil Lines', pincode: '440001' },
    { value: 'clark-Town', label: 'Clark Town', pincode: '440004' },
    { value: 'dahegaon', label: 'Dahegaon', pincode: '441113' },
    { value: 'dangarpura', label: 'Dangarpura', pincode: '441110' },
    { value: 'dharampeth', label: 'Dharampeth', pincode: '440010' },
    { value: 'dindayal-Nagar', label: 'Dindayal Nagar', pincode: '440022' },
    { value: 'duttawadi', label: 'Duttawadi', pincode: '440023' },
    { value: 'gandhibagh', label: 'Gandhibagh', pincode: '440002' },
    { value: 'godhni', label: 'Godhni', pincode: '441123' },
    { value: 'gokulpeth', label: 'Gokulpeth', pincode: '440010' },
    { value: 'gopal-Nagar', label: 'Gopal Nagar', pincode: '440022' },
    { value: 'gorepeth', label: 'Gorepeth', pincode: '440010' },
    { value: 'gorewada', label: 'Gorewada', pincode: '440013' },
    { value: 'hansapuri', label: 'Hansapuri', pincode: '440018' },
    { value: 'hingna', label: 'Hingna', pincode: '441110' },
    { value: 'hudkeshwar-Road', label: 'Hudkeshwar Road', pincode: '440034' },
    { value: 'jamtha', label: 'Jamtha', pincode: '441108' },
    { value: 'khamla', label: 'Khamla', pincode: '440025' },
    { value: 'koradi-Road', label: 'Koradi Road', pincode: '441111' },
    { value: 'laxmi-Nagar', label: 'Laxmi Nagar', pincode: '440022' },
    { value: 'mahal', label: 'Mahal', pincode: '440032' },
    { value: 'mhalgi-Nagar', label: 'Mhalgi Nagar', pincode: '440034' },
    { value: 'mominpura', label: 'Mominpura', pincode: '440018' },
    { value: 'narendra-Nagar', label: 'Narendra Nagar', pincode: '440015' },
    { value: 'narsala', label: 'Narsala', pincode: '440034' },
    { value: 'parde-Layout', label: 'Parde Layout', pincode: '440025' },
    { value: 'premnagar', label: 'Premnagar', pincode: '440002' },
    { value: 'ramdaspeth', label: 'Ramdaspeth', pincode: '440010' },
    { value: 'reshamBag', label: 'ReshamBag', pincode: '440009' },
    { value: 'rPTS-Road', label: 'RPTS Road', pincode: '440022' },
    { value: 'sadar', label: 'Sadar', pincode: '440001' },
    { value: 'shivaji-Nagar', label: 'Shivaji Nagar', pincode: '440010' },
    { value: 'somalwada', label: 'Somalwada', pincode: '440025' },
    { value: 'takli', label: 'Takli', pincode: '440030' },
    { value: 'vishwakarma-Nagar', label: 'Vishwakarma Nagar', pincode: '440027' },
    { value: 'wadi', label: 'Wadi', pincode: '440023' },
    { value: 'wanadongri', label: 'Wanadongri', pincode: '441110' },
    { value: 'zingabai-Takli', label: 'Zingabai Takli', pincode: '440030' }
  ],
  'wardha': [
  { value: 'anvapada', label: 'Anvapada', pincode: '442001' },
  { value: 'badnera', label: 'Badnera', pincode: '444701' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '442103' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '442103' },
  { value: 'chandpur', label: 'Chandpur', pincode: '442303' },
  { value: 'dhamangaon', label: 'Dhamangaon', pincode: '444709' },
  { value: 'jambhli', label: 'Jambhli', pincode: '442304' },
  { value: 'khambala', label: 'Khambala', pincode: '442304' },
  { value: 'kheda', label: 'Kheda', pincode: '442202' },
  { value: 'morshi', label: 'Morshi', pincode: '444701' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '442207' },
  { value: 'punapur', label: 'Punapur', pincode: '442301' },
  { value: 'raikheda', label: 'Raikheda', pincode: '442303' },
  { value: 'sawargaon', label: 'Sawargaon', pincode: '442307' },
  { value: 'sindi', label: 'Sindi', pincode: '442001' },
  { value: 'shahapur', label: 'Shahapur', pincode: '442307' },
  { value: 'shiraswadi', label: 'Shiraswadi', pincode: '442206' },
  { value: 'sindhi', label: 'Sindhi', pincode: '442307' },
  { value: 'tahsil', label: 'Tahsil', pincode: '442002' },
  { value: 'wardha', label: 'Wardha', pincode: '442001' }
  ],
  
  'yavatmal': [
  { value: 'adgaon', label: 'Adgaon', pincode: '445001' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '445204' },
  { value: 'banegaon', label: 'Banegaon', pincode: '445001' },
  { value: 'chandpur', label: 'Chandpur', pincode: '445103' },
  { value: 'digras', label: 'Digras', pincode: '445203' },
  { value: 'gajanan-nagar', label: 'Gajanan Nagar', pincode: '445001' },
  { value: 'jambhli', label: 'Jambhli', pincode: '445306' },
  { value: 'kandali', label: 'Kandali', pincode: '445001' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '445208' },
  { value: 'lasur', label: 'Lasur', pincode: '445205' },
  { value: 'malkapur', label: 'Malkapur', pincode: '445107' },
  { value: 'nandanvan', label: 'Nandanvan', pincode: '445001' },
  { value: 'nawapur', label: 'Nawapur', pincode: '445305' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '445001' },
  { value: 'ramtek', label: 'Ramtek', pincode: '445204' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '445001' },
  { value: 'varora', label: 'Varora', pincode: '445301' },
  { value: 'wadi', label: 'Wadi', pincode: '445202' },
  { value: 'warora', label: 'Warora', pincode: '445204' },
  { value: 'yavatmal', label: 'Yavatmal', pincode: '445001' },
  { value: 'zari', label: 'Zari', pincode: '445206' }
  ],
    
  'ulhasnagar': [
  { value: 'bhagat-ram', label: 'Bhagat Ram', pincode: '421004' },
  { value: 'ulhasnagar-1', label: 'Ulhasnagar-1', pincode: '421001' },
  { value: 'ulhasnagar-2', label: 'Ulhasnagar-2', pincode: '421002' },
  { value: 'ulhasnagar-3', label: 'Ulhasnagar-3', pincode: '421003' },
  { value: 'ulhasnagar-4', label: 'Ulhasnagar-4', pincode: '421005' },
  { value: 'ulhasnagar-5', label: 'Ulhasnagar-5', pincode: '421006' },
  { value: 'ulhasnagar-6', label: 'Ulhasnagar-6', pincode: '421007' },
  { value: 'ulhasnagar-7', label: 'Ulhasnagar-7', pincode: '421008' },
  { value: 'ulhasnagar-8', label: 'Ulhasnagar-8', pincode: '421009' },
  { value: 'ulhasnagar-9', label: 'Ulhasnagar-9', pincode: '421010' },
  { value: 'new-ulhasnagar', label: 'New Ulhasnagar', pincode: '421011' },
  { value: 'mumbai-ambarnath', label: 'Mumbai-Ambarnath', pincode: '421501' },
  { value: 'kalyan-1', label: 'Kalyan-1', pincode: '421301' },
  { value: 'kalyan-2', label: 'Kalyan-2', pincode: '421302' },
  { value: 'dombivli', label: 'Dombivli', pincode: '421202' },
  { value: 'vikramgadh', label: 'Vikramgadh', pincode: '421302' },
  { value: 'ambernath-east', label: 'Ambernath East', pincode: '421501' },
  { value: 'ambernath-west', label: 'Ambernath West', pincode: '421501' },
  { value: 'badlapur', label: 'Badlapur', pincode: '421503' }
  ],
  
  'buldhana': [
  { value: 'banosa', label: 'Banosa', pincode: '444306' },
  { value: 'chikhli', label: 'Chikhli', pincode: '443201' },
  { value: 'deulgaon-mahi', label: 'Deulgaon Mahi', pincode: '443206' },
  { value: 'deulgaon-raja', label: 'Deulgaon Raja', pincode: '443204' },
  { value: 'jalgaon-jamod', label: 'Jalgaon Jamod', pincode: '443402' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '444303' },
  { value: 'lonar', label: 'Lonar', pincode: '443302' },
  { value: 'mehkar', label: 'Mehkar', pincode: '443301' },
  { value: 'motala', label: 'Motala', pincode: '443103' },
  { value: 'nandura', label: 'Nandura', pincode: '443404' },
  { value: 'rajaura', label: 'Rajaura', pincode: '443204' },
  { value: 'sangrampur', label: 'Sangrampur', pincode: '444202' },
  { value: 'shegaon', label: 'Shegaon', pincode: '444203' },
  { value: 'sindkhed-raja', label: 'Sindkhed Raja', pincode: '443203' },
  { value: 'warwat-bakhal', label: 'Warwat Bakhal', pincode: '443304' }
  ],
  
  'sangamner': [
  { value: 'akole', label: 'Akole', pincode: '422601' },
  { value: 'ashvi-bk', label: 'Ashvi BK', pincode: '422605' },
  { value: 'bota', label: 'Bota', pincode: '422602' },
  { value: 'dhandarphal', label: 'Dhandarphal', pincode: '422603' },
  { value: 'ghulewadi', label: 'Ghulewadi', pincode: '422605' },
  { value: 'gorakhwadi', label: 'Gorakhwadi', pincode: '422605' },
  { value: 'jambhulwadi', label: 'Jambhulwadi', pincode: '422605' },
  { value: 'kausadi', label: 'Kausadi', pincode: '422606' },
  { value: 'khandgaon', label: 'Khandgaon', pincode: '422605' },
  { value: 'khandobachiwadi', label: 'Khandobachiwadi', pincode: '422605' },
  { value: 'kokangaon', label: 'Kokangaon', pincode: '422605' },
  { value: 'malunje', label: 'Malunje', pincode: '422605' },
  { value: 'malegaon-pathar', label: 'Malegaon Pathar', pincode: '422605' },
  { value: 'nalwandi', label: 'Nalwandi', pincode: '422605' },
  { value: 'pangari', label: 'Pangari', pincode: '422606' },
  { value: 'pimpalgaon-konkan', label: 'Pimpalgaon Konkan', pincode: '422605' },
  { value: 'rajapur', label: 'Rajapur', pincode: '422603' },
  { value: 'sangamner-city', label: 'Sangamner City', pincode: '422605' },
  { value: 'savargaon-ghule', label: 'Savargaon Ghule', pincode: '422606' },
  { value: 'shingave', label: 'Shingave', pincode: '422605' },
  { value: 'sonoshi', label: 'Sonoshi', pincode: '422605' },
  { value: 'wadgaon-landaga', label: 'Wadgaon Landaga', pincode: '422605' },
  { value: 'wadner', label: 'Wadner', pincode: '422606' },
  { value: 'wadi', label: 'Wadi', pincode: '422605' }
  ],
  
  'washim': [
  { value: 'anekarwadi', label: 'Anekarwadi', pincode: '444507' },
  { value: 'anjanpur', label: 'Anjanpur', pincode: '444510' },
  { value: 'bellura', label: 'Bellura', pincode: '444504' },
  { value: 'bhoyarwadi', label: 'Bhoyarwadi', pincode: '444504' },
  { value: 'chikhali', label: 'Chikhali', pincode: '444503' },
  { value: 'degaon', label: 'Degaon', pincode: '444505' },
  { value: 'ekburji', label: 'Ekburji', pincode: '444506' },
  { value: 'ganeshpur', label: 'Ganeshpur', pincode: '444503' },
  { value: 'kanergaon', label: 'Kanergaon', pincode: '444506' },
  { value: 'karanja-lad', label: 'Karanja Lad', pincode: '444110' },
  { value: 'katpur', label: 'Katpur', pincode: '444507' },
  { value: 'kondala', label: 'Kondala', pincode: '444503' },
  { value: 'manora', label: 'Manora', pincode: '444404' },
  { value: 'mangrulpir', label: 'Mangrulpir', pincode: '444403' },
  { value: 'medshi', label: 'Medshi', pincode: '444510' },
  { value: 'nimbhi', label: 'Nimbhi', pincode: '444503' },
  { value: 'risod', label: 'Risod', pincode: '444506' },
  { value: 'sawargaon', label: 'Sawargaon', pincode: '444507' },
  { value: 'shirpur', label: 'Shirpur', pincode: '444504' },
  { value: 'sukali', label: 'Sukali', pincode: '444504' },
  { value: 'washim-city', label: 'Washim City', pincode: '444505' },
  { value: 'washi', label: 'Washi', pincode: '444507' },
  { value: 'yeoti', label: 'Yeoti', pincode: '444505' }
  ],
  
  'hadgaon': [
  { value: 'adgaon', label: 'Adgaon', pincode: '431712' },
  { value: 'anvapada', label: 'Anvapada', pincode: '431712' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '431711' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '431711' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '431702' },
  { value: 'hadgaon', label: 'Hadgaon', pincode: '431712' },
  { value: 'karanjala', label: 'Karanjala', pincode: '431703' },
  { value: 'kuthewadi', label: 'Kuthewadi', pincode: '431712' },
  { value: 'pendhari', label: 'Pendhari', pincode: '431702' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '431711' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '431711' },
  { value: 'takli', label: 'Takli', pincode: '431703' },
  { value: 'bandhara', label: 'Bandhara', pincode: '431715' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '431717' },
  { value: 'borigaon', label: 'Borigaon', pincode: '431715' },
  { value: 'malkapur', label: 'Malkapur', pincode: '431703' },
  { value: 'manegaon', label: 'Manegaon', pincode: '431712' },
  { value: 'nimbora', label: 'Nimbora', pincode: '431715' },
  { value: 'pimpalgaon-jalgaon', label: 'Pimpalgaon Jalgaon', pincode: '431716' },
  { value: 'rajur', label: 'Rajur', pincode: '431703' },
  { value: 'vazirabad', label: 'Vazirabad', pincode: '431705' }
  ],
  
  'dahanu': [
  { value: 'amboli', label: 'Amboli', pincode: '401602' },
  { value: 'anwa', label: 'Anwa', pincode: '401606' },
  { value: 'babhai', label: 'Babhai', pincode: '401602' },
  { value: 'bordi', label: 'Bordi', pincode: '401701' },
  { value: 'dahanu', label: 'Dahanu', pincode: '401602' },
  { value: 'dahanu-tribal', label: 'Dahanu Tribal', pincode: '401602' },
  { value: 'garkheda', label: 'Garkheda', pincode: '401602' },
  { value: 'kashimira', label: 'Kashimira', pincode: '401603' },
  { value: 'khadki', label: 'Khadki', pincode: '401604' },
  { value: 'kolak', label: 'Kolak', pincode: '401606' },
  { value: 'mangrol', label: 'Mangrol', pincode: '401602' },
  { value: 'naroli', label: 'Naroli', pincode: '401602' },
  { value: 'tarapur', label: 'Tarapur', pincode: '401606' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '401602' },
  { value: 'boisar', label: 'Boisar', pincode: '401504' },
  { value: 'gokhiware', label: 'Gokhiware', pincode: '401504' },
  { value: 'jambhulpada', label: 'Jambhulpada', pincode: '401602' },
  { value: 'malad', label: 'Malad', pincode: '401602' },
  { value: 'palghar', label: 'Palghar', pincode: '401404' },
  { value: 'virar', label: 'Virar', pincode: '401303' }
  ],
  
  'yeola': [
  { value: 'alapur', label: 'Alapur', pincode: '423401' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '423404' },
  { value: 'bhalgaon', label: 'Bhalgaon', pincode: '423402' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '423404' },
  { value: 'chapad', label: 'Chapad', pincode: '423402' },
  { value: 'jambhulpada', label: 'Jambhulpada', pincode: '423405' },
  { value: 'kamad', label: 'Kamad', pincode: '423406' },
  { value: 'kandari', label: 'Kandari', pincode: '423403' },
  { value: 'mankapur', label: 'Mankapur', pincode: '423401' },
  { value: 'mohadi', label: 'Mohadi', pincode: '423401' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '423405' },
  { value: 'shirasgaon', label: 'Shirasgaon', pincode: '423402' },
  { value: 'yeola', label: 'Yeola', pincode: '423401' },
  { value: 'adgaon', label: 'Adgaon', pincode: '423403' },
  { value: 'babhulgaon-bk', label: 'Babhulgaon BK', pincode: '423405' },
  { value: 'nimbhara', label: 'Nimbhara', pincode: '423402' },
  { value: 'rajaur', label: 'Rajaur', pincode: '423406' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '423407' },
  { value: 'varkheda', label: 'Varkheda', pincode: '423401' }
  ],
  
  'beed': [
  { value: 'ambajogai', label: 'Ambajogai', pincode: '431517' },
  { value: 'anvapada', label: 'Anvapada', pincode: '431514' },
  { value: 'baranjala', label: 'Baranjala', pincode: '431503' },
  { value: 'beed', label: 'Beed', pincode: '431122' },
  { value: 'borgaon', label: 'Borgaon', pincode: '431520' },
  { value: 'chakur', label: 'Chakur', pincode: '431511' },
  { value: 'dhamangaon', label: 'Dhamangaon', pincode: '431513' },
  { value: 'hasnabad', label: 'Hasnabad', pincode: '431517' },
  { value: 'karmad', label: 'Karmad', pincode: '431509' },
  { value: 'kingaon', label: 'Kingaon', pincode: '431503' },
  { value: 'majri', label: 'Majri', pincode: '431516' },
  { value: 'mohammadwadi', label: 'Mohammadwadi', pincode: '431505' },
  { value: 'morgad', label: 'Morgad', pincode: '431515' },
  { value: 'nandgaon', label: 'Nandgaon', pincode: '431508' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '431512' },
  { value: 'purna', label: 'Purna', pincode: '431518' },
  { value: 'sakhra', label: 'Sakhra', pincode: '431522' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '431510' },
  { value: 'bandhavi', label: 'Bandhavi', pincode: '431504' },
  { value: 'gadad', label: 'Gadad', pincode: '431523' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '431521' },
  { value: 'kankari', label: 'Kankari', pincode: '431506' },
  { value: 'katakheda', label: 'Katakheda', pincode: '431507' },
  { value: 'nagapur', label: 'Nagapur', pincode: '431509' },
  { value: 'pachod', label: 'Pachod', pincode: '431525' },
  { value: 'sarkheda', label: 'Sarkheda', pincode: '431526' }
  ],
  
  'ahilya-nagar': [
  { value: 'bhivpur', label: 'Bhivpur', pincode: '422204' },
  { value: 'budhpur', label: 'Budhpur', pincode: '422206' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '422212' },
  { value: 'khursapur', label: 'Khursapur', pincode: '422205' },
  { value: 'mahabubnagar', label: 'Mahabubnagar', pincode: '422213' },
  { value: 'mohammadpur', label: 'Mohammadpur', pincode: '422214' },
  { value: 'narsapur', label: 'Narsapur', pincode: '422215' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '422201' },
  { value: 'rangpur', label: 'Rangpur', pincode: '422217' },
  { value: 'satpur', label: 'Satpur', pincode: '422205' },
  { value: 'sindhpur', label: 'Sindhpur', pincode: '422220' },
  { value: 'vishrampur', label: 'Vishrampur', pincode: '422216' },
  { value: 'alapur', label: 'Alapur', pincode: '422202' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '422203' },
  { value: 'bardi', label: 'Bardi', pincode: '422211' },
  { value: 'dhamangaon', label: 'Dhamangaon', pincode: '422209' },
  { value: 'garkheda', label: 'Garkheda', pincode: '422210' },
  { value: 'jambhulpada', label: 'Jambhulpada', pincode: '422218' },
  { value: 'khandvi', label: 'Khandvi', pincode: '422208' },
  { value: 'khambala', label: 'Khambala', pincode: '422207' },
  { value: 'manegaon', label: 'Manegaon', pincode: '422209' },
  { value: 'pimpalwadi', label: 'Pimpalwadi', pincode: '422205' },
  { value: 'ramnagar', label: 'Ramnagar', pincode: '422219' },
  { value: 'rishalpur', label: 'Rishalpur', pincode: '422222' }
  ],
  
  'ichalkaranji': [
  { value: 'adgaon', label: 'Adgaon', pincode: '416115' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '416118' },
  { value: 'chandrapur', label: 'Chandrapur', pincode: '416114' },
  { value: 'ichalkaranji', label: 'Ichalkaranji', pincode: '416115' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '416116' },
  { value: 'kamgar', label: 'Kamgar', pincode: '416112' },
  { value: 'kudnur', label: 'Kudnur', pincode: '416118' },
  { value: 'mandre', label: 'Mandre', pincode: '416111' },
  { value: 'mankapur', label: 'Mankapur', pincode: '416116' },
  { value: 'mulgaon', label: 'Mulgaon', pincode: '416116' },
  { value: 'nakpur', label: 'Nakpur', pincode: '416113' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '416114' },
  { value: 'rajapur', label: 'Rajapur', pincode: '416113' },
  { value: 'shiroli', label: 'Shiroli', pincode: '416119' },
  { value: 'wadi', label: 'Wadi', pincode: '416119' },
  { value: 'varkheda', label: 'Varkheda', pincode: '416113' },
  { value: 'sangli', label: 'Sangli', pincode: '416112' },
  { value: 'bhivpur-khurd', label: 'Bhivpur Khurd', pincode: '416118' },
  { value: 'sanjay-nagar', label: 'Sanjay Nagar', pincode: '416114' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '416118' },
  { value: 'borgaon', label: 'Borgaon', pincode: '416119' },
  { value: 'gadad', label: 'Gadad', pincode: '416115' },
  { value: 'pahur', label: 'Pahur', pincode: '416114' },
  { value: 'solapur', label: 'Solapur', pincode: '416115' },
  { value: 'tarabai-nagar', label: 'Tarabai Nagar', pincode: '416112' }
  ],
  
  'malegaon': [
  { value: 'adgaon', label: 'Adgaon', pincode: '423205' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '423203' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '423203' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '423206' },
  { value: 'ghatpada', label: 'Ghatpada', pincode: '423202' },
  { value: 'godapada', label: 'Godapada', pincode: '423208' },
  { value: 'malegaon', label: 'Malegaon', pincode: '423203' },
  { value: 'nimbhora', label: 'Nimbhora', pincode: '423205' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '423206' },
  { value: 'rajur', label: 'Rajur', pincode: '423207' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '423208' },
  { value: 'shirasgaon', label: 'Shirasgaon', pincode: '423204' },
  { value: 'varkheda', label: 'Varkheda', pincode: '423202' },
  { value: 'ambapur', label: 'Ambapur', pincode: '423209' },
  { value: 'ankapur', label: 'Ankapur', pincode: '423210' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '423211' },
  { value: 'dhamangaon', label: 'Dhamangaon', pincode: '423212' },
  { value: 'ghogargaon', label: 'Ghogargaon', pincode: '423213' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '423214' },
  { value: 'kamdapur', label: 'Kamdapur', pincode: '423215' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '423216' },
  { value: 'malkapur', label: 'Malkapur', pincode: '423217' },
  { value: 'pimpalwadi', label: 'Pimpalwadi', pincode: '423218' },
  { value: 'rangpur', label: 'Rangpur', pincode: '423219' },
  { value: 'shirsalwadi', label: 'Shirsalwadi', pincode: '423220' }
  ],
  
  'parbhani': [
  { value: 'adgaon', label: 'Adgaon', pincode: '431101' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '431104' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '431111' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '431112' },
  { value: 'godapada', label: 'Godapada', pincode: '431113' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '431114' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '431115' },
  { value: 'malegaon', label: 'Malegaon', pincode: '431116' },
  { value: 'mandwa', label: 'Mandwa', pincode: '431117' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '431118' },
  { value: 'rajur', label: 'Rajur', pincode: '431119' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '431120' },
  { value: 'varkheda', label: 'Varkheda', pincode: '431121' },
  { value: 'warud', label: 'Warud', pincode: '431122' },
  { value: 'zari', label: 'Zari', pincode: '431123' },
  { value: 'alapur', label: 'Alapur', pincode: '431124' },
  { value: 'balapur', label: 'Balapur', pincode: '431125' },
  { value: 'chincholi', label: 'Chincholi', pincode: '431126' },
  { value: 'dhamangaon', label: 'Dhamangaon', pincode: '431127' },
  { value: 'gajapur', label: 'Gajapur', pincode: '431128' },
  { value: 'ganegaon', label: 'Ganegaon', pincode: '431129' },
  { value: 'khandvi', label: 'Khandvi', pincode: '431130' },
  { value: 'laxminagar', label: 'Laxminagar', pincode: '431131' },
  { value: 'malkapur', label: 'Malkapur', pincode: '431132' },
  { value: 'pimpalwadi', label: 'Pimpalwadi', pincode: '431133' },
  { value: 'shetkheda', label: 'Shetkheda', pincode: '431134' },
  { value: 'shirasgaon', label: 'Shirasgaon', pincode: '431135' },
  { value: 'tirwade', label: 'Tirwade', pincode: '431136' },
  { value: 'vankheda', label: 'Vankheda', pincode: '431137' }
  ],
  
  'sangli': [
  { value: 'adgaon', label: 'Adgaon', pincode: '416416' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '416410' },
  { value: 'chinchani', label: 'Chinchani', pincode: '416421' },
  { value: 'godavari', label: 'Godavari', pincode: '416418' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '416409' },
  { value: 'kadepur', label: 'Kadepur', pincode: '416420' },
  { value: 'malegaon', label: 'Malegaon', pincode: '416408' },
  { value: 'manegaon', label: 'Manegaon', pincode: '416406' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '416417' },
  { value: 'rajapur', label: 'Rajapur', pincode: '416423' },
  { value: 'sangli', label: 'Sangli', pincode: '416416' },
  { value: 'sarsangvi', label: 'Sarsangvi', pincode: '416419' },
  { value: 'shirasgaon', label: 'Shirasgaon', pincode: '416405' },
  { value: 'wangi', label: 'Wangi', pincode: '416424' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '416424' },
  { value: 'banegaon', label: 'Banegaon', pincode: '416426' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '416431' },
  { value: 'devgaon', label: 'Devgaon', pincode: '416432' },
  { value: 'ghatpada', label: 'Ghatpada', pincode: '416433' },
  { value: 'jambhli', label: 'Jambhli', pincode: '416434' },
  { value: 'kamthala', label: 'Kamthala', pincode: '416435' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '416436' },
  { value: 'malkapur', label: 'Malkapur', pincode: '416437' },
  { value: 'pathardi', label: 'Pathardi', pincode: '416438' },
  { value: 'rajanpur', label: 'Rajanpur', pincode: '416439' },
  { value: 'shetkheda', label: 'Shetkheda', pincode: '416440' },
  { value: 'varkheda', label: 'Varkheda', pincode: '416441' }
  ],
  
  'pusad': [
  { value: 'adgaon', label: 'Adgaon', pincode: '445204' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '445201' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '445202' },
  { value: 'godapada', label: 'Godapada', pincode: '445205' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '445206' },
  { value: 'kadegaon', label: 'Kadegaon', pincode: '445207' },
  { value: 'malegaon', label: 'Malegaon', pincode: '445208' },
  { value: 'manegaon', label: 'Manegaon', pincode: '445209' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '445210' },
  { value: 'rajur', label: 'Rajur', pincode: '445211' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '445212' },
  { value: 'varkheda', label: 'Varkheda', pincode: '445213' },
  { value: 'warud', label: 'Warud', pincode: '445214' },
  { value: 'zari', label: 'Zari', pincode: '445215' },
  { value: 'alapur', label: 'Alapur', pincode: '445217' },
  { value: 'banegaon', label: 'Banegaon', pincode: '445218' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '445219' },
  { value: 'devgaon', label: 'Devgaon', pincode: '445220' },
  { value: 'jalgaon-bk', label: 'Jalgaon Bk', pincode: '445221' },
  { value: 'kamargaon', label: 'Kamargaon', pincode: '445222' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '445223' },
  { value: 'malkapur', label: 'Malkapur', pincode: '445224' },
  { value: 'pathardi', label: 'Pathardi', pincode: '445225' },
  { value: 'rajanpur', label: 'Rajanpur', pincode: '445226' },
  { value: 'shetkheda', label: 'Shetkheda', pincode: '445227' },
  { value: 'shirasgaon', label: 'Shirasgaon', pincode: '445228' },
  { value: 'tirwade', label: 'Tirwade', pincode: '445229' }
  ],
  
  'hingoli': [
  { value: 'adgaon', label: 'Adgaon', pincode: '431513' },
  { value: 'alapur', label: 'Alapur', pincode: '431506' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '431501' },
  { value: 'borgaon', label: 'Borgaon', pincode: '431507' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '431504' },
  { value: 'devgaon', label: 'Devgaon', pincode: '431515' },
  { value: 'godavari', label: 'Godavari', pincode: '431505' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '431506' },
  { value: 'kadegaon', label: 'Kadegaon', pincode: '431507' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '431508' },
  { value: 'malegaon', label: 'Malegaon', pincode: '431508' },
  { value: 'manegaon', label: 'Manegaon', pincode: '431509' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '431510' },
  { value: 'rajur', label: 'Rajur', pincode: '431511' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '431512' },
  { value: 'sonkheda', label: 'Sonkheda', pincode: '431514' },
  { value: 'varkheda', label: 'Varkheda', pincode: '431514' },
  { value: 'warud', label: 'Warud', pincode: '431515' },
  { value: 'zari', label: 'Zari', pincode: '431516' }
  ],
  
  'bhandara': [
  { value: 'adgaon', label: 'Adgaon', pincode: '441901' },
  { value: 'alapur', label: 'Alapur', pincode: '441902' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '441902' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '441903' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '441903' },
  { value: 'devgaon', label: 'Devgaon', pincode: '441904' },
  { value: 'godhani', label: 'Godhani', pincode: '441904' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '441905' },
  { value: 'kadegaon', label: 'Kadegaon', pincode: '441906' },
  { value: 'kamthala', label: 'Kamthala', pincode: '441907' },
  { value: 'malegaon', label: 'Malegaon', pincode: '441907' },
  { value: 'manegaon', label: 'Manegaon', pincode: '441908' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '441909' },
  { value: 'rajur', label: 'Rajur', pincode: '441910' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '441911' },
  { value: 'varkheda', label: 'Varkheda', pincode: '441912' },
  { value: 'warud', label: 'Warud', pincode: '441913' },
  { value: 'zari', label: 'Zari', pincode: '441914' },
  { value: 'banegaon', label: 'Banegaon', pincode: '441915' },
  { value: 'chandpur', label: 'Chandpur', pincode: '441916' },
  { value: 'jambhli', label: 'Jambhli', pincode: '441917' },
  { value: 'kamargaon', label: 'Kamargaon', pincode: '441918' }
  ],
  
  'indapur': [
  { value: 'adgaon', label: 'Adgaon', pincode: '413106' },
  { value: 'alapur', label: 'Alapur', pincode: '413107' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '413108' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '413109' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '413110' },
  { value: 'devgaon', label: 'Devgaon', pincode: '413111' },
  { value: 'godhani', label: 'Godhani', pincode: '413112' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '413113' },
  { value: 'kamargaon', label: 'Kamargaon', pincode: '413114' },
  { value: 'kadegaon', label: 'Kadegaon', pincode: '413115' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '413116' },
  { value: 'malegaon', label: 'Malegaon', pincode: '413117' },
  { value: 'manegaon', label: 'Manegaon', pincode: '413118' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '413119' },
  { value: 'rajur', label: 'Rajur', pincode: '413120' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '413121' },
  { value: 'varkheda', label: 'Varkheda', pincode: '413122' },
  { value: 'warud', label: 'Warud', pincode: '413123' },
  { value: 'zari', label: 'Zari', pincode: '413124' },
  { value: 'banegaon', label: 'Banegaon', pincode: '413125' },
  { value: 'chakrapur', label: 'Chakrapur', pincode: '413126' },
  { value: 'devpur', label: 'Devpur', pincode: '413127' },
  { value: 'kedarwadi', label: 'Kedarwadi', pincode: '413128' },
  { value: 'loni', label: 'Loni', pincode: '413129' }
  ],
  
  'nandgaon': [
  { value: 'adgaon', label: 'Adgaon', pincode: '423106' },
  { value: 'alapur', label: 'Alapur', pincode: '423107' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '423108' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '423109' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '423110' },
  { value: 'devgaon', label: 'Devgaon', pincode: '423111' },
  { value: 'godhani', label: 'Godhani', pincode: '423112' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '423113' },
  { value: 'kamargaon', label: 'Kamargaon', pincode: '423114' },
  { value: 'kadegaon', label: 'Kadegaon', pincode: '423115' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '423116' },
  { value: 'malegaon', label: 'Malegaon', pincode: '423117' },
  { value: 'manegaon', label: 'Manegaon', pincode: '423118' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '423119' },
  { value: 'rajur', label: 'Rajur', pincode: '423120' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '423121' },
  { value: 'varkheda', label: 'Varkheda', pincode: '423122' },
  { value: 'warud', label: 'Warud', pincode: '423123' },
  { value: 'zari', label: 'Zari', pincode: '423124' },
  { value: 'banegaon', label: 'Banegaon', pincode: '423125' },
  { value: 'chakrapur', label: 'Chakrapur', pincode: '423126' },
  { value: 'devpur', label: 'Devpur', pincode: '423127' },
  { value: 'kedarwadi', label: 'Kedarwadi', pincode: '423128' },
  { value: 'loni', label: 'Loni', pincode: '423129' }
  ],
  
  'ramtek': [
  { value: 'adgaon', label: 'Adgaon', pincode: '441106' },
  { value: 'alapur', label: 'Alapur', pincode: '441107' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '441108' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '441109' },
  { value: 'chandpur', label: 'Chandpur', pincode: '441110' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '441111' },
  { value: 'devpur', label: 'Devpur', pincode: '441112' },
  { value: 'godhani', label: 'Godhani', pincode: '441113' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '441114' },
  { value: 'kamargaon', label: 'Kamargaon', pincode: '441115' },
  { value: 'kadegaon', label: 'Kadegaon', pincode: '441116' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '441117' },
  { value: 'malegaon', label: 'Malegaon', pincode: '441118' },
  { value: 'manegaon', label: 'Manegaon', pincode: '441119' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '441120' },
  { value: 'rajur', label: 'Rajur', pincode: '441121' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '441122' },
  { value: 'varkheda', label: 'Varkheda', pincode: '441123' },
  { value: 'warud', label: 'Warud', pincode: '441124' },
  { value: 'zari', label: 'Zari', pincode: '441125' },
  { value: 'banegaon', label: 'Banegaon', pincode: '441126' },
  { value: 'chakrapur', label: 'Chakrapur', pincode: '441127' },
  { value: 'ghorpuri', label: 'Ghorpuri', pincode: '441128' },
  { value: 'kamalapur', label: 'Kamalapur', pincode: '441129' }
  ],
  
  'pandharkawada': [
  { value: 'adgaon', label: 'Adgaon', pincode: '442302' },
  { value: 'alapur', label: 'Alapur', pincode: '442303' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '442304' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '442305' },
  { value: 'chandpur', label: 'Chandpur', pincode: '442306' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '442307' },
  { value: 'devpur', label: 'Devpur', pincode: '442308' },
  { value: 'godhani', label: 'Godhani', pincode: '442309' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '442310' },
  { value: 'kamargaon', label: 'Kamargaon', pincode: '442311' },
  { value: 'kadegaon', label: 'Kadegaon', pincode: '442312' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '442313' },
  { value: 'malegaon', label: 'Malegaon', pincode: '442314' },
  { value: 'manegaon', label: 'Manegaon', pincode: '442315' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '442316' },
  { value: 'rajur', label: 'Rajur', pincode: '442317' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '442318' },
  { value: 'varkheda', label: 'Varkheda', pincode: '442319' },
  { value: 'warud', label: 'Warud', pincode: '442320' },
  { value: 'zari', label: 'Zari', pincode: '442321' },
  { value: 'banegaon', label: 'Banegaon', pincode: '442322' },
  { value: 'chakrapur', label: 'Chakrapur', pincode: '442323' },
  { value: 'godavari', label: 'Godavari', pincode: '442324' },
  { value: 'kamalapur', label: 'Kamalapur', pincode: '442325' },
  { value: 'pimpalwadi', label: 'Pimpalwadi', pincode: '442326' }
  ],
  
  'yawal': [
  { value: 'adgaon', label: 'Adgaon', pincode: '425301' },
  { value: 'alapur', label: 'Alapur', pincode: '425302' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '425303' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '425304' },
  { value: 'chandpur', label: 'Chandpur', pincode: '425305' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '425306' },
  { value: 'devpur', label: 'Devpur', pincode: '425307' },
  { value: 'godhani', label: 'Godhani', pincode: '425308' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '425309' },
  { value: 'kamargaon', label: 'Kamargaon', pincode: '425310' },
  { value: 'kadegaon', label: 'Kadegaon', pincode: '425311' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '425312' },
  { value: 'malegaon', label: 'Malegaon', pincode: '425313' },
  { value: 'manegaon', label: 'Manegaon', pincode: '425314' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '425315' },
  { value: 'rajur', label: 'Rajur', pincode: '425316' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '425317' },
  { value: 'varkheda', label: 'Varkheda', pincode: '425318' },
  { value: 'warud', label: 'Warud', pincode: '425319' },
  { value: 'zari', label: 'Zari', pincode: '425320' },
  { value: 'banegaon', label: 'Banegaon', pincode: '425321' },
  { value: 'chakrapur', label: 'Chakrapur', pincode: '425322' },
  { value: 'godavari', label: 'Godavari', pincode: '425323' },
  { value: 'kamalapur', label: 'Kamalapur', pincode: '425324' },
  { value: 'pimpalwadi', label: 'Pimpalwadi', pincode: '425325' },
  { value: 'jambhli', label: 'Jambhli', pincode: '425326' },
  { value: 'mehndi', label: 'Mehndi', pincode: '425327' },
  { value: 'karanjala', label: 'Karanjala', pincode: '425328' }
  ],
  
  'wani': [
  { value: 'adgaon', label: 'Adgaon', pincode: '445304' },
  { value: 'alapur', label: 'Alapur', pincode: '445305' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '445306' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '445307' },
  { value: 'chandpur', label: 'Chandpur', pincode: '445308' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '445309' },
  { value: 'devpur', label: 'Devpur', pincode: '445310' },
  { value: 'godhani', label: 'Godhani', pincode: '445311' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '445312' },
  { value: 'kamargaon', label: 'Kamargaon', pincode: '445313' },
  { value: 'kadegaon', label: 'Kadegaon', pincode: '445314' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '445315' },
  { value: 'malegaon', label: 'Malegaon', pincode: '445316' },
  { value: 'manegaon', label: 'Manegaon', pincode: '445317' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '445318' },
  { value: 'rajur', label: 'Rajur', pincode: '445319' },
  { value: 'sindkheda', label: 'Sindkheda', pincode: '445320' },
  { value: 'varkheda', label: 'Varkheda', pincode: '445321' },
  { value: 'warud', label: 'Warud', pincode: '445322' },
  { value: 'zari', label: 'Zari', pincode: '445323' },
  { value: 'banegaon', label: 'Banegaon', pincode: '445324' },
  { value: 'chakrapur', label: 'Chakrapur', pincode: '445325' },
  { value: 'godavari', label: 'Godavari', pincode: '445326' },
  { value: 'kamalapur', label: 'Kamalapur', pincode: '445327' },
  { value: 'pimpalwadi', label: 'Pimpalwadi', pincode: '445328' },
  { value: 'jambhli', label: 'Jambhli', pincode: '445329' },
  { value: 'mehndi', label: 'Mehndi', pincode: '445330' },
  { value: 'karanjala', label: 'Karanjala', pincode: '445331' },
  { value: 'murpada', label: 'Murpada', pincode: '445332' },
  { value: 'rahimpur', label: 'Rahimpur', pincode: '445333' }
  ],
  
  'vasai-virar': [
  { value: 'agnel-ashram', label: 'Agnel Ashram', pincode: '401303' },
  { value: 'achole', label: 'Achole', pincode: '401209' },
  { value: 'arjunali', label: 'Arjunali', pincode: '401303' },
  { value: 'bhabhola', label: 'Bhabhola', pincode: '401202' },
  { value: 'bolinj', label: 'Bolinj', pincode: '401303' },
  { value: 'chandansar', label: 'Chandansar', pincode: '401303' },
  { value: 'chulna', label: 'Chulna', pincode: '401202' },
  { value: 'dahisar', label: 'Dahisar', pincode: '401201' },
  { value: 'dongarpada', label: 'Dongarpada', pincode: '401303' },
  { value: 'evershine-city', label: 'Evershine City', pincode: '401208' },
  { value: 'gass', label: 'Gass', pincode: '401303' },
  { value: 'ghokivare', label: 'Ghokivare', pincode: '401303' },
  { value: 'giriz', label: 'Giriz', pincode: '401303' },
  { value: 'juchandra', label: 'Juchandra', pincode: '401208' },
  { value: 'manickpur', label: 'Manickpur', pincode: '401202' },
  { value: 'mardes', label: 'Mardes', pincode: '401303' },
  { value: 'naigaon-east', label: 'Naigaon East', pincode: '401208' },
  { value: 'naigaon-west', label: 'Naigaon West', pincode: '401207' },
  { value: 'nandhakhal', label: 'Nandhakhal', pincode: '401304' },
  { value: 'nandore', label: 'Nandore', pincode: '401304' },
  { value: 'pachubandar', label: 'Pachubandar', pincode: '401301' },
  { value: 'papdi', label: 'Papdi', pincode: '401207' },
  { value: 'rangaon', label: 'Rangaon', pincode: '401201' },
  { value: 'sandor', label: 'Sandor', pincode: '401201' },
  { value: 'sativali', label: 'Sativali', pincode: '401208' },
  { value: 'sopara', label: 'Sopara', pincode: '401203' },
  { value: 'tungareshwar', label: 'Tungareshwar', pincode: '401208' },
  { value: 'umrale', label: 'Umrale', pincode: '401203' },
  { value: 'vasai-east', label: 'Vasai East', pincode: '401208' },
  { value: 'vasai-road', label: 'Vasai Road', pincode: '401202' },
  { value: 'vasai-west', label: 'Vasai West', pincode: '401201' },
  { value: 'virar-east', label: 'Virar East', pincode: '401305' },
  { value: 'virar-west', label: 'Virar West', pincode: '401303' },
  { value: 'waliv', label: 'Waliv', pincode: '401208' }
  ],
  
  'sindhudurg': [
  { "value": "achara", "label": "Achara", "pincode": "416614" },
  { "value": "akeri", "label": "Akeri", "pincode": "416510" },
  { "value": "ambegaon", "label": "Ambegaon", "pincode": "416510" },
  { "value": "amboli", "label": "Amboli", "pincode": "416510" },
  { "value": "ansur", "label": "Ansur", "pincode": "416518" },
  { "value": "asoli", "label": "Asoli", "pincode": "416518" },
  { "value": "banda", "label": "Banda", "pincode": "416511" },
  { "value": "charatha", "label": "Charatha", "pincode": "416510" },
  { "value": "choukul", "label": "Choukul", "pincode": "416510" },
  { "value": "dabholi", "label": "Dabholi", "pincode": "416518" },
  { "value": "danoli", "label": "Danoli", "pincode": "416510" },
  { "value": "devgad", "label": "Devgad", "pincode": "416613" },
  { "value": "devsu", "label": "Devsu", "pincode": "416510" },
  { "value": "hedul", "label": "Hedul", "pincode": "416611" },
  { "value": "insuli", "label": "Insuli", "pincode": "416510" },
  { "value": "kankavli", "label": "Kankavli", "pincode": "416602" },
  { "value": "karivade", "label": "Karivade", "pincode": "416510" },
  { "value": "karlachawhal", "label": "Karlachawhal", "pincode": "416611" },
  { "value": "kasaal", "label": "Kasaal", "pincode": "416603" },
  { "value": "katta", "label": "Katta", "pincode": "416604" },
  { "value": "kolgaon", "label": "Kolgaon", "pincode": "416510" },
  { "value": "kudal", "label": "Kudal", "pincode": "416520" },
  { "value": "kunkeri", "label": "Kunkeri", "pincode": "416510" },
  { "value": "kunkeshwar", "label": "Kunkeshwar", "pincode": "416612" },
  { "value": "madkhol", "label": "Madkhol", "pincode": "416510" },
  { "value": "malgaon", "label": "Malgaon", "pincode": "416510" },
  { "value": "malvan", "label": "Malvan", "pincode": "416606" },
  { "value": "malewad", "label": "Malewad", "pincode": "416510" },
  { "value": "mazgaon", "label": "Mazgaon", "pincode": "416510" },
  { "value": "mhapan", "label": "Mhapan", "pincode": "416605" },
  { "value": "naringre", "label": "Naringre", "pincode": "416610" },
  { "value": "nemle", "label": "Nemle", "pincode": "416510" },
  { "value": "nhaveli", "label": "Nhaveli", "pincode": "416510" },
  { "value": "niravade", "label": "Niravade", "pincode": "416510" },
  { "value": "otavane", "label": "Otavane", "pincode": "416510" },
  { "value": "pal", "label": "Pal", "pincode": "416518" },
  { "value": "phondaghat", "label": "Phondaghat", "pincode": "416601" },
  { "value": "redy", "label": "Redy", "pincode": "416517" },
  { "value": "salgaon", "label": "Salgaon", "pincode": "416510" },
  { "value": "sawantwadi", "label": "Sawantwadi", "pincode": "416510" },
  { "value": "shiroda", "label": "Shiroda", "pincode": "416518" },
  { "value": "talere", "label": "Talere", "pincode": "416611" },
  { "value": "tulas", "label": "Tulas", "pincode": "416518" },
  { "value": "vengurla", "label": "Vengurla", "pincode": "416518" },
  { "value": "wayangani", "label": "Wayangani", "pincode": "416518" }
  ],

'gadchiroli': [
  { value: 'adyal', label: 'Adyal', pincode: '442605' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '442605' },
  { value: 'bhamragad', label: 'Bhamragad', pincode: '442605' },
  { value: 'bhivpur-kalan', label: 'Bhivpur Kalan', pincode: '442605' },
  { value: 'chandpur', label: 'Chandpur', pincode: '442605' },
  { value: 'gadhapur', label: 'Gadhapur', pincode: '442605' },
  { value: 'gadchiroli-town', label: 'Gadchiroli Town', pincode: '442605' },
  { value: 'goregaon', label: 'Goregaon', pincode: '442605' },
  { value: 'jambhli', label: 'Jambhli', pincode: '442605' },
  { value: 'karanjala', label: 'Karanjala', pincode: '442605' },
  { value: 'kelapur', label: 'Kelapur', pincode: '442605' },
  { value: 'kotgir', label: 'Kotgir', pincode: '442605' },
  { value: 'mahadula', label: 'Mahadula', pincode: '442605' },
  { value: 'makadi', label: 'Makadi', pincode: '442605' },
  { value: 'malewada', label: 'Malewada', pincode: '442605' },
  { value: 'pendhari', label: 'Pendhari', pincode: '442605' },
  { value: 'rajur', label: 'Rajur', pincode: '442605' },
  { value: 'surjapur', label: 'Surjapur', pincode: '442605' },
  { value: 'wadgaon', label: 'Wadgaon', pincode: '442605' },
  { value: 'wanala', label: 'Wanala', pincode: '442605' },
  { value: 'bandhara', label: 'Bandhara', pincode: '442605' },
  { value: 'belura', label: 'Belura', pincode: '442605' },
  { value: 'bhivpur-bk', label: 'Bhivpur BK', pincode: '442605' },
  { value: 'chimur', label: 'Chimur', pincode: '442903' },
  { value: 'dhanora', label: 'Dhanora', pincode: '442605' },
  { value: 'gajbhiye', label: 'Gajbhiye', pincode: '442605' },
  { value: 'korpana', label: 'Korpana', pincode: '442203' },
  { value: 'mundara', label: 'Mundara', pincode: '442605' },
  { value: 'pombhurna', label: 'Pombhurna', pincode: '442903' },
  { value: 'rajur-bk', label: 'Rajur BK', pincode: '442605' },
  { value: 'waghala', label: 'Waghala', pincode: '442605' }
  ],
  
  'mumbai-suburban': [
  { value: 'andheri-east', label: 'Andheri East', pincode: '400069' },
  { value: 'andheri-west', label: 'Andheri West', pincode: '400058' },
  { value: 'bandra-east', label: 'Bandra East', pincode: '400051' },
  { value: 'bandra-west', label: 'Bandra West', pincode: '400050' },
  { value: 'borivali-east', label: 'Borivali East', pincode: '400066' },
  { value: 'borivali-west', label: 'Borivali West', pincode: '400092' },
  { value: 'charni-road', label: 'Charni Road', pincode: '400004' },
  { value: 'goregaon-east', label: 'Goregaon East', pincode: '400063' },
  { value: 'goregaon-west', label: 'Goregaon West', pincode: '400104' },
  { value: 'jogeshwari-east', label: 'Jogeshwari East', pincode: '400060' },
  { value: 'jogeshwari-west', label: 'Jogeshwari West', pincode: '400102' },
  { value: 'kandivali-east', label: 'Kandivali East', pincode: '400101' },
  { value: 'kandivali-west', label: 'Kandivali West', pincode: '400067' },
  { value: 'kurla-east', label: 'Kurla East', pincode: '400024' },
  { value: 'kurla-west', label: 'Kurla West', pincode: '400070' },
  { value: 'malad-east', label: 'Malad East', pincode: '400097' },
  { value: 'malad-west', label: 'Malad West', pincode: '400064' },
  { value: 'matunga-east', label: 'Matunga East', pincode: '400019' },
  { value: 'matunga-west', label: 'Matunga West', pincode: '400016' },
  { value: 'mulund-east', label: 'Mulund East', pincode: '400081' },
  { value: 'mulund-west', label: 'Mulund West', pincode: '400080' },
  { value: 'nariman-point', label: 'Nariman Point', pincode: '400021' },
  { value: 'powai', label: 'Powai', pincode: '400076' },
  { value: 'santacruz-east', label: 'Santacruz East', pincode: '400055' },
  { value: 'santacruz-west', label: 'Santacruz West', pincode: '400054' },
  { value: 'sewri', label: 'Sewri', pincode: '400015' },
  { value: 'shivaji-park', label: 'Shivaji Park', pincode: '400028' },
  { value: 'vile-parle-east', label: 'Vile Parle East', pincode: '400057' },
  { value: 'vile-parle-west', label: 'Vile Parle West', pincode: '400056' },
  { value: 'lokhandwala', label: 'Lokhandwala', pincode: '400053' },
  { value: 'mahim', label: 'Mahim', pincode: '400016' },
  { value: 'prabhadevi', label: 'Prabhadevi', pincode: '400025' },
  { value: 'lowerparel', label: 'Lower Parel', pincode: '400013' },
  { value: 'kandivali-east', label: 'Kandivali East', pincode: '400101' },
  { value: 'kandivali-west', label: 'Kandivali West', pincode: '400067' },
  { value: 'gandhi-nagar', label: 'Gandhi Nagar', pincode: '400037' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '400083' },
  { value: 'dahisar-east', label: 'Dahisar East', pincode: '400068' },
  { value: 'dahisar-west', label: 'Dahisar West', pincode: '400116' },
  { value: 'borivali-east', label: 'Borivali East', pincode: '400066' },
  { value: 'borivali-west', label: 'Borivali West', pincode: '400092' },
  { value: 'bhandup-east', label: 'Bhandup East', pincode: '400078' },
  { value: 'bhandup-west', label: 'Bhandup West', pincode: '400078' },
  { value: 'mira-road', label: 'Mira Road', pincode: '400067' },
  { value: 'naigaon', label: 'Naigaon', pincode: '400072' }
  ],
  
  'nandurbar': [
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '425412' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '425412' },
  { value: 'gajraula', label: 'Gajraula', pincode: '425412' },
  { value: 'kalamba', label: 'Kalamba', pincode: '425419' },
  { value: 'khandvi', label: 'Khandvi', pincode: '425410' },
  { value: 'nandurbar', label: 'Nandurbar', pincode: '425412' },
  { value: 'navapur', label: 'Navapur', pincode: '425418' },
  { value: 'rahud', label: 'Rahud', pincode: '425414' },
  { value: 'shahada', label: 'Shahada', pincode: '425409' },
  { value: 'shivaji-nagar', label: 'Shivaji Nagar', pincode: '425419' },
  { value: 'suklaya', label: 'Suklaya', pincode: '425415' },
  { value: 'tandulwadi', label: 'Tandulwadi', pincode: '425411' },
  { value: 'vavadi', label: 'Vavadi', pincode: '425417' },
  { value: 'zari', label: 'Zari', pincode: '425421' },
  { value: 'dhamangaon', label: 'Dhamangaon', pincode: '425416' },
  { value: 'khodki', label: 'Khodki', pincode: '425420' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '425413' },
  { value: 'pachora', label: 'Pachora', pincode: '425422' },
  { value: 'kamalpur', label: 'Kamalpur', pincode: '425424' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '425423' }
  ],
  
  'raigad': [
  { value: 'alibag', label: 'Alibag', pincode: '402201' },
  { value: 'anding', label: 'Anding', pincode: '402301' },
  { value: 'badlapur', label: 'Badlapur', pincode: '421503' },
  { value: 'karjat', label: 'Karjat', pincode: '410201' },
  { value: 'kharghar', label: 'Kharghar', pincode: '410210' },
  { value: 'khopoli', label: 'Khopoli', pincode: '410203' },
  { value: 'matheran', label: 'Matheran', pincode: '410102' },
  { value: 'murud', label: 'Murud', pincode: '402401' },
  { value: 'panvel', label: 'Panvel', pincode: '410206' },
  { value: 'raigad', label: 'Raigad', pincode: '402107' },
  { value: 'roha', label: 'Roha', pincode: '402109' },
  { value: 'seawood', label: 'Seawood', pincode: '400706' },
  { value: 'turbhe', label: 'Turbhe', pincode: '400705' },
  { value: 'uran', label: 'Uran', pincode: '400702' },
  { value: 'vardha', label: 'Vardha', pincode: '402208' },
  { value: 'adgaon', label: 'Adgaon', pincode: '402106' },
  { value: 'anwa', label: 'Anwa', pincode: '402302' },
  { value: 'bhivpuri', label: 'Bhivpuri', pincode: '410202' },
  { value: 'chinchani', label: 'Chinchani', pincode: '402401' },
  { value: 'goregaon', label: 'Goregaon', pincode: '402303' },
  { value: 'khandale', label: 'Khandale', pincode: '402107' },
  { value: 'mandad', label: 'Mandad', pincode: '402302' },
  { value: 'morbe', label: 'Morbe', pincode: '410206' },
  { value: 'pen', label: 'Pen', pincode: '402107' },
  { value: 'shirsad', label: 'Shirsad', pincode: '402105' },
  { value: 'tala', label: 'Tala', pincode: '402201' },
  { value: 'wadi', label: 'Wadi', pincode: '402204' },
  { value: 'wadi-s', label: 'Wadi South', pincode: '402205' }
  ],
  
  'ratnagiri': [
  { value: 'alapur', label: 'Alapur', pincode: '415612' },
  { value: 'ankoli', label: 'Ankoli', pincode: '415713' },
  { value: 'bhivpur', label: 'Bhivpur', pincode: '415607' },
  { value: 'dhakti', label: 'Dhakti', pincode: '415612' },
  { value: 'diveagar', label: 'Diveagar', pincode: '402404' },
  { value: 'guhagar', label: 'Guhagar', pincode: '415729' },
  { value: 'javhar', label: 'Javhar', pincode: '415607' },
  { value: 'mandangad', label: 'Mandangad', pincode: '415712' },
  { value: 'ratnagiri', label: 'Ratnagiri', pincode: '415612' },
  { value: 'raigad', label: 'Raigad', pincode: '415608' },
  { value: 'rajapur', label: 'Rajapur', pincode: '415639' },
  { value: 'shiras', label: 'Shiras', pincode: '415618' },
  { value: 'sindhudurg', label: 'Sindhudurg', pincode: '416601' },
  { value: 'sundernagar', label: 'Sundernagar', pincode: '415710' },
  { value: 'tapad', label: 'Tapad', pincode: '415639' },
  { value: 'tsihati', label: 'Tsihati', pincode: '415620' },
  { value: 'wadghar', label: 'Wadghar', pincode: '415611' },
  { value: 'vadgaon', label: 'Vadgaon', pincode: '415606' },
  { value: 'vijaydurg', label: 'Vijaydurg', pincode: '416606' },
  { value: 'devgad', label: 'Devgad', pincode: '416610' },
  { value: 'ratnagiri-bk', label: 'Ratnagiri Bk', pincode: '415612' },
  { value: 'palshet', label: 'Palshet', pincode: '415622' },
  { value: 'adgaon', label: 'Adgaon', pincode: '415620' }
  ],

 'jalgaon': [
  { value: 'adgaon', label: 'Adgaon', pincode: '425001' },
  { value: 'alapur', label: 'Alapur', pincode: '425002' },
  { value: 'babhulgaon', label: 'Babhulgaon', pincode: '425003' },
  { value: 'bhorkheda', label: 'Bhorkheda', pincode: '425004' },
  { value: 'chandpur', label: 'Chandpur', pincode: '425005' },
  { value: 'dharmapuri', label: 'Dharmapuri', pincode: '425006' },
  { value: 'gajanan-nagar', label: 'Gajanan Nagar', pincode: '425007' },
  { value: 'jalgaon', label: 'Jalgaon', pincode: '425001' },
  { value: 'kamgar-nagar', label: 'Kamgar Nagar', pincode: '425008' },
  { value: 'khamgaon', label: 'Khamgaon', pincode: '425009' },
  { value: 'khandvi', label: 'Khandvi', pincode: '425010' },
  { value: 'malkapur', label: 'Malkapur', pincode: '425011' },
  { value: 'manegaon', label: 'Manegaon', pincode: '425012' },
  { value: 'pimpalgaon', label: 'Pimpalgaon', pincode: '425013' },
  { value: 'rahata', label: 'Rahata', pincode: '425014' },
  { value: 'rahimpur', label: 'Rahimpur', pincode: '425015' },
  { value: 'sant-nagar', label: 'Sant Nagar', pincode: '425016' },
  { value: 'siddharth-nagar', label: 'Siddharth Nagar', pincode: '425017' },
  { value: 'talegaon', label: 'Talegaon', pincode: '425018' },
  { value: 'warora', label: 'Warora', pincode: '425019' },
  { value: 'wadgaon', label: 'Wadgaon', pincode: '425020' },
  { value: 'wadgaon-bk', label: 'Wadgaon BK', pincode: '425021' },
  { value: 'tq-jalgaon', label: 'TQ Jalgaon', pincode: '425022' },
  { value: 'khamgaon-bk', label: 'Khamgaon BK', pincode: '425023' },
  { value: 'pratappur', label: 'Pratappur', pincode: '425024' },
  { value: 'balapur', label: 'Balapur', pincode: '425025' },
  { value: 'khandvi-bk', label: 'Khandvi BK', pincode: '425026' },
  { value: 'narayanpur', label: 'Narayanpur', pincode: '425027' },
  { value: 'kalegaon', label: 'Kalegaon', pincode: '425028' },
  { value: 'manikpur', label: 'Manikpur', pincode: '425029' },
  { value: 'sonale', label: 'Sonale', pincode: '425030' },
  { value: 'khodpur', label: 'Khodpur', pincode: '425031' },
  { value: 'rahimatpur', label: 'Rahimatpur', pincode: '425032' },
  { value: 'banegaon', label: 'Banegaon', pincode: '425033' },
  { value: 'chinchkheda', label: 'Chinchkheda', pincode: '425034' },
  { value: 'roha', label: 'Roha', pincode: '425035' }
  ],

  // Pune Areas
  'pune': [
    { value: 'agarkar-Nagar', label: 'Agarkar Nagar', pincode: '411001' },
    { value: 'akurdi', label: 'Akurdi', pincode: '411044' },
    { value: 'alandi', label: 'Alandi', pincode: '412105' },
    { value: 'alandi-Markal-Road', label: 'Alandi-Markal Road', pincode: '412105' },
    { value: 'alephata', label: 'Alephata', pincode: '410504' },
    { value: 'alandi-Road', label: 'Alandi Road', pincode: '411015' },
    { value: 'ambarwet', label: 'Ambarwet', pincode: '412108' },
    { value: 'ambavane', label: 'Ambavane', pincode: '412107' },
    { value: 'ambegaon-Budruk', label: 'Ambegaon Budruk', pincode: '411046' },
    { value: 'ambegaon-Khurd', label: 'Ambegaon Khurd', pincode: '411046' },
    { value: 'amchi-Colony', label: 'Amchi Colony', pincode: '411033' },
    { value: 'anand-Nagar', label: 'Anand Nagar', pincode: '411033' },
    { value: 'ananthnagar', label: 'Ananthnagar', pincode: '411047' },
    { value: 'ashtapur', label: 'Ashtapur', pincode: '412207' },
    { value: 'ashok-Nagar', label: 'Ashok Nagar', pincode: '411033' },
    { value: 'aundh', label: 'Aundh', pincode: '411007' },
    { value: 'aundh-Road', label: 'Aundh Road', pincode: '411007' },
    { value: 'awhalwadi', label: 'Awhalwadi', pincode: '412207' },
    { value: 'bahul', label: 'Bahul', pincode: '412213' },
    { value: 'bajirao-Road', label: 'Bajirao Road', pincode: '411002' },
    { value: 'bakori', label: 'Bakori', pincode: '412207' },
    { value: 'balaji-Nagar', label: 'Balaji Nagar', pincode: '411045' },
    { value: 'balewadi', label: 'Balewadi', pincode: '411045' },
    { value: 'baner', label: 'Baner', pincode: '411045' },
    { value: 'baner-Bypass-Highway', label: 'Baner Bypass Highway', pincode: '411045' },
    { value: 'baner-pashan-Link-Road', label: 'Baner Pashan Link Road', pincode: '411021' },
    { value: 'baramati', label: 'Baramati', pincode: '413102' },
    { value: 'bavdhan', label: 'Bavdhan', pincode: '411021' },
    { value: 'bhekrai-Nagar', label: 'Bhekrai Nagar', pincode: '411042' },
    { value: 'bhoirwadi', label: 'Bhoirwadi', pincode: '411057' },
    { value: 'bhosale-Nagar', label: 'Bhosale Nagar', pincode: '411037' },
    { value: 'bhosari', label: 'Bhosari', pincode: '411039' },
    { value: 'bhugaon', label: 'Bhugaon', pincode: '412115' },
    { value: 'bhukum', label: 'Bhukum', pincode: '412108' },
    { value: 'bhusari-Colony', label: 'Bhusari Colony', pincode: '411038' },
    { value: 'bopkhel', label: 'Bopkhel', pincode: '411046' },
    { value: 'bopodi', label: 'Bopodi', pincode: '411020' },
    { value: 'bund-Garden-Road', label: 'Bund Garden Road', pincode: '411001' },
    { value: 'camp', label: 'Camp', pincode: '411001' },
    { value: 'chakan', label: 'Chakan', pincode: '410501' },
    { value: 'chandani-Chowk', label: 'Chandani Chowk', pincode: '411001' },
    { value: 'chandan-Nagar', label: 'Chandan Nagar', pincode: '411014' },
    { value: 'charholi-Budruk', label: 'Charholi Budruk', pincode: '412105' },
    { value: 'charholi-Khurd', label: 'Charholi Khurd', pincode: '412105' },
    { value: 'chinchwad', label: 'Chinchwad', pincode: '411019' },
    { value: 'dapodi', label: 'Dapodi', pincode: '411012' },
    { value: 'dattavadi', label: 'Dattavadi', pincode: '411030' },
    { value: 'deccan-Gymkhana', label: 'Deccan Gymkhana', pincode: '411004' },
    { value: 'dehu', label: 'Dehu', pincode: '412109' },
    { value: 'dehu-Road', label: 'Dehu Road', pincode: '412101' },
    { value: 'dhankawadi', label: 'Dhankawadi', pincode: '411043' },
    { value: 'dhanori', label: 'Dhanori', pincode: '411015' },
    { value: 'dighi', label: 'Dighi', pincode: '411015' },
    { value: 'donaje', label: 'Donaje', pincode: '412107' },
    { value: 'fatima-Nagar', label: 'Fatima Nagar', pincode: '411013' },
    { value: 'fC-Road', label: 'FC Road', pincode: '411005' },
    { value: 'ganeshkhind', label: 'Ganeshkhind', pincode: '411007' },
    { value: 'ganesh-Peth', label: 'Ganesh Peth', pincode: '411042' },
    { value: 'gayatri-Nagar', label: 'Gayatri Nagar', pincode: '411027' },
    { value: 'gultekdi', label: 'Gultekdi', pincode: '411037' },
    { value: 'hadapsar', label: 'Hadapsar', pincode: '411028' },
    { value: 'handewadi', label: 'Handewadi', pincode: '411060' },
    { value: 'hingne-Khurd', label: 'Hingne Khurd', pincode: '411051' },
    { value: 'hinjawadi', label: 'Hinjawadi', pincode: '411057' },
    { value: 'hinjawadi-Phase', label: 'Hinjawadi Phase', pincode: '411057' },
    { value: 'indira-Nagar', label: 'Indira Nagar', pincode: '411037' },
    { value: 'jM-Road', label: 'JM Road', pincode: '411005' },
    { value: 'jejuri', label: 'Jejuri', pincode: '412303' },
    { value: 'kalewadi', label: 'Kalewadi', pincode: '411017' },
    { value: 'karve-Road', label: 'Karve Road', pincode: '411038' },
    { value: 'kharadi', label: 'Kharadi', pincode: '411014' },
    { value: 'kharadi-Bypass-Road', label: 'Kharadi Bypass Road', pincode: '411014' },
    { value: 'khed', label: 'Khed', pincode: '410501' },
    { value: 'kondhwa', label: 'Kondhwa', pincode: '411048' },
    { value: 'koregaon-Bhima', label: 'Koregaon Bhima', pincode: '412216' },
    { value: 'kothrud', label: 'Kothrud', pincode: '411038' },
    { value: 'lavale', label: 'Lavale', pincode: '412115' },
    { value: 'magarpatta', label: 'Magarpatta', pincode: '411013' },
    { value: 'manchar', label: 'Manchar', pincode: '410503' },
    { value: 'marunji', label: 'Marunji', pincode: '411057' },
    { value: 'mundhwa', label: 'Mundhwa', pincode: '411036' },
    { value: 'narayan-Peth', label: 'Narayan Peth', pincode: '411030' },
    { value: 'narayangaon', label: 'Narayangaon', pincode: '410504' },
    { value: 'pashan', label: 'Pashan', pincode: '411021' },
    { value: 'paud-Road', label: 'Paud Road', pincode: '411029' },
    { value: 'pimple-Saudagar', label: 'Pimple Saudagar', pincode: '411027' },
    { value: 'pimpri', label: 'Pimpri', pincode: '411018' },
    { value: 'ramtekdi', label: 'Ramtekdi', pincode: '411028' },
    { value: 'sangvi', label: 'Sangvi', pincode: '411027' },
    { value: 'satara-Road', label: 'Satara Road', pincode: '411034' },
    { value: 'shivajinagar', label: 'Shivajinagar', pincode: '411004' },
    { value: 'talegaon-Dabhade', label: 'Talegaon Dabhade', pincode: '410506' },
    { value: 'theur', label: 'Theur', pincode: '412110' },
    { value: 'wadgaon-Sheri', label: 'Wadgaon Sheri', pincode: '411014' },
    { value: 'wakad', label: 'Wakad', pincode: '411057' },
    { value: 'yerwada', label: 'Yerwada', pincode: '411006' }
  ],
} as const;

// Helper function to get areas for a specific city
export function getAreasForCity(cityValue: string) {
  return areas[cityValue] || [];
}